function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireff03"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireff03"] = parcelRequire;
}
parcelRequire.register("5mD5L", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $3e7d54a8f14f6dd2$export$ffb0004e005737fa, (v) => $3e7d54a8f14f6dd2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $3e7d54a8f14f6dd2$export$34b9dba7ce09269b, (v) => $3e7d54a8f14f6dd2$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $3e7d54a8f14f6dd2$export$25062201e9e25d76, (v) => $3e7d54a8f14f6dd2$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3e7d54a8f14f6dd2$export$ffb0004e005737fa;
var $3e7d54a8f14f6dd2$export$34b9dba7ce09269b;
var $3e7d54a8f14f6dd2$export$25062201e9e25d76;
"use strict";

var $1bdO8 = parcelRequire("1bdO8");
var $3e7d54a8f14f6dd2$var$k = Symbol.for("react.element"), $3e7d54a8f14f6dd2$var$l = Symbol.for("react.fragment"), $3e7d54a8f14f6dd2$var$m = Object.prototype.hasOwnProperty, $3e7d54a8f14f6dd2$var$n = $1bdO8.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $3e7d54a8f14f6dd2$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $3e7d54a8f14f6dd2$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$3e7d54a8f14f6dd2$var$m.call(a, b) && !$3e7d54a8f14f6dd2$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $3e7d54a8f14f6dd2$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $3e7d54a8f14f6dd2$var$n.current
    };
}
$3e7d54a8f14f6dd2$export$ffb0004e005737fa = $3e7d54a8f14f6dd2$var$l;
$3e7d54a8f14f6dd2$export$34b9dba7ce09269b = $3e7d54a8f14f6dd2$var$q;
$3e7d54a8f14f6dd2$export$25062201e9e25d76 = $3e7d54a8f14f6dd2$var$q;

});
parcelRequire.register("1bdO8", function(module, exports) {
"use strict";

module.exports = (parcelRequire("lbQgI"));

});
parcelRequire.register("lbQgI", function(module, exports) {

$parcel$export(module.exports, "Children", () => $f6d32b875b167f67$export$dca3b0875bd9a954, (v) => $f6d32b875b167f67$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $f6d32b875b167f67$export$16fa2f45be04daa8, (v) => $f6d32b875b167f67$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $f6d32b875b167f67$export$ffb0004e005737fa, (v) => $f6d32b875b167f67$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $f6d32b875b167f67$export$e2c29f18771995cb, (v) => $f6d32b875b167f67$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $f6d32b875b167f67$export$221d75b3f55bb0bd, (v) => $f6d32b875b167f67$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $f6d32b875b167f67$export$5f8d39834fd61797, (v) => $f6d32b875b167f67$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $f6d32b875b167f67$export$74bf444e3cd11ea5, (v) => $f6d32b875b167f67$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $f6d32b875b167f67$export$ae55be85d98224ed, (v) => $f6d32b875b167f67$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $f6d32b875b167f67$export$e530037191fcd5d7, (v) => $f6d32b875b167f67$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $f6d32b875b167f67$export$fd42f52fd3ae1109, (v) => $f6d32b875b167f67$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $f6d32b875b167f67$export$c8a8987d4410bf2d, (v) => $f6d32b875b167f67$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $f6d32b875b167f67$export$d38cd72104c1f0e9, (v) => $f6d32b875b167f67$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $f6d32b875b167f67$export$7d1e3a5e95ceca43, (v) => $f6d32b875b167f67$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $f6d32b875b167f67$export$257a8862b851cb5b, (v) => $f6d32b875b167f67$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $f6d32b875b167f67$export$a8257692ac88316c, (v) => $f6d32b875b167f67$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $f6d32b875b167f67$export$488013bae63b21da, (v) => $f6d32b875b167f67$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $f6d32b875b167f67$export$7c73462e0d25e514, (v) => $f6d32b875b167f67$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $f6d32b875b167f67$export$7568632d0d33d16d, (v) => $f6d32b875b167f67$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $f6d32b875b167f67$export$88948ce120ea2619, (v) => $f6d32b875b167f67$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $f6d32b875b167f67$export$35808ee640e87ca7, (v) => $f6d32b875b167f67$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $f6d32b875b167f67$export$fae74005e78b1a27, (v) => $f6d32b875b167f67$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $f6d32b875b167f67$export$dc8fbce3eb94dc1e, (v) => $f6d32b875b167f67$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $f6d32b875b167f67$export$6a7bc4e911dc01cf, (v) => $f6d32b875b167f67$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $f6d32b875b167f67$export$6d9c69b0de29b591, (v) => $f6d32b875b167f67$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $f6d32b875b167f67$export$f680877a34711e37, (v) => $f6d32b875b167f67$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $f6d32b875b167f67$export$d5a552a76deda3c2, (v) => $f6d32b875b167f67$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $f6d32b875b167f67$export$aaabe4eda9ed9969, (v) => $f6d32b875b167f67$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $f6d32b875b167f67$export$e5c5a5f917a5871c, (v) => $f6d32b875b167f67$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $f6d32b875b167f67$export$1538c33de8887b59, (v) => $f6d32b875b167f67$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $f6d32b875b167f67$export$13e3392192263954, (v) => $f6d32b875b167f67$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $f6d32b875b167f67$export$b8f5890fc79d6aca, (v) => $f6d32b875b167f67$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $f6d32b875b167f67$export$60241385465d0a34, (v) => $f6d32b875b167f67$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $f6d32b875b167f67$export$306c0aa65ff9ec16, (v) => $f6d32b875b167f67$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $f6d32b875b167f67$export$7b286972b8d8ccbf, (v) => $f6d32b875b167f67$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $f6d32b875b167f67$export$83d89fbfd8236492, (v) => $f6d32b875b167f67$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f6d32b875b167f67$export$dca3b0875bd9a954;
var $f6d32b875b167f67$export$16fa2f45be04daa8;
var $f6d32b875b167f67$export$ffb0004e005737fa;
var $f6d32b875b167f67$export$e2c29f18771995cb;
var $f6d32b875b167f67$export$221d75b3f55bb0bd;
var $f6d32b875b167f67$export$5f8d39834fd61797;
var $f6d32b875b167f67$export$74bf444e3cd11ea5;
var $f6d32b875b167f67$export$ae55be85d98224ed;
var $f6d32b875b167f67$export$e530037191fcd5d7;
var $f6d32b875b167f67$export$fd42f52fd3ae1109;
var $f6d32b875b167f67$export$c8a8987d4410bf2d;
var $f6d32b875b167f67$export$d38cd72104c1f0e9;
var $f6d32b875b167f67$export$7d1e3a5e95ceca43;
var $f6d32b875b167f67$export$257a8862b851cb5b;
var $f6d32b875b167f67$export$a8257692ac88316c;
var $f6d32b875b167f67$export$488013bae63b21da;
var $f6d32b875b167f67$export$7c73462e0d25e514;
var $f6d32b875b167f67$export$7568632d0d33d16d;
var $f6d32b875b167f67$export$88948ce120ea2619;
var $f6d32b875b167f67$export$35808ee640e87ca7;
var $f6d32b875b167f67$export$fae74005e78b1a27;
var $f6d32b875b167f67$export$dc8fbce3eb94dc1e;
var $f6d32b875b167f67$export$6a7bc4e911dc01cf;
var $f6d32b875b167f67$export$6d9c69b0de29b591;
var $f6d32b875b167f67$export$f680877a34711e37;
var $f6d32b875b167f67$export$d5a552a76deda3c2;
var $f6d32b875b167f67$export$aaabe4eda9ed9969;
var $f6d32b875b167f67$export$e5c5a5f917a5871c;
var $f6d32b875b167f67$export$1538c33de8887b59;
var $f6d32b875b167f67$export$13e3392192263954;
var $f6d32b875b167f67$export$b8f5890fc79d6aca;
var $f6d32b875b167f67$export$60241385465d0a34;
var $f6d32b875b167f67$export$306c0aa65ff9ec16;
var $f6d32b875b167f67$export$7b286972b8d8ccbf;
var $f6d32b875b167f67$export$83d89fbfd8236492;
"use strict";
var $f6d32b875b167f67$var$l = Symbol.for("react.element"), $f6d32b875b167f67$var$n = Symbol.for("react.portal"), $f6d32b875b167f67$var$p = Symbol.for("react.fragment"), $f6d32b875b167f67$var$q = Symbol.for("react.strict_mode"), $f6d32b875b167f67$var$r = Symbol.for("react.profiler"), $f6d32b875b167f67$var$t = Symbol.for("react.provider"), $f6d32b875b167f67$var$u = Symbol.for("react.context"), $f6d32b875b167f67$var$v = Symbol.for("react.forward_ref"), $f6d32b875b167f67$var$w = Symbol.for("react.suspense"), $f6d32b875b167f67$var$x = Symbol.for("react.memo"), $f6d32b875b167f67$var$y = Symbol.for("react.lazy"), $f6d32b875b167f67$var$z = Symbol.iterator;
function $f6d32b875b167f67$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $f6d32b875b167f67$var$z && a[$f6d32b875b167f67$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $f6d32b875b167f67$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $f6d32b875b167f67$var$C = Object.assign, $f6d32b875b167f67$var$D = {};
function $f6d32b875b167f67$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $f6d32b875b167f67$var$D;
    this.updater = e || $f6d32b875b167f67$var$B;
}
$f6d32b875b167f67$var$E.prototype.isReactComponent = {};
$f6d32b875b167f67$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$f6d32b875b167f67$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $f6d32b875b167f67$var$F() {}
$f6d32b875b167f67$var$F.prototype = $f6d32b875b167f67$var$E.prototype;
function $f6d32b875b167f67$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $f6d32b875b167f67$var$D;
    this.updater = e || $f6d32b875b167f67$var$B;
}
var $f6d32b875b167f67$var$H = $f6d32b875b167f67$var$G.prototype = new $f6d32b875b167f67$var$F;
$f6d32b875b167f67$var$H.constructor = $f6d32b875b167f67$var$G;
$f6d32b875b167f67$var$C($f6d32b875b167f67$var$H, $f6d32b875b167f67$var$E.prototype);
$f6d32b875b167f67$var$H.isPureReactComponent = !0;
var $f6d32b875b167f67$var$I = Array.isArray, $f6d32b875b167f67$var$J = Object.prototype.hasOwnProperty, $f6d32b875b167f67$var$K = {
    current: null
}, $f6d32b875b167f67$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $f6d32b875b167f67$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$f6d32b875b167f67$var$J.call(b, d) && !$f6d32b875b167f67$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $f6d32b875b167f67$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $f6d32b875b167f67$var$K.current
    };
}
function $f6d32b875b167f67$var$N(a, b) {
    return {
        $$typeof: $f6d32b875b167f67$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $f6d32b875b167f67$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $f6d32b875b167f67$var$l;
}
function $f6d32b875b167f67$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $f6d32b875b167f67$var$P = /\/+/g;
function $f6d32b875b167f67$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $f6d32b875b167f67$var$escape("" + a.key) : b.toString(36);
}
function $f6d32b875b167f67$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $f6d32b875b167f67$var$l:
                case $f6d32b875b167f67$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $f6d32b875b167f67$var$Q(h, 0) : d, $f6d32b875b167f67$var$I(c) ? (e = "", null != a && (e = a.replace($f6d32b875b167f67$var$P, "$&/") + "/"), $f6d32b875b167f67$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($f6d32b875b167f67$var$O(c) && (c = $f6d32b875b167f67$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($f6d32b875b167f67$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($f6d32b875b167f67$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $f6d32b875b167f67$var$Q(k, g);
        h += $f6d32b875b167f67$var$R(k, b, e, f, c);
    }
    else if (f = $f6d32b875b167f67$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $f6d32b875b167f67$var$Q(k, g++), h += $f6d32b875b167f67$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $f6d32b875b167f67$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $f6d32b875b167f67$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $f6d32b875b167f67$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $f6d32b875b167f67$var$U = {
    current: null
}, $f6d32b875b167f67$var$V = {
    transition: null
}, $f6d32b875b167f67$var$W = {
    ReactCurrentDispatcher: $f6d32b875b167f67$var$U,
    ReactCurrentBatchConfig: $f6d32b875b167f67$var$V,
    ReactCurrentOwner: $f6d32b875b167f67$var$K
};
$f6d32b875b167f67$export$dca3b0875bd9a954 = {
    map: $f6d32b875b167f67$var$S,
    forEach: function(a, b, e) {
        $f6d32b875b167f67$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $f6d32b875b167f67$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $f6d32b875b167f67$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$f6d32b875b167f67$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$f6d32b875b167f67$export$16fa2f45be04daa8 = $f6d32b875b167f67$var$E;
$f6d32b875b167f67$export$ffb0004e005737fa = $f6d32b875b167f67$var$p;
$f6d32b875b167f67$export$e2c29f18771995cb = $f6d32b875b167f67$var$r;
$f6d32b875b167f67$export$221d75b3f55bb0bd = $f6d32b875b167f67$var$G;
$f6d32b875b167f67$export$5f8d39834fd61797 = $f6d32b875b167f67$var$q;
$f6d32b875b167f67$export$74bf444e3cd11ea5 = $f6d32b875b167f67$var$w;
$f6d32b875b167f67$export$ae55be85d98224ed = $f6d32b875b167f67$var$W;
$f6d32b875b167f67$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $f6d32b875b167f67$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $f6d32b875b167f67$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$f6d32b875b167f67$var$J.call(b, f) && !$f6d32b875b167f67$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $f6d32b875b167f67$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$f6d32b875b167f67$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $f6d32b875b167f67$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $f6d32b875b167f67$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$f6d32b875b167f67$export$c8a8987d4410bf2d = $f6d32b875b167f67$var$M;
$f6d32b875b167f67$export$d38cd72104c1f0e9 = function(a) {
    var b = $f6d32b875b167f67$var$M.bind(null, a);
    b.type = a;
    return b;
};
$f6d32b875b167f67$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$f6d32b875b167f67$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $f6d32b875b167f67$var$v,
        render: a
    };
};
$f6d32b875b167f67$export$a8257692ac88316c = $f6d32b875b167f67$var$O;
$f6d32b875b167f67$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $f6d32b875b167f67$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $f6d32b875b167f67$var$T
    };
};
$f6d32b875b167f67$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $f6d32b875b167f67$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$f6d32b875b167f67$export$7568632d0d33d16d = function(a) {
    var b = $f6d32b875b167f67$var$V.transition;
    $f6d32b875b167f67$var$V.transition = {};
    try {
        a();
    } finally{
        $f6d32b875b167f67$var$V.transition = b;
    }
};
$f6d32b875b167f67$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$f6d32b875b167f67$export$35808ee640e87ca7 = function(a, b) {
    return $f6d32b875b167f67$var$U.current.useCallback(a, b);
};
$f6d32b875b167f67$export$fae74005e78b1a27 = function(a) {
    return $f6d32b875b167f67$var$U.current.useContext(a);
};
$f6d32b875b167f67$export$dc8fbce3eb94dc1e = function() {};
$f6d32b875b167f67$export$6a7bc4e911dc01cf = function(a) {
    return $f6d32b875b167f67$var$U.current.useDeferredValue(a);
};
$f6d32b875b167f67$export$6d9c69b0de29b591 = function(a, b) {
    return $f6d32b875b167f67$var$U.current.useEffect(a, b);
};
$f6d32b875b167f67$export$f680877a34711e37 = function() {
    return $f6d32b875b167f67$var$U.current.useId();
};
$f6d32b875b167f67$export$d5a552a76deda3c2 = function(a, b, e) {
    return $f6d32b875b167f67$var$U.current.useImperativeHandle(a, b, e);
};
$f6d32b875b167f67$export$aaabe4eda9ed9969 = function(a, b) {
    return $f6d32b875b167f67$var$U.current.useInsertionEffect(a, b);
};
$f6d32b875b167f67$export$e5c5a5f917a5871c = function(a, b) {
    return $f6d32b875b167f67$var$U.current.useLayoutEffect(a, b);
};
$f6d32b875b167f67$export$1538c33de8887b59 = function(a, b) {
    return $f6d32b875b167f67$var$U.current.useMemo(a, b);
};
$f6d32b875b167f67$export$13e3392192263954 = function(a, b, e) {
    return $f6d32b875b167f67$var$U.current.useReducer(a, b, e);
};
$f6d32b875b167f67$export$b8f5890fc79d6aca = function(a) {
    return $f6d32b875b167f67$var$U.current.useRef(a);
};
$f6d32b875b167f67$export$60241385465d0a34 = function(a) {
    return $f6d32b875b167f67$var$U.current.useState(a);
};
$f6d32b875b167f67$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $f6d32b875b167f67$var$U.current.useSyncExternalStore(a, b, e);
};
$f6d32b875b167f67$export$7b286972b8d8ccbf = function() {
    return $f6d32b875b167f67$var$U.current.useTransition();
};
$f6d32b875b167f67$export$83d89fbfd8236492 = "18.2.0";

});



parcelRequire.register("9nkLV", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $6d365ff072dfd6ae$export$ae55be85d98224ed, (v) => $6d365ff072dfd6ae$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $6d365ff072dfd6ae$export$d39a5bbd09211389, (v) => $6d365ff072dfd6ae$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $6d365ff072dfd6ae$export$882461b6382ed46c, (v) => $6d365ff072dfd6ae$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $6d365ff072dfd6ae$export$466bfc07425424d5, (v) => $6d365ff072dfd6ae$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $6d365ff072dfd6ae$export$cd75ccfd720a3cd4, (v) => $6d365ff072dfd6ae$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $6d365ff072dfd6ae$export$fa8d919ba61d84db, (v) => $6d365ff072dfd6ae$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $6d365ff072dfd6ae$export$757ceba2d55c277e, (v) => $6d365ff072dfd6ae$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $6d365ff072dfd6ae$export$b3890eb0ae9dca99, (v) => $6d365ff072dfd6ae$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $6d365ff072dfd6ae$export$502457920280e6be, (v) => $6d365ff072dfd6ae$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $6d365ff072dfd6ae$export$c78a37762a8d58e1, (v) => $6d365ff072dfd6ae$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $6d365ff072dfd6ae$export$dc54d992c10e8a18, (v) => $6d365ff072dfd6ae$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $6d365ff072dfd6ae$export$83d89fbfd8236492, (v) => $6d365ff072dfd6ae$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $6d365ff072dfd6ae$export$ae55be85d98224ed;
var $6d365ff072dfd6ae$export$d39a5bbd09211389;
var $6d365ff072dfd6ae$export$882461b6382ed46c;
var $6d365ff072dfd6ae$export$466bfc07425424d5;
var $6d365ff072dfd6ae$export$cd75ccfd720a3cd4;
var $6d365ff072dfd6ae$export$fa8d919ba61d84db;
var $6d365ff072dfd6ae$export$757ceba2d55c277e;
var $6d365ff072dfd6ae$export$b3890eb0ae9dca99;
var $6d365ff072dfd6ae$export$502457920280e6be;
var $6d365ff072dfd6ae$export$c78a37762a8d58e1;
var $6d365ff072dfd6ae$export$dc54d992c10e8a18;
var $6d365ff072dfd6ae$export$83d89fbfd8236492;
"use strict";

var $1bdO8 = parcelRequire("1bdO8");

var $jNpn7 = parcelRequire("jNpn7");
function $6d365ff072dfd6ae$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $6d365ff072dfd6ae$var$da = new Set, $6d365ff072dfd6ae$var$ea = {};
function $6d365ff072dfd6ae$var$fa(a, b) {
    $6d365ff072dfd6ae$var$ha(a, b);
    $6d365ff072dfd6ae$var$ha(a + "Capture", b);
}
function $6d365ff072dfd6ae$var$ha(a, b) {
    $6d365ff072dfd6ae$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$6d365ff072dfd6ae$var$da.add(b[a]);
}
var $6d365ff072dfd6ae$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $6d365ff072dfd6ae$var$ja = Object.prototype.hasOwnProperty, $6d365ff072dfd6ae$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $6d365ff072dfd6ae$var$la = {}, $6d365ff072dfd6ae$var$ma = {};
function $6d365ff072dfd6ae$var$oa(a) {
    if ($6d365ff072dfd6ae$var$ja.call($6d365ff072dfd6ae$var$ma, a)) return !0;
    if ($6d365ff072dfd6ae$var$ja.call($6d365ff072dfd6ae$var$la, a)) return !1;
    if ($6d365ff072dfd6ae$var$ka.test(a)) return $6d365ff072dfd6ae$var$ma[a] = !0;
    $6d365ff072dfd6ae$var$la[a] = !0;
    return !1;
}
function $6d365ff072dfd6ae$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $6d365ff072dfd6ae$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $6d365ff072dfd6ae$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $6d365ff072dfd6ae$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $6d365ff072dfd6ae$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $6d365ff072dfd6ae$var$z[a] = new $6d365ff072dfd6ae$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $6d365ff072dfd6ae$var$z[b] = new $6d365ff072dfd6ae$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $6d365ff072dfd6ae$var$z[a] = new $6d365ff072dfd6ae$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $6d365ff072dfd6ae$var$z[a] = new $6d365ff072dfd6ae$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $6d365ff072dfd6ae$var$z[a] = new $6d365ff072dfd6ae$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $6d365ff072dfd6ae$var$z[a] = new $6d365ff072dfd6ae$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $6d365ff072dfd6ae$var$z[a] = new $6d365ff072dfd6ae$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $6d365ff072dfd6ae$var$z[a] = new $6d365ff072dfd6ae$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $6d365ff072dfd6ae$var$z[a] = new $6d365ff072dfd6ae$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $6d365ff072dfd6ae$var$ra = /[\-:]([a-z])/g;
function $6d365ff072dfd6ae$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($6d365ff072dfd6ae$var$ra, $6d365ff072dfd6ae$var$sa);
    $6d365ff072dfd6ae$var$z[b] = new $6d365ff072dfd6ae$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($6d365ff072dfd6ae$var$ra, $6d365ff072dfd6ae$var$sa);
    $6d365ff072dfd6ae$var$z[b] = new $6d365ff072dfd6ae$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($6d365ff072dfd6ae$var$ra, $6d365ff072dfd6ae$var$sa);
    $6d365ff072dfd6ae$var$z[b] = new $6d365ff072dfd6ae$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $6d365ff072dfd6ae$var$z[a] = new $6d365ff072dfd6ae$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$6d365ff072dfd6ae$var$z.xlinkHref = new $6d365ff072dfd6ae$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $6d365ff072dfd6ae$var$z[a] = new $6d365ff072dfd6ae$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $6d365ff072dfd6ae$var$ta(a, b, c, d) {
    var e = $6d365ff072dfd6ae$var$z.hasOwnProperty(b) ? $6d365ff072dfd6ae$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $6d365ff072dfd6ae$var$qa(b, c, e, d) && (c = null), d || null === e ? $6d365ff072dfd6ae$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $6d365ff072dfd6ae$var$ua = $1bdO8.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $6d365ff072dfd6ae$var$va = Symbol.for("react.element"), $6d365ff072dfd6ae$var$wa = Symbol.for("react.portal"), $6d365ff072dfd6ae$var$ya = Symbol.for("react.fragment"), $6d365ff072dfd6ae$var$za = Symbol.for("react.strict_mode"), $6d365ff072dfd6ae$var$Aa = Symbol.for("react.profiler"), $6d365ff072dfd6ae$var$Ba = Symbol.for("react.provider"), $6d365ff072dfd6ae$var$Ca = Symbol.for("react.context"), $6d365ff072dfd6ae$var$Da = Symbol.for("react.forward_ref"), $6d365ff072dfd6ae$var$Ea = Symbol.for("react.suspense"), $6d365ff072dfd6ae$var$Fa = Symbol.for("react.suspense_list"), $6d365ff072dfd6ae$var$Ga = Symbol.for("react.memo"), $6d365ff072dfd6ae$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $6d365ff072dfd6ae$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $6d365ff072dfd6ae$var$Ja = Symbol.iterator;
function $6d365ff072dfd6ae$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $6d365ff072dfd6ae$var$Ja && a[$6d365ff072dfd6ae$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $6d365ff072dfd6ae$var$A = Object.assign, $6d365ff072dfd6ae$var$La;
function $6d365ff072dfd6ae$var$Ma(a) {
    if (void 0 === $6d365ff072dfd6ae$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $6d365ff072dfd6ae$var$La = b && b[1] || "";
    }
    return "\n" + $6d365ff072dfd6ae$var$La + a;
}
var $6d365ff072dfd6ae$var$Na = !1;
function $6d365ff072dfd6ae$var$Oa(a, b) {
    if (!a || $6d365ff072dfd6ae$var$Na) return "";
    $6d365ff072dfd6ae$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $6d365ff072dfd6ae$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $6d365ff072dfd6ae$var$Ma(a) : "";
}
function $6d365ff072dfd6ae$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $6d365ff072dfd6ae$var$Ma(a.type);
        case 16:
            return $6d365ff072dfd6ae$var$Ma("Lazy");
        case 13:
            return $6d365ff072dfd6ae$var$Ma("Suspense");
        case 19:
            return $6d365ff072dfd6ae$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $6d365ff072dfd6ae$var$Oa(a.type, !1), a;
        case 11:
            return a = $6d365ff072dfd6ae$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $6d365ff072dfd6ae$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $6d365ff072dfd6ae$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $6d365ff072dfd6ae$var$ya:
            return "Fragment";
        case $6d365ff072dfd6ae$var$wa:
            return "Portal";
        case $6d365ff072dfd6ae$var$Aa:
            return "Profiler";
        case $6d365ff072dfd6ae$var$za:
            return "StrictMode";
        case $6d365ff072dfd6ae$var$Ea:
            return "Suspense";
        case $6d365ff072dfd6ae$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $6d365ff072dfd6ae$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $6d365ff072dfd6ae$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $6d365ff072dfd6ae$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $6d365ff072dfd6ae$var$Ga:
            return b = a.displayName || null, null !== b ? b : $6d365ff072dfd6ae$var$Qa(a.type) || "Memo";
        case $6d365ff072dfd6ae$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $6d365ff072dfd6ae$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $6d365ff072dfd6ae$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $6d365ff072dfd6ae$var$Qa(b);
        case 8:
            return b === $6d365ff072dfd6ae$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $6d365ff072dfd6ae$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $6d365ff072dfd6ae$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $6d365ff072dfd6ae$var$Ua(a) {
    var b = $6d365ff072dfd6ae$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $6d365ff072dfd6ae$var$Va(a) {
    a._valueTracker || (a._valueTracker = $6d365ff072dfd6ae$var$Ua(a));
}
function $6d365ff072dfd6ae$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $6d365ff072dfd6ae$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $6d365ff072dfd6ae$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $6d365ff072dfd6ae$var$Ya(a, b) {
    var c = b.checked;
    return $6d365ff072dfd6ae$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $6d365ff072dfd6ae$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $6d365ff072dfd6ae$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $6d365ff072dfd6ae$var$ab(a, b) {
    b = b.checked;
    null != b && $6d365ff072dfd6ae$var$ta(a, "checked", b, !1);
}
function $6d365ff072dfd6ae$var$bb(a, b) {
    $6d365ff072dfd6ae$var$ab(a, b);
    var c = $6d365ff072dfd6ae$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $6d365ff072dfd6ae$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $6d365ff072dfd6ae$var$cb(a, b.type, $6d365ff072dfd6ae$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $6d365ff072dfd6ae$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $6d365ff072dfd6ae$var$cb(a, b, c) {
    if ("number" !== b || $6d365ff072dfd6ae$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $6d365ff072dfd6ae$var$eb = Array.isArray;
function $6d365ff072dfd6ae$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $6d365ff072dfd6ae$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $6d365ff072dfd6ae$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($6d365ff072dfd6ae$var$p(91));
    return $6d365ff072dfd6ae$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $6d365ff072dfd6ae$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($6d365ff072dfd6ae$var$p(92));
            if ($6d365ff072dfd6ae$var$eb(c)) {
                if (1 < c.length) throw Error($6d365ff072dfd6ae$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $6d365ff072dfd6ae$var$Sa(c)
    };
}
function $6d365ff072dfd6ae$var$ib(a, b) {
    var c = $6d365ff072dfd6ae$var$Sa(b.value), d = $6d365ff072dfd6ae$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $6d365ff072dfd6ae$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $6d365ff072dfd6ae$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $6d365ff072dfd6ae$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $6d365ff072dfd6ae$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $6d365ff072dfd6ae$var$mb, $6d365ff072dfd6ae$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $6d365ff072dfd6ae$var$mb = $6d365ff072dfd6ae$var$mb || document.createElement("div");
        $6d365ff072dfd6ae$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $6d365ff072dfd6ae$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $6d365ff072dfd6ae$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $6d365ff072dfd6ae$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $6d365ff072dfd6ae$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($6d365ff072dfd6ae$var$pb).forEach(function(a) {
    $6d365ff072dfd6ae$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $6d365ff072dfd6ae$var$pb[b] = $6d365ff072dfd6ae$var$pb[a];
    });
});
function $6d365ff072dfd6ae$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $6d365ff072dfd6ae$var$pb.hasOwnProperty(a) && $6d365ff072dfd6ae$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $6d365ff072dfd6ae$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $6d365ff072dfd6ae$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $6d365ff072dfd6ae$var$tb = $6d365ff072dfd6ae$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $6d365ff072dfd6ae$var$ub(a, b) {
    if (b) {
        if ($6d365ff072dfd6ae$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($6d365ff072dfd6ae$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($6d365ff072dfd6ae$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($6d365ff072dfd6ae$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($6d365ff072dfd6ae$var$p(62));
    }
}
function $6d365ff072dfd6ae$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $6d365ff072dfd6ae$var$wb = null;
function $6d365ff072dfd6ae$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $6d365ff072dfd6ae$var$yb = null, $6d365ff072dfd6ae$var$zb = null, $6d365ff072dfd6ae$var$Ab = null;
function $6d365ff072dfd6ae$var$Bb(a) {
    if (a = $6d365ff072dfd6ae$var$Cb(a)) {
        if ("function" !== typeof $6d365ff072dfd6ae$var$yb) throw Error($6d365ff072dfd6ae$var$p(280));
        var b = a.stateNode;
        b && (b = $6d365ff072dfd6ae$var$Db(b), $6d365ff072dfd6ae$var$yb(a.stateNode, a.type, b));
    }
}
function $6d365ff072dfd6ae$var$Eb(a) {
    $6d365ff072dfd6ae$var$zb ? $6d365ff072dfd6ae$var$Ab ? $6d365ff072dfd6ae$var$Ab.push(a) : $6d365ff072dfd6ae$var$Ab = [
        a
    ] : $6d365ff072dfd6ae$var$zb = a;
}
function $6d365ff072dfd6ae$var$Fb() {
    if ($6d365ff072dfd6ae$var$zb) {
        var a = $6d365ff072dfd6ae$var$zb, b = $6d365ff072dfd6ae$var$Ab;
        $6d365ff072dfd6ae$var$Ab = $6d365ff072dfd6ae$var$zb = null;
        $6d365ff072dfd6ae$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$6d365ff072dfd6ae$var$Bb(b[a]);
    }
}
function $6d365ff072dfd6ae$var$Gb(a, b) {
    return a(b);
}
function $6d365ff072dfd6ae$var$Hb() {}
var $6d365ff072dfd6ae$var$Ib = !1;
function $6d365ff072dfd6ae$var$Jb(a, b, c) {
    if ($6d365ff072dfd6ae$var$Ib) return a(b, c);
    $6d365ff072dfd6ae$var$Ib = !0;
    try {
        return $6d365ff072dfd6ae$var$Gb(a, b, c);
    } finally{
        if ($6d365ff072dfd6ae$var$Ib = !1, null !== $6d365ff072dfd6ae$var$zb || null !== $6d365ff072dfd6ae$var$Ab) $6d365ff072dfd6ae$var$Hb(), $6d365ff072dfd6ae$var$Fb();
    }
}
function $6d365ff072dfd6ae$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $6d365ff072dfd6ae$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($6d365ff072dfd6ae$var$p(231, b, typeof c));
    return c;
}
var $6d365ff072dfd6ae$var$Lb = !1;
if ($6d365ff072dfd6ae$var$ia) try {
    var $6d365ff072dfd6ae$var$Mb = {};
    Object.defineProperty($6d365ff072dfd6ae$var$Mb, "passive", {
        get: function() {
            $6d365ff072dfd6ae$var$Lb = !0;
        }
    });
    window.addEventListener("test", $6d365ff072dfd6ae$var$Mb, $6d365ff072dfd6ae$var$Mb);
    window.removeEventListener("test", $6d365ff072dfd6ae$var$Mb, $6d365ff072dfd6ae$var$Mb);
} catch (a) {
    $6d365ff072dfd6ae$var$Lb = !1;
}
function $6d365ff072dfd6ae$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $6d365ff072dfd6ae$var$Ob = !1, $6d365ff072dfd6ae$var$Pb = null, $6d365ff072dfd6ae$var$Qb = !1, $6d365ff072dfd6ae$var$Rb = null, $6d365ff072dfd6ae$var$Sb = {
    onError: function(a) {
        $6d365ff072dfd6ae$var$Ob = !0;
        $6d365ff072dfd6ae$var$Pb = a;
    }
};
function $6d365ff072dfd6ae$var$Tb(a, b, c, d, e, f, g, h, k) {
    $6d365ff072dfd6ae$var$Ob = !1;
    $6d365ff072dfd6ae$var$Pb = null;
    $6d365ff072dfd6ae$var$Nb.apply($6d365ff072dfd6ae$var$Sb, arguments);
}
function $6d365ff072dfd6ae$var$Ub(a, b, c, d, e, f, g, h, k) {
    $6d365ff072dfd6ae$var$Tb.apply(this, arguments);
    if ($6d365ff072dfd6ae$var$Ob) {
        if ($6d365ff072dfd6ae$var$Ob) {
            var l = $6d365ff072dfd6ae$var$Pb;
            $6d365ff072dfd6ae$var$Ob = !1;
            $6d365ff072dfd6ae$var$Pb = null;
        } else throw Error($6d365ff072dfd6ae$var$p(198));
        $6d365ff072dfd6ae$var$Qb || ($6d365ff072dfd6ae$var$Qb = !0, $6d365ff072dfd6ae$var$Rb = l);
    }
}
function $6d365ff072dfd6ae$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $6d365ff072dfd6ae$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $6d365ff072dfd6ae$var$Xb(a) {
    if ($6d365ff072dfd6ae$var$Vb(a) !== a) throw Error($6d365ff072dfd6ae$var$p(188));
}
function $6d365ff072dfd6ae$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $6d365ff072dfd6ae$var$Vb(a);
        if (null === b) throw Error($6d365ff072dfd6ae$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $6d365ff072dfd6ae$var$Xb(e), a;
                if (f === d) return $6d365ff072dfd6ae$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($6d365ff072dfd6ae$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($6d365ff072dfd6ae$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($6d365ff072dfd6ae$var$p(190));
    }
    if (3 !== c.tag) throw Error($6d365ff072dfd6ae$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $6d365ff072dfd6ae$var$Zb(a) {
    a = $6d365ff072dfd6ae$var$Yb(a);
    return null !== a ? $6d365ff072dfd6ae$var$$b(a) : null;
}
function $6d365ff072dfd6ae$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $6d365ff072dfd6ae$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $6d365ff072dfd6ae$var$ac = $jNpn7.unstable_scheduleCallback, $6d365ff072dfd6ae$var$bc = $jNpn7.unstable_cancelCallback, $6d365ff072dfd6ae$var$cc = $jNpn7.unstable_shouldYield, $6d365ff072dfd6ae$var$dc = $jNpn7.unstable_requestPaint, $6d365ff072dfd6ae$var$B = $jNpn7.unstable_now, $6d365ff072dfd6ae$var$ec = $jNpn7.unstable_getCurrentPriorityLevel, $6d365ff072dfd6ae$var$fc = $jNpn7.unstable_ImmediatePriority, $6d365ff072dfd6ae$var$gc = $jNpn7.unstable_UserBlockingPriority, $6d365ff072dfd6ae$var$hc = $jNpn7.unstable_NormalPriority, $6d365ff072dfd6ae$var$ic = $jNpn7.unstable_LowPriority, $6d365ff072dfd6ae$var$jc = $jNpn7.unstable_IdlePriority, $6d365ff072dfd6ae$var$kc = null, $6d365ff072dfd6ae$var$lc = null;
function $6d365ff072dfd6ae$var$mc(a) {
    if ($6d365ff072dfd6ae$var$lc && "function" === typeof $6d365ff072dfd6ae$var$lc.onCommitFiberRoot) try {
        $6d365ff072dfd6ae$var$lc.onCommitFiberRoot($6d365ff072dfd6ae$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $6d365ff072dfd6ae$var$oc = Math.clz32 ? Math.clz32 : $6d365ff072dfd6ae$var$nc, $6d365ff072dfd6ae$var$pc = Math.log, $6d365ff072dfd6ae$var$qc = Math.LN2;
function $6d365ff072dfd6ae$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($6d365ff072dfd6ae$var$pc(a) / $6d365ff072dfd6ae$var$qc | 0) | 0;
}
var $6d365ff072dfd6ae$var$rc = 64, $6d365ff072dfd6ae$var$sc = 4194304;
function $6d365ff072dfd6ae$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $6d365ff072dfd6ae$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $6d365ff072dfd6ae$var$tc(h) : (f &= g, 0 !== f && (d = $6d365ff072dfd6ae$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $6d365ff072dfd6ae$var$tc(g) : 0 !== f && (d = $6d365ff072dfd6ae$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $6d365ff072dfd6ae$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $6d365ff072dfd6ae$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $6d365ff072dfd6ae$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $6d365ff072dfd6ae$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $6d365ff072dfd6ae$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $6d365ff072dfd6ae$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $6d365ff072dfd6ae$var$yc() {
    var a = $6d365ff072dfd6ae$var$rc;
    $6d365ff072dfd6ae$var$rc <<= 1;
    0 === ($6d365ff072dfd6ae$var$rc & 4194240) && ($6d365ff072dfd6ae$var$rc = 64);
    return a;
}
function $6d365ff072dfd6ae$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $6d365ff072dfd6ae$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $6d365ff072dfd6ae$var$oc(b);
    a[b] = c;
}
function $6d365ff072dfd6ae$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $6d365ff072dfd6ae$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $6d365ff072dfd6ae$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $6d365ff072dfd6ae$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $6d365ff072dfd6ae$var$C = 0;
function $6d365ff072dfd6ae$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $6d365ff072dfd6ae$var$Ec, $6d365ff072dfd6ae$var$Fc, $6d365ff072dfd6ae$var$Gc, $6d365ff072dfd6ae$var$Hc, $6d365ff072dfd6ae$var$Ic, $6d365ff072dfd6ae$var$Jc = !1, $6d365ff072dfd6ae$var$Kc = [], $6d365ff072dfd6ae$var$Lc = null, $6d365ff072dfd6ae$var$Mc = null, $6d365ff072dfd6ae$var$Nc = null, $6d365ff072dfd6ae$var$Oc = new Map, $6d365ff072dfd6ae$var$Pc = new Map, $6d365ff072dfd6ae$var$Qc = [], $6d365ff072dfd6ae$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $6d365ff072dfd6ae$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $6d365ff072dfd6ae$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $6d365ff072dfd6ae$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $6d365ff072dfd6ae$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $6d365ff072dfd6ae$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $6d365ff072dfd6ae$var$Pc.delete(b.pointerId);
    }
}
function $6d365ff072dfd6ae$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $6d365ff072dfd6ae$var$Cb(b), null !== b && $6d365ff072dfd6ae$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $6d365ff072dfd6ae$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $6d365ff072dfd6ae$var$Lc = $6d365ff072dfd6ae$var$Tc($6d365ff072dfd6ae$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $6d365ff072dfd6ae$var$Mc = $6d365ff072dfd6ae$var$Tc($6d365ff072dfd6ae$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $6d365ff072dfd6ae$var$Nc = $6d365ff072dfd6ae$var$Tc($6d365ff072dfd6ae$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $6d365ff072dfd6ae$var$Oc.set(f, $6d365ff072dfd6ae$var$Tc($6d365ff072dfd6ae$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $6d365ff072dfd6ae$var$Pc.set(f, $6d365ff072dfd6ae$var$Tc($6d365ff072dfd6ae$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $6d365ff072dfd6ae$var$Vc(a) {
    var b = $6d365ff072dfd6ae$var$Wc(a.target);
    if (null !== b) {
        var c = $6d365ff072dfd6ae$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $6d365ff072dfd6ae$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $6d365ff072dfd6ae$var$Ic(a.priority, function() {
                        $6d365ff072dfd6ae$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $6d365ff072dfd6ae$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $6d365ff072dfd6ae$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $6d365ff072dfd6ae$var$wb = d;
            c.target.dispatchEvent(d);
            $6d365ff072dfd6ae$var$wb = null;
        } else return b = $6d365ff072dfd6ae$var$Cb(c), null !== b && $6d365ff072dfd6ae$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $6d365ff072dfd6ae$var$Zc(a, b, c) {
    $6d365ff072dfd6ae$var$Xc(a) && c.delete(b);
}
function $6d365ff072dfd6ae$var$$c() {
    $6d365ff072dfd6ae$var$Jc = !1;
    null !== $6d365ff072dfd6ae$var$Lc && $6d365ff072dfd6ae$var$Xc($6d365ff072dfd6ae$var$Lc) && ($6d365ff072dfd6ae$var$Lc = null);
    null !== $6d365ff072dfd6ae$var$Mc && $6d365ff072dfd6ae$var$Xc($6d365ff072dfd6ae$var$Mc) && ($6d365ff072dfd6ae$var$Mc = null);
    null !== $6d365ff072dfd6ae$var$Nc && $6d365ff072dfd6ae$var$Xc($6d365ff072dfd6ae$var$Nc) && ($6d365ff072dfd6ae$var$Nc = null);
    $6d365ff072dfd6ae$var$Oc.forEach($6d365ff072dfd6ae$var$Zc);
    $6d365ff072dfd6ae$var$Pc.forEach($6d365ff072dfd6ae$var$Zc);
}
function $6d365ff072dfd6ae$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $6d365ff072dfd6ae$var$Jc || ($6d365ff072dfd6ae$var$Jc = !0, $jNpn7.unstable_scheduleCallback($jNpn7.unstable_NormalPriority, $6d365ff072dfd6ae$var$$c)));
}
function $6d365ff072dfd6ae$var$bd(a) {
    function b(b) {
        return $6d365ff072dfd6ae$var$ad(b, a);
    }
    if (0 < $6d365ff072dfd6ae$var$Kc.length) {
        $6d365ff072dfd6ae$var$ad($6d365ff072dfd6ae$var$Kc[0], a);
        for(var c = 1; c < $6d365ff072dfd6ae$var$Kc.length; c++){
            var d = $6d365ff072dfd6ae$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $6d365ff072dfd6ae$var$Lc && $6d365ff072dfd6ae$var$ad($6d365ff072dfd6ae$var$Lc, a);
    null !== $6d365ff072dfd6ae$var$Mc && $6d365ff072dfd6ae$var$ad($6d365ff072dfd6ae$var$Mc, a);
    null !== $6d365ff072dfd6ae$var$Nc && $6d365ff072dfd6ae$var$ad($6d365ff072dfd6ae$var$Nc, a);
    $6d365ff072dfd6ae$var$Oc.forEach(b);
    $6d365ff072dfd6ae$var$Pc.forEach(b);
    for(c = 0; c < $6d365ff072dfd6ae$var$Qc.length; c++)d = $6d365ff072dfd6ae$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $6d365ff072dfd6ae$var$Qc.length && (c = $6d365ff072dfd6ae$var$Qc[0], null === c.blockedOn);)$6d365ff072dfd6ae$var$Vc(c), null === c.blockedOn && $6d365ff072dfd6ae$var$Qc.shift();
}
var $6d365ff072dfd6ae$var$cd = $6d365ff072dfd6ae$var$ua.ReactCurrentBatchConfig, $6d365ff072dfd6ae$var$dd = !0;
function $6d365ff072dfd6ae$var$ed(a, b, c, d) {
    var e = $6d365ff072dfd6ae$var$C, f = $6d365ff072dfd6ae$var$cd.transition;
    $6d365ff072dfd6ae$var$cd.transition = null;
    try {
        $6d365ff072dfd6ae$var$C = 1, $6d365ff072dfd6ae$var$fd(a, b, c, d);
    } finally{
        $6d365ff072dfd6ae$var$C = e, $6d365ff072dfd6ae$var$cd.transition = f;
    }
}
function $6d365ff072dfd6ae$var$gd(a, b, c, d) {
    var e = $6d365ff072dfd6ae$var$C, f = $6d365ff072dfd6ae$var$cd.transition;
    $6d365ff072dfd6ae$var$cd.transition = null;
    try {
        $6d365ff072dfd6ae$var$C = 4, $6d365ff072dfd6ae$var$fd(a, b, c, d);
    } finally{
        $6d365ff072dfd6ae$var$C = e, $6d365ff072dfd6ae$var$cd.transition = f;
    }
}
function $6d365ff072dfd6ae$var$fd(a, b, c, d) {
    if ($6d365ff072dfd6ae$var$dd) {
        var e = $6d365ff072dfd6ae$var$Yc(a, b, c, d);
        if (null === e) $6d365ff072dfd6ae$var$hd(a, b, d, $6d365ff072dfd6ae$var$id, c), $6d365ff072dfd6ae$var$Sc(a, d);
        else if ($6d365ff072dfd6ae$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($6d365ff072dfd6ae$var$Sc(a, d), b & 4 && -1 < $6d365ff072dfd6ae$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $6d365ff072dfd6ae$var$Cb(e);
                null !== f && $6d365ff072dfd6ae$var$Ec(f);
                f = $6d365ff072dfd6ae$var$Yc(a, b, c, d);
                null === f && $6d365ff072dfd6ae$var$hd(a, b, d, $6d365ff072dfd6ae$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $6d365ff072dfd6ae$var$hd(a, b, d, null, c);
    }
}
var $6d365ff072dfd6ae$var$id = null;
function $6d365ff072dfd6ae$var$Yc(a, b, c, d) {
    $6d365ff072dfd6ae$var$id = null;
    a = $6d365ff072dfd6ae$var$xb(d);
    a = $6d365ff072dfd6ae$var$Wc(a);
    if (null !== a) {
        if (b = $6d365ff072dfd6ae$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $6d365ff072dfd6ae$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $6d365ff072dfd6ae$var$id = a;
    return null;
}
function $6d365ff072dfd6ae$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($6d365ff072dfd6ae$var$ec()){
                case $6d365ff072dfd6ae$var$fc:
                    return 1;
                case $6d365ff072dfd6ae$var$gc:
                    return 4;
                case $6d365ff072dfd6ae$var$hc:
                case $6d365ff072dfd6ae$var$ic:
                    return 16;
                case $6d365ff072dfd6ae$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $6d365ff072dfd6ae$var$kd = null, $6d365ff072dfd6ae$var$ld = null, $6d365ff072dfd6ae$var$md = null;
function $6d365ff072dfd6ae$var$nd() {
    if ($6d365ff072dfd6ae$var$md) return $6d365ff072dfd6ae$var$md;
    var a, b = $6d365ff072dfd6ae$var$ld, c = b.length, d, e = "value" in $6d365ff072dfd6ae$var$kd ? $6d365ff072dfd6ae$var$kd.value : $6d365ff072dfd6ae$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $6d365ff072dfd6ae$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $6d365ff072dfd6ae$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $6d365ff072dfd6ae$var$pd() {
    return !0;
}
function $6d365ff072dfd6ae$var$qd() {
    return !1;
}
function $6d365ff072dfd6ae$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $6d365ff072dfd6ae$var$pd : $6d365ff072dfd6ae$var$qd;
        this.isPropagationStopped = $6d365ff072dfd6ae$var$qd;
        return this;
    }
    $6d365ff072dfd6ae$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $6d365ff072dfd6ae$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $6d365ff072dfd6ae$var$pd);
        },
        persist: function() {},
        isPersistent: $6d365ff072dfd6ae$var$pd
    });
    return b;
}
var $6d365ff072dfd6ae$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $6d365ff072dfd6ae$var$td = $6d365ff072dfd6ae$var$rd($6d365ff072dfd6ae$var$sd), $6d365ff072dfd6ae$var$ud = $6d365ff072dfd6ae$var$A({}, $6d365ff072dfd6ae$var$sd, {
    view: 0,
    detail: 0
}), $6d365ff072dfd6ae$var$vd = $6d365ff072dfd6ae$var$rd($6d365ff072dfd6ae$var$ud), $6d365ff072dfd6ae$var$wd, $6d365ff072dfd6ae$var$xd, $6d365ff072dfd6ae$var$yd, $6d365ff072dfd6ae$var$Ad = $6d365ff072dfd6ae$var$A({}, $6d365ff072dfd6ae$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $6d365ff072dfd6ae$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $6d365ff072dfd6ae$var$yd && ($6d365ff072dfd6ae$var$yd && "mousemove" === a.type ? ($6d365ff072dfd6ae$var$wd = a.screenX - $6d365ff072dfd6ae$var$yd.screenX, $6d365ff072dfd6ae$var$xd = a.screenY - $6d365ff072dfd6ae$var$yd.screenY) : $6d365ff072dfd6ae$var$xd = $6d365ff072dfd6ae$var$wd = 0, $6d365ff072dfd6ae$var$yd = a);
        return $6d365ff072dfd6ae$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $6d365ff072dfd6ae$var$xd;
    }
}), $6d365ff072dfd6ae$var$Bd = $6d365ff072dfd6ae$var$rd($6d365ff072dfd6ae$var$Ad), $6d365ff072dfd6ae$var$Cd = $6d365ff072dfd6ae$var$A({}, $6d365ff072dfd6ae$var$Ad, {
    dataTransfer: 0
}), $6d365ff072dfd6ae$var$Dd = $6d365ff072dfd6ae$var$rd($6d365ff072dfd6ae$var$Cd), $6d365ff072dfd6ae$var$Ed = $6d365ff072dfd6ae$var$A({}, $6d365ff072dfd6ae$var$ud, {
    relatedTarget: 0
}), $6d365ff072dfd6ae$var$Fd = $6d365ff072dfd6ae$var$rd($6d365ff072dfd6ae$var$Ed), $6d365ff072dfd6ae$var$Gd = $6d365ff072dfd6ae$var$A({}, $6d365ff072dfd6ae$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $6d365ff072dfd6ae$var$Hd = $6d365ff072dfd6ae$var$rd($6d365ff072dfd6ae$var$Gd), $6d365ff072dfd6ae$var$Id = $6d365ff072dfd6ae$var$A({}, $6d365ff072dfd6ae$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $6d365ff072dfd6ae$var$Jd = $6d365ff072dfd6ae$var$rd($6d365ff072dfd6ae$var$Id), $6d365ff072dfd6ae$var$Kd = $6d365ff072dfd6ae$var$A({}, $6d365ff072dfd6ae$var$sd, {
    data: 0
}), $6d365ff072dfd6ae$var$Ld = $6d365ff072dfd6ae$var$rd($6d365ff072dfd6ae$var$Kd), $6d365ff072dfd6ae$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $6d365ff072dfd6ae$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $6d365ff072dfd6ae$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $6d365ff072dfd6ae$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $6d365ff072dfd6ae$var$Od[a]) ? !!b[a] : !1;
}
function $6d365ff072dfd6ae$var$zd() {
    return $6d365ff072dfd6ae$var$Pd;
}
var $6d365ff072dfd6ae$var$Qd = $6d365ff072dfd6ae$var$A({}, $6d365ff072dfd6ae$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $6d365ff072dfd6ae$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $6d365ff072dfd6ae$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $6d365ff072dfd6ae$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $6d365ff072dfd6ae$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $6d365ff072dfd6ae$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $6d365ff072dfd6ae$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $6d365ff072dfd6ae$var$Rd = $6d365ff072dfd6ae$var$rd($6d365ff072dfd6ae$var$Qd), $6d365ff072dfd6ae$var$Sd = $6d365ff072dfd6ae$var$A({}, $6d365ff072dfd6ae$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $6d365ff072dfd6ae$var$Td = $6d365ff072dfd6ae$var$rd($6d365ff072dfd6ae$var$Sd), $6d365ff072dfd6ae$var$Ud = $6d365ff072dfd6ae$var$A({}, $6d365ff072dfd6ae$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $6d365ff072dfd6ae$var$zd
}), $6d365ff072dfd6ae$var$Vd = $6d365ff072dfd6ae$var$rd($6d365ff072dfd6ae$var$Ud), $6d365ff072dfd6ae$var$Wd = $6d365ff072dfd6ae$var$A({}, $6d365ff072dfd6ae$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $6d365ff072dfd6ae$var$Xd = $6d365ff072dfd6ae$var$rd($6d365ff072dfd6ae$var$Wd), $6d365ff072dfd6ae$var$Yd = $6d365ff072dfd6ae$var$A({}, $6d365ff072dfd6ae$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $6d365ff072dfd6ae$var$Zd = $6d365ff072dfd6ae$var$rd($6d365ff072dfd6ae$var$Yd), $6d365ff072dfd6ae$var$$d = [
    9,
    13,
    27,
    32
], $6d365ff072dfd6ae$var$ae = $6d365ff072dfd6ae$var$ia && "CompositionEvent" in window, $6d365ff072dfd6ae$var$be = null;
$6d365ff072dfd6ae$var$ia && "documentMode" in document && ($6d365ff072dfd6ae$var$be = document.documentMode);
var $6d365ff072dfd6ae$var$ce = $6d365ff072dfd6ae$var$ia && "TextEvent" in window && !$6d365ff072dfd6ae$var$be, $6d365ff072dfd6ae$var$de = $6d365ff072dfd6ae$var$ia && (!$6d365ff072dfd6ae$var$ae || $6d365ff072dfd6ae$var$be && 8 < $6d365ff072dfd6ae$var$be && 11 >= $6d365ff072dfd6ae$var$be), $6d365ff072dfd6ae$var$ee = String.fromCharCode(32), $6d365ff072dfd6ae$var$fe = !1;
function $6d365ff072dfd6ae$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $6d365ff072dfd6ae$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $6d365ff072dfd6ae$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $6d365ff072dfd6ae$var$ie = !1;
function $6d365ff072dfd6ae$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $6d365ff072dfd6ae$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $6d365ff072dfd6ae$var$fe = !0;
            return $6d365ff072dfd6ae$var$ee;
        case "textInput":
            return a = b.data, a === $6d365ff072dfd6ae$var$ee && $6d365ff072dfd6ae$var$fe ? null : a;
        default:
            return null;
    }
}
function $6d365ff072dfd6ae$var$ke(a, b) {
    if ($6d365ff072dfd6ae$var$ie) return "compositionend" === a || !$6d365ff072dfd6ae$var$ae && $6d365ff072dfd6ae$var$ge(a, b) ? (a = $6d365ff072dfd6ae$var$nd(), $6d365ff072dfd6ae$var$md = $6d365ff072dfd6ae$var$ld = $6d365ff072dfd6ae$var$kd = null, $6d365ff072dfd6ae$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $6d365ff072dfd6ae$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $6d365ff072dfd6ae$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $6d365ff072dfd6ae$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$6d365ff072dfd6ae$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $6d365ff072dfd6ae$var$ne(a, b, c, d) {
    $6d365ff072dfd6ae$var$Eb(d);
    b = $6d365ff072dfd6ae$var$oe(b, "onChange");
    0 < b.length && (c = new $6d365ff072dfd6ae$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $6d365ff072dfd6ae$var$pe = null, $6d365ff072dfd6ae$var$qe = null;
function $6d365ff072dfd6ae$var$re(a) {
    $6d365ff072dfd6ae$var$se(a, 0);
}
function $6d365ff072dfd6ae$var$te(a) {
    var b = $6d365ff072dfd6ae$var$ue(a);
    if ($6d365ff072dfd6ae$var$Wa(b)) return a;
}
function $6d365ff072dfd6ae$var$ve(a, b) {
    if ("change" === a) return b;
}
var $6d365ff072dfd6ae$var$we = !1;
if ($6d365ff072dfd6ae$var$ia) {
    var $6d365ff072dfd6ae$var$xe;
    if ($6d365ff072dfd6ae$var$ia) {
        var $6d365ff072dfd6ae$var$ye = "oninput" in document;
        if (!$6d365ff072dfd6ae$var$ye) {
            var $6d365ff072dfd6ae$var$ze = document.createElement("div");
            $6d365ff072dfd6ae$var$ze.setAttribute("oninput", "return;");
            $6d365ff072dfd6ae$var$ye = "function" === typeof $6d365ff072dfd6ae$var$ze.oninput;
        }
        $6d365ff072dfd6ae$var$xe = $6d365ff072dfd6ae$var$ye;
    } else $6d365ff072dfd6ae$var$xe = !1;
    $6d365ff072dfd6ae$var$we = $6d365ff072dfd6ae$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $6d365ff072dfd6ae$var$Ae() {
    $6d365ff072dfd6ae$var$pe && ($6d365ff072dfd6ae$var$pe.detachEvent("onpropertychange", $6d365ff072dfd6ae$var$Be), $6d365ff072dfd6ae$var$qe = $6d365ff072dfd6ae$var$pe = null);
}
function $6d365ff072dfd6ae$var$Be(a) {
    if ("value" === a.propertyName && $6d365ff072dfd6ae$var$te($6d365ff072dfd6ae$var$qe)) {
        var b = [];
        $6d365ff072dfd6ae$var$ne(b, $6d365ff072dfd6ae$var$qe, a, $6d365ff072dfd6ae$var$xb(a));
        $6d365ff072dfd6ae$var$Jb($6d365ff072dfd6ae$var$re, b);
    }
}
function $6d365ff072dfd6ae$var$Ce(a, b, c) {
    "focusin" === a ? ($6d365ff072dfd6ae$var$Ae(), $6d365ff072dfd6ae$var$pe = b, $6d365ff072dfd6ae$var$qe = c, $6d365ff072dfd6ae$var$pe.attachEvent("onpropertychange", $6d365ff072dfd6ae$var$Be)) : "focusout" === a && $6d365ff072dfd6ae$var$Ae();
}
function $6d365ff072dfd6ae$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $6d365ff072dfd6ae$var$te($6d365ff072dfd6ae$var$qe);
}
function $6d365ff072dfd6ae$var$Ee(a, b) {
    if ("click" === a) return $6d365ff072dfd6ae$var$te(b);
}
function $6d365ff072dfd6ae$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $6d365ff072dfd6ae$var$te(b);
}
function $6d365ff072dfd6ae$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $6d365ff072dfd6ae$var$He = "function" === typeof Object.is ? Object.is : $6d365ff072dfd6ae$var$Ge;
function $6d365ff072dfd6ae$var$Ie(a, b) {
    if ($6d365ff072dfd6ae$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$6d365ff072dfd6ae$var$ja.call(b, e) || !$6d365ff072dfd6ae$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $6d365ff072dfd6ae$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $6d365ff072dfd6ae$var$Ke(a, b) {
    var c = $6d365ff072dfd6ae$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $6d365ff072dfd6ae$var$Je(c);
    }
}
function $6d365ff072dfd6ae$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $6d365ff072dfd6ae$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $6d365ff072dfd6ae$var$Me() {
    for(var a = window, b = $6d365ff072dfd6ae$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $6d365ff072dfd6ae$var$Xa(a.document);
    }
    return b;
}
function $6d365ff072dfd6ae$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $6d365ff072dfd6ae$var$Oe(a) {
    var b = $6d365ff072dfd6ae$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $6d365ff072dfd6ae$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $6d365ff072dfd6ae$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $6d365ff072dfd6ae$var$Ke(c, f);
                var g = $6d365ff072dfd6ae$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $6d365ff072dfd6ae$var$Pe = $6d365ff072dfd6ae$var$ia && "documentMode" in document && 11 >= document.documentMode, $6d365ff072dfd6ae$var$Qe = null, $6d365ff072dfd6ae$var$Re = null, $6d365ff072dfd6ae$var$Se = null, $6d365ff072dfd6ae$var$Te = !1;
function $6d365ff072dfd6ae$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $6d365ff072dfd6ae$var$Te || null == $6d365ff072dfd6ae$var$Qe || $6d365ff072dfd6ae$var$Qe !== $6d365ff072dfd6ae$var$Xa(d) || (d = $6d365ff072dfd6ae$var$Qe, "selectionStart" in d && $6d365ff072dfd6ae$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $6d365ff072dfd6ae$var$Se && $6d365ff072dfd6ae$var$Ie($6d365ff072dfd6ae$var$Se, d) || ($6d365ff072dfd6ae$var$Se = d, d = $6d365ff072dfd6ae$var$oe($6d365ff072dfd6ae$var$Re, "onSelect"), 0 < d.length && (b = new $6d365ff072dfd6ae$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $6d365ff072dfd6ae$var$Qe)));
}
function $6d365ff072dfd6ae$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $6d365ff072dfd6ae$var$We = {
    animationend: $6d365ff072dfd6ae$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $6d365ff072dfd6ae$var$Ve("Animation", "AnimationIteration"),
    animationstart: $6d365ff072dfd6ae$var$Ve("Animation", "AnimationStart"),
    transitionend: $6d365ff072dfd6ae$var$Ve("Transition", "TransitionEnd")
}, $6d365ff072dfd6ae$var$Xe = {}, $6d365ff072dfd6ae$var$Ye = {};
$6d365ff072dfd6ae$var$ia && ($6d365ff072dfd6ae$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $6d365ff072dfd6ae$var$We.animationend.animation, delete $6d365ff072dfd6ae$var$We.animationiteration.animation, delete $6d365ff072dfd6ae$var$We.animationstart.animation), "TransitionEvent" in window || delete $6d365ff072dfd6ae$var$We.transitionend.transition);
function $6d365ff072dfd6ae$var$Ze(a) {
    if ($6d365ff072dfd6ae$var$Xe[a]) return $6d365ff072dfd6ae$var$Xe[a];
    if (!$6d365ff072dfd6ae$var$We[a]) return a;
    var b = $6d365ff072dfd6ae$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $6d365ff072dfd6ae$var$Ye) return $6d365ff072dfd6ae$var$Xe[a] = b[c];
    return a;
}
var $6d365ff072dfd6ae$var$$e = $6d365ff072dfd6ae$var$Ze("animationend"), $6d365ff072dfd6ae$var$af = $6d365ff072dfd6ae$var$Ze("animationiteration"), $6d365ff072dfd6ae$var$bf = $6d365ff072dfd6ae$var$Ze("animationstart"), $6d365ff072dfd6ae$var$cf = $6d365ff072dfd6ae$var$Ze("transitionend"), $6d365ff072dfd6ae$var$df = new Map, $6d365ff072dfd6ae$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $6d365ff072dfd6ae$var$ff(a, b) {
    $6d365ff072dfd6ae$var$df.set(a, b);
    $6d365ff072dfd6ae$var$fa(b, [
        a
    ]);
}
for(var $6d365ff072dfd6ae$var$gf = 0; $6d365ff072dfd6ae$var$gf < $6d365ff072dfd6ae$var$ef.length; $6d365ff072dfd6ae$var$gf++){
    var $6d365ff072dfd6ae$var$hf = $6d365ff072dfd6ae$var$ef[$6d365ff072dfd6ae$var$gf], $6d365ff072dfd6ae$var$jf = $6d365ff072dfd6ae$var$hf.toLowerCase(), $6d365ff072dfd6ae$var$kf = $6d365ff072dfd6ae$var$hf[0].toUpperCase() + $6d365ff072dfd6ae$var$hf.slice(1);
    $6d365ff072dfd6ae$var$ff($6d365ff072dfd6ae$var$jf, "on" + $6d365ff072dfd6ae$var$kf);
}
$6d365ff072dfd6ae$var$ff($6d365ff072dfd6ae$var$$e, "onAnimationEnd");
$6d365ff072dfd6ae$var$ff($6d365ff072dfd6ae$var$af, "onAnimationIteration");
$6d365ff072dfd6ae$var$ff($6d365ff072dfd6ae$var$bf, "onAnimationStart");
$6d365ff072dfd6ae$var$ff("dblclick", "onDoubleClick");
$6d365ff072dfd6ae$var$ff("focusin", "onFocus");
$6d365ff072dfd6ae$var$ff("focusout", "onBlur");
$6d365ff072dfd6ae$var$ff($6d365ff072dfd6ae$var$cf, "onTransitionEnd");
$6d365ff072dfd6ae$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$6d365ff072dfd6ae$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$6d365ff072dfd6ae$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$6d365ff072dfd6ae$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$6d365ff072dfd6ae$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$6d365ff072dfd6ae$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$6d365ff072dfd6ae$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$6d365ff072dfd6ae$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$6d365ff072dfd6ae$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$6d365ff072dfd6ae$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $6d365ff072dfd6ae$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $6d365ff072dfd6ae$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($6d365ff072dfd6ae$var$lf));
function $6d365ff072dfd6ae$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $6d365ff072dfd6ae$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $6d365ff072dfd6ae$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $6d365ff072dfd6ae$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $6d365ff072dfd6ae$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($6d365ff072dfd6ae$var$Qb) throw a = $6d365ff072dfd6ae$var$Rb, $6d365ff072dfd6ae$var$Qb = !1, $6d365ff072dfd6ae$var$Rb = null, a;
}
function $6d365ff072dfd6ae$var$D(a, b) {
    var c = b[$6d365ff072dfd6ae$var$of];
    void 0 === c && (c = b[$6d365ff072dfd6ae$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($6d365ff072dfd6ae$var$pf(b, a, 2, !1), c.add(d));
}
function $6d365ff072dfd6ae$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $6d365ff072dfd6ae$var$pf(c, a, d, b);
}
var $6d365ff072dfd6ae$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $6d365ff072dfd6ae$var$sf(a) {
    if (!a[$6d365ff072dfd6ae$var$rf]) {
        a[$6d365ff072dfd6ae$var$rf] = !0;
        $6d365ff072dfd6ae$var$da.forEach(function(b) {
            "selectionchange" !== b && ($6d365ff072dfd6ae$var$mf.has(b) || $6d365ff072dfd6ae$var$qf(b, !1, a), $6d365ff072dfd6ae$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$6d365ff072dfd6ae$var$rf] || (b[$6d365ff072dfd6ae$var$rf] = !0, $6d365ff072dfd6ae$var$qf("selectionchange", !1, b));
    }
}
function $6d365ff072dfd6ae$var$pf(a, b, c, d) {
    switch($6d365ff072dfd6ae$var$jd(b)){
        case 1:
            var e = $6d365ff072dfd6ae$var$ed;
            break;
        case 4:
            e = $6d365ff072dfd6ae$var$gd;
            break;
        default:
            e = $6d365ff072dfd6ae$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$6d365ff072dfd6ae$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $6d365ff072dfd6ae$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $6d365ff072dfd6ae$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $6d365ff072dfd6ae$var$Jb(function() {
        var d = f, e = $6d365ff072dfd6ae$var$xb(c), g = [];
        a: {
            var h = $6d365ff072dfd6ae$var$df.get(a);
            if (void 0 !== h) {
                var k = $6d365ff072dfd6ae$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $6d365ff072dfd6ae$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $6d365ff072dfd6ae$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $6d365ff072dfd6ae$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $6d365ff072dfd6ae$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $6d365ff072dfd6ae$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $6d365ff072dfd6ae$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $6d365ff072dfd6ae$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $6d365ff072dfd6ae$var$Vd;
                        break;
                    case $6d365ff072dfd6ae$var$$e:
                    case $6d365ff072dfd6ae$var$af:
                    case $6d365ff072dfd6ae$var$bf:
                        k = $6d365ff072dfd6ae$var$Hd;
                        break;
                    case $6d365ff072dfd6ae$var$cf:
                        k = $6d365ff072dfd6ae$var$Xd;
                        break;
                    case "scroll":
                        k = $6d365ff072dfd6ae$var$vd;
                        break;
                    case "wheel":
                        k = $6d365ff072dfd6ae$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $6d365ff072dfd6ae$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $6d365ff072dfd6ae$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $6d365ff072dfd6ae$var$Kb(w, x), null != F && t.push($6d365ff072dfd6ae$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $6d365ff072dfd6ae$var$wb && (n = c.relatedTarget || c.fromElement) && ($6d365ff072dfd6ae$var$Wc(n) || n[$6d365ff072dfd6ae$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $6d365ff072dfd6ae$var$Wc(n) : null, null !== n && (J = $6d365ff072dfd6ae$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $6d365ff072dfd6ae$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $6d365ff072dfd6ae$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $6d365ff072dfd6ae$var$ue(k);
                        u = null == n ? h : $6d365ff072dfd6ae$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $6d365ff072dfd6ae$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $6d365ff072dfd6ae$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $6d365ff072dfd6ae$var$vf(F))u++;
                            for(; 0 < w - u;)t = $6d365ff072dfd6ae$var$vf(t), w--;
                            for(; 0 < u - w;)x = $6d365ff072dfd6ae$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $6d365ff072dfd6ae$var$vf(t);
                                x = $6d365ff072dfd6ae$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $6d365ff072dfd6ae$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $6d365ff072dfd6ae$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $6d365ff072dfd6ae$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $6d365ff072dfd6ae$var$ve;
                else if ($6d365ff072dfd6ae$var$me(h)) {
                    if ($6d365ff072dfd6ae$var$we) na = $6d365ff072dfd6ae$var$Fe;
                    else {
                        na = $6d365ff072dfd6ae$var$De;
                        var xa = $6d365ff072dfd6ae$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $6d365ff072dfd6ae$var$Ee);
                if (na && (na = na(a, d))) {
                    $6d365ff072dfd6ae$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $6d365ff072dfd6ae$var$cb(h, "number", h.value);
            }
            xa = d ? $6d365ff072dfd6ae$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($6d365ff072dfd6ae$var$me(xa) || "true" === xa.contentEditable) $6d365ff072dfd6ae$var$Qe = xa, $6d365ff072dfd6ae$var$Re = d, $6d365ff072dfd6ae$var$Se = null;
                    break;
                case "focusout":
                    $6d365ff072dfd6ae$var$Se = $6d365ff072dfd6ae$var$Re = $6d365ff072dfd6ae$var$Qe = null;
                    break;
                case "mousedown":
                    $6d365ff072dfd6ae$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $6d365ff072dfd6ae$var$Te = !1;
                    $6d365ff072dfd6ae$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($6d365ff072dfd6ae$var$Pe) break;
                case "keydown":
                case "keyup":
                    $6d365ff072dfd6ae$var$Ue(g, c, e);
            }
            var $a;
            if ($6d365ff072dfd6ae$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $6d365ff072dfd6ae$var$ie ? $6d365ff072dfd6ae$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($6d365ff072dfd6ae$var$de && "ko" !== c.locale && ($6d365ff072dfd6ae$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $6d365ff072dfd6ae$var$ie && ($a = $6d365ff072dfd6ae$var$nd()) : ($6d365ff072dfd6ae$var$kd = e, $6d365ff072dfd6ae$var$ld = "value" in $6d365ff072dfd6ae$var$kd ? $6d365ff072dfd6ae$var$kd.value : $6d365ff072dfd6ae$var$kd.textContent, $6d365ff072dfd6ae$var$ie = !0)), xa = $6d365ff072dfd6ae$var$oe(d, ba), 0 < xa.length && (ba = new $6d365ff072dfd6ae$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $6d365ff072dfd6ae$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $6d365ff072dfd6ae$var$ce ? $6d365ff072dfd6ae$var$je(a, c) : $6d365ff072dfd6ae$var$ke(a, c)) d = $6d365ff072dfd6ae$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $6d365ff072dfd6ae$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $6d365ff072dfd6ae$var$se(g, b);
    });
}
function $6d365ff072dfd6ae$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $6d365ff072dfd6ae$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $6d365ff072dfd6ae$var$Kb(a, c), null != f && d.unshift($6d365ff072dfd6ae$var$tf(a, f, e)), f = $6d365ff072dfd6ae$var$Kb(a, b), null != f && d.push($6d365ff072dfd6ae$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $6d365ff072dfd6ae$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $6d365ff072dfd6ae$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $6d365ff072dfd6ae$var$Kb(c, f), null != k && g.unshift($6d365ff072dfd6ae$var$tf(c, k, h))) : e || (k = $6d365ff072dfd6ae$var$Kb(c, f), null != k && g.push($6d365ff072dfd6ae$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $6d365ff072dfd6ae$var$xf = /\r\n?/g, $6d365ff072dfd6ae$var$yf = /\u0000|\uFFFD/g;
function $6d365ff072dfd6ae$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($6d365ff072dfd6ae$var$xf, "\n").replace($6d365ff072dfd6ae$var$yf, "");
}
function $6d365ff072dfd6ae$var$Af(a, b, c) {
    b = $6d365ff072dfd6ae$var$zf(b);
    if ($6d365ff072dfd6ae$var$zf(a) !== b && c) throw Error($6d365ff072dfd6ae$var$p(425));
}
function $6d365ff072dfd6ae$var$Bf() {}
var $6d365ff072dfd6ae$var$Cf = null, $6d365ff072dfd6ae$var$Df = null;
function $6d365ff072dfd6ae$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $6d365ff072dfd6ae$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $6d365ff072dfd6ae$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $6d365ff072dfd6ae$var$Hf = "function" === typeof Promise ? Promise : void 0, $6d365ff072dfd6ae$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $6d365ff072dfd6ae$var$Hf ? function(a) {
    return $6d365ff072dfd6ae$var$Hf.resolve(null).then(a).catch($6d365ff072dfd6ae$var$If);
} : $6d365ff072dfd6ae$var$Ff;
function $6d365ff072dfd6ae$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $6d365ff072dfd6ae$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $6d365ff072dfd6ae$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $6d365ff072dfd6ae$var$bd(b);
}
function $6d365ff072dfd6ae$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $6d365ff072dfd6ae$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $6d365ff072dfd6ae$var$Nf = Math.random().toString(36).slice(2), $6d365ff072dfd6ae$var$Of = "__reactFiber$" + $6d365ff072dfd6ae$var$Nf, $6d365ff072dfd6ae$var$Pf = "__reactProps$" + $6d365ff072dfd6ae$var$Nf, $6d365ff072dfd6ae$var$uf = "__reactContainer$" + $6d365ff072dfd6ae$var$Nf, $6d365ff072dfd6ae$var$of = "__reactEvents$" + $6d365ff072dfd6ae$var$Nf, $6d365ff072dfd6ae$var$Qf = "__reactListeners$" + $6d365ff072dfd6ae$var$Nf, $6d365ff072dfd6ae$var$Rf = "__reactHandles$" + $6d365ff072dfd6ae$var$Nf;
function $6d365ff072dfd6ae$var$Wc(a) {
    var b = a[$6d365ff072dfd6ae$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$6d365ff072dfd6ae$var$uf] || c[$6d365ff072dfd6ae$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $6d365ff072dfd6ae$var$Mf(a); null !== a;){
                if (c = a[$6d365ff072dfd6ae$var$Of]) return c;
                a = $6d365ff072dfd6ae$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $6d365ff072dfd6ae$var$Cb(a) {
    a = a[$6d365ff072dfd6ae$var$Of] || a[$6d365ff072dfd6ae$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $6d365ff072dfd6ae$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($6d365ff072dfd6ae$var$p(33));
}
function $6d365ff072dfd6ae$var$Db(a) {
    return a[$6d365ff072dfd6ae$var$Pf] || null;
}
var $6d365ff072dfd6ae$var$Sf = [], $6d365ff072dfd6ae$var$Tf = -1;
function $6d365ff072dfd6ae$var$Uf(a) {
    return {
        current: a
    };
}
function $6d365ff072dfd6ae$var$E(a) {
    0 > $6d365ff072dfd6ae$var$Tf || (a.current = $6d365ff072dfd6ae$var$Sf[$6d365ff072dfd6ae$var$Tf], $6d365ff072dfd6ae$var$Sf[$6d365ff072dfd6ae$var$Tf] = null, $6d365ff072dfd6ae$var$Tf--);
}
function $6d365ff072dfd6ae$var$G(a, b) {
    $6d365ff072dfd6ae$var$Tf++;
    $6d365ff072dfd6ae$var$Sf[$6d365ff072dfd6ae$var$Tf] = a.current;
    a.current = b;
}
var $6d365ff072dfd6ae$var$Vf = {}, $6d365ff072dfd6ae$var$H = $6d365ff072dfd6ae$var$Uf($6d365ff072dfd6ae$var$Vf), $6d365ff072dfd6ae$var$Wf = $6d365ff072dfd6ae$var$Uf(!1), $6d365ff072dfd6ae$var$Xf = $6d365ff072dfd6ae$var$Vf;
function $6d365ff072dfd6ae$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $6d365ff072dfd6ae$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $6d365ff072dfd6ae$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $6d365ff072dfd6ae$var$$f() {
    $6d365ff072dfd6ae$var$E($6d365ff072dfd6ae$var$Wf);
    $6d365ff072dfd6ae$var$E($6d365ff072dfd6ae$var$H);
}
function $6d365ff072dfd6ae$var$ag(a, b, c) {
    if ($6d365ff072dfd6ae$var$H.current !== $6d365ff072dfd6ae$var$Vf) throw Error($6d365ff072dfd6ae$var$p(168));
    $6d365ff072dfd6ae$var$G($6d365ff072dfd6ae$var$H, b);
    $6d365ff072dfd6ae$var$G($6d365ff072dfd6ae$var$Wf, c);
}
function $6d365ff072dfd6ae$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($6d365ff072dfd6ae$var$p(108, $6d365ff072dfd6ae$var$Ra(a) || "Unknown", e));
    return $6d365ff072dfd6ae$var$A({}, c, d);
}
function $6d365ff072dfd6ae$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $6d365ff072dfd6ae$var$Vf;
    $6d365ff072dfd6ae$var$Xf = $6d365ff072dfd6ae$var$H.current;
    $6d365ff072dfd6ae$var$G($6d365ff072dfd6ae$var$H, a);
    $6d365ff072dfd6ae$var$G($6d365ff072dfd6ae$var$Wf, $6d365ff072dfd6ae$var$Wf.current);
    return !0;
}
function $6d365ff072dfd6ae$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($6d365ff072dfd6ae$var$p(169));
    c ? (a = $6d365ff072dfd6ae$var$bg(a, b, $6d365ff072dfd6ae$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $6d365ff072dfd6ae$var$E($6d365ff072dfd6ae$var$Wf), $6d365ff072dfd6ae$var$E($6d365ff072dfd6ae$var$H), $6d365ff072dfd6ae$var$G($6d365ff072dfd6ae$var$H, a)) : $6d365ff072dfd6ae$var$E($6d365ff072dfd6ae$var$Wf);
    $6d365ff072dfd6ae$var$G($6d365ff072dfd6ae$var$Wf, c);
}
var $6d365ff072dfd6ae$var$eg = null, $6d365ff072dfd6ae$var$fg = !1, $6d365ff072dfd6ae$var$gg = !1;
function $6d365ff072dfd6ae$var$hg(a) {
    null === $6d365ff072dfd6ae$var$eg ? $6d365ff072dfd6ae$var$eg = [
        a
    ] : $6d365ff072dfd6ae$var$eg.push(a);
}
function $6d365ff072dfd6ae$var$ig(a) {
    $6d365ff072dfd6ae$var$fg = !0;
    $6d365ff072dfd6ae$var$hg(a);
}
function $6d365ff072dfd6ae$var$jg() {
    if (!$6d365ff072dfd6ae$var$gg && null !== $6d365ff072dfd6ae$var$eg) {
        $6d365ff072dfd6ae$var$gg = !0;
        var a = 0, b = $6d365ff072dfd6ae$var$C;
        try {
            var c = $6d365ff072dfd6ae$var$eg;
            for($6d365ff072dfd6ae$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $6d365ff072dfd6ae$var$eg = null;
            $6d365ff072dfd6ae$var$fg = !1;
        } catch (e) {
            throw null !== $6d365ff072dfd6ae$var$eg && ($6d365ff072dfd6ae$var$eg = $6d365ff072dfd6ae$var$eg.slice(a + 1)), $6d365ff072dfd6ae$var$ac($6d365ff072dfd6ae$var$fc, $6d365ff072dfd6ae$var$jg), e;
        } finally{
            $6d365ff072dfd6ae$var$C = b, $6d365ff072dfd6ae$var$gg = !1;
        }
    }
    return null;
}
var $6d365ff072dfd6ae$var$kg = [], $6d365ff072dfd6ae$var$lg = 0, $6d365ff072dfd6ae$var$mg = null, $6d365ff072dfd6ae$var$ng = 0, $6d365ff072dfd6ae$var$og = [], $6d365ff072dfd6ae$var$pg = 0, $6d365ff072dfd6ae$var$qg = null, $6d365ff072dfd6ae$var$rg = 1, $6d365ff072dfd6ae$var$sg = "";
function $6d365ff072dfd6ae$var$tg(a, b) {
    $6d365ff072dfd6ae$var$kg[$6d365ff072dfd6ae$var$lg++] = $6d365ff072dfd6ae$var$ng;
    $6d365ff072dfd6ae$var$kg[$6d365ff072dfd6ae$var$lg++] = $6d365ff072dfd6ae$var$mg;
    $6d365ff072dfd6ae$var$mg = a;
    $6d365ff072dfd6ae$var$ng = b;
}
function $6d365ff072dfd6ae$var$ug(a, b, c) {
    $6d365ff072dfd6ae$var$og[$6d365ff072dfd6ae$var$pg++] = $6d365ff072dfd6ae$var$rg;
    $6d365ff072dfd6ae$var$og[$6d365ff072dfd6ae$var$pg++] = $6d365ff072dfd6ae$var$sg;
    $6d365ff072dfd6ae$var$og[$6d365ff072dfd6ae$var$pg++] = $6d365ff072dfd6ae$var$qg;
    $6d365ff072dfd6ae$var$qg = a;
    var d = $6d365ff072dfd6ae$var$rg;
    a = $6d365ff072dfd6ae$var$sg;
    var e = 32 - $6d365ff072dfd6ae$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $6d365ff072dfd6ae$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $6d365ff072dfd6ae$var$rg = 1 << 32 - $6d365ff072dfd6ae$var$oc(b) + e | c << e | d;
        $6d365ff072dfd6ae$var$sg = f + a;
    } else $6d365ff072dfd6ae$var$rg = 1 << f | c << e | d, $6d365ff072dfd6ae$var$sg = a;
}
function $6d365ff072dfd6ae$var$vg(a) {
    null !== a.return && ($6d365ff072dfd6ae$var$tg(a, 1), $6d365ff072dfd6ae$var$ug(a, 1, 0));
}
function $6d365ff072dfd6ae$var$wg(a) {
    for(; a === $6d365ff072dfd6ae$var$mg;)$6d365ff072dfd6ae$var$mg = $6d365ff072dfd6ae$var$kg[--$6d365ff072dfd6ae$var$lg], $6d365ff072dfd6ae$var$kg[$6d365ff072dfd6ae$var$lg] = null, $6d365ff072dfd6ae$var$ng = $6d365ff072dfd6ae$var$kg[--$6d365ff072dfd6ae$var$lg], $6d365ff072dfd6ae$var$kg[$6d365ff072dfd6ae$var$lg] = null;
    for(; a === $6d365ff072dfd6ae$var$qg;)$6d365ff072dfd6ae$var$qg = $6d365ff072dfd6ae$var$og[--$6d365ff072dfd6ae$var$pg], $6d365ff072dfd6ae$var$og[$6d365ff072dfd6ae$var$pg] = null, $6d365ff072dfd6ae$var$sg = $6d365ff072dfd6ae$var$og[--$6d365ff072dfd6ae$var$pg], $6d365ff072dfd6ae$var$og[$6d365ff072dfd6ae$var$pg] = null, $6d365ff072dfd6ae$var$rg = $6d365ff072dfd6ae$var$og[--$6d365ff072dfd6ae$var$pg], $6d365ff072dfd6ae$var$og[$6d365ff072dfd6ae$var$pg] = null;
}
var $6d365ff072dfd6ae$var$xg = null, $6d365ff072dfd6ae$var$yg = null, $6d365ff072dfd6ae$var$I = !1, $6d365ff072dfd6ae$var$zg = null;
function $6d365ff072dfd6ae$var$Ag(a, b) {
    var c = $6d365ff072dfd6ae$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $6d365ff072dfd6ae$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $6d365ff072dfd6ae$var$xg = a, $6d365ff072dfd6ae$var$yg = $6d365ff072dfd6ae$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $6d365ff072dfd6ae$var$xg = a, $6d365ff072dfd6ae$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $6d365ff072dfd6ae$var$qg ? {
                id: $6d365ff072dfd6ae$var$rg,
                overflow: $6d365ff072dfd6ae$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $6d365ff072dfd6ae$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $6d365ff072dfd6ae$var$xg = a, $6d365ff072dfd6ae$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $6d365ff072dfd6ae$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $6d365ff072dfd6ae$var$Eg(a) {
    if ($6d365ff072dfd6ae$var$I) {
        var b = $6d365ff072dfd6ae$var$yg;
        if (b) {
            var c = b;
            if (!$6d365ff072dfd6ae$var$Cg(a, b)) {
                if ($6d365ff072dfd6ae$var$Dg(a)) throw Error($6d365ff072dfd6ae$var$p(418));
                b = $6d365ff072dfd6ae$var$Lf(c.nextSibling);
                var d = $6d365ff072dfd6ae$var$xg;
                b && $6d365ff072dfd6ae$var$Cg(a, b) ? $6d365ff072dfd6ae$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $6d365ff072dfd6ae$var$I = !1, $6d365ff072dfd6ae$var$xg = a);
            }
        } else {
            if ($6d365ff072dfd6ae$var$Dg(a)) throw Error($6d365ff072dfd6ae$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $6d365ff072dfd6ae$var$I = !1;
            $6d365ff072dfd6ae$var$xg = a;
        }
    }
}
function $6d365ff072dfd6ae$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $6d365ff072dfd6ae$var$xg = a;
}
function $6d365ff072dfd6ae$var$Gg(a) {
    if (a !== $6d365ff072dfd6ae$var$xg) return !1;
    if (!$6d365ff072dfd6ae$var$I) return $6d365ff072dfd6ae$var$Fg(a), $6d365ff072dfd6ae$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$6d365ff072dfd6ae$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $6d365ff072dfd6ae$var$yg)) {
        if ($6d365ff072dfd6ae$var$Dg(a)) throw $6d365ff072dfd6ae$var$Hg(), Error($6d365ff072dfd6ae$var$p(418));
        for(; b;)$6d365ff072dfd6ae$var$Ag(a, b), b = $6d365ff072dfd6ae$var$Lf(b.nextSibling);
    }
    $6d365ff072dfd6ae$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($6d365ff072dfd6ae$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $6d365ff072dfd6ae$var$yg = $6d365ff072dfd6ae$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $6d365ff072dfd6ae$var$yg = null;
        }
    } else $6d365ff072dfd6ae$var$yg = $6d365ff072dfd6ae$var$xg ? $6d365ff072dfd6ae$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $6d365ff072dfd6ae$var$Hg() {
    for(var a = $6d365ff072dfd6ae$var$yg; a;)a = $6d365ff072dfd6ae$var$Lf(a.nextSibling);
}
function $6d365ff072dfd6ae$var$Ig() {
    $6d365ff072dfd6ae$var$yg = $6d365ff072dfd6ae$var$xg = null;
    $6d365ff072dfd6ae$var$I = !1;
}
function $6d365ff072dfd6ae$var$Jg(a) {
    null === $6d365ff072dfd6ae$var$zg ? $6d365ff072dfd6ae$var$zg = [
        a
    ] : $6d365ff072dfd6ae$var$zg.push(a);
}
var $6d365ff072dfd6ae$var$Kg = $6d365ff072dfd6ae$var$ua.ReactCurrentBatchConfig;
function $6d365ff072dfd6ae$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $6d365ff072dfd6ae$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $6d365ff072dfd6ae$var$Mg = $6d365ff072dfd6ae$var$Uf(null), $6d365ff072dfd6ae$var$Ng = null, $6d365ff072dfd6ae$var$Og = null, $6d365ff072dfd6ae$var$Pg = null;
function $6d365ff072dfd6ae$var$Qg() {
    $6d365ff072dfd6ae$var$Pg = $6d365ff072dfd6ae$var$Og = $6d365ff072dfd6ae$var$Ng = null;
}
function $6d365ff072dfd6ae$var$Rg(a) {
    var b = $6d365ff072dfd6ae$var$Mg.current;
    $6d365ff072dfd6ae$var$E($6d365ff072dfd6ae$var$Mg);
    a._currentValue = b;
}
function $6d365ff072dfd6ae$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $6d365ff072dfd6ae$var$Tg(a, b) {
    $6d365ff072dfd6ae$var$Ng = a;
    $6d365ff072dfd6ae$var$Pg = $6d365ff072dfd6ae$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($6d365ff072dfd6ae$var$Ug = !0), a.firstContext = null);
}
function $6d365ff072dfd6ae$var$Vg(a) {
    var b = a._currentValue;
    if ($6d365ff072dfd6ae$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $6d365ff072dfd6ae$var$Og) {
            if (null === $6d365ff072dfd6ae$var$Ng) throw Error($6d365ff072dfd6ae$var$p(308));
            $6d365ff072dfd6ae$var$Og = a;
            $6d365ff072dfd6ae$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $6d365ff072dfd6ae$var$Og = $6d365ff072dfd6ae$var$Og.next = a;
    }
    return b;
}
var $6d365ff072dfd6ae$var$Wg = null;
function $6d365ff072dfd6ae$var$Xg(a) {
    null === $6d365ff072dfd6ae$var$Wg ? $6d365ff072dfd6ae$var$Wg = [
        a
    ] : $6d365ff072dfd6ae$var$Wg.push(a);
}
function $6d365ff072dfd6ae$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $6d365ff072dfd6ae$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $6d365ff072dfd6ae$var$Zg(a, d);
}
function $6d365ff072dfd6ae$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $6d365ff072dfd6ae$var$$g = !1;
function $6d365ff072dfd6ae$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $6d365ff072dfd6ae$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $6d365ff072dfd6ae$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $6d365ff072dfd6ae$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($6d365ff072dfd6ae$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $6d365ff072dfd6ae$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $6d365ff072dfd6ae$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $6d365ff072dfd6ae$var$Zg(a, c);
}
function $6d365ff072dfd6ae$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $6d365ff072dfd6ae$var$Cc(a, c);
    }
}
function $6d365ff072dfd6ae$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $6d365ff072dfd6ae$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $6d365ff072dfd6ae$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $6d365ff072dfd6ae$var$A({}, q, r);
                            break a;
                        case 2:
                            $6d365ff072dfd6ae$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $6d365ff072dfd6ae$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $6d365ff072dfd6ae$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($6d365ff072dfd6ae$var$p(191, e));
            e.call(d);
        }
    }
}
var $6d365ff072dfd6ae$var$jh = (new $1bdO8.Component).refs;
function $6d365ff072dfd6ae$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $6d365ff072dfd6ae$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $6d365ff072dfd6ae$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $6d365ff072dfd6ae$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $6d365ff072dfd6ae$var$L(), e = $6d365ff072dfd6ae$var$lh(a), f = $6d365ff072dfd6ae$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $6d365ff072dfd6ae$var$dh(a, f, e);
        null !== b && ($6d365ff072dfd6ae$var$mh(b, a, e, d), $6d365ff072dfd6ae$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $6d365ff072dfd6ae$var$L(), e = $6d365ff072dfd6ae$var$lh(a), f = $6d365ff072dfd6ae$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $6d365ff072dfd6ae$var$dh(a, f, e);
        null !== b && ($6d365ff072dfd6ae$var$mh(b, a, e, d), $6d365ff072dfd6ae$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $6d365ff072dfd6ae$var$L(), d = $6d365ff072dfd6ae$var$lh(a), e = $6d365ff072dfd6ae$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $6d365ff072dfd6ae$var$dh(a, e, d);
        null !== b && ($6d365ff072dfd6ae$var$mh(b, a, d, c), $6d365ff072dfd6ae$var$eh(b, a, d));
    }
};
function $6d365ff072dfd6ae$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$6d365ff072dfd6ae$var$Ie(c, d) || !$6d365ff072dfd6ae$var$Ie(e, f) : !0;
}
function $6d365ff072dfd6ae$var$ph(a, b, c) {
    var d = !1, e = $6d365ff072dfd6ae$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $6d365ff072dfd6ae$var$Vg(f) : (e = $6d365ff072dfd6ae$var$Zf(b) ? $6d365ff072dfd6ae$var$Xf : $6d365ff072dfd6ae$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $6d365ff072dfd6ae$var$Yf(a, e) : $6d365ff072dfd6ae$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $6d365ff072dfd6ae$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $6d365ff072dfd6ae$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $6d365ff072dfd6ae$var$nh.enqueueReplaceState(b, b.state, null);
}
function $6d365ff072dfd6ae$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $6d365ff072dfd6ae$var$jh;
    $6d365ff072dfd6ae$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $6d365ff072dfd6ae$var$Vg(f) : (f = $6d365ff072dfd6ae$var$Zf(b) ? $6d365ff072dfd6ae$var$Xf : $6d365ff072dfd6ae$var$H.current, e.context = $6d365ff072dfd6ae$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($6d365ff072dfd6ae$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $6d365ff072dfd6ae$var$nh.enqueueReplaceState(e, e.state, null), $6d365ff072dfd6ae$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $6d365ff072dfd6ae$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($6d365ff072dfd6ae$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($6d365ff072dfd6ae$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $6d365ff072dfd6ae$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($6d365ff072dfd6ae$var$p(284));
        if (!c._owner) throw Error($6d365ff072dfd6ae$var$p(290, a));
    }
    return a;
}
function $6d365ff072dfd6ae$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($6d365ff072dfd6ae$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $6d365ff072dfd6ae$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $6d365ff072dfd6ae$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $6d365ff072dfd6ae$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $6d365ff072dfd6ae$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $6d365ff072dfd6ae$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $6d365ff072dfd6ae$var$Ha && $6d365ff072dfd6ae$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $6d365ff072dfd6ae$var$sh(a, b, c), d.return = a, d;
        d = $6d365ff072dfd6ae$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $6d365ff072dfd6ae$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $6d365ff072dfd6ae$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $6d365ff072dfd6ae$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $6d365ff072dfd6ae$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $6d365ff072dfd6ae$var$va:
                    return c = $6d365ff072dfd6ae$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $6d365ff072dfd6ae$var$sh(a, null, b), c.return = a, c;
                case $6d365ff072dfd6ae$var$wa:
                    return b = $6d365ff072dfd6ae$var$zh(b, a.mode, c), b.return = a, b;
                case $6d365ff072dfd6ae$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($6d365ff072dfd6ae$var$eb(b) || $6d365ff072dfd6ae$var$Ka(b)) return b = $6d365ff072dfd6ae$var$Ah(b, a.mode, c, null), b.return = a, b;
            $6d365ff072dfd6ae$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $6d365ff072dfd6ae$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $6d365ff072dfd6ae$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $6d365ff072dfd6ae$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($6d365ff072dfd6ae$var$eb(c) || $6d365ff072dfd6ae$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $6d365ff072dfd6ae$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $6d365ff072dfd6ae$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $6d365ff072dfd6ae$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $6d365ff072dfd6ae$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($6d365ff072dfd6ae$var$eb(d) || $6d365ff072dfd6ae$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $6d365ff072dfd6ae$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $6d365ff072dfd6ae$var$I && $6d365ff072dfd6ae$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $6d365ff072dfd6ae$var$I && $6d365ff072dfd6ae$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $6d365ff072dfd6ae$var$I && $6d365ff072dfd6ae$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $6d365ff072dfd6ae$var$Ka(h);
        if ("function" !== typeof l) throw Error($6d365ff072dfd6ae$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($6d365ff072dfd6ae$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $6d365ff072dfd6ae$var$I && $6d365ff072dfd6ae$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $6d365ff072dfd6ae$var$I && $6d365ff072dfd6ae$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $6d365ff072dfd6ae$var$I && $6d365ff072dfd6ae$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $6d365ff072dfd6ae$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $6d365ff072dfd6ae$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $6d365ff072dfd6ae$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $6d365ff072dfd6ae$var$Ha && $6d365ff072dfd6ae$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $6d365ff072dfd6ae$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $6d365ff072dfd6ae$var$ya ? (d = $6d365ff072dfd6ae$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $6d365ff072dfd6ae$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $6d365ff072dfd6ae$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $6d365ff072dfd6ae$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $6d365ff072dfd6ae$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $6d365ff072dfd6ae$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($6d365ff072dfd6ae$var$eb(f)) return n(a, d, f, h);
            if ($6d365ff072dfd6ae$var$Ka(f)) return t(a, d, f, h);
            $6d365ff072dfd6ae$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $6d365ff072dfd6ae$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $6d365ff072dfd6ae$var$Bh = $6d365ff072dfd6ae$var$vh(!0), $6d365ff072dfd6ae$var$Ch = $6d365ff072dfd6ae$var$vh(!1), $6d365ff072dfd6ae$var$Dh = {}, $6d365ff072dfd6ae$var$Eh = $6d365ff072dfd6ae$var$Uf($6d365ff072dfd6ae$var$Dh), $6d365ff072dfd6ae$var$Fh = $6d365ff072dfd6ae$var$Uf($6d365ff072dfd6ae$var$Dh), $6d365ff072dfd6ae$var$Gh = $6d365ff072dfd6ae$var$Uf($6d365ff072dfd6ae$var$Dh);
function $6d365ff072dfd6ae$var$Hh(a) {
    if (a === $6d365ff072dfd6ae$var$Dh) throw Error($6d365ff072dfd6ae$var$p(174));
    return a;
}
function $6d365ff072dfd6ae$var$Ih(a, b) {
    $6d365ff072dfd6ae$var$G($6d365ff072dfd6ae$var$Gh, b);
    $6d365ff072dfd6ae$var$G($6d365ff072dfd6ae$var$Fh, a);
    $6d365ff072dfd6ae$var$G($6d365ff072dfd6ae$var$Eh, $6d365ff072dfd6ae$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $6d365ff072dfd6ae$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $6d365ff072dfd6ae$var$lb(b, a);
    }
    $6d365ff072dfd6ae$var$E($6d365ff072dfd6ae$var$Eh);
    $6d365ff072dfd6ae$var$G($6d365ff072dfd6ae$var$Eh, b);
}
function $6d365ff072dfd6ae$var$Jh() {
    $6d365ff072dfd6ae$var$E($6d365ff072dfd6ae$var$Eh);
    $6d365ff072dfd6ae$var$E($6d365ff072dfd6ae$var$Fh);
    $6d365ff072dfd6ae$var$E($6d365ff072dfd6ae$var$Gh);
}
function $6d365ff072dfd6ae$var$Kh(a) {
    $6d365ff072dfd6ae$var$Hh($6d365ff072dfd6ae$var$Gh.current);
    var b = $6d365ff072dfd6ae$var$Hh($6d365ff072dfd6ae$var$Eh.current);
    var c = $6d365ff072dfd6ae$var$lb(b, a.type);
    b !== c && ($6d365ff072dfd6ae$var$G($6d365ff072dfd6ae$var$Fh, a), $6d365ff072dfd6ae$var$G($6d365ff072dfd6ae$var$Eh, c));
}
function $6d365ff072dfd6ae$var$Lh(a) {
    $6d365ff072dfd6ae$var$Fh.current === a && ($6d365ff072dfd6ae$var$E($6d365ff072dfd6ae$var$Eh), $6d365ff072dfd6ae$var$E($6d365ff072dfd6ae$var$Fh));
}
var $6d365ff072dfd6ae$var$M = $6d365ff072dfd6ae$var$Uf(0);
function $6d365ff072dfd6ae$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $6d365ff072dfd6ae$var$Nh = [];
function $6d365ff072dfd6ae$var$Oh() {
    for(var a = 0; a < $6d365ff072dfd6ae$var$Nh.length; a++)$6d365ff072dfd6ae$var$Nh[a]._workInProgressVersionPrimary = null;
    $6d365ff072dfd6ae$var$Nh.length = 0;
}
var $6d365ff072dfd6ae$var$Ph = $6d365ff072dfd6ae$var$ua.ReactCurrentDispatcher, $6d365ff072dfd6ae$var$Qh = $6d365ff072dfd6ae$var$ua.ReactCurrentBatchConfig, $6d365ff072dfd6ae$var$Rh = 0, $6d365ff072dfd6ae$var$N = null, $6d365ff072dfd6ae$var$O = null, $6d365ff072dfd6ae$var$P = null, $6d365ff072dfd6ae$var$Sh = !1, $6d365ff072dfd6ae$var$Th = !1, $6d365ff072dfd6ae$var$Uh = 0, $6d365ff072dfd6ae$var$Vh = 0;
function $6d365ff072dfd6ae$var$Q() {
    throw Error($6d365ff072dfd6ae$var$p(321));
}
function $6d365ff072dfd6ae$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$6d365ff072dfd6ae$var$He(a[c], b[c])) return !1;
    return !0;
}
function $6d365ff072dfd6ae$var$Xh(a, b, c, d, e, f) {
    $6d365ff072dfd6ae$var$Rh = f;
    $6d365ff072dfd6ae$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $6d365ff072dfd6ae$var$Ph.current = null === a || null === a.memoizedState ? $6d365ff072dfd6ae$var$Yh : $6d365ff072dfd6ae$var$Zh;
    a = c(d, e);
    if ($6d365ff072dfd6ae$var$Th) {
        f = 0;
        do {
            $6d365ff072dfd6ae$var$Th = !1;
            $6d365ff072dfd6ae$var$Uh = 0;
            if (25 <= f) throw Error($6d365ff072dfd6ae$var$p(301));
            f += 1;
            $6d365ff072dfd6ae$var$P = $6d365ff072dfd6ae$var$O = null;
            b.updateQueue = null;
            $6d365ff072dfd6ae$var$Ph.current = $6d365ff072dfd6ae$var$$h;
            a = c(d, e);
        }while ($6d365ff072dfd6ae$var$Th);
    }
    $6d365ff072dfd6ae$var$Ph.current = $6d365ff072dfd6ae$var$ai;
    b = null !== $6d365ff072dfd6ae$var$O && null !== $6d365ff072dfd6ae$var$O.next;
    $6d365ff072dfd6ae$var$Rh = 0;
    $6d365ff072dfd6ae$var$P = $6d365ff072dfd6ae$var$O = $6d365ff072dfd6ae$var$N = null;
    $6d365ff072dfd6ae$var$Sh = !1;
    if (b) throw Error($6d365ff072dfd6ae$var$p(300));
    return a;
}
function $6d365ff072dfd6ae$var$bi() {
    var a = 0 !== $6d365ff072dfd6ae$var$Uh;
    $6d365ff072dfd6ae$var$Uh = 0;
    return a;
}
function $6d365ff072dfd6ae$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $6d365ff072dfd6ae$var$P ? $6d365ff072dfd6ae$var$N.memoizedState = $6d365ff072dfd6ae$var$P = a : $6d365ff072dfd6ae$var$P = $6d365ff072dfd6ae$var$P.next = a;
    return $6d365ff072dfd6ae$var$P;
}
function $6d365ff072dfd6ae$var$di() {
    if (null === $6d365ff072dfd6ae$var$O) {
        var a = $6d365ff072dfd6ae$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $6d365ff072dfd6ae$var$O.next;
    var b = null === $6d365ff072dfd6ae$var$P ? $6d365ff072dfd6ae$var$N.memoizedState : $6d365ff072dfd6ae$var$P.next;
    if (null !== b) $6d365ff072dfd6ae$var$P = b, $6d365ff072dfd6ae$var$O = a;
    else {
        if (null === a) throw Error($6d365ff072dfd6ae$var$p(310));
        $6d365ff072dfd6ae$var$O = a;
        a = {
            memoizedState: $6d365ff072dfd6ae$var$O.memoizedState,
            baseState: $6d365ff072dfd6ae$var$O.baseState,
            baseQueue: $6d365ff072dfd6ae$var$O.baseQueue,
            queue: $6d365ff072dfd6ae$var$O.queue,
            next: null
        };
        null === $6d365ff072dfd6ae$var$P ? $6d365ff072dfd6ae$var$N.memoizedState = $6d365ff072dfd6ae$var$P = a : $6d365ff072dfd6ae$var$P = $6d365ff072dfd6ae$var$P.next = a;
    }
    return $6d365ff072dfd6ae$var$P;
}
function $6d365ff072dfd6ae$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $6d365ff072dfd6ae$var$fi(a) {
    var b = $6d365ff072dfd6ae$var$di(), c = b.queue;
    if (null === c) throw Error($6d365ff072dfd6ae$var$p(311));
    c.lastRenderedReducer = a;
    var d = $6d365ff072dfd6ae$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($6d365ff072dfd6ae$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $6d365ff072dfd6ae$var$N.lanes |= m;
                $6d365ff072dfd6ae$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $6d365ff072dfd6ae$var$He(d, b.memoizedState) || ($6d365ff072dfd6ae$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $6d365ff072dfd6ae$var$N.lanes |= f, $6d365ff072dfd6ae$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $6d365ff072dfd6ae$var$gi(a) {
    var b = $6d365ff072dfd6ae$var$di(), c = b.queue;
    if (null === c) throw Error($6d365ff072dfd6ae$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $6d365ff072dfd6ae$var$He(f, b.memoizedState) || ($6d365ff072dfd6ae$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $6d365ff072dfd6ae$var$hi() {}
function $6d365ff072dfd6ae$var$ii(a, b) {
    var c = $6d365ff072dfd6ae$var$N, d = $6d365ff072dfd6ae$var$di(), e = b(), f = !$6d365ff072dfd6ae$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $6d365ff072dfd6ae$var$Ug = !0);
    d = d.queue;
    $6d365ff072dfd6ae$var$ji($6d365ff072dfd6ae$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $6d365ff072dfd6ae$var$P && $6d365ff072dfd6ae$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $6d365ff072dfd6ae$var$li(9, $6d365ff072dfd6ae$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $6d365ff072dfd6ae$var$R) throw Error($6d365ff072dfd6ae$var$p(349));
        0 !== ($6d365ff072dfd6ae$var$Rh & 30) || $6d365ff072dfd6ae$var$ni(c, b, e);
    }
    return e;
}
function $6d365ff072dfd6ae$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $6d365ff072dfd6ae$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $6d365ff072dfd6ae$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $6d365ff072dfd6ae$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $6d365ff072dfd6ae$var$oi(b) && $6d365ff072dfd6ae$var$pi(a);
}
function $6d365ff072dfd6ae$var$ki(a, b, c) {
    return c(function() {
        $6d365ff072dfd6ae$var$oi(b) && $6d365ff072dfd6ae$var$pi(a);
    });
}
function $6d365ff072dfd6ae$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$6d365ff072dfd6ae$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $6d365ff072dfd6ae$var$pi(a) {
    var b = $6d365ff072dfd6ae$var$Zg(a, 1);
    null !== b && $6d365ff072dfd6ae$var$mh(b, a, 1, -1);
}
function $6d365ff072dfd6ae$var$qi(a) {
    var b = $6d365ff072dfd6ae$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $6d365ff072dfd6ae$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $6d365ff072dfd6ae$var$ri.bind(null, $6d365ff072dfd6ae$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $6d365ff072dfd6ae$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $6d365ff072dfd6ae$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $6d365ff072dfd6ae$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $6d365ff072dfd6ae$var$si() {
    return $6d365ff072dfd6ae$var$di().memoizedState;
}
function $6d365ff072dfd6ae$var$ti(a, b, c, d) {
    var e = $6d365ff072dfd6ae$var$ci();
    $6d365ff072dfd6ae$var$N.flags |= a;
    e.memoizedState = $6d365ff072dfd6ae$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $6d365ff072dfd6ae$var$ui(a, b, c, d) {
    var e = $6d365ff072dfd6ae$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $6d365ff072dfd6ae$var$O) {
        var g = $6d365ff072dfd6ae$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $6d365ff072dfd6ae$var$Wh(d, g.deps)) {
            e.memoizedState = $6d365ff072dfd6ae$var$li(b, c, f, d);
            return;
        }
    }
    $6d365ff072dfd6ae$var$N.flags |= a;
    e.memoizedState = $6d365ff072dfd6ae$var$li(1 | b, c, f, d);
}
function $6d365ff072dfd6ae$var$vi(a, b) {
    return $6d365ff072dfd6ae$var$ti(8390656, 8, a, b);
}
function $6d365ff072dfd6ae$var$ji(a, b) {
    return $6d365ff072dfd6ae$var$ui(2048, 8, a, b);
}
function $6d365ff072dfd6ae$var$wi(a, b) {
    return $6d365ff072dfd6ae$var$ui(4, 2, a, b);
}
function $6d365ff072dfd6ae$var$xi(a, b) {
    return $6d365ff072dfd6ae$var$ui(4, 4, a, b);
}
function $6d365ff072dfd6ae$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $6d365ff072dfd6ae$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $6d365ff072dfd6ae$var$ui(4, 4, $6d365ff072dfd6ae$var$yi.bind(null, b, a), c);
}
function $6d365ff072dfd6ae$var$Ai() {}
function $6d365ff072dfd6ae$var$Bi(a, b) {
    var c = $6d365ff072dfd6ae$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $6d365ff072dfd6ae$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $6d365ff072dfd6ae$var$Ci(a, b) {
    var c = $6d365ff072dfd6ae$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $6d365ff072dfd6ae$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $6d365ff072dfd6ae$var$Di(a, b, c) {
    if (0 === ($6d365ff072dfd6ae$var$Rh & 21)) return a.baseState && (a.baseState = !1, $6d365ff072dfd6ae$var$Ug = !0), a.memoizedState = c;
    $6d365ff072dfd6ae$var$He(c, b) || (c = $6d365ff072dfd6ae$var$yc(), $6d365ff072dfd6ae$var$N.lanes |= c, $6d365ff072dfd6ae$var$hh |= c, a.baseState = !0);
    return b;
}
function $6d365ff072dfd6ae$var$Ei(a, b) {
    var c = $6d365ff072dfd6ae$var$C;
    $6d365ff072dfd6ae$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $6d365ff072dfd6ae$var$Qh.transition;
    $6d365ff072dfd6ae$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $6d365ff072dfd6ae$var$C = c, $6d365ff072dfd6ae$var$Qh.transition = d;
    }
}
function $6d365ff072dfd6ae$var$Fi() {
    return $6d365ff072dfd6ae$var$di().memoizedState;
}
function $6d365ff072dfd6ae$var$Gi(a, b, c) {
    var d = $6d365ff072dfd6ae$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($6d365ff072dfd6ae$var$Hi(a)) $6d365ff072dfd6ae$var$Ii(b, c);
    else if (c = $6d365ff072dfd6ae$var$Yg(a, b, c, d), null !== c) {
        var e = $6d365ff072dfd6ae$var$L();
        $6d365ff072dfd6ae$var$mh(c, a, d, e);
        $6d365ff072dfd6ae$var$Ji(c, b, d);
    }
}
function $6d365ff072dfd6ae$var$ri(a, b, c) {
    var d = $6d365ff072dfd6ae$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($6d365ff072dfd6ae$var$Hi(a)) $6d365ff072dfd6ae$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($6d365ff072dfd6ae$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $6d365ff072dfd6ae$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $6d365ff072dfd6ae$var$Yg(a, b, e, d);
        null !== c && (e = $6d365ff072dfd6ae$var$L(), $6d365ff072dfd6ae$var$mh(c, a, d, e), $6d365ff072dfd6ae$var$Ji(c, b, d));
    }
}
function $6d365ff072dfd6ae$var$Hi(a) {
    var b = a.alternate;
    return a === $6d365ff072dfd6ae$var$N || null !== b && b === $6d365ff072dfd6ae$var$N;
}
function $6d365ff072dfd6ae$var$Ii(a, b) {
    $6d365ff072dfd6ae$var$Th = $6d365ff072dfd6ae$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $6d365ff072dfd6ae$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $6d365ff072dfd6ae$var$Cc(a, c);
    }
}
var $6d365ff072dfd6ae$var$ai = {
    readContext: $6d365ff072dfd6ae$var$Vg,
    useCallback: $6d365ff072dfd6ae$var$Q,
    useContext: $6d365ff072dfd6ae$var$Q,
    useEffect: $6d365ff072dfd6ae$var$Q,
    useImperativeHandle: $6d365ff072dfd6ae$var$Q,
    useInsertionEffect: $6d365ff072dfd6ae$var$Q,
    useLayoutEffect: $6d365ff072dfd6ae$var$Q,
    useMemo: $6d365ff072dfd6ae$var$Q,
    useReducer: $6d365ff072dfd6ae$var$Q,
    useRef: $6d365ff072dfd6ae$var$Q,
    useState: $6d365ff072dfd6ae$var$Q,
    useDebugValue: $6d365ff072dfd6ae$var$Q,
    useDeferredValue: $6d365ff072dfd6ae$var$Q,
    useTransition: $6d365ff072dfd6ae$var$Q,
    useMutableSource: $6d365ff072dfd6ae$var$Q,
    useSyncExternalStore: $6d365ff072dfd6ae$var$Q,
    useId: $6d365ff072dfd6ae$var$Q,
    unstable_isNewReconciler: !1
}, $6d365ff072dfd6ae$var$Yh = {
    readContext: $6d365ff072dfd6ae$var$Vg,
    useCallback: function(a, b) {
        $6d365ff072dfd6ae$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $6d365ff072dfd6ae$var$Vg,
    useEffect: $6d365ff072dfd6ae$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $6d365ff072dfd6ae$var$ti(4194308, 4, $6d365ff072dfd6ae$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $6d365ff072dfd6ae$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $6d365ff072dfd6ae$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $6d365ff072dfd6ae$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $6d365ff072dfd6ae$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $6d365ff072dfd6ae$var$Gi.bind(null, $6d365ff072dfd6ae$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $6d365ff072dfd6ae$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $6d365ff072dfd6ae$var$qi,
    useDebugValue: $6d365ff072dfd6ae$var$Ai,
    useDeferredValue: function(a) {
        return $6d365ff072dfd6ae$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $6d365ff072dfd6ae$var$qi(!1), b = a[0];
        a = $6d365ff072dfd6ae$var$Ei.bind(null, a[1]);
        $6d365ff072dfd6ae$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $6d365ff072dfd6ae$var$N, e = $6d365ff072dfd6ae$var$ci();
        if ($6d365ff072dfd6ae$var$I) {
            if (void 0 === c) throw Error($6d365ff072dfd6ae$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $6d365ff072dfd6ae$var$R) throw Error($6d365ff072dfd6ae$var$p(349));
            0 !== ($6d365ff072dfd6ae$var$Rh & 30) || $6d365ff072dfd6ae$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $6d365ff072dfd6ae$var$vi($6d365ff072dfd6ae$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $6d365ff072dfd6ae$var$li(9, $6d365ff072dfd6ae$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $6d365ff072dfd6ae$var$ci(), b = $6d365ff072dfd6ae$var$R.identifierPrefix;
        if ($6d365ff072dfd6ae$var$I) {
            var c = $6d365ff072dfd6ae$var$sg;
            var d = $6d365ff072dfd6ae$var$rg;
            c = (d & ~(1 << 32 - $6d365ff072dfd6ae$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $6d365ff072dfd6ae$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $6d365ff072dfd6ae$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $6d365ff072dfd6ae$var$Zh = {
    readContext: $6d365ff072dfd6ae$var$Vg,
    useCallback: $6d365ff072dfd6ae$var$Bi,
    useContext: $6d365ff072dfd6ae$var$Vg,
    useEffect: $6d365ff072dfd6ae$var$ji,
    useImperativeHandle: $6d365ff072dfd6ae$var$zi,
    useInsertionEffect: $6d365ff072dfd6ae$var$wi,
    useLayoutEffect: $6d365ff072dfd6ae$var$xi,
    useMemo: $6d365ff072dfd6ae$var$Ci,
    useReducer: $6d365ff072dfd6ae$var$fi,
    useRef: $6d365ff072dfd6ae$var$si,
    useState: function() {
        return $6d365ff072dfd6ae$var$fi($6d365ff072dfd6ae$var$ei);
    },
    useDebugValue: $6d365ff072dfd6ae$var$Ai,
    useDeferredValue: function(a) {
        var b = $6d365ff072dfd6ae$var$di();
        return $6d365ff072dfd6ae$var$Di(b, $6d365ff072dfd6ae$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $6d365ff072dfd6ae$var$fi($6d365ff072dfd6ae$var$ei)[0], b = $6d365ff072dfd6ae$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $6d365ff072dfd6ae$var$hi,
    useSyncExternalStore: $6d365ff072dfd6ae$var$ii,
    useId: $6d365ff072dfd6ae$var$Fi,
    unstable_isNewReconciler: !1
}, $6d365ff072dfd6ae$var$$h = {
    readContext: $6d365ff072dfd6ae$var$Vg,
    useCallback: $6d365ff072dfd6ae$var$Bi,
    useContext: $6d365ff072dfd6ae$var$Vg,
    useEffect: $6d365ff072dfd6ae$var$ji,
    useImperativeHandle: $6d365ff072dfd6ae$var$zi,
    useInsertionEffect: $6d365ff072dfd6ae$var$wi,
    useLayoutEffect: $6d365ff072dfd6ae$var$xi,
    useMemo: $6d365ff072dfd6ae$var$Ci,
    useReducer: $6d365ff072dfd6ae$var$gi,
    useRef: $6d365ff072dfd6ae$var$si,
    useState: function() {
        return $6d365ff072dfd6ae$var$gi($6d365ff072dfd6ae$var$ei);
    },
    useDebugValue: $6d365ff072dfd6ae$var$Ai,
    useDeferredValue: function(a) {
        var b = $6d365ff072dfd6ae$var$di();
        return null === $6d365ff072dfd6ae$var$O ? b.memoizedState = a : $6d365ff072dfd6ae$var$Di(b, $6d365ff072dfd6ae$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $6d365ff072dfd6ae$var$gi($6d365ff072dfd6ae$var$ei)[0], b = $6d365ff072dfd6ae$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $6d365ff072dfd6ae$var$hi,
    useSyncExternalStore: $6d365ff072dfd6ae$var$ii,
    useId: $6d365ff072dfd6ae$var$Fi,
    unstable_isNewReconciler: !1
};
function $6d365ff072dfd6ae$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $6d365ff072dfd6ae$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $6d365ff072dfd6ae$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $6d365ff072dfd6ae$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $6d365ff072dfd6ae$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $6d365ff072dfd6ae$var$Oi(a, b, c) {
    c = $6d365ff072dfd6ae$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $6d365ff072dfd6ae$var$Pi || ($6d365ff072dfd6ae$var$Pi = !0, $6d365ff072dfd6ae$var$Qi = d);
        $6d365ff072dfd6ae$var$Mi(a, b);
    };
    return c;
}
function $6d365ff072dfd6ae$var$Ri(a, b, c) {
    c = $6d365ff072dfd6ae$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $6d365ff072dfd6ae$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $6d365ff072dfd6ae$var$Mi(a, b);
        "function" !== typeof d && (null === $6d365ff072dfd6ae$var$Si ? $6d365ff072dfd6ae$var$Si = new Set([
            this
        ]) : $6d365ff072dfd6ae$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $6d365ff072dfd6ae$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $6d365ff072dfd6ae$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $6d365ff072dfd6ae$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $6d365ff072dfd6ae$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $6d365ff072dfd6ae$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $6d365ff072dfd6ae$var$ch(-1, 1), b.tag = 2, $6d365ff072dfd6ae$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $6d365ff072dfd6ae$var$Xi = $6d365ff072dfd6ae$var$ua.ReactCurrentOwner, $6d365ff072dfd6ae$var$Ug = !1;
function $6d365ff072dfd6ae$var$Yi(a, b, c, d) {
    b.child = null === a ? $6d365ff072dfd6ae$var$Ch(b, null, c, d) : $6d365ff072dfd6ae$var$Bh(b, a.child, c, d);
}
function $6d365ff072dfd6ae$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $6d365ff072dfd6ae$var$Tg(b, e);
    d = $6d365ff072dfd6ae$var$Xh(a, b, c, d, f, e);
    c = $6d365ff072dfd6ae$var$bi();
    if (null !== a && !$6d365ff072dfd6ae$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $6d365ff072dfd6ae$var$$i(a, b, e);
    $6d365ff072dfd6ae$var$I && c && $6d365ff072dfd6ae$var$vg(b);
    b.flags |= 1;
    $6d365ff072dfd6ae$var$Yi(a, b, d, e);
    return b.child;
}
function $6d365ff072dfd6ae$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$6d365ff072dfd6ae$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $6d365ff072dfd6ae$var$cj(a, b, f, d, e);
        a = $6d365ff072dfd6ae$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $6d365ff072dfd6ae$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $6d365ff072dfd6ae$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $6d365ff072dfd6ae$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $6d365ff072dfd6ae$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($6d365ff072dfd6ae$var$Ie(f, d) && a.ref === b.ref) {
            if ($6d365ff072dfd6ae$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($6d365ff072dfd6ae$var$Ug = !0);
            else return b.lanes = a.lanes, $6d365ff072dfd6ae$var$$i(a, b, e);
        }
    }
    return $6d365ff072dfd6ae$var$dj(a, b, c, d, e);
}
function $6d365ff072dfd6ae$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $6d365ff072dfd6ae$var$G($6d365ff072dfd6ae$var$fj, $6d365ff072dfd6ae$var$gj), $6d365ff072dfd6ae$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $6d365ff072dfd6ae$var$G($6d365ff072dfd6ae$var$fj, $6d365ff072dfd6ae$var$gj), $6d365ff072dfd6ae$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $6d365ff072dfd6ae$var$G($6d365ff072dfd6ae$var$fj, $6d365ff072dfd6ae$var$gj);
            $6d365ff072dfd6ae$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $6d365ff072dfd6ae$var$G($6d365ff072dfd6ae$var$fj, $6d365ff072dfd6ae$var$gj), $6d365ff072dfd6ae$var$gj |= d;
    $6d365ff072dfd6ae$var$Yi(a, b, e, c);
    return b.child;
}
function $6d365ff072dfd6ae$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $6d365ff072dfd6ae$var$dj(a, b, c, d, e) {
    var f = $6d365ff072dfd6ae$var$Zf(c) ? $6d365ff072dfd6ae$var$Xf : $6d365ff072dfd6ae$var$H.current;
    f = $6d365ff072dfd6ae$var$Yf(b, f);
    $6d365ff072dfd6ae$var$Tg(b, e);
    c = $6d365ff072dfd6ae$var$Xh(a, b, c, d, f, e);
    d = $6d365ff072dfd6ae$var$bi();
    if (null !== a && !$6d365ff072dfd6ae$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $6d365ff072dfd6ae$var$$i(a, b, e);
    $6d365ff072dfd6ae$var$I && d && $6d365ff072dfd6ae$var$vg(b);
    b.flags |= 1;
    $6d365ff072dfd6ae$var$Yi(a, b, c, e);
    return b.child;
}
function $6d365ff072dfd6ae$var$ij(a, b, c, d, e) {
    if ($6d365ff072dfd6ae$var$Zf(c)) {
        var f = !0;
        $6d365ff072dfd6ae$var$cg(b);
    } else f = !1;
    $6d365ff072dfd6ae$var$Tg(b, e);
    if (null === b.stateNode) $6d365ff072dfd6ae$var$jj(a, b), $6d365ff072dfd6ae$var$ph(b, c, d), $6d365ff072dfd6ae$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $6d365ff072dfd6ae$var$Vg(l) : (l = $6d365ff072dfd6ae$var$Zf(c) ? $6d365ff072dfd6ae$var$Xf : $6d365ff072dfd6ae$var$H.current, l = $6d365ff072dfd6ae$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $6d365ff072dfd6ae$var$qh(b, g, d, l);
        $6d365ff072dfd6ae$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $6d365ff072dfd6ae$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $6d365ff072dfd6ae$var$Wf.current || $6d365ff072dfd6ae$var$$g ? ("function" === typeof m && ($6d365ff072dfd6ae$var$kh(b, c, m, d), k = b.memoizedState), (h = $6d365ff072dfd6ae$var$$g || $6d365ff072dfd6ae$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $6d365ff072dfd6ae$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $6d365ff072dfd6ae$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $6d365ff072dfd6ae$var$Vg(k) : (k = $6d365ff072dfd6ae$var$Zf(c) ? $6d365ff072dfd6ae$var$Xf : $6d365ff072dfd6ae$var$H.current, k = $6d365ff072dfd6ae$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $6d365ff072dfd6ae$var$qh(b, g, d, k);
        $6d365ff072dfd6ae$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $6d365ff072dfd6ae$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $6d365ff072dfd6ae$var$Wf.current || $6d365ff072dfd6ae$var$$g ? ("function" === typeof y && ($6d365ff072dfd6ae$var$kh(b, c, y, d), n = b.memoizedState), (l = $6d365ff072dfd6ae$var$$g || $6d365ff072dfd6ae$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $6d365ff072dfd6ae$var$kj(a, b, c, d, f, e);
}
function $6d365ff072dfd6ae$var$kj(a, b, c, d, e, f) {
    $6d365ff072dfd6ae$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $6d365ff072dfd6ae$var$dg(b, c, !1), $6d365ff072dfd6ae$var$$i(a, b, f);
    d = b.stateNode;
    $6d365ff072dfd6ae$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $6d365ff072dfd6ae$var$Bh(b, a.child, null, f), b.child = $6d365ff072dfd6ae$var$Bh(b, null, h, f)) : $6d365ff072dfd6ae$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $6d365ff072dfd6ae$var$dg(b, c, !0);
    return b.child;
}
function $6d365ff072dfd6ae$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $6d365ff072dfd6ae$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $6d365ff072dfd6ae$var$ag(a, b.context, !1);
    $6d365ff072dfd6ae$var$Ih(a, b.containerInfo);
}
function $6d365ff072dfd6ae$var$mj(a, b, c, d, e) {
    $6d365ff072dfd6ae$var$Ig();
    $6d365ff072dfd6ae$var$Jg(e);
    b.flags |= 256;
    $6d365ff072dfd6ae$var$Yi(a, b, c, d);
    return b.child;
}
var $6d365ff072dfd6ae$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $6d365ff072dfd6ae$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $6d365ff072dfd6ae$var$pj(a, b, c) {
    var d = b.pendingProps, e = $6d365ff072dfd6ae$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $6d365ff072dfd6ae$var$G($6d365ff072dfd6ae$var$M, e & 1);
    if (null === a) {
        $6d365ff072dfd6ae$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $6d365ff072dfd6ae$var$qj(g, d, 0, null), a = $6d365ff072dfd6ae$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $6d365ff072dfd6ae$var$oj(c), b.memoizedState = $6d365ff072dfd6ae$var$nj, a) : $6d365ff072dfd6ae$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $6d365ff072dfd6ae$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $6d365ff072dfd6ae$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $6d365ff072dfd6ae$var$wh(h, f) : (f = $6d365ff072dfd6ae$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $6d365ff072dfd6ae$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $6d365ff072dfd6ae$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $6d365ff072dfd6ae$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $6d365ff072dfd6ae$var$rj(a, b) {
    b = $6d365ff072dfd6ae$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $6d365ff072dfd6ae$var$tj(a, b, c, d) {
    null !== d && $6d365ff072dfd6ae$var$Jg(d);
    $6d365ff072dfd6ae$var$Bh(b, a.child, null, c);
    a = $6d365ff072dfd6ae$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $6d365ff072dfd6ae$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $6d365ff072dfd6ae$var$Li(Error($6d365ff072dfd6ae$var$p(422))), $6d365ff072dfd6ae$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $6d365ff072dfd6ae$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $6d365ff072dfd6ae$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $6d365ff072dfd6ae$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $6d365ff072dfd6ae$var$oj(g);
        b.memoizedState = $6d365ff072dfd6ae$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $6d365ff072dfd6ae$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($6d365ff072dfd6ae$var$p(419));
        d = $6d365ff072dfd6ae$var$Li(f, d, void 0);
        return $6d365ff072dfd6ae$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($6d365ff072dfd6ae$var$Ug || h) {
        d = $6d365ff072dfd6ae$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $6d365ff072dfd6ae$var$Zg(a, e), $6d365ff072dfd6ae$var$mh(d, a, e, -1));
        }
        $6d365ff072dfd6ae$var$uj();
        d = $6d365ff072dfd6ae$var$Li(Error($6d365ff072dfd6ae$var$p(421)));
        return $6d365ff072dfd6ae$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $6d365ff072dfd6ae$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $6d365ff072dfd6ae$var$yg = $6d365ff072dfd6ae$var$Lf(e.nextSibling);
    $6d365ff072dfd6ae$var$xg = b;
    $6d365ff072dfd6ae$var$I = !0;
    $6d365ff072dfd6ae$var$zg = null;
    null !== a && ($6d365ff072dfd6ae$var$og[$6d365ff072dfd6ae$var$pg++] = $6d365ff072dfd6ae$var$rg, $6d365ff072dfd6ae$var$og[$6d365ff072dfd6ae$var$pg++] = $6d365ff072dfd6ae$var$sg, $6d365ff072dfd6ae$var$og[$6d365ff072dfd6ae$var$pg++] = $6d365ff072dfd6ae$var$qg, $6d365ff072dfd6ae$var$rg = a.id, $6d365ff072dfd6ae$var$sg = a.overflow, $6d365ff072dfd6ae$var$qg = b);
    b = $6d365ff072dfd6ae$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $6d365ff072dfd6ae$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $6d365ff072dfd6ae$var$Sg(a.return, b, c);
}
function $6d365ff072dfd6ae$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $6d365ff072dfd6ae$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $6d365ff072dfd6ae$var$Yi(a, b, d.children, c);
    d = $6d365ff072dfd6ae$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $6d365ff072dfd6ae$var$wj(a, c, b);
            else if (19 === a.tag) $6d365ff072dfd6ae$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $6d365ff072dfd6ae$var$G($6d365ff072dfd6ae$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $6d365ff072dfd6ae$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $6d365ff072dfd6ae$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $6d365ff072dfd6ae$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $6d365ff072dfd6ae$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $6d365ff072dfd6ae$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $6d365ff072dfd6ae$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $6d365ff072dfd6ae$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $6d365ff072dfd6ae$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($6d365ff072dfd6ae$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $6d365ff072dfd6ae$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $6d365ff072dfd6ae$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $6d365ff072dfd6ae$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $6d365ff072dfd6ae$var$lj(b);
            $6d365ff072dfd6ae$var$Ig();
            break;
        case 5:
            $6d365ff072dfd6ae$var$Kh(b);
            break;
        case 1:
            $6d365ff072dfd6ae$var$Zf(b.type) && $6d365ff072dfd6ae$var$cg(b);
            break;
        case 4:
            $6d365ff072dfd6ae$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $6d365ff072dfd6ae$var$G($6d365ff072dfd6ae$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $6d365ff072dfd6ae$var$G($6d365ff072dfd6ae$var$M, $6d365ff072dfd6ae$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $6d365ff072dfd6ae$var$pj(a, b, c);
                $6d365ff072dfd6ae$var$G($6d365ff072dfd6ae$var$M, $6d365ff072dfd6ae$var$M.current & 1);
                a = $6d365ff072dfd6ae$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $6d365ff072dfd6ae$var$G($6d365ff072dfd6ae$var$M, $6d365ff072dfd6ae$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $6d365ff072dfd6ae$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $6d365ff072dfd6ae$var$G($6d365ff072dfd6ae$var$M, $6d365ff072dfd6ae$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $6d365ff072dfd6ae$var$ej(a, b, c);
    }
    return $6d365ff072dfd6ae$var$$i(a, b, c);
}
var $6d365ff072dfd6ae$var$Aj, $6d365ff072dfd6ae$var$Bj, $6d365ff072dfd6ae$var$Cj, $6d365ff072dfd6ae$var$Dj;
$6d365ff072dfd6ae$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$6d365ff072dfd6ae$var$Bj = function() {};
$6d365ff072dfd6ae$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $6d365ff072dfd6ae$var$Hh($6d365ff072dfd6ae$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $6d365ff072dfd6ae$var$Ya(a, e);
                d = $6d365ff072dfd6ae$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $6d365ff072dfd6ae$var$A({}, e, {
                    value: void 0
                });
                d = $6d365ff072dfd6ae$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $6d365ff072dfd6ae$var$gb(a, e);
                d = $6d365ff072dfd6ae$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $6d365ff072dfd6ae$var$Bf);
        }
        $6d365ff072dfd6ae$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($6d365ff072dfd6ae$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($6d365ff072dfd6ae$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $6d365ff072dfd6ae$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$6d365ff072dfd6ae$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $6d365ff072dfd6ae$var$Ej(a, b) {
    if (!$6d365ff072dfd6ae$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $6d365ff072dfd6ae$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $6d365ff072dfd6ae$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $6d365ff072dfd6ae$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $6d365ff072dfd6ae$var$S(b), null;
        case 1:
            return $6d365ff072dfd6ae$var$Zf(b.type) && $6d365ff072dfd6ae$var$$f(), $6d365ff072dfd6ae$var$S(b), null;
        case 3:
            d = b.stateNode;
            $6d365ff072dfd6ae$var$Jh();
            $6d365ff072dfd6ae$var$E($6d365ff072dfd6ae$var$Wf);
            $6d365ff072dfd6ae$var$E($6d365ff072dfd6ae$var$H);
            $6d365ff072dfd6ae$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $6d365ff072dfd6ae$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $6d365ff072dfd6ae$var$zg && ($6d365ff072dfd6ae$var$Gj($6d365ff072dfd6ae$var$zg), $6d365ff072dfd6ae$var$zg = null));
            $6d365ff072dfd6ae$var$Bj(a, b);
            $6d365ff072dfd6ae$var$S(b);
            return null;
        case 5:
            $6d365ff072dfd6ae$var$Lh(b);
            var e = $6d365ff072dfd6ae$var$Hh($6d365ff072dfd6ae$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $6d365ff072dfd6ae$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($6d365ff072dfd6ae$var$p(166));
                    $6d365ff072dfd6ae$var$S(b);
                    return null;
                }
                a = $6d365ff072dfd6ae$var$Hh($6d365ff072dfd6ae$var$Eh.current);
                if ($6d365ff072dfd6ae$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$6d365ff072dfd6ae$var$Of] = b;
                    d[$6d365ff072dfd6ae$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $6d365ff072dfd6ae$var$D("cancel", d);
                            $6d365ff072dfd6ae$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $6d365ff072dfd6ae$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $6d365ff072dfd6ae$var$lf.length; e++)$6d365ff072dfd6ae$var$D($6d365ff072dfd6ae$var$lf[e], d);
                            break;
                        case "source":
                            $6d365ff072dfd6ae$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $6d365ff072dfd6ae$var$D("error", d);
                            $6d365ff072dfd6ae$var$D("load", d);
                            break;
                        case "details":
                            $6d365ff072dfd6ae$var$D("toggle", d);
                            break;
                        case "input":
                            $6d365ff072dfd6ae$var$Za(d, f);
                            $6d365ff072dfd6ae$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $6d365ff072dfd6ae$var$D("invalid", d);
                            break;
                        case "textarea":
                            $6d365ff072dfd6ae$var$hb(d, f), $6d365ff072dfd6ae$var$D("invalid", d);
                    }
                    $6d365ff072dfd6ae$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $6d365ff072dfd6ae$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $6d365ff072dfd6ae$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $6d365ff072dfd6ae$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $6d365ff072dfd6ae$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $6d365ff072dfd6ae$var$Va(d);
                            $6d365ff072dfd6ae$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $6d365ff072dfd6ae$var$Va(d);
                            $6d365ff072dfd6ae$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $6d365ff072dfd6ae$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $6d365ff072dfd6ae$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$6d365ff072dfd6ae$var$Of] = b;
                    a[$6d365ff072dfd6ae$var$Pf] = d;
                    $6d365ff072dfd6ae$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $6d365ff072dfd6ae$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $6d365ff072dfd6ae$var$D("cancel", a);
                                $6d365ff072dfd6ae$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $6d365ff072dfd6ae$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $6d365ff072dfd6ae$var$lf.length; e++)$6d365ff072dfd6ae$var$D($6d365ff072dfd6ae$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $6d365ff072dfd6ae$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $6d365ff072dfd6ae$var$D("error", a);
                                $6d365ff072dfd6ae$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $6d365ff072dfd6ae$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $6d365ff072dfd6ae$var$Za(a, d);
                                e = $6d365ff072dfd6ae$var$Ya(a, d);
                                $6d365ff072dfd6ae$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $6d365ff072dfd6ae$var$A({}, d, {
                                    value: void 0
                                });
                                $6d365ff072dfd6ae$var$D("invalid", a);
                                break;
                            case "textarea":
                                $6d365ff072dfd6ae$var$hb(a, d);
                                e = $6d365ff072dfd6ae$var$gb(a, d);
                                $6d365ff072dfd6ae$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $6d365ff072dfd6ae$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $6d365ff072dfd6ae$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $6d365ff072dfd6ae$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $6d365ff072dfd6ae$var$ob(a, k) : "number" === typeof k && $6d365ff072dfd6ae$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($6d365ff072dfd6ae$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $6d365ff072dfd6ae$var$D("scroll", a) : null != k && $6d365ff072dfd6ae$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $6d365ff072dfd6ae$var$Va(a);
                                $6d365ff072dfd6ae$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $6d365ff072dfd6ae$var$Va(a);
                                $6d365ff072dfd6ae$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $6d365ff072dfd6ae$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $6d365ff072dfd6ae$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $6d365ff072dfd6ae$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $6d365ff072dfd6ae$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $6d365ff072dfd6ae$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $6d365ff072dfd6ae$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($6d365ff072dfd6ae$var$p(166));
                c = $6d365ff072dfd6ae$var$Hh($6d365ff072dfd6ae$var$Gh.current);
                $6d365ff072dfd6ae$var$Hh($6d365ff072dfd6ae$var$Eh.current);
                if ($6d365ff072dfd6ae$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$6d365ff072dfd6ae$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $6d365ff072dfd6ae$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $6d365ff072dfd6ae$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $6d365ff072dfd6ae$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$6d365ff072dfd6ae$var$Of] = b, b.stateNode = d;
            }
            $6d365ff072dfd6ae$var$S(b);
            return null;
        case 13:
            $6d365ff072dfd6ae$var$E($6d365ff072dfd6ae$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($6d365ff072dfd6ae$var$I && null !== $6d365ff072dfd6ae$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $6d365ff072dfd6ae$var$Hg(), $6d365ff072dfd6ae$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $6d365ff072dfd6ae$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($6d365ff072dfd6ae$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($6d365ff072dfd6ae$var$p(317));
                        f[$6d365ff072dfd6ae$var$Of] = b;
                    } else $6d365ff072dfd6ae$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $6d365ff072dfd6ae$var$S(b);
                    f = !1;
                } else null !== $6d365ff072dfd6ae$var$zg && ($6d365ff072dfd6ae$var$Gj($6d365ff072dfd6ae$var$zg), $6d365ff072dfd6ae$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($6d365ff072dfd6ae$var$M.current & 1) ? 0 === $6d365ff072dfd6ae$var$T && ($6d365ff072dfd6ae$var$T = 3) : $6d365ff072dfd6ae$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $6d365ff072dfd6ae$var$S(b);
            return null;
        case 4:
            return $6d365ff072dfd6ae$var$Jh(), $6d365ff072dfd6ae$var$Bj(a, b), null === a && $6d365ff072dfd6ae$var$sf(b.stateNode.containerInfo), $6d365ff072dfd6ae$var$S(b), null;
        case 10:
            return $6d365ff072dfd6ae$var$Rg(b.type._context), $6d365ff072dfd6ae$var$S(b), null;
        case 17:
            return $6d365ff072dfd6ae$var$Zf(b.type) && $6d365ff072dfd6ae$var$$f(), $6d365ff072dfd6ae$var$S(b), null;
        case 19:
            $6d365ff072dfd6ae$var$E($6d365ff072dfd6ae$var$M);
            f = b.memoizedState;
            if (null === f) return $6d365ff072dfd6ae$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $6d365ff072dfd6ae$var$Ej(f, !1);
                else {
                    if (0 !== $6d365ff072dfd6ae$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $6d365ff072dfd6ae$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $6d365ff072dfd6ae$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $6d365ff072dfd6ae$var$G($6d365ff072dfd6ae$var$M, $6d365ff072dfd6ae$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $6d365ff072dfd6ae$var$B() > $6d365ff072dfd6ae$var$Hj && (b.flags |= 128, d = !0, $6d365ff072dfd6ae$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $6d365ff072dfd6ae$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $6d365ff072dfd6ae$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$6d365ff072dfd6ae$var$I) return $6d365ff072dfd6ae$var$S(b), null;
                    } else 2 * $6d365ff072dfd6ae$var$B() - f.renderingStartTime > $6d365ff072dfd6ae$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $6d365ff072dfd6ae$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $6d365ff072dfd6ae$var$B(), b.sibling = null, c = $6d365ff072dfd6ae$var$M.current, $6d365ff072dfd6ae$var$G($6d365ff072dfd6ae$var$M, d ? c & 1 | 2 : c & 1), b;
            $6d365ff072dfd6ae$var$S(b);
            return null;
        case 22:
        case 23:
            return $6d365ff072dfd6ae$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($6d365ff072dfd6ae$var$gj & 1073741824) && ($6d365ff072dfd6ae$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $6d365ff072dfd6ae$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($6d365ff072dfd6ae$var$p(156, b.tag));
}
function $6d365ff072dfd6ae$var$Jj(a, b) {
    $6d365ff072dfd6ae$var$wg(b);
    switch(b.tag){
        case 1:
            return $6d365ff072dfd6ae$var$Zf(b.type) && $6d365ff072dfd6ae$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $6d365ff072dfd6ae$var$Jh(), $6d365ff072dfd6ae$var$E($6d365ff072dfd6ae$var$Wf), $6d365ff072dfd6ae$var$E($6d365ff072dfd6ae$var$H), $6d365ff072dfd6ae$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $6d365ff072dfd6ae$var$Lh(b), null;
        case 13:
            $6d365ff072dfd6ae$var$E($6d365ff072dfd6ae$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($6d365ff072dfd6ae$var$p(340));
                $6d365ff072dfd6ae$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $6d365ff072dfd6ae$var$E($6d365ff072dfd6ae$var$M), null;
        case 4:
            return $6d365ff072dfd6ae$var$Jh(), null;
        case 10:
            return $6d365ff072dfd6ae$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $6d365ff072dfd6ae$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $6d365ff072dfd6ae$var$Kj = !1, $6d365ff072dfd6ae$var$U = !1, $6d365ff072dfd6ae$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $6d365ff072dfd6ae$var$V = null;
function $6d365ff072dfd6ae$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $6d365ff072dfd6ae$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $6d365ff072dfd6ae$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $6d365ff072dfd6ae$var$W(a, b, d);
    }
}
var $6d365ff072dfd6ae$var$Oj = !1;
function $6d365ff072dfd6ae$var$Pj(a, b) {
    $6d365ff072dfd6ae$var$Cf = $6d365ff072dfd6ae$var$dd;
    a = $6d365ff072dfd6ae$var$Me();
    if ($6d365ff072dfd6ae$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $6d365ff072dfd6ae$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $6d365ff072dfd6ae$var$dd = !1;
    for($6d365ff072dfd6ae$var$V = b; null !== $6d365ff072dfd6ae$var$V;)if (b = $6d365ff072dfd6ae$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $6d365ff072dfd6ae$var$V = a;
    else for(; null !== $6d365ff072dfd6ae$var$V;){
        b = $6d365ff072dfd6ae$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $6d365ff072dfd6ae$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($6d365ff072dfd6ae$var$p(163));
            }
        } catch (F) {
            $6d365ff072dfd6ae$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $6d365ff072dfd6ae$var$V = a;
            break;
        }
        $6d365ff072dfd6ae$var$V = b.return;
    }
    n = $6d365ff072dfd6ae$var$Oj;
    $6d365ff072dfd6ae$var$Oj = !1;
    return n;
}
function $6d365ff072dfd6ae$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $6d365ff072dfd6ae$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $6d365ff072dfd6ae$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $6d365ff072dfd6ae$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $6d365ff072dfd6ae$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $6d365ff072dfd6ae$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$6d365ff072dfd6ae$var$Of], delete b[$6d365ff072dfd6ae$var$Pf], delete b[$6d365ff072dfd6ae$var$of], delete b[$6d365ff072dfd6ae$var$Qf], delete b[$6d365ff072dfd6ae$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $6d365ff072dfd6ae$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $6d365ff072dfd6ae$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $6d365ff072dfd6ae$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $6d365ff072dfd6ae$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $6d365ff072dfd6ae$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($6d365ff072dfd6ae$var$Wj(a, b, c), a = a.sibling; null !== a;)$6d365ff072dfd6ae$var$Wj(a, b, c), a = a.sibling;
}
function $6d365ff072dfd6ae$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($6d365ff072dfd6ae$var$Xj(a, b, c), a = a.sibling; null !== a;)$6d365ff072dfd6ae$var$Xj(a, b, c), a = a.sibling;
}
var $6d365ff072dfd6ae$var$X = null, $6d365ff072dfd6ae$var$Yj = !1;
function $6d365ff072dfd6ae$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$6d365ff072dfd6ae$var$ak(a, b, c), c = c.sibling;
}
function $6d365ff072dfd6ae$var$ak(a, b, c) {
    if ($6d365ff072dfd6ae$var$lc && "function" === typeof $6d365ff072dfd6ae$var$lc.onCommitFiberUnmount) try {
        $6d365ff072dfd6ae$var$lc.onCommitFiberUnmount($6d365ff072dfd6ae$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $6d365ff072dfd6ae$var$U || $6d365ff072dfd6ae$var$Mj(c, b);
        case 6:
            var d = $6d365ff072dfd6ae$var$X, e = $6d365ff072dfd6ae$var$Yj;
            $6d365ff072dfd6ae$var$X = null;
            $6d365ff072dfd6ae$var$Zj(a, b, c);
            $6d365ff072dfd6ae$var$X = d;
            $6d365ff072dfd6ae$var$Yj = e;
            null !== $6d365ff072dfd6ae$var$X && ($6d365ff072dfd6ae$var$Yj ? (a = $6d365ff072dfd6ae$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $6d365ff072dfd6ae$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $6d365ff072dfd6ae$var$X && ($6d365ff072dfd6ae$var$Yj ? (a = $6d365ff072dfd6ae$var$X, c = c.stateNode, 8 === a.nodeType ? $6d365ff072dfd6ae$var$Kf(a.parentNode, c) : 1 === a.nodeType && $6d365ff072dfd6ae$var$Kf(a, c), $6d365ff072dfd6ae$var$bd(a)) : $6d365ff072dfd6ae$var$Kf($6d365ff072dfd6ae$var$X, c.stateNode));
            break;
        case 4:
            d = $6d365ff072dfd6ae$var$X;
            e = $6d365ff072dfd6ae$var$Yj;
            $6d365ff072dfd6ae$var$X = c.stateNode.containerInfo;
            $6d365ff072dfd6ae$var$Yj = !0;
            $6d365ff072dfd6ae$var$Zj(a, b, c);
            $6d365ff072dfd6ae$var$X = d;
            $6d365ff072dfd6ae$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$6d365ff072dfd6ae$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $6d365ff072dfd6ae$var$Nj(c, b, g) : 0 !== (f & 4) && $6d365ff072dfd6ae$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $6d365ff072dfd6ae$var$Zj(a, b, c);
            break;
        case 1:
            if (!$6d365ff072dfd6ae$var$U && ($6d365ff072dfd6ae$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $6d365ff072dfd6ae$var$W(c, b, h);
            }
            $6d365ff072dfd6ae$var$Zj(a, b, c);
            break;
        case 21:
            $6d365ff072dfd6ae$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($6d365ff072dfd6ae$var$U = (d = $6d365ff072dfd6ae$var$U) || null !== c.memoizedState, $6d365ff072dfd6ae$var$Zj(a, b, c), $6d365ff072dfd6ae$var$U = d) : $6d365ff072dfd6ae$var$Zj(a, b, c);
            break;
        default:
            $6d365ff072dfd6ae$var$Zj(a, b, c);
    }
}
function $6d365ff072dfd6ae$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $6d365ff072dfd6ae$var$Lj);
        b.forEach(function(b) {
            var d = $6d365ff072dfd6ae$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $6d365ff072dfd6ae$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $6d365ff072dfd6ae$var$X = h.stateNode;
                        $6d365ff072dfd6ae$var$Yj = !1;
                        break a;
                    case 3:
                        $6d365ff072dfd6ae$var$X = h.stateNode.containerInfo;
                        $6d365ff072dfd6ae$var$Yj = !0;
                        break a;
                    case 4:
                        $6d365ff072dfd6ae$var$X = h.stateNode.containerInfo;
                        $6d365ff072dfd6ae$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $6d365ff072dfd6ae$var$X) throw Error($6d365ff072dfd6ae$var$p(160));
            $6d365ff072dfd6ae$var$ak(f, g, e);
            $6d365ff072dfd6ae$var$X = null;
            $6d365ff072dfd6ae$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $6d365ff072dfd6ae$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$6d365ff072dfd6ae$var$ek(b, a), b = b.sibling;
}
function $6d365ff072dfd6ae$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $6d365ff072dfd6ae$var$dk(b, a);
            $6d365ff072dfd6ae$var$fk(a);
            if (d & 4) {
                try {
                    $6d365ff072dfd6ae$var$Qj(3, a, a.return), $6d365ff072dfd6ae$var$Rj(3, a);
                } catch (t) {
                    $6d365ff072dfd6ae$var$W(a, a.return, t);
                }
                try {
                    $6d365ff072dfd6ae$var$Qj(5, a, a.return);
                } catch (t) {
                    $6d365ff072dfd6ae$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $6d365ff072dfd6ae$var$dk(b, a);
            $6d365ff072dfd6ae$var$fk(a);
            d & 512 && null !== c && $6d365ff072dfd6ae$var$Mj(c, c.return);
            break;
        case 5:
            $6d365ff072dfd6ae$var$dk(b, a);
            $6d365ff072dfd6ae$var$fk(a);
            d & 512 && null !== c && $6d365ff072dfd6ae$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $6d365ff072dfd6ae$var$ob(e, "");
                } catch (t) {
                    $6d365ff072dfd6ae$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $6d365ff072dfd6ae$var$ab(e, f);
                    $6d365ff072dfd6ae$var$vb(h, g);
                    var l = $6d365ff072dfd6ae$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $6d365ff072dfd6ae$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $6d365ff072dfd6ae$var$nb(e, q) : "children" === m ? $6d365ff072dfd6ae$var$ob(e, q) : $6d365ff072dfd6ae$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $6d365ff072dfd6ae$var$bb(e, f);
                            break;
                        case "textarea":
                            $6d365ff072dfd6ae$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $6d365ff072dfd6ae$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $6d365ff072dfd6ae$var$fb(e, !!f.multiple, f.defaultValue, !0) : $6d365ff072dfd6ae$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$6d365ff072dfd6ae$var$Pf] = f;
                } catch (t) {
                    $6d365ff072dfd6ae$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $6d365ff072dfd6ae$var$dk(b, a);
            $6d365ff072dfd6ae$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($6d365ff072dfd6ae$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $6d365ff072dfd6ae$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $6d365ff072dfd6ae$var$dk(b, a);
            $6d365ff072dfd6ae$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $6d365ff072dfd6ae$var$bd(b.containerInfo);
            } catch (t) {
                $6d365ff072dfd6ae$var$W(a, a.return, t);
            }
            break;
        case 4:
            $6d365ff072dfd6ae$var$dk(b, a);
            $6d365ff072dfd6ae$var$fk(a);
            break;
        case 13:
            $6d365ff072dfd6ae$var$dk(b, a);
            $6d365ff072dfd6ae$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($6d365ff072dfd6ae$var$gk = $6d365ff072dfd6ae$var$B()));
            d & 4 && $6d365ff072dfd6ae$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($6d365ff072dfd6ae$var$U = (l = $6d365ff072dfd6ae$var$U) || m, $6d365ff072dfd6ae$var$dk(b, a), $6d365ff072dfd6ae$var$U = l) : $6d365ff072dfd6ae$var$dk(b, a);
            $6d365ff072dfd6ae$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($6d365ff072dfd6ae$var$V = a, m = a.child; null !== m;){
                    for(q = $6d365ff072dfd6ae$var$V = m; null !== $6d365ff072dfd6ae$var$V;){
                        r = $6d365ff072dfd6ae$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $6d365ff072dfd6ae$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $6d365ff072dfd6ae$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $6d365ff072dfd6ae$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $6d365ff072dfd6ae$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $6d365ff072dfd6ae$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $6d365ff072dfd6ae$var$V = y) : $6d365ff072dfd6ae$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $6d365ff072dfd6ae$var$rb("display", g));
                            } catch (t) {
                                $6d365ff072dfd6ae$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $6d365ff072dfd6ae$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $6d365ff072dfd6ae$var$dk(b, a);
            $6d365ff072dfd6ae$var$fk(a);
            d & 4 && $6d365ff072dfd6ae$var$bk(a);
            break;
        case 21:
            break;
        default:
            $6d365ff072dfd6ae$var$dk(b, a), $6d365ff072dfd6ae$var$fk(a);
    }
}
function $6d365ff072dfd6ae$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($6d365ff072dfd6ae$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($6d365ff072dfd6ae$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($6d365ff072dfd6ae$var$ob(e, ""), d.flags &= -33);
                    var f = $6d365ff072dfd6ae$var$Vj(a);
                    $6d365ff072dfd6ae$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $6d365ff072dfd6ae$var$Vj(a);
                    $6d365ff072dfd6ae$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($6d365ff072dfd6ae$var$p(161));
            }
        } catch (k) {
            $6d365ff072dfd6ae$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $6d365ff072dfd6ae$var$ik(a, b, c) {
    $6d365ff072dfd6ae$var$V = a;
    $6d365ff072dfd6ae$var$jk(a, b, c);
}
function $6d365ff072dfd6ae$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $6d365ff072dfd6ae$var$V;){
        var e = $6d365ff072dfd6ae$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $6d365ff072dfd6ae$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $6d365ff072dfd6ae$var$U;
                h = $6d365ff072dfd6ae$var$Kj;
                var l = $6d365ff072dfd6ae$var$U;
                $6d365ff072dfd6ae$var$Kj = g;
                if (($6d365ff072dfd6ae$var$U = k) && !l) for($6d365ff072dfd6ae$var$V = e; null !== $6d365ff072dfd6ae$var$V;)g = $6d365ff072dfd6ae$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $6d365ff072dfd6ae$var$kk(e) : null !== k ? (k.return = g, $6d365ff072dfd6ae$var$V = k) : $6d365ff072dfd6ae$var$kk(e);
                for(; null !== f;)$6d365ff072dfd6ae$var$V = f, $6d365ff072dfd6ae$var$jk(f, b, c), f = f.sibling;
                $6d365ff072dfd6ae$var$V = e;
                $6d365ff072dfd6ae$var$Kj = h;
                $6d365ff072dfd6ae$var$U = l;
            }
            $6d365ff072dfd6ae$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $6d365ff072dfd6ae$var$V = f) : $6d365ff072dfd6ae$var$lk(a, b, c);
    }
}
function $6d365ff072dfd6ae$var$lk(a) {
    for(; null !== $6d365ff072dfd6ae$var$V;){
        var b = $6d365ff072dfd6ae$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $6d365ff072dfd6ae$var$U || $6d365ff072dfd6ae$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$6d365ff072dfd6ae$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $6d365ff072dfd6ae$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $6d365ff072dfd6ae$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $6d365ff072dfd6ae$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $6d365ff072dfd6ae$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($6d365ff072dfd6ae$var$p(163));
                }
                $6d365ff072dfd6ae$var$U || b.flags & 512 && $6d365ff072dfd6ae$var$Sj(b);
            } catch (r) {
                $6d365ff072dfd6ae$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $6d365ff072dfd6ae$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $6d365ff072dfd6ae$var$V = c;
            break;
        }
        $6d365ff072dfd6ae$var$V = b.return;
    }
}
function $6d365ff072dfd6ae$var$hk(a) {
    for(; null !== $6d365ff072dfd6ae$var$V;){
        var b = $6d365ff072dfd6ae$var$V;
        if (b === a) {
            $6d365ff072dfd6ae$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $6d365ff072dfd6ae$var$V = c;
            break;
        }
        $6d365ff072dfd6ae$var$V = b.return;
    }
}
function $6d365ff072dfd6ae$var$kk(a) {
    for(; null !== $6d365ff072dfd6ae$var$V;){
        var b = $6d365ff072dfd6ae$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $6d365ff072dfd6ae$var$Rj(4, b);
                    } catch (k) {
                        $6d365ff072dfd6ae$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $6d365ff072dfd6ae$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $6d365ff072dfd6ae$var$Sj(b);
                    } catch (k) {
                        $6d365ff072dfd6ae$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $6d365ff072dfd6ae$var$Sj(b);
                    } catch (k) {
                        $6d365ff072dfd6ae$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $6d365ff072dfd6ae$var$W(b, b.return, k);
        }
        if (b === a) {
            $6d365ff072dfd6ae$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $6d365ff072dfd6ae$var$V = h;
            break;
        }
        $6d365ff072dfd6ae$var$V = b.return;
    }
}
var $6d365ff072dfd6ae$var$mk = Math.ceil, $6d365ff072dfd6ae$var$nk = $6d365ff072dfd6ae$var$ua.ReactCurrentDispatcher, $6d365ff072dfd6ae$var$ok = $6d365ff072dfd6ae$var$ua.ReactCurrentOwner, $6d365ff072dfd6ae$var$pk = $6d365ff072dfd6ae$var$ua.ReactCurrentBatchConfig, $6d365ff072dfd6ae$var$K = 0, $6d365ff072dfd6ae$var$R = null, $6d365ff072dfd6ae$var$Y = null, $6d365ff072dfd6ae$var$Z = 0, $6d365ff072dfd6ae$var$gj = 0, $6d365ff072dfd6ae$var$fj = $6d365ff072dfd6ae$var$Uf(0), $6d365ff072dfd6ae$var$T = 0, $6d365ff072dfd6ae$var$qk = null, $6d365ff072dfd6ae$var$hh = 0, $6d365ff072dfd6ae$var$rk = 0, $6d365ff072dfd6ae$var$sk = 0, $6d365ff072dfd6ae$var$tk = null, $6d365ff072dfd6ae$var$uk = null, $6d365ff072dfd6ae$var$gk = 0, $6d365ff072dfd6ae$var$Hj = Infinity, $6d365ff072dfd6ae$var$vk = null, $6d365ff072dfd6ae$var$Pi = !1, $6d365ff072dfd6ae$var$Qi = null, $6d365ff072dfd6ae$var$Si = null, $6d365ff072dfd6ae$var$wk = !1, $6d365ff072dfd6ae$var$xk = null, $6d365ff072dfd6ae$var$yk = 0, $6d365ff072dfd6ae$var$zk = 0, $6d365ff072dfd6ae$var$Ak = null, $6d365ff072dfd6ae$var$Bk = -1, $6d365ff072dfd6ae$var$Ck = 0;
function $6d365ff072dfd6ae$var$L() {
    return 0 !== ($6d365ff072dfd6ae$var$K & 6) ? $6d365ff072dfd6ae$var$B() : -1 !== $6d365ff072dfd6ae$var$Bk ? $6d365ff072dfd6ae$var$Bk : $6d365ff072dfd6ae$var$Bk = $6d365ff072dfd6ae$var$B();
}
function $6d365ff072dfd6ae$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($6d365ff072dfd6ae$var$K & 2) && 0 !== $6d365ff072dfd6ae$var$Z) return $6d365ff072dfd6ae$var$Z & -$6d365ff072dfd6ae$var$Z;
    if (null !== $6d365ff072dfd6ae$var$Kg.transition) return 0 === $6d365ff072dfd6ae$var$Ck && ($6d365ff072dfd6ae$var$Ck = $6d365ff072dfd6ae$var$yc()), $6d365ff072dfd6ae$var$Ck;
    a = $6d365ff072dfd6ae$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $6d365ff072dfd6ae$var$jd(a.type);
    return a;
}
function $6d365ff072dfd6ae$var$mh(a, b, c, d) {
    if (50 < $6d365ff072dfd6ae$var$zk) throw $6d365ff072dfd6ae$var$zk = 0, $6d365ff072dfd6ae$var$Ak = null, Error($6d365ff072dfd6ae$var$p(185));
    $6d365ff072dfd6ae$var$Ac(a, c, d);
    if (0 === ($6d365ff072dfd6ae$var$K & 2) || a !== $6d365ff072dfd6ae$var$R) a === $6d365ff072dfd6ae$var$R && (0 === ($6d365ff072dfd6ae$var$K & 2) && ($6d365ff072dfd6ae$var$rk |= c), 4 === $6d365ff072dfd6ae$var$T && $6d365ff072dfd6ae$var$Dk(a, $6d365ff072dfd6ae$var$Z)), $6d365ff072dfd6ae$var$Ek(a, d), 1 === c && 0 === $6d365ff072dfd6ae$var$K && 0 === (b.mode & 1) && ($6d365ff072dfd6ae$var$Hj = $6d365ff072dfd6ae$var$B() + 500, $6d365ff072dfd6ae$var$fg && $6d365ff072dfd6ae$var$jg());
}
function $6d365ff072dfd6ae$var$Ek(a, b) {
    var c = a.callbackNode;
    $6d365ff072dfd6ae$var$wc(a, b);
    var d = $6d365ff072dfd6ae$var$uc(a, a === $6d365ff072dfd6ae$var$R ? $6d365ff072dfd6ae$var$Z : 0);
    if (0 === d) null !== c && $6d365ff072dfd6ae$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $6d365ff072dfd6ae$var$bc(c);
        if (1 === b) 0 === a.tag ? $6d365ff072dfd6ae$var$ig($6d365ff072dfd6ae$var$Fk.bind(null, a)) : $6d365ff072dfd6ae$var$hg($6d365ff072dfd6ae$var$Fk.bind(null, a)), $6d365ff072dfd6ae$var$Jf(function() {
            0 === ($6d365ff072dfd6ae$var$K & 6) && $6d365ff072dfd6ae$var$jg();
        }), c = null;
        else {
            switch($6d365ff072dfd6ae$var$Dc(d)){
                case 1:
                    c = $6d365ff072dfd6ae$var$fc;
                    break;
                case 4:
                    c = $6d365ff072dfd6ae$var$gc;
                    break;
                case 16:
                    c = $6d365ff072dfd6ae$var$hc;
                    break;
                case 536870912:
                    c = $6d365ff072dfd6ae$var$jc;
                    break;
                default:
                    c = $6d365ff072dfd6ae$var$hc;
            }
            c = $6d365ff072dfd6ae$var$Gk(c, $6d365ff072dfd6ae$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $6d365ff072dfd6ae$var$Hk(a, b) {
    $6d365ff072dfd6ae$var$Bk = -1;
    $6d365ff072dfd6ae$var$Ck = 0;
    if (0 !== ($6d365ff072dfd6ae$var$K & 6)) throw Error($6d365ff072dfd6ae$var$p(327));
    var c = a.callbackNode;
    if ($6d365ff072dfd6ae$var$Ik() && a.callbackNode !== c) return null;
    var d = $6d365ff072dfd6ae$var$uc(a, a === $6d365ff072dfd6ae$var$R ? $6d365ff072dfd6ae$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $6d365ff072dfd6ae$var$Jk(a, d);
    else {
        b = d;
        var e = $6d365ff072dfd6ae$var$K;
        $6d365ff072dfd6ae$var$K |= 2;
        var f = $6d365ff072dfd6ae$var$Kk();
        if ($6d365ff072dfd6ae$var$R !== a || $6d365ff072dfd6ae$var$Z !== b) $6d365ff072dfd6ae$var$vk = null, $6d365ff072dfd6ae$var$Hj = $6d365ff072dfd6ae$var$B() + 500, $6d365ff072dfd6ae$var$Lk(a, b);
        for(;;)try {
            $6d365ff072dfd6ae$var$Mk();
            break;
        } catch (h) {
            $6d365ff072dfd6ae$var$Nk(a, h);
        }
        $6d365ff072dfd6ae$var$Qg();
        $6d365ff072dfd6ae$var$nk.current = f;
        $6d365ff072dfd6ae$var$K = e;
        null !== $6d365ff072dfd6ae$var$Y ? b = 0 : ($6d365ff072dfd6ae$var$R = null, $6d365ff072dfd6ae$var$Z = 0, b = $6d365ff072dfd6ae$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $6d365ff072dfd6ae$var$xc(a), 0 !== e && (d = e, b = $6d365ff072dfd6ae$var$Ok(a, e)));
        if (1 === b) throw c = $6d365ff072dfd6ae$var$qk, $6d365ff072dfd6ae$var$Lk(a, 0), $6d365ff072dfd6ae$var$Dk(a, d), $6d365ff072dfd6ae$var$Ek(a, $6d365ff072dfd6ae$var$B()), c;
        if (6 === b) $6d365ff072dfd6ae$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$6d365ff072dfd6ae$var$Pk(e) && (b = $6d365ff072dfd6ae$var$Jk(a, d), 2 === b && (f = $6d365ff072dfd6ae$var$xc(a), 0 !== f && (d = f, b = $6d365ff072dfd6ae$var$Ok(a, f))), 1 === b)) throw c = $6d365ff072dfd6ae$var$qk, $6d365ff072dfd6ae$var$Lk(a, 0), $6d365ff072dfd6ae$var$Dk(a, d), $6d365ff072dfd6ae$var$Ek(a, $6d365ff072dfd6ae$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($6d365ff072dfd6ae$var$p(345));
                case 2:
                    $6d365ff072dfd6ae$var$Qk(a, $6d365ff072dfd6ae$var$uk, $6d365ff072dfd6ae$var$vk);
                    break;
                case 3:
                    $6d365ff072dfd6ae$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $6d365ff072dfd6ae$var$gk + 500 - $6d365ff072dfd6ae$var$B(), 10 < b)) {
                        if (0 !== $6d365ff072dfd6ae$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $6d365ff072dfd6ae$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $6d365ff072dfd6ae$var$Ff($6d365ff072dfd6ae$var$Qk.bind(null, a, $6d365ff072dfd6ae$var$uk, $6d365ff072dfd6ae$var$vk), b);
                        break;
                    }
                    $6d365ff072dfd6ae$var$Qk(a, $6d365ff072dfd6ae$var$uk, $6d365ff072dfd6ae$var$vk);
                    break;
                case 4:
                    $6d365ff072dfd6ae$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $6d365ff072dfd6ae$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $6d365ff072dfd6ae$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $6d365ff072dfd6ae$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $6d365ff072dfd6ae$var$Ff($6d365ff072dfd6ae$var$Qk.bind(null, a, $6d365ff072dfd6ae$var$uk, $6d365ff072dfd6ae$var$vk), d);
                        break;
                    }
                    $6d365ff072dfd6ae$var$Qk(a, $6d365ff072dfd6ae$var$uk, $6d365ff072dfd6ae$var$vk);
                    break;
                case 5:
                    $6d365ff072dfd6ae$var$Qk(a, $6d365ff072dfd6ae$var$uk, $6d365ff072dfd6ae$var$vk);
                    break;
                default:
                    throw Error($6d365ff072dfd6ae$var$p(329));
            }
        }
    }
    $6d365ff072dfd6ae$var$Ek(a, $6d365ff072dfd6ae$var$B());
    return a.callbackNode === c ? $6d365ff072dfd6ae$var$Hk.bind(null, a) : null;
}
function $6d365ff072dfd6ae$var$Ok(a, b) {
    var c = $6d365ff072dfd6ae$var$tk;
    a.current.memoizedState.isDehydrated && ($6d365ff072dfd6ae$var$Lk(a, b).flags |= 256);
    a = $6d365ff072dfd6ae$var$Jk(a, b);
    2 !== a && (b = $6d365ff072dfd6ae$var$uk, $6d365ff072dfd6ae$var$uk = c, null !== b && $6d365ff072dfd6ae$var$Gj(b));
    return a;
}
function $6d365ff072dfd6ae$var$Gj(a) {
    null === $6d365ff072dfd6ae$var$uk ? $6d365ff072dfd6ae$var$uk = a : $6d365ff072dfd6ae$var$uk.push.apply($6d365ff072dfd6ae$var$uk, a);
}
function $6d365ff072dfd6ae$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$6d365ff072dfd6ae$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $6d365ff072dfd6ae$var$Dk(a, b) {
    b &= ~$6d365ff072dfd6ae$var$sk;
    b &= ~$6d365ff072dfd6ae$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $6d365ff072dfd6ae$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $6d365ff072dfd6ae$var$Fk(a) {
    if (0 !== ($6d365ff072dfd6ae$var$K & 6)) throw Error($6d365ff072dfd6ae$var$p(327));
    $6d365ff072dfd6ae$var$Ik();
    var b = $6d365ff072dfd6ae$var$uc(a, 0);
    if (0 === (b & 1)) return $6d365ff072dfd6ae$var$Ek(a, $6d365ff072dfd6ae$var$B()), null;
    var c = $6d365ff072dfd6ae$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $6d365ff072dfd6ae$var$xc(a);
        0 !== d && (b = d, c = $6d365ff072dfd6ae$var$Ok(a, d));
    }
    if (1 === c) throw c = $6d365ff072dfd6ae$var$qk, $6d365ff072dfd6ae$var$Lk(a, 0), $6d365ff072dfd6ae$var$Dk(a, b), $6d365ff072dfd6ae$var$Ek(a, $6d365ff072dfd6ae$var$B()), c;
    if (6 === c) throw Error($6d365ff072dfd6ae$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $6d365ff072dfd6ae$var$Qk(a, $6d365ff072dfd6ae$var$uk, $6d365ff072dfd6ae$var$vk);
    $6d365ff072dfd6ae$var$Ek(a, $6d365ff072dfd6ae$var$B());
    return null;
}
function $6d365ff072dfd6ae$var$Rk(a, b) {
    var c = $6d365ff072dfd6ae$var$K;
    $6d365ff072dfd6ae$var$K |= 1;
    try {
        return a(b);
    } finally{
        $6d365ff072dfd6ae$var$K = c, 0 === $6d365ff072dfd6ae$var$K && ($6d365ff072dfd6ae$var$Hj = $6d365ff072dfd6ae$var$B() + 500, $6d365ff072dfd6ae$var$fg && $6d365ff072dfd6ae$var$jg());
    }
}
function $6d365ff072dfd6ae$var$Sk(a) {
    null !== $6d365ff072dfd6ae$var$xk && 0 === $6d365ff072dfd6ae$var$xk.tag && 0 === ($6d365ff072dfd6ae$var$K & 6) && $6d365ff072dfd6ae$var$Ik();
    var b = $6d365ff072dfd6ae$var$K;
    $6d365ff072dfd6ae$var$K |= 1;
    var c = $6d365ff072dfd6ae$var$pk.transition, d = $6d365ff072dfd6ae$var$C;
    try {
        if ($6d365ff072dfd6ae$var$pk.transition = null, $6d365ff072dfd6ae$var$C = 1, a) return a();
    } finally{
        $6d365ff072dfd6ae$var$C = d, $6d365ff072dfd6ae$var$pk.transition = c, $6d365ff072dfd6ae$var$K = b, 0 === ($6d365ff072dfd6ae$var$K & 6) && $6d365ff072dfd6ae$var$jg();
    }
}
function $6d365ff072dfd6ae$var$Ij() {
    $6d365ff072dfd6ae$var$gj = $6d365ff072dfd6ae$var$fj.current;
    $6d365ff072dfd6ae$var$E($6d365ff072dfd6ae$var$fj);
}
function $6d365ff072dfd6ae$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $6d365ff072dfd6ae$var$Gf(c));
    if (null !== $6d365ff072dfd6ae$var$Y) for(c = $6d365ff072dfd6ae$var$Y.return; null !== c;){
        var d = c;
        $6d365ff072dfd6ae$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $6d365ff072dfd6ae$var$$f();
                break;
            case 3:
                $6d365ff072dfd6ae$var$Jh();
                $6d365ff072dfd6ae$var$E($6d365ff072dfd6ae$var$Wf);
                $6d365ff072dfd6ae$var$E($6d365ff072dfd6ae$var$H);
                $6d365ff072dfd6ae$var$Oh();
                break;
            case 5:
                $6d365ff072dfd6ae$var$Lh(d);
                break;
            case 4:
                $6d365ff072dfd6ae$var$Jh();
                break;
            case 13:
                $6d365ff072dfd6ae$var$E($6d365ff072dfd6ae$var$M);
                break;
            case 19:
                $6d365ff072dfd6ae$var$E($6d365ff072dfd6ae$var$M);
                break;
            case 10:
                $6d365ff072dfd6ae$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $6d365ff072dfd6ae$var$Ij();
        }
        c = c.return;
    }
    $6d365ff072dfd6ae$var$R = a;
    $6d365ff072dfd6ae$var$Y = a = $6d365ff072dfd6ae$var$wh(a.current, null);
    $6d365ff072dfd6ae$var$Z = $6d365ff072dfd6ae$var$gj = b;
    $6d365ff072dfd6ae$var$T = 0;
    $6d365ff072dfd6ae$var$qk = null;
    $6d365ff072dfd6ae$var$sk = $6d365ff072dfd6ae$var$rk = $6d365ff072dfd6ae$var$hh = 0;
    $6d365ff072dfd6ae$var$uk = $6d365ff072dfd6ae$var$tk = null;
    if (null !== $6d365ff072dfd6ae$var$Wg) {
        for(b = 0; b < $6d365ff072dfd6ae$var$Wg.length; b++)if (c = $6d365ff072dfd6ae$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $6d365ff072dfd6ae$var$Wg = null;
    }
    return a;
}
function $6d365ff072dfd6ae$var$Nk(a, b) {
    do {
        var c = $6d365ff072dfd6ae$var$Y;
        try {
            $6d365ff072dfd6ae$var$Qg();
            $6d365ff072dfd6ae$var$Ph.current = $6d365ff072dfd6ae$var$ai;
            if ($6d365ff072dfd6ae$var$Sh) {
                for(var d = $6d365ff072dfd6ae$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $6d365ff072dfd6ae$var$Sh = !1;
            }
            $6d365ff072dfd6ae$var$Rh = 0;
            $6d365ff072dfd6ae$var$P = $6d365ff072dfd6ae$var$O = $6d365ff072dfd6ae$var$N = null;
            $6d365ff072dfd6ae$var$Th = !1;
            $6d365ff072dfd6ae$var$Uh = 0;
            $6d365ff072dfd6ae$var$ok.current = null;
            if (null === c || null === c.return) {
                $6d365ff072dfd6ae$var$T = 1;
                $6d365ff072dfd6ae$var$qk = b;
                $6d365ff072dfd6ae$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $6d365ff072dfd6ae$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $6d365ff072dfd6ae$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $6d365ff072dfd6ae$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $6d365ff072dfd6ae$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $6d365ff072dfd6ae$var$Ti(f, l, b);
                            $6d365ff072dfd6ae$var$uj();
                            break a;
                        }
                        k = Error($6d365ff072dfd6ae$var$p(426));
                    }
                } else if ($6d365ff072dfd6ae$var$I && h.mode & 1) {
                    var J = $6d365ff072dfd6ae$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $6d365ff072dfd6ae$var$Wi(J, g, h, f, b);
                        $6d365ff072dfd6ae$var$Jg($6d365ff072dfd6ae$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $6d365ff072dfd6ae$var$Ki(k, h);
                4 !== $6d365ff072dfd6ae$var$T && ($6d365ff072dfd6ae$var$T = 2);
                null === $6d365ff072dfd6ae$var$tk ? $6d365ff072dfd6ae$var$tk = [
                    f
                ] : $6d365ff072dfd6ae$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $6d365ff072dfd6ae$var$Oi(f, k, b);
                            $6d365ff072dfd6ae$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $6d365ff072dfd6ae$var$Si || !$6d365ff072dfd6ae$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $6d365ff072dfd6ae$var$Ri(f, h, b);
                                $6d365ff072dfd6ae$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $6d365ff072dfd6ae$var$Tk(c);
        } catch (na) {
            b = na;
            $6d365ff072dfd6ae$var$Y === c && null !== c && ($6d365ff072dfd6ae$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $6d365ff072dfd6ae$var$Kk() {
    var a = $6d365ff072dfd6ae$var$nk.current;
    $6d365ff072dfd6ae$var$nk.current = $6d365ff072dfd6ae$var$ai;
    return null === a ? $6d365ff072dfd6ae$var$ai : a;
}
function $6d365ff072dfd6ae$var$uj() {
    if (0 === $6d365ff072dfd6ae$var$T || 3 === $6d365ff072dfd6ae$var$T || 2 === $6d365ff072dfd6ae$var$T) $6d365ff072dfd6ae$var$T = 4;
    null === $6d365ff072dfd6ae$var$R || 0 === ($6d365ff072dfd6ae$var$hh & 268435455) && 0 === ($6d365ff072dfd6ae$var$rk & 268435455) || $6d365ff072dfd6ae$var$Dk($6d365ff072dfd6ae$var$R, $6d365ff072dfd6ae$var$Z);
}
function $6d365ff072dfd6ae$var$Jk(a, b) {
    var c = $6d365ff072dfd6ae$var$K;
    $6d365ff072dfd6ae$var$K |= 2;
    var d = $6d365ff072dfd6ae$var$Kk();
    if ($6d365ff072dfd6ae$var$R !== a || $6d365ff072dfd6ae$var$Z !== b) $6d365ff072dfd6ae$var$vk = null, $6d365ff072dfd6ae$var$Lk(a, b);
    for(;;)try {
        $6d365ff072dfd6ae$var$Uk();
        break;
    } catch (e) {
        $6d365ff072dfd6ae$var$Nk(a, e);
    }
    $6d365ff072dfd6ae$var$Qg();
    $6d365ff072dfd6ae$var$K = c;
    $6d365ff072dfd6ae$var$nk.current = d;
    if (null !== $6d365ff072dfd6ae$var$Y) throw Error($6d365ff072dfd6ae$var$p(261));
    $6d365ff072dfd6ae$var$R = null;
    $6d365ff072dfd6ae$var$Z = 0;
    return $6d365ff072dfd6ae$var$T;
}
function $6d365ff072dfd6ae$var$Uk() {
    for(; null !== $6d365ff072dfd6ae$var$Y;)$6d365ff072dfd6ae$var$Vk($6d365ff072dfd6ae$var$Y);
}
function $6d365ff072dfd6ae$var$Mk() {
    for(; null !== $6d365ff072dfd6ae$var$Y && !$6d365ff072dfd6ae$var$cc();)$6d365ff072dfd6ae$var$Vk($6d365ff072dfd6ae$var$Y);
}
function $6d365ff072dfd6ae$var$Vk(a) {
    var b = $6d365ff072dfd6ae$var$Wk(a.alternate, a, $6d365ff072dfd6ae$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $6d365ff072dfd6ae$var$Tk(a) : $6d365ff072dfd6ae$var$Y = b;
    $6d365ff072dfd6ae$var$ok.current = null;
}
function $6d365ff072dfd6ae$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $6d365ff072dfd6ae$var$Fj(c, b, $6d365ff072dfd6ae$var$gj), null !== c) {
                $6d365ff072dfd6ae$var$Y = c;
                return;
            }
        } else {
            c = $6d365ff072dfd6ae$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $6d365ff072dfd6ae$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $6d365ff072dfd6ae$var$T = 6;
                $6d365ff072dfd6ae$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $6d365ff072dfd6ae$var$Y = b;
            return;
        }
        $6d365ff072dfd6ae$var$Y = b = a;
    }while (null !== b);
    0 === $6d365ff072dfd6ae$var$T && ($6d365ff072dfd6ae$var$T = 5);
}
function $6d365ff072dfd6ae$var$Qk(a, b, c) {
    var d = $6d365ff072dfd6ae$var$C, e = $6d365ff072dfd6ae$var$pk.transition;
    try {
        $6d365ff072dfd6ae$var$pk.transition = null, $6d365ff072dfd6ae$var$C = 1, $6d365ff072dfd6ae$var$Xk(a, b, c, d);
    } finally{
        $6d365ff072dfd6ae$var$pk.transition = e, $6d365ff072dfd6ae$var$C = d;
    }
    return null;
}
function $6d365ff072dfd6ae$var$Xk(a, b, c, d) {
    do $6d365ff072dfd6ae$var$Ik();
    while (null !== $6d365ff072dfd6ae$var$xk);
    if (0 !== ($6d365ff072dfd6ae$var$K & 6)) throw Error($6d365ff072dfd6ae$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($6d365ff072dfd6ae$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $6d365ff072dfd6ae$var$Bc(a, f);
    a === $6d365ff072dfd6ae$var$R && ($6d365ff072dfd6ae$var$Y = $6d365ff072dfd6ae$var$R = null, $6d365ff072dfd6ae$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $6d365ff072dfd6ae$var$wk || ($6d365ff072dfd6ae$var$wk = !0, $6d365ff072dfd6ae$var$Gk($6d365ff072dfd6ae$var$hc, function() {
        $6d365ff072dfd6ae$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $6d365ff072dfd6ae$var$pk.transition;
        $6d365ff072dfd6ae$var$pk.transition = null;
        var g = $6d365ff072dfd6ae$var$C;
        $6d365ff072dfd6ae$var$C = 1;
        var h = $6d365ff072dfd6ae$var$K;
        $6d365ff072dfd6ae$var$K |= 4;
        $6d365ff072dfd6ae$var$ok.current = null;
        $6d365ff072dfd6ae$var$Pj(a, c);
        $6d365ff072dfd6ae$var$ek(c, a);
        $6d365ff072dfd6ae$var$Oe($6d365ff072dfd6ae$var$Df);
        $6d365ff072dfd6ae$var$dd = !!$6d365ff072dfd6ae$var$Cf;
        $6d365ff072dfd6ae$var$Df = $6d365ff072dfd6ae$var$Cf = null;
        a.current = c;
        $6d365ff072dfd6ae$var$ik(c, a, e);
        $6d365ff072dfd6ae$var$dc();
        $6d365ff072dfd6ae$var$K = h;
        $6d365ff072dfd6ae$var$C = g;
        $6d365ff072dfd6ae$var$pk.transition = f;
    } else a.current = c;
    $6d365ff072dfd6ae$var$wk && ($6d365ff072dfd6ae$var$wk = !1, $6d365ff072dfd6ae$var$xk = a, $6d365ff072dfd6ae$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($6d365ff072dfd6ae$var$Si = null);
    $6d365ff072dfd6ae$var$mc(c.stateNode, d);
    $6d365ff072dfd6ae$var$Ek(a, $6d365ff072dfd6ae$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($6d365ff072dfd6ae$var$Pi) throw $6d365ff072dfd6ae$var$Pi = !1, a = $6d365ff072dfd6ae$var$Qi, $6d365ff072dfd6ae$var$Qi = null, a;
    0 !== ($6d365ff072dfd6ae$var$yk & 1) && 0 !== a.tag && $6d365ff072dfd6ae$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $6d365ff072dfd6ae$var$Ak ? $6d365ff072dfd6ae$var$zk++ : ($6d365ff072dfd6ae$var$zk = 0, $6d365ff072dfd6ae$var$Ak = a) : $6d365ff072dfd6ae$var$zk = 0;
    $6d365ff072dfd6ae$var$jg();
    return null;
}
function $6d365ff072dfd6ae$var$Ik() {
    if (null !== $6d365ff072dfd6ae$var$xk) {
        var a = $6d365ff072dfd6ae$var$Dc($6d365ff072dfd6ae$var$yk), b = $6d365ff072dfd6ae$var$pk.transition, c = $6d365ff072dfd6ae$var$C;
        try {
            $6d365ff072dfd6ae$var$pk.transition = null;
            $6d365ff072dfd6ae$var$C = 16 > a ? 16 : a;
            if (null === $6d365ff072dfd6ae$var$xk) var d = !1;
            else {
                a = $6d365ff072dfd6ae$var$xk;
                $6d365ff072dfd6ae$var$xk = null;
                $6d365ff072dfd6ae$var$yk = 0;
                if (0 !== ($6d365ff072dfd6ae$var$K & 6)) throw Error($6d365ff072dfd6ae$var$p(331));
                var e = $6d365ff072dfd6ae$var$K;
                $6d365ff072dfd6ae$var$K |= 4;
                for($6d365ff072dfd6ae$var$V = a.current; null !== $6d365ff072dfd6ae$var$V;){
                    var f = $6d365ff072dfd6ae$var$V, g = f.child;
                    if (0 !== ($6d365ff072dfd6ae$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($6d365ff072dfd6ae$var$V = l; null !== $6d365ff072dfd6ae$var$V;){
                                    var m = $6d365ff072dfd6ae$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $6d365ff072dfd6ae$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $6d365ff072dfd6ae$var$V = q;
                                    else for(; null !== $6d365ff072dfd6ae$var$V;){
                                        m = $6d365ff072dfd6ae$var$V;
                                        var r = m.sibling, y = m.return;
                                        $6d365ff072dfd6ae$var$Tj(m);
                                        if (m === l) {
                                            $6d365ff072dfd6ae$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $6d365ff072dfd6ae$var$V = r;
                                            break;
                                        }
                                        $6d365ff072dfd6ae$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $6d365ff072dfd6ae$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $6d365ff072dfd6ae$var$V = g;
                    else b: for(; null !== $6d365ff072dfd6ae$var$V;){
                        f = $6d365ff072dfd6ae$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $6d365ff072dfd6ae$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $6d365ff072dfd6ae$var$V = x;
                            break b;
                        }
                        $6d365ff072dfd6ae$var$V = f.return;
                    }
                }
                var w = a.current;
                for($6d365ff072dfd6ae$var$V = w; null !== $6d365ff072dfd6ae$var$V;){
                    g = $6d365ff072dfd6ae$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $6d365ff072dfd6ae$var$V = u;
                    else b: for(g = w; null !== $6d365ff072dfd6ae$var$V;){
                        h = $6d365ff072dfd6ae$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $6d365ff072dfd6ae$var$Rj(9, h);
                            }
                        } catch (na) {
                            $6d365ff072dfd6ae$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $6d365ff072dfd6ae$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $6d365ff072dfd6ae$var$V = F;
                            break b;
                        }
                        $6d365ff072dfd6ae$var$V = h.return;
                    }
                }
                $6d365ff072dfd6ae$var$K = e;
                $6d365ff072dfd6ae$var$jg();
                if ($6d365ff072dfd6ae$var$lc && "function" === typeof $6d365ff072dfd6ae$var$lc.onPostCommitFiberRoot) try {
                    $6d365ff072dfd6ae$var$lc.onPostCommitFiberRoot($6d365ff072dfd6ae$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $6d365ff072dfd6ae$var$C = c, $6d365ff072dfd6ae$var$pk.transition = b;
        }
    }
    return !1;
}
function $6d365ff072dfd6ae$var$Yk(a, b, c) {
    b = $6d365ff072dfd6ae$var$Ki(c, b);
    b = $6d365ff072dfd6ae$var$Oi(a, b, 1);
    a = $6d365ff072dfd6ae$var$dh(a, b, 1);
    b = $6d365ff072dfd6ae$var$L();
    null !== a && ($6d365ff072dfd6ae$var$Ac(a, 1, b), $6d365ff072dfd6ae$var$Ek(a, b));
}
function $6d365ff072dfd6ae$var$W(a, b, c) {
    if (3 === a.tag) $6d365ff072dfd6ae$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $6d365ff072dfd6ae$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $6d365ff072dfd6ae$var$Si || !$6d365ff072dfd6ae$var$Si.has(d))) {
                a = $6d365ff072dfd6ae$var$Ki(c, a);
                a = $6d365ff072dfd6ae$var$Ri(b, a, 1);
                b = $6d365ff072dfd6ae$var$dh(b, a, 1);
                a = $6d365ff072dfd6ae$var$L();
                null !== b && ($6d365ff072dfd6ae$var$Ac(b, 1, a), $6d365ff072dfd6ae$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $6d365ff072dfd6ae$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $6d365ff072dfd6ae$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $6d365ff072dfd6ae$var$R === a && ($6d365ff072dfd6ae$var$Z & c) === c && (4 === $6d365ff072dfd6ae$var$T || 3 === $6d365ff072dfd6ae$var$T && ($6d365ff072dfd6ae$var$Z & 130023424) === $6d365ff072dfd6ae$var$Z && 500 > $6d365ff072dfd6ae$var$B() - $6d365ff072dfd6ae$var$gk ? $6d365ff072dfd6ae$var$Lk(a, 0) : $6d365ff072dfd6ae$var$sk |= c);
    $6d365ff072dfd6ae$var$Ek(a, b);
}
function $6d365ff072dfd6ae$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $6d365ff072dfd6ae$var$sc, $6d365ff072dfd6ae$var$sc <<= 1, 0 === ($6d365ff072dfd6ae$var$sc & 130023424) && ($6d365ff072dfd6ae$var$sc = 4194304)));
    var c = $6d365ff072dfd6ae$var$L();
    a = $6d365ff072dfd6ae$var$Zg(a, b);
    null !== a && ($6d365ff072dfd6ae$var$Ac(a, b, c), $6d365ff072dfd6ae$var$Ek(a, c));
}
function $6d365ff072dfd6ae$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $6d365ff072dfd6ae$var$Zk(a, c);
}
function $6d365ff072dfd6ae$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($6d365ff072dfd6ae$var$p(314));
    }
    null !== d && d.delete(b);
    $6d365ff072dfd6ae$var$Zk(a, c);
}
var $6d365ff072dfd6ae$var$Wk;
$6d365ff072dfd6ae$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $6d365ff072dfd6ae$var$Wf.current) $6d365ff072dfd6ae$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $6d365ff072dfd6ae$var$Ug = !1, $6d365ff072dfd6ae$var$zj(a, b, c);
            $6d365ff072dfd6ae$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $6d365ff072dfd6ae$var$Ug = !1, $6d365ff072dfd6ae$var$I && 0 !== (b.flags & 1048576) && $6d365ff072dfd6ae$var$ug(b, $6d365ff072dfd6ae$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $6d365ff072dfd6ae$var$jj(a, b);
            a = b.pendingProps;
            var e = $6d365ff072dfd6ae$var$Yf(b, $6d365ff072dfd6ae$var$H.current);
            $6d365ff072dfd6ae$var$Tg(b, c);
            e = $6d365ff072dfd6ae$var$Xh(null, b, d, a, e, c);
            var f = $6d365ff072dfd6ae$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $6d365ff072dfd6ae$var$Zf(d) ? (f = !0, $6d365ff072dfd6ae$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $6d365ff072dfd6ae$var$ah(b), e.updater = $6d365ff072dfd6ae$var$nh, b.stateNode = e, e._reactInternals = b, $6d365ff072dfd6ae$var$rh(b, d, a, c), b = $6d365ff072dfd6ae$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $6d365ff072dfd6ae$var$I && f && $6d365ff072dfd6ae$var$vg(b), $6d365ff072dfd6ae$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $6d365ff072dfd6ae$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $6d365ff072dfd6ae$var$$k(d);
                a = $6d365ff072dfd6ae$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $6d365ff072dfd6ae$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $6d365ff072dfd6ae$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $6d365ff072dfd6ae$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $6d365ff072dfd6ae$var$aj(null, b, d, $6d365ff072dfd6ae$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($6d365ff072dfd6ae$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $6d365ff072dfd6ae$var$Lg(d, e), $6d365ff072dfd6ae$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $6d365ff072dfd6ae$var$Lg(d, e), $6d365ff072dfd6ae$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $6d365ff072dfd6ae$var$lj(b);
                if (null === a) throw Error($6d365ff072dfd6ae$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $6d365ff072dfd6ae$var$bh(a, b);
                $6d365ff072dfd6ae$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $6d365ff072dfd6ae$var$Ki(Error($6d365ff072dfd6ae$var$p(423)), b);
                        b = $6d365ff072dfd6ae$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $6d365ff072dfd6ae$var$Ki(Error($6d365ff072dfd6ae$var$p(424)), b);
                        b = $6d365ff072dfd6ae$var$mj(a, b, d, c, e);
                        break a;
                    } else for($6d365ff072dfd6ae$var$yg = $6d365ff072dfd6ae$var$Lf(b.stateNode.containerInfo.firstChild), $6d365ff072dfd6ae$var$xg = b, $6d365ff072dfd6ae$var$I = !0, $6d365ff072dfd6ae$var$zg = null, c = $6d365ff072dfd6ae$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $6d365ff072dfd6ae$var$Ig();
                    if (d === e) {
                        b = $6d365ff072dfd6ae$var$$i(a, b, c);
                        break a;
                    }
                    $6d365ff072dfd6ae$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $6d365ff072dfd6ae$var$Kh(b), null === a && $6d365ff072dfd6ae$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $6d365ff072dfd6ae$var$Ef(d, e) ? g = null : null !== f && $6d365ff072dfd6ae$var$Ef(d, f) && (b.flags |= 32), $6d365ff072dfd6ae$var$hj(a, b), $6d365ff072dfd6ae$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $6d365ff072dfd6ae$var$Eg(b), null;
        case 13:
            return $6d365ff072dfd6ae$var$pj(a, b, c);
        case 4:
            return $6d365ff072dfd6ae$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $6d365ff072dfd6ae$var$Bh(b, null, d, c) : $6d365ff072dfd6ae$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $6d365ff072dfd6ae$var$Lg(d, e), $6d365ff072dfd6ae$var$Zi(a, b, d, e, c);
        case 7:
            return $6d365ff072dfd6ae$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $6d365ff072dfd6ae$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $6d365ff072dfd6ae$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $6d365ff072dfd6ae$var$G($6d365ff072dfd6ae$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($6d365ff072dfd6ae$var$He(f.value, g)) {
                        if (f.children === e.children && !$6d365ff072dfd6ae$var$Wf.current) {
                            b = $6d365ff072dfd6ae$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $6d365ff072dfd6ae$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $6d365ff072dfd6ae$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($6d365ff072dfd6ae$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $6d365ff072dfd6ae$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $6d365ff072dfd6ae$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $6d365ff072dfd6ae$var$Tg(b, c), e = $6d365ff072dfd6ae$var$Vg(e), d = d(e), b.flags |= 1, $6d365ff072dfd6ae$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $6d365ff072dfd6ae$var$Lg(d, b.pendingProps), e = $6d365ff072dfd6ae$var$Lg(d.type, e), $6d365ff072dfd6ae$var$aj(a, b, d, e, c);
        case 15:
            return $6d365ff072dfd6ae$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $6d365ff072dfd6ae$var$Lg(d, e), $6d365ff072dfd6ae$var$jj(a, b), b.tag = 1, $6d365ff072dfd6ae$var$Zf(d) ? (a = !0, $6d365ff072dfd6ae$var$cg(b)) : a = !1, $6d365ff072dfd6ae$var$Tg(b, c), $6d365ff072dfd6ae$var$ph(b, d, e), $6d365ff072dfd6ae$var$rh(b, d, e, c), $6d365ff072dfd6ae$var$kj(null, b, d, !0, a, c);
        case 19:
            return $6d365ff072dfd6ae$var$yj(a, b, c);
        case 22:
            return $6d365ff072dfd6ae$var$ej(a, b, c);
    }
    throw Error($6d365ff072dfd6ae$var$p(156, b.tag));
};
function $6d365ff072dfd6ae$var$Gk(a, b) {
    return $6d365ff072dfd6ae$var$ac(a, b);
}
function $6d365ff072dfd6ae$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $6d365ff072dfd6ae$var$Bg(a, b, c, d) {
    return new $6d365ff072dfd6ae$var$al(a, b, c, d);
}
function $6d365ff072dfd6ae$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $6d365ff072dfd6ae$var$$k(a) {
    if ("function" === typeof a) return $6d365ff072dfd6ae$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $6d365ff072dfd6ae$var$Da) return 11;
        if (a === $6d365ff072dfd6ae$var$Ga) return 14;
    }
    return 2;
}
function $6d365ff072dfd6ae$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $6d365ff072dfd6ae$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $6d365ff072dfd6ae$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $6d365ff072dfd6ae$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $6d365ff072dfd6ae$var$ya:
            return $6d365ff072dfd6ae$var$Ah(c.children, e, f, b);
        case $6d365ff072dfd6ae$var$za:
            g = 8;
            e |= 8;
            break;
        case $6d365ff072dfd6ae$var$Aa:
            return a = $6d365ff072dfd6ae$var$Bg(12, c, b, e | 2), a.elementType = $6d365ff072dfd6ae$var$Aa, a.lanes = f, a;
        case $6d365ff072dfd6ae$var$Ea:
            return a = $6d365ff072dfd6ae$var$Bg(13, c, b, e), a.elementType = $6d365ff072dfd6ae$var$Ea, a.lanes = f, a;
        case $6d365ff072dfd6ae$var$Fa:
            return a = $6d365ff072dfd6ae$var$Bg(19, c, b, e), a.elementType = $6d365ff072dfd6ae$var$Fa, a.lanes = f, a;
        case $6d365ff072dfd6ae$var$Ia:
            return $6d365ff072dfd6ae$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $6d365ff072dfd6ae$var$Ba:
                    g = 10;
                    break a;
                case $6d365ff072dfd6ae$var$Ca:
                    g = 9;
                    break a;
                case $6d365ff072dfd6ae$var$Da:
                    g = 11;
                    break a;
                case $6d365ff072dfd6ae$var$Ga:
                    g = 14;
                    break a;
                case $6d365ff072dfd6ae$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($6d365ff072dfd6ae$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $6d365ff072dfd6ae$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $6d365ff072dfd6ae$var$Ah(a, b, c, d) {
    a = $6d365ff072dfd6ae$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $6d365ff072dfd6ae$var$qj(a, b, c, d) {
    a = $6d365ff072dfd6ae$var$Bg(22, a, d, b);
    a.elementType = $6d365ff072dfd6ae$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $6d365ff072dfd6ae$var$xh(a, b, c) {
    a = $6d365ff072dfd6ae$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $6d365ff072dfd6ae$var$zh(a, b, c) {
    b = $6d365ff072dfd6ae$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $6d365ff072dfd6ae$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $6d365ff072dfd6ae$var$zc(0);
    this.expirationTimes = $6d365ff072dfd6ae$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $6d365ff072dfd6ae$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $6d365ff072dfd6ae$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $6d365ff072dfd6ae$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $6d365ff072dfd6ae$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $6d365ff072dfd6ae$var$ah(f);
    return a;
}
function $6d365ff072dfd6ae$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $6d365ff072dfd6ae$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $6d365ff072dfd6ae$var$el(a) {
    if (!a) return $6d365ff072dfd6ae$var$Vf;
    a = a._reactInternals;
    a: {
        if ($6d365ff072dfd6ae$var$Vb(a) !== a || 1 !== a.tag) throw Error($6d365ff072dfd6ae$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($6d365ff072dfd6ae$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($6d365ff072dfd6ae$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($6d365ff072dfd6ae$var$Zf(c)) return $6d365ff072dfd6ae$var$bg(a, c, b);
    }
    return b;
}
function $6d365ff072dfd6ae$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $6d365ff072dfd6ae$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $6d365ff072dfd6ae$var$el(null);
    c = a.current;
    d = $6d365ff072dfd6ae$var$L();
    e = $6d365ff072dfd6ae$var$lh(c);
    f = $6d365ff072dfd6ae$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $6d365ff072dfd6ae$var$dh(c, f, e);
    a.current.lanes = e;
    $6d365ff072dfd6ae$var$Ac(a, e, d);
    $6d365ff072dfd6ae$var$Ek(a, d);
    return a;
}
function $6d365ff072dfd6ae$var$gl(a, b, c, d) {
    var e = b.current, f = $6d365ff072dfd6ae$var$L(), g = $6d365ff072dfd6ae$var$lh(e);
    c = $6d365ff072dfd6ae$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $6d365ff072dfd6ae$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $6d365ff072dfd6ae$var$dh(e, b, g);
    null !== a && ($6d365ff072dfd6ae$var$mh(a, e, g, f), $6d365ff072dfd6ae$var$eh(a, e, g));
    return g;
}
function $6d365ff072dfd6ae$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $6d365ff072dfd6ae$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $6d365ff072dfd6ae$var$jl(a, b) {
    $6d365ff072dfd6ae$var$il(a, b);
    (a = a.alternate) && $6d365ff072dfd6ae$var$il(a, b);
}
function $6d365ff072dfd6ae$var$kl() {
    return null;
}
var $6d365ff072dfd6ae$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $6d365ff072dfd6ae$var$ml(a) {
    this._internalRoot = a;
}
$6d365ff072dfd6ae$var$nl.prototype.render = $6d365ff072dfd6ae$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($6d365ff072dfd6ae$var$p(409));
    $6d365ff072dfd6ae$var$gl(a, b, null, null);
};
$6d365ff072dfd6ae$var$nl.prototype.unmount = $6d365ff072dfd6ae$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $6d365ff072dfd6ae$var$Sk(function() {
            $6d365ff072dfd6ae$var$gl(null, a, null, null);
        });
        b[$6d365ff072dfd6ae$var$uf] = null;
    }
};
function $6d365ff072dfd6ae$var$nl(a) {
    this._internalRoot = a;
}
$6d365ff072dfd6ae$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $6d365ff072dfd6ae$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $6d365ff072dfd6ae$var$Qc.length && 0 !== b && b < $6d365ff072dfd6ae$var$Qc[c].priority; c++);
        $6d365ff072dfd6ae$var$Qc.splice(c, 0, a);
        0 === c && $6d365ff072dfd6ae$var$Vc(a);
    }
};
function $6d365ff072dfd6ae$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $6d365ff072dfd6ae$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $6d365ff072dfd6ae$var$ql() {}
function $6d365ff072dfd6ae$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $6d365ff072dfd6ae$var$hl(g);
                f.call(a);
            };
        }
        var g = $6d365ff072dfd6ae$var$fl(b, d, a, 0, null, !1, !1, "", $6d365ff072dfd6ae$var$ql);
        a._reactRootContainer = g;
        a[$6d365ff072dfd6ae$var$uf] = g.current;
        $6d365ff072dfd6ae$var$sf(8 === a.nodeType ? a.parentNode : a);
        $6d365ff072dfd6ae$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $6d365ff072dfd6ae$var$hl(k);
            h.call(a);
        };
    }
    var k = $6d365ff072dfd6ae$var$cl(a, 0, !1, null, null, !1, !1, "", $6d365ff072dfd6ae$var$ql);
    a._reactRootContainer = k;
    a[$6d365ff072dfd6ae$var$uf] = k.current;
    $6d365ff072dfd6ae$var$sf(8 === a.nodeType ? a.parentNode : a);
    $6d365ff072dfd6ae$var$Sk(function() {
        $6d365ff072dfd6ae$var$gl(b, k, c, d);
    });
    return k;
}
function $6d365ff072dfd6ae$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $6d365ff072dfd6ae$var$hl(g);
                h.call(a);
            };
        }
        $6d365ff072dfd6ae$var$gl(b, g, a, e);
    } else g = $6d365ff072dfd6ae$var$rl(c, b, a, e, d);
    return $6d365ff072dfd6ae$var$hl(g);
}
$6d365ff072dfd6ae$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $6d365ff072dfd6ae$var$tc(b.pendingLanes);
                0 !== c && ($6d365ff072dfd6ae$var$Cc(b, c | 1), $6d365ff072dfd6ae$var$Ek(b, $6d365ff072dfd6ae$var$B()), 0 === ($6d365ff072dfd6ae$var$K & 6) && ($6d365ff072dfd6ae$var$Hj = $6d365ff072dfd6ae$var$B() + 500, $6d365ff072dfd6ae$var$jg()));
            }
            break;
        case 13:
            $6d365ff072dfd6ae$var$Sk(function() {
                var b = $6d365ff072dfd6ae$var$Zg(a, 1);
                if (null !== b) {
                    var c = $6d365ff072dfd6ae$var$L();
                    $6d365ff072dfd6ae$var$mh(b, a, 1, c);
                }
            }), $6d365ff072dfd6ae$var$jl(a, 1);
    }
};
$6d365ff072dfd6ae$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $6d365ff072dfd6ae$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $6d365ff072dfd6ae$var$L();
            $6d365ff072dfd6ae$var$mh(b, a, 134217728, c);
        }
        $6d365ff072dfd6ae$var$jl(a, 134217728);
    }
};
$6d365ff072dfd6ae$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $6d365ff072dfd6ae$var$lh(a), c = $6d365ff072dfd6ae$var$Zg(a, b);
        if (null !== c) {
            var d = $6d365ff072dfd6ae$var$L();
            $6d365ff072dfd6ae$var$mh(c, a, b, d);
        }
        $6d365ff072dfd6ae$var$jl(a, b);
    }
};
$6d365ff072dfd6ae$var$Hc = function() {
    return $6d365ff072dfd6ae$var$C;
};
$6d365ff072dfd6ae$var$Ic = function(a, b) {
    var c = $6d365ff072dfd6ae$var$C;
    try {
        return $6d365ff072dfd6ae$var$C = a, b();
    } finally{
        $6d365ff072dfd6ae$var$C = c;
    }
};
$6d365ff072dfd6ae$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $6d365ff072dfd6ae$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $6d365ff072dfd6ae$var$Db(d);
                        if (!e) throw Error($6d365ff072dfd6ae$var$p(90));
                        $6d365ff072dfd6ae$var$Wa(d);
                        $6d365ff072dfd6ae$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $6d365ff072dfd6ae$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $6d365ff072dfd6ae$var$fb(a, !!c.multiple, b, !1);
    }
};
$6d365ff072dfd6ae$var$Gb = $6d365ff072dfd6ae$var$Rk;
$6d365ff072dfd6ae$var$Hb = $6d365ff072dfd6ae$var$Sk;
var $6d365ff072dfd6ae$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $6d365ff072dfd6ae$var$Cb,
        $6d365ff072dfd6ae$var$ue,
        $6d365ff072dfd6ae$var$Db,
        $6d365ff072dfd6ae$var$Eb,
        $6d365ff072dfd6ae$var$Fb,
        $6d365ff072dfd6ae$var$Rk
    ]
}, $6d365ff072dfd6ae$var$ul = {
    findFiberByHostInstance: $6d365ff072dfd6ae$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $6d365ff072dfd6ae$var$vl = {
    bundleType: $6d365ff072dfd6ae$var$ul.bundleType,
    version: $6d365ff072dfd6ae$var$ul.version,
    rendererPackageName: $6d365ff072dfd6ae$var$ul.rendererPackageName,
    rendererConfig: $6d365ff072dfd6ae$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $6d365ff072dfd6ae$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $6d365ff072dfd6ae$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $6d365ff072dfd6ae$var$ul.findFiberByHostInstance || $6d365ff072dfd6ae$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $6d365ff072dfd6ae$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$6d365ff072dfd6ae$var$wl.isDisabled && $6d365ff072dfd6ae$var$wl.supportsFiber) try {
        $6d365ff072dfd6ae$var$kc = $6d365ff072dfd6ae$var$wl.inject($6d365ff072dfd6ae$var$vl), $6d365ff072dfd6ae$var$lc = $6d365ff072dfd6ae$var$wl;
    } catch (a) {}
}
$6d365ff072dfd6ae$export$ae55be85d98224ed = $6d365ff072dfd6ae$var$tl;
$6d365ff072dfd6ae$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$6d365ff072dfd6ae$var$ol(b)) throw Error($6d365ff072dfd6ae$var$p(200));
    return $6d365ff072dfd6ae$var$dl(a, b, null, c);
};
$6d365ff072dfd6ae$export$882461b6382ed46c = function(a, b) {
    if (!$6d365ff072dfd6ae$var$ol(a)) throw Error($6d365ff072dfd6ae$var$p(299));
    var c = !1, d = "", e = $6d365ff072dfd6ae$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $6d365ff072dfd6ae$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$6d365ff072dfd6ae$var$uf] = b.current;
    $6d365ff072dfd6ae$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $6d365ff072dfd6ae$var$ml(b);
};
$6d365ff072dfd6ae$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($6d365ff072dfd6ae$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($6d365ff072dfd6ae$var$p(268, a));
    }
    a = $6d365ff072dfd6ae$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$6d365ff072dfd6ae$export$cd75ccfd720a3cd4 = function(a) {
    return $6d365ff072dfd6ae$var$Sk(a);
};
$6d365ff072dfd6ae$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$6d365ff072dfd6ae$var$pl(b)) throw Error($6d365ff072dfd6ae$var$p(200));
    return $6d365ff072dfd6ae$var$sl(null, a, b, !0, c);
};
$6d365ff072dfd6ae$export$757ceba2d55c277e = function(a, b, c) {
    if (!$6d365ff072dfd6ae$var$ol(a)) throw Error($6d365ff072dfd6ae$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $6d365ff072dfd6ae$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $6d365ff072dfd6ae$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$6d365ff072dfd6ae$var$uf] = b.current;
    $6d365ff072dfd6ae$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $6d365ff072dfd6ae$var$nl(b);
};
$6d365ff072dfd6ae$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$6d365ff072dfd6ae$var$pl(b)) throw Error($6d365ff072dfd6ae$var$p(200));
    return $6d365ff072dfd6ae$var$sl(null, a, b, !1, c);
};
$6d365ff072dfd6ae$export$502457920280e6be = function(a) {
    if (!$6d365ff072dfd6ae$var$pl(a)) throw Error($6d365ff072dfd6ae$var$p(40));
    return a._reactRootContainer ? ($6d365ff072dfd6ae$var$Sk(function() {
        $6d365ff072dfd6ae$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$6d365ff072dfd6ae$var$uf] = null;
        });
    }), !0) : !1;
};
$6d365ff072dfd6ae$export$c78a37762a8d58e1 = $6d365ff072dfd6ae$var$Rk;
$6d365ff072dfd6ae$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$6d365ff072dfd6ae$var$pl(c)) throw Error($6d365ff072dfd6ae$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($6d365ff072dfd6ae$var$p(38));
    return $6d365ff072dfd6ae$var$sl(a, b, c, !1, d);
};
$6d365ff072dfd6ae$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("jNpn7", function(module, exports) {
"use strict";

module.exports = (parcelRequire("3euQH"));

});
parcelRequire.register("3euQH", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $25aa9bdfb681a381$export$c4744153514ff05d, (v) => $25aa9bdfb681a381$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $25aa9bdfb681a381$export$3e506c1ccc9cc1a7, (v) => $25aa9bdfb681a381$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $25aa9bdfb681a381$export$e26fe2ed2fa76875, (v) => $25aa9bdfb681a381$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $25aa9bdfb681a381$export$502329bbf4b505b1, (v) => $25aa9bdfb681a381$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $25aa9bdfb681a381$export$6e3807111c4874c4, (v) => $25aa9bdfb681a381$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $25aa9bdfb681a381$export$c27134553091fb3a, (v) => $25aa9bdfb681a381$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $25aa9bdfb681a381$export$33ee1acdc04fd2a2, (v) => $25aa9bdfb681a381$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $25aa9bdfb681a381$export$b00a404bbd5edef2, (v) => $25aa9bdfb681a381$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $25aa9bdfb681a381$export$8352ce38b91d0c62, (v) => $25aa9bdfb681a381$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $25aa9bdfb681a381$export$d66a1c1c77bd778b, (v) => $25aa9bdfb681a381$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $25aa9bdfb681a381$export$d3dfb8e4810cb555, (v) => $25aa9bdfb681a381$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $25aa9bdfb681a381$export$839f9183b0465a69, (v) => $25aa9bdfb681a381$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $25aa9bdfb681a381$export$72fdf0e06517287b, (v) => $25aa9bdfb681a381$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $25aa9bdfb681a381$export$4b844e58a3e414b4, (v) => $25aa9bdfb681a381$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $25aa9bdfb681a381$export$816d2913ae6b83b1, (v) => $25aa9bdfb681a381$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $25aa9bdfb681a381$export$61bcfe829111a1d0, (v) => $25aa9bdfb681a381$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $25aa9bdfb681a381$export$7ee8c9beb337bc3f, (v) => $25aa9bdfb681a381$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $25aa9bdfb681a381$export$b5836b71941fa3ed, (v) => $25aa9bdfb681a381$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $25aa9bdfb681a381$export$cf845f2c119da08a, (v) => $25aa9bdfb681a381$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $25aa9bdfb681a381$export$c4744153514ff05d;
var $25aa9bdfb681a381$export$3e506c1ccc9cc1a7;
var $25aa9bdfb681a381$export$e26fe2ed2fa76875;
var $25aa9bdfb681a381$export$502329bbf4b505b1;
var $25aa9bdfb681a381$export$6e3807111c4874c4;
var $25aa9bdfb681a381$export$c27134553091fb3a;
var $25aa9bdfb681a381$export$33ee1acdc04fd2a2;
var $25aa9bdfb681a381$export$b00a404bbd5edef2;
var $25aa9bdfb681a381$export$8352ce38b91d0c62;
var $25aa9bdfb681a381$export$d66a1c1c77bd778b;
var $25aa9bdfb681a381$export$d3dfb8e4810cb555;
var $25aa9bdfb681a381$export$839f9183b0465a69;
var $25aa9bdfb681a381$export$72fdf0e06517287b;
var $25aa9bdfb681a381$export$4b844e58a3e414b4;
var $25aa9bdfb681a381$export$816d2913ae6b83b1;
var $25aa9bdfb681a381$export$61bcfe829111a1d0;
var $25aa9bdfb681a381$export$7ee8c9beb337bc3f;
var $25aa9bdfb681a381$export$b5836b71941fa3ed;
var $25aa9bdfb681a381$export$cf845f2c119da08a;
"use strict";
function $25aa9bdfb681a381$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $25aa9bdfb681a381$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $25aa9bdfb681a381$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $25aa9bdfb681a381$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $25aa9bdfb681a381$var$g(C, c)) n < e && 0 > $25aa9bdfb681a381$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $25aa9bdfb681a381$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $25aa9bdfb681a381$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $25aa9bdfb681a381$var$l = performance;
    $25aa9bdfb681a381$export$c4744153514ff05d = function() {
        return $25aa9bdfb681a381$var$l.now();
    };
} else {
    var $25aa9bdfb681a381$var$p = Date, $25aa9bdfb681a381$var$q = $25aa9bdfb681a381$var$p.now();
    $25aa9bdfb681a381$export$c4744153514ff05d = function() {
        return $25aa9bdfb681a381$var$p.now() - $25aa9bdfb681a381$var$q;
    };
}
var $25aa9bdfb681a381$var$r = [], $25aa9bdfb681a381$var$t = [], $25aa9bdfb681a381$var$u = 1, $25aa9bdfb681a381$var$v = null, $25aa9bdfb681a381$var$y = 3, $25aa9bdfb681a381$var$z = !1, $25aa9bdfb681a381$var$A = !1, $25aa9bdfb681a381$var$B = !1, $25aa9bdfb681a381$var$D = "function" === typeof setTimeout ? setTimeout : null, $25aa9bdfb681a381$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $25aa9bdfb681a381$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $25aa9bdfb681a381$var$G(a) {
    for(var b = $25aa9bdfb681a381$var$h($25aa9bdfb681a381$var$t); null !== b;){
        if (null === b.callback) $25aa9bdfb681a381$var$k($25aa9bdfb681a381$var$t);
        else if (b.startTime <= a) $25aa9bdfb681a381$var$k($25aa9bdfb681a381$var$t), b.sortIndex = b.expirationTime, $25aa9bdfb681a381$var$f($25aa9bdfb681a381$var$r, b);
        else break;
        b = $25aa9bdfb681a381$var$h($25aa9bdfb681a381$var$t);
    }
}
function $25aa9bdfb681a381$var$H(a) {
    $25aa9bdfb681a381$var$B = !1;
    $25aa9bdfb681a381$var$G(a);
    if (!$25aa9bdfb681a381$var$A) {
        if (null !== $25aa9bdfb681a381$var$h($25aa9bdfb681a381$var$r)) $25aa9bdfb681a381$var$A = !0, $25aa9bdfb681a381$var$I($25aa9bdfb681a381$var$J);
        else {
            var b = $25aa9bdfb681a381$var$h($25aa9bdfb681a381$var$t);
            null !== b && $25aa9bdfb681a381$var$K($25aa9bdfb681a381$var$H, b.startTime - a);
        }
    }
}
function $25aa9bdfb681a381$var$J(a, b) {
    $25aa9bdfb681a381$var$A = !1;
    $25aa9bdfb681a381$var$B && ($25aa9bdfb681a381$var$B = !1, $25aa9bdfb681a381$var$E($25aa9bdfb681a381$var$L), $25aa9bdfb681a381$var$L = -1);
    $25aa9bdfb681a381$var$z = !0;
    var c = $25aa9bdfb681a381$var$y;
    try {
        $25aa9bdfb681a381$var$G(b);
        for($25aa9bdfb681a381$var$v = $25aa9bdfb681a381$var$h($25aa9bdfb681a381$var$r); null !== $25aa9bdfb681a381$var$v && (!($25aa9bdfb681a381$var$v.expirationTime > b) || a && !$25aa9bdfb681a381$var$M());){
            var d = $25aa9bdfb681a381$var$v.callback;
            if ("function" === typeof d) {
                $25aa9bdfb681a381$var$v.callback = null;
                $25aa9bdfb681a381$var$y = $25aa9bdfb681a381$var$v.priorityLevel;
                var e = d($25aa9bdfb681a381$var$v.expirationTime <= b);
                b = $25aa9bdfb681a381$export$c4744153514ff05d();
                "function" === typeof e ? $25aa9bdfb681a381$var$v.callback = e : $25aa9bdfb681a381$var$v === $25aa9bdfb681a381$var$h($25aa9bdfb681a381$var$r) && $25aa9bdfb681a381$var$k($25aa9bdfb681a381$var$r);
                $25aa9bdfb681a381$var$G(b);
            } else $25aa9bdfb681a381$var$k($25aa9bdfb681a381$var$r);
            $25aa9bdfb681a381$var$v = $25aa9bdfb681a381$var$h($25aa9bdfb681a381$var$r);
        }
        if (null !== $25aa9bdfb681a381$var$v) var w = !0;
        else {
            var m = $25aa9bdfb681a381$var$h($25aa9bdfb681a381$var$t);
            null !== m && $25aa9bdfb681a381$var$K($25aa9bdfb681a381$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $25aa9bdfb681a381$var$v = null, $25aa9bdfb681a381$var$y = c, $25aa9bdfb681a381$var$z = !1;
    }
}
var $25aa9bdfb681a381$var$N = !1, $25aa9bdfb681a381$var$O = null, $25aa9bdfb681a381$var$L = -1, $25aa9bdfb681a381$var$P = 5, $25aa9bdfb681a381$var$Q = -1;
function $25aa9bdfb681a381$var$M() {
    return $25aa9bdfb681a381$export$c4744153514ff05d() - $25aa9bdfb681a381$var$Q < $25aa9bdfb681a381$var$P ? !1 : !0;
}
function $25aa9bdfb681a381$var$R() {
    if (null !== $25aa9bdfb681a381$var$O) {
        var a = $25aa9bdfb681a381$export$c4744153514ff05d();
        $25aa9bdfb681a381$var$Q = a;
        var b = !0;
        try {
            b = $25aa9bdfb681a381$var$O(!0, a);
        } finally{
            b ? $25aa9bdfb681a381$var$S() : ($25aa9bdfb681a381$var$N = !1, $25aa9bdfb681a381$var$O = null);
        }
    } else $25aa9bdfb681a381$var$N = !1;
}
var $25aa9bdfb681a381$var$S;
if ("function" === typeof $25aa9bdfb681a381$var$F) $25aa9bdfb681a381$var$S = function() {
    $25aa9bdfb681a381$var$F($25aa9bdfb681a381$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $25aa9bdfb681a381$var$T = new MessageChannel, $25aa9bdfb681a381$var$U = $25aa9bdfb681a381$var$T.port2;
    $25aa9bdfb681a381$var$T.port1.onmessage = $25aa9bdfb681a381$var$R;
    $25aa9bdfb681a381$var$S = function() {
        $25aa9bdfb681a381$var$U.postMessage(null);
    };
} else $25aa9bdfb681a381$var$S = function() {
    $25aa9bdfb681a381$var$D($25aa9bdfb681a381$var$R, 0);
};
function $25aa9bdfb681a381$var$I(a) {
    $25aa9bdfb681a381$var$O = a;
    $25aa9bdfb681a381$var$N || ($25aa9bdfb681a381$var$N = !0, $25aa9bdfb681a381$var$S());
}
function $25aa9bdfb681a381$var$K(a, b) {
    $25aa9bdfb681a381$var$L = $25aa9bdfb681a381$var$D(function() {
        a($25aa9bdfb681a381$export$c4744153514ff05d());
    }, b);
}
$25aa9bdfb681a381$export$3e506c1ccc9cc1a7 = 5;
$25aa9bdfb681a381$export$e26fe2ed2fa76875 = 1;
$25aa9bdfb681a381$export$502329bbf4b505b1 = 4;
$25aa9bdfb681a381$export$6e3807111c4874c4 = 3;
$25aa9bdfb681a381$export$c27134553091fb3a = null;
$25aa9bdfb681a381$export$33ee1acdc04fd2a2 = 2;
$25aa9bdfb681a381$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$25aa9bdfb681a381$export$8352ce38b91d0c62 = function() {
    $25aa9bdfb681a381$var$A || $25aa9bdfb681a381$var$z || ($25aa9bdfb681a381$var$A = !0, $25aa9bdfb681a381$var$I($25aa9bdfb681a381$var$J));
};
$25aa9bdfb681a381$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $25aa9bdfb681a381$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$25aa9bdfb681a381$export$d3dfb8e4810cb555 = function() {
    return $25aa9bdfb681a381$var$y;
};
$25aa9bdfb681a381$export$839f9183b0465a69 = function() {
    return $25aa9bdfb681a381$var$h($25aa9bdfb681a381$var$r);
};
$25aa9bdfb681a381$export$72fdf0e06517287b = function(a) {
    switch($25aa9bdfb681a381$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $25aa9bdfb681a381$var$y;
    }
    var c = $25aa9bdfb681a381$var$y;
    $25aa9bdfb681a381$var$y = b;
    try {
        return a();
    } finally{
        $25aa9bdfb681a381$var$y = c;
    }
};
$25aa9bdfb681a381$export$4b844e58a3e414b4 = function() {};
$25aa9bdfb681a381$export$816d2913ae6b83b1 = function() {};
$25aa9bdfb681a381$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $25aa9bdfb681a381$var$y;
    $25aa9bdfb681a381$var$y = a;
    try {
        return b();
    } finally{
        $25aa9bdfb681a381$var$y = c;
    }
};
$25aa9bdfb681a381$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $25aa9bdfb681a381$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $25aa9bdfb681a381$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $25aa9bdfb681a381$var$f($25aa9bdfb681a381$var$t, a), null === $25aa9bdfb681a381$var$h($25aa9bdfb681a381$var$r) && a === $25aa9bdfb681a381$var$h($25aa9bdfb681a381$var$t) && ($25aa9bdfb681a381$var$B ? ($25aa9bdfb681a381$var$E($25aa9bdfb681a381$var$L), $25aa9bdfb681a381$var$L = -1) : $25aa9bdfb681a381$var$B = !0, $25aa9bdfb681a381$var$K($25aa9bdfb681a381$var$H, c - d))) : (a.sortIndex = e, $25aa9bdfb681a381$var$f($25aa9bdfb681a381$var$r, a), $25aa9bdfb681a381$var$A || $25aa9bdfb681a381$var$z || ($25aa9bdfb681a381$var$A = !0, $25aa9bdfb681a381$var$I($25aa9bdfb681a381$var$J)));
    return a;
};
$25aa9bdfb681a381$export$b5836b71941fa3ed = $25aa9bdfb681a381$var$M;
$25aa9bdfb681a381$export$cf845f2c119da08a = function(a) {
    var b = $25aa9bdfb681a381$var$y;
    return function() {
        var c = $25aa9bdfb681a381$var$y;
        $25aa9bdfb681a381$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $25aa9bdfb681a381$var$y = c;
        }
    };
};

});



parcelRequire.register("dkyoU", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $9b47d3e3f859fb88$export$2b8d127b894957b9, (v) => $9b47d3e3f859fb88$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $9b47d3e3f859fb88$export$cea3a54a6425200c, (v) => $9b47d3e3f859fb88$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $9b47d3e3f859fb88$export$a7c73072b1a182ae, (v) => $9b47d3e3f859fb88$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $9b47d3e3f859fb88$export$9f27bc3417b4524d, (v) => $9b47d3e3f859fb88$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $9b47d3e3f859fb88$export$db77ccec0bb4ccac, (v) => $9b47d3e3f859fb88$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $9b47d3e3f859fb88$export$8392c0c9d3dcbd35, (v) => $9b47d3e3f859fb88$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $9b47d3e3f859fb88$export$ffb0004e005737fa, (v) => $9b47d3e3f859fb88$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $9b47d3e3f859fb88$export$b624eff549462981, (v) => $9b47d3e3f859fb88$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $9b47d3e3f859fb88$export$7897aa7841a5380c, (v) => $9b47d3e3f859fb88$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $9b47d3e3f859fb88$export$602eac185826482c, (v) => $9b47d3e3f859fb88$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $9b47d3e3f859fb88$export$e2c29f18771995cb, (v) => $9b47d3e3f859fb88$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $9b47d3e3f859fb88$export$5f8d39834fd61797, (v) => $9b47d3e3f859fb88$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $9b47d3e3f859fb88$export$74bf444e3cd11ea5, (v) => $9b47d3e3f859fb88$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $9b47d3e3f859fb88$export$92387174baf9b227, (v) => $9b47d3e3f859fb88$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $9b47d3e3f859fb88$export$ec112efeb987d9c6, (v) => $9b47d3e3f859fb88$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $9b47d3e3f859fb88$export$b706b080d889d2c9, (v) => $9b47d3e3f859fb88$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $9b47d3e3f859fb88$export$5be5a87408f70ddc, (v) => $9b47d3e3f859fb88$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $9b47d3e3f859fb88$export$45a5e7f76e0caa8d, (v) => $9b47d3e3f859fb88$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $9b47d3e3f859fb88$export$455c2e768291efa6, (v) => $9b47d3e3f859fb88$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $9b47d3e3f859fb88$export$9522e17588c12572, (v) => $9b47d3e3f859fb88$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $9b47d3e3f859fb88$export$2110ac352bb060b9, (v) => $9b47d3e3f859fb88$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $9b47d3e3f859fb88$export$56885ab8b9c456ab, (v) => $9b47d3e3f859fb88$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $9b47d3e3f859fb88$export$d927fcb6adf8f9de, (v) => $9b47d3e3f859fb88$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $9b47d3e3f859fb88$export$b82d16f27459e05a, (v) => $9b47d3e3f859fb88$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $9b47d3e3f859fb88$export$522c17b4f5e123e8, (v) => $9b47d3e3f859fb88$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $9b47d3e3f859fb88$export$1aabd8a0274ecfd6, (v) => $9b47d3e3f859fb88$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $9b47d3e3f859fb88$export$9b621391a187a31a, (v) => $9b47d3e3f859fb88$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $9b47d3e3f859fb88$export$f5bbd400c2f4426f, (v) => $9b47d3e3f859fb88$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9b47d3e3f859fb88$export$2b8d127b894957b9;
var $9b47d3e3f859fb88$export$cea3a54a6425200c;
var $9b47d3e3f859fb88$export$a7c73072b1a182ae;
var $9b47d3e3f859fb88$export$9f27bc3417b4524d;
var $9b47d3e3f859fb88$export$db77ccec0bb4ccac;
var $9b47d3e3f859fb88$export$8392c0c9d3dcbd35;
var $9b47d3e3f859fb88$export$ffb0004e005737fa;
var $9b47d3e3f859fb88$export$b624eff549462981;
var $9b47d3e3f859fb88$export$7897aa7841a5380c;
var $9b47d3e3f859fb88$export$602eac185826482c;
var $9b47d3e3f859fb88$export$e2c29f18771995cb;
var $9b47d3e3f859fb88$export$5f8d39834fd61797;
var $9b47d3e3f859fb88$export$74bf444e3cd11ea5;
var $9b47d3e3f859fb88$export$92387174baf9b227;
var $9b47d3e3f859fb88$export$ec112efeb987d9c6;
var $9b47d3e3f859fb88$export$b706b080d889d2c9;
var $9b47d3e3f859fb88$export$5be5a87408f70ddc;
var $9b47d3e3f859fb88$export$45a5e7f76e0caa8d;
var $9b47d3e3f859fb88$export$455c2e768291efa6;
var $9b47d3e3f859fb88$export$9522e17588c12572;
var $9b47d3e3f859fb88$export$2110ac352bb060b9;
var $9b47d3e3f859fb88$export$56885ab8b9c456ab;
var $9b47d3e3f859fb88$export$d927fcb6adf8f9de;
var $9b47d3e3f859fb88$export$b82d16f27459e05a;
var $9b47d3e3f859fb88$export$522c17b4f5e123e8;
var $9b47d3e3f859fb88$export$1aabd8a0274ecfd6;
var $9b47d3e3f859fb88$export$9b621391a187a31a;
var $9b47d3e3f859fb88$export$f5bbd400c2f4426f;
"use strict";
var $9b47d3e3f859fb88$var$b = "function" === typeof Symbol && Symbol.for, $9b47d3e3f859fb88$var$c = $9b47d3e3f859fb88$var$b ? Symbol.for("react.element") : 60103, $9b47d3e3f859fb88$var$d = $9b47d3e3f859fb88$var$b ? Symbol.for("react.portal") : 60106, $9b47d3e3f859fb88$var$e = $9b47d3e3f859fb88$var$b ? Symbol.for("react.fragment") : 60107, $9b47d3e3f859fb88$var$f = $9b47d3e3f859fb88$var$b ? Symbol.for("react.strict_mode") : 60108, $9b47d3e3f859fb88$var$g = $9b47d3e3f859fb88$var$b ? Symbol.for("react.profiler") : 60114, $9b47d3e3f859fb88$var$h = $9b47d3e3f859fb88$var$b ? Symbol.for("react.provider") : 60109, $9b47d3e3f859fb88$var$k = $9b47d3e3f859fb88$var$b ? Symbol.for("react.context") : 60110, $9b47d3e3f859fb88$var$l = $9b47d3e3f859fb88$var$b ? Symbol.for("react.async_mode") : 60111, $9b47d3e3f859fb88$var$m = $9b47d3e3f859fb88$var$b ? Symbol.for("react.concurrent_mode") : 60111, $9b47d3e3f859fb88$var$n = $9b47d3e3f859fb88$var$b ? Symbol.for("react.forward_ref") : 60112, $9b47d3e3f859fb88$var$p = $9b47d3e3f859fb88$var$b ? Symbol.for("react.suspense") : 60113, $9b47d3e3f859fb88$var$q = $9b47d3e3f859fb88$var$b ? Symbol.for("react.suspense_list") : 60120, $9b47d3e3f859fb88$var$r = $9b47d3e3f859fb88$var$b ? Symbol.for("react.memo") : 60115, $9b47d3e3f859fb88$var$t = $9b47d3e3f859fb88$var$b ? Symbol.for("react.lazy") : 60116, $9b47d3e3f859fb88$var$v = $9b47d3e3f859fb88$var$b ? Symbol.for("react.block") : 60121, $9b47d3e3f859fb88$var$w = $9b47d3e3f859fb88$var$b ? Symbol.for("react.fundamental") : 60117, $9b47d3e3f859fb88$var$x = $9b47d3e3f859fb88$var$b ? Symbol.for("react.responder") : 60118, $9b47d3e3f859fb88$var$y = $9b47d3e3f859fb88$var$b ? Symbol.for("react.scope") : 60119;
function $9b47d3e3f859fb88$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $9b47d3e3f859fb88$var$c:
                switch(a = a.type, a){
                    case $9b47d3e3f859fb88$var$l:
                    case $9b47d3e3f859fb88$var$m:
                    case $9b47d3e3f859fb88$var$e:
                    case $9b47d3e3f859fb88$var$g:
                    case $9b47d3e3f859fb88$var$f:
                    case $9b47d3e3f859fb88$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $9b47d3e3f859fb88$var$k:
                            case $9b47d3e3f859fb88$var$n:
                            case $9b47d3e3f859fb88$var$t:
                            case $9b47d3e3f859fb88$var$r:
                            case $9b47d3e3f859fb88$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $9b47d3e3f859fb88$var$d:
                return u;
        }
    }
}
function $9b47d3e3f859fb88$var$A(a) {
    return $9b47d3e3f859fb88$var$z(a) === $9b47d3e3f859fb88$var$m;
}
$9b47d3e3f859fb88$export$2b8d127b894957b9 = $9b47d3e3f859fb88$var$l;
$9b47d3e3f859fb88$export$cea3a54a6425200c = $9b47d3e3f859fb88$var$m;
$9b47d3e3f859fb88$export$a7c73072b1a182ae = $9b47d3e3f859fb88$var$k;
$9b47d3e3f859fb88$export$9f27bc3417b4524d = $9b47d3e3f859fb88$var$h;
$9b47d3e3f859fb88$export$db77ccec0bb4ccac = $9b47d3e3f859fb88$var$c;
$9b47d3e3f859fb88$export$8392c0c9d3dcbd35 = $9b47d3e3f859fb88$var$n;
$9b47d3e3f859fb88$export$ffb0004e005737fa = $9b47d3e3f859fb88$var$e;
$9b47d3e3f859fb88$export$b624eff549462981 = $9b47d3e3f859fb88$var$t;
$9b47d3e3f859fb88$export$7897aa7841a5380c = $9b47d3e3f859fb88$var$r;
$9b47d3e3f859fb88$export$602eac185826482c = $9b47d3e3f859fb88$var$d;
$9b47d3e3f859fb88$export$e2c29f18771995cb = $9b47d3e3f859fb88$var$g;
$9b47d3e3f859fb88$export$5f8d39834fd61797 = $9b47d3e3f859fb88$var$f;
$9b47d3e3f859fb88$export$74bf444e3cd11ea5 = $9b47d3e3f859fb88$var$p;
$9b47d3e3f859fb88$export$92387174baf9b227 = function(a) {
    return $9b47d3e3f859fb88$var$A(a) || $9b47d3e3f859fb88$var$z(a) === $9b47d3e3f859fb88$var$l;
};
$9b47d3e3f859fb88$export$ec112efeb987d9c6 = $9b47d3e3f859fb88$var$A;
$9b47d3e3f859fb88$export$b706b080d889d2c9 = function(a) {
    return $9b47d3e3f859fb88$var$z(a) === $9b47d3e3f859fb88$var$k;
};
$9b47d3e3f859fb88$export$5be5a87408f70ddc = function(a) {
    return $9b47d3e3f859fb88$var$z(a) === $9b47d3e3f859fb88$var$h;
};
$9b47d3e3f859fb88$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $9b47d3e3f859fb88$var$c;
};
$9b47d3e3f859fb88$export$455c2e768291efa6 = function(a) {
    return $9b47d3e3f859fb88$var$z(a) === $9b47d3e3f859fb88$var$n;
};
$9b47d3e3f859fb88$export$9522e17588c12572 = function(a) {
    return $9b47d3e3f859fb88$var$z(a) === $9b47d3e3f859fb88$var$e;
};
$9b47d3e3f859fb88$export$2110ac352bb060b9 = function(a) {
    return $9b47d3e3f859fb88$var$z(a) === $9b47d3e3f859fb88$var$t;
};
$9b47d3e3f859fb88$export$56885ab8b9c456ab = function(a) {
    return $9b47d3e3f859fb88$var$z(a) === $9b47d3e3f859fb88$var$r;
};
$9b47d3e3f859fb88$export$d927fcb6adf8f9de = function(a) {
    return $9b47d3e3f859fb88$var$z(a) === $9b47d3e3f859fb88$var$d;
};
$9b47d3e3f859fb88$export$b82d16f27459e05a = function(a) {
    return $9b47d3e3f859fb88$var$z(a) === $9b47d3e3f859fb88$var$g;
};
$9b47d3e3f859fb88$export$522c17b4f5e123e8 = function(a) {
    return $9b47d3e3f859fb88$var$z(a) === $9b47d3e3f859fb88$var$f;
};
$9b47d3e3f859fb88$export$1aabd8a0274ecfd6 = function(a) {
    return $9b47d3e3f859fb88$var$z(a) === $9b47d3e3f859fb88$var$p;
};
$9b47d3e3f859fb88$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $9b47d3e3f859fb88$var$e || a === $9b47d3e3f859fb88$var$m || a === $9b47d3e3f859fb88$var$g || a === $9b47d3e3f859fb88$var$f || a === $9b47d3e3f859fb88$var$p || a === $9b47d3e3f859fb88$var$q || "object" === typeof a && null !== a && (a.$$typeof === $9b47d3e3f859fb88$var$t || a.$$typeof === $9b47d3e3f859fb88$var$r || a.$$typeof === $9b47d3e3f859fb88$var$h || a.$$typeof === $9b47d3e3f859fb88$var$k || a.$$typeof === $9b47d3e3f859fb88$var$n || a.$$typeof === $9b47d3e3f859fb88$var$w || a.$$typeof === $9b47d3e3f859fb88$var$x || a.$$typeof === $9b47d3e3f859fb88$var$y || a.$$typeof === $9b47d3e3f859fb88$var$v);
};
$9b47d3e3f859fb88$export$f5bbd400c2f4426f = $9b47d3e3f859fb88$var$z;

});

parcelRequire.register("8oBBS", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['’]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "Ā": "A",
        "Ă": "A",
        "Ą": "A",
        "ā": "a",
        "ă": "a",
        "ą": "a",
        "Ć": "C",
        "Ĉ": "C",
        "Ċ": "C",
        "Č": "C",
        "ć": "c",
        "ĉ": "c",
        "ċ": "c",
        "č": "c",
        "Ď": "D",
        "Đ": "D",
        "ď": "d",
        "đ": "d",
        "Ē": "E",
        "Ĕ": "E",
        "Ė": "E",
        "Ę": "E",
        "Ě": "E",
        "ē": "e",
        "ĕ": "e",
        "ė": "e",
        "ę": "e",
        "ě": "e",
        "Ĝ": "G",
        "Ğ": "G",
        "Ġ": "G",
        "Ģ": "G",
        "ĝ": "g",
        "ğ": "g",
        "ġ": "g",
        "ģ": "g",
        "Ĥ": "H",
        "Ħ": "H",
        "ĥ": "h",
        "ħ": "h",
        "Ĩ": "I",
        "Ī": "I",
        "Ĭ": "I",
        "Į": "I",
        "İ": "I",
        "ĩ": "i",
        "ī": "i",
        "ĭ": "i",
        "į": "i",
        "ı": "i",
        "Ĵ": "J",
        "ĵ": "j",
        "Ķ": "K",
        "ķ": "k",
        "ĸ": "k",
        "Ĺ": "L",
        "Ļ": "L",
        "Ľ": "L",
        "Ŀ": "L",
        "Ł": "L",
        "ĺ": "l",
        "ļ": "l",
        "ľ": "l",
        "ŀ": "l",
        "ł": "l",
        "Ń": "N",
        "Ņ": "N",
        "Ň": "N",
        "Ŋ": "N",
        "ń": "n",
        "ņ": "n",
        "ň": "n",
        "ŋ": "n",
        "Ō": "O",
        "Ŏ": "O",
        "Ő": "O",
        "ō": "o",
        "ŏ": "o",
        "ő": "o",
        "Ŕ": "R",
        "Ŗ": "R",
        "Ř": "R",
        "ŕ": "r",
        "ŗ": "r",
        "ř": "r",
        "Ś": "S",
        "Ŝ": "S",
        "Ş": "S",
        "Š": "S",
        "ś": "s",
        "ŝ": "s",
        "ş": "s",
        "š": "s",
        "Ţ": "T",
        "Ť": "T",
        "Ŧ": "T",
        "ţ": "t",
        "ť": "t",
        "ŧ": "t",
        "Ũ": "U",
        "Ū": "U",
        "Ŭ": "U",
        "Ů": "U",
        "Ű": "U",
        "Ų": "U",
        "ũ": "u",
        "ū": "u",
        "ŭ": "u",
        "ů": "u",
        "ű": "u",
        "ų": "u",
        "Ŵ": "W",
        "ŵ": "w",
        "Ŷ": "Y",
        "ŷ": "y",
        "Ÿ": "Y",
        "Ź": "Z",
        "Ż": "Z",
        "Ž": "Z",
        "ź": "z",
        "ż": "z",
        "ž": "z",
        "Ĳ": "IJ",
        "ĳ": "ij",
        "Œ": "Oe",
        "œ": "oe",
        "ŉ": "'n",
        "ſ": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRequire.register("e6nxJ", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $a443e3679b3ebb6f$export$bf730a2d8bf68b42, (v) => $a443e3679b3ebb6f$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a443e3679b3ebb6f$export$bf730a2d8bf68b42;
"use strict";

var $1bdO8 = parcelRequire("1bdO8");

var $8vqHO = parcelRequire("8vqHO");
function $a443e3679b3ebb6f$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $a443e3679b3ebb6f$var$q = "function" === typeof Object.is ? Object.is : $a443e3679b3ebb6f$var$p, $a443e3679b3ebb6f$var$r = $8vqHO.useSyncExternalStore, $a443e3679b3ebb6f$var$t = $1bdO8.useRef, $a443e3679b3ebb6f$var$u = $1bdO8.useEffect, $a443e3679b3ebb6f$var$v = $1bdO8.useMemo, $a443e3679b3ebb6f$var$w = $1bdO8.useDebugValue;
$a443e3679b3ebb6f$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $a443e3679b3ebb6f$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $a443e3679b3ebb6f$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($a443e3679b3ebb6f$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $a443e3679b3ebb6f$var$r(a, c[0], c[1]);
    $a443e3679b3ebb6f$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $a443e3679b3ebb6f$var$w(d);
    return d;
};

});
parcelRequire.register("8vqHO", function(module, exports) {
"use strict";

module.exports = (parcelRequire("9Dxyu"));

});
parcelRequire.register("9Dxyu", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $7041c8f9359bc60d$export$306c0aa65ff9ec16, (v) => $7041c8f9359bc60d$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7041c8f9359bc60d$export$306c0aa65ff9ec16;
"use strict";

var $1bdO8 = parcelRequire("1bdO8");
function $7041c8f9359bc60d$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $7041c8f9359bc60d$var$k = "function" === typeof Object.is ? Object.is : $7041c8f9359bc60d$var$h, $7041c8f9359bc60d$var$l = $1bdO8.useState, $7041c8f9359bc60d$var$m = $1bdO8.useEffect, $7041c8f9359bc60d$var$n = $1bdO8.useLayoutEffect, $7041c8f9359bc60d$var$p = $1bdO8.useDebugValue;
function $7041c8f9359bc60d$var$q(a, b) {
    var d = b(), f = $7041c8f9359bc60d$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $7041c8f9359bc60d$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $7041c8f9359bc60d$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $7041c8f9359bc60d$var$m(function() {
        $7041c8f9359bc60d$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $7041c8f9359bc60d$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $7041c8f9359bc60d$var$p(d);
    return d;
}
function $7041c8f9359bc60d$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$7041c8f9359bc60d$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $7041c8f9359bc60d$var$t(a, b) {
    return b();
}
var $7041c8f9359bc60d$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $7041c8f9359bc60d$var$t : $7041c8f9359bc60d$var$q;
$7041c8f9359bc60d$export$306c0aa65ff9ec16 = void 0 !== $1bdO8.useSyncExternalStore ? $1bdO8.useSyncExternalStore : $7041c8f9359bc60d$var$u;

});



parcelRequire.register("j0uTL", function(module, exports) {

module.exports = new URL((parcelRequire("hMn6r")).resolve("iuGcm"), import.meta.url).toString();

});

parcelRequire.register("bU6e0", function(module, exports) {

module.exports = new URL((parcelRequire("hMn6r")).resolve("f0qU3"), import.meta.url).toString();

});

parcelRequire.register("5fHJD", function(module, exports) {

module.exports = new URL((parcelRequire("hMn6r")).resolve("a6cJd"), import.meta.url).toString();

});

parcelRequire.register("jxRGc", function(module, exports) {

module.exports = new URL((parcelRequire("hMn6r")).resolve("7QAa4"), import.meta.url).toString();

});

parcelRequire.register("ek3fl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6wXS5.default;
    }
});

var $6wXS5 = parcelRequire("6wXS5");

});
parcelRequire.register("6wXS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $013a21bfd19f2045$export$2e2bcd8739ae039);

var $63nUy = parcelRequire("63nUy");

var $1bdO8 = parcelRequire("1bdO8");

var $kVGEJ = parcelRequire("kVGEJ");

var $cVgDf = parcelRequire("cVgDf");
function $013a21bfd19f2045$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $kVGEJ.default), (0, $63nUy.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $kVGEJ.default).muiName;
    return /*#__PURE__*/ $1bdO8.memo(/*#__PURE__*/ $1bdO8.forwardRef(Component));
}

});
parcelRequire.register("63nUy", function(module, exports) {

$parcel$export(module.exports, "default", () => $46859221647ebd0c$export$2e2bcd8739ae039);
function $46859221647ebd0c$export$2e2bcd8739ae039() {
    $46859221647ebd0c$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $46859221647ebd0c$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRequire.register("kVGEJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3ca381e98e0e13b$export$2e2bcd8739ae039);

var $63nUy = parcelRequire("63nUy");

var $fZ2DJ = parcelRequire("fZ2DJ");

var $1bdO8 = parcelRequire("1bdO8");


var $gJjS7 = parcelRequire("gJjS7");

var $9H0b9 = parcelRequire("9H0b9");

var $82mcY = parcelRequire("82mcY");

var $dHuM2 = parcelRequire("dHuM2");

var $gIzLq = parcelRequire("gIzLq");

var $89KYv = parcelRequire("89KYv");

var $cVgDf = parcelRequire("cVgDf");
const $f3ca381e98e0e13b$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $f3ca381e98e0e13b$var$useUtilityClasses = (ownerState)=>{
    const { color: color , fontSize: fontSize , classes: classes  } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, $82mcY.default)(color)}`,
            `fontSize${(0, $82mcY.default)(fontSize)}`
        ]
    };
    return (0, $9H0b9.default)(slots, (0, $89KYv.getSvgIconUtilityClass), classes);
};
const $f3ca381e98e0e13b$var$SvgIconRoot = (0, $gIzLq.default)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, $82mcY.default)(ownerState.color)}`],
            styles[`fontSize${(0, $82mcY.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$transitions2$d, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette$ownerState$c2, _palette2, _palette2$action, _palette3, _palette3$action;
    return {
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        fill: "currentColor",
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null ? void 0 : (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, "fill", {
            duration: (_theme$transitions2 = theme.transitions) == null ? void 0 : (_theme$transitions2$d = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2$d.shorter
        }),
        fontSize: ({
            inherit: "inherit",
            small: ((_theme$typography = theme.typography) == null ? void 0 : (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || "1.25rem",
            medium: ((_theme$typography2 = theme.typography) == null ? void 0 : (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || "1.5rem",
            large: ((_theme$typography3 = theme.typography) == null ? void 0 : (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || "2.1875rem"
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null ? void 0 : (_palette$ownerState$c2 = _palette[ownerState.color]) == null ? void 0 : _palette$ownerState$c2.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null ? void 0 : (_palette2$action = _palette2.action) == null ? void 0 : _palette2$action.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null ? void 0 : (_palette3$action = _palette3.action) == null ? void 0 : _palette3$action.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $f3ca381e98e0e13b$var$SvgIcon = /*#__PURE__*/ $1bdO8.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $dHuM2.default)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    const { children: children , className: className , color: color = "inherit" , component: component = "svg" , fontSize: fontSize = "medium" , htmlColor: htmlColor , inheritViewBox: inheritViewBox = false , titleAccess: titleAccess , viewBox: viewBox = "0 0 24 24"  } = props, other = (0, $fZ2DJ.default)(props, $f3ca381e98e0e13b$var$_excluded);
    const ownerState = (0, $63nUy.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $f3ca381e98e0e13b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $cVgDf.jsxs)($f3ca381e98e0e13b$var$SvgIconRoot, (0, $63nUy.default)({
        as: component,
        className: (0, $gJjS7.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, more, other, {
        ownerState: ownerState,
        children: [
            children,
            titleAccess ? /*#__PURE__*/ (0, $cVgDf.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$f3ca381e98e0e13b$var$SvgIcon.muiName = "SvgIcon";
var $f3ca381e98e0e13b$export$2e2bcd8739ae039 = $f3ca381e98e0e13b$var$SvgIcon;

});
parcelRequire.register("fZ2DJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba2e99b64c07eedc$export$2e2bcd8739ae039);
function $ba2e99b64c07eedc$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRequire.register("gJjS7", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2e043734d0cdb46$export$2e2bcd8739ae039);
function $c2e043734d0cdb46$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $c2e043734d0cdb46$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $c2e043734d0cdb46$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $c2e043734d0cdb46$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $c2e043734d0cdb46$export$2e2bcd8739ae039 = $c2e043734d0cdb46$export$4f5d2d50c9deca37;

});

parcelRequire.register("9H0b9", function(module, exports) {

$parcel$export(module.exports, "default", () => $70e844b9b6ec2795$export$2e2bcd8739ae039);
function $70e844b9b6ec2795$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Objet.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== "") acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(" ");
    });
    return output;
}

});

parcelRequire.register("82mcY", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d9fbcc0d7ccd645$export$2e2bcd8739ae039);

var $56MqO = parcelRequire("56MqO");
var $5d9fbcc0d7ccd645$export$2e2bcd8739ae039 = (0, $56MqO.default);

});
parcelRequire.register("56MqO", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b8314c47fe82b2a$export$2e2bcd8739ae039);

var $7xoNL = parcelRequire("7xoNL");
function $3b8314c47fe82b2a$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $7xoNL.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRequire.register("7xoNL", function(module, exports) {

$parcel$export(module.exports, "default", () => $57ceda8a7be5a1b7$export$2e2bcd8739ae039);
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */ function $57ceda8a7be5a1b7$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe iff we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});



parcelRequire.register("dHuM2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f9729934f8c4b19$export$2e2bcd8739ae039);

var $j8X8X = parcelRequire("j8X8X");

var $5VMQ9 = parcelRequire("5VMQ9");

var $5ZcGy = parcelRequire("5ZcGy");
function $9f9729934f8c4b19$export$2e2bcd8739ae039({ props: props , name: name  }) {
    return (0, $j8X8X.default)({
        props: props,
        name: name,
        defaultTheme: $5VMQ9.default,
        themeId: (0, $5ZcGy.default)
    });
}

});
parcelRequire.register("j8X8X", function(module, exports) {

$parcel$export(module.exports, "default", () => $defca453df587ffb$export$2e2bcd8739ae039);

var $b6fjJ = parcelRequire("b6fjJ");

var $ldP8C = parcelRequire("ldP8C");
function $defca453df587ffb$export$2e2bcd8739ae039({ props: props , name: name , defaultTheme: defaultTheme , themeId: themeId  }) {
    let theme = (0, $ldP8C.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $b6fjJ.default)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}

});
parcelRequire.register("b6fjJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $814c22ebadeccd68$export$2e2bcd8739ae039);

var $fEWvF = parcelRequire("fEWvF");
function $814c22ebadeccd68$export$2e2bcd8739ae039(params) {
    const { theme: theme , name: name , props: props  } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $fEWvF.default)(theme.components[name].defaultProps, props);
}

});
parcelRequire.register("fEWvF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b667fa484364d880$export$2e2bcd8739ae039);
/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param {object} defaultProps
 * @param {object} props
 * @returns {object} resolved props
 */ function $b667fa484364d880$export$2e2bcd8739ae039(defaultProps, props) {
    const output = {
        ...props
    };
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = {
            ...defaultProps[propName],
            ...output[propName]
        };
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = {
                    ...slotProps
                };
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $b667fa484364d880$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});


parcelRequire.register("ldP8C", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7327ad5df86f142$export$2e2bcd8739ae039);

var $1iZe2 = parcelRequire("1iZe2");

var $7xI6r = parcelRequire("7xI6r");
const $f7327ad5df86f142$export$35e57303dbd8a66 = (0, $1iZe2.default)();
function $f7327ad5df86f142$var$useTheme(defaultTheme = $f7327ad5df86f142$export$35e57303dbd8a66) {
    return (0, $7xI6r.default)(defaultTheme);
}
var $f7327ad5df86f142$export$2e2bcd8739ae039 = $f7327ad5df86f142$var$useTheme;

});
parcelRequire.register("1iZe2", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f36f6f45f2cb8f0$export$2e2bcd8739ae039);

var $63nUy = parcelRequire("63nUy");

var $fZ2DJ = parcelRequire("fZ2DJ");

var $1nBS8 = parcelRequire("1nBS8");

var $daYiJ = parcelRequire("daYiJ");

var $4H0iB = parcelRequire("4H0iB");

var $l8T0B = parcelRequire("l8T0B");

var $70fZE = parcelRequire("70fZE");

var $k5Vxs = parcelRequire("k5Vxs");
const $0f36f6f45f2cb8f0$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $0f36f6f45f2cb8f0$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {} , palette: paletteInput = {} , spacing: spacingInput , shape: shapeInput = {}  } = options, other = (0, $fZ2DJ.default)(options, $0f36f6f45f2cb8f0$var$_excluded);
    const breakpoints = (0, $daYiJ.default)(breakpointsInput);
    const spacing = (0, $l8T0B.default)(spacingInput);
    let muiTheme = (0, $1nBS8.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, $63nUy.default)({
            mode: "light"
        }, paletteInput),
        spacing: spacing,
        shape: (0, $63nUy.default)({}, (0, $4H0iB.default), shapeInput)
    }, other);
    muiTheme = args.reduce((acc, argument)=>(0, $1nBS8.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $63nUy.default)({}, (0, $k5Vxs.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $70fZE.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $0f36f6f45f2cb8f0$export$2e2bcd8739ae039 = $0f36f6f45f2cb8f0$var$createTheme;

});
parcelRequire.register("1nBS8", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $1015510b970a6197$export$53b83ca8eaab0383);
$parcel$export(module.exports, "default", () => $1015510b970a6197$export$2e2bcd8739ae039);
function $1015510b970a6197$export$53b83ca8eaab0383(item) {
    return item !== null && typeof item === "object" && item.constructor === Object;
}
function $1015510b970a6197$var$deepClone(source) {
    if (!$1015510b970a6197$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $1015510b970a6197$var$deepClone(source[key]);
    });
    return output;
}
function $1015510b970a6197$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if ($1015510b970a6197$export$53b83ca8eaab0383(target) && $1015510b970a6197$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($1015510b970a6197$export$53b83ca8eaab0383(source[key]) && key in target && $1015510b970a6197$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $1015510b970a6197$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $1015510b970a6197$export$53b83ca8eaab0383(source[key]) ? $1015510b970a6197$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRequire.register("daYiJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $997afc0f02a526fa$export$2e2bcd8739ae039);

var $fZ2DJ = parcelRequire("fZ2DJ");

var $63nUy = parcelRequire("63nUy");
const $997afc0f02a526fa$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $997afc0f02a526fa$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $997afc0f02a526fa$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $63nUy.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $997afc0f02a526fa$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    } , unit: unit = "px" , step: step = 5  } = breakpoints, other = (0, $fZ2DJ.default)(breakpoints, $997afc0f02a526fa$var$_excluded);
    const sortedValues = $997afc0f02a526fa$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return (0, $63nUy.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRequire.register("4H0iB", function(module, exports) {

$parcel$export(module.exports, "default", () => $36ab68fc2aa9ed54$export$2e2bcd8739ae039);
const $36ab68fc2aa9ed54$var$shape = {
    borderRadius: 4
};
var $36ab68fc2aa9ed54$export$2e2bcd8739ae039 = $36ab68fc2aa9ed54$var$shape;

});

parcelRequire.register("l8T0B", function(module, exports) {

$parcel$export(module.exports, "default", () => $f64503ee43c02c69$export$2e2bcd8739ae039);

var $fvKw9 = parcelRequire("fvKw9");
function $f64503ee43c02c69$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $fvKw9.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRequire.register("fvKw9", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", () => $b4add5b0f8d24fc0$export$cb5ee237cce814a2);
$parcel$export(module.exports, "createUnarySpacing", () => $b4add5b0f8d24fc0$export$1def6f833384e3d1);
$parcel$export(module.exports, "getValue", () => $b4add5b0f8d24fc0$export$bf7199a9ebcb84a9);
$parcel$export(module.exports, "margin", () => $b4add5b0f8d24fc0$export$7ede87f9b603dd3c);
$parcel$export(module.exports, "padding", () => $b4add5b0f8d24fc0$export$6f98e8eaf0be1996);


var $bTeke = parcelRequire("bTeke");

var $lrFcc = parcelRequire("lrFcc");

var $5HS3K = parcelRequire("5HS3K");

var $8DoCA = parcelRequire("8DoCA");
const $b4add5b0f8d24fc0$var$properties = {
    m: "margin",
    p: "padding"
};
const $b4add5b0f8d24fc0$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $b4add5b0f8d24fc0$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $b4add5b0f8d24fc0$var$getCssProperties = (0, $8DoCA.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($b4add5b0f8d24fc0$var$aliases[prop]) prop = $b4add5b0f8d24fc0$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $b4add5b0f8d24fc0$var$properties[a];
    const direction = $b4add5b0f8d24fc0$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $b4add5b0f8d24fc0$export$aab52a0dde05ad8a = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $b4add5b0f8d24fc0$export$f8397d44f03ab6ad = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $b4add5b0f8d24fc0$var$spacingKeys = [
    ...$b4add5b0f8d24fc0$export$aab52a0dde05ad8a,
    ...$b4add5b0f8d24fc0$export$f8397d44f03ab6ad
];
function $b4add5b0f8d24fc0$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $lrFcc.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === "number") return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $b4add5b0f8d24fc0$export$1def6f833384e3d1(theme) {
    return $b4add5b0f8d24fc0$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $b4add5b0f8d24fc0$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return `-${transformed}`;
}
function $b4add5b0f8d24fc0$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $b4add5b0f8d24fc0$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $b4add5b0f8d24fc0$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $b4add5b0f8d24fc0$var$getCssProperties(prop);
    const styleFromPropValue = $b4add5b0f8d24fc0$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $bTeke.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $b4add5b0f8d24fc0$var$style(props, keys) {
    const transformer = $b4add5b0f8d24fc0$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$b4add5b0f8d24fc0$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $5HS3K.default), {});
}
function $b4add5b0f8d24fc0$export$7ede87f9b603dd3c(props) {
    return $b4add5b0f8d24fc0$var$style(props, $b4add5b0f8d24fc0$export$aab52a0dde05ad8a);
}
$b4add5b0f8d24fc0$export$7ede87f9b603dd3c.propTypes = {};
$b4add5b0f8d24fc0$export$7ede87f9b603dd3c.filterProps = $b4add5b0f8d24fc0$export$aab52a0dde05ad8a;
function $b4add5b0f8d24fc0$export$6f98e8eaf0be1996(props) {
    return $b4add5b0f8d24fc0$var$style(props, $b4add5b0f8d24fc0$export$f8397d44f03ab6ad);
}
$b4add5b0f8d24fc0$export$6f98e8eaf0be1996.propTypes = {};
$b4add5b0f8d24fc0$export$6f98e8eaf0be1996.filterProps = $b4add5b0f8d24fc0$export$f8397d44f03ab6ad;
function $b4add5b0f8d24fc0$var$spacing(props) {
    return $b4add5b0f8d24fc0$var$style(props, $b4add5b0f8d24fc0$var$spacingKeys);
}
$b4add5b0f8d24fc0$var$spacing.propTypes = {};
$b4add5b0f8d24fc0$var$spacing.filterProps = $b4add5b0f8d24fc0$var$spacingKeys;
var $b4add5b0f8d24fc0$export$2e2bcd8739ae039 = $b4add5b0f8d24fc0$var$spacing;

});
parcelRequire.register("bTeke", function(module, exports) {

$parcel$export(module.exports, "values", () => $8a7ff17d1178fb5d$export$68c286be0e7e55b7);
$parcel$export(module.exports, "handleBreakpoints", () => $8a7ff17d1178fb5d$export$88347efdb2e19abd);
$parcel$export(module.exports, "createEmptyBreakpointObject", () => $8a7ff17d1178fb5d$export$1f2600516e91381f);
$parcel$export(module.exports, "removeUnusedBreakpoints", () => $8a7ff17d1178fb5d$export$8922c90b6e020726);
$parcel$export(module.exports, "mergeBreakpointsInOrder", () => $8a7ff17d1178fb5d$export$b89a003a1e05c0ee);
$parcel$export(module.exports, "resolveBreakpointValues", () => $8a7ff17d1178fb5d$export$980e6a259d807490);

var $63nUy = parcelRequire("63nUy");


var $1nBS8 = parcelRequire("1nBS8");

var $5HS3K = parcelRequire("5HS3K");
const $8a7ff17d1178fb5d$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $8a7ff17d1178fb5d$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$8a7ff17d1178fb5d$export$68c286be0e7e55b7[key]}px)`
};
function $8a7ff17d1178fb5d$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $8a7ff17d1178fb5d$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $8a7ff17d1178fb5d$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $8a7ff17d1178fb5d$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $8a7ff17d1178fb5d$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $8a7ff17d1178fb5d$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $63nUy.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $5HS3K.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $8a7ff17d1178fb5d$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $8a7ff17d1178fb5d$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $8a7ff17d1178fb5d$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $8a7ff17d1178fb5d$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $1nBS8.default)(prev, next), {});
    return $8a7ff17d1178fb5d$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $8a7ff17d1178fb5d$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $8a7ff17d1178fb5d$export$980e6a259d807490({ values: breakpointValues , breakpoints: themeBreakpoints , base: customBase  }) {
    const base = customBase || $8a7ff17d1178fb5d$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $8a7ff17d1178fb5d$export$2e2bcd8739ae039 = $8a7ff17d1178fb5d$var$breakpoints;

});
parcelRequire.register("5HS3K", function(module, exports) {

$parcel$export(module.exports, "default", () => $427ae6fd9c697120$export$2e2bcd8739ae039);

var $1nBS8 = parcelRequire("1nBS8");
function $427ae6fd9c697120$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $1nBS8.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $427ae6fd9c697120$export$2e2bcd8739ae039 = $427ae6fd9c697120$var$merge;

});


parcelRequire.register("lrFcc", function(module, exports) {

$parcel$export(module.exports, "getPath", () => $f9cc133763a3c6cc$export$2aa3fd96c49a84a8);
$parcel$export(module.exports, "getStyleValue", () => $f9cc133763a3c6cc$export$741ad47189a64aa0);
$parcel$export(module.exports, "default", () => $f9cc133763a3c6cc$export$2e2bcd8739ae039);

var $56MqO = parcelRequire("56MqO");


var $bTeke = parcelRequire("bTeke");
function $f9cc133763a3c6cc$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $f9cc133763a3c6cc$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $f9cc133763a3c6cc$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $f9cc133763a3c6cc$var$style(options) {
    const { prop: prop , cssProperty: cssProperty = options.prop , themeKey: themeKey , transform: transform  } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $f9cc133763a3c6cc$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $f9cc133763a3c6cc$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $f9cc133763a3c6cc$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $56MqO.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $bTeke.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $f9cc133763a3c6cc$export$2e2bcd8739ae039 = $f9cc133763a3c6cc$var$style;

});

parcelRequire.register("8DoCA", function(module, exports) {

$parcel$export(module.exports, "default", () => $64951083ae1bf2df$export$2e2bcd8739ae039);
function $64951083ae1bf2df$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRequire.register("70fZE", function(module, exports) {

$parcel$export(module.exports, "default", () => $5194f06ef6bd3db6$export$2e2bcd8739ae039);

var $56MqO = parcelRequire("56MqO");

var $5HS3K = parcelRequire("5HS3K");

var $lrFcc = parcelRequire("lrFcc");

var $bTeke = parcelRequire("bTeke");

var $k5Vxs = parcelRequire("k5Vxs");
function $5194f06ef6bd3db6$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $5194f06ef6bd3db6$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $5194f06ef6bd3db6$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop , themeKey: themeKey , transform: transform , style: style  } = options;
        if (val == null) return null;
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, $lrFcc.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $lrFcc.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, $lrFcc.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $56MqO.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $bTeke.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx , theme: theme = {}  } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $k5Vxs.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $bTeke.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $5194f06ef6bd3db6$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, $5HS3K.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $bTeke.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($5194f06ef6bd3db6$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $5HS3K.default)(css, breakpointsValues);
                        }
                    } else css = (0, $5HS3K.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $bTeke.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $5194f06ef6bd3db6$var$styleFunctionSx = $5194f06ef6bd3db6$export$7d53d8bf2911e013();
$5194f06ef6bd3db6$var$styleFunctionSx.filterProps = [
    "sx"
];
var $5194f06ef6bd3db6$export$2e2bcd8739ae039 = $5194f06ef6bd3db6$var$styleFunctionSx;

});
parcelRequire.register("k5Vxs", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea10e8468d5ddeca$export$2e2bcd8739ae039);

var $fvKw9 = parcelRequire("fvKw9");

var $aPOCP = parcelRequire("aPOCP");

var $7L4Pq = parcelRequire("7L4Pq");

var $68NUE = parcelRequire("68NUE");

var $ke17L = parcelRequire("ke17L");
const $ea10e8468d5ddeca$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, $aPOCP.borderTransform)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, $aPOCP.borderTransform)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, $aPOCP.borderTransform)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, $aPOCP.borderTransform)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, $aPOCP.borderTransform)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, $aPOCP.borderRadius)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, $68NUE.paletteTransform)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, $68NUE.paletteTransform)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, $68NUE.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $fvKw9.padding)
    },
    pt: {
        style: (0, $fvKw9.padding)
    },
    pr: {
        style: (0, $fvKw9.padding)
    },
    pb: {
        style: (0, $fvKw9.padding)
    },
    pl: {
        style: (0, $fvKw9.padding)
    },
    px: {
        style: (0, $fvKw9.padding)
    },
    py: {
        style: (0, $fvKw9.padding)
    },
    padding: {
        style: (0, $fvKw9.padding)
    },
    paddingTop: {
        style: (0, $fvKw9.padding)
    },
    paddingRight: {
        style: (0, $fvKw9.padding)
    },
    paddingBottom: {
        style: (0, $fvKw9.padding)
    },
    paddingLeft: {
        style: (0, $fvKw9.padding)
    },
    paddingX: {
        style: (0, $fvKw9.padding)
    },
    paddingY: {
        style: (0, $fvKw9.padding)
    },
    paddingInline: {
        style: (0, $fvKw9.padding)
    },
    paddingInlineStart: {
        style: (0, $fvKw9.padding)
    },
    paddingInlineEnd: {
        style: (0, $fvKw9.padding)
    },
    paddingBlock: {
        style: (0, $fvKw9.padding)
    },
    paddingBlockStart: {
        style: (0, $fvKw9.padding)
    },
    paddingBlockEnd: {
        style: (0, $fvKw9.padding)
    },
    m: {
        style: (0, $fvKw9.margin)
    },
    mt: {
        style: (0, $fvKw9.margin)
    },
    mr: {
        style: (0, $fvKw9.margin)
    },
    mb: {
        style: (0, $fvKw9.margin)
    },
    ml: {
        style: (0, $fvKw9.margin)
    },
    mx: {
        style: (0, $fvKw9.margin)
    },
    my: {
        style: (0, $fvKw9.margin)
    },
    margin: {
        style: (0, $fvKw9.margin)
    },
    marginTop: {
        style: (0, $fvKw9.margin)
    },
    marginRight: {
        style: (0, $fvKw9.margin)
    },
    marginBottom: {
        style: (0, $fvKw9.margin)
    },
    marginLeft: {
        style: (0, $fvKw9.margin)
    },
    marginX: {
        style: (0, $fvKw9.margin)
    },
    marginY: {
        style: (0, $fvKw9.margin)
    },
    marginInline: {
        style: (0, $fvKw9.margin)
    },
    marginInlineStart: {
        style: (0, $fvKw9.margin)
    },
    marginInlineEnd: {
        style: (0, $fvKw9.margin)
    },
    marginBlock: {
        style: (0, $fvKw9.margin)
    },
    marginBlockStart: {
        style: (0, $fvKw9.margin)
    },
    marginBlockEnd: {
        style: (0, $fvKw9.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $7L4Pq.gap)
    },
    rowGap: {
        style: (0, $7L4Pq.rowGap)
    },
    columnGap: {
        style: (0, $7L4Pq.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, $ke17L.sizingTransform)
    },
    maxWidth: {
        style: (0, $ke17L.maxWidth)
    },
    minWidth: {
        transform: (0, $ke17L.sizingTransform)
    },
    height: {
        transform: (0, $ke17L.sizingTransform)
    },
    maxHeight: {
        transform: (0, $ke17L.sizingTransform)
    },
    minHeight: {
        transform: (0, $ke17L.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
var $ea10e8468d5ddeca$export$2e2bcd8739ae039 = $ea10e8468d5ddeca$var$defaultSxConfig;

});
parcelRequire.register("aPOCP", function(module, exports) {

$parcel$export(module.exports, "borderTransform", () => $7e35efe7c44e63bf$export$34e2febe53ae29cc);
$parcel$export(module.exports, "borderRadius", () => $7e35efe7c44e63bf$export$7a57f79000377ca2);


var $lrFcc = parcelRequire("lrFcc");

var $dkRTB = parcelRequire("dkRTB");

var $fvKw9 = parcelRequire("fvKw9");

var $bTeke = parcelRequire("bTeke");
function $7e35efe7c44e63bf$export$34e2febe53ae29cc(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
const $7e35efe7c44e63bf$export$1edee58a52776cd9 = (0, $lrFcc.default)({
    prop: "border",
    themeKey: "borders",
    transform: $7e35efe7c44e63bf$export$34e2febe53ae29cc
});
const $7e35efe7c44e63bf$export$f9a7b6bd24892946 = (0, $lrFcc.default)({
    prop: "borderTop",
    themeKey: "borders",
    transform: $7e35efe7c44e63bf$export$34e2febe53ae29cc
});
const $7e35efe7c44e63bf$export$5abca33e6be905d2 = (0, $lrFcc.default)({
    prop: "borderRight",
    themeKey: "borders",
    transform: $7e35efe7c44e63bf$export$34e2febe53ae29cc
});
const $7e35efe7c44e63bf$export$e2ce9f12a980a822 = (0, $lrFcc.default)({
    prop: "borderBottom",
    themeKey: "borders",
    transform: $7e35efe7c44e63bf$export$34e2febe53ae29cc
});
const $7e35efe7c44e63bf$export$47658cca1a909427 = (0, $lrFcc.default)({
    prop: "borderLeft",
    themeKey: "borders",
    transform: $7e35efe7c44e63bf$export$34e2febe53ae29cc
});
const $7e35efe7c44e63bf$export$e7fb0694ba2404fc = (0, $lrFcc.default)({
    prop: "borderColor",
    themeKey: "palette"
});
const $7e35efe7c44e63bf$export$126a92c968acdb85 = (0, $lrFcc.default)({
    prop: "borderTopColor",
    themeKey: "palette"
});
const $7e35efe7c44e63bf$export$85cc51cb8fbb8c0e = (0, $lrFcc.default)({
    prop: "borderRightColor",
    themeKey: "palette"
});
const $7e35efe7c44e63bf$export$340b0327727f6d1a = (0, $lrFcc.default)({
    prop: "borderBottomColor",
    themeKey: "palette"
});
const $7e35efe7c44e63bf$export$60beef91a985b4bf = (0, $lrFcc.default)({
    prop: "borderLeftColor",
    themeKey: "palette"
});
const $7e35efe7c44e63bf$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $fvKw9.createUnaryUnit)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $fvKw9.getValue)(transformer, propValue)
            });
        return (0, $bTeke.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$7e35efe7c44e63bf$export$7a57f79000377ca2.propTypes = {};
$7e35efe7c44e63bf$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $7e35efe7c44e63bf$var$borders = (0, $dkRTB.default)($7e35efe7c44e63bf$export$1edee58a52776cd9, $7e35efe7c44e63bf$export$f9a7b6bd24892946, $7e35efe7c44e63bf$export$5abca33e6be905d2, $7e35efe7c44e63bf$export$e2ce9f12a980a822, $7e35efe7c44e63bf$export$47658cca1a909427, $7e35efe7c44e63bf$export$e7fb0694ba2404fc, $7e35efe7c44e63bf$export$126a92c968acdb85, $7e35efe7c44e63bf$export$85cc51cb8fbb8c0e, $7e35efe7c44e63bf$export$340b0327727f6d1a, $7e35efe7c44e63bf$export$60beef91a985b4bf, $7e35efe7c44e63bf$export$7a57f79000377ca2);
var $7e35efe7c44e63bf$export$2e2bcd8739ae039 = $7e35efe7c44e63bf$var$borders;

});
parcelRequire.register("dkRTB", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b56f32f29e116ec$export$2e2bcd8739ae039);

var $5HS3K = parcelRequire("5HS3K");
function $9b56f32f29e116ec$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $5HS3K.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $9b56f32f29e116ec$export$2e2bcd8739ae039 = $9b56f32f29e116ec$var$compose;

});


parcelRequire.register("7L4Pq", function(module, exports) {

$parcel$export(module.exports, "gap", () => $5a60ab00f8a4f58d$export$5df9adcb0db95e1e);
$parcel$export(module.exports, "columnGap", () => $5a60ab00f8a4f58d$export$ec60d70ff941a580);
$parcel$export(module.exports, "rowGap", () => $5a60ab00f8a4f58d$export$8a833ffa5f5dbeda);

var $lrFcc = parcelRequire("lrFcc");

var $dkRTB = parcelRequire("dkRTB");

var $fvKw9 = parcelRequire("fvKw9");

var $bTeke = parcelRequire("bTeke");

const $5a60ab00f8a4f58d$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $fvKw9.createUnaryUnit)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $fvKw9.getValue)(transformer, propValue)
            });
        return (0, $bTeke.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$5a60ab00f8a4f58d$export$5df9adcb0db95e1e.propTypes = {};
$5a60ab00f8a4f58d$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $5a60ab00f8a4f58d$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $fvKw9.createUnaryUnit)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $fvKw9.getValue)(transformer, propValue)
            });
        return (0, $bTeke.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$5a60ab00f8a4f58d$export$ec60d70ff941a580.propTypes = {};
$5a60ab00f8a4f58d$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $5a60ab00f8a4f58d$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $fvKw9.createUnaryUnit)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $fvKw9.getValue)(transformer, propValue)
            });
        return (0, $bTeke.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$5a60ab00f8a4f58d$export$8a833ffa5f5dbeda.propTypes = {};
$5a60ab00f8a4f58d$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $5a60ab00f8a4f58d$export$baf44164ca3a34e8 = (0, $lrFcc.default)({
    prop: "gridColumn"
});
const $5a60ab00f8a4f58d$export$8f7213a1cd01e832 = (0, $lrFcc.default)({
    prop: "gridRow"
});
const $5a60ab00f8a4f58d$export$b0e0abbc49ba668 = (0, $lrFcc.default)({
    prop: "gridAutoFlow"
});
const $5a60ab00f8a4f58d$export$bcd8b929d4b4142 = (0, $lrFcc.default)({
    prop: "gridAutoColumns"
});
const $5a60ab00f8a4f58d$export$e5039a674e14c828 = (0, $lrFcc.default)({
    prop: "gridAutoRows"
});
const $5a60ab00f8a4f58d$export$42bd9088661ffb03 = (0, $lrFcc.default)({
    prop: "gridTemplateColumns"
});
const $5a60ab00f8a4f58d$export$920682ae05b999bc = (0, $lrFcc.default)({
    prop: "gridTemplateRows"
});
const $5a60ab00f8a4f58d$export$1b88fbdd482fd33a = (0, $lrFcc.default)({
    prop: "gridTemplateAreas"
});
const $5a60ab00f8a4f58d$export$bdb486e40d52d26f = (0, $lrFcc.default)({
    prop: "gridArea"
});
const $5a60ab00f8a4f58d$var$grid = (0, $dkRTB.default)($5a60ab00f8a4f58d$export$5df9adcb0db95e1e, $5a60ab00f8a4f58d$export$ec60d70ff941a580, $5a60ab00f8a4f58d$export$8a833ffa5f5dbeda, $5a60ab00f8a4f58d$export$baf44164ca3a34e8, $5a60ab00f8a4f58d$export$8f7213a1cd01e832, $5a60ab00f8a4f58d$export$b0e0abbc49ba668, $5a60ab00f8a4f58d$export$bcd8b929d4b4142, $5a60ab00f8a4f58d$export$e5039a674e14c828, $5a60ab00f8a4f58d$export$42bd9088661ffb03, $5a60ab00f8a4f58d$export$920682ae05b999bc, $5a60ab00f8a4f58d$export$1b88fbdd482fd33a, $5a60ab00f8a4f58d$export$bdb486e40d52d26f);
var $5a60ab00f8a4f58d$export$2e2bcd8739ae039 = $5a60ab00f8a4f58d$var$grid;

});

parcelRequire.register("68NUE", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", () => $478a35125a567fbd$export$dbaffd4420ea0ac6);

var $lrFcc = parcelRequire("lrFcc");

var $dkRTB = parcelRequire("dkRTB");
function $478a35125a567fbd$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const $478a35125a567fbd$export$35e9368ef982300f = (0, $lrFcc.default)({
    prop: "color",
    themeKey: "palette",
    transform: $478a35125a567fbd$export$dbaffd4420ea0ac6
});
const $478a35125a567fbd$export$2506f56c10355b33 = (0, $lrFcc.default)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $478a35125a567fbd$export$dbaffd4420ea0ac6
});
const $478a35125a567fbd$export$8c5a050822fd698c = (0, $lrFcc.default)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $478a35125a567fbd$export$dbaffd4420ea0ac6
});
const $478a35125a567fbd$var$palette = (0, $dkRTB.default)($478a35125a567fbd$export$35e9368ef982300f, $478a35125a567fbd$export$2506f56c10355b33, $478a35125a567fbd$export$8c5a050822fd698c);
var $478a35125a567fbd$export$2e2bcd8739ae039 = $478a35125a567fbd$var$palette;

});

parcelRequire.register("ke17L", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", () => $eb95fcb622df8266$export$8afece71750ec241);
$parcel$export(module.exports, "maxWidth", () => $eb95fcb622df8266$export$488fda99655ff65a);

var $lrFcc = parcelRequire("lrFcc");

var $dkRTB = parcelRequire("dkRTB");

var $bTeke = parcelRequire("bTeke");
function $eb95fcb622df8266$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $eb95fcb622df8266$export$7e3df82ee760448c = (0, $lrFcc.default)({
    prop: "width",
    transform: $eb95fcb622df8266$export$8afece71750ec241
});
const $eb95fcb622df8266$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme$breakpoi, _props$theme$breakpoi2;
            const breakpoint = ((_props$theme = props.theme) == null ? void 0 : (_props$theme$breakpoi = _props$theme.breakpoints) == null ? void 0 : (_props$theme$breakpoi2 = _props$theme$breakpoi.values) == null ? void 0 : _props$theme$breakpoi2[propValue]) || (0, $bTeke.values)[propValue];
            return {
                maxWidth: breakpoint || $eb95fcb622df8266$export$8afece71750ec241(propValue)
            };
        };
        return (0, $bTeke.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$eb95fcb622df8266$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $eb95fcb622df8266$export$ee148fbbe8357dd2 = (0, $lrFcc.default)({
    prop: "minWidth",
    transform: $eb95fcb622df8266$export$8afece71750ec241
});
const $eb95fcb622df8266$export$ac607276a8fe9f0a = (0, $lrFcc.default)({
    prop: "height",
    transform: $eb95fcb622df8266$export$8afece71750ec241
});
const $eb95fcb622df8266$export$dc0d8bd0b94f8570 = (0, $lrFcc.default)({
    prop: "maxHeight",
    transform: $eb95fcb622df8266$export$8afece71750ec241
});
const $eb95fcb622df8266$export$a43cf604e12f3b17 = (0, $lrFcc.default)({
    prop: "minHeight",
    transform: $eb95fcb622df8266$export$8afece71750ec241
});
const $eb95fcb622df8266$export$ffed9f14fb65e276 = (0, $lrFcc.default)({
    prop: "size",
    cssProperty: "width",
    transform: $eb95fcb622df8266$export$8afece71750ec241
});
const $eb95fcb622df8266$export$905076ed6620e671 = (0, $lrFcc.default)({
    prop: "size",
    cssProperty: "height",
    transform: $eb95fcb622df8266$export$8afece71750ec241
});
const $eb95fcb622df8266$export$6ccc93f785106a58 = (0, $lrFcc.default)({
    prop: "boxSizing"
});
const $eb95fcb622df8266$var$sizing = (0, $dkRTB.default)($eb95fcb622df8266$export$7e3df82ee760448c, $eb95fcb622df8266$export$488fda99655ff65a, $eb95fcb622df8266$export$ee148fbbe8357dd2, $eb95fcb622df8266$export$ac607276a8fe9f0a, $eb95fcb622df8266$export$dc0d8bd0b94f8570, $eb95fcb622df8266$export$a43cf604e12f3b17, $eb95fcb622df8266$export$6ccc93f785106a58);
var $eb95fcb622df8266$export$2e2bcd8739ae039 = $eb95fcb622df8266$var$sizing;

});




parcelRequire.register("7xI6r", function(module, exports) {

$parcel$export(module.exports, "default", () => $57ddd3690a58d974$export$2e2bcd8739ae039);

var $1bdO8 = parcelRequire("1bdO8");
parcelRequire("alXcb");
var $79R6f = parcelRequire("79R6f");
function $57ddd3690a58d974$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $57ddd3690a58d974$var$useTheme(defaultTheme = null) {
    const contextTheme = $1bdO8.useContext((0, $79R6f.T));
    return !contextTheme || $57ddd3690a58d974$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $57ddd3690a58d974$export$2e2bcd8739ae039 = $57ddd3690a58d974$var$useTheme;

});
parcelRequire.register("alXcb", function(module, exports) {

$parcel$export(module.exports, "Global", () => $7899c88c166c97d0$export$98f03c5d19621d70);
$parcel$export(module.exports, "keyframes", () => $7899c88c166c97d0$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("79R6f")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("79R6f")).w);

var $79R6f = parcelRequire("79R6f");

var $1bdO8 = parcelRequire("1bdO8");

var $257EV = parcelRequire("257EV");

var $92M4l = parcelRequire("92M4l");

var $fRUBy = parcelRequire("fRUBy");
parcelRequire("ENSZy");
parcelRequire("4pGln");
parcelRequire("k1u8s");

parcelRequire("gmH6s");
var $7899c88c166c97d0$var$pkg = {
    name: "@emotion/react",
    version: "11.11.0",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.2",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.0",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $7899c88c166c97d0$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $79R6f.h).call(props, "css")) // $FlowFixMe
    return $1bdO8.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $79R6f.E);
    createElementArgArray[1] = (0, $79R6f.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $1bdO8.createElement.apply(null, createElementArgArray);
};
var $7899c88c166c97d0$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $7899c88c166c97d0$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $79R6f.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $fRUBy.serializeStyles)([
        styles
    ], undefined, $1bdO8.useContext((0, $79R6f.T)));
    if (!(0, $79R6f.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $1bdO8.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $1bdO8.useRef();
    (0, $92M4l.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $92M4l.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $257EV.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $7899c88c166c97d0$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $fRUBy.serializeStyles)(args);
}
var $7899c88c166c97d0$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $7899c88c166c97d0$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $7899c88c166c97d0$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $7899c88c166c97d0$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $257EV.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $7899c88c166c97d0$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $92M4l.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $257EV.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $7899c88c166c97d0$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $79R6f.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $fRUBy.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $257EV.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $7899c88c166c97d0$var$merge(cache.registered, css, $7899c88c166c97d0$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $1bdO8.useContext((0, $79R6f.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $1bdO8.createElement($1bdO8.Fragment, null, /*#__PURE__*/ $1bdO8.createElement($7899c88c166c97d0$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $7899c88c166c97d0$var$isBrowser, $7899c88c166c97d0$var$isTestEnv, $7899c88c166c97d0$var$globalContext, $7899c88c166c97d0$var$globalKey;

});
parcelRequire.register("79R6f", function(module, exports) {

$parcel$export(module.exports, "i", () => $536290277d4b30df$export$23f2a1d2818174ef);
$parcel$export(module.exports, "h", () => $536290277d4b30df$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "w", () => $536290277d4b30df$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $536290277d4b30df$export$971d5caa766a69d7);
$parcel$export(module.exports, "c", () => $536290277d4b30df$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $536290277d4b30df$export$a9c23c6ac3fc3eca);

var $1bdO8 = parcelRequire("1bdO8");

var $ENSZy = parcelRequire("ENSZy");

var $63nUy = parcelRequire("63nUy");

var $k1u8s = parcelRequire("k1u8s");

var $ffPGT = parcelRequire("ffPGT");

var $257EV = parcelRequire("257EV");

var $fRUBy = parcelRequire("fRUBy");

var $92M4l = parcelRequire("92M4l");
var $536290277d4b30df$export$23f2a1d2818174ef = true;
var $536290277d4b30df$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $536290277d4b30df$var$EmotionCacheContext = /* #__PURE__ */ $1bdO8.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $ENSZy.default)({
    key: "css"
}) : null);
var $536290277d4b30df$export$e7094788287c5e9b = $536290277d4b30df$var$EmotionCacheContext.Provider;
var $536290277d4b30df$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $1bdO8.useContext)($536290277d4b30df$var$EmotionCacheContext);
};
var $536290277d4b30df$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $1bdO8.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $1bdO8.useContext)($536290277d4b30df$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$536290277d4b30df$export$23f2a1d2818174ef) $536290277d4b30df$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $1bdO8.useContext)($536290277d4b30df$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $ENSZy.default)({
                key: "css"
            });
            return /*#__PURE__*/ $1bdO8.createElement($536290277d4b30df$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $536290277d4b30df$export$971d5caa766a69d7 = /* #__PURE__ */ $1bdO8.createContext({});
var $536290277d4b30df$export$3b14a55fb2447963 = function useTheme() {
    return $1bdO8.useContext($536290277d4b30df$export$971d5caa766a69d7);
};
var $536290277d4b30df$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $63nUy.default)({}, outerTheme, theme);
};
var $536290277d4b30df$var$createCacheWithTheme = /* #__PURE__ */ (0, $k1u8s.default)(function(outerTheme) {
    return (0, $k1u8s.default)(function(theme) {
        return $536290277d4b30df$var$getTheme(outerTheme, theme);
    });
});
var $536290277d4b30df$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $1bdO8.useContext($536290277d4b30df$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $536290277d4b30df$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $1bdO8.createElement($536290277d4b30df$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $536290277d4b30df$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $1bdO8.useContext($536290277d4b30df$export$971d5caa766a69d7);
        return /*#__PURE__*/ $1bdO8.createElement(Component, (0, $63nUy.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $1bdO8.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $ffPGT.default)(WithTheme, Component);
}
var $536290277d4b30df$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $536290277d4b30df$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $536290277d4b30df$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $536290277d4b30df$var$getLastPart(match[1]);
    return undefined;
};
var $536290277d4b30df$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $536290277d4b30df$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $536290277d4b30df$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $536290277d4b30df$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($536290277d4b30df$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $536290277d4b30df$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $536290277d4b30df$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $536290277d4b30df$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $536290277d4b30df$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($536290277d4b30df$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$536290277d4b30df$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $536290277d4b30df$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $257EV.registerStyles)(cache, serialized, isStringTag);
    (0, $92M4l.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $257EV.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $536290277d4b30df$var$Emotion = /* #__PURE__ */ $536290277d4b30df$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$536290277d4b30df$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $257EV.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $fRUBy.serializeStyles)(registeredStyles, undefined, $1bdO8.useContext($536290277d4b30df$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($536290277d4b30df$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $536290277d4b30df$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $1bdO8.createElement($1bdO8.Fragment, null, /*#__PURE__*/ $1bdO8.createElement($536290277d4b30df$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $1bdO8.createElement(WrappedComponent, newProps));
});
var $536290277d4b30df$export$a9c23c6ac3fc3eca = $536290277d4b30df$var$Emotion;

});
parcelRequire.register("ENSZy", function(module, exports) {

$parcel$export(module.exports, "default", () => $07aa6edacd7ef73c$export$2e2bcd8739ae039);

var $7tb12 = parcelRequire("7tb12");

var $fngFU = parcelRequire("fngFU");
parcelRequire("k1u8s");
parcelRequire("1qjjx");
var $07aa6edacd7ef73c$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $fngFU.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $fngFU.token)(character)) break;
        (0, $fngFU.next)();
    }
    return (0, $fngFU.slice)(begin, (0, $fngFU.position));
};
var $07aa6edacd7ef73c$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $fngFU.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $fngFU.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $07aa6edacd7ef73c$var$identifierWithPointTracking((0, $fngFU.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $fngFU.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $fngFU.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $fngFU.from)(character);
    }
    while (character = (0, $fngFU.next)());
    return parsed;
};
var $07aa6edacd7ef73c$var$getRules = function getRules(value, points) {
    return (0, $fngFU.dealloc)($07aa6edacd7ef73c$var$toRules((0, $fngFU.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $07aa6edacd7ef73c$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $07aa6edacd7ef73c$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$07aa6edacd7ef73c$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $07aa6edacd7ef73c$var$fixedElements.set(element, true);
    var points = [];
    var rules = $07aa6edacd7ef73c$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $07aa6edacd7ef73c$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $07aa6edacd7ef73c$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $07aa6edacd7ef73c$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($07aa6edacd7ef73c$var$ignoreFlag) > -1;
};
var $07aa6edacd7ef73c$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($07aa6edacd7ef73c$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $07aa6edacd7ef73c$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $07aa6edacd7ef73c$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$07aa6edacd7ef73c$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $07aa6edacd7ef73c$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $07aa6edacd7ef73c$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$07aa6edacd7ef73c$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $07aa6edacd7ef73c$var$nullifyElement(element);
    } else if ($07aa6edacd7ef73c$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $07aa6edacd7ef73c$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $07aa6edacd7ef73c$var$prefix(value, length) {
    switch((0, $fngFU.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $fngFU.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $fngFU.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $fngFU.WEBKIT) + value + (0, $fngFU.MOZ) + value + (0, $fngFU.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $fngFU.WEBKIT) + value + (0, $fngFU.MS) + value + value;
        // order
        case 6165:
            return (0, $fngFU.WEBKIT) + value + (0, $fngFU.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $fngFU.WEBKIT) + value + (0, $fngFU.replace)(value, /(\w+).+(:[^]+)/, (0, $fngFU.WEBKIT) + "box-$1$2" + (0, $fngFU.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $fngFU.WEBKIT) + value + (0, $fngFU.MS) + "flex-item-" + (0, $fngFU.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $fngFU.WEBKIT) + value + (0, $fngFU.MS) + "flex-line-pack" + (0, $fngFU.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $fngFU.WEBKIT) + value + (0, $fngFU.MS) + (0, $fngFU.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $fngFU.WEBKIT) + value + (0, $fngFU.MS) + (0, $fngFU.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $fngFU.WEBKIT) + "box-" + (0, $fngFU.replace)(value, "-grow", "") + (0, $fngFU.WEBKIT) + value + (0, $fngFU.MS) + (0, $fngFU.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $fngFU.WEBKIT) + (0, $fngFU.replace)(value, /([^-])(transform)/g, "$1" + (0, $fngFU.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $fngFU.replace)((0, $fngFU.replace)((0, $fngFU.replace)(value, /(zoom-|grab)/, (0, $fngFU.WEBKIT) + "$1"), /(image-set)/, (0, $fngFU.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $fngFU.replace)(value, /(image-set\([^]*)/, (0, $fngFU.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $fngFU.replace)((0, $fngFU.replace)(value, /(.+:)(flex-)?(.*)/, (0, $fngFU.WEBKIT) + "box-pack:$3" + (0, $fngFU.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $fngFU.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $fngFU.replace)(value, /(.+)-inline(.+)/, (0, $fngFU.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $fngFU.strlen)(value) - 1 - length > 6) switch((0, $fngFU.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $fngFU.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $fngFU.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $fngFU.WEBKIT) + "$2-$3" + "$1" + (0, $fngFU.MOZ) + ((0, $fngFU.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $fngFU.indexof)(value, "stretch") ? $07aa6edacd7ef73c$var$prefix((0, $fngFU.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $fngFU.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $fngFU.charat)(value, (0, $fngFU.strlen)(value) - 3 - (~(0, $fngFU.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $fngFU.replace)(value, ":", ":" + (0, $fngFU.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $fngFU.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $fngFU.WEBKIT) + ((0, $fngFU.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $fngFU.WEBKIT) + "$2$3" + "$1" + (0, $fngFU.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $fngFU.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $fngFU.WEBKIT) + value + (0, $fngFU.MS) + (0, $fngFU.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $fngFU.WEBKIT) + value + (0, $fngFU.MS) + (0, $fngFU.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $fngFU.WEBKIT) + value + (0, $fngFU.MS) + (0, $fngFU.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $fngFU.WEBKIT) + value + (0, $fngFU.MS) + value + value;
    }
    return value;
}
var $07aa6edacd7ef73c$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $fngFU.DECLARATION:
                element["return"] = $07aa6edacd7ef73c$var$prefix(element.value, element.length);
                break;
            case 0, $fngFU.KEYFRAMES:
                return (0, $fngFU.serialize)([
                    (0, $fngFU.copy)(element, {
                        value: (0, $fngFU.replace)(element.value, "@", "@" + (0, $fngFU.WEBKIT))
                    })
                ], callback);
            case 0, $fngFU.RULESET:
                if (element.length) return (0, $fngFU.combine)(element.props, function(value) {
                    switch((0, $fngFU.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $fngFU.serialize)([
                                (0, $fngFU.copy)(element, {
                                    props: [
                                        (0, $fngFU.replace)(value, /:(read-\w+)/, ":" + (0, $fngFU.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $fngFU.serialize)([
                                (0, $fngFU.copy)(element, {
                                    props: [
                                        (0, $fngFU.replace)(value, /:(plac\w+)/, ":" + (0, $fngFU.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $fngFU.copy)(element, {
                                    props: [
                                        (0, $fngFU.replace)(value, /:(plac\w+)/, ":" + (0, $fngFU.MOZ) + "$1")
                                    ]
                                }),
                                (0, $fngFU.copy)(element, {
                                    props: [
                                        (0, $fngFU.replace)(value, /:(plac\w+)/, (0, $fngFU.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $07aa6edacd7ef73c$var$defaultStylisPlugins = [
    $07aa6edacd7ef73c$var$prefixer
];
var $07aa6edacd7ef73c$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $07aa6edacd7ef73c$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $07aa6edacd7ef73c$var$compat,
        $07aa6edacd7ef73c$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $fngFU.stringify),
        (0, $fngFU.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $fngFU.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $fngFU.serialize)((0, $fngFU.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $7tb12.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRequire.register("7tb12", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $5703c94efe5a5736$export$9d753cd7ae895cce);
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $5703c94efe5a5736$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $5703c94efe5a5736$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $5703c94efe5a5736$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($5703c94efe5a5736$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $5703c94efe5a5736$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRequire.register("fngFU", function(module, exports) {

$parcel$export(module.exports, "MS", () => $635154939f115572$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $635154939f115572$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $635154939f115572$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $635154939f115572$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $635154939f115572$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $635154939f115572$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $635154939f115572$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $635154939f115572$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $635154939f115572$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $635154939f115572$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $635154939f115572$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $635154939f115572$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $635154939f115572$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $635154939f115572$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $635154939f115572$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $635154939f115572$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $635154939f115572$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $635154939f115572$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $635154939f115572$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $635154939f115572$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $635154939f115572$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $635154939f115572$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $635154939f115572$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $635154939f115572$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $635154939f115572$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $635154939f115572$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $635154939f115572$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $635154939f115572$export$38bcb760f1d4871c);
var $635154939f115572$export$71ad59f2e432cfe8 = "-ms-";
var $635154939f115572$export$2c0f367103c8d01c = "-moz-";
var $635154939f115572$export$39dfd62a25e0fe93 = "-webkit-";
var $635154939f115572$export$a29989082612d0d9 = "comm";
var $635154939f115572$export$aa3a2e812ca8570d = "rule";
var $635154939f115572$export$527d108ccf083c2b = "decl";
var $635154939f115572$export$d3d35020fa5b54f0 = "@page";
var $635154939f115572$export$500415a86c544f73 = "@media";
var $635154939f115572$export$a763edbf796b780a = "@import";
var $635154939f115572$export$2790aeb8b4e5c826 = "@charset";
var $635154939f115572$export$1cc683e23b84b133 = "@viewport";
var $635154939f115572$export$9447a5efea57e862 = "@supports";
var $635154939f115572$export$ef011b4e114b1fba = "@document";
var $635154939f115572$export$6aad947bda0f3f46 = "@namespace";
var $635154939f115572$export$b44a8529a35fcb60 = "@keyframes";
var $635154939f115572$export$2c16de31893252e6 = "@font-face";
var $635154939f115572$export$3d846dd52e150c6f = "@counter-style";
var $635154939f115572$export$22314bfbb57653fe = "@font-feature-values";
var $635154939f115572$export$d773506282b3cfe6 = "@layer";
var $635154939f115572$export$2335f513bbd82c6d = Math.abs;
var $635154939f115572$export$6788812c4e6611e6 = String.fromCharCode;
var $635154939f115572$export$e6e34fd1f2686227 = Object.assign;
function $635154939f115572$export$d6af199866bfb566(e, r) {
    return $635154939f115572$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $635154939f115572$export$a9db5e087081082d(e, 0)) << 2 ^ $635154939f115572$export$a9db5e087081082d(e, 1)) << 2 ^ $635154939f115572$export$a9db5e087081082d(e, 2)) << 2 ^ $635154939f115572$export$a9db5e087081082d(e, 3) : 0;
}
function $635154939f115572$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $635154939f115572$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $635154939f115572$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $635154939f115572$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $635154939f115572$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $635154939f115572$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $635154939f115572$export$36776f635604f274(e) {
    return e.length;
}
function $635154939f115572$export$f9084667e487ed46(e) {
    return e.length;
}
function $635154939f115572$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $635154939f115572$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $635154939f115572$export$53f1d5ea8de3d7c = 1;
var $635154939f115572$export$4e0c71f277ca26b3 = 1;
var $635154939f115572$export$f24224f1c91d8156 = 0;
var $635154939f115572$export$5880b8b5730aff45 = 0;
var $635154939f115572$export$c0306caf338ac095 = 0;
var $635154939f115572$export$30a86d91af8ff6e6 = "";
function $635154939f115572$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $635154939f115572$export$53f1d5ea8de3d7c,
        column: $635154939f115572$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $635154939f115572$export$784d13d8ee351f07(e, r) {
    return $635154939f115572$export$e6e34fd1f2686227($635154939f115572$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $635154939f115572$export$eba6f6f03b0a92e7() {
    return $635154939f115572$export$c0306caf338ac095;
}
function $635154939f115572$export$232faf9add678146() {
    $635154939f115572$export$c0306caf338ac095 = $635154939f115572$export$5880b8b5730aff45 > 0 ? $635154939f115572$export$a9db5e087081082d($635154939f115572$export$30a86d91af8ff6e6, --$635154939f115572$export$5880b8b5730aff45) : 0;
    if ($635154939f115572$export$4e0c71f277ca26b3--, $635154939f115572$export$c0306caf338ac095 === 10) $635154939f115572$export$4e0c71f277ca26b3 = 1, $635154939f115572$export$53f1d5ea8de3d7c--;
    return $635154939f115572$export$c0306caf338ac095;
}
function $635154939f115572$export$48cfd1e771a65c4f() {
    $635154939f115572$export$c0306caf338ac095 = $635154939f115572$export$5880b8b5730aff45 < $635154939f115572$export$f24224f1c91d8156 ? $635154939f115572$export$a9db5e087081082d($635154939f115572$export$30a86d91af8ff6e6, $635154939f115572$export$5880b8b5730aff45++) : 0;
    if ($635154939f115572$export$4e0c71f277ca26b3++, $635154939f115572$export$c0306caf338ac095 === 10) $635154939f115572$export$4e0c71f277ca26b3 = 1, $635154939f115572$export$53f1d5ea8de3d7c++;
    return $635154939f115572$export$c0306caf338ac095;
}
function $635154939f115572$export$4d3fb11e950abb9e() {
    return $635154939f115572$export$a9db5e087081082d($635154939f115572$export$30a86d91af8ff6e6, $635154939f115572$export$5880b8b5730aff45);
}
function $635154939f115572$export$e88cb2efb12ae807() {
    return $635154939f115572$export$5880b8b5730aff45;
}
function $635154939f115572$export$58adb3bec8346d0f(e, r) {
    return $635154939f115572$export$2f35ab04d2335697($635154939f115572$export$30a86d91af8ff6e6, e, r);
}
function $635154939f115572$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $635154939f115572$export$2de70f21292aac9e(e) {
    return $635154939f115572$export$53f1d5ea8de3d7c = $635154939f115572$export$4e0c71f277ca26b3 = 1, $635154939f115572$export$f24224f1c91d8156 = $635154939f115572$export$36776f635604f274($635154939f115572$export$30a86d91af8ff6e6 = e), $635154939f115572$export$5880b8b5730aff45 = 0, [];
}
function $635154939f115572$export$45918ac1574455b1(e) {
    return $635154939f115572$export$30a86d91af8ff6e6 = "", e;
}
function $635154939f115572$export$410ac95b9ec204b8(e) {
    return $635154939f115572$export$87c2784dc9fc4ab($635154939f115572$export$58adb3bec8346d0f($635154939f115572$export$5880b8b5730aff45 - 1, $635154939f115572$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $635154939f115572$export$660b2ee2d4fb4eff(e) {
    return $635154939f115572$export$45918ac1574455b1($635154939f115572$export$5f8c09e3ae6f64e1($635154939f115572$export$2de70f21292aac9e(e)));
}
function $635154939f115572$export$7af1228ff777d175(e) {
    while($635154939f115572$export$c0306caf338ac095 = $635154939f115572$export$4d3fb11e950abb9e())if ($635154939f115572$export$c0306caf338ac095 < 33) $635154939f115572$export$48cfd1e771a65c4f();
    else break;
    return $635154939f115572$export$9e1725a4cfeada27(e) > 2 || $635154939f115572$export$9e1725a4cfeada27($635154939f115572$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $635154939f115572$export$5f8c09e3ae6f64e1(e) {
    while($635154939f115572$export$48cfd1e771a65c4f())switch($635154939f115572$export$9e1725a4cfeada27($635154939f115572$export$c0306caf338ac095)){
        case 0:
            $635154939f115572$export$10d8903dec122b9d($635154939f115572$export$c2ab62c7bf24634($635154939f115572$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $635154939f115572$export$10d8903dec122b9d($635154939f115572$export$410ac95b9ec204b8($635154939f115572$export$c0306caf338ac095), e);
            break;
        default:
            $635154939f115572$export$10d8903dec122b9d($635154939f115572$export$6788812c4e6611e6($635154939f115572$export$c0306caf338ac095), e);
    }
    return e;
}
function $635154939f115572$export$955ba06d119e085e(e, r) {
    while(--r && $635154939f115572$export$48cfd1e771a65c4f())if ($635154939f115572$export$c0306caf338ac095 < 48 || $635154939f115572$export$c0306caf338ac095 > 102 || $635154939f115572$export$c0306caf338ac095 > 57 && $635154939f115572$export$c0306caf338ac095 < 65 || $635154939f115572$export$c0306caf338ac095 > 70 && $635154939f115572$export$c0306caf338ac095 < 97) break;
    return $635154939f115572$export$58adb3bec8346d0f(e, $635154939f115572$export$e88cb2efb12ae807() + (r < 6 && $635154939f115572$export$4d3fb11e950abb9e() == 32 && $635154939f115572$export$48cfd1e771a65c4f() == 32));
}
function $635154939f115572$export$c889f2fcc19dbf12(e) {
    while($635154939f115572$export$48cfd1e771a65c4f())switch($635154939f115572$export$c0306caf338ac095){
        case e:
            return $635154939f115572$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $635154939f115572$export$c889f2fcc19dbf12($635154939f115572$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $635154939f115572$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $635154939f115572$export$48cfd1e771a65c4f();
            break;
    }
    return $635154939f115572$export$5880b8b5730aff45;
}
function $635154939f115572$export$4254d4e2b3745c4c(e, r) {
    while($635154939f115572$export$48cfd1e771a65c4f())if (e + $635154939f115572$export$c0306caf338ac095 === 57) break;
    else if (e + $635154939f115572$export$c0306caf338ac095 === 84 && $635154939f115572$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $635154939f115572$export$58adb3bec8346d0f(r, $635154939f115572$export$5880b8b5730aff45 - 1) + "*" + $635154939f115572$export$6788812c4e6611e6(e === 47 ? e : $635154939f115572$export$48cfd1e771a65c4f());
}
function $635154939f115572$export$c2ab62c7bf24634(e) {
    while(!$635154939f115572$export$9e1725a4cfeada27($635154939f115572$export$4d3fb11e950abb9e()))$635154939f115572$export$48cfd1e771a65c4f();
    return $635154939f115572$export$58adb3bec8346d0f(e, $635154939f115572$export$5880b8b5730aff45);
}
function $635154939f115572$export$ef7acd7185315e22(e) {
    return $635154939f115572$export$45918ac1574455b1($635154939f115572$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $635154939f115572$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $635154939f115572$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $635154939f115572$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $635154939f115572$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($635154939f115572$export$f8e21b1e77979a08(j += $635154939f115572$export$77ad94ebf1c2b9ed($635154939f115572$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $635154939f115572$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $635154939f115572$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $635154939f115572$export$955ba06d119e085e($635154939f115572$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($635154939f115572$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $635154939f115572$export$10d8903dec122b9d($635154939f115572$export$4a34f930e789283c($635154939f115572$export$4254d4e2b3745c4c($635154939f115572$export$48cfd1e771a65c4f(), $635154939f115572$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $635154939f115572$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $635154939f115572$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $635154939f115572$export$36776f635604f274(j) - l) $635154939f115572$export$10d8903dec122b9d(p > 32 ? $635154939f115572$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $635154939f115572$export$f8483753829ec8f3($635154939f115572$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $635154939f115572$export$10d8903dec122b9d(y = $635154939f115572$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $635154939f115572$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $635154939f115572$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $635154939f115572$export$98e6a39c04603d36(e, y, y, n && $635154939f115572$export$10d8903dec122b9d($635154939f115572$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $635154939f115572$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $635154939f115572$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $635154939f115572$export$232faf9add678146() == 125) continue;
            }
            switch(j += $635154939f115572$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($635154939f115572$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($635154939f115572$export$4d3fb11e950abb9e() === 45) j += $635154939f115572$export$410ac95b9ec204b8($635154939f115572$export$48cfd1e771a65c4f());
                    v = $635154939f115572$export$4d3fb11e950abb9e(), o = l = $635154939f115572$export$36776f635604f274(g = j += $635154939f115572$export$c2ab62c7bf24634($635154939f115572$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $635154939f115572$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $635154939f115572$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $635154939f115572$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $635154939f115572$export$2f35ab04d2335697(e, v + 1, v = $635154939f115572$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $635154939f115572$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $635154939f115572$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $635154939f115572$export$35059013cd4a06db(e, r, a, s === 0 ? $635154939f115572$export$aa3a2e812ca8570d : i, f, o, l);
}
function $635154939f115572$export$4a34f930e789283c(e, r, a) {
    return $635154939f115572$export$35059013cd4a06db(e, r, a, $635154939f115572$export$a29989082612d0d9, $635154939f115572$export$6788812c4e6611e6($635154939f115572$export$eba6f6f03b0a92e7()), $635154939f115572$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $635154939f115572$export$f8483753829ec8f3(e, r, a, n) {
    return $635154939f115572$export$35059013cd4a06db(e, r, a, $635154939f115572$export$527d108ccf083c2b, $635154939f115572$export$2f35ab04d2335697(e, 0, n), $635154939f115572$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $635154939f115572$export$82e9f45cca5ba907(n, c, s) {
    switch($635154939f115572$export$d6af199866bfb566(n, c)){
        case 5103:
            return $635154939f115572$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $635154939f115572$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $635154939f115572$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $635154939f115572$export$39dfd62a25e0fe93 + n + $635154939f115572$export$2c0f367103c8d01c + n + $635154939f115572$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($635154939f115572$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $635154939f115572$export$39dfd62a25e0fe93 + n + $635154939f115572$export$71ad59f2e432cfe8 + $635154939f115572$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $635154939f115572$export$39dfd62a25e0fe93 + n + $635154939f115572$export$71ad59f2e432cfe8 + $635154939f115572$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $635154939f115572$export$39dfd62a25e0fe93 + n + $635154939f115572$export$71ad59f2e432cfe8 + $635154939f115572$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $635154939f115572$export$39dfd62a25e0fe93 + n + $635154939f115572$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $635154939f115572$export$39dfd62a25e0fe93 + n + $635154939f115572$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $635154939f115572$export$39dfd62a25e0fe93 + n + $635154939f115572$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $635154939f115572$export$39dfd62a25e0fe93 + "box-$1$2" + $635154939f115572$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $635154939f115572$export$39dfd62a25e0fe93 + n + $635154939f115572$export$71ad59f2e432cfe8 + "flex-item-" + $635154939f115572$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$635154939f115572$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $635154939f115572$export$71ad59f2e432cfe8 + "grid-row-" + $635154939f115572$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $635154939f115572$export$39dfd62a25e0fe93 + n + $635154939f115572$export$71ad59f2e432cfe8 + "flex-line-pack" + $635154939f115572$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $635154939f115572$export$39dfd62a25e0fe93 + n + $635154939f115572$export$71ad59f2e432cfe8 + $635154939f115572$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $635154939f115572$export$39dfd62a25e0fe93 + n + $635154939f115572$export$71ad59f2e432cfe8 + $635154939f115572$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $635154939f115572$export$39dfd62a25e0fe93 + "box-" + $635154939f115572$export$77ad94ebf1c2b9ed(n, "-grow", "") + $635154939f115572$export$39dfd62a25e0fe93 + n + $635154939f115572$export$71ad59f2e432cfe8 + $635154939f115572$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $635154939f115572$export$39dfd62a25e0fe93 + $635154939f115572$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $635154939f115572$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $635154939f115572$export$77ad94ebf1c2b9ed($635154939f115572$export$77ad94ebf1c2b9ed($635154939f115572$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $635154939f115572$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $635154939f115572$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $635154939f115572$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $635154939f115572$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $635154939f115572$export$77ad94ebf1c2b9ed($635154939f115572$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $635154939f115572$export$39dfd62a25e0fe93 + "box-pack:$3" + $635154939f115572$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $635154939f115572$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$635154939f115572$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $635154939f115572$export$71ad59f2e432cfe8 + "grid-column-align" + $635154939f115572$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $635154939f115572$export$71ad59f2e432cfe8 + $635154939f115572$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $635154939f115572$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$635154939f115572$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $635154939f115572$export$71ad59f2e432cfe8 + $635154939f115572$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $635154939f115572$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$635154939f115572$export$f8e21b1e77979a08(s, "span") ? $635154939f115572$export$4659b591c19bdf3d(s, /\d+/) : +$635154939f115572$export$4659b591c19bdf3d(s, /\d+/) - +$635154939f115572$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $635154939f115572$export$71ad59f2e432cfe8 + $635154939f115572$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $635154939f115572$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $635154939f115572$export$71ad59f2e432cfe8 + $635154939f115572$export$77ad94ebf1c2b9ed($635154939f115572$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $635154939f115572$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $635154939f115572$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($635154939f115572$export$36776f635604f274(n) - 1 - c > 6) switch($635154939f115572$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($635154939f115572$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $635154939f115572$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $635154939f115572$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $635154939f115572$export$2c0f367103c8d01c + ($635154939f115572$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$635154939f115572$export$f8e21b1e77979a08(n, "stretch") ? $635154939f115572$export$82e9f45cca5ba907($635154939f115572$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $635154939f115572$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $635154939f115572$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $635154939f115572$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($635154939f115572$export$a9db5e087081082d(n, c + 6) === 121) return $635154939f115572$export$77ad94ebf1c2b9ed(n, ":", ":" + $635154939f115572$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($635154939f115572$export$a9db5e087081082d(n, $635154939f115572$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $635154939f115572$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $635154939f115572$export$39dfd62a25e0fe93 + ($635154939f115572$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $635154939f115572$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $635154939f115572$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $635154939f115572$export$77ad94ebf1c2b9ed(n, ":", ":" + $635154939f115572$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $635154939f115572$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $635154939f115572$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $635154939f115572$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $635154939f115572$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $635154939f115572$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $635154939f115572$export$a763edbf796b780a:
        case $635154939f115572$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $635154939f115572$export$a29989082612d0d9:
            return "";
        case $635154939f115572$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $635154939f115572$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $635154939f115572$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $635154939f115572$export$36776f635604f274(a = $635154939f115572$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $635154939f115572$export$5a7767152ae0305f(e) {
    var r = $635154939f115572$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $635154939f115572$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $635154939f115572$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $635154939f115572$export$527d108ccf083c2b:
                n.return = $635154939f115572$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $635154939f115572$export$b44a8529a35fcb60:
                return $635154939f115572$export$dfdc1655ccc5b9cb([
                    $635154939f115572$export$784d13d8ee351f07(n, {
                        value: $635154939f115572$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $635154939f115572$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $635154939f115572$export$aa3a2e812ca8570d:
                if (n.length) return $635154939f115572$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($635154939f115572$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $635154939f115572$export$dfdc1655ccc5b9cb([
                                $635154939f115572$export$784d13d8ee351f07(n, {
                                    props: [
                                        $635154939f115572$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $635154939f115572$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $635154939f115572$export$dfdc1655ccc5b9cb([
                                $635154939f115572$export$784d13d8ee351f07(n, {
                                    props: [
                                        $635154939f115572$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $635154939f115572$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $635154939f115572$export$784d13d8ee351f07(n, {
                                    props: [
                                        $635154939f115572$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $635154939f115572$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $635154939f115572$export$784d13d8ee351f07(n, {
                                    props: [
                                        $635154939f115572$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $635154939f115572$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $635154939f115572$export$76a88f7de6507443(e) {
    switch(e.type){
        case $635154939f115572$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $635154939f115572$export$1be1fc439b849fdf($635154939f115572$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($635154939f115572$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $635154939f115572$export$2f35ab04d2335697(r, 1, $635154939f115572$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $635154939f115572$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $635154939f115572$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $635154939f115572$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRequire.register("k1u8s", function(module, exports) {

$parcel$export(module.exports, "default", () => $e93b46e82ed3c6c3$export$2e2bcd8739ae039);
var $e93b46e82ed3c6c3$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRequire.register("1qjjx", function(module, exports) {

$parcel$export(module.exports, "default", () => $1097338b053b6602$export$2e2bcd8739ae039);
function $1097338b053b6602$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRequire.register("ffPGT", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1b05a73b2b1f1a2$export$2e2bcd8739ae039);

var $gmH6s = parcelRequire("gmH6s");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $b1b05a73b2b1f1a2$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($gmH6s)))(targetComponent, sourceComponent);
};

});
parcelRequire.register("gmH6s", function(module, exports) {
"use strict";

var $egPjB = parcelRequire("egPjB");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $bea022d38c8f8ab9$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $bea022d38c8f8ab9$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $bea022d38c8f8ab9$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $bea022d38c8f8ab9$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $bea022d38c8f8ab9$var$TYPE_STATICS = {};
$bea022d38c8f8ab9$var$TYPE_STATICS[$egPjB.ForwardRef] = $bea022d38c8f8ab9$var$FORWARD_REF_STATICS;
$bea022d38c8f8ab9$var$TYPE_STATICS[$egPjB.Memo] = $bea022d38c8f8ab9$var$MEMO_STATICS;
function $bea022d38c8f8ab9$var$getStatics(component) {
    // React v16.11 and below
    if ($egPjB.isMemo(component)) return $bea022d38c8f8ab9$var$MEMO_STATICS;
     // React v16.12 and above
    return $bea022d38c8f8ab9$var$TYPE_STATICS[component["$$typeof"]] || $bea022d38c8f8ab9$var$REACT_STATICS;
}
var $bea022d38c8f8ab9$var$defineProperty = Object.defineProperty;
var $bea022d38c8f8ab9$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $bea022d38c8f8ab9$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $bea022d38c8f8ab9$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $bea022d38c8f8ab9$var$getPrototypeOf = Object.getPrototypeOf;
var $bea022d38c8f8ab9$var$objectPrototype = Object.prototype;
function $bea022d38c8f8ab9$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($bea022d38c8f8ab9$var$objectPrototype) {
            var inheritedComponent = $bea022d38c8f8ab9$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $bea022d38c8f8ab9$var$objectPrototype) $bea022d38c8f8ab9$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $bea022d38c8f8ab9$var$getOwnPropertyNames(sourceComponent);
        if ($bea022d38c8f8ab9$var$getOwnPropertySymbols) keys = keys.concat($bea022d38c8f8ab9$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $bea022d38c8f8ab9$var$getStatics(targetComponent);
        var sourceStatics = $bea022d38c8f8ab9$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$bea022d38c8f8ab9$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $bea022d38c8f8ab9$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $bea022d38c8f8ab9$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $bea022d38c8f8ab9$var$hoistNonReactStatics;

});
parcelRequire.register("egPjB", function(module, exports) {
"use strict";

module.exports = (parcelRequire("dkyoU"));

});



parcelRequire.register("257EV", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $1841fd5010e9667a$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $1841fd5010e9667a$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $1841fd5010e9667a$export$6f077d94b33a01aa);
var $1841fd5010e9667a$var$isBrowser = true;
function $1841fd5010e9667a$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $1841fd5010e9667a$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $1841fd5010e9667a$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $1841fd5010e9667a$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $1841fd5010e9667a$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRequire.register("fRUBy", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $b8d7b6caae62c89e$export$6321afa313b251b5);

var $3rmoE = parcelRequire("3rmoE");

var $g0Xb1 = parcelRequire("g0Xb1");

var $1qjjx = parcelRequire("1qjjx");
var $b8d7b6caae62c89e$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $b8d7b6caae62c89e$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $b8d7b6caae62c89e$var$hyphenateRegex = /[A-Z]|^ms/g;
var $b8d7b6caae62c89e$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $b8d7b6caae62c89e$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $b8d7b6caae62c89e$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $b8d7b6caae62c89e$var$processStyleName = /* #__PURE__ */ (0, $1qjjx.default)(function(styleName) {
    return $b8d7b6caae62c89e$var$isCustomProperty(styleName) ? styleName : styleName.replace($b8d7b6caae62c89e$var$hyphenateRegex, "-$&").toLowerCase();
});
var $b8d7b6caae62c89e$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($b8d7b6caae62c89e$var$animationRegex, function(match, p1, p2) {
                $b8d7b6caae62c89e$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $b8d7b6caae62c89e$var$cursor
                };
                return p1;
            });
    }
    if ((0, $g0Xb1.default)[key] !== 1 && !$b8d7b6caae62c89e$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $b8d7b6caae62c89e$var$contentValuePattern, $b8d7b6caae62c89e$var$contentValues, $b8d7b6caae62c89e$var$oldProcessStyleValue, $b8d7b6caae62c89e$var$msPattern, $b8d7b6caae62c89e$var$hyphenPattern, $b8d7b6caae62c89e$var$hyphenatedCache;
var $b8d7b6caae62c89e$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $b8d7b6caae62c89e$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $b8d7b6caae62c89e$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $b8d7b6caae62c89e$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $b8d7b6caae62c89e$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $b8d7b6caae62c89e$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $b8d7b6caae62c89e$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $b8d7b6caae62c89e$var$cursor;
                var result = interpolation(mergedProps);
                $b8d7b6caae62c89e$var$cursor = previousCursor;
                return $b8d7b6caae62c89e$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $b8d7b6caae62c89e$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $b8d7b6caae62c89e$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($b8d7b6caae62c89e$var$isProcessableValue(value)) string += $b8d7b6caae62c89e$var$processStyleName(_key) + ":" + $b8d7b6caae62c89e$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($b8d7b6caae62c89e$var$isProcessableValue(value[_i])) string += $b8d7b6caae62c89e$var$processStyleName(_key) + ":" + $b8d7b6caae62c89e$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $b8d7b6caae62c89e$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $b8d7b6caae62c89e$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $b8d7b6caae62c89e$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $b8d7b6caae62c89e$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $b8d7b6caae62c89e$var$cursor;
var $b8d7b6caae62c89e$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $b8d7b6caae62c89e$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $b8d7b6caae62c89e$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $b8d7b6caae62c89e$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $b8d7b6caae62c89e$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $b8d7b6caae62c89e$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $3rmoE.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $b8d7b6caae62c89e$var$cursor
    };
};

});
parcelRequire.register("3rmoE", function(module, exports) {

$parcel$export(module.exports, "default", () => $28154432bce43299$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $28154432bce43299$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRequire.register("g0Xb1", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba8a8caf5ea87b2f$export$2e2bcd8739ae039);
var $ba8a8caf5ea87b2f$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRequire.register("92M4l", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $695996803c5147ee$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $695996803c5147ee$export$811a713a7276cb9d);

var $1bdO8 = parcelRequire("1bdO8");
var $695996803c5147ee$var$syncFallback = function syncFallback(create) {
    return create();
};
var $695996803c5147ee$var$useInsertionEffect = $1bdO8.useInsertionEffect ? $1bdO8.useInsertionEffect : false;
var $695996803c5147ee$export$db21c7ffa21794e7 = $695996803c5147ee$var$useInsertionEffect || $695996803c5147ee$var$syncFallback;
var $695996803c5147ee$export$811a713a7276cb9d = $695996803c5147ee$var$useInsertionEffect || $1bdO8.useLayoutEffect;

});


parcelRequire.register("4pGln", function(module, exports) {
function $336a57cf560742d5$var$_extends() {
    module.exports = $336a57cf560742d5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $336a57cf560742d5$var$_extends.apply(this, arguments);
}
module.exports = $336a57cf560742d5$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRequire.register("5VMQ9", function(module, exports) {

$parcel$export(module.exports, "default", () => $4518294396969f5c$export$2e2bcd8739ae039);

var $1pZEV = parcelRequire("1pZEV");
const $4518294396969f5c$var$defaultTheme = (0, $1pZEV.default)();
var $4518294396969f5c$export$2e2bcd8739ae039 = $4518294396969f5c$var$defaultTheme;

});
parcelRequire.register("1pZEV", function(module, exports) {

$parcel$export(module.exports, "default", () => $1087f478a7845bde$export$2e2bcd8739ae039);

var $63nUy = parcelRequire("63nUy");

var $fZ2DJ = parcelRequire("fZ2DJ");

var $1nBS8 = parcelRequire("1nBS8");
var $7xoNL = parcelRequire("7xoNL");

var $1iZe2 = parcelRequire("1iZe2");
var $k5Vxs = parcelRequire("k5Vxs");
var $70fZE = parcelRequire("70fZE");


var $lltAn = parcelRequire("lltAn");

var $erUIb = parcelRequire("erUIb");

var $2wrLa = parcelRequire("2wrLa");

var $gG4Ht = parcelRequire("gG4Ht");

var $ecz5v = parcelRequire("ecz5v");

var $toXP4 = parcelRequire("toXP4");
const $1087f478a7845bde$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $1087f478a7845bde$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {} , palette: paletteInput = {} , transitions: transitionsInput = {} , typography: typographyInput = {}  } = options, other = (0, $fZ2DJ.default)(options, $1087f478a7845bde$var$_excluded);
    if (options.vars) throw new Error((0, $7xoNL.default)(18));
    const palette = (0, $erUIb.default)(paletteInput);
    const systemTheme = (0, $1iZe2.default)(options);
    let muiTheme = (0, $1nBS8.default)(systemTheme, {
        mixins: (0, $lltAn.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $gG4Ht.default).slice(),
        typography: (0, $2wrLa.default)(palette, typographyInput),
        transitions: (0, $ecz5v.default)(transitionsInput),
        zIndex: (0, $63nUy.default)({}, (0, $toXP4.default))
    });
    muiTheme = (0, $1nBS8.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $1nBS8.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $63nUy.default)({}, (0, $k5Vxs.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $70fZE.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $1087f478a7845bde$var$warnedOnce = false;
function $1087f478a7845bde$export$c469355549431d9b(...args) {
    return $1087f478a7845bde$var$createTheme(...args);
}
var $1087f478a7845bde$export$2e2bcd8739ae039 = $1087f478a7845bde$var$createTheme;

});
parcelRequire.register("lltAn", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8a2823f3f4db4b0$export$2e2bcd8739ae039);

var $63nUy = parcelRequire("63nUy");
function $f8a2823f3f4db4b0$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $63nUy.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRequire.register("erUIb", function(module, exports) {

$parcel$export(module.exports, "default", () => $a84f940d7e46664a$export$2e2bcd8739ae039);

var $63nUy = parcelRequire("63nUy");

var $fZ2DJ = parcelRequire("fZ2DJ");

var $1nBS8 = parcelRequire("1nBS8");
var $7xoNL = parcelRequire("7xoNL");

var $b8tOr = parcelRequire("b8tOr");

var $1Avk6 = parcelRequire("1Avk6");

var $bWWR4 = parcelRequire("bWWR4");

var $hgmuN = parcelRequire("hgmuN");

var $8JSUZ = parcelRequire("8JSUZ");

var $jQqby = parcelRequire("jQqby");

var $gSyx1 = parcelRequire("gSyx1");

var $k1xCd = parcelRequire("k1xCd");

var $io14o = parcelRequire("io14o");
const $a84f940d7e46664a$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $a84f940d7e46664a$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $1Avk6.default).white,
        default: (0, $1Avk6.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $a84f940d7e46664a$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $1Avk6.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, $1Avk6.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $a84f940d7e46664a$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $b8tOr.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $b8tOr.darken)(intent.main, tonalOffsetDark);
    }
}
function $a84f940d7e46664a$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $gSyx1.default)[200],
        light: (0, $gSyx1.default)[50],
        dark: (0, $gSyx1.default)[400]
    };
    return {
        main: (0, $gSyx1.default)[700],
        light: (0, $gSyx1.default)[400],
        dark: (0, $gSyx1.default)[800]
    };
}
function $a84f940d7e46664a$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $hgmuN.default)[200],
        light: (0, $hgmuN.default)[50],
        dark: (0, $hgmuN.default)[400]
    };
    return {
        main: (0, $hgmuN.default)[500],
        light: (0, $hgmuN.default)[300],
        dark: (0, $hgmuN.default)[700]
    };
}
function $a84f940d7e46664a$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $8JSUZ.default)[500],
        light: (0, $8JSUZ.default)[300],
        dark: (0, $8JSUZ.default)[700]
    };
    return {
        main: (0, $8JSUZ.default)[700],
        light: (0, $8JSUZ.default)[400],
        dark: (0, $8JSUZ.default)[800]
    };
}
function $a84f940d7e46664a$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $k1xCd.default)[400],
        light: (0, $k1xCd.default)[300],
        dark: (0, $k1xCd.default)[700]
    };
    return {
        main: (0, $k1xCd.default)[700],
        light: (0, $k1xCd.default)[500],
        dark: (0, $k1xCd.default)[900]
    };
}
function $a84f940d7e46664a$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $io14o.default)[400],
        light: (0, $io14o.default)[300],
        dark: (0, $io14o.default)[700]
    };
    return {
        main: (0, $io14o.default)[800],
        light: (0, $io14o.default)[500],
        dark: (0, $io14o.default)[900]
    };
}
function $a84f940d7e46664a$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $jQqby.default)[400],
        light: (0, $jQqby.default)[300],
        dark: (0, $jQqby.default)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $jQqby.default)[500],
        dark: (0, $jQqby.default)[900]
    };
}
function $a84f940d7e46664a$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light" , contrastThreshold: contrastThreshold = 3 , tonalOffset: tonalOffset = 0.2  } = palette, other = (0, $fZ2DJ.default)(palette, $a84f940d7e46664a$var$_excluded);
    const primary = palette.primary || $a84f940d7e46664a$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $a84f940d7e46664a$var$getDefaultSecondary(mode);
    const error = palette.error || $a84f940d7e46664a$var$getDefaultError(mode);
    const info = palette.info || $a84f940d7e46664a$var$getDefaultInfo(mode);
    const success = palette.success || $a84f940d7e46664a$var$getDefaultSuccess(mode);
    const warning = palette.warning || $a84f940d7e46664a$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $b8tOr.getContrastRatio)(background, $a84f940d7e46664a$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $a84f940d7e46664a$export$55ce6f3a06c59543.text.primary : $a84f940d7e46664a$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color , name: name , mainShade: mainShade = 500 , lightShade: lightShade = 300 , darkShade: darkShade = 700  })=>{
        color = (0, $63nUy.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $7xoNL.default)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $7xoNL.default)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        $a84f940d7e46664a$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $a84f940d7e46664a$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $a84f940d7e46664a$export$55ce6f3a06c59543,
        light: $a84f940d7e46664a$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $1nBS8.default)((0, $63nUy.default)({
        // A collection of common colors.
        common: (0, $63nUy.default)({}, (0, $1Avk6.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $bWWR4.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRequire.register("b8tOr", function(module, exports) {

$parcel$export(module.exports, "getContrastRatio", () => $81b79135415c645e$export$d061e26956a60b0a);
$parcel$export(module.exports, "alpha", () => $81b79135415c645e$export$58f0f39f63f3cf42);
$parcel$export(module.exports, "darken", () => $81b79135415c645e$export$4b073707ff63303);
$parcel$export(module.exports, "lighten", () => $81b79135415c645e$export$c0816ed86df316af);
$parcel$export(module.exports, "emphasize", () => $81b79135415c645e$export$e665714f76e581fd);

var $7xoNL = parcelRequire("7xoNL");
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $81b79135415c645e$var$clamp(value, min = 0, max = 1) {
    return Math.min(Math.max(min, value), max);
}
function $81b79135415c645e$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $81b79135415c645e$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $81b79135415c645e$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $81b79135415c645e$export$677b39864803984e($81b79135415c645e$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $7xoNL.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $7xoNL.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $81b79135415c645e$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $81b79135415c645e$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
const $81b79135415c645e$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $81b79135415c645e$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $81b79135415c645e$export$211a73f2b8c10ce4(color) {
    const { type: type , colorSpace: colorSpace  } = color;
    let { values: values  } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
function $81b79135415c645e$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values  } = $81b79135415c645e$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$81b79135415c645e$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function $81b79135415c645e$export$29fb7152bd3f781a(color) {
    color = $81b79135415c645e$export$677b39864803984e(color);
    const { values: values  } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $81b79135415c645e$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $81b79135415c645e$export$c852d90bf7403b62(color) {
    color = $81b79135415c645e$export$677b39864803984e(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $81b79135415c645e$export$677b39864803984e($81b79135415c645e$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $81b79135415c645e$export$d061e26956a60b0a(foreground, background) {
    const lumA = $81b79135415c645e$export$c852d90bf7403b62(foreground);
    const lumB = $81b79135415c645e$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $81b79135415c645e$export$58f0f39f63f3cf42(color, value) {
    color = $81b79135415c645e$export$677b39864803984e(color);
    value = $81b79135415c645e$var$clamp(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $81b79135415c645e$export$211a73f2b8c10ce4(color);
}
function $81b79135415c645e$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $81b79135415c645e$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $81b79135415c645e$export$4b073707ff63303(color, coefficient) {
    color = $81b79135415c645e$export$677b39864803984e(color);
    coefficient = $81b79135415c645e$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $81b79135415c645e$export$211a73f2b8c10ce4(color);
}
function $81b79135415c645e$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $81b79135415c645e$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $81b79135415c645e$export$c0816ed86df316af(color, coefficient) {
    color = $81b79135415c645e$export$677b39864803984e(color);
    coefficient = $81b79135415c645e$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $81b79135415c645e$export$211a73f2b8c10ce4(color);
}
function $81b79135415c645e$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $81b79135415c645e$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $81b79135415c645e$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $81b79135415c645e$export$c852d90bf7403b62(color) > 0.5 ? $81b79135415c645e$export$4b073707ff63303(color, coefficient) : $81b79135415c645e$export$c0816ed86df316af(color, coefficient);
}
function $81b79135415c645e$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $81b79135415c645e$export$11bb74ba10c85505(color, coefficient);
    } catch (error) {
        return color;
    }
}

});

parcelRequire.register("1Avk6", function(module, exports) {

$parcel$export(module.exports, "default", () => $12817366394120f5$export$2e2bcd8739ae039);
const $12817366394120f5$var$common = {
    black: "#000",
    white: "#fff"
};
var $12817366394120f5$export$2e2bcd8739ae039 = $12817366394120f5$var$common;

});

parcelRequire.register("bWWR4", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b32c3e1f58f74f7$export$2e2bcd8739ae039);
const $8b32c3e1f58f74f7$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $8b32c3e1f58f74f7$export$2e2bcd8739ae039 = $8b32c3e1f58f74f7$var$grey;

});

parcelRequire.register("hgmuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $c915617aac8e5f56$export$2e2bcd8739ae039);
const $c915617aac8e5f56$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $c915617aac8e5f56$export$2e2bcd8739ae039 = $c915617aac8e5f56$var$purple;

});

parcelRequire.register("8JSUZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $65cd2048a5dc1509$export$2e2bcd8739ae039);
const $65cd2048a5dc1509$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $65cd2048a5dc1509$export$2e2bcd8739ae039 = $65cd2048a5dc1509$var$red;

});

parcelRequire.register("jQqby", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7272f87beccdce7$export$2e2bcd8739ae039);
const $e7272f87beccdce7$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $e7272f87beccdce7$export$2e2bcd8739ae039 = $e7272f87beccdce7$var$orange;

});

parcelRequire.register("gSyx1", function(module, exports) {

$parcel$export(module.exports, "default", () => $c49c79bc721d3ef4$export$2e2bcd8739ae039);
const $c49c79bc721d3ef4$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $c49c79bc721d3ef4$export$2e2bcd8739ae039 = $c49c79bc721d3ef4$var$blue;

});

parcelRequire.register("k1xCd", function(module, exports) {

$parcel$export(module.exports, "default", () => $e93df9fb3cd3bd03$export$2e2bcd8739ae039);
const $e93df9fb3cd3bd03$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $e93df9fb3cd3bd03$export$2e2bcd8739ae039 = $e93df9fb3cd3bd03$var$lightBlue;

});

parcelRequire.register("io14o", function(module, exports) {

$parcel$export(module.exports, "default", () => $d62b4c5bd98646fc$export$2e2bcd8739ae039);
const $d62b4c5bd98646fc$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $d62b4c5bd98646fc$export$2e2bcd8739ae039 = $d62b4c5bd98646fc$var$green;

});


parcelRequire.register("2wrLa", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d641a7701173dea$export$2e2bcd8739ae039);

var $63nUy = parcelRequire("63nUy");

var $fZ2DJ = parcelRequire("fZ2DJ");

var $1nBS8 = parcelRequire("1nBS8");
const $1d641a7701173dea$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $1d641a7701173dea$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $1d641a7701173dea$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $1d641a7701173dea$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $1d641a7701173dea$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === "function" ? typography(palette) : typography, { fontFamily: fontFamily = $1d641a7701173dea$var$defaultFontFamily , fontSize: // The default font size of the Material Specification.
    fontSize = 14 , fontWeightLight: // px
    fontWeightLight = 300 , fontWeightRegular: fontWeightRegular = 400 , fontWeightMedium: fontWeightMedium = 500 , fontWeightBold: fontWeightBold = 700 , htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16 , allVariants: // Apply the CSS properties to all the variants.
    allVariants , pxToRem: pxToRem2  } = _ref, other = (0, $fZ2DJ.default)(_ref, $1d641a7701173dea$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $63nUy.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $1d641a7701173dea$var$defaultFontFamily ? {
            letterSpacing: `${$1d641a7701173dea$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $1d641a7701173dea$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $1d641a7701173dea$var$caseAllCaps),
        inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
        }
    };
    return (0, $1nBS8.default)((0, $63nUy.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRequire.register("gG4Ht", function(module, exports) {

$parcel$export(module.exports, "default", () => $c24436efd5bf575d$export$2e2bcd8739ae039);
const $c24436efd5bf575d$var$shadowKeyUmbraOpacity = 0.2;
const $c24436efd5bf575d$var$shadowKeyPenumbraOpacity = 0.14;
const $c24436efd5bf575d$var$shadowAmbientShadowOpacity = 0.12;
function $c24436efd5bf575d$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$c24436efd5bf575d$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$c24436efd5bf575d$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$c24436efd5bf575d$var$shadowAmbientShadowOpacity})`
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $c24436efd5bf575d$var$shadows = [
    "none",
    $c24436efd5bf575d$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $c24436efd5bf575d$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $c24436efd5bf575d$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $c24436efd5bf575d$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $c24436efd5bf575d$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $c24436efd5bf575d$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $c24436efd5bf575d$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $c24436efd5bf575d$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $c24436efd5bf575d$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $c24436efd5bf575d$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $c24436efd5bf575d$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $c24436efd5bf575d$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $c24436efd5bf575d$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $c24436efd5bf575d$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $c24436efd5bf575d$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $c24436efd5bf575d$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $c24436efd5bf575d$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $c24436efd5bf575d$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $c24436efd5bf575d$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $c24436efd5bf575d$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $c24436efd5bf575d$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $c24436efd5bf575d$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $c24436efd5bf575d$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $c24436efd5bf575d$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $c24436efd5bf575d$export$2e2bcd8739ae039 = $c24436efd5bf575d$var$shadows;

});

parcelRequire.register("ecz5v", function(module, exports) {

$parcel$export(module.exports, "default", () => $a56d675c7cc6b61f$export$2e2bcd8739ae039);

var $fZ2DJ = parcelRequire("fZ2DJ");

var $63nUy = parcelRequire("63nUy");
const $a56d675c7cc6b61f$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $a56d675c7cc6b61f$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const $a56d675c7cc6b61f$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $a56d675c7cc6b61f$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $a56d675c7cc6b61f$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $a56d675c7cc6b61f$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $63nUy.default)({}, $a56d675c7cc6b61f$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $63nUy.default)({}, $a56d675c7cc6b61f$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard , easing: easingOption = mergedEasing.easeInOut , delay: delay = 0  } = options, other = (0, $fZ2DJ.default)(options, $a56d675c7cc6b61f$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $a56d675c7cc6b61f$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $a56d675c7cc6b61f$var$formatMs(delay)}`).join(",");
    };
    return (0, $63nUy.default)({
        getAutoHeightDuration: $a56d675c7cc6b61f$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRequire.register("toXP4", function(module, exports) {

$parcel$export(module.exports, "default", () => $058612daed864188$export$2e2bcd8739ae039);
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $058612daed864188$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $058612daed864188$export$2e2bcd8739ae039 = $058612daed864188$var$zIndex;

});



parcelRequire.register("5ZcGy", function(module, exports) {

$parcel$export(module.exports, "default", () => $45bc7d4fe74e5291$export$2e2bcd8739ae039);
var $45bc7d4fe74e5291$export$2e2bcd8739ae039 = "$$material";

});


parcelRequire.register("gIzLq", function(module, exports) {

$parcel$export(module.exports, "rootShouldForwardProp", () => $c2bc7f61139402bc$export$effb20ecdbf4d6aa);
$parcel$export(module.exports, "slotShouldForwardProp", () => $c2bc7f61139402bc$export$f10c5a10d27438e5);
$parcel$export(module.exports, "default", () => $c2bc7f61139402bc$export$2e2bcd8739ae039);

var $kWGGm = parcelRequire("kWGGm");

var $5VMQ9 = parcelRequire("5VMQ9");

var $5ZcGy = parcelRequire("5ZcGy");
const $c2bc7f61139402bc$export$effb20ecdbf4d6aa = (prop)=>(0, $kWGGm.shouldForwardProp)(prop) && prop !== "classes";
const $c2bc7f61139402bc$export$f10c5a10d27438e5 = (0, $kWGGm.shouldForwardProp);
const $c2bc7f61139402bc$var$styled = (0, $kWGGm.default)({
    themeId: (0, $5ZcGy.default),
    defaultTheme: $5VMQ9.default,
    rootShouldForwardProp: $c2bc7f61139402bc$export$effb20ecdbf4d6aa
});
var $c2bc7f61139402bc$export$2e2bcd8739ae039 = $c2bc7f61139402bc$var$styled;

});
parcelRequire.register("kWGGm", function(module, exports) {

$parcel$export(module.exports, "shouldForwardProp", () => $f3fa553464994e07$export$3ba67b570e26eea0);
$parcel$export(module.exports, "default", () => $f3fa553464994e07$export$2e2bcd8739ae039);

var $fZ2DJ = parcelRequire("fZ2DJ");

var $63nUy = parcelRequire("63nUy");

var $jdiIz = parcelRequire("jdiIz");


var $1iZe2 = parcelRequire("1iZe2");

var $id0vf = parcelRequire("id0vf");

var $70fZE = parcelRequire("70fZE");
const $f3fa553464994e07$var$_excluded = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $f3fa553464994e07$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $f3fa553464994e07$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
const $f3fa553464994e07$var$getStyleOverrides = (name, theme)=>{
    if (theme.components && theme.components[name] && theme.components[name].styleOverrides) return theme.components[name].styleOverrides;
    return null;
};
const $f3fa553464994e07$var$getVariantStyles = (name, theme)=>{
    let variants = [];
    if (theme && theme.components && theme.components[name] && theme.components[name].variants) variants = theme.components[name].variants;
    const variantsStyles = {};
    variants.forEach((definition)=>{
        const key = (0, $id0vf.default)(definition.props);
        variantsStyles[key] = definition.style;
    });
    return variantsStyles;
};
const $f3fa553464994e07$var$variantsResolver = (props, styles, theme, name)=>{
    var _theme$components, _theme$components$nam;
    const { ownerState: ownerState = {}  } = props;
    const variantsStyles = [];
    const themeVariants = theme == null ? void 0 : (_theme$components = theme.components) == null ? void 0 : (_theme$components$nam = _theme$components[name]) == null ? void 0 : _theme$components$nam.variants;
    if (themeVariants) themeVariants.forEach((themeVariant)=>{
        let isMatch = true;
        Object.keys(themeVariant.props).forEach((key)=>{
            if (ownerState[key] !== themeVariant.props[key] && props[key] !== themeVariant.props[key]) isMatch = false;
        });
        if (isMatch) variantsStyles.push(styles[(0, $id0vf.default)(themeVariant.props)]);
    });
    return variantsStyles;
};
function $f3fa553464994e07$export$3ba67b570e26eea0(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $f3fa553464994e07$export$35e57303dbd8a66 = (0, $1iZe2.default)();
const $f3fa553464994e07$var$lowercaseFirstLetter = (string)=>{
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $f3fa553464994e07$var$resolveTheme({ defaultTheme: defaultTheme , theme: theme , themeId: themeId  }) {
    return $f3fa553464994e07$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $f3fa553464994e07$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId , defaultTheme: defaultTheme = $f3fa553464994e07$export$35e57303dbd8a66 , rootShouldForwardProp: rootShouldForwardProp = $f3fa553464994e07$export$3ba67b570e26eea0 , slotShouldForwardProp: slotShouldForwardProp = $f3fa553464994e07$export$3ba67b570e26eea0  } = input;
    const systemSx = (props)=>{
        return (0, $70fZE.default)((0, $63nUy.default)({}, props, {
            theme: $f3fa553464994e07$var$resolveTheme((0, $63nUy.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $jdiIz.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName , slot: componentSlot , skipVariantsResolver: inputSkipVariantsResolver , skipSx: inputSkipSx , overridesResolver: overridesResolver  } = inputOptions, options = (0, $fZ2DJ.default)(inputOptions, $f3fa553464994e07$var$_excluded);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : componentSlot && componentSlot !== "Root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $f3fa553464994e07$export$3ba67b570e26eea0;
        if (componentSlot === "Root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($f3fa553464994e07$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $jdiIz.default)(tag, (0, $63nUy.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const muiStyledResolver = (styleArg, ...expressions)=>{
            const expressionsWithDefaultTheme = expressions ? expressions.map((stylesArg)=>{
                // On the server Emotion doesn't use React.forwardRef for creating components, so the created
                // component stays as a function. This condition makes sure that we do not interpolate functions
                // which are basically components used as a selectors.
                return typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg ? (props)=>{
                    return stylesArg((0, $63nUy.default)({}, props, {
                        theme: $f3fa553464994e07$var$resolveTheme((0, $63nUy.default)({}, props, {
                            defaultTheme: defaultTheme,
                            themeId: themeId
                        }))
                    }));
                } : stylesArg;
            }) : [];
            let transformedStyleArg = styleArg;
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $f3fa553464994e07$var$resolveTheme((0, $63nUy.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const styleOverrides = $f3fa553464994e07$var$getStyleOverrides(componentName, theme);
                if (styleOverrides) {
                    const resolvedStyleOverrides = {};
                    Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                        resolvedStyleOverrides[slotKey] = typeof slotStyle === "function" ? slotStyle((0, $63nUy.default)({}, props, {
                            theme: theme
                        })) : slotStyle;
                    });
                    return overridesResolver(props, resolvedStyleOverrides);
                }
                return null;
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $f3fa553464994e07$var$resolveTheme((0, $63nUy.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                return $f3fa553464994e07$var$variantsResolver(props, $f3fa553464994e07$var$getVariantStyles(componentName, theme), theme, componentName);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            } else if (typeof styleArg === "function" && // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            styleArg.__emotion_real !== styleArg) // If the type is function, we need to define the default theme.
            transformedStyleArg = (props)=>styleArg((0, $63nUy.default)({}, props, {
                    theme: $f3fa553464994e07$var$resolveTheme((0, $63nUy.default)({}, props, {
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    }))
                }));
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRequire.register("jdiIz", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfcdc032b7d15d54$export$2e2bcd8739ae039);
$parcel$export(module.exports, "internal_processStyles", () => $dfcdc032b7d15d54$export$e00380445f2b9e0c);
/**
 * @mui/styled-engine v5.13.2
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable no-underscore-dangle */ 
var $fV4ko = parcelRequire("fV4ko");
parcelRequire("alXcb");
var $79R6f = parcelRequire("79R6f");
var $alXcb = parcelRequire("alXcb");


var $hc4Oj = parcelRequire("hc4Oj");
function $dfcdc032b7d15d54$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $fV4ko.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $dfcdc032b7d15d54$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRequire.register("fV4ko", function(module, exports) {

$parcel$export(module.exports, "default", () => $b96f894feeb45749$export$2e2bcd8739ae039);

var $bDut0 = parcelRequire("bDut0");
parcelRequire("4pGln");
parcelRequire("1bdO8");
parcelRequire("gC24H");

parcelRequire("257EV");
parcelRequire("fRUBy");
parcelRequire("92M4l");
var $b96f894feeb45749$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $b96f894feeb45749$export$2e2bcd8739ae039 = (0, $bDut0.default).bind();
$b96f894feeb45749$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $b96f894feeb45749$export$2e2bcd8739ae039[tagName] = $b96f894feeb45749$export$2e2bcd8739ae039(tagName);
});

});
parcelRequire.register("bDut0", function(module, exports) {

$parcel$export(module.exports, "default", () => $878af84b750bb7fb$export$2e2bcd8739ae039);

var $63nUy = parcelRequire("63nUy");

var $1bdO8 = parcelRequire("1bdO8");

var $gC24H = parcelRequire("gC24H");
parcelRequire("alXcb");
var $79R6f = parcelRequire("79R6f");

var $257EV = parcelRequire("257EV");

var $fRUBy = parcelRequire("fRUBy");

var $92M4l = parcelRequire("92M4l");
var $878af84b750bb7fb$var$testOmitPropsOnStringTag = (0, $gC24H.default);
var $878af84b750bb7fb$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $878af84b750bb7fb$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $878af84b750bb7fb$var$testOmitPropsOnStringTag : $878af84b750bb7fb$var$testOmitPropsOnComponent;
};
var $878af84b750bb7fb$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $878af84b750bb7fb$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $878af84b750bb7fb$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $257EV.registerStyles)(cache, serialized, isStringTag);
    (0, $92M4l.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $257EV.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $878af84b750bb7fb$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $878af84b750bb7fb$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $878af84b750bb7fb$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $79R6f.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $1bdO8.useContext((0, $79R6f.T));
            }
            if (typeof props.className === "string") className = (0, $257EV.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $fRUBy.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $878af84b750bb7fb$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ $1bdO8.createElement($1bdO8.Fragment, null, /*#__PURE__*/ $1bdO8.createElement($878af84b750bb7fb$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $1bdO8.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $63nUy.default)({}, options, nextOptions, {
                shouldForwardProp: $878af84b750bb7fb$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRequire.register("gC24H", function(module, exports) {

$parcel$export(module.exports, "default", () => $c181cdfa5b52161f$export$2e2bcd8739ae039);

var $1qjjx = parcelRequire("1qjjx");
var $c181cdfa5b52161f$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $c181cdfa5b52161f$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $1qjjx.default)(function(prop) {
    return $c181cdfa5b52161f$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRequire.register("hc4Oj", function(module, exports) {

$parcel$export(module.exports, "default", () => $c84749e8dba34482$export$2e2bcd8739ae039);
parcelRequire("1bdO8");


var $alXcb = parcelRequire("alXcb");

var $cVgDf = parcelRequire("cVgDf");
function $c84749e8dba34482$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $c84749e8dba34482$export$2e2bcd8739ae039(props) {
    const { styles: styles , defaultTheme: defaultTheme = {}  } = props;
    const globalStyles = typeof styles === "function" ? (themeInput)=>styles($c84749e8dba34482$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $alXcb.Global), {
        styles: globalStyles
    });
}

});
parcelRequire.register("cVgDf", function(module, exports) {
"use strict";

module.exports = (parcelRequire("5mD5L"));

});



parcelRequire.register("id0vf", function(module, exports) {

$parcel$export(module.exports, "default", () => $d419d4c5c6829442$export$2e2bcd8739ae039);

var $fZ2DJ = parcelRequire("fZ2DJ");

var $56MqO = parcelRequire("56MqO");
const $d419d4c5c6829442$var$_excluded = [
    "variant"
];
function $d419d4c5c6829442$var$isEmpty(string) {
    return string.length === 0;
}
function $d419d4c5c6829442$export$2e2bcd8739ae039(props) {
    const { variant: variant  } = props, other = (0, $fZ2DJ.default)(props, $d419d4c5c6829442$var$_excluded);
    let classKey = variant || "";
    Object.keys(other).sort().forEach((key)=>{
        if (key === "color") classKey += $d419d4c5c6829442$var$isEmpty(classKey) ? props[key] : (0, $56MqO.default)(props[key]);
        else classKey += `${$d419d4c5c6829442$var$isEmpty(classKey) ? key : (0, $56MqO.default)(key)}${(0, $56MqO.default)(props[key].toString())}`;
    });
    return classKey;
}

});



parcelRequire.register("89KYv", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", () => $5f039a3e6b46246f$export$c7c50641356bdfa5);

var $itJr1 = parcelRequire("itJr1");

var $9nXgc = parcelRequire("9nXgc");
function $5f039a3e6b46246f$export$c7c50641356bdfa5(slot) {
    return (0, $9nXgc.default)("MuiSvgIcon", slot);
}
const $5f039a3e6b46246f$var$svgIconClasses = (0, $itJr1.default)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $5f039a3e6b46246f$export$2e2bcd8739ae039 = $5f039a3e6b46246f$var$svgIconClasses;

});
parcelRequire.register("itJr1", function(module, exports) {

$parcel$export(module.exports, "default", () => $d73e2ddb7ad7e388$export$2e2bcd8739ae039);

var $9nXgc = parcelRequire("9nXgc");
function $d73e2ddb7ad7e388$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $9nXgc.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRequire.register("9nXgc", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d543ae2508d9eb5$export$2e2bcd8739ae039);

var $2pvom = parcelRequire("2pvom");
const $6d543ae2508d9eb5$var$globalStateClassesMapping = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    readOnly: "readOnly",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    required: "required",
    selected: "selected"
};
function $6d543ae2508d9eb5$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = $6d543ae2508d9eb5$var$globalStateClassesMapping[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $2pvom.default).generate(componentName)}-${slot}`;
}

});
parcelRequire.register("2pvom", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c16445795a216d0$export$2e2bcd8739ae039);
const $1c16445795a216d0$var$defaultGenerator = (componentName)=>componentName;
const $1c16445795a216d0$var$createClassNameGenerator = ()=>{
    let generate = $1c16445795a216d0$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $1c16445795a216d0$var$defaultGenerator;
        }
    };
};
const $1c16445795a216d0$var$ClassNameGenerator = $1c16445795a216d0$var$createClassNameGenerator();
var $1c16445795a216d0$export$2e2bcd8739ae039 = $1c16445795a216d0$var$ClassNameGenerator;

});







parcelRequire.register("c1aiQ", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $8bfd91fe2728d420$export$a7c73072b1a182ae, (v) => $8bfd91fe2728d420$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $8bfd91fe2728d420$export$9f27bc3417b4524d, (v) => $8bfd91fe2728d420$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $8bfd91fe2728d420$export$db77ccec0bb4ccac, (v) => $8bfd91fe2728d420$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $8bfd91fe2728d420$export$8392c0c9d3dcbd35, (v) => $8bfd91fe2728d420$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $8bfd91fe2728d420$export$ffb0004e005737fa, (v) => $8bfd91fe2728d420$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $8bfd91fe2728d420$export$b624eff549462981, (v) => $8bfd91fe2728d420$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $8bfd91fe2728d420$export$7897aa7841a5380c, (v) => $8bfd91fe2728d420$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $8bfd91fe2728d420$export$602eac185826482c, (v) => $8bfd91fe2728d420$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $8bfd91fe2728d420$export$e2c29f18771995cb, (v) => $8bfd91fe2728d420$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $8bfd91fe2728d420$export$5f8d39834fd61797, (v) => $8bfd91fe2728d420$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $8bfd91fe2728d420$export$74bf444e3cd11ea5, (v) => $8bfd91fe2728d420$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $8bfd91fe2728d420$export$998bcd577473dd93, (v) => $8bfd91fe2728d420$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $8bfd91fe2728d420$export$92387174baf9b227, (v) => $8bfd91fe2728d420$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $8bfd91fe2728d420$export$ec112efeb987d9c6, (v) => $8bfd91fe2728d420$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $8bfd91fe2728d420$export$b706b080d889d2c9, (v) => $8bfd91fe2728d420$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $8bfd91fe2728d420$export$5be5a87408f70ddc, (v) => $8bfd91fe2728d420$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $8bfd91fe2728d420$export$45a5e7f76e0caa8d, (v) => $8bfd91fe2728d420$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $8bfd91fe2728d420$export$455c2e768291efa6, (v) => $8bfd91fe2728d420$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $8bfd91fe2728d420$export$9522e17588c12572, (v) => $8bfd91fe2728d420$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $8bfd91fe2728d420$export$2110ac352bb060b9, (v) => $8bfd91fe2728d420$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $8bfd91fe2728d420$export$56885ab8b9c456ab, (v) => $8bfd91fe2728d420$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $8bfd91fe2728d420$export$d927fcb6adf8f9de, (v) => $8bfd91fe2728d420$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $8bfd91fe2728d420$export$b82d16f27459e05a, (v) => $8bfd91fe2728d420$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $8bfd91fe2728d420$export$522c17b4f5e123e8, (v) => $8bfd91fe2728d420$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $8bfd91fe2728d420$export$1aabd8a0274ecfd6, (v) => $8bfd91fe2728d420$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $8bfd91fe2728d420$export$3d6c20d97e46b957, (v) => $8bfd91fe2728d420$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $8bfd91fe2728d420$export$9b621391a187a31a, (v) => $8bfd91fe2728d420$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $8bfd91fe2728d420$export$f5bbd400c2f4426f, (v) => $8bfd91fe2728d420$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8bfd91fe2728d420$export$a7c73072b1a182ae;
var $8bfd91fe2728d420$export$9f27bc3417b4524d;
var $8bfd91fe2728d420$export$db77ccec0bb4ccac;
var $8bfd91fe2728d420$export$8392c0c9d3dcbd35;
var $8bfd91fe2728d420$export$ffb0004e005737fa;
var $8bfd91fe2728d420$export$b624eff549462981;
var $8bfd91fe2728d420$export$7897aa7841a5380c;
var $8bfd91fe2728d420$export$602eac185826482c;
var $8bfd91fe2728d420$export$e2c29f18771995cb;
var $8bfd91fe2728d420$export$5f8d39834fd61797;
var $8bfd91fe2728d420$export$74bf444e3cd11ea5;
var $8bfd91fe2728d420$export$998bcd577473dd93;
var $8bfd91fe2728d420$export$92387174baf9b227;
var $8bfd91fe2728d420$export$ec112efeb987d9c6;
var $8bfd91fe2728d420$export$b706b080d889d2c9;
var $8bfd91fe2728d420$export$5be5a87408f70ddc;
var $8bfd91fe2728d420$export$45a5e7f76e0caa8d;
var $8bfd91fe2728d420$export$455c2e768291efa6;
var $8bfd91fe2728d420$export$9522e17588c12572;
var $8bfd91fe2728d420$export$2110ac352bb060b9;
var $8bfd91fe2728d420$export$56885ab8b9c456ab;
var $8bfd91fe2728d420$export$d927fcb6adf8f9de;
var $8bfd91fe2728d420$export$b82d16f27459e05a;
var $8bfd91fe2728d420$export$522c17b4f5e123e8;
var $8bfd91fe2728d420$export$1aabd8a0274ecfd6;
var $8bfd91fe2728d420$export$3d6c20d97e46b957;
var $8bfd91fe2728d420$export$9b621391a187a31a;
var $8bfd91fe2728d420$export$f5bbd400c2f4426f;
"use strict";
var $8bfd91fe2728d420$var$b = Symbol.for("react.element"), $8bfd91fe2728d420$var$c = Symbol.for("react.portal"), $8bfd91fe2728d420$var$d = Symbol.for("react.fragment"), $8bfd91fe2728d420$var$e = Symbol.for("react.strict_mode"), $8bfd91fe2728d420$var$f = Symbol.for("react.profiler"), $8bfd91fe2728d420$var$g = Symbol.for("react.provider"), $8bfd91fe2728d420$var$h = Symbol.for("react.context"), $8bfd91fe2728d420$var$k = Symbol.for("react.server_context"), $8bfd91fe2728d420$var$l = Symbol.for("react.forward_ref"), $8bfd91fe2728d420$var$m = Symbol.for("react.suspense"), $8bfd91fe2728d420$var$n = Symbol.for("react.suspense_list"), $8bfd91fe2728d420$var$p = Symbol.for("react.memo"), $8bfd91fe2728d420$var$q = Symbol.for("react.lazy"), $8bfd91fe2728d420$var$t = Symbol.for("react.offscreen"), $8bfd91fe2728d420$var$u;
$8bfd91fe2728d420$var$u = Symbol.for("react.module.reference");
function $8bfd91fe2728d420$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $8bfd91fe2728d420$var$b:
                switch(a = a.type, a){
                    case $8bfd91fe2728d420$var$d:
                    case $8bfd91fe2728d420$var$f:
                    case $8bfd91fe2728d420$var$e:
                    case $8bfd91fe2728d420$var$m:
                    case $8bfd91fe2728d420$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $8bfd91fe2728d420$var$k:
                            case $8bfd91fe2728d420$var$h:
                            case $8bfd91fe2728d420$var$l:
                            case $8bfd91fe2728d420$var$q:
                            case $8bfd91fe2728d420$var$p:
                            case $8bfd91fe2728d420$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $8bfd91fe2728d420$var$c:
                return r;
        }
    }
}
$8bfd91fe2728d420$export$a7c73072b1a182ae = $8bfd91fe2728d420$var$h;
$8bfd91fe2728d420$export$9f27bc3417b4524d = $8bfd91fe2728d420$var$g;
$8bfd91fe2728d420$export$db77ccec0bb4ccac = $8bfd91fe2728d420$var$b;
$8bfd91fe2728d420$export$8392c0c9d3dcbd35 = $8bfd91fe2728d420$var$l;
$8bfd91fe2728d420$export$ffb0004e005737fa = $8bfd91fe2728d420$var$d;
$8bfd91fe2728d420$export$b624eff549462981 = $8bfd91fe2728d420$var$q;
$8bfd91fe2728d420$export$7897aa7841a5380c = $8bfd91fe2728d420$var$p;
$8bfd91fe2728d420$export$602eac185826482c = $8bfd91fe2728d420$var$c;
$8bfd91fe2728d420$export$e2c29f18771995cb = $8bfd91fe2728d420$var$f;
$8bfd91fe2728d420$export$5f8d39834fd61797 = $8bfd91fe2728d420$var$e;
$8bfd91fe2728d420$export$74bf444e3cd11ea5 = $8bfd91fe2728d420$var$m;
$8bfd91fe2728d420$export$998bcd577473dd93 = $8bfd91fe2728d420$var$n;
$8bfd91fe2728d420$export$92387174baf9b227 = function() {
    return !1;
};
$8bfd91fe2728d420$export$ec112efeb987d9c6 = function() {
    return !1;
};
$8bfd91fe2728d420$export$b706b080d889d2c9 = function(a) {
    return $8bfd91fe2728d420$var$v(a) === $8bfd91fe2728d420$var$h;
};
$8bfd91fe2728d420$export$5be5a87408f70ddc = function(a) {
    return $8bfd91fe2728d420$var$v(a) === $8bfd91fe2728d420$var$g;
};
$8bfd91fe2728d420$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $8bfd91fe2728d420$var$b;
};
$8bfd91fe2728d420$export$455c2e768291efa6 = function(a) {
    return $8bfd91fe2728d420$var$v(a) === $8bfd91fe2728d420$var$l;
};
$8bfd91fe2728d420$export$9522e17588c12572 = function(a) {
    return $8bfd91fe2728d420$var$v(a) === $8bfd91fe2728d420$var$d;
};
$8bfd91fe2728d420$export$2110ac352bb060b9 = function(a) {
    return $8bfd91fe2728d420$var$v(a) === $8bfd91fe2728d420$var$q;
};
$8bfd91fe2728d420$export$56885ab8b9c456ab = function(a) {
    return $8bfd91fe2728d420$var$v(a) === $8bfd91fe2728d420$var$p;
};
$8bfd91fe2728d420$export$d927fcb6adf8f9de = function(a) {
    return $8bfd91fe2728d420$var$v(a) === $8bfd91fe2728d420$var$c;
};
$8bfd91fe2728d420$export$b82d16f27459e05a = function(a) {
    return $8bfd91fe2728d420$var$v(a) === $8bfd91fe2728d420$var$f;
};
$8bfd91fe2728d420$export$522c17b4f5e123e8 = function(a) {
    return $8bfd91fe2728d420$var$v(a) === $8bfd91fe2728d420$var$e;
};
$8bfd91fe2728d420$export$1aabd8a0274ecfd6 = function(a) {
    return $8bfd91fe2728d420$var$v(a) === $8bfd91fe2728d420$var$m;
};
$8bfd91fe2728d420$export$3d6c20d97e46b957 = function(a) {
    return $8bfd91fe2728d420$var$v(a) === $8bfd91fe2728d420$var$n;
};
$8bfd91fe2728d420$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $8bfd91fe2728d420$var$d || a === $8bfd91fe2728d420$var$f || a === $8bfd91fe2728d420$var$e || a === $8bfd91fe2728d420$var$m || a === $8bfd91fe2728d420$var$n || a === $8bfd91fe2728d420$var$t || "object" === typeof a && null !== a && (a.$$typeof === $8bfd91fe2728d420$var$q || a.$$typeof === $8bfd91fe2728d420$var$p || a.$$typeof === $8bfd91fe2728d420$var$g || a.$$typeof === $8bfd91fe2728d420$var$h || a.$$typeof === $8bfd91fe2728d420$var$l || a.$$typeof === $8bfd91fe2728d420$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$8bfd91fe2728d420$export$f5bbd400c2f4426f = $8bfd91fe2728d420$var$v;

});

parcelRequire.register("inpRe", function(module, exports) {

$parcel$export(module.exports, "ConcurrentRoot", () => $d60e6ec53f7e38c6$export$816aac48d41c2f81, (v) => $d60e6ec53f7e38c6$export$816aac48d41c2f81 = v);
$parcel$export(module.exports, "ContinuousEventPriority", () => $d60e6ec53f7e38c6$export$3bb88615cd12cb3b, (v) => $d60e6ec53f7e38c6$export$3bb88615cd12cb3b = v);
$parcel$export(module.exports, "DefaultEventPriority", () => $d60e6ec53f7e38c6$export$d46163d5c045f347, (v) => $d60e6ec53f7e38c6$export$d46163d5c045f347 = v);
$parcel$export(module.exports, "DiscreteEventPriority", () => $d60e6ec53f7e38c6$export$8ee75c97f0333f15, (v) => $d60e6ec53f7e38c6$export$8ee75c97f0333f15 = v);
$parcel$export(module.exports, "IdleEventPriority", () => $d60e6ec53f7e38c6$export$d1c113b83e1f881a, (v) => $d60e6ec53f7e38c6$export$d1c113b83e1f881a = v);
$parcel$export(module.exports, "LegacyRoot", () => $d60e6ec53f7e38c6$export$ff78c4883554845d, (v) => $d60e6ec53f7e38c6$export$ff78c4883554845d = v);
/**
 * @license React
 * react-reconciler-constants.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d60e6ec53f7e38c6$export$816aac48d41c2f81;
var $d60e6ec53f7e38c6$export$3bb88615cd12cb3b;
var $d60e6ec53f7e38c6$export$d46163d5c045f347;
var $d60e6ec53f7e38c6$export$8ee75c97f0333f15;
var $d60e6ec53f7e38c6$export$d1c113b83e1f881a;
var $d60e6ec53f7e38c6$export$ff78c4883554845d;
"use strict";
$d60e6ec53f7e38c6$export$816aac48d41c2f81 = 1;
$d60e6ec53f7e38c6$export$3bb88615cd12cb3b = 4;
$d60e6ec53f7e38c6$export$d46163d5c045f347 = 16;
$d60e6ec53f7e38c6$export$8ee75c97f0333f15 = 1;
$d60e6ec53f7e38c6$export$d1c113b83e1f881a = 536870912;
$d60e6ec53f7e38c6$export$ff78c4883554845d = 0;

});

parcelRequire.register("iz3tf", function(module, exports) {
/**
 * @license React
 * react-reconciler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 

module.exports = function $$$reconciler($$$hostConfig) {
    var exports = {};
    "use strict";
    var aa = (parcelRequire("1bdO8")), ba = (parcelRequire("cpxvE")), ca = Object.assign;
    function n(a) {
        for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
        return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    var ea = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, fa = Symbol.for("react.element"), ha = Symbol.for("react.portal"), ia = Symbol.for("react.fragment"), ja = Symbol.for("react.strict_mode"), ka = Symbol.for("react.profiler"), la = Symbol.for("react.provider"), ma = Symbol.for("react.context"), na = Symbol.for("react.forward_ref"), oa = Symbol.for("react.suspense"), pa = Symbol.for("react.suspense_list"), qa = Symbol.for("react.memo"), ra = Symbol.for("react.lazy");
    Symbol.for("react.scope");
    Symbol.for("react.debug_trace_mode");
    var sa = Symbol.for("react.offscreen");
    Symbol.for("react.legacy_hidden");
    Symbol.for("react.cache");
    Symbol.for("react.tracing_marker");
    var ta = Symbol.iterator;
    function ua(a) {
        if (null === a || "object" !== typeof a) return null;
        a = ta && a[ta] || a["@@iterator"];
        return "function" === typeof a ? a : null;
    }
    function va(a) {
        if (null == a) return null;
        if ("function" === typeof a) return a.displayName || a.name || null;
        if ("string" === typeof a) return a;
        switch(a){
            case ia:
                return "Fragment";
            case ha:
                return "Portal";
            case ka:
                return "Profiler";
            case ja:
                return "StrictMode";
            case oa:
                return "Suspense";
            case pa:
                return "SuspenseList";
        }
        if ("object" === typeof a) switch(a.$$typeof){
            case ma:
                return (a.displayName || "Context") + ".Consumer";
            case la:
                return (a._context.displayName || "Context") + ".Provider";
            case na:
                var b = a.render;
                a = a.displayName;
                a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
                return a;
            case qa:
                return b = a.displayName || null, null !== b ? b : va(a.type) || "Memo";
            case ra:
                b = a._payload;
                a = a._init;
                try {
                    return va(a(b));
                } catch (c) {}
        }
        return null;
    }
    function xa(a) {
        var b = a.type;
        switch(a.tag){
            case 24:
                return "Cache";
            case 9:
                return (b.displayName || "Context") + ".Consumer";
            case 10:
                return (b._context.displayName || "Context") + ".Provider";
            case 18:
                return "DehydratedFragment";
            case 11:
                return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            case 7:
                return "Fragment";
            case 5:
                return b;
            case 4:
                return "Portal";
            case 3:
                return "Root";
            case 6:
                return "Text";
            case 16:
                return va(b);
            case 8:
                return b === ja ? "StrictMode" : "Mode";
            case 22:
                return "Offscreen";
            case 12:
                return "Profiler";
            case 21:
                return "Scope";
            case 13:
                return "Suspense";
            case 19:
                return "SuspenseList";
            case 25:
                return "TracingMarker";
            case 1:
            case 0:
            case 17:
            case 2:
            case 14:
            case 15:
                if ("function" === typeof b) return b.displayName || b.name || null;
                if ("string" === typeof b) return b;
        }
        return null;
    }
    function ya(a) {
        var b = a, c = a;
        if (a.alternate) for(; b.return;)b = b.return;
        else {
            a = b;
            do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
            while (a);
        }
        return 3 === b.tag ? c : null;
    }
    function za(a) {
        if (ya(a) !== a) throw Error(n(188));
    }
    function Aa(a) {
        var b = a.alternate;
        if (!b) {
            b = ya(a);
            if (null === b) throw Error(n(188));
            return b !== a ? null : a;
        }
        for(var c = a, d = b;;){
            var e = c.return;
            if (null === e) break;
            var f = e.alternate;
            if (null === f) {
                d = e.return;
                if (null !== d) {
                    c = d;
                    continue;
                }
                break;
            }
            if (e.child === f.child) {
                for(f = e.child; f;){
                    if (f === c) return za(e), a;
                    if (f === d) return za(e), b;
                    f = f.sibling;
                }
                throw Error(n(188));
            }
            if (c.return !== d.return) c = e, d = f;
            else {
                for(var g = !1, h = e.child; h;){
                    if (h === c) {
                        g = !0;
                        c = e;
                        d = f;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = e;
                        c = f;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) {
                    for(h = f.child; h;){
                        if (h === c) {
                            g = !0;
                            c = f;
                            d = e;
                            break;
                        }
                        if (h === d) {
                            g = !0;
                            d = f;
                            c = e;
                            break;
                        }
                        h = h.sibling;
                    }
                    if (!g) throw Error(n(189));
                }
            }
            if (c.alternate !== d) throw Error(n(190));
        }
        if (3 !== c.tag) throw Error(n(188));
        return c.stateNode.current === c ? a : b;
    }
    function Ba(a) {
        a = Aa(a);
        return null !== a ? Ca(a) : null;
    }
    function Ca(a) {
        if (5 === a.tag || 6 === a.tag) return a;
        for(a = a.child; null !== a;){
            var b = Ca(a);
            if (null !== b) return b;
            a = a.sibling;
        }
        return null;
    }
    function Da(a) {
        if (5 === a.tag || 6 === a.tag) return a;
        for(a = a.child; null !== a;){
            if (4 !== a.tag) {
                var b = Da(a);
                if (null !== b) return b;
            }
            a = a.sibling;
        }
        return null;
    }
    var Ea = Array.isArray, Fa = $$$hostConfig.getPublicInstance, Ga = $$$hostConfig.getRootHostContext, Ha = $$$hostConfig.getChildHostContext, Ia = $$$hostConfig.prepareForCommit, Ja = $$$hostConfig.resetAfterCommit, Ka = $$$hostConfig.createInstance, La = $$$hostConfig.appendInitialChild, Ma = $$$hostConfig.finalizeInitialChildren, Na = $$$hostConfig.prepareUpdate, Oa = $$$hostConfig.shouldSetTextContent, Pa = $$$hostConfig.createTextInstance, Qa = $$$hostConfig.scheduleTimeout, Ra = $$$hostConfig.cancelTimeout, Sa = $$$hostConfig.noTimeout, Ta = $$$hostConfig.isPrimaryRenderer, Ua = $$$hostConfig.supportsMutation, Va = $$$hostConfig.supportsPersistence, p = $$$hostConfig.supportsHydration, Wa = $$$hostConfig.getInstanceFromNode, Xa = $$$hostConfig.preparePortalMount, Ya = $$$hostConfig.getCurrentEventPriority, Za = $$$hostConfig.detachDeletedInstance, $a = $$$hostConfig.supportsMicrotasks, ab = $$$hostConfig.scheduleMicrotask, bb = $$$hostConfig.supportsTestSelectors, cb = $$$hostConfig.findFiberRoot, db = $$$hostConfig.getBoundingRect, eb = $$$hostConfig.getTextContent, fb = $$$hostConfig.isHiddenSubtree, gb = $$$hostConfig.matchAccessibilityRole, hb = $$$hostConfig.setFocusIfFocusable, ib = $$$hostConfig.setupIntersectionObserver, jb = $$$hostConfig.appendChild, kb = $$$hostConfig.appendChildToContainer, lb = $$$hostConfig.commitTextUpdate, mb = $$$hostConfig.commitMount, nb = $$$hostConfig.commitUpdate, ob = $$$hostConfig.insertBefore, pb = $$$hostConfig.insertInContainerBefore, qb = $$$hostConfig.removeChild, rb = $$$hostConfig.removeChildFromContainer, sb = $$$hostConfig.resetTextContent, tb = $$$hostConfig.hideInstance, ub = $$$hostConfig.hideTextInstance, vb = $$$hostConfig.unhideInstance, wb = $$$hostConfig.unhideTextInstance, xb = $$$hostConfig.clearContainer, yb = $$$hostConfig.cloneInstance, zb = $$$hostConfig.createContainerChildSet, Ab = $$$hostConfig.appendChildToContainerChildSet, Bb = $$$hostConfig.finalizeContainerChildren, Cb = $$$hostConfig.replaceContainerChildren, Db = $$$hostConfig.cloneHiddenInstance, Eb = $$$hostConfig.cloneHiddenTextInstance, Fb = $$$hostConfig.canHydrateInstance, Gb = $$$hostConfig.canHydrateTextInstance, Hb = $$$hostConfig.canHydrateSuspenseInstance, Ib = $$$hostConfig.isSuspenseInstancePending, Jb = $$$hostConfig.isSuspenseInstanceFallback, Kb = $$$hostConfig.registerSuspenseInstanceRetry, Lb = $$$hostConfig.getNextHydratableSibling, Mb = $$$hostConfig.getFirstHydratableChild, Nb = $$$hostConfig.getFirstHydratableChildWithinContainer, Ob = $$$hostConfig.getFirstHydratableChildWithinSuspenseInstance, Pb = $$$hostConfig.hydrateInstance, Qb = $$$hostConfig.hydrateTextInstance, Rb = $$$hostConfig.hydrateSuspenseInstance, Sb = $$$hostConfig.getNextHydratableInstanceAfterSuspenseInstance, Tb = $$$hostConfig.commitHydratedContainer, Ub = $$$hostConfig.commitHydratedSuspenseInstance, Vb = $$$hostConfig.clearSuspenseBoundary, Wb = $$$hostConfig.clearSuspenseBoundaryFromContainer, Xb = $$$hostConfig.shouldDeleteUnhydratedTailInstances, Yb = $$$hostConfig.didNotMatchHydratedContainerTextInstance, Zb = $$$hostConfig.didNotMatchHydratedTextInstance, $b;
    function ac(a) {
        if (void 0 === $b) try {
            throw Error();
        } catch (c) {
            var b = c.stack.trim().match(/\n( *(at )?)/);
            $b = b && b[1] || "";
        }
        return "\n" + $b + a;
    }
    var bc = !1;
    function cc(a, b) {
        if (!a || bc) return "";
        bc = !0;
        var c = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        try {
            if (b) {
                if (b = function() {
                    throw Error();
                }, Object.defineProperty(b.prototype, "props", {
                    set: function() {
                        throw Error();
                    }
                }), "object" === typeof Reflect && Reflect.construct) {
                    try {
                        Reflect.construct(b, []);
                    } catch (l) {
                        var d = l;
                    }
                    Reflect.construct(a, [], b);
                } else {
                    try {
                        b.call();
                    } catch (l) {
                        d = l;
                    }
                    a.call(b.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (l) {
                    d = l;
                }
                a();
            }
        } catch (l) {
            if (l && d && "string" === typeof l.stack) {
                for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
                for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                    if (1 !== g || 1 !== h) {
                        do if (g--, h--, 0 > h || e[g] !== f[h]) {
                            var k = "\n" + e[g].replace(" at new ", " at ");
                            a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                            return k;
                        }
                        while (1 <= g && 0 <= h);
                    }
                    break;
                }
            }
        } finally{
            bc = !1, Error.prepareStackTrace = c;
        }
        return (a = a ? a.displayName || a.name : "") ? ac(a) : "";
    }
    var dc = Object.prototype.hasOwnProperty, ec = [], fc = -1;
    function gc(a) {
        return {
            current: a
        };
    }
    function x(a) {
        0 > fc || (a.current = ec[fc], ec[fc] = null, fc--);
    }
    function y(a, b) {
        fc++;
        ec[fc] = a.current;
        a.current = b;
    }
    var hc = {}, A = gc(hc), B = gc(!1), ic = hc;
    function jc(a, b) {
        var c = a.type.contextTypes;
        if (!c) return hc;
        var d = a.stateNode;
        if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
        var e = {}, f;
        for(f in c)e[f] = b[f];
        d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
        return e;
    }
    function C(a) {
        a = a.childContextTypes;
        return null !== a && void 0 !== a;
    }
    function kc() {
        x(B);
        x(A);
    }
    function lc(a, b, c) {
        if (A.current !== hc) throw Error(n(168));
        y(A, b);
        y(B, c);
    }
    function mc(a, b, c) {
        var d = a.stateNode;
        b = b.childContextTypes;
        if ("function" !== typeof d.getChildContext) return c;
        d = d.getChildContext();
        for(var e in d)if (!(e in b)) throw Error(n(108, xa(a) || "Unknown", e));
        return ca({}, c, d);
    }
    function nc(a) {
        a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || hc;
        ic = A.current;
        y(A, a);
        y(B, B.current);
        return !0;
    }
    function oc(a, b, c) {
        var d = a.stateNode;
        if (!d) throw Error(n(169));
        c ? (a = mc(a, b, ic), d.__reactInternalMemoizedMergedChildContext = a, x(B), x(A), y(A, a)) : x(B);
        y(B, c);
    }
    var qc = Math.clz32 ? Math.clz32 : pc, rc = Math.log, sc = Math.LN2;
    function pc(a) {
        a >>>= 0;
        return 0 === a ? 32 : 31 - (rc(a) / sc | 0) | 0;
    }
    var tc = 64, uc = 4194304;
    function vc(a) {
        switch(a & -a){
            case 1:
                return 1;
            case 2:
                return 2;
            case 4:
                return 4;
            case 8:
                return 8;
            case 16:
                return 16;
            case 32:
                return 32;
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
                return a & 4194240;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
            case 67108864:
                return a & 130023424;
            case 134217728:
                return 134217728;
            case 268435456:
                return 268435456;
            case 536870912:
                return 536870912;
            case 1073741824:
                return 1073741824;
            default:
                return a;
        }
    }
    function wc(a, b) {
        var c = a.pendingLanes;
        if (0 === c) return 0;
        var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
        if (0 !== g) {
            var h = g & ~e;
            0 !== h ? d = vc(h) : (f &= g, 0 !== f && (d = vc(f)));
        } else g = c & ~e, 0 !== g ? d = vc(g) : 0 !== f && (d = vc(f));
        if (0 === d) return 0;
        if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
        0 !== (d & 4) && (d |= c & 16);
        b = a.entangledLanes;
        if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - qc(b), e = 1 << c, d |= a[c], b &= ~e;
        return d;
    }
    function xc(a, b) {
        switch(a){
            case 1:
            case 2:
            case 4:
                return b + 250;
            case 8:
            case 16:
            case 32:
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
                return b + 5E3;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
            case 67108864:
                return -1;
            case 134217728:
            case 268435456:
            case 536870912:
            case 1073741824:
                return -1;
            default:
                return -1;
        }
    }
    function yc(a, b) {
        for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
            var g = 31 - qc(f), h = 1 << g, k = e[g];
            if (-1 === k) {
                if (0 === (h & c) || 0 !== (h & d)) e[g] = xc(h, b);
            } else k <= b && (a.expiredLanes |= h);
            f &= ~h;
        }
    }
    function zc(a) {
        a = a.pendingLanes & -1073741825;
        return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
    }
    function Ac(a) {
        for(var b = [], c = 0; 31 > c; c++)b.push(a);
        return b;
    }
    function Bc(a, b, c) {
        a.pendingLanes |= b;
        536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
        a = a.eventTimes;
        b = 31 - qc(b);
        a[b] = c;
    }
    function Cc(a, b) {
        var c = a.pendingLanes & ~b;
        a.pendingLanes = b;
        a.suspendedLanes = 0;
        a.pingedLanes = 0;
        a.expiredLanes &= b;
        a.mutableReadLanes &= b;
        a.entangledLanes &= b;
        b = a.entanglements;
        var d = a.eventTimes;
        for(a = a.expirationTimes; 0 < c;){
            var e = 31 - qc(c), f = 1 << e;
            b[e] = 0;
            d[e] = -1;
            a[e] = -1;
            c &= ~f;
        }
    }
    function Dc(a, b) {
        var c = a.entangledLanes |= b;
        for(a = a.entanglements; c;){
            var d = 31 - qc(c), e = 1 << d;
            e & b | a[d] & b && (a[d] |= b);
            c &= ~e;
        }
    }
    var D = 0;
    function Ec(a) {
        a &= -a;
        return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
    }
    var Fc = ba.unstable_scheduleCallback, Gc = ba.unstable_cancelCallback, Hc = ba.unstable_shouldYield, Ic = ba.unstable_requestPaint, E = ba.unstable_now, Jc = ba.unstable_ImmediatePriority, Kc = ba.unstable_UserBlockingPriority, Lc = ba.unstable_NormalPriority, Mc = ba.unstable_IdlePriority, Nc = null, Oc = null;
    function Pc(a) {
        if (Oc && "function" === typeof Oc.onCommitFiberRoot) try {
            Oc.onCommitFiberRoot(Nc, a, void 0, 128 === (a.current.flags & 128));
        } catch (b) {}
    }
    function Qc(a, b) {
        return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
    }
    var Rc = "function" === typeof Object.is ? Object.is : Qc, Sc = null, Tc = !1, Uc = !1;
    function Vc(a) {
        null === Sc ? Sc = [
            a
        ] : Sc.push(a);
    }
    function Wc(a) {
        Tc = !0;
        Vc(a);
    }
    function Xc() {
        if (!Uc && null !== Sc) {
            Uc = !0;
            var a = 0, b = D;
            try {
                var c = Sc;
                for(D = 1; a < c.length; a++){
                    var d = c[a];
                    do d = d(!0);
                    while (null !== d);
                }
                Sc = null;
                Tc = !1;
            } catch (e) {
                throw null !== Sc && (Sc = Sc.slice(a + 1)), Fc(Jc, Xc), e;
            } finally{
                D = b, Uc = !1;
            }
        }
        return null;
    }
    var Yc = ea.ReactCurrentBatchConfig;
    function Zc(a, b) {
        if (Rc(a, b)) return !0;
        if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
        var c = Object.keys(a), d = Object.keys(b);
        if (c.length !== d.length) return !1;
        for(d = 0; d < c.length; d++){
            var e = c[d];
            if (!dc.call(b, e) || !Rc(a[e], b[e])) return !1;
        }
        return !0;
    }
    function $c(a) {
        switch(a.tag){
            case 5:
                return ac(a.type);
            case 16:
                return ac("Lazy");
            case 13:
                return ac("Suspense");
            case 19:
                return ac("SuspenseList");
            case 0:
            case 2:
            case 15:
                return a = cc(a.type, !1), a;
            case 11:
                return a = cc(a.type.render, !1), a;
            case 1:
                return a = cc(a.type, !0), a;
            default:
                return "";
        }
    }
    function ad(a, b) {
        if (a && a.defaultProps) {
            b = ca({}, b);
            a = a.defaultProps;
            for(var c in a)void 0 === b[c] && (b[c] = a[c]);
            return b;
        }
        return b;
    }
    var bd = gc(null), cd = null, dd = null, ed = null;
    function fd() {
        ed = dd = cd = null;
    }
    function gd(a, b, c) {
        Ta ? (y(bd, b._currentValue), b._currentValue = c) : (y(bd, b._currentValue2), b._currentValue2 = c);
    }
    function hd(a) {
        var b = bd.current;
        x(bd);
        Ta ? a._currentValue = b : a._currentValue2 = b;
    }
    function id(a, b, c) {
        for(; null !== a;){
            var d = a.alternate;
            (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
            if (a === c) break;
            a = a.return;
        }
    }
    function jd(a, b) {
        cd = a;
        ed = dd = null;
        a = a.dependencies;
        null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (kd = !0), a.firstContext = null);
    }
    function ld(a) {
        var b = Ta ? a._currentValue : a._currentValue2;
        if (ed !== a) {
            if (a = {
                context: a,
                memoizedValue: b,
                next: null
            }, null === dd) {
                if (null === cd) throw Error(n(308));
                dd = a;
                cd.dependencies = {
                    lanes: 0,
                    firstContext: a
                };
            } else dd = dd.next = a;
        }
        return b;
    }
    var md = null, nd = !1;
    function od(a) {
        a.updateQueue = {
            baseState: a.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null,
                interleaved: null,
                lanes: 0
            },
            effects: null
        };
    }
    function pd(a, b) {
        a = a.updateQueue;
        b.updateQueue === a && (b.updateQueue = {
            baseState: a.baseState,
            firstBaseUpdate: a.firstBaseUpdate,
            lastBaseUpdate: a.lastBaseUpdate,
            shared: a.shared,
            effects: a.effects
        });
    }
    function qd(a, b) {
        return {
            eventTime: a,
            lane: b,
            tag: 0,
            payload: null,
            callback: null,
            next: null
        };
    }
    function rd(a, b) {
        var c = a.updateQueue;
        null !== c && (c = c.shared, null !== F && 0 !== (a.mode & 1) && 0 === (G & 2) ? (a = c.interleaved, null === a ? (b.next = b, null === md ? md = [
            c
        ] : md.push(c)) : (b.next = a.next, a.next = b), c.interleaved = b) : (a = c.pending, null === a ? b.next = b : (b.next = a.next, a.next = b), c.pending = b));
    }
    function sd(a, b, c) {
        b = b.updateQueue;
        if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
            var d = b.lanes;
            d &= a.pendingLanes;
            c |= d;
            b.lanes = c;
            Dc(a, c);
        }
    }
    function td(a, b) {
        var c = a.updateQueue, d = a.alternate;
        if (null !== d && (d = d.updateQueue, c === d)) {
            var e = null, f = null;
            c = c.firstBaseUpdate;
            if (null !== c) {
                do {
                    var g = {
                        eventTime: c.eventTime,
                        lane: c.lane,
                        tag: c.tag,
                        payload: c.payload,
                        callback: c.callback,
                        next: null
                    };
                    null === f ? e = f = g : f = f.next = g;
                    c = c.next;
                }while (null !== c);
                null === f ? e = f = b : f = f.next = b;
            } else e = f = b;
            c = {
                baseState: d.baseState,
                firstBaseUpdate: e,
                lastBaseUpdate: f,
                shared: d.shared,
                effects: d.effects
            };
            a.updateQueue = c;
            return;
        }
        a = c.lastBaseUpdate;
        null === a ? c.firstBaseUpdate = b : a.next = b;
        c.lastBaseUpdate = b;
    }
    function ud(a, b, c, d) {
        var e = a.updateQueue;
        nd = !1;
        var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
        if (null !== h) {
            e.shared.pending = null;
            var k = h, l = k.next;
            k.next = null;
            null === g ? f = l : g.next = l;
            g = k;
            var m = a.alternate;
            null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
        }
        if (null !== f) {
            var v = e.baseState;
            g = 0;
            m = l = k = null;
            h = f;
            do {
                var r = h.lane, z = h.eventTime;
                if ((d & r) === r) {
                    null !== m && (m = m.next = {
                        eventTime: z,
                        lane: 0,
                        tag: h.tag,
                        payload: h.payload,
                        callback: h.callback,
                        next: null
                    });
                    a: {
                        var q = a, N = h;
                        r = b;
                        z = c;
                        switch(N.tag){
                            case 1:
                                q = N.payload;
                                if ("function" === typeof q) {
                                    v = q.call(z, v, r);
                                    break a;
                                }
                                v = q;
                                break a;
                            case 3:
                                q.flags = q.flags & -65537 | 128;
                            case 0:
                                q = N.payload;
                                r = "function" === typeof q ? q.call(z, v, r) : q;
                                if (null === r || void 0 === r) break a;
                                v = ca({}, v, r);
                                break a;
                            case 2:
                                nd = !0;
                        }
                    }
                    null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                        h
                    ] : r.push(h));
                } else z = {
                    eventTime: z,
                    lane: r,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                }, null === m ? (l = m = z, k = v) : m = m.next = z, g |= r;
                h = h.next;
                if (null === h) {
                    if (h = e.shared.pending, null === h) break;
                    else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
                }
            }while (1);
            null === m && (k = v);
            e.baseState = k;
            e.firstBaseUpdate = l;
            e.lastBaseUpdate = m;
            b = e.shared.interleaved;
            if (null !== b) {
                e = b;
                do g |= e.lane, e = e.next;
                while (e !== b);
            } else null === f && (e.shared.lanes = 0);
            vd |= g;
            a.lanes = g;
            a.memoizedState = v;
        }
    }
    function wd(a, b, c) {
        a = b.effects;
        b.effects = null;
        if (null !== a) for(b = 0; b < a.length; b++){
            var d = a[b], e = d.callback;
            if (null !== e) {
                d.callback = null;
                d = c;
                if ("function" !== typeof e) throw Error(n(191, e));
                e.call(d);
            }
        }
    }
    var xd = (new aa.Component).refs;
    function yd(a, b, c, d) {
        b = a.memoizedState;
        c = c(d, b);
        c = null === c || void 0 === c ? b : ca({}, b, c);
        a.memoizedState = c;
        0 === a.lanes && (a.updateQueue.baseState = c);
    }
    var Bd = {
        isMounted: function(a) {
            return (a = a._reactInternals) ? ya(a) === a : !1;
        },
        enqueueSetState: function(a, b, c) {
            a = a._reactInternals;
            var d = H(), e = zd(a), f = qd(d, e);
            f.payload = b;
            void 0 !== c && null !== c && (f.callback = c);
            rd(a, f);
            b = Ad(a, e, d);
            null !== b && sd(b, a, e);
        },
        enqueueReplaceState: function(a, b, c) {
            a = a._reactInternals;
            var d = H(), e = zd(a), f = qd(d, e);
            f.tag = 1;
            f.payload = b;
            void 0 !== c && null !== c && (f.callback = c);
            rd(a, f);
            b = Ad(a, e, d);
            null !== b && sd(b, a, e);
        },
        enqueueForceUpdate: function(a, b) {
            a = a._reactInternals;
            var c = H(), d = zd(a), e = qd(c, d);
            e.tag = 2;
            void 0 !== b && null !== b && (e.callback = b);
            rd(a, e);
            b = Ad(a, d, c);
            null !== b && sd(b, a, d);
        }
    };
    function Cd(a, b, c, d, e, f, g) {
        a = a.stateNode;
        return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Zc(c, d) || !Zc(e, f) : !0;
    }
    function Dd(a, b, c) {
        var d = !1, e = hc;
        var f = b.contextType;
        "object" === typeof f && null !== f ? f = ld(f) : (e = C(b) ? ic : A.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? jc(a, e) : hc);
        b = new b(c, f);
        a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
        b.updater = Bd;
        a.stateNode = b;
        b._reactInternals = a;
        d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
        return b;
    }
    function Ed(a, b, c, d) {
        a = b.state;
        "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
        "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
        b.state !== a && Bd.enqueueReplaceState(b, b.state, null);
    }
    function Fd(a, b, c, d) {
        var e = a.stateNode;
        e.props = c;
        e.state = a.memoizedState;
        e.refs = xd;
        od(a);
        var f = b.contextType;
        "object" === typeof f && null !== f ? e.context = ld(f) : (f = C(b) ? ic : A.current, e.context = jc(a, f));
        e.state = a.memoizedState;
        f = b.getDerivedStateFromProps;
        "function" === typeof f && (yd(a, b, f, c), e.state = a.memoizedState);
        "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Bd.enqueueReplaceState(e, e.state, null), ud(a, c, e, d), e.state = a.memoizedState);
        "function" === typeof e.componentDidMount && (a.flags |= 4194308);
    }
    var Gd = [], Hd = 0, Id = null, Jd = 0, Kd = [], Ld = 0, Md = null, Nd = 1, Od = "";
    function Pd(a, b) {
        Gd[Hd++] = Jd;
        Gd[Hd++] = Id;
        Id = a;
        Jd = b;
    }
    function Qd(a, b, c) {
        Kd[Ld++] = Nd;
        Kd[Ld++] = Od;
        Kd[Ld++] = Md;
        Md = a;
        var d = Nd;
        a = Od;
        var e = 32 - qc(d) - 1;
        d &= ~(1 << e);
        c += 1;
        var f = 32 - qc(b) + e;
        if (30 < f) {
            var g = e - e % 5;
            f = (d & (1 << g) - 1).toString(32);
            d >>= g;
            e -= g;
            Nd = 1 << 32 - qc(b) + e | c << e | d;
            Od = f + a;
        } else Nd = 1 << f | c << e | d, Od = a;
    }
    function Rd(a) {
        null !== a.return && (Pd(a, 1), Qd(a, 1, 0));
    }
    function Sd(a) {
        for(; a === Id;)Id = Gd[--Hd], Gd[Hd] = null, Jd = Gd[--Hd], Gd[Hd] = null;
        for(; a === Md;)Md = Kd[--Ld], Kd[Ld] = null, Od = Kd[--Ld], Kd[Ld] = null, Nd = Kd[--Ld], Kd[Ld] = null;
    }
    var Td = null, Ud = null, I = !1, Vd = !1, Wd = null;
    function Xd(a, b) {
        var c = Yd(5, null, null, 0);
        c.elementType = "DELETED";
        c.stateNode = b;
        c.return = a;
        b = a.deletions;
        null === b ? (a.deletions = [
            c
        ], a.flags |= 16) : b.push(c);
    }
    function Zd(a, b) {
        switch(a.tag){
            case 5:
                return b = Fb(b, a.type, a.pendingProps), null !== b ? (a.stateNode = b, Td = a, Ud = Mb(b), !0) : !1;
            case 6:
                return b = Gb(b, a.pendingProps), null !== b ? (a.stateNode = b, Td = a, Ud = null, !0) : !1;
            case 13:
                b = Hb(b);
                if (null !== b) {
                    var c = null !== Md ? {
                        id: Nd,
                        overflow: Od
                    } : null;
                    a.memoizedState = {
                        dehydrated: b,
                        treeContext: c,
                        retryLane: 1073741824
                    };
                    c = Yd(18, null, null, 0);
                    c.stateNode = b;
                    c.return = a;
                    a.child = c;
                    Td = a;
                    Ud = null;
                    return !0;
                }
                return !1;
            default:
                return !1;
        }
    }
    function $d(a) {
        return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
    }
    function ae(a) {
        if (I) {
            var b = Ud;
            if (b) {
                var c = b;
                if (!Zd(a, b)) {
                    if ($d(a)) throw Error(n(418));
                    b = Lb(c);
                    var d = Td;
                    b && Zd(a, b) ? Xd(d, c) : (a.flags = a.flags & -4097 | 2, I = !1, Td = a);
                }
            } else {
                if ($d(a)) throw Error(n(418));
                a.flags = a.flags & -4097 | 2;
                I = !1;
                Td = a;
            }
        }
    }
    function be(a) {
        for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
        Td = a;
    }
    function ce(a) {
        if (!p || a !== Td) return !1;
        if (!I) return be(a), I = !0, !1;
        if (3 !== a.tag && (5 !== a.tag || Xb(a.type) && !Oa(a.type, a.memoizedProps))) {
            var b = Ud;
            if (b) {
                if ($d(a)) {
                    for(a = Ud; a;)a = Lb(a);
                    throw Error(n(418));
                }
                for(; b;)Xd(a, b), b = Lb(b);
            }
        }
        be(a);
        if (13 === a.tag) {
            if (!p) throw Error(n(316));
            a = a.memoizedState;
            a = null !== a ? a.dehydrated : null;
            if (!a) throw Error(n(317));
            Ud = Sb(a);
        } else Ud = Td ? Lb(a.stateNode) : null;
        return !0;
    }
    function de() {
        p && (Ud = Td = null, Vd = I = !1);
    }
    function ee(a) {
        null === Wd ? Wd = [
            a
        ] : Wd.push(a);
    }
    function fe(a, b, c) {
        a = c.ref;
        if (null !== a && "function" !== typeof a && "object" !== typeof a) {
            if (c._owner) {
                c = c._owner;
                if (c) {
                    if (1 !== c.tag) throw Error(n(309));
                    var d = c.stateNode;
                }
                if (!d) throw Error(n(147, a));
                var e = d, f = "" + a;
                if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
                b = function(a) {
                    var b = e.refs;
                    b === xd && (b = e.refs = {});
                    null === a ? delete b[f] : b[f] = a;
                };
                b._stringRef = f;
                return b;
            }
            if ("string" !== typeof a) throw Error(n(284));
            if (!c._owner) throw Error(n(290, a));
        }
        return a;
    }
    function ge(a, b) {
        a = Object.prototype.toString.call(b);
        throw Error(n(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
    }
    function he(a) {
        var b = a._init;
        return b(a._payload);
    }
    function ie(a) {
        function b(b, c) {
            if (a) {
                var d = b.deletions;
                null === d ? (b.deletions = [
                    c
                ], b.flags |= 16) : d.push(c);
            }
        }
        function c(c, d) {
            if (!a) return null;
            for(; null !== d;)b(c, d), d = d.sibling;
            return null;
        }
        function d(a, b) {
            for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
            return a;
        }
        function e(a, b) {
            a = je(a, b);
            a.index = 0;
            a.sibling = null;
            return a;
        }
        function f(b, c, d) {
            b.index = d;
            if (!a) return b.flags |= 1048576, c;
            d = b.alternate;
            if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
            b.flags |= 2;
            return c;
        }
        function g(b) {
            a && null === b.alternate && (b.flags |= 2);
            return b;
        }
        function h(a, b, c, d) {
            if (null === b || 6 !== b.tag) return b = ke(c, a.mode, d), b.return = a, b;
            b = e(b, c);
            b.return = a;
            return b;
        }
        function k(a, b, c, d) {
            var f = c.type;
            if (f === ia) return m(a, b, c.props.children, d, c.key);
            if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === ra && he(f) === b.type)) return d = e(b, c.props), d.ref = fe(a, b, c), d.return = a, d;
            d = le(c.type, c.key, c.props, null, a.mode, d);
            d.ref = fe(a, b, c);
            d.return = a;
            return d;
        }
        function l(a, b, c, d) {
            if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = me(c, a.mode, d), b.return = a, b;
            b = e(b, c.children || []);
            b.return = a;
            return b;
        }
        function m(a, b, c, d, f) {
            if (null === b || 7 !== b.tag) return b = ne(c, a.mode, d, f), b.return = a, b;
            b = e(b, c);
            b.return = a;
            return b;
        }
        function v(a, b, c) {
            if ("string" === typeof b && "" !== b || "number" === typeof b) return b = ke("" + b, a.mode, c), b.return = a, b;
            if ("object" === typeof b && null !== b) {
                switch(b.$$typeof){
                    case fa:
                        return c = le(b.type, b.key, b.props, null, a.mode, c), c.ref = fe(a, null, b), c.return = a, c;
                    case ha:
                        return b = me(b, a.mode, c), b.return = a, b;
                    case ra:
                        var d = b._init;
                        return v(a, d(b._payload), c);
                }
                if (Ea(b) || ua(b)) return b = ne(b, a.mode, c, null), b.return = a, b;
                ge(a, b);
            }
            return null;
        }
        function r(a, b, c, d) {
            var e = null !== b ? b.key : null;
            if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
            if ("object" === typeof c && null !== c) {
                switch(c.$$typeof){
                    case fa:
                        return c.key === e ? k(a, b, c, d) : null;
                    case ha:
                        return c.key === e ? l(a, b, c, d) : null;
                    case ra:
                        return e = c._init, r(a, b, e(c._payload), d);
                }
                if (Ea(c) || ua(c)) return null !== e ? null : m(a, b, c, d, null);
                ge(a, c);
            }
            return null;
        }
        function z(a, b, c, d, e) {
            if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
            if ("object" === typeof d && null !== d) {
                switch(d.$$typeof){
                    case fa:
                        return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                    case ha:
                        return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                    case ra:
                        var f = d._init;
                        return z(a, b, c, f(d._payload), e);
                }
                if (Ea(d) || ua(d)) return a = a.get(c) || null, m(b, a, d, e, null);
                ge(b, d);
            }
            return null;
        }
        function q(e, g, h, k) {
            for(var l = null, m = null, w = g, u = g = 0, t = null; null !== w && u < h.length; u++){
                w.index > u ? (t = w, w = null) : t = w.sibling;
                var q = r(e, w, h[u], k);
                if (null === q) {
                    null === w && (w = t);
                    break;
                }
                a && w && null === q.alternate && b(e, w);
                g = f(q, g, u);
                null === m ? l = q : m.sibling = q;
                m = q;
                w = t;
            }
            if (u === h.length) return c(e, w), I && Pd(e, u), l;
            if (null === w) {
                for(; u < h.length; u++)w = v(e, h[u], k), null !== w && (g = f(w, g, u), null === m ? l = w : m.sibling = w, m = w);
                I && Pd(e, u);
                return l;
            }
            for(w = d(e, w); u < h.length; u++)t = z(w, e, u, h[u], k), null !== t && (a && null !== t.alternate && w.delete(null === t.key ? u : t.key), g = f(t, g, u), null === m ? l = t : m.sibling = t, m = t);
            a && w.forEach(function(a) {
                return b(e, a);
            });
            I && Pd(e, u);
            return l;
        }
        function N(e, g, h, k) {
            var l = ua(h);
            if ("function" !== typeof l) throw Error(n(150));
            h = l.call(h);
            if (null == h) throw Error(n(151));
            for(var w = l = null, m = g, u = g = 0, q = null, t = h.next(); null !== m && !t.done; u++, t = h.next()){
                m.index > u ? (q = m, m = null) : q = m.sibling;
                var V = r(e, m, t.value, k);
                if (null === V) {
                    null === m && (m = q);
                    break;
                }
                a && m && null === V.alternate && b(e, m);
                g = f(V, g, u);
                null === w ? l = V : w.sibling = V;
                w = V;
                m = q;
            }
            if (t.done) return c(e, m), I && Pd(e, u), l;
            if (null === m) {
                for(; !t.done; u++, t = h.next())t = v(e, t.value, k), null !== t && (g = f(t, g, u), null === w ? l = t : w.sibling = t, w = t);
                I && Pd(e, u);
                return l;
            }
            for(m = d(e, m); !t.done; u++, t = h.next())t = z(m, e, u, t.value, k), null !== t && (a && null !== t.alternate && m.delete(null === t.key ? u : t.key), g = f(t, g, u), null === w ? l = t : w.sibling = t, w = t);
            a && m.forEach(function(a) {
                return b(e, a);
            });
            I && Pd(e, u);
            return l;
        }
        function da(a, d, f, h) {
            "object" === typeof f && null !== f && f.type === ia && null === f.key && (f = f.props.children);
            if ("object" === typeof f && null !== f) {
                switch(f.$$typeof){
                    case fa:
                        a: {
                            for(var k = f.key, l = d; null !== l;){
                                if (l.key === k) {
                                    k = f.type;
                                    if (k === ia) {
                                        if (7 === l.tag) {
                                            c(a, l.sibling);
                                            d = e(l, f.props.children);
                                            d.return = a;
                                            a = d;
                                            break a;
                                        }
                                    } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === ra && he(k) === l.type) {
                                        c(a, l.sibling);
                                        d = e(l, f.props);
                                        d.ref = fe(a, l, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    c(a, l);
                                    break;
                                } else b(a, l);
                                l = l.sibling;
                            }
                            f.type === ia ? (d = ne(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = le(f.type, f.key, f.props, null, a.mode, h), h.ref = fe(a, d, f), h.return = a, a = h);
                        }
                        return g(a);
                    case ha:
                        a: {
                            for(l = f.key; null !== d;){
                                if (d.key === l) {
                                    if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                        c(a, d.sibling);
                                        d = e(d, f.children || []);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    } else {
                                        c(a, d);
                                        break;
                                    }
                                } else b(a, d);
                                d = d.sibling;
                            }
                            d = me(f, a.mode, h);
                            d.return = a;
                            a = d;
                        }
                        return g(a);
                    case ra:
                        return l = f._init, da(a, d, l(f._payload), h);
                }
                if (Ea(f)) return q(a, d, f, h);
                if (ua(f)) return N(a, d, f, h);
                ge(a, f);
            }
            return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = ke(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
        }
        return da;
    }
    var oe = ie(!0), pe = ie(!1), qe = {}, re = gc(qe), se = gc(qe), te = gc(qe);
    function ue(a) {
        if (a === qe) throw Error(n(174));
        return a;
    }
    function ve(a, b) {
        y(te, b);
        y(se, a);
        y(re, qe);
        a = Ga(b);
        x(re);
        y(re, a);
    }
    function we() {
        x(re);
        x(se);
        x(te);
    }
    function xe(a) {
        var b = ue(te.current), c = ue(re.current);
        b = Ha(c, a.type, b);
        c !== b && (y(se, a), y(re, b));
    }
    function ye(a) {
        se.current === a && (x(re), x(se));
    }
    var J = gc(0);
    function ze(a) {
        for(var b = a; null !== b;){
            if (13 === b.tag) {
                var c = b.memoizedState;
                if (null !== c && (c = c.dehydrated, null === c || Ib(c) || Jb(c))) return b;
            } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
                if (0 !== (b.flags & 128)) return b;
            } else if (null !== b.child) {
                b.child.return = b;
                b = b.child;
                continue;
            }
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
        return null;
    }
    var Ae = [];
    function Be() {
        for(var a = 0; a < Ae.length; a++){
            var b = Ae[a];
            Ta ? b._workInProgressVersionPrimary = null : b._workInProgressVersionSecondary = null;
        }
        Ae.length = 0;
    }
    var Ce = ea.ReactCurrentDispatcher, De = ea.ReactCurrentBatchConfig, Ee = 0, K = null, L = null, M = null, Fe = !1, Ge = !1, He = 0, Ie = 0;
    function O() {
        throw Error(n(321));
    }
    function Je(a, b) {
        if (null === b) return !1;
        for(var c = 0; c < b.length && c < a.length; c++)if (!Rc(a[c], b[c])) return !1;
        return !0;
    }
    function Ke(a, b, c, d, e, f) {
        Ee = f;
        K = b;
        b.memoizedState = null;
        b.updateQueue = null;
        b.lanes = 0;
        Ce.current = null === a || null === a.memoizedState ? Le : Me;
        a = c(d, e);
        if (Ge) {
            f = 0;
            do {
                Ge = !1;
                He = 0;
                if (25 <= f) throw Error(n(301));
                f += 1;
                M = L = null;
                b.updateQueue = null;
                Ce.current = Ne;
                a = c(d, e);
            }while (Ge);
        }
        Ce.current = Oe;
        b = null !== L && null !== L.next;
        Ee = 0;
        M = L = K = null;
        Fe = !1;
        if (b) throw Error(n(300));
        return a;
    }
    function Pe() {
        var a = 0 !== He;
        He = 0;
        return a;
    }
    function Qe() {
        var a = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        null === M ? K.memoizedState = M = a : M = M.next = a;
        return M;
    }
    function Re() {
        if (null === L) {
            var a = K.alternate;
            a = null !== a ? a.memoizedState : null;
        } else a = L.next;
        var b = null === M ? K.memoizedState : M.next;
        if (null !== b) M = b, L = a;
        else {
            if (null === a) throw Error(n(310));
            L = a;
            a = {
                memoizedState: L.memoizedState,
                baseState: L.baseState,
                baseQueue: L.baseQueue,
                queue: L.queue,
                next: null
            };
            null === M ? K.memoizedState = M = a : M = M.next = a;
        }
        return M;
    }
    function Se(a, b) {
        return "function" === typeof b ? b(a) : b;
    }
    function Te(a) {
        var b = Re(), c = b.queue;
        if (null === c) throw Error(n(311));
        c.lastRenderedReducer = a;
        var d = L, e = d.baseQueue, f = c.pending;
        if (null !== f) {
            if (null !== e) {
                var g = e.next;
                e.next = f.next;
                f.next = g;
            }
            d.baseQueue = e = f;
            c.pending = null;
        }
        if (null !== e) {
            f = e.next;
            d = d.baseState;
            var h = g = null, k = null, l = f;
            do {
                var m = l.lane;
                if ((Ee & m) === m) null !== k && (k = k.next = {
                    lane: 0,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
                else {
                    var v = {
                        lane: m,
                        action: l.action,
                        hasEagerState: l.hasEagerState,
                        eagerState: l.eagerState,
                        next: null
                    };
                    null === k ? (h = k = v, g = d) : k = k.next = v;
                    K.lanes |= m;
                    vd |= m;
                }
                l = l.next;
            }while (null !== l && l !== f);
            null === k ? g = d : k.next = h;
            Rc(d, b.memoizedState) || (kd = !0);
            b.memoizedState = d;
            b.baseState = g;
            b.baseQueue = k;
            c.lastRenderedState = d;
        }
        a = c.interleaved;
        if (null !== a) {
            e = a;
            do f = e.lane, K.lanes |= f, vd |= f, e = e.next;
            while (e !== a);
        } else null === e && (c.lanes = 0);
        return [
            b.memoizedState,
            c.dispatch
        ];
    }
    function Ue(a) {
        var b = Re(), c = b.queue;
        if (null === c) throw Error(n(311));
        c.lastRenderedReducer = a;
        var d = c.dispatch, e = c.pending, f = b.memoizedState;
        if (null !== e) {
            c.pending = null;
            var g = e = e.next;
            do f = a(f, g.action), g = g.next;
            while (g !== e);
            Rc(f, b.memoizedState) || (kd = !0);
            b.memoizedState = f;
            null === b.baseQueue && (b.baseState = f);
            c.lastRenderedState = f;
        }
        return [
            f,
            d
        ];
    }
    function Ve() {}
    function We(a, b) {
        var c = K, d = Re(), e = b(), f = !Rc(d.memoizedState, e);
        f && (d.memoizedState = e, kd = !0);
        d = d.queue;
        Xe(Ye.bind(null, c, d, a), [
            a
        ]);
        if (d.getSnapshot !== b || f || null !== M && M.memoizedState.tag & 1) {
            c.flags |= 2048;
            Ze(9, $e.bind(null, c, d, e, b), void 0, null);
            if (null === F) throw Error(n(349));
            0 !== (Ee & 30) || af(c, b, e);
        }
        return e;
    }
    function af(a, b, c) {
        a.flags |= 16384;
        a = {
            getSnapshot: b,
            value: c
        };
        b = K.updateQueue;
        null === b ? (b = {
            lastEffect: null,
            stores: null
        }, K.updateQueue = b, b.stores = [
            a
        ]) : (c = b.stores, null === c ? b.stores = [
            a
        ] : c.push(a));
    }
    function $e(a, b, c, d) {
        b.value = c;
        b.getSnapshot = d;
        bf(b) && Ad(a, 1, -1);
    }
    function Ye(a, b, c) {
        return c(function() {
            bf(b) && Ad(a, 1, -1);
        });
    }
    function bf(a) {
        var b = a.getSnapshot;
        a = a.value;
        try {
            var c = b();
            return !Rc(a, c);
        } catch (d) {
            return !0;
        }
    }
    function cf(a) {
        var b = Qe();
        "function" === typeof a && (a = a());
        b.memoizedState = b.baseState = a;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: Se,
            lastRenderedState: a
        };
        b.queue = a;
        a = a.dispatch = df.bind(null, K, a);
        return [
            b.memoizedState,
            a
        ];
    }
    function Ze(a, b, c, d) {
        a = {
            tag: a,
            create: b,
            destroy: c,
            deps: d,
            next: null
        };
        b = K.updateQueue;
        null === b ? (b = {
            lastEffect: null,
            stores: null
        }, K.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
        return a;
    }
    function ef() {
        return Re().memoizedState;
    }
    function ff(a, b, c, d) {
        var e = Qe();
        K.flags |= a;
        e.memoizedState = Ze(1 | b, c, void 0, void 0 === d ? null : d);
    }
    function gf(a, b, c, d) {
        var e = Re();
        d = void 0 === d ? null : d;
        var f = void 0;
        if (null !== L) {
            var g = L.memoizedState;
            f = g.destroy;
            if (null !== d && Je(d, g.deps)) {
                e.memoizedState = Ze(b, c, f, d);
                return;
            }
        }
        K.flags |= a;
        e.memoizedState = Ze(1 | b, c, f, d);
    }
    function hf(a, b) {
        return ff(8390656, 8, a, b);
    }
    function Xe(a, b) {
        return gf(2048, 8, a, b);
    }
    function jf(a, b) {
        return gf(4, 2, a, b);
    }
    function kf(a, b) {
        return gf(4, 4, a, b);
    }
    function lf(a, b) {
        if ("function" === typeof b) return a = a(), b(a), function() {
            b(null);
        };
        if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
            b.current = null;
        };
    }
    function mf(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return gf(4, 4, lf.bind(null, b, a), c);
    }
    function nf() {}
    function of(a, b) {
        var c = Re();
        b = void 0 === b ? null : b;
        var d = c.memoizedState;
        if (null !== d && null !== b && Je(b, d[1])) return d[0];
        c.memoizedState = [
            a,
            b
        ];
        return a;
    }
    function pf(a, b) {
        var c = Re();
        b = void 0 === b ? null : b;
        var d = c.memoizedState;
        if (null !== d && null !== b && Je(b, d[1])) return d[0];
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    }
    function qf(a, b) {
        var c = D;
        D = 0 !== c && 4 > c ? c : 4;
        a(!0);
        var d = De.transition;
        De.transition = {};
        try {
            a(!1), b();
        } finally{
            D = c, De.transition = d;
        }
    }
    function rf() {
        return Re().memoizedState;
    }
    function sf(a, b, c) {
        var d = zd(a);
        c = {
            lane: d,
            action: c,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        tf(a) ? uf(b, c) : (vf(a, b, c), c = H(), a = Ad(a, d, c), null !== a && wf(a, b, d));
    }
    function df(a, b, c) {
        var d = zd(a), e = {
            lane: d,
            action: c,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        if (tf(a)) uf(b, e);
        else {
            vf(a, b, e);
            var f = a.alternate;
            if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
                var g = b.lastRenderedState, h = f(g, c);
                e.hasEagerState = !0;
                e.eagerState = h;
                if (Rc(h, g)) return;
            } catch (k) {} finally{}
            c = H();
            a = Ad(a, d, c);
            null !== a && wf(a, b, d);
        }
    }
    function tf(a) {
        var b = a.alternate;
        return a === K || null !== b && b === K;
    }
    function uf(a, b) {
        Ge = Fe = !0;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
    function vf(a, b, c) {
        null !== F && 0 !== (a.mode & 1) && 0 === (G & 2) ? (a = b.interleaved, null === a ? (c.next = c, null === md ? md = [
            b
        ] : md.push(b)) : (c.next = a.next, a.next = c), b.interleaved = c) : (a = b.pending, null === a ? c.next = c : (c.next = a.next, a.next = c), b.pending = c);
    }
    function wf(a, b, c) {
        if (0 !== (c & 4194240)) {
            var d = b.lanes;
            d &= a.pendingLanes;
            c |= d;
            b.lanes = c;
            Dc(a, c);
        }
    }
    var Oe = {
        readContext: ld,
        useCallback: O,
        useContext: O,
        useEffect: O,
        useImperativeHandle: O,
        useInsertionEffect: O,
        useLayoutEffect: O,
        useMemo: O,
        useReducer: O,
        useRef: O,
        useState: O,
        useDebugValue: O,
        useDeferredValue: O,
        useTransition: O,
        useMutableSource: O,
        useSyncExternalStore: O,
        useId: O,
        unstable_isNewReconciler: !1
    }, Le = {
        readContext: ld,
        useCallback: function(a, b) {
            Qe().memoizedState = [
                a,
                void 0 === b ? null : b
            ];
            return a;
        },
        useContext: ld,
        useEffect: hf,
        useImperativeHandle: function(a, b, c) {
            c = null !== c && void 0 !== c ? c.concat([
                a
            ]) : null;
            return ff(4194308, 4, lf.bind(null, b, a), c);
        },
        useLayoutEffect: function(a, b) {
            return ff(4194308, 4, a, b);
        },
        useInsertionEffect: function(a, b) {
            return ff(4, 2, a, b);
        },
        useMemo: function(a, b) {
            var c = Qe();
            b = void 0 === b ? null : b;
            a = a();
            c.memoizedState = [
                a,
                b
            ];
            return a;
        },
        useReducer: function(a, b, c) {
            var d = Qe();
            b = void 0 !== c ? c(b) : b;
            d.memoizedState = d.baseState = b;
            a = {
                pending: null,
                interleaved: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: a,
                lastRenderedState: b
            };
            d.queue = a;
            a = a.dispatch = sf.bind(null, K, a);
            return [
                d.memoizedState,
                a
            ];
        },
        useRef: function(a) {
            var b = Qe();
            a = {
                current: a
            };
            return b.memoizedState = a;
        },
        useState: cf,
        useDebugValue: nf,
        useDeferredValue: function(a) {
            var b = cf(a), c = b[0], d = b[1];
            hf(function() {
                var b = De.transition;
                De.transition = {};
                try {
                    d(a);
                } finally{
                    De.transition = b;
                }
            }, [
                a
            ]);
            return c;
        },
        useTransition: function() {
            var a = cf(!1), b = a[0];
            a = qf.bind(null, a[1]);
            Qe().memoizedState = a;
            return [
                b,
                a
            ];
        },
        useMutableSource: function() {},
        useSyncExternalStore: function(a, b, c) {
            var d = K, e = Qe();
            if (I) {
                if (void 0 === c) throw Error(n(407));
                c = c();
            } else {
                c = b();
                if (null === F) throw Error(n(349));
                0 !== (Ee & 30) || af(d, b, c);
            }
            e.memoizedState = c;
            var f = {
                value: c,
                getSnapshot: b
            };
            e.queue = f;
            hf(Ye.bind(null, d, f, a), [
                a
            ]);
            d.flags |= 2048;
            Ze(9, $e.bind(null, d, f, c, b), void 0, null);
            return c;
        },
        useId: function() {
            var a = Qe(), b = F.identifierPrefix;
            if (I) {
                var c = Od;
                var d = Nd;
                c = (d & ~(1 << 32 - qc(d) - 1)).toString(32) + c;
                b = ":" + b + "R" + c;
                c = He++;
                0 < c && (b += "H" + c.toString(32));
                b += ":";
            } else c = Ie++, b = ":" + b + "r" + c.toString(32) + ":";
            return a.memoizedState = b;
        },
        unstable_isNewReconciler: !1
    }, Me = {
        readContext: ld,
        useCallback: of,
        useContext: ld,
        useEffect: Xe,
        useImperativeHandle: mf,
        useInsertionEffect: jf,
        useLayoutEffect: kf,
        useMemo: pf,
        useReducer: Te,
        useRef: ef,
        useState: function() {
            return Te(Se);
        },
        useDebugValue: nf,
        useDeferredValue: function(a) {
            var b = Te(Se), c = b[0], d = b[1];
            Xe(function() {
                var b = De.transition;
                De.transition = {};
                try {
                    d(a);
                } finally{
                    De.transition = b;
                }
            }, [
                a
            ]);
            return c;
        },
        useTransition: function() {
            var a = Te(Se)[0], b = Re().memoizedState;
            return [
                a,
                b
            ];
        },
        useMutableSource: Ve,
        useSyncExternalStore: We,
        useId: rf,
        unstable_isNewReconciler: !1
    }, Ne = {
        readContext: ld,
        useCallback: of,
        useContext: ld,
        useEffect: Xe,
        useImperativeHandle: mf,
        useInsertionEffect: jf,
        useLayoutEffect: kf,
        useMemo: pf,
        useReducer: Ue,
        useRef: ef,
        useState: function() {
            return Ue(Se);
        },
        useDebugValue: nf,
        useDeferredValue: function(a) {
            var b = Ue(Se), c = b[0], d = b[1];
            Xe(function() {
                var b = De.transition;
                De.transition = {};
                try {
                    d(a);
                } finally{
                    De.transition = b;
                }
            }, [
                a
            ]);
            return c;
        },
        useTransition: function() {
            var a = Ue(Se)[0], b = Re().memoizedState;
            return [
                a,
                b
            ];
        },
        useMutableSource: Ve,
        useSyncExternalStore: We,
        useId: rf,
        unstable_isNewReconciler: !1
    };
    function xf(a, b) {
        try {
            var c = "", d = b;
            do c += $c(d), d = d.return;
            while (d);
            var e = c;
        } catch (f) {
            e = "\nError generating stack: " + f.message + "\n" + f.stack;
        }
        return {
            value: a,
            source: b,
            stack: e
        };
    }
    function yf(a, b) {
        try {
            console.error(b.value);
        } catch (c) {
            setTimeout(function() {
                throw c;
            });
        }
    }
    var zf = "function" === typeof WeakMap ? WeakMap : Map;
    function Af(a, b, c) {
        c = qd(-1, c);
        c.tag = 3;
        c.payload = {
            element: null
        };
        var d = b.value;
        c.callback = function() {
            Bf || (Bf = !0, Cf = d);
            yf(a, b);
        };
        return c;
    }
    function Df(a, b, c) {
        c = qd(-1, c);
        c.tag = 3;
        var d = a.type.getDerivedStateFromError;
        if ("function" === typeof d) {
            var e = b.value;
            c.payload = function() {
                return d(e);
            };
            c.callback = function() {
                yf(a, b);
            };
        }
        var f = a.stateNode;
        null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
            yf(a, b);
            "function" !== typeof d && (null === Ef ? Ef = new Set([
                this
            ]) : Ef.add(this));
            var c = b.stack;
            this.componentDidCatch(b.value, {
                componentStack: null !== c ? c : ""
            });
        });
        return c;
    }
    function Ff(a, b, c) {
        var d = a.pingCache;
        if (null === d) {
            d = a.pingCache = new zf;
            var e = new Set;
            d.set(b, e);
        } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
        e.has(c) || (e.add(c), a = Gf.bind(null, a, b, c), b.then(a, a));
    }
    function Hf(a) {
        do {
            var b;
            if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
            if (b) return a;
            a = a.return;
        }while (null !== a);
        return null;
    }
    function If(a, b, c, d, e) {
        if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = qd(-1, 1), b.tag = 2, rd(c, b))), c.lanes |= 1), a;
        a.flags |= 65536;
        a.lanes = e;
        return a;
    }
    function Jf(a) {
        a.flags |= 4;
    }
    function Kf(a, b) {
        if (null !== a && a.child === b.child) return !0;
        if (0 !== (b.flags & 16)) return !1;
        for(a = b.child; null !== a;){
            if (0 !== (a.flags & 12854) || 0 !== (a.subtreeFlags & 12854)) return !1;
            a = a.sibling;
        }
        return !0;
    }
    var Lf, Mf, Nf, Of;
    if (Ua) Lf = function(a, b) {
        for(var c = b.child; null !== c;){
            if (5 === c.tag || 6 === c.tag) La(a, c.stateNode);
            else if (4 !== c.tag && null !== c.child) {
                c.child.return = c;
                c = c.child;
                continue;
            }
            if (c === b) break;
            for(; null === c.sibling;){
                if (null === c.return || c.return === b) return;
                c = c.return;
            }
            c.sibling.return = c.return;
            c = c.sibling;
        }
    }, Mf = function() {}, Nf = function(a, b, c, d, e) {
        a = a.memoizedProps;
        if (a !== d) {
            var f = b.stateNode, g = ue(re.current);
            c = Na(f, c, a, d, e, g);
            (b.updateQueue = c) && Jf(b);
        }
    }, Of = function(a, b, c, d) {
        c !== d && Jf(b);
    };
    else if (Va) {
        Lf = function(a, b, c, d) {
            for(var e = b.child; null !== e;){
                if (5 === e.tag) {
                    var f = e.stateNode;
                    c && d && (f = Db(f, e.type, e.memoizedProps, e));
                    La(a, f);
                } else if (6 === e.tag) f = e.stateNode, c && d && (f = Eb(f, e.memoizedProps, e)), La(a, f);
                else if (4 !== e.tag) {
                    if (22 === e.tag && null !== e.memoizedState) f = e.child, null !== f && (f.return = e), Lf(a, e, !0, !0);
                    else if (null !== e.child) {
                        e.child.return = e;
                        e = e.child;
                        continue;
                    }
                }
                if (e === b) break;
                for(; null === e.sibling;){
                    if (null === e.return || e.return === b) return;
                    e = e.return;
                }
                e.sibling.return = e.return;
                e = e.sibling;
            }
        };
        var Pf = function(a, b, c, d) {
            for(var e = b.child; null !== e;){
                if (5 === e.tag) {
                    var f = e.stateNode;
                    c && d && (f = Db(f, e.type, e.memoizedProps, e));
                    Ab(a, f);
                } else if (6 === e.tag) f = e.stateNode, c && d && (f = Eb(f, e.memoizedProps, e)), Ab(a, f);
                else if (4 !== e.tag) {
                    if (22 === e.tag && null !== e.memoizedState) f = e.child, null !== f && (f.return = e), Pf(a, e, !0, !0);
                    else if (null !== e.child) {
                        e.child.return = e;
                        e = e.child;
                        continue;
                    }
                }
                if (e === b) break;
                for(; null === e.sibling;){
                    if (null === e.return || e.return === b) return;
                    e = e.return;
                }
                e.sibling.return = e.return;
                e = e.sibling;
            }
        };
        Mf = function(a, b) {
            var c = b.stateNode;
            if (!Kf(a, b)) {
                a = c.containerInfo;
                var d = zb(a);
                Pf(d, b, !1, !1);
                c.pendingChildren = d;
                Jf(b);
                Bb(a, d);
            }
        };
        Nf = function(a, b, c, d, e) {
            var f = a.stateNode, g = a.memoizedProps;
            if ((a = Kf(a, b)) && g === d) b.stateNode = f;
            else {
                var h = b.stateNode, k = ue(re.current), l = null;
                g !== d && (l = Na(h, c, g, d, e, k));
                a && null === l ? b.stateNode = f : (f = yb(f, l, c, g, d, b, a, h), Ma(f, c, d, e, k) && Jf(b), b.stateNode = f, a ? Jf(b) : Lf(f, b, !1, !1));
            }
        };
        Of = function(a, b, c, d) {
            c !== d ? (a = ue(te.current), c = ue(re.current), b.stateNode = Pa(d, a, c, b), Jf(b)) : b.stateNode = a.stateNode;
        };
    } else Mf = function() {}, Nf = function() {}, Of = function() {};
    function Qf(a, b) {
        if (!I) switch(a.tailMode){
            case "hidden":
                b = a.tail;
                for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
                null === c ? a.tail = null : c.sibling = null;
                break;
            case "collapsed":
                c = a.tail;
                for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
                null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
        }
    }
    function P(a) {
        var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
        if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
        else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
        a.subtreeFlags |= d;
        a.childLanes = c;
        return b;
    }
    function Rf(a, b, c) {
        var d = b.pendingProps;
        Sd(b);
        switch(b.tag){
            case 2:
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
                return P(b), null;
            case 1:
                return C(b.type) && kc(), P(b), null;
            case 3:
                d = b.stateNode;
                we();
                x(B);
                x(A);
                Be();
                d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
                if (null === a || null === a.child) ce(b) ? Jf(b) : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== Wd && (Sf(Wd), Wd = null));
                Mf(a, b);
                P(b);
                return null;
            case 5:
                ye(b);
                c = ue(te.current);
                var e = b.type;
                if (null !== a && null != b.stateNode) Nf(a, b, e, d, c), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
                else {
                    if (!d) {
                        if (null === b.stateNode) throw Error(n(166));
                        P(b);
                        return null;
                    }
                    a = ue(re.current);
                    if (ce(b)) {
                        if (!p) throw Error(n(175));
                        a = Pb(b.stateNode, b.type, b.memoizedProps, c, a, b, !Vd);
                        b.updateQueue = a;
                        null !== a && Jf(b);
                    } else {
                        var f = Ka(e, d, c, a, b);
                        Lf(f, b, !1, !1);
                        b.stateNode = f;
                        Ma(f, e, d, c, a) && Jf(b);
                    }
                    null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
                }
                P(b);
                return null;
            case 6:
                if (a && null != b.stateNode) Of(a, b, a.memoizedProps, d);
                else {
                    if ("string" !== typeof d && null === b.stateNode) throw Error(n(166));
                    a = ue(te.current);
                    c = ue(re.current);
                    if (ce(b)) {
                        if (!p) throw Error(n(176));
                        a = b.stateNode;
                        d = b.memoizedProps;
                        if (c = Qb(a, d, b, !Vd)) {
                            if (e = Td, null !== e) switch(f = 0 !== (e.mode & 1), e.tag){
                                case 3:
                                    Yb(e.stateNode.containerInfo, a, d, f);
                                    break;
                                case 5:
                                    Zb(e.type, e.memoizedProps, e.stateNode, a, d, f);
                            }
                        }
                        c && Jf(b);
                    } else b.stateNode = Pa(d, a, c, b);
                }
                P(b);
                return null;
            case 13:
                x(J);
                d = b.memoizedState;
                if (I && null !== Ud && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) {
                    for(a = Ud; a;)a = Lb(a);
                    de();
                    b.flags |= 98560;
                    return b;
                }
                if (null !== d && null !== d.dehydrated) {
                    d = ce(b);
                    if (null === a) {
                        if (!d) throw Error(n(318));
                        if (!p) throw Error(n(344));
                        a = b.memoizedState;
                        a = null !== a ? a.dehydrated : null;
                        if (!a) throw Error(n(317));
                        Rb(a, b);
                    } else de(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    P(b);
                    return null;
                }
                null !== Wd && (Sf(Wd), Wd = null);
                if (0 !== (b.flags & 128)) return b.lanes = c, b;
                d = null !== d;
                c = !1;
                null === a ? ce(b) : c = null !== a.memoizedState;
                d && !c && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (J.current & 1) ? 0 === Q && (Q = 3) : Tf()));
                null !== b.updateQueue && (b.flags |= 4);
                P(b);
                return null;
            case 4:
                return we(), Mf(a, b), null === a && Xa(b.stateNode.containerInfo), P(b), null;
            case 10:
                return hd(b.type._context), P(b), null;
            case 17:
                return C(b.type) && kc(), P(b), null;
            case 19:
                x(J);
                e = b.memoizedState;
                if (null === e) return P(b), null;
                d = 0 !== (b.flags & 128);
                f = e.rendering;
                if (null === f) {
                    if (d) Qf(e, !1);
                    else {
                        if (0 !== Q || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                            f = ze(a);
                            if (null !== f) {
                                b.flags |= 128;
                                Qf(e, !1);
                                a = f.updateQueue;
                                null !== a && (b.updateQueue = a, b.flags |= 4);
                                b.subtreeFlags = 0;
                                a = c;
                                for(d = b.child; null !== d;)c = d, e = a, c.flags &= 14680066, f = c.alternate, null === f ? (c.childLanes = 0, c.lanes = e, c.child = null, c.subtreeFlags = 0, c.memoizedProps = null, c.memoizedState = null, c.updateQueue = null, c.dependencies = null, c.stateNode = null) : (c.childLanes = f.childLanes, c.lanes = f.lanes, c.child = f.child, c.subtreeFlags = 0, c.deletions = null, c.memoizedProps = f.memoizedProps, c.memoizedState = f.memoizedState, c.updateQueue = f.updateQueue, c.type = f.type, e = f.dependencies, c.dependencies = null === e ? null : {
                                    lanes: e.lanes,
                                    firstContext: e.firstContext
                                }), d = d.sibling;
                                y(J, J.current & 1 | 2);
                                return b.child;
                            }
                            a = a.sibling;
                        }
                        null !== e.tail && E() > Uf && (b.flags |= 128, d = !0, Qf(e, !1), b.lanes = 4194304);
                    }
                } else {
                    if (!d) {
                        if (a = ze(f), null !== a) {
                            if (b.flags |= 128, d = !0, a = a.updateQueue, null !== a && (b.updateQueue = a, b.flags |= 4), Qf(e, !0), null === e.tail && "hidden" === e.tailMode && !f.alternate && !I) return P(b), null;
                        } else 2 * E() - e.renderingStartTime > Uf && 1073741824 !== c && (b.flags |= 128, d = !0, Qf(e, !1), b.lanes = 4194304);
                    }
                    e.isBackwards ? (f.sibling = b.child, b.child = f) : (a = e.last, null !== a ? a.sibling = f : b.child = f, e.last = f);
                }
                if (null !== e.tail) return b = e.tail, e.rendering = b, e.tail = b.sibling, e.renderingStartTime = E(), b.sibling = null, a = J.current, y(J, d ? a & 1 | 2 : a & 1), b;
                P(b);
                return null;
            case 22:
            case 23:
                return Vf(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (Wf & 1073741824) && (P(b), Ua && b.subtreeFlags & 6 && (b.flags |= 8192)) : P(b), null;
            case 24:
                return null;
            case 25:
                return null;
        }
        throw Error(n(156, b.tag));
    }
    var Xf = ea.ReactCurrentOwner, kd = !1;
    function R(a, b, c, d) {
        b.child = null === a ? pe(b, null, c, d) : oe(b, a.child, c, d);
    }
    function Yf(a, b, c, d, e) {
        c = c.render;
        var f = b.ref;
        jd(b, e);
        d = Ke(a, b, c, d, f, e);
        c = Pe();
        if (null !== a && !kd) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zf(a, b, e);
        I && c && Rd(b);
        b.flags |= 1;
        R(a, b, d, e);
        return b.child;
    }
    function $f(a, b, c, d, e) {
        if (null === a) {
            var f = c.type;
            if ("function" === typeof f && !ag(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, bg(a, b, f, d, e);
            a = le(c.type, null, d, b, b.mode, e);
            a.ref = b.ref;
            a.return = b;
            return b.child = a;
        }
        f = a.child;
        if (0 === (a.lanes & e)) {
            var g = f.memoizedProps;
            c = c.compare;
            c = null !== c ? c : Zc;
            if (c(g, d) && a.ref === b.ref) return Zf(a, b, e);
        }
        b.flags |= 1;
        a = je(f, d);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    function bg(a, b, c, d, e) {
        if (null !== a && Zc(a.memoizedProps, d) && a.ref === b.ref) {
            if (kd = !1, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (kd = !0);
            else return b.lanes = a.lanes, Zf(a, b, e);
        }
        return cg(a, b, c, d, e);
    }
    function dg(a, b, c) {
        var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
        if ("hidden" === d.mode) {
            if (0 === (b.mode & 1)) b.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, y(eg, Wf), Wf |= c;
            else if (0 !== (c & 1073741824)) b.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, d = null !== f ? f.baseLanes : c, y(eg, Wf), Wf |= d;
            else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null
            }, b.updateQueue = null, y(eg, Wf), Wf |= a, null;
        } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, y(eg, Wf), Wf |= d;
        R(a, b, e, c);
        return b.child;
    }
    function fg(a, b) {
        var c = b.ref;
        if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
    }
    function cg(a, b, c, d, e) {
        var f = C(c) ? ic : A.current;
        f = jc(b, f);
        jd(b, e);
        c = Ke(a, b, c, d, f, e);
        d = Pe();
        if (null !== a && !kd) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zf(a, b, e);
        I && d && Rd(b);
        b.flags |= 1;
        R(a, b, c, e);
        return b.child;
    }
    function gg(a, b, c, d, e) {
        if (C(c)) {
            var f = !0;
            nc(b);
        } else f = !1;
        jd(b, e);
        if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Dd(b, c, d), Fd(b, c, d, e), d = !0;
        else if (null === a) {
            var g = b.stateNode, h = b.memoizedProps;
            g.props = h;
            var k = g.context, l = c.contextType;
            "object" === typeof l && null !== l ? l = ld(l) : (l = C(c) ? ic : A.current, l = jc(b, l));
            var m = c.getDerivedStateFromProps, v = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
            v || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ed(b, g, d, l);
            nd = !1;
            var r = b.memoizedState;
            g.state = r;
            ud(b, d, g, e);
            k = b.memoizedState;
            h !== d || r !== k || B.current || nd ? ("function" === typeof m && (yd(b, c, m, d), k = b.memoizedState), (h = nd || Cd(b, c, h, d, r, k, l)) ? (v || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
        } else {
            g = b.stateNode;
            pd(a, b);
            h = b.memoizedProps;
            l = b.type === b.elementType ? h : ad(b.type, h);
            g.props = l;
            v = b.pendingProps;
            r = g.context;
            k = c.contextType;
            "object" === typeof k && null !== k ? k = ld(k) : (k = C(c) ? ic : A.current, k = jc(b, k));
            var z = c.getDerivedStateFromProps;
            (m = "function" === typeof z || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== v || r !== k) && Ed(b, g, d, k);
            nd = !1;
            r = b.memoizedState;
            g.state = r;
            ud(b, d, g, e);
            var q = b.memoizedState;
            h !== v || r !== q || B.current || nd ? ("function" === typeof z && (yd(b, c, z, d), q = b.memoizedState), (l = nd || Cd(b, c, l, d, r, q, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, q, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, q, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = q), g.props = d, g.state = q, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
        }
        return hg(a, b, c, d, f, e);
    }
    function hg(a, b, c, d, e, f) {
        fg(a, b);
        var g = 0 !== (b.flags & 128);
        if (!d && !g) return e && oc(b, c, !1), Zf(a, b, f);
        d = b.stateNode;
        Xf.current = b;
        var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
        b.flags |= 1;
        null !== a && g ? (b.child = oe(b, a.child, null, f), b.child = oe(b, null, h, f)) : R(a, b, h, f);
        b.memoizedState = d.state;
        e && oc(b, c, !0);
        return b.child;
    }
    function ig(a) {
        var b = a.stateNode;
        b.pendingContext ? lc(a, b.pendingContext, b.pendingContext !== b.context) : b.context && lc(a, b.context, !1);
        ve(a, b.containerInfo);
    }
    function jg(a, b, c, d, e) {
        de();
        ee(e);
        b.flags |= 256;
        R(a, b, c, d);
        return b.child;
    }
    var kg = {
        dehydrated: null,
        treeContext: null,
        retryLane: 0
    };
    function lg(a) {
        return {
            baseLanes: a,
            cachePool: null
        };
    }
    function mg(a, b, c) {
        var d = b.pendingProps, e = J.current, f = !1, g = 0 !== (b.flags & 128), h;
        (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
        if (h) f = !0, b.flags &= -129;
        else if (null === a || null !== a.memoizedState) e |= 1;
        y(J, e & 1);
        if (null === a) {
            ae(b);
            a = b.memoizedState;
            if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : Jb(a) ? b.lanes = 8 : b.lanes = 1073741824, null;
            e = d.children;
            a = d.fallback;
            return f ? (d = b.mode, f = b.child, e = {
                mode: "hidden",
                children: e
            }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = e) : f = ng(e, d, 0, null), a = ne(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = lg(c), b.memoizedState = kg, a) : og(b, e);
        }
        e = a.memoizedState;
        if (null !== e) {
            h = e.dehydrated;
            if (null !== h) {
                if (g) {
                    if (b.flags & 256) return b.flags &= -257, pg(a, b, c, Error(n(422)));
                    if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
                    f = d.fallback;
                    e = b.mode;
                    d = ng({
                        mode: "visible",
                        children: d.children
                    }, e, 0, null);
                    f = ne(f, e, c, null);
                    f.flags |= 2;
                    d.return = b;
                    f.return = b;
                    d.sibling = f;
                    b.child = d;
                    0 !== (b.mode & 1) && oe(b, a.child, null, c);
                    b.child.memoizedState = lg(c);
                    b.memoizedState = kg;
                    return f;
                }
                if (0 === (b.mode & 1)) b = pg(a, b, c, null);
                else if (Jb(h)) b = pg(a, b, c, Error(n(419)));
                else if (d = 0 !== (c & a.childLanes), kd || d) {
                    d = F;
                    if (null !== d) {
                        switch(c & -c){
                            case 4:
                                f = 2;
                                break;
                            case 16:
                                f = 8;
                                break;
                            case 64:
                            case 128:
                            case 256:
                            case 512:
                            case 1024:
                            case 2048:
                            case 4096:
                            case 8192:
                            case 16384:
                            case 32768:
                            case 65536:
                            case 131072:
                            case 262144:
                            case 524288:
                            case 1048576:
                            case 2097152:
                            case 4194304:
                            case 8388608:
                            case 16777216:
                            case 33554432:
                            case 67108864:
                                f = 32;
                                break;
                            case 536870912:
                                f = 268435456;
                                break;
                            default:
                                f = 0;
                        }
                        d = 0 !== (f & (d.suspendedLanes | c)) ? 0 : f;
                        0 !== d && d !== e.retryLane && (e.retryLane = d, Ad(a, d, -1));
                    }
                    Tf();
                    b = pg(a, b, c, Error(n(421)));
                } else Ib(h) ? (b.flags |= 128, b.child = a.child, b = qg.bind(null, a), Kb(h, b), b = null) : (c = e.treeContext, p && (Ud = Ob(h), Td = b, I = !0, Wd = null, Vd = !1, null !== c && (Kd[Ld++] = Nd, Kd[Ld++] = Od, Kd[Ld++] = Md, Nd = c.id, Od = c.overflow, Md = b)), b = og(b, b.pendingProps.children), b.flags |= 4096);
                return b;
            }
            if (f) return d = rg(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? lg(c) : {
                baseLanes: e.baseLanes | c,
                cachePool: null
            }, f.childLanes = a.childLanes & ~c, b.memoizedState = kg, d;
            c = sg(a, b, d.children, c);
            b.memoizedState = null;
            return c;
        }
        if (f) return d = rg(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? lg(c) : {
            baseLanes: e.baseLanes | c,
            cachePool: null
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = kg, d;
        c = sg(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    function og(a, b) {
        b = ng({
            mode: "visible",
            children: b
        }, a.mode, 0, null);
        b.return = a;
        return a.child = b;
    }
    function sg(a, b, c, d) {
        var e = a.child;
        a = e.sibling;
        c = je(e, {
            mode: "visible",
            children: c
        });
        0 === (b.mode & 1) && (c.lanes = d);
        c.return = b;
        c.sibling = null;
        null !== a && (d = b.deletions, null === d ? (b.deletions = [
            a
        ], b.flags |= 16) : d.push(a));
        return b.child = c;
    }
    function rg(a, b, c, d, e) {
        var f = b.mode;
        a = a.child;
        var g = a.sibling, h = {
            mode: "hidden",
            children: c
        };
        0 === (f & 1) && b.child !== a ? (c = b.child, c.childLanes = 0, c.pendingProps = h, b.deletions = null) : (c = je(a, h), c.subtreeFlags = a.subtreeFlags & 14680064);
        null !== g ? d = je(g, d) : (d = ne(d, f, e, null), d.flags |= 2);
        d.return = b;
        c.return = b;
        c.sibling = d;
        b.child = c;
        return d;
    }
    function pg(a, b, c, d) {
        null !== d && ee(d);
        oe(b, a.child, null, c);
        a = og(b, b.pendingProps.children);
        a.flags |= 2;
        b.memoizedState = null;
        return a;
    }
    function tg(a, b, c) {
        a.lanes |= b;
        var d = a.alternate;
        null !== d && (d.lanes |= b);
        id(a.return, b, c);
    }
    function ug(a, b, c, d, e) {
        var f = a.memoizedState;
        null === f ? a.memoizedState = {
            isBackwards: b,
            rendering: null,
            renderingStartTime: 0,
            last: d,
            tail: c,
            tailMode: e
        } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
    }
    function vg(a, b, c) {
        var d = b.pendingProps, e = d.revealOrder, f = d.tail;
        R(a, b, d.children, c);
        d = J.current;
        if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
        else {
            if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
                if (13 === a.tag) null !== a.memoizedState && tg(a, c, b);
                else if (19 === a.tag) tg(a, c, b);
                else if (null !== a.child) {
                    a.child.return = a;
                    a = a.child;
                    continue;
                }
                if (a === b) break a;
                for(; null === a.sibling;){
                    if (null === a.return || a.return === b) break a;
                    a = a.return;
                }
                a.sibling.return = a.return;
                a = a.sibling;
            }
            d &= 1;
        }
        y(J, d);
        if (0 === (b.mode & 1)) b.memoizedState = null;
        else switch(e){
            case "forwards":
                c = b.child;
                for(e = null; null !== c;)a = c.alternate, null !== a && null === ze(a) && (e = c), c = c.sibling;
                c = e;
                null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
                ug(b, !1, e, c, f);
                break;
            case "backwards":
                c = null;
                e = b.child;
                for(b.child = null; null !== e;){
                    a = e.alternate;
                    if (null !== a && null === ze(a)) {
                        b.child = e;
                        break;
                    }
                    a = e.sibling;
                    e.sibling = c;
                    c = e;
                    e = a;
                }
                ug(b, !0, c, null, f);
                break;
            case "together":
                ug(b, !1, null, null, void 0);
                break;
            default:
                b.memoizedState = null;
        }
        return b.child;
    }
    function Zf(a, b, c) {
        null !== a && (b.dependencies = a.dependencies);
        vd |= b.lanes;
        if (0 === (c & b.childLanes)) return null;
        if (null !== a && b.child !== a.child) throw Error(n(153));
        if (null !== b.child) {
            a = b.child;
            c = je(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = je(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    function wg(a, b, c) {
        switch(b.tag){
            case 3:
                ig(b);
                de();
                break;
            case 5:
                xe(b);
                break;
            case 1:
                C(b.type) && nc(b);
                break;
            case 4:
                ve(b, b.stateNode.containerInfo);
                break;
            case 10:
                gd(b, b.type._context, b.memoizedProps.value);
                break;
            case 13:
                var d = b.memoizedState;
                if (null !== d) {
                    if (null !== d.dehydrated) return y(J, J.current & 1), b.flags |= 128, null;
                    if (0 !== (c & b.child.childLanes)) return mg(a, b, c);
                    y(J, J.current & 1);
                    a = Zf(a, b, c);
                    return null !== a ? a.sibling : null;
                }
                y(J, J.current & 1);
                break;
            case 19:
                d = 0 !== (c & b.childLanes);
                if (0 !== (a.flags & 128)) {
                    if (d) return vg(a, b, c);
                    b.flags |= 128;
                }
                var e = b.memoizedState;
                null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                y(J, J.current);
                if (d) break;
                else return null;
            case 22:
            case 23:
                return b.lanes = 0, dg(a, b, c);
        }
        return Zf(a, b, c);
    }
    function xg(a, b) {
        Sd(b);
        switch(b.tag){
            case 1:
                return C(b.type) && kc(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
            case 3:
                return we(), x(B), x(A), Be(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
            case 5:
                return ye(b), null;
            case 13:
                x(J);
                a = b.memoizedState;
                if (null !== a && null !== a.dehydrated) {
                    if (null === b.alternate) throw Error(n(340));
                    de();
                }
                a = b.flags;
                return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
            case 19:
                return x(J), null;
            case 4:
                return we(), null;
            case 10:
                return hd(b.type._context), null;
            case 22:
            case 23:
                return Vf(), null;
            case 24:
                return null;
            default:
                return null;
        }
    }
    var yg = !1, zg = !1, Ag = "function" === typeof WeakSet ? WeakSet : Set, S = null;
    function Bg(a, b) {
        var c = a.ref;
        if (null !== c) {
            if ("function" === typeof c) try {
                c(null);
            } catch (d) {
                T(a, b, d);
            }
            else c.current = null;
        }
    }
    function Cg(a, b, c) {
        try {
            c();
        } catch (d) {
            T(a, b, d);
        }
    }
    var Dg = !1;
    function Eg(a, b) {
        Ia(a.containerInfo);
        for(S = b; null !== S;)if (a = S, b = a.child, 0 !== (a.subtreeFlags & 1028) && null !== b) b.return = a, S = b;
        else for(; null !== S;){
            a = S;
            try {
                var c = a.alternate;
                if (0 !== (a.flags & 1024)) switch(a.tag){
                    case 0:
                    case 11:
                    case 15:
                        break;
                    case 1:
                        if (null !== c) {
                            var d = c.memoizedProps, e = c.memoizedState, f = a.stateNode, g = f.getSnapshotBeforeUpdate(a.elementType === a.type ? d : ad(a.type, d), e);
                            f.__reactInternalSnapshotBeforeUpdate = g;
                        }
                        break;
                    case 3:
                        Ua && xb(a.stateNode.containerInfo);
                        break;
                    case 5:
                    case 6:
                    case 4:
                    case 17:
                        break;
                    default:
                        throw Error(n(163));
                }
            } catch (h) {
                T(a, a.return, h);
            }
            b = a.sibling;
            if (null !== b) {
                b.return = a.return;
                S = b;
                break;
            }
            S = a.return;
        }
        c = Dg;
        Dg = !1;
        return c;
    }
    function Fg(a, b, c) {
        var d = b.updateQueue;
        d = null !== d ? d.lastEffect : null;
        if (null !== d) {
            var e = d = d.next;
            do {
                if ((e.tag & a) === a) {
                    var f = e.destroy;
                    e.destroy = void 0;
                    void 0 !== f && Cg(b, c, f);
                }
                e = e.next;
            }while (e !== d);
        }
    }
    function Gg(a, b) {
        b = b.updateQueue;
        b = null !== b ? b.lastEffect : null;
        if (null !== b) {
            var c = b = b.next;
            do {
                if ((c.tag & a) === a) {
                    var d = c.create;
                    c.destroy = d();
                }
                c = c.next;
            }while (c !== b);
        }
    }
    function Hg(a) {
        var b = a.ref;
        if (null !== b) {
            var c = a.stateNode;
            switch(a.tag){
                case 5:
                    a = Fa(c);
                    break;
                default:
                    a = c;
            }
            "function" === typeof b ? b(a) : b.current = a;
        }
    }
    function Ig(a, b, c) {
        if (Oc && "function" === typeof Oc.onCommitFiberUnmount) try {
            Oc.onCommitFiberUnmount(Nc, b);
        } catch (g) {}
        switch(b.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                a = b.updateQueue;
                if (null !== a && (a = a.lastEffect, null !== a)) {
                    var d = a = a.next;
                    do {
                        var e = d, f = e.destroy;
                        e = e.tag;
                        void 0 !== f && (0 !== (e & 2) ? Cg(b, c, f) : 0 !== (e & 4) && Cg(b, c, f));
                        d = d.next;
                    }while (d !== a);
                }
                break;
            case 1:
                Bg(b, c);
                a = b.stateNode;
                if ("function" === typeof a.componentWillUnmount) try {
                    a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
                } catch (g) {
                    T(b, c, g);
                }
                break;
            case 5:
                Bg(b, c);
                break;
            case 4:
                Ua ? Jg(a, b, c) : Va && Va && (b = b.stateNode.containerInfo, c = zb(b), Cb(b, c));
        }
    }
    function Kg(a, b, c) {
        for(var d = b;;)if (Ig(a, d, c), null === d.child || Ua && 4 === d.tag) {
            if (d === b) break;
            for(; null === d.sibling;){
                if (null === d.return || d.return === b) return;
                d = d.return;
            }
            d.sibling.return = d.return;
            d = d.sibling;
        } else d.child.return = d, d = d.child;
    }
    function Lg(a) {
        var b = a.alternate;
        null !== b && (a.alternate = null, Lg(b));
        a.child = null;
        a.deletions = null;
        a.sibling = null;
        5 === a.tag && (b = a.stateNode, null !== b && Za(b));
        a.stateNode = null;
        a.return = null;
        a.dependencies = null;
        a.memoizedProps = null;
        a.memoizedState = null;
        a.pendingProps = null;
        a.stateNode = null;
        a.updateQueue = null;
    }
    function Mg(a) {
        return 5 === a.tag || 3 === a.tag || 4 === a.tag;
    }
    function Ng(a) {
        a: for(;;){
            for(; null === a.sibling;){
                if (null === a.return || Mg(a.return)) return null;
                a = a.return;
            }
            a.sibling.return = a.return;
            for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
                if (a.flags & 2) continue a;
                if (null === a.child || 4 === a.tag) continue a;
                else a.child.return = a, a = a.child;
            }
            if (!(a.flags & 2)) return a.stateNode;
        }
    }
    function Og(a) {
        if (Ua) {
            a: {
                for(var b = a.return; null !== b;){
                    if (Mg(b)) break a;
                    b = b.return;
                }
                throw Error(n(160));
            }
            var c = b;
            switch(c.tag){
                case 5:
                    b = c.stateNode;
                    c.flags & 32 && (sb(b), c.flags &= -33);
                    c = Ng(a);
                    Pg(a, c, b);
                    break;
                case 3:
                case 4:
                    b = c.stateNode.containerInfo;
                    c = Ng(a);
                    Qg(a, c, b);
                    break;
                default:
                    throw Error(n(161));
            }
        }
    }
    function Qg(a, b, c) {
        var d = a.tag;
        if (5 === d || 6 === d) a = a.stateNode, b ? pb(c, a, b) : kb(c, a);
        else if (4 !== d && (a = a.child, null !== a)) for(Qg(a, b, c), a = a.sibling; null !== a;)Qg(a, b, c), a = a.sibling;
    }
    function Pg(a, b, c) {
        var d = a.tag;
        if (5 === d || 6 === d) a = a.stateNode, b ? ob(c, a, b) : jb(c, a);
        else if (4 !== d && (a = a.child, null !== a)) for(Pg(a, b, c), a = a.sibling; null !== a;)Pg(a, b, c), a = a.sibling;
    }
    function Jg(a, b, c) {
        for(var d = b, e = !1, f, g;;){
            if (!e) {
                e = d.return;
                a: for(;;){
                    if (null === e) throw Error(n(160));
                    f = e.stateNode;
                    switch(e.tag){
                        case 5:
                            g = !1;
                            break a;
                        case 3:
                            f = f.containerInfo;
                            g = !0;
                            break a;
                        case 4:
                            f = f.containerInfo;
                            g = !0;
                            break a;
                    }
                    e = e.return;
                }
                e = !0;
            }
            if (5 === d.tag || 6 === d.tag) Kg(a, d, c), g ? rb(f, d.stateNode) : qb(f, d.stateNode);
            else if (18 === d.tag) g ? Wb(f, d.stateNode) : Vb(f, d.stateNode);
            else if (4 === d.tag) {
                if (null !== d.child) {
                    f = d.stateNode.containerInfo;
                    g = !0;
                    d.child.return = d;
                    d = d.child;
                    continue;
                }
            } else if (Ig(a, d, c), null !== d.child) {
                d.child.return = d;
                d = d.child;
                continue;
            }
            if (d === b) break;
            for(; null === d.sibling;){
                if (null === d.return || d.return === b) return;
                d = d.return;
                4 === d.tag && (e = !1);
            }
            d.sibling.return = d.return;
            d = d.sibling;
        }
    }
    function Rg(a, b) {
        if (Ua) {
            switch(b.tag){
                case 0:
                case 11:
                case 14:
                case 15:
                    Fg(3, b, b.return);
                    Gg(3, b);
                    Fg(5, b, b.return);
                    return;
                case 1:
                    return;
                case 5:
                    var c = b.stateNode;
                    if (null != c) {
                        var d = b.memoizedProps;
                        a = null !== a ? a.memoizedProps : d;
                        var e = b.type, f = b.updateQueue;
                        b.updateQueue = null;
                        null !== f && nb(c, f, e, a, d, b);
                    }
                    return;
                case 6:
                    if (null === b.stateNode) throw Error(n(162));
                    c = b.memoizedProps;
                    lb(b.stateNode, null !== a ? a.memoizedProps : c, c);
                    return;
                case 3:
                    p && null !== a && a.memoizedState.isDehydrated && Tb(b.stateNode.containerInfo);
                    return;
                case 12:
                    return;
                case 13:
                    Sg(b);
                    return;
                case 19:
                    Sg(b);
                    return;
                case 17:
                    return;
            }
            throw Error(n(163));
        }
        switch(b.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                Fg(3, b, b.return);
                Gg(3, b);
                Fg(5, b, b.return);
                return;
            case 12:
                return;
            case 13:
                Sg(b);
                return;
            case 19:
                Sg(b);
                return;
            case 3:
                p && null !== a && a.memoizedState.isDehydrated && Tb(b.stateNode.containerInfo);
                break;
            case 22:
            case 23:
                return;
        }
        a: if (Va) {
            switch(b.tag){
                case 1:
                case 5:
                case 6:
                    break a;
                case 3:
                case 4:
                    b = b.stateNode;
                    Cb(b.containerInfo, b.pendingChildren);
                    break a;
            }
            throw Error(n(163));
        }
    }
    function Sg(a) {
        var b = a.updateQueue;
        if (null !== b) {
            a.updateQueue = null;
            var c = a.stateNode;
            null === c && (c = a.stateNode = new Ag);
            b.forEach(function(b) {
                var d = Tg.bind(null, a, b);
                c.has(b) || (c.add(b), b.then(d, d));
            });
        }
    }
    function Ug(a, b) {
        for(S = b; null !== S;){
            b = S;
            var c = b.deletions;
            if (null !== c) for(var d = 0; d < c.length; d++){
                var e = c[d];
                try {
                    var f = a;
                    Ua ? Jg(f, e, b) : Kg(f, e, b);
                    var g = e.alternate;
                    null !== g && (g.return = null);
                    e.return = null;
                } catch (wa) {
                    T(e, b, wa);
                }
            }
            c = b.child;
            if (0 !== (b.subtreeFlags & 12854) && null !== c) c.return = b, S = c;
            else for(; null !== S;){
                b = S;
                try {
                    var h = b.flags;
                    h & 32 && Ua && sb(b.stateNode);
                    if (h & 512) {
                        var k = b.alternate;
                        if (null !== k) {
                            var l = k.ref;
                            null !== l && ("function" === typeof l ? l(null) : l.current = null);
                        }
                    }
                    if (h & 8192) switch(b.tag){
                        case 13:
                            if (null !== b.memoizedState) {
                                var m = b.alternate;
                                if (null === m || null === m.memoizedState) Vg = E();
                            }
                            break;
                        case 22:
                            var v = null !== b.memoizedState, r = b.alternate, z = null !== r && null !== r.memoizedState;
                            c = b;
                            if (Ua) {
                                a: if (d = c, e = v, f = null, Ua) for(var q = d;;){
                                    if (5 === q.tag) {
                                        if (null === f) {
                                            f = q;
                                            var N = q.stateNode;
                                            e ? tb(N) : vb(q.stateNode, q.memoizedProps);
                                        }
                                    } else if (6 === q.tag) {
                                        if (null === f) {
                                            var da = q.stateNode;
                                            e ? ub(da) : wb(da, q.memoizedProps);
                                        }
                                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === d) && null !== q.child) {
                                        q.child.return = q;
                                        q = q.child;
                                        continue;
                                    }
                                    if (q === d) break;
                                    for(; null === q.sibling;){
                                        if (null === q.return || q.return === d) break a;
                                        f === q && (f = null);
                                        q = q.return;
                                    }
                                    f === q && (f = null);
                                    q.sibling.return = q.return;
                                    q = q.sibling;
                                }
                            }
                            if (v && !z && 0 !== (c.mode & 1)) {
                                S = c;
                                for(var t = c.child; null !== t;){
                                    for(c = S = t; null !== S;){
                                        d = S;
                                        var w = d.child;
                                        switch(d.tag){
                                            case 0:
                                            case 11:
                                            case 14:
                                            case 15:
                                                Fg(4, d, d.return);
                                                break;
                                            case 1:
                                                Bg(d, d.return);
                                                var u = d.stateNode;
                                                if ("function" === typeof u.componentWillUnmount) {
                                                    var V = d.return;
                                                    try {
                                                        u.props = d.memoizedProps, u.state = d.memoizedState, u.componentWillUnmount();
                                                    } catch (wa) {
                                                        T(d, V, wa);
                                                    }
                                                }
                                                break;
                                            case 5:
                                                Bg(d, d.return);
                                                break;
                                            case 22:
                                                if (null !== d.memoizedState) {
                                                    Wg(c);
                                                    continue;
                                                }
                                        }
                                        null !== w ? (w.return = d, S = w) : Wg(c);
                                    }
                                    t = t.sibling;
                                }
                            }
                    }
                    switch(h & 4102){
                        case 2:
                            Og(b);
                            b.flags &= -3;
                            break;
                        case 6:
                            Og(b);
                            b.flags &= -3;
                            Rg(b.alternate, b);
                            break;
                        case 4096:
                            b.flags &= -4097;
                            break;
                        case 4100:
                            b.flags &= -4097;
                            Rg(b.alternate, b);
                            break;
                        case 4:
                            Rg(b.alternate, b);
                    }
                } catch (wa) {
                    T(b, b.return, wa);
                }
                c = b.sibling;
                if (null !== c) {
                    c.return = b.return;
                    S = c;
                    break;
                }
                S = b.return;
            }
        }
    }
    function Xg(a, b, c) {
        S = a;
        Yg(a, b, c);
    }
    function Yg(a, b, c) {
        for(var d = 0 !== (a.mode & 1); null !== S;){
            var e = S, f = e.child;
            if (22 === e.tag && d) {
                var g = null !== e.memoizedState || yg;
                if (!g) {
                    var h = e.alternate, k = null !== h && null !== h.memoizedState || zg;
                    h = yg;
                    var l = zg;
                    yg = g;
                    if ((zg = k) && !l) for(S = e; null !== S;)g = S, k = g.child, 22 === g.tag && null !== g.memoizedState ? Zg(e) : null !== k ? (k.return = g, S = k) : Zg(e);
                    for(; null !== f;)S = f, Yg(f, b, c), f = f.sibling;
                    S = e;
                    yg = h;
                    zg = l;
                }
                $g(a, b, c);
            } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, S = f) : $g(a, b, c);
        }
    }
    function $g(a) {
        for(; null !== S;){
            var b = S;
            if (0 !== (b.flags & 8772)) {
                var c = b.alternate;
                try {
                    if (0 !== (b.flags & 8772)) switch(b.tag){
                        case 0:
                        case 11:
                        case 15:
                            zg || Gg(5, b);
                            break;
                        case 1:
                            var d = b.stateNode;
                            if (b.flags & 4 && !zg) {
                                if (null === c) d.componentDidMount();
                                else {
                                    var e = b.elementType === b.type ? c.memoizedProps : ad(b.type, c.memoizedProps);
                                    d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                                }
                            }
                            var f = b.updateQueue;
                            null !== f && wd(b, f, d);
                            break;
                        case 3:
                            var g = b.updateQueue;
                            if (null !== g) {
                                c = null;
                                if (null !== b.child) switch(b.child.tag){
                                    case 5:
                                        c = Fa(b.child.stateNode);
                                        break;
                                    case 1:
                                        c = b.child.stateNode;
                                }
                                wd(b, g, c);
                            }
                            break;
                        case 5:
                            var h = b.stateNode;
                            null === c && b.flags & 4 && mb(h, b.type, b.memoizedProps, b);
                            break;
                        case 6:
                            break;
                        case 4:
                            break;
                        case 12:
                            break;
                        case 13:
                            if (p && null === b.memoizedState) {
                                var k = b.alternate;
                                if (null !== k) {
                                    var l = k.memoizedState;
                                    if (null !== l) {
                                        var m = l.dehydrated;
                                        null !== m && Ub(m);
                                    }
                                }
                            }
                            break;
                        case 19:
                        case 17:
                        case 21:
                        case 22:
                        case 23:
                            break;
                        default:
                            throw Error(n(163));
                    }
                    zg || b.flags & 512 && Hg(b);
                } catch (v) {
                    T(b, b.return, v);
                }
            }
            if (b === a) {
                S = null;
                break;
            }
            c = b.sibling;
            if (null !== c) {
                c.return = b.return;
                S = c;
                break;
            }
            S = b.return;
        }
    }
    function Wg(a) {
        for(; null !== S;){
            var b = S;
            if (b === a) {
                S = null;
                break;
            }
            var c = b.sibling;
            if (null !== c) {
                c.return = b.return;
                S = c;
                break;
            }
            S = b.return;
        }
    }
    function Zg(a) {
        for(; null !== S;){
            var b = S;
            try {
                switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        var c = b.return;
                        try {
                            Gg(4, b);
                        } catch (k) {
                            T(b, c, k);
                        }
                        break;
                    case 1:
                        var d = b.stateNode;
                        if ("function" === typeof d.componentDidMount) {
                            var e = b.return;
                            try {
                                d.componentDidMount();
                            } catch (k) {
                                T(b, e, k);
                            }
                        }
                        var f = b.return;
                        try {
                            Hg(b);
                        } catch (k) {
                            T(b, f, k);
                        }
                        break;
                    case 5:
                        var g = b.return;
                        try {
                            Hg(b);
                        } catch (k) {
                            T(b, g, k);
                        }
                }
            } catch (k) {
                T(b, b.return, k);
            }
            if (b === a) {
                S = null;
                break;
            }
            var h = b.sibling;
            if (null !== h) {
                h.return = b.return;
                S = h;
                break;
            }
            S = b.return;
        }
    }
    var ah = 0, bh = 1, ch = 2, dh = 3, eh = 4;
    if ("function" === typeof Symbol && Symbol.for) {
        var fh = Symbol.for;
        ah = fh("selector.component");
        bh = fh("selector.has_pseudo_class");
        ch = fh("selector.role");
        dh = fh("selector.test_id");
        eh = fh("selector.text");
    }
    function gh(a) {
        var b = Wa(a);
        if (null != b) {
            if ("string" !== typeof b.memoizedProps["data-testname"]) throw Error(n(364));
            return b;
        }
        a = cb(a);
        if (null === a) throw Error(n(362));
        return a.stateNode.current;
    }
    function hh(a, b) {
        switch(b.$$typeof){
            case ah:
                if (a.type === b.value) return !0;
                break;
            case bh:
                a: {
                    b = b.value;
                    a = [
                        a,
                        0
                    ];
                    for(var c = 0; c < a.length;){
                        var d = a[c++], e = a[c++], f = b[e];
                        if (5 !== d.tag || !fb(d)) {
                            for(; null != f && hh(d, f);)e++, f = b[e];
                            if (e === b.length) {
                                b = !0;
                                break a;
                            } else for(d = d.child; null !== d;)a.push(d, e), d = d.sibling;
                        }
                    }
                    b = !1;
                }
                return b;
            case ch:
                if (5 === a.tag && gb(a.stateNode, b.value)) return !0;
                break;
            case eh:
                if (5 === a.tag || 6 === a.tag) {
                    if (a = eb(a), null !== a && 0 <= a.indexOf(b.value)) return !0;
                }
                break;
            case dh:
                if (5 === a.tag && (a = a.memoizedProps["data-testname"], "string" === typeof a && a.toLowerCase() === b.value.toLowerCase())) return !0;
                break;
            default:
                throw Error(n(365));
        }
        return !1;
    }
    function ih(a) {
        switch(a.$$typeof){
            case ah:
                return "<" + (va(a.value) || "Unknown") + ">";
            case bh:
                return ":has(" + (ih(a) || "") + ")";
            case ch:
                return '[role="' + a.value + '"]';
            case eh:
                return '"' + a.value + '"';
            case dh:
                return '[data-testname="' + a.value + '"]';
            default:
                throw Error(n(365));
        }
    }
    function jh(a, b) {
        var c = [];
        a = [
            a,
            0
        ];
        for(var d = 0; d < a.length;){
            var e = a[d++], f = a[d++], g = b[f];
            if (5 !== e.tag || !fb(e)) {
                for(; null != g && hh(e, g);)f++, g = b[f];
                if (f === b.length) c.push(e);
                else for(e = e.child; null !== e;)a.push(e, f), e = e.sibling;
            }
        }
        return c;
    }
    function kh(a, b) {
        if (!bb) throw Error(n(363));
        a = gh(a);
        a = jh(a, b);
        b = [];
        a = Array.from(a);
        for(var c = 0; c < a.length;){
            var d = a[c++];
            if (5 === d.tag) fb(d) || b.push(d.stateNode);
            else for(d = d.child; null !== d;)a.push(d), d = d.sibling;
        }
        return b;
    }
    var lh = Math.ceil, mh = ea.ReactCurrentDispatcher, nh = ea.ReactCurrentOwner, U = ea.ReactCurrentBatchConfig, G = 0, F = null, W = null, X = 0, Wf = 0, eg = gc(0), Q = 0, oh = null, vd = 0, ph = 0, qh = 0, rh = null, Y = null, Vg = 0, Uf = Infinity;
    function sh() {
        Uf = E() + 500;
    }
    var Bf = !1, Cf = null, Ef = null, th = !1, uh = null, vh = 0, wh = 0, xh = null, yh = -1, zh = 0;
    function H() {
        return 0 !== (G & 6) ? E() : -1 !== yh ? yh : yh = E();
    }
    function zd(a) {
        if (0 === (a.mode & 1)) return 1;
        if (0 !== (G & 2) && 0 !== X) return X & -X;
        if (null !== Yc.transition) return 0 === zh && (a = tc, tc <<= 1, 0 === (tc & 4194240) && (tc = 64), zh = a), zh;
        a = D;
        return 0 !== a ? a : Ya();
    }
    function Ad(a, b, c) {
        if (50 < wh) throw wh = 0, xh = null, Error(n(185));
        var d = Ah(a, b);
        if (null === d) return null;
        Bc(d, b, c);
        if (0 === (G & 2) || d !== F) d === F && (0 === (G & 2) && (ph |= b), 4 === Q && Bh(d, X)), Z(d, c), 1 === b && 0 === G && 0 === (a.mode & 1) && (sh(), Tc && Xc());
        return d;
    }
    function Ah(a, b) {
        a.lanes |= b;
        var c = a.alternate;
        null !== c && (c.lanes |= b);
        c = a;
        for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
        return 3 === c.tag ? c.stateNode : null;
    }
    function Z(a, b) {
        var c = a.callbackNode;
        yc(a, b);
        var d = wc(a, a === F ? X : 0);
        if (0 === d) null !== c && Gc(c), a.callbackNode = null, a.callbackPriority = 0;
        else if (b = d & -d, a.callbackPriority !== b) {
            null != c && Gc(c);
            if (1 === b) 0 === a.tag ? Wc(Ch.bind(null, a)) : Vc(Ch.bind(null, a)), $a ? ab(function() {
                0 === G && Xc();
            }) : Fc(Jc, Xc), c = null;
            else {
                switch(Ec(d)){
                    case 1:
                        c = Jc;
                        break;
                    case 4:
                        c = Kc;
                        break;
                    case 16:
                        c = Lc;
                        break;
                    case 536870912:
                        c = Mc;
                        break;
                    default:
                        c = Lc;
                }
                c = Dh(c, Eh.bind(null, a));
            }
            a.callbackPriority = b;
            a.callbackNode = c;
        }
    }
    function Eh(a, b) {
        yh = -1;
        zh = 0;
        if (0 !== (G & 6)) throw Error(n(327));
        var c = a.callbackNode;
        if (Fh() && a.callbackNode !== c) return null;
        var d = wc(a, a === F ? X : 0);
        if (0 === d) return null;
        if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Gh(a, d);
        else {
            b = d;
            var e = G;
            G |= 2;
            var f = Hh();
            if (F !== a || X !== b) sh(), Ih(a, b);
            for(;;)try {
                Jh();
                break;
            } catch (h) {
                Kh(a, h);
            }
            fd();
            mh.current = f;
            G = e;
            null !== W ? b = 0 : (F = null, X = 0, b = Q);
        }
        if (0 !== b) {
            2 === b && (e = zc(a), 0 !== e && (d = e, b = Lh(a, e)));
            if (1 === b) throw c = oh, Ih(a, 0), Bh(a, d), Z(a, E()), c;
            if (6 === b) Bh(a, d);
            else {
                e = a.current.alternate;
                if (0 === (d & 30) && !Mh(e) && (b = Gh(a, d), 2 === b && (f = zc(a), 0 !== f && (d = f, b = Lh(a, f))), 1 === b)) throw c = oh, Ih(a, 0), Bh(a, d), Z(a, E()), c;
                a.finishedWork = e;
                a.finishedLanes = d;
                switch(b){
                    case 0:
                    case 1:
                        throw Error(n(345));
                    case 2:
                        Nh(a, Y);
                        break;
                    case 3:
                        Bh(a, d);
                        if ((d & 130023424) === d && (b = Vg + 500 - E(), 10 < b)) {
                            if (0 !== wc(a, 0)) break;
                            e = a.suspendedLanes;
                            if ((e & d) !== d) {
                                H();
                                a.pingedLanes |= a.suspendedLanes & e;
                                break;
                            }
                            a.timeoutHandle = Qa(Nh.bind(null, a, Y), b);
                            break;
                        }
                        Nh(a, Y);
                        break;
                    case 4:
                        Bh(a, d);
                        if ((d & 4194240) === d) break;
                        b = a.eventTimes;
                        for(e = -1; 0 < d;){
                            var g = 31 - qc(d);
                            f = 1 << g;
                            g = b[g];
                            g > e && (e = g);
                            d &= ~f;
                        }
                        d = e;
                        d = E() - d;
                        d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * lh(d / 1960)) - d;
                        if (10 < d) {
                            a.timeoutHandle = Qa(Nh.bind(null, a, Y), d);
                            break;
                        }
                        Nh(a, Y);
                        break;
                    case 5:
                        Nh(a, Y);
                        break;
                    default:
                        throw Error(n(329));
                }
            }
        }
        Z(a, E());
        return a.callbackNode === c ? Eh.bind(null, a) : null;
    }
    function Lh(a, b) {
        var c = rh;
        a.current.memoizedState.isDehydrated && (Ih(a, b).flags |= 256);
        a = Gh(a, b);
        2 !== a && (b = Y, Y = c, null !== b && Sf(b));
        return a;
    }
    function Sf(a) {
        null === Y ? Y = a : Y.push.apply(Y, a);
    }
    function Mh(a) {
        for(var b = a;;){
            if (b.flags & 16384) {
                var c = b.updateQueue;
                if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                    var e = c[d], f = e.getSnapshot;
                    e = e.value;
                    try {
                        if (!Rc(f(), e)) return !1;
                    } catch (g) {
                        return !1;
                    }
                }
            }
            c = b.child;
            if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
            else {
                if (b === a) break;
                for(; null === b.sibling;){
                    if (null === b.return || b.return === a) return !0;
                    b = b.return;
                }
                b.sibling.return = b.return;
                b = b.sibling;
            }
        }
        return !0;
    }
    function Bh(a, b) {
        b &= ~qh;
        b &= ~ph;
        a.suspendedLanes |= b;
        a.pingedLanes &= ~b;
        for(a = a.expirationTimes; 0 < b;){
            var c = 31 - qc(b), d = 1 << c;
            a[c] = -1;
            b &= ~d;
        }
    }
    function Ch(a) {
        if (0 !== (G & 6)) throw Error(n(327));
        Fh();
        var b = wc(a, 0);
        if (0 === (b & 1)) return Z(a, E()), null;
        var c = Gh(a, b);
        if (0 !== a.tag && 2 === c) {
            var d = zc(a);
            0 !== d && (b = d, c = Lh(a, d));
        }
        if (1 === c) throw c = oh, Ih(a, 0), Bh(a, b), Z(a, E()), c;
        if (6 === c) throw Error(n(345));
        a.finishedWork = a.current.alternate;
        a.finishedLanes = b;
        Nh(a, Y);
        Z(a, E());
        return null;
    }
    function Oh(a) {
        null !== uh && 0 === uh.tag && 0 === (G & 6) && Fh();
        var b = G;
        G |= 1;
        var c = U.transition, d = D;
        try {
            if (U.transition = null, D = 1, a) return a();
        } finally{
            D = d, U.transition = c, G = b, 0 === (G & 6) && Xc();
        }
    }
    function Vf() {
        Wf = eg.current;
        x(eg);
    }
    function Ih(a, b) {
        a.finishedWork = null;
        a.finishedLanes = 0;
        var c = a.timeoutHandle;
        c !== Sa && (a.timeoutHandle = Sa, Ra(c));
        if (null !== W) for(c = W.return; null !== c;){
            var d = c;
            Sd(d);
            switch(d.tag){
                case 1:
                    d = d.type.childContextTypes;
                    null !== d && void 0 !== d && kc();
                    break;
                case 3:
                    we();
                    x(B);
                    x(A);
                    Be();
                    break;
                case 5:
                    ye(d);
                    break;
                case 4:
                    we();
                    break;
                case 13:
                    x(J);
                    break;
                case 19:
                    x(J);
                    break;
                case 10:
                    hd(d.type._context);
                    break;
                case 22:
                case 23:
                    Vf();
            }
            c = c.return;
        }
        F = a;
        W = a = je(a.current, null);
        X = Wf = b;
        Q = 0;
        oh = null;
        qh = ph = vd = 0;
        Y = rh = null;
        if (null !== md) {
            for(b = 0; b < md.length; b++)if (c = md[b], d = c.interleaved, null !== d) {
                c.interleaved = null;
                var e = d.next, f = c.pending;
                if (null !== f) {
                    var g = f.next;
                    f.next = e;
                    d.next = g;
                }
                c.pending = d;
            }
            md = null;
        }
        return a;
    }
    function Kh(a, b) {
        do {
            var c = W;
            try {
                fd();
                Ce.current = Oe;
                if (Fe) {
                    for(var d = K.memoizedState; null !== d;){
                        var e = d.queue;
                        null !== e && (e.pending = null);
                        d = d.next;
                    }
                    Fe = !1;
                }
                Ee = 0;
                M = L = K = null;
                Ge = !1;
                He = 0;
                nh.current = null;
                if (null === c || null === c.return) {
                    Q = 1;
                    oh = b;
                    W = null;
                    break;
                }
                a: {
                    var f = a, g = c.return, h = c, k = b;
                    b = X;
                    h.flags |= 32768;
                    if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                        var l = k, m = h, v = m.tag;
                        if (0 === (m.mode & 1) && (0 === v || 11 === v || 15 === v)) {
                            var r = m.alternate;
                            r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                        }
                        var z = Hf(g);
                        if (null !== z) {
                            z.flags &= -257;
                            If(z, g, h, f, b);
                            z.mode & 1 && Ff(f, l, b);
                            b = z;
                            k = l;
                            var q = b.updateQueue;
                            if (null === q) {
                                var N = new Set;
                                N.add(k);
                                b.updateQueue = N;
                            } else q.add(k);
                            break a;
                        } else {
                            if (0 === (b & 1)) {
                                Ff(f, l, b);
                                Tf();
                                break a;
                            }
                            k = Error(n(426));
                        }
                    } else if (I && h.mode & 1) {
                        var da = Hf(g);
                        if (null !== da) {
                            0 === (da.flags & 65536) && (da.flags |= 256);
                            If(da, g, h, f, b);
                            ee(k);
                            break a;
                        }
                    }
                    f = k;
                    4 !== Q && (Q = 2);
                    null === rh ? rh = [
                        f
                    ] : rh.push(f);
                    k = xf(k, h);
                    h = g;
                    do {
                        switch(h.tag){
                            case 3:
                                h.flags |= 65536;
                                b &= -b;
                                h.lanes |= b;
                                var t = Af(h, k, b);
                                td(h, t);
                                break a;
                            case 1:
                                f = k;
                                var w = h.type, u = h.stateNode;
                                if (0 === (h.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === Ef || !Ef.has(u)))) {
                                    h.flags |= 65536;
                                    b &= -b;
                                    h.lanes |= b;
                                    var V = Df(h, f, b);
                                    td(h, V);
                                    break a;
                                }
                        }
                        h = h.return;
                    }while (null !== h);
                }
                Ph(c);
            } catch (wa) {
                b = wa;
                W === c && null !== c && (W = c = c.return);
                continue;
            }
            break;
        }while (1);
    }
    function Hh() {
        var a = mh.current;
        mh.current = Oe;
        return null === a ? Oe : a;
    }
    function Tf() {
        if (0 === Q || 3 === Q || 2 === Q) Q = 4;
        null === F || 0 === (vd & 268435455) && 0 === (ph & 268435455) || Bh(F, X);
    }
    function Gh(a, b) {
        var c = G;
        G |= 2;
        var d = Hh();
        F === a && X === b || Ih(a, b);
        for(;;)try {
            Qh();
            break;
        } catch (e) {
            Kh(a, e);
        }
        fd();
        G = c;
        mh.current = d;
        if (null !== W) throw Error(n(261));
        F = null;
        X = 0;
        return Q;
    }
    function Qh() {
        for(; null !== W;)Rh(W);
    }
    function Jh() {
        for(; null !== W && !Hc();)Rh(W);
    }
    function Rh(a) {
        var b = Sh(a.alternate, a, Wf);
        a.memoizedProps = a.pendingProps;
        null === b ? Ph(a) : W = b;
        nh.current = null;
    }
    function Ph(a) {
        var b = a;
        do {
            var c = b.alternate;
            a = b.return;
            if (0 === (b.flags & 32768)) {
                if (c = Rf(c, b, Wf), null !== c) {
                    W = c;
                    return;
                }
            } else {
                c = xg(c, b);
                if (null !== c) {
                    c.flags &= 32767;
                    W = c;
                    return;
                }
                if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
                else {
                    Q = 6;
                    W = null;
                    return;
                }
            }
            b = b.sibling;
            if (null !== b) {
                W = b;
                return;
            }
            W = b = a;
        }while (null !== b);
        0 === Q && (Q = 5);
    }
    function Nh(a, b) {
        var c = D, d = U.transition;
        try {
            U.transition = null, D = 1, Th(a, b, c);
        } finally{
            U.transition = d, D = c;
        }
        return null;
    }
    function Th(a, b, c) {
        do Fh();
        while (null !== uh);
        if (0 !== (G & 6)) throw Error(n(327));
        var d = a.finishedWork, e = a.finishedLanes;
        if (null === d) return null;
        a.finishedWork = null;
        a.finishedLanes = 0;
        if (d === a.current) throw Error(n(177));
        a.callbackNode = null;
        a.callbackPriority = 0;
        var f = d.lanes | d.childLanes;
        Cc(a, f);
        a === F && (W = F = null, X = 0);
        0 === (d.subtreeFlags & 2064) && 0 === (d.flags & 2064) || th || (th = !0, Dh(Lc, function() {
            Fh();
            return null;
        }));
        f = 0 !== (d.flags & 15990);
        if (0 !== (d.subtreeFlags & 15990) || f) {
            f = U.transition;
            U.transition = null;
            var g = D;
            D = 1;
            var h = G;
            G |= 4;
            nh.current = null;
            Eg(a, d);
            Ug(a, d, e);
            Ja(a.containerInfo);
            a.current = d;
            Xg(d, a, e);
            Ic();
            G = h;
            D = g;
            U.transition = f;
        } else a.current = d;
        th && (th = !1, uh = a, vh = e);
        f = a.pendingLanes;
        0 === f && (Ef = null);
        Pc(d.stateNode, c);
        Z(a, E());
        if (null !== b) for(c = a.onRecoverableError, d = 0; d < b.length; d++)c(b[d]);
        if (Bf) throw Bf = !1, a = Cf, Cf = null, a;
        0 !== (vh & 1) && 0 !== a.tag && Fh();
        f = a.pendingLanes;
        0 !== (f & 1) ? a === xh ? wh++ : (wh = 0, xh = a) : wh = 0;
        Xc();
        return null;
    }
    function Fh() {
        if (null !== uh) {
            var a = Ec(vh), b = U.transition, c = D;
            try {
                U.transition = null;
                D = 16 > a ? 16 : a;
                if (null === uh) var d = !1;
                else {
                    a = uh;
                    uh = null;
                    vh = 0;
                    if (0 !== (G & 6)) throw Error(n(331));
                    var e = G;
                    G |= 4;
                    for(S = a.current; null !== S;){
                        var f = S, g = f.child;
                        if (0 !== (S.flags & 16)) {
                            var h = f.deletions;
                            if (null !== h) {
                                for(var k = 0; k < h.length; k++){
                                    var l = h[k];
                                    for(S = l; null !== S;){
                                        var m = S;
                                        switch(m.tag){
                                            case 0:
                                            case 11:
                                            case 15:
                                                Fg(8, m, f);
                                        }
                                        var v = m.child;
                                        if (null !== v) v.return = m, S = v;
                                        else for(; null !== S;){
                                            m = S;
                                            var r = m.sibling, z = m.return;
                                            Lg(m);
                                            if (m === l) {
                                                S = null;
                                                break;
                                            }
                                            if (null !== r) {
                                                r.return = z;
                                                S = r;
                                                break;
                                            }
                                            S = z;
                                        }
                                    }
                                }
                                var q = f.alternate;
                                if (null !== q) {
                                    var N = q.child;
                                    if (null !== N) {
                                        q.child = null;
                                        do {
                                            var da = N.sibling;
                                            N.sibling = null;
                                            N = da;
                                        }while (null !== N);
                                    }
                                }
                                S = f;
                            }
                        }
                        if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, S = g;
                        else b: for(; null !== S;){
                            f = S;
                            if (0 !== (f.flags & 2048)) switch(f.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Fg(9, f, f.return);
                            }
                            var t = f.sibling;
                            if (null !== t) {
                                t.return = f.return;
                                S = t;
                                break b;
                            }
                            S = f.return;
                        }
                    }
                    var w = a.current;
                    for(S = w; null !== S;){
                        g = S;
                        var u = g.child;
                        if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, S = u;
                        else b: for(g = w; null !== S;){
                            h = S;
                            if (0 !== (h.flags & 2048)) try {
                                switch(h.tag){
                                    case 0:
                                    case 11:
                                    case 15:
                                        Gg(9, h);
                                }
                            } catch (wa) {
                                T(h, h.return, wa);
                            }
                            if (h === g) {
                                S = null;
                                break b;
                            }
                            var V = h.sibling;
                            if (null !== V) {
                                V.return = h.return;
                                S = V;
                                break b;
                            }
                            S = h.return;
                        }
                    }
                    G = e;
                    Xc();
                    if (Oc && "function" === typeof Oc.onPostCommitFiberRoot) try {
                        Oc.onPostCommitFiberRoot(Nc, a);
                    } catch (wa) {}
                    d = !0;
                }
                return d;
            } finally{
                D = c, U.transition = b;
            }
        }
        return !1;
    }
    function Uh(a, b, c) {
        b = xf(c, b);
        b = Af(a, b, 1);
        rd(a, b);
        b = H();
        a = Ah(a, 1);
        null !== a && (Bc(a, 1, b), Z(a, b));
    }
    function T(a, b, c) {
        if (3 === a.tag) Uh(a, a, c);
        else for(; null !== b;){
            if (3 === b.tag) {
                Uh(b, a, c);
                break;
            } else if (1 === b.tag) {
                var d = b.stateNode;
                if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ef || !Ef.has(d))) {
                    a = xf(c, a);
                    a = Df(b, a, 1);
                    rd(b, a);
                    a = H();
                    b = Ah(b, 1);
                    null !== b && (Bc(b, 1, a), Z(b, a));
                    break;
                }
            }
            b = b.return;
        }
    }
    function Gf(a, b, c) {
        var d = a.pingCache;
        null !== d && d.delete(b);
        b = H();
        a.pingedLanes |= a.suspendedLanes & c;
        F === a && (X & c) === c && (4 === Q || 3 === Q && (X & 130023424) === X && 500 > E() - Vg ? Ih(a, 0) : qh |= c);
        Z(a, b);
    }
    function Vh(a, b) {
        0 === b && (0 === (a.mode & 1) ? b = 1 : (b = uc, uc <<= 1, 0 === (uc & 130023424) && (uc = 4194304)));
        var c = H();
        a = Ah(a, b);
        null !== a && (Bc(a, b, c), Z(a, c));
    }
    function qg(a) {
        var b = a.memoizedState, c = 0;
        null !== b && (c = b.retryLane);
        Vh(a, c);
    }
    function Tg(a, b) {
        var c = 0;
        switch(a.tag){
            case 13:
                var d = a.stateNode;
                var e = a.memoizedState;
                null !== e && (c = e.retryLane);
                break;
            case 19:
                d = a.stateNode;
                break;
            default:
                throw Error(n(314));
        }
        null !== d && d.delete(b);
        Vh(a, c);
    }
    var Sh;
    Sh = function(a, b, c) {
        if (null !== a) {
            if (a.memoizedProps !== b.pendingProps || B.current) kd = !0;
            else {
                if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return kd = !1, wg(a, b, c);
                kd = 0 !== (a.flags & 131072) ? !0 : !1;
            }
        } else kd = !1, I && 0 !== (b.flags & 1048576) && Qd(b, Jd, b.index);
        b.lanes = 0;
        switch(b.tag){
            case 2:
                var d = b.type;
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                var e = jc(b, A.current);
                jd(b, c);
                e = Ke(null, b, d, a, e, c);
                var f = Pe();
                b.flags |= 1;
                "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, C(d) ? (f = !0, nc(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, od(b), e.updater = Bd, b.stateNode = e, e._reactInternals = b, Fd(b, d, a, c), b = hg(null, b, d, !0, f, c)) : (b.tag = 0, I && f && Rd(b), R(null, b, e, c), b = b.child);
                return b;
            case 16:
                d = b.elementType;
                a: {
                    null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                    a = b.pendingProps;
                    e = d._init;
                    d = e(d._payload);
                    b.type = d;
                    e = b.tag = Wh(d);
                    a = ad(d, a);
                    switch(e){
                        case 0:
                            b = cg(null, b, d, a, c);
                            break a;
                        case 1:
                            b = gg(null, b, d, a, c);
                            break a;
                        case 11:
                            b = Yf(null, b, d, a, c);
                            break a;
                        case 14:
                            b = $f(null, b, d, ad(d.type, a), c);
                            break a;
                    }
                    throw Error(n(306, d, ""));
                }
                return b;
            case 0:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ad(d, e), cg(a, b, d, e, c);
            case 1:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ad(d, e), gg(a, b, d, e, c);
            case 3:
                a: {
                    ig(b);
                    if (null === a) throw Error(n(387));
                    d = b.pendingProps;
                    f = b.memoizedState;
                    e = f.element;
                    pd(a, b);
                    ud(b, d, null, c);
                    var g = b.memoizedState;
                    d = g.element;
                    if (p && f.isDehydrated) {
                        if (f = {
                            element: d,
                            isDehydrated: !1,
                            cache: g.cache,
                            transitions: g.transitions
                        }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                            e = Error(n(423));
                            b = jg(a, b, d, c, e);
                            break a;
                        } else if (d !== e) {
                            e = Error(n(424));
                            b = jg(a, b, d, c, e);
                            break a;
                        } else for(p && (Ud = Nb(b.stateNode.containerInfo), Td = b, I = !0, Wd = null, Vd = !1), c = pe(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                    } else {
                        de();
                        if (d === e) {
                            b = Zf(a, b, c);
                            break a;
                        }
                        R(a, b, d, c);
                    }
                    b = b.child;
                }
                return b;
            case 5:
                return xe(b), null === a && ae(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Oa(d, e) ? g = null : null !== f && Oa(d, f) && (b.flags |= 32), fg(a, b), R(a, b, g, c), b.child;
            case 6:
                return null === a && ae(b), null;
            case 13:
                return mg(a, b, c);
            case 4:
                return ve(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = oe(b, null, d, c) : R(a, b, d, c), b.child;
            case 11:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ad(d, e), Yf(a, b, d, e, c);
            case 7:
                return R(a, b, b.pendingProps, c), b.child;
            case 8:
                return R(a, b, b.pendingProps.children, c), b.child;
            case 12:
                return R(a, b, b.pendingProps.children, c), b.child;
            case 10:
                a: {
                    d = b.type._context;
                    e = b.pendingProps;
                    f = b.memoizedProps;
                    g = e.value;
                    gd(b, d, g);
                    if (null !== f) {
                        if (Rc(f.value, g)) {
                            if (f.children === e.children && !B.current) {
                                b = Zf(a, b, c);
                                break a;
                            }
                        } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                            var h = f.dependencies;
                            if (null !== h) {
                                g = f.child;
                                for(var k = h.firstContext; null !== k;){
                                    if (k.context === d) {
                                        if (1 === f.tag) {
                                            k = qd(-1, c & -c);
                                            k.tag = 2;
                                            var l = f.updateQueue;
                                            if (null !== l) {
                                                l = l.shared;
                                                var m = l.pending;
                                                null === m ? k.next = k : (k.next = m.next, m.next = k);
                                                l.pending = k;
                                            }
                                        }
                                        f.lanes |= c;
                                        k = f.alternate;
                                        null !== k && (k.lanes |= c);
                                        id(f.return, c, b);
                                        h.lanes |= c;
                                        break;
                                    }
                                    k = k.next;
                                }
                            } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                            else if (18 === f.tag) {
                                g = f.return;
                                if (null === g) throw Error(n(341));
                                g.lanes |= c;
                                h = g.alternate;
                                null !== h && (h.lanes |= c);
                                id(g, c, b);
                                g = f.sibling;
                            } else g = f.child;
                            if (null !== g) g.return = f;
                            else for(g = f; null !== g;){
                                if (g === b) {
                                    g = null;
                                    break;
                                }
                                f = g.sibling;
                                if (null !== f) {
                                    f.return = g.return;
                                    g = f;
                                    break;
                                }
                                g = g.return;
                            }
                            f = g;
                        }
                    }
                    R(a, b, e.children, c);
                    b = b.child;
                }
                return b;
            case 9:
                return e = b.type, d = b.pendingProps.children, jd(b, c), e = ld(e), d = d(e), b.flags |= 1, R(a, b, d, c), b.child;
            case 14:
                return d = b.type, e = ad(d, b.pendingProps), e = ad(d.type, e), $f(a, b, d, e, c);
            case 15:
                return bg(a, b, b.type, b.pendingProps, c);
            case 17:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ad(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, C(d) ? (a = !0, nc(b)) : a = !1, jd(b, c), Dd(b, d, e), Fd(b, d, e, c), hg(null, b, d, !0, a, c);
            case 19:
                return vg(a, b, c);
            case 22:
                return dg(a, b, c);
        }
        throw Error(n(156, b.tag));
    };
    function Dh(a, b) {
        return Fc(a, b);
    }
    function Xh(a, b, c, d) {
        this.tag = a;
        this.key = c;
        this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = b;
        this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
        this.mode = d;
        this.subtreeFlags = this.flags = 0;
        this.deletions = null;
        this.childLanes = this.lanes = 0;
        this.alternate = null;
    }
    function Yd(a, b, c, d) {
        return new Xh(a, b, c, d);
    }
    function ag(a) {
        a = a.prototype;
        return !(!a || !a.isReactComponent);
    }
    function Wh(a) {
        if ("function" === typeof a) return ag(a) ? 1 : 0;
        if (void 0 !== a && null !== a) {
            a = a.$$typeof;
            if (a === na) return 11;
            if (a === qa) return 14;
        }
        return 2;
    }
    function je(a, b) {
        var c = a.alternate;
        null === c ? (c = Yd(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
        c.flags = a.flags & 14680064;
        c.childLanes = a.childLanes;
        c.lanes = a.lanes;
        c.child = a.child;
        c.memoizedProps = a.memoizedProps;
        c.memoizedState = a.memoizedState;
        c.updateQueue = a.updateQueue;
        b = a.dependencies;
        c.dependencies = null === b ? null : {
            lanes: b.lanes,
            firstContext: b.firstContext
        };
        c.sibling = a.sibling;
        c.index = a.index;
        c.ref = a.ref;
        return c;
    }
    function le(a, b, c, d, e, f) {
        var g = 2;
        d = a;
        if ("function" === typeof a) ag(a) && (g = 1);
        else if ("string" === typeof a) g = 5;
        else a: switch(a){
            case ia:
                return ne(c.children, e, f, b);
            case ja:
                g = 8;
                e |= 8;
                break;
            case ka:
                return a = Yd(12, c, b, e | 2), a.elementType = ka, a.lanes = f, a;
            case oa:
                return a = Yd(13, c, b, e), a.elementType = oa, a.lanes = f, a;
            case pa:
                return a = Yd(19, c, b, e), a.elementType = pa, a.lanes = f, a;
            case sa:
                return ng(c, e, f, b);
            default:
                if ("object" === typeof a && null !== a) switch(a.$$typeof){
                    case la:
                        g = 10;
                        break a;
                    case ma:
                        g = 9;
                        break a;
                    case na:
                        g = 11;
                        break a;
                    case qa:
                        g = 14;
                        break a;
                    case ra:
                        g = 16;
                        d = null;
                        break a;
                }
                throw Error(n(130, null == a ? a : typeof a, ""));
        }
        b = Yd(g, c, b, e);
        b.elementType = a;
        b.type = d;
        b.lanes = f;
        return b;
    }
    function ne(a, b, c, d) {
        a = Yd(7, a, d, b);
        a.lanes = c;
        return a;
    }
    function ng(a, b, c, d) {
        a = Yd(22, a, d, b);
        a.elementType = sa;
        a.lanes = c;
        a.stateNode = {};
        return a;
    }
    function ke(a, b, c) {
        a = Yd(6, a, null, b);
        a.lanes = c;
        return a;
    }
    function me(a, b, c) {
        b = Yd(4, null !== a.children ? a.children : [], a.key, b);
        b.lanes = c;
        b.stateNode = {
            containerInfo: a.containerInfo,
            pendingChildren: null,
            implementation: a.implementation
        };
        return b;
    }
    function Yh(a, b, c, d, e) {
        this.tag = b;
        this.containerInfo = a;
        this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
        this.timeoutHandle = Sa;
        this.callbackNode = this.pendingContext = this.context = null;
        this.callbackPriority = 0;
        this.eventTimes = Ac(0);
        this.expirationTimes = Ac(-1);
        this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
        this.entanglements = Ac(0);
        this.identifierPrefix = d;
        this.onRecoverableError = e;
        p && (this.mutableSourceEagerHydrationData = null);
    }
    function Zh(a, b, c, d, e, f, g, h, k) {
        a = new Yh(a, b, c, h, k);
        1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
        f = Yd(3, null, null, b);
        a.current = f;
        f.stateNode = a;
        f.memoizedState = {
            element: d,
            isDehydrated: c,
            cache: null,
            transitions: null
        };
        od(f);
        return a;
    }
    function $h(a) {
        if (!a) return hc;
        a = a._reactInternals;
        a: {
            if (ya(a) !== a || 1 !== a.tag) throw Error(n(170));
            var b = a;
            do {
                switch(b.tag){
                    case 3:
                        b = b.stateNode.context;
                        break a;
                    case 1:
                        if (C(b.type)) {
                            b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                            break a;
                        }
                }
                b = b.return;
            }while (null !== b);
            throw Error(n(171));
        }
        if (1 === a.tag) {
            var c = a.type;
            if (C(c)) return mc(a, c, b);
        }
        return b;
    }
    function ai(a) {
        var b = a._reactInternals;
        if (void 0 === b) {
            if ("function" === typeof a.render) throw Error(n(188));
            a = Object.keys(a).join(",");
            throw Error(n(268, a));
        }
        a = Ba(b);
        return null === a ? null : a.stateNode;
    }
    function bi(a, b) {
        a = a.memoizedState;
        if (null !== a && null !== a.dehydrated) {
            var c = a.retryLane;
            a.retryLane = 0 !== c && c < b ? c : b;
        }
    }
    function ci(a, b) {
        bi(a, b);
        (a = a.alternate) && bi(a, b);
    }
    function di(a) {
        a = Ba(a);
        return null === a ? null : a.stateNode;
    }
    function ei() {
        return null;
    }
    exports.attemptContinuousHydration = function(a) {
        if (13 === a.tag) {
            var b = H();
            Ad(a, 134217728, b);
            ci(a, 134217728);
        }
    };
    exports.attemptHydrationAtCurrentPriority = function(a) {
        if (13 === a.tag) {
            var b = H(), c = zd(a);
            Ad(a, c, b);
            ci(a, c);
        }
    };
    exports.attemptSynchronousHydration = function(a) {
        switch(a.tag){
            case 3:
                var b = a.stateNode;
                if (b.current.memoizedState.isDehydrated) {
                    var c = vc(b.pendingLanes);
                    0 !== c && (Dc(b, c | 1), Z(b, E()), 0 === (G & 6) && (sh(), Xc()));
                }
                break;
            case 13:
                var d = H();
                Oh(function() {
                    return Ad(a, 1, d);
                });
                ci(a, 1);
        }
    };
    exports.batchedUpdates = function(a, b) {
        var c = G;
        G |= 1;
        try {
            return a(b);
        } finally{
            G = c, 0 === G && (sh(), Tc && Xc());
        }
    };
    exports.createComponentSelector = function(a) {
        return {
            $$typeof: ah,
            value: a
        };
    };
    exports.createContainer = function(a, b, c, d, e, f, g) {
        return Zh(a, b, !1, null, c, d, e, f, g);
    };
    exports.createHasPseudoClassSelector = function(a) {
        return {
            $$typeof: bh,
            value: a
        };
    };
    exports.createHydrationContainer = function(a, b, c, d, e, f, g, h, k) {
        a = Zh(c, d, !0, a, e, f, g, h, k);
        a.context = $h(null);
        c = a.current;
        d = H();
        e = zd(c);
        f = qd(d, e);
        f.callback = void 0 !== b && null !== b ? b : null;
        rd(c, f);
        a.current.lanes = e;
        Bc(a, e, d);
        Z(a, d);
        return a;
    };
    exports.createPortal = function(a, b, c) {
        var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
        return {
            $$typeof: ha,
            key: null == d ? null : "" + d,
            children: a,
            containerInfo: b,
            implementation: c
        };
    };
    exports.createRoleSelector = function(a) {
        return {
            $$typeof: ch,
            value: a
        };
    };
    exports.createTestNameSelector = function(a) {
        return {
            $$typeof: dh,
            value: a
        };
    };
    exports.createTextSelector = function(a) {
        return {
            $$typeof: eh,
            value: a
        };
    };
    exports.deferredUpdates = function(a) {
        var b = D, c = U.transition;
        try {
            return U.transition = null, D = 16, a();
        } finally{
            D = b, U.transition = c;
        }
    };
    exports.discreteUpdates = function(a, b, c, d, e) {
        var f = D, g = U.transition;
        try {
            return U.transition = null, D = 1, a(b, c, d, e);
        } finally{
            D = f, U.transition = g, 0 === G && sh();
        }
    };
    exports.findAllNodes = kh;
    exports.findBoundingRects = function(a, b) {
        if (!bb) throw Error(n(363));
        b = kh(a, b);
        a = [];
        for(var c = 0; c < b.length; c++)a.push(db(b[c]));
        for(b = a.length - 1; 0 < b; b--){
            c = a[b];
            for(var d = c.x, e = d + c.width, f = c.y, g = f + c.height, h = b - 1; 0 <= h; h--)if (b !== h) {
                var k = a[h], l = k.x, m = l + k.width, v = k.y, r = v + k.height;
                if (d >= l && f >= v && e <= m && g <= r) {
                    a.splice(b, 1);
                    break;
                } else if (!(d !== l || c.width !== k.width || r < f || v > g)) {
                    v > f && (k.height += v - f, k.y = f);
                    r < g && (k.height = g - v);
                    a.splice(b, 1);
                    break;
                } else if (!(f !== v || c.height !== k.height || m < d || l > e)) {
                    l > d && (k.width += l - d, k.x = d);
                    m < e && (k.width = e - l);
                    a.splice(b, 1);
                    break;
                }
            }
        }
        return a;
    };
    exports.findHostInstance = ai;
    exports.findHostInstanceWithNoPortals = function(a) {
        a = Aa(a);
        a = null !== a ? Da(a) : null;
        return null === a ? null : a.stateNode;
    };
    exports.findHostInstanceWithWarning = function(a) {
        return ai(a);
    };
    exports.flushControlled = function(a) {
        var b = G;
        G |= 1;
        var c = U.transition, d = D;
        try {
            U.transition = null, D = 1, a();
        } finally{
            D = d, U.transition = c, G = b, 0 === G && (sh(), Xc());
        }
    };
    exports.flushPassiveEffects = Fh;
    exports.flushSync = Oh;
    exports.focusWithin = function(a, b) {
        if (!bb) throw Error(n(363));
        a = gh(a);
        b = jh(a, b);
        b = Array.from(b);
        for(a = 0; a < b.length;){
            var c = b[a++];
            if (!fb(c)) {
                if (5 === c.tag && hb(c.stateNode)) return !0;
                for(c = c.child; null !== c;)b.push(c), c = c.sibling;
            }
        }
        return !1;
    };
    exports.getCurrentUpdatePriority = function() {
        return D;
    };
    exports.getFindAllNodesFailureDescription = function(a, b) {
        if (!bb) throw Error(n(363));
        var c = 0, d = [];
        a = [
            gh(a),
            0
        ];
        for(var e = 0; e < a.length;){
            var f = a[e++], g = a[e++], h = b[g];
            if (5 !== f.tag || !fb(f)) {
                if (hh(f, h) && (d.push(ih(h)), g++, g > c && (c = g)), g < b.length) for(f = f.child; null !== f;)a.push(f, g), f = f.sibling;
            }
        }
        if (c < b.length) {
            for(a = []; c < b.length; c++)a.push(ih(b[c]));
            return "findAllNodes was able to match part of the selector:\n  " + (d.join(" > ") + "\n\nNo matching component was found for:\n  ") + a.join(" > ");
        }
        return null;
    };
    exports.getPublicRootInstance = function(a) {
        a = a.current;
        if (!a.child) return null;
        switch(a.child.tag){
            case 5:
                return Fa(a.child.stateNode);
            default:
                return a.child.stateNode;
        }
    };
    exports.injectIntoDevTools = function(a) {
        a = {
            bundleType: a.bundleType,
            version: a.version,
            rendererPackageName: a.rendererPackageName,
            rendererConfig: a.rendererConfig,
            overrideHookState: null,
            overrideHookStateDeletePath: null,
            overrideHookStateRenamePath: null,
            overrideProps: null,
            overridePropsDeletePath: null,
            overridePropsRenamePath: null,
            setErrorHandler: null,
            setSuspenseHandler: null,
            scheduleUpdate: null,
            currentDispatcherRef: ea.ReactCurrentDispatcher,
            findHostInstanceByFiber: di,
            findFiberByHostInstance: a.findFiberByHostInstance || ei,
            findHostInstancesForRefresh: null,
            scheduleRefresh: null,
            scheduleRoot: null,
            setRefreshHandler: null,
            getCurrentFiber: null,
            reconcilerVersion: "18.0.0-fc46dba67-20220329"
        };
        if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) a = !1;
        else {
            var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
            if (b.isDisabled || !b.supportsFiber) a = !0;
            else {
                try {
                    Nc = b.inject(a), Oc = b;
                } catch (c) {}
                a = b.checkDCE ? !0 : !1;
            }
        }
        return a;
    };
    exports.isAlreadyRendering = function() {
        return !1;
    };
    exports.observeVisibleRects = function(a, b, c, d) {
        if (!bb) throw Error(n(363));
        a = kh(a, b);
        var e = ib(a, c, d).disconnect;
        return {
            disconnect: function() {
                e();
            }
        };
    };
    exports.registerMutableSourceForHydration = function(a, b) {
        var c = b._getVersion;
        c = c(b._source);
        null == a.mutableSourceEagerHydrationData ? a.mutableSourceEagerHydrationData = [
            b,
            c
        ] : a.mutableSourceEagerHydrationData.push(b, c);
    };
    exports.runWithPriority = function(a, b) {
        var c = D;
        try {
            return D = a, b();
        } finally{
            D = c;
        }
    };
    exports.shouldError = function() {
        return null;
    };
    exports.shouldSuspend = function() {
        return !1;
    };
    exports.updateContainer = function(a, b, c, d) {
        var e = b.current, f = H(), g = zd(e);
        c = $h(c);
        null === b.context ? b.context = c : b.pendingContext = c;
        b = qd(f, g);
        b.payload = {
            element: a
        };
        d = void 0 === d ? null : d;
        null !== d && (b.callback = d);
        rd(e, b);
        a = Ad(e, g, f);
        null !== a && sd(a, e, g);
        return g;
    };
    return exports;
};

});
parcelRequire.register("cpxvE", function(module, exports) {
"use strict";

module.exports = (parcelRequire("8q7Rp"));

});
parcelRequire.register("8q7Rp", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $6216d961cde62e0e$export$c4744153514ff05d, (v) => $6216d961cde62e0e$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $6216d961cde62e0e$export$3e506c1ccc9cc1a7, (v) => $6216d961cde62e0e$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $6216d961cde62e0e$export$e26fe2ed2fa76875, (v) => $6216d961cde62e0e$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $6216d961cde62e0e$export$502329bbf4b505b1, (v) => $6216d961cde62e0e$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $6216d961cde62e0e$export$6e3807111c4874c4, (v) => $6216d961cde62e0e$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $6216d961cde62e0e$export$c27134553091fb3a, (v) => $6216d961cde62e0e$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $6216d961cde62e0e$export$33ee1acdc04fd2a2, (v) => $6216d961cde62e0e$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $6216d961cde62e0e$export$b00a404bbd5edef2, (v) => $6216d961cde62e0e$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $6216d961cde62e0e$export$8352ce38b91d0c62, (v) => $6216d961cde62e0e$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $6216d961cde62e0e$export$d66a1c1c77bd778b, (v) => $6216d961cde62e0e$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $6216d961cde62e0e$export$d3dfb8e4810cb555, (v) => $6216d961cde62e0e$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $6216d961cde62e0e$export$839f9183b0465a69, (v) => $6216d961cde62e0e$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $6216d961cde62e0e$export$72fdf0e06517287b, (v) => $6216d961cde62e0e$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $6216d961cde62e0e$export$4b844e58a3e414b4, (v) => $6216d961cde62e0e$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $6216d961cde62e0e$export$816d2913ae6b83b1, (v) => $6216d961cde62e0e$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $6216d961cde62e0e$export$61bcfe829111a1d0, (v) => $6216d961cde62e0e$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $6216d961cde62e0e$export$7ee8c9beb337bc3f, (v) => $6216d961cde62e0e$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $6216d961cde62e0e$export$b5836b71941fa3ed, (v) => $6216d961cde62e0e$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $6216d961cde62e0e$export$cf845f2c119da08a, (v) => $6216d961cde62e0e$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6216d961cde62e0e$export$c4744153514ff05d;
var $6216d961cde62e0e$export$3e506c1ccc9cc1a7;
var $6216d961cde62e0e$export$e26fe2ed2fa76875;
var $6216d961cde62e0e$export$502329bbf4b505b1;
var $6216d961cde62e0e$export$6e3807111c4874c4;
var $6216d961cde62e0e$export$c27134553091fb3a;
var $6216d961cde62e0e$export$33ee1acdc04fd2a2;
var $6216d961cde62e0e$export$b00a404bbd5edef2;
var $6216d961cde62e0e$export$8352ce38b91d0c62;
var $6216d961cde62e0e$export$d66a1c1c77bd778b;
var $6216d961cde62e0e$export$d3dfb8e4810cb555;
var $6216d961cde62e0e$export$839f9183b0465a69;
var $6216d961cde62e0e$export$72fdf0e06517287b;
var $6216d961cde62e0e$export$4b844e58a3e414b4;
var $6216d961cde62e0e$export$816d2913ae6b83b1;
var $6216d961cde62e0e$export$61bcfe829111a1d0;
var $6216d961cde62e0e$export$7ee8c9beb337bc3f;
var $6216d961cde62e0e$export$b5836b71941fa3ed;
var $6216d961cde62e0e$export$cf845f2c119da08a;
"use strict";
function $6216d961cde62e0e$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $6216d961cde62e0e$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $6216d961cde62e0e$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $6216d961cde62e0e$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $6216d961cde62e0e$var$g(C, c)) n < e && 0 > $6216d961cde62e0e$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $6216d961cde62e0e$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $6216d961cde62e0e$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6216d961cde62e0e$var$l = performance;
    $6216d961cde62e0e$export$c4744153514ff05d = function() {
        return $6216d961cde62e0e$var$l.now();
    };
} else {
    var $6216d961cde62e0e$var$p = Date, $6216d961cde62e0e$var$q = $6216d961cde62e0e$var$p.now();
    $6216d961cde62e0e$export$c4744153514ff05d = function() {
        return $6216d961cde62e0e$var$p.now() - $6216d961cde62e0e$var$q;
    };
}
var $6216d961cde62e0e$var$r = [], $6216d961cde62e0e$var$t = [], $6216d961cde62e0e$var$u = 1, $6216d961cde62e0e$var$v = null, $6216d961cde62e0e$var$y = 3, $6216d961cde62e0e$var$z = !1, $6216d961cde62e0e$var$A = !1, $6216d961cde62e0e$var$B = !1, $6216d961cde62e0e$var$D = "function" === typeof setTimeout ? setTimeout : null, $6216d961cde62e0e$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $6216d961cde62e0e$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $6216d961cde62e0e$var$G(a) {
    for(var b = $6216d961cde62e0e$var$h($6216d961cde62e0e$var$t); null !== b;){
        if (null === b.callback) $6216d961cde62e0e$var$k($6216d961cde62e0e$var$t);
        else if (b.startTime <= a) $6216d961cde62e0e$var$k($6216d961cde62e0e$var$t), b.sortIndex = b.expirationTime, $6216d961cde62e0e$var$f($6216d961cde62e0e$var$r, b);
        else break;
        b = $6216d961cde62e0e$var$h($6216d961cde62e0e$var$t);
    }
}
function $6216d961cde62e0e$var$H(a) {
    $6216d961cde62e0e$var$B = !1;
    $6216d961cde62e0e$var$G(a);
    if (!$6216d961cde62e0e$var$A) {
        if (null !== $6216d961cde62e0e$var$h($6216d961cde62e0e$var$r)) $6216d961cde62e0e$var$A = !0, $6216d961cde62e0e$var$I($6216d961cde62e0e$var$J);
        else {
            var b = $6216d961cde62e0e$var$h($6216d961cde62e0e$var$t);
            null !== b && $6216d961cde62e0e$var$K($6216d961cde62e0e$var$H, b.startTime - a);
        }
    }
}
function $6216d961cde62e0e$var$J(a, b) {
    $6216d961cde62e0e$var$A = !1;
    $6216d961cde62e0e$var$B && ($6216d961cde62e0e$var$B = !1, $6216d961cde62e0e$var$E($6216d961cde62e0e$var$L), $6216d961cde62e0e$var$L = -1);
    $6216d961cde62e0e$var$z = !0;
    var c = $6216d961cde62e0e$var$y;
    try {
        $6216d961cde62e0e$var$G(b);
        for($6216d961cde62e0e$var$v = $6216d961cde62e0e$var$h($6216d961cde62e0e$var$r); null !== $6216d961cde62e0e$var$v && (!($6216d961cde62e0e$var$v.expirationTime > b) || a && !$6216d961cde62e0e$var$M());){
            var d = $6216d961cde62e0e$var$v.callback;
            if ("function" === typeof d) {
                $6216d961cde62e0e$var$v.callback = null;
                $6216d961cde62e0e$var$y = $6216d961cde62e0e$var$v.priorityLevel;
                var e = d($6216d961cde62e0e$var$v.expirationTime <= b);
                b = $6216d961cde62e0e$export$c4744153514ff05d();
                "function" === typeof e ? $6216d961cde62e0e$var$v.callback = e : $6216d961cde62e0e$var$v === $6216d961cde62e0e$var$h($6216d961cde62e0e$var$r) && $6216d961cde62e0e$var$k($6216d961cde62e0e$var$r);
                $6216d961cde62e0e$var$G(b);
            } else $6216d961cde62e0e$var$k($6216d961cde62e0e$var$r);
            $6216d961cde62e0e$var$v = $6216d961cde62e0e$var$h($6216d961cde62e0e$var$r);
        }
        if (null !== $6216d961cde62e0e$var$v) var w = !0;
        else {
            var m = $6216d961cde62e0e$var$h($6216d961cde62e0e$var$t);
            null !== m && $6216d961cde62e0e$var$K($6216d961cde62e0e$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $6216d961cde62e0e$var$v = null, $6216d961cde62e0e$var$y = c, $6216d961cde62e0e$var$z = !1;
    }
}
var $6216d961cde62e0e$var$N = !1, $6216d961cde62e0e$var$O = null, $6216d961cde62e0e$var$L = -1, $6216d961cde62e0e$var$P = 5, $6216d961cde62e0e$var$Q = -1;
function $6216d961cde62e0e$var$M() {
    return $6216d961cde62e0e$export$c4744153514ff05d() - $6216d961cde62e0e$var$Q < $6216d961cde62e0e$var$P ? !1 : !0;
}
function $6216d961cde62e0e$var$R() {
    if (null !== $6216d961cde62e0e$var$O) {
        var a = $6216d961cde62e0e$export$c4744153514ff05d();
        $6216d961cde62e0e$var$Q = a;
        var b = !0;
        try {
            b = $6216d961cde62e0e$var$O(!0, a);
        } finally{
            b ? $6216d961cde62e0e$var$S() : ($6216d961cde62e0e$var$N = !1, $6216d961cde62e0e$var$O = null);
        }
    } else $6216d961cde62e0e$var$N = !1;
}
var $6216d961cde62e0e$var$S;
if ("function" === typeof $6216d961cde62e0e$var$F) $6216d961cde62e0e$var$S = function() {
    $6216d961cde62e0e$var$F($6216d961cde62e0e$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6216d961cde62e0e$var$T = new MessageChannel, $6216d961cde62e0e$var$U = $6216d961cde62e0e$var$T.port2;
    $6216d961cde62e0e$var$T.port1.onmessage = $6216d961cde62e0e$var$R;
    $6216d961cde62e0e$var$S = function() {
        $6216d961cde62e0e$var$U.postMessage(null);
    };
} else $6216d961cde62e0e$var$S = function() {
    $6216d961cde62e0e$var$D($6216d961cde62e0e$var$R, 0);
};
function $6216d961cde62e0e$var$I(a) {
    $6216d961cde62e0e$var$O = a;
    $6216d961cde62e0e$var$N || ($6216d961cde62e0e$var$N = !0, $6216d961cde62e0e$var$S());
}
function $6216d961cde62e0e$var$K(a, b) {
    $6216d961cde62e0e$var$L = $6216d961cde62e0e$var$D(function() {
        a($6216d961cde62e0e$export$c4744153514ff05d());
    }, b);
}
$6216d961cde62e0e$export$3e506c1ccc9cc1a7 = 5;
$6216d961cde62e0e$export$e26fe2ed2fa76875 = 1;
$6216d961cde62e0e$export$502329bbf4b505b1 = 4;
$6216d961cde62e0e$export$6e3807111c4874c4 = 3;
$6216d961cde62e0e$export$c27134553091fb3a = null;
$6216d961cde62e0e$export$33ee1acdc04fd2a2 = 2;
$6216d961cde62e0e$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$6216d961cde62e0e$export$8352ce38b91d0c62 = function() {
    $6216d961cde62e0e$var$A || $6216d961cde62e0e$var$z || ($6216d961cde62e0e$var$A = !0, $6216d961cde62e0e$var$I($6216d961cde62e0e$var$J));
};
$6216d961cde62e0e$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6216d961cde62e0e$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$6216d961cde62e0e$export$d3dfb8e4810cb555 = function() {
    return $6216d961cde62e0e$var$y;
};
$6216d961cde62e0e$export$839f9183b0465a69 = function() {
    return $6216d961cde62e0e$var$h($6216d961cde62e0e$var$r);
};
$6216d961cde62e0e$export$72fdf0e06517287b = function(a) {
    switch($6216d961cde62e0e$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $6216d961cde62e0e$var$y;
    }
    var c = $6216d961cde62e0e$var$y;
    $6216d961cde62e0e$var$y = b;
    try {
        return a();
    } finally{
        $6216d961cde62e0e$var$y = c;
    }
};
$6216d961cde62e0e$export$4b844e58a3e414b4 = function() {};
$6216d961cde62e0e$export$816d2913ae6b83b1 = function() {};
$6216d961cde62e0e$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $6216d961cde62e0e$var$y;
    $6216d961cde62e0e$var$y = a;
    try {
        return b();
    } finally{
        $6216d961cde62e0e$var$y = c;
    }
};
$6216d961cde62e0e$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $6216d961cde62e0e$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $6216d961cde62e0e$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $6216d961cde62e0e$var$f($6216d961cde62e0e$var$t, a), null === $6216d961cde62e0e$var$h($6216d961cde62e0e$var$r) && a === $6216d961cde62e0e$var$h($6216d961cde62e0e$var$t) && ($6216d961cde62e0e$var$B ? ($6216d961cde62e0e$var$E($6216d961cde62e0e$var$L), $6216d961cde62e0e$var$L = -1) : $6216d961cde62e0e$var$B = !0, $6216d961cde62e0e$var$K($6216d961cde62e0e$var$H, c - d))) : (a.sortIndex = e, $6216d961cde62e0e$var$f($6216d961cde62e0e$var$r, a), $6216d961cde62e0e$var$A || $6216d961cde62e0e$var$z || ($6216d961cde62e0e$var$A = !0, $6216d961cde62e0e$var$I($6216d961cde62e0e$var$J)));
    return a;
};
$6216d961cde62e0e$export$b5836b71941fa3ed = $6216d961cde62e0e$var$M;
$6216d961cde62e0e$export$cf845f2c119da08a = function(a) {
    var b = $6216d961cde62e0e$var$y;
    return function() {
        var c = $6216d961cde62e0e$var$y;
        $6216d961cde62e0e$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $6216d961cde62e0e$var$y = c;
        }
    };
};

});




var $cVgDf = parcelRequire("cVgDf");
parcelRequire("1bdO8");
var $9c5fb7f33068258d$export$882461b6382ed46c;
var $9c5fb7f33068258d$export$757ceba2d55c277e;
"use strict";
var $82db826d323863e6$exports = {};
"use strict";
function $82db826d323863e6$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($82db826d323863e6$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$82db826d323863e6$var$checkDCE();

$82db826d323863e6$exports = (parcelRequire("9nkLV"));


var $9c5fb7f33068258d$var$i;
$9c5fb7f33068258d$export$882461b6382ed46c = $82db826d323863e6$exports.createRoot;
$9c5fb7f33068258d$export$757ceba2d55c277e = $82db826d323863e6$exports.hydrateRoot;



var $cVgDf = parcelRequire("cVgDf");

var $1bdO8 = parcelRequire("1bdO8");

var $63nUy = parcelRequire("63nUy");

var $1bdO8 = parcelRequire("1bdO8");


var $dHuM2 = parcelRequire("dHuM2");

var $63nUy = parcelRequire("63nUy");
parcelRequire("1bdO8");

parcelRequire("1bdO8");


var $hc4Oj = parcelRequire("hc4Oj");

var $ldP8C = parcelRequire("ldP8C");

var $cVgDf = parcelRequire("cVgDf");
function $232957724f5695b1$var$GlobalStyles({ styles: styles , themeId: themeId , defaultTheme: defaultTheme = {}  }) {
    const upperTheme = (0, $ldP8C.default)(defaultTheme);
    const globalStyles = typeof styles === "function" ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $hc4Oj.default), {
        styles: globalStyles
    });
}
var $232957724f5695b1$export$2e2bcd8739ae039 = $232957724f5695b1$var$GlobalStyles;



var $5VMQ9 = parcelRequire("5VMQ9");

var $5ZcGy = parcelRequire("5ZcGy");

var $cVgDf = parcelRequire("cVgDf");
function $23385e0944e190fb$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $232957724f5695b1$export$2e2bcd8739ae039), (0, $63nUy.default)({}, props, {
        defaultTheme: (0, $5VMQ9.default),
        themeId: (0, $5ZcGy.default)
    }));
}
var $23385e0944e190fb$export$2e2bcd8739ae039 = $23385e0944e190fb$var$GlobalStyles;



var $cVgDf = parcelRequire("cVgDf");
const $4e7ac4d9add92137$export$c0bb0b647f701bb5 = (theme, enableColorScheme)=>(0, $63nUy.default)({
        WebkitFontSmoothing: "antialiased",
        // Antialiasing.
        MozOsxFontSmoothing: "grayscale",
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: "border-box",
        // Fix font resize problem in iOS
        WebkitTextSizeAdjust: "100%"
    }, enableColorScheme && !theme.vars && {
        colorScheme: theme.palette.mode
    });
const $4e7ac4d9add92137$export$32180ef41b15b513 = (theme)=>(0, $63nUy.default)({
        color: (theme.vars || theme).palette.text.primary
    }, theme.typography.body1, {
        backgroundColor: (theme.vars || theme).palette.background.default,
        "@media print": {
            // Save printer ink.
            backgroundColor: (theme.vars || theme).palette.common.white
        }
    });
const $4e7ac4d9add92137$export$9dd6ff9ea0189349 = (theme, enableColorScheme = false)=>{
    var _theme$components, _theme$components$Mui;
    const colorSchemeStyles = {};
    if (enableColorScheme && theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        var _scheme$palette;
        colorSchemeStyles[theme.getColorSchemeSelector(key).replace(/\s*&/, "")] = {
            colorScheme: (_scheme$palette = scheme.palette) == null ? void 0 : _scheme$palette.mode
        };
    });
    let defaultStyles = (0, $63nUy.default)({
        html: $4e7ac4d9add92137$export$c0bb0b647f701bb5(theme, enableColorScheme),
        "*, *::before, *::after": {
            boxSizing: "inherit"
        },
        "strong, b": {
            fontWeight: theme.typography.fontWeightBold
        },
        body: (0, $63nUy.default)({
            margin: 0
        }, $4e7ac4d9add92137$export$32180ef41b15b513(theme), {
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            "&::backdrop": {
                backgroundColor: (theme.vars || theme).palette.background.default
            }
        })
    }, colorSchemeStyles);
    const themeOverrides = (_theme$components = theme.components) == null ? void 0 : (_theme$components$Mui = _theme$components.MuiCssBaseline) == null ? void 0 : _theme$components$Mui.styleOverrides;
    if (themeOverrides) defaultStyles = [
        defaultStyles,
        themeOverrides
    ];
    return defaultStyles;
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $4e7ac4d9add92137$var$CssBaseline(inProps) {
    const props = (0, $dHuM2.default)({
        props: inProps,
        name: "MuiCssBaseline"
    });
    const { children: children , enableColorScheme: enableColorScheme = false  } = props;
    return /*#__PURE__*/ (0, $cVgDf.jsxs)($1bdO8.Fragment, {
        children: [
            /*#__PURE__*/ (0, $cVgDf.jsx)((0, $23385e0944e190fb$export$2e2bcd8739ae039), {
                styles: (theme)=>$4e7ac4d9add92137$export$9dd6ff9ea0189349(theme, enableColorScheme)
            }),
            children
        ]
    });
}
var $4e7ac4d9add92137$export$2e2bcd8739ae039 = $4e7ac4d9add92137$var$CssBaseline;



var $63nUy = parcelRequire("63nUy");

var $fZ2DJ = parcelRequire("fZ2DJ");
parcelRequire("1bdO8");


var $63nUy = parcelRequire("63nUy");

var $1bdO8 = parcelRequire("1bdO8");


var $1bdO8 = parcelRequire("1bdO8");



var $1bdO8 = parcelRequire("1bdO8");
const $23ea8d95f874ae7f$var$ThemeContext = /*#__PURE__*/ $1bdO8.createContext(null);
var $23ea8d95f874ae7f$export$2e2bcd8739ae039 = $23ea8d95f874ae7f$var$ThemeContext;



var $1bdO8 = parcelRequire("1bdO8");

function $76f2fdeea7ff4d63$export$2e2bcd8739ae039() {
    const theme = $1bdO8.useContext((0, $23ea8d95f874ae7f$export$2e2bcd8739ae039));
    return theme;
}


const $eb79fdd1cc11c008$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $eb79fdd1cc11c008$export$2e2bcd8739ae039 = $eb79fdd1cc11c008$var$hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";



var $cVgDf = parcelRequire("cVgDf");
function $43934f56cf957c76$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return {
        ...outerTheme,
        ...localTheme
    };
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $43934f56cf957c76$var$ThemeProvider(props) {
    const { children: children , theme: localTheme  } = props;
    const outerTheme = (0, $76f2fdeea7ff4d63$export$2e2bcd8739ae039)();
    const theme = $1bdO8.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $43934f56cf957c76$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $eb79fdd1cc11c008$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $23ea8d95f874ae7f$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $43934f56cf957c76$export$2e2bcd8739ae039 = $43934f56cf957c76$var$ThemeProvider;



parcelRequire("alXcb");
var $79R6f = parcelRequire("79R6f");

var $7xI6r = parcelRequire("7xI6r");

var $cVgDf = parcelRequire("cVgDf");
const $02020871cefd49df$var$EMPTY_THEME = {};
function $02020871cefd49df$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $1bdO8.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === "function") {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $63nUy.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $63nUy.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $63nUy.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $02020871cefd49df$var$ThemeProvider(props) {
    const { children: children , theme: localTheme , themeId: themeId  } = props;
    const upperTheme = (0, $7xI6r.default)($02020871cefd49df$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $76f2fdeea7ff4d63$export$2e2bcd8739ae039)() || $02020871cefd49df$var$EMPTY_THEME;
    const engineTheme = $02020871cefd49df$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $02020871cefd49df$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $43934f56cf957c76$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $cVgDf.jsx)((0, $79R6f.T).Provider, {
            value: engineTheme,
            children: children
        })
    });
}
var $02020871cefd49df$export$2e2bcd8739ae039 = $02020871cefd49df$var$ThemeProvider;



var $5ZcGy = parcelRequire("5ZcGy");

var $cVgDf = parcelRequire("cVgDf");
const $d9f98aed922d8554$var$_excluded = [
    "theme"
];
function $d9f98aed922d8554$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput  } = _ref, props = (0, $fZ2DJ.default)(_ref, $d9f98aed922d8554$var$_excluded);
    const scopedTheme = themeInput[0, $5ZcGy.default];
    return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $02020871cefd49df$export$2e2bcd8739ae039), (0, $63nUy.default)({}, props, {
        themeId: scopedTheme ? (0, $5ZcGy.default) : undefined,
        theme: scopedTheme || themeInput
    }));
}



var $b8tOr = parcelRequire("b8tOr");
var $1pZEV = parcelRequire("1pZEV");
const $3810992676f217af$var$baseColor = "#202020";
const $3810992676f217af$var$colors = {
    paper: (0, $b8tOr.alpha)($3810992676f217af$var$baseColor, 0.8),
    paperHovered: (0, $b8tOr.alpha)((0, $b8tOr.lighten)($3810992676f217af$var$baseColor, 0.1), 0.8),
    paperActive: (0, $b8tOr.alpha)((0, $b8tOr.lighten)($3810992676f217af$var$baseColor, 0.15), 0.8),
    border: (0, $b8tOr.alpha)((0, $b8tOr.lighten)($3810992676f217af$var$baseColor, 0.25), 0.4),
    borderLight: (0, $b8tOr.alpha)((0, $b8tOr.lighten)($3810992676f217af$var$baseColor, 0.35), 0.3),
    borderHovered: (0, $b8tOr.alpha)((0, $b8tOr.lighten)($3810992676f217af$var$baseColor, 0.3), 0.9),
    borderActive: (0, $b8tOr.alpha)((0, $b8tOr.lighten)($3810992676f217af$var$baseColor, 0.3), 0.9),
    paperButton: (0, $b8tOr.alpha)((0, $b8tOr.lighten)($3810992676f217af$var$baseColor, 0.5), 0.2),
    paperButtonLight: (0, $b8tOr.alpha)((0, $b8tOr.lighten)($3810992676f217af$var$baseColor, 0.4), 0.15),
    paperButtonHovered: (0, $b8tOr.alpha)((0, $b8tOr.lighten)($3810992676f217af$var$baseColor, 0.8), 0.2),
    paperButtonActive: (0, $b8tOr.alpha)((0, $b8tOr.lighten)($3810992676f217af$var$baseColor, 0.8), 0.25)
};
const $3810992676f217af$var$theme = (0, $1pZEV.default)({
    typography: {
        fontSize: 10,
        fontFamily: "ui-monospace, SFMono-Regular, Menlo"
    },
    spacing: 3,
    shape: {
        borderRadius: 8
    },
    palette: {
        mode: "dark",
        text: {
            primary: "#ccc",
            secondary: (0, $b8tOr.alpha)("#ddd", 0.6),
            disabled: (0, $b8tOr.alpha)("#ddd", 0.25)
        },
        primary: {
            main: "#ddd"
        },
        secondary: {
            main: "#999"
        },
        grey: {
            A100: $3810992676f217af$var$colors.paperButtonActive,
            A200: $3810992676f217af$var$colors.paperButtonHovered,
            A400: $3810992676f217af$var$colors.paperButton,
            A700: $3810992676f217af$var$colors.paperButtonLight,
            200: $3810992676f217af$var$colors.borderActive,
            300: $3810992676f217af$var$colors.borderHovered,
            400: $3810992676f217af$var$colors.border,
            500: $3810992676f217af$var$colors.paperActive,
            600: $3810992676f217af$var$colors.paperHovered,
            700: $3810992676f217af$var$colors.paper
        },
        divider: $3810992676f217af$var$colors.border,
        background: {
            default: $3810992676f217af$var$colors.paperButton,
            paper: $3810992676f217af$var$colors.paper
        }
    }
});
var $3810992676f217af$export$2e2bcd8739ae039 = (0, $1pZEV.default)($3810992676f217af$var$theme, {
    components: {
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    pointerEvents: "auto",
                    minWidth: $3810992676f217af$var$theme.spacing(8),
                    color: $3810992676f217af$var$theme.palette.text.secondary,
                    borderColor: $3810992676f217af$var$colors.border,
                    backgroundColor: $3810992676f217af$var$colors.paper,
                    backdropFilter: "blur(10px)",
                    borderRadius: $3810992676f217af$var$theme.shape.borderRadius,
                    "&:hover": {
                        color: $3810992676f217af$var$theme.palette.text.primary,
                        borderColor: $3810992676f217af$var$colors.borderHovered,
                        backgroundColor: $3810992676f217af$var$colors.paperHovered
                    },
                    "&:active": {
                        color: $3810992676f217af$var$theme.palette.text.primary,
                        borderColor: $3810992676f217af$var$colors.borderActive,
                        backgroundColor: $3810992676f217af$var$colors.paperActive
                    }
                },
                outlinedSecondary: {
                    color: $3810992676f217af$var$theme.palette.text.primary,
                    borderColor: $3810992676f217af$var$colors.borderActive,
                    backgroundColor: $3810992676f217af$var$colors.paperActive,
                    "&:hover": {
                        color: $3810992676f217af$var$theme.palette.text.primary,
                        borderColor: $3810992676f217af$var$colors.borderActive,
                        backgroundColor: $3810992676f217af$var$colors.paperActive
                    }
                }
            }
        },
        MuiIconButton: {
            defaultProps: {
                size: "small",
                disableRipple: true
            },
            styleOverrides: {
                root: {
                    borderRadius: $3810992676f217af$var$theme.shape.borderRadius
                }
            }
        },
        MuiChip: {
            defaultProps: {
                size: "small",
                // @ts-ignore
                disableRipple: true
            },
            styleOverrides: {
                root: {
                    color: $3810992676f217af$var$theme.palette.text.primary,
                    backgroundColor: $3810992676f217af$var$colors.paperButtonLight,
                    height: 22,
                    borderRadius: 5,
                    padding: 0,
                    "&:hover": {
                        color: $3810992676f217af$var$theme.palette.text.primary,
                        backgroundColor: $3810992676f217af$var$colors.paperButtonHovered
                    },
                    "&:active": {
                        color: $3810992676f217af$var$theme.palette.text.primary,
                        backgroundColor: $3810992676f217af$var$colors.paperButtonActive
                    }
                }
            }
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    border: `1px solid ${$3810992676f217af$var$colors.border}`,
                    backgroundImage: "none",
                    backgroundColor: $3810992676f217af$var$colors.paper,
                    backdropFilter: "blur(16px)",
                    pointerEvents: "auto",
                    "& .MuiIconButton-root": {
                        width: $3810992676f217af$var$theme.spacing(8),
                        height: $3810992676f217af$var$theme.spacing(8),
                        color: $3810992676f217af$var$theme.palette.text.primary,
                        backgroundColor: $3810992676f217af$var$colors.paperButton,
                        "&:hover": {
                            color: $3810992676f217af$var$theme.palette.text.primary,
                            backgroundColor: $3810992676f217af$var$colors.paperButtonHovered
                        },
                        "&:active": {
                            color: $3810992676f217af$var$theme.palette.text.primary,
                            backgroundColor: $3810992676f217af$var$colors.paperButtonActive
                        }
                    }
                }
            }
        },
        MuiMenu: {
            defaultProps: {
                elevation: 5
            },
            styleOverrides: {
                paper: {
                    border: `1px solid ${$3810992676f217af$var$colors.borderLight}`,
                    backgroundColor: $3810992676f217af$var$colors.paper,
                    pointerEvents: "auto"
                },
                list: {
                    padding: 0
                }
            }
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    fontSize: $3810992676f217af$var$theme.typography.fontSize,
                    color: $3810992676f217af$var$theme.palette.text.primary,
                    "&:hover": {
                        backgroundColor: $3810992676f217af$var$colors.paperButton
                    },
                    "&:active": {
                        backgroundColor: $3810992676f217af$var$colors.paperButtonHovered
                    },
                    "&.Mui-selected": {
                        backgroundColor: $3810992676f217af$var$colors.paperButtonHovered,
                        "&:hover": {
                            backgroundColor: $3810992676f217af$var$colors.paperButtonHovered
                        }
                    }
                }
            }
        },
        MuiPopover: {
            styleOverrides: {
                paper: {
                    border: `1px solid ${$3810992676f217af$var$colors.border}`,
                    backgroundColor: $3810992676f217af$var$colors.paper,
                    backdropFilter: "blur(16px)",
                    pointerEvents: "auto"
                }
            }
        },
        MuiTooltip: {
            defaultProps: {
                arrow: true,
                followCursor: true
            }
        }
    }
});



var $cVgDf = parcelRequire("cVgDf");

var $1bdO8 = parcelRequire("1bdO8");

var $1bdO8 = parcelRequire("1bdO8");

var $1bdO8 = parcelRequire("1bdO8");
var $6f6a414f7b6d6705$export$8793edee2d425525 = function() {};
function $6f6a414f7b6d6705$export$af631764ddc44097(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (obj && obj.addEventListener) obj.addEventListener.apply(obj, args);
}
function $6f6a414f7b6d6705$export$8c8705df4a2dcec9(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (obj && obj.removeEventListener) obj.removeEventListener.apply(obj, args);
}
var $6f6a414f7b6d6705$export$4e09c449d6c407f7 = typeof window !== "undefined";
var $6f6a414f7b6d6705$export$42e7ac6120dd324e = typeof navigator !== "undefined";


var $d7b300a34dff373a$var$defaultTarget = (0, $6f6a414f7b6d6705$export$4e09c449d6c407f7) ? window : null;
var $d7b300a34dff373a$var$isListenerType1 = function(target) {
    return !!target.addEventListener;
};
var $d7b300a34dff373a$var$isListenerType2 = function(target) {
    return !!target.on;
};
var $d7b300a34dff373a$var$useEvent = function(name, handler, target, options) {
    if (target === void 0) target = $d7b300a34dff373a$var$defaultTarget;
    (0, $1bdO8.useEffect)(function() {
        if (!handler) return;
        if (!target) return;
        if ($d7b300a34dff373a$var$isListenerType1(target)) (0, $6f6a414f7b6d6705$export$af631764ddc44097)(target, name, handler, options);
        else if ($d7b300a34dff373a$var$isListenerType2(target)) target.on(name, handler, options);
        return function() {
            if ($d7b300a34dff373a$var$isListenerType1(target)) (0, $6f6a414f7b6d6705$export$8c8705df4a2dcec9)(target, name, handler, options);
            else if ($d7b300a34dff373a$var$isListenerType2(target)) target.off(name, handler, options);
        };
    }, [
        name,
        handler,
        target,
        JSON.stringify(options)
    ]);
};
var $d7b300a34dff373a$export$2e2bcd8739ae039 = $d7b300a34dff373a$var$useEvent;



var $06a60cf932bc70f9$var$createKeyPredicate = function(keyFilter) {
    return typeof keyFilter === "function" ? keyFilter : typeof keyFilter === "string" ? function(event) {
        return event.key === keyFilter;
    } : keyFilter ? function() {
        return true;
    } : function() {
        return false;
    };
};
var $06a60cf932bc70f9$var$useKey = function(key, fn, opts, deps) {
    if (fn === void 0) fn = (0, $6f6a414f7b6d6705$export$8793edee2d425525);
    if (opts === void 0) opts = {};
    if (deps === void 0) deps = [
        key
    ];
    var _a = opts.event, event = _a === void 0 ? "keydown" : _a, target = opts.target, options = opts.options;
    var useMemoHandler = (0, $1bdO8.useMemo)(function() {
        var predicate = $06a60cf932bc70f9$var$createKeyPredicate(key);
        var handler = function(handlerEvent) {
            if (predicate(handlerEvent)) return fn(handlerEvent);
        };
        return handler;
    }, deps);
    (0, $d7b300a34dff373a$export$2e2bcd8739ae039)(event, useMemoHandler, target, options);
};
var $06a60cf932bc70f9$export$2e2bcd8739ae039 = $06a60cf932bc70f9$var$useKey;


var $1bdO8 = parcelRequire("1bdO8");

var $b0ad4098c2db7014$var$useKeyPress = function(keyFilter) {
    var _a = (0, $1bdO8.useState)([
        false,
        null
    ]), state = _a[0], set = _a[1];
    (0, $06a60cf932bc70f9$export$2e2bcd8739ae039)(keyFilter, function(event) {
        return set([
            true,
            event
        ]);
    }, {
        event: "keydown"
    }, [
        state
    ]);
    (0, $06a60cf932bc70f9$export$2e2bcd8739ae039)(keyFilter, function(event) {
        return set([
            false,
            event
        ]);
    }, {
        event: "keyup"
    }, [
        state
    ]);
    return state;
};
var $b0ad4098c2db7014$export$2e2bcd8739ae039 = $b0ad4098c2db7014$var$useKeyPress;



var $fZ2DJ = parcelRequire("fZ2DJ");

var $63nUy = parcelRequire("63nUy");

var $1bdO8 = parcelRequire("1bdO8");


var $gJjS7 = parcelRequire("gJjS7");


var $9H0b9 = parcelRequire("9H0b9");

var $b8tOr = parcelRequire("b8tOr");

var $gIzLq = parcelRequire("gIzLq");

var $dHuM2 = parcelRequire("dHuM2");

var $63nUy = parcelRequire("63nUy");

var $fZ2DJ = parcelRequire("fZ2DJ");

var $1bdO8 = parcelRequire("1bdO8");


var $gJjS7 = parcelRequire("gJjS7");


var $9H0b9 = parcelRequire("9H0b9");

var $gIzLq = parcelRequire("gIzLq");

var $dHuM2 = parcelRequire("dHuM2");

var $1bdO8 = parcelRequire("1bdO8");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $10be72f05148c94a$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}


function $dd3d0833de97326d$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $1bdO8.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $10be72f05148c94a$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


var $428a291d5bcff83c$export$2e2bcd8739ae039 = (0, $dd3d0833de97326d$export$2e2bcd8739ae039);



var $1bdO8 = parcelRequire("1bdO8");

var $1bdO8 = parcelRequire("1bdO8");
const $791ae28d50d58f30$var$useEnhancedEffect = typeof window !== "undefined" ? $1bdO8.useLayoutEffect : $1bdO8.useEffect;
var $791ae28d50d58f30$export$2e2bcd8739ae039 = $791ae28d50d58f30$var$useEnhancedEffect;


function $f10d5b4622f4a02e$export$2e2bcd8739ae039(fn) {
    const ref = $1bdO8.useRef(fn);
    (0, $791ae28d50d58f30$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $1bdO8.useCallback((...args)=>// @ts-expect-error hide `this`
        // tslint:disable-next-line:ban-comma-operator
        (0, ref.current)(...args), []);
}


var $4488f30dc60272e5$export$2e2bcd8739ae039 = (0, $f10d5b4622f4a02e$export$2e2bcd8739ae039);


// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js

var $1bdO8 = parcelRequire("1bdO8");
let $fd0b7a245a8e08e3$var$hadKeyboardEvent = true;
let $fd0b7a245a8e08e3$var$hadFocusVisibleRecently = false;
let $fd0b7a245a8e08e3$var$hadFocusVisibleRecentlyTimeout;
const $fd0b7a245a8e08e3$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $fd0b7a245a8e08e3$var$focusTriggersKeyboardModality(node) {
    const { type: type , tagName: tagName  } = node;
    if (tagName === "INPUT" && $fd0b7a245a8e08e3$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $fd0b7a245a8e08e3$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $fd0b7a245a8e08e3$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $fd0b7a245a8e08e3$var$handlePointerDown() {
    $fd0b7a245a8e08e3$var$hadKeyboardEvent = false;
}
function $fd0b7a245a8e08e3$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($fd0b7a245a8e08e3$var$hadFocusVisibleRecently) $fd0b7a245a8e08e3$var$hadKeyboardEvent = true;
    }
}
function $fd0b7a245a8e08e3$var$prepare(doc) {
    doc.addEventListener("keydown", $fd0b7a245a8e08e3$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $fd0b7a245a8e08e3$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $fd0b7a245a8e08e3$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $fd0b7a245a8e08e3$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $fd0b7a245a8e08e3$var$handleVisibilityChange, true);
}
function $fd0b7a245a8e08e3$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $fd0b7a245a8e08e3$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $fd0b7a245a8e08e3$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $fd0b7a245a8e08e3$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $fd0b7a245a8e08e3$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $fd0b7a245a8e08e3$var$handleVisibilityChange, true);
}
function $fd0b7a245a8e08e3$var$isFocusVisible(event) {
    const { target: target  } = event;
    try {
        return target.matches(":focus-visible");
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $fd0b7a245a8e08e3$var$hadKeyboardEvent || $fd0b7a245a8e08e3$var$focusTriggersKeyboardModality(target);
}
function $fd0b7a245a8e08e3$export$2e2bcd8739ae039() {
    const ref = $1bdO8.useCallback((node)=>{
        if (node != null) $fd0b7a245a8e08e3$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $1bdO8.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $fd0b7a245a8e08e3$var$hadFocusVisibleRecently = true;
            window.clearTimeout($fd0b7a245a8e08e3$var$hadFocusVisibleRecentlyTimeout);
            $fd0b7a245a8e08e3$var$hadFocusVisibleRecentlyTimeout = window.setTimeout(()=>{
                $fd0b7a245a8e08e3$var$hadFocusVisibleRecently = false;
            }, 100);
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($fd0b7a245a8e08e3$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


var $246fdd8b2b400d4f$export$2e2bcd8739ae039 = (0, $fd0b7a245a8e08e3$export$2e2bcd8739ae039);



var $63nUy = parcelRequire("63nUy");

var $fZ2DJ = parcelRequire("fZ2DJ");

var $1bdO8 = parcelRequire("1bdO8");


var $fZ2DJ = parcelRequire("fZ2DJ");

var $63nUy = parcelRequire("63nUy");
function $d6cd1af32c9073f0$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $91f95acf3bb4fa87$export$2e2bcd8739ae039(o, p) {
    $91f95acf3bb4fa87$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $91f95acf3bb4fa87$export$2e2bcd8739ae039(o, p);
}


function $03c724935cdf0204$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $91f95acf3bb4fa87$export$2e2bcd8739ae039)(subClass, superClass);
}




var $1bdO8 = parcelRequire("1bdO8");

var $1bdO8 = parcelRequire("1bdO8");
var $d2ad56df87269604$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($1bdO8))).createContext(null);



var $1bdO8 = parcelRequire("1bdO8");
function $57f8e49330a732ac$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $1bdO8.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $1bdO8.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $57f8e49330a732ac$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $57f8e49330a732ac$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $57f8e49330a732ac$export$fa71e2345c31d7a2(props, onExited) {
    return $57f8e49330a732ac$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $1bdO8.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $57f8e49330a732ac$var$getProp(child, "appear", props),
            enter: $57f8e49330a732ac$var$getProp(child, "enter", props),
            exit: $57f8e49330a732ac$var$getProp(child, "exit", props)
        });
    });
}
function $57f8e49330a732ac$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $57f8e49330a732ac$export$bbc8a025727ea824(nextProps.children);
    var children = $57f8e49330a732ac$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $1bdO8.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $1bdO8.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $1bdO8.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $57f8e49330a732ac$var$getProp(child, "exit", nextProps),
            enter: $57f8e49330a732ac$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $1bdO8.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $1bdO8.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $1bdO8.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $57f8e49330a732ac$var$getProp(child, "exit", nextProps),
            enter: $57f8e49330a732ac$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}


var $d86677664d5c7ed2$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $d86677664d5c7ed2$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $d86677664d5c7ed2$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $03c724935cdf0204$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $d6cd1af32c9073f0$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $57f8e49330a732ac$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $57f8e49330a732ac$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $57f8e49330a732ac$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $63nUy.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $fZ2DJ.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $d86677664d5c7ed2$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bdO8))).createElement((0, $d2ad56df87269604$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bdO8))).createElement((0, $d2ad56df87269604$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bdO8))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($1bdO8))).Component);
$d86677664d5c7ed2$var$TransitionGroup.propTypes = {};
$d86677664d5c7ed2$var$TransitionGroup.defaultProps = $d86677664d5c7ed2$var$defaultProps;
var $d86677664d5c7ed2$export$2e2bcd8739ae039 = $d86677664d5c7ed2$var$TransitionGroup;



var $gJjS7 = parcelRequire("gJjS7");

var $alXcb = parcelRequire("alXcb");

var $gIzLq = parcelRequire("gIzLq");

var $dHuM2 = parcelRequire("dHuM2");

var $1bdO8 = parcelRequire("1bdO8");


var $gJjS7 = parcelRequire("gJjS7");

var $cVgDf = parcelRequire("cVgDf");
function $caf5903a335cf34a$var$Ripple(props) {
    const { className: className , classes: classes , pulsate: pulsate = false , rippleX: rippleX , rippleY: rippleY , rippleSize: rippleSize , in: inProp , onExited: onExited , timeout: timeout  } = props;
    const [leaving, setLeaving] = $1bdO8.useState(false);
    const rippleClassName = (0, $gJjS7.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $gJjS7.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $1bdO8.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $cVgDf.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $cVgDf.jsx)("span", {
            className: childClassName
        })
    });
}
var $caf5903a335cf34a$export$2e2bcd8739ae039 = $caf5903a335cf34a$var$Ripple;



var $itJr1 = parcelRequire("itJr1");

var $9nXgc = parcelRequire("9nXgc");
function $5c0511c80dec76db$export$b464606f735ab902(slot) {
    return (0, $9nXgc.default)("MuiTouchRipple", slot);
}
const $5c0511c80dec76db$var$touchRippleClasses = (0, $itJr1.default)("MuiTouchRipple", [
    "root",
    "ripple",
    "rippleVisible",
    "ripplePulsate",
    "child",
    "childLeaving",
    "childPulsate"
]);
var $5c0511c80dec76db$export$2e2bcd8739ae039 = $5c0511c80dec76db$var$touchRippleClasses;



var $cVgDf = parcelRequire("cVgDf");
const $184a76c0976360fa$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $184a76c0976360fa$var$_ = (t)=>t, $184a76c0976360fa$var$_t, $184a76c0976360fa$var$_t2, $184a76c0976360fa$var$_t3, $184a76c0976360fa$var$_t4;
const $184a76c0976360fa$var$DURATION = 550;
const $184a76c0976360fa$export$95d0c9356b2231a3 = 80;
const $184a76c0976360fa$var$enterKeyframe = (0, $alXcb.keyframes)($184a76c0976360fa$var$_t || ($184a76c0976360fa$var$_t = $184a76c0976360fa$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $184a76c0976360fa$var$exitKeyframe = (0, $alXcb.keyframes)($184a76c0976360fa$var$_t2 || ($184a76c0976360fa$var$_t2 = $184a76c0976360fa$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $184a76c0976360fa$var$pulsateKeyframe = (0, $alXcb.keyframes)($184a76c0976360fa$var$_t3 || ($184a76c0976360fa$var$_t3 = $184a76c0976360fa$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $184a76c0976360fa$export$f6b7418508c72c25 = (0, $gIzLq.default)("span", {
    name: "MuiTouchRipple",
    slot: "Root"
})({
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "inherit"
});
const $184a76c0976360fa$export$676cfe7b12693c4b = (0, $gIzLq.default)((0, $caf5903a335cf34a$export$2e2bcd8739ae039), {
    name: "MuiTouchRipple",
    slot: "Ripple"
})($184a76c0976360fa$var$_t4 || ($184a76c0976360fa$var$_t4 = $184a76c0976360fa$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $5c0511c80dec76db$export$2e2bcd8739ae039).rippleVisible, $184a76c0976360fa$var$enterKeyframe, $184a76c0976360fa$var$DURATION, ({ theme: theme  })=>theme.transitions.easing.easeInOut, (0, $5c0511c80dec76db$export$2e2bcd8739ae039).ripplePulsate, ({ theme: theme  })=>theme.transitions.duration.shorter, (0, $5c0511c80dec76db$export$2e2bcd8739ae039).child, (0, $5c0511c80dec76db$export$2e2bcd8739ae039).childLeaving, $184a76c0976360fa$var$exitKeyframe, $184a76c0976360fa$var$DURATION, ({ theme: theme  })=>theme.transitions.easing.easeInOut, (0, $5c0511c80dec76db$export$2e2bcd8739ae039).childPulsate, $184a76c0976360fa$var$pulsateKeyframe, ({ theme: theme  })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $184a76c0976360fa$var$TouchRipple = /*#__PURE__*/ $1bdO8.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $dHuM2.default)({
        props: inProps,
        name: "MuiTouchRipple"
    });
    const { center: centerProp = false , classes: classes = {} , className: className  } = props, other = (0, $fZ2DJ.default)(props, $184a76c0976360fa$var$_excluded);
    const [ripples, setRipples] = $1bdO8.useState([]);
    const nextKey = $1bdO8.useRef(0);
    const rippleCallback = $1bdO8.useRef(null);
    $1bdO8.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $1bdO8.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = $1bdO8.useRef(null);
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $1bdO8.useRef(null);
    const container = $1bdO8.useRef(null);
    $1bdO8.useEffect(()=>{
        return ()=>{
            clearTimeout(startTimer.current);
        };
    }, []);
    const startCommit = $1bdO8.useCallback((params)=>{
        const { pulsate: pulsate , rippleX: rippleX , rippleY: rippleY , rippleSize: rippleSize , cb: cb  } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $cVgDf.jsx)($184a76c0976360fa$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $gJjS7.default)(classes.ripple, (0, $5c0511c80dec76db$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $gJjS7.default)(classes.rippleVisible, (0, $5c0511c80dec76db$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $gJjS7.default)(classes.ripplePulsate, (0, $5c0511c80dec76db$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $gJjS7.default)(classes.child, (0, $5c0511c80dec76db$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $gJjS7.default)(classes.childLeaving, (0, $5c0511c80dec76db$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $gJjS7.default)(classes.childPulsate, (0, $5c0511c80dec76db$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $184a76c0976360fa$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $1bdO8.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false , center: center = centerProp || options.pulsate , fakeElement: fakeElement = false // For test purposes
          } = options;
        if ((event == null ? void 0 : event.type) === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === "touchstart") ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX , clientY: clientY  } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                startTimer.current = setTimeout(()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                }, $184a76c0976360fa$export$95d0c9356b2231a3); // We have to make a tradeoff with this value.
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit
    ]);
    const pulsate = $1bdO8.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $1bdO8.useCallback((event, cb)=>{
        clearTimeout(startTimer.current);
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === "touchend" && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.current = setTimeout(()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, []);
    $1bdO8.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $cVgDf.jsx)($184a76c0976360fa$export$f6b7418508c72c25, (0, $63nUy.default)({
        className: (0, $gJjS7.default)((0, $5c0511c80dec76db$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $cVgDf.jsx)((0, $d86677664d5c7ed2$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $184a76c0976360fa$export$2e2bcd8739ae039 = $184a76c0976360fa$var$TouchRipple;



var $itJr1 = parcelRequire("itJr1");

var $9nXgc = parcelRequire("9nXgc");
function $db804d9c1c375eb2$export$fccb0498dcd99783(slot) {
    return (0, $9nXgc.default)("MuiButtonBase", slot);
}
const $db804d9c1c375eb2$var$buttonBaseClasses = (0, $itJr1.default)("MuiButtonBase", [
    "root",
    "disabled",
    "focusVisible"
]);
var $db804d9c1c375eb2$export$2e2bcd8739ae039 = $db804d9c1c375eb2$var$buttonBaseClasses;



var $cVgDf = parcelRequire("cVgDf");
const $22f13692c22c9568$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $22f13692c22c9568$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled , focusVisible: focusVisible , focusVisibleClassName: focusVisibleClassName , classes: classes  } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible"
        ]
    };
    const composedClasses = (0, $9H0b9.default)(slots, (0, $db804d9c1c375eb2$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $22f13692c22c9568$export$7ec0dcc5e3cdcd36 = (0, $gIzLq.default)("button", {
    name: "MuiButtonBase",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    boxSizing: "border-box",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    MozAppearance: "none",
    // Reset
    WebkitAppearance: "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
        borderStyle: "none" // Remove Firefox dotted outline.
    },
    [`&.${(0, $db804d9c1c375eb2$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: "none",
        // Disable link interactions
        cursor: "default"
    },
    "@media print": {
        colorAdjust: "exact"
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $22f13692c22c9568$var$ButtonBase = /*#__PURE__*/ $1bdO8.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $dHuM2.default)({
        props: inProps,
        name: "MuiButtonBase"
    });
    const { action: action , centerRipple: centerRipple = false , children: children , className: className , component: component = "button" , disabled: disabled = false , disableRipple: disableRipple = false , disableTouchRipple: disableTouchRipple = false , focusRipple: focusRipple = false , LinkComponent: LinkComponent = "a" , onBlur: onBlur , onClick: onClick , onContextMenu: onContextMenu , onDragLeave: onDragLeave , onFocus: onFocus , onFocusVisible: onFocusVisible , onKeyDown: onKeyDown , onKeyUp: onKeyUp , onMouseDown: onMouseDown , onMouseLeave: onMouseLeave , onMouseUp: onMouseUp , onTouchEnd: onTouchEnd , onTouchMove: onTouchMove , onTouchStart: onTouchStart , tabIndex: tabIndex = 0 , TouchRippleProps: TouchRippleProps , touchRippleRef: touchRippleRef , type: type  } = props, other = (0, $fZ2DJ.default)(props, $22f13692c22c9568$var$_excluded);
    const buttonRef = $1bdO8.useRef(null);
    const rippleRef = $1bdO8.useRef(null);
    const handleRippleRef = (0, $428a291d5bcff83c$export$2e2bcd8739ae039)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef , onFocus: handleFocusVisible , onBlur: handleBlurVisible , ref: focusVisibleRef  } = (0, $246fdd8b2b400d4f$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $1bdO8.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $1bdO8.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $1bdO8.useState(false);
    $1bdO8.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $1bdO8.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $4488f30dc60272e5$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler("start", onMouseDown);
    const handleContextMenu = useRippleHandler("stop", onContextMenu);
    const handleDragLeave = useRippleHandler("stop", onDragLeave);
    const handleMouseUp = useRippleHandler("stop", onMouseUp);
    const handleMouseLeave = useRippleHandler("stop", (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler("start", onTouchStart);
    const handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    const handleTouchMove = useRippleHandler("stop", onTouchMove);
    const handleBlur = useRippleHandler("stop", (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $4488f30dc60272e5$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $1bdO8.useRef(false);
    const handleKeyDown = (0, $4488f30dc60272e5$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $4488f30dc60272e5$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === "button" && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type === undefined ? "button" : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = "button";
        if (disabled) buttonProps["aria-disabled"] = disabled;
    }
    const handleRef = (0, $428a291d5bcff83c$export$2e2bcd8739ae039)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $63nUy.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $22f13692c22c9568$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $cVgDf.jsxs)($22f13692c22c9568$export$7ec0dcc5e3cdcd36, (0, $63nUy.default)({
        as: ComponentProp,
        className: (0, $gJjS7.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $cVgDf.jsx)((0, $184a76c0976360fa$export$2e2bcd8739ae039), (0, $63nUy.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $22f13692c22c9568$export$2e2bcd8739ae039 = $22f13692c22c9568$var$ButtonBase;



var $82mcY = parcelRequire("82mcY");

var $itJr1 = parcelRequire("itJr1");

var $9nXgc = parcelRequire("9nXgc");
function $fd39169e04bff61d$export$5e8702d71474f093(slot) {
    return (0, $9nXgc.default)("MuiIconButton", slot);
}
const $fd39169e04bff61d$var$iconButtonClasses = (0, $itJr1.default)("MuiIconButton", [
    "root",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "colorError",
    "colorInfo",
    "colorSuccess",
    "colorWarning",
    "edgeStart",
    "edgeEnd",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge"
]);
var $fd39169e04bff61d$export$2e2bcd8739ae039 = $fd39169e04bff61d$var$iconButtonClasses;



var $cVgDf = parcelRequire("cVgDf");
const $7845ddbb24692f34$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $7845ddbb24692f34$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , disabled: disabled , color: color , edge: edge , size: size  } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            color !== "default" && `color${(0, $82mcY.default)(color)}`,
            edge && `edge${(0, $82mcY.default)(edge)}`,
            `size${(0, $82mcY.default)(size)}`
        ]
    };
    return (0, $9H0b9.default)(slots, (0, $fd39169e04bff61d$export$5e8702d71474f093), classes);
};
const $7845ddbb24692f34$var$IconButtonRoot = (0, $gIzLq.default)((0, $22f13692c22c9568$export$2e2bcd8739ae039), {
    name: "MuiIconButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $82mcY.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $82mcY.default)(ownerState.edge)}`],
            styles[`size${(0, $82mcY.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>(0, $63nUy.default)({
        textAlign: "center",
        flex: "0 0 auto",
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: "50%",
        overflow: "visible",
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $b8tOr.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }), ({ theme: theme , ownerState: ownerState  })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $63nUy.default)({}, ownerState.color === "inherit" && {
        color: "inherit"
    }, ownerState.color !== "inherit" && ownerState.color !== "default" && (0, $63nUy.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        "&:hover": (0, $63nUy.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $b8tOr.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        })
    }), ownerState.size === "small" && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === "large" && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $fd39169e04bff61d$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: "transparent",
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $7845ddbb24692f34$var$IconButton = /*#__PURE__*/ $1bdO8.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $dHuM2.default)({
        props: inProps,
        name: "MuiIconButton"
    });
    const { edge: edge = false , children: children , className: className , color: color = "default" , disabled: disabled = false , disableFocusRipple: disableFocusRipple = false , size: size = "medium"  } = props, other = (0, $fZ2DJ.default)(props, $7845ddbb24692f34$var$_excluded);
    const ownerState = (0, $63nUy.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $7845ddbb24692f34$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $cVgDf.jsx)($7845ddbb24692f34$var$IconButtonRoot, (0, $63nUy.default)({
        className: (0, $gJjS7.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children
    }));
});
var $7845ddbb24692f34$export$2e2bcd8739ae039 = $7845ddbb24692f34$var$IconButton;



var $fZ2DJ = parcelRequire("fZ2DJ");

var $63nUy = parcelRequire("63nUy");

var $1bdO8 = parcelRequire("1bdO8");


var $gJjS7 = parcelRequire("gJjS7");

var $1nBS8 = parcelRequire("1nBS8");
var $9H0b9 = parcelRequire("9H0b9");
var $9nXgc = parcelRequire("9nXgc");

var $kWGGm = parcelRequire("kWGGm");
const $e46d01b4fa5ffeed$var$styled = (0, $kWGGm.default)();
var $e46d01b4fa5ffeed$export$2e2bcd8739ae039 = $e46d01b4fa5ffeed$var$styled;



var $j8X8X = parcelRequire("j8X8X");

var $63nUy = parcelRequire("63nUy");

var $fZ2DJ = parcelRequire("fZ2DJ");

var $1nBS8 = parcelRequire("1nBS8");

var $k5Vxs = parcelRequire("k5Vxs");
const $9ffbb66e3e984d75$var$_excluded = [
    "sx"
];
const $9ffbb66e3e984d75$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null ? void 0 : (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $k5Vxs.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $9ffbb66e3e984d75$export$2e2bcd8739ae039(props) {
    const { sx: inSx  } = props, other = (0, $fZ2DJ.default)(props, $9ffbb66e3e984d75$var$_excluded);
    const { systemProps: systemProps , otherProps: otherProps  } = $9ffbb66e3e984d75$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $1nBS8.isPlainObject)(result)) return systemProps;
        return (0, $63nUy.default)({}, systemProps, result);
    };
    else finalSx = (0, $63nUy.default)({}, systemProps, inSx);
    return (0, $63nUy.default)({}, otherProps, {
        sx: finalSx
    });
}



var $1iZe2 = parcelRequire("1iZe2");

var $bTeke = parcelRequire("bTeke");

var $fvKw9 = parcelRequire("fvKw9");

var $cVgDf = parcelRequire("cVgDf");
const $84db172a01177155$var$_excluded = [
    "component",
    "direction",
    "spacing",
    "divider",
    "children",
    "className",
    "useFlexGap"
];
const $84db172a01177155$var$defaultTheme = (0, $1iZe2.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $84db172a01177155$var$defaultCreateStyledComponent = (0, $e46d01b4fa5ffeed$export$2e2bcd8739ae039)("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
});
function $84db172a01177155$var$useThemePropsDefault(props) {
    return (0, $j8X8X.default)({
        props: props,
        name: "MuiStack",
        defaultTheme: $84db172a01177155$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $84db172a01177155$var$joinChildren(children, separator) {
    const childrenArray = $1bdO8.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $1bdO8.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $84db172a01177155$var$getSideFromDirection = (direction)=>{
    return ({
        row: "Left",
        "row-reverse": "Right",
        column: "Top",
        "column-reverse": "Bottom"
    })[direction];
};
const $84db172a01177155$export$1d567c320f4763bc = ({ ownerState: ownerState , theme: theme  })=>{
    let styles = (0, $63nUy.default)({
        display: "flex",
        flexDirection: "column"
    }, (0, $bTeke.handleBreakpoints)({
        theme: theme
    }, (0, $bTeke.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    }), (propValue)=>({
            flexDirection: propValue
        })));
    if (ownerState.spacing) {
        const transformer = (0, $fvKw9.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === "object" && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === "object" && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $bTeke.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $bTeke.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === "object") Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : "column";
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $fvKw9.getValue)(transformer, propValue)
            };
            return {
                "& > :not(style) + :not(style)": {
                    margin: 0,
                    [`margin${$84db172a01177155$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $fvKw9.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $1nBS8.default)(styles, (0, $bTeke.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $bTeke.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $84db172a01177155$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $84db172a01177155$var$defaultCreateStyledComponent , useThemeProps: useThemeProps = $84db172a01177155$var$useThemePropsDefault , componentName: componentName = "MuiStack"  } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                "root"
            ]
        };
        return (0, $9H0b9.default)(slots, (slot)=>(0, $9nXgc.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($84db172a01177155$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $1bdO8.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $9ffbb66e3e984d75$export$2e2bcd8739ae039)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = "div" , direction: direction = "column" , spacing: spacing = 0 , divider: divider , children: children , className: className , useFlexGap: useFlexGap = false  } = props, other = (0, $fZ2DJ.default)(props, $84db172a01177155$var$_excluded);
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $cVgDf.jsx)(StackRoot, (0, $63nUy.default)({
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $gJjS7.default)(classes.root, className)
        }, other, {
            children: divider ? $84db172a01177155$var$joinChildren(children, divider) : children
        }));
    });
    return Stack;
}



var $gIzLq = parcelRequire("gIzLq");

var $dHuM2 = parcelRequire("dHuM2");
const $89216f20f1c77281$var$Stack = (0, $84db172a01177155$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $gIzLq.default)("div", {
        name: "MuiStack",
        slot: "Root",
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $dHuM2.default)({
            props: inProps,
            name: "MuiStack"
        })
});
var $89216f20f1c77281$export$2e2bcd8739ae039 = $89216f20f1c77281$var$Stack;


var $fZ2DJ = parcelRequire("fZ2DJ");

var $63nUy = parcelRequire("63nUy");

var $1bdO8 = parcelRequire("1bdO8");


var $gJjS7 = parcelRequire("gJjS7");


var $63nUy = parcelRequire("63nUy");
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $0bca8c2e2f0c859d$export$2e2bcd8739ae039(element) {
    return typeof element === "string";
}


function $d61875c6f8fa8dbb$export$2e2bcd8739ae039(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $0bca8c2e2f0c859d$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return (0, $63nUy.default)({}, otherProps, {
        ownerState: (0, $63nUy.default)({}, otherProps.ownerState, ownerState)
    });
}


var $9H0b9 = parcelRequire("9H0b9");

var $b8tOr = parcelRequire("b8tOr");

var $gIzLq = parcelRequire("gIzLq");
parcelRequire("1bdO8");

var $ldP8C = parcelRequire("ldP8C");

var $5VMQ9 = parcelRequire("5VMQ9");

var $5ZcGy = parcelRequire("5ZcGy");
function $e8c20c93268b1fae$export$2e2bcd8739ae039() {
    const theme = (0, $ldP8C.default)((0, $5VMQ9.default));
    return theme[0, $5ZcGy.default] || theme;
}



var $dHuM2 = parcelRequire("dHuM2");

var $82mcY = parcelRequire("82mcY");

var $63nUy = parcelRequire("63nUy");

var $fZ2DJ = parcelRequire("fZ2DJ");

var $1bdO8 = parcelRequire("1bdO8");



var $fZ2DJ = parcelRequire("fZ2DJ");



var $1bdO8 = parcelRequire("1bdO8");

var $dd4e421937f49d6e$export$2e2bcd8739ae039 = {
    disabled: false
};




var $c4633f087bfd1de8$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $8c1448717d190df7$export$bb38bb9a1161268 = "unmounted";
var $8c1448717d190df7$export$84cbff306f539230 = "exited";
var $8c1448717d190df7$export$df38205c966be359 = "entering";
var $8c1448717d190df7$export$78e9e6e3e014d60a = "entered";
var $8c1448717d190df7$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $8c1448717d190df7$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $03c724935cdf0204$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $8c1448717d190df7$export$84cbff306f539230;
                _this.appearStatus = $8c1448717d190df7$export$df38205c966be359;
            } else initialStatus = $8c1448717d190df7$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $8c1448717d190df7$export$bb38bb9a1161268;
        else initialStatus = $8c1448717d190df7$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $8c1448717d190df7$export$bb38bb9a1161268) return {
            status: $8c1448717d190df7$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $8c1448717d190df7$export$df38205c966be359 && status !== $8c1448717d190df7$export$78e9e6e3e014d60a) nextStatus = $8c1448717d190df7$export$df38205c966be359;
            } else if (status === $8c1448717d190df7$export$df38205c966be359 || status === $8c1448717d190df7$export$78e9e6e3e014d60a) nextStatus = $8c1448717d190df7$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $8c1448717d190df7$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($82db826d323863e6$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $c4633f087bfd1de8$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $8c1448717d190df7$export$84cbff306f539230) this.setState({
            status: $8c1448717d190df7$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($82db826d323863e6$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $dd4e421937f49d6e$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $8c1448717d190df7$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $8c1448717d190df7$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $8c1448717d190df7$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($82db826d323863e6$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $dd4e421937f49d6e$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $8c1448717d190df7$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $8c1448717d190df7$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $8c1448717d190df7$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($82db826d323863e6$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $8c1448717d190df7$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $fZ2DJ.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($1bdO8))).createElement((0, $d2ad56df87269604$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($1bdO8))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($1bdO8))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($1bdO8))).Component);
$8c1448717d190df7$var$Transition.contextType = (0, $d2ad56df87269604$export$2e2bcd8739ae039);
$8c1448717d190df7$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $8c1448717d190df7$var$noop() {}
$8c1448717d190df7$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $8c1448717d190df7$var$noop,
    onEntering: $8c1448717d190df7$var$noop,
    onEntered: $8c1448717d190df7$var$noop,
    onExit: $8c1448717d190df7$var$noop,
    onExiting: $8c1448717d190df7$var$noop,
    onExited: $8c1448717d190df7$var$noop
};
$8c1448717d190df7$var$Transition.UNMOUNTED = $8c1448717d190df7$export$bb38bb9a1161268;
$8c1448717d190df7$var$Transition.EXITED = $8c1448717d190df7$export$84cbff306f539230;
$8c1448717d190df7$var$Transition.ENTERING = $8c1448717d190df7$export$df38205c966be359;
$8c1448717d190df7$var$Transition.ENTERED = $8c1448717d190df7$export$78e9e6e3e014d60a;
$8c1448717d190df7$var$Transition.EXITING = $8c1448717d190df7$export$4aacc83d4d59139f;
var $8c1448717d190df7$export$2e2bcd8739ae039 = $8c1448717d190df7$var$Transition;



const $784b87006e28997c$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $784b87006e28997c$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout , easing: easing , style: style = {}  } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === "object" ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}




var $cVgDf = parcelRequire("cVgDf");
const $5f3be16a76f1a341$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $5f3be16a76f1a341$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $5f3be16a76f1a341$var$styles = {
    entering: {
        opacity: 1,
        transform: $5f3be16a76f1a341$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $5f3be16a76f1a341$var$isWebKit154 = typeof navigator !== "undefined" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $5f3be16a76f1a341$var$Grow = /*#__PURE__*/ $1bdO8.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener , appear: appear = true , children: children , easing: easing , in: inProp , onEnter: onEnter , onEntered: onEntered , onEntering: onEntering , onExit: onExit , onExited: onExited , onExiting: onExiting , style: style , timeout: timeout = "auto" , TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $8c1448717d190df7$export$2e2bcd8739ae039)  } = props, other = (0, $fZ2DJ.default)(props, $5f3be16a76f1a341$var$_excluded);
    const timer = $1bdO8.useRef();
    const autoTimeout = $1bdO8.useRef();
    const theme = (0, $e8c20c93268b1fae$export$2e2bcd8739ae039)();
    const nodeRef = $1bdO8.useRef(null);
    const handleRef = (0, $428a291d5bcff83c$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $784b87006e28997c$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration , delay: delay , easing: transitionTimingFunction  } = (0, $784b87006e28997c$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $5f3be16a76f1a341$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration , delay: delay , easing: transitionTimingFunction  } = (0, $784b87006e28997c$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $5f3be16a76f1a341$var$isWebKit154 ? duration : duration * 0.666,
                delay: $5f3be16a76f1a341$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(",");
        node.style.opacity = 0;
        node.style.transform = $5f3be16a76f1a341$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.current = setTimeout(next, autoTimeout.current || 0);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    $1bdO8.useEffect(()=>{
        return ()=>{
            clearTimeout(timer.current);
        };
    }, []);
    return /*#__PURE__*/ (0, $cVgDf.jsx)(TransitionComponent, (0, $63nUy.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $1bdO8.cloneElement(children, (0, $63nUy.default)({
                style: (0, $63nUy.default)({
                    opacity: 0,
                    transform: $5f3be16a76f1a341$var$getScale(0.75),
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $5f3be16a76f1a341$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$5f3be16a76f1a341$var$Grow.muiSupportAuto = true;
var $5f3be16a76f1a341$export$2e2bcd8739ae039 = $5f3be16a76f1a341$var$Grow;



var $63nUy = parcelRequire("63nUy");

var $fZ2DJ = parcelRequire("fZ2DJ");

var $63nUy = parcelRequire("63nUy");

var $fZ2DJ = parcelRequire("fZ2DJ");

var $1bdO8 = parcelRequire("1bdO8");
function $274f1134d02f9864$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $81566aef622fa1e2$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $b4c894cf55942628$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $81566aef622fa1e2$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $b4c894cf55942628$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $81566aef622fa1e2$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $b4c894cf55942628$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $81566aef622fa1e2$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $99fa3f0b85457ce1$export$8960430cfd85939f = Math.max;
var $99fa3f0b85457ce1$export$96ec731ed4dcb222 = Math.min;
var $99fa3f0b85457ce1$export$2077e0241d6afd3c = Math.round;



function $5757d71fa3f5f9ed$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $aff78d02672fa4e2$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $5757d71fa3f5f9ed$export$2e2bcd8739ae039)());
}


function $56abb6ddb5dd6426$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $b4c894cf55942628$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $99fa3f0b85457ce1$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $99fa3f0b85457ce1$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $b4c894cf55942628$export$45a5e7f76e0caa8d)(element) ? (0, $81566aef622fa1e2$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $aff78d02672fa4e2$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $efc206aff85ba24c$export$2e2bcd8739ae039(node) {
    var win = (0, $81566aef622fa1e2$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $59ea82b633a7e520$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $5c202c50b781a549$export$2e2bcd8739ae039(node) {
    if (node === (0, $81566aef622fa1e2$export$2e2bcd8739ae039)(node) || !(0, $b4c894cf55942628$export$1b3bfaa9684536aa)(node)) return (0, $efc206aff85ba24c$export$2e2bcd8739ae039)(node);
    else return (0, $59ea82b633a7e520$export$2e2bcd8739ae039)(node);
}


function $15c3724885a77de0$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}





function $18332d887a695981$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $b4c894cf55942628$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $b94bb961f3c66fd7$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $56abb6ddb5dd6426$export$2e2bcd8739ae039)((0, $18332d887a695981$export$2e2bcd8739ae039)(element)).left + (0, $efc206aff85ba24c$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $d1cda2f96d222073$export$2e2bcd8739ae039(element) {
    return (0, $81566aef622fa1e2$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $32e274104ba12a0b$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $d1cda2f96d222073$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $1a1b81566bea8116$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $99fa3f0b85457ce1$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $99fa3f0b85457ce1$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $1a1b81566bea8116$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $b4c894cf55942628$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $b4c894cf55942628$export$1b3bfaa9684536aa)(offsetParent) && $1a1b81566bea8116$var$isElementScaled(offsetParent);
    var documentElement = (0, $18332d887a695981$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $56abb6ddb5dd6426$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $15c3724885a77de0$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $32e274104ba12a0b$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $5c202c50b781a549$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $b4c894cf55942628$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $56abb6ddb5dd6426$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $b94bb961f3c66fd7$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $2dad99ec31d21b13$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $56abb6ddb5dd6426$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $d24f1c019ab7b1e6$export$2e2bcd8739ae039(element) {
    if ((0, $15c3724885a77de0$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $b4c894cf55942628$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $18332d887a695981$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $7f7ea8a61f993ddd$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $15c3724885a77de0$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $b4c894cf55942628$export$1b3bfaa9684536aa)(node) && (0, $32e274104ba12a0b$export$2e2bcd8739ae039)(node)) return node;
    return $7f7ea8a61f993ddd$export$2e2bcd8739ae039((0, $d24f1c019ab7b1e6$export$2e2bcd8739ae039)(node));
}





function $2f451db21cb52868$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $7f7ea8a61f993ddd$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $81566aef622fa1e2$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $32e274104ba12a0b$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($2f451db21cb52868$export$2e2bcd8739ae039((0, $d24f1c019ab7b1e6$export$2e2bcd8739ae039)(target)));
}







function $c1f6f0d51fca21bc$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $15c3724885a77de0$export$2e2bcd8739ae039)(element)) >= 0;
}




function $f909394098034cdb$var$getTrueOffsetParent(element) {
    if (!(0, $b4c894cf55942628$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $d1cda2f96d222073$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $f909394098034cdb$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $5757d71fa3f5f9ed$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $5757d71fa3f5f9ed$export$2e2bcd8739ae039)());
    if (isIE && (0, $b4c894cf55942628$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $d1cda2f96d222073$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $d24f1c019ab7b1e6$export$2e2bcd8739ae039)(element);
    if ((0, $b4c894cf55942628$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $b4c894cf55942628$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $15c3724885a77de0$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $d1cda2f96d222073$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $f909394098034cdb$export$2e2bcd8739ae039(element) {
    var window = (0, $81566aef622fa1e2$export$2e2bcd8739ae039)(element);
    var offsetParent = $f909394098034cdb$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $c1f6f0d51fca21bc$export$2e2bcd8739ae039)(offsetParent) && (0, $d1cda2f96d222073$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $f909394098034cdb$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $15c3724885a77de0$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $15c3724885a77de0$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $d1cda2f96d222073$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $f909394098034cdb$var$getContainingBlock(element) || window;
}


var $026dd86814b3758e$export$1e95b668f3b82d = "top";
var $026dd86814b3758e$export$40e543e69a8b3fbb = "bottom";
var $026dd86814b3758e$export$79ffe56a765070d2 = "right";
var $026dd86814b3758e$export$eabcd2c8791e7bf4 = "left";
var $026dd86814b3758e$export$dfb5619354ba860 = "auto";
var $026dd86814b3758e$export$aec2ce47c367b8c3 = [
    $026dd86814b3758e$export$1e95b668f3b82d,
    $026dd86814b3758e$export$40e543e69a8b3fbb,
    $026dd86814b3758e$export$79ffe56a765070d2,
    $026dd86814b3758e$export$eabcd2c8791e7bf4
];
var $026dd86814b3758e$export$b3571188c770cc5a = "start";
var $026dd86814b3758e$export$bd5df0f255a350f8 = "end";
var $026dd86814b3758e$export$390fd549c5303b4d = "clippingParents";
var $026dd86814b3758e$export$d7b7311ec04a3e8f = "viewport";
var $026dd86814b3758e$export$ae5ab1c730825774 = "popper";
var $026dd86814b3758e$export$ca50aac9f3ba507f = "reference";
var $026dd86814b3758e$export$368f9a87e87fa4e1 = /*#__PURE__*/ $026dd86814b3758e$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $026dd86814b3758e$export$b3571188c770cc5a,
        placement + "-" + $026dd86814b3758e$export$bd5df0f255a350f8
    ]);
}, []);
var $026dd86814b3758e$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($026dd86814b3758e$export$aec2ce47c367b8c3, [
    $026dd86814b3758e$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $026dd86814b3758e$export$b3571188c770cc5a,
        placement + "-" + $026dd86814b3758e$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $026dd86814b3758e$export$421679a7c3d56e = "beforeRead";
var $026dd86814b3758e$export$aafa59e2e03f2942 = "read";
var $026dd86814b3758e$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $026dd86814b3758e$export$c65e99957a05207c = "beforeMain";
var $026dd86814b3758e$export$f22da7240b7add18 = "main";
var $026dd86814b3758e$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $026dd86814b3758e$export$8d4d2d70e7d46032 = "beforeWrite";
var $026dd86814b3758e$export$68d8715fc104d294 = "write";
var $026dd86814b3758e$export$70a6e5159acce2e6 = "afterWrite";
var $026dd86814b3758e$export$d087d3878fdf71d5 = [
    $026dd86814b3758e$export$421679a7c3d56e,
    $026dd86814b3758e$export$aafa59e2e03f2942,
    $026dd86814b3758e$export$6964f6c886723980,
    $026dd86814b3758e$export$c65e99957a05207c,
    $026dd86814b3758e$export$f22da7240b7add18,
    $026dd86814b3758e$export$bab79516f2d662fe,
    $026dd86814b3758e$export$8d4d2d70e7d46032,
    $026dd86814b3758e$export$68d8715fc104d294,
    $026dd86814b3758e$export$70a6e5159acce2e6
];


function $63399b8f8a3531d3$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $63399b8f8a3531d3$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $63399b8f8a3531d3$var$order(modifiers); // order based on phase
    return (0, $026dd86814b3758e$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $64bd6e98493b7a72$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $8fa195ea4e06596e$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $2b0b585f2967a0c3$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $2b0b585f2967a0c3$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $2b0b585f2967a0c3$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $2b0b585f2967a0c3$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $2b0b585f2967a0c3$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $b4c894cf55942628$export$45a5e7f76e0caa8d)(reference) ? (0, $2f451db21cb52868$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $2f451db21cb52868$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $2f451db21cb52868$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $63399b8f8a3531d3$export$2e2bcd8739ae039)((0, $8fa195ea4e06596e$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$2b0b585f2967a0c3$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $1a1b81566bea8116$export$2e2bcd8739ae039)(reference, (0, $f909394098034cdb$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $2dad99ec31d21b13$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $64bd6e98493b7a72$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$2b0b585f2967a0c3$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $2b0b585f2967a0c3$export$8f7491d57c8f97a9 = /*#__PURE__*/ $2b0b585f2967a0c3$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $d2e078c02ab93a51$var$passive = {
    passive: true
};
function $d2e078c02ab93a51$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $81566aef622fa1e2$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $d2e078c02ab93a51$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $d2e078c02ab93a51$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $d2e078c02ab93a51$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $d2e078c02ab93a51$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $d2e078c02ab93a51$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $d2e078c02ab93a51$var$effect,
    data: {}
};



function $277c0793eb3066bd$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $72516cb1549e5e86$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $8e5be827b17f8312$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $9bdfbc57e42999e0$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $277c0793eb3066bd$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $72516cb1549e5e86$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $026dd86814b3758e$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $026dd86814b3758e$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $026dd86814b3758e$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $026dd86814b3758e$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $8e5be827b17f8312$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $026dd86814b3758e$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $026dd86814b3758e$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $acfcc3fd10cd3510$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $9bdfbc57e42999e0$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $acfcc3fd10cd3510$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $acfcc3fd10cd3510$var$popperOffsets,
    data: {}
};










var $cad8bd0f69a46615$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $cad8bd0f69a46615$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $99fa3f0b85457ce1$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $99fa3f0b85457ce1$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $cad8bd0f69a46615$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $026dd86814b3758e$export$eabcd2c8791e7bf4);
    var sideY = (0, $026dd86814b3758e$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $f909394098034cdb$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $81566aef622fa1e2$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $18332d887a695981$export$2e2bcd8739ae039)(popper);
            if ((0, $d1cda2f96d222073$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $026dd86814b3758e$export$1e95b668f3b82d) || (placement === (0, $026dd86814b3758e$export$eabcd2c8791e7bf4) || placement === (0, $026dd86814b3758e$export$79ffe56a765070d2)) && variation === (0, $026dd86814b3758e$export$bd5df0f255a350f8)) {
            sideY = (0, $026dd86814b3758e$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $026dd86814b3758e$export$eabcd2c8791e7bf4) || (placement === (0, $026dd86814b3758e$export$1e95b668f3b82d) || placement === (0, $026dd86814b3758e$export$40e543e69a8b3fbb)) && variation === (0, $026dd86814b3758e$export$bd5df0f255a350f8)) {
            sideX = (0, $026dd86814b3758e$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $cad8bd0f69a46615$var$unsetSides);
    var _ref4 = roundOffsets === true ? $cad8bd0f69a46615$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $81566aef622fa1e2$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $cad8bd0f69a46615$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $277c0793eb3066bd$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $72516cb1549e5e86$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $cad8bd0f69a46615$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $cad8bd0f69a46615$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $cad8bd0f69a46615$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $cad8bd0f69a46615$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $0905bed5de3c2b15$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $b4c894cf55942628$export$1b3bfaa9684536aa)(element) || !(0, $15c3724885a77de0$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $0905bed5de3c2b15$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $b4c894cf55942628$export$1b3bfaa9684536aa)(element) || !(0, $15c3724885a77de0$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $0905bed5de3c2b15$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $0905bed5de3c2b15$var$applyStyles,
    effect: $0905bed5de3c2b15$var$effect,
    requires: [
        "computeStyles"
    ]
};




function $069517ec6da8ca83$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $277c0793eb3066bd$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $026dd86814b3758e$export$eabcd2c8791e7bf4),
        (0, $026dd86814b3758e$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $026dd86814b3758e$export$eabcd2c8791e7bf4),
        (0, $026dd86814b3758e$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $069517ec6da8ca83$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $026dd86814b3758e$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $069517ec6da8ca83$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $069517ec6da8ca83$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $069517ec6da8ca83$var$offset
};


var $96cf17afae3dc6ee$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $96cf17afae3dc6ee$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $96cf17afae3dc6ee$var$hash[matched];
    });
}



var $620173a77431d9d1$var$hash = {
    start: "end",
    end: "start"
};
function $620173a77431d9d1$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $620173a77431d9d1$var$hash[matched];
    });
}







function $64597cb018937bb6$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $81566aef622fa1e2$export$2e2bcd8739ae039)(element);
    var html = (0, $18332d887a695981$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $aff78d02672fa4e2$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $b94bb961f3c66fd7$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $0ba99ca7b4153c7a$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $18332d887a695981$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $efc206aff85ba24c$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $99fa3f0b85457ce1$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $99fa3f0b85457ce1$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $b94bb961f3c66fd7$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $d1cda2f96d222073$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $99fa3f0b85457ce1$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $e590625f8b670b69$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $b4c894cf55942628$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $f64334574ff33baf$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $8b1a07cd15329dfa$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $56abb6ddb5dd6426$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $8b1a07cd15329dfa$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $026dd86814b3758e$export$d7b7311ec04a3e8f) ? (0, $f64334574ff33baf$export$2e2bcd8739ae039)((0, $64597cb018937bb6$export$2e2bcd8739ae039)(element, strategy)) : (0, $b4c894cf55942628$export$45a5e7f76e0caa8d)(clippingParent) ? $8b1a07cd15329dfa$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $f64334574ff33baf$export$2e2bcd8739ae039)((0, $0ba99ca7b4153c7a$export$2e2bcd8739ae039)((0, $18332d887a695981$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $8b1a07cd15329dfa$var$getClippingParents(element) {
    var clippingParents = (0, $2f451db21cb52868$export$2e2bcd8739ae039)((0, $d24f1c019ab7b1e6$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $d1cda2f96d222073$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $b4c894cf55942628$export$1b3bfaa9684536aa)(element) ? (0, $f909394098034cdb$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $b4c894cf55942628$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $b4c894cf55942628$export$45a5e7f76e0caa8d)(clippingParent) && (0, $e590625f8b670b69$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $15c3724885a77de0$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $8b1a07cd15329dfa$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $8b1a07cd15329dfa$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $8b1a07cd15329dfa$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $99fa3f0b85457ce1$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $99fa3f0b85457ce1$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $99fa3f0b85457ce1$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $99fa3f0b85457ce1$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $8b1a07cd15329dfa$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $7275fff592573642$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $5d39426a43db37e9$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $7275fff592573642$export$2e2bcd8739ae039)(), paddingObject);
}


function $e8e0eac258a145ea$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $77c6b8e138bc5e4b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $026dd86814b3758e$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $026dd86814b3758e$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $026dd86814b3758e$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $5d39426a43db37e9$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $e8e0eac258a145ea$export$2e2bcd8739ae039)(padding, (0, $026dd86814b3758e$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $026dd86814b3758e$export$ae5ab1c730825774) ? (0, $026dd86814b3758e$export$ca50aac9f3ba507f) : (0, $026dd86814b3758e$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $8b1a07cd15329dfa$export$2e2bcd8739ae039)((0, $b4c894cf55942628$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $18332d887a695981$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $56abb6ddb5dd6426$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $9bdfbc57e42999e0$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $f64334574ff33baf$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $026dd86814b3758e$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $026dd86814b3758e$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $026dd86814b3758e$export$79ffe56a765070d2),
                (0, $026dd86814b3758e$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $026dd86814b3758e$export$1e95b668f3b82d),
                (0, $026dd86814b3758e$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $89c795701e75877d$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $026dd86814b3758e$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $72516cb1549e5e86$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $026dd86814b3758e$export$368f9a87e87fa4e1) : (0, $026dd86814b3758e$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $72516cb1549e5e86$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $026dd86814b3758e$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $77c6b8e138bc5e4b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $277c0793eb3066bd$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $6684624c95eae6bd$var$getExpandedFallbackPlacements(placement) {
    if ((0, $277c0793eb3066bd$export$2e2bcd8739ae039)(placement) === (0, $026dd86814b3758e$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $96cf17afae3dc6ee$export$2e2bcd8739ae039)(placement);
    return [
        (0, $620173a77431d9d1$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $620173a77431d9d1$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $6684624c95eae6bd$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $277c0793eb3066bd$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $96cf17afae3dc6ee$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $6684624c95eae6bd$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $277c0793eb3066bd$export$2e2bcd8739ae039)(placement) === (0, $026dd86814b3758e$export$dfb5619354ba860) ? (0, $89c795701e75877d$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $277c0793eb3066bd$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $72516cb1549e5e86$export$2e2bcd8739ae039)(placement) === (0, $026dd86814b3758e$export$b3571188c770cc5a);
        var isVertical = [
            (0, $026dd86814b3758e$export$1e95b668f3b82d),
            (0, $026dd86814b3758e$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $77c6b8e138bc5e4b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $026dd86814b3758e$export$79ffe56a765070d2) : (0, $026dd86814b3758e$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $026dd86814b3758e$export$40e543e69a8b3fbb) : (0, $026dd86814b3758e$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $96cf17afae3dc6ee$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $96cf17afae3dc6ee$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $6684624c95eae6bd$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $6684624c95eae6bd$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $532ce93953a0bba6$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $996e6ff00c9d4747$export$f28d906d67a997f3(min, value, max) {
    return (0, $99fa3f0b85457ce1$export$8960430cfd85939f)(min, (0, $99fa3f0b85457ce1$export$96ec731ed4dcb222)(value, max));
}
function $996e6ff00c9d4747$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $996e6ff00c9d4747$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $7dc7d9ec2a2ba162$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $77c6b8e138bc5e4b$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $277c0793eb3066bd$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $72516cb1549e5e86$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $8e5be827b17f8312$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $532ce93953a0bba6$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $026dd86814b3758e$export$1e95b668f3b82d) : (0, $026dd86814b3758e$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $026dd86814b3758e$export$40e543e69a8b3fbb) : (0, $026dd86814b3758e$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $026dd86814b3758e$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $026dd86814b3758e$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $2dad99ec31d21b13$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $7275fff592573642$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $996e6ff00c9d4747$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $f909394098034cdb$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $996e6ff00c9d4747$export$f28d906d67a997f3)(tether ? (0, $99fa3f0b85457ce1$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $99fa3f0b85457ce1$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $026dd86814b3758e$export$1e95b668f3b82d) : (0, $026dd86814b3758e$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $026dd86814b3758e$export$40e543e69a8b3fbb) : (0, $026dd86814b3758e$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $026dd86814b3758e$export$1e95b668f3b82d),
            (0, $026dd86814b3758e$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $996e6ff00c9d4747$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $996e6ff00c9d4747$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $7dc7d9ec2a2ba162$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $7dc7d9ec2a2ba162$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};











var $ac79c3cb19967755$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $5d39426a43db37e9$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $e8e0eac258a145ea$export$2e2bcd8739ae039)(padding, (0, $026dd86814b3758e$export$aec2ce47c367b8c3)));
};
function $ac79c3cb19967755$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $277c0793eb3066bd$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $8e5be827b17f8312$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $026dd86814b3758e$export$eabcd2c8791e7bf4),
        (0, $026dd86814b3758e$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $ac79c3cb19967755$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $2dad99ec31d21b13$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $026dd86814b3758e$export$1e95b668f3b82d) : (0, $026dd86814b3758e$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $026dd86814b3758e$export$40e543e69a8b3fbb) : (0, $026dd86814b3758e$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $f909394098034cdb$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $996e6ff00c9d4747$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $ac79c3cb19967755$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $e590625f8b670b69$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $ac79c3cb19967755$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $ac79c3cb19967755$var$arrow,
    effect: $ac79c3cb19967755$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $f616c1cfd469c664$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $f616c1cfd469c664$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $026dd86814b3758e$export$1e95b668f3b82d),
        (0, $026dd86814b3758e$export$79ffe56a765070d2),
        (0, $026dd86814b3758e$export$40e543e69a8b3fbb),
        (0, $026dd86814b3758e$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $f616c1cfd469c664$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $77c6b8e138bc5e4b$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $77c6b8e138bc5e4b$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $f616c1cfd469c664$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $f616c1cfd469c664$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $f616c1cfd469c664$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $f616c1cfd469c664$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $f616c1cfd469c664$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $f616c1cfd469c664$var$hide
};




var $debd961d13d80de7$export$d34966752335dd47 = [
    (0, $d2e078c02ab93a51$export$2e2bcd8739ae039),
    (0, $acfcc3fd10cd3510$export$2e2bcd8739ae039),
    (0, $cad8bd0f69a46615$export$2e2bcd8739ae039),
    (0, $0905bed5de3c2b15$export$2e2bcd8739ae039),
    (0, $069517ec6da8ca83$export$2e2bcd8739ae039),
    (0, $6684624c95eae6bd$export$2e2bcd8739ae039),
    (0, $7dc7d9ec2a2ba162$export$2e2bcd8739ae039),
    (0, $ac79c3cb19967755$export$2e2bcd8739ae039),
    (0, $f616c1cfd469c664$export$2e2bcd8739ae039)
];
var $debd961d13d80de7$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $2b0b585f2967a0c3$export$ed5e13716264f202)({
    defaultModifiers: $debd961d13d80de7$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules




var $9H0b9 = parcelRequire("9H0b9");

var $1bdO8 = parcelRequire("1bdO8");




var $cVgDf = parcelRequire("cVgDf");
function $1f51e0c5982a0f47$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/base/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/base/react-portal/components-api/#portal)
 */ const $1f51e0c5982a0f47$var$Portal = /*#__PURE__*/ $1bdO8.forwardRef(function Portal(props, forwardedRef) {
    const { children: children , container: container , disablePortal: disablePortal = false  } = props;
    const [mountNode, setMountNode] = $1bdO8.useState(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $dd3d0833de97326d$export$2e2bcd8739ae039)(/*#__PURE__*/ $1bdO8.isValidElement(children) ? children.ref : null, forwardedRef);
    (0, $791ae28d50d58f30$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($1f51e0c5982a0f47$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $791ae28d50d58f30$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $10be72f05148c94a$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $10be72f05148c94a$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $1bdO8.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $1bdO8.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $cVgDf.jsx)($1bdO8.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $cVgDf.jsx)($1bdO8.Fragment, {
        children: mountNode ? /*#__PURE__*/ $82db826d323863e6$exports.createPortal(children, mountNode) : mountNode
    });
});
var $1f51e0c5982a0f47$export$2e2bcd8739ae039 = $1f51e0c5982a0f47$var$Portal;



var $9nXgc = parcelRequire("9nXgc");

var $itJr1 = parcelRequire("itJr1");
function $f40ec28cdab90c94$export$1b69b6cd0fa638a1(slot) {
    return (0, $9nXgc.default)("MuiPopper", slot);
}
const $f40ec28cdab90c94$var$popperClasses = (0, $itJr1.default)("MuiPopper", [
    "root"
]);
var $f40ec28cdab90c94$export$2e2bcd8739ae039 = $f40ec28cdab90c94$var$popperClasses;



var $63nUy = parcelRequire("63nUy");

var $fZ2DJ = parcelRequire("fZ2DJ");



var $63nUy = parcelRequire("63nUy");

var $gJjS7 = parcelRequire("gJjS7");
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $f079698d98ef2187$export$2e2bcd8739ae039(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $abd95be7de5f75bf$export$2e2bcd8739ae039(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


function $c8bfe256a63be327$export$2e2bcd8739ae039(parameters) {
    const { getSlotProps: getSlotProps , additionalProps: additionalProps , externalSlotProps: externalSlotProps , externalForwardedProps: externalForwardedProps , className: className  } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $gJjS7.default)(externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className, className, additionalProps == null ? void 0 : additionalProps.className);
        const mergedStyle = (0, $63nUy.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $63nUy.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $f079698d98ef2187$export$2e2bcd8739ae039)((0, $63nUy.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $abd95be7de5f75bf$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $abd95be7de5f75bf$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $gJjS7.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $63nUy.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $63nUy.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $394749d958e9c14d$export$2e2bcd8739ae039(componentProps, ownerState) {
    if (typeof componentProps === "function") return componentProps(ownerState);
    return componentProps;
}


const $a3690fae0734bc5f$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState"
];
function $a3690fae0734bc5f$export$2e2bcd8739ae039(parameters) {
    var _parameters$additiona;
    const { elementType: elementType , externalSlotProps: externalSlotProps , ownerState: ownerState  } = parameters, rest = (0, $fZ2DJ.default)(parameters, $a3690fae0734bc5f$var$_excluded);
    const resolvedComponentsProps = (0, $394749d958e9c14d$export$2e2bcd8739ae039)(externalSlotProps, ownerState);
    const { props: mergedProps , internalRef: internalRef  } = (0, $c8bfe256a63be327$export$2e2bcd8739ae039)((0, $63nUy.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $dd3d0833de97326d$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $d61875c6f8fa8dbb$export$2e2bcd8739ae039)(elementType, (0, $63nUy.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}



var $1bdO8 = parcelRequire("1bdO8");

var $cVgDf = parcelRequire("cVgDf");
const $6daae6859fe59e44$var$defaultContextValue = {
    disableDefaultClasses: false
};
const $6daae6859fe59e44$var$ClassNameConfiguratorContext = /*#__PURE__*/ $1bdO8.createContext($6daae6859fe59e44$var$defaultContextValue);
function $6daae6859fe59e44$export$b0f7603cd2f9ee15(generateUtilityClass) {
    const { disableDefaultClasses: disableDefaultClasses  } = $1bdO8.useContext($6daae6859fe59e44$var$ClassNameConfiguratorContext);
    return (slot)=>{
        if (disableDefaultClasses) return "";
        return generateUtilityClass(slot);
    };
}
function $6daae6859fe59e44$export$2e2bcd8739ae039(props) {
    const { disableDefaultClasses: disableDefaultClasses , children: children  } = props;
    const contextValue = $1bdO8.useMemo(()=>({
            disableDefaultClasses: disableDefaultClasses != null ? disableDefaultClasses : false
        }), [
        disableDefaultClasses
    ]);
    return /*#__PURE__*/ (0, $cVgDf.jsx)($6daae6859fe59e44$var$ClassNameConfiguratorContext.Provider, {
        value: contextValue,
        children: children
    });
}



var $cVgDf = parcelRequire("cVgDf");
const $ff3c1554a9404209$var$_excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    "ownerState"
], $ff3c1554a9404209$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
];
function $ff3c1554a9404209$var$flipPlacement(placement, direction) {
    if (direction === "ltr") return placement;
    switch(placement){
        case "bottom-end":
            return "bottom-start";
        case "bottom-start":
            return "bottom-end";
        case "top-end":
            return "top-start";
        case "top-start":
            return "top-end";
        default:
            return placement;
    }
}
function $ff3c1554a9404209$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
function $ff3c1554a9404209$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $ff3c1554a9404209$var$isVirtualElement(element) {
    return !$ff3c1554a9404209$var$isHTMLElement(element);
}
const $ff3c1554a9404209$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $9H0b9.default)(slots, (0, $6daae6859fe59e44$export$b0f7603cd2f9ee15)((0, $f40ec28cdab90c94$export$1b69b6cd0fa638a1)));
};
const $ff3c1554a9404209$var$defaultPopperOptions = {};
const $ff3c1554a9404209$var$PopperTooltip = /*#__PURE__*/ $1bdO8.forwardRef(function PopperTooltip(props, forwardedRef) {
    var _slots$root;
    const { anchorEl: anchorEl , children: children , direction: direction , disablePortal: disablePortal , modifiers: modifiers , open: open , placement: initialPlacement , popperOptions: popperOptions , popperRef: popperRefProp , slotProps: slotProps = {} , slots: slots = {} , TransitionProps: TransitionProps  } = props, other = (0, $fZ2DJ.default)(props, $ff3c1554a9404209$var$_excluded);
    const tooltipRef = $1bdO8.useRef(null);
    const ownRef = (0, $dd3d0833de97326d$export$2e2bcd8739ae039)(tooltipRef, forwardedRef);
    const popperRef = $1bdO8.useRef(null);
    const handlePopperRef = (0, $dd3d0833de97326d$export$2e2bcd8739ae039)(popperRef, popperRefProp);
    const handlePopperRefRef = $1bdO8.useRef(handlePopperRef);
    (0, $791ae28d50d58f30$export$2e2bcd8739ae039)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $1bdO8.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $ff3c1554a9404209$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $1bdO8.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $1bdO8.useState($ff3c1554a9404209$var$resolveAnchorEl(anchorEl));
    $1bdO8.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $1bdO8.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($ff3c1554a9404209$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $791ae28d50d58f30$export$2e2bcd8739ae039)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: "preventOverflow",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "flip",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "onUpdate",
                enabled: true,
                phase: "afterWrite",
                fn: ({ state: state  })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $debd961d13d80de7$export$8f7491d57c8f97a9)(resolvedAnchorElement, tooltipRef.current, (0, $63nUy.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $ff3c1554a9404209$var$useUtilityClasses();
    const Root = (_slots$root = slots.root) != null ? _slots$root : "div";
    const rootProps = (0, $a3690fae0734bc5f$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: "tooltip",
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $cVgDf.jsx)(Root, (0, $63nUy.default)({}, rootProps, {
        children: typeof children === "function" ? children(childProps) : children
    }));
});
/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v2/) for positioning.
 *
 * Demos:
 *
 * - [Popper](https://mui.com/base/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/base/react-popper/components-api/#popper)
 */ const $ff3c1554a9404209$var$Popper = /*#__PURE__*/ $1bdO8.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl , children: children , container: containerProp , direction: direction = "ltr" , disablePortal: disablePortal = false , keepMounted: keepMounted = false , modifiers: modifiers , open: open , placement: placement = "bottom" , popperOptions: popperOptions = $ff3c1554a9404209$var$defaultPopperOptions , popperRef: popperRef , style: style , transition: transition = false , slotProps: slotProps = {} , slots: slots = {}  } = props, other = (0, $fZ2DJ.default)(props, $ff3c1554a9404209$var$_excluded2);
    const [exited, setExited] = $1bdO8.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $ff3c1554a9404209$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $ff3c1554a9404209$var$isHTMLElement(resolvedAnchorEl) ? (0, $274f1134d02f9864$export$2e2bcd8739ae039)(resolvedAnchorEl).body : (0, $274f1134d02f9864$export$2e2bcd8739ae039)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? "none" : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $1f51e0c5982a0f47$export$2e2bcd8739ae039), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $cVgDf.jsx)($ff3c1554a9404209$var$PopperTooltip, (0, $63nUy.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other, {
            style: (0, $63nUy.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: "fixed",
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});
var $ff3c1554a9404209$export$2e2bcd8739ae039 = $ff3c1554a9404209$var$Popper;



var $7xI6r = parcelRequire("7xI6r");



var $1bdO8 = parcelRequire("1bdO8");

var $gIzLq = parcelRequire("gIzLq");
var $dHuM2 = parcelRequire("dHuM2");

var $cVgDf = parcelRequire("cVgDf");
const $0ff8345440fbfe60$var$_excluded = [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
];
const $0ff8345440fbfe60$var$PopperRoot = (0, $gIzLq.default)((0, $ff3c1554a9404209$export$2e2bcd8739ae039), {
    name: "MuiPopper",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $0ff8345440fbfe60$var$Popper = /*#__PURE__*/ $1bdO8.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, $7xI6r.default)();
    const props = (0, $dHuM2.default)({
        props: inProps,
        name: "MuiPopper"
    });
    const { anchorEl: anchorEl , component: component , components: components , componentsProps: componentsProps , container: container , disablePortal: disablePortal , keepMounted: keepMounted , modifiers: modifiers , open: open , placement: placement , popperOptions: popperOptions , popperRef: popperRef , transition: transition , slots: slots , slotProps: slotProps  } = props, other = (0, $fZ2DJ.default)(props, $0ff8345440fbfe60$var$_excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    const otherProps = (0, $63nUy.default)({
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition
    }, other);
    return /*#__PURE__*/ (0, $cVgDf.jsx)($0ff8345440fbfe60$var$PopperRoot, (0, $63nUy.default)({
        as: component,
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, otherProps, {
        ref: ref
    }));
});
var $0ff8345440fbfe60$export$2e2bcd8739ae039 = $0ff8345440fbfe60$var$Popper;





var $1bdO8 = parcelRequire("1bdO8");
let $4c7b18eb3cf1cefc$var$globalId = 0;
function $4c7b18eb3cf1cefc$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $1bdO8.useState(idOverride);
    const id = idOverride || defaultId;
    $1bdO8.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $4c7b18eb3cf1cefc$var$globalId += 1;
            setDefaultId(`mui-${$4c7b18eb3cf1cefc$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $4c7b18eb3cf1cefc$var$maybeReactUseId = $1bdO8["useId".toString()];
function $4c7b18eb3cf1cefc$export$2e2bcd8739ae039(idOverride) {
    if ($4c7b18eb3cf1cefc$var$maybeReactUseId !== undefined) {
        const reactId = $4c7b18eb3cf1cefc$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $4c7b18eb3cf1cefc$var$useGlobalId(idOverride);
}


var $76b9da61cda9919c$export$2e2bcd8739ae039 = (0, $4c7b18eb3cf1cefc$export$2e2bcd8739ae039);



/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ 
var $1bdO8 = parcelRequire("1bdO8");
function $e76f0abec7bf07f5$export$2e2bcd8739ae039({ controlled: controlled , default: defaultProp , name: name , state: state = "value"  }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled  } = $1bdO8.useRef(controlled !== undefined);
    const [valueState, setValue] = $1bdO8.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $1bdO8.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


var $e5534e08f650a1ea$export$2e2bcd8739ae039 = (0, $e76f0abec7bf07f5$export$2e2bcd8739ae039);



var $itJr1 = parcelRequire("itJr1");

var $9nXgc = parcelRequire("9nXgc");
function $13e2cd5c13b2d6dc$export$837848f5f6cee923(slot) {
    return (0, $9nXgc.default)("MuiTooltip", slot);
}
const $13e2cd5c13b2d6dc$var$tooltipClasses = (0, $itJr1.default)("MuiTooltip", [
    "popper",
    "popperInteractive",
    "popperArrow",
    "popperClose",
    "tooltip",
    "tooltipArrow",
    "touch",
    "tooltipPlacementLeft",
    "tooltipPlacementRight",
    "tooltipPlacementTop",
    "tooltipPlacementBottom",
    "arrow"
]);
var $13e2cd5c13b2d6dc$export$2e2bcd8739ae039 = $13e2cd5c13b2d6dc$var$tooltipClasses;



var $cVgDf = parcelRequire("cVgDf");
const $b679af97cafc2a91$var$_excluded = [
    "arrow",
    "children",
    "classes",
    "components",
    "componentsProps",
    "describeChild",
    "disableFocusListener",
    "disableHoverListener",
    "disableInteractive",
    "disableTouchListener",
    "enterDelay",
    "enterNextDelay",
    "enterTouchDelay",
    "followCursor",
    "id",
    "leaveDelay",
    "leaveTouchDelay",
    "onClose",
    "onOpen",
    "open",
    "placement",
    "PopperComponent",
    "PopperProps",
    "slotProps",
    "slots",
    "title",
    "TransitionComponent",
    "TransitionProps"
];
function $b679af97cafc2a91$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $b679af97cafc2a91$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , disableInteractive: disableInteractive , arrow: arrow , touch: touch , placement: placement  } = ownerState;
    const slots = {
        popper: [
            "popper",
            !disableInteractive && "popperInteractive",
            arrow && "popperArrow"
        ],
        tooltip: [
            "tooltip",
            arrow && "tooltipArrow",
            touch && "touch",
            `tooltipPlacement${(0, $82mcY.default)(placement.split("-")[0])}`
        ],
        arrow: [
            "arrow"
        ]
    };
    return (0, $9H0b9.default)(slots, (0, $13e2cd5c13b2d6dc$export$837848f5f6cee923), classes);
};
const $b679af97cafc2a91$var$TooltipPopper = (0, $gIzLq.default)((0, $0ff8345440fbfe60$export$2e2bcd8739ae039), {
    name: "MuiTooltip",
    slot: "Popper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})(({ theme: theme , ownerState: ownerState , open: open  })=>(0, $63nUy.default)({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: "none"
    }, !ownerState.disableInteractive && {
        pointerEvents: "auto"
    }, !open && {
        pointerEvents: "none"
    }, ownerState.arrow && {
        [`&[data-popper-placement*="bottom"] .${(0, $13e2cd5c13b2d6dc$export$2e2bcd8739ae039).arrow}`]: {
            top: 0,
            marginTop: "-0.71em",
            "&::before": {
                transformOrigin: "0 100%"
            }
        },
        [`&[data-popper-placement*="top"] .${(0, $13e2cd5c13b2d6dc$export$2e2bcd8739ae039).arrow}`]: {
            bottom: 0,
            marginBottom: "-0.71em",
            "&::before": {
                transformOrigin: "100% 0"
            }
        },
        [`&[data-popper-placement*="right"] .${(0, $13e2cd5c13b2d6dc$export$2e2bcd8739ae039).arrow}`]: (0, $63nUy.default)({}, !ownerState.isRtl ? {
            left: 0,
            marginLeft: "-0.71em"
        } : {
            right: 0,
            marginRight: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "100% 100%"
            }
        }),
        [`&[data-popper-placement*="left"] .${(0, $13e2cd5c13b2d6dc$export$2e2bcd8739ae039).arrow}`]: (0, $63nUy.default)({}, !ownerState.isRtl ? {
            right: 0,
            marginRight: "-0.71em"
        } : {
            left: 0,
            marginLeft: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "0 0"
            }
        })
    }));
const $b679af97cafc2a91$var$TooltipTooltip = (0, $gIzLq.default)("div", {
    name: "MuiTooltip",
    slot: "Tooltip",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $82mcY.default)(ownerState.placement.split("-")[0])}`]
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>(0, $63nUy.default)({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $b8tOr.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: "4px 8px",
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: "break-word",
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.arrow && {
        position: "relative",
        margin: 0
    }, ownerState.touch && {
        padding: "8px 16px",
        fontSize: theme.typography.pxToRem(14),
        lineHeight: `${$b679af97cafc2a91$var$round(16 / 14)}em`,
        fontWeight: theme.typography.fontWeightRegular
    }, {
        [`.${(0, $13e2cd5c13b2d6dc$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: (0, $63nUy.default)({
            transformOrigin: "right center"
        }, !ownerState.isRtl ? (0, $63nUy.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        }) : (0, $63nUy.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        })),
        [`.${(0, $13e2cd5c13b2d6dc$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: (0, $63nUy.default)({
            transformOrigin: "left center"
        }, !ownerState.isRtl ? (0, $63nUy.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        }) : (0, $63nUy.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        })),
        [`.${(0, $13e2cd5c13b2d6dc$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: (0, $63nUy.default)({
            transformOrigin: "center bottom",
            marginBottom: "14px"
        }, ownerState.touch && {
            marginBottom: "24px"
        }),
        [`.${(0, $13e2cd5c13b2d6dc$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: (0, $63nUy.default)({
            transformOrigin: "center top",
            marginTop: "14px"
        }, ownerState.touch && {
            marginTop: "24px"
        })
    }));
const $b679af97cafc2a91$var$TooltipArrow = (0, $gIzLq.default)("span", {
    name: "MuiTooltip",
    slot: "Arrow",
    overridesResolver: (props, styles)=>styles.arrow
})(({ theme: theme  })=>({
        overflow: "hidden",
        position: "absolute",
        width: "1em",
        height: "0.71em" /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: "border-box",
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $b8tOr.alpha)(theme.palette.grey[700], 0.9),
        "&::before": {
            content: '""',
            margin: "auto",
            display: "block",
            width: "100%",
            height: "100%",
            backgroundColor: "currentColor",
            transform: "rotate(45deg)"
        }
    }));
let $b679af97cafc2a91$var$hystersisOpen = false;
let $b679af97cafc2a91$var$hystersisTimer = null;
let $b679af97cafc2a91$var$cursorPosition = {
    x: 0,
    y: 0
};
function $b679af97cafc2a91$export$b9ee5a7ace0541f8() {
    $b679af97cafc2a91$var$hystersisOpen = false;
    clearTimeout($b679af97cafc2a91$var$hystersisTimer);
}
function $b679af97cafc2a91$var$composeEventHandler(handler, eventHandler) {
    return (event)=>{
        if (eventHandler) eventHandler(event);
        handler(event);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $b679af97cafc2a91$var$Tooltip = /*#__PURE__*/ $1bdO8.forwardRef(function Tooltip(inProps, ref) {
    var _ref, _slots$popper, _ref2, _ref3, _slots$transition, _ref4, _slots$tooltip, _ref5, _slots$arrow, _slotProps$popper, _ref6, _slotProps$popper2, _slotProps$transition, _slotProps$tooltip, _ref7, _slotProps$tooltip2, _slotProps$arrow, _ref8, _slotProps$arrow2;
    const props = (0, $dHuM2.default)({
        props: inProps,
        name: "MuiTooltip"
    });
    const { arrow: arrow = false , children: children , components: components = {} , componentsProps: componentsProps = {} , describeChild: describeChild = false , disableFocusListener: disableFocusListener = false , disableHoverListener: disableHoverListener = false , disableInteractive: disableInteractiveProp = false , disableTouchListener: disableTouchListener = false , enterDelay: enterDelay = 100 , enterNextDelay: enterNextDelay = 0 , enterTouchDelay: enterTouchDelay = 700 , followCursor: followCursor = false , id: idProp , leaveDelay: leaveDelay = 0 , leaveTouchDelay: leaveTouchDelay = 1500 , onClose: onClose , onOpen: onOpen , open: openProp , placement: placement = "bottom" , PopperComponent: PopperComponentProp , PopperProps: PopperProps = {} , slotProps: slotProps = {} , slots: slots = {} , title: title , TransitionComponent: TransitionComponentProp = (0, $5f3be16a76f1a341$export$2e2bcd8739ae039) , TransitionProps: TransitionProps  } = props, other = (0, $fZ2DJ.default)(props, $b679af97cafc2a91$var$_excluded);
    const theme = (0, $e8c20c93268b1fae$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === "rtl";
    const [childNode, setChildNode] = $1bdO8.useState();
    const [arrowRef, setArrowRef] = $1bdO8.useState(null);
    const ignoreNonTouchEvents = $1bdO8.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = $1bdO8.useRef();
    const enterTimer = $1bdO8.useRef();
    const leaveTimer = $1bdO8.useRef();
    const touchTimer = $1bdO8.useRef();
    const [openState, setOpenState] = (0, $e5534e08f650a1ea$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: "Tooltip",
        state: "open"
    });
    let open = openState;
    const id = (0, $76b9da61cda9919c$export$2e2bcd8739ae039)(idProp);
    const prevUserSelect = $1bdO8.useRef();
    const stopTouchInteraction = $1bdO8.useCallback(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        clearTimeout(touchTimer.current);
    }, []);
    $1bdO8.useEffect(()=>{
        return ()=>{
            clearTimeout(closeTimer.current);
            clearTimeout(enterTimer.current);
            clearTimeout(leaveTimer.current);
            stopTouchInteraction();
        };
    }, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        clearTimeout($b679af97cafc2a91$var$hystersisTimer);
        $b679af97cafc2a91$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $4488f30dc60272e5$export$2e2bcd8739ae039)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        clearTimeout($b679af97cafc2a91$var$hystersisTimer);
        $b679af97cafc2a91$var$hystersisTimer = setTimeout(()=>{
            $b679af97cafc2a91$var$hystersisOpen = false;
        }, 800 + leaveDelay);
        setOpenState(false);
        if (onClose && open) onClose(event);
        clearTimeout(closeTimer.current);
        closeTimer.current = setTimeout(()=>{
            ignoreNonTouchEvents.current = false;
        }, theme.transitions.duration.shortest);
    });
    const handleEnter = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== "touchstart") return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute("title");
        clearTimeout(enterTimer.current);
        clearTimeout(leaveTimer.current);
        if (enterDelay || $b679af97cafc2a91$var$hystersisOpen && enterNextDelay) enterTimer.current = setTimeout(()=>{
            handleOpen(event);
        }, $b679af97cafc2a91$var$hystersisOpen ? enterNextDelay : enterDelay);
        else handleOpen(event);
    };
    const handleLeave = (event)=>{
        clearTimeout(enterTimer.current);
        clearTimeout(leaveTimer.current);
        leaveTimer.current = setTimeout(()=>{
            handleClose(event);
        }, leaveDelay);
    };
    const { isFocusVisibleRef: isFocusVisibleRef , onBlur: handleBlurVisible , onFocus: handleFocusVisible , ref: focusVisibleRef  } = (0, $246fdd8b2b400d4f$export$2e2bcd8739ae039)();
    // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
    // We just need to re-render the Tooltip if the focus-visible state changes.
    const [, setChildIsFocusVisible] = $1bdO8.useState(false);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setChildIsFocusVisible(false);
            handleLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setChildIsFocusVisible(true);
            handleEnter(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleMouseOver = handleEnter;
    const handleMouseLeave = handleLeave;
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        clearTimeout(leaveTimer.current);
        clearTimeout(closeTimer.current);
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = "none";
        touchTimer.current = setTimeout(()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleEnter(event);
        }, enterTouchDelay);
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        clearTimeout(leaveTimer.current);
        leaveTimer.current = setTimeout(()=>{
            handleClose(event);
        }, leaveTouchDelay);
    };
    $1bdO8.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === "Escape" || nativeEvent.key === "Esc") handleClose(nativeEvent);
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $428a291d5bcff83c$export$2e2bcd8739ae039)(children.ref, focusVisibleRef, setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    if (!title && title !== 0) open = false;
    const popperRef = $1bdO8.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $b679af97cafc2a91$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === "string";
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps["aria-describedby"] = open ? id : null;
    } else {
        nameOrDescProps["aria-label"] = titleIsString ? title : null;
        nameOrDescProps["aria-labelledby"] = open && !titleIsString ? id : null;
    }
    const childrenProps = (0, $63nUy.default)({}, nameOrDescProps, other, children.props, {
        className: (0, $gJjS7.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    }, followCursor ? {
        onMouseMove: handleMouseMove
    } : {});
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $b679af97cafc2a91$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $b679af97cafc2a91$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $b679af97cafc2a91$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $b679af97cafc2a91$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const popperOptions = $1bdO8.useMemo(()=>{
        var _PopperProps$popperOp;
        let tooltipModifiers = [
            {
                name: "arrow",
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        return (0, $63nUy.default)({}, PopperProps.popperOptions, {
            modifiers: tooltipModifiers
        });
    }, [
        arrowRef,
        PopperProps
    ]);
    const ownerState = (0, $63nUy.default)({}, props, {
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    });
    const classes = $b679af97cafc2a91$var$useUtilityClasses(ownerState);
    const PopperComponent = (_ref = (_slots$popper = slots.popper) != null ? _slots$popper : components.Popper) != null ? _ref : $b679af97cafc2a91$var$TooltipPopper;
    const TransitionComponent = (_ref2 = (_ref3 = (_slots$transition = slots.transition) != null ? _slots$transition : components.Transition) != null ? _ref3 : TransitionComponentProp) != null ? _ref2 : (0, $5f3be16a76f1a341$export$2e2bcd8739ae039);
    const TooltipComponent = (_ref4 = (_slots$tooltip = slots.tooltip) != null ? _slots$tooltip : components.Tooltip) != null ? _ref4 : $b679af97cafc2a91$var$TooltipTooltip;
    const ArrowComponent = (_ref5 = (_slots$arrow = slots.arrow) != null ? _slots$arrow : components.Arrow) != null ? _ref5 : $b679af97cafc2a91$var$TooltipArrow;
    const popperProps = (0, $d61875c6f8fa8dbb$export$2e2bcd8739ae039)(PopperComponent, (0, $63nUy.default)({}, PopperProps, (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper, {
        className: (0, $gJjS7.default)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_ref6 = (_slotProps$popper2 = slotProps.popper) != null ? _slotProps$popper2 : componentsProps.popper) == null ? void 0 : _ref6.className)
    }), ownerState);
    const transitionProps = (0, $d61875c6f8fa8dbb$export$2e2bcd8739ae039)(TransitionComponent, (0, $63nUy.default)({}, TransitionProps, (_slotProps$transition = slotProps.transition) != null ? _slotProps$transition : componentsProps.transition), ownerState);
    const tooltipProps = (0, $d61875c6f8fa8dbb$export$2e2bcd8739ae039)(TooltipComponent, (0, $63nUy.default)({}, (_slotProps$tooltip = slotProps.tooltip) != null ? _slotProps$tooltip : componentsProps.tooltip, {
        className: (0, $gJjS7.default)(classes.tooltip, (_ref7 = (_slotProps$tooltip2 = slotProps.tooltip) != null ? _slotProps$tooltip2 : componentsProps.tooltip) == null ? void 0 : _ref7.className)
    }), ownerState);
    const tooltipArrowProps = (0, $d61875c6f8fa8dbb$export$2e2bcd8739ae039)(ArrowComponent, (0, $63nUy.default)({}, (_slotProps$arrow = slotProps.arrow) != null ? _slotProps$arrow : componentsProps.arrow, {
        className: (0, $gJjS7.default)(classes.arrow, (_ref8 = (_slotProps$arrow2 = slotProps.arrow) != null ? _slotProps$arrow2 : componentsProps.arrow) == null ? void 0 : _ref8.className)
    }), ownerState);
    return /*#__PURE__*/ (0, $cVgDf.jsxs)($1bdO8.Fragment, {
        children: [
            /*#__PURE__*/ $1bdO8.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $cVgDf.jsx)(PopperComponent, (0, $63nUy.default)({
                as: PopperComponentProp != null ? PopperComponentProp : (0, $0ff8345440fbfe60$export$2e2bcd8739ae039),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $b679af97cafc2a91$var$cursorPosition.y,
                            left: $b679af97cafc2a91$var$cursorPosition.x,
                            right: $b679af97cafc2a91$var$cursorPosition.x,
                            bottom: $b679af97cafc2a91$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true
            }, interactiveWrapperListeners, popperProps, {
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner  })=>/*#__PURE__*/ (0, $cVgDf.jsx)(TransitionComponent, (0, $63nUy.default)({
                        timeout: theme.transitions.duration.shorter
                    }, TransitionPropsInner, transitionProps, {
                        children: /*#__PURE__*/ (0, $cVgDf.jsxs)(TooltipComponent, (0, $63nUy.default)({}, tooltipProps, {
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $cVgDf.jsx)(ArrowComponent, (0, $63nUy.default)({}, tooltipArrowProps, {
                                    ref: setArrowRef
                                })) : null
                            ]
                        }))
                    }))
            }))
        ]
    });
});
var $b679af97cafc2a91$export$2e2bcd8739ae039 = $b679af97cafc2a91$var$Tooltip;


var $fZ2DJ = parcelRequire("fZ2DJ");

var $63nUy = parcelRequire("63nUy");

var $1bdO8 = parcelRequire("1bdO8");


var $gJjS7 = parcelRequire("gJjS7");


var $9H0b9 = parcelRequire("9H0b9");

var $gIzLq = parcelRequire("gIzLq");

var $dHuM2 = parcelRequire("dHuM2");

var $82mcY = parcelRequire("82mcY");

var $itJr1 = parcelRequire("itJr1");

var $9nXgc = parcelRequire("9nXgc");
function $77b02f96ac3f7a85$export$24c1f8f60cbac79e(slot) {
    return (0, $9nXgc.default)("MuiTypography", slot);
}
const $77b02f96ac3f7a85$var$typographyClasses = (0, $itJr1.default)("MuiTypography", [
    "root",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "subtitle1",
    "subtitle2",
    "body1",
    "body2",
    "inherit",
    "button",
    "caption",
    "overline",
    "alignLeft",
    "alignRight",
    "alignCenter",
    "alignJustify",
    "noWrap",
    "gutterBottom",
    "paragraph"
]);
var $77b02f96ac3f7a85$export$2e2bcd8739ae039 = $77b02f96ac3f7a85$var$typographyClasses;



var $cVgDf = parcelRequire("cVgDf");
const $15020dfde881caab$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $15020dfde881caab$var$useUtilityClasses = (ownerState)=>{
    const { align: align , gutterBottom: gutterBottom , noWrap: noWrap , paragraph: paragraph , variant: variant , classes: classes  } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            ownerState.align !== "inherit" && `align${(0, $82mcY.default)(align)}`,
            gutterBottom && "gutterBottom",
            noWrap && "noWrap",
            paragraph && "paragraph"
        ]
    };
    return (0, $9H0b9.default)(slots, (0, $77b02f96ac3f7a85$export$24c1f8f60cbac79e), classes);
};
const $15020dfde881caab$export$140e2f5526d3cad8 = (0, $gIzLq.default)("span", {
    name: "MuiTypography",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== "inherit" && styles[`align${(0, $82mcY.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>(0, $63nUy.default)({
        margin: 0
    }, ownerState.variant && theme.typography[ownerState.variant], ownerState.align !== "inherit" && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, ownerState.gutterBottom && {
        marginBottom: "0.35em"
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $15020dfde881caab$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p",
    inherit: "p"
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $15020dfde881caab$var$colorTransformations = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $15020dfde881caab$var$transformDeprecatedColors = (color)=>{
    return $15020dfde881caab$var$colorTransformations[color] || color;
};
const $15020dfde881caab$var$Typography = /*#__PURE__*/ $1bdO8.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $dHuM2.default)({
        props: inProps,
        name: "MuiTypography"
    });
    const color = $15020dfde881caab$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $9ffbb66e3e984d75$export$2e2bcd8739ae039)((0, $63nUy.default)({}, themeProps, {
        color: color
    }));
    const { align: align = "inherit" , className: className , component: component , gutterBottom: gutterBottom = false , noWrap: noWrap = false , paragraph: paragraph = false , variant: variant = "body1" , variantMapping: variantMapping = $15020dfde881caab$var$defaultVariantMapping  } = props, other = (0, $fZ2DJ.default)(props, $15020dfde881caab$var$_excluded);
    const ownerState = (0, $63nUy.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? "p" : variantMapping[variant] || $15020dfde881caab$var$defaultVariantMapping[variant]) || "span";
    const classes = $15020dfde881caab$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $cVgDf.jsx)($15020dfde881caab$export$140e2f5526d3cad8, (0, $63nUy.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $gJjS7.default)(classes.root, className)
    }, other));
});
var $15020dfde881caab$export$2e2bcd8739ae039 = $15020dfde881caab$var$Typography;



var $8oBBS = parcelRequire("8oBBS");
var $ca0ed0868e4d0815$exports = {};
"use strict";
var $5a7eb3d2ea9cca20$exports = {};
"use strict";
var $5a7eb3d2ea9cca20$var$createStoreImpl = function createStoreImpl(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            var _previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object") ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var subscribe = function subscribe(listener) {
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        subscribe: subscribe,
        destroy: destroy
    };
    state = createState(setState, getState, api);
    return api;
};
var $5a7eb3d2ea9cca20$var$createStore = function createStore(createState) {
    return createState ? $5a7eb3d2ea9cca20$var$createStoreImpl(createState) : $5a7eb3d2ea9cca20$var$createStoreImpl;
};
var $5a7eb3d2ea9cca20$var$vanilla = function(createState) {
    return $5a7eb3d2ea9cca20$var$createStore(createState);
};
$5a7eb3d2ea9cca20$exports.createStore = $5a7eb3d2ea9cca20$var$createStore;
$5a7eb3d2ea9cca20$exports.default = $5a7eb3d2ea9cca20$var$vanilla;
$5a7eb3d2ea9cca20$exports = $5a7eb3d2ea9cca20$var$vanilla;
$5a7eb3d2ea9cca20$exports.createStore = $5a7eb3d2ea9cca20$var$createStore;
$5a7eb3d2ea9cca20$exports.default = $5a7eb3d2ea9cca20$exports;



var $1bdO8 = parcelRequire("1bdO8");
var $a54cab85374ae1bd$exports = {};
"use strict";

$a54cab85374ae1bd$exports = (parcelRequire("e6nxJ"));


var $ca0ed0868e4d0815$var$useSyncExternalStoreWithSelector = $a54cab85374ae1bd$exports.useSyncExternalStoreWithSelector;
function $ca0ed0868e4d0815$var$useStore(api, selector, equalityFn) {
    if (selector === void 0) selector = api.getState;
    var slice = $ca0ed0868e4d0815$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getState, selector, equalityFn);
    $1bdO8.useDebugValue(slice);
    return slice;
}
var $ca0ed0868e4d0815$var$createImpl = function createImpl(createState) {
    var api = typeof createState === "function" ? $5a7eb3d2ea9cca20$exports.createStore(createState) : createState;
    var useBoundStore = function useBoundStore(selector, equalityFn) {
        return $ca0ed0868e4d0815$var$useStore(api, selector, equalityFn);
    };
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
var $ca0ed0868e4d0815$var$create = function create(createState) {
    return createState ? $ca0ed0868e4d0815$var$createImpl(createState) : $ca0ed0868e4d0815$var$createImpl;
};
var $ca0ed0868e4d0815$var$react = function(createState) {
    return $ca0ed0868e4d0815$var$create(createState);
};
$ca0ed0868e4d0815$exports.create = $ca0ed0868e4d0815$var$create;
$ca0ed0868e4d0815$exports.default = $ca0ed0868e4d0815$var$react;
$ca0ed0868e4d0815$exports.useStore = $ca0ed0868e4d0815$var$useStore;
Object.keys($5a7eb3d2ea9cca20$exports).forEach(function(k) {
    if (k !== "default" && !$ca0ed0868e4d0815$exports.hasOwnProperty(k)) Object.defineProperty($ca0ed0868e4d0815$exports, k, {
        enumerable: true,
        get: function() {
            return $5a7eb3d2ea9cca20$exports[k];
        }
    });
});
$ca0ed0868e4d0815$exports = $ca0ed0868e4d0815$var$react;
$ca0ed0868e4d0815$exports.create = $ca0ed0868e4d0815$var$create;
$ca0ed0868e4d0815$exports.useStore = $ca0ed0868e4d0815$var$useStore;
$ca0ed0868e4d0815$exports.createStore = $5a7eb3d2ea9cca20$exports.createStore;
$ca0ed0868e4d0815$exports.default = $ca0ed0868e4d0815$exports;


const $91a6458dd589bbd0$export$4b4c417a6113a34c = (0, $ca0ed0868e4d0815$exports.create)((set)=>({
        selectedIds: [],
        setSelectedIds: (ids)=>set({
                selectedIds: ids
            }),
        addSelectedIds: (ids)=>set((state)=>({
                    selectedIds: (0, (/*@__PURE__*/$parcel$interopDefault($8oBBS))).uniq([
                        ...state.selectedIds,
                        ...ids
                    ])
                })),
        removeSelectedIds: (ids)=>set((state)=>({
                    selectedIds: (0, (/*@__PURE__*/$parcel$interopDefault($8oBBS))).difference(state.selectedIds, ids)
                })),
        clearSelection: ()=>{
            set({
                selectedIds: []
            });
            set({
                highlightIds: []
            });
            set({
                searchText: ""
            });
        },
        highlightIds: [],
        setHighlightIds: (ids)=>set({
                highlightIds: ids
            }),
        clearHighlight: ()=>set({
                highlightIds: []
            }),
        searchText: "",
        setSearchText: (text)=>set({
                searchText: text
            })
    }));



var $e8ea6a63d48a4fea$exports = {};

$parcel$export($e8ea6a63d48a4fea$exports, "REVISION", () => $e8ea6a63d48a4fea$export$3545e07a80636437);
$parcel$export($e8ea6a63d48a4fea$exports, "MOUSE", () => $e8ea6a63d48a4fea$export$7177b3e430c2d7ca);
$parcel$export($e8ea6a63d48a4fea$exports, "TOUCH", () => $e8ea6a63d48a4fea$export$d46bd3ead7cc759b);
$parcel$export($e8ea6a63d48a4fea$exports, "CullFaceNone", () => $e8ea6a63d48a4fea$export$3237e1f2c1ea1f44);
$parcel$export($e8ea6a63d48a4fea$exports, "CullFaceBack", () => $e8ea6a63d48a4fea$export$b9a7b4fc5cb15f9b);
$parcel$export($e8ea6a63d48a4fea$exports, "CullFaceFront", () => $e8ea6a63d48a4fea$export$b8058bcc7037d3f3);
$parcel$export($e8ea6a63d48a4fea$exports, "CullFaceFrontBack", () => $e8ea6a63d48a4fea$export$f24be24dcddeac0d);
$parcel$export($e8ea6a63d48a4fea$exports, "BasicShadowMap", () => $e8ea6a63d48a4fea$export$346307dbae2b7447);
$parcel$export($e8ea6a63d48a4fea$exports, "PCFShadowMap", () => $e8ea6a63d48a4fea$export$5813f879eee7cd88);
$parcel$export($e8ea6a63d48a4fea$exports, "PCFSoftShadowMap", () => $e8ea6a63d48a4fea$export$a47c4b43a1be34f0);
$parcel$export($e8ea6a63d48a4fea$exports, "VSMShadowMap", () => $e8ea6a63d48a4fea$export$896ae1ade6c829c4);
$parcel$export($e8ea6a63d48a4fea$exports, "FrontSide", () => $e8ea6a63d48a4fea$export$2ede184fc2998901);
$parcel$export($e8ea6a63d48a4fea$exports, "BackSide", () => $e8ea6a63d48a4fea$export$d9f0486e75b5ace);
$parcel$export($e8ea6a63d48a4fea$exports, "DoubleSide", () => $e8ea6a63d48a4fea$export$3b296b6f144d5b03);
$parcel$export($e8ea6a63d48a4fea$exports, "TwoPassDoubleSide", () => $e8ea6a63d48a4fea$export$211211c00f97204d);
$parcel$export($e8ea6a63d48a4fea$exports, "NoBlending", () => $e8ea6a63d48a4fea$export$63b8d6b580fc65ba);
$parcel$export($e8ea6a63d48a4fea$exports, "NormalBlending", () => $e8ea6a63d48a4fea$export$5b29a26d96ee6af0);
$parcel$export($e8ea6a63d48a4fea$exports, "AdditiveBlending", () => $e8ea6a63d48a4fea$export$777d8f9551c2216b);
$parcel$export($e8ea6a63d48a4fea$exports, "SubtractiveBlending", () => $e8ea6a63d48a4fea$export$cdfa06f868e2e467);
$parcel$export($e8ea6a63d48a4fea$exports, "MultiplyBlending", () => $e8ea6a63d48a4fea$export$4138e1c684b46a20);
$parcel$export($e8ea6a63d48a4fea$exports, "CustomBlending", () => $e8ea6a63d48a4fea$export$eda4864c68df1fa2);
$parcel$export($e8ea6a63d48a4fea$exports, "AddEquation", () => $e8ea6a63d48a4fea$export$20183a0484ce21a0);
$parcel$export($e8ea6a63d48a4fea$exports, "SubtractEquation", () => $e8ea6a63d48a4fea$export$73e0df5177988548);
$parcel$export($e8ea6a63d48a4fea$exports, "ReverseSubtractEquation", () => $e8ea6a63d48a4fea$export$28e582859cbec660);
$parcel$export($e8ea6a63d48a4fea$exports, "MinEquation", () => $e8ea6a63d48a4fea$export$c8c1508da8d0600c);
$parcel$export($e8ea6a63d48a4fea$exports, "MaxEquation", () => $e8ea6a63d48a4fea$export$99948c02fb51055f);
$parcel$export($e8ea6a63d48a4fea$exports, "ZeroFactor", () => $e8ea6a63d48a4fea$export$2110f05edf778d3d);
$parcel$export($e8ea6a63d48a4fea$exports, "OneFactor", () => $e8ea6a63d48a4fea$export$8805bad65e24940e);
$parcel$export($e8ea6a63d48a4fea$exports, "SrcColorFactor", () => $e8ea6a63d48a4fea$export$7fbe15b28d28cf52);
$parcel$export($e8ea6a63d48a4fea$exports, "OneMinusSrcColorFactor", () => $e8ea6a63d48a4fea$export$947829af9f2c17f6);
$parcel$export($e8ea6a63d48a4fea$exports, "SrcAlphaFactor", () => $e8ea6a63d48a4fea$export$d5773124e86cf28c);
$parcel$export($e8ea6a63d48a4fea$exports, "OneMinusSrcAlphaFactor", () => $e8ea6a63d48a4fea$export$11d468cc7f19e971);
$parcel$export($e8ea6a63d48a4fea$exports, "DstAlphaFactor", () => $e8ea6a63d48a4fea$export$a78aed1ca2a87192);
$parcel$export($e8ea6a63d48a4fea$exports, "OneMinusDstAlphaFactor", () => $e8ea6a63d48a4fea$export$5d0fe17fd8773bac);
$parcel$export($e8ea6a63d48a4fea$exports, "DstColorFactor", () => $e8ea6a63d48a4fea$export$ef5f2dd8ffac5574);
$parcel$export($e8ea6a63d48a4fea$exports, "OneMinusDstColorFactor", () => $e8ea6a63d48a4fea$export$56b85b2686ab16);
$parcel$export($e8ea6a63d48a4fea$exports, "SrcAlphaSaturateFactor", () => $e8ea6a63d48a4fea$export$c05e2a1fc8609506);
$parcel$export($e8ea6a63d48a4fea$exports, "NeverDepth", () => $e8ea6a63d48a4fea$export$69025ce147cee220);
$parcel$export($e8ea6a63d48a4fea$exports, "AlwaysDepth", () => $e8ea6a63d48a4fea$export$7182eb52ea3b3f04);
$parcel$export($e8ea6a63d48a4fea$exports, "LessDepth", () => $e8ea6a63d48a4fea$export$eedccec66ab7ebe);
$parcel$export($e8ea6a63d48a4fea$exports, "LessEqualDepth", () => $e8ea6a63d48a4fea$export$296f78a0b892f81a);
$parcel$export($e8ea6a63d48a4fea$exports, "EqualDepth", () => $e8ea6a63d48a4fea$export$a60d398fc7b7590e);
$parcel$export($e8ea6a63d48a4fea$exports, "GreaterEqualDepth", () => $e8ea6a63d48a4fea$export$7d7234c1240a1fc4);
$parcel$export($e8ea6a63d48a4fea$exports, "GreaterDepth", () => $e8ea6a63d48a4fea$export$c5e2c52991f30937);
$parcel$export($e8ea6a63d48a4fea$exports, "NotEqualDepth", () => $e8ea6a63d48a4fea$export$2f843afa843d8916);
$parcel$export($e8ea6a63d48a4fea$exports, "MultiplyOperation", () => $e8ea6a63d48a4fea$export$e50ac29801f1774d);
$parcel$export($e8ea6a63d48a4fea$exports, "MixOperation", () => $e8ea6a63d48a4fea$export$9f9d94f963c85479);
$parcel$export($e8ea6a63d48a4fea$exports, "AddOperation", () => $e8ea6a63d48a4fea$export$e641dc52bc3494aa);
$parcel$export($e8ea6a63d48a4fea$exports, "NoToneMapping", () => $e8ea6a63d48a4fea$export$9fcb6b4294603b2);
$parcel$export($e8ea6a63d48a4fea$exports, "LinearToneMapping", () => $e8ea6a63d48a4fea$export$98f52c2a46c598ca);
$parcel$export($e8ea6a63d48a4fea$exports, "ReinhardToneMapping", () => $e8ea6a63d48a4fea$export$74b25e54b3bcd548);
$parcel$export($e8ea6a63d48a4fea$exports, "CineonToneMapping", () => $e8ea6a63d48a4fea$export$932b3dd283d4a366);
$parcel$export($e8ea6a63d48a4fea$exports, "ACESFilmicToneMapping", () => $e8ea6a63d48a4fea$export$a0d98fe6d7e4af64);
$parcel$export($e8ea6a63d48a4fea$exports, "CustomToneMapping", () => $e8ea6a63d48a4fea$export$2c7b09c1e9abfb5e);
$parcel$export($e8ea6a63d48a4fea$exports, "UVMapping", () => $e8ea6a63d48a4fea$export$1beec6768cbb3d2d);
$parcel$export($e8ea6a63d48a4fea$exports, "CubeReflectionMapping", () => $e8ea6a63d48a4fea$export$8759762a6477f2c4);
$parcel$export($e8ea6a63d48a4fea$exports, "CubeRefractionMapping", () => $e8ea6a63d48a4fea$export$dc59f8aed047f61d);
$parcel$export($e8ea6a63d48a4fea$exports, "EquirectangularReflectionMapping", () => $e8ea6a63d48a4fea$export$d64030b316d3b087);
$parcel$export($e8ea6a63d48a4fea$exports, "EquirectangularRefractionMapping", () => $e8ea6a63d48a4fea$export$ee99d97d46898098);
$parcel$export($e8ea6a63d48a4fea$exports, "CubeUVReflectionMapping", () => $e8ea6a63d48a4fea$export$dbf3e70ff37af79);
$parcel$export($e8ea6a63d48a4fea$exports, "RepeatWrapping", () => $e8ea6a63d48a4fea$export$533346c8e8dac0f5);
$parcel$export($e8ea6a63d48a4fea$exports, "ClampToEdgeWrapping", () => $e8ea6a63d48a4fea$export$9d9334239a5a5e06);
$parcel$export($e8ea6a63d48a4fea$exports, "MirroredRepeatWrapping", () => $e8ea6a63d48a4fea$export$c7e7c00b14f51a4f);
$parcel$export($e8ea6a63d48a4fea$exports, "NearestFilter", () => $e8ea6a63d48a4fea$export$727aa5ec3fe39bf0);
$parcel$export($e8ea6a63d48a4fea$exports, "NearestMipmapNearestFilter", () => $e8ea6a63d48a4fea$export$d129e38cf6feaa8c);
$parcel$export($e8ea6a63d48a4fea$exports, "NearestMipMapNearestFilter", () => $e8ea6a63d48a4fea$export$14a4936464a36496);
$parcel$export($e8ea6a63d48a4fea$exports, "NearestMipmapLinearFilter", () => $e8ea6a63d48a4fea$export$d2327c1afe5bfdf2);
$parcel$export($e8ea6a63d48a4fea$exports, "NearestMipMapLinearFilter", () => $e8ea6a63d48a4fea$export$cbc5b7f5647595d8);
$parcel$export($e8ea6a63d48a4fea$exports, "LinearFilter", () => $e8ea6a63d48a4fea$export$8a72f490b25c56c8);
$parcel$export($e8ea6a63d48a4fea$exports, "LinearMipmapNearestFilter", () => $e8ea6a63d48a4fea$export$19a719f377145a13);
$parcel$export($e8ea6a63d48a4fea$exports, "LinearMipMapNearestFilter", () => $e8ea6a63d48a4fea$export$dbe96bee3fe9dbf0);
$parcel$export($e8ea6a63d48a4fea$exports, "LinearMipmapLinearFilter", () => $e8ea6a63d48a4fea$export$5d8599b6a933fb1b);
$parcel$export($e8ea6a63d48a4fea$exports, "LinearMipMapLinearFilter", () => $e8ea6a63d48a4fea$export$90d80f1e3506775f);
$parcel$export($e8ea6a63d48a4fea$exports, "UnsignedByteType", () => $e8ea6a63d48a4fea$export$2e8ce08d3f6f5e10);
$parcel$export($e8ea6a63d48a4fea$exports, "ByteType", () => $e8ea6a63d48a4fea$export$545fce0311a9796a);
$parcel$export($e8ea6a63d48a4fea$exports, "ShortType", () => $e8ea6a63d48a4fea$export$88572337f312435f);
$parcel$export($e8ea6a63d48a4fea$exports, "UnsignedShortType", () => $e8ea6a63d48a4fea$export$c63dc51868b06a9d);
$parcel$export($e8ea6a63d48a4fea$exports, "IntType", () => $e8ea6a63d48a4fea$export$5c612977753abe2);
$parcel$export($e8ea6a63d48a4fea$exports, "UnsignedIntType", () => $e8ea6a63d48a4fea$export$c3c7fc4518ebba96);
$parcel$export($e8ea6a63d48a4fea$exports, "FloatType", () => $e8ea6a63d48a4fea$export$f6d331659b644596);
$parcel$export($e8ea6a63d48a4fea$exports, "HalfFloatType", () => $e8ea6a63d48a4fea$export$2697304443f382bc);
$parcel$export($e8ea6a63d48a4fea$exports, "UnsignedShort4444Type", () => $e8ea6a63d48a4fea$export$b3969b01faf587f2);
$parcel$export($e8ea6a63d48a4fea$exports, "UnsignedShort5551Type", () => $e8ea6a63d48a4fea$export$18886f8ae33e90de);
$parcel$export($e8ea6a63d48a4fea$exports, "UnsignedInt248Type", () => $e8ea6a63d48a4fea$export$6c8ea339bfab1301);
$parcel$export($e8ea6a63d48a4fea$exports, "AlphaFormat", () => $e8ea6a63d48a4fea$export$988473390501ed4b);
$parcel$export($e8ea6a63d48a4fea$exports, "RGBAFormat", () => $e8ea6a63d48a4fea$export$3f8bb04b555a363c);
$parcel$export($e8ea6a63d48a4fea$exports, "LuminanceFormat", () => $e8ea6a63d48a4fea$export$cc09ccbf6d1ed449);
$parcel$export($e8ea6a63d48a4fea$exports, "LuminanceAlphaFormat", () => $e8ea6a63d48a4fea$export$9053a81c4a69c289);
$parcel$export($e8ea6a63d48a4fea$exports, "DepthFormat", () => $e8ea6a63d48a4fea$export$c1b6b5136be58045);
$parcel$export($e8ea6a63d48a4fea$exports, "DepthStencilFormat", () => $e8ea6a63d48a4fea$export$1e113ac2d0905829);
$parcel$export($e8ea6a63d48a4fea$exports, "RedFormat", () => $e8ea6a63d48a4fea$export$4e041a7967d15c4b);
$parcel$export($e8ea6a63d48a4fea$exports, "RedIntegerFormat", () => $e8ea6a63d48a4fea$export$aa92e870a709d190);
$parcel$export($e8ea6a63d48a4fea$exports, "RGFormat", () => $e8ea6a63d48a4fea$export$6cdf0b461c7ce8a0);
$parcel$export($e8ea6a63d48a4fea$exports, "RGIntegerFormat", () => $e8ea6a63d48a4fea$export$1ba1c45f9f77d4d7);
$parcel$export($e8ea6a63d48a4fea$exports, "RGBAIntegerFormat", () => $e8ea6a63d48a4fea$export$c200e7d26f592f21);
$parcel$export($e8ea6a63d48a4fea$exports, "RGB_S3TC_DXT1_Format", () => $e8ea6a63d48a4fea$export$21d1799c6d552fc0);
$parcel$export($e8ea6a63d48a4fea$exports, "RGBA_S3TC_DXT1_Format", () => $e8ea6a63d48a4fea$export$afa304c3e981b668);
$parcel$export($e8ea6a63d48a4fea$exports, "RGBA_S3TC_DXT3_Format", () => $e8ea6a63d48a4fea$export$d2a1a68024a3e56c);
$parcel$export($e8ea6a63d48a4fea$exports, "RGBA_S3TC_DXT5_Format", () => $e8ea6a63d48a4fea$export$9a79c424327dacf9);
$parcel$export($e8ea6a63d48a4fea$exports, "RGB_PVRTC_4BPPV1_Format", () => $e8ea6a63d48a4fea$export$19ada9bbb1af3573);
$parcel$export($e8ea6a63d48a4fea$exports, "RGB_PVRTC_2BPPV1_Format", () => $e8ea6a63d48a4fea$export$d0f0355bb3d948e4);
$parcel$export($e8ea6a63d48a4fea$exports, "RGBA_PVRTC_4BPPV1_Format", () => $e8ea6a63d48a4fea$export$b82296714358084c);
$parcel$export($e8ea6a63d48a4fea$exports, "RGBA_PVRTC_2BPPV1_Format", () => $e8ea6a63d48a4fea$export$b71692456c47b6c3);
$parcel$export($e8ea6a63d48a4fea$exports, "RGB_ETC1_Format", () => $e8ea6a63d48a4fea$export$6ab91af2d757aee7);
$parcel$export($e8ea6a63d48a4fea$exports, "RGB_ETC2_Format", () => $e8ea6a63d48a4fea$export$7800993ef8106a6a);
$parcel$export($e8ea6a63d48a4fea$exports, "RGBA_ETC2_EAC_Format", () => $e8ea6a63d48a4fea$export$23ed8300a860e7d8);
$parcel$export($e8ea6a63d48a4fea$exports, "RGBA_ASTC_4x4_Format", () => $e8ea6a63d48a4fea$export$dc5570b4a2b92d48);
$parcel$export($e8ea6a63d48a4fea$exports, "RGBA_ASTC_5x4_Format", () => $e8ea6a63d48a4fea$export$68880cd325f8b2fb);
$parcel$export($e8ea6a63d48a4fea$exports, "RGBA_ASTC_5x5_Format", () => $e8ea6a63d48a4fea$export$7d2c0be323373d95);
$parcel$export($e8ea6a63d48a4fea$exports, "RGBA_ASTC_6x5_Format", () => $e8ea6a63d48a4fea$export$22b52da301fc3a3e);
$parcel$export($e8ea6a63d48a4fea$exports, "RGBA_ASTC_6x6_Format", () => $e8ea6a63d48a4fea$export$c009e2cb4a66485e);
$parcel$export($e8ea6a63d48a4fea$exports, "RGBA_ASTC_8x5_Format", () => $e8ea6a63d48a4fea$export$118fff5afa255b63);
$parcel$export($e8ea6a63d48a4fea$exports, "RGBA_ASTC_8x6_Format", () => $e8ea6a63d48a4fea$export$120713c829ae0667);
$parcel$export($e8ea6a63d48a4fea$exports, "RGBA_ASTC_8x8_Format", () => $e8ea6a63d48a4fea$export$c79eeabbf53313e9);
$parcel$export($e8ea6a63d48a4fea$exports, "RGBA_ASTC_10x5_Format", () => $e8ea6a63d48a4fea$export$443cf6567cdd6424);
$parcel$export($e8ea6a63d48a4fea$exports, "RGBA_ASTC_10x6_Format", () => $e8ea6a63d48a4fea$export$6573984fc9840780);
$parcel$export($e8ea6a63d48a4fea$exports, "RGBA_ASTC_10x8_Format", () => $e8ea6a63d48a4fea$export$e7aee563f30091de);
$parcel$export($e8ea6a63d48a4fea$exports, "RGBA_ASTC_10x10_Format", () => $e8ea6a63d48a4fea$export$2eb8634622ddeab7);
$parcel$export($e8ea6a63d48a4fea$exports, "RGBA_ASTC_12x10_Format", () => $e8ea6a63d48a4fea$export$202b1ce7b5d25742);
$parcel$export($e8ea6a63d48a4fea$exports, "RGBA_ASTC_12x12_Format", () => $e8ea6a63d48a4fea$export$18ab77abd087e467);
$parcel$export($e8ea6a63d48a4fea$exports, "RGBA_BPTC_Format", () => $e8ea6a63d48a4fea$export$ce40b115e188bc81);
$parcel$export($e8ea6a63d48a4fea$exports, "RED_RGTC1_Format", () => $e8ea6a63d48a4fea$export$b1688df4c4c21670);
$parcel$export($e8ea6a63d48a4fea$exports, "SIGNED_RED_RGTC1_Format", () => $e8ea6a63d48a4fea$export$fc15e5d8261eed58);
$parcel$export($e8ea6a63d48a4fea$exports, "RED_GREEN_RGTC2_Format", () => $e8ea6a63d48a4fea$export$d220f6ade8463a0f);
$parcel$export($e8ea6a63d48a4fea$exports, "SIGNED_RED_GREEN_RGTC2_Format", () => $e8ea6a63d48a4fea$export$768646d09dc1b6ef);
$parcel$export($e8ea6a63d48a4fea$exports, "LoopOnce", () => $e8ea6a63d48a4fea$export$d62fdc9d1b1cccad);
$parcel$export($e8ea6a63d48a4fea$exports, "LoopRepeat", () => $e8ea6a63d48a4fea$export$dfaf4422ce096e29);
$parcel$export($e8ea6a63d48a4fea$exports, "LoopPingPong", () => $e8ea6a63d48a4fea$export$f8f6f2041b78e210);
$parcel$export($e8ea6a63d48a4fea$exports, "InterpolateDiscrete", () => $e8ea6a63d48a4fea$export$995b32462a65e855);
$parcel$export($e8ea6a63d48a4fea$exports, "InterpolateLinear", () => $e8ea6a63d48a4fea$export$30fac1aace31cf4d);
$parcel$export($e8ea6a63d48a4fea$exports, "InterpolateSmooth", () => $e8ea6a63d48a4fea$export$198b11ff4c72bb30);
$parcel$export($e8ea6a63d48a4fea$exports, "ZeroCurvatureEnding", () => $e8ea6a63d48a4fea$export$7f795934b84ab523);
$parcel$export($e8ea6a63d48a4fea$exports, "ZeroSlopeEnding", () => $e8ea6a63d48a4fea$export$24a4ccb5099273b5);
$parcel$export($e8ea6a63d48a4fea$exports, "WrapAroundEnding", () => $e8ea6a63d48a4fea$export$8e8c3ecdcd8e1fee);
$parcel$export($e8ea6a63d48a4fea$exports, "NormalAnimationBlendMode", () => $e8ea6a63d48a4fea$export$bcfbbdcf8de7f8cd);
$parcel$export($e8ea6a63d48a4fea$exports, "AdditiveAnimationBlendMode", () => $e8ea6a63d48a4fea$export$d875e029ef558d3);
$parcel$export($e8ea6a63d48a4fea$exports, "TrianglesDrawMode", () => $e8ea6a63d48a4fea$export$4c28c87c2dc84758);
$parcel$export($e8ea6a63d48a4fea$exports, "TriangleStripDrawMode", () => $e8ea6a63d48a4fea$export$b23a071aa286eb29);
$parcel$export($e8ea6a63d48a4fea$exports, "TriangleFanDrawMode", () => $e8ea6a63d48a4fea$export$f0d8293634f88842);
$parcel$export($e8ea6a63d48a4fea$exports, "LinearEncoding", () => $e8ea6a63d48a4fea$export$7207336e4151a112);
$parcel$export($e8ea6a63d48a4fea$exports, "sRGBEncoding", () => $e8ea6a63d48a4fea$export$f32388edbb32674);
$parcel$export($e8ea6a63d48a4fea$exports, "BasicDepthPacking", () => $e8ea6a63d48a4fea$export$deeb383078690b50);
$parcel$export($e8ea6a63d48a4fea$exports, "RGBADepthPacking", () => $e8ea6a63d48a4fea$export$8f910f4c4f73df11);
$parcel$export($e8ea6a63d48a4fea$exports, "TangentSpaceNormalMap", () => $e8ea6a63d48a4fea$export$2852a58ebdac27b8);
$parcel$export($e8ea6a63d48a4fea$exports, "ObjectSpaceNormalMap", () => $e8ea6a63d48a4fea$export$9990ad26f9db5b2c);
$parcel$export($e8ea6a63d48a4fea$exports, "NoColorSpace", () => $e8ea6a63d48a4fea$export$bfcb490c2dd3db51);
$parcel$export($e8ea6a63d48a4fea$exports, "SRGBColorSpace", () => $e8ea6a63d48a4fea$export$561f394b24edfcaa);
$parcel$export($e8ea6a63d48a4fea$exports, "LinearSRGBColorSpace", () => $e8ea6a63d48a4fea$export$42429b3acfb233a4);
$parcel$export($e8ea6a63d48a4fea$exports, "DisplayP3ColorSpace", () => $e8ea6a63d48a4fea$export$626af19ae879bdf6);
$parcel$export($e8ea6a63d48a4fea$exports, "ZeroStencilOp", () => $e8ea6a63d48a4fea$export$69433f11f42d5527);
$parcel$export($e8ea6a63d48a4fea$exports, "KeepStencilOp", () => $e8ea6a63d48a4fea$export$9f542ae4b5baca34);
$parcel$export($e8ea6a63d48a4fea$exports, "ReplaceStencilOp", () => $e8ea6a63d48a4fea$export$8a4f28336ef203d3);
$parcel$export($e8ea6a63d48a4fea$exports, "IncrementStencilOp", () => $e8ea6a63d48a4fea$export$2928c0231297c036);
$parcel$export($e8ea6a63d48a4fea$exports, "DecrementStencilOp", () => $e8ea6a63d48a4fea$export$c0e9611c8a15f9a8);
$parcel$export($e8ea6a63d48a4fea$exports, "IncrementWrapStencilOp", () => $e8ea6a63d48a4fea$export$9c2c08927385dcc4);
$parcel$export($e8ea6a63d48a4fea$exports, "DecrementWrapStencilOp", () => $e8ea6a63d48a4fea$export$7c74ea00fa1315e6);
$parcel$export($e8ea6a63d48a4fea$exports, "InvertStencilOp", () => $e8ea6a63d48a4fea$export$22e2e5726612443);
$parcel$export($e8ea6a63d48a4fea$exports, "NeverStencilFunc", () => $e8ea6a63d48a4fea$export$1343870698229224);
$parcel$export($e8ea6a63d48a4fea$exports, "LessStencilFunc", () => $e8ea6a63d48a4fea$export$8e1d8ed281997fa6);
$parcel$export($e8ea6a63d48a4fea$exports, "EqualStencilFunc", () => $e8ea6a63d48a4fea$export$55648a1cde8329a7);
$parcel$export($e8ea6a63d48a4fea$exports, "LessEqualStencilFunc", () => $e8ea6a63d48a4fea$export$2dff107857e6aca2);
$parcel$export($e8ea6a63d48a4fea$exports, "GreaterStencilFunc", () => $e8ea6a63d48a4fea$export$6f93765ab2f451a2);
$parcel$export($e8ea6a63d48a4fea$exports, "NotEqualStencilFunc", () => $e8ea6a63d48a4fea$export$6f3fb2d2440f2b76);
$parcel$export($e8ea6a63d48a4fea$exports, "GreaterEqualStencilFunc", () => $e8ea6a63d48a4fea$export$4119cf7b4c98fd5a);
$parcel$export($e8ea6a63d48a4fea$exports, "AlwaysStencilFunc", () => $e8ea6a63d48a4fea$export$14cf96713ddd97a8);
$parcel$export($e8ea6a63d48a4fea$exports, "StaticDrawUsage", () => $e8ea6a63d48a4fea$export$763e8360f4d7f77d);
$parcel$export($e8ea6a63d48a4fea$exports, "DynamicDrawUsage", () => $e8ea6a63d48a4fea$export$8505d14ac8546ca);
$parcel$export($e8ea6a63d48a4fea$exports, "StreamDrawUsage", () => $e8ea6a63d48a4fea$export$721e63549e51d81e);
$parcel$export($e8ea6a63d48a4fea$exports, "StaticReadUsage", () => $e8ea6a63d48a4fea$export$415731dc4f48e299);
$parcel$export($e8ea6a63d48a4fea$exports, "DynamicReadUsage", () => $e8ea6a63d48a4fea$export$9e809946455f13bc);
$parcel$export($e8ea6a63d48a4fea$exports, "StreamReadUsage", () => $e8ea6a63d48a4fea$export$2ed9499a35b5f832);
$parcel$export($e8ea6a63d48a4fea$exports, "StaticCopyUsage", () => $e8ea6a63d48a4fea$export$32ab2503ea19469a);
$parcel$export($e8ea6a63d48a4fea$exports, "DynamicCopyUsage", () => $e8ea6a63d48a4fea$export$ab4022c2c3f86315);
$parcel$export($e8ea6a63d48a4fea$exports, "StreamCopyUsage", () => $e8ea6a63d48a4fea$export$ba7f1db36a76a970);
$parcel$export($e8ea6a63d48a4fea$exports, "GLSL1", () => $e8ea6a63d48a4fea$export$43600cc67fabd9f);
$parcel$export($e8ea6a63d48a4fea$exports, "GLSL3", () => $e8ea6a63d48a4fea$export$f63012db5506e7dd);
$parcel$export($e8ea6a63d48a4fea$exports, "_SRGBAFormat", () => $e8ea6a63d48a4fea$export$ca1dce8b5e1de74d);
$parcel$export($e8ea6a63d48a4fea$exports, "EventDispatcher", () => $e8ea6a63d48a4fea$export$ec8b666c5fe2c75a);
$parcel$export($e8ea6a63d48a4fea$exports, "MathUtils", () => $e8ea6a63d48a4fea$export$6a7ef315a0d1ef07);
$parcel$export($e8ea6a63d48a4fea$exports, "Vector2", () => $e8ea6a63d48a4fea$export$c977b3e384af9ae1);
$parcel$export($e8ea6a63d48a4fea$exports, "Matrix3", () => $e8ea6a63d48a4fea$export$8ff26dafa08918);
$parcel$export($e8ea6a63d48a4fea$exports, "ColorManagement", () => $e8ea6a63d48a4fea$export$5e6fd513f44698c);
$parcel$export($e8ea6a63d48a4fea$exports, "ImageUtils", () => $e8ea6a63d48a4fea$export$698882cf06df44aa);
$parcel$export($e8ea6a63d48a4fea$exports, "Source", () => $e8ea6a63d48a4fea$export$1d2df86270c81ecb);
$parcel$export($e8ea6a63d48a4fea$exports, "Texture", () => $e8ea6a63d48a4fea$export$5431306cf43de24a);
$parcel$export($e8ea6a63d48a4fea$exports, "Vector4", () => $e8ea6a63d48a4fea$export$fa7daccca11cdbe3);
$parcel$export($e8ea6a63d48a4fea$exports, "WebGLRenderTarget", () => $e8ea6a63d48a4fea$export$3c052beb2e51e23f);
$parcel$export($e8ea6a63d48a4fea$exports, "DataArrayTexture", () => $e8ea6a63d48a4fea$export$dfac6c8e811406a3);
$parcel$export($e8ea6a63d48a4fea$exports, "WebGLArrayRenderTarget", () => $e8ea6a63d48a4fea$export$c77a02c11ed180c7);
$parcel$export($e8ea6a63d48a4fea$exports, "Data3DTexture", () => $e8ea6a63d48a4fea$export$d7a3086320f856db);
$parcel$export($e8ea6a63d48a4fea$exports, "WebGL3DRenderTarget", () => $e8ea6a63d48a4fea$export$7ee06591009639df);
$parcel$export($e8ea6a63d48a4fea$exports, "WebGLMultipleRenderTargets", () => $e8ea6a63d48a4fea$export$bd934554fb721730);
$parcel$export($e8ea6a63d48a4fea$exports, "Quaternion", () => $e8ea6a63d48a4fea$export$23d6a54f0bbc85a3);
$parcel$export($e8ea6a63d48a4fea$exports, "Vector3", () => $e8ea6a63d48a4fea$export$64b5c384219d3699);
$parcel$export($e8ea6a63d48a4fea$exports, "Box3", () => $e8ea6a63d48a4fea$export$6f7d5a9418ab2aa3);
$parcel$export($e8ea6a63d48a4fea$exports, "Sphere", () => $e8ea6a63d48a4fea$export$805e8b72413ccaba);
$parcel$export($e8ea6a63d48a4fea$exports, "Ray", () => $e8ea6a63d48a4fea$export$a186db52eed6d40e);
$parcel$export($e8ea6a63d48a4fea$exports, "Matrix4", () => $e8ea6a63d48a4fea$export$2ae72fc923e5eb5);
$parcel$export($e8ea6a63d48a4fea$exports, "Euler", () => $e8ea6a63d48a4fea$export$d93cc409a0768c5f);
$parcel$export($e8ea6a63d48a4fea$exports, "Layers", () => $e8ea6a63d48a4fea$export$89312ce47c0ca777);
$parcel$export($e8ea6a63d48a4fea$exports, "Object3D", () => $e8ea6a63d48a4fea$export$e4dd07dff30cc924);
$parcel$export($e8ea6a63d48a4fea$exports, "Triangle", () => $e8ea6a63d48a4fea$export$5a465592bfe74b48);
$parcel$export($e8ea6a63d48a4fea$exports, "Material", () => $e8ea6a63d48a4fea$export$a2d8b23205c25948);
$parcel$export($e8ea6a63d48a4fea$exports, "Color", () => $e8ea6a63d48a4fea$export$892596cec99bc70e);
$parcel$export($e8ea6a63d48a4fea$exports, "MeshBasicMaterial", () => $e8ea6a63d48a4fea$export$55cbcc9b622fe1f5);
$parcel$export($e8ea6a63d48a4fea$exports, "DataUtils", () => $e8ea6a63d48a4fea$export$11ce8b759162cc80);
$parcel$export($e8ea6a63d48a4fea$exports, "BufferAttribute", () => $e8ea6a63d48a4fea$export$8dea267bd6bde117);
$parcel$export($e8ea6a63d48a4fea$exports, "Int8BufferAttribute", () => $e8ea6a63d48a4fea$export$f9ff2d6a20248cbf);
$parcel$export($e8ea6a63d48a4fea$exports, "Uint8BufferAttribute", () => $e8ea6a63d48a4fea$export$cacc90cf35d11cdd);
$parcel$export($e8ea6a63d48a4fea$exports, "Uint8ClampedBufferAttribute", () => $e8ea6a63d48a4fea$export$baaa85a1a812c157);
$parcel$export($e8ea6a63d48a4fea$exports, "Int16BufferAttribute", () => $e8ea6a63d48a4fea$export$2b755a102ccdcefe);
$parcel$export($e8ea6a63d48a4fea$exports, "Uint16BufferAttribute", () => $e8ea6a63d48a4fea$export$640a853f68025f2e);
$parcel$export($e8ea6a63d48a4fea$exports, "Int32BufferAttribute", () => $e8ea6a63d48a4fea$export$46b369aed2968a0a);
$parcel$export($e8ea6a63d48a4fea$exports, "Uint32BufferAttribute", () => $e8ea6a63d48a4fea$export$7eb8c9fa25cd5bd6);
$parcel$export($e8ea6a63d48a4fea$exports, "Float16BufferAttribute", () => $e8ea6a63d48a4fea$export$dbd3698c64958d69);
$parcel$export($e8ea6a63d48a4fea$exports, "Float32BufferAttribute", () => $e8ea6a63d48a4fea$export$cbe7a62641830ebd);
$parcel$export($e8ea6a63d48a4fea$exports, "Float64BufferAttribute", () => $e8ea6a63d48a4fea$export$9e0ade74842adbb8);
$parcel$export($e8ea6a63d48a4fea$exports, "BufferGeometry", () => $e8ea6a63d48a4fea$export$b7be63a67df8959);
$parcel$export($e8ea6a63d48a4fea$exports, "Mesh", () => $e8ea6a63d48a4fea$export$e176487c05830cc5);
$parcel$export($e8ea6a63d48a4fea$exports, "BoxGeometry", () => $e8ea6a63d48a4fea$export$33e43285f7406bd5);
$parcel$export($e8ea6a63d48a4fea$exports, "UniformsUtils", () => $e8ea6a63d48a4fea$export$d8ecdf8615bfea69);
$parcel$export($e8ea6a63d48a4fea$exports, "ShaderMaterial", () => $e8ea6a63d48a4fea$export$83c7d75d550a8b0d);
$parcel$export($e8ea6a63d48a4fea$exports, "Camera", () => $e8ea6a63d48a4fea$export$79f141de891a5fed);
$parcel$export($e8ea6a63d48a4fea$exports, "PerspectiveCamera", () => $e8ea6a63d48a4fea$export$74e4ae24825f68d7);
$parcel$export($e8ea6a63d48a4fea$exports, "CubeCamera", () => $e8ea6a63d48a4fea$export$d0cdd0bd804995de);
$parcel$export($e8ea6a63d48a4fea$exports, "CubeTexture", () => $e8ea6a63d48a4fea$export$ee2e5a18258a4049);
$parcel$export($e8ea6a63d48a4fea$exports, "WebGLCubeRenderTarget", () => $e8ea6a63d48a4fea$export$ac386671d651941e);
$parcel$export($e8ea6a63d48a4fea$exports, "Plane", () => $e8ea6a63d48a4fea$export$7ff5ac152ef991b0);
$parcel$export($e8ea6a63d48a4fea$exports, "Frustum", () => $e8ea6a63d48a4fea$export$35efe6f4c85463d2);
$parcel$export($e8ea6a63d48a4fea$exports, "PlaneGeometry", () => $e8ea6a63d48a4fea$export$967d831af31f69ce);
$parcel$export($e8ea6a63d48a4fea$exports, "ShaderChunk", () => $e8ea6a63d48a4fea$export$955f9f2e84c43c8b);
$parcel$export($e8ea6a63d48a4fea$exports, "UniformsLib", () => $e8ea6a63d48a4fea$export$6643083551874bf5);
$parcel$export($e8ea6a63d48a4fea$exports, "ShaderLib", () => $e8ea6a63d48a4fea$export$bee4a7d47f8f5014);
$parcel$export($e8ea6a63d48a4fea$exports, "OrthographicCamera", () => $e8ea6a63d48a4fea$export$9ebf355ee4ed261b);
$parcel$export($e8ea6a63d48a4fea$exports, "PMREMGenerator", () => $e8ea6a63d48a4fea$export$6add42717753e221);
$parcel$export($e8ea6a63d48a4fea$exports, "MeshDepthMaterial", () => $e8ea6a63d48a4fea$export$2698c22ec13825db);
$parcel$export($e8ea6a63d48a4fea$exports, "MeshDistanceMaterial", () => $e8ea6a63d48a4fea$export$33e187ed002f2a19);
$parcel$export($e8ea6a63d48a4fea$exports, "WebGLUtils", () => $e8ea6a63d48a4fea$export$ddaebcad857649a8);
$parcel$export($e8ea6a63d48a4fea$exports, "ArrayCamera", () => $e8ea6a63d48a4fea$export$56b937d9e5581166);
$parcel$export($e8ea6a63d48a4fea$exports, "Group", () => $e8ea6a63d48a4fea$export$eb2fcfdbd7ba97d4);
$parcel$export($e8ea6a63d48a4fea$exports, "DepthTexture", () => $e8ea6a63d48a4fea$export$fc830aa069cc8c2f);
$parcel$export($e8ea6a63d48a4fea$exports, "WebGLRenderer", () => $e8ea6a63d48a4fea$export$f6cc00ef28d7cf97);
$parcel$export($e8ea6a63d48a4fea$exports, "WebGL1Renderer", () => $e8ea6a63d48a4fea$export$a2f65229194348f9);
$parcel$export($e8ea6a63d48a4fea$exports, "FogExp2", () => $e8ea6a63d48a4fea$export$6f1519f023b8d0f6);
$parcel$export($e8ea6a63d48a4fea$exports, "Fog", () => $e8ea6a63d48a4fea$export$3c890837b09508d4);
$parcel$export($e8ea6a63d48a4fea$exports, "Scene", () => $e8ea6a63d48a4fea$export$38af1803e3442a7f);
$parcel$export($e8ea6a63d48a4fea$exports, "InterleavedBuffer", () => $e8ea6a63d48a4fea$export$3d5cd879f108f53f);
$parcel$export($e8ea6a63d48a4fea$exports, "InterleavedBufferAttribute", () => $e8ea6a63d48a4fea$export$920b6d07334599c7);
$parcel$export($e8ea6a63d48a4fea$exports, "SpriteMaterial", () => $e8ea6a63d48a4fea$export$5ec7dd1c6994bf8e);
$parcel$export($e8ea6a63d48a4fea$exports, "Sprite", () => $e8ea6a63d48a4fea$export$3075603db8e6204c);
$parcel$export($e8ea6a63d48a4fea$exports, "LOD", () => $e8ea6a63d48a4fea$export$112e7237be0c5f30);
$parcel$export($e8ea6a63d48a4fea$exports, "SkinnedMesh", () => $e8ea6a63d48a4fea$export$b303577035157ecf);
$parcel$export($e8ea6a63d48a4fea$exports, "Bone", () => $e8ea6a63d48a4fea$export$b127726e56765aa4);
$parcel$export($e8ea6a63d48a4fea$exports, "DataTexture", () => $e8ea6a63d48a4fea$export$b691f601014eabe1);
$parcel$export($e8ea6a63d48a4fea$exports, "Skeleton", () => $e8ea6a63d48a4fea$export$8f31e4c4a37b8e9c);
$parcel$export($e8ea6a63d48a4fea$exports, "InstancedBufferAttribute", () => $e8ea6a63d48a4fea$export$32ea87a8b54d744a);
$parcel$export($e8ea6a63d48a4fea$exports, "InstancedMesh", () => $e8ea6a63d48a4fea$export$f3c979c331175ad7);
$parcel$export($e8ea6a63d48a4fea$exports, "LineBasicMaterial", () => $e8ea6a63d48a4fea$export$fbaaa33907730a0c);
$parcel$export($e8ea6a63d48a4fea$exports, "Line", () => $e8ea6a63d48a4fea$export$17d680238e50603e);
$parcel$export($e8ea6a63d48a4fea$exports, "LineSegments", () => $e8ea6a63d48a4fea$export$ff1ed10fedfdd604);
$parcel$export($e8ea6a63d48a4fea$exports, "LineLoop", () => $e8ea6a63d48a4fea$export$f85a24d745e4f17d);
$parcel$export($e8ea6a63d48a4fea$exports, "PointsMaterial", () => $e8ea6a63d48a4fea$export$a178c45366ce5d6b);
$parcel$export($e8ea6a63d48a4fea$exports, "Points", () => $e8ea6a63d48a4fea$export$1c787534cb11aa3e);
$parcel$export($e8ea6a63d48a4fea$exports, "VideoTexture", () => $e8ea6a63d48a4fea$export$6e09d1edf8d5a25c);
$parcel$export($e8ea6a63d48a4fea$exports, "FramebufferTexture", () => $e8ea6a63d48a4fea$export$9270d786f73ce6fe);
$parcel$export($e8ea6a63d48a4fea$exports, "CompressedTexture", () => $e8ea6a63d48a4fea$export$3466bac9141a5cc4);
$parcel$export($e8ea6a63d48a4fea$exports, "CompressedArrayTexture", () => $e8ea6a63d48a4fea$export$5fe6b8e34b274fcb);
$parcel$export($e8ea6a63d48a4fea$exports, "CanvasTexture", () => $e8ea6a63d48a4fea$export$f7189e49152d1c13);
$parcel$export($e8ea6a63d48a4fea$exports, "Curve", () => $e8ea6a63d48a4fea$export$b0e83c3ef8d2db1);
$parcel$export($e8ea6a63d48a4fea$exports, "EllipseCurve", () => $e8ea6a63d48a4fea$export$3f87a931616cde04);
$parcel$export($e8ea6a63d48a4fea$exports, "ArcCurve", () => $e8ea6a63d48a4fea$export$b1eedc9aab6300e8);
$parcel$export($e8ea6a63d48a4fea$exports, "CatmullRomCurve3", () => $e8ea6a63d48a4fea$export$b9146b27c24b744c);
$parcel$export($e8ea6a63d48a4fea$exports, "CubicBezierCurve", () => $e8ea6a63d48a4fea$export$e36650d36468bb39);
$parcel$export($e8ea6a63d48a4fea$exports, "CubicBezierCurve3", () => $e8ea6a63d48a4fea$export$13d5f1c9525f246c);
$parcel$export($e8ea6a63d48a4fea$exports, "LineCurve", () => $e8ea6a63d48a4fea$export$ab2e07e76531a47e);
$parcel$export($e8ea6a63d48a4fea$exports, "LineCurve3", () => $e8ea6a63d48a4fea$export$1fdfd9d9cf487600);
$parcel$export($e8ea6a63d48a4fea$exports, "QuadraticBezierCurve", () => $e8ea6a63d48a4fea$export$5938c4ee491a43ad);
$parcel$export($e8ea6a63d48a4fea$exports, "QuadraticBezierCurve3", () => $e8ea6a63d48a4fea$export$bf3f4c7e459f90fc);
$parcel$export($e8ea6a63d48a4fea$exports, "SplineCurve", () => $e8ea6a63d48a4fea$export$d3bdd77da77afc1b);
$parcel$export($e8ea6a63d48a4fea$exports, "CurvePath", () => $e8ea6a63d48a4fea$export$4aaf9b66af1bbf2c);
$parcel$export($e8ea6a63d48a4fea$exports, "Path", () => $e8ea6a63d48a4fea$export$4b2950bdac9b6ee9);
$parcel$export($e8ea6a63d48a4fea$exports, "LatheGeometry", () => $e8ea6a63d48a4fea$export$6d839803fcd1882c);
$parcel$export($e8ea6a63d48a4fea$exports, "CapsuleGeometry", () => $e8ea6a63d48a4fea$export$41680e8551036033);
$parcel$export($e8ea6a63d48a4fea$exports, "CircleGeometry", () => $e8ea6a63d48a4fea$export$d5c0e8d607467193);
$parcel$export($e8ea6a63d48a4fea$exports, "CylinderGeometry", () => $e8ea6a63d48a4fea$export$68f745719dbe5198);
$parcel$export($e8ea6a63d48a4fea$exports, "ConeGeometry", () => $e8ea6a63d48a4fea$export$a7a48974f285c9b3);
$parcel$export($e8ea6a63d48a4fea$exports, "PolyhedronGeometry", () => $e8ea6a63d48a4fea$export$60e57a7d3f20ff65);
$parcel$export($e8ea6a63d48a4fea$exports, "DodecahedronGeometry", () => $e8ea6a63d48a4fea$export$c0babfeb8708fc9c);
$parcel$export($e8ea6a63d48a4fea$exports, "EdgesGeometry", () => $e8ea6a63d48a4fea$export$4730b1542707547f);
$parcel$export($e8ea6a63d48a4fea$exports, "Shape", () => $e8ea6a63d48a4fea$export$6428a7f2611ef1fa);
$parcel$export($e8ea6a63d48a4fea$exports, "ShapeUtils", () => $e8ea6a63d48a4fea$export$96bdf6d9c66d7ba8);
$parcel$export($e8ea6a63d48a4fea$exports, "ExtrudeGeometry", () => $e8ea6a63d48a4fea$export$598697a1efa63ca7);
$parcel$export($e8ea6a63d48a4fea$exports, "IcosahedronGeometry", () => $e8ea6a63d48a4fea$export$9567cc828c9535da);
$parcel$export($e8ea6a63d48a4fea$exports, "OctahedronGeometry", () => $e8ea6a63d48a4fea$export$1954e2b809fe361e);
$parcel$export($e8ea6a63d48a4fea$exports, "RingGeometry", () => $e8ea6a63d48a4fea$export$68cb731f50f614af);
$parcel$export($e8ea6a63d48a4fea$exports, "ShapeGeometry", () => $e8ea6a63d48a4fea$export$57a29a1c803e9065);
$parcel$export($e8ea6a63d48a4fea$exports, "SphereGeometry", () => $e8ea6a63d48a4fea$export$1b417fc3b307a251);
$parcel$export($e8ea6a63d48a4fea$exports, "TetrahedronGeometry", () => $e8ea6a63d48a4fea$export$fb3f7adc68bd6e02);
$parcel$export($e8ea6a63d48a4fea$exports, "TorusGeometry", () => $e8ea6a63d48a4fea$export$a2312a2a1fa56495);
$parcel$export($e8ea6a63d48a4fea$exports, "TorusKnotGeometry", () => $e8ea6a63d48a4fea$export$77e9bfadfb9ab8c8);
$parcel$export($e8ea6a63d48a4fea$exports, "TubeGeometry", () => $e8ea6a63d48a4fea$export$7897d9d48904490c);
$parcel$export($e8ea6a63d48a4fea$exports, "WireframeGeometry", () => $e8ea6a63d48a4fea$export$4b739da06d24892b);
$parcel$export($e8ea6a63d48a4fea$exports, "ShadowMaterial", () => $e8ea6a63d48a4fea$export$e8564da406055a3);
$parcel$export($e8ea6a63d48a4fea$exports, "RawShaderMaterial", () => $e8ea6a63d48a4fea$export$21c421a2e1df9d22);
$parcel$export($e8ea6a63d48a4fea$exports, "MeshStandardMaterial", () => $e8ea6a63d48a4fea$export$f2980790215acccd);
$parcel$export($e8ea6a63d48a4fea$exports, "MeshPhysicalMaterial", () => $e8ea6a63d48a4fea$export$28d04986c4269c9f);
$parcel$export($e8ea6a63d48a4fea$exports, "MeshPhongMaterial", () => $e8ea6a63d48a4fea$export$24c72f71cbaf0678);
$parcel$export($e8ea6a63d48a4fea$exports, "MeshToonMaterial", () => $e8ea6a63d48a4fea$export$df893cf97e765622);
$parcel$export($e8ea6a63d48a4fea$exports, "MeshNormalMaterial", () => $e8ea6a63d48a4fea$export$bfe8c0a091f41ae7);
$parcel$export($e8ea6a63d48a4fea$exports, "MeshLambertMaterial", () => $e8ea6a63d48a4fea$export$5023a9a8114806b8);
$parcel$export($e8ea6a63d48a4fea$exports, "MeshMatcapMaterial", () => $e8ea6a63d48a4fea$export$6f5fef6235ec12ee);
$parcel$export($e8ea6a63d48a4fea$exports, "LineDashedMaterial", () => $e8ea6a63d48a4fea$export$327886a3efaeaebe);
$parcel$export($e8ea6a63d48a4fea$exports, "AnimationUtils", () => $e8ea6a63d48a4fea$export$7ee8caa573e71ad1);
$parcel$export($e8ea6a63d48a4fea$exports, "Interpolant", () => $e8ea6a63d48a4fea$export$b558baee9c0f72d3);
$parcel$export($e8ea6a63d48a4fea$exports, "CubicInterpolant", () => $e8ea6a63d48a4fea$export$3646682e7a3959);
$parcel$export($e8ea6a63d48a4fea$exports, "LinearInterpolant", () => $e8ea6a63d48a4fea$export$a8e6009059f51e1a);
$parcel$export($e8ea6a63d48a4fea$exports, "DiscreteInterpolant", () => $e8ea6a63d48a4fea$export$fb9758ef7ef8d5cc);
$parcel$export($e8ea6a63d48a4fea$exports, "KeyframeTrack", () => $e8ea6a63d48a4fea$export$b0e479f45b7006d6);
$parcel$export($e8ea6a63d48a4fea$exports, "BooleanKeyframeTrack", () => $e8ea6a63d48a4fea$export$d3a344b98cf0b775);
$parcel$export($e8ea6a63d48a4fea$exports, "ColorKeyframeTrack", () => $e8ea6a63d48a4fea$export$83444c5d885347d8);
$parcel$export($e8ea6a63d48a4fea$exports, "NumberKeyframeTrack", () => $e8ea6a63d48a4fea$export$d45f0d1a4d9a9314);
$parcel$export($e8ea6a63d48a4fea$exports, "QuaternionLinearInterpolant", () => $e8ea6a63d48a4fea$export$2db1cfb7923d931e);
$parcel$export($e8ea6a63d48a4fea$exports, "QuaternionKeyframeTrack", () => $e8ea6a63d48a4fea$export$b8043f12b5aafbd7);
$parcel$export($e8ea6a63d48a4fea$exports, "StringKeyframeTrack", () => $e8ea6a63d48a4fea$export$6ce41d4f3a8df9cd);
$parcel$export($e8ea6a63d48a4fea$exports, "VectorKeyframeTrack", () => $e8ea6a63d48a4fea$export$5ce2dcb4cc9f2bff);
$parcel$export($e8ea6a63d48a4fea$exports, "AnimationClip", () => $e8ea6a63d48a4fea$export$d942c706bf23829c);
$parcel$export($e8ea6a63d48a4fea$exports, "Cache", () => $e8ea6a63d48a4fea$export$94affb487e701bf2);
$parcel$export($e8ea6a63d48a4fea$exports, "LoadingManager", () => $e8ea6a63d48a4fea$export$99cc795e99919eed);
$parcel$export($e8ea6a63d48a4fea$exports, "DefaultLoadingManager", () => $e8ea6a63d48a4fea$export$b033c3f9a95c6a16);
$parcel$export($e8ea6a63d48a4fea$exports, "Loader", () => $e8ea6a63d48a4fea$export$3b0d6d7590275603);
$parcel$export($e8ea6a63d48a4fea$exports, "FileLoader", () => $e8ea6a63d48a4fea$export$98435a25b5cf7b2b);
$parcel$export($e8ea6a63d48a4fea$exports, "AnimationLoader", () => $e8ea6a63d48a4fea$export$29711c7e14f61db);
$parcel$export($e8ea6a63d48a4fea$exports, "CompressedTextureLoader", () => $e8ea6a63d48a4fea$export$bd73ce947a280350);
$parcel$export($e8ea6a63d48a4fea$exports, "ImageLoader", () => $e8ea6a63d48a4fea$export$8905ce1c7a2464a1);
$parcel$export($e8ea6a63d48a4fea$exports, "CubeTextureLoader", () => $e8ea6a63d48a4fea$export$2ec114afc2cf6308);
$parcel$export($e8ea6a63d48a4fea$exports, "DataTextureLoader", () => $e8ea6a63d48a4fea$export$792d8a18f2c55855);
$parcel$export($e8ea6a63d48a4fea$exports, "TextureLoader", () => $e8ea6a63d48a4fea$export$fd1bfc71f64c538c);
$parcel$export($e8ea6a63d48a4fea$exports, "Light", () => $e8ea6a63d48a4fea$export$6ecadb6ed240d696);
$parcel$export($e8ea6a63d48a4fea$exports, "HemisphereLight", () => $e8ea6a63d48a4fea$export$8d474f55edbb9624);
$parcel$export($e8ea6a63d48a4fea$exports, "SpotLight", () => $e8ea6a63d48a4fea$export$81495cbb73897362);
$parcel$export($e8ea6a63d48a4fea$exports, "PointLight", () => $e8ea6a63d48a4fea$export$4c9c1cb3f0b6f455);
$parcel$export($e8ea6a63d48a4fea$exports, "DirectionalLight", () => $e8ea6a63d48a4fea$export$3fea33cc9972c868);
$parcel$export($e8ea6a63d48a4fea$exports, "AmbientLight", () => $e8ea6a63d48a4fea$export$af279bfef9ec2c96);
$parcel$export($e8ea6a63d48a4fea$exports, "RectAreaLight", () => $e8ea6a63d48a4fea$export$61db2d908bbd2429);
$parcel$export($e8ea6a63d48a4fea$exports, "SphericalHarmonics3", () => $e8ea6a63d48a4fea$export$ba61ce607e1f405a);
$parcel$export($e8ea6a63d48a4fea$exports, "LightProbe", () => $e8ea6a63d48a4fea$export$e7ef036e309b38d2);
$parcel$export($e8ea6a63d48a4fea$exports, "MaterialLoader", () => $e8ea6a63d48a4fea$export$3bd6d323353dcf96);
$parcel$export($e8ea6a63d48a4fea$exports, "LoaderUtils", () => $e8ea6a63d48a4fea$export$b5d2dc08d867e41a);
$parcel$export($e8ea6a63d48a4fea$exports, "InstancedBufferGeometry", () => $e8ea6a63d48a4fea$export$231f009cbe414146);
$parcel$export($e8ea6a63d48a4fea$exports, "BufferGeometryLoader", () => $e8ea6a63d48a4fea$export$dc275bb96327833a);
$parcel$export($e8ea6a63d48a4fea$exports, "ObjectLoader", () => $e8ea6a63d48a4fea$export$40110c8505c5ad19);
$parcel$export($e8ea6a63d48a4fea$exports, "ImageBitmapLoader", () => $e8ea6a63d48a4fea$export$52286b55c4a9b51f);
$parcel$export($e8ea6a63d48a4fea$exports, "AudioContext", () => $e8ea6a63d48a4fea$export$fcbc63750ec2a81f);
$parcel$export($e8ea6a63d48a4fea$exports, "AudioLoader", () => $e8ea6a63d48a4fea$export$d8d5fccfbf47714e);
$parcel$export($e8ea6a63d48a4fea$exports, "HemisphereLightProbe", () => $e8ea6a63d48a4fea$export$2f22dadc8bc42820);
$parcel$export($e8ea6a63d48a4fea$exports, "AmbientLightProbe", () => $e8ea6a63d48a4fea$export$afe310a21c86023d);
$parcel$export($e8ea6a63d48a4fea$exports, "StereoCamera", () => $e8ea6a63d48a4fea$export$bc7f73a1065bee0c);
$parcel$export($e8ea6a63d48a4fea$exports, "Clock", () => $e8ea6a63d48a4fea$export$9735c82c4bae3302);
$parcel$export($e8ea6a63d48a4fea$exports, "AudioListener", () => $e8ea6a63d48a4fea$export$8a1b810c6fde8951);
$parcel$export($e8ea6a63d48a4fea$exports, "Audio", () => $e8ea6a63d48a4fea$export$153755f98d9861de);
$parcel$export($e8ea6a63d48a4fea$exports, "PositionalAudio", () => $e8ea6a63d48a4fea$export$4b3e397ef1832507);
$parcel$export($e8ea6a63d48a4fea$exports, "AudioAnalyser", () => $e8ea6a63d48a4fea$export$d47da1ef3d382827);
$parcel$export($e8ea6a63d48a4fea$exports, "PropertyMixer", () => $e8ea6a63d48a4fea$export$dfe0af1ca1acb78a);
$parcel$export($e8ea6a63d48a4fea$exports, "PropertyBinding", () => $e8ea6a63d48a4fea$export$7bf70fcf9f891893);
$parcel$export($e8ea6a63d48a4fea$exports, "AnimationObjectGroup", () => $e8ea6a63d48a4fea$export$30619c2afd3f34db);
$parcel$export($e8ea6a63d48a4fea$exports, "AnimationAction", () => $e8ea6a63d48a4fea$export$6946940a69e799e);
$parcel$export($e8ea6a63d48a4fea$exports, "AnimationMixer", () => $e8ea6a63d48a4fea$export$fbd77e5aefaa0102);
$parcel$export($e8ea6a63d48a4fea$exports, "Uniform", () => $e8ea6a63d48a4fea$export$2947cebfe91c02f8);
$parcel$export($e8ea6a63d48a4fea$exports, "UniformsGroup", () => $e8ea6a63d48a4fea$export$c412d5ffe1f79209);
$parcel$export($e8ea6a63d48a4fea$exports, "InstancedInterleavedBuffer", () => $e8ea6a63d48a4fea$export$25ec0e1af1389358);
$parcel$export($e8ea6a63d48a4fea$exports, "GLBufferAttribute", () => $e8ea6a63d48a4fea$export$6b7339ae8dbddf73);
$parcel$export($e8ea6a63d48a4fea$exports, "Raycaster", () => $e8ea6a63d48a4fea$export$8b7aaceff00bd2f);
$parcel$export($e8ea6a63d48a4fea$exports, "Spherical", () => $e8ea6a63d48a4fea$export$d712cd887b4a00f7);
$parcel$export($e8ea6a63d48a4fea$exports, "Cylindrical", () => $e8ea6a63d48a4fea$export$287165bb2177f4fd);
$parcel$export($e8ea6a63d48a4fea$exports, "Box2", () => $e8ea6a63d48a4fea$export$60f553fa130f08b0);
$parcel$export($e8ea6a63d48a4fea$exports, "Line3", () => $e8ea6a63d48a4fea$export$e0ba6359f1954fd3);
$parcel$export($e8ea6a63d48a4fea$exports, "SpotLightHelper", () => $e8ea6a63d48a4fea$export$4b14638ffdd81e68);
$parcel$export($e8ea6a63d48a4fea$exports, "SkeletonHelper", () => $e8ea6a63d48a4fea$export$5277df3c9e732259);
$parcel$export($e8ea6a63d48a4fea$exports, "PointLightHelper", () => $e8ea6a63d48a4fea$export$9a9291685b9e4023);
$parcel$export($e8ea6a63d48a4fea$exports, "HemisphereLightHelper", () => $e8ea6a63d48a4fea$export$8dca15f13f4f8172);
$parcel$export($e8ea6a63d48a4fea$exports, "GridHelper", () => $e8ea6a63d48a4fea$export$3875d39926561055);
$parcel$export($e8ea6a63d48a4fea$exports, "PolarGridHelper", () => $e8ea6a63d48a4fea$export$361430a10f533cd3);
$parcel$export($e8ea6a63d48a4fea$exports, "DirectionalLightHelper", () => $e8ea6a63d48a4fea$export$f8e434dc14203e7d);
$parcel$export($e8ea6a63d48a4fea$exports, "CameraHelper", () => $e8ea6a63d48a4fea$export$ed8e93f853cd795);
$parcel$export($e8ea6a63d48a4fea$exports, "BoxHelper", () => $e8ea6a63d48a4fea$export$38a664cc862a6a9d);
$parcel$export($e8ea6a63d48a4fea$exports, "Box3Helper", () => $e8ea6a63d48a4fea$export$ce39f4bb96c9a290);
$parcel$export($e8ea6a63d48a4fea$exports, "PlaneHelper", () => $e8ea6a63d48a4fea$export$a34fe8156c66e5d7);
$parcel$export($e8ea6a63d48a4fea$exports, "ArrowHelper", () => $e8ea6a63d48a4fea$export$a3008e7bd8d2cbe7);
$parcel$export($e8ea6a63d48a4fea$exports, "AxesHelper", () => $e8ea6a63d48a4fea$export$6c8303f35b8578fd);
$parcel$export($e8ea6a63d48a4fea$exports, "ShapePath", () => $e8ea6a63d48a4fea$export$148534a3c727230b);
$parcel$export($e8ea6a63d48a4fea$exports, "BoxBufferGeometry", () => $e8ea6a63d48a4fea$export$ab3456a079aa7d80);
$parcel$export($e8ea6a63d48a4fea$exports, "CapsuleBufferGeometry", () => $e8ea6a63d48a4fea$export$f036d76f832848a);
$parcel$export($e8ea6a63d48a4fea$exports, "CircleBufferGeometry", () => $e8ea6a63d48a4fea$export$3f74fe60decf7462);
$parcel$export($e8ea6a63d48a4fea$exports, "ConeBufferGeometry", () => $e8ea6a63d48a4fea$export$59d971120dc8b6e7);
$parcel$export($e8ea6a63d48a4fea$exports, "CylinderBufferGeometry", () => $e8ea6a63d48a4fea$export$d4345c83207d7c68);
$parcel$export($e8ea6a63d48a4fea$exports, "DodecahedronBufferGeometry", () => $e8ea6a63d48a4fea$export$37cd4e52cce48c4c);
$parcel$export($e8ea6a63d48a4fea$exports, "ExtrudeBufferGeometry", () => $e8ea6a63d48a4fea$export$91836d01b9f75a58);
$parcel$export($e8ea6a63d48a4fea$exports, "IcosahedronBufferGeometry", () => $e8ea6a63d48a4fea$export$731fd4feef063ea2);
$parcel$export($e8ea6a63d48a4fea$exports, "LatheBufferGeometry", () => $e8ea6a63d48a4fea$export$dc3e1273c1dd9240);
$parcel$export($e8ea6a63d48a4fea$exports, "OctahedronBufferGeometry", () => $e8ea6a63d48a4fea$export$8e05fc91596f4752);
$parcel$export($e8ea6a63d48a4fea$exports, "PlaneBufferGeometry", () => $e8ea6a63d48a4fea$export$e789a11a194ca4e0);
$parcel$export($e8ea6a63d48a4fea$exports, "PolyhedronBufferGeometry", () => $e8ea6a63d48a4fea$export$38789b531813345c);
$parcel$export($e8ea6a63d48a4fea$exports, "RingBufferGeometry", () => $e8ea6a63d48a4fea$export$ee8b85b34b7d9cad);
$parcel$export($e8ea6a63d48a4fea$exports, "ShapeBufferGeometry", () => $e8ea6a63d48a4fea$export$233afc324766bed8);
$parcel$export($e8ea6a63d48a4fea$exports, "SphereBufferGeometry", () => $e8ea6a63d48a4fea$export$d5d06a966fec4192);
$parcel$export($e8ea6a63d48a4fea$exports, "TetrahedronBufferGeometry", () => $e8ea6a63d48a4fea$export$369e08f62a796c65);
$parcel$export($e8ea6a63d48a4fea$exports, "TorusBufferGeometry", () => $e8ea6a63d48a4fea$export$19d55f905fa4f2cb);
$parcel$export($e8ea6a63d48a4fea$exports, "TorusKnotBufferGeometry", () => $e8ea6a63d48a4fea$export$2b32466f4274fe5c);
$parcel$export($e8ea6a63d48a4fea$exports, "TubeBufferGeometry", () => $e8ea6a63d48a4fea$export$d97a193ce44e691b);
/**
 * @license
 * Copyright 2010-2023 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ const $e8ea6a63d48a4fea$export$3545e07a80636437 = "151";
const $e8ea6a63d48a4fea$export$7177b3e430c2d7ca = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
};
const $e8ea6a63d48a4fea$export$d46bd3ead7cc759b = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
};
const $e8ea6a63d48a4fea$export$3237e1f2c1ea1f44 = 0;
const $e8ea6a63d48a4fea$export$b9a7b4fc5cb15f9b = 1;
const $e8ea6a63d48a4fea$export$b8058bcc7037d3f3 = 2;
const $e8ea6a63d48a4fea$export$f24be24dcddeac0d = 3;
const $e8ea6a63d48a4fea$export$346307dbae2b7447 = 0;
const $e8ea6a63d48a4fea$export$5813f879eee7cd88 = 1;
const $e8ea6a63d48a4fea$export$a47c4b43a1be34f0 = 2;
const $e8ea6a63d48a4fea$export$896ae1ade6c829c4 = 3;
const $e8ea6a63d48a4fea$export$2ede184fc2998901 = 0;
const $e8ea6a63d48a4fea$export$d9f0486e75b5ace = 1;
const $e8ea6a63d48a4fea$export$3b296b6f144d5b03 = 2;
const $e8ea6a63d48a4fea$export$211211c00f97204d = 2; // r149
const $e8ea6a63d48a4fea$export$63b8d6b580fc65ba = 0;
const $e8ea6a63d48a4fea$export$5b29a26d96ee6af0 = 1;
const $e8ea6a63d48a4fea$export$777d8f9551c2216b = 2;
const $e8ea6a63d48a4fea$export$cdfa06f868e2e467 = 3;
const $e8ea6a63d48a4fea$export$4138e1c684b46a20 = 4;
const $e8ea6a63d48a4fea$export$eda4864c68df1fa2 = 5;
const $e8ea6a63d48a4fea$export$20183a0484ce21a0 = 100;
const $e8ea6a63d48a4fea$export$73e0df5177988548 = 101;
const $e8ea6a63d48a4fea$export$28e582859cbec660 = 102;
const $e8ea6a63d48a4fea$export$c8c1508da8d0600c = 103;
const $e8ea6a63d48a4fea$export$99948c02fb51055f = 104;
const $e8ea6a63d48a4fea$export$2110f05edf778d3d = 200;
const $e8ea6a63d48a4fea$export$8805bad65e24940e = 201;
const $e8ea6a63d48a4fea$export$7fbe15b28d28cf52 = 202;
const $e8ea6a63d48a4fea$export$947829af9f2c17f6 = 203;
const $e8ea6a63d48a4fea$export$d5773124e86cf28c = 204;
const $e8ea6a63d48a4fea$export$11d468cc7f19e971 = 205;
const $e8ea6a63d48a4fea$export$a78aed1ca2a87192 = 206;
const $e8ea6a63d48a4fea$export$5d0fe17fd8773bac = 207;
const $e8ea6a63d48a4fea$export$ef5f2dd8ffac5574 = 208;
const $e8ea6a63d48a4fea$export$56b85b2686ab16 = 209;
const $e8ea6a63d48a4fea$export$c05e2a1fc8609506 = 210;
const $e8ea6a63d48a4fea$export$69025ce147cee220 = 0;
const $e8ea6a63d48a4fea$export$7182eb52ea3b3f04 = 1;
const $e8ea6a63d48a4fea$export$eedccec66ab7ebe = 2;
const $e8ea6a63d48a4fea$export$296f78a0b892f81a = 3;
const $e8ea6a63d48a4fea$export$a60d398fc7b7590e = 4;
const $e8ea6a63d48a4fea$export$7d7234c1240a1fc4 = 5;
const $e8ea6a63d48a4fea$export$c5e2c52991f30937 = 6;
const $e8ea6a63d48a4fea$export$2f843afa843d8916 = 7;
const $e8ea6a63d48a4fea$export$e50ac29801f1774d = 0;
const $e8ea6a63d48a4fea$export$9f9d94f963c85479 = 1;
const $e8ea6a63d48a4fea$export$e641dc52bc3494aa = 2;
const $e8ea6a63d48a4fea$export$9fcb6b4294603b2 = 0;
const $e8ea6a63d48a4fea$export$98f52c2a46c598ca = 1;
const $e8ea6a63d48a4fea$export$74b25e54b3bcd548 = 2;
const $e8ea6a63d48a4fea$export$932b3dd283d4a366 = 3;
const $e8ea6a63d48a4fea$export$a0d98fe6d7e4af64 = 4;
const $e8ea6a63d48a4fea$export$2c7b09c1e9abfb5e = 5;
const $e8ea6a63d48a4fea$export$1beec6768cbb3d2d = 300;
const $e8ea6a63d48a4fea$export$8759762a6477f2c4 = 301;
const $e8ea6a63d48a4fea$export$dc59f8aed047f61d = 302;
const $e8ea6a63d48a4fea$export$d64030b316d3b087 = 303;
const $e8ea6a63d48a4fea$export$ee99d97d46898098 = 304;
const $e8ea6a63d48a4fea$export$dbf3e70ff37af79 = 306;
const $e8ea6a63d48a4fea$export$533346c8e8dac0f5 = 1000;
const $e8ea6a63d48a4fea$export$9d9334239a5a5e06 = 1001;
const $e8ea6a63d48a4fea$export$c7e7c00b14f51a4f = 1002;
const $e8ea6a63d48a4fea$export$727aa5ec3fe39bf0 = 1003;
const $e8ea6a63d48a4fea$export$d129e38cf6feaa8c = 1004;
const $e8ea6a63d48a4fea$export$14a4936464a36496 = 1004;
const $e8ea6a63d48a4fea$export$d2327c1afe5bfdf2 = 1005;
const $e8ea6a63d48a4fea$export$cbc5b7f5647595d8 = 1005;
const $e8ea6a63d48a4fea$export$8a72f490b25c56c8 = 1006;
const $e8ea6a63d48a4fea$export$19a719f377145a13 = 1007;
const $e8ea6a63d48a4fea$export$dbe96bee3fe9dbf0 = 1007;
const $e8ea6a63d48a4fea$export$5d8599b6a933fb1b = 1008;
const $e8ea6a63d48a4fea$export$90d80f1e3506775f = 1008;
const $e8ea6a63d48a4fea$export$2e8ce08d3f6f5e10 = 1009;
const $e8ea6a63d48a4fea$export$545fce0311a9796a = 1010;
const $e8ea6a63d48a4fea$export$88572337f312435f = 1011;
const $e8ea6a63d48a4fea$export$c63dc51868b06a9d = 1012;
const $e8ea6a63d48a4fea$export$5c612977753abe2 = 1013;
const $e8ea6a63d48a4fea$export$c3c7fc4518ebba96 = 1014;
const $e8ea6a63d48a4fea$export$f6d331659b644596 = 1015;
const $e8ea6a63d48a4fea$export$2697304443f382bc = 1016;
const $e8ea6a63d48a4fea$export$b3969b01faf587f2 = 1017;
const $e8ea6a63d48a4fea$export$18886f8ae33e90de = 1018;
const $e8ea6a63d48a4fea$export$6c8ea339bfab1301 = 1020;
const $e8ea6a63d48a4fea$export$988473390501ed4b = 1021;
const $e8ea6a63d48a4fea$export$3f8bb04b555a363c = 1023;
const $e8ea6a63d48a4fea$export$cc09ccbf6d1ed449 = 1024;
const $e8ea6a63d48a4fea$export$9053a81c4a69c289 = 1025;
const $e8ea6a63d48a4fea$export$c1b6b5136be58045 = 1026;
const $e8ea6a63d48a4fea$export$1e113ac2d0905829 = 1027;
const $e8ea6a63d48a4fea$export$4e041a7967d15c4b = 1028;
const $e8ea6a63d48a4fea$export$aa92e870a709d190 = 1029;
const $e8ea6a63d48a4fea$export$6cdf0b461c7ce8a0 = 1030;
const $e8ea6a63d48a4fea$export$1ba1c45f9f77d4d7 = 1031;
const $e8ea6a63d48a4fea$export$c200e7d26f592f21 = 1033;
const $e8ea6a63d48a4fea$export$21d1799c6d552fc0 = 33776;
const $e8ea6a63d48a4fea$export$afa304c3e981b668 = 33777;
const $e8ea6a63d48a4fea$export$d2a1a68024a3e56c = 33778;
const $e8ea6a63d48a4fea$export$9a79c424327dacf9 = 33779;
const $e8ea6a63d48a4fea$export$19ada9bbb1af3573 = 35840;
const $e8ea6a63d48a4fea$export$d0f0355bb3d948e4 = 35841;
const $e8ea6a63d48a4fea$export$b82296714358084c = 35842;
const $e8ea6a63d48a4fea$export$b71692456c47b6c3 = 35843;
const $e8ea6a63d48a4fea$export$6ab91af2d757aee7 = 36196;
const $e8ea6a63d48a4fea$export$7800993ef8106a6a = 37492;
const $e8ea6a63d48a4fea$export$23ed8300a860e7d8 = 37496;
const $e8ea6a63d48a4fea$export$dc5570b4a2b92d48 = 37808;
const $e8ea6a63d48a4fea$export$68880cd325f8b2fb = 37809;
const $e8ea6a63d48a4fea$export$7d2c0be323373d95 = 37810;
const $e8ea6a63d48a4fea$export$22b52da301fc3a3e = 37811;
const $e8ea6a63d48a4fea$export$c009e2cb4a66485e = 37812;
const $e8ea6a63d48a4fea$export$118fff5afa255b63 = 37813;
const $e8ea6a63d48a4fea$export$120713c829ae0667 = 37814;
const $e8ea6a63d48a4fea$export$c79eeabbf53313e9 = 37815;
const $e8ea6a63d48a4fea$export$443cf6567cdd6424 = 37816;
const $e8ea6a63d48a4fea$export$6573984fc9840780 = 37817;
const $e8ea6a63d48a4fea$export$e7aee563f30091de = 37818;
const $e8ea6a63d48a4fea$export$2eb8634622ddeab7 = 37819;
const $e8ea6a63d48a4fea$export$202b1ce7b5d25742 = 37820;
const $e8ea6a63d48a4fea$export$18ab77abd087e467 = 37821;
const $e8ea6a63d48a4fea$export$ce40b115e188bc81 = 36492;
const $e8ea6a63d48a4fea$export$b1688df4c4c21670 = 36283;
const $e8ea6a63d48a4fea$export$fc15e5d8261eed58 = 36284;
const $e8ea6a63d48a4fea$export$d220f6ade8463a0f = 36285;
const $e8ea6a63d48a4fea$export$768646d09dc1b6ef = 36286;
const $e8ea6a63d48a4fea$export$d62fdc9d1b1cccad = 2200;
const $e8ea6a63d48a4fea$export$dfaf4422ce096e29 = 2201;
const $e8ea6a63d48a4fea$export$f8f6f2041b78e210 = 2202;
const $e8ea6a63d48a4fea$export$995b32462a65e855 = 2300;
const $e8ea6a63d48a4fea$export$30fac1aace31cf4d = 2301;
const $e8ea6a63d48a4fea$export$198b11ff4c72bb30 = 2302;
const $e8ea6a63d48a4fea$export$7f795934b84ab523 = 2400;
const $e8ea6a63d48a4fea$export$24a4ccb5099273b5 = 2401;
const $e8ea6a63d48a4fea$export$8e8c3ecdcd8e1fee = 2402;
const $e8ea6a63d48a4fea$export$bcfbbdcf8de7f8cd = 2500;
const $e8ea6a63d48a4fea$export$d875e029ef558d3 = 2501;
const $e8ea6a63d48a4fea$export$4c28c87c2dc84758 = 0;
const $e8ea6a63d48a4fea$export$b23a071aa286eb29 = 1;
const $e8ea6a63d48a4fea$export$f0d8293634f88842 = 2;
const $e8ea6a63d48a4fea$export$7207336e4151a112 = 3000;
const $e8ea6a63d48a4fea$export$f32388edbb32674 = 3001;
const $e8ea6a63d48a4fea$export$deeb383078690b50 = 3200;
const $e8ea6a63d48a4fea$export$8f910f4c4f73df11 = 3201;
const $e8ea6a63d48a4fea$export$2852a58ebdac27b8 = 0;
const $e8ea6a63d48a4fea$export$9990ad26f9db5b2c = 1;
// Color space string identifiers, matching CSS Color Module Level 4 and WebGPU names where available.
const $e8ea6a63d48a4fea$export$bfcb490c2dd3db51 = "";
const $e8ea6a63d48a4fea$export$561f394b24edfcaa = "srgb";
const $e8ea6a63d48a4fea$export$42429b3acfb233a4 = "srgb-linear";
const $e8ea6a63d48a4fea$export$626af19ae879bdf6 = "display-p3";
const $e8ea6a63d48a4fea$export$69433f11f42d5527 = 0;
const $e8ea6a63d48a4fea$export$9f542ae4b5baca34 = 7680;
const $e8ea6a63d48a4fea$export$8a4f28336ef203d3 = 7681;
const $e8ea6a63d48a4fea$export$2928c0231297c036 = 7682;
const $e8ea6a63d48a4fea$export$c0e9611c8a15f9a8 = 7683;
const $e8ea6a63d48a4fea$export$9c2c08927385dcc4 = 34055;
const $e8ea6a63d48a4fea$export$7c74ea00fa1315e6 = 34056;
const $e8ea6a63d48a4fea$export$22e2e5726612443 = 5386;
const $e8ea6a63d48a4fea$export$1343870698229224 = 512;
const $e8ea6a63d48a4fea$export$8e1d8ed281997fa6 = 513;
const $e8ea6a63d48a4fea$export$55648a1cde8329a7 = 514;
const $e8ea6a63d48a4fea$export$2dff107857e6aca2 = 515;
const $e8ea6a63d48a4fea$export$6f93765ab2f451a2 = 516;
const $e8ea6a63d48a4fea$export$6f3fb2d2440f2b76 = 517;
const $e8ea6a63d48a4fea$export$4119cf7b4c98fd5a = 518;
const $e8ea6a63d48a4fea$export$14cf96713ddd97a8 = 519;
const $e8ea6a63d48a4fea$export$763e8360f4d7f77d = 35044;
const $e8ea6a63d48a4fea$export$8505d14ac8546ca = 35048;
const $e8ea6a63d48a4fea$export$721e63549e51d81e = 35040;
const $e8ea6a63d48a4fea$export$415731dc4f48e299 = 35045;
const $e8ea6a63d48a4fea$export$9e809946455f13bc = 35049;
const $e8ea6a63d48a4fea$export$2ed9499a35b5f832 = 35041;
const $e8ea6a63d48a4fea$export$32ab2503ea19469a = 35046;
const $e8ea6a63d48a4fea$export$ab4022c2c3f86315 = 35050;
const $e8ea6a63d48a4fea$export$ba7f1db36a76a970 = 35042;
const $e8ea6a63d48a4fea$export$43600cc67fabd9f = "100";
const $e8ea6a63d48a4fea$export$f63012db5506e7dd = "300 es";
const $e8ea6a63d48a4fea$export$ca1dce8b5e1de74d = 1035; // fallback for WebGL 1
/**
 * https://github.com/mrdoob/eventdispatcher.js/
 */ class $e8ea6a63d48a4fea$export$ec8b666c5fe2c75a {
    addEventListener(type, listener) {
        if (this._listeners === undefined) this._listeners = {};
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
    }
    hasEventListener(type, listener) {
        if (this._listeners === undefined) return false;
        const listeners = this._listeners;
        return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
    }
    removeEventListener(type, listener) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[type];
        if (listenerArray !== undefined) {
            const index = listenerArray.indexOf(listener);
            if (index !== -1) listenerArray.splice(index, 1);
        }
    }
    dispatchEvent(event) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            // Make a copy, in case listeners are removed while iterating.
            const array = listenerArray.slice(0);
            for(let i = 0, l = array.length; i < l; i++)array[i].call(this, event);
            event.target = null;
        }
    }
}
const $e8ea6a63d48a4fea$var$_lut = [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "0a",
    "0b",
    "0c",
    "0d",
    "0e",
    "0f",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "1a",
    "1b",
    "1c",
    "1d",
    "1e",
    "1f",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "2a",
    "2b",
    "2c",
    "2d",
    "2e",
    "2f",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "3a",
    "3b",
    "3c",
    "3d",
    "3e",
    "3f",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "4a",
    "4b",
    "4c",
    "4d",
    "4e",
    "4f",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59",
    "5a",
    "5b",
    "5c",
    "5d",
    "5e",
    "5f",
    "60",
    "61",
    "62",
    "63",
    "64",
    "65",
    "66",
    "67",
    "68",
    "69",
    "6a",
    "6b",
    "6c",
    "6d",
    "6e",
    "6f",
    "70",
    "71",
    "72",
    "73",
    "74",
    "75",
    "76",
    "77",
    "78",
    "79",
    "7a",
    "7b",
    "7c",
    "7d",
    "7e",
    "7f",
    "80",
    "81",
    "82",
    "83",
    "84",
    "85",
    "86",
    "87",
    "88",
    "89",
    "8a",
    "8b",
    "8c",
    "8d",
    "8e",
    "8f",
    "90",
    "91",
    "92",
    "93",
    "94",
    "95",
    "96",
    "97",
    "98",
    "99",
    "9a",
    "9b",
    "9c",
    "9d",
    "9e",
    "9f",
    "a0",
    "a1",
    "a2",
    "a3",
    "a4",
    "a5",
    "a6",
    "a7",
    "a8",
    "a9",
    "aa",
    "ab",
    "ac",
    "ad",
    "ae",
    "af",
    "b0",
    "b1",
    "b2",
    "b3",
    "b4",
    "b5",
    "b6",
    "b7",
    "b8",
    "b9",
    "ba",
    "bb",
    "bc",
    "bd",
    "be",
    "bf",
    "c0",
    "c1",
    "c2",
    "c3",
    "c4",
    "c5",
    "c6",
    "c7",
    "c8",
    "c9",
    "ca",
    "cb",
    "cc",
    "cd",
    "ce",
    "cf",
    "d0",
    "d1",
    "d2",
    "d3",
    "d4",
    "d5",
    "d6",
    "d7",
    "d8",
    "d9",
    "da",
    "db",
    "dc",
    "dd",
    "de",
    "df",
    "e0",
    "e1",
    "e2",
    "e3",
    "e4",
    "e5",
    "e6",
    "e7",
    "e8",
    "e9",
    "ea",
    "eb",
    "ec",
    "ed",
    "ee",
    "ef",
    "f0",
    "f1",
    "f2",
    "f3",
    "f4",
    "f5",
    "f6",
    "f7",
    "f8",
    "f9",
    "fa",
    "fb",
    "fc",
    "fd",
    "fe",
    "ff"
];
let $e8ea6a63d48a4fea$var$_seed = 1234567;
const $e8ea6a63d48a4fea$var$DEG2RAD = Math.PI / 180;
const $e8ea6a63d48a4fea$var$RAD2DEG = 180 / Math.PI;
// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
function $e8ea6a63d48a4fea$var$generateUUID() {
    const d0 = Math.random() * 0xffffffff | 0;
    const d1 = Math.random() * 0xffffffff | 0;
    const d2 = Math.random() * 0xffffffff | 0;
    const d3 = Math.random() * 0xffffffff | 0;
    const uuid = $e8ea6a63d48a4fea$var$_lut[d0 & 0xff] + $e8ea6a63d48a4fea$var$_lut[d0 >> 8 & 0xff] + $e8ea6a63d48a4fea$var$_lut[d0 >> 16 & 0xff] + $e8ea6a63d48a4fea$var$_lut[d0 >> 24 & 0xff] + "-" + $e8ea6a63d48a4fea$var$_lut[d1 & 0xff] + $e8ea6a63d48a4fea$var$_lut[d1 >> 8 & 0xff] + "-" + $e8ea6a63d48a4fea$var$_lut[d1 >> 16 & 0x0f | 0x40] + $e8ea6a63d48a4fea$var$_lut[d1 >> 24 & 0xff] + "-" + $e8ea6a63d48a4fea$var$_lut[d2 & 0x3f | 0x80] + $e8ea6a63d48a4fea$var$_lut[d2 >> 8 & 0xff] + "-" + $e8ea6a63d48a4fea$var$_lut[d2 >> 16 & 0xff] + $e8ea6a63d48a4fea$var$_lut[d2 >> 24 & 0xff] + $e8ea6a63d48a4fea$var$_lut[d3 & 0xff] + $e8ea6a63d48a4fea$var$_lut[d3 >> 8 & 0xff] + $e8ea6a63d48a4fea$var$_lut[d3 >> 16 & 0xff] + $e8ea6a63d48a4fea$var$_lut[d3 >> 24 & 0xff];
    // .toLowerCase() here flattens concatenated strings to save heap memory space.
    return uuid.toLowerCase();
}
function $e8ea6a63d48a4fea$var$clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
// compute euclidean modulo of m % n
// https://en.wikipedia.org/wiki/Modulo_operation
function $e8ea6a63d48a4fea$var$euclideanModulo(n, m) {
    return (n % m + m) % m;
}
// Linear mapping from range <a1, a2> to range <b1, b2>
function $e8ea6a63d48a4fea$var$mapLinear(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
// https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
function $e8ea6a63d48a4fea$var$inverseLerp(x, y, value) {
    if (x !== y) return (value - x) / (y - x);
    else return 0;
}
// https://en.wikipedia.org/wiki/Linear_interpolation
function $e8ea6a63d48a4fea$var$lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
// http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/
function $e8ea6a63d48a4fea$var$damp(x, y, lambda, dt) {
    return $e8ea6a63d48a4fea$var$lerp(x, y, 1 - Math.exp(-lambda * dt));
}
// https://www.desmos.com/calculator/vcsjnyz7x4
function $e8ea6a63d48a4fea$var$pingpong(x, length = 1) {
    return length - Math.abs($e8ea6a63d48a4fea$var$euclideanModulo(x, length * 2) - length);
}
// http://en.wikipedia.org/wiki/Smoothstep
function $e8ea6a63d48a4fea$var$smoothstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
}
function $e8ea6a63d48a4fea$var$smootherstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
// Random integer from <low, high> interval
function $e8ea6a63d48a4fea$var$randInt(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
}
// Random float from <low, high> interval
function $e8ea6a63d48a4fea$var$randFloat(low, high) {
    return low + Math.random() * (high - low);
}
// Random float from <-range/2, range/2> interval
function $e8ea6a63d48a4fea$var$randFloatSpread(range) {
    return range * (0.5 - Math.random());
}
// Deterministic pseudo-random float in the interval [ 0, 1 ]
function $e8ea6a63d48a4fea$var$seededRandom(s) {
    if (s !== undefined) $e8ea6a63d48a4fea$var$_seed = s;
    // Mulberry32 generator
    let t = $e8ea6a63d48a4fea$var$_seed += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
}
function $e8ea6a63d48a4fea$var$degToRad(degrees) {
    return degrees * $e8ea6a63d48a4fea$var$DEG2RAD;
}
function $e8ea6a63d48a4fea$var$radToDeg(radians) {
    return radians * $e8ea6a63d48a4fea$var$RAD2DEG;
}
function $e8ea6a63d48a4fea$var$isPowerOfTwo(value) {
    return (value & value - 1) === 0 && value !== 0;
}
function $e8ea6a63d48a4fea$var$ceilPowerOfTwo(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
function $e8ea6a63d48a4fea$var$floorPowerOfTwo(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
function $e8ea6a63d48a4fea$var$setQuaternionFromProperEuler(q, a, b, c, order) {
    // Intrinsic Proper Euler Angles - see https://en.wikipedia.org/wiki/Euler_angles
    // rotations are applied to the axes in the order specified by 'order'
    // rotation by angle 'a' is applied first, then by angle 'b', then by angle 'c'
    // angles are in radians
    const cos = Math.cos;
    const sin = Math.sin;
    const c2 = cos(b / 2);
    const s2 = sin(b / 2);
    const c13 = cos((a + c) / 2);
    const s13 = sin((a + c) / 2);
    const c1_3 = cos((a - c) / 2);
    const s1_3 = sin((a - c) / 2);
    const c3_1 = cos((c - a) / 2);
    const s3_1 = sin((c - a) / 2);
    switch(order){
        case "XYX":
            q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
            break;
        case "YZY":
            q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
            break;
        case "ZXZ":
            q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
            break;
        case "XZX":
            q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
            break;
        case "YXY":
            q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
            break;
        case "ZYZ":
            q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
            break;
        default:
            console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + order);
    }
}
function $e8ea6a63d48a4fea$var$denormalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint16Array:
            return value / 65535.0;
        case Uint8Array:
            return value / 255.0;
        case Int16Array:
            return Math.max(value / 32767.0, -1);
        case Int8Array:
            return Math.max(value / 127.0, -1);
        default:
            throw new Error("Invalid component type.");
    }
}
function $e8ea6a63d48a4fea$var$normalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint16Array:
            return Math.round(value * 65535.0);
        case Uint8Array:
            return Math.round(value * 255.0);
        case Int16Array:
            return Math.round(value * 32767.0);
        case Int8Array:
            return Math.round(value * 127.0);
        default:
            throw new Error("Invalid component type.");
    }
}
const $e8ea6a63d48a4fea$export$6a7ef315a0d1ef07 = {
    DEG2RAD: $e8ea6a63d48a4fea$var$DEG2RAD,
    RAD2DEG: $e8ea6a63d48a4fea$var$RAD2DEG,
    generateUUID: $e8ea6a63d48a4fea$var$generateUUID,
    clamp: $e8ea6a63d48a4fea$var$clamp,
    euclideanModulo: $e8ea6a63d48a4fea$var$euclideanModulo,
    mapLinear: $e8ea6a63d48a4fea$var$mapLinear,
    inverseLerp: $e8ea6a63d48a4fea$var$inverseLerp,
    lerp: $e8ea6a63d48a4fea$var$lerp,
    damp: $e8ea6a63d48a4fea$var$damp,
    pingpong: $e8ea6a63d48a4fea$var$pingpong,
    smoothstep: $e8ea6a63d48a4fea$var$smoothstep,
    smootherstep: $e8ea6a63d48a4fea$var$smootherstep,
    randInt: $e8ea6a63d48a4fea$var$randInt,
    randFloat: $e8ea6a63d48a4fea$var$randFloat,
    randFloatSpread: $e8ea6a63d48a4fea$var$randFloatSpread,
    seededRandom: $e8ea6a63d48a4fea$var$seededRandom,
    degToRad: $e8ea6a63d48a4fea$var$degToRad,
    radToDeg: $e8ea6a63d48a4fea$var$radToDeg,
    isPowerOfTwo: $e8ea6a63d48a4fea$var$isPowerOfTwo,
    ceilPowerOfTwo: $e8ea6a63d48a4fea$var$ceilPowerOfTwo,
    floorPowerOfTwo: $e8ea6a63d48a4fea$var$floorPowerOfTwo,
    setQuaternionFromProperEuler: $e8ea6a63d48a4fea$var$setQuaternionFromProperEuler,
    normalize: $e8ea6a63d48a4fea$var$normalize,
    denormalize: $e8ea6a63d48a4fea$var$denormalize
};
class $e8ea6a63d48a4fea$export$c977b3e384af9ae1 {
    constructor(x = 0, y = 0){
        $e8ea6a63d48a4fea$export$c977b3e384af9ae1.prototype.isVector2 = true;
        this.x = x;
        this.y = y;
    }
    get width() {
        return this.x;
    }
    set width(value) {
        this.x = value;
    }
    get height() {
        return this.y;
    }
    set height(value) {
        this.y = value;
    }
    set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            default:
                throw new Error("index is out of range: " + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error("index is out of range: " + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6];
        this.y = e[1] * x + e[4] * y + e[7];
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y;
    }
    cross(v) {
        return this.x * v.y - this.y * v.x;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    angle() {
        // computes the angle in radians with respect to the positive x-axis
        const angle = Math.atan2(-this.y, -this.x) + Math.PI;
        return angle;
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($e8ea6a63d48a4fea$var$clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y;
        return dx * dx + dy * dy;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        return this;
    }
    rotateAround(center, angle) {
        const c = Math.cos(angle), s = Math.sin(angle);
        const x = this.x - center.x;
        const y = this.y - center.y;
        this.x = x * c - y * s + center.x;
        this.y = x * s + y * c + center.y;
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
    }
}
class $e8ea6a63d48a4fea$export$8ff26dafa08918 {
    constructor(){
        $e8ea6a63d48a4fea$export$8ff26dafa08918.prototype.isMatrix3 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
    }
    set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
        const te = this.elements;
        te[0] = n11;
        te[1] = n21;
        te[2] = n31;
        te[3] = n12;
        te[4] = n22;
        te[5] = n32;
        te[6] = n13;
        te[7] = n23;
        te[8] = n33;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
        return this;
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrix3Column(this, 0);
        yAxis.setFromMatrix3Column(this, 1);
        zAxis.setFromMatrix3Column(this, 2);
        return this;
    }
    setFromMatrix4(m) {
        const me = m.elements;
        this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[3], a13 = ae[6];
        const a21 = ae[1], a22 = ae[4], a23 = ae[7];
        const a31 = ae[2], a32 = ae[5], a33 = ae[8];
        const b11 = be[0], b12 = be[3], b13 = be[6];
        const b21 = be[1], b22 = be[4], b23 = be[7];
        const b31 = be[2], b32 = be[5], b33 = be[8];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31;
        te[3] = a11 * b12 + a12 * b22 + a13 * b32;
        te[6] = a11 * b13 + a12 * b23 + a13 * b33;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31;
        te[4] = a21 * b12 + a22 * b22 + a23 * b32;
        te[7] = a21 * b13 + a22 * b23 + a23 * b33;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31;
        te[5] = a31 * b12 + a32 * b22 + a33 * b32;
        te[8] = a31 * b13 + a32 * b23 + a33 * b33;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[3] *= s;
        te[6] *= s;
        te[1] *= s;
        te[4] *= s;
        te[7] *= s;
        te[2] *= s;
        te[5] *= s;
        te[8] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
        return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    }
    invert() {
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n31 * n23 - n33 * n21) * detInv;
        te[2] = (n32 * n21 - n31 * n22) * detInv;
        te[3] = t12 * detInv;
        te[4] = (n33 * n11 - n31 * n13) * detInv;
        te[5] = (n31 * n12 - n32 * n11) * detInv;
        te[6] = t13 * detInv;
        te[7] = (n21 * n13 - n23 * n11) * detInv;
        te[8] = (n22 * n11 - n21 * n12) * detInv;
        return this;
    }
    transpose() {
        let tmp;
        const m = this.elements;
        tmp = m[1];
        m[1] = m[3];
        m[3] = tmp;
        tmp = m[2];
        m[2] = m[6];
        m[6] = tmp;
        tmp = m[5];
        m[5] = m[7];
        m[7] = tmp;
        return this;
    }
    getNormalMatrix(matrix4) {
        return this.setFromMatrix4(matrix4).invert().transpose();
    }
    transposeIntoArray(r) {
        const m = this.elements;
        r[0] = m[0];
        r[1] = m[3];
        r[2] = m[6];
        r[3] = m[1];
        r[4] = m[4];
        r[5] = m[7];
        r[6] = m[2];
        r[7] = m[5];
        r[8] = m[8];
        return this;
    }
    setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
        const c = Math.cos(rotation);
        const s = Math.sin(rotation);
        this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
        return this;
    }
    //
    scale(sx, sy) {
        this.premultiply($e8ea6a63d48a4fea$var$_m3.makeScale(sx, sy));
        return this;
    }
    rotate(theta) {
        this.premultiply($e8ea6a63d48a4fea$var$_m3.makeRotation(-theta));
        return this;
    }
    translate(tx, ty) {
        this.premultiply($e8ea6a63d48a4fea$var$_m3.makeTranslation(tx, ty));
        return this;
    }
    // for 2D Transforms
    makeTranslation(x, y) {
        this.set(1, 0, x, 0, 1, y, 0, 0, 1);
        return this;
    }
    makeRotation(theta) {
        // counterclockwise
        const c = Math.cos(theta);
        const s = Math.sin(theta);
        this.set(c, -s, 0, s, c, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y) {
        this.set(x, 0, 0, 0, y, 0, 0, 0, 1);
        return this;
    }
    //
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 9; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 9; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        return array;
    }
    clone() {
        return new this.constructor().fromArray(this.elements);
    }
}
const $e8ea6a63d48a4fea$var$_m3 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$8ff26dafa08918();
function $e8ea6a63d48a4fea$var$arrayNeedsUint32(array) {
    // assumes larger values usually on last
    for(let i = array.length - 1; i >= 0; --i){
        if (array[i] >= 65535) return true; // account for PRIMITIVE_RESTART_FIXED_INDEX, #24565
    }
    return false;
}
const $e8ea6a63d48a4fea$var$TYPED_ARRAYS = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function $e8ea6a63d48a4fea$var$getTypedArray(type, buffer) {
    return new $e8ea6a63d48a4fea$var$TYPED_ARRAYS[type](buffer);
}
function $e8ea6a63d48a4fea$var$createElementNS(name) {
    return document.createElementNS("http://www.w3.org/1999/xhtml", name);
}
function $e8ea6a63d48a4fea$var$SRGBToLinear(c) {
    return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function $e8ea6a63d48a4fea$var$LinearToSRGB(c) {
    return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
/**
 * Matrices converting P3 <-> Rec. 709 primaries, without gamut mapping
 * or clipping. Based on W3C specifications for sRGB and Display P3,
 * and ICC specifications for the D50 connection space. Values in/out
 * are _linear_ sRGB and _linear_ Display P3.
 *
 * Note that both sRGB and Display P3 use the sRGB transfer functions.
 *
 * Reference:
 * - http://www.russellcottrell.com/photo/matrixCalculator.htm
 */ const $e8ea6a63d48a4fea$var$LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$8ff26dafa08918().fromArray([
    0.8224621,
    0.0331941,
    0.0170827,
    0.1775380,
    0.9668058,
    0.0723974,
    -0.0000001,
    0.0000001,
    0.9105199
]);
const $e8ea6a63d48a4fea$var$LINEAR_DISPLAY_P3_TO_LINEAR_SRGB = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$8ff26dafa08918().fromArray([
    1.2249401,
    -0.0420569,
    -0.0196376,
    -0.2249404,
    1.0420571,
    -0.0786361,
    0.0000001,
    0.0000000,
    1.0982735
]);
function $e8ea6a63d48a4fea$var$DisplayP3ToLinearSRGB(color) {
    // Display P3 uses the sRGB transfer functions
    return color.convertSRGBToLinear().applyMatrix3($e8ea6a63d48a4fea$var$LINEAR_DISPLAY_P3_TO_LINEAR_SRGB);
}
function $e8ea6a63d48a4fea$var$LinearSRGBToDisplayP3(color) {
    // Display P3 uses the sRGB transfer functions
    return color.applyMatrix3($e8ea6a63d48a4fea$var$LINEAR_SRGB_TO_LINEAR_DISPLAY_P3).convertLinearToSRGB();
}
// Conversions from <source> to Linear-sRGB reference space.
const $e8ea6a63d48a4fea$var$TO_LINEAR = {
    [$e8ea6a63d48a4fea$export$42429b3acfb233a4]: (color)=>color,
    [$e8ea6a63d48a4fea$export$561f394b24edfcaa]: (color)=>color.convertSRGBToLinear(),
    [$e8ea6a63d48a4fea$export$626af19ae879bdf6]: $e8ea6a63d48a4fea$var$DisplayP3ToLinearSRGB
};
// Conversions to <target> from Linear-sRGB reference space.
const $e8ea6a63d48a4fea$var$FROM_LINEAR = {
    [$e8ea6a63d48a4fea$export$42429b3acfb233a4]: (color)=>color,
    [$e8ea6a63d48a4fea$export$561f394b24edfcaa]: (color)=>color.convertLinearToSRGB(),
    [$e8ea6a63d48a4fea$export$626af19ae879bdf6]: $e8ea6a63d48a4fea$var$LinearSRGBToDisplayP3
};
const $e8ea6a63d48a4fea$export$5e6fd513f44698c = {
    enabled: false,
    get legacyMode () {
        console.warn("THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150.");
        return !this.enabled;
    },
    set legacyMode (legacyMode){
        console.warn("THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150.");
        this.enabled = !legacyMode;
    },
    get workingColorSpace () {
        return $e8ea6a63d48a4fea$export$42429b3acfb233a4;
    },
    set workingColorSpace (colorSpace){
        console.warn("THREE.ColorManagement: .workingColorSpace is readonly.");
    },
    convert: function(color, sourceColorSpace, targetColorSpace) {
        if (this.enabled === false || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) return color;
        const sourceToLinear = $e8ea6a63d48a4fea$var$TO_LINEAR[sourceColorSpace];
        const targetFromLinear = $e8ea6a63d48a4fea$var$FROM_LINEAR[targetColorSpace];
        if (sourceToLinear === undefined || targetFromLinear === undefined) throw new Error(`Unsupported color space conversion, "${sourceColorSpace}" to "${targetColorSpace}".`);
        return targetFromLinear(sourceToLinear(color));
    },
    fromWorkingColorSpace: function(color, targetColorSpace) {
        return this.convert(color, this.workingColorSpace, targetColorSpace);
    },
    toWorkingColorSpace: function(color, sourceColorSpace) {
        return this.convert(color, sourceColorSpace, this.workingColorSpace);
    }
};
let $e8ea6a63d48a4fea$var$_canvas;
class $e8ea6a63d48a4fea$export$698882cf06df44aa {
    static getDataURL(image) {
        if (/^data:/i.test(image.src)) return image.src;
        if (typeof HTMLCanvasElement === "undefined") return image.src;
        let canvas;
        if (image instanceof HTMLCanvasElement) canvas = image;
        else {
            if ($e8ea6a63d48a4fea$var$_canvas === undefined) $e8ea6a63d48a4fea$var$_canvas = $e8ea6a63d48a4fea$var$createElementNS("canvas");
            $e8ea6a63d48a4fea$var$_canvas.width = image.width;
            $e8ea6a63d48a4fea$var$_canvas.height = image.height;
            const context = $e8ea6a63d48a4fea$var$_canvas.getContext("2d");
            if (image instanceof ImageData) context.putImageData(image, 0, 0);
            else context.drawImage(image, 0, 0, image.width, image.height);
            canvas = $e8ea6a63d48a4fea$var$_canvas;
        }
        if (canvas.width > 2048 || canvas.height > 2048) {
            console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", image);
            return canvas.toDataURL("image/jpeg", 0.6);
        } else return canvas.toDataURL("image/png");
    }
    static sRGBToLinear(image) {
        if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
            const canvas = $e8ea6a63d48a4fea$var$createElementNS("canvas");
            canvas.width = image.width;
            canvas.height = image.height;
            const context = canvas.getContext("2d");
            context.drawImage(image, 0, 0, image.width, image.height);
            const imageData = context.getImageData(0, 0, image.width, image.height);
            const data = imageData.data;
            for(let i = 0; i < data.length; i++)data[i] = $e8ea6a63d48a4fea$var$SRGBToLinear(data[i] / 255) * 255;
            context.putImageData(imageData, 0, 0);
            return canvas;
        } else if (image.data) {
            const data = image.data.slice(0);
            for(let i = 0; i < data.length; i++)if (data instanceof Uint8Array || data instanceof Uint8ClampedArray) data[i] = Math.floor($e8ea6a63d48a4fea$var$SRGBToLinear(data[i] / 255) * 255);
            else // assuming float
            data[i] = $e8ea6a63d48a4fea$var$SRGBToLinear(data[i]);
            return {
                data: data,
                width: image.width,
                height: image.height
            };
        } else {
            console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.");
            return image;
        }
    }
}
class $e8ea6a63d48a4fea$export$1d2df86270c81ecb {
    constructor(data = null){
        this.isSource = true;
        this.uuid = $e8ea6a63d48a4fea$var$generateUUID();
        this.data = data;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === "string";
        if (!isRootObject && meta.images[this.uuid] !== undefined) return meta.images[this.uuid];
        const output = {
            uuid: this.uuid,
            url: ""
        };
        const data = this.data;
        if (data !== null) {
            let url;
            if (Array.isArray(data)) {
                // cube texture
                url = [];
                for(let i = 0, l = data.length; i < l; i++)if (data[i].isDataTexture) url.push($e8ea6a63d48a4fea$var$serializeImage(data[i].image));
                else url.push($e8ea6a63d48a4fea$var$serializeImage(data[i]));
            } else // texture
            url = $e8ea6a63d48a4fea$var$serializeImage(data);
            output.url = url;
        }
        if (!isRootObject) meta.images[this.uuid] = output;
        return output;
    }
}
function $e8ea6a63d48a4fea$var$serializeImage(image) {
    if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) // default images
    return $e8ea6a63d48a4fea$export$698882cf06df44aa.getDataURL(image);
    else {
        if (image.data) // images of DataTexture
        return {
            data: Array.from(image.data),
            width: image.width,
            height: image.height,
            type: image.data.constructor.name
        };
        else {
            console.warn("THREE.Texture: Unable to serialize Texture.");
            return {};
        }
    }
}
let $e8ea6a63d48a4fea$var$textureId = 0;
class $e8ea6a63d48a4fea$export$5431306cf43de24a extends $e8ea6a63d48a4fea$export$ec8b666c5fe2c75a {
    constructor(image = $e8ea6a63d48a4fea$export$5431306cf43de24a.DEFAULT_IMAGE, mapping = $e8ea6a63d48a4fea$export$5431306cf43de24a.DEFAULT_MAPPING, wrapS = $e8ea6a63d48a4fea$export$9d9334239a5a5e06, wrapT = $e8ea6a63d48a4fea$export$9d9334239a5a5e06, magFilter = $e8ea6a63d48a4fea$export$8a72f490b25c56c8, minFilter = $e8ea6a63d48a4fea$export$5d8599b6a933fb1b, format = $e8ea6a63d48a4fea$export$3f8bb04b555a363c, type = $e8ea6a63d48a4fea$export$2e8ce08d3f6f5e10, anisotropy = $e8ea6a63d48a4fea$export$5431306cf43de24a.DEFAULT_ANISOTROPY, encoding = $e8ea6a63d48a4fea$export$7207336e4151a112){
        super();
        this.isTexture = true;
        Object.defineProperty(this, "id", {
            value: $e8ea6a63d48a4fea$var$textureId++
        });
        this.uuid = $e8ea6a63d48a4fea$var$generateUUID();
        this.name = "";
        this.source = new $e8ea6a63d48a4fea$export$1d2df86270c81ecb(image);
        this.mipmaps = [];
        this.mapping = mapping;
        this.channel = 0;
        this.wrapS = wrapS;
        this.wrapT = wrapT;
        this.magFilter = magFilter;
        this.minFilter = minFilter;
        this.anisotropy = anisotropy;
        this.format = format;
        this.internalFormat = null;
        this.type = type;
        this.offset = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(0, 0);
        this.repeat = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(1, 1);
        this.center = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(0, 0);
        this.rotation = 0;
        this.matrixAutoUpdate = true;
        this.matrix = new $e8ea6a63d48a4fea$export$8ff26dafa08918();
        this.generateMipmaps = true;
        this.premultiplyAlpha = false;
        this.flipY = true;
        this.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
        // Values of encoding !== THREE.LinearEncoding only supported on map, envMap and emissiveMap.
        //
        // Also changing the encoding after already used by a Material will not automatically make the Material
        // update. You need to explicitly call Material.needsUpdate to trigger it to recompile.
        this.encoding = encoding;
        this.userData = {};
        this.version = 0;
        this.onUpdate = null;
        this.isRenderTargetTexture = false; // indicates whether a texture belongs to a render target or not
        this.needsPMREMUpdate = false; // indicates whether this texture should be processed by PMREMGenerator or not (only relevant for render target textures)
    }
    get image() {
        return this.source.data;
    }
    set image(value = null) {
        this.source.data = value;
    }
    updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.source = source.source;
        this.mipmaps = source.mipmaps.slice(0);
        this.mapping = source.mapping;
        this.channel = source.channel;
        this.wrapS = source.wrapS;
        this.wrapT = source.wrapT;
        this.magFilter = source.magFilter;
        this.minFilter = source.minFilter;
        this.anisotropy = source.anisotropy;
        this.format = source.format;
        this.internalFormat = source.internalFormat;
        this.type = source.type;
        this.offset.copy(source.offset);
        this.repeat.copy(source.repeat);
        this.center.copy(source.center);
        this.rotation = source.rotation;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrix.copy(source.matrix);
        this.generateMipmaps = source.generateMipmaps;
        this.premultiplyAlpha = source.premultiplyAlpha;
        this.flipY = source.flipY;
        this.unpackAlignment = source.unpackAlignment;
        this.encoding = source.encoding;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        this.needsUpdate = true;
        return this;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === "string";
        if (!isRootObject && meta.textures[this.uuid] !== undefined) return meta.textures[this.uuid];
        const output = {
            metadata: {
                version: 4.5,
                type: "Texture",
                generator: "Texture.toJSON"
            },
            uuid: this.uuid,
            name: this.name,
            image: this.source.toJSON(meta).uuid,
            mapping: this.mapping,
            channel: this.channel,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            internalFormat: this.internalFormat,
            type: this.type,
            encoding: this.encoding,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            generateMipmaps: this.generateMipmaps,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        if (Object.keys(this.userData).length > 0) output.userData = this.userData;
        if (!isRootObject) meta.textures[this.uuid] = output;
        return output;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    transformUv(uv) {
        if (this.mapping !== $e8ea6a63d48a4fea$export$1beec6768cbb3d2d) return uv;
        uv.applyMatrix3(this.matrix);
        if (uv.x < 0 || uv.x > 1) switch(this.wrapS){
            case $e8ea6a63d48a4fea$export$533346c8e8dac0f5:
                uv.x = uv.x - Math.floor(uv.x);
                break;
            case $e8ea6a63d48a4fea$export$9d9334239a5a5e06:
                uv.x = uv.x < 0 ? 0 : 1;
                break;
            case $e8ea6a63d48a4fea$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.x) % 2) === 1) uv.x = Math.ceil(uv.x) - uv.x;
                else uv.x = uv.x - Math.floor(uv.x);
                break;
        }
        if (uv.y < 0 || uv.y > 1) switch(this.wrapT){
            case $e8ea6a63d48a4fea$export$533346c8e8dac0f5:
                uv.y = uv.y - Math.floor(uv.y);
                break;
            case $e8ea6a63d48a4fea$export$9d9334239a5a5e06:
                uv.y = uv.y < 0 ? 0 : 1;
                break;
            case $e8ea6a63d48a4fea$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.y) % 2) === 1) uv.y = Math.ceil(uv.y) - uv.y;
                else uv.y = uv.y - Math.floor(uv.y);
                break;
        }
        if (this.flipY) uv.y = 1 - uv.y;
        return uv;
    }
    set needsUpdate(value) {
        if (value === true) {
            this.version++;
            this.source.needsUpdate = true;
        }
    }
}
$e8ea6a63d48a4fea$export$5431306cf43de24a.DEFAULT_IMAGE = null;
$e8ea6a63d48a4fea$export$5431306cf43de24a.DEFAULT_MAPPING = $e8ea6a63d48a4fea$export$1beec6768cbb3d2d;
$e8ea6a63d48a4fea$export$5431306cf43de24a.DEFAULT_ANISOTROPY = 1;
class $e8ea6a63d48a4fea$export$fa7daccca11cdbe3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        $e8ea6a63d48a4fea$export$fa7daccca11cdbe3.prototype.isVector4 = true;
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
    }
    get width() {
        return this.z;
    }
    set width(value) {
        this.z = value;
    }
    get height() {
        return this.w;
    }
    set height(value) {
        this.w = value;
    }
    set(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        this.w = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setW(w) {
        this.w = w;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            case 3:
                this.w = value;
                break;
            default:
                throw new Error("index is out of range: " + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error("index is out of range: " + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        this.w = v.w !== undefined ? v.w : 1;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        this.w += v.w;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        this.w += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        this.w = a.w + b.w;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        this.w += v.w * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        this.w -= v.w;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        this.w -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        this.w = a.w - b.w;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        this.w *= v.w;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        this.w *= scalar;
        return this;
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z, w = this.w;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
        this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
        this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
        this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    setAxisAngleFromQuaternion(q) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
        // q is assumed to be normalized
        this.w = 2 * Math.acos(q.w);
        const s = Math.sqrt(1 - q.w * q.w);
        if (s < 0.0001) {
            this.x = 1;
            this.y = 0;
            this.z = 0;
        } else {
            this.x = q.x / s;
            this.y = q.y / s;
            this.z = q.z / s;
        }
        return this;
    }
    setAxisAngleFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        let angle, x, y, z; // variables for result
        const epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
        if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
            // singularity found
            // first check for identity matrix which must have +1 for all terms
            // in leading diagonal and zero in other terms
            if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
                // this singularity is identity matrix so angle = 0
                this.set(1, 0, 0, 0);
                return this; // zero angle, arbitrary axis
            }
            // otherwise this singularity is angle = 180
            angle = Math.PI;
            const xx = (m11 + 1) / 2;
            const yy = (m22 + 1) / 2;
            const zz = (m33 + 1) / 2;
            const xy = (m12 + m21) / 4;
            const xz = (m13 + m31) / 4;
            const yz = (m23 + m32) / 4;
            if (xx > yy && xx > zz) {
                // m11 is the largest diagonal term
                if (xx < epsilon) {
                    x = 0;
                    y = 0.707106781;
                    z = 0.707106781;
                } else {
                    x = Math.sqrt(xx);
                    y = xy / x;
                    z = xz / x;
                }
            } else if (yy > zz) {
                // m22 is the largest diagonal term
                if (yy < epsilon) {
                    x = 0.707106781;
                    y = 0;
                    z = 0.707106781;
                } else {
                    y = Math.sqrt(yy);
                    x = xy / y;
                    z = yz / y;
                }
            } else // m33 is the largest diagonal term so base result on this
            if (zz < epsilon) {
                x = 0.707106781;
                y = 0.707106781;
                z = 0;
            } else {
                z = Math.sqrt(zz);
                x = xz / z;
                y = yz / z;
            }
            this.set(x, y, z, angle);
            return this; // return 180 deg rotation
        }
        // as we have reached here there are no singularities so we can handle normally
        let s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize
        if (Math.abs(s) < 0.001) s = 1;
        // prevent divide by zero, should not happen if matrix is orthogonal and should be
        // caught by singularity test above, but I've left it in just in case
        this.x = (m32 - m23) / s;
        this.y = (m13 - m31) / s;
        this.z = (m21 - m12) / s;
        this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        this.w = Math.min(this.w, v.w);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        this.w = Math.max(this.w, v.w);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        this.w = Math.max(min.w, Math.min(max.w, this.w));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        this.w = Math.max(minVal, Math.min(maxVal, this.w));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        this.w = Math.floor(this.w);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        this.w = Math.ceil(this.w);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        this.w = Math.round(this.w);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
        this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        this.w = -this.w;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        this.w += (v.w - this.w) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        this.w = v1.w + (v2.w - v1.w) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        this.w = array[offset + 3];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        array[offset + 3] = this.w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        this.w = attribute.getW(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        this.w = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
        yield this.w;
    }
}
/*
 In options, we can specify:
 * Texture parameters for an auto-generated target texture
 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
*/ class $e8ea6a63d48a4fea$export$3c052beb2e51e23f extends $e8ea6a63d48a4fea$export$ec8b666c5fe2c75a {
    constructor(width = 1, height = 1, options = {}){
        super();
        this.isWebGLRenderTarget = true;
        this.width = width;
        this.height = height;
        this.depth = 1;
        this.scissor = new $e8ea6a63d48a4fea$export$fa7daccca11cdbe3(0, 0, width, height);
        this.scissorTest = false;
        this.viewport = new $e8ea6a63d48a4fea$export$fa7daccca11cdbe3(0, 0, width, height);
        const image = {
            width: width,
            height: height,
            depth: 1
        };
        this.texture = new $e8ea6a63d48a4fea$export$5431306cf43de24a(image, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding);
        this.texture.isRenderTargetTexture = true;
        this.texture.flipY = false;
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.internalFormat = options.internalFormat !== undefined ? options.internalFormat : null;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $e8ea6a63d48a4fea$export$8a72f490b25c56c8;
        this.depthBuffer = options.depthBuffer !== undefined ? options.depthBuffer : true;
        this.stencilBuffer = options.stencilBuffer !== undefined ? options.stencilBuffer : false;
        this.depthTexture = options.depthTexture !== undefined ? options.depthTexture : null;
        this.samples = options.samples !== undefined ? options.samples : 0;
    }
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            this.texture.image.width = width;
            this.texture.image.height = height;
            this.texture.image.depth = depth;
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.viewport.copy(source.viewport);
        this.texture = source.texture.clone();
        this.texture.isRenderTargetTexture = true;
        // ensure image object is not shared, see #20328
        const image = Object.assign({}, source.texture.image);
        this.texture.source = new $e8ea6a63d48a4fea$export$1d2df86270c81ecb(image);
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.samples = source.samples;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
class $e8ea6a63d48a4fea$export$dfac6c8e811406a3 extends $e8ea6a63d48a4fea$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        super(null);
        this.isDataArrayTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $e8ea6a63d48a4fea$export$727aa5ec3fe39bf0;
        this.minFilter = $e8ea6a63d48a4fea$export$727aa5ec3fe39bf0;
        this.wrapR = $e8ea6a63d48a4fea$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
class $e8ea6a63d48a4fea$export$c77a02c11ed180c7 extends $e8ea6a63d48a4fea$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, depth = 1){
        super(width, height);
        this.isWebGLArrayRenderTarget = true;
        this.depth = depth;
        this.texture = new $e8ea6a63d48a4fea$export$dfac6c8e811406a3(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $e8ea6a63d48a4fea$export$d7a3086320f856db extends $e8ea6a63d48a4fea$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        // We're going to add .setXXX() methods for setting properties later.
        // Users can still set in DataTexture3D directly.
        //
        //	const texture = new THREE.DataTexture3D( data, width, height, depth );
        // 	texture.anisotropy = 16;
        //
        // See #14839
        super(null);
        this.isData3DTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $e8ea6a63d48a4fea$export$727aa5ec3fe39bf0;
        this.minFilter = $e8ea6a63d48a4fea$export$727aa5ec3fe39bf0;
        this.wrapR = $e8ea6a63d48a4fea$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
class $e8ea6a63d48a4fea$export$7ee06591009639df extends $e8ea6a63d48a4fea$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, depth = 1){
        super(width, height);
        this.isWebGL3DRenderTarget = true;
        this.depth = depth;
        this.texture = new $e8ea6a63d48a4fea$export$d7a3086320f856db(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $e8ea6a63d48a4fea$export$bd934554fb721730 extends $e8ea6a63d48a4fea$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, count = 1, options = {}){
        super(width, height, options);
        this.isWebGLMultipleRenderTargets = true;
        const texture = this.texture;
        this.texture = [];
        for(let i = 0; i < count; i++){
            this.texture[i] = texture.clone();
            this.texture[i].isRenderTargetTexture = true;
        }
    }
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            for(let i = 0, il = this.texture.length; i < il; i++){
                this.texture[i].image.width = width;
                this.texture[i].image.height = height;
                this.texture[i].image.depth = depth;
            }
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
        return this;
    }
    copy(source) {
        this.dispose();
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.viewport.set(0, 0, this.width, this.height);
        this.scissor.set(0, 0, this.width, this.height);
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.texture.length = 0;
        for(let i = 0, il = source.texture.length; i < il; i++){
            this.texture[i] = source.texture[i].clone();
            this.texture[i].isRenderTargetTexture = true;
        }
        return this;
    }
}
class $e8ea6a63d48a4fea$export$23d6a54f0bbc85a3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        this.isQuaternion = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
    static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
        // fuzz-free, array-based Quaternion SLERP operation
        let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
        if (t === 0) {
            dst[dstOffset + 0] = x0;
            dst[dstOffset + 1] = y0;
            dst[dstOffset + 2] = z0;
            dst[dstOffset + 3] = w0;
            return;
        }
        if (t === 1) {
            dst[dstOffset + 0] = x1;
            dst[dstOffset + 1] = y1;
            dst[dstOffset + 2] = z1;
            dst[dstOffset + 3] = w1;
            return;
        }
        if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
            let s = 1 - t;
            const cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos >= 0 ? 1 : -1, sqrSin = 1 - cos * cos;
            // Skip the Slerp for tiny steps to avoid numeric problems:
            if (sqrSin > Number.EPSILON) {
                const sin = Math.sqrt(sqrSin), len = Math.atan2(sin, cos * dir);
                s = Math.sin(s * len) / sin;
                t = Math.sin(t * len) / sin;
            }
            const tDir = t * dir;
            x0 = x0 * s + x1 * tDir;
            y0 = y0 * s + y1 * tDir;
            z0 = z0 * s + z1 * tDir;
            w0 = w0 * s + w1 * tDir;
            // Normalize in case we just did a lerp:
            if (s === 1 - t) {
                const f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                x0 *= f;
                y0 *= f;
                z0 *= f;
                w0 *= f;
            }
        }
        dst[dstOffset] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
    }
    static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
        const x0 = src0[srcOffset0];
        const y0 = src0[srcOffset0 + 1];
        const z0 = src0[srcOffset0 + 2];
        const w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1];
        const y1 = src1[srcOffset1 + 1];
        const z1 = src1[srcOffset1 + 2];
        const w1 = src1[srcOffset1 + 3];
        dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
        dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
        dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
        dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
        return dst;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get w() {
        return this._w;
    }
    set w(value) {
        this._w = value;
        this._onChangeCallback();
    }
    set(x, y, z, w) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    copy(quaternion) {
        this._x = quaternion.x;
        this._y = quaternion.y;
        this._z = quaternion.z;
        this._w = quaternion.w;
        this._onChangeCallback();
        return this;
    }
    setFromEuler(euler, update) {
        const x = euler._x, y = euler._y, z = euler._z, order = euler._order;
        // http://www.mathworks.com/matlabcentral/fileexchange/
        // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
        //	content/SpinCalc.m
        const cos = Math.cos;
        const sin = Math.sin;
        const c1 = cos(x / 2);
        const c2 = cos(y / 2);
        const c3 = cos(z / 2);
        const s1 = sin(x / 2);
        const s2 = sin(y / 2);
        const s3 = sin(z / 2);
        switch(order){
            case "XYZ":
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case "YXZ":
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case "ZXY":
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case "ZYX":
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case "YZX":
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case "XZY":
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            default:
                console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + order);
        }
        if (update !== false) this._onChangeCallback();
        return this;
    }
    setFromAxisAngle(axis, angle) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
        // assumes axis is normalized
        const halfAngle = angle / 2, s = Math.sin(halfAngle);
        this._x = axis.x * s;
        this._y = axis.y * s;
        this._z = axis.z * s;
        this._w = Math.cos(halfAngle);
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
        if (trace > 0) {
            const s = 0.5 / Math.sqrt(trace + 1.0);
            this._w = 0.25 / s;
            this._x = (m32 - m23) * s;
            this._y = (m13 - m31) * s;
            this._z = (m21 - m12) * s;
        } else if (m11 > m22 && m11 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
            this._w = (m32 - m23) / s;
            this._x = 0.25 * s;
            this._y = (m12 + m21) / s;
            this._z = (m13 + m31) / s;
        } else if (m22 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
            this._w = (m13 - m31) / s;
            this._x = (m12 + m21) / s;
            this._y = 0.25 * s;
            this._z = (m23 + m32) / s;
        } else {
            const s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
            this._w = (m21 - m12) / s;
            this._x = (m13 + m31) / s;
            this._y = (m23 + m32) / s;
            this._z = 0.25 * s;
        }
        this._onChangeCallback();
        return this;
    }
    setFromUnitVectors(vFrom, vTo) {
        // assumes direction vectors vFrom and vTo are normalized
        let r = vFrom.dot(vTo) + 1;
        if (r < Number.EPSILON) {
            // vFrom and vTo point in opposite directions
            r = 0;
            if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                this._x = -vFrom.y;
                this._y = vFrom.x;
                this._z = 0;
                this._w = r;
            } else {
                this._x = 0;
                this._y = -vFrom.z;
                this._z = vFrom.y;
                this._w = r;
            }
        } else {
            // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
            this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
            this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
            this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
            this._w = r;
        }
        return this.normalize();
    }
    angleTo(q) {
        return 2 * Math.acos(Math.abs($e8ea6a63d48a4fea$var$clamp(this.dot(q), -1, 1)));
    }
    rotateTowards(q, step) {
        const angle = this.angleTo(q);
        if (angle === 0) return this;
        const t = Math.min(1, step / angle);
        this.slerp(q, t);
        return this;
    }
    identity() {
        return this.set(0, 0, 0, 1);
    }
    invert() {
        // quaternion is assumed to have unit length
        return this.conjugate();
    }
    conjugate() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._onChangeCallback();
        return this;
    }
    dot(v) {
        return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
    }
    lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    normalize() {
        let l = this.length();
        if (l === 0) {
            this._x = 0;
            this._y = 0;
            this._z = 0;
            this._w = 1;
        } else {
            l = 1 / l;
            this._x = this._x * l;
            this._y = this._y * l;
            this._z = this._z * l;
            this._w = this._w * l;
        }
        this._onChangeCallback();
        return this;
    }
    multiply(q) {
        return this.multiplyQuaternions(this, q);
    }
    premultiply(q) {
        return this.multiplyQuaternions(q, this);
    }
    multiplyQuaternions(a, b) {
        // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
        const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
        const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
        this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
        this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
        this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
        this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
        this._onChangeCallback();
        return this;
    }
    slerp(qb, t) {
        if (t === 0) return this;
        if (t === 1) return this.copy(qb);
        const x = this._x, y = this._y, z = this._z, w = this._w;
        // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
        let cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
        if (cosHalfTheta < 0) {
            this._w = -qb._w;
            this._x = -qb._x;
            this._y = -qb._y;
            this._z = -qb._z;
            cosHalfTheta = -cosHalfTheta;
        } else this.copy(qb);
        if (cosHalfTheta >= 1.0) {
            this._w = w;
            this._x = x;
            this._y = y;
            this._z = z;
            return this;
        }
        const sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;
        if (sqrSinHalfTheta <= Number.EPSILON) {
            const s = 1 - t;
            this._w = s * w + t * this._w;
            this._x = s * x + t * this._x;
            this._y = s * y + t * this._y;
            this._z = s * z + t * this._z;
            this.normalize();
            this._onChangeCallback();
            return this;
        }
        const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
        const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
        const ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
        this._w = w * ratioA + this._w * ratioB;
        this._x = x * ratioA + this._x * ratioB;
        this._y = y * ratioA + this._y * ratioB;
        this._z = z * ratioA + this._z * ratioB;
        this._onChangeCallback();
        return this;
    }
    slerpQuaternions(qa, qb, t) {
        return this.copy(qa).slerp(qb, t);
    }
    random() {
        // Derived from http://planning.cs.uiuc.edu/node198.html
        // Note, this source uses w, x, y, z ordering,
        // so we swap the order below.
        const u1 = Math.random();
        const sqrt1u1 = Math.sqrt(1 - u1);
        const sqrtu1 = Math.sqrt(u1);
        const u2 = 2 * Math.PI * Math.random();
        const u3 = 2 * Math.PI * Math.random();
        return this.set(sqrt1u1 * Math.cos(u2), sqrtu1 * Math.sin(u3), sqrtu1 * Math.cos(u3), sqrt1u1 * Math.sin(u2));
    }
    equals(quaternion) {
        return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
    }
    fromArray(array, offset = 0) {
        this._x = array[offset];
        this._y = array[offset + 1];
        this._z = array[offset + 2];
        this._w = array[offset + 3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this._x = attribute.getX(index);
        this._y = attribute.getY(index);
        this._z = attribute.getZ(index);
        this._w = attribute.getW(index);
        return this;
    }
    toJSON() {
        return this.toArray();
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._w;
    }
}
class $e8ea6a63d48a4fea$export$64b5c384219d3699 {
    constructor(x = 0, y = 0, z = 0){
        $e8ea6a63d48a4fea$export$64b5c384219d3699.prototype.isVector3 = true;
        this.x = x;
        this.y = y;
        this.z = z;
    }
    set(x, y, z) {
        if (z === undefined) z = this.z; // sprite.scale.set(x,y)
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            default:
                throw new Error("index is out of range: " + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error("index is out of range: " + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        return this;
    }
    multiplyVectors(a, b) {
        this.x = a.x * b.x;
        this.y = a.y * b.y;
        this.z = a.z * b.z;
        return this;
    }
    applyEuler(euler) {
        return this.applyQuaternion($e8ea6a63d48a4fea$var$_quaternion$4.setFromEuler(euler));
    }
    applyAxisAngle(axis, angle) {
        return this.applyQuaternion($e8ea6a63d48a4fea$var$_quaternion$4.setFromAxisAngle(axis, angle));
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6] * z;
        this.y = e[1] * x + e[4] * y + e[7] * z;
        this.z = e[2] * x + e[5] * y + e[8] * z;
        return this;
    }
    applyNormalMatrix(m) {
        return this.applyMatrix3(m).normalize();
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        const w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
        this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
        this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
        this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
        return this;
    }
    applyQuaternion(q) {
        const x = this.x, y = this.y, z = this.z;
        const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
        // calculate quat * vector
        const ix = qw * x + qy * z - qz * y;
        const iy = qw * y + qz * x - qx * z;
        const iz = qw * z + qx * y - qy * x;
        const iw = -qx * x - qy * y - qz * z;
        // calculate result * inverse quat
        this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
        this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
        this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
        return this;
    }
    project(camera) {
        return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
    }
    unproject(camera) {
        return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
    }
    transformDirection(m) {
        // input: THREE.Matrix4 affine matrix
        // vector interpreted as a direction
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z;
        this.y = e[1] * x + e[5] * y + e[9] * z;
        this.z = e[2] * x + e[6] * y + e[10] * z;
        return this.normalize();
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
    }
    // TODO lengthSquared?
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        return this;
    }
    cross(v) {
        return this.crossVectors(this, v);
    }
    crossVectors(a, b) {
        const ax = a.x, ay = a.y, az = a.z;
        const bx = b.x, by = b.y, bz = b.z;
        this.x = ay * bz - az * by;
        this.y = az * bx - ax * bz;
        this.z = ax * by - ay * bx;
        return this;
    }
    projectOnVector(v) {
        const denominator = v.lengthSq();
        if (denominator === 0) return this.set(0, 0, 0);
        const scalar = v.dot(this) / denominator;
        return this.copy(v).multiplyScalar(scalar);
    }
    projectOnPlane(planeNormal) {
        $e8ea6a63d48a4fea$var$_vector$b.copy(this).projectOnVector(planeNormal);
        return this.sub($e8ea6a63d48a4fea$var$_vector$b);
    }
    reflect(normal) {
        // reflect incident vector off plane orthogonal to normal
        // normal is assumed to have unit length
        return this.sub($e8ea6a63d48a4fea$var$_vector$b.copy(normal).multiplyScalar(2 * this.dot(normal)));
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($e8ea6a63d48a4fea$var$clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
        return dx * dx + dy * dy + dz * dz;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
    }
    setFromSpherical(s) {
        return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
    }
    setFromSphericalCoords(radius, phi, theta) {
        const sinPhiRadius = Math.sin(phi) * radius;
        this.x = sinPhiRadius * Math.sin(theta);
        this.y = Math.cos(phi) * radius;
        this.z = sinPhiRadius * Math.cos(theta);
        return this;
    }
    setFromCylindrical(c) {
        return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
    }
    setFromCylindricalCoords(radius, theta, y) {
        this.x = radius * Math.sin(theta);
        this.y = y;
        this.z = radius * Math.cos(theta);
        return this;
    }
    setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        return this;
    }
    setFromMatrixScale(m) {
        const sx = this.setFromMatrixColumn(m, 0).length();
        const sy = this.setFromMatrixColumn(m, 1).length();
        const sz = this.setFromMatrixColumn(m, 2).length();
        this.x = sx;
        this.y = sy;
        this.z = sz;
        return this;
    }
    setFromMatrixColumn(m, index) {
        return this.fromArray(m.elements, index * 4);
    }
    setFromMatrix3Column(m, index) {
        return this.fromArray(m.elements, index * 3);
    }
    setFromEuler(e) {
        this.x = e._x;
        this.y = e._y;
        this.z = e._z;
        return this;
    }
    setFromColor(c) {
        this.x = c.r;
        this.y = c.g;
        this.z = c.b;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        return this;
    }
    randomDirection() {
        // Derived from https://mathworld.wolfram.com/SpherePointPicking.html
        const u = (Math.random() - 0.5) * 2;
        const t = Math.random() * Math.PI * 2;
        const f = Math.sqrt(1 - u ** 2);
        this.x = f * Math.cos(t);
        this.y = f * Math.sin(t);
        this.z = u;
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
    }
}
const $e8ea6a63d48a4fea$var$_vector$b = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_quaternion$4 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$23d6a54f0bbc85a3();
class $e8ea6a63d48a4fea$export$6f7d5a9418ab2aa3 {
    constructor(min = new $e8ea6a63d48a4fea$export$64b5c384219d3699(Infinity, Infinity, Infinity), max = new $e8ea6a63d48a4fea$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity)){
        this.isBox3 = true;
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromArray(array) {
        this.makeEmpty();
        for(let i = 0, il = array.length; i < il; i += 3)this.expandByPoint($e8ea6a63d48a4fea$var$_vector$a.fromArray(array, i));
        return this;
    }
    setFromBufferAttribute(attribute) {
        this.makeEmpty();
        for(let i = 0, il = attribute.count; i < il; i++)this.expandByPoint($e8ea6a63d48a4fea$var$_vector$a.fromBufferAttribute(attribute, i));
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $e8ea6a63d48a4fea$var$_vector$a.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    setFromObject(object, precise = false) {
        this.makeEmpty();
        return this.expandByObject(object, precise);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = this.min.z = Infinity;
        this.max.x = this.max.y = this.max.z = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    expandByObject(object, precise = false) {
        // Computes the world-axis-aligned bounding box of an object (including its children),
        // accounting for both the object's, and children's, world transforms
        object.updateWorldMatrix(false, false);
        if (object.boundingBox !== undefined) {
            if (object.boundingBox === null) object.computeBoundingBox();
            $e8ea6a63d48a4fea$var$_box$3.copy(object.boundingBox);
            $e8ea6a63d48a4fea$var$_box$3.applyMatrix4(object.matrixWorld);
            this.union($e8ea6a63d48a4fea$var$_box$3);
        } else {
            const geometry = object.geometry;
            if (geometry !== undefined) {
                if (precise && geometry.attributes !== undefined && geometry.attributes.position !== undefined) {
                    const position = geometry.attributes.position;
                    for(let i = 0, l = position.count; i < l; i++){
                        $e8ea6a63d48a4fea$var$_vector$a.fromBufferAttribute(position, i).applyMatrix4(object.matrixWorld);
                        this.expandByPoint($e8ea6a63d48a4fea$var$_vector$a);
                    }
                } else {
                    if (geometry.boundingBox === null) geometry.computeBoundingBox();
                    $e8ea6a63d48a4fea$var$_box$3.copy(geometry.boundingBox);
                    $e8ea6a63d48a4fea$var$_box$3.applyMatrix4(object.matrixWorld);
                    this.union($e8ea6a63d48a4fea$var$_box$3);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)this.expandByObject(children[i], precise);
        return this;
    }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y || point.z < this.min.z || point.z > this.max.z ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
    }
    intersectsBox(box) {
        // using 6 splitting planes to rule out intersections.
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y || box.max.z < this.min.z || box.min.z > this.max.z ? false : true;
    }
    intersectsSphere(sphere) {
        // Find the point on the AABB closest to the sphere center.
        this.clampPoint(sphere.center, $e8ea6a63d48a4fea$var$_vector$a);
        // If that point is inside the sphere, the AABB and sphere intersect.
        return $e8ea6a63d48a4fea$var$_vector$a.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
    }
    intersectsPlane(plane) {
        // We compute the minimum and maximum dot product values. If those values
        // are on the same side (back or front) of the plane, then there is no intersection.
        let min, max;
        if (plane.normal.x > 0) {
            min = plane.normal.x * this.min.x;
            max = plane.normal.x * this.max.x;
        } else {
            min = plane.normal.x * this.max.x;
            max = plane.normal.x * this.min.x;
        }
        if (plane.normal.y > 0) {
            min += plane.normal.y * this.min.y;
            max += plane.normal.y * this.max.y;
        } else {
            min += plane.normal.y * this.max.y;
            max += plane.normal.y * this.min.y;
        }
        if (plane.normal.z > 0) {
            min += plane.normal.z * this.min.z;
            max += plane.normal.z * this.max.z;
        } else {
            min += plane.normal.z * this.max.z;
            max += plane.normal.z * this.min.z;
        }
        return min <= -plane.constant && max >= -plane.constant;
    }
    intersectsTriangle(triangle) {
        if (this.isEmpty()) return false;
        // compute box center and extents
        this.getCenter($e8ea6a63d48a4fea$var$_center);
        $e8ea6a63d48a4fea$var$_extents.subVectors(this.max, $e8ea6a63d48a4fea$var$_center);
        // translate triangle to aabb origin
        $e8ea6a63d48a4fea$var$_v0$2.subVectors(triangle.a, $e8ea6a63d48a4fea$var$_center);
        $e8ea6a63d48a4fea$var$_v1$7.subVectors(triangle.b, $e8ea6a63d48a4fea$var$_center);
        $e8ea6a63d48a4fea$var$_v2$4.subVectors(triangle.c, $e8ea6a63d48a4fea$var$_center);
        // compute edge vectors for triangle
        $e8ea6a63d48a4fea$var$_f0.subVectors($e8ea6a63d48a4fea$var$_v1$7, $e8ea6a63d48a4fea$var$_v0$2);
        $e8ea6a63d48a4fea$var$_f1.subVectors($e8ea6a63d48a4fea$var$_v2$4, $e8ea6a63d48a4fea$var$_v1$7);
        $e8ea6a63d48a4fea$var$_f2.subVectors($e8ea6a63d48a4fea$var$_v0$2, $e8ea6a63d48a4fea$var$_v2$4);
        // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
        // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
        // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
        let axes = [
            0,
            -$e8ea6a63d48a4fea$var$_f0.z,
            $e8ea6a63d48a4fea$var$_f0.y,
            0,
            -$e8ea6a63d48a4fea$var$_f1.z,
            $e8ea6a63d48a4fea$var$_f1.y,
            0,
            -$e8ea6a63d48a4fea$var$_f2.z,
            $e8ea6a63d48a4fea$var$_f2.y,
            $e8ea6a63d48a4fea$var$_f0.z,
            0,
            -$e8ea6a63d48a4fea$var$_f0.x,
            $e8ea6a63d48a4fea$var$_f1.z,
            0,
            -$e8ea6a63d48a4fea$var$_f1.x,
            $e8ea6a63d48a4fea$var$_f2.z,
            0,
            -$e8ea6a63d48a4fea$var$_f2.x,
            -$e8ea6a63d48a4fea$var$_f0.y,
            $e8ea6a63d48a4fea$var$_f0.x,
            0,
            -$e8ea6a63d48a4fea$var$_f1.y,
            $e8ea6a63d48a4fea$var$_f1.x,
            0,
            -$e8ea6a63d48a4fea$var$_f2.y,
            $e8ea6a63d48a4fea$var$_f2.x,
            0
        ];
        if (!$e8ea6a63d48a4fea$var$satForAxes(axes, $e8ea6a63d48a4fea$var$_v0$2, $e8ea6a63d48a4fea$var$_v1$7, $e8ea6a63d48a4fea$var$_v2$4, $e8ea6a63d48a4fea$var$_extents)) return false;
        // test 3 face normals from the aabb
        axes = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (!$e8ea6a63d48a4fea$var$satForAxes(axes, $e8ea6a63d48a4fea$var$_v0$2, $e8ea6a63d48a4fea$var$_v1$7, $e8ea6a63d48a4fea$var$_v2$4, $e8ea6a63d48a4fea$var$_extents)) return false;
        // finally testing the face normal of the triangle
        // use already existing triangle edge vectors here
        $e8ea6a63d48a4fea$var$_triangleNormal.crossVectors($e8ea6a63d48a4fea$var$_f0, $e8ea6a63d48a4fea$var$_f1);
        axes = [
            $e8ea6a63d48a4fea$var$_triangleNormal.x,
            $e8ea6a63d48a4fea$var$_triangleNormal.y,
            $e8ea6a63d48a4fea$var$_triangleNormal.z
        ];
        return $e8ea6a63d48a4fea$var$satForAxes(axes, $e8ea6a63d48a4fea$var$_v0$2, $e8ea6a63d48a4fea$var$_v1$7, $e8ea6a63d48a4fea$var$_v2$4, $e8ea6a63d48a4fea$var$_extents);
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        return this.clampPoint(point, $e8ea6a63d48a4fea$var$_vector$a).distanceTo(point);
    }
    getBoundingSphere(target) {
        if (this.isEmpty()) target.makeEmpty();
        else {
            this.getCenter(target.center);
            target.radius = this.getSize($e8ea6a63d48a4fea$var$_vector$a).length() * 0.5;
        }
        return target;
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    applyMatrix4(matrix) {
        // transform of empty box is an empty box.
        if (this.isEmpty()) return this;
        // NOTE: I am using a binary pattern to specify all 2^3 combinations below
        $e8ea6a63d48a4fea$var$_points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
        $e8ea6a63d48a4fea$var$_points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
        $e8ea6a63d48a4fea$var$_points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
        $e8ea6a63d48a4fea$var$_points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
        $e8ea6a63d48a4fea$var$_points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
        $e8ea6a63d48a4fea$var$_points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
        $e8ea6a63d48a4fea$var$_points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
        $e8ea6a63d48a4fea$var$_points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111
        this.setFromPoints($e8ea6a63d48a4fea$var$_points);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $e8ea6a63d48a4fea$var$_points = [
    /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699(),
    /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699(),
    /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699(),
    /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699(),
    /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699(),
    /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699(),
    /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699(),
    /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699()
];
const $e8ea6a63d48a4fea$var$_vector$a = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_box$3 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$6f7d5a9418ab2aa3();
// triangle centered vertices
const $e8ea6a63d48a4fea$var$_v0$2 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_v1$7 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_v2$4 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
// triangle edge vectors
const $e8ea6a63d48a4fea$var$_f0 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_f1 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_f2 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_center = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_extents = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_triangleNormal = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_testAxis = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
function $e8ea6a63d48a4fea$var$satForAxes(axes, v0, v1, v2, extents) {
    for(let i = 0, j = axes.length - 3; i <= j; i += 3){
        $e8ea6a63d48a4fea$var$_testAxis.fromArray(axes, i);
        // project the aabb onto the separating axis
        const r = extents.x * Math.abs($e8ea6a63d48a4fea$var$_testAxis.x) + extents.y * Math.abs($e8ea6a63d48a4fea$var$_testAxis.y) + extents.z * Math.abs($e8ea6a63d48a4fea$var$_testAxis.z);
        // project all 3 vertices of the triangle onto the separating axis
        const p0 = v0.dot($e8ea6a63d48a4fea$var$_testAxis);
        const p1 = v1.dot($e8ea6a63d48a4fea$var$_testAxis);
        const p2 = v2.dot($e8ea6a63d48a4fea$var$_testAxis);
        // actual test, basically see if either of the most extreme of the triangle points intersects r
        if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) // points of the projected triangle are outside the projected half-length of the aabb
        // the axis is separating and we can exit
        return false;
    }
    return true;
}
const $e8ea6a63d48a4fea$var$_box$2 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$6f7d5a9418ab2aa3();
const $e8ea6a63d48a4fea$var$_v1$6 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_v2$3 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
class $e8ea6a63d48a4fea$export$805e8b72413ccaba {
    constructor(center = new $e8ea6a63d48a4fea$export$64b5c384219d3699(), radius = -1){
        this.center = center;
        this.radius = radius;
    }
    set(center, radius) {
        this.center.copy(center);
        this.radius = radius;
        return this;
    }
    setFromPoints(points, optionalCenter) {
        const center = this.center;
        if (optionalCenter !== undefined) center.copy(optionalCenter);
        else $e8ea6a63d48a4fea$var$_box$2.setFromPoints(points).getCenter(center);
        let maxRadiusSq = 0;
        for(let i = 0, il = points.length; i < il; i++)maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
        this.radius = Math.sqrt(maxRadiusSq);
        return this;
    }
    copy(sphere) {
        this.center.copy(sphere.center);
        this.radius = sphere.radius;
        return this;
    }
    isEmpty() {
        return this.radius < 0;
    }
    makeEmpty() {
        this.center.set(0, 0, 0);
        this.radius = -1;
        return this;
    }
    containsPoint(point) {
        return point.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    distanceToPoint(point) {
        return point.distanceTo(this.center) - this.radius;
    }
    intersectsSphere(sphere) {
        const radiusSum = this.radius + sphere.radius;
        return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
    }
    intersectsBox(box) {
        return box.intersectsSphere(this);
    }
    intersectsPlane(plane) {
        return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
    }
    clampPoint(point, target) {
        const deltaLengthSq = this.center.distanceToSquared(point);
        target.copy(point);
        if (deltaLengthSq > this.radius * this.radius) {
            target.sub(this.center).normalize();
            target.multiplyScalar(this.radius).add(this.center);
        }
        return target;
    }
    getBoundingBox(target) {
        if (this.isEmpty()) {
            // Empty sphere produces empty bounding box
            target.makeEmpty();
            return target;
        }
        target.set(this.center, this.center);
        target.expandByScalar(this.radius);
        return target;
    }
    applyMatrix4(matrix) {
        this.center.applyMatrix4(matrix);
        this.radius = this.radius * matrix.getMaxScaleOnAxis();
        return this;
    }
    translate(offset) {
        this.center.add(offset);
        return this;
    }
    expandByPoint(point) {
        if (this.isEmpty()) {
            this.center.copy(point);
            this.radius = 0;
            return this;
        }
        $e8ea6a63d48a4fea$var$_v1$6.subVectors(point, this.center);
        const lengthSq = $e8ea6a63d48a4fea$var$_v1$6.lengthSq();
        if (lengthSq > this.radius * this.radius) {
            // calculate the minimal sphere
            const length = Math.sqrt(lengthSq);
            const delta = (length - this.radius) * 0.5;
            this.center.addScaledVector($e8ea6a63d48a4fea$var$_v1$6, delta / length);
            this.radius += delta;
        }
        return this;
    }
    union(sphere) {
        if (sphere.isEmpty()) return this;
        if (this.isEmpty()) {
            this.copy(sphere);
            return this;
        }
        if (this.center.equals(sphere.center) === true) this.radius = Math.max(this.radius, sphere.radius);
        else {
            $e8ea6a63d48a4fea$var$_v2$3.subVectors(sphere.center, this.center).setLength(sphere.radius);
            this.expandByPoint($e8ea6a63d48a4fea$var$_v1$6.copy(sphere.center).add($e8ea6a63d48a4fea$var$_v2$3));
            this.expandByPoint($e8ea6a63d48a4fea$var$_v1$6.copy(sphere.center).sub($e8ea6a63d48a4fea$var$_v2$3));
        }
        return this;
    }
    equals(sphere) {
        return sphere.center.equals(this.center) && sphere.radius === this.radius;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $e8ea6a63d48a4fea$var$_vector$9 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_segCenter = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_segDir = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_diff = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_edge1 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_edge2 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_normal$1 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
class $e8ea6a63d48a4fea$export$a186db52eed6d40e {
    constructor(origin = new $e8ea6a63d48a4fea$export$64b5c384219d3699(), direction = new $e8ea6a63d48a4fea$export$64b5c384219d3699(0, 0, -1)){
        this.origin = origin;
        this.direction = direction;
    }
    set(origin, direction) {
        this.origin.copy(origin);
        this.direction.copy(direction);
        return this;
    }
    copy(ray) {
        this.origin.copy(ray.origin);
        this.direction.copy(ray.direction);
        return this;
    }
    at(t, target) {
        return target.copy(this.origin).addScaledVector(this.direction, t);
    }
    lookAt(v) {
        this.direction.copy(v).sub(this.origin).normalize();
        return this;
    }
    recast(t) {
        this.origin.copy(this.at(t, $e8ea6a63d48a4fea$var$_vector$9));
        return this;
    }
    closestPointToPoint(point, target) {
        target.subVectors(point, this.origin);
        const directionDistance = target.dot(this.direction);
        if (directionDistance < 0) return target.copy(this.origin);
        return target.copy(this.origin).addScaledVector(this.direction, directionDistance);
    }
    distanceToPoint(point) {
        return Math.sqrt(this.distanceSqToPoint(point));
    }
    distanceSqToPoint(point) {
        const directionDistance = $e8ea6a63d48a4fea$var$_vector$9.subVectors(point, this.origin).dot(this.direction);
        // point behind the ray
        if (directionDistance < 0) return this.origin.distanceToSquared(point);
        $e8ea6a63d48a4fea$var$_vector$9.copy(this.origin).addScaledVector(this.direction, directionDistance);
        return $e8ea6a63d48a4fea$var$_vector$9.distanceToSquared(point);
    }
    distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
        // It returns the min distance between the ray and the segment
        // defined by v0 and v1
        // It can also set two optional targets :
        // - The closest point on the ray
        // - The closest point on the segment
        $e8ea6a63d48a4fea$var$_segCenter.copy(v0).add(v1).multiplyScalar(0.5);
        $e8ea6a63d48a4fea$var$_segDir.copy(v1).sub(v0).normalize();
        $e8ea6a63d48a4fea$var$_diff.copy(this.origin).sub($e8ea6a63d48a4fea$var$_segCenter);
        const segExtent = v0.distanceTo(v1) * 0.5;
        const a01 = -this.direction.dot($e8ea6a63d48a4fea$var$_segDir);
        const b0 = $e8ea6a63d48a4fea$var$_diff.dot(this.direction);
        const b1 = -$e8ea6a63d48a4fea$var$_diff.dot($e8ea6a63d48a4fea$var$_segDir);
        const c = $e8ea6a63d48a4fea$var$_diff.lengthSq();
        const det = Math.abs(1 - a01 * a01);
        let s0, s1, sqrDist, extDet;
        if (det > 0) {
            // The ray and segment are not parallel.
            s0 = a01 * b1 - b0;
            s1 = a01 * b0 - b1;
            extDet = segExtent * det;
            if (s0 >= 0) {
                if (s1 >= -extDet) {
                    if (s1 <= extDet) {
                        // region 0
                        // Minimum at interior points of ray and segment.
                        const invDet = 1 / det;
                        s0 *= invDet;
                        s1 *= invDet;
                        sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
                    } else {
                        // region 1
                        s1 = segExtent;
                        s0 = Math.max(0, -(a01 * s1 + b0));
                        sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                    }
                } else {
                    // region 5
                    s1 = -segExtent;
                    s0 = Math.max(0, -(a01 * s1 + b0));
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            } else {
                if (s1 <= -extDet) {
                    // region 4
                    s0 = Math.max(0, -(-a01 * segExtent + b0));
                    s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                } else if (s1 <= extDet) {
                    // region 3
                    s0 = 0;
                    s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = s1 * (s1 + 2 * b1) + c;
                } else {
                    // region 2
                    s0 = Math.max(0, -(a01 * segExtent + b0));
                    s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            }
        } else {
            // Ray and segment are parallel.
            s1 = a01 > 0 ? -segExtent : segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
        if (optionalPointOnRay) optionalPointOnRay.copy(this.origin).addScaledVector(this.direction, s0);
        if (optionalPointOnSegment) optionalPointOnSegment.copy($e8ea6a63d48a4fea$var$_segCenter).addScaledVector($e8ea6a63d48a4fea$var$_segDir, s1);
        return sqrDist;
    }
    intersectSphere(sphere, target) {
        $e8ea6a63d48a4fea$var$_vector$9.subVectors(sphere.center, this.origin);
        const tca = $e8ea6a63d48a4fea$var$_vector$9.dot(this.direction);
        const d2 = $e8ea6a63d48a4fea$var$_vector$9.dot($e8ea6a63d48a4fea$var$_vector$9) - tca * tca;
        const radius2 = sphere.radius * sphere.radius;
        if (d2 > radius2) return null;
        const thc = Math.sqrt(radius2 - d2);
        // t0 = first intersect point - entrance on front of sphere
        const t0 = tca - thc;
        // t1 = second intersect point - exit point on back of sphere
        const t1 = tca + thc;
        // test to see if t1 is behind the ray - if so, return null
        if (t1 < 0) return null;
        // test to see if t0 is behind the ray:
        // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
        // in order to always return an intersect point that is in front of the ray.
        if (t0 < 0) return this.at(t1, target);
        // else t0 is in front of the ray, so return the first collision point scaled by t0
        return this.at(t0, target);
    }
    intersectsSphere(sphere) {
        return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
    }
    distanceToPlane(plane) {
        const denominator = plane.normal.dot(this.direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (plane.distanceToPoint(this.origin) === 0) return 0;
            // Null is preferable to undefined since undefined means.... it is undefined
            return null;
        }
        const t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
        // Return if the ray never intersects the plane
        return t >= 0 ? t : null;
    }
    intersectPlane(plane, target) {
        const t = this.distanceToPlane(plane);
        if (t === null) return null;
        return this.at(t, target);
    }
    intersectsPlane(plane) {
        // check if the ray lies on the plane first
        const distToPoint = plane.distanceToPoint(this.origin);
        if (distToPoint === 0) return true;
        const denominator = plane.normal.dot(this.direction);
        if (denominator * distToPoint < 0) return true;
        // ray origin is behind the plane (and is pointing behind it)
        return false;
    }
    intersectBox(box, target) {
        let tmin, tmax, tymin, tymax, tzmin, tzmax;
        const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
        const origin = this.origin;
        if (invdirx >= 0) {
            tmin = (box.min.x - origin.x) * invdirx;
            tmax = (box.max.x - origin.x) * invdirx;
        } else {
            tmin = (box.max.x - origin.x) * invdirx;
            tmax = (box.min.x - origin.x) * invdirx;
        }
        if (invdiry >= 0) {
            tymin = (box.min.y - origin.y) * invdiry;
            tymax = (box.max.y - origin.y) * invdiry;
        } else {
            tymin = (box.max.y - origin.y) * invdiry;
            tymax = (box.min.y - origin.y) * invdiry;
        }
        if (tmin > tymax || tymin > tmax) return null;
        if (tymin > tmin || isNaN(tmin)) tmin = tymin;
        if (tymax < tmax || isNaN(tmax)) tmax = tymax;
        if (invdirz >= 0) {
            tzmin = (box.min.z - origin.z) * invdirz;
            tzmax = (box.max.z - origin.z) * invdirz;
        } else {
            tzmin = (box.max.z - origin.z) * invdirz;
            tzmax = (box.min.z - origin.z) * invdirz;
        }
        if (tmin > tzmax || tzmin > tmax) return null;
        if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
        if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
        //return point closest to the ray (positive side)
        if (tmax < 0) return null;
        return this.at(tmin >= 0 ? tmin : tmax, target);
    }
    intersectsBox(box) {
        return this.intersectBox(box, $e8ea6a63d48a4fea$var$_vector$9) !== null;
    }
    intersectTriangle(a, b, c, backfaceCulling, target) {
        // Compute the offset origin, edges, and normal.
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
        $e8ea6a63d48a4fea$var$_edge1.subVectors(b, a);
        $e8ea6a63d48a4fea$var$_edge2.subVectors(c, a);
        $e8ea6a63d48a4fea$var$_normal$1.crossVectors($e8ea6a63d48a4fea$var$_edge1, $e8ea6a63d48a4fea$var$_edge2);
        // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
        // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
        //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
        //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
        //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
        let DdN = this.direction.dot($e8ea6a63d48a4fea$var$_normal$1);
        let sign;
        if (DdN > 0) {
            if (backfaceCulling) return null;
            sign = 1;
        } else if (DdN < 0) {
            sign = -1;
            DdN = -DdN;
        } else return null;
        $e8ea6a63d48a4fea$var$_diff.subVectors(this.origin, a);
        const DdQxE2 = sign * this.direction.dot($e8ea6a63d48a4fea$var$_edge2.crossVectors($e8ea6a63d48a4fea$var$_diff, $e8ea6a63d48a4fea$var$_edge2));
        // b1 < 0, no intersection
        if (DdQxE2 < 0) return null;
        const DdE1xQ = sign * this.direction.dot($e8ea6a63d48a4fea$var$_edge1.cross($e8ea6a63d48a4fea$var$_diff));
        // b2 < 0, no intersection
        if (DdE1xQ < 0) return null;
        // b1+b2 > 1, no intersection
        if (DdQxE2 + DdE1xQ > DdN) return null;
        // Line intersects triangle, check if ray does.
        const QdN = -sign * $e8ea6a63d48a4fea$var$_diff.dot($e8ea6a63d48a4fea$var$_normal$1);
        // t < 0, no intersection
        if (QdN < 0) return null;
        // Ray intersects triangle.
        return this.at(QdN / DdN, target);
    }
    applyMatrix4(matrix4) {
        this.origin.applyMatrix4(matrix4);
        this.direction.transformDirection(matrix4);
        return this;
    }
    equals(ray) {
        return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $e8ea6a63d48a4fea$export$2ae72fc923e5eb5 {
    constructor(){
        $e8ea6a63d48a4fea$export$2ae72fc923e5eb5.prototype.isMatrix4 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
    }
    set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        const te = this.elements;
        te[0] = n11;
        te[4] = n12;
        te[8] = n13;
        te[12] = n14;
        te[1] = n21;
        te[5] = n22;
        te[9] = n23;
        te[13] = n24;
        te[2] = n31;
        te[6] = n32;
        te[10] = n33;
        te[14] = n34;
        te[3] = n41;
        te[7] = n42;
        te[11] = n43;
        te[15] = n44;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    clone() {
        return new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5().fromArray(this.elements);
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        te[9] = me[9];
        te[10] = me[10];
        te[11] = me[11];
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        te[15] = me[15];
        return this;
    }
    copyPosition(m) {
        const te = this.elements, me = m.elements;
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        return this;
    }
    setFromMatrix3(m) {
        const me = m.elements;
        this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrixColumn(this, 0);
        yAxis.setFromMatrixColumn(this, 1);
        zAxis.setFromMatrixColumn(this, 2);
        return this;
    }
    makeBasis(xAxis, yAxis, zAxis) {
        this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
        return this;
    }
    extractRotation(m) {
        // this method does not support reflection matrices
        const te = this.elements;
        const me = m.elements;
        const scaleX = 1 / $e8ea6a63d48a4fea$var$_v1$5.setFromMatrixColumn(m, 0).length();
        const scaleY = 1 / $e8ea6a63d48a4fea$var$_v1$5.setFromMatrixColumn(m, 1).length();
        const scaleZ = 1 / $e8ea6a63d48a4fea$var$_v1$5.setFromMatrixColumn(m, 2).length();
        te[0] = me[0] * scaleX;
        te[1] = me[1] * scaleX;
        te[2] = me[2] * scaleX;
        te[3] = 0;
        te[4] = me[4] * scaleY;
        te[5] = me[5] * scaleY;
        te[6] = me[6] * scaleY;
        te[7] = 0;
        te[8] = me[8] * scaleZ;
        te[9] = me[9] * scaleZ;
        te[10] = me[10] * scaleZ;
        te[11] = 0;
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromEuler(euler) {
        const te = this.elements;
        const x = euler.x, y = euler.y, z = euler.z;
        const a = Math.cos(x), b = Math.sin(x);
        const c = Math.cos(y), d = Math.sin(y);
        const e = Math.cos(z), f = Math.sin(z);
        if (euler.order === "XYZ") {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = -c * f;
            te[8] = d;
            te[1] = af + be * d;
            te[5] = ae - bf * d;
            te[9] = -b * c;
            te[2] = bf - ae * d;
            te[6] = be + af * d;
            te[10] = a * c;
        } else if (euler.order === "YXZ") {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce + df * b;
            te[4] = de * b - cf;
            te[8] = a * d;
            te[1] = a * f;
            te[5] = a * e;
            te[9] = -b;
            te[2] = cf * b - de;
            te[6] = df + ce * b;
            te[10] = a * c;
        } else if (euler.order === "ZXY") {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce - df * b;
            te[4] = -a * f;
            te[8] = de + cf * b;
            te[1] = cf + de * b;
            te[5] = a * e;
            te[9] = df - ce * b;
            te[2] = -a * d;
            te[6] = b;
            te[10] = a * c;
        } else if (euler.order === "ZYX") {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = be * d - af;
            te[8] = ae * d + bf;
            te[1] = c * f;
            te[5] = bf * d + ae;
            te[9] = af * d - be;
            te[2] = -d;
            te[6] = b * c;
            te[10] = a * c;
        } else if (euler.order === "YZX") {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = bd - ac * f;
            te[8] = bc * f + ad;
            te[1] = f;
            te[5] = a * e;
            te[9] = -b * e;
            te[2] = -d * e;
            te[6] = ad * f + bc;
            te[10] = ac - bd * f;
        } else if (euler.order === "XZY") {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = -f;
            te[8] = d * e;
            te[1] = ac * f + bd;
            te[5] = a * e;
            te[9] = ad * f - bc;
            te[2] = bc * f - ad;
            te[6] = b * e;
            te[10] = bd * f + ac;
        }
        // bottom row
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        // last column
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromQuaternion(q) {
        return this.compose($e8ea6a63d48a4fea$var$_zero, q, $e8ea6a63d48a4fea$var$_one);
    }
    lookAt(eye, target, up) {
        const te = this.elements;
        $e8ea6a63d48a4fea$var$_z.subVectors(eye, target);
        if ($e8ea6a63d48a4fea$var$_z.lengthSq() === 0) // eye and target are in the same position
        $e8ea6a63d48a4fea$var$_z.z = 1;
        $e8ea6a63d48a4fea$var$_z.normalize();
        $e8ea6a63d48a4fea$var$_x.crossVectors(up, $e8ea6a63d48a4fea$var$_z);
        if ($e8ea6a63d48a4fea$var$_x.lengthSq() === 0) {
            // up and z are parallel
            if (Math.abs(up.z) === 1) $e8ea6a63d48a4fea$var$_z.x += 0.0001;
            else $e8ea6a63d48a4fea$var$_z.z += 0.0001;
            $e8ea6a63d48a4fea$var$_z.normalize();
            $e8ea6a63d48a4fea$var$_x.crossVectors(up, $e8ea6a63d48a4fea$var$_z);
        }
        $e8ea6a63d48a4fea$var$_x.normalize();
        $e8ea6a63d48a4fea$var$_y.crossVectors($e8ea6a63d48a4fea$var$_z, $e8ea6a63d48a4fea$var$_x);
        te[0] = $e8ea6a63d48a4fea$var$_x.x;
        te[4] = $e8ea6a63d48a4fea$var$_y.x;
        te[8] = $e8ea6a63d48a4fea$var$_z.x;
        te[1] = $e8ea6a63d48a4fea$var$_x.y;
        te[5] = $e8ea6a63d48a4fea$var$_y.y;
        te[9] = $e8ea6a63d48a4fea$var$_z.y;
        te[2] = $e8ea6a63d48a4fea$var$_x.z;
        te[6] = $e8ea6a63d48a4fea$var$_y.z;
        te[10] = $e8ea6a63d48a4fea$var$_z.z;
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
        const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
        const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
        const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
        const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
        const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
        const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
        const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
        te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
        te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
        te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
        te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
        te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
        te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
        te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
        te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
        te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
        te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
        te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
        te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
        te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[4] *= s;
        te[8] *= s;
        te[12] *= s;
        te[1] *= s;
        te[5] *= s;
        te[9] *= s;
        te[13] *= s;
        te[2] *= s;
        te[6] *= s;
        te[10] *= s;
        te[14] *= s;
        te[3] *= s;
        te[7] *= s;
        te[11] *= s;
        te[15] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
        const n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
        const n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
        const n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
        //TODO: make this more efficient
        //( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )
        return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
    }
    transpose() {
        const te = this.elements;
        let tmp;
        tmp = te[1];
        te[1] = te[4];
        te[4] = tmp;
        tmp = te[2];
        te[2] = te[8];
        te[8] = tmp;
        tmp = te[6];
        te[6] = te[9];
        te[9] = tmp;
        tmp = te[3];
        te[3] = te[12];
        te[12] = tmp;
        tmp = te[7];
        te[7] = te[13];
        te[13] = tmp;
        tmp = te[11];
        te[11] = te[14];
        te[14] = tmp;
        return this;
    }
    setPosition(x, y, z) {
        const te = this.elements;
        if (x.isVector3) {
            te[12] = x.x;
            te[13] = x.y;
            te[14] = x.z;
        } else {
            te[12] = x;
            te[13] = y;
            te[14] = z;
        }
        return this;
    }
    invert() {
        // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
        const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
        te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
        te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
        te[4] = t12 * detInv;
        te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
        te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
        te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
        te[8] = t13 * detInv;
        te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
        te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
        te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
        te[12] = t14 * detInv;
        te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
        te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
        te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
        return this;
    }
    scale(v) {
        const te = this.elements;
        const x = v.x, y = v.y, z = v.z;
        te[0] *= x;
        te[4] *= y;
        te[8] *= z;
        te[1] *= x;
        te[5] *= y;
        te[9] *= z;
        te[2] *= x;
        te[6] *= y;
        te[10] *= z;
        te[3] *= x;
        te[7] *= y;
        te[11] *= z;
        return this;
    }
    getMaxScaleOnAxis() {
        const te = this.elements;
        const scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
        const scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
        const scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
    }
    makeTranslation(x, y, z) {
        this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
        return this;
    }
    makeRotationX(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationY(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationZ(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationAxis(axis, angle) {
        // Based on http://www.gamedev.net/reference/articles/article1199.asp
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        const t = 1 - c;
        const x = axis.x, y = axis.y, z = axis.z;
        const tx = t * x, ty = t * y;
        this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y, z) {
        this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
        return this;
    }
    makeShear(xy, xz, yx, yz, zx, zy) {
        this.set(1, yx, zx, 0, xy, 1, zy, 0, xz, yz, 1, 0, 0, 0, 0, 1);
        return this;
    }
    compose(position, quaternion, scale) {
        const te = this.elements;
        const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
        const x2 = x + x, y2 = y + y, z2 = z + z;
        const xx = x * x2, xy = x * y2, xz = x * z2;
        const yy = y * y2, yz = y * z2, zz = z * z2;
        const wx = w * x2, wy = w * y2, wz = w * z2;
        const sx = scale.x, sy = scale.y, sz = scale.z;
        te[0] = (1 - (yy + zz)) * sx;
        te[1] = (xy + wz) * sx;
        te[2] = (xz - wy) * sx;
        te[3] = 0;
        te[4] = (xy - wz) * sy;
        te[5] = (1 - (xx + zz)) * sy;
        te[6] = (yz + wx) * sy;
        te[7] = 0;
        te[8] = (xz + wy) * sz;
        te[9] = (yz - wx) * sz;
        te[10] = (1 - (xx + yy)) * sz;
        te[11] = 0;
        te[12] = position.x;
        te[13] = position.y;
        te[14] = position.z;
        te[15] = 1;
        return this;
    }
    decompose(position, quaternion, scale) {
        const te = this.elements;
        let sx = $e8ea6a63d48a4fea$var$_v1$5.set(te[0], te[1], te[2]).length();
        const sy = $e8ea6a63d48a4fea$var$_v1$5.set(te[4], te[5], te[6]).length();
        const sz = $e8ea6a63d48a4fea$var$_v1$5.set(te[8], te[9], te[10]).length();
        // if determine is negative, we need to invert one scale
        const det = this.determinant();
        if (det < 0) sx = -sx;
        position.x = te[12];
        position.y = te[13];
        position.z = te[14];
        // scale the rotation part
        $e8ea6a63d48a4fea$var$_m1$2.copy(this);
        const invSX = 1 / sx;
        const invSY = 1 / sy;
        const invSZ = 1 / sz;
        $e8ea6a63d48a4fea$var$_m1$2.elements[0] *= invSX;
        $e8ea6a63d48a4fea$var$_m1$2.elements[1] *= invSX;
        $e8ea6a63d48a4fea$var$_m1$2.elements[2] *= invSX;
        $e8ea6a63d48a4fea$var$_m1$2.elements[4] *= invSY;
        $e8ea6a63d48a4fea$var$_m1$2.elements[5] *= invSY;
        $e8ea6a63d48a4fea$var$_m1$2.elements[6] *= invSY;
        $e8ea6a63d48a4fea$var$_m1$2.elements[8] *= invSZ;
        $e8ea6a63d48a4fea$var$_m1$2.elements[9] *= invSZ;
        $e8ea6a63d48a4fea$var$_m1$2.elements[10] *= invSZ;
        quaternion.setFromRotationMatrix($e8ea6a63d48a4fea$var$_m1$2);
        scale.x = sx;
        scale.y = sy;
        scale.z = sz;
        return this;
    }
    makePerspective(left, right, top, bottom, near, far) {
        const te = this.elements;
        const x = 2 * near / (right - left);
        const y = 2 * near / (top - bottom);
        const a = (right + left) / (right - left);
        const b = (top + bottom) / (top - bottom);
        const c = -(far + near) / (far - near);
        const d = -2 * far * near / (far - near);
        te[0] = x;
        te[4] = 0;
        te[8] = a;
        te[12] = 0;
        te[1] = 0;
        te[5] = y;
        te[9] = b;
        te[13] = 0;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = -1;
        te[15] = 0;
        return this;
    }
    makeOrthographic(left, right, top, bottom, near, far) {
        const te = this.elements;
        const w = 1.0 / (right - left);
        const h = 1.0 / (top - bottom);
        const p = 1.0 / (far - near);
        const x = (right + left) * w;
        const y = (top + bottom) * h;
        const z = (far + near) * p;
        te[0] = 2 * w;
        te[4] = 0;
        te[8] = 0;
        te[12] = -x;
        te[1] = 0;
        te[5] = 2 * h;
        te[9] = 0;
        te[13] = -y;
        te[2] = 0;
        te[6] = 0;
        te[10] = -2 * p;
        te[14] = -z;
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        te[15] = 1;
        return this;
    }
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 16; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 16; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        array[offset + 9] = te[9];
        array[offset + 10] = te[10];
        array[offset + 11] = te[11];
        array[offset + 12] = te[12];
        array[offset + 13] = te[13];
        array[offset + 14] = te[14];
        array[offset + 15] = te[15];
        return array;
    }
}
const $e8ea6a63d48a4fea$var$_v1$5 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_m1$2 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5();
const $e8ea6a63d48a4fea$var$_zero = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699(0, 0, 0);
const $e8ea6a63d48a4fea$var$_one = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699(1, 1, 1);
const $e8ea6a63d48a4fea$var$_x = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_y = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_z = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_matrix = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5();
const $e8ea6a63d48a4fea$var$_quaternion$3 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$23d6a54f0bbc85a3();
class $e8ea6a63d48a4fea$export$d93cc409a0768c5f {
    constructor(x = 0, y = 0, z = 0, order = $e8ea6a63d48a4fea$export$d93cc409a0768c5f.DEFAULT_ORDER){
        this.isEuler = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
        this._onChangeCallback();
    }
    set(x, y, z, order = this._order) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    copy(euler) {
        this._x = euler._x;
        this._y = euler._y;
        this._z = euler._z;
        this._order = euler._order;
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m, order = this._order, update = true) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements;
        const m11 = te[0], m12 = te[4], m13 = te[8];
        const m21 = te[1], m22 = te[5], m23 = te[9];
        const m31 = te[2], m32 = te[6], m33 = te[10];
        switch(order){
            case "XYZ":
                this._y = Math.asin($e8ea6a63d48a4fea$var$clamp(m13, -1, 1));
                if (Math.abs(m13) < 0.9999999) {
                    this._x = Math.atan2(-m23, m33);
                    this._z = Math.atan2(-m12, m11);
                } else {
                    this._x = Math.atan2(m32, m22);
                    this._z = 0;
                }
                break;
            case "YXZ":
                this._x = Math.asin(-$e8ea6a63d48a4fea$var$clamp(m23, -1, 1));
                if (Math.abs(m23) < 0.9999999) {
                    this._y = Math.atan2(m13, m33);
                    this._z = Math.atan2(m21, m22);
                } else {
                    this._y = Math.atan2(-m31, m11);
                    this._z = 0;
                }
                break;
            case "ZXY":
                this._x = Math.asin($e8ea6a63d48a4fea$var$clamp(m32, -1, 1));
                if (Math.abs(m32) < 0.9999999) {
                    this._y = Math.atan2(-m31, m33);
                    this._z = Math.atan2(-m12, m22);
                } else {
                    this._y = 0;
                    this._z = Math.atan2(m21, m11);
                }
                break;
            case "ZYX":
                this._y = Math.asin(-$e8ea6a63d48a4fea$var$clamp(m31, -1, 1));
                if (Math.abs(m31) < 0.9999999) {
                    this._x = Math.atan2(m32, m33);
                    this._z = Math.atan2(m21, m11);
                } else {
                    this._x = 0;
                    this._z = Math.atan2(-m12, m22);
                }
                break;
            case "YZX":
                this._z = Math.asin($e8ea6a63d48a4fea$var$clamp(m21, -1, 1));
                if (Math.abs(m21) < 0.9999999) {
                    this._x = Math.atan2(-m23, m22);
                    this._y = Math.atan2(-m31, m11);
                } else {
                    this._x = 0;
                    this._y = Math.atan2(m13, m33);
                }
                break;
            case "XZY":
                this._z = Math.asin(-$e8ea6a63d48a4fea$var$clamp(m12, -1, 1));
                if (Math.abs(m12) < 0.9999999) {
                    this._x = Math.atan2(m32, m22);
                    this._y = Math.atan2(m13, m11);
                } else {
                    this._x = Math.atan2(-m23, m33);
                    this._y = 0;
                }
                break;
            default:
                console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + order);
        }
        this._order = order;
        if (update === true) this._onChangeCallback();
        return this;
    }
    setFromQuaternion(q, order, update) {
        $e8ea6a63d48a4fea$var$_matrix.makeRotationFromQuaternion(q);
        return this.setFromRotationMatrix($e8ea6a63d48a4fea$var$_matrix, order, update);
    }
    setFromVector3(v, order = this._order) {
        return this.set(v.x, v.y, v.z, order);
    }
    reorder(newOrder) {
        // WARNING: this discards revolution information -bhouston
        $e8ea6a63d48a4fea$var$_quaternion$3.setFromEuler(this);
        return this.setFromQuaternion($e8ea6a63d48a4fea$var$_quaternion$3, newOrder);
    }
    equals(euler) {
        return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
    }
    fromArray(array) {
        this._x = array[0];
        this._y = array[1];
        this._z = array[2];
        if (array[3] !== undefined) this._order = array[3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._order;
        return array;
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._order;
    }
}
$e8ea6a63d48a4fea$export$d93cc409a0768c5f.DEFAULT_ORDER = "XYZ";
class $e8ea6a63d48a4fea$export$89312ce47c0ca777 {
    constructor(){
        this.mask = 1;
    }
    set(channel) {
        this.mask = (1 << channel | 0) >>> 0;
    }
    enable(channel) {
        this.mask |= 1 << channel | 0;
    }
    enableAll() {
        this.mask = -1;
    }
    toggle(channel) {
        this.mask ^= 1 << channel | 0;
    }
    disable(channel) {
        this.mask &= ~(1 << channel | 0);
    }
    disableAll() {
        this.mask = 0;
    }
    test(layers) {
        return (this.mask & layers.mask) !== 0;
    }
    isEnabled(channel) {
        return (this.mask & (1 << channel | 0)) !== 0;
    }
}
let $e8ea6a63d48a4fea$var$_object3DId = 0;
const $e8ea6a63d48a4fea$var$_v1$4 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_q1 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$23d6a54f0bbc85a3();
const $e8ea6a63d48a4fea$var$_m1$1 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5();
const $e8ea6a63d48a4fea$var$_target = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_position$3 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_scale$2 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_quaternion$2 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$23d6a54f0bbc85a3();
const $e8ea6a63d48a4fea$var$_xAxis = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699(1, 0, 0);
const $e8ea6a63d48a4fea$var$_yAxis = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699(0, 1, 0);
const $e8ea6a63d48a4fea$var$_zAxis = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699(0, 0, 1);
const $e8ea6a63d48a4fea$var$_addedEvent = {
    type: "added"
};
const $e8ea6a63d48a4fea$var$_removedEvent = {
    type: "removed"
};
class $e8ea6a63d48a4fea$export$e4dd07dff30cc924 extends $e8ea6a63d48a4fea$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isObject3D = true;
        Object.defineProperty(this, "id", {
            value: $e8ea6a63d48a4fea$var$_object3DId++
        });
        this.uuid = $e8ea6a63d48a4fea$var$generateUUID();
        this.name = "";
        this.type = "Object3D";
        this.parent = null;
        this.children = [];
        this.up = $e8ea6a63d48a4fea$export$e4dd07dff30cc924.DEFAULT_UP.clone();
        const position = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        const rotation = new $e8ea6a63d48a4fea$export$d93cc409a0768c5f();
        const quaternion = new $e8ea6a63d48a4fea$export$23d6a54f0bbc85a3();
        const scale = new $e8ea6a63d48a4fea$export$64b5c384219d3699(1, 1, 1);
        function onRotationChange() {
            quaternion.setFromEuler(rotation, false);
        }
        function onQuaternionChange() {
            rotation.setFromQuaternion(quaternion, undefined, false);
        }
        rotation._onChange(onRotationChange);
        quaternion._onChange(onQuaternionChange);
        Object.defineProperties(this, {
            position: {
                configurable: true,
                enumerable: true,
                value: position
            },
            rotation: {
                configurable: true,
                enumerable: true,
                value: rotation
            },
            quaternion: {
                configurable: true,
                enumerable: true,
                value: quaternion
            },
            scale: {
                configurable: true,
                enumerable: true,
                value: scale
            },
            modelViewMatrix: {
                value: new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5()
            },
            normalMatrix: {
                value: new $e8ea6a63d48a4fea$export$8ff26dafa08918()
            }
        });
        this.matrix = new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5();
        this.matrixWorld = new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5();
        this.matrixAutoUpdate = $e8ea6a63d48a4fea$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE;
        this.matrixWorldNeedsUpdate = false;
        this.matrixWorldAutoUpdate = $e8ea6a63d48a4fea$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE; // checked by the renderer
        this.layers = new $e8ea6a63d48a4fea$export$89312ce47c0ca777();
        this.visible = true;
        this.castShadow = false;
        this.receiveShadow = false;
        this.frustumCulled = true;
        this.renderOrder = 0;
        this.animations = [];
        this.userData = {};
    }
    onBeforeRender() {}
    onAfterRender() {}
    applyMatrix4(matrix) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        this.matrix.premultiply(matrix);
        this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    applyQuaternion(q) {
        this.quaternion.premultiply(q);
        return this;
    }
    setRotationFromAxisAngle(axis, angle) {
        // assumes axis is normalized
        this.quaternion.setFromAxisAngle(axis, angle);
    }
    setRotationFromEuler(euler) {
        this.quaternion.setFromEuler(euler, true);
    }
    setRotationFromMatrix(m) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        this.quaternion.setFromRotationMatrix(m);
    }
    setRotationFromQuaternion(q) {
        // assumes q is normalized
        this.quaternion.copy(q);
    }
    rotateOnAxis(axis, angle) {
        // rotate object on axis in object space
        // axis is assumed to be normalized
        $e8ea6a63d48a4fea$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.multiply($e8ea6a63d48a4fea$var$_q1);
        return this;
    }
    rotateOnWorldAxis(axis, angle) {
        // rotate object on axis in world space
        // axis is assumed to be normalized
        // method assumes no rotated parent
        $e8ea6a63d48a4fea$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.premultiply($e8ea6a63d48a4fea$var$_q1);
        return this;
    }
    rotateX(angle) {
        return this.rotateOnAxis($e8ea6a63d48a4fea$var$_xAxis, angle);
    }
    rotateY(angle) {
        return this.rotateOnAxis($e8ea6a63d48a4fea$var$_yAxis, angle);
    }
    rotateZ(angle) {
        return this.rotateOnAxis($e8ea6a63d48a4fea$var$_zAxis, angle);
    }
    translateOnAxis(axis, distance) {
        // translate object by distance along axis in object space
        // axis is assumed to be normalized
        $e8ea6a63d48a4fea$var$_v1$4.copy(axis).applyQuaternion(this.quaternion);
        this.position.add($e8ea6a63d48a4fea$var$_v1$4.multiplyScalar(distance));
        return this;
    }
    translateX(distance) {
        return this.translateOnAxis($e8ea6a63d48a4fea$var$_xAxis, distance);
    }
    translateY(distance) {
        return this.translateOnAxis($e8ea6a63d48a4fea$var$_yAxis, distance);
    }
    translateZ(distance) {
        return this.translateOnAxis($e8ea6a63d48a4fea$var$_zAxis, distance);
    }
    localToWorld(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4(this.matrixWorld);
    }
    worldToLocal(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4($e8ea6a63d48a4fea$var$_m1$1.copy(this.matrixWorld).invert());
    }
    lookAt(x, y, z) {
        // This method does not support objects having non-uniformly-scaled parent(s)
        if (x.isVector3) $e8ea6a63d48a4fea$var$_target.copy(x);
        else $e8ea6a63d48a4fea$var$_target.set(x, y, z);
        const parent = this.parent;
        this.updateWorldMatrix(true, false);
        $e8ea6a63d48a4fea$var$_position$3.setFromMatrixPosition(this.matrixWorld);
        if (this.isCamera || this.isLight) $e8ea6a63d48a4fea$var$_m1$1.lookAt($e8ea6a63d48a4fea$var$_position$3, $e8ea6a63d48a4fea$var$_target, this.up);
        else $e8ea6a63d48a4fea$var$_m1$1.lookAt($e8ea6a63d48a4fea$var$_target, $e8ea6a63d48a4fea$var$_position$3, this.up);
        this.quaternion.setFromRotationMatrix($e8ea6a63d48a4fea$var$_m1$1);
        if (parent) {
            $e8ea6a63d48a4fea$var$_m1$1.extractRotation(parent.matrixWorld);
            $e8ea6a63d48a4fea$var$_q1.setFromRotationMatrix($e8ea6a63d48a4fea$var$_m1$1);
            this.quaternion.premultiply($e8ea6a63d48a4fea$var$_q1.invert());
        }
    }
    add(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        if (object === this) {
            console.error("THREE.Object3D.add: object can't be added as a child of itself.", object);
            return this;
        }
        if (object && object.isObject3D) {
            if (object.parent !== null) object.parent.remove(object);
            object.parent = this;
            this.children.push(object);
            object.dispatchEvent($e8ea6a63d48a4fea$var$_addedEvent);
        } else console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", object);
        return this;
    }
    remove(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.remove(arguments[i]);
            return this;
        }
        const index = this.children.indexOf(object);
        if (index !== -1) {
            object.parent = null;
            this.children.splice(index, 1);
            object.dispatchEvent($e8ea6a63d48a4fea$var$_removedEvent);
        }
        return this;
    }
    removeFromParent() {
        const parent = this.parent;
        if (parent !== null) parent.remove(this);
        return this;
    }
    clear() {
        for(let i = 0; i < this.children.length; i++){
            const object = this.children[i];
            object.parent = null;
            object.dispatchEvent($e8ea6a63d48a4fea$var$_removedEvent);
        }
        this.children.length = 0;
        return this;
    }
    attach(object) {
        // adds object as a child of this, while maintaining the object's world transform
        // Note: This method does not support scene graphs having non-uniformly-scaled nodes(s)
        this.updateWorldMatrix(true, false);
        $e8ea6a63d48a4fea$var$_m1$1.copy(this.matrixWorld).invert();
        if (object.parent !== null) {
            object.parent.updateWorldMatrix(true, false);
            $e8ea6a63d48a4fea$var$_m1$1.multiply(object.parent.matrixWorld);
        }
        object.applyMatrix4($e8ea6a63d48a4fea$var$_m1$1);
        this.add(object);
        object.updateWorldMatrix(false, true);
        return this;
    }
    getObjectById(id) {
        return this.getObjectByProperty("id", id);
    }
    getObjectByName(name) {
        return this.getObjectByProperty("name", name);
    }
    getObjectByProperty(name, value) {
        if (this[name] === value) return this;
        for(let i = 0, l = this.children.length; i < l; i++){
            const child = this.children[i];
            const object = child.getObjectByProperty(name, value);
            if (object !== undefined) return object;
        }
        return undefined;
    }
    getObjectsByProperty(name, value) {
        let result = [];
        if (this[name] === value) result.push(this);
        for(let i = 0, l = this.children.length; i < l; i++){
            const childResult = this.children[i].getObjectsByProperty(name, value);
            if (childResult.length > 0) result = result.concat(childResult);
        }
        return result;
    }
    getWorldPosition(target) {
        this.updateWorldMatrix(true, false);
        return target.setFromMatrixPosition(this.matrixWorld);
    }
    getWorldQuaternion(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($e8ea6a63d48a4fea$var$_position$3, target, $e8ea6a63d48a4fea$var$_scale$2);
        return target;
    }
    getWorldScale(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($e8ea6a63d48a4fea$var$_position$3, $e8ea6a63d48a4fea$var$_quaternion$2, target);
        return target;
    }
    getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(e[8], e[9], e[10]).normalize();
    }
    raycast() {}
    traverse(callback) {
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverse(callback);
    }
    traverseVisible(callback) {
        if (this.visible === false) return;
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverseVisible(callback);
    }
    traverseAncestors(callback) {
        const parent = this.parent;
        if (parent !== null) {
            callback(parent);
            parent.traverseAncestors(callback);
        }
    }
    updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale);
        this.matrixWorldNeedsUpdate = true;
    }
    updateMatrixWorld(force) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldNeedsUpdate || force) {
            if (this.parent === null) this.matrixWorld.copy(this.matrix);
            else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
            this.matrixWorldNeedsUpdate = false;
            force = true;
        }
        // update children
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++){
            const child = children[i];
            if (child.matrixWorldAutoUpdate === true || force === true) child.updateMatrixWorld(force);
        }
    }
    updateWorldMatrix(updateParents, updateChildren) {
        const parent = this.parent;
        if (updateParents === true && parent !== null && parent.matrixWorldAutoUpdate === true) parent.updateWorldMatrix(true, false);
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.parent === null) this.matrixWorld.copy(this.matrix);
        else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        // update children
        if (updateChildren === true) {
            const children = this.children;
            for(let i = 0, l = children.length; i < l; i++){
                const child = children[i];
                if (child.matrixWorldAutoUpdate === true) child.updateWorldMatrix(false, true);
            }
        }
    }
    toJSON(meta) {
        // meta is a string when called from JSON.stringify
        const isRootObject = meta === undefined || typeof meta === "string";
        const output = {};
        // meta is a hash used to collect geometries, materials.
        // not providing it implies that this is the root object
        // being serialized.
        if (isRootObject) {
            // initialize meta obj
            meta = {
                geometries: {},
                materials: {},
                textures: {},
                images: {},
                shapes: {},
                skeletons: {},
                animations: {},
                nodes: {}
            };
            output.metadata = {
                version: 4.5,
                type: "Object",
                generator: "Object3D.toJSON"
            };
        }
        // standard Object3D serialization
        const object = {};
        object.uuid = this.uuid;
        object.type = this.type;
        if (this.name !== "") object.name = this.name;
        if (this.castShadow === true) object.castShadow = true;
        if (this.receiveShadow === true) object.receiveShadow = true;
        if (this.visible === false) object.visible = false;
        if (this.frustumCulled === false) object.frustumCulled = false;
        if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
        if (Object.keys(this.userData).length > 0) object.userData = this.userData;
        object.layers = this.layers.mask;
        object.matrix = this.matrix.toArray();
        object.up = this.up.toArray();
        if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
        // object specific properties
        if (this.isInstancedMesh) {
            object.type = "InstancedMesh";
            object.count = this.count;
            object.instanceMatrix = this.instanceMatrix.toJSON();
            if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
        }
        //
        function serialize(library, element) {
            if (library[element.uuid] === undefined) library[element.uuid] = element.toJSON(meta);
            return element.uuid;
        }
        if (this.isScene) {
            if (this.background) {
                if (this.background.isColor) object.background = this.background.toJSON();
                else if (this.background.isTexture) object.background = this.background.toJSON(meta).uuid;
            }
            if (this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true) object.environment = this.environment.toJSON(meta).uuid;
        } else if (this.isMesh || this.isLine || this.isPoints) {
            object.geometry = serialize(meta.geometries, this.geometry);
            const parameters = this.geometry.parameters;
            if (parameters !== undefined && parameters.shapes !== undefined) {
                const shapes = parameters.shapes;
                if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
                    const shape = shapes[i];
                    serialize(meta.shapes, shape);
                }
                else serialize(meta.shapes, shapes);
            }
        }
        if (this.isSkinnedMesh) {
            object.bindMode = this.bindMode;
            object.bindMatrix = this.bindMatrix.toArray();
            if (this.skeleton !== undefined) {
                serialize(meta.skeletons, this.skeleton);
                object.skeleton = this.skeleton.uuid;
            }
        }
        if (this.material !== undefined) {
            if (Array.isArray(this.material)) {
                const uuids = [];
                for(let i = 0, l = this.material.length; i < l; i++)uuids.push(serialize(meta.materials, this.material[i]));
                object.material = uuids;
            } else object.material = serialize(meta.materials, this.material);
        }
        //
        if (this.children.length > 0) {
            object.children = [];
            for(let i = 0; i < this.children.length; i++)object.children.push(this.children[i].toJSON(meta).object);
        }
        //
        if (this.animations.length > 0) {
            object.animations = [];
            for(let i = 0; i < this.animations.length; i++){
                const animation = this.animations[i];
                object.animations.push(serialize(meta.animations, animation));
            }
        }
        if (isRootObject) {
            const geometries = extractFromCache(meta.geometries);
            const materials = extractFromCache(meta.materials);
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const shapes = extractFromCache(meta.shapes);
            const skeletons = extractFromCache(meta.skeletons);
            const animations = extractFromCache(meta.animations);
            const nodes = extractFromCache(meta.nodes);
            if (geometries.length > 0) output.geometries = geometries;
            if (materials.length > 0) output.materials = materials;
            if (textures.length > 0) output.textures = textures;
            if (images.length > 0) output.images = images;
            if (shapes.length > 0) output.shapes = shapes;
            if (skeletons.length > 0) output.skeletons = skeletons;
            if (animations.length > 0) output.animations = animations;
            if (nodes.length > 0) output.nodes = nodes;
        }
        output.object = object;
        return output;
        // extract data from the cache hash
        // remove metadata on each item
        // and return as array
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
    }
    clone(recursive) {
        return new this.constructor().copy(this, recursive);
    }
    copy(source, recursive = true) {
        this.name = source.name;
        this.up.copy(source.up);
        this.position.copy(source.position);
        this.rotation.order = source.rotation.order;
        this.quaternion.copy(source.quaternion);
        this.scale.copy(source.scale);
        this.matrix.copy(source.matrix);
        this.matrixWorld.copy(source.matrixWorld);
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
        this.matrixWorldAutoUpdate = source.matrixWorldAutoUpdate;
        this.layers.mask = source.layers.mask;
        this.visible = source.visible;
        this.castShadow = source.castShadow;
        this.receiveShadow = source.receiveShadow;
        this.frustumCulled = source.frustumCulled;
        this.renderOrder = source.renderOrder;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        if (recursive === true) for(let i = 0; i < source.children.length; i++){
            const child = source.children[i];
            this.add(child.clone());
        }
        return this;
    }
}
$e8ea6a63d48a4fea$export$e4dd07dff30cc924.DEFAULT_UP = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699(0, 1, 0);
$e8ea6a63d48a4fea$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE = true;
$e8ea6a63d48a4fea$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = true;
const $e8ea6a63d48a4fea$var$_v0$1 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_v1$3 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_v2$2 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_v3$1 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_vab = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_vac = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_vbc = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_vap = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_vbp = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_vcp = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
let $e8ea6a63d48a4fea$var$warnedGetUV = false;
class $e8ea6a63d48a4fea$export$5a465592bfe74b48 {
    constructor(a = new $e8ea6a63d48a4fea$export$64b5c384219d3699(), b = new $e8ea6a63d48a4fea$export$64b5c384219d3699(), c = new $e8ea6a63d48a4fea$export$64b5c384219d3699()){
        this.a = a;
        this.b = b;
        this.c = c;
    }
    static getNormal(a, b, c, target) {
        target.subVectors(c, b);
        $e8ea6a63d48a4fea$var$_v0$1.subVectors(a, b);
        target.cross($e8ea6a63d48a4fea$var$_v0$1);
        const targetLengthSq = target.lengthSq();
        if (targetLengthSq > 0) return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
        return target.set(0, 0, 0);
    }
    // static/instance method to calculate barycentric coordinates
    // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
    static getBarycoord(point, a, b, c, target) {
        $e8ea6a63d48a4fea$var$_v0$1.subVectors(c, a);
        $e8ea6a63d48a4fea$var$_v1$3.subVectors(b, a);
        $e8ea6a63d48a4fea$var$_v2$2.subVectors(point, a);
        const dot00 = $e8ea6a63d48a4fea$var$_v0$1.dot($e8ea6a63d48a4fea$var$_v0$1);
        const dot01 = $e8ea6a63d48a4fea$var$_v0$1.dot($e8ea6a63d48a4fea$var$_v1$3);
        const dot02 = $e8ea6a63d48a4fea$var$_v0$1.dot($e8ea6a63d48a4fea$var$_v2$2);
        const dot11 = $e8ea6a63d48a4fea$var$_v1$3.dot($e8ea6a63d48a4fea$var$_v1$3);
        const dot12 = $e8ea6a63d48a4fea$var$_v1$3.dot($e8ea6a63d48a4fea$var$_v2$2);
        const denom = dot00 * dot11 - dot01 * dot01;
        // collinear or singular triangle
        if (denom === 0) // arbitrary location outside of triangle?
        // not sure if this is the best idea, maybe should be returning undefined
        return target.set(-2, -1, -1);
        const invDenom = 1 / denom;
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        // barycentric coordinates must always sum to 1
        return target.set(1 - u - v, v, u);
    }
    static containsPoint(point, a, b, c) {
        this.getBarycoord(point, a, b, c, $e8ea6a63d48a4fea$var$_v3$1);
        return $e8ea6a63d48a4fea$var$_v3$1.x >= 0 && $e8ea6a63d48a4fea$var$_v3$1.y >= 0 && $e8ea6a63d48a4fea$var$_v3$1.x + $e8ea6a63d48a4fea$var$_v3$1.y <= 1;
    }
    static getUV(point, p1, p2, p3, uv1, uv2, uv3, target) {
        if ($e8ea6a63d48a4fea$var$warnedGetUV === false) {
            console.warn("THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation().");
            $e8ea6a63d48a4fea$var$warnedGetUV = true;
        }
        return this.getInterpolation(point, p1, p2, p3, uv1, uv2, uv3, target);
    }
    static getInterpolation(point, p1, p2, p3, v1, v2, v3, target) {
        this.getBarycoord(point, p1, p2, p3, $e8ea6a63d48a4fea$var$_v3$1);
        target.setScalar(0);
        target.addScaledVector(v1, $e8ea6a63d48a4fea$var$_v3$1.x);
        target.addScaledVector(v2, $e8ea6a63d48a4fea$var$_v3$1.y);
        target.addScaledVector(v3, $e8ea6a63d48a4fea$var$_v3$1.z);
        return target;
    }
    static isFrontFacing(a, b, c, direction) {
        $e8ea6a63d48a4fea$var$_v0$1.subVectors(c, b);
        $e8ea6a63d48a4fea$var$_v1$3.subVectors(a, b);
        // strictly front facing
        return $e8ea6a63d48a4fea$var$_v0$1.cross($e8ea6a63d48a4fea$var$_v1$3).dot(direction) < 0 ? true : false;
    }
    set(a, b, c) {
        this.a.copy(a);
        this.b.copy(b);
        this.c.copy(c);
        return this;
    }
    setFromPointsAndIndices(points, i0, i1, i2) {
        this.a.copy(points[i0]);
        this.b.copy(points[i1]);
        this.c.copy(points[i2]);
        return this;
    }
    setFromAttributeAndIndices(attribute, i0, i1, i2) {
        this.a.fromBufferAttribute(attribute, i0);
        this.b.fromBufferAttribute(attribute, i1);
        this.c.fromBufferAttribute(attribute, i2);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(triangle) {
        this.a.copy(triangle.a);
        this.b.copy(triangle.b);
        this.c.copy(triangle.c);
        return this;
    }
    getArea() {
        $e8ea6a63d48a4fea$var$_v0$1.subVectors(this.c, this.b);
        $e8ea6a63d48a4fea$var$_v1$3.subVectors(this.a, this.b);
        return $e8ea6a63d48a4fea$var$_v0$1.cross($e8ea6a63d48a4fea$var$_v1$3).length() * 0.5;
    }
    getMidpoint(target) {
        return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    getNormal(target) {
        return $e8ea6a63d48a4fea$export$5a465592bfe74b48.getNormal(this.a, this.b, this.c, target);
    }
    getPlane(target) {
        return target.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    getBarycoord(point, target) {
        return $e8ea6a63d48a4fea$export$5a465592bfe74b48.getBarycoord(point, this.a, this.b, this.c, target);
    }
    getUV(point, uv1, uv2, uv3, target) {
        if ($e8ea6a63d48a4fea$var$warnedGetUV === false) {
            console.warn("THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation().");
            $e8ea6a63d48a4fea$var$warnedGetUV = true;
        }
        return $e8ea6a63d48a4fea$export$5a465592bfe74b48.getInterpolation(point, this.a, this.b, this.c, uv1, uv2, uv3, target);
    }
    getInterpolation(point, v1, v2, v3, target) {
        return $e8ea6a63d48a4fea$export$5a465592bfe74b48.getInterpolation(point, this.a, this.b, this.c, v1, v2, v3, target);
    }
    containsPoint(point) {
        return $e8ea6a63d48a4fea$export$5a465592bfe74b48.containsPoint(point, this.a, this.b, this.c);
    }
    isFrontFacing(direction) {
        return $e8ea6a63d48a4fea$export$5a465592bfe74b48.isFrontFacing(this.a, this.b, this.c, direction);
    }
    intersectsBox(box) {
        return box.intersectsTriangle(this);
    }
    closestPointToPoint(p, target) {
        const a = this.a, b = this.b, c = this.c;
        let v, w;
        // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
        // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
        // under the accompanying license; see chapter 5.1.5 for detailed explanation.
        // basically, we're distinguishing which of the voronoi regions of the triangle
        // the point lies in with the minimum amount of redundant computation.
        $e8ea6a63d48a4fea$var$_vab.subVectors(b, a);
        $e8ea6a63d48a4fea$var$_vac.subVectors(c, a);
        $e8ea6a63d48a4fea$var$_vap.subVectors(p, a);
        const d1 = $e8ea6a63d48a4fea$var$_vab.dot($e8ea6a63d48a4fea$var$_vap);
        const d2 = $e8ea6a63d48a4fea$var$_vac.dot($e8ea6a63d48a4fea$var$_vap);
        if (d1 <= 0 && d2 <= 0) // vertex region of A; barycentric coords (1, 0, 0)
        return target.copy(a);
        $e8ea6a63d48a4fea$var$_vbp.subVectors(p, b);
        const d3 = $e8ea6a63d48a4fea$var$_vab.dot($e8ea6a63d48a4fea$var$_vbp);
        const d4 = $e8ea6a63d48a4fea$var$_vac.dot($e8ea6a63d48a4fea$var$_vbp);
        if (d3 >= 0 && d4 <= d3) // vertex region of B; barycentric coords (0, 1, 0)
        return target.copy(b);
        const vc = d1 * d4 - d3 * d2;
        if (vc <= 0 && d1 >= 0 && d3 <= 0) {
            v = d1 / (d1 - d3);
            // edge region of AB; barycentric coords (1-v, v, 0)
            return target.copy(a).addScaledVector($e8ea6a63d48a4fea$var$_vab, v);
        }
        $e8ea6a63d48a4fea$var$_vcp.subVectors(p, c);
        const d5 = $e8ea6a63d48a4fea$var$_vab.dot($e8ea6a63d48a4fea$var$_vcp);
        const d6 = $e8ea6a63d48a4fea$var$_vac.dot($e8ea6a63d48a4fea$var$_vcp);
        if (d6 >= 0 && d5 <= d6) // vertex region of C; barycentric coords (0, 0, 1)
        return target.copy(c);
        const vb = d5 * d2 - d1 * d6;
        if (vb <= 0 && d2 >= 0 && d6 <= 0) {
            w = d2 / (d2 - d6);
            // edge region of AC; barycentric coords (1-w, 0, w)
            return target.copy(a).addScaledVector($e8ea6a63d48a4fea$var$_vac, w);
        }
        const va = d3 * d6 - d5 * d4;
        if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
            $e8ea6a63d48a4fea$var$_vbc.subVectors(c, b);
            w = (d4 - d3) / (d4 - d3 + (d5 - d6));
            // edge region of BC; barycentric coords (0, 1-w, w)
            return target.copy(b).addScaledVector($e8ea6a63d48a4fea$var$_vbc, w); // edge region of BC
        }
        // face region
        const denom = 1 / (va + vb + vc);
        // u = va * denom
        v = vb * denom;
        w = vc * denom;
        return target.copy(a).addScaledVector($e8ea6a63d48a4fea$var$_vab, v).addScaledVector($e8ea6a63d48a4fea$var$_vac, w);
    }
    equals(triangle) {
        return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
    }
}
let $e8ea6a63d48a4fea$var$materialId = 0;
class $e8ea6a63d48a4fea$export$a2d8b23205c25948 extends $e8ea6a63d48a4fea$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isMaterial = true;
        Object.defineProperty(this, "id", {
            value: $e8ea6a63d48a4fea$var$materialId++
        });
        this.uuid = $e8ea6a63d48a4fea$var$generateUUID();
        this.name = "";
        this.type = "Material";
        this.blending = $e8ea6a63d48a4fea$export$5b29a26d96ee6af0;
        this.side = $e8ea6a63d48a4fea$export$2ede184fc2998901;
        this.vertexColors = false;
        this.opacity = 1;
        this.transparent = false;
        this.blendSrc = $e8ea6a63d48a4fea$export$d5773124e86cf28c;
        this.blendDst = $e8ea6a63d48a4fea$export$11d468cc7f19e971;
        this.blendEquation = $e8ea6a63d48a4fea$export$20183a0484ce21a0;
        this.blendSrcAlpha = null;
        this.blendDstAlpha = null;
        this.blendEquationAlpha = null;
        this.depthFunc = $e8ea6a63d48a4fea$export$296f78a0b892f81a;
        this.depthTest = true;
        this.depthWrite = true;
        this.stencilWriteMask = 0xff;
        this.stencilFunc = $e8ea6a63d48a4fea$export$14cf96713ddd97a8;
        this.stencilRef = 0;
        this.stencilFuncMask = 0xff;
        this.stencilFail = $e8ea6a63d48a4fea$export$9f542ae4b5baca34;
        this.stencilZFail = $e8ea6a63d48a4fea$export$9f542ae4b5baca34;
        this.stencilZPass = $e8ea6a63d48a4fea$export$9f542ae4b5baca34;
        this.stencilWrite = false;
        this.clippingPlanes = null;
        this.clipIntersection = false;
        this.clipShadows = false;
        this.shadowSide = null;
        this.colorWrite = true;
        this.precision = null; // override the renderer's default precision for this material
        this.polygonOffset = false;
        this.polygonOffsetFactor = 0;
        this.polygonOffsetUnits = 0;
        this.dithering = false;
        this.alphaToCoverage = false;
        this.premultipliedAlpha = false;
        this.forceSinglePass = false;
        this.visible = true;
        this.toneMapped = true;
        this.userData = {};
        this.version = 0;
        this._alphaTest = 0;
    }
    get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(value) {
        if (this._alphaTest > 0 !== value > 0) this.version++;
        this._alphaTest = value;
    }
    onBuild() {}
    onBeforeRender() {}
    onBeforeCompile() {}
    customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    setValues(values) {
        if (values === undefined) return;
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                console.warn(`THREE.Material: parameter '${key}' has value of undefined.`);
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                console.warn(`THREE.Material: '${key}' is not a property of THREE.${this.type}.`);
                continue;
            }
            if (currentValue && currentValue.isColor) currentValue.set(newValue);
            else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === "string";
        if (isRootObject) meta = {
            textures: {},
            images: {}
        };
        const data = {
            metadata: {
                version: 4.5,
                type: "Material",
                generator: "Material.toJSON"
            }
        };
        // standard Material serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== "") data.name = this.name;
        if (this.color && this.color.isColor) data.color = this.color.getHex();
        if (this.roughness !== undefined) data.roughness = this.roughness;
        if (this.metalness !== undefined) data.metalness = this.metalness;
        if (this.sheen !== undefined) data.sheen = this.sheen;
        if (this.sheenColor && this.sheenColor.isColor) data.sheenColor = this.sheenColor.getHex();
        if (this.sheenRoughness !== undefined) data.sheenRoughness = this.sheenRoughness;
        if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
        if (this.emissiveIntensity && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
        if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
        if (this.specularIntensity !== undefined) data.specularIntensity = this.specularIntensity;
        if (this.specularColor && this.specularColor.isColor) data.specularColor = this.specularColor.getHex();
        if (this.shininess !== undefined) data.shininess = this.shininess;
        if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
        if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;
        if (this.clearcoatMap && this.clearcoatMap.isTexture) data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
        if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
        if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
            data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
            data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
        }
        if (this.iridescence !== undefined) data.iridescence = this.iridescence;
        if (this.iridescenceIOR !== undefined) data.iridescenceIOR = this.iridescenceIOR;
        if (this.iridescenceThicknessRange !== undefined) data.iridescenceThicknessRange = this.iridescenceThicknessRange;
        if (this.iridescenceMap && this.iridescenceMap.isTexture) data.iridescenceMap = this.iridescenceMap.toJSON(meta).uuid;
        if (this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture) data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(meta).uuid;
        if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
        if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
        if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
        if (this.lightMap && this.lightMap.isTexture) {
            data.lightMap = this.lightMap.toJSON(meta).uuid;
            data.lightMapIntensity = this.lightMapIntensity;
        }
        if (this.aoMap && this.aoMap.isTexture) {
            data.aoMap = this.aoMap.toJSON(meta).uuid;
            data.aoMapIntensity = this.aoMapIntensity;
        }
        if (this.bumpMap && this.bumpMap.isTexture) {
            data.bumpMap = this.bumpMap.toJSON(meta).uuid;
            data.bumpScale = this.bumpScale;
        }
        if (this.normalMap && this.normalMap.isTexture) {
            data.normalMap = this.normalMap.toJSON(meta).uuid;
            data.normalMapType = this.normalMapType;
            data.normalScale = this.normalScale.toArray();
        }
        if (this.displacementMap && this.displacementMap.isTexture) {
            data.displacementMap = this.displacementMap.toJSON(meta).uuid;
            data.displacementScale = this.displacementScale;
            data.displacementBias = this.displacementBias;
        }
        if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
        if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
        if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
        if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
        if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
        if (this.specularColorMap && this.specularColorMap.isTexture) data.specularColorMap = this.specularColorMap.toJSON(meta).uuid;
        if (this.envMap && this.envMap.isTexture) {
            data.envMap = this.envMap.toJSON(meta).uuid;
            if (this.combine !== undefined) data.combine = this.combine;
        }
        if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
        if (this.reflectivity !== undefined) data.reflectivity = this.reflectivity;
        if (this.refractionRatio !== undefined) data.refractionRatio = this.refractionRatio;
        if (this.gradientMap && this.gradientMap.isTexture) data.gradientMap = this.gradientMap.toJSON(meta).uuid;
        if (this.transmission !== undefined) data.transmission = this.transmission;
        if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
        if (this.thickness !== undefined) data.thickness = this.thickness;
        if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
        if (this.attenuationDistance !== undefined && this.attenuationDistance !== Infinity) data.attenuationDistance = this.attenuationDistance;
        if (this.attenuationColor !== undefined) data.attenuationColor = this.attenuationColor.getHex();
        if (this.size !== undefined) data.size = this.size;
        if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
        if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;
        if (this.blending !== $e8ea6a63d48a4fea$export$5b29a26d96ee6af0) data.blending = this.blending;
        if (this.side !== $e8ea6a63d48a4fea$export$2ede184fc2998901) data.side = this.side;
        if (this.vertexColors) data.vertexColors = true;
        if (this.opacity < 1) data.opacity = this.opacity;
        if (this.transparent === true) data.transparent = this.transparent;
        data.depthFunc = this.depthFunc;
        data.depthTest = this.depthTest;
        data.depthWrite = this.depthWrite;
        data.colorWrite = this.colorWrite;
        data.stencilWrite = this.stencilWrite;
        data.stencilWriteMask = this.stencilWriteMask;
        data.stencilFunc = this.stencilFunc;
        data.stencilRef = this.stencilRef;
        data.stencilFuncMask = this.stencilFuncMask;
        data.stencilFail = this.stencilFail;
        data.stencilZFail = this.stencilZFail;
        data.stencilZPass = this.stencilZPass;
        // rotation (SpriteMaterial)
        if (this.rotation !== undefined && this.rotation !== 0) data.rotation = this.rotation;
        if (this.polygonOffset === true) data.polygonOffset = true;
        if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
        if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
        if (this.linewidth !== undefined && this.linewidth !== 1) data.linewidth = this.linewidth;
        if (this.dashSize !== undefined) data.dashSize = this.dashSize;
        if (this.gapSize !== undefined) data.gapSize = this.gapSize;
        if (this.scale !== undefined) data.scale = this.scale;
        if (this.dithering === true) data.dithering = true;
        if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
        if (this.alphaToCoverage === true) data.alphaToCoverage = this.alphaToCoverage;
        if (this.premultipliedAlpha === true) data.premultipliedAlpha = this.premultipliedAlpha;
        if (this.forceSinglePass === true) data.forceSinglePass = this.forceSinglePass;
        if (this.wireframe === true) data.wireframe = this.wireframe;
        if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
        if (this.wireframeLinecap !== "round") data.wireframeLinecap = this.wireframeLinecap;
        if (this.wireframeLinejoin !== "round") data.wireframeLinejoin = this.wireframeLinejoin;
        if (this.flatShading === true) data.flatShading = this.flatShading;
        if (this.visible === false) data.visible = false;
        if (this.toneMapped === false) data.toneMapped = false;
        if (this.fog === false) data.fog = false;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRootObject) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
        }
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.blending = source.blending;
        this.side = source.side;
        this.vertexColors = source.vertexColors;
        this.opacity = source.opacity;
        this.transparent = source.transparent;
        this.blendSrc = source.blendSrc;
        this.blendDst = source.blendDst;
        this.blendEquation = source.blendEquation;
        this.blendSrcAlpha = source.blendSrcAlpha;
        this.blendDstAlpha = source.blendDstAlpha;
        this.blendEquationAlpha = source.blendEquationAlpha;
        this.depthFunc = source.depthFunc;
        this.depthTest = source.depthTest;
        this.depthWrite = source.depthWrite;
        this.stencilWriteMask = source.stencilWriteMask;
        this.stencilFunc = source.stencilFunc;
        this.stencilRef = source.stencilRef;
        this.stencilFuncMask = source.stencilFuncMask;
        this.stencilFail = source.stencilFail;
        this.stencilZFail = source.stencilZFail;
        this.stencilZPass = source.stencilZPass;
        this.stencilWrite = source.stencilWrite;
        const srcPlanes = source.clippingPlanes;
        let dstPlanes = null;
        if (srcPlanes !== null) {
            const n = srcPlanes.length;
            dstPlanes = new Array(n);
            for(let i = 0; i !== n; ++i)dstPlanes[i] = srcPlanes[i].clone();
        }
        this.clippingPlanes = dstPlanes;
        this.clipIntersection = source.clipIntersection;
        this.clipShadows = source.clipShadows;
        this.shadowSide = source.shadowSide;
        this.colorWrite = source.colorWrite;
        this.precision = source.precision;
        this.polygonOffset = source.polygonOffset;
        this.polygonOffsetFactor = source.polygonOffsetFactor;
        this.polygonOffsetUnits = source.polygonOffsetUnits;
        this.dithering = source.dithering;
        this.alphaTest = source.alphaTest;
        this.alphaToCoverage = source.alphaToCoverage;
        this.premultipliedAlpha = source.premultipliedAlpha;
        this.forceSinglePass = source.forceSinglePass;
        this.visible = source.visible;
        this.toneMapped = source.toneMapped;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
}
const $e8ea6a63d48a4fea$var$_colorKeywords = {
    "aliceblue": 0xF0F8FF,
    "antiquewhite": 0xFAEBD7,
    "aqua": 0x00FFFF,
    "aquamarine": 0x7FFFD4,
    "azure": 0xF0FFFF,
    "beige": 0xF5F5DC,
    "bisque": 0xFFE4C4,
    "black": 0x000000,
    "blanchedalmond": 0xFFEBCD,
    "blue": 0x0000FF,
    "blueviolet": 0x8A2BE2,
    "brown": 0xA52A2A,
    "burlywood": 0xDEB887,
    "cadetblue": 0x5F9EA0,
    "chartreuse": 0x7FFF00,
    "chocolate": 0xD2691E,
    "coral": 0xFF7F50,
    "cornflowerblue": 0x6495ED,
    "cornsilk": 0xFFF8DC,
    "crimson": 0xDC143C,
    "cyan": 0x00FFFF,
    "darkblue": 0x00008B,
    "darkcyan": 0x008B8B,
    "darkgoldenrod": 0xB8860B,
    "darkgray": 0xA9A9A9,
    "darkgreen": 0x006400,
    "darkgrey": 0xA9A9A9,
    "darkkhaki": 0xBDB76B,
    "darkmagenta": 0x8B008B,
    "darkolivegreen": 0x556B2F,
    "darkorange": 0xFF8C00,
    "darkorchid": 0x9932CC,
    "darkred": 0x8B0000,
    "darksalmon": 0xE9967A,
    "darkseagreen": 0x8FBC8F,
    "darkslateblue": 0x483D8B,
    "darkslategray": 0x2F4F4F,
    "darkslategrey": 0x2F4F4F,
    "darkturquoise": 0x00CED1,
    "darkviolet": 0x9400D3,
    "deeppink": 0xFF1493,
    "deepskyblue": 0x00BFFF,
    "dimgray": 0x696969,
    "dimgrey": 0x696969,
    "dodgerblue": 0x1E90FF,
    "firebrick": 0xB22222,
    "floralwhite": 0xFFFAF0,
    "forestgreen": 0x228B22,
    "fuchsia": 0xFF00FF,
    "gainsboro": 0xDCDCDC,
    "ghostwhite": 0xF8F8FF,
    "gold": 0xFFD700,
    "goldenrod": 0xDAA520,
    "gray": 0x808080,
    "green": 0x008000,
    "greenyellow": 0xADFF2F,
    "grey": 0x808080,
    "honeydew": 0xF0FFF0,
    "hotpink": 0xFF69B4,
    "indianred": 0xCD5C5C,
    "indigo": 0x4B0082,
    "ivory": 0xFFFFF0,
    "khaki": 0xF0E68C,
    "lavender": 0xE6E6FA,
    "lavenderblush": 0xFFF0F5,
    "lawngreen": 0x7CFC00,
    "lemonchiffon": 0xFFFACD,
    "lightblue": 0xADD8E6,
    "lightcoral": 0xF08080,
    "lightcyan": 0xE0FFFF,
    "lightgoldenrodyellow": 0xFAFAD2,
    "lightgray": 0xD3D3D3,
    "lightgreen": 0x90EE90,
    "lightgrey": 0xD3D3D3,
    "lightpink": 0xFFB6C1,
    "lightsalmon": 0xFFA07A,
    "lightseagreen": 0x20B2AA,
    "lightskyblue": 0x87CEFA,
    "lightslategray": 0x778899,
    "lightslategrey": 0x778899,
    "lightsteelblue": 0xB0C4DE,
    "lightyellow": 0xFFFFE0,
    "lime": 0x00FF00,
    "limegreen": 0x32CD32,
    "linen": 0xFAF0E6,
    "magenta": 0xFF00FF,
    "maroon": 0x800000,
    "mediumaquamarine": 0x66CDAA,
    "mediumblue": 0x0000CD,
    "mediumorchid": 0xBA55D3,
    "mediumpurple": 0x9370DB,
    "mediumseagreen": 0x3CB371,
    "mediumslateblue": 0x7B68EE,
    "mediumspringgreen": 0x00FA9A,
    "mediumturquoise": 0x48D1CC,
    "mediumvioletred": 0xC71585,
    "midnightblue": 0x191970,
    "mintcream": 0xF5FFFA,
    "mistyrose": 0xFFE4E1,
    "moccasin": 0xFFE4B5,
    "navajowhite": 0xFFDEAD,
    "navy": 0x000080,
    "oldlace": 0xFDF5E6,
    "olive": 0x808000,
    "olivedrab": 0x6B8E23,
    "orange": 0xFFA500,
    "orangered": 0xFF4500,
    "orchid": 0xDA70D6,
    "palegoldenrod": 0xEEE8AA,
    "palegreen": 0x98FB98,
    "paleturquoise": 0xAFEEEE,
    "palevioletred": 0xDB7093,
    "papayawhip": 0xFFEFD5,
    "peachpuff": 0xFFDAB9,
    "peru": 0xCD853F,
    "pink": 0xFFC0CB,
    "plum": 0xDDA0DD,
    "powderblue": 0xB0E0E6,
    "purple": 0x800080,
    "rebeccapurple": 0x663399,
    "red": 0xFF0000,
    "rosybrown": 0xBC8F8F,
    "royalblue": 0x4169E1,
    "saddlebrown": 0x8B4513,
    "salmon": 0xFA8072,
    "sandybrown": 0xF4A460,
    "seagreen": 0x2E8B57,
    "seashell": 0xFFF5EE,
    "sienna": 0xA0522D,
    "silver": 0xC0C0C0,
    "skyblue": 0x87CEEB,
    "slateblue": 0x6A5ACD,
    "slategray": 0x708090,
    "slategrey": 0x708090,
    "snow": 0xFFFAFA,
    "springgreen": 0x00FF7F,
    "steelblue": 0x4682B4,
    "tan": 0xD2B48C,
    "teal": 0x008080,
    "thistle": 0xD8BFD8,
    "tomato": 0xFF6347,
    "turquoise": 0x40E0D0,
    "violet": 0xEE82EE,
    "wheat": 0xF5DEB3,
    "white": 0xFFFFFF,
    "whitesmoke": 0xF5F5F5,
    "yellow": 0xFFFF00,
    "yellowgreen": 0x9ACD32
};
const $e8ea6a63d48a4fea$var$_hslA = {
    h: 0,
    s: 0,
    l: 0
};
const $e8ea6a63d48a4fea$var$_hslB = {
    h: 0,
    s: 0,
    l: 0
};
function $e8ea6a63d48a4fea$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
    return p;
}
class $e8ea6a63d48a4fea$export$892596cec99bc70e {
    constructor(r, g, b){
        this.isColor = true;
        this.r = 1;
        this.g = 1;
        this.b = 1;
        if (g === undefined && b === undefined) // r is THREE.Color, hex or string
        return this.set(r);
        return this.setRGB(r, g, b);
    }
    set(value) {
        if (value && value.isColor) this.copy(value);
        else if (typeof value === "number") this.setHex(value);
        else if (typeof value === "string") this.setStyle(value);
        return this;
    }
    setScalar(scalar) {
        this.r = scalar;
        this.g = scalar;
        this.b = scalar;
        return this;
    }
    setHex(hex, colorSpace1 = $e8ea6a63d48a4fea$export$561f394b24edfcaa) {
        hex = Math.floor(hex);
        this.r = (hex >> 16 & 255) / 255;
        this.g = (hex >> 8 & 255) / 255;
        this.b = (hex & 255) / 255;
        $e8ea6a63d48a4fea$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setRGB(r, g, b, colorSpace1 = $e8ea6a63d48a4fea$export$5e6fd513f44698c.workingColorSpace) {
        this.r = r;
        this.g = g;
        this.b = b;
        $e8ea6a63d48a4fea$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setHSL(h, s, l, colorSpace1 = $e8ea6a63d48a4fea$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        h = $e8ea6a63d48a4fea$var$euclideanModulo(h, 1);
        s = $e8ea6a63d48a4fea$var$clamp(s, 0, 1);
        l = $e8ea6a63d48a4fea$var$clamp(l, 0, 1);
        if (s === 0) this.r = this.g = this.b = l;
        else {
            const p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
            const q = 2 * l - p;
            this.r = $e8ea6a63d48a4fea$var$hue2rgb(q, p, h + 1 / 3);
            this.g = $e8ea6a63d48a4fea$var$hue2rgb(q, p, h);
            this.b = $e8ea6a63d48a4fea$var$hue2rgb(q, p, h - 1 / 3);
        }
        $e8ea6a63d48a4fea$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setStyle(style, colorSpace1 = $e8ea6a63d48a4fea$export$561f394b24edfcaa) {
        function handleAlpha(string) {
            if (string === undefined) return;
            if (parseFloat(string) < 1) console.warn("THREE.Color: Alpha component of " + style + " will be ignored.");
        }
        let m;
        if (m = /^(\w+)\(([^\)]*)\)/.exec(style)) {
            // rgb / hsl
            let color;
            const name = m[1];
            const components = m[2];
            switch(name){
                case "rgb":
                case "rgba":
                    if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(255,0,0) rgba(255,0,0,0.5)
                        this.r = Math.min(255, parseInt(color[1], 10)) / 255;
                        this.g = Math.min(255, parseInt(color[2], 10)) / 255;
                        this.b = Math.min(255, parseInt(color[3], 10)) / 255;
                        $e8ea6a63d48a4fea$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
                        handleAlpha(color[4]);
                        return this;
                    }
                    if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
                        this.r = Math.min(100, parseInt(color[1], 10)) / 100;
                        this.g = Math.min(100, parseInt(color[2], 10)) / 100;
                        this.b = Math.min(100, parseInt(color[3], 10)) / 100;
                        $e8ea6a63d48a4fea$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
                        handleAlpha(color[4]);
                        return this;
                    }
                    break;
                case "hsl":
                case "hsla":
                    if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
                        const h = parseFloat(color[1]) / 360;
                        const s = parseFloat(color[2]) / 100;
                        const l = parseFloat(color[3]) / 100;
                        handleAlpha(color[4]);
                        return this.setHSL(h, s, l, colorSpace1);
                    }
                    break;
                default:
                    console.warn("THREE.Color: Unknown color model " + style);
            }
        } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
            // hex color
            const hex = m[1];
            const size = hex.length;
            if (size === 3) // #ff0
            return this.setRGB(parseInt(hex.charAt(0), 16) / 15, parseInt(hex.charAt(1), 16) / 15, parseInt(hex.charAt(2), 16) / 15, colorSpace1);
            else if (size === 6) // #ff0000
            return this.setHex(parseInt(hex, 16), colorSpace1);
            else console.warn("THREE.Color: Invalid hex color " + style);
        } else if (style && style.length > 0) return this.setColorName(style, colorSpace1);
        return this;
    }
    setColorName(style, colorSpace1 = $e8ea6a63d48a4fea$export$561f394b24edfcaa) {
        // color keywords
        const hex = $e8ea6a63d48a4fea$var$_colorKeywords[style.toLowerCase()];
        if (hex !== undefined) // red
        this.setHex(hex, colorSpace1);
        else // unknown color
        console.warn("THREE.Color: Unknown color " + style);
        return this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    copy(color) {
        this.r = color.r;
        this.g = color.g;
        this.b = color.b;
        return this;
    }
    copySRGBToLinear(color) {
        this.r = $e8ea6a63d48a4fea$var$SRGBToLinear(color.r);
        this.g = $e8ea6a63d48a4fea$var$SRGBToLinear(color.g);
        this.b = $e8ea6a63d48a4fea$var$SRGBToLinear(color.b);
        return this;
    }
    copyLinearToSRGB(color) {
        this.r = $e8ea6a63d48a4fea$var$LinearToSRGB(color.r);
        this.g = $e8ea6a63d48a4fea$var$LinearToSRGB(color.g);
        this.b = $e8ea6a63d48a4fea$var$LinearToSRGB(color.b);
        return this;
    }
    convertSRGBToLinear() {
        this.copySRGBToLinear(this);
        return this;
    }
    convertLinearToSRGB() {
        this.copyLinearToSRGB(this);
        return this;
    }
    getHex(colorSpace1 = $e8ea6a63d48a4fea$export$561f394b24edfcaa) {
        $e8ea6a63d48a4fea$export$5e6fd513f44698c.fromWorkingColorSpace($e8ea6a63d48a4fea$var$_color.copy(this), colorSpace1);
        return $e8ea6a63d48a4fea$var$clamp($e8ea6a63d48a4fea$var$_color.r * 255, 0, 255) << 16 ^ $e8ea6a63d48a4fea$var$clamp($e8ea6a63d48a4fea$var$_color.g * 255, 0, 255) << 8 ^ $e8ea6a63d48a4fea$var$clamp($e8ea6a63d48a4fea$var$_color.b * 255, 0, 255) << 0;
    }
    getHexString(colorSpace1 = $e8ea6a63d48a4fea$export$561f394b24edfcaa) {
        return ("000000" + this.getHex(colorSpace1).toString(16)).slice(-6);
    }
    getHSL(target, colorSpace1 = $e8ea6a63d48a4fea$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        $e8ea6a63d48a4fea$export$5e6fd513f44698c.fromWorkingColorSpace($e8ea6a63d48a4fea$var$_color.copy(this), colorSpace1);
        const r = $e8ea6a63d48a4fea$var$_color.r, g = $e8ea6a63d48a4fea$var$_color.g, b = $e8ea6a63d48a4fea$var$_color.b;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let hue, saturation;
        const lightness = (min + max) / 2.0;
        if (min === max) {
            hue = 0;
            saturation = 0;
        } else {
            const delta = max - min;
            saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
            switch(max){
                case r:
                    hue = (g - b) / delta + (g < b ? 6 : 0);
                    break;
                case g:
                    hue = (b - r) / delta + 2;
                    break;
                case b:
                    hue = (r - g) / delta + 4;
                    break;
            }
            hue /= 6;
        }
        target.h = hue;
        target.s = saturation;
        target.l = lightness;
        return target;
    }
    getRGB(target, colorSpace1 = $e8ea6a63d48a4fea$export$5e6fd513f44698c.workingColorSpace) {
        $e8ea6a63d48a4fea$export$5e6fd513f44698c.fromWorkingColorSpace($e8ea6a63d48a4fea$var$_color.copy(this), colorSpace1);
        target.r = $e8ea6a63d48a4fea$var$_color.r;
        target.g = $e8ea6a63d48a4fea$var$_color.g;
        target.b = $e8ea6a63d48a4fea$var$_color.b;
        return target;
    }
    getStyle(colorSpace1 = $e8ea6a63d48a4fea$export$561f394b24edfcaa) {
        $e8ea6a63d48a4fea$export$5e6fd513f44698c.fromWorkingColorSpace($e8ea6a63d48a4fea$var$_color.copy(this), colorSpace1);
        const r = $e8ea6a63d48a4fea$var$_color.r, g = $e8ea6a63d48a4fea$var$_color.g, b = $e8ea6a63d48a4fea$var$_color.b;
        if (colorSpace1 !== $e8ea6a63d48a4fea$export$561f394b24edfcaa) // Requires CSS Color Module Level 4 (https://www.w3.org/TR/css-color-4/).
        return `color(${colorSpace1} ${r.toFixed(3)} ${g.toFixed(3)} ${b.toFixed(3)})`;
        return `rgb(${r * 255 | 0},${g * 255 | 0},${b * 255 | 0})`;
    }
    offsetHSL(h, s, l) {
        this.getHSL($e8ea6a63d48a4fea$var$_hslA);
        $e8ea6a63d48a4fea$var$_hslA.h += h;
        $e8ea6a63d48a4fea$var$_hslA.s += s;
        $e8ea6a63d48a4fea$var$_hslA.l += l;
        this.setHSL($e8ea6a63d48a4fea$var$_hslA.h, $e8ea6a63d48a4fea$var$_hslA.s, $e8ea6a63d48a4fea$var$_hslA.l);
        return this;
    }
    add(color) {
        this.r += color.r;
        this.g += color.g;
        this.b += color.b;
        return this;
    }
    addColors(color1, color2) {
        this.r = color1.r + color2.r;
        this.g = color1.g + color2.g;
        this.b = color1.b + color2.b;
        return this;
    }
    addScalar(s) {
        this.r += s;
        this.g += s;
        this.b += s;
        return this;
    }
    sub(color) {
        this.r = Math.max(0, this.r - color.r);
        this.g = Math.max(0, this.g - color.g);
        this.b = Math.max(0, this.b - color.b);
        return this;
    }
    multiply(color) {
        this.r *= color.r;
        this.g *= color.g;
        this.b *= color.b;
        return this;
    }
    multiplyScalar(s) {
        this.r *= s;
        this.g *= s;
        this.b *= s;
        return this;
    }
    lerp(color, alpha) {
        this.r += (color.r - this.r) * alpha;
        this.g += (color.g - this.g) * alpha;
        this.b += (color.b - this.b) * alpha;
        return this;
    }
    lerpColors(color1, color2, alpha) {
        this.r = color1.r + (color2.r - color1.r) * alpha;
        this.g = color1.g + (color2.g - color1.g) * alpha;
        this.b = color1.b + (color2.b - color1.b) * alpha;
        return this;
    }
    lerpHSL(color, alpha) {
        this.getHSL($e8ea6a63d48a4fea$var$_hslA);
        color.getHSL($e8ea6a63d48a4fea$var$_hslB);
        const h = $e8ea6a63d48a4fea$var$lerp($e8ea6a63d48a4fea$var$_hslA.h, $e8ea6a63d48a4fea$var$_hslB.h, alpha);
        const s = $e8ea6a63d48a4fea$var$lerp($e8ea6a63d48a4fea$var$_hslA.s, $e8ea6a63d48a4fea$var$_hslB.s, alpha);
        const l = $e8ea6a63d48a4fea$var$lerp($e8ea6a63d48a4fea$var$_hslA.l, $e8ea6a63d48a4fea$var$_hslB.l, alpha);
        this.setHSL(h, s, l);
        return this;
    }
    setFromVector3(v) {
        this.r = v.x;
        this.g = v.y;
        this.b = v.z;
        return this;
    }
    applyMatrix3(m) {
        const r = this.r, g = this.g, b = this.b;
        const e = m.elements;
        this.r = e[0] * r + e[3] * g + e[6] * b;
        this.g = e[1] * r + e[4] * g + e[7] * b;
        this.b = e[2] * r + e[5] * g + e[8] * b;
        return this;
    }
    equals(c) {
        return c.r === this.r && c.g === this.g && c.b === this.b;
    }
    fromArray(array, offset = 0) {
        this.r = array[offset];
        this.g = array[offset + 1];
        this.b = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.r;
        array[offset + 1] = this.g;
        array[offset + 2] = this.b;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.r = attribute.getX(index);
        this.g = attribute.getY(index);
        this.b = attribute.getZ(index);
        return this;
    }
    toJSON() {
        return this.getHex();
    }
    *[Symbol.iterator]() {
        yield this.r;
        yield this.g;
        yield this.b;
    }
}
const $e8ea6a63d48a4fea$var$_color = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$892596cec99bc70e();
$e8ea6a63d48a4fea$export$892596cec99bc70e.NAMES = $e8ea6a63d48a4fea$var$_colorKeywords;
class $e8ea6a63d48a4fea$export$55cbcc9b622fe1f5 extends $e8ea6a63d48a4fea$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshBasicMaterial = true;
        this.type = "MeshBasicMaterial";
        this.color = new $e8ea6a63d48a4fea$export$892596cec99bc70e(0xffffff); // emissive
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $e8ea6a63d48a4fea$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
// Fast Half Float Conversions, http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
const $e8ea6a63d48a4fea$var$_tables = /*@__PURE__*/ $e8ea6a63d48a4fea$var$_generateTables();
function $e8ea6a63d48a4fea$var$_generateTables() {
    // float32 to float16 helpers
    const buffer = new ArrayBuffer(4);
    const floatView = new Float32Array(buffer);
    const uint32View = new Uint32Array(buffer);
    const baseTable = new Uint32Array(512);
    const shiftTable = new Uint32Array(512);
    for(let i = 0; i < 256; ++i){
        const e = i - 127;
        // very small number (0, -0)
        if (e < -27) {
            baseTable[i] = 0x0000;
            baseTable[i | 0x100] = 0x8000;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // small number (denorm)
        } else if (e < -14) {
            baseTable[i] = 0x0400 >> -e - 14;
            baseTable[i | 0x100] = 0x0400 >> -e - 14 | 0x8000;
            shiftTable[i] = -e - 1;
            shiftTable[i | 0x100] = -e - 1;
        // normal number
        } else if (e <= 15) {
            baseTable[i] = e + 15 << 10;
            baseTable[i | 0x100] = e + 15 << 10 | 0x8000;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        // large number (Infinity, -Infinity)
        } else if (e < 128) {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // stay (NaN, Infinity, -Infinity)
        } else {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        }
    }
    // float16 to float32 helpers
    const mantissaTable = new Uint32Array(2048);
    const exponentTable = new Uint32Array(64);
    const offsetTable = new Uint32Array(64);
    for(let i = 1; i < 1024; ++i){
        let m = i << 13; // zero pad mantissa bits
        let e = 0; // zero exponent
        // normalized
        while((m & 0x00800000) === 0){
            m <<= 1;
            e -= 0x00800000; // decrement exponent
        }
        m &= -8388609; // clear leading 1 bit
        e += 0x38800000; // adjust bias
        mantissaTable[i] = m | e;
    }
    for(let i = 1024; i < 2048; ++i)mantissaTable[i] = 0x38000000 + (i - 1024 << 13);
    for(let i = 1; i < 31; ++i)exponentTable[i] = i << 23;
    exponentTable[31] = 0x47800000;
    exponentTable[32] = 0x80000000;
    for(let i = 33; i < 63; ++i)exponentTable[i] = 0x80000000 + (i - 32 << 23);
    exponentTable[63] = 0xc7800000;
    for(let i = 1; i < 64; ++i)if (i !== 32) offsetTable[i] = 1024;
    return {
        floatView: floatView,
        uint32View: uint32View,
        baseTable: baseTable,
        shiftTable: shiftTable,
        mantissaTable: mantissaTable,
        exponentTable: exponentTable,
        offsetTable: offsetTable
    };
}
// float32 to float16
function $e8ea6a63d48a4fea$var$toHalfFloat(val) {
    if (Math.abs(val) > 65504) console.warn("THREE.DataUtils.toHalfFloat(): Value out of range.");
    val = $e8ea6a63d48a4fea$var$clamp(val, -65504, 65504);
    $e8ea6a63d48a4fea$var$_tables.floatView[0] = val;
    const f = $e8ea6a63d48a4fea$var$_tables.uint32View[0];
    const e = f >> 23 & 0x1ff;
    return $e8ea6a63d48a4fea$var$_tables.baseTable[e] + ((f & 0x007fffff) >> $e8ea6a63d48a4fea$var$_tables.shiftTable[e]);
}
// float16 to float32
function $e8ea6a63d48a4fea$var$fromHalfFloat(val) {
    const m = val >> 10;
    $e8ea6a63d48a4fea$var$_tables.uint32View[0] = $e8ea6a63d48a4fea$var$_tables.mantissaTable[$e8ea6a63d48a4fea$var$_tables.offsetTable[m] + (val & 0x3ff)] + $e8ea6a63d48a4fea$var$_tables.exponentTable[m];
    return $e8ea6a63d48a4fea$var$_tables.floatView[0];
}
const $e8ea6a63d48a4fea$export$11ce8b759162cc80 = {
    toHalfFloat: $e8ea6a63d48a4fea$var$toHalfFloat,
    fromHalfFloat: $e8ea6a63d48a4fea$var$fromHalfFloat
};
const $e8ea6a63d48a4fea$var$_vector$8 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_vector2$1 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$c977b3e384af9ae1();
class $e8ea6a63d48a4fea$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized = false){
        if (Array.isArray(array)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
        this.isBufferAttribute = true;
        this.name = "";
        this.array = array;
        this.itemSize = itemSize;
        this.count = array !== undefined ? array.length / itemSize : 0;
        this.normalized = normalized;
        this.usage = $e8ea6a63d48a4fea$export$763e8360f4d7f77d;
        this.updateRange = {
            offset: 0,
            count: -1
        };
        this.version = 0;
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    copy(source) {
        this.name = source.name;
        this.array = new source.array.constructor(source.array);
        this.itemSize = source.itemSize;
        this.count = source.count;
        this.normalized = source.normalized;
        this.usage = source.usage;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.itemSize;
        index2 *= attribute.itemSize;
        for(let i = 0, l = this.itemSize; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    copyArray(array) {
        this.array.set(array);
        return this;
    }
    applyMatrix3(m) {
        if (this.itemSize === 2) for(let i = 0, l = this.count; i < l; i++){
            $e8ea6a63d48a4fea$var$_vector2$1.fromBufferAttribute(this, i);
            $e8ea6a63d48a4fea$var$_vector2$1.applyMatrix3(m);
            this.setXY(i, $e8ea6a63d48a4fea$var$_vector2$1.x, $e8ea6a63d48a4fea$var$_vector2$1.y);
        }
        else if (this.itemSize === 3) for(let i = 0, l = this.count; i < l; i++){
            $e8ea6a63d48a4fea$var$_vector$8.fromBufferAttribute(this, i);
            $e8ea6a63d48a4fea$var$_vector$8.applyMatrix3(m);
            this.setXYZ(i, $e8ea6a63d48a4fea$var$_vector$8.x, $e8ea6a63d48a4fea$var$_vector$8.y, $e8ea6a63d48a4fea$var$_vector$8.z);
        }
        return this;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $e8ea6a63d48a4fea$var$_vector$8.fromBufferAttribute(this, i);
            $e8ea6a63d48a4fea$var$_vector$8.applyMatrix4(m);
            this.setXYZ(i, $e8ea6a63d48a4fea$var$_vector$8.x, $e8ea6a63d48a4fea$var$_vector$8.y, $e8ea6a63d48a4fea$var$_vector$8.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $e8ea6a63d48a4fea$var$_vector$8.fromBufferAttribute(this, i);
            $e8ea6a63d48a4fea$var$_vector$8.applyNormalMatrix(m);
            this.setXYZ(i, $e8ea6a63d48a4fea$var$_vector$8.x, $e8ea6a63d48a4fea$var$_vector$8.y, $e8ea6a63d48a4fea$var$_vector$8.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $e8ea6a63d48a4fea$var$_vector$8.fromBufferAttribute(this, i);
            $e8ea6a63d48a4fea$var$_vector$8.transformDirection(m);
            this.setXYZ(i, $e8ea6a63d48a4fea$var$_vector$8.x, $e8ea6a63d48a4fea$var$_vector$8.y, $e8ea6a63d48a4fea$var$_vector$8.z);
        }
        return this;
    }
    set(value, offset = 0) {
        // Matching BufferAttribute constructor, do not normalize the array.
        this.array.set(value, offset);
        return this;
    }
    getX(index) {
        let x = this.array[index * this.itemSize];
        if (this.normalized) x = $e8ea6a63d48a4fea$var$denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = $e8ea6a63d48a4fea$var$normalize(x, this.array);
        this.array[index * this.itemSize] = x;
        return this;
    }
    getY(index) {
        let y = this.array[index * this.itemSize + 1];
        if (this.normalized) y = $e8ea6a63d48a4fea$var$denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = $e8ea6a63d48a4fea$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = y;
        return this;
    }
    getZ(index) {
        let z = this.array[index * this.itemSize + 2];
        if (this.normalized) z = $e8ea6a63d48a4fea$var$denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = $e8ea6a63d48a4fea$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = z;
        return this;
    }
    getW(index) {
        let w = this.array[index * this.itemSize + 3];
        if (this.normalized) w = $e8ea6a63d48a4fea$var$denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = $e8ea6a63d48a4fea$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = w;
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $e8ea6a63d48a4fea$var$normalize(x, this.array);
            y = $e8ea6a63d48a4fea$var$normalize(y, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $e8ea6a63d48a4fea$var$normalize(x, this.array);
            y = $e8ea6a63d48a4fea$var$normalize(y, this.array);
            z = $e8ea6a63d48a4fea$var$normalize(z, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $e8ea6a63d48a4fea$var$normalize(x, this.array);
            y = $e8ea6a63d48a4fea$var$normalize(y, this.array);
            z = $e8ea6a63d48a4fea$var$normalize(z, this.array);
            w = $e8ea6a63d48a4fea$var$normalize(w, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        this.array[index + 3] = w;
        return this;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    toJSON() {
        const data = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.from(this.array),
            normalized: this.normalized
        };
        if (this.name !== "") data.name = this.name;
        if (this.usage !== $e8ea6a63d48a4fea$export$763e8360f4d7f77d) data.usage = this.usage;
        if (this.updateRange.offset !== 0 || this.updateRange.count !== -1) data.updateRange = this.updateRange;
        return data;
    }
    copyColorsArray() {
        console.error("THREE.BufferAttribute: copyColorsArray() was removed in r144.");
    }
    copyVector2sArray() {
        console.error("THREE.BufferAttribute: copyVector2sArray() was removed in r144.");
    }
    copyVector3sArray() {
        console.error("THREE.BufferAttribute: copyVector3sArray() was removed in r144.");
    }
    copyVector4sArray() {
        console.error("THREE.BufferAttribute: copyVector4sArray() was removed in r144.");
    }
}
//
class $e8ea6a63d48a4fea$export$f9ff2d6a20248cbf extends $e8ea6a63d48a4fea$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int8Array(array), itemSize, normalized);
    }
}
class $e8ea6a63d48a4fea$export$cacc90cf35d11cdd extends $e8ea6a63d48a4fea$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8Array(array), itemSize, normalized);
    }
}
class $e8ea6a63d48a4fea$export$baaa85a1a812c157 extends $e8ea6a63d48a4fea$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8ClampedArray(array), itemSize, normalized);
    }
}
class $e8ea6a63d48a4fea$export$2b755a102ccdcefe extends $e8ea6a63d48a4fea$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int16Array(array), itemSize, normalized);
    }
}
class $e8ea6a63d48a4fea$export$640a853f68025f2e extends $e8ea6a63d48a4fea$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
    }
}
class $e8ea6a63d48a4fea$export$46b369aed2968a0a extends $e8ea6a63d48a4fea$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int32Array(array), itemSize, normalized);
    }
}
class $e8ea6a63d48a4fea$export$7eb8c9fa25cd5bd6 extends $e8ea6a63d48a4fea$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint32Array(array), itemSize, normalized);
    }
}
class $e8ea6a63d48a4fea$export$dbd3698c64958d69 extends $e8ea6a63d48a4fea$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
        this.isFloat16BufferAttribute = true;
    }
    getX(index) {
        let x = $e8ea6a63d48a4fea$var$fromHalfFloat(this.array[index * this.itemSize]);
        if (this.normalized) x = $e8ea6a63d48a4fea$var$denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = $e8ea6a63d48a4fea$var$normalize(x, this.array);
        this.array[index * this.itemSize] = $e8ea6a63d48a4fea$var$toHalfFloat(x);
        return this;
    }
    getY(index) {
        let y = $e8ea6a63d48a4fea$var$fromHalfFloat(this.array[index * this.itemSize + 1]);
        if (this.normalized) y = $e8ea6a63d48a4fea$var$denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = $e8ea6a63d48a4fea$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = $e8ea6a63d48a4fea$var$toHalfFloat(y);
        return this;
    }
    getZ(index) {
        let z = $e8ea6a63d48a4fea$var$fromHalfFloat(this.array[index * this.itemSize + 2]);
        if (this.normalized) z = $e8ea6a63d48a4fea$var$denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = $e8ea6a63d48a4fea$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = $e8ea6a63d48a4fea$var$toHalfFloat(z);
        return this;
    }
    getW(index) {
        let w = $e8ea6a63d48a4fea$var$fromHalfFloat(this.array[index * this.itemSize + 3]);
        if (this.normalized) w = $e8ea6a63d48a4fea$var$denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = $e8ea6a63d48a4fea$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = $e8ea6a63d48a4fea$var$toHalfFloat(w);
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $e8ea6a63d48a4fea$var$normalize(x, this.array);
            y = $e8ea6a63d48a4fea$var$normalize(y, this.array);
        }
        this.array[index + 0] = $e8ea6a63d48a4fea$var$toHalfFloat(x);
        this.array[index + 1] = $e8ea6a63d48a4fea$var$toHalfFloat(y);
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $e8ea6a63d48a4fea$var$normalize(x, this.array);
            y = $e8ea6a63d48a4fea$var$normalize(y, this.array);
            z = $e8ea6a63d48a4fea$var$normalize(z, this.array);
        }
        this.array[index + 0] = $e8ea6a63d48a4fea$var$toHalfFloat(x);
        this.array[index + 1] = $e8ea6a63d48a4fea$var$toHalfFloat(y);
        this.array[index + 2] = $e8ea6a63d48a4fea$var$toHalfFloat(z);
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $e8ea6a63d48a4fea$var$normalize(x, this.array);
            y = $e8ea6a63d48a4fea$var$normalize(y, this.array);
            z = $e8ea6a63d48a4fea$var$normalize(z, this.array);
            w = $e8ea6a63d48a4fea$var$normalize(w, this.array);
        }
        this.array[index + 0] = $e8ea6a63d48a4fea$var$toHalfFloat(x);
        this.array[index + 1] = $e8ea6a63d48a4fea$var$toHalfFloat(y);
        this.array[index + 2] = $e8ea6a63d48a4fea$var$toHalfFloat(z);
        this.array[index + 3] = $e8ea6a63d48a4fea$var$toHalfFloat(w);
        return this;
    }
}
class $e8ea6a63d48a4fea$export$cbe7a62641830ebd extends $e8ea6a63d48a4fea$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float32Array(array), itemSize, normalized);
    }
}
class $e8ea6a63d48a4fea$export$9e0ade74842adbb8 extends $e8ea6a63d48a4fea$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float64Array(array), itemSize, normalized);
    }
}
let $e8ea6a63d48a4fea$var$_id$1 = 0;
const $e8ea6a63d48a4fea$var$_m1 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5();
const $e8ea6a63d48a4fea$var$_obj = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$e4dd07dff30cc924();
const $e8ea6a63d48a4fea$var$_offset = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_box$1 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$6f7d5a9418ab2aa3();
const $e8ea6a63d48a4fea$var$_boxMorphTargets = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$6f7d5a9418ab2aa3();
const $e8ea6a63d48a4fea$var$_vector$7 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
class $e8ea6a63d48a4fea$export$b7be63a67df8959 extends $e8ea6a63d48a4fea$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isBufferGeometry = true;
        Object.defineProperty(this, "id", {
            value: $e8ea6a63d48a4fea$var$_id$1++
        });
        this.uuid = $e8ea6a63d48a4fea$var$generateUUID();
        this.name = "";
        this.type = "BufferGeometry";
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.morphTargetsRelative = false;
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        this.drawRange = {
            start: 0,
            count: Infinity
        };
        this.userData = {};
    }
    getIndex() {
        return this.index;
    }
    setIndex(index) {
        if (Array.isArray(index)) this.index = new ($e8ea6a63d48a4fea$var$arrayNeedsUint32(index) ? $e8ea6a63d48a4fea$export$7eb8c9fa25cd5bd6 : $e8ea6a63d48a4fea$export$640a853f68025f2e)(index, 1);
        else this.index = index;
        return this;
    }
    getAttribute(name) {
        return this.attributes[name];
    }
    setAttribute(name, attribute) {
        this.attributes[name] = attribute;
        return this;
    }
    deleteAttribute(name) {
        delete this.attributes[name];
        return this;
    }
    hasAttribute(name) {
        return this.attributes[name] !== undefined;
    }
    addGroup(start, count, materialIndex = 0) {
        this.groups.push({
            start: start,
            count: count,
            materialIndex: materialIndex
        });
    }
    clearGroups() {
        this.groups = [];
    }
    setDrawRange(start, count) {
        this.drawRange.start = start;
        this.drawRange.count = count;
    }
    applyMatrix4(matrix) {
        const position = this.attributes.position;
        if (position !== undefined) {
            position.applyMatrix4(matrix);
            position.needsUpdate = true;
        }
        const normal = this.attributes.normal;
        if (normal !== undefined) {
            const normalMatrix = new $e8ea6a63d48a4fea$export$8ff26dafa08918().getNormalMatrix(matrix);
            normal.applyNormalMatrix(normalMatrix);
            normal.needsUpdate = true;
        }
        const tangent = this.attributes.tangent;
        if (tangent !== undefined) {
            tangent.transformDirection(matrix);
            tangent.needsUpdate = true;
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        return this;
    }
    applyQuaternion(q) {
        $e8ea6a63d48a4fea$var$_m1.makeRotationFromQuaternion(q);
        this.applyMatrix4($e8ea6a63d48a4fea$var$_m1);
        return this;
    }
    rotateX(angle) {
        // rotate geometry around world x-axis
        $e8ea6a63d48a4fea$var$_m1.makeRotationX(angle);
        this.applyMatrix4($e8ea6a63d48a4fea$var$_m1);
        return this;
    }
    rotateY(angle) {
        // rotate geometry around world y-axis
        $e8ea6a63d48a4fea$var$_m1.makeRotationY(angle);
        this.applyMatrix4($e8ea6a63d48a4fea$var$_m1);
        return this;
    }
    rotateZ(angle) {
        // rotate geometry around world z-axis
        $e8ea6a63d48a4fea$var$_m1.makeRotationZ(angle);
        this.applyMatrix4($e8ea6a63d48a4fea$var$_m1);
        return this;
    }
    translate(x, y, z) {
        // translate geometry
        $e8ea6a63d48a4fea$var$_m1.makeTranslation(x, y, z);
        this.applyMatrix4($e8ea6a63d48a4fea$var$_m1);
        return this;
    }
    scale(x, y, z) {
        // scale geometry
        $e8ea6a63d48a4fea$var$_m1.makeScale(x, y, z);
        this.applyMatrix4($e8ea6a63d48a4fea$var$_m1);
        return this;
    }
    lookAt(vector) {
        $e8ea6a63d48a4fea$var$_obj.lookAt(vector);
        $e8ea6a63d48a4fea$var$_obj.updateMatrix();
        this.applyMatrix4($e8ea6a63d48a4fea$var$_obj.matrix);
        return this;
    }
    center() {
        this.computeBoundingBox();
        this.boundingBox.getCenter($e8ea6a63d48a4fea$var$_offset).negate();
        this.translate($e8ea6a63d48a4fea$var$_offset.x, $e8ea6a63d48a4fea$var$_offset.y, $e8ea6a63d48a4fea$var$_offset.z);
        return this;
    }
    setFromPoints(points) {
        const position = [];
        for(let i = 0, l = points.length; i < l; i++){
            const point = points[i];
            position.push(point.x, point.y, point.z || 0);
        }
        this.setAttribute("position", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(position, 3));
        return this;
    }
    computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $e8ea6a63d48a4fea$export$6f7d5a9418ab2aa3();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this);
            this.boundingBox.set(new $e8ea6a63d48a4fea$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity), new $e8ea6a63d48a4fea$export$64b5c384219d3699(Infinity, Infinity, Infinity));
            return;
        }
        if (position !== undefined) {
            this.boundingBox.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $e8ea6a63d48a4fea$var$_box$1.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $e8ea6a63d48a4fea$var$_vector$7.addVectors(this.boundingBox.min, $e8ea6a63d48a4fea$var$_box$1.min);
                    this.boundingBox.expandByPoint($e8ea6a63d48a4fea$var$_vector$7);
                    $e8ea6a63d48a4fea$var$_vector$7.addVectors(this.boundingBox.max, $e8ea6a63d48a4fea$var$_box$1.max);
                    this.boundingBox.expandByPoint($e8ea6a63d48a4fea$var$_vector$7);
                } else {
                    this.boundingBox.expandByPoint($e8ea6a63d48a4fea$var$_box$1.min);
                    this.boundingBox.expandByPoint($e8ea6a63d48a4fea$var$_box$1.max);
                }
            }
        } else this.boundingBox.makeEmpty();
        if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $e8ea6a63d48a4fea$export$805e8b72413ccaba();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this);
            this.boundingSphere.set(new $e8ea6a63d48a4fea$export$64b5c384219d3699(), Infinity);
            return;
        }
        if (position) {
            // first, find the center of the bounding sphere
            const center = this.boundingSphere.center;
            $e8ea6a63d48a4fea$var$_box$1.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $e8ea6a63d48a4fea$var$_boxMorphTargets.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $e8ea6a63d48a4fea$var$_vector$7.addVectors($e8ea6a63d48a4fea$var$_box$1.min, $e8ea6a63d48a4fea$var$_boxMorphTargets.min);
                    $e8ea6a63d48a4fea$var$_box$1.expandByPoint($e8ea6a63d48a4fea$var$_vector$7);
                    $e8ea6a63d48a4fea$var$_vector$7.addVectors($e8ea6a63d48a4fea$var$_box$1.max, $e8ea6a63d48a4fea$var$_boxMorphTargets.max);
                    $e8ea6a63d48a4fea$var$_box$1.expandByPoint($e8ea6a63d48a4fea$var$_vector$7);
                } else {
                    $e8ea6a63d48a4fea$var$_box$1.expandByPoint($e8ea6a63d48a4fea$var$_boxMorphTargets.min);
                    $e8ea6a63d48a4fea$var$_box$1.expandByPoint($e8ea6a63d48a4fea$var$_boxMorphTargets.max);
                }
            }
            $e8ea6a63d48a4fea$var$_box$1.getCenter(center);
            // second, try to find a boundingSphere with a radius smaller than the
            // boundingSphere of the boundingBox: sqrt(3) smaller in the best case
            let maxRadiusSq = 0;
            for(let i = 0, il = position.count; i < il; i++){
                $e8ea6a63d48a4fea$var$_vector$7.fromBufferAttribute(position, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($e8ea6a63d48a4fea$var$_vector$7));
            }
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                const morphTargetsRelative = this.morphTargetsRelative;
                for(let j = 0, jl = morphAttribute.count; j < jl; j++){
                    $e8ea6a63d48a4fea$var$_vector$7.fromBufferAttribute(morphAttribute, j);
                    if (morphTargetsRelative) {
                        $e8ea6a63d48a4fea$var$_offset.fromBufferAttribute(position, j);
                        $e8ea6a63d48a4fea$var$_vector$7.add($e8ea6a63d48a4fea$var$_offset);
                    }
                    maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($e8ea6a63d48a4fea$var$_vector$7));
                }
            }
            this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
            if (isNaN(this.boundingSphere.radius)) console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    computeTangents() {
        const index = this.index;
        const attributes = this.attributes;
        // based on http://www.terathon.com/code/tangent.html
        // (per vertex tangents)
        if (index === null || attributes.position === undefined || attributes.normal === undefined || attributes.uv === undefined) {
            console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
            return;
        }
        const indices = index.array;
        const positions = attributes.position.array;
        const normals = attributes.normal.array;
        const uvs = attributes.uv.array;
        const nVertices = positions.length / 3;
        if (this.hasAttribute("tangent") === false) this.setAttribute("tangent", new $e8ea6a63d48a4fea$export$8dea267bd6bde117(new Float32Array(4 * nVertices), 4));
        const tangents = this.getAttribute("tangent").array;
        const tan1 = [], tan2 = [];
        for(let i = 0; i < nVertices; i++){
            tan1[i] = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
            tan2[i] = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        }
        const vA = new $e8ea6a63d48a4fea$export$64b5c384219d3699(), vB = new $e8ea6a63d48a4fea$export$64b5c384219d3699(), vC = new $e8ea6a63d48a4fea$export$64b5c384219d3699(), uvA = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(), uvB = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(), uvC = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(), sdir = new $e8ea6a63d48a4fea$export$64b5c384219d3699(), tdir = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        function handleTriangle(a, b, c) {
            vA.fromArray(positions, a * 3);
            vB.fromArray(positions, b * 3);
            vC.fromArray(positions, c * 3);
            uvA.fromArray(uvs, a * 2);
            uvB.fromArray(uvs, b * 2);
            uvC.fromArray(uvs, c * 2);
            vB.sub(vA);
            vC.sub(vA);
            uvB.sub(uvA);
            uvC.sub(uvA);
            const r = 1.0 / (uvB.x * uvC.y - uvC.x * uvB.y);
            // silently ignore degenerate uv triangles having coincident or colinear vertices
            if (!isFinite(r)) return;
            sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
            tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
            tan1[a].add(sdir);
            tan1[b].add(sdir);
            tan1[c].add(sdir);
            tan2[a].add(tdir);
            tan2[b].add(tdir);
            tan2[c].add(tdir);
        }
        let groups = this.groups;
        if (groups.length === 0) groups = [
            {
                start: 0,
                count: indices.length
            }
        ];
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3)handleTriangle(indices[j + 0], indices[j + 1], indices[j + 2]);
        }
        const tmp = new $e8ea6a63d48a4fea$export$64b5c384219d3699(), tmp2 = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        const n = new $e8ea6a63d48a4fea$export$64b5c384219d3699(), n2 = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        function handleVertex(v) {
            n.fromArray(normals, v * 3);
            n2.copy(n);
            const t = tan1[v];
            // Gram-Schmidt orthogonalize
            tmp.copy(t);
            tmp.sub(n.multiplyScalar(n.dot(t))).normalize();
            // Calculate handedness
            tmp2.crossVectors(n2, t);
            const test = tmp2.dot(tan2[v]);
            const w = test < 0.0 ? -1 : 1.0;
            tangents[v * 4] = tmp.x;
            tangents[v * 4 + 1] = tmp.y;
            tangents[v * 4 + 2] = tmp.z;
            tangents[v * 4 + 3] = w;
        }
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3){
                handleVertex(indices[j + 0]);
                handleVertex(indices[j + 1]);
                handleVertex(indices[j + 2]);
            }
        }
    }
    computeVertexNormals() {
        const index = this.index;
        const positionAttribute = this.getAttribute("position");
        if (positionAttribute !== undefined) {
            let normalAttribute = this.getAttribute("normal");
            if (normalAttribute === undefined) {
                normalAttribute = new $e8ea6a63d48a4fea$export$8dea267bd6bde117(new Float32Array(positionAttribute.count * 3), 3);
                this.setAttribute("normal", normalAttribute);
            } else // reset existing normals to zero
            for(let i = 0, il = normalAttribute.count; i < il; i++)normalAttribute.setXYZ(i, 0, 0, 0);
            const pA = new $e8ea6a63d48a4fea$export$64b5c384219d3699(), pB = new $e8ea6a63d48a4fea$export$64b5c384219d3699(), pC = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
            const nA = new $e8ea6a63d48a4fea$export$64b5c384219d3699(), nB = new $e8ea6a63d48a4fea$export$64b5c384219d3699(), nC = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
            const cb = new $e8ea6a63d48a4fea$export$64b5c384219d3699(), ab = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
            // indexed elements
            if (index) for(let i = 0, il = index.count; i < il; i += 3){
                const vA = index.getX(i + 0);
                const vB = index.getX(i + 1);
                const vC = index.getX(i + 2);
                pA.fromBufferAttribute(positionAttribute, vA);
                pB.fromBufferAttribute(positionAttribute, vB);
                pC.fromBufferAttribute(positionAttribute, vC);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                nA.fromBufferAttribute(normalAttribute, vA);
                nB.fromBufferAttribute(normalAttribute, vB);
                nC.fromBufferAttribute(normalAttribute, vC);
                nA.add(cb);
                nB.add(cb);
                nC.add(cb);
                normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
                normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
                normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
            }
            else // non-indexed elements (unconnected triangle soup)
            for(let i = 0, il = positionAttribute.count; i < il; i += 3){
                pA.fromBufferAttribute(positionAttribute, i + 0);
                pB.fromBufferAttribute(positionAttribute, i + 1);
                pC.fromBufferAttribute(positionAttribute, i + 2);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                normalAttribute.setXYZ(i + 0, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 1, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 2, cb.x, cb.y, cb.z);
            }
            this.normalizeNormals();
            normalAttribute.needsUpdate = true;
        }
    }
    merge() {
        console.error("THREE.BufferGeometry.merge() has been removed. Use THREE.BufferGeometryUtils.mergeGeometries() instead.");
        return this;
    }
    normalizeNormals() {
        const normals = this.attributes.normal;
        for(let i = 0, il = normals.count; i < il; i++){
            $e8ea6a63d48a4fea$var$_vector$7.fromBufferAttribute(normals, i);
            $e8ea6a63d48a4fea$var$_vector$7.normalize();
            normals.setXYZ(i, $e8ea6a63d48a4fea$var$_vector$7.x, $e8ea6a63d48a4fea$var$_vector$7.y, $e8ea6a63d48a4fea$var$_vector$7.z);
        }
    }
    toNonIndexed() {
        function convertBufferAttribute(attribute, indices) {
            const array = attribute.array;
            const itemSize = attribute.itemSize;
            const normalized = attribute.normalized;
            const array2 = new array.constructor(indices.length * itemSize);
            let index = 0, index2 = 0;
            for(let i = 0, l = indices.length; i < l; i++){
                if (attribute.isInterleavedBufferAttribute) index = indices[i] * attribute.data.stride + attribute.offset;
                else index = indices[i] * itemSize;
                for(let j = 0; j < itemSize; j++)array2[index2++] = array[index++];
            }
            return new $e8ea6a63d48a4fea$export$8dea267bd6bde117(array2, itemSize, normalized);
        }
        //
        if (this.index === null) {
            console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.");
            return this;
        }
        const geometry2 = new $e8ea6a63d48a4fea$export$b7be63a67df8959();
        const indices = this.index.array;
        const attributes = this.attributes;
        // attributes
        for(const name in attributes){
            const attribute = attributes[name];
            const newAttribute = convertBufferAttribute(attribute, indices);
            geometry2.setAttribute(name, newAttribute);
        }
        // morph attributes
        const morphAttributes = this.morphAttributes;
        for(const name in morphAttributes){
            const morphArray = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const attribute = morphAttribute[i];
                const newAttribute = convertBufferAttribute(attribute, indices);
                morphArray.push(newAttribute);
            }
            geometry2.morphAttributes[name] = morphArray;
        }
        geometry2.morphTargetsRelative = this.morphTargetsRelative;
        // groups
        const groups = this.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            geometry2.addGroup(group.start, group.count, group.materialIndex);
        }
        return geometry2;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.5,
                type: "BufferGeometry",
                generator: "BufferGeometry.toJSON"
            }
        };
        // standard BufferGeometry serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== "") data.name = this.name;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        if (this.parameters !== undefined) {
            const parameters = this.parameters;
            for(const key in parameters)if (parameters[key] !== undefined) data[key] = parameters[key];
            return data;
        }
        // for simplicity the code assumes attributes are not shared across geometries, see #15811
        data.data = {
            attributes: {}
        };
        const index = this.index;
        if (index !== null) data.data.index = {
            type: index.array.constructor.name,
            array: Array.prototype.slice.call(index.array)
        };
        const attributes = this.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            data.data.attributes[key] = attribute.toJSON(data.data);
        }
        const morphAttributes = {};
        let hasMorphAttributes = false;
        for(const key in this.morphAttributes){
            const attributeArray = this.morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                array.push(attribute.toJSON(data.data));
            }
            if (array.length > 0) {
                morphAttributes[key] = array;
                hasMorphAttributes = true;
            }
        }
        if (hasMorphAttributes) {
            data.data.morphAttributes = morphAttributes;
            data.data.morphTargetsRelative = this.morphTargetsRelative;
        }
        const groups = this.groups;
        if (groups.length > 0) data.data.groups = JSON.parse(JSON.stringify(groups));
        const boundingSphere = this.boundingSphere;
        if (boundingSphere !== null) data.data.boundingSphere = {
            center: boundingSphere.center.toArray(),
            radius: boundingSphere.radius
        };
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        // reset
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        // used for storing cloned, shared data
        const data = {};
        // name
        this.name = source.name;
        // index
        const index = source.index;
        if (index !== null) this.setIndex(index.clone(data));
        // attributes
        const attributes = source.attributes;
        for(const name in attributes){
            const attribute = attributes[name];
            this.setAttribute(name, attribute.clone(data));
        }
        // morph attributes
        const morphAttributes = source.morphAttributes;
        for(const name in morphAttributes){
            const array = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, l = morphAttribute.length; i < l; i++)array.push(morphAttribute[i].clone(data));
            this.morphAttributes[name] = array;
        }
        this.morphTargetsRelative = source.morphTargetsRelative;
        // groups
        const groups = source.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            this.addGroup(group.start, group.count, group.materialIndex);
        }
        // bounding box
        const boundingBox = source.boundingBox;
        if (boundingBox !== null) this.boundingBox = boundingBox.clone();
        // bounding sphere
        const boundingSphere = source.boundingSphere;
        if (boundingSphere !== null) this.boundingSphere = boundingSphere.clone();
        // draw range
        this.drawRange.start = source.drawRange.start;
        this.drawRange.count = source.drawRange.count;
        // user data
        this.userData = source.userData;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
const $e8ea6a63d48a4fea$var$_inverseMatrix$2 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5();
const $e8ea6a63d48a4fea$var$_ray$2 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$a186db52eed6d40e();
const $e8ea6a63d48a4fea$var$_sphere$4 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$805e8b72413ccaba();
const $e8ea6a63d48a4fea$var$_sphereHitAt = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_vA$1 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_vB$1 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_vC$1 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_tempA = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_morphA = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_uvA$1 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$c977b3e384af9ae1();
const $e8ea6a63d48a4fea$var$_uvB$1 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$c977b3e384af9ae1();
const $e8ea6a63d48a4fea$var$_uvC$1 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$c977b3e384af9ae1();
const $e8ea6a63d48a4fea$var$_normalA = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_normalB = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_normalC = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_intersectionPoint = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_intersectionPointWorld = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
class $e8ea6a63d48a4fea$export$e176487c05830cc5 extends $e8ea6a63d48a4fea$export$e4dd07dff30cc924 {
    constructor(geometry = new $e8ea6a63d48a4fea$export$b7be63a67df8959(), material = new $e8ea6a63d48a4fea$export$55cbcc9b622fe1f5()){
        super();
        this.isMesh = true;
        this.type = "Mesh";
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.morphTargetInfluences !== undefined) this.morphTargetInfluences = source.morphTargetInfluences.slice();
        if (source.morphTargetDictionary !== undefined) this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
    getVertexPosition(index, target) {
        const geometry = this.geometry;
        const position = geometry.attributes.position;
        const morphPosition = geometry.morphAttributes.position;
        const morphTargetsRelative = geometry.morphTargetsRelative;
        target.fromBufferAttribute(position, index);
        const morphInfluences = this.morphTargetInfluences;
        if (morphPosition && morphInfluences) {
            $e8ea6a63d48a4fea$var$_morphA.set(0, 0, 0);
            for(let i = 0, il = morphPosition.length; i < il; i++){
                const influence = morphInfluences[i];
                const morphAttribute = morphPosition[i];
                if (influence === 0) continue;
                $e8ea6a63d48a4fea$var$_tempA.fromBufferAttribute(morphAttribute, index);
                if (morphTargetsRelative) $e8ea6a63d48a4fea$var$_morphA.addScaledVector($e8ea6a63d48a4fea$var$_tempA, influence);
                else $e8ea6a63d48a4fea$var$_morphA.addScaledVector($e8ea6a63d48a4fea$var$_tempA.sub(target), influence);
            }
            target.add($e8ea6a63d48a4fea$var$_morphA);
        }
        if (this.isSkinnedMesh) this.applyBoneTransform(index, target);
        return target;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $e8ea6a63d48a4fea$var$_sphere$4.copy(geometry.boundingSphere);
        $e8ea6a63d48a4fea$var$_sphere$4.applyMatrix4(matrixWorld);
        $e8ea6a63d48a4fea$var$_ray$2.copy(raycaster.ray).recast(raycaster.near);
        if ($e8ea6a63d48a4fea$var$_sphere$4.containsPoint($e8ea6a63d48a4fea$var$_ray$2.origin) === false) {
            if ($e8ea6a63d48a4fea$var$_ray$2.intersectSphere($e8ea6a63d48a4fea$var$_sphere$4, $e8ea6a63d48a4fea$var$_sphereHitAt) === null) return;
            if ($e8ea6a63d48a4fea$var$_ray$2.origin.distanceToSquared($e8ea6a63d48a4fea$var$_sphereHitAt) > (raycaster.far - raycaster.near) ** 2) return;
        }
        //
        $e8ea6a63d48a4fea$var$_inverseMatrix$2.copy(matrixWorld).invert();
        $e8ea6a63d48a4fea$var$_ray$2.copy(raycaster.ray).applyMatrix4($e8ea6a63d48a4fea$var$_inverseMatrix$2);
        // Check boundingBox before continuing
        if (geometry.boundingBox !== null) {
            if ($e8ea6a63d48a4fea$var$_ray$2.intersectsBox(geometry.boundingBox) === false) return;
        }
        let intersection;
        const index = geometry.index;
        const position = geometry.attributes.position;
        const uv = geometry.attributes.uv;
        const uv2 = geometry.attributes.uv2;
        const normal = geometry.attributes.normal;
        const groups = geometry.groups;
        const drawRange = geometry.drawRange;
        if (index !== null) {
            // indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(index.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = index.getX(j);
                    const b = index.getX(j + 1);
                    const c = index.getX(j + 2);
                    intersection = $e8ea6a63d48a4fea$var$checkGeometryIntersection(this, groupMaterial, raycaster, $e8ea6a63d48a4fea$var$_ray$2, uv, uv2, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(index.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = index.getX(i);
                    const b = index.getX(i + 1);
                    const c = index.getX(i + 2);
                    intersection = $e8ea6a63d48a4fea$var$checkGeometryIntersection(this, material, raycaster, $e8ea6a63d48a4fea$var$_ray$2, uv, uv2, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        } else if (position !== undefined) {
            // non-indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(position.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = j;
                    const b = j + 1;
                    const c = j + 2;
                    intersection = $e8ea6a63d48a4fea$var$checkGeometryIntersection(this, groupMaterial, raycaster, $e8ea6a63d48a4fea$var$_ray$2, uv, uv2, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in non-indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(position.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = i;
                    const b = i + 1;
                    const c = i + 2;
                    intersection = $e8ea6a63d48a4fea$var$checkGeometryIntersection(this, material, raycaster, $e8ea6a63d48a4fea$var$_ray$2, uv, uv2, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in non-indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        }
    }
}
function $e8ea6a63d48a4fea$var$checkIntersection(object, material, raycaster, ray, pA, pB, pC, point) {
    let intersect;
    if (material.side === $e8ea6a63d48a4fea$export$d9f0486e75b5ace) intersect = ray.intersectTriangle(pC, pB, pA, true, point);
    else intersect = ray.intersectTriangle(pA, pB, pC, material.side === $e8ea6a63d48a4fea$export$2ede184fc2998901, point);
    if (intersect === null) return null;
    $e8ea6a63d48a4fea$var$_intersectionPointWorld.copy(point);
    $e8ea6a63d48a4fea$var$_intersectionPointWorld.applyMatrix4(object.matrixWorld);
    const distance = raycaster.ray.origin.distanceTo($e8ea6a63d48a4fea$var$_intersectionPointWorld);
    if (distance < raycaster.near || distance > raycaster.far) return null;
    return {
        distance: distance,
        point: $e8ea6a63d48a4fea$var$_intersectionPointWorld.clone(),
        object: object
    };
}
function $e8ea6a63d48a4fea$var$checkGeometryIntersection(object, material, raycaster, ray, uv, uv2, normal, a, b, c) {
    object.getVertexPosition(a, $e8ea6a63d48a4fea$var$_vA$1);
    object.getVertexPosition(b, $e8ea6a63d48a4fea$var$_vB$1);
    object.getVertexPosition(c, $e8ea6a63d48a4fea$var$_vC$1);
    const intersection = $e8ea6a63d48a4fea$var$checkIntersection(object, material, raycaster, ray, $e8ea6a63d48a4fea$var$_vA$1, $e8ea6a63d48a4fea$var$_vB$1, $e8ea6a63d48a4fea$var$_vC$1, $e8ea6a63d48a4fea$var$_intersectionPoint);
    if (intersection) {
        if (uv) {
            $e8ea6a63d48a4fea$var$_uvA$1.fromBufferAttribute(uv, a);
            $e8ea6a63d48a4fea$var$_uvB$1.fromBufferAttribute(uv, b);
            $e8ea6a63d48a4fea$var$_uvC$1.fromBufferAttribute(uv, c);
            intersection.uv = $e8ea6a63d48a4fea$export$5a465592bfe74b48.getInterpolation($e8ea6a63d48a4fea$var$_intersectionPoint, $e8ea6a63d48a4fea$var$_vA$1, $e8ea6a63d48a4fea$var$_vB$1, $e8ea6a63d48a4fea$var$_vC$1, $e8ea6a63d48a4fea$var$_uvA$1, $e8ea6a63d48a4fea$var$_uvB$1, $e8ea6a63d48a4fea$var$_uvC$1, new $e8ea6a63d48a4fea$export$c977b3e384af9ae1());
        }
        if (uv2) {
            $e8ea6a63d48a4fea$var$_uvA$1.fromBufferAttribute(uv2, a);
            $e8ea6a63d48a4fea$var$_uvB$1.fromBufferAttribute(uv2, b);
            $e8ea6a63d48a4fea$var$_uvC$1.fromBufferAttribute(uv2, c);
            intersection.uv2 = $e8ea6a63d48a4fea$export$5a465592bfe74b48.getInterpolation($e8ea6a63d48a4fea$var$_intersectionPoint, $e8ea6a63d48a4fea$var$_vA$1, $e8ea6a63d48a4fea$var$_vB$1, $e8ea6a63d48a4fea$var$_vC$1, $e8ea6a63d48a4fea$var$_uvA$1, $e8ea6a63d48a4fea$var$_uvB$1, $e8ea6a63d48a4fea$var$_uvC$1, new $e8ea6a63d48a4fea$export$c977b3e384af9ae1());
        }
        if (normal) {
            $e8ea6a63d48a4fea$var$_normalA.fromBufferAttribute(normal, a);
            $e8ea6a63d48a4fea$var$_normalB.fromBufferAttribute(normal, b);
            $e8ea6a63d48a4fea$var$_normalC.fromBufferAttribute(normal, c);
            intersection.normal = $e8ea6a63d48a4fea$export$5a465592bfe74b48.getInterpolation($e8ea6a63d48a4fea$var$_intersectionPoint, $e8ea6a63d48a4fea$var$_vA$1, $e8ea6a63d48a4fea$var$_vB$1, $e8ea6a63d48a4fea$var$_vC$1, $e8ea6a63d48a4fea$var$_normalA, $e8ea6a63d48a4fea$var$_normalB, $e8ea6a63d48a4fea$var$_normalC, new $e8ea6a63d48a4fea$export$64b5c384219d3699());
            if (intersection.normal.dot(ray.direction) > 0) intersection.normal.multiplyScalar(-1);
        }
        const face = {
            a: a,
            b: b,
            c: c,
            normal: new $e8ea6a63d48a4fea$export$64b5c384219d3699(),
            materialIndex: 0
        };
        $e8ea6a63d48a4fea$export$5a465592bfe74b48.getNormal($e8ea6a63d48a4fea$var$_vA$1, $e8ea6a63d48a4fea$var$_vB$1, $e8ea6a63d48a4fea$var$_vC$1, face.normal);
        intersection.face = face;
    }
    return intersection;
}
class $e8ea6a63d48a4fea$export$33e43285f7406bd5 extends $e8ea6a63d48a4fea$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1){
        super();
        this.type = "BoxGeometry";
        this.parameters = {
            width: width,
            height: height,
            depth: depth,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            depthSegments: depthSegments
        };
        const scope = this;
        // segments
        widthSegments = Math.floor(widthSegments);
        heightSegments = Math.floor(heightSegments);
        depthSegments = Math.floor(depthSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let numberOfVertices = 0;
        let groupStart = 0;
        // build each side of the box geometry
        buildPlane("z", "y", "x", -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
        buildPlane("z", "y", "x", 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
        buildPlane("x", "z", "y", 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
        buildPlane("x", "z", "y", 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
        buildPlane("x", "y", "z", 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
        buildPlane("x", "y", "z", -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(uvs, 2));
        function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {
            const segmentWidth = width / gridX;
            const segmentHeight = height / gridY;
            const widthHalf = width / 2;
            const heightHalf = height / 2;
            const depthHalf = depth / 2;
            const gridX1 = gridX + 1;
            const gridY1 = gridY + 1;
            let vertexCounter = 0;
            let groupCount = 0;
            const vector = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
            // generate vertices, normals and uvs
            for(let iy = 0; iy < gridY1; iy++){
                const y = iy * segmentHeight - heightHalf;
                for(let ix = 0; ix < gridX1; ix++){
                    const x = ix * segmentWidth - widthHalf;
                    // set values to correct vector component
                    vector[u] = x * udir;
                    vector[v] = y * vdir;
                    vector[w] = depthHalf;
                    // now apply vector to vertex buffer
                    vertices.push(vector.x, vector.y, vector.z);
                    // set values to correct vector component
                    vector[u] = 0;
                    vector[v] = 0;
                    vector[w] = depth > 0 ? 1 : -1;
                    // now apply vector to normal buffer
                    normals.push(vector.x, vector.y, vector.z);
                    // uvs
                    uvs.push(ix / gridX);
                    uvs.push(1 - iy / gridY);
                    // counters
                    vertexCounter += 1;
                }
            }
            // indices
            // 1. you need three indices to draw a single face
            // 2. a single segment consists of two faces
            // 3. so we need to generate six (2*3) indices per segment
            for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
                const a = numberOfVertices + ix + gridX1 * iy;
                const b = numberOfVertices + ix + gridX1 * (iy + 1);
                const c = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
                const d = numberOfVertices + (ix + 1) + gridX1 * iy;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // increase counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, materialIndex);
            // calculate new start value for groups
            groupStart += groupCount;
            // update total number of vertices
            numberOfVertices += vertexCounter;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $e8ea6a63d48a4fea$export$33e43285f7406bd5(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
    }
}
/**
 * Uniform Utilities
 */ function $e8ea6a63d48a4fea$var$cloneUniforms(src) {
    const dst = {};
    for(const u in src){
        dst[u] = {};
        for(const p in src[u]){
            const property = src[u][p];
            if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) {
                if (property.isRenderTargetTexture) {
                    console.warn("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().");
                    dst[u][p] = null;
                } else dst[u][p] = property.clone();
            } else if (Array.isArray(property)) dst[u][p] = property.slice();
            else dst[u][p] = property;
        }
    }
    return dst;
}
function $e8ea6a63d48a4fea$var$mergeUniforms(uniforms) {
    const merged = {};
    for(let u = 0; u < uniforms.length; u++){
        const tmp = $e8ea6a63d48a4fea$var$cloneUniforms(uniforms[u]);
        for(const p in tmp)merged[p] = tmp[p];
    }
    return merged;
}
function $e8ea6a63d48a4fea$var$cloneUniformsGroups(src) {
    const dst = [];
    for(let u = 0; u < src.length; u++)dst.push(src[u].clone());
    return dst;
}
function $e8ea6a63d48a4fea$var$getUnlitUniformColorSpace(renderer) {
    if (renderer.getRenderTarget() === null) // https://github.com/mrdoob/three.js/pull/23937#issuecomment-1111067398
    return renderer.outputEncoding === $e8ea6a63d48a4fea$export$f32388edbb32674 ? $e8ea6a63d48a4fea$export$561f394b24edfcaa : $e8ea6a63d48a4fea$export$42429b3acfb233a4;
    return $e8ea6a63d48a4fea$export$42429b3acfb233a4;
}
// Legacy
const $e8ea6a63d48a4fea$export$d8ecdf8615bfea69 = {
    clone: $e8ea6a63d48a4fea$var$cloneUniforms,
    merge: $e8ea6a63d48a4fea$var$mergeUniforms
};
var $e8ea6a63d48a4fea$var$default_vertex = "void main() {\n	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var $e8ea6a63d48a4fea$var$default_fragment = "void main() {\n	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
class $e8ea6a63d48a4fea$export$83c7d75d550a8b0d extends $e8ea6a63d48a4fea$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isShaderMaterial = true;
        this.type = "ShaderMaterial";
        this.defines = {};
        this.uniforms = {};
        this.uniformsGroups = [];
        this.vertexShader = $e8ea6a63d48a4fea$var$default_vertex;
        this.fragmentShader = $e8ea6a63d48a4fea$var$default_fragment;
        this.linewidth = 1;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.fog = false; // set to use scene fog
        this.lights = false; // set to use scene lights
        this.clipping = false; // set to use user-defined clipping planes
        this.forceSinglePass = true;
        this.extensions = {
            derivatives: false,
            fragDepth: false,
            drawBuffers: false,
            shaderTextureLOD: false // set to use shader texture LOD
        };
        // When rendered geometry doesn't include these attributes but the material does,
        // use these default values in WebGL. This avoids errors when buffer data is missing.
        this.defaultAttributeValues = {
            "color": [
                1,
                1,
                1
            ],
            "uv": [
                0,
                0
            ],
            "uv2": [
                0,
                0
            ]
        };
        this.index0AttributeName = undefined;
        this.uniformsNeedUpdate = false;
        this.glslVersion = null;
        if (parameters !== undefined) this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.fragmentShader = source.fragmentShader;
        this.vertexShader = source.vertexShader;
        this.uniforms = $e8ea6a63d48a4fea$var$cloneUniforms(source.uniforms);
        this.uniformsGroups = $e8ea6a63d48a4fea$var$cloneUniformsGroups(source.uniformsGroups);
        this.defines = Object.assign({}, source.defines);
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.fog = source.fog;
        this.lights = source.lights;
        this.clipping = source.clipping;
        this.extensions = Object.assign({}, source.extensions);
        this.glslVersion = source.glslVersion;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.glslVersion = this.glslVersion;
        data.uniforms = {};
        for(const name in this.uniforms){
            const uniform = this.uniforms[name];
            const value = uniform.value;
            if (value && value.isTexture) data.uniforms[name] = {
                type: "t",
                value: value.toJSON(meta).uuid
            };
            else if (value && value.isColor) data.uniforms[name] = {
                type: "c",
                value: value.getHex()
            };
            else if (value && value.isVector2) data.uniforms[name] = {
                type: "v2",
                value: value.toArray()
            };
            else if (value && value.isVector3) data.uniforms[name] = {
                type: "v3",
                value: value.toArray()
            };
            else if (value && value.isVector4) data.uniforms[name] = {
                type: "v4",
                value: value.toArray()
            };
            else if (value && value.isMatrix3) data.uniforms[name] = {
                type: "m3",
                value: value.toArray()
            };
            else if (value && value.isMatrix4) data.uniforms[name] = {
                type: "m4",
                value: value.toArray()
            };
            else data.uniforms[name] = {
                value: value
            };
        }
        if (Object.keys(this.defines).length > 0) data.defines = this.defines;
        data.vertexShader = this.vertexShader;
        data.fragmentShader = this.fragmentShader;
        const extensions = {};
        for(const key in this.extensions)if (this.extensions[key] === true) extensions[key] = true;
        if (Object.keys(extensions).length > 0) data.extensions = extensions;
        return data;
    }
}
class $e8ea6a63d48a4fea$export$79f141de891a5fed extends $e8ea6a63d48a4fea$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isCamera = true;
        this.type = "Camera";
        this.matrixWorldInverse = new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5();
        this.projectionMatrix = new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5();
        this.projectionMatrixInverse = new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.matrixWorldInverse.copy(source.matrixWorldInverse);
        this.projectionMatrix.copy(source.projectionMatrix);
        this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
        return this;
    }
    getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(-e[8], -e[9], -e[10]).normalize();
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(updateParents, updateChildren) {
        super.updateWorldMatrix(updateParents, updateChildren);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $e8ea6a63d48a4fea$export$74e4ae24825f68d7 extends $e8ea6a63d48a4fea$export$79f141de891a5fed {
    constructor(fov = 50, aspect = 1, near = 0.1, far = 2000){
        super();
        this.isPerspectiveCamera = true;
        this.type = "PerspectiveCamera";
        this.fov = fov;
        this.zoom = 1;
        this.near = near;
        this.far = far;
        this.focus = 10;
        this.aspect = aspect;
        this.view = null;
        this.filmGauge = 35; // width of the film (default in millimeters)
        this.filmOffset = 0; // horizontal film offset (same unit as gauge)
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.fov = source.fov;
        this.zoom = source.zoom;
        this.near = source.near;
        this.far = source.far;
        this.focus = source.focus;
        this.aspect = source.aspect;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        this.filmGauge = source.filmGauge;
        this.filmOffset = source.filmOffset;
        return this;
    }
    /**
	 * Sets the FOV by focal length in respect to the current .filmGauge.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * Values for focal length and film gauge must have the same unit.
	 */ setFocalLength(focalLength) {
        /** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */ const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
        this.fov = $e8ea6a63d48a4fea$var$RAD2DEG * 2 * Math.atan(vExtentSlope);
        this.updateProjectionMatrix();
    }
    /**
	 * Calculates the focal length from the current .fov and .filmGauge.
	 */ getFocalLength() {
        const vExtentSlope = Math.tan($e8ea6a63d48a4fea$var$DEG2RAD * 0.5 * this.fov);
        return 0.5 * this.getFilmHeight() / vExtentSlope;
    }
    getEffectiveFOV() {
        return $e8ea6a63d48a4fea$var$RAD2DEG * 2 * Math.atan(Math.tan($e8ea6a63d48a4fea$var$DEG2RAD * 0.5 * this.fov) / this.zoom);
    }
    getFilmWidth() {
        // film not completely covered in portrait format (aspect < 1)
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    getFilmHeight() {
        // film not completely covered in landscape format (aspect > 1)
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *
	 * then for each monitor you would call it like this
	 *
	 *   const w = 1920;
	 *   const h = 1080;
	 *   const fullWidth = w * 3;
	 *   const fullHeight = h * 2;
	 *
	 *   --A--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 *   --B--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 *   --C--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 *   --D--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 *   --E--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 *   --F--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 *
	 *   Note there is no reason monitors have to be the same size or in a grid.
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        this.aspect = fullWidth / fullHeight;
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const near = this.near;
        let top = near * Math.tan($e8ea6a63d48a4fea$var$DEG2RAD * 0.5 * this.fov) / this.zoom;
        let height = 2 * top;
        let width = this.aspect * height;
        let left = -0.5 * width;
        const view = this.view;
        if (this.view !== null && this.view.enabled) {
            const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
            left += view.offsetX * width / fullWidth;
            top -= view.offsetY * height / fullHeight;
            width *= view.width / fullWidth;
            height *= view.height / fullHeight;
        }
        const skew = this.filmOffset;
        if (skew !== 0) left += near * skew / this.getFilmWidth();
        this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.fov = this.fov;
        data.object.zoom = this.zoom;
        data.object.near = this.near;
        data.object.far = this.far;
        data.object.focus = this.focus;
        data.object.aspect = this.aspect;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        data.object.filmGauge = this.filmGauge;
        data.object.filmOffset = this.filmOffset;
        return data;
    }
}
const $e8ea6a63d48a4fea$var$fov = -90; // negative fov is not an error
const $e8ea6a63d48a4fea$var$aspect = 1;
class $e8ea6a63d48a4fea$export$d0cdd0bd804995de extends $e8ea6a63d48a4fea$export$e4dd07dff30cc924 {
    constructor(near, far, renderTarget){
        super();
        this.type = "CubeCamera";
        this.renderTarget = renderTarget;
        const cameraPX = new $e8ea6a63d48a4fea$export$74e4ae24825f68d7($e8ea6a63d48a4fea$var$fov, $e8ea6a63d48a4fea$var$aspect, near, far);
        cameraPX.layers = this.layers;
        cameraPX.up.set(0, 1, 0);
        cameraPX.lookAt(1, 0, 0);
        this.add(cameraPX);
        const cameraNX = new $e8ea6a63d48a4fea$export$74e4ae24825f68d7($e8ea6a63d48a4fea$var$fov, $e8ea6a63d48a4fea$var$aspect, near, far);
        cameraNX.layers = this.layers;
        cameraNX.up.set(0, 1, 0);
        cameraNX.lookAt(-1, 0, 0);
        this.add(cameraNX);
        const cameraPY = new $e8ea6a63d48a4fea$export$74e4ae24825f68d7($e8ea6a63d48a4fea$var$fov, $e8ea6a63d48a4fea$var$aspect, near, far);
        cameraPY.layers = this.layers;
        cameraPY.up.set(0, 0, -1);
        cameraPY.lookAt(0, 1, 0);
        this.add(cameraPY);
        const cameraNY = new $e8ea6a63d48a4fea$export$74e4ae24825f68d7($e8ea6a63d48a4fea$var$fov, $e8ea6a63d48a4fea$var$aspect, near, far);
        cameraNY.layers = this.layers;
        cameraNY.up.set(0, 0, 1);
        cameraNY.lookAt(0, -1, 0);
        this.add(cameraNY);
        const cameraPZ = new $e8ea6a63d48a4fea$export$74e4ae24825f68d7($e8ea6a63d48a4fea$var$fov, $e8ea6a63d48a4fea$var$aspect, near, far);
        cameraPZ.layers = this.layers;
        cameraPZ.up.set(0, 1, 0);
        cameraPZ.lookAt(0, 0, 1);
        this.add(cameraPZ);
        const cameraNZ = new $e8ea6a63d48a4fea$export$74e4ae24825f68d7($e8ea6a63d48a4fea$var$fov, $e8ea6a63d48a4fea$var$aspect, near, far);
        cameraNZ.layers = this.layers;
        cameraNZ.up.set(0, 1, 0);
        cameraNZ.lookAt(0, 0, -1);
        this.add(cameraNZ);
    }
    update(renderer, scene) {
        if (this.parent === null) this.updateMatrixWorld();
        const renderTarget = this.renderTarget;
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = this.children;
        const currentRenderTarget = renderer.getRenderTarget();
        const currentToneMapping = renderer.toneMapping;
        const currentXrEnabled = renderer.xr.enabled;
        renderer.toneMapping = $e8ea6a63d48a4fea$export$9fcb6b4294603b2;
        renderer.xr.enabled = false;
        const generateMipmaps = renderTarget.texture.generateMipmaps;
        renderTarget.texture.generateMipmaps = false;
        renderer.setRenderTarget(renderTarget, 0);
        renderer.render(scene, cameraPX);
        renderer.setRenderTarget(renderTarget, 1);
        renderer.render(scene, cameraNX);
        renderer.setRenderTarget(renderTarget, 2);
        renderer.render(scene, cameraPY);
        renderer.setRenderTarget(renderTarget, 3);
        renderer.render(scene, cameraNY);
        renderer.setRenderTarget(renderTarget, 4);
        renderer.render(scene, cameraPZ);
        renderTarget.texture.generateMipmaps = generateMipmaps;
        renderer.setRenderTarget(renderTarget, 5);
        renderer.render(scene, cameraNZ);
        renderer.setRenderTarget(currentRenderTarget);
        renderer.toneMapping = currentToneMapping;
        renderer.xr.enabled = currentXrEnabled;
        renderTarget.texture.needsPMREMUpdate = true;
    }
}
class $e8ea6a63d48a4fea$export$ee2e5a18258a4049 extends $e8ea6a63d48a4fea$export$5431306cf43de24a {
    constructor(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding){
        images = images !== undefined ? images : [];
        mapping = mapping !== undefined ? mapping : $e8ea6a63d48a4fea$export$8759762a6477f2c4;
        super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
        this.isCubeTexture = true;
        this.flipY = false;
    }
    get images() {
        return this.image;
    }
    set images(value) {
        this.image = value;
    }
}
class $e8ea6a63d48a4fea$export$ac386671d651941e extends $e8ea6a63d48a4fea$export$3c052beb2e51e23f {
    constructor(size = 1, options = {}){
        super(size, size, options);
        this.isWebGLCubeRenderTarget = true;
        const image = {
            width: size,
            height: size,
            depth: 1
        };
        const images = [
            image,
            image,
            image,
            image,
            image,
            image
        ];
        this.texture = new $e8ea6a63d48a4fea$export$ee2e5a18258a4049(images, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding);
        // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
        // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
        // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
        // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
        // and the flag isRenderTargetTexture controls this conversion. The flip is not required when using WebGLCubeRenderTarget.texture
        // as a cube texture (this is detected when isRenderTargetTexture is set to true for cube textures).
        this.texture.isRenderTargetTexture = true;
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $e8ea6a63d48a4fea$export$8a72f490b25c56c8;
    }
    fromEquirectangularTexture(renderer, texture) {
        this.texture.type = texture.type;
        this.texture.encoding = texture.encoding;
        this.texture.generateMipmaps = texture.generateMipmaps;
        this.texture.minFilter = texture.minFilter;
        this.texture.magFilter = texture.magFilter;
        const shader = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: /* glsl */ `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
            fragmentShader: /* glsl */ `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        };
        const geometry = new $e8ea6a63d48a4fea$export$33e43285f7406bd5(5, 5, 5);
        const material = new $e8ea6a63d48a4fea$export$83c7d75d550a8b0d({
            name: "CubemapFromEquirect",
            uniforms: $e8ea6a63d48a4fea$var$cloneUniforms(shader.uniforms),
            vertexShader: shader.vertexShader,
            fragmentShader: shader.fragmentShader,
            side: $e8ea6a63d48a4fea$export$d9f0486e75b5ace,
            blending: $e8ea6a63d48a4fea$export$63b8d6b580fc65ba
        });
        material.uniforms.tEquirect.value = texture;
        const mesh = new $e8ea6a63d48a4fea$export$e176487c05830cc5(geometry, material);
        const currentMinFilter = texture.minFilter;
        // Avoid blurred poles
        if (texture.minFilter === $e8ea6a63d48a4fea$export$5d8599b6a933fb1b) texture.minFilter = $e8ea6a63d48a4fea$export$8a72f490b25c56c8;
        const camera = new $e8ea6a63d48a4fea$export$d0cdd0bd804995de(1, 10, this);
        camera.update(renderer, mesh);
        texture.minFilter = currentMinFilter;
        mesh.geometry.dispose();
        mesh.material.dispose();
        return this;
    }
    clear(renderer, color, depth, stencil) {
        const currentRenderTarget = renderer.getRenderTarget();
        for(let i = 0; i < 6; i++){
            renderer.setRenderTarget(this, i);
            renderer.clear(color, depth, stencil);
        }
        renderer.setRenderTarget(currentRenderTarget);
    }
}
const $e8ea6a63d48a4fea$var$_vector1 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_vector2 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_normalMatrix = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$8ff26dafa08918();
class $e8ea6a63d48a4fea$export$7ff5ac152ef991b0 {
    constructor(normal = new $e8ea6a63d48a4fea$export$64b5c384219d3699(1, 0, 0), constant = 0){
        this.isPlane = true;
        // normal is assumed to be normalized
        this.normal = normal;
        this.constant = constant;
    }
    set(normal, constant) {
        this.normal.copy(normal);
        this.constant = constant;
        return this;
    }
    setComponents(x, y, z, w) {
        this.normal.set(x, y, z);
        this.constant = w;
        return this;
    }
    setFromNormalAndCoplanarPoint(normal, point) {
        this.normal.copy(normal);
        this.constant = -point.dot(this.normal);
        return this;
    }
    setFromCoplanarPoints(a, b, c) {
        const normal = $e8ea6a63d48a4fea$var$_vector1.subVectors(c, b).cross($e8ea6a63d48a4fea$var$_vector2.subVectors(a, b)).normalize();
        // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
        this.setFromNormalAndCoplanarPoint(normal, a);
        return this;
    }
    copy(plane) {
        this.normal.copy(plane.normal);
        this.constant = plane.constant;
        return this;
    }
    normalize() {
        // Note: will lead to a divide by zero if the plane is invalid.
        const inverseNormalLength = 1.0 / this.normal.length();
        this.normal.multiplyScalar(inverseNormalLength);
        this.constant *= inverseNormalLength;
        return this;
    }
    negate() {
        this.constant *= -1;
        this.normal.negate();
        return this;
    }
    distanceToPoint(point) {
        return this.normal.dot(point) + this.constant;
    }
    distanceToSphere(sphere) {
        return this.distanceToPoint(sphere.center) - sphere.radius;
    }
    projectPoint(point, target) {
        return target.copy(point).addScaledVector(this.normal, -this.distanceToPoint(point));
    }
    intersectLine(line, target) {
        const direction = line.delta($e8ea6a63d48a4fea$var$_vector1);
        const denominator = this.normal.dot(direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (this.distanceToPoint(line.start) === 0) return target.copy(line.start);
            // Unsure if this is the correct method to handle this case.
            return null;
        }
        const t = -(line.start.dot(this.normal) + this.constant) / denominator;
        if (t < 0 || t > 1) return null;
        return target.copy(line.start).addScaledVector(direction, t);
    }
    intersectsLine(line) {
        // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
        const startSign = this.distanceToPoint(line.start);
        const endSign = this.distanceToPoint(line.end);
        return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
    }
    intersectsBox(box) {
        return box.intersectsPlane(this);
    }
    intersectsSphere(sphere) {
        return sphere.intersectsPlane(this);
    }
    coplanarPoint(target) {
        return target.copy(this.normal).multiplyScalar(-this.constant);
    }
    applyMatrix4(matrix, optionalNormalMatrix) {
        const normalMatrix = optionalNormalMatrix || $e8ea6a63d48a4fea$var$_normalMatrix.getNormalMatrix(matrix);
        const referencePoint = this.coplanarPoint($e8ea6a63d48a4fea$var$_vector1).applyMatrix4(matrix);
        const normal = this.normal.applyMatrix3(normalMatrix).normalize();
        this.constant = -referencePoint.dot(normal);
        return this;
    }
    translate(offset) {
        this.constant -= offset.dot(this.normal);
        return this;
    }
    equals(plane) {
        return plane.normal.equals(this.normal) && plane.constant === this.constant;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $e8ea6a63d48a4fea$var$_sphere$3 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$805e8b72413ccaba();
const $e8ea6a63d48a4fea$var$_vector$6 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
class $e8ea6a63d48a4fea$export$35efe6f4c85463d2 {
    constructor(p0 = new $e8ea6a63d48a4fea$export$7ff5ac152ef991b0(), p1 = new $e8ea6a63d48a4fea$export$7ff5ac152ef991b0(), p2 = new $e8ea6a63d48a4fea$export$7ff5ac152ef991b0(), p3 = new $e8ea6a63d48a4fea$export$7ff5ac152ef991b0(), p4 = new $e8ea6a63d48a4fea$export$7ff5ac152ef991b0(), p5 = new $e8ea6a63d48a4fea$export$7ff5ac152ef991b0()){
        this.planes = [
            p0,
            p1,
            p2,
            p3,
            p4,
            p5
        ];
    }
    set(p0, p1, p2, p3, p4, p5) {
        const planes = this.planes;
        planes[0].copy(p0);
        planes[1].copy(p1);
        planes[2].copy(p2);
        planes[3].copy(p3);
        planes[4].copy(p4);
        planes[5].copy(p5);
        return this;
    }
    copy(frustum) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++)planes[i].copy(frustum.planes[i]);
        return this;
    }
    setFromProjectionMatrix(m) {
        const planes = this.planes;
        const me = m.elements;
        const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
        const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
        const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
        const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
        planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
        planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
        planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
        planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
        planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
        planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
        return this;
    }
    intersectsObject(object) {
        if (object.boundingSphere !== undefined) {
            if (object.boundingSphere === null) object.computeBoundingSphere();
            $e8ea6a63d48a4fea$var$_sphere$3.copy(object.boundingSphere).applyMatrix4(object.matrixWorld);
        } else {
            const geometry = object.geometry;
            if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
            $e8ea6a63d48a4fea$var$_sphere$3.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
        }
        return this.intersectsSphere($e8ea6a63d48a4fea$var$_sphere$3);
    }
    intersectsSprite(sprite) {
        $e8ea6a63d48a4fea$var$_sphere$3.center.set(0, 0, 0);
        $e8ea6a63d48a4fea$var$_sphere$3.radius = 0.7071067811865476;
        $e8ea6a63d48a4fea$var$_sphere$3.applyMatrix4(sprite.matrixWorld);
        return this.intersectsSphere($e8ea6a63d48a4fea$var$_sphere$3);
    }
    intersectsSphere(sphere) {
        const planes = this.planes;
        const center = sphere.center;
        const negRadius = -sphere.radius;
        for(let i = 0; i < 6; i++){
            const distance = planes[i].distanceToPoint(center);
            if (distance < negRadius) return false;
        }
        return true;
    }
    intersectsBox(box) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            const plane = planes[i];
            // corner at max distance
            $e8ea6a63d48a4fea$var$_vector$6.x = plane.normal.x > 0 ? box.max.x : box.min.x;
            $e8ea6a63d48a4fea$var$_vector$6.y = plane.normal.y > 0 ? box.max.y : box.min.y;
            $e8ea6a63d48a4fea$var$_vector$6.z = plane.normal.z > 0 ? box.max.z : box.min.z;
            if (plane.distanceToPoint($e8ea6a63d48a4fea$var$_vector$6) < 0) return false;
        }
        return true;
    }
    containsPoint(point) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            if (planes[i].distanceToPoint(point) < 0) return false;
        }
        return true;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
function $e8ea6a63d48a4fea$var$WebGLAnimation() {
    let context = null;
    let isAnimating = false;
    let animationLoop = null;
    let requestId = null;
    function onAnimationFrame(time, frame) {
        animationLoop(time, frame);
        requestId = context.requestAnimationFrame(onAnimationFrame);
    }
    return {
        start: function() {
            if (isAnimating === true) return;
            if (animationLoop === null) return;
            requestId = context.requestAnimationFrame(onAnimationFrame);
            isAnimating = true;
        },
        stop: function() {
            context.cancelAnimationFrame(requestId);
            isAnimating = false;
        },
        setAnimationLoop: function(callback) {
            animationLoop = callback;
        },
        setContext: function(value) {
            context = value;
        }
    };
}
function $e8ea6a63d48a4fea$var$WebGLAttributes(gl, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    const buffers = new WeakMap();
    function createBuffer(attribute, bufferType) {
        const array = attribute.array;
        const usage = attribute.usage;
        const buffer = gl.createBuffer();
        gl.bindBuffer(bufferType, buffer);
        gl.bufferData(bufferType, array, usage);
        attribute.onUploadCallback();
        let type;
        if (array instanceof Float32Array) type = 5126;
        else if (array instanceof Uint16Array) {
            if (attribute.isFloat16BufferAttribute) {
                if (isWebGL2) type = 5131;
                else throw new Error("THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.");
            } else type = 5123;
        } else if (array instanceof Int16Array) type = 5122;
        else if (array instanceof Uint32Array) type = 5125;
        else if (array instanceof Int32Array) type = 5124;
        else if (array instanceof Int8Array) type = 5120;
        else if (array instanceof Uint8Array) type = 5121;
        else if (array instanceof Uint8ClampedArray) type = 5121;
        else throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + array);
        return {
            buffer: buffer,
            type: type,
            bytesPerElement: array.BYTES_PER_ELEMENT,
            version: attribute.version
        };
    }
    function updateBuffer(buffer, attribute, bufferType) {
        const array = attribute.array;
        const updateRange = attribute.updateRange;
        gl.bindBuffer(bufferType, buffer);
        if (updateRange.count === -1) // Not using update ranges
        gl.bufferSubData(bufferType, 0, array);
        else {
            if (isWebGL2) gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array, updateRange.offset, updateRange.count);
            else gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array.subarray(updateRange.offset, updateRange.offset + updateRange.count));
            updateRange.count = -1; // reset range
        }
        attribute.onUploadCallback();
    }
    //
    function get(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return buffers.get(attribute);
    }
    function remove(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data) {
            gl.deleteBuffer(data.buffer);
            buffers.delete(attribute);
        }
    }
    function update(attribute, bufferType) {
        if (attribute.isGLBufferAttribute) {
            const cached = buffers.get(attribute);
            if (!cached || cached.version < attribute.version) buffers.set(attribute, {
                buffer: attribute.buffer,
                type: attribute.type,
                bytesPerElement: attribute.elementSize,
                version: attribute.version
            });
            return;
        }
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data === undefined) buffers.set(attribute, createBuffer(attribute, bufferType));
        else if (data.version < attribute.version) {
            updateBuffer(data.buffer, attribute, bufferType);
            data.version = attribute.version;
        }
    }
    return {
        get: get,
        remove: remove,
        update: update
    };
}
class $e8ea6a63d48a4fea$export$967d831af31f69ce extends $e8ea6a63d48a4fea$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1){
        super();
        this.type = "PlaneGeometry";
        this.parameters = {
            width: width,
            height: height,
            widthSegments: widthSegments,
            heightSegments: heightSegments
        };
        const width_half = width / 2;
        const height_half = height / 2;
        const gridX = Math.floor(widthSegments);
        const gridY = Math.floor(heightSegments);
        const gridX1 = gridX + 1;
        const gridY1 = gridY + 1;
        const segment_width = width / gridX;
        const segment_height = height / gridY;
        //
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        for(let iy = 0; iy < gridY1; iy++){
            const y = iy * segment_height - height_half;
            for(let ix = 0; ix < gridX1; ix++){
                const x = ix * segment_width - width_half;
                vertices.push(x, -y, 0);
                normals.push(0, 0, 1);
                uvs.push(ix / gridX);
                uvs.push(1 - iy / gridY);
            }
        }
        for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
            const a = ix + gridX1 * iy;
            const b = ix + gridX1 * (iy + 1);
            const c = ix + 1 + gridX1 * (iy + 1);
            const d = ix + 1 + gridX1 * iy;
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        this.setIndex(indices);
        this.setAttribute("position", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $e8ea6a63d48a4fea$export$967d831af31f69ce(data.width, data.height, data.widthSegments, data.heightSegments);
    }
}
var $e8ea6a63d48a4fea$var$alphamap_fragment = "#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif";
var $e8ea6a63d48a4fea$var$alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
var $e8ea6a63d48a4fea$var$alphatest_fragment = "#ifdef USE_ALPHATEST\n	if ( diffuseColor.a < alphaTest ) discard;\n#endif";
var $e8ea6a63d48a4fea$var$alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n	uniform float alphaTest;\n#endif";
var $e8ea6a63d48a4fea$var$aomap_fragment = "#ifdef USE_AOMAP\n	float ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n	reflectedLight.indirectDiffuse *= ambientOcclusion;\n	#if defined( USE_ENVMAP ) && defined( STANDARD )\n		float dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n	#endif\n#endif";
var $e8ea6a63d48a4fea$var$aomap_pars_fragment = "#ifdef USE_AOMAP\n	uniform sampler2D aoMap;\n	uniform float aoMapIntensity;\n#endif";
var $e8ea6a63d48a4fea$var$begin_vertex = "vec3 transformed = vec3( position );";
var $e8ea6a63d48a4fea$var$beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n	vec3 objectTangent = vec3( tangent.xyz );\n#endif";
var $e8ea6a63d48a4fea$var$bsdfs = "float G_BlinnPhong_Implicit( ) {\n	return 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( specularColor, 1.0, dotVH );\n	float G = G_BlinnPhong_Implicit( );\n	float D = D_BlinnPhong( shininess, dotNH );\n	return F * ( G * D );\n} // validated";
var $e8ea6a63d48a4fea$var$iridescence_fragment = "#ifdef USE_IRIDESCENCE\n	const mat3 XYZ_TO_REC709 = mat3(\n		 3.2404542, -0.9692660,  0.0556434,\n		-1.5371385,  1.8760108, -0.2040259,\n		-0.4985314,  0.0415560,  1.0572252\n	);\n	vec3 Fresnel0ToIor( vec3 fresnel0 ) {\n		vec3 sqrtF0 = sqrt( fresnel0 );\n		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n	}\n	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n	}\n	float IorToFresnel0( float transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n	}\n	vec3 evalSensitivity( float OPD, vec3 shift ) {\n		float phase = 2.0 * PI * OPD * 1.0e-9;\n		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n		xyz /= 1.0685e-7;\n		vec3 rgb = XYZ_TO_REC709 * xyz;\n		return rgb;\n	}\n	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n		vec3 I;\n		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n		float cosTheta2Sq = 1.0 - sinTheta2Sq;\n		if ( cosTheta2Sq < 0.0 ) {\n			 return vec3( 1.0 );\n		}\n		float cosTheta2 = sqrt( cosTheta2Sq );\n		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n		float R12 = F_Schlick( R0, 1.0, cosTheta1 );\n		float R21 = R12;\n		float T121 = 1.0 - R12;\n		float phi12 = 0.0;\n		if ( iridescenceIOR < outsideIOR ) phi12 = PI;\n		float phi21 = PI - phi12;\n		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n		vec3 phi23 = vec3( 0.0 );\n		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n		vec3 phi = vec3( phi21 ) + phi23;\n		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n		vec3 r123 = sqrt( R123 );\n		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n		vec3 C0 = R12 + Rs;\n		I = C0;\n		vec3 Cm = Rs - T121;\n		for ( int m = 1; m <= 2; ++ m ) {\n			Cm *= r123;\n			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n			I += Cm * Sm;\n		}\n		return max( I, vec3( 0.0 ) );\n	}\n#endif";
var $e8ea6a63d48a4fea$var$bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n	uniform sampler2D bumpMap;\n	uniform float bumpScale;\n	vec2 dHdxy_fwd() {\n		vec2 dSTdx = dFdx( vBumpMapUv );\n		vec2 dSTdy = dFdy( vBumpMapUv );\n		float Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n		float dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n		float dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n		return vec2( dBx, dBy );\n	}\n	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n		vec3 vSigmaX = dFdx( surf_pos.xyz );\n		vec3 vSigmaY = dFdy( surf_pos.xyz );\n		vec3 vN = surf_norm;\n		vec3 R1 = cross( vSigmaY, vN );\n		vec3 R2 = cross( vN, vSigmaX );\n		float fDet = dot( vSigmaX, R1 ) * faceDirection;\n		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n		return normalize( abs( fDet ) * surf_norm - vGrad );\n	}\n#endif";
var $e8ea6a63d48a4fea$var$clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n	vec4 plane;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n		plane = clippingPlanes[ i ];\n		if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n	}\n	#pragma unroll_loop_end\n	#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n		bool clipped = true;\n		#pragma unroll_loop_start\n		for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n			plane = clippingPlanes[ i ];\n			clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n		}\n		#pragma unroll_loop_end\n		if ( clipped ) discard;\n	#endif\n#endif";
var $e8ea6a63d48a4fea$var$clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var $e8ea6a63d48a4fea$var$clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n#endif";
var $e8ea6a63d48a4fea$var$clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n	vClipPosition = - mvPosition.xyz;\n#endif";
var $e8ea6a63d48a4fea$var$color_fragment = "#if defined( USE_COLOR_ALPHA )\n	diffuseColor *= vColor;\n#elif defined( USE_COLOR )\n	diffuseColor.rgb *= vColor;\n#endif";
var $e8ea6a63d48a4fea$var$color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR )\n	varying vec3 vColor;\n#endif";
var $e8ea6a63d48a4fea$var$color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n	varying vec3 vColor;\n#endif";
var $e8ea6a63d48a4fea$var$color_vertex = "#if defined( USE_COLOR_ALPHA )\n	vColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n	vColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n	vColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n	vColor.xyz *= instanceColor.xyz;\n#endif";
var $e8ea6a63d48a4fea$var$common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n	const highp float a = 12.9898, b = 78.233, c = 43758.5453;\n	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n	return fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n	float precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n	float precisionSafeLength( vec3 v ) {\n		float maxComponent = max3( abs( v ) );\n		return length( v / maxComponent ) * maxComponent;\n	}\n#endif\nstruct IncidentLight {\n	vec3 color;\n	vec3 direction;\n	bool visible;\n};\nstruct ReflectedLight {\n	vec3 directDiffuse;\n	vec3 directSpecular;\n	vec3 indirectDiffuse;\n	vec3 indirectSpecular;\n};\nstruct GeometricContext {\n	vec3 position;\n	vec3 normal;\n	vec3 viewDir;\n#ifdef USE_CLEARCOAT\n	vec3 clearcoatNormal;\n#endif\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n	mat3 tmp;\n	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n	return tmp;\n}\nfloat luminance( const in vec3 rgb ) {\n	const vec3 weights = vec3( 0.2126729, 0.7151522, 0.0721750 );\n	return dot( weights, rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n	return m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n	return vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n	return RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated";
var $e8ea6a63d48a4fea$var$cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n	#define cubeUV_minMipLevel 4.0\n	#define cubeUV_minTileSize 16.0\n	float getFace( vec3 direction ) {\n		vec3 absDirection = abs( direction );\n		float face = - 1.0;\n		if ( absDirection.x > absDirection.z ) {\n			if ( absDirection.x > absDirection.y )\n				face = direction.x > 0.0 ? 0.0 : 3.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		} else {\n			if ( absDirection.z > absDirection.y )\n				face = direction.z > 0.0 ? 2.0 : 5.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		}\n		return face;\n	}\n	vec2 getUV( vec3 direction, float face ) {\n		vec2 uv;\n		if ( face == 0.0 ) {\n			uv = vec2( direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 1.0 ) {\n			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n		} else if ( face == 2.0 ) {\n			uv = vec2( - direction.x, direction.y ) / abs( direction.z );\n		} else if ( face == 3.0 ) {\n			uv = vec2( - direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 4.0 ) {\n			uv = vec2( - direction.x, direction.z ) / abs( direction.y );\n		} else {\n			uv = vec2( direction.x, direction.y ) / abs( direction.z );\n		}\n		return 0.5 * ( uv + 1.0 );\n	}\n	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n		float face = getFace( direction );\n		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n		mipInt = max( mipInt, cubeUV_minMipLevel );\n		float faceSize = exp2( mipInt );\n		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n		if ( face > 2.0 ) {\n			uv.y += faceSize;\n			face -= 3.0;\n		}\n		uv.x += face * faceSize;\n		uv.x += filterInt * 3.0 * cubeUV_minTileSize;\n		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n		uv.x *= CUBEUV_TEXEL_WIDTH;\n		uv.y *= CUBEUV_TEXEL_HEIGHT;\n		#ifdef texture2DGradEXT\n			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n		#else\n			return texture2D( envMap, uv ).rgb;\n		#endif\n	}\n	#define cubeUV_r0 1.0\n	#define cubeUV_v0 0.339\n	#define cubeUV_m0 - 2.0\n	#define cubeUV_r1 0.8\n	#define cubeUV_v1 0.276\n	#define cubeUV_m1 - 1.0\n	#define cubeUV_r4 0.4\n	#define cubeUV_v4 0.046\n	#define cubeUV_m4 2.0\n	#define cubeUV_r5 0.305\n	#define cubeUV_v5 0.016\n	#define cubeUV_m5 3.0\n	#define cubeUV_r6 0.21\n	#define cubeUV_v6 0.0038\n	#define cubeUV_m6 4.0\n	float roughnessToMip( float roughness ) {\n		float mip = 0.0;\n		if ( roughness >= cubeUV_r1 ) {\n			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n		} else if ( roughness >= cubeUV_r4 ) {\n			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n		} else if ( roughness >= cubeUV_r5 ) {\n			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n		} else if ( roughness >= cubeUV_r6 ) {\n			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n		} else {\n			mip = - 2.0 * log2( 1.16 * roughness );		}\n		return mip;\n	}\n	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n		float mipF = fract( mip );\n		float mipInt = floor( mip );\n		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n		if ( mipF == 0.0 ) {\n			return vec4( color0, 1.0 );\n		} else {\n			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n			return vec4( mix( color0, color1, mipF ), 1.0 );\n		}\n	}\n#endif";
var $e8ea6a63d48a4fea$var$defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n	mat3 m = mat3( instanceMatrix );\n	transformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n	transformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n	transformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n	vec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#ifdef FLIP_SIDED\n		transformedTangent = - transformedTangent;\n	#endif\n#endif";
var $e8ea6a63d48a4fea$var$displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n	uniform sampler2D displacementMap;\n	uniform float displacementScale;\n	uniform float displacementBias;\n#endif";
var $e8ea6a63d48a4fea$var$displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif";
var $e8ea6a63d48a4fea$var$emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n	vec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n	totalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var $e8ea6a63d48a4fea$var$emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n	uniform sampler2D emissiveMap;\n#endif";
var $e8ea6a63d48a4fea$var$encodings_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var $e8ea6a63d48a4fea$var$encodings_pars_fragment = "vec4 LinearToLinear( in vec4 value ) {\n	return value;\n}\nvec4 LinearTosRGB( in vec4 value ) {\n	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}";
var $e8ea6a63d48a4fea$var$envmap_fragment = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vec3 cameraToFrag;\n		if ( isOrthographic ) {\n			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToFrag = normalize( vWorldPosition - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vec3 reflectVec = reflect( cameraToFrag, worldNormal );\n		#else\n			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n		#endif\n	#else\n		vec3 reflectVec = vReflect;\n	#endif\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n	#else\n		vec4 envColor = vec4( 0.0 );\n	#endif\n	#ifdef ENVMAP_BLENDING_MULTIPLY\n		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_MIX )\n		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_ADD )\n		outgoingLight += envColor.xyz * specularStrength * reflectivity;\n	#endif\n#endif";
var $e8ea6a63d48a4fea$var$envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n	uniform float envMapIntensity;\n	uniform float flipEnvMap;\n	#ifdef ENVMAP_TYPE_CUBE\n		uniform samplerCube envMap;\n	#else\n		uniform sampler2D envMap;\n	#endif\n	\n#endif";
var $e8ea6a63d48a4fea$var$envmap_pars_fragment = "#ifdef USE_ENVMAP\n	uniform float reflectivity;\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		varying vec3 vWorldPosition;\n		uniform float refractionRatio;\n	#else\n		varying vec3 vReflect;\n	#endif\n#endif";
var $e8ea6a63d48a4fea$var$envmap_pars_vertex = "#ifdef USE_ENVMAP\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		\n		varying vec3 vWorldPosition;\n	#else\n		varying vec3 vReflect;\n		uniform float refractionRatio;\n	#endif\n#endif";
var $e8ea6a63d48a4fea$var$envmap_vertex = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vWorldPosition = worldPosition.xyz;\n	#else\n		vec3 cameraToVertex;\n		if ( isOrthographic ) {\n			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vReflect = reflect( cameraToVertex, worldNormal );\n		#else\n			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n		#endif\n	#endif\n#endif";
var $e8ea6a63d48a4fea$var$fog_vertex = "#ifdef USE_FOG\n	vFogDepth = - mvPosition.z;\n#endif";
var $e8ea6a63d48a4fea$var$fog_pars_vertex = "#ifdef USE_FOG\n	varying float vFogDepth;\n#endif";
var $e8ea6a63d48a4fea$var$fog_fragment = "#ifdef USE_FOG\n	#ifdef FOG_EXP2\n		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n	#else\n		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n	#endif\n	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var $e8ea6a63d48a4fea$var$fog_pars_fragment = "#ifdef USE_FOG\n	uniform vec3 fogColor;\n	varying float vFogDepth;\n	#ifdef FOG_EXP2\n		uniform float fogDensity;\n	#else\n		uniform float fogNear;\n		uniform float fogFar;\n	#endif\n#endif";
var $e8ea6a63d48a4fea$var$gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n	uniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n	float dotNL = dot( normal, lightDirection );\n	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n	#ifdef USE_GRADIENTMAP\n		return vec3( texture2D( gradientMap, coord ).r );\n	#else\n		vec2 fw = fwidth( coord ) * 0.5;\n		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n	#endif\n}";
var $e8ea6a63d48a4fea$var$lightmap_fragment = "#ifdef USE_LIGHTMAP\n	vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n	vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n	reflectedLight.indirectDiffuse += lightMapIrradiance;\n#endif";
var $e8ea6a63d48a4fea$var$lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n	uniform sampler2D lightMap;\n	uniform float lightMapIntensity;\n#endif";
var $e8ea6a63d48a4fea$var$lights_lambert_fragment = "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;";
var $e8ea6a63d48a4fea$var$lights_lambert_pars_fragment = "varying vec3 vViewPosition;\nstruct LambertMaterial {\n	vec3 diffuseColor;\n	float specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in GeometricContext geometry, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in GeometricContext geometry, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Lambert\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert";
var $e8ea6a63d48a4fea$var$lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\nuniform vec3 lightProbe[ 9 ];\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n	float x = normal.x, y = normal.y, z = normal.z;\n	vec3 result = shCoefficients[ 0 ] * 0.886227;\n	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n	return result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n	return irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n	vec3 irradiance = ambientLightColor;\n	return irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n	#if defined ( LEGACY_LIGHTS )\n		if ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n			return pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );\n		}\n		return 1.0;\n	#else\n		float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n		if ( cutoffDistance > 0.0 ) {\n			distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n		}\n		return distanceFalloff;\n	#endif\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n	return smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n	struct DirectionalLight {\n		vec3 direction;\n		vec3 color;\n	};\n	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n	void getDirectionalLightInfo( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight light ) {\n		light.color = directionalLight.color;\n		light.direction = directionalLight.direction;\n		light.visible = true;\n	}\n#endif\n#if NUM_POINT_LIGHTS > 0\n	struct PointLight {\n		vec3 position;\n		vec3 color;\n		float distance;\n		float decay;\n	};\n	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n	void getPointLightInfo( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight light ) {\n		vec3 lVector = pointLight.position - geometry.position;\n		light.direction = normalize( lVector );\n		float lightDistance = length( lVector );\n		light.color = pointLight.color;\n		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n		light.visible = ( light.color != vec3( 0.0 ) );\n	}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n	struct SpotLight {\n		vec3 position;\n		vec3 direction;\n		vec3 color;\n		float distance;\n		float decay;\n		float coneCos;\n		float penumbraCos;\n	};\n	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n	void getSpotLightInfo( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight light ) {\n		vec3 lVector = spotLight.position - geometry.position;\n		light.direction = normalize( lVector );\n		float angleCos = dot( light.direction, spotLight.direction );\n		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n		if ( spotAttenuation > 0.0 ) {\n			float lightDistance = length( lVector );\n			light.color = spotLight.color * spotAttenuation;\n			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n			light.visible = ( light.color != vec3( 0.0 ) );\n		} else {\n			light.color = vec3( 0.0 );\n			light.visible = false;\n		}\n	}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n	struct RectAreaLight {\n		vec3 color;\n		vec3 position;\n		vec3 halfWidth;\n		vec3 halfHeight;\n	};\n	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;\n	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n	struct HemisphereLight {\n		vec3 direction;\n		vec3 skyColor;\n		vec3 groundColor;\n	};\n	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n		float dotNL = dot( normal, hemiLight.direction );\n		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n		return irradiance;\n	}\n#endif";
var $e8ea6a63d48a4fea$var$envmap_physical_pars_fragment = "#if defined( USE_ENVMAP )\n	vec3 getIBLIrradiance( const in vec3 normal ) {\n		#if defined( ENVMAP_TYPE_CUBE_UV )\n			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n			return PI * envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n		#if defined( ENVMAP_TYPE_CUBE_UV )\n			vec3 reflectVec = reflect( - viewDir, normal );\n			reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n			return envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n#endif";
var $e8ea6a63d48a4fea$var$lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var $e8ea6a63d48a4fea$var$lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n	vec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	vec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Toon\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon";
var $e8ea6a63d48a4fea$var$lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var $e8ea6a63d48a4fea$var$lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n	vec3 diffuseColor;\n	vec3 specularColor;\n	float specularShininess;\n	float specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_BlinnPhong\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong";
var $e8ea6a63d48a4fea$var$lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n	material.ior = ior;\n	#ifdef USE_SPECULAR\n		float specularIntensityFactor = specularIntensity;\n		vec3 specularColorFactor = specularColor;\n		#ifdef USE_SPECULAR_COLORMAP\n			specularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n		#endif\n		#ifdef USE_SPECULAR_INTENSITYMAP\n			specularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n		#endif\n		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n	#else\n		float specularIntensityFactor = 1.0;\n		vec3 specularColorFactor = vec3( 1.0 );\n		material.specularF90 = 1.0;\n	#endif\n	material.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n	material.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n	material.clearcoat = clearcoat;\n	material.clearcoatRoughness = clearcoatRoughness;\n	material.clearcoatF0 = vec3( 0.04 );\n	material.clearcoatF90 = 1.0;\n	#ifdef USE_CLEARCOATMAP\n		material.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n	#endif\n	#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n	#endif\n	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n	material.clearcoatRoughness += geometryRoughness;\n	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_IRIDESCENCE\n	material.iridescence = iridescence;\n	material.iridescenceIOR = iridescenceIOR;\n	#ifdef USE_IRIDESCENCEMAP\n		material.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n	#endif\n	#ifdef USE_IRIDESCENCE_THICKNESSMAP\n		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n	#else\n		material.iridescenceThickness = iridescenceThicknessMaximum;\n	#endif\n#endif\n#ifdef USE_SHEEN\n	material.sheenColor = sheenColor;\n	#ifdef USE_SHEEN_COLORMAP\n		material.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n	#endif\n	material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		material.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n	#endif\n#endif";
var $e8ea6a63d48a4fea$var$lights_physical_pars_fragment = "struct PhysicalMaterial {\n	vec3 diffuseColor;\n	float roughness;\n	vec3 specularColor;\n	float specularF90;\n	#ifdef USE_CLEARCOAT\n		float clearcoat;\n		float clearcoatRoughness;\n		vec3 clearcoatF0;\n		float clearcoatF90;\n	#endif\n	#ifdef USE_IRIDESCENCE\n		float iridescence;\n		float iridescenceIOR;\n		float iridescenceThickness;\n		vec3 iridescenceFresnel;\n		vec3 iridescenceF0;\n	#endif\n	#ifdef USE_SHEEN\n		vec3 sheenColor;\n		float sheenRoughness;\n	#endif\n	#ifdef IOR\n		float ior;\n	#endif\n	#ifdef USE_TRANSMISSION\n		float transmission;\n		float transmissionAlpha;\n		float thickness;\n		float attenuationDistance;\n		vec3 attenuationColor;\n	#endif\n};\nvec3 clearcoatSpecular = vec3( 0.0 );\nvec3 sheenSpecular = vec3( 0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n	float a2 = pow2( alpha );\n	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n	return 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n	float a2 = pow2( alpha );\n	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n	return RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_CLEARCOAT\n	vec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n		vec3 f0 = material.clearcoatF0;\n		float f90 = material.clearcoatF90;\n		float roughness = material.clearcoatRoughness;\n		float alpha = pow2( roughness );\n		vec3 halfDir = normalize( lightDir + viewDir );\n		float dotNL = saturate( dot( normal, lightDir ) );\n		float dotNV = saturate( dot( normal, viewDir ) );\n		float dotNH = saturate( dot( normal, halfDir ) );\n		float dotVH = saturate( dot( viewDir, halfDir ) );\n		vec3 F = F_Schlick( f0, f90, dotVH );\n		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n		float D = D_GGX( alpha, dotNH );\n		return F * ( V * D );\n	}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n	vec3 f0 = material.specularColor;\n	float f90 = material.specularF90;\n	float roughness = material.roughness;\n	float alpha = pow2( roughness );\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( f0, f90, dotVH );\n	#ifdef USE_IRIDESCENCE\n		F = mix( F, material.iridescenceFresnel, material.iridescence );\n	#endif\n	float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n	float D = D_GGX( alpha, dotNH );\n	return F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n	const float LUT_SIZE = 64.0;\n	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n	const float LUT_BIAS = 0.5 / LUT_SIZE;\n	float dotNV = saturate( dot( N, V ) );\n	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n	uv = uv * LUT_SCALE + LUT_BIAS;\n	return uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n	float l = length( f );\n	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n	float x = dot( v1, v2 );\n	float y = abs( x );\n	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n	float b = 3.4175940 + ( 4.1616724 + y ) * y;\n	float v = a / b;\n	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n	return cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n	vec3 lightNormal = cross( v1, v2 );\n	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n	vec3 T1, T2;\n	T1 = normalize( V - N * dot( V, N ) );\n	T2 = - cross( N, T1 );\n	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n	vec3 coords[ 4 ];\n	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n	coords[ 0 ] = normalize( coords[ 0 ] );\n	coords[ 1 ] = normalize( coords[ 1 ] );\n	coords[ 2 ] = normalize( coords[ 2 ] );\n	coords[ 3 ] = normalize( coords[ 3 ] );\n	vec3 vectorFormFactor = vec3( 0.0 );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n	return vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n	float alpha = pow2( roughness );\n	float invAlpha = 1.0 / alpha;\n	float cos2h = dotNH * dotNH;\n	float sin2h = max( 1.0 - cos2h, 0.0078125 );\n	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float D = D_Charlie( sheenRoughness, dotNH );\n	float V = V_Neubelt( dotNV, dotNL );\n	return sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float r2 = roughness * roughness;\n	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n	return saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n	vec4 r = roughness * c0 + c1;\n	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n	return fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	return specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	#ifdef USE_IRIDESCENCE\n		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n	#else\n		vec3 Fr = specularColor;\n	#endif\n	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n	float Ess = fab.x + fab.y;\n	float Ems = 1.0 - Ess;\n	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n	singleScatter += FssEss;\n	multiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n		vec3 normal = geometry.normal;\n		vec3 viewDir = geometry.viewDir;\n		vec3 position = geometry.position;\n		vec3 lightPos = rectAreaLight.position;\n		vec3 halfWidth = rectAreaLight.halfWidth;\n		vec3 halfHeight = rectAreaLight.halfHeight;\n		vec3 lightColor = rectAreaLight.color;\n		float roughness = material.roughness;\n		vec3 rectCoords[ 4 ];\n		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n		vec2 uv = LTC_Uv( normal, viewDir, roughness );\n		vec4 t1 = texture2D( ltc_1, uv );\n		vec4 t2 = texture2D( ltc_2, uv );\n		mat3 mInv = mat3(\n			vec3( t1.x, 0, t1.y ),\n			vec3(    0, 1,    0 ),\n			vec3( t1.z, 0, t1.w )\n		);\n		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n	}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	#ifdef USE_CLEARCOAT\n		float dotNLcc = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );\n		vec3 ccIrradiance = dotNLcc * directLight.color;\n		clearcoatSpecular += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometry.viewDir, geometry.clearcoatNormal, material );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecular += irradiance * BRDF_Sheen( directLight.direction, geometry.viewDir, geometry.normal, material.sheenColor, material.sheenRoughness );\n	#endif\n	reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.normal, material );\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n	#ifdef USE_CLEARCOAT\n		clearcoatSpecular += clearcoatRadiance * EnvironmentBRDF( geometry.clearcoatNormal, geometry.viewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecular += irradiance * material.sheenColor * IBLSheenBRDF( geometry.normal, geometry.viewDir, material.sheenRoughness );\n	#endif\n	vec3 singleScattering = vec3( 0.0 );\n	vec3 multiScattering = vec3( 0.0 );\n	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n	#ifdef USE_IRIDESCENCE\n		computeMultiscatteringIridescence( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n	#else\n		computeMultiscattering( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n	#endif\n	vec3 totalScattering = singleScattering + multiScattering;\n	vec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n	reflectedLight.indirectSpecular += radiance * singleScattering;\n	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct				RE_Direct_Physical\n#define RE_Direct_RectArea		RE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular		RE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var $e8ea6a63d48a4fea$var$lights_fragment_begin = "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\n#ifdef USE_CLEARCOAT\n	geometry.clearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n	float dotNVi = saturate( dot( normal, geometry.viewDir ) );\n	if ( material.iridescenceThickness == 0.0 ) {\n		material.iridescence = 0.0;\n	} else {\n		material.iridescence = saturate( material.iridescence );\n	}\n	if ( material.iridescence > 0.0 ) {\n		material.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n		material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n	}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n	PointLight pointLight;\n	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n		pointLight = pointLights[ i ];\n		getPointLightInfo( pointLight, geometry, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n		pointLightShadow = pointLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n	SpotLight spotLight;\n	vec4 spotColor;\n	vec3 spotLightCoord;\n	bool inSpotLightMap;\n	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n		spotLight = spotLights[ i ];\n		getSpotLightInfo( spotLight, geometry, directLight );\n		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n		#else\n		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#endif\n		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n		#endif\n		#undef SPOT_LIGHT_MAP_INDEX\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		spotLightShadow = spotLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n	DirectionalLight directionalLight;\n	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n		directionalLight = directionalLights[ i ];\n		getDirectionalLightInfo( directionalLight, geometry, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n		directionalLightShadow = directionalLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n	RectAreaLight rectAreaLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n		rectAreaLight = rectAreaLights[ i ];\n		RE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n	vec3 iblIrradiance = vec3( 0.0 );\n	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n	irradiance += getLightProbeIrradiance( lightProbe, geometry.normal );\n	#if ( NUM_HEMI_LIGHTS > 0 )\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if defined( RE_IndirectSpecular )\n	vec3 radiance = vec3( 0.0 );\n	vec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var $e8ea6a63d48a4fea$var$lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n		irradiance += lightMapIrradiance;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n		iblIrradiance += getIBLIrradiance( geometry.normal );\n	#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n	radiance += getIBLRadiance( geometry.viewDir, geometry.normal, material.roughness );\n	#ifdef USE_CLEARCOAT\n		clearcoatRadiance += getIBLRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness );\n	#endif\n#endif";
var $e8ea6a63d48a4fea$var$lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n	RE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );\n#endif";
var $e8ea6a63d48a4fea$var$logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n	gl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var $e8ea6a63d48a4fea$var$logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n	uniform float logDepthBufFC;\n	varying float vFragDepth;\n	varying float vIsPerspective;\n#endif";
var $e8ea6a63d48a4fea$var$logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n	#ifdef USE_LOGDEPTHBUF_EXT\n		varying float vFragDepth;\n		varying float vIsPerspective;\n	#else\n		uniform float logDepthBufFC;\n	#endif\n#endif";
var $e8ea6a63d48a4fea$var$logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n	#ifdef USE_LOGDEPTHBUF_EXT\n		vFragDepth = 1.0 + gl_Position.w;\n		vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n	#else\n		if ( isPerspectiveMatrix( projectionMatrix ) ) {\n			gl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n			gl_Position.z *= gl_Position.w;\n		}\n	#endif\n#endif";
var $e8ea6a63d48a4fea$var$map_fragment = "#ifdef USE_MAP\n	vec4 sampledDiffuseColor = texture2D( map, vMapUv );\n	#ifdef DECODE_VIDEO_TEXTURE\n		sampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );\n	#endif\n	diffuseColor *= sampledDiffuseColor;\n#endif";
var $e8ea6a63d48a4fea$var$map_pars_fragment = "#ifdef USE_MAP\n	uniform sampler2D map;\n#endif";
var $e8ea6a63d48a4fea$var$map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n	#if defined( USE_POINTS_UV )\n		vec2 uv = vUv;\n	#else\n		vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n	#endif\n#endif\n#ifdef USE_MAP\n	diffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var $e8ea6a63d48a4fea$var$map_particle_pars_fragment = "#if defined( USE_POINTS_UV )\n	varying vec2 vUv;\n#else\n	#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n		uniform mat3 uvTransform;\n	#endif\n#endif\n#ifdef USE_MAP\n	uniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
var $e8ea6a63d48a4fea$var$metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n	vec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n	metalnessFactor *= texelMetalness.b;\n#endif";
var $e8ea6a63d48a4fea$var$metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n	uniform sampler2D metalnessMap;\n#endif";
var $e8ea6a63d48a4fea$var$morphcolor_vertex = "#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )\n	vColor *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		#if defined( USE_COLOR_ALPHA )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n		#elif defined( USE_COLOR )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n		#endif\n	}\n#endif";
var $e8ea6a63d48a4fea$var$morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n	objectNormal *= morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n			if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n		}\n	#else\n		objectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n		objectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n		objectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n		objectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n	#endif\n#endif";
var $e8ea6a63d48a4fea$var$morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n	uniform float morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n		uniform sampler2DArray morphTargetsTexture;\n		uniform ivec2 morphTargetsTextureSize;\n		vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n			int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n			int y = texelIndex / morphTargetsTextureSize.x;\n			int x = texelIndex - y * morphTargetsTextureSize.x;\n			ivec3 morphUV = ivec3( x, y, morphTargetIndex );\n			return texelFetch( morphTargetsTexture, morphUV, 0 );\n		}\n	#else\n		#ifndef USE_MORPHNORMALS\n			uniform float morphTargetInfluences[ 8 ];\n		#else\n			uniform float morphTargetInfluences[ 4 ];\n		#endif\n	#endif\n#endif";
var $e8ea6a63d48a4fea$var$morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n	transformed *= morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n			if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n		}\n	#else\n		transformed += morphTarget0 * morphTargetInfluences[ 0 ];\n		transformed += morphTarget1 * morphTargetInfluences[ 1 ];\n		transformed += morphTarget2 * morphTargetInfluences[ 2 ];\n		transformed += morphTarget3 * morphTargetInfluences[ 3 ];\n		#ifndef USE_MORPHNORMALS\n			transformed += morphTarget4 * morphTargetInfluences[ 4 ];\n			transformed += morphTarget5 * morphTargetInfluences[ 5 ];\n			transformed += morphTarget6 * morphTargetInfluences[ 6 ];\n			transformed += morphTarget7 * morphTargetInfluences[ 7 ];\n		#endif\n	#endif\n#endif";
var $e8ea6a63d48a4fea$var$normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n	vec3 fdx = dFdx( vViewPosition );\n	vec3 fdy = dFdy( vViewPosition );\n	vec3 normal = normalize( cross( fdx, fdy ) );\n#else\n	vec3 normal = normalize( vNormal );\n	#ifdef DOUBLE_SIDED\n		normal *= faceDirection;\n	#endif\n#endif\n#ifdef USE_NORMALMAP_TANGENTSPACE\n	#ifdef USE_TANGENT\n		mat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn = getTangentFrame( - vViewPosition, normal, vNormalMapUv );\n	#endif\n	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n		tbn[0] *= faceDirection;\n		tbn[1] *= faceDirection;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	#ifdef USE_TANGENT\n		mat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n	#endif\n	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n		tbn2[0] *= faceDirection;\n		tbn2[1] *= faceDirection;\n	#endif\n#endif\nvec3 geometryNormal = normal;";
var $e8ea6a63d48a4fea$var$normal_fragment_maps = "#ifdef USE_NORMALMAP_OBJECTSPACE\n	normal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	#ifdef FLIP_SIDED\n		normal = - normal;\n	#endif\n	#ifdef DOUBLE_SIDED\n		normal = normal * faceDirection;\n	#endif\n	normal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n	vec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	mapN.xy *= normalScale;\n	normal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var $e8ea6a63d48a4fea$var$normal_pars_fragment = "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif";
var $e8ea6a63d48a4fea$var$normal_pars_vertex = "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif";
var $e8ea6a63d48a4fea$var$normal_vertex = "#ifndef FLAT_SHADED\n	vNormal = normalize( transformedNormal );\n	#ifdef USE_TANGENT\n		vTangent = normalize( transformedTangent );\n		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n	#endif\n#endif";
var $e8ea6a63d48a4fea$var$normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n	uniform sampler2D normalMap;\n	uniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n	uniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) )\n	mat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n		vec3 q0 = dFdx( eye_pos.xyz );\n		vec3 q1 = dFdy( eye_pos.xyz );\n		vec2 st0 = dFdx( uv.st );\n		vec2 st1 = dFdy( uv.st );\n		vec3 N = surf_norm;\n		vec3 q1perp = cross( q1, N );\n		vec3 q0perp = cross( N, q0 );\n		vec3 T = q1perp * st0.x + q0perp * st1.x;\n		vec3 B = q1perp * st0.y + q0perp * st1.y;\n		float det = max( dot( T, T ), dot( B, B ) );\n		float scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n		return mat3( T * scale, B * scale, N );\n	}\n#endif";
var $e8ea6a63d48a4fea$var$clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n	vec3 clearcoatNormal = geometryNormal;\n#endif";
var $e8ea6a63d48a4fea$var$clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n	clearcoatMapN.xy *= clearcoatNormalScale;\n	clearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif";
var $e8ea6a63d48a4fea$var$clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n	uniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform sampler2D clearcoatNormalMap;\n	uniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform sampler2D clearcoatRoughnessMap;\n#endif";
var $e8ea6a63d48a4fea$var$iridescence_pars_fragment = "#ifdef USE_IRIDESCENCEMAP\n	uniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform sampler2D iridescenceThicknessMap;\n#endif";
var $e8ea6a63d48a4fea$var$output_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha + 0.1;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
var $e8ea6a63d48a4fea$var$packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n	return normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n	return 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n	vec4 r = vec4( fract( v * PackFactors ), v );\n	r.yzw -= r.xyz * ShiftRight8;	return r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n	return dot( v, UnpackFactors );\n}\nvec2 packDepthToRG( in highp float v ) {\n	return packDepthToRGBA( v ).yx;\n}\nfloat unpackRGToDepth( const in highp vec2 v ) {\n	return unpackRGBAToDepth( vec4( v.xy, 0.0, 0.0 ) );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	return depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	return ( near * far ) / ( ( far - near ) * depth - far );\n}";
var $e8ea6a63d48a4fea$var$premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n	gl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var $e8ea6a63d48a4fea$var$project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n	mvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var $e8ea6a63d48a4fea$var$dithering_fragment = "#ifdef DITHERING\n	gl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var $e8ea6a63d48a4fea$var$dithering_pars_fragment = "#ifdef DITHERING\n	vec3 dithering( vec3 color ) {\n		float grid_position = rand( gl_FragCoord.xy );\n		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n		return color + dither_shift_RGB;\n	}\n#endif";
var $e8ea6a63d48a4fea$var$roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n	vec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n	roughnessFactor *= texelRoughness.g;\n#endif";
var $e8ea6a63d48a4fea$var$roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n	uniform sampler2D roughnessMap;\n#endif";
var $e8ea6a63d48a4fea$var$shadowmap_pars_fragment = "#if NUM_SPOT_LIGHT_COORDS > 0\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n	uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n		struct SpotLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n		return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n	}\n	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n		return unpackRGBATo2Half( texture2D( shadow, uv ) );\n	}\n	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n		float occlusion = 1.0;\n		vec2 distribution = texture2DDistribution( shadow, uv );\n		float hard_shadow = step( compare , distribution.x );\n		if (hard_shadow != 1.0 ) {\n			float distance = compare - distribution.x ;\n			float variance = max( 0.00000, distribution.y * distribution.y );\n			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n		}\n		return occlusion;\n	}\n	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n		float shadow = 1.0;\n		shadowCoord.xyz /= shadowCoord.w;\n		shadowCoord.z += shadowBias;\n		bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n		bool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n		if ( frustumTest ) {\n		#if defined( SHADOWMAP_TYPE_PCF )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx0 = - texelSize.x * shadowRadius;\n			float dy0 = - texelSize.y * shadowRadius;\n			float dx1 = + texelSize.x * shadowRadius;\n			float dy1 = + texelSize.y * shadowRadius;\n			float dx2 = dx0 / 2.0;\n			float dy2 = dy0 / 2.0;\n			float dx3 = dx1 / 2.0;\n			float dy3 = dy1 / 2.0;\n			shadow = (\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n			) * ( 1.0 / 17.0 );\n		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx = texelSize.x;\n			float dy = texelSize.y;\n			vec2 uv = shadowCoord.xy;\n			vec2 f = fract( uv * shadowMapSize + 0.5 );\n			uv -= f * texelSize;\n			shadow = (\n				texture2DCompare( shadowMap, uv, shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n						  f.x ),\n					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n						  f.x ),\n					 f.y )\n			) * ( 1.0 / 9.0 );\n		#elif defined( SHADOWMAP_TYPE_VSM )\n			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#else\n			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#endif\n		}\n		return shadow;\n	}\n	vec2 cubeToUV( vec3 v, float texelSizeY ) {\n		vec3 absV = abs( v );\n		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n		absV *= scaleToCube;\n		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n		vec2 planar = v.xy;\n		float almostATexel = 1.5 * texelSizeY;\n		float almostOne = 1.0 - almostATexel;\n		if ( absV.z >= almostOne ) {\n			if ( v.z > 0.0 )\n				planar.x = 4.0 - v.x;\n		} else if ( absV.x >= almostOne ) {\n			float signX = sign( v.x );\n			planar.x = v.z * signX + 2.0 * signX;\n		} else if ( absV.y >= almostOne ) {\n			float signY = sign( v.y );\n			planar.x = v.x + 2.0 * signY + 2.0;\n			planar.y = v.z * signY - 2.0;\n		}\n		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n	}\n	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n		vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n		vec3 lightToPosition = shadowCoord.xyz;\n		float dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );		dp += shadowBias;\n		vec3 bd3D = normalize( lightToPosition );\n		#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n			vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n			return (\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n			) * ( 1.0 / 9.0 );\n		#else\n			return texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n		#endif\n	}\n#endif";
var $e8ea6a63d48a4fea$var$shadowmap_pars_vertex = "#if NUM_SPOT_LIGHT_COORDS > 0\n	uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		struct SpotLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n#endif";
var $e8ea6a63d48a4fea$var$shadowmap_vertex = "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n	vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n	vec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n			vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n			vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n		shadowWorldPosition = worldPosition;\n		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n		#endif\n		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n#endif";
var $e8ea6a63d48a4fea$var$shadowmask_pars_fragment = "float getShadowMask() {\n	float shadow = 1.0;\n	#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n		directionalLight = directionalLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n		spotLight = spotLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n		pointLight = pointLightShadows[ i ];\n		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#endif\n	return shadow;\n}";
var $e8ea6a63d48a4fea$var$skinbase_vertex = "#ifdef USE_SKINNING\n	mat4 boneMatX = getBoneMatrix( skinIndex.x );\n	mat4 boneMatY = getBoneMatrix( skinIndex.y );\n	mat4 boneMatZ = getBoneMatrix( skinIndex.z );\n	mat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var $e8ea6a63d48a4fea$var$skinning_pars_vertex = "#ifdef USE_SKINNING\n	uniform mat4 bindMatrix;\n	uniform mat4 bindMatrixInverse;\n	uniform highp sampler2D boneTexture;\n	uniform int boneTextureSize;\n	mat4 getBoneMatrix( const in float i ) {\n		float j = i * 4.0;\n		float x = mod( j, float( boneTextureSize ) );\n		float y = floor( j / float( boneTextureSize ) );\n		float dx = 1.0 / float( boneTextureSize );\n		float dy = 1.0 / float( boneTextureSize );\n		y = dy * ( y + 0.5 );\n		vec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n		vec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n		vec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n		vec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n		mat4 bone = mat4( v1, v2, v3, v4 );\n		return bone;\n	}\n#endif";
var $e8ea6a63d48a4fea$var$skinning_vertex = "#ifdef USE_SKINNING\n	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n	vec4 skinned = vec4( 0.0 );\n	skinned += boneMatX * skinVertex * skinWeight.x;\n	skinned += boneMatY * skinVertex * skinWeight.y;\n	skinned += boneMatZ * skinVertex * skinWeight.z;\n	skinned += boneMatW * skinVertex * skinWeight.w;\n	transformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var $e8ea6a63d48a4fea$var$skinnormal_vertex = "#ifdef USE_SKINNING\n	mat4 skinMatrix = mat4( 0.0 );\n	skinMatrix += skinWeight.x * boneMatX;\n	skinMatrix += skinWeight.y * boneMatY;\n	skinMatrix += skinWeight.z * boneMatZ;\n	skinMatrix += skinWeight.w * boneMatW;\n	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n	#ifdef USE_TANGENT\n		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#endif\n#endif";
var $e8ea6a63d48a4fea$var$specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n	vec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n	specularStrength = texelSpecular.r;\n#else\n	specularStrength = 1.0;\n#endif";
var $e8ea6a63d48a4fea$var$specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n	uniform sampler2D specularMap;\n#endif";
var $e8ea6a63d48a4fea$var$tonemapping_fragment = "#if defined( TONE_MAPPING )\n	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var $e8ea6a63d48a4fea$var$tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n	return toneMappingExposure * color;\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	return saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	color = max( vec3( 0.0 ), color - 0.004 );\n	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n	return a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n	const mat3 ACESInputMat = mat3(\n		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),\n		vec3( 0.04823, 0.01566, 0.83777 )\n	);\n	const mat3 ACESOutputMat = mat3(\n		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),\n		vec3( -0.07367, -0.00605,  1.07602 )\n	);\n	color *= toneMappingExposure / 0.6;\n	color = ACESInputMat * color;\n	color = RRTAndODTFit( color );\n	color = ACESOutputMat * color;\n	return saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var $e8ea6a63d48a4fea$var$transmission_fragment = "#ifdef USE_TRANSMISSION\n	material.transmission = transmission;\n	material.transmissionAlpha = 1.0;\n	material.thickness = thickness;\n	material.attenuationDistance = attenuationDistance;\n	material.attenuationColor = attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		material.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		material.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n	#endif\n	vec3 pos = vWorldPosition;\n	vec3 v = normalize( cameraPosition - pos );\n	vec3 n = inverseTransformDirection( normal, viewMatrix );\n	vec4 transmission = getIBLVolumeRefraction(\n		n, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n		pos, modelMatrix, viewMatrix, projectionMatrix, material.ior, material.thickness,\n		material.attenuationColor, material.attenuationDistance );\n	material.transmissionAlpha = mix( material.transmissionAlpha, transmission.a, material.transmission );\n	totalDiffuse = mix( totalDiffuse, transmission.rgb, material.transmission );\n#endif";
var $e8ea6a63d48a4fea$var$transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n	uniform float transmission;\n	uniform float thickness;\n	uniform float attenuationDistance;\n	uniform vec3 attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		uniform sampler2D transmissionMap;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		uniform sampler2D thicknessMap;\n	#endif\n	uniform vec2 transmissionSamplerSize;\n	uniform sampler2D transmissionSamplerMap;\n	uniform mat4 modelMatrix;\n	uniform mat4 projectionMatrix;\n	varying vec3 vWorldPosition;\n	float w0( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n	}\n	float w1( float a ) {\n		return ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n	}\n	float w2( float a ){\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n	}\n	float w3( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * a * a );\n	}\n	float g0( float a ) {\n		return w0( a ) + w1( a );\n	}\n	float g1( float a ) {\n		return w2( a ) + w3( a );\n	}\n	float h0( float a ) {\n		return - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n	}\n	float h1( float a ) {\n		return 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n	}\n	vec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, vec2 fullSize, float lod ) {\n		uv = uv * texelSize.zw + 0.5;\n		vec2 iuv = floor( uv );\n		vec2 fuv = fract( uv );\n		float g0x = g0( fuv.x );\n		float g1x = g1( fuv.x );\n		float h0x = h0( fuv.x );\n		float h1x = h1( fuv.x );\n		float h0y = h0( fuv.y );\n		float h1y = h1( fuv.y );\n		vec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		vec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		\n		vec2 lodFudge = pow( 1.95, lod ) / fullSize;\n		return g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n			g1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n	}\n	vec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n		vec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n		vec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n		vec2 fLodSizeInv = 1.0 / fLodSize;\n		vec2 cLodSizeInv = 1.0 / cLodSize;\n		vec2 fullSize = vec2( textureSize( sampler, 0 ) );\n		vec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), fullSize, floor( lod ) );\n		vec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), fullSize, ceil( lod ) );\n		return mix( fSample, cSample, fract( lod ) );\n	}\n	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n		vec3 modelScale;\n		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n		return normalize( refractionVector ) * thickness * modelScale;\n	}\n	float applyIorToRoughness( const in float roughness, const in float ior ) {\n		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n	}\n	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n		float lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n		return textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n	}\n	vec3 applyVolumeAttenuation( const in vec3 radiance, const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n		if ( isinf( attenuationDistance ) ) {\n			return radiance;\n		} else {\n			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance * radiance;\n		}\n	}\n	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n		const in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,\n		const in vec3 attenuationColor, const in float attenuationDistance ) {\n		vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n		vec3 refractedRayExit = position + transmissionRay;\n		vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n		vec2 refractionCoords = ndcPos.xy / ndcPos.w;\n		refractionCoords += 1.0;\n		refractionCoords /= 2.0;\n		vec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n		vec3 attenuatedColor = applyVolumeAttenuation( transmittedLight.rgb, length( transmissionRay ), attenuationColor, attenuationDistance );\n		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n		return vec4( ( 1.0 - F ) * attenuatedColor * diffuseColor, transmittedLight.a );\n	}\n#endif";
var $e8ea6a63d48a4fea$var$uv_pars_fragment = "#ifdef USE_UV\n	varying vec2 vUv;\n#endif\n#ifdef USE_MAP\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif";
var $e8ea6a63d48a4fea$var$uv_pars_vertex = "#ifdef USE_UV\n	varying vec2 vUv;\n#endif\n#ifdef USE_UV2\n	attribute vec2 uv2;\n#endif\n#ifdef USE_MAP\n	uniform mat3 mapTransform;\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform mat3 alphaMapTransform;\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	uniform mat3 lightMapTransform;\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	uniform mat3 aoMapTransform;\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	uniform mat3 bumpMapTransform;\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	uniform mat3 normalMapTransform;\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	uniform mat3 displacementMapTransform;\n	varying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	uniform mat3 emissiveMapTransform;\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	uniform mat3 metalnessMapTransform;\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	uniform mat3 roughnessMapTransform;\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	uniform mat3 clearcoatMapTransform;\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform mat3 clearcoatNormalMapTransform;\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform mat3 clearcoatRoughnessMapTransform;\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	uniform mat3 sheenColorMapTransform;\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	uniform mat3 sheenRoughnessMapTransform;\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	uniform mat3 iridescenceMapTransform;\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform mat3 iridescenceThicknessMapTransform;\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	uniform mat3 specularMapTransform;\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	uniform mat3 specularColorMapTransform;\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	uniform mat3 specularIntensityMapTransform;\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif";
var $e8ea6a63d48a4fea$var$uv_vertex = "#ifdef USE_UV\n	vUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n	vMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n	vAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n	vLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n	vAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n	vBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n	vNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	vDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n	vEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n	vMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	vRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n	vClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	vClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	vClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	vIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	vIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	vSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	vSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n	vSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	vSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	vSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	vTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n	vThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif";
var $e8ea6a63d48a4fea$var$worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n	vec4 worldPosition = vec4( transformed, 1.0 );\n	#ifdef USE_INSTANCING\n		worldPosition = instanceMatrix * worldPosition;\n	#endif\n	worldPosition = modelMatrix * worldPosition;\n#endif";
const $e8ea6a63d48a4fea$var$vertex$h = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	gl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
const $e8ea6a63d48a4fea$var$fragment$h = "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n	vec4 texColor = texture2D( t2D, vUv );\n	#ifdef DECODE_VIDEO_TEXTURE\n		texColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n	#endif\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n}";
const $e8ea6a63d48a4fea$var$vertex$g = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}";
const $e8ea6a63d48a4fea$var$fragment$g = "#ifdef ENVMAP_TYPE_CUBE\n	uniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n	uniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 texColor = textureCube( envMap, vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n	#elif defined( ENVMAP_TYPE_CUBE_UV )\n		vec4 texColor = textureCubeUV( envMap, vWorldDirection, backgroundBlurriness );\n	#else\n		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n	#endif\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n}";
const $e8ea6a63d48a4fea$var$vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}";
const $e8ea6a63d48a4fea$var$fragment$f = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n	gl_FragColor = texColor;\n	gl_FragColor.a *= opacity;\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n}";
const $e8ea6a63d48a4fea$var$vertex$e = "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <uv_vertex>\n	#include <skinbase_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vHighPrecisionZW = gl_Position.zw;\n}";
const $e8ea6a63d48a4fea$var$fragment$e = "#if DEPTH_PACKING == 3200\n	uniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( 1.0 );\n	#if DEPTH_PACKING == 3200\n		diffuseColor.a = opacity;\n	#endif\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <logdepthbuf_fragment>\n	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n	#if DEPTH_PACKING == 3200\n		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n	#elif DEPTH_PACKING == 3201\n		gl_FragColor = packDepthToRGBA( fragCoordZ );\n	#endif\n}";
const $e8ea6a63d48a4fea$var$vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <skinbase_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <worldpos_vertex>\n	#include <clipping_planes_vertex>\n	vWorldPosition = worldPosition.xyz;\n}";
const $e8ea6a63d48a4fea$var$fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( 1.0 );\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	float dist = length( vWorldPosition - referencePosition );\n	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n	dist = saturate( dist );\n	gl_FragColor = packDepthToRGBA( dist );\n}";
const $e8ea6a63d48a4fea$var$vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n}";
const $e8ea6a63d48a4fea$var$fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vec3 direction = normalize( vWorldDirection );\n	vec2 sampleUV = equirectUv( direction );\n	gl_FragColor = texture2D( tEquirect, sampleUV );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n}";
const $e8ea6a63d48a4fea$var$vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	vLineDistance = scale * lineDistance;\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
const $e8ea6a63d48a4fea$var$fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	if ( mod( vLineDistance, totalSize ) > dashSize ) {\n		discard;\n	}\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
const $e8ea6a63d48a4fea$var$vertex$a = "#include <common>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinbase_vertex>\n		#include <skinnormal_vertex>\n		#include <defaultnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <fog_vertex>\n}";
const $e8ea6a63d48a4fea$var$fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <specularmap_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n	#else\n		reflectedLight.indirectDiffuse += vec3( 1.0 );\n	#endif\n	#include <aomap_fragment>\n	reflectedLight.indirectDiffuse *= diffuseColor.rgb;\n	vec3 outgoingLight = reflectedLight.indirectDiffuse;\n	#include <envmap_fragment>\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $e8ea6a63d48a4fea$var$vertex$9 = "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $e8ea6a63d48a4fea$var$fragment$9 = "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_lambert_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $e8ea6a63d48a4fea$var$vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n	vViewPosition = - mvPosition.xyz;\n}";
const $e8ea6a63d48a4fea$var$fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	vec3 viewDir = normalize( vViewPosition );\n	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n	vec3 y = cross( viewDir, x );\n	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n	#ifdef USE_MATCAP\n		vec4 matcapColor = texture2D( matcap, uv );\n	#else\n		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n	#endif\n	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $e8ea6a63d48a4fea$var$vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	vViewPosition = - mvPosition.xyz;\n#endif\n}";
const $e8ea6a63d48a4fea$var$fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	gl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n	#ifdef OPAQUE\n		gl_FragColor.a = 1.0;\n	#endif\n}";
const $e8ea6a63d48a4fea$var$vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $e8ea6a63d48a4fea$var$fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_phong_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $e8ea6a63d48a4fea$var$vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n	varying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n	vWorldPosition = worldPosition.xyz;\n#endif\n}";
const $e8ea6a63d48a4fea$var$fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n	#define IOR\n	#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n	uniform float ior;\n#endif\n#ifdef USE_SPECULAR\n	uniform float specularIntensity;\n	uniform vec3 specularColor;\n	#ifdef USE_SPECULAR_COLORMAP\n		uniform sampler2D specularColorMap;\n	#endif\n	#ifdef USE_SPECULAR_INTENSITYMAP\n		uniform sampler2D specularIntensityMap;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT\n	uniform float clearcoat;\n	uniform float clearcoatRoughness;\n#endif\n#ifdef USE_IRIDESCENCE\n	uniform float iridescence;\n	uniform float iridescenceIOR;\n	uniform float iridescenceThicknessMinimum;\n	uniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n	uniform vec3 sheenColor;\n	uniform float sheenRoughness;\n	#ifdef USE_SHEEN_COLORMAP\n		uniform sampler2D sheenColorMap;\n	#endif\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		uniform sampler2D sheenRoughnessMap;\n	#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <roughnessmap_fragment>\n	#include <metalnessmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <clearcoat_normal_fragment_begin>\n	#include <clearcoat_normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_physical_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n	#include <transmission_fragment>\n	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n	#ifdef USE_SHEEN\n		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecular;\n	#endif\n	#ifdef USE_CLEARCOAT\n		float dotNVcc = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );\n		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + clearcoatSpecular * material.clearcoat;\n	#endif\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $e8ea6a63d48a4fea$var$vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $e8ea6a63d48a4fea$var$fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_toon_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $e8ea6a63d48a4fea$var$vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n	varying vec2 vUv;\n	uniform mat3 uvTransform;\n#endif\nvoid main() {\n	#ifdef USE_POINTS_UV\n		vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	#endif\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	gl_PointSize = size;\n	#ifdef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n	#endif\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <fog_vertex>\n}";
const $e8ea6a63d48a4fea$var$fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_particle_fragment>\n	#include <color_fragment>\n	#include <alphatest_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
const $e8ea6a63d48a4fea$var$vertex$2 = "#include <common>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $e8ea6a63d48a4fea$var$fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n	#include <logdepthbuf_fragment>\n	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n}";
const $e8ea6a63d48a4fea$var$vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	vec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n	vec2 scale;\n	scale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n	scale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n	#ifndef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) scale *= - mvPosition.z;\n	#endif\n	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n	vec2 rotatedPosition;\n	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n	mvPosition.xy += rotatedPosition;\n	gl_Position = projectionMatrix * mvPosition;\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
const $e8ea6a63d48a4fea$var$fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n}";
const $e8ea6a63d48a4fea$export$955f9f2e84c43c8b = {
    alphamap_fragment: $e8ea6a63d48a4fea$var$alphamap_fragment,
    alphamap_pars_fragment: $e8ea6a63d48a4fea$var$alphamap_pars_fragment,
    alphatest_fragment: $e8ea6a63d48a4fea$var$alphatest_fragment,
    alphatest_pars_fragment: $e8ea6a63d48a4fea$var$alphatest_pars_fragment,
    aomap_fragment: $e8ea6a63d48a4fea$var$aomap_fragment,
    aomap_pars_fragment: $e8ea6a63d48a4fea$var$aomap_pars_fragment,
    begin_vertex: $e8ea6a63d48a4fea$var$begin_vertex,
    beginnormal_vertex: $e8ea6a63d48a4fea$var$beginnormal_vertex,
    bsdfs: $e8ea6a63d48a4fea$var$bsdfs,
    iridescence_fragment: $e8ea6a63d48a4fea$var$iridescence_fragment,
    bumpmap_pars_fragment: $e8ea6a63d48a4fea$var$bumpmap_pars_fragment,
    clipping_planes_fragment: $e8ea6a63d48a4fea$var$clipping_planes_fragment,
    clipping_planes_pars_fragment: $e8ea6a63d48a4fea$var$clipping_planes_pars_fragment,
    clipping_planes_pars_vertex: $e8ea6a63d48a4fea$var$clipping_planes_pars_vertex,
    clipping_planes_vertex: $e8ea6a63d48a4fea$var$clipping_planes_vertex,
    color_fragment: $e8ea6a63d48a4fea$var$color_fragment,
    color_pars_fragment: $e8ea6a63d48a4fea$var$color_pars_fragment,
    color_pars_vertex: $e8ea6a63d48a4fea$var$color_pars_vertex,
    color_vertex: $e8ea6a63d48a4fea$var$color_vertex,
    common: $e8ea6a63d48a4fea$var$common,
    cube_uv_reflection_fragment: $e8ea6a63d48a4fea$var$cube_uv_reflection_fragment,
    defaultnormal_vertex: $e8ea6a63d48a4fea$var$defaultnormal_vertex,
    displacementmap_pars_vertex: $e8ea6a63d48a4fea$var$displacementmap_pars_vertex,
    displacementmap_vertex: $e8ea6a63d48a4fea$var$displacementmap_vertex,
    emissivemap_fragment: $e8ea6a63d48a4fea$var$emissivemap_fragment,
    emissivemap_pars_fragment: $e8ea6a63d48a4fea$var$emissivemap_pars_fragment,
    encodings_fragment: $e8ea6a63d48a4fea$var$encodings_fragment,
    encodings_pars_fragment: $e8ea6a63d48a4fea$var$encodings_pars_fragment,
    envmap_fragment: $e8ea6a63d48a4fea$var$envmap_fragment,
    envmap_common_pars_fragment: $e8ea6a63d48a4fea$var$envmap_common_pars_fragment,
    envmap_pars_fragment: $e8ea6a63d48a4fea$var$envmap_pars_fragment,
    envmap_pars_vertex: $e8ea6a63d48a4fea$var$envmap_pars_vertex,
    envmap_physical_pars_fragment: $e8ea6a63d48a4fea$var$envmap_physical_pars_fragment,
    envmap_vertex: $e8ea6a63d48a4fea$var$envmap_vertex,
    fog_vertex: $e8ea6a63d48a4fea$var$fog_vertex,
    fog_pars_vertex: $e8ea6a63d48a4fea$var$fog_pars_vertex,
    fog_fragment: $e8ea6a63d48a4fea$var$fog_fragment,
    fog_pars_fragment: $e8ea6a63d48a4fea$var$fog_pars_fragment,
    gradientmap_pars_fragment: $e8ea6a63d48a4fea$var$gradientmap_pars_fragment,
    lightmap_fragment: $e8ea6a63d48a4fea$var$lightmap_fragment,
    lightmap_pars_fragment: $e8ea6a63d48a4fea$var$lightmap_pars_fragment,
    lights_lambert_fragment: $e8ea6a63d48a4fea$var$lights_lambert_fragment,
    lights_lambert_pars_fragment: $e8ea6a63d48a4fea$var$lights_lambert_pars_fragment,
    lights_pars_begin: $e8ea6a63d48a4fea$var$lights_pars_begin,
    lights_toon_fragment: $e8ea6a63d48a4fea$var$lights_toon_fragment,
    lights_toon_pars_fragment: $e8ea6a63d48a4fea$var$lights_toon_pars_fragment,
    lights_phong_fragment: $e8ea6a63d48a4fea$var$lights_phong_fragment,
    lights_phong_pars_fragment: $e8ea6a63d48a4fea$var$lights_phong_pars_fragment,
    lights_physical_fragment: $e8ea6a63d48a4fea$var$lights_physical_fragment,
    lights_physical_pars_fragment: $e8ea6a63d48a4fea$var$lights_physical_pars_fragment,
    lights_fragment_begin: $e8ea6a63d48a4fea$var$lights_fragment_begin,
    lights_fragment_maps: $e8ea6a63d48a4fea$var$lights_fragment_maps,
    lights_fragment_end: $e8ea6a63d48a4fea$var$lights_fragment_end,
    logdepthbuf_fragment: $e8ea6a63d48a4fea$var$logdepthbuf_fragment,
    logdepthbuf_pars_fragment: $e8ea6a63d48a4fea$var$logdepthbuf_pars_fragment,
    logdepthbuf_pars_vertex: $e8ea6a63d48a4fea$var$logdepthbuf_pars_vertex,
    logdepthbuf_vertex: $e8ea6a63d48a4fea$var$logdepthbuf_vertex,
    map_fragment: $e8ea6a63d48a4fea$var$map_fragment,
    map_pars_fragment: $e8ea6a63d48a4fea$var$map_pars_fragment,
    map_particle_fragment: $e8ea6a63d48a4fea$var$map_particle_fragment,
    map_particle_pars_fragment: $e8ea6a63d48a4fea$var$map_particle_pars_fragment,
    metalnessmap_fragment: $e8ea6a63d48a4fea$var$metalnessmap_fragment,
    metalnessmap_pars_fragment: $e8ea6a63d48a4fea$var$metalnessmap_pars_fragment,
    morphcolor_vertex: $e8ea6a63d48a4fea$var$morphcolor_vertex,
    morphnormal_vertex: $e8ea6a63d48a4fea$var$morphnormal_vertex,
    morphtarget_pars_vertex: $e8ea6a63d48a4fea$var$morphtarget_pars_vertex,
    morphtarget_vertex: $e8ea6a63d48a4fea$var$morphtarget_vertex,
    normal_fragment_begin: $e8ea6a63d48a4fea$var$normal_fragment_begin,
    normal_fragment_maps: $e8ea6a63d48a4fea$var$normal_fragment_maps,
    normal_pars_fragment: $e8ea6a63d48a4fea$var$normal_pars_fragment,
    normal_pars_vertex: $e8ea6a63d48a4fea$var$normal_pars_vertex,
    normal_vertex: $e8ea6a63d48a4fea$var$normal_vertex,
    normalmap_pars_fragment: $e8ea6a63d48a4fea$var$normalmap_pars_fragment,
    clearcoat_normal_fragment_begin: $e8ea6a63d48a4fea$var$clearcoat_normal_fragment_begin,
    clearcoat_normal_fragment_maps: $e8ea6a63d48a4fea$var$clearcoat_normal_fragment_maps,
    clearcoat_pars_fragment: $e8ea6a63d48a4fea$var$clearcoat_pars_fragment,
    iridescence_pars_fragment: $e8ea6a63d48a4fea$var$iridescence_pars_fragment,
    output_fragment: $e8ea6a63d48a4fea$var$output_fragment,
    packing: $e8ea6a63d48a4fea$var$packing,
    premultiplied_alpha_fragment: $e8ea6a63d48a4fea$var$premultiplied_alpha_fragment,
    project_vertex: $e8ea6a63d48a4fea$var$project_vertex,
    dithering_fragment: $e8ea6a63d48a4fea$var$dithering_fragment,
    dithering_pars_fragment: $e8ea6a63d48a4fea$var$dithering_pars_fragment,
    roughnessmap_fragment: $e8ea6a63d48a4fea$var$roughnessmap_fragment,
    roughnessmap_pars_fragment: $e8ea6a63d48a4fea$var$roughnessmap_pars_fragment,
    shadowmap_pars_fragment: $e8ea6a63d48a4fea$var$shadowmap_pars_fragment,
    shadowmap_pars_vertex: $e8ea6a63d48a4fea$var$shadowmap_pars_vertex,
    shadowmap_vertex: $e8ea6a63d48a4fea$var$shadowmap_vertex,
    shadowmask_pars_fragment: $e8ea6a63d48a4fea$var$shadowmask_pars_fragment,
    skinbase_vertex: $e8ea6a63d48a4fea$var$skinbase_vertex,
    skinning_pars_vertex: $e8ea6a63d48a4fea$var$skinning_pars_vertex,
    skinning_vertex: $e8ea6a63d48a4fea$var$skinning_vertex,
    skinnormal_vertex: $e8ea6a63d48a4fea$var$skinnormal_vertex,
    specularmap_fragment: $e8ea6a63d48a4fea$var$specularmap_fragment,
    specularmap_pars_fragment: $e8ea6a63d48a4fea$var$specularmap_pars_fragment,
    tonemapping_fragment: $e8ea6a63d48a4fea$var$tonemapping_fragment,
    tonemapping_pars_fragment: $e8ea6a63d48a4fea$var$tonemapping_pars_fragment,
    transmission_fragment: $e8ea6a63d48a4fea$var$transmission_fragment,
    transmission_pars_fragment: $e8ea6a63d48a4fea$var$transmission_pars_fragment,
    uv_pars_fragment: $e8ea6a63d48a4fea$var$uv_pars_fragment,
    uv_pars_vertex: $e8ea6a63d48a4fea$var$uv_pars_vertex,
    uv_vertex: $e8ea6a63d48a4fea$var$uv_vertex,
    worldpos_vertex: $e8ea6a63d48a4fea$var$worldpos_vertex,
    background_vert: $e8ea6a63d48a4fea$var$vertex$h,
    background_frag: $e8ea6a63d48a4fea$var$fragment$h,
    backgroundCube_vert: $e8ea6a63d48a4fea$var$vertex$g,
    backgroundCube_frag: $e8ea6a63d48a4fea$var$fragment$g,
    cube_vert: $e8ea6a63d48a4fea$var$vertex$f,
    cube_frag: $e8ea6a63d48a4fea$var$fragment$f,
    depth_vert: $e8ea6a63d48a4fea$var$vertex$e,
    depth_frag: $e8ea6a63d48a4fea$var$fragment$e,
    distanceRGBA_vert: $e8ea6a63d48a4fea$var$vertex$d,
    distanceRGBA_frag: $e8ea6a63d48a4fea$var$fragment$d,
    equirect_vert: $e8ea6a63d48a4fea$var$vertex$c,
    equirect_frag: $e8ea6a63d48a4fea$var$fragment$c,
    linedashed_vert: $e8ea6a63d48a4fea$var$vertex$b,
    linedashed_frag: $e8ea6a63d48a4fea$var$fragment$b,
    meshbasic_vert: $e8ea6a63d48a4fea$var$vertex$a,
    meshbasic_frag: $e8ea6a63d48a4fea$var$fragment$a,
    meshlambert_vert: $e8ea6a63d48a4fea$var$vertex$9,
    meshlambert_frag: $e8ea6a63d48a4fea$var$fragment$9,
    meshmatcap_vert: $e8ea6a63d48a4fea$var$vertex$8,
    meshmatcap_frag: $e8ea6a63d48a4fea$var$fragment$8,
    meshnormal_vert: $e8ea6a63d48a4fea$var$vertex$7,
    meshnormal_frag: $e8ea6a63d48a4fea$var$fragment$7,
    meshphong_vert: $e8ea6a63d48a4fea$var$vertex$6,
    meshphong_frag: $e8ea6a63d48a4fea$var$fragment$6,
    meshphysical_vert: $e8ea6a63d48a4fea$var$vertex$5,
    meshphysical_frag: $e8ea6a63d48a4fea$var$fragment$5,
    meshtoon_vert: $e8ea6a63d48a4fea$var$vertex$4,
    meshtoon_frag: $e8ea6a63d48a4fea$var$fragment$4,
    points_vert: $e8ea6a63d48a4fea$var$vertex$3,
    points_frag: $e8ea6a63d48a4fea$var$fragment$3,
    shadow_vert: $e8ea6a63d48a4fea$var$vertex$2,
    shadow_frag: $e8ea6a63d48a4fea$var$fragment$2,
    sprite_vert: $e8ea6a63d48a4fea$var$vertex$1,
    sprite_frag: $e8ea6a63d48a4fea$var$fragment$1
};
/**
 * Uniforms library for shared webgl shaders
 */ const $e8ea6a63d48a4fea$export$6643083551874bf5 = {
    common: {
        diffuse: {
            value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$8ff26dafa08918()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$8ff26dafa08918()
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        },
        specularMapTransform: {
            value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$8ff26dafa08918()
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1.0
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: 0.98
        }
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        },
        aoMapTransform: {
            value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$8ff26dafa08918()
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        },
        lightMapTransform: {
            value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$8ff26dafa08918()
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpMapTransform: {
            value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$8ff26dafa08918()
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalMapTransform: {
            value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$8ff26dafa08918()
        },
        normalScale: {
            value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementMapTransform: {
            value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$8ff26dafa08918()
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        },
        emissiveMapTransform: {
            value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$8ff26dafa08918()
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        },
        metalnessMapTransform: {
            value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$8ff26dafa08918()
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        },
        roughnessMapTransform: {
            value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$8ff26dafa08918()
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 0.00025
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2000
        },
        fogColor: {
            value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$892596cec99bc70e(0xffffff)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotLightMap: {
            value: []
        },
        spotShadowMap: {
            value: []
        },
        spotLightMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        size: {
            value: 1.0
        },
        scale: {
            value: 1.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$8ff26dafa08918()
        }
    },
    sprite: {
        diffuse: {
            value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        center: {
            value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(0.5, 0.5)
        },
        rotation: {
            value: 0.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$8ff26dafa08918()
        },
        alphaMap: {
            value: null
        },
        alphaTest: {
            value: 0
        }
    }
};
const $e8ea6a63d48a4fea$export$bee4a7d47f8f5014 = {
    basic: {
        uniforms: /*@__PURE__*/ $e8ea6a63d48a4fea$var$mergeUniforms([
            $e8ea6a63d48a4fea$export$6643083551874bf5.common,
            $e8ea6a63d48a4fea$export$6643083551874bf5.specularmap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.envmap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.aomap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.lightmap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.fog
        ]),
        vertexShader: $e8ea6a63d48a4fea$export$955f9f2e84c43c8b.meshbasic_vert,
        fragmentShader: $e8ea6a63d48a4fea$export$955f9f2e84c43c8b.meshbasic_frag
    },
    lambert: {
        uniforms: /*@__PURE__*/ $e8ea6a63d48a4fea$var$mergeUniforms([
            $e8ea6a63d48a4fea$export$6643083551874bf5.common,
            $e8ea6a63d48a4fea$export$6643083551874bf5.specularmap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.envmap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.aomap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.lightmap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.emissivemap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.bumpmap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.normalmap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.displacementmap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.fog,
            $e8ea6a63d48a4fea$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $e8ea6a63d48a4fea$export$955f9f2e84c43c8b.meshlambert_vert,
        fragmentShader: $e8ea6a63d48a4fea$export$955f9f2e84c43c8b.meshlambert_frag
    },
    phong: {
        uniforms: /*@__PURE__*/ $e8ea6a63d48a4fea$var$mergeUniforms([
            $e8ea6a63d48a4fea$export$6643083551874bf5.common,
            $e8ea6a63d48a4fea$export$6643083551874bf5.specularmap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.envmap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.aomap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.lightmap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.emissivemap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.bumpmap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.normalmap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.displacementmap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.fog,
            $e8ea6a63d48a4fea$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$892596cec99bc70e(0x000000)
                },
                specular: {
                    value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$892596cec99bc70e(0x111111)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: $e8ea6a63d48a4fea$export$955f9f2e84c43c8b.meshphong_vert,
        fragmentShader: $e8ea6a63d48a4fea$export$955f9f2e84c43c8b.meshphong_frag
    },
    standard: {
        uniforms: /*@__PURE__*/ $e8ea6a63d48a4fea$var$mergeUniforms([
            $e8ea6a63d48a4fea$export$6643083551874bf5.common,
            $e8ea6a63d48a4fea$export$6643083551874bf5.envmap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.aomap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.lightmap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.emissivemap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.bumpmap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.normalmap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.displacementmap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.roughnessmap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.metalnessmap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.fog,
            $e8ea6a63d48a4fea$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$892596cec99bc70e(0x000000)
                },
                roughness: {
                    value: 1.0
                },
                metalness: {
                    value: 0.0
                },
                envMapIntensity: {
                    value: 1
                } // temporary
            }
        ]),
        vertexShader: $e8ea6a63d48a4fea$export$955f9f2e84c43c8b.meshphysical_vert,
        fragmentShader: $e8ea6a63d48a4fea$export$955f9f2e84c43c8b.meshphysical_frag
    },
    toon: {
        uniforms: /*@__PURE__*/ $e8ea6a63d48a4fea$var$mergeUniforms([
            $e8ea6a63d48a4fea$export$6643083551874bf5.common,
            $e8ea6a63d48a4fea$export$6643083551874bf5.aomap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.lightmap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.emissivemap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.bumpmap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.normalmap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.displacementmap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.gradientmap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.fog,
            $e8ea6a63d48a4fea$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $e8ea6a63d48a4fea$export$955f9f2e84c43c8b.meshtoon_vert,
        fragmentShader: $e8ea6a63d48a4fea$export$955f9f2e84c43c8b.meshtoon_frag
    },
    matcap: {
        uniforms: /*@__PURE__*/ $e8ea6a63d48a4fea$var$mergeUniforms([
            $e8ea6a63d48a4fea$export$6643083551874bf5.common,
            $e8ea6a63d48a4fea$export$6643083551874bf5.bumpmap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.normalmap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.displacementmap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: $e8ea6a63d48a4fea$export$955f9f2e84c43c8b.meshmatcap_vert,
        fragmentShader: $e8ea6a63d48a4fea$export$955f9f2e84c43c8b.meshmatcap_frag
    },
    points: {
        uniforms: /*@__PURE__*/ $e8ea6a63d48a4fea$var$mergeUniforms([
            $e8ea6a63d48a4fea$export$6643083551874bf5.points,
            $e8ea6a63d48a4fea$export$6643083551874bf5.fog
        ]),
        vertexShader: $e8ea6a63d48a4fea$export$955f9f2e84c43c8b.points_vert,
        fragmentShader: $e8ea6a63d48a4fea$export$955f9f2e84c43c8b.points_frag
    },
    dashed: {
        uniforms: /*@__PURE__*/ $e8ea6a63d48a4fea$var$mergeUniforms([
            $e8ea6a63d48a4fea$export$6643083551874bf5.common,
            $e8ea6a63d48a4fea$export$6643083551874bf5.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: $e8ea6a63d48a4fea$export$955f9f2e84c43c8b.linedashed_vert,
        fragmentShader: $e8ea6a63d48a4fea$export$955f9f2e84c43c8b.linedashed_frag
    },
    depth: {
        uniforms: /*@__PURE__*/ $e8ea6a63d48a4fea$var$mergeUniforms([
            $e8ea6a63d48a4fea$export$6643083551874bf5.common,
            $e8ea6a63d48a4fea$export$6643083551874bf5.displacementmap
        ]),
        vertexShader: $e8ea6a63d48a4fea$export$955f9f2e84c43c8b.depth_vert,
        fragmentShader: $e8ea6a63d48a4fea$export$955f9f2e84c43c8b.depth_frag
    },
    normal: {
        uniforms: /*@__PURE__*/ $e8ea6a63d48a4fea$var$mergeUniforms([
            $e8ea6a63d48a4fea$export$6643083551874bf5.common,
            $e8ea6a63d48a4fea$export$6643083551874bf5.bumpmap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.normalmap,
            $e8ea6a63d48a4fea$export$6643083551874bf5.displacementmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $e8ea6a63d48a4fea$export$955f9f2e84c43c8b.meshnormal_vert,
        fragmentShader: $e8ea6a63d48a4fea$export$955f9f2e84c43c8b.meshnormal_frag
    },
    sprite: {
        uniforms: /*@__PURE__*/ $e8ea6a63d48a4fea$var$mergeUniforms([
            $e8ea6a63d48a4fea$export$6643083551874bf5.sprite,
            $e8ea6a63d48a4fea$export$6643083551874bf5.fog
        ]),
        vertexShader: $e8ea6a63d48a4fea$export$955f9f2e84c43c8b.sprite_vert,
        fragmentShader: $e8ea6a63d48a4fea$export$955f9f2e84c43c8b.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$8ff26dafa08918()
            },
            t2D: {
                value: null
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: $e8ea6a63d48a4fea$export$955f9f2e84c43c8b.background_vert,
        fragmentShader: $e8ea6a63d48a4fea$export$955f9f2e84c43c8b.background_frag
    },
    backgroundCube: {
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            },
            backgroundBlurriness: {
                value: 0
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: $e8ea6a63d48a4fea$export$955f9f2e84c43c8b.backgroundCube_vert,
        fragmentShader: $e8ea6a63d48a4fea$export$955f9f2e84c43c8b.backgroundCube_frag
    },
    cube: {
        uniforms: {
            tCube: {
                value: null
            },
            tFlip: {
                value: -1
            },
            opacity: {
                value: 1.0
            }
        },
        vertexShader: $e8ea6a63d48a4fea$export$955f9f2e84c43c8b.cube_vert,
        fragmentShader: $e8ea6a63d48a4fea$export$955f9f2e84c43c8b.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: $e8ea6a63d48a4fea$export$955f9f2e84c43c8b.equirect_vert,
        fragmentShader: $e8ea6a63d48a4fea$export$955f9f2e84c43c8b.equirect_frag
    },
    distanceRGBA: {
        uniforms: /*@__PURE__*/ $e8ea6a63d48a4fea$var$mergeUniforms([
            $e8ea6a63d48a4fea$export$6643083551874bf5.common,
            $e8ea6a63d48a4fea$export$6643083551874bf5.displacementmap,
            {
                referencePosition: {
                    value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699()
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1000
                }
            }
        ]),
        vertexShader: $e8ea6a63d48a4fea$export$955f9f2e84c43c8b.distanceRGBA_vert,
        fragmentShader: $e8ea6a63d48a4fea$export$955f9f2e84c43c8b.distanceRGBA_frag
    },
    shadow: {
        uniforms: /*@__PURE__*/ $e8ea6a63d48a4fea$var$mergeUniforms([
            $e8ea6a63d48a4fea$export$6643083551874bf5.lights,
            $e8ea6a63d48a4fea$export$6643083551874bf5.fog,
            {
                color: {
                    value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$892596cec99bc70e(0x00000)
                },
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $e8ea6a63d48a4fea$export$955f9f2e84c43c8b.shadow_vert,
        fragmentShader: $e8ea6a63d48a4fea$export$955f9f2e84c43c8b.shadow_frag
    }
};
$e8ea6a63d48a4fea$export$bee4a7d47f8f5014.physical = {
    uniforms: /*@__PURE__*/ $e8ea6a63d48a4fea$var$mergeUniforms([
        $e8ea6a63d48a4fea$export$bee4a7d47f8f5014.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatMapTransform: {
                value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$8ff26dafa08918()
            },
            clearcoatNormalMap: {
                value: null
            },
            clearcoatNormalMapTransform: {
                value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$8ff26dafa08918()
            },
            clearcoatNormalScale: {
                value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(1, 1)
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatRoughnessMapTransform: {
                value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$8ff26dafa08918()
            },
            iridescence: {
                value: 0
            },
            iridescenceMap: {
                value: null
            },
            iridescenceMapTransform: {
                value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$8ff26dafa08918()
            },
            iridescenceIOR: {
                value: 1.3
            },
            iridescenceThicknessMinimum: {
                value: 100
            },
            iridescenceThicknessMaximum: {
                value: 400
            },
            iridescenceThicknessMap: {
                value: null
            },
            iridescenceThicknessMapTransform: {
                value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$8ff26dafa08918()
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$892596cec99bc70e(0x000000)
            },
            sheenColorMap: {
                value: null
            },
            sheenColorMapTransform: {
                value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$8ff26dafa08918()
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            sheenRoughnessMapTransform: {
                value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$8ff26dafa08918()
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionMapTransform: {
                value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$8ff26dafa08918()
            },
            transmissionSamplerSize: {
                value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$c977b3e384af9ae1()
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            thicknessMapTransform: {
                value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$8ff26dafa08918()
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$892596cec99bc70e(0x000000)
            },
            specularColor: {
                value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$892596cec99bc70e(1, 1, 1)
            },
            specularColorMap: {
                value: null
            },
            specularColorMapTransform: {
                value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$8ff26dafa08918()
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularIntensityMapTransform: {
                value: /*@__PURE__*/ new $e8ea6a63d48a4fea$export$8ff26dafa08918()
            }
        }
    ]),
    vertexShader: $e8ea6a63d48a4fea$export$955f9f2e84c43c8b.meshphysical_vert,
    fragmentShader: $e8ea6a63d48a4fea$export$955f9f2e84c43c8b.meshphysical_frag
};
const $e8ea6a63d48a4fea$var$_rgb = {
    r: 0,
    b: 0,
    g: 0
};
function $e8ea6a63d48a4fea$var$WebGLBackground(renderer, cubemaps, cubeuvmaps, state, objects, alpha, premultipliedAlpha) {
    const clearColor = new $e8ea6a63d48a4fea$export$892596cec99bc70e(0x000000);
    let clearAlpha = alpha === true ? 0 : 1;
    let planeMesh;
    let boxMesh;
    let currentBackground = null;
    let currentBackgroundVersion = 0;
    let currentTonemapping = null;
    function render(renderList, scene) {
        let forceClear = false;
        let background = scene.isScene === true ? scene.background : null;
        if (background && background.isTexture) {
            const usePMREM = scene.backgroundBlurriness > 0; // use PMREM if the user wants to blur the background
            background = (usePMREM ? cubeuvmaps : cubemaps).get(background);
        }
        // Ignore background in AR
        // TODO: Reconsider this.
        const xr = renderer.xr;
        const session = xr.getSession && xr.getSession();
        if (session && session.environmentBlendMode === "additive") background = null;
        if (background === null) setClear(clearColor, clearAlpha);
        else if (background && background.isColor) {
            setClear(background, 1);
            forceClear = true;
        }
        if (renderer.autoClear || forceClear) renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        if (background && (background.isCubeTexture || background.mapping === $e8ea6a63d48a4fea$export$dbf3e70ff37af79)) {
            if (boxMesh === undefined) {
                boxMesh = new $e8ea6a63d48a4fea$export$e176487c05830cc5(new $e8ea6a63d48a4fea$export$33e43285f7406bd5(1, 1, 1), new $e8ea6a63d48a4fea$export$83c7d75d550a8b0d({
                    name: "BackgroundCubeMaterial",
                    uniforms: $e8ea6a63d48a4fea$var$cloneUniforms($e8ea6a63d48a4fea$export$bee4a7d47f8f5014.backgroundCube.uniforms),
                    vertexShader: $e8ea6a63d48a4fea$export$bee4a7d47f8f5014.backgroundCube.vertexShader,
                    fragmentShader: $e8ea6a63d48a4fea$export$bee4a7d47f8f5014.backgroundCube.fragmentShader,
                    side: $e8ea6a63d48a4fea$export$d9f0486e75b5ace,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                boxMesh.geometry.deleteAttribute("normal");
                boxMesh.geometry.deleteAttribute("uv");
                boxMesh.onBeforeRender = function(renderer, scene, camera) {
                    this.matrixWorld.copyPosition(camera.matrixWorld);
                };
                // add "envMap" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(boxMesh.material, "envMap", {
                    get: function() {
                        return this.uniforms.envMap.value;
                    }
                });
                objects.update(boxMesh);
            }
            boxMesh.material.uniforms.envMap.value = background;
            boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background.isRenderTargetTexture === false ? -1 : 1;
            boxMesh.material.uniforms.backgroundBlurriness.value = scene.backgroundBlurriness;
            boxMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            boxMesh.material.toneMapped = background.encoding === $e8ea6a63d48a4fea$export$f32388edbb32674 ? false : true;
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                boxMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            boxMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
        } else if (background && background.isTexture) {
            if (planeMesh === undefined) {
                planeMesh = new $e8ea6a63d48a4fea$export$e176487c05830cc5(new $e8ea6a63d48a4fea$export$967d831af31f69ce(2, 2), new $e8ea6a63d48a4fea$export$83c7d75d550a8b0d({
                    name: "BackgroundMaterial",
                    uniforms: $e8ea6a63d48a4fea$var$cloneUniforms($e8ea6a63d48a4fea$export$bee4a7d47f8f5014.background.uniforms),
                    vertexShader: $e8ea6a63d48a4fea$export$bee4a7d47f8f5014.background.vertexShader,
                    fragmentShader: $e8ea6a63d48a4fea$export$bee4a7d47f8f5014.background.fragmentShader,
                    side: $e8ea6a63d48a4fea$export$2ede184fc2998901,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                planeMesh.geometry.deleteAttribute("normal");
                // add "map" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(planeMesh.material, "map", {
                    get: function() {
                        return this.uniforms.t2D.value;
                    }
                });
                objects.update(planeMesh);
            }
            planeMesh.material.uniforms.t2D.value = background;
            planeMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            planeMesh.material.toneMapped = background.encoding === $e8ea6a63d48a4fea$export$f32388edbb32674 ? false : true;
            if (background.matrixAutoUpdate === true) background.updateMatrix();
            planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                planeMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            planeMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
        }
    }
    function setClear(color, alpha) {
        color.getRGB($e8ea6a63d48a4fea$var$_rgb, $e8ea6a63d48a4fea$var$getUnlitUniformColorSpace(renderer));
        state.buffers.color.setClear($e8ea6a63d48a4fea$var$_rgb.r, $e8ea6a63d48a4fea$var$_rgb.g, $e8ea6a63d48a4fea$var$_rgb.b, alpha, premultipliedAlpha);
    }
    return {
        getClearColor: function() {
            return clearColor;
        },
        setClearColor: function(color, alpha = 1) {
            clearColor.set(color);
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        getClearAlpha: function() {
            return clearAlpha;
        },
        setClearAlpha: function(alpha) {
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        render: render
    };
}
function $e8ea6a63d48a4fea$var$WebGLBindingStates(gl, extensions, attributes, capabilities) {
    const maxVertexAttributes = gl.getParameter(34921);
    const extension = capabilities.isWebGL2 ? null : extensions.get("OES_vertex_array_object");
    const vaoAvailable = capabilities.isWebGL2 || extension !== null;
    const bindingStates = {};
    const defaultState = createBindingState(null);
    let currentState = defaultState;
    let forceUpdate = false;
    function setup(object, material, program, geometry, index) {
        let updateBuffers = false;
        if (vaoAvailable) {
            const state = getBindingState(geometry, program, material);
            if (currentState !== state) {
                currentState = state;
                bindVertexArrayObject(currentState.object);
            }
            updateBuffers = needsUpdate(object, geometry, program, index);
            if (updateBuffers) saveCache(object, geometry, program, index);
        } else {
            const wireframe = material.wireframe === true;
            if (currentState.geometry !== geometry.id || currentState.program !== program.id || currentState.wireframe !== wireframe) {
                currentState.geometry = geometry.id;
                currentState.program = program.id;
                currentState.wireframe = wireframe;
                updateBuffers = true;
            }
        }
        if (index !== null) attributes.update(index, 34963);
        if (updateBuffers || forceUpdate) {
            forceUpdate = false;
            setupVertexAttributes(object, material, program, geometry);
            if (index !== null) gl.bindBuffer(34963, attributes.get(index).buffer);
        }
    }
    function createVertexArrayObject() {
        if (capabilities.isWebGL2) return gl.createVertexArray();
        return extension.createVertexArrayOES();
    }
    function bindVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.bindVertexArray(vao);
        return extension.bindVertexArrayOES(vao);
    }
    function deleteVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.deleteVertexArray(vao);
        return extension.deleteVertexArrayOES(vao);
    }
    function getBindingState(geometry, program, material) {
        const wireframe = material.wireframe === true;
        let programMap = bindingStates[geometry.id];
        if (programMap === undefined) {
            programMap = {};
            bindingStates[geometry.id] = programMap;
        }
        let stateMap = programMap[program.id];
        if (stateMap === undefined) {
            stateMap = {};
            programMap[program.id] = stateMap;
        }
        let state = stateMap[wireframe];
        if (state === undefined) {
            state = createBindingState(createVertexArrayObject());
            stateMap[wireframe] = state;
        }
        return state;
    }
    function createBindingState(vao) {
        const newAttributes = [];
        const enabledAttributes = [];
        const attributeDivisors = [];
        for(let i = 0; i < maxVertexAttributes; i++){
            newAttributes[i] = 0;
            enabledAttributes[i] = 0;
            attributeDivisors[i] = 0;
        }
        return {
            // for backward compatibility on non-VAO support browser
            geometry: null,
            program: null,
            wireframe: false,
            newAttributes: newAttributes,
            enabledAttributes: enabledAttributes,
            attributeDivisors: attributeDivisors,
            object: vao,
            attributes: {},
            index: null
        };
    }
    function needsUpdate(object, geometry, program, index) {
        const cachedAttributes = currentState.attributes;
        const geometryAttributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                const cachedAttribute = cachedAttributes[name];
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === "instanceMatrix" && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === "instanceColor" && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (cachedAttribute === undefined) return true;
                if (cachedAttribute.attribute !== geometryAttribute) return true;
                if (geometryAttribute && cachedAttribute.data !== geometryAttribute.data) return true;
                attributesNum++;
            }
        }
        if (currentState.attributesNum !== attributesNum) return true;
        if (currentState.index !== index) return true;
        return false;
    }
    function saveCache(object, geometry, program, index) {
        const cache = {};
        const attributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let attribute = attributes[name];
                if (attribute === undefined) {
                    if (name === "instanceMatrix" && object.instanceMatrix) attribute = object.instanceMatrix;
                    if (name === "instanceColor" && object.instanceColor) attribute = object.instanceColor;
                }
                const data = {};
                data.attribute = attribute;
                if (attribute && attribute.data) data.data = attribute.data;
                cache[name] = data;
                attributesNum++;
            }
        }
        currentState.attributes = cache;
        currentState.attributesNum = attributesNum;
        currentState.index = index;
    }
    function initAttributes() {
        const newAttributes = currentState.newAttributes;
        for(let i = 0, il = newAttributes.length; i < il; i++)newAttributes[i] = 0;
    }
    function enableAttribute(attribute) {
        enableAttributeAndDivisor(attribute, 0);
    }
    function enableAttributeAndDivisor(attribute, meshPerAttribute) {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        const attributeDivisors = currentState.attributeDivisors;
        newAttributes[attribute] = 1;
        if (enabledAttributes[attribute] === 0) {
            gl.enableVertexAttribArray(attribute);
            enabledAttributes[attribute] = 1;
        }
        if (attributeDivisors[attribute] !== meshPerAttribute) {
            const extension = capabilities.isWebGL2 ? gl : extensions.get("ANGLE_instanced_arrays");
            extension[capabilities.isWebGL2 ? "vertexAttribDivisor" : "vertexAttribDivisorANGLE"](attribute, meshPerAttribute);
            attributeDivisors[attribute] = meshPerAttribute;
        }
    }
    function disableUnusedAttributes() {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        for(let i = 0, il = enabledAttributes.length; i < il; i++)if (enabledAttributes[i] !== newAttributes[i]) {
            gl.disableVertexAttribArray(i);
            enabledAttributes[i] = 0;
        }
    }
    function vertexAttribPointer(index, size, type, normalized, stride, offset) {
        if (capabilities.isWebGL2 === true && (type === 5124 || type === 5125)) gl.vertexAttribIPointer(index, size, type, stride, offset);
        else gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
    function setupVertexAttributes(object, material, program, geometry) {
        if (capabilities.isWebGL2 === false && (object.isInstancedMesh || geometry.isInstancedBufferGeometry)) {
            if (extensions.get("ANGLE_instanced_arrays") === null) return;
        }
        initAttributes();
        const geometryAttributes = geometry.attributes;
        const programAttributes = program.getAttributes();
        const materialDefaultAttributeValues = material.defaultAttributeValues;
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === "instanceMatrix" && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === "instanceColor" && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (geometryAttribute !== undefined) {
                    const normalized = geometryAttribute.normalized;
                    const size = geometryAttribute.itemSize;
                    const attribute = attributes.get(geometryAttribute);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    const bytesPerElement = attribute.bytesPerElement;
                    if (geometryAttribute.isInterleavedBufferAttribute) {
                        const data = geometryAttribute.data;
                        const stride = data.stride;
                        const offset = geometryAttribute.offset;
                        if (data.isInstancedInterleavedBuffer) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, data.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = data.meshPerAttribute * data.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(34962, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, stride * bytesPerElement, (offset + size / programAttribute.locationSize * i) * bytesPerElement);
                    } else {
                        if (geometryAttribute.isInstancedBufferAttribute) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, geometryAttribute.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(34962, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, size * bytesPerElement, size / programAttribute.locationSize * i * bytesPerElement);
                    }
                } else if (materialDefaultAttributeValues !== undefined) {
                    const value = materialDefaultAttributeValues[name];
                    if (value !== undefined) switch(value.length){
                        case 2:
                            gl.vertexAttrib2fv(programAttribute.location, value);
                            break;
                        case 3:
                            gl.vertexAttrib3fv(programAttribute.location, value);
                            break;
                        case 4:
                            gl.vertexAttrib4fv(programAttribute.location, value);
                            break;
                        default:
                            gl.vertexAttrib1fv(programAttribute.location, value);
                    }
                }
            }
        }
        disableUnusedAttributes();
    }
    function dispose() {
        reset();
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            for(const programId in programMap){
                const stateMap = programMap[programId];
                for(const wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[programId];
            }
            delete bindingStates[geometryId];
        }
    }
    function releaseStatesOfGeometry(geometry) {
        if (bindingStates[geometry.id] === undefined) return;
        const programMap = bindingStates[geometry.id];
        for(const programId in programMap){
            const stateMap = programMap[programId];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[programId];
        }
        delete bindingStates[geometry.id];
    }
    function releaseStatesOfProgram(program) {
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            if (programMap[program.id] === undefined) continue;
            const stateMap = programMap[program.id];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[program.id];
        }
    }
    function reset() {
        resetDefaultState();
        forceUpdate = true;
        if (currentState === defaultState) return;
        currentState = defaultState;
        bindVertexArrayObject(currentState.object);
    }
    // for backward-compatibility
    function resetDefaultState() {
        defaultState.geometry = null;
        defaultState.program = null;
        defaultState.wireframe = false;
    }
    return {
        setup: setup,
        reset: reset,
        resetDefaultState: resetDefaultState,
        dispose: dispose,
        releaseStatesOfGeometry: releaseStatesOfGeometry,
        releaseStatesOfProgram: releaseStatesOfProgram,
        initAttributes: initAttributes,
        enableAttribute: enableAttribute,
        disableUnusedAttributes: disableUnusedAttributes
    };
}
function $e8ea6a63d48a4fea$var$WebGLBufferRenderer(gl, extensions, info, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    let mode;
    function setMode(value) {
        mode = value;
    }
    function render(start, count) {
        gl.drawArrays(mode, start, count);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        let extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = "drawArraysInstanced";
        } else {
            extension = extensions.get("ANGLE_instanced_arrays");
            methodName = "drawArraysInstancedANGLE";
            if (extension === null) {
                console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
                return;
            }
        }
        extension[methodName](mode, start, count, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.render = render;
    this.renderInstances = renderInstances;
}
function $e8ea6a63d48a4fea$var$WebGLCapabilities(gl, extensions, parameters) {
    let maxAnisotropy;
    function getMaxAnisotropy() {
        if (maxAnisotropy !== undefined) return maxAnisotropy;
        if (extensions.has("EXT_texture_filter_anisotropic") === true) {
            const extension = extensions.get("EXT_texture_filter_anisotropic");
            maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else maxAnisotropy = 0;
        return maxAnisotropy;
    }
    function getMaxPrecision(precision) {
        if (precision === "highp") {
            if (gl.getShaderPrecisionFormat(35633, 36338).precision > 0 && gl.getShaderPrecisionFormat(35632, 36338).precision > 0) return "highp";
            precision = "mediump";
        }
        if (precision === "mediump") {
            if (gl.getShaderPrecisionFormat(35633, 36337).precision > 0 && gl.getShaderPrecisionFormat(35632, 36337).precision > 0) return "mediump";
        }
        return "lowp";
    }
    const isWebGL2 = typeof WebGL2RenderingContext !== "undefined" && gl.constructor.name === "WebGL2RenderingContext";
    let precision = parameters.precision !== undefined ? parameters.precision : "highp";
    const maxPrecision = getMaxPrecision(precision);
    if (maxPrecision !== precision) {
        console.warn("THREE.WebGLRenderer:", precision, "not supported, using", maxPrecision, "instead.");
        precision = maxPrecision;
    }
    const drawBuffers = isWebGL2 || extensions.has("WEBGL_draw_buffers");
    const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
    const maxTextures = gl.getParameter(34930);
    const maxVertexTextures = gl.getParameter(35660);
    const maxTextureSize = gl.getParameter(3379);
    const maxCubemapSize = gl.getParameter(34076);
    const maxAttributes = gl.getParameter(34921);
    const maxVertexUniforms = gl.getParameter(36347);
    const maxVaryings = gl.getParameter(36348);
    const maxFragmentUniforms = gl.getParameter(36349);
    const vertexTextures = maxVertexTextures > 0;
    const floatFragmentTextures = isWebGL2 || extensions.has("OES_texture_float");
    const floatVertexTextures = vertexTextures && floatFragmentTextures;
    const maxSamples = isWebGL2 ? gl.getParameter(36183) : 0;
    return {
        isWebGL2: isWebGL2,
        drawBuffers: drawBuffers,
        getMaxAnisotropy: getMaxAnisotropy,
        getMaxPrecision: getMaxPrecision,
        precision: precision,
        logarithmicDepthBuffer: logarithmicDepthBuffer,
        maxTextures: maxTextures,
        maxVertexTextures: maxVertexTextures,
        maxTextureSize: maxTextureSize,
        maxCubemapSize: maxCubemapSize,
        maxAttributes: maxAttributes,
        maxVertexUniforms: maxVertexUniforms,
        maxVaryings: maxVaryings,
        maxFragmentUniforms: maxFragmentUniforms,
        vertexTextures: vertexTextures,
        floatFragmentTextures: floatFragmentTextures,
        floatVertexTextures: floatVertexTextures,
        maxSamples: maxSamples
    };
}
function $e8ea6a63d48a4fea$var$WebGLClipping(properties) {
    const scope = this;
    let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
    const plane = new $e8ea6a63d48a4fea$export$7ff5ac152ef991b0(), viewNormalMatrix = new $e8ea6a63d48a4fea$export$8ff26dafa08918(), uniform = {
        value: null,
        needsUpdate: false
    };
    this.uniform = uniform;
    this.numPlanes = 0;
    this.numIntersection = 0;
    this.init = function(planes, enableLocalClipping) {
        const enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
        // run another frame in order to reset the state:
        numGlobalPlanes !== 0 || localClippingEnabled;
        localClippingEnabled = enableLocalClipping;
        numGlobalPlanes = planes.length;
        return enabled;
    };
    this.beginShadows = function() {
        renderingShadows = true;
        projectPlanes(null);
    };
    this.endShadows = function() {
        renderingShadows = false;
    };
    this.setGlobalState = function(planes, camera) {
        globalState = projectPlanes(planes, camera, 0);
    };
    this.setState = function(material, camera, useCache) {
        const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
        const materialProperties = properties.get(material);
        if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
            // there's no local clipping
            if (renderingShadows) // there's no global clipping
            projectPlanes(null);
            else resetGlobalState();
        } else {
            const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
            let dstArray = materialProperties.clippingState || null;
            uniform.value = dstArray; // ensure unique state
            dstArray = projectPlanes(planes, camera, lGlobal, useCache);
            for(let i = 0; i !== lGlobal; ++i)dstArray[i] = globalState[i];
            materialProperties.clippingState = dstArray;
            this.numIntersection = clipIntersection ? this.numPlanes : 0;
            this.numPlanes += nGlobal;
        }
    };
    function resetGlobalState() {
        if (uniform.value !== globalState) {
            uniform.value = globalState;
            uniform.needsUpdate = numGlobalPlanes > 0;
        }
        scope.numPlanes = numGlobalPlanes;
        scope.numIntersection = 0;
    }
    function projectPlanes(planes, camera, dstOffset, skipTransform) {
        const nPlanes = planes !== null ? planes.length : 0;
        let dstArray = null;
        if (nPlanes !== 0) {
            dstArray = uniform.value;
            if (skipTransform !== true || dstArray === null) {
                const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
                viewNormalMatrix.getNormalMatrix(viewMatrix);
                if (dstArray === null || dstArray.length < flatSize) dstArray = new Float32Array(flatSize);
                for(let i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4){
                    plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);
                    plane.normal.toArray(dstArray, i4);
                    dstArray[i4 + 3] = plane.constant;
                }
            }
            uniform.value = dstArray;
            uniform.needsUpdate = true;
        }
        scope.numPlanes = nPlanes;
        scope.numIntersection = 0;
        return dstArray;
    }
}
function $e8ea6a63d48a4fea$var$WebGLCubeMaps(renderer) {
    let cubemaps = new WeakMap();
    function mapTextureMapping(texture, mapping) {
        if (mapping === $e8ea6a63d48a4fea$export$d64030b316d3b087) texture.mapping = $e8ea6a63d48a4fea$export$8759762a6477f2c4;
        else if (mapping === $e8ea6a63d48a4fea$export$ee99d97d46898098) texture.mapping = $e8ea6a63d48a4fea$export$dc59f8aed047f61d;
        return texture;
    }
    function get(texture) {
        if (texture && texture.isTexture && texture.isRenderTargetTexture === false) {
            const mapping = texture.mapping;
            if (mapping === $e8ea6a63d48a4fea$export$d64030b316d3b087 || mapping === $e8ea6a63d48a4fea$export$ee99d97d46898098) {
                if (cubemaps.has(texture)) {
                    const cubemap = cubemaps.get(texture).texture;
                    return mapTextureMapping(cubemap, texture.mapping);
                } else {
                    const image = texture.image;
                    if (image && image.height > 0) {
                        const renderTarget = new $e8ea6a63d48a4fea$export$ac386671d651941e(image.height / 2);
                        renderTarget.fromEquirectangularTexture(renderer, texture);
                        cubemaps.set(texture, renderTarget);
                        texture.addEventListener("dispose", onTextureDispose);
                        return mapTextureMapping(renderTarget.texture, texture.mapping);
                    } else // image not yet ready. try the conversion next frame
                    return null;
                }
            }
        }
        return texture;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener("dispose", onTextureDispose);
        const cubemap = cubemaps.get(texture);
        if (cubemap !== undefined) {
            cubemaps.delete(texture);
            cubemap.dispose();
        }
    }
    function dispose() {
        cubemaps = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
class $e8ea6a63d48a4fea$export$9ebf355ee4ed261b extends $e8ea6a63d48a4fea$export$79f141de891a5fed {
    constructor(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2000){
        super();
        this.isOrthographicCamera = true;
        this.type = "OrthographicCamera";
        this.zoom = 1;
        this.view = null;
        this.left = left;
        this.right = right;
        this.top = top;
        this.bottom = bottom;
        this.near = near;
        this.far = far;
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.left = source.left;
        this.right = source.right;
        this.top = source.top;
        this.bottom = source.bottom;
        this.near = source.near;
        this.far = source.far;
        this.zoom = source.zoom;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        return this;
    }
    setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const dx = (this.right - this.left) / (2 * this.zoom);
        const dy = (this.top - this.bottom) / (2 * this.zoom);
        const cx = (this.right + this.left) / 2;
        const cy = (this.top + this.bottom) / 2;
        let left = cx - dx;
        let right = cx + dx;
        let top = cy + dy;
        let bottom = cy - dy;
        if (this.view !== null && this.view.enabled) {
            const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
            const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            left += scaleW * this.view.offsetX;
            right = left + scaleW * this.view.width;
            top -= scaleH * this.view.offsetY;
            bottom = top - scaleH * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.zoom = this.zoom;
        data.object.left = this.left;
        data.object.right = this.right;
        data.object.top = this.top;
        data.object.bottom = this.bottom;
        data.object.near = this.near;
        data.object.far = this.far;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        return data;
    }
}
const $e8ea6a63d48a4fea$var$LOD_MIN = 4;
// The standard deviations (radians) associated with the extra mips. These are
// chosen to approximate a Trowbridge-Reitz distribution function times the
// geometric shadowing function. These sigma values squared must match the
// variance #defines in cube_uv_reflection_fragment.glsl.js.
const $e8ea6a63d48a4fea$var$EXTRA_LOD_SIGMA = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
];
// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
const $e8ea6a63d48a4fea$var$MAX_SAMPLES = 20;
const $e8ea6a63d48a4fea$var$_flatCamera = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$9ebf355ee4ed261b();
const $e8ea6a63d48a4fea$var$_clearColor = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$892596cec99bc70e();
let $e8ea6a63d48a4fea$var$_oldTarget = null;
// Golden Ratio
const $e8ea6a63d48a4fea$var$PHI = (1 + Math.sqrt(5)) / 2;
const $e8ea6a63d48a4fea$var$INV_PHI = 1 / $e8ea6a63d48a4fea$var$PHI;
// Vertices of a dodecahedron (except the opposites, which represent the
// same axis), used as axis directions evenly spread on a sphere.
const $e8ea6a63d48a4fea$var$_axisDirections = [
    /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699(1, 1, 1),
    /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699(-1, 1, 1),
    /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699(1, 1, -1),
    /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699(-1, 1, -1),
    /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699(0, $e8ea6a63d48a4fea$var$PHI, $e8ea6a63d48a4fea$var$INV_PHI),
    /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699(0, $e8ea6a63d48a4fea$var$PHI, -$e8ea6a63d48a4fea$var$INV_PHI),
    /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699($e8ea6a63d48a4fea$var$INV_PHI, 0, $e8ea6a63d48a4fea$var$PHI),
    /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699(-$e8ea6a63d48a4fea$var$INV_PHI, 0, $e8ea6a63d48a4fea$var$PHI),
    /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699($e8ea6a63d48a4fea$var$PHI, $e8ea6a63d48a4fea$var$INV_PHI, 0),
    /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699(-$e8ea6a63d48a4fea$var$PHI, $e8ea6a63d48a4fea$var$INV_PHI, 0)
];
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * Paper: Fast, Accurate Image-Based Lighting
 * https://drive.google.com/file/d/15y8r_UpKlU9SvV4ILb0C3qCPecS8pvLz/view
*/ class $e8ea6a63d48a4fea$export$6add42717753e221 {
    constructor(renderer){
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._lodMax = 0;
        this._cubeSize = 0;
        this._lodPlanes = [];
        this._sizeLods = [];
        this._sigmas = [];
        this._blurMaterial = null;
        this._cubemapMaterial = null;
        this._equirectMaterial = null;
        this._compileMaterial(this._blurMaterial);
    }
    /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety (the cubeCamera
	 * is placed at the origin).
	 */ fromScene(scene, sigma = 0, near = 0.1, far = 100) {
        $e8ea6a63d48a4fea$var$_oldTarget = this._renderer.getRenderTarget();
        this._setSize(256);
        const cubeUVRenderTarget = this._allocateTargets();
        cubeUVRenderTarget.depthBuffer = true;
        this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget);
        if (sigma > 0) this._blur(cubeUVRenderTarget, 0, 0, sigma);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * or HDR. The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromEquirectangular(equirectangular, renderTarget = null) {
        return this._fromTexture(equirectangular, renderTarget);
    }
    /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * or HDR. The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromCubemap(cubemap, renderTarget = null) {
        return this._fromTexture(cubemap, renderTarget);
    }
    /**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileCubemapShader() {
        if (this._cubemapMaterial === null) {
            this._cubemapMaterial = $e8ea6a63d48a4fea$var$_getCubemapMaterial();
            this._compileMaterial(this._cubemapMaterial);
        }
    }
    /**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileEquirectangularShader() {
        if (this._equirectMaterial === null) {
            this._equirectMaterial = $e8ea6a63d48a4fea$var$_getEquirectMaterial();
            this._compileMaterial(this._equirectMaterial);
        }
    }
    /**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */ dispose() {
        this._dispose();
        if (this._cubemapMaterial !== null) this._cubemapMaterial.dispose();
        if (this._equirectMaterial !== null) this._equirectMaterial.dispose();
    }
    // private interface
    _setSize(cubeSize) {
        this._lodMax = Math.floor(Math.log2(cubeSize));
        this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        if (this._blurMaterial !== null) this._blurMaterial.dispose();
        if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();
        for(let i = 0; i < this._lodPlanes.length; i++)this._lodPlanes[i].dispose();
    }
    _cleanup(outputTarget) {
        this._renderer.setRenderTarget($e8ea6a63d48a4fea$var$_oldTarget);
        outputTarget.scissorTest = false;
        $e8ea6a63d48a4fea$var$_setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
    }
    _fromTexture(texture, renderTarget) {
        if (texture.mapping === $e8ea6a63d48a4fea$export$8759762a6477f2c4 || texture.mapping === $e8ea6a63d48a4fea$export$dc59f8aed047f61d) this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
        else this._setSize(texture.image.width / 4);
        $e8ea6a63d48a4fea$var$_oldTarget = this._renderer.getRenderTarget();
        const cubeUVRenderTarget = renderTarget || this._allocateTargets();
        this._textureToCubeUV(texture, cubeUVRenderTarget);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    _allocateTargets() {
        const width = 3 * Math.max(this._cubeSize, 112);
        const height = 4 * this._cubeSize;
        const params = {
            magFilter: $e8ea6a63d48a4fea$export$8a72f490b25c56c8,
            minFilter: $e8ea6a63d48a4fea$export$8a72f490b25c56c8,
            generateMipmaps: false,
            type: $e8ea6a63d48a4fea$export$2697304443f382bc,
            format: $e8ea6a63d48a4fea$export$3f8bb04b555a363c,
            encoding: $e8ea6a63d48a4fea$export$7207336e4151a112,
            depthBuffer: false
        };
        const cubeUVRenderTarget = $e8ea6a63d48a4fea$var$_createRenderTarget(width, height, params);
        if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width || this._pingPongRenderTarget.height !== height) {
            if (this._pingPongRenderTarget !== null) this._dispose();
            this._pingPongRenderTarget = $e8ea6a63d48a4fea$var$_createRenderTarget(width, height, params);
            const { _lodMax: _lodMax  } = this;
            ({ sizeLods: this._sizeLods , lodPlanes: this._lodPlanes , sigmas: this._sigmas  } = $e8ea6a63d48a4fea$var$_createPlanes(_lodMax));
            this._blurMaterial = $e8ea6a63d48a4fea$var$_getBlurShader(_lodMax, width, height);
        }
        return cubeUVRenderTarget;
    }
    _compileMaterial(material) {
        const tmpMesh = new $e8ea6a63d48a4fea$export$e176487c05830cc5(this._lodPlanes[0], material);
        this._renderer.compile(tmpMesh, $e8ea6a63d48a4fea$var$_flatCamera);
    }
    _sceneToCubeUV(scene, near, far, cubeUVRenderTarget) {
        const fov = 90;
        const aspect = 1;
        const cubeCamera = new $e8ea6a63d48a4fea$export$74e4ae24825f68d7(fov, aspect, near, far);
        const upSign = [
            1,
            -1,
            1,
            1,
            1,
            1
        ];
        const forwardSign = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ];
        const renderer = this._renderer;
        const originalAutoClear = renderer.autoClear;
        const toneMapping = renderer.toneMapping;
        renderer.getClearColor($e8ea6a63d48a4fea$var$_clearColor);
        renderer.toneMapping = $e8ea6a63d48a4fea$export$9fcb6b4294603b2;
        renderer.autoClear = false;
        const backgroundMaterial = new $e8ea6a63d48a4fea$export$55cbcc9b622fe1f5({
            name: "PMREM.Background",
            side: $e8ea6a63d48a4fea$export$d9f0486e75b5ace,
            depthWrite: false,
            depthTest: false
        });
        const backgroundBox = new $e8ea6a63d48a4fea$export$e176487c05830cc5(new $e8ea6a63d48a4fea$export$33e43285f7406bd5(), backgroundMaterial);
        let useSolidColor = false;
        const background = scene.background;
        if (background) {
            if (background.isColor) {
                backgroundMaterial.color.copy(background);
                scene.background = null;
                useSolidColor = true;
            }
        } else {
            backgroundMaterial.color.copy($e8ea6a63d48a4fea$var$_clearColor);
            useSolidColor = true;
        }
        for(let i = 0; i < 6; i++){
            const col = i % 3;
            if (col === 0) {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(forwardSign[i], 0, 0);
            } else if (col === 1) {
                cubeCamera.up.set(0, 0, upSign[i]);
                cubeCamera.lookAt(0, forwardSign[i], 0);
            } else {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(0, 0, forwardSign[i]);
            }
            const size = this._cubeSize;
            $e8ea6a63d48a4fea$var$_setViewport(cubeUVRenderTarget, col * size, i > 2 ? size : 0, size, size);
            renderer.setRenderTarget(cubeUVRenderTarget);
            if (useSolidColor) renderer.render(backgroundBox, cubeCamera);
            renderer.render(scene, cubeCamera);
        }
        backgroundBox.geometry.dispose();
        backgroundBox.material.dispose();
        renderer.toneMapping = toneMapping;
        renderer.autoClear = originalAutoClear;
        scene.background = background;
    }
    _textureToCubeUV(texture, cubeUVRenderTarget) {
        const renderer = this._renderer;
        const isCubeTexture = texture.mapping === $e8ea6a63d48a4fea$export$8759762a6477f2c4 || texture.mapping === $e8ea6a63d48a4fea$export$dc59f8aed047f61d;
        if (isCubeTexture) {
            if (this._cubemapMaterial === null) this._cubemapMaterial = $e8ea6a63d48a4fea$var$_getCubemapMaterial();
            this._cubemapMaterial.uniforms.flipEnvMap.value = texture.isRenderTargetTexture === false ? -1 : 1;
        } else if (this._equirectMaterial === null) this._equirectMaterial = $e8ea6a63d48a4fea$var$_getEquirectMaterial();
        const material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
        const mesh = new $e8ea6a63d48a4fea$export$e176487c05830cc5(this._lodPlanes[0], material);
        const uniforms = material.uniforms;
        uniforms["envMap"].value = texture;
        const size = this._cubeSize;
        $e8ea6a63d48a4fea$var$_setViewport(cubeUVRenderTarget, 0, 0, 3 * size, 2 * size);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(mesh, $e8ea6a63d48a4fea$var$_flatCamera);
    }
    _applyPMREM(cubeUVRenderTarget) {
        const renderer = this._renderer;
        const autoClear = renderer.autoClear;
        renderer.autoClear = false;
        for(let i = 1; i < this._lodPlanes.length; i++){
            const sigma = Math.sqrt(this._sigmas[i] * this._sigmas[i] - this._sigmas[i - 1] * this._sigmas[i - 1]);
            const poleAxis = $e8ea6a63d48a4fea$var$_axisDirections[(i - 1) % $e8ea6a63d48a4fea$var$_axisDirections.length];
            this._blur(cubeUVRenderTarget, i - 1, i, sigma, poleAxis);
        }
        renderer.autoClear = autoClear;
    }
    /**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 */ _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
        const pingPongRenderTarget = this._pingPongRenderTarget;
        this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, "latitudinal", poleAxis);
        this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, "longitudinal", poleAxis);
    }
    _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
        const renderer = this._renderer;
        const blurMaterial = this._blurMaterial;
        if (direction !== "latitudinal" && direction !== "longitudinal") console.error("blur direction must be either latitudinal or longitudinal!");
        // Number of standard deviations at which to cut off the discrete approximation.
        const STANDARD_DEVIATIONS = 3;
        const blurMesh = new $e8ea6a63d48a4fea$export$e176487c05830cc5(this._lodPlanes[lodOut], blurMaterial);
        const blurUniforms = blurMaterial.uniforms;
        const pixels = this._sizeLods[lodIn] - 1;
        const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * $e8ea6a63d48a4fea$var$MAX_SAMPLES - 1);
        const sigmaPixels = sigmaRadians / radiansPerPixel;
        const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : $e8ea6a63d48a4fea$var$MAX_SAMPLES;
        if (samples > $e8ea6a63d48a4fea$var$MAX_SAMPLES) console.warn(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${$e8ea6a63d48a4fea$var$MAX_SAMPLES}`);
        const weights = [];
        let sum = 0;
        for(let i = 0; i < $e8ea6a63d48a4fea$var$MAX_SAMPLES; ++i){
            const x = i / sigmaPixels;
            const weight = Math.exp(-x * x / 2);
            weights.push(weight);
            if (i === 0) sum += weight;
            else if (i < samples) sum += 2 * weight;
        }
        for(let i = 0; i < weights.length; i++)weights[i] = weights[i] / sum;
        blurUniforms["envMap"].value = targetIn.texture;
        blurUniforms["samples"].value = samples;
        blurUniforms["weights"].value = weights;
        blurUniforms["latitudinal"].value = direction === "latitudinal";
        if (poleAxis) blurUniforms["poleAxis"].value = poleAxis;
        const { _lodMax: _lodMax  } = this;
        blurUniforms["dTheta"].value = radiansPerPixel;
        blurUniforms["mipInt"].value = _lodMax - lodIn;
        const outputSize = this._sizeLods[lodOut];
        const x = 3 * outputSize * (lodOut > _lodMax - $e8ea6a63d48a4fea$var$LOD_MIN ? lodOut - _lodMax + $e8ea6a63d48a4fea$var$LOD_MIN : 0);
        const y = 4 * (this._cubeSize - outputSize);
        $e8ea6a63d48a4fea$var$_setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(targetOut);
        renderer.render(blurMesh, $e8ea6a63d48a4fea$var$_flatCamera);
    }
}
function $e8ea6a63d48a4fea$var$_createPlanes(lodMax) {
    const lodPlanes = [];
    const sizeLods = [];
    const sigmas = [];
    let lod = lodMax;
    const totalLods = lodMax - $e8ea6a63d48a4fea$var$LOD_MIN + 1 + $e8ea6a63d48a4fea$var$EXTRA_LOD_SIGMA.length;
    for(let i = 0; i < totalLods; i++){
        const sizeLod = Math.pow(2, lod);
        sizeLods.push(sizeLod);
        let sigma = 1.0 / sizeLod;
        if (i > lodMax - $e8ea6a63d48a4fea$var$LOD_MIN) sigma = $e8ea6a63d48a4fea$var$EXTRA_LOD_SIGMA[i - lodMax + $e8ea6a63d48a4fea$var$LOD_MIN - 1];
        else if (i === 0) sigma = 0;
        sigmas.push(sigma);
        const texelSize = 1.0 / (sizeLod - 2);
        const min = -texelSize;
        const max = 1 + texelSize;
        const uv1 = [
            min,
            min,
            max,
            min,
            max,
            max,
            min,
            min,
            max,
            max,
            min,
            max
        ];
        const cubeFaces = 6;
        const vertices = 6;
        const positionSize = 3;
        const uvSize = 2;
        const faceIndexSize = 1;
        const position = new Float32Array(positionSize * vertices * cubeFaces);
        const uv = new Float32Array(uvSize * vertices * cubeFaces);
        const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
        for(let face = 0; face < cubeFaces; face++){
            const x = face % 3 * 2 / 3 - 1;
            const y = face > 2 ? 0 : -1;
            const coordinates = [
                x,
                y,
                0,
                x + 2 / 3,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y + 1,
                0
            ];
            position.set(coordinates, positionSize * vertices * face);
            uv.set(uv1, uvSize * vertices * face);
            const fill = [
                face,
                face,
                face,
                face,
                face,
                face
            ];
            faceIndex.set(fill, faceIndexSize * vertices * face);
        }
        const planes = new $e8ea6a63d48a4fea$export$b7be63a67df8959();
        planes.setAttribute("position", new $e8ea6a63d48a4fea$export$8dea267bd6bde117(position, positionSize));
        planes.setAttribute("uv", new $e8ea6a63d48a4fea$export$8dea267bd6bde117(uv, uvSize));
        planes.setAttribute("faceIndex", new $e8ea6a63d48a4fea$export$8dea267bd6bde117(faceIndex, faceIndexSize));
        lodPlanes.push(planes);
        if (lod > $e8ea6a63d48a4fea$var$LOD_MIN) lod--;
    }
    return {
        lodPlanes: lodPlanes,
        sizeLods: sizeLods,
        sigmas: sigmas
    };
}
function $e8ea6a63d48a4fea$var$_createRenderTarget(width, height, params) {
    const cubeUVRenderTarget = new $e8ea6a63d48a4fea$export$3c052beb2e51e23f(width, height, params);
    cubeUVRenderTarget.texture.mapping = $e8ea6a63d48a4fea$export$dbf3e70ff37af79;
    cubeUVRenderTarget.texture.name = "PMREM.cubeUv";
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
}
function $e8ea6a63d48a4fea$var$_setViewport(target, x, y, width, height) {
    target.viewport.set(x, y, width, height);
    target.scissor.set(x, y, width, height);
}
function $e8ea6a63d48a4fea$var$_getBlurShader(lodMax, width, height) {
    const weights = new Float32Array($e8ea6a63d48a4fea$var$MAX_SAMPLES);
    const poleAxis = new $e8ea6a63d48a4fea$export$64b5c384219d3699(0, 1, 0);
    const shaderMaterial = new $e8ea6a63d48a4fea$export$83c7d75d550a8b0d({
        name: "SphericalGaussianBlur",
        defines: {
            "n": $e8ea6a63d48a4fea$var$MAX_SAMPLES,
            "CUBEUV_TEXEL_WIDTH": 1.0 / width,
            "CUBEUV_TEXEL_HEIGHT": 1.0 / height,
            "CUBEUV_MAX_MIP": `${lodMax}.0`
        },
        uniforms: {
            "envMap": {
                value: null
            },
            "samples": {
                value: 1
            },
            "weights": {
                value: weights
            },
            "latitudinal": {
                value: false
            },
            "dTheta": {
                value: 0
            },
            "mipInt": {
                value: 0
            },
            "poleAxis": {
                value: poleAxis
            }
        },
        vertexShader: $e8ea6a63d48a4fea$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
        blending: $e8ea6a63d48a4fea$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $e8ea6a63d48a4fea$var$_getEquirectMaterial() {
    return new $e8ea6a63d48a4fea$export$83c7d75d550a8b0d({
        name: "EquirectangularToCubeUV",
        uniforms: {
            "envMap": {
                value: null
            }
        },
        vertexShader: $e8ea6a63d48a4fea$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,
        blending: $e8ea6a63d48a4fea$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
}
function $e8ea6a63d48a4fea$var$_getCubemapMaterial() {
    return new $e8ea6a63d48a4fea$export$83c7d75d550a8b0d({
        name: "CubemapToCubeUV",
        uniforms: {
            "envMap": {
                value: null
            },
            "flipEnvMap": {
                value: -1
            }
        },
        vertexShader: $e8ea6a63d48a4fea$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
        blending: $e8ea6a63d48a4fea$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
}
function $e8ea6a63d48a4fea$var$_getCommonVertexShader() {
    return /* glsl */ `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
function $e8ea6a63d48a4fea$var$WebGLCubeUVMaps(renderer) {
    let cubeUVmaps = new WeakMap();
    let pmremGenerator = null;
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            const isEquirectMap = mapping === $e8ea6a63d48a4fea$export$d64030b316d3b087 || mapping === $e8ea6a63d48a4fea$export$ee99d97d46898098;
            const isCubeMap = mapping === $e8ea6a63d48a4fea$export$8759762a6477f2c4 || mapping === $e8ea6a63d48a4fea$export$dc59f8aed047f61d;
            // equirect/cube map to cubeUV conversion
            if (isEquirectMap || isCubeMap) {
                if (texture.isRenderTargetTexture && texture.needsPMREMUpdate === true) {
                    texture.needsPMREMUpdate = false;
                    let renderTarget = cubeUVmaps.get(texture);
                    if (pmremGenerator === null) pmremGenerator = new $e8ea6a63d48a4fea$export$6add42717753e221(renderer);
                    renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture, renderTarget) : pmremGenerator.fromCubemap(texture, renderTarget);
                    cubeUVmaps.set(texture, renderTarget);
                    return renderTarget.texture;
                } else {
                    if (cubeUVmaps.has(texture)) return cubeUVmaps.get(texture).texture;
                    else {
                        const image = texture.image;
                        if (isEquirectMap && image && image.height > 0 || isCubeMap && image && isCubeTextureComplete(image)) {
                            if (pmremGenerator === null) pmremGenerator = new $e8ea6a63d48a4fea$export$6add42717753e221(renderer);
                            const renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);
                            cubeUVmaps.set(texture, renderTarget);
                            texture.addEventListener("dispose", onTextureDispose);
                            return renderTarget.texture;
                        } else // image not yet ready. try the conversion next frame
                        return null;
                    }
                }
            }
        }
        return texture;
    }
    function isCubeTextureComplete(image) {
        let count = 0;
        const length = 6;
        for(let i = 0; i < length; i++)if (image[i] !== undefined) count++;
        return count === length;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener("dispose", onTextureDispose);
        const cubemapUV = cubeUVmaps.get(texture);
        if (cubemapUV !== undefined) {
            cubeUVmaps.delete(texture);
            cubemapUV.dispose();
        }
    }
    function dispose() {
        cubeUVmaps = new WeakMap();
        if (pmremGenerator !== null) {
            pmremGenerator.dispose();
            pmremGenerator = null;
        }
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $e8ea6a63d48a4fea$var$WebGLExtensions(gl) {
    const extensions = {};
    function getExtension(name) {
        if (extensions[name] !== undefined) return extensions[name];
        let extension;
        switch(name){
            case "WEBGL_depth_texture":
                extension = gl.getExtension("WEBGL_depth_texture") || gl.getExtension("MOZ_WEBGL_depth_texture") || gl.getExtension("WEBKIT_WEBGL_depth_texture");
                break;
            case "EXT_texture_filter_anisotropic":
                extension = gl.getExtension("EXT_texture_filter_anisotropic") || gl.getExtension("MOZ_EXT_texture_filter_anisotropic") || gl.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
                break;
            case "WEBGL_compressed_texture_s3tc":
                extension = gl.getExtension("WEBGL_compressed_texture_s3tc") || gl.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
                break;
            case "WEBGL_compressed_texture_pvrtc":
                extension = gl.getExtension("WEBGL_compressed_texture_pvrtc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
                break;
            default:
                extension = gl.getExtension(name);
        }
        extensions[name] = extension;
        return extension;
    }
    return {
        has: function(name) {
            return getExtension(name) !== null;
        },
        init: function(capabilities) {
            if (capabilities.isWebGL2) getExtension("EXT_color_buffer_float");
            else {
                getExtension("WEBGL_depth_texture");
                getExtension("OES_texture_float");
                getExtension("OES_texture_half_float");
                getExtension("OES_texture_half_float_linear");
                getExtension("OES_standard_derivatives");
                getExtension("OES_element_index_uint");
                getExtension("OES_vertex_array_object");
                getExtension("ANGLE_instanced_arrays");
            }
            getExtension("OES_texture_float_linear");
            getExtension("EXT_color_buffer_half_float");
            getExtension("WEBGL_multisampled_render_to_texture");
        },
        get: function(name) {
            const extension = getExtension(name);
            if (extension === null) console.warn("THREE.WebGLRenderer: " + name + " extension not supported.");
            return extension;
        }
    };
}
function $e8ea6a63d48a4fea$var$WebGLGeometries(gl, attributes, info, bindingStates) {
    const geometries = {};
    const wireframeAttributes = new WeakMap();
    function onGeometryDispose(event) {
        const geometry = event.target;
        if (geometry.index !== null) attributes.remove(geometry.index);
        for(const name in geometry.attributes)attributes.remove(geometry.attributes[name]);
        geometry.removeEventListener("dispose", onGeometryDispose);
        delete geometries[geometry.id];
        const attribute = wireframeAttributes.get(geometry);
        if (attribute) {
            attributes.remove(attribute);
            wireframeAttributes.delete(geometry);
        }
        bindingStates.releaseStatesOfGeometry(geometry);
        if (geometry.isInstancedBufferGeometry === true) delete geometry._maxInstanceCount;
        //
        info.memory.geometries--;
    }
    function get(object, geometry) {
        if (geometries[geometry.id] === true) return geometry;
        geometry.addEventListener("dispose", onGeometryDispose);
        geometries[geometry.id] = true;
        info.memory.geometries++;
        return geometry;
    }
    function update(geometry) {
        const geometryAttributes = geometry.attributes;
        // Updating index buffer in VAO now. See WebGLBindingStates.
        for(const name in geometryAttributes)attributes.update(geometryAttributes[name], 34962);
        // morph targets
        const morphAttributes = geometry.morphAttributes;
        for(const name in morphAttributes){
            const array = morphAttributes[name];
            for(let i = 0, l = array.length; i < l; i++)attributes.update(array[i], 34962);
        }
    }
    function updateWireframeAttribute(geometry) {
        const indices = [];
        const geometryIndex = geometry.index;
        const geometryPosition = geometry.attributes.position;
        let version = 0;
        if (geometryIndex !== null) {
            const array = geometryIndex.array;
            version = geometryIndex.version;
            for(let i = 0, l = array.length; i < l; i += 3){
                const a = array[i + 0];
                const b = array[i + 1];
                const c = array[i + 2];
                indices.push(a, b, b, c, c, a);
            }
        } else {
            const array = geometryPosition.array;
            version = geometryPosition.version;
            for(let i = 0, l = array.length / 3 - 1; i < l; i += 3){
                const a = i + 0;
                const b = i + 1;
                const c = i + 2;
                indices.push(a, b, b, c, c, a);
            }
        }
        const attribute = new ($e8ea6a63d48a4fea$var$arrayNeedsUint32(indices) ? $e8ea6a63d48a4fea$export$7eb8c9fa25cd5bd6 : $e8ea6a63d48a4fea$export$640a853f68025f2e)(indices, 1);
        attribute.version = version;
        // Updating index buffer in VAO now. See WebGLBindingStates
        //
        const previousAttribute = wireframeAttributes.get(geometry);
        if (previousAttribute) attributes.remove(previousAttribute);
        //
        wireframeAttributes.set(geometry, attribute);
    }
    function getWireframeAttribute(geometry) {
        const currentAttribute = wireframeAttributes.get(geometry);
        if (currentAttribute) {
            const geometryIndex = geometry.index;
            if (geometryIndex !== null) // if the attribute is obsolete, create a new one
            {
                if (currentAttribute.version < geometryIndex.version) updateWireframeAttribute(geometry);
            }
        } else updateWireframeAttribute(geometry);
        return wireframeAttributes.get(geometry);
    }
    return {
        get: get,
        update: update,
        getWireframeAttribute: getWireframeAttribute
    };
}
function $e8ea6a63d48a4fea$var$WebGLIndexedBufferRenderer(gl, extensions, info, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    let mode;
    function setMode(value) {
        mode = value;
    }
    let type, bytesPerElement;
    function setIndex(value) {
        type = value.type;
        bytesPerElement = value.bytesPerElement;
    }
    function render(start, count) {
        gl.drawElements(mode, count, type, start * bytesPerElement);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        let extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = "drawElementsInstanced";
        } else {
            extension = extensions.get("ANGLE_instanced_arrays");
            methodName = "drawElementsInstancedANGLE";
            if (extension === null) {
                console.error("THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
                return;
            }
        }
        extension[methodName](mode, count, type, start * bytesPerElement, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.setIndex = setIndex;
    this.render = render;
    this.renderInstances = renderInstances;
}
function $e8ea6a63d48a4fea$var$WebGLInfo(gl) {
    const memory = {
        geometries: 0,
        textures: 0
    };
    const render = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function update(count, mode, instanceCount) {
        render.calls++;
        switch(mode){
            case 4:
                render.triangles += instanceCount * (count / 3);
                break;
            case 1:
                render.lines += instanceCount * (count / 2);
                break;
            case 3:
                render.lines += instanceCount * (count - 1);
                break;
            case 2:
                render.lines += instanceCount * count;
                break;
            case 0:
                render.points += instanceCount * count;
                break;
            default:
                console.error("THREE.WebGLInfo: Unknown draw mode:", mode);
                break;
        }
    }
    function reset() {
        render.frame++;
        render.calls = 0;
        render.triangles = 0;
        render.points = 0;
        render.lines = 0;
    }
    return {
        memory: memory,
        render: render,
        programs: null,
        autoReset: true,
        reset: reset,
        update: update
    };
}
function $e8ea6a63d48a4fea$var$numericalSort(a, b) {
    return a[0] - b[0];
}
function $e8ea6a63d48a4fea$var$absNumericalSort(a, b) {
    return Math.abs(b[1]) - Math.abs(a[1]);
}
function $e8ea6a63d48a4fea$var$WebGLMorphtargets(gl, capabilities, textures) {
    const influencesList = {};
    const morphInfluences = new Float32Array(8);
    const morphTextures = new WeakMap();
    const morph = new $e8ea6a63d48a4fea$export$fa7daccca11cdbe3();
    const workInfluences = [];
    for(let i = 0; i < 8; i++)workInfluences[i] = [
        i,
        0
    ];
    function update(object, geometry, program) {
        const objectInfluences = object.morphTargetInfluences;
        if (capabilities.isWebGL2 === true) {
            // instead of using attributes, the WebGL 2 code path encodes morph targets
            // into an array of data textures. Each layer represents a single morph target.
            const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
            const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
            let entry = morphTextures.get(geometry);
            if (entry === undefined || entry.count !== morphTargetsCount) {
                if (entry !== undefined) entry.texture.dispose();
                const hasMorphPosition = geometry.morphAttributes.position !== undefined;
                const hasMorphNormals = geometry.morphAttributes.normal !== undefined;
                const hasMorphColors = geometry.morphAttributes.color !== undefined;
                const morphTargets = geometry.morphAttributes.position || [];
                const morphNormals = geometry.morphAttributes.normal || [];
                const morphColors = geometry.morphAttributes.color || [];
                let vertexDataCount = 0;
                if (hasMorphPosition === true) vertexDataCount = 1;
                if (hasMorphNormals === true) vertexDataCount = 2;
                if (hasMorphColors === true) vertexDataCount = 3;
                let width = geometry.attributes.position.count * vertexDataCount;
                let height = 1;
                if (width > capabilities.maxTextureSize) {
                    height = Math.ceil(width / capabilities.maxTextureSize);
                    width = capabilities.maxTextureSize;
                }
                const buffer = new Float32Array(width * height * 4 * morphTargetsCount);
                const texture = new $e8ea6a63d48a4fea$export$dfac6c8e811406a3(buffer, width, height, morphTargetsCount);
                texture.type = $e8ea6a63d48a4fea$export$f6d331659b644596;
                texture.needsUpdate = true;
                // fill buffer
                const vertexDataStride = vertexDataCount * 4;
                for(let i = 0; i < morphTargetsCount; i++){
                    const morphTarget = morphTargets[i];
                    const morphNormal = morphNormals[i];
                    const morphColor = morphColors[i];
                    const offset = width * height * 4 * i;
                    for(let j = 0; j < morphTarget.count; j++){
                        const stride = j * vertexDataStride;
                        if (hasMorphPosition === true) {
                            morph.fromBufferAttribute(morphTarget, j);
                            buffer[offset + stride + 0] = morph.x;
                            buffer[offset + stride + 1] = morph.y;
                            buffer[offset + stride + 2] = morph.z;
                            buffer[offset + stride + 3] = 0;
                        }
                        if (hasMorphNormals === true) {
                            morph.fromBufferAttribute(morphNormal, j);
                            buffer[offset + stride + 4] = morph.x;
                            buffer[offset + stride + 5] = morph.y;
                            buffer[offset + stride + 6] = morph.z;
                            buffer[offset + stride + 7] = 0;
                        }
                        if (hasMorphColors === true) {
                            morph.fromBufferAttribute(morphColor, j);
                            buffer[offset + stride + 8] = morph.x;
                            buffer[offset + stride + 9] = morph.y;
                            buffer[offset + stride + 10] = morph.z;
                            buffer[offset + stride + 11] = morphColor.itemSize === 4 ? morph.w : 1;
                        }
                    }
                }
                entry = {
                    count: morphTargetsCount,
                    texture: texture,
                    size: new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(width, height)
                };
                morphTextures.set(geometry, entry);
                function disposeTexture() {
                    texture.dispose();
                    morphTextures.delete(geometry);
                    geometry.removeEventListener("dispose", disposeTexture);
                }
                geometry.addEventListener("dispose", disposeTexture);
            }
            //
            let morphInfluencesSum = 0;
            for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, "morphTargetBaseInfluence", morphBaseInfluence);
            program.getUniforms().setValue(gl, "morphTargetInfluences", objectInfluences);
            program.getUniforms().setValue(gl, "morphTargetsTexture", entry.texture, textures);
            program.getUniforms().setValue(gl, "morphTargetsTextureSize", entry.size);
        } else {
            // When object doesn't have morph target influences defined, we treat it as a 0-length array
            // This is important to make sure we set up morphTargetBaseInfluence / morphTargetInfluences
            const length = objectInfluences === undefined ? 0 : objectInfluences.length;
            let influences = influencesList[geometry.id];
            if (influences === undefined || influences.length !== length) {
                // initialise list
                influences = [];
                for(let i = 0; i < length; i++)influences[i] = [
                    i,
                    0
                ];
                influencesList[geometry.id] = influences;
            }
            // Collect influences
            for(let i = 0; i < length; i++){
                const influence = influences[i];
                influence[0] = i;
                influence[1] = objectInfluences[i];
            }
            influences.sort($e8ea6a63d48a4fea$var$absNumericalSort);
            for(let i = 0; i < 8; i++)if (i < length && influences[i][1]) {
                workInfluences[i][0] = influences[i][0];
                workInfluences[i][1] = influences[i][1];
            } else {
                workInfluences[i][0] = Number.MAX_SAFE_INTEGER;
                workInfluences[i][1] = 0;
            }
            workInfluences.sort($e8ea6a63d48a4fea$var$numericalSort);
            const morphTargets = geometry.morphAttributes.position;
            const morphNormals = geometry.morphAttributes.normal;
            let morphInfluencesSum = 0;
            for(let i = 0; i < 8; i++){
                const influence = workInfluences[i];
                const index = influence[0];
                const value = influence[1];
                if (index !== Number.MAX_SAFE_INTEGER && value) {
                    if (morphTargets && geometry.getAttribute("morphTarget" + i) !== morphTargets[index]) geometry.setAttribute("morphTarget" + i, morphTargets[index]);
                    if (morphNormals && geometry.getAttribute("morphNormal" + i) !== morphNormals[index]) geometry.setAttribute("morphNormal" + i, morphNormals[index]);
                    morphInfluences[i] = value;
                    morphInfluencesSum += value;
                } else {
                    if (morphTargets && geometry.hasAttribute("morphTarget" + i) === true) geometry.deleteAttribute("morphTarget" + i);
                    if (morphNormals && geometry.hasAttribute("morphNormal" + i) === true) geometry.deleteAttribute("morphNormal" + i);
                    morphInfluences[i] = 0;
                }
            }
            // GLSL shader uses formula baseinfluence * base + sum(target * influence)
            // This allows us to switch between absolute morphs and relative morphs without changing shader code
            // When baseinfluence = 1 - sum(influence), the above is equivalent to sum((target - base) * influence)
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, "morphTargetBaseInfluence", morphBaseInfluence);
            program.getUniforms().setValue(gl, "morphTargetInfluences", morphInfluences);
        }
    }
    return {
        update: update
    };
}
function $e8ea6a63d48a4fea$var$WebGLObjects(gl, geometries, attributes, info) {
    let updateMap = new WeakMap();
    function update(object) {
        const frame = info.render.frame;
        const geometry = object.geometry;
        const buffergeometry = geometries.get(object, geometry);
        // Update once per frame
        if (updateMap.get(buffergeometry) !== frame) {
            geometries.update(buffergeometry);
            updateMap.set(buffergeometry, frame);
        }
        if (object.isInstancedMesh) {
            if (object.hasEventListener("dispose", onInstancedMeshDispose) === false) object.addEventListener("dispose", onInstancedMeshDispose);
            attributes.update(object.instanceMatrix, 34962);
            if (object.instanceColor !== null) attributes.update(object.instanceColor, 34962);
        }
        return buffergeometry;
    }
    function dispose() {
        updateMap = new WeakMap();
    }
    function onInstancedMeshDispose(event) {
        const instancedMesh = event.target;
        instancedMesh.removeEventListener("dispose", onInstancedMeshDispose);
        attributes.remove(instancedMesh.instanceMatrix);
        if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
    }
    return {
        update: update,
        dispose: dispose
    };
}
/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */ const $e8ea6a63d48a4fea$var$emptyTexture = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$5431306cf43de24a();
const $e8ea6a63d48a4fea$var$emptyArrayTexture = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$dfac6c8e811406a3();
const $e8ea6a63d48a4fea$var$empty3dTexture = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$d7a3086320f856db();
const $e8ea6a63d48a4fea$var$emptyCubeTexture = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$ee2e5a18258a4049();
// --- Utilities ---
// Array Caches (provide typed arrays for temporary by size)
const $e8ea6a63d48a4fea$var$arrayCacheF32 = [];
const $e8ea6a63d48a4fea$var$arrayCacheI32 = [];
// Float32Array caches used for uploading Matrix uniforms
const $e8ea6a63d48a4fea$var$mat4array = new Float32Array(16);
const $e8ea6a63d48a4fea$var$mat3array = new Float32Array(9);
const $e8ea6a63d48a4fea$var$mat2array = new Float32Array(4);
// Flattening for arrays of vectors and matrices
function $e8ea6a63d48a4fea$var$flatten(array, nBlocks, blockSize) {
    const firstElem = array[0];
    if (firstElem <= 0 || firstElem > 0) return array;
    // unoptimized: ! isNaN( firstElem )
    // see http://jacksondunstan.com/articles/983
    const n = nBlocks * blockSize;
    let r = $e8ea6a63d48a4fea$var$arrayCacheF32[n];
    if (r === undefined) {
        r = new Float32Array(n);
        $e8ea6a63d48a4fea$var$arrayCacheF32[n] = r;
    }
    if (nBlocks !== 0) {
        firstElem.toArray(r, 0);
        for(let i = 1, offset = 0; i !== nBlocks; ++i){
            offset += blockSize;
            array[i].toArray(r, offset);
        }
    }
    return r;
}
function $e8ea6a63d48a4fea$var$arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $e8ea6a63d48a4fea$var$copyArray(a, b) {
    for(let i = 0, l = b.length; i < l; i++)a[i] = b[i];
}
// Texture unit allocation
function $e8ea6a63d48a4fea$var$allocTexUnits(textures, n) {
    let r = $e8ea6a63d48a4fea$var$arrayCacheI32[n];
    if (r === undefined) {
        r = new Int32Array(n);
        $e8ea6a63d48a4fea$var$arrayCacheI32[n] = r;
    }
    for(let i = 0; i !== n; ++i)r[i] = textures.allocateTextureUnit();
    return r;
}
// --- Setters ---
// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.
// Single scalar
function $e8ea6a63d48a4fea$var$setValueV1f(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1f(this.addr, v);
    cache[0] = v;
}
// Single float vector (from flat array or THREE.VectorN)
function $e8ea6a63d48a4fea$var$setValueV2f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2f(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($e8ea6a63d48a4fea$var$arraysEqual(cache, v)) return;
        gl.uniform2fv(this.addr, v);
        $e8ea6a63d48a4fea$var$copyArray(cache, v);
    }
}
function $e8ea6a63d48a4fea$var$setValueV3f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3f(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else if (v.r !== undefined) {
        if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
            gl.uniform3f(this.addr, v.r, v.g, v.b);
            cache[0] = v.r;
            cache[1] = v.g;
            cache[2] = v.b;
        }
    } else {
        if ($e8ea6a63d48a4fea$var$arraysEqual(cache, v)) return;
        gl.uniform3fv(this.addr, v);
        $e8ea6a63d48a4fea$var$copyArray(cache, v);
    }
}
function $e8ea6a63d48a4fea$var$setValueV4f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($e8ea6a63d48a4fea$var$arraysEqual(cache, v)) return;
        gl.uniform4fv(this.addr, v);
        $e8ea6a63d48a4fea$var$copyArray(cache, v);
    }
}
// Single matrix (from flat array or THREE.MatrixN)
function $e8ea6a63d48a4fea$var$setValueM2(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($e8ea6a63d48a4fea$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix2fv(this.addr, false, v);
        $e8ea6a63d48a4fea$var$copyArray(cache, v);
    } else {
        if ($e8ea6a63d48a4fea$var$arraysEqual(cache, elements)) return;
        $e8ea6a63d48a4fea$var$mat2array.set(elements);
        gl.uniformMatrix2fv(this.addr, false, $e8ea6a63d48a4fea$var$mat2array);
        $e8ea6a63d48a4fea$var$copyArray(cache, elements);
    }
}
function $e8ea6a63d48a4fea$var$setValueM3(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($e8ea6a63d48a4fea$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix3fv(this.addr, false, v);
        $e8ea6a63d48a4fea$var$copyArray(cache, v);
    } else {
        if ($e8ea6a63d48a4fea$var$arraysEqual(cache, elements)) return;
        $e8ea6a63d48a4fea$var$mat3array.set(elements);
        gl.uniformMatrix3fv(this.addr, false, $e8ea6a63d48a4fea$var$mat3array);
        $e8ea6a63d48a4fea$var$copyArray(cache, elements);
    }
}
function $e8ea6a63d48a4fea$var$setValueM4(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($e8ea6a63d48a4fea$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix4fv(this.addr, false, v);
        $e8ea6a63d48a4fea$var$copyArray(cache, v);
    } else {
        if ($e8ea6a63d48a4fea$var$arraysEqual(cache, elements)) return;
        $e8ea6a63d48a4fea$var$mat4array.set(elements);
        gl.uniformMatrix4fv(this.addr, false, $e8ea6a63d48a4fea$var$mat4array);
        $e8ea6a63d48a4fea$var$copyArray(cache, elements);
    }
}
// Single integer / boolean
function $e8ea6a63d48a4fea$var$setValueV1i(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1i(this.addr, v);
    cache[0] = v;
}
// Single integer / boolean vector (from flat array or THREE.VectorN)
function $e8ea6a63d48a4fea$var$setValueV2i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2i(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($e8ea6a63d48a4fea$var$arraysEqual(cache, v)) return;
        gl.uniform2iv(this.addr, v);
        $e8ea6a63d48a4fea$var$copyArray(cache, v);
    }
}
function $e8ea6a63d48a4fea$var$setValueV3i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3i(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($e8ea6a63d48a4fea$var$arraysEqual(cache, v)) return;
        gl.uniform3iv(this.addr, v);
        $e8ea6a63d48a4fea$var$copyArray(cache, v);
    }
}
function $e8ea6a63d48a4fea$var$setValueV4i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4i(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($e8ea6a63d48a4fea$var$arraysEqual(cache, v)) return;
        gl.uniform4iv(this.addr, v);
        $e8ea6a63d48a4fea$var$copyArray(cache, v);
    }
}
// Single unsigned integer
function $e8ea6a63d48a4fea$var$setValueV1ui(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1ui(this.addr, v);
    cache[0] = v;
}
// Single unsigned integer vector (from flat array or THREE.VectorN)
function $e8ea6a63d48a4fea$var$setValueV2ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2ui(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($e8ea6a63d48a4fea$var$arraysEqual(cache, v)) return;
        gl.uniform2uiv(this.addr, v);
        $e8ea6a63d48a4fea$var$copyArray(cache, v);
    }
}
function $e8ea6a63d48a4fea$var$setValueV3ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3ui(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($e8ea6a63d48a4fea$var$arraysEqual(cache, v)) return;
        gl.uniform3uiv(this.addr, v);
        $e8ea6a63d48a4fea$var$copyArray(cache, v);
    }
}
function $e8ea6a63d48a4fea$var$setValueV4ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4ui(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($e8ea6a63d48a4fea$var$arraysEqual(cache, v)) return;
        gl.uniform4uiv(this.addr, v);
        $e8ea6a63d48a4fea$var$copyArray(cache, v);
    }
}
// Single texture (2D / Cube)
function $e8ea6a63d48a4fea$var$setValueT1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2D(v || $e8ea6a63d48a4fea$var$emptyTexture, unit);
}
function $e8ea6a63d48a4fea$var$setValueT3D1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture3D(v || $e8ea6a63d48a4fea$var$empty3dTexture, unit);
}
function $e8ea6a63d48a4fea$var$setValueT6(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTextureCube(v || $e8ea6a63d48a4fea$var$emptyCubeTexture, unit);
}
function $e8ea6a63d48a4fea$var$setValueT2DArray1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2DArray(v || $e8ea6a63d48a4fea$var$emptyArrayTexture, unit);
}
// Helper to pick the right setter for the singular case
function $e8ea6a63d48a4fea$var$getSingularSetter(type) {
    switch(type){
        case 0x1406:
            return $e8ea6a63d48a4fea$var$setValueV1f; // FLOAT
        case 0x8b50:
            return $e8ea6a63d48a4fea$var$setValueV2f; // _VEC2
        case 0x8b51:
            return $e8ea6a63d48a4fea$var$setValueV3f; // _VEC3
        case 0x8b52:
            return $e8ea6a63d48a4fea$var$setValueV4f; // _VEC4
        case 0x8b5a:
            return $e8ea6a63d48a4fea$var$setValueM2; // _MAT2
        case 0x8b5b:
            return $e8ea6a63d48a4fea$var$setValueM3; // _MAT3
        case 0x8b5c:
            return $e8ea6a63d48a4fea$var$setValueM4; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $e8ea6a63d48a4fea$var$setValueV1i; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $e8ea6a63d48a4fea$var$setValueV2i; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $e8ea6a63d48a4fea$var$setValueV3i; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $e8ea6a63d48a4fea$var$setValueV4i; // _VEC4
        case 0x1405:
            return $e8ea6a63d48a4fea$var$setValueV1ui; // UINT
        case 0x8dc6:
            return $e8ea6a63d48a4fea$var$setValueV2ui; // _VEC2
        case 0x8dc7:
            return $e8ea6a63d48a4fea$var$setValueV3ui; // _VEC3
        case 0x8dc8:
            return $e8ea6a63d48a4fea$var$setValueV4ui; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $e8ea6a63d48a4fea$var$setValueT1;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $e8ea6a63d48a4fea$var$setValueT3D1;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $e8ea6a63d48a4fea$var$setValueT6;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $e8ea6a63d48a4fea$var$setValueT2DArray1;
    }
}
// Array of scalars
function $e8ea6a63d48a4fea$var$setValueV1fArray(gl, v) {
    gl.uniform1fv(this.addr, v);
}
// Array of vectors (from flat array or array of THREE.VectorN)
function $e8ea6a63d48a4fea$var$setValueV2fArray(gl, v) {
    const data = $e8ea6a63d48a4fea$var$flatten(v, this.size, 2);
    gl.uniform2fv(this.addr, data);
}
function $e8ea6a63d48a4fea$var$setValueV3fArray(gl, v) {
    const data = $e8ea6a63d48a4fea$var$flatten(v, this.size, 3);
    gl.uniform3fv(this.addr, data);
}
function $e8ea6a63d48a4fea$var$setValueV4fArray(gl, v) {
    const data = $e8ea6a63d48a4fea$var$flatten(v, this.size, 4);
    gl.uniform4fv(this.addr, data);
}
// Array of matrices (from flat array or array of THREE.MatrixN)
function $e8ea6a63d48a4fea$var$setValueM2Array(gl, v) {
    const data = $e8ea6a63d48a4fea$var$flatten(v, this.size, 4);
    gl.uniformMatrix2fv(this.addr, false, data);
}
function $e8ea6a63d48a4fea$var$setValueM3Array(gl, v) {
    const data = $e8ea6a63d48a4fea$var$flatten(v, this.size, 9);
    gl.uniformMatrix3fv(this.addr, false, data);
}
function $e8ea6a63d48a4fea$var$setValueM4Array(gl, v) {
    const data = $e8ea6a63d48a4fea$var$flatten(v, this.size, 16);
    gl.uniformMatrix4fv(this.addr, false, data);
}
// Array of integer / boolean
function $e8ea6a63d48a4fea$var$setValueV1iArray(gl, v) {
    gl.uniform1iv(this.addr, v);
}
// Array of integer / boolean vectors (from flat array)
function $e8ea6a63d48a4fea$var$setValueV2iArray(gl, v) {
    gl.uniform2iv(this.addr, v);
}
function $e8ea6a63d48a4fea$var$setValueV3iArray(gl, v) {
    gl.uniform3iv(this.addr, v);
}
function $e8ea6a63d48a4fea$var$setValueV4iArray(gl, v) {
    gl.uniform4iv(this.addr, v);
}
// Array of unsigned integer
function $e8ea6a63d48a4fea$var$setValueV1uiArray(gl, v) {
    gl.uniform1uiv(this.addr, v);
}
// Array of unsigned integer vectors (from flat array)
function $e8ea6a63d48a4fea$var$setValueV2uiArray(gl, v) {
    gl.uniform2uiv(this.addr, v);
}
function $e8ea6a63d48a4fea$var$setValueV3uiArray(gl, v) {
    gl.uniform3uiv(this.addr, v);
}
function $e8ea6a63d48a4fea$var$setValueV4uiArray(gl, v) {
    gl.uniform4uiv(this.addr, v);
}
// Array of textures (2D / 3D / Cube / 2DArray)
function $e8ea6a63d48a4fea$var$setValueT1Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $e8ea6a63d48a4fea$var$allocTexUnits(textures, n);
    if (!$e8ea6a63d48a4fea$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $e8ea6a63d48a4fea$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2D(v[i] || $e8ea6a63d48a4fea$var$emptyTexture, units[i]);
}
function $e8ea6a63d48a4fea$var$setValueT3DArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $e8ea6a63d48a4fea$var$allocTexUnits(textures, n);
    if (!$e8ea6a63d48a4fea$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $e8ea6a63d48a4fea$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture3D(v[i] || $e8ea6a63d48a4fea$var$empty3dTexture, units[i]);
}
function $e8ea6a63d48a4fea$var$setValueT6Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $e8ea6a63d48a4fea$var$allocTexUnits(textures, n);
    if (!$e8ea6a63d48a4fea$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $e8ea6a63d48a4fea$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTextureCube(v[i] || $e8ea6a63d48a4fea$var$emptyCubeTexture, units[i]);
}
function $e8ea6a63d48a4fea$var$setValueT2DArrayArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $e8ea6a63d48a4fea$var$allocTexUnits(textures, n);
    if (!$e8ea6a63d48a4fea$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $e8ea6a63d48a4fea$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2DArray(v[i] || $e8ea6a63d48a4fea$var$emptyArrayTexture, units[i]);
}
// Helper to pick the right setter for a pure (bottom-level) array
function $e8ea6a63d48a4fea$var$getPureArraySetter(type) {
    switch(type){
        case 0x1406:
            return $e8ea6a63d48a4fea$var$setValueV1fArray; // FLOAT
        case 0x8b50:
            return $e8ea6a63d48a4fea$var$setValueV2fArray; // _VEC2
        case 0x8b51:
            return $e8ea6a63d48a4fea$var$setValueV3fArray; // _VEC3
        case 0x8b52:
            return $e8ea6a63d48a4fea$var$setValueV4fArray; // _VEC4
        case 0x8b5a:
            return $e8ea6a63d48a4fea$var$setValueM2Array; // _MAT2
        case 0x8b5b:
            return $e8ea6a63d48a4fea$var$setValueM3Array; // _MAT3
        case 0x8b5c:
            return $e8ea6a63d48a4fea$var$setValueM4Array; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $e8ea6a63d48a4fea$var$setValueV1iArray; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $e8ea6a63d48a4fea$var$setValueV2iArray; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $e8ea6a63d48a4fea$var$setValueV3iArray; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $e8ea6a63d48a4fea$var$setValueV4iArray; // _VEC4
        case 0x1405:
            return $e8ea6a63d48a4fea$var$setValueV1uiArray; // UINT
        case 0x8dc6:
            return $e8ea6a63d48a4fea$var$setValueV2uiArray; // _VEC2
        case 0x8dc7:
            return $e8ea6a63d48a4fea$var$setValueV3uiArray; // _VEC3
        case 0x8dc8:
            return $e8ea6a63d48a4fea$var$setValueV4uiArray; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $e8ea6a63d48a4fea$var$setValueT1Array;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $e8ea6a63d48a4fea$var$setValueT3DArray;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $e8ea6a63d48a4fea$var$setValueT6Array;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $e8ea6a63d48a4fea$var$setValueT2DArrayArray;
    }
}
// --- Uniform Classes ---
class $e8ea6a63d48a4fea$var$SingleUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.setValue = $e8ea6a63d48a4fea$var$getSingularSetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $e8ea6a63d48a4fea$var$PureArrayUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.size = activeInfo.size;
        this.setValue = $e8ea6a63d48a4fea$var$getPureArraySetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $e8ea6a63d48a4fea$var$StructuredUniform {
    constructor(id){
        this.id = id;
        this.seq = [];
        this.map = {};
    }
    setValue(gl, value, textures) {
        const seq = this.seq;
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            u.setValue(gl, value[u.id], textures);
        }
    }
}
// --- Top-level ---
// Parser - builds up the property tree from the path strings
const $e8ea6a63d48a4fea$var$RePathPart = /(\w+)(\])?(\[|\.)?/g;
// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.
function $e8ea6a63d48a4fea$var$addUniform(container, uniformObject) {
    container.seq.push(uniformObject);
    container.map[uniformObject.id] = uniformObject;
}
function $e8ea6a63d48a4fea$var$parseUniform(activeInfo, addr, container) {
    const path = activeInfo.name, pathLength = path.length;
    // reset RegExp object, because of the early exit of a previous run
    $e8ea6a63d48a4fea$var$RePathPart.lastIndex = 0;
    while(true){
        const match = $e8ea6a63d48a4fea$var$RePathPart.exec(path), matchEnd = $e8ea6a63d48a4fea$var$RePathPart.lastIndex;
        let id = match[1];
        const idIsIndex = match[2] === "]", subscript = match[3];
        if (idIsIndex) id = id | 0; // convert to integer
        if (subscript === undefined || subscript === "[" && matchEnd + 2 === pathLength) {
            // bare name or "pure" bottom-level array "[0]" suffix
            $e8ea6a63d48a4fea$var$addUniform(container, subscript === undefined ? new $e8ea6a63d48a4fea$var$SingleUniform(id, activeInfo, addr) : new $e8ea6a63d48a4fea$var$PureArrayUniform(id, activeInfo, addr));
            break;
        } else {
            // step into inner node / create it in case it doesn't exist
            const map = container.map;
            let next = map[id];
            if (next === undefined) {
                next = new $e8ea6a63d48a4fea$var$StructuredUniform(id);
                $e8ea6a63d48a4fea$var$addUniform(container, next);
            }
            container = next;
        }
    }
}
// Root Container
class $e8ea6a63d48a4fea$var$WebGLUniforms {
    constructor(gl, program){
        this.seq = [];
        this.map = {};
        const n = gl.getProgramParameter(program, 35718);
        for(let i = 0; i < n; ++i){
            const info = gl.getActiveUniform(program, i), addr = gl.getUniformLocation(program, info.name);
            $e8ea6a63d48a4fea$var$parseUniform(info, addr, this);
        }
    }
    setValue(gl, name, value, textures) {
        const u = this.map[name];
        if (u !== undefined) u.setValue(gl, value, textures);
    }
    setOptional(gl, object, name) {
        const v = object[name];
        if (v !== undefined) this.setValue(gl, name, v);
    }
    static upload(gl, seq, values, textures) {
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i], v = values[u.id];
            if (v.needsUpdate !== false) // note: always updating when .needsUpdate is undefined
            u.setValue(gl, v.value, textures);
        }
    }
    static seqWithValue(seq, values) {
        const r = [];
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            if (u.id in values) r.push(u);
        }
        return r;
    }
}
function $e8ea6a63d48a4fea$var$WebGLShader(gl, type, string) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, string);
    gl.compileShader(shader);
    return shader;
}
let $e8ea6a63d48a4fea$var$programIdCount = 0;
function $e8ea6a63d48a4fea$var$handleSource(string, errorLine) {
    const lines = string.split("\n");
    const lines2 = [];
    const from = Math.max(errorLine - 6, 0);
    const to = Math.min(errorLine + 6, lines.length);
    for(let i = from; i < to; i++){
        const line = i + 1;
        lines2.push(`${line === errorLine ? ">" : " "} ${line}: ${lines[i]}`);
    }
    return lines2.join("\n");
}
function $e8ea6a63d48a4fea$var$getEncodingComponents(encoding) {
    switch(encoding){
        case $e8ea6a63d48a4fea$export$7207336e4151a112:
            return [
                "Linear",
                "( value )"
            ];
        case $e8ea6a63d48a4fea$export$f32388edbb32674:
            return [
                "sRGB",
                "( value )"
            ];
        default:
            console.warn("THREE.WebGLProgram: Unsupported encoding:", encoding);
            return [
                "Linear",
                "( value )"
            ];
    }
}
function $e8ea6a63d48a4fea$var$getShaderErrors(gl, shader, type) {
    const status = gl.getShaderParameter(shader, 35713);
    const errors = gl.getShaderInfoLog(shader).trim();
    if (status && errors === "") return "";
    const errorMatches = /ERROR: 0:(\d+)/.exec(errors);
    if (errorMatches) {
        // --enable-privileged-webgl-extension
        // console.log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
        const errorLine = parseInt(errorMatches[1]);
        return type.toUpperCase() + "\n\n" + errors + "\n\n" + $e8ea6a63d48a4fea$var$handleSource(gl.getShaderSource(shader), errorLine);
    } else return errors;
}
function $e8ea6a63d48a4fea$var$getTexelEncodingFunction(functionName, encoding) {
    const components = $e8ea6a63d48a4fea$var$getEncodingComponents(encoding);
    return "vec4 " + functionName + "( vec4 value ) { return LinearTo" + components[0] + components[1] + "; }";
}
function $e8ea6a63d48a4fea$var$getToneMappingFunction(functionName, toneMapping) {
    let toneMappingName;
    switch(toneMapping){
        case $e8ea6a63d48a4fea$export$98f52c2a46c598ca:
            toneMappingName = "Linear";
            break;
        case $e8ea6a63d48a4fea$export$74b25e54b3bcd548:
            toneMappingName = "Reinhard";
            break;
        case $e8ea6a63d48a4fea$export$932b3dd283d4a366:
            toneMappingName = "OptimizedCineon";
            break;
        case $e8ea6a63d48a4fea$export$a0d98fe6d7e4af64:
            toneMappingName = "ACESFilmic";
            break;
        case $e8ea6a63d48a4fea$export$2c7b09c1e9abfb5e:
            toneMappingName = "Custom";
            break;
        default:
            console.warn("THREE.WebGLProgram: Unsupported toneMapping:", toneMapping);
            toneMappingName = "Linear";
    }
    return "vec3 " + functionName + "( vec3 color ) { return " + toneMappingName + "ToneMapping( color ); }";
}
function $e8ea6a63d48a4fea$var$generateExtensions(parameters) {
    const chunks = [
        parameters.extensionDerivatives || !!parameters.envMapCubeUVHeight || parameters.bumpMap || parameters.normalMapTangentSpace || parameters.clearcoatNormalMap || parameters.flatShading || parameters.shaderID === "physical" ? "#extension GL_OES_standard_derivatives : enable" : "",
        (parameters.extensionFragDepth || parameters.logarithmicDepthBuffer) && parameters.rendererExtensionFragDepth ? "#extension GL_EXT_frag_depth : enable" : "",
        parameters.extensionDrawBuffers && parameters.rendererExtensionDrawBuffers ? "#extension GL_EXT_draw_buffers : require" : "",
        (parameters.extensionShaderTextureLOD || parameters.envMap || parameters.transmission) && parameters.rendererExtensionShaderTextureLod ? "#extension GL_EXT_shader_texture_lod : enable" : ""
    ];
    return chunks.filter($e8ea6a63d48a4fea$var$filterEmptyLine).join("\n");
}
function $e8ea6a63d48a4fea$var$generateDefines(defines) {
    const chunks = [];
    for(const name in defines){
        const value = defines[name];
        if (value === false) continue;
        chunks.push("#define " + name + " " + value);
    }
    return chunks.join("\n");
}
function $e8ea6a63d48a4fea$var$fetchAttributeLocations(gl, program) {
    const attributes = {};
    const n = gl.getProgramParameter(program, 35721);
    for(let i = 0; i < n; i++){
        const info = gl.getActiveAttrib(program, i);
        const name = info.name;
        let locationSize = 1;
        if (info.type === 35674) locationSize = 2;
        if (info.type === 35675) locationSize = 3;
        if (info.type === 35676) locationSize = 4;
        // console.log( 'THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );
        attributes[name] = {
            type: info.type,
            location: gl.getAttribLocation(program, name),
            locationSize: locationSize
        };
    }
    return attributes;
}
function $e8ea6a63d48a4fea$var$filterEmptyLine(string) {
    return string !== "";
}
function $e8ea6a63d48a4fea$var$replaceLightNums(string, parameters) {
    const numSpotLightCoords = parameters.numSpotLightShadows + parameters.numSpotLightMaps - parameters.numSpotLightShadowsWithMaps;
    return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, parameters.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, numSpotLightCoords).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, parameters.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function $e8ea6a63d48a4fea$var$replaceClippingPlaneNums(string, parameters) {
    return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
// Resolve Includes
const $e8ea6a63d48a4fea$var$includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function $e8ea6a63d48a4fea$var$resolveIncludes(string) {
    return string.replace($e8ea6a63d48a4fea$var$includePattern, $e8ea6a63d48a4fea$var$includeReplacer);
}
function $e8ea6a63d48a4fea$var$includeReplacer(match, include) {
    const string = $e8ea6a63d48a4fea$export$955f9f2e84c43c8b[include];
    if (string === undefined) throw new Error("Can not resolve #include <" + include + ">");
    return $e8ea6a63d48a4fea$var$resolveIncludes(string);
}
// Unroll Loops
const $e8ea6a63d48a4fea$var$unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function $e8ea6a63d48a4fea$var$unrollLoops(string) {
    return string.replace($e8ea6a63d48a4fea$var$unrollLoopPattern, $e8ea6a63d48a4fea$var$loopReplacer);
}
function $e8ea6a63d48a4fea$var$loopReplacer(match, start, end, snippet) {
    let string = "";
    for(let i = parseInt(start); i < parseInt(end); i++)string += snippet.replace(/\[\s*i\s*\]/g, "[ " + i + " ]").replace(/UNROLLED_LOOP_INDEX/g, i);
    return string;
}
//
function $e8ea6a63d48a4fea$var$generatePrecision(parameters) {
    let precisionstring = "precision " + parameters.precision + " float;\nprecision " + parameters.precision + " int;";
    if (parameters.precision === "highp") precisionstring += "\n#define HIGH_PRECISION";
    else if (parameters.precision === "mediump") precisionstring += "\n#define MEDIUM_PRECISION";
    else if (parameters.precision === "lowp") precisionstring += "\n#define LOW_PRECISION";
    return precisionstring;
}
function $e8ea6a63d48a4fea$var$generateShadowMapTypeDefine(parameters) {
    let shadowMapTypeDefine = "SHADOWMAP_TYPE_BASIC";
    if (parameters.shadowMapType === $e8ea6a63d48a4fea$export$5813f879eee7cd88) shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF";
    else if (parameters.shadowMapType === $e8ea6a63d48a4fea$export$a47c4b43a1be34f0) shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF_SOFT";
    else if (parameters.shadowMapType === $e8ea6a63d48a4fea$export$896ae1ade6c829c4) shadowMapTypeDefine = "SHADOWMAP_TYPE_VSM";
    return shadowMapTypeDefine;
}
function $e8ea6a63d48a4fea$var$generateEnvMapTypeDefine(parameters) {
    let envMapTypeDefine = "ENVMAP_TYPE_CUBE";
    if (parameters.envMap) switch(parameters.envMapMode){
        case $e8ea6a63d48a4fea$export$8759762a6477f2c4:
        case $e8ea6a63d48a4fea$export$dc59f8aed047f61d:
            envMapTypeDefine = "ENVMAP_TYPE_CUBE";
            break;
        case $e8ea6a63d48a4fea$export$dbf3e70ff37af79:
            envMapTypeDefine = "ENVMAP_TYPE_CUBE_UV";
            break;
    }
    return envMapTypeDefine;
}
function $e8ea6a63d48a4fea$var$generateEnvMapModeDefine(parameters) {
    let envMapModeDefine = "ENVMAP_MODE_REFLECTION";
    if (parameters.envMap) switch(parameters.envMapMode){
        case $e8ea6a63d48a4fea$export$dc59f8aed047f61d:
            envMapModeDefine = "ENVMAP_MODE_REFRACTION";
            break;
    }
    return envMapModeDefine;
}
function $e8ea6a63d48a4fea$var$generateEnvMapBlendingDefine(parameters) {
    let envMapBlendingDefine = "ENVMAP_BLENDING_NONE";
    if (parameters.envMap) switch(parameters.combine){
        case $e8ea6a63d48a4fea$export$e50ac29801f1774d:
            envMapBlendingDefine = "ENVMAP_BLENDING_MULTIPLY";
            break;
        case $e8ea6a63d48a4fea$export$9f9d94f963c85479:
            envMapBlendingDefine = "ENVMAP_BLENDING_MIX";
            break;
        case $e8ea6a63d48a4fea$export$e641dc52bc3494aa:
            envMapBlendingDefine = "ENVMAP_BLENDING_ADD";
            break;
    }
    return envMapBlendingDefine;
}
function $e8ea6a63d48a4fea$var$generateCubeUVSize(parameters) {
    const imageHeight = parameters.envMapCubeUVHeight;
    if (imageHeight === null) return null;
    const maxMip = Math.log2(imageHeight) - 2;
    const texelHeight = 1.0 / imageHeight;
    const texelWidth = 1.0 / (3 * Math.max(Math.pow(2, maxMip), 112));
    return {
        texelWidth: texelWidth,
        texelHeight: texelHeight,
        maxMip: maxMip
    };
}
function $e8ea6a63d48a4fea$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
    // TODO Send this event to Three.js DevTools
    // console.log( 'WebGLProgram', cacheKey );
    const gl = renderer.getContext();
    const defines = parameters.defines;
    let vertexShader = parameters.vertexShader;
    let fragmentShader = parameters.fragmentShader;
    const shadowMapTypeDefine = $e8ea6a63d48a4fea$var$generateShadowMapTypeDefine(parameters);
    const envMapTypeDefine = $e8ea6a63d48a4fea$var$generateEnvMapTypeDefine(parameters);
    const envMapModeDefine = $e8ea6a63d48a4fea$var$generateEnvMapModeDefine(parameters);
    const envMapBlendingDefine = $e8ea6a63d48a4fea$var$generateEnvMapBlendingDefine(parameters);
    const envMapCubeUVSize = $e8ea6a63d48a4fea$var$generateCubeUVSize(parameters);
    const customExtensions = parameters.isWebGL2 ? "" : $e8ea6a63d48a4fea$var$generateExtensions(parameters);
    const customDefines = $e8ea6a63d48a4fea$var$generateDefines(defines);
    const program = gl.createProgram();
    let prefixVertex, prefixFragment;
    let versionString = parameters.glslVersion ? "#version " + parameters.glslVersion + "\n" : "";
    if (parameters.isRawShaderMaterial) {
        prefixVertex = [
            customDefines
        ].filter($e8ea6a63d48a4fea$var$filterEmptyLine).join("\n");
        if (prefixVertex.length > 0) prefixVertex += "\n";
        prefixFragment = [
            customExtensions,
            customDefines
        ].filter($e8ea6a63d48a4fea$var$filterEmptyLine).join("\n");
        if (prefixFragment.length > 0) prefixFragment += "\n";
    } else {
        prefixVertex = [
            $e8ea6a63d48a4fea$var$generatePrecision(parameters),
            "#define SHADER_NAME " + parameters.shaderName,
            customDefines,
            parameters.instancing ? "#define USE_INSTANCING" : "",
            parameters.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
            parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
            parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
            parameters.map ? "#define USE_MAP" : "",
            parameters.envMap ? "#define USE_ENVMAP" : "",
            parameters.envMap ? "#define " + envMapModeDefine : "",
            parameters.lightMap ? "#define USE_LIGHTMAP" : "",
            parameters.aoMap ? "#define USE_AOMAP" : "",
            parameters.bumpMap ? "#define USE_BUMPMAP" : "",
            parameters.normalMap ? "#define USE_NORMALMAP" : "",
            parameters.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
            parameters.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
            parameters.displacementMap ? "#define USE_DISPLACEMENTMAP" : "",
            parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
            parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
            parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
            parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
            parameters.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
            parameters.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
            parameters.specularMap ? "#define USE_SPECULARMAP" : "",
            parameters.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
            parameters.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
            parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
            parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
            parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
            parameters.transmission ? "#define USE_TRANSMISSION" : "",
            parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
            parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
            parameters.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
            parameters.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
            //
            parameters.mapUv ? "#define MAP_UV " + parameters.mapUv : "",
            parameters.alphaMapUv ? "#define ALPHAMAP_UV " + parameters.alphaMapUv : "",
            parameters.lightMapUv ? "#define LIGHTMAP_UV " + parameters.lightMapUv : "",
            parameters.aoMapUv ? "#define AOMAP_UV " + parameters.aoMapUv : "",
            parameters.emissiveMapUv ? "#define EMISSIVEMAP_UV " + parameters.emissiveMapUv : "",
            parameters.bumpMapUv ? "#define BUMPMAP_UV " + parameters.bumpMapUv : "",
            parameters.normalMapUv ? "#define NORMALMAP_UV " + parameters.normalMapUv : "",
            parameters.displacementMapUv ? "#define DISPLACEMENTMAP_UV " + parameters.displacementMapUv : "",
            parameters.metalnessMapUv ? "#define METALNESSMAP_UV " + parameters.metalnessMapUv : "",
            parameters.roughnessMapUv ? "#define ROUGHNESSMAP_UV " + parameters.roughnessMapUv : "",
            parameters.clearcoatMapUv ? "#define CLEARCOATMAP_UV " + parameters.clearcoatMapUv : "",
            parameters.clearcoatNormalMapUv ? "#define CLEARCOAT_NORMALMAP_UV " + parameters.clearcoatNormalMapUv : "",
            parameters.clearcoatRoughnessMapUv ? "#define CLEARCOAT_ROUGHNESSMAP_UV " + parameters.clearcoatRoughnessMapUv : "",
            parameters.iridescenceMapUv ? "#define IRIDESCENCEMAP_UV " + parameters.iridescenceMapUv : "",
            parameters.iridescenceThicknessMapUv ? "#define IRIDESCENCE_THICKNESSMAP_UV " + parameters.iridescenceThicknessMapUv : "",
            parameters.sheenColorMapUv ? "#define SHEEN_COLORMAP_UV " + parameters.sheenColorMapUv : "",
            parameters.sheenRoughnessMapUv ? "#define SHEEN_ROUGHNESSMAP_UV " + parameters.sheenRoughnessMapUv : "",
            parameters.specularMapUv ? "#define SPECULARMAP_UV " + parameters.specularMapUv : "",
            parameters.specularColorMapUv ? "#define SPECULAR_COLORMAP_UV " + parameters.specularColorMapUv : "",
            parameters.specularIntensityMapUv ? "#define SPECULAR_INTENSITYMAP_UV " + parameters.specularIntensityMapUv : "",
            parameters.transmissionMapUv ? "#define TRANSMISSIONMAP_UV " + parameters.transmissionMapUv : "",
            parameters.thicknessMapUv ? "#define THICKNESSMAP_UV " + parameters.thicknessMapUv : "",
            //
            parameters.vertexTangents ? "#define USE_TANGENT" : "",
            parameters.vertexColors ? "#define USE_COLOR" : "",
            parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
            parameters.vertexUvs2 ? "#define USE_UV2" : "",
            parameters.pointsUvs ? "#define USE_POINTS_UV" : "",
            parameters.flatShading ? "#define FLAT_SHADED" : "",
            parameters.skinning ? "#define USE_SKINNING" : "",
            parameters.morphTargets ? "#define USE_MORPHTARGETS" : "",
            parameters.morphNormals && parameters.flatShading === false ? "#define USE_MORPHNORMALS" : "",
            parameters.morphColors && parameters.isWebGL2 ? "#define USE_MORPHCOLORS" : "",
            parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? "#define MORPHTARGETS_TEXTURE" : "",
            parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + parameters.morphTextureStride : "",
            parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? "#define MORPHTARGETS_COUNT " + parameters.morphTargetsCount : "",
            parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
            parameters.flipSided ? "#define FLIP_SIDED" : "",
            parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
            parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
            parameters.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
            parameters.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
            "uniform mat4 modelMatrix;",
            "uniform mat4 modelViewMatrix;",
            "uniform mat4 projectionMatrix;",
            "uniform mat4 viewMatrix;",
            "uniform mat3 normalMatrix;",
            "uniform vec3 cameraPosition;",
            "uniform bool isOrthographic;",
            "#ifdef USE_INSTANCING",
            "	attribute mat4 instanceMatrix;",
            "#endif",
            "#ifdef USE_INSTANCING_COLOR",
            "	attribute vec3 instanceColor;",
            "#endif",
            "attribute vec3 position;",
            "attribute vec3 normal;",
            "attribute vec2 uv;",
            "#ifdef USE_TANGENT",
            "	attribute vec4 tangent;",
            "#endif",
            "#if defined( USE_COLOR_ALPHA )",
            "	attribute vec4 color;",
            "#elif defined( USE_COLOR )",
            "	attribute vec3 color;",
            "#endif",
            "#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )",
            "	attribute vec3 morphTarget0;",
            "	attribute vec3 morphTarget1;",
            "	attribute vec3 morphTarget2;",
            "	attribute vec3 morphTarget3;",
            "	#ifdef USE_MORPHNORMALS",
            "		attribute vec3 morphNormal0;",
            "		attribute vec3 morphNormal1;",
            "		attribute vec3 morphNormal2;",
            "		attribute vec3 morphNormal3;",
            "	#else",
            "		attribute vec3 morphTarget4;",
            "		attribute vec3 morphTarget5;",
            "		attribute vec3 morphTarget6;",
            "		attribute vec3 morphTarget7;",
            "	#endif",
            "#endif",
            "#ifdef USE_SKINNING",
            "	attribute vec4 skinIndex;",
            "	attribute vec4 skinWeight;",
            "#endif",
            "\n"
        ].filter($e8ea6a63d48a4fea$var$filterEmptyLine).join("\n");
        prefixFragment = [
            customExtensions,
            $e8ea6a63d48a4fea$var$generatePrecision(parameters),
            "#define SHADER_NAME " + parameters.shaderName,
            customDefines,
            parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
            parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
            parameters.map ? "#define USE_MAP" : "",
            parameters.matcap ? "#define USE_MATCAP" : "",
            parameters.envMap ? "#define USE_ENVMAP" : "",
            parameters.envMap ? "#define " + envMapTypeDefine : "",
            parameters.envMap ? "#define " + envMapModeDefine : "",
            parameters.envMap ? "#define " + envMapBlendingDefine : "",
            envMapCubeUVSize ? "#define CUBEUV_TEXEL_WIDTH " + envMapCubeUVSize.texelWidth : "",
            envMapCubeUVSize ? "#define CUBEUV_TEXEL_HEIGHT " + envMapCubeUVSize.texelHeight : "",
            envMapCubeUVSize ? "#define CUBEUV_MAX_MIP " + envMapCubeUVSize.maxMip + ".0" : "",
            parameters.lightMap ? "#define USE_LIGHTMAP" : "",
            parameters.aoMap ? "#define USE_AOMAP" : "",
            parameters.bumpMap ? "#define USE_BUMPMAP" : "",
            parameters.normalMap ? "#define USE_NORMALMAP" : "",
            parameters.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
            parameters.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
            parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
            parameters.clearcoat ? "#define USE_CLEARCOAT" : "",
            parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
            parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
            parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
            parameters.iridescence ? "#define USE_IRIDESCENCE" : "",
            parameters.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
            parameters.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
            parameters.specularMap ? "#define USE_SPECULARMAP" : "",
            parameters.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
            parameters.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
            parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
            parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
            parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
            parameters.alphaTest ? "#define USE_ALPHATEST" : "",
            parameters.sheen ? "#define USE_SHEEN" : "",
            parameters.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
            parameters.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
            parameters.transmission ? "#define USE_TRANSMISSION" : "",
            parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
            parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
            parameters.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
            parameters.vertexTangents ? "#define USE_TANGENT" : "",
            parameters.vertexColors || parameters.instancingColor ? "#define USE_COLOR" : "",
            parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
            parameters.vertexUvs2 ? "#define USE_UV2" : "",
            parameters.pointsUvs ? "#define USE_POINTS_UV" : "",
            parameters.gradientMap ? "#define USE_GRADIENTMAP" : "",
            parameters.flatShading ? "#define FLAT_SHADED" : "",
            parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
            parameters.flipSided ? "#define FLIP_SIDED" : "",
            parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
            parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
            parameters.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
            parameters.useLegacyLights ? "#define LEGACY_LIGHTS" : "",
            parameters.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
            "uniform mat4 viewMatrix;",
            "uniform vec3 cameraPosition;",
            "uniform bool isOrthographic;",
            parameters.toneMapping !== $e8ea6a63d48a4fea$export$9fcb6b4294603b2 ? "#define TONE_MAPPING" : "",
            parameters.toneMapping !== $e8ea6a63d48a4fea$export$9fcb6b4294603b2 ? $e8ea6a63d48a4fea$export$955f9f2e84c43c8b["tonemapping_pars_fragment"] : "",
            parameters.toneMapping !== $e8ea6a63d48a4fea$export$9fcb6b4294603b2 ? $e8ea6a63d48a4fea$var$getToneMappingFunction("toneMapping", parameters.toneMapping) : "",
            parameters.dithering ? "#define DITHERING" : "",
            parameters.opaque ? "#define OPAQUE" : "",
            $e8ea6a63d48a4fea$export$955f9f2e84c43c8b["encodings_pars_fragment"],
            $e8ea6a63d48a4fea$var$getTexelEncodingFunction("linearToOutputTexel", parameters.outputEncoding),
            parameters.useDepthPacking ? "#define DEPTH_PACKING " + parameters.depthPacking : "",
            "\n"
        ].filter($e8ea6a63d48a4fea$var$filterEmptyLine).join("\n");
    }
    vertexShader = $e8ea6a63d48a4fea$var$resolveIncludes(vertexShader);
    vertexShader = $e8ea6a63d48a4fea$var$replaceLightNums(vertexShader, parameters);
    vertexShader = $e8ea6a63d48a4fea$var$replaceClippingPlaneNums(vertexShader, parameters);
    fragmentShader = $e8ea6a63d48a4fea$var$resolveIncludes(fragmentShader);
    fragmentShader = $e8ea6a63d48a4fea$var$replaceLightNums(fragmentShader, parameters);
    fragmentShader = $e8ea6a63d48a4fea$var$replaceClippingPlaneNums(fragmentShader, parameters);
    vertexShader = $e8ea6a63d48a4fea$var$unrollLoops(vertexShader);
    fragmentShader = $e8ea6a63d48a4fea$var$unrollLoops(fragmentShader);
    if (parameters.isWebGL2 && parameters.isRawShaderMaterial !== true) {
        // GLSL 3.0 conversion for built-in materials and ShaderMaterial
        versionString = "#version 300 es\n";
        prefixVertex = [
            "precision mediump sampler2DArray;",
            "#define attribute in",
            "#define varying out",
            "#define texture2D texture"
        ].join("\n") + "\n" + prefixVertex;
        prefixFragment = [
            "#define varying in",
            parameters.glslVersion === $e8ea6a63d48a4fea$export$f63012db5506e7dd ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
            parameters.glslVersion === $e8ea6a63d48a4fea$export$f63012db5506e7dd ? "" : "#define gl_FragColor pc_fragColor",
            "#define gl_FragDepthEXT gl_FragDepth",
            "#define texture2D texture",
            "#define textureCube texture",
            "#define texture2DProj textureProj",
            "#define texture2DLodEXT textureLod",
            "#define texture2DProjLodEXT textureProjLod",
            "#define textureCubeLodEXT textureLod",
            "#define texture2DGradEXT textureGrad",
            "#define texture2DProjGradEXT textureProjGrad",
            "#define textureCubeGradEXT textureGrad"
        ].join("\n") + "\n" + prefixFragment;
    }
    const vertexGlsl = versionString + prefixVertex + vertexShader;
    const fragmentGlsl = versionString + prefixFragment + fragmentShader;
    // console.log( '*VERTEX*', vertexGlsl );
    // console.log( '*FRAGMENT*', fragmentGlsl );
    const glVertexShader = $e8ea6a63d48a4fea$var$WebGLShader(gl, 35633, vertexGlsl);
    const glFragmentShader = $e8ea6a63d48a4fea$var$WebGLShader(gl, 35632, fragmentGlsl);
    gl.attachShader(program, glVertexShader);
    gl.attachShader(program, glFragmentShader);
    // Force a particular attribute to index 0.
    if (parameters.index0AttributeName !== undefined) gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
    else if (parameters.morphTargets === true) // programs with morphTargets displace position out of attribute 0
    gl.bindAttribLocation(program, 0, "position");
    gl.linkProgram(program);
    // check for link errors
    if (renderer.debug.checkShaderErrors) {
        const programLog = gl.getProgramInfoLog(program).trim();
        const vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
        const fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();
        let runnable = true;
        let haveDiagnostics = true;
        if (gl.getProgramParameter(program, 35714) === false) {
            runnable = false;
            if (typeof renderer.debug.onShaderError === "function") renderer.debug.onShaderError(gl, program, glVertexShader, glFragmentShader);
            else {
                // default error reporting
                const vertexErrors = $e8ea6a63d48a4fea$var$getShaderErrors(gl, glVertexShader, "vertex");
                const fragmentErrors = $e8ea6a63d48a4fea$var$getShaderErrors(gl, glFragmentShader, "fragment");
                console.error("THREE.WebGLProgram: Shader Error " + gl.getError() + " - " + "VALIDATE_STATUS " + gl.getProgramParameter(program, 35715) + "\n\n" + "Program Info Log: " + programLog + "\n" + vertexErrors + "\n" + fragmentErrors);
            }
        } else if (programLog !== "") console.warn("THREE.WebGLProgram: Program Info Log:", programLog);
        else if (vertexLog === "" || fragmentLog === "") haveDiagnostics = false;
        if (haveDiagnostics) this.diagnostics = {
            runnable: runnable,
            programLog: programLog,
            vertexShader: {
                log: vertexLog,
                prefix: prefixVertex
            },
            fragmentShader: {
                log: fragmentLog,
                prefix: prefixFragment
            }
        };
    }
    // Clean up
    // Crashes in iOS9 and iOS10. #18402
    // gl.detachShader( program, glVertexShader );
    // gl.detachShader( program, glFragmentShader );
    gl.deleteShader(glVertexShader);
    gl.deleteShader(glFragmentShader);
    // set up caching for uniform locations
    let cachedUniforms;
    this.getUniforms = function() {
        if (cachedUniforms === undefined) cachedUniforms = new $e8ea6a63d48a4fea$var$WebGLUniforms(gl, program);
        return cachedUniforms;
    };
    // set up caching for attribute locations
    let cachedAttributes;
    this.getAttributes = function() {
        if (cachedAttributes === undefined) cachedAttributes = $e8ea6a63d48a4fea$var$fetchAttributeLocations(gl, program);
        return cachedAttributes;
    };
    // free resource
    this.destroy = function() {
        bindingStates.releaseStatesOfProgram(this);
        gl.deleteProgram(program);
        this.program = undefined;
    };
    //
    this.name = parameters.shaderName;
    this.id = $e8ea6a63d48a4fea$var$programIdCount++;
    this.cacheKey = cacheKey;
    this.usedTimes = 1;
    this.program = program;
    this.vertexShader = glVertexShader;
    this.fragmentShader = glFragmentShader;
    return this;
}
let $e8ea6a63d48a4fea$var$_id = 0;
class $e8ea6a63d48a4fea$var$WebGLShaderCache {
    constructor(){
        this.shaderCache = new Map();
        this.materialCache = new Map();
    }
    update(material) {
        const vertexShader = material.vertexShader;
        const fragmentShader = material.fragmentShader;
        const vertexShaderStage = this._getShaderStage(vertexShader);
        const fragmentShaderStage = this._getShaderStage(fragmentShader);
        const materialShaders = this._getShaderCacheForMaterial(material);
        if (materialShaders.has(vertexShaderStage) === false) {
            materialShaders.add(vertexShaderStage);
            vertexShaderStage.usedTimes++;
        }
        if (materialShaders.has(fragmentShaderStage) === false) {
            materialShaders.add(fragmentShaderStage);
            fragmentShaderStage.usedTimes++;
        }
        return this;
    }
    remove(material) {
        const materialShaders = this.materialCache.get(material);
        for (const shaderStage of materialShaders){
            shaderStage.usedTimes--;
            if (shaderStage.usedTimes === 0) this.shaderCache.delete(shaderStage.code);
        }
        this.materialCache.delete(material);
        return this;
    }
    getVertexShaderID(material) {
        return this._getShaderStage(material.vertexShader).id;
    }
    getFragmentShaderID(material) {
        return this._getShaderStage(material.fragmentShader).id;
    }
    dispose() {
        this.shaderCache.clear();
        this.materialCache.clear();
    }
    _getShaderCacheForMaterial(material) {
        const cache = this.materialCache;
        let set = cache.get(material);
        if (set === undefined) {
            set = new Set();
            cache.set(material, set);
        }
        return set;
    }
    _getShaderStage(code) {
        const cache = this.shaderCache;
        let stage = cache.get(code);
        if (stage === undefined) {
            stage = new $e8ea6a63d48a4fea$var$WebGLShaderStage(code);
            cache.set(code, stage);
        }
        return stage;
    }
}
class $e8ea6a63d48a4fea$var$WebGLShaderStage {
    constructor(code){
        this.id = $e8ea6a63d48a4fea$var$_id++;
        this.code = code;
        this.usedTimes = 0;
    }
}
function $e8ea6a63d48a4fea$var$WebGLPrograms(renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping) {
    const _programLayers = new $e8ea6a63d48a4fea$export$89312ce47c0ca777();
    const _customShaders = new $e8ea6a63d48a4fea$var$WebGLShaderCache();
    const programs = [];
    const IS_WEBGL2 = capabilities.isWebGL2;
    const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
    const SUPPORTS_VERTEX_TEXTURES = capabilities.vertexTextures;
    let precision = capabilities.precision;
    const shaderIDs = {
        MeshDepthMaterial: "depth",
        MeshDistanceMaterial: "distanceRGBA",
        MeshNormalMaterial: "normal",
        MeshBasicMaterial: "basic",
        MeshLambertMaterial: "lambert",
        MeshPhongMaterial: "phong",
        MeshToonMaterial: "toon",
        MeshStandardMaterial: "physical",
        MeshPhysicalMaterial: "physical",
        MeshMatcapMaterial: "matcap",
        LineBasicMaterial: "basic",
        LineDashedMaterial: "dashed",
        PointsMaterial: "points",
        ShadowMaterial: "shadow",
        SpriteMaterial: "sprite"
    };
    function getChannel(value) {
        if (value === 1) return "uv2";
        return "uv";
    }
    function getParameters(material, lights, shadows, scene, object) {
        const fog = scene.fog;
        const geometry = object.geometry;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
        const envMapCubeUVHeight = !!envMap && envMap.mapping === $e8ea6a63d48a4fea$export$dbf3e70ff37af79 ? envMap.image.height : null;
        const shaderID = shaderIDs[material.type];
        // heuristics to create shader parameters according to lights in the scene
        // (not to blow over maxLights budget)
        if (material.precision !== null) {
            precision = capabilities.getMaxPrecision(material.precision);
            if (precision !== material.precision) console.warn("THREE.WebGLProgram.getParameters:", material.precision, "not supported, using", precision, "instead.");
        }
        //
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let morphTextureStride = 0;
        if (geometry.morphAttributes.position !== undefined) morphTextureStride = 1;
        if (geometry.morphAttributes.normal !== undefined) morphTextureStride = 2;
        if (geometry.morphAttributes.color !== undefined) morphTextureStride = 3;
        //
        let vertexShader, fragmentShader;
        let customVertexShaderID, customFragmentShaderID;
        if (shaderID) {
            const shader = $e8ea6a63d48a4fea$export$bee4a7d47f8f5014[shaderID];
            vertexShader = shader.vertexShader;
            fragmentShader = shader.fragmentShader;
        } else {
            vertexShader = material.vertexShader;
            fragmentShader = material.fragmentShader;
            _customShaders.update(material);
            customVertexShaderID = _customShaders.getVertexShaderID(material);
            customFragmentShaderID = _customShaders.getFragmentShaderID(material);
        }
        const currentRenderTarget = renderer.getRenderTarget();
        const IS_INSTANCEDMESH = object.isInstancedMesh === true;
        const HAS_MAP = !!material.map;
        const HAS_MATCAP = !!material.matcap;
        const HAS_ENVMAP = !!envMap;
        const HAS_AOMAP = !!material.aoMap;
        const HAS_LIGHTMAP = !!material.lightMap;
        const HAS_BUMPMAP = !!material.bumpMap;
        const HAS_NORMALMAP = !!material.normalMap;
        const HAS_DISPLACEMENTMAP = !!material.displacementMap;
        const HAS_EMISSIVEMAP = !!material.emissiveMap;
        const HAS_METALNESSMAP = !!material.metalnessMap;
        const HAS_ROUGHNESSMAP = !!material.roughnessMap;
        const HAS_CLEARCOAT = material.clearcoat > 0;
        const HAS_IRIDESCENCE = material.iridescence > 0;
        const HAS_SHEEN = material.sheen > 0;
        const HAS_TRANSMISSION = material.transmission > 0;
        const HAS_CLEARCOATMAP = HAS_CLEARCOAT && !!material.clearcoatMap;
        const HAS_CLEARCOAT_NORMALMAP = HAS_CLEARCOAT && !!material.clearcoatNormalMap;
        const HAS_CLEARCOAT_ROUGHNESSMAP = HAS_CLEARCOAT && !!material.clearcoatRoughnessMap;
        const HAS_IRIDESCENCEMAP = HAS_IRIDESCENCE && !!material.iridescenceMap;
        const HAS_IRIDESCENCE_THICKNESSMAP = HAS_IRIDESCENCE && !!material.iridescenceThicknessMap;
        const HAS_SHEEN_COLORMAP = HAS_SHEEN && !!material.sheenColorMap;
        const HAS_SHEEN_ROUGHNESSMAP = HAS_SHEEN && !!material.sheenRoughnessMap;
        const HAS_SPECULARMAP = !!material.specularMap;
        const HAS_SPECULAR_COLORMAP = !!material.specularColorMap;
        const HAS_SPECULAR_INTENSITYMAP = !!material.specularIntensityMap;
        const HAS_TRANSMISSIONMAP = HAS_TRANSMISSION && !!material.transmissionMap;
        const HAS_THICKNESSMAP = HAS_TRANSMISSION && !!material.thicknessMap;
        const HAS_GRADIENTMAP = !!material.gradientMap;
        const HAS_ALPHAMAP = !!material.alphaMap;
        const HAS_ALPHATEST = material.alphaTest > 0;
        const HAS_EXTENSIONS = !!material.extensions;
        const HAS_ATTRIBUTE_UV2 = !!geometry.attributes.uv2;
        const parameters = {
            isWebGL2: IS_WEBGL2,
            shaderID: shaderID,
            shaderName: material.type,
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            defines: material.defines,
            customVertexShaderID: customVertexShaderID,
            customFragmentShaderID: customFragmentShaderID,
            isRawShaderMaterial: material.isRawShaderMaterial === true,
            glslVersion: material.glslVersion,
            precision: precision,
            instancing: IS_INSTANCEDMESH,
            instancingColor: IS_INSTANCEDMESH && object.instanceColor !== null,
            supportsVertexTextures: SUPPORTS_VERTEX_TEXTURES,
            outputEncoding: currentRenderTarget === null ? renderer.outputEncoding : currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.encoding : $e8ea6a63d48a4fea$export$7207336e4151a112,
            map: HAS_MAP,
            matcap: HAS_MATCAP,
            envMap: HAS_ENVMAP,
            envMapMode: HAS_ENVMAP && envMap.mapping,
            envMapCubeUVHeight: envMapCubeUVHeight,
            aoMap: HAS_AOMAP,
            lightMap: HAS_LIGHTMAP,
            bumpMap: HAS_BUMPMAP,
            normalMap: HAS_NORMALMAP,
            displacementMap: SUPPORTS_VERTEX_TEXTURES && HAS_DISPLACEMENTMAP,
            emissiveMap: HAS_EMISSIVEMAP,
            normalMapObjectSpace: HAS_NORMALMAP && material.normalMapType === $e8ea6a63d48a4fea$export$9990ad26f9db5b2c,
            normalMapTangentSpace: HAS_NORMALMAP && material.normalMapType === $e8ea6a63d48a4fea$export$2852a58ebdac27b8,
            decodeVideoTexture: HAS_MAP && material.map.isVideoTexture === true && material.map.encoding === $e8ea6a63d48a4fea$export$f32388edbb32674,
            metalnessMap: HAS_METALNESSMAP,
            roughnessMap: HAS_ROUGHNESSMAP,
            clearcoat: HAS_CLEARCOAT,
            clearcoatMap: HAS_CLEARCOATMAP,
            clearcoatNormalMap: HAS_CLEARCOAT_NORMALMAP,
            clearcoatRoughnessMap: HAS_CLEARCOAT_ROUGHNESSMAP,
            iridescence: HAS_IRIDESCENCE,
            iridescenceMap: HAS_IRIDESCENCEMAP,
            iridescenceThicknessMap: HAS_IRIDESCENCE_THICKNESSMAP,
            sheen: HAS_SHEEN,
            sheenColorMap: HAS_SHEEN_COLORMAP,
            sheenRoughnessMap: HAS_SHEEN_ROUGHNESSMAP,
            specularMap: HAS_SPECULARMAP,
            specularColorMap: HAS_SPECULAR_COLORMAP,
            specularIntensityMap: HAS_SPECULAR_INTENSITYMAP,
            transmission: HAS_TRANSMISSION,
            transmissionMap: HAS_TRANSMISSIONMAP,
            thicknessMap: HAS_THICKNESSMAP,
            gradientMap: HAS_GRADIENTMAP,
            opaque: material.transparent === false && material.blending === $e8ea6a63d48a4fea$export$5b29a26d96ee6af0,
            alphaMap: HAS_ALPHAMAP,
            alphaTest: HAS_ALPHATEST,
            combine: material.combine,
            //
            mapUv: HAS_MAP && getChannel(material.map.channel),
            aoMapUv: HAS_AOMAP && getChannel(material.aoMap.channel),
            lightMapUv: HAS_LIGHTMAP && getChannel(material.lightMap.channel),
            bumpMapUv: HAS_BUMPMAP && getChannel(material.bumpMap.channel),
            normalMapUv: HAS_NORMALMAP && getChannel(material.normalMap.channel),
            displacementMapUv: HAS_DISPLACEMENTMAP && getChannel(material.displacementMap.channel),
            emissiveMapUv: HAS_EMISSIVEMAP && getChannel(material.emissiveMap.channel),
            metalnessMapUv: HAS_METALNESSMAP && getChannel(material.metalnessMap.channel),
            roughnessMapUv: HAS_ROUGHNESSMAP && getChannel(material.roughnessMap.channel),
            clearcoatMapUv: HAS_CLEARCOATMAP && getChannel(material.clearcoatMap.channel),
            clearcoatNormalMapUv: HAS_CLEARCOAT_NORMALMAP && getChannel(material.clearcoatNormalMap.channel),
            clearcoatRoughnessMapUv: HAS_CLEARCOAT_ROUGHNESSMAP && getChannel(material.clearcoatRoughnessMap.channel),
            iridescenceMapUv: HAS_IRIDESCENCEMAP && getChannel(material.iridescenceMap.channel),
            iridescenceThicknessMapUv: HAS_IRIDESCENCE_THICKNESSMAP && getChannel(material.iridescenceThicknessMap.channel),
            sheenColorMapUv: HAS_SHEEN_COLORMAP && getChannel(material.sheenColorMap.channel),
            sheenRoughnessMapUv: HAS_SHEEN_ROUGHNESSMAP && getChannel(material.sheenRoughnessMap.channel),
            specularMapUv: HAS_SPECULARMAP && getChannel(material.specularMap.channel),
            specularColorMapUv: HAS_SPECULAR_COLORMAP && getChannel(material.specularColorMap.channel),
            specularIntensityMapUv: HAS_SPECULAR_INTENSITYMAP && getChannel(material.specularIntensityMap.channel),
            transmissionMapUv: HAS_TRANSMISSIONMAP && getChannel(material.transmissionMap.channel),
            thicknessMapUv: HAS_THICKNESSMAP && getChannel(material.thicknessMap.channel),
            alphaMapUv: HAS_ALPHAMAP && getChannel(material.alphaMap.channel),
            //
            vertexTangents: HAS_NORMALMAP && !!geometry.attributes.tangent,
            vertexColors: material.vertexColors,
            vertexAlphas: material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4,
            vertexUvs2: HAS_ATTRIBUTE_UV2,
            pointsUvs: object.isPoints === true && !!geometry.attributes.uv && (HAS_MAP || HAS_ALPHAMAP),
            fog: !!fog,
            useFog: material.fog === true,
            fogExp2: fog && fog.isFogExp2,
            flatShading: material.flatShading === true,
            sizeAttenuation: material.sizeAttenuation === true,
            logarithmicDepthBuffer: logarithmicDepthBuffer,
            skinning: object.isSkinnedMesh === true,
            morphTargets: geometry.morphAttributes.position !== undefined,
            morphNormals: geometry.morphAttributes.normal !== undefined,
            morphColors: geometry.morphAttributes.color !== undefined,
            morphTargetsCount: morphTargetsCount,
            morphTextureStride: morphTextureStride,
            numDirLights: lights.directional.length,
            numPointLights: lights.point.length,
            numSpotLights: lights.spot.length,
            numSpotLightMaps: lights.spotLightMap.length,
            numRectAreaLights: lights.rectArea.length,
            numHemiLights: lights.hemi.length,
            numDirLightShadows: lights.directionalShadowMap.length,
            numPointLightShadows: lights.pointShadowMap.length,
            numSpotLightShadows: lights.spotShadowMap.length,
            numSpotLightShadowsWithMaps: lights.numSpotLightShadowsWithMaps,
            numClippingPlanes: clipping.numPlanes,
            numClipIntersection: clipping.numIntersection,
            dithering: material.dithering,
            shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
            shadowMapType: renderer.shadowMap.type,
            toneMapping: material.toneMapped ? renderer.toneMapping : $e8ea6a63d48a4fea$export$9fcb6b4294603b2,
            useLegacyLights: renderer.useLegacyLights,
            premultipliedAlpha: material.premultipliedAlpha,
            doubleSided: material.side === $e8ea6a63d48a4fea$export$3b296b6f144d5b03,
            flipSided: material.side === $e8ea6a63d48a4fea$export$d9f0486e75b5ace,
            useDepthPacking: material.depthPacking >= 0,
            depthPacking: material.depthPacking || 0,
            index0AttributeName: material.index0AttributeName,
            extensionDerivatives: HAS_EXTENSIONS && material.extensions.derivatives === true,
            extensionFragDepth: HAS_EXTENSIONS && material.extensions.fragDepth === true,
            extensionDrawBuffers: HAS_EXTENSIONS && material.extensions.drawBuffers === true,
            extensionShaderTextureLOD: HAS_EXTENSIONS && material.extensions.shaderTextureLOD === true,
            rendererExtensionFragDepth: IS_WEBGL2 || extensions.has("EXT_frag_depth"),
            rendererExtensionDrawBuffers: IS_WEBGL2 || extensions.has("WEBGL_draw_buffers"),
            rendererExtensionShaderTextureLod: IS_WEBGL2 || extensions.has("EXT_shader_texture_lod"),
            customProgramCacheKey: material.customProgramCacheKey()
        };
        return parameters;
    }
    function getProgramCacheKey(parameters) {
        const array = [];
        if (parameters.shaderID) array.push(parameters.shaderID);
        else {
            array.push(parameters.customVertexShaderID);
            array.push(parameters.customFragmentShaderID);
        }
        if (parameters.defines !== undefined) for(const name in parameters.defines){
            array.push(name);
            array.push(parameters.defines[name]);
        }
        if (parameters.isRawShaderMaterial === false) {
            getProgramCacheKeyParameters(array, parameters);
            getProgramCacheKeyBooleans(array, parameters);
            array.push(renderer.outputEncoding);
        }
        array.push(parameters.customProgramCacheKey);
        return array.join();
    }
    function getProgramCacheKeyParameters(array, parameters) {
        array.push(parameters.precision);
        array.push(parameters.outputEncoding);
        array.push(parameters.envMapMode);
        array.push(parameters.envMapCubeUVHeight);
        array.push(parameters.mapUv);
        array.push(parameters.alphaMapUv);
        array.push(parameters.lightMapUv);
        array.push(parameters.aoMapUv);
        array.push(parameters.bumpMapUv);
        array.push(parameters.normalMapUv);
        array.push(parameters.displacementMapUv);
        array.push(parameters.emissiveMapUv);
        array.push(parameters.metalnessMapUv);
        array.push(parameters.roughnessMapUv);
        array.push(parameters.clearcoatMapUv);
        array.push(parameters.clearcoatNormalMapUv);
        array.push(parameters.clearcoatRoughnessMapUv);
        array.push(parameters.iridescenceMapUv);
        array.push(parameters.iridescenceThicknessMapUv);
        array.push(parameters.sheenColorMapUv);
        array.push(parameters.sheenRoughnessMapUv);
        array.push(parameters.specularMapUv);
        array.push(parameters.specularColorMapUv);
        array.push(parameters.specularIntensityMapUv);
        array.push(parameters.transmissionMapUv);
        array.push(parameters.thicknessMapUv);
        array.push(parameters.combine);
        array.push(parameters.fogExp2);
        array.push(parameters.sizeAttenuation);
        array.push(parameters.morphTargetsCount);
        array.push(parameters.morphAttributeCount);
        array.push(parameters.numDirLights);
        array.push(parameters.numPointLights);
        array.push(parameters.numSpotLights);
        array.push(parameters.numSpotLightMaps);
        array.push(parameters.numHemiLights);
        array.push(parameters.numRectAreaLights);
        array.push(parameters.numDirLightShadows);
        array.push(parameters.numPointLightShadows);
        array.push(parameters.numSpotLightShadows);
        array.push(parameters.numSpotLightShadowsWithMaps);
        array.push(parameters.shadowMapType);
        array.push(parameters.toneMapping);
        array.push(parameters.numClippingPlanes);
        array.push(parameters.numClipIntersection);
        array.push(parameters.depthPacking);
    }
    function getProgramCacheKeyBooleans(array, parameters) {
        _programLayers.disableAll();
        if (parameters.isWebGL2) _programLayers.enable(0);
        if (parameters.supportsVertexTextures) _programLayers.enable(1);
        if (parameters.instancing) _programLayers.enable(2);
        if (parameters.instancingColor) _programLayers.enable(3);
        if (parameters.matcap) _programLayers.enable(4);
        if (parameters.envMap) _programLayers.enable(5);
        if (parameters.normalMapObjectSpace) _programLayers.enable(6);
        if (parameters.normalMapTangentSpace) _programLayers.enable(7);
        if (parameters.clearcoat) _programLayers.enable(8);
        if (parameters.iridescence) _programLayers.enable(9);
        if (parameters.alphaTest) _programLayers.enable(10);
        if (parameters.vertexColors) _programLayers.enable(11);
        if (parameters.vertexAlphas) _programLayers.enable(12);
        if (parameters.vertexUvs2) _programLayers.enable(13);
        if (parameters.vertexTangents) _programLayers.enable(14);
        array.push(_programLayers.mask);
        _programLayers.disableAll();
        if (parameters.fog) _programLayers.enable(0);
        if (parameters.useFog) _programLayers.enable(1);
        if (parameters.flatShading) _programLayers.enable(2);
        if (parameters.logarithmicDepthBuffer) _programLayers.enable(3);
        if (parameters.skinning) _programLayers.enable(4);
        if (parameters.morphTargets) _programLayers.enable(5);
        if (parameters.morphNormals) _programLayers.enable(6);
        if (parameters.morphColors) _programLayers.enable(7);
        if (parameters.premultipliedAlpha) _programLayers.enable(8);
        if (parameters.shadowMapEnabled) _programLayers.enable(9);
        if (parameters.useLegacyLights) _programLayers.enable(10);
        if (parameters.doubleSided) _programLayers.enable(11);
        if (parameters.flipSided) _programLayers.enable(12);
        if (parameters.useDepthPacking) _programLayers.enable(13);
        if (parameters.dithering) _programLayers.enable(14);
        if (parameters.transmission) _programLayers.enable(15);
        if (parameters.sheen) _programLayers.enable(16);
        if (parameters.decodeVideoTexture) _programLayers.enable(17);
        if (parameters.opaque) _programLayers.enable(18);
        if (parameters.pointsUvs) _programLayers.enable(19);
        array.push(_programLayers.mask);
    }
    function getUniforms(material) {
        const shaderID = shaderIDs[material.type];
        let uniforms;
        if (shaderID) {
            const shader = $e8ea6a63d48a4fea$export$bee4a7d47f8f5014[shaderID];
            uniforms = $e8ea6a63d48a4fea$export$d8ecdf8615bfea69.clone(shader.uniforms);
        } else uniforms = material.uniforms;
        return uniforms;
    }
    function acquireProgram(parameters, cacheKey) {
        let program;
        // Check if code has been already compiled
        for(let p = 0, pl = programs.length; p < pl; p++){
            const preexistingProgram = programs[p];
            if (preexistingProgram.cacheKey === cacheKey) {
                program = preexistingProgram;
                ++program.usedTimes;
                break;
            }
        }
        if (program === undefined) {
            program = new $e8ea6a63d48a4fea$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates);
            programs.push(program);
        }
        return program;
    }
    function releaseProgram(program) {
        if (--program.usedTimes === 0) {
            // Remove from unordered set
            const i = programs.indexOf(program);
            programs[i] = programs[programs.length - 1];
            programs.pop();
            // Free WebGL resources
            program.destroy();
        }
    }
    function releaseShaderCache(material) {
        _customShaders.remove(material);
    }
    function dispose() {
        _customShaders.dispose();
    }
    return {
        getParameters: getParameters,
        getProgramCacheKey: getProgramCacheKey,
        getUniforms: getUniforms,
        acquireProgram: acquireProgram,
        releaseProgram: releaseProgram,
        releaseShaderCache: releaseShaderCache,
        // Exposed for resource monitoring & error feedback via renderer.info:
        programs: programs,
        dispose: dispose
    };
}
function $e8ea6a63d48a4fea$var$WebGLProperties() {
    let properties = new WeakMap();
    function get(object) {
        let map = properties.get(object);
        if (map === undefined) {
            map = {};
            properties.set(object, map);
        }
        return map;
    }
    function remove(object) {
        properties.delete(object);
    }
    function update(object, key, value) {
        properties.get(object)[key] = value;
    }
    function dispose() {
        properties = new WeakMap();
    }
    return {
        get: get,
        remove: remove,
        update: update,
        dispose: dispose
    };
}
function $e8ea6a63d48a4fea$var$painterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.material.id !== b.material.id) return a.material.id - b.material.id;
    else if (a.z !== b.z) return a.z - b.z;
    else return a.id - b.id;
}
function $e8ea6a63d48a4fea$var$reversePainterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return b.z - a.z;
    else return a.id - b.id;
}
function $e8ea6a63d48a4fea$var$WebGLRenderList() {
    const renderItems = [];
    let renderItemsIndex = 0;
    const opaque = [];
    const transmissive = [];
    const transparent = [];
    function init() {
        renderItemsIndex = 0;
        opaque.length = 0;
        transmissive.length = 0;
        transparent.length = 0;
    }
    function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
        let renderItem = renderItems[renderItemsIndex];
        if (renderItem === undefined) {
            renderItem = {
                id: object.id,
                object: object,
                geometry: geometry,
                material: material,
                groupOrder: groupOrder,
                renderOrder: object.renderOrder,
                z: z,
                group: group
            };
            renderItems[renderItemsIndex] = renderItem;
        } else {
            renderItem.id = object.id;
            renderItem.object = object;
            renderItem.geometry = geometry;
            renderItem.material = material;
            renderItem.groupOrder = groupOrder;
            renderItem.renderOrder = object.renderOrder;
            renderItem.z = z;
            renderItem.group = group;
        }
        renderItemsIndex++;
        return renderItem;
    }
    function push(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.push(renderItem);
        else if (material.transparent === true) transparent.push(renderItem);
        else opaque.push(renderItem);
    }
    function unshift(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.unshift(renderItem);
        else if (material.transparent === true) transparent.unshift(renderItem);
        else opaque.unshift(renderItem);
    }
    function sort(customOpaqueSort, customTransparentSort) {
        if (opaque.length > 1) opaque.sort(customOpaqueSort || $e8ea6a63d48a4fea$var$painterSortStable);
        if (transmissive.length > 1) transmissive.sort(customTransparentSort || $e8ea6a63d48a4fea$var$reversePainterSortStable);
        if (transparent.length > 1) transparent.sort(customTransparentSort || $e8ea6a63d48a4fea$var$reversePainterSortStable);
    }
    function finish() {
        // Clear references from inactive renderItems in the list
        for(let i = renderItemsIndex, il = renderItems.length; i < il; i++){
            const renderItem = renderItems[i];
            if (renderItem.id === null) break;
            renderItem.id = null;
            renderItem.object = null;
            renderItem.geometry = null;
            renderItem.material = null;
            renderItem.group = null;
        }
    }
    return {
        opaque: opaque,
        transmissive: transmissive,
        transparent: transparent,
        init: init,
        push: push,
        unshift: unshift,
        finish: finish,
        sort: sort
    };
}
function $e8ea6a63d48a4fea$var$WebGLRenderLists() {
    let lists = new WeakMap();
    function get(scene, renderCallDepth) {
        const listArray = lists.get(scene);
        let list;
        if (listArray === undefined) {
            list = new $e8ea6a63d48a4fea$var$WebGLRenderList();
            lists.set(scene, [
                list
            ]);
        } else if (renderCallDepth >= listArray.length) {
            list = new $e8ea6a63d48a4fea$var$WebGLRenderList();
            listArray.push(list);
        } else list = listArray[renderCallDepth];
        return list;
    }
    function dispose() {
        lists = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $e8ea6a63d48a4fea$var$UniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case "DirectionalLight":
                    uniforms = {
                        direction: new $e8ea6a63d48a4fea$export$64b5c384219d3699(),
                        color: new $e8ea6a63d48a4fea$export$892596cec99bc70e()
                    };
                    break;
                case "SpotLight":
                    uniforms = {
                        position: new $e8ea6a63d48a4fea$export$64b5c384219d3699(),
                        direction: new $e8ea6a63d48a4fea$export$64b5c384219d3699(),
                        color: new $e8ea6a63d48a4fea$export$892596cec99bc70e(),
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case "PointLight":
                    uniforms = {
                        position: new $e8ea6a63d48a4fea$export$64b5c384219d3699(),
                        color: new $e8ea6a63d48a4fea$export$892596cec99bc70e(),
                        distance: 0,
                        decay: 0
                    };
                    break;
                case "HemisphereLight":
                    uniforms = {
                        direction: new $e8ea6a63d48a4fea$export$64b5c384219d3699(),
                        skyColor: new $e8ea6a63d48a4fea$export$892596cec99bc70e(),
                        groundColor: new $e8ea6a63d48a4fea$export$892596cec99bc70e()
                    };
                    break;
                case "RectAreaLight":
                    uniforms = {
                        color: new $e8ea6a63d48a4fea$export$892596cec99bc70e(),
                        position: new $e8ea6a63d48a4fea$export$64b5c384219d3699(),
                        halfWidth: new $e8ea6a63d48a4fea$export$64b5c384219d3699(),
                        halfHeight: new $e8ea6a63d48a4fea$export$64b5c384219d3699()
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
function $e8ea6a63d48a4fea$var$ShadowUniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case "DirectionalLight":
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $e8ea6a63d48a4fea$export$c977b3e384af9ae1()
                    };
                    break;
                case "SpotLight":
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $e8ea6a63d48a4fea$export$c977b3e384af9ae1()
                    };
                    break;
                case "PointLight":
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(),
                        shadowCameraNear: 1,
                        shadowCameraFar: 1000
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
let $e8ea6a63d48a4fea$var$nextVersion = 0;
function $e8ea6a63d48a4fea$var$shadowCastingAndTexturingLightsFirst(lightA, lightB) {
    return (lightB.castShadow ? 2 : 0) - (lightA.castShadow ? 2 : 0) + (lightB.map ? 1 : 0) - (lightA.map ? 1 : 0);
}
function $e8ea6a63d48a4fea$var$WebGLLights(extensions, capabilities) {
    const cache = new $e8ea6a63d48a4fea$var$UniformsCache();
    const shadowCache = $e8ea6a63d48a4fea$var$ShadowUniformsCache();
    const state = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1,
            numSpotMaps: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotLightMap: [],
        spotShadow: [],
        spotShadowMap: [],
        spotLightMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: [],
        numSpotLightShadowsWithMaps: 0
    };
    for(let i = 0; i < 9; i++)state.probe.push(new $e8ea6a63d48a4fea$export$64b5c384219d3699());
    const vector3 = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
    const matrix4 = new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5();
    const matrix42 = new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5();
    function setup(lights, useLegacyLights) {
        let r = 0, g = 0, b = 0;
        for(let i = 0; i < 9; i++)state.probe[i].set(0, 0, 0);
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        let numDirectionalShadows = 0;
        let numPointShadows = 0;
        let numSpotShadows = 0;
        let numSpotMaps = 0;
        let numSpotShadowsWithMaps = 0;
        // ordering : [shadow casting + map texturing, map texturing, shadow casting, none ]
        lights.sort($e8ea6a63d48a4fea$var$shadowCastingAndTexturingLightsFirst);
        // artist-friendly light intensity scaling factor
        const scaleFactor = useLegacyLights === true ? Math.PI : 1;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            const color = light.color;
            const intensity = light.intensity;
            const distance = light.distance;
            const shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
            if (light.isAmbientLight) {
                r += color.r * intensity * scaleFactor;
                g += color.g * intensity * scaleFactor;
                b += color.b * intensity * scaleFactor;
            } else if (light.isLightProbe) for(let j = 0; j < 9; j++)state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
            else if (light.isDirectionalLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.directionalShadow[directionalLength] = shadowUniforms;
                    state.directionalShadowMap[directionalLength] = shadowMap;
                    state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
                    numDirectionalShadows++;
                }
                state.directional[directionalLength] = uniforms;
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = cache.get(light);
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.color.copy(color).multiplyScalar(intensity * scaleFactor);
                uniforms.distance = distance;
                uniforms.coneCos = Math.cos(light.angle);
                uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
                uniforms.decay = light.decay;
                state.spot[spotLength] = uniforms;
                const shadow = light.shadow;
                if (light.map) {
                    state.spotLightMap[numSpotMaps] = light.map;
                    numSpotMaps++;
                    // make sure the lightMatrix is up to date
                    // TODO : do it if required only
                    shadow.updateMatrices(light);
                    if (light.castShadow) numSpotShadowsWithMaps++;
                }
                state.spotLightMatrix[spotLength] = shadow.matrix;
                if (light.castShadow) {
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.spotShadow[spotLength] = shadowUniforms;
                    state.spotShadowMap[spotLength] = shadowMap;
                    numSpotShadows++;
                }
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                state.rectArea[rectAreaLength] = uniforms;
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);
                uniforms.distance = light.distance;
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    shadowUniforms.shadowCameraNear = shadow.camera.near;
                    shadowUniforms.shadowCameraFar = shadow.camera.far;
                    state.pointShadow[pointLength] = shadowUniforms;
                    state.pointShadowMap[pointLength] = shadowMap;
                    state.pointShadowMatrix[pointLength] = light.shadow.matrix;
                    numPointShadows++;
                }
                state.point[pointLength] = uniforms;
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = cache.get(light);
                uniforms.skyColor.copy(light.color).multiplyScalar(intensity * scaleFactor);
                uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity * scaleFactor);
                state.hemi[hemiLength] = uniforms;
                hemiLength++;
            }
        }
        if (rectAreaLength > 0) {
            if (capabilities.isWebGL2) {
                // WebGL 2
                state.rectAreaLTC1 = $e8ea6a63d48a4fea$export$6643083551874bf5.LTC_FLOAT_1;
                state.rectAreaLTC2 = $e8ea6a63d48a4fea$export$6643083551874bf5.LTC_FLOAT_2;
            } else {
                // WebGL 1
                if (extensions.has("OES_texture_float_linear") === true) {
                    state.rectAreaLTC1 = $e8ea6a63d48a4fea$export$6643083551874bf5.LTC_FLOAT_1;
                    state.rectAreaLTC2 = $e8ea6a63d48a4fea$export$6643083551874bf5.LTC_FLOAT_2;
                } else if (extensions.has("OES_texture_half_float_linear") === true) {
                    state.rectAreaLTC1 = $e8ea6a63d48a4fea$export$6643083551874bf5.LTC_HALF_1;
                    state.rectAreaLTC2 = $e8ea6a63d48a4fea$export$6643083551874bf5.LTC_HALF_2;
                } else console.error("THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.");
            }
        }
        state.ambient[0] = r;
        state.ambient[1] = g;
        state.ambient[2] = b;
        const hash = state.hash;
        if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows || hash.numSpotMaps !== numSpotMaps) {
            state.directional.length = directionalLength;
            state.spot.length = spotLength;
            state.rectArea.length = rectAreaLength;
            state.point.length = pointLength;
            state.hemi.length = hemiLength;
            state.directionalShadow.length = numDirectionalShadows;
            state.directionalShadowMap.length = numDirectionalShadows;
            state.pointShadow.length = numPointShadows;
            state.pointShadowMap.length = numPointShadows;
            state.spotShadow.length = numSpotShadows;
            state.spotShadowMap.length = numSpotShadows;
            state.directionalShadowMatrix.length = numDirectionalShadows;
            state.pointShadowMatrix.length = numPointShadows;
            state.spotLightMatrix.length = numSpotShadows + numSpotMaps - numSpotShadowsWithMaps;
            state.spotLightMap.length = numSpotMaps;
            state.numSpotLightShadowsWithMaps = numSpotShadowsWithMaps;
            hash.directionalLength = directionalLength;
            hash.pointLength = pointLength;
            hash.spotLength = spotLength;
            hash.rectAreaLength = rectAreaLength;
            hash.hemiLength = hemiLength;
            hash.numDirectionalShadows = numDirectionalShadows;
            hash.numPointShadows = numPointShadows;
            hash.numSpotShadows = numSpotShadows;
            hash.numSpotMaps = numSpotMaps;
            state.version = $e8ea6a63d48a4fea$var$nextVersion++;
        }
    }
    function setupView(lights, camera) {
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        const viewMatrix = camera.matrixWorldInverse;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            if (light.isDirectionalLight) {
                const uniforms = state.directional[directionalLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = state.spot[spotLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = state.rectArea[rectAreaLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                // extract local rotation of light to derive width/height half vectors
                matrix42.identity();
                matrix4.copy(light.matrixWorld);
                matrix4.premultiply(viewMatrix);
                matrix42.extractRotation(matrix4);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                uniforms.halfWidth.applyMatrix4(matrix42);
                uniforms.halfHeight.applyMatrix4(matrix42);
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = state.point[pointLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = state.hemi[hemiLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                uniforms.direction.transformDirection(viewMatrix);
                hemiLength++;
            }
        }
    }
    return {
        setup: setup,
        setupView: setupView,
        state: state
    };
}
function $e8ea6a63d48a4fea$var$WebGLRenderState(extensions, capabilities) {
    const lights = new $e8ea6a63d48a4fea$var$WebGLLights(extensions, capabilities);
    const lightsArray = [];
    const shadowsArray = [];
    function init() {
        lightsArray.length = 0;
        shadowsArray.length = 0;
    }
    function pushLight(light) {
        lightsArray.push(light);
    }
    function pushShadow(shadowLight) {
        shadowsArray.push(shadowLight);
    }
    function setupLights(useLegacyLights) {
        lights.setup(lightsArray, useLegacyLights);
    }
    function setupLightsView(camera) {
        lights.setupView(lightsArray, camera);
    }
    const state = {
        lightsArray: lightsArray,
        shadowsArray: shadowsArray,
        lights: lights
    };
    return {
        init: init,
        state: state,
        setupLights: setupLights,
        setupLightsView: setupLightsView,
        pushLight: pushLight,
        pushShadow: pushShadow
    };
}
function $e8ea6a63d48a4fea$var$WebGLRenderStates(extensions, capabilities) {
    let renderStates = new WeakMap();
    function get(scene, renderCallDepth = 0) {
        const renderStateArray = renderStates.get(scene);
        let renderState;
        if (renderStateArray === undefined) {
            renderState = new $e8ea6a63d48a4fea$var$WebGLRenderState(extensions, capabilities);
            renderStates.set(scene, [
                renderState
            ]);
        } else if (renderCallDepth >= renderStateArray.length) {
            renderState = new $e8ea6a63d48a4fea$var$WebGLRenderState(extensions, capabilities);
            renderStateArray.push(renderState);
        } else renderState = renderStateArray[renderCallDepth];
        return renderState;
    }
    function dispose() {
        renderStates = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
class $e8ea6a63d48a4fea$export$2698c22ec13825db extends $e8ea6a63d48a4fea$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshDepthMaterial = true;
        this.type = "MeshDepthMaterial";
        this.depthPacking = $e8ea6a63d48a4fea$export$deeb383078690b50;
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.depthPacking = source.depthPacking;
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        return this;
    }
}
class $e8ea6a63d48a4fea$export$33e187ed002f2a19 extends $e8ea6a63d48a4fea$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshDistanceMaterial = true;
        this.type = "MeshDistanceMaterial";
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        return this;
    }
}
const $e8ea6a63d48a4fea$var$vertex = "void main() {\n	gl_Position = vec4( position, 1.0 );\n}";
const $e8ea6a63d48a4fea$var$fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n	const float samples = float( VSM_SAMPLES );\n	float mean = 0.0;\n	float squared_mean = 0.0;\n	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n	for ( float i = 0.0; i < samples; i ++ ) {\n		float uvOffset = uvStart + i * uvStride;\n		#ifdef HORIZONTAL_PASS\n			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n			mean += distribution.x;\n			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n		#else\n			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n			mean += depth;\n			squared_mean += depth * depth;\n		#endif\n	}\n	mean = mean / samples;\n	squared_mean = squared_mean / samples;\n	float std_dev = sqrt( squared_mean - mean * mean );\n	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
function $e8ea6a63d48a4fea$var$WebGLShadowMap(_renderer, _objects, _capabilities) {
    let _frustum = new $e8ea6a63d48a4fea$export$35efe6f4c85463d2();
    const _shadowMapSize = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(), _viewportSize = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(), _viewport = new $e8ea6a63d48a4fea$export$fa7daccca11cdbe3(), _depthMaterial = new $e8ea6a63d48a4fea$export$2698c22ec13825db({
        depthPacking: $e8ea6a63d48a4fea$export$8f910f4c4f73df11
    }), _distanceMaterial = new $e8ea6a63d48a4fea$export$33e187ed002f2a19(), _materialCache = {}, _maxTextureSize = _capabilities.maxTextureSize;
    const shadowSide = {
        [$e8ea6a63d48a4fea$export$2ede184fc2998901]: $e8ea6a63d48a4fea$export$d9f0486e75b5ace,
        [$e8ea6a63d48a4fea$export$d9f0486e75b5ace]: $e8ea6a63d48a4fea$export$2ede184fc2998901,
        [$e8ea6a63d48a4fea$export$3b296b6f144d5b03]: $e8ea6a63d48a4fea$export$3b296b6f144d5b03
    };
    const shadowMaterialVertical = new $e8ea6a63d48a4fea$export$83c7d75d550a8b0d({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new $e8ea6a63d48a4fea$export$c977b3e384af9ae1()
            },
            radius: {
                value: 4.0
            }
        },
        vertexShader: $e8ea6a63d48a4fea$var$vertex,
        fragmentShader: $e8ea6a63d48a4fea$var$fragment
    });
    const shadowMaterialHorizontal = shadowMaterialVertical.clone();
    shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
    const fullScreenTri = new $e8ea6a63d48a4fea$export$b7be63a67df8959();
    fullScreenTri.setAttribute("position", new $e8ea6a63d48a4fea$export$8dea267bd6bde117(new Float32Array([
        -1,
        -1,
        0.5,
        3,
        -1,
        0.5,
        -1,
        3,
        0.5
    ]), 3));
    const fullScreenMesh = new $e8ea6a63d48a4fea$export$e176487c05830cc5(fullScreenTri, shadowMaterialVertical);
    const scope = this;
    this.enabled = false;
    this.autoUpdate = true;
    this.needsUpdate = false;
    this.type = $e8ea6a63d48a4fea$export$5813f879eee7cd88;
    this.render = function(lights, scene, camera) {
        if (scope.enabled === false) return;
        if (scope.autoUpdate === false && scope.needsUpdate === false) return;
        if (lights.length === 0) return;
        const currentRenderTarget = _renderer.getRenderTarget();
        const activeCubeFace = _renderer.getActiveCubeFace();
        const activeMipmapLevel = _renderer.getActiveMipmapLevel();
        const _state = _renderer.state;
        // Set GL state for depth map.
        _state.setBlending($e8ea6a63d48a4fea$export$63b8d6b580fc65ba);
        _state.buffers.color.setClear(1, 1, 1, 1);
        _state.buffers.depth.setTest(true);
        _state.setScissorTest(false);
        // render depth map
        for(let i = 0, il = lights.length; i < il; i++){
            const light = lights[i];
            const shadow = light.shadow;
            if (shadow === undefined) {
                console.warn("THREE.WebGLShadowMap:", light, "has no shadow.");
                continue;
            }
            if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
            _shadowMapSize.copy(shadow.mapSize);
            const shadowFrameExtents = shadow.getFrameExtents();
            _shadowMapSize.multiply(shadowFrameExtents);
            _viewportSize.copy(shadow.mapSize);
            if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
                if (_shadowMapSize.x > _maxTextureSize) {
                    _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
                    _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
                    shadow.mapSize.x = _viewportSize.x;
                }
                if (_shadowMapSize.y > _maxTextureSize) {
                    _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
                    _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
                    shadow.mapSize.y = _viewportSize.y;
                }
            }
            if (shadow.map === null) {
                const pars = this.type !== $e8ea6a63d48a4fea$export$896ae1ade6c829c4 ? {
                    minFilter: $e8ea6a63d48a4fea$export$727aa5ec3fe39bf0,
                    magFilter: $e8ea6a63d48a4fea$export$727aa5ec3fe39bf0
                } : {};
                shadow.map = new $e8ea6a63d48a4fea$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.map.texture.name = light.name + ".shadowMap";
                shadow.camera.updateProjectionMatrix();
            }
            _renderer.setRenderTarget(shadow.map);
            _renderer.clear();
            const viewportCount = shadow.getViewportCount();
            for(let vp = 0; vp < viewportCount; vp++){
                const viewport = shadow.getViewport(vp);
                _viewport.set(_viewportSize.x * viewport.x, _viewportSize.y * viewport.y, _viewportSize.x * viewport.z, _viewportSize.y * viewport.w);
                _state.viewport(_viewport);
                shadow.updateMatrices(light, vp);
                _frustum = shadow.getFrustum();
                renderObject(scene, camera, shadow.camera, light, this.type);
            }
            // do blur pass for VSM
            if (shadow.isPointLightShadow !== true && this.type === $e8ea6a63d48a4fea$export$896ae1ade6c829c4) VSMPass(shadow, camera);
            shadow.needsUpdate = false;
        }
        scope.needsUpdate = false;
        _renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
    };
    function VSMPass(shadow, camera) {
        const geometry = _objects.update(fullScreenMesh);
        if (shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples) {
            shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialVertical.needsUpdate = true;
            shadowMaterialHorizontal.needsUpdate = true;
        }
        if (shadow.mapPass === null) shadow.mapPass = new $e8ea6a63d48a4fea$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y);
        // vertical pass
        shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
        shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialVertical.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.mapPass);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
        // horizontal pass
        shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
        shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.map);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
    }
    function getDepthMaterial(object, material, light, type) {
        let result = null;
        const customMaterial = light.isPointLight === true ? object.customDistanceMaterial : object.customDepthMaterial;
        if (customMaterial !== undefined) result = customMaterial;
        else {
            result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;
            if (_renderer.localClippingEnabled && material.clipShadows === true && Array.isArray(material.clippingPlanes) && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0 || material.map && material.alphaTest > 0) {
                // in this case we need a unique material instance reflecting the
                // appropriate state
                const keyA = result.uuid, keyB = material.uuid;
                let materialsForVariant = _materialCache[keyA];
                if (materialsForVariant === undefined) {
                    materialsForVariant = {};
                    _materialCache[keyA] = materialsForVariant;
                }
                let cachedMaterial = materialsForVariant[keyB];
                if (cachedMaterial === undefined) {
                    cachedMaterial = result.clone();
                    materialsForVariant[keyB] = cachedMaterial;
                }
                result = cachedMaterial;
            }
        }
        result.visible = material.visible;
        result.wireframe = material.wireframe;
        if (type === $e8ea6a63d48a4fea$export$896ae1ade6c829c4) result.side = material.shadowSide !== null ? material.shadowSide : material.side;
        else result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
        result.alphaMap = material.alphaMap;
        result.alphaTest = material.alphaTest;
        result.map = material.map;
        result.clipShadows = material.clipShadows;
        result.clippingPlanes = material.clippingPlanes;
        result.clipIntersection = material.clipIntersection;
        result.displacementMap = material.displacementMap;
        result.displacementScale = material.displacementScale;
        result.displacementBias = material.displacementBias;
        result.wireframeLinewidth = material.wireframeLinewidth;
        result.linewidth = material.linewidth;
        if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
            const materialProperties = _renderer.properties.get(result);
            materialProperties.light = light;
        }
        return result;
    }
    function renderObject(object, camera, shadowCamera, light, type) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible && (object.isMesh || object.isLine || object.isPoints)) {
            if ((object.castShadow || object.receiveShadow && type === $e8ea6a63d48a4fea$export$896ae1ade6c829c4) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
                object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
                const geometry = _objects.update(object);
                const material = object.material;
                if (Array.isArray(material)) {
                    const groups = geometry.groups;
                    for(let k = 0, kl = groups.length; k < kl; k++){
                        const group = groups[k];
                        const groupMaterial = material[group.materialIndex];
                        if (groupMaterial && groupMaterial.visible) {
                            const depthMaterial = getDepthMaterial(object, groupMaterial, light, type);
                            _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
                        }
                    }
                } else if (material.visible) {
                    const depthMaterial = getDepthMaterial(object, material, light, type);
                    _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)renderObject(children[i], camera, shadowCamera, light, type);
    }
}
function $e8ea6a63d48a4fea$var$WebGLState(gl, extensions, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    function ColorBuffer() {
        let locked = false;
        const color = new $e8ea6a63d48a4fea$export$fa7daccca11cdbe3();
        let currentColorMask = null;
        const currentColorClear = new $e8ea6a63d48a4fea$export$fa7daccca11cdbe3(0, 0, 0, 0);
        return {
            setMask: function(colorMask) {
                if (currentColorMask !== colorMask && !locked) {
                    gl.colorMask(colorMask, colorMask, colorMask, colorMask);
                    currentColorMask = colorMask;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(r, g, b, a, premultipliedAlpha) {
                if (premultipliedAlpha === true) {
                    r *= a;
                    g *= a;
                    b *= a;
                }
                color.set(r, g, b, a);
                if (currentColorClear.equals(color) === false) {
                    gl.clearColor(r, g, b, a);
                    currentColorClear.copy(color);
                }
            },
            reset: function() {
                locked = false;
                currentColorMask = null;
                currentColorClear.set(-1, 0, 0, 0); // set to invalid state
            }
        };
    }
    function DepthBuffer() {
        let locked = false;
        let currentDepthMask = null;
        let currentDepthFunc = null;
        let currentDepthClear = null;
        return {
            setTest: function(depthTest) {
                if (depthTest) enable(2929);
                else disable(2929);
            },
            setMask: function(depthMask) {
                if (currentDepthMask !== depthMask && !locked) {
                    gl.depthMask(depthMask);
                    currentDepthMask = depthMask;
                }
            },
            setFunc: function(depthFunc) {
                if (currentDepthFunc !== depthFunc) {
                    switch(depthFunc){
                        case $e8ea6a63d48a4fea$export$69025ce147cee220:
                            gl.depthFunc(512);
                            break;
                        case $e8ea6a63d48a4fea$export$7182eb52ea3b3f04:
                            gl.depthFunc(519);
                            break;
                        case $e8ea6a63d48a4fea$export$eedccec66ab7ebe:
                            gl.depthFunc(513);
                            break;
                        case $e8ea6a63d48a4fea$export$296f78a0b892f81a:
                            gl.depthFunc(515);
                            break;
                        case $e8ea6a63d48a4fea$export$a60d398fc7b7590e:
                            gl.depthFunc(514);
                            break;
                        case $e8ea6a63d48a4fea$export$7d7234c1240a1fc4:
                            gl.depthFunc(518);
                            break;
                        case $e8ea6a63d48a4fea$export$c5e2c52991f30937:
                            gl.depthFunc(516);
                            break;
                        case $e8ea6a63d48a4fea$export$2f843afa843d8916:
                            gl.depthFunc(517);
                            break;
                        default:
                            gl.depthFunc(515);
                    }
                    currentDepthFunc = depthFunc;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(depth) {
                if (currentDepthClear !== depth) {
                    gl.clearDepth(depth);
                    currentDepthClear = depth;
                }
            },
            reset: function() {
                locked = false;
                currentDepthMask = null;
                currentDepthFunc = null;
                currentDepthClear = null;
            }
        };
    }
    function StencilBuffer() {
        let locked = false;
        let currentStencilMask = null;
        let currentStencilFunc = null;
        let currentStencilRef = null;
        let currentStencilFuncMask = null;
        let currentStencilFail = null;
        let currentStencilZFail = null;
        let currentStencilZPass = null;
        let currentStencilClear = null;
        return {
            setTest: function(stencilTest) {
                if (!locked) {
                    if (stencilTest) enable(2960);
                    else disable(2960);
                }
            },
            setMask: function(stencilMask) {
                if (currentStencilMask !== stencilMask && !locked) {
                    gl.stencilMask(stencilMask);
                    currentStencilMask = stencilMask;
                }
            },
            setFunc: function(stencilFunc, stencilRef, stencilMask) {
                if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
                    gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
                    currentStencilFunc = stencilFunc;
                    currentStencilRef = stencilRef;
                    currentStencilFuncMask = stencilMask;
                }
            },
            setOp: function(stencilFail, stencilZFail, stencilZPass) {
                if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
                    gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
                    currentStencilFail = stencilFail;
                    currentStencilZFail = stencilZFail;
                    currentStencilZPass = stencilZPass;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(stencil) {
                if (currentStencilClear !== stencil) {
                    gl.clearStencil(stencil);
                    currentStencilClear = stencil;
                }
            },
            reset: function() {
                locked = false;
                currentStencilMask = null;
                currentStencilFunc = null;
                currentStencilRef = null;
                currentStencilFuncMask = null;
                currentStencilFail = null;
                currentStencilZFail = null;
                currentStencilZPass = null;
                currentStencilClear = null;
            }
        };
    }
    //
    const colorBuffer = new ColorBuffer();
    const depthBuffer = new DepthBuffer();
    const stencilBuffer = new StencilBuffer();
    const uboBindings = new WeakMap();
    const uboProgramMap = new WeakMap();
    let enabledCapabilities = {};
    let currentBoundFramebuffers = {};
    let currentDrawbuffers = new WeakMap();
    let defaultDrawbuffers = [];
    let currentProgram = null;
    let currentBlendingEnabled = false;
    let currentBlending = null;
    let currentBlendEquation = null;
    let currentBlendSrc = null;
    let currentBlendDst = null;
    let currentBlendEquationAlpha = null;
    let currentBlendSrcAlpha = null;
    let currentBlendDstAlpha = null;
    let currentPremultipledAlpha = false;
    let currentFlipSided = null;
    let currentCullFace = null;
    let currentLineWidth = null;
    let currentPolygonOffsetFactor = null;
    let currentPolygonOffsetUnits = null;
    const maxTextures = gl.getParameter(35661);
    let lineWidthAvailable = false;
    let version = 0;
    const glVersion = gl.getParameter(7938);
    if (glVersion.indexOf("WebGL") !== -1) {
        version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 1.0;
    } else if (glVersion.indexOf("OpenGL ES") !== -1) {
        version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 2.0;
    }
    let currentTextureSlot = null;
    let currentBoundTextures = {};
    const scissorParam = gl.getParameter(3088);
    const viewportParam = gl.getParameter(2978);
    const currentScissor = new $e8ea6a63d48a4fea$export$fa7daccca11cdbe3().fromArray(scissorParam);
    const currentViewport = new $e8ea6a63d48a4fea$export$fa7daccca11cdbe3().fromArray(viewportParam);
    function createTexture(type, target, count) {
        const data = new Uint8Array(4); // 4 is required to match default unpack alignment of 4.
        const texture = gl.createTexture();
        gl.bindTexture(type, texture);
        gl.texParameteri(type, 10241, 9728);
        gl.texParameteri(type, 10240, 9728);
        for(let i = 0; i < count; i++)gl.texImage2D(target + i, 0, 6408, 1, 1, 0, 6408, 5121, data);
        return texture;
    }
    const emptyTextures = {};
    emptyTextures[3553] = createTexture(3553, 3553, 1);
    emptyTextures[34067] = createTexture(34067, 34069, 6);
    // init
    colorBuffer.setClear(0, 0, 0, 1);
    depthBuffer.setClear(1);
    stencilBuffer.setClear(0);
    enable(2929);
    depthBuffer.setFunc($e8ea6a63d48a4fea$export$296f78a0b892f81a);
    setFlipSided(false);
    setCullFace($e8ea6a63d48a4fea$export$b9a7b4fc5cb15f9b);
    enable(2884);
    setBlending($e8ea6a63d48a4fea$export$63b8d6b580fc65ba);
    //
    function enable(id) {
        if (enabledCapabilities[id] !== true) {
            gl.enable(id);
            enabledCapabilities[id] = true;
        }
    }
    function disable(id) {
        if (enabledCapabilities[id] !== false) {
            gl.disable(id);
            enabledCapabilities[id] = false;
        }
    }
    function bindFramebuffer(target, framebuffer) {
        if (currentBoundFramebuffers[target] !== framebuffer) {
            gl.bindFramebuffer(target, framebuffer);
            currentBoundFramebuffers[target] = framebuffer;
            if (isWebGL2) {
                // 36009 is equivalent to 36160
                if (target === 36009) currentBoundFramebuffers[36160] = framebuffer;
                if (target === 36160) currentBoundFramebuffers[36009] = framebuffer;
            }
            return true;
        }
        return false;
    }
    function drawBuffers(renderTarget, framebuffer) {
        let drawBuffers = defaultDrawbuffers;
        let needsUpdate = false;
        if (renderTarget) {
            drawBuffers = currentDrawbuffers.get(framebuffer);
            if (drawBuffers === undefined) {
                drawBuffers = [];
                currentDrawbuffers.set(framebuffer, drawBuffers);
            }
            if (renderTarget.isWebGLMultipleRenderTargets) {
                const textures = renderTarget.texture;
                if (drawBuffers.length !== textures.length || drawBuffers[0] !== 36064) {
                    for(let i = 0, il = textures.length; i < il; i++)drawBuffers[i] = 36064 + i;
                    drawBuffers.length = textures.length;
                    needsUpdate = true;
                }
            } else if (drawBuffers[0] !== 36064) {
                drawBuffers[0] = 36064;
                needsUpdate = true;
            }
        } else if (drawBuffers[0] !== 1029) {
            drawBuffers[0] = 1029;
            needsUpdate = true;
        }
        if (needsUpdate) {
            if (capabilities.isWebGL2) gl.drawBuffers(drawBuffers);
            else extensions.get("WEBGL_draw_buffers").drawBuffersWEBGL(drawBuffers);
        }
    }
    function useProgram(program) {
        if (currentProgram !== program) {
            gl.useProgram(program);
            currentProgram = program;
            return true;
        }
        return false;
    }
    const equationToGL = {
        [$e8ea6a63d48a4fea$export$20183a0484ce21a0]: 32774,
        [$e8ea6a63d48a4fea$export$73e0df5177988548]: 32778,
        [$e8ea6a63d48a4fea$export$28e582859cbec660]: 32779
    };
    if (isWebGL2) {
        equationToGL[$e8ea6a63d48a4fea$export$c8c1508da8d0600c] = 32775;
        equationToGL[$e8ea6a63d48a4fea$export$99948c02fb51055f] = 32776;
    } else {
        const extension = extensions.get("EXT_blend_minmax");
        if (extension !== null) {
            equationToGL[$e8ea6a63d48a4fea$export$c8c1508da8d0600c] = extension.MIN_EXT;
            equationToGL[$e8ea6a63d48a4fea$export$99948c02fb51055f] = extension.MAX_EXT;
        }
    }
    const factorToGL = {
        [$e8ea6a63d48a4fea$export$2110f05edf778d3d]: 0,
        [$e8ea6a63d48a4fea$export$8805bad65e24940e]: 1,
        [$e8ea6a63d48a4fea$export$7fbe15b28d28cf52]: 768,
        [$e8ea6a63d48a4fea$export$d5773124e86cf28c]: 770,
        [$e8ea6a63d48a4fea$export$c05e2a1fc8609506]: 776,
        [$e8ea6a63d48a4fea$export$ef5f2dd8ffac5574]: 774,
        [$e8ea6a63d48a4fea$export$a78aed1ca2a87192]: 772,
        [$e8ea6a63d48a4fea$export$947829af9f2c17f6]: 769,
        [$e8ea6a63d48a4fea$export$11d468cc7f19e971]: 771,
        [$e8ea6a63d48a4fea$export$56b85b2686ab16]: 775,
        [$e8ea6a63d48a4fea$export$5d0fe17fd8773bac]: 773
    };
    function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, premultipliedAlpha) {
        if (blending === $e8ea6a63d48a4fea$export$63b8d6b580fc65ba) {
            if (currentBlendingEnabled === true) {
                disable(3042);
                currentBlendingEnabled = false;
            }
            return;
        }
        if (currentBlendingEnabled === false) {
            enable(3042);
            currentBlendingEnabled = true;
        }
        if (blending !== $e8ea6a63d48a4fea$export$eda4864c68df1fa2) {
            if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
                if (currentBlendEquation !== $e8ea6a63d48a4fea$export$20183a0484ce21a0 || currentBlendEquationAlpha !== $e8ea6a63d48a4fea$export$20183a0484ce21a0) {
                    gl.blendEquation(32774);
                    currentBlendEquation = $e8ea6a63d48a4fea$export$20183a0484ce21a0;
                    currentBlendEquationAlpha = $e8ea6a63d48a4fea$export$20183a0484ce21a0;
                }
                if (premultipliedAlpha) switch(blending){
                    case $e8ea6a63d48a4fea$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(1, 771, 1, 771);
                        break;
                    case $e8ea6a63d48a4fea$export$777d8f9551c2216b:
                        gl.blendFunc(1, 1);
                        break;
                    case $e8ea6a63d48a4fea$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(0, 769, 0, 1);
                        break;
                    case $e8ea6a63d48a4fea$export$4138e1c684b46a20:
                        gl.blendFuncSeparate(0, 768, 0, 770);
                        break;
                    default:
                        console.error("THREE.WebGLState: Invalid blending: ", blending);
                        break;
                }
                else switch(blending){
                    case $e8ea6a63d48a4fea$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(770, 771, 1, 771);
                        break;
                    case $e8ea6a63d48a4fea$export$777d8f9551c2216b:
                        gl.blendFunc(770, 1);
                        break;
                    case $e8ea6a63d48a4fea$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(0, 769, 0, 1);
                        break;
                    case $e8ea6a63d48a4fea$export$4138e1c684b46a20:
                        gl.blendFunc(0, 768);
                        break;
                    default:
                        console.error("THREE.WebGLState: Invalid blending: ", blending);
                        break;
                }
                currentBlendSrc = null;
                currentBlendDst = null;
                currentBlendSrcAlpha = null;
                currentBlendDstAlpha = null;
                currentBlending = blending;
                currentPremultipledAlpha = premultipliedAlpha;
            }
            return;
        }
        // custom blending
        blendEquationAlpha = blendEquationAlpha || blendEquation;
        blendSrcAlpha = blendSrcAlpha || blendSrc;
        blendDstAlpha = blendDstAlpha || blendDst;
        if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
            gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
            currentBlendEquation = blendEquation;
            currentBlendEquationAlpha = blendEquationAlpha;
        }
        if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
            gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
            currentBlendSrc = blendSrc;
            currentBlendDst = blendDst;
            currentBlendSrcAlpha = blendSrcAlpha;
            currentBlendDstAlpha = blendDstAlpha;
        }
        currentBlending = blending;
        currentPremultipledAlpha = false;
    }
    function setMaterial(material, frontFaceCW) {
        material.side === $e8ea6a63d48a4fea$export$3b296b6f144d5b03 ? disable(2884) : enable(2884);
        let flipSided = material.side === $e8ea6a63d48a4fea$export$d9f0486e75b5ace;
        if (frontFaceCW) flipSided = !flipSided;
        setFlipSided(flipSided);
        material.blending === $e8ea6a63d48a4fea$export$5b29a26d96ee6af0 && material.transparent === false ? setBlending($e8ea6a63d48a4fea$export$63b8d6b580fc65ba) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha);
        depthBuffer.setFunc(material.depthFunc);
        depthBuffer.setTest(material.depthTest);
        depthBuffer.setMask(material.depthWrite);
        colorBuffer.setMask(material.colorWrite);
        const stencilWrite = material.stencilWrite;
        stencilBuffer.setTest(stencilWrite);
        if (stencilWrite) {
            stencilBuffer.setMask(material.stencilWriteMask);
            stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
            stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
        }
        setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
        material.alphaToCoverage === true ? enable(32926) : disable(32926);
    }
    //
    function setFlipSided(flipSided) {
        if (currentFlipSided !== flipSided) {
            if (flipSided) gl.frontFace(2304);
            else gl.frontFace(2305);
            currentFlipSided = flipSided;
        }
    }
    function setCullFace(cullFace) {
        if (cullFace !== $e8ea6a63d48a4fea$export$3237e1f2c1ea1f44) {
            enable(2884);
            if (cullFace !== currentCullFace) {
                if (cullFace === $e8ea6a63d48a4fea$export$b9a7b4fc5cb15f9b) gl.cullFace(1029);
                else if (cullFace === $e8ea6a63d48a4fea$export$b8058bcc7037d3f3) gl.cullFace(1028);
                else gl.cullFace(1032);
            }
        } else disable(2884);
        currentCullFace = cullFace;
    }
    function setLineWidth(width) {
        if (width !== currentLineWidth) {
            if (lineWidthAvailable) gl.lineWidth(width);
            currentLineWidth = width;
        }
    }
    function setPolygonOffset(polygonOffset, factor, units) {
        if (polygonOffset) {
            enable(32823);
            if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
                gl.polygonOffset(factor, units);
                currentPolygonOffsetFactor = factor;
                currentPolygonOffsetUnits = units;
            }
        } else disable(32823);
    }
    function setScissorTest(scissorTest) {
        if (scissorTest) enable(3089);
        else disable(3089);
    }
    // texture
    function activeTexture(webglSlot) {
        if (webglSlot === undefined) webglSlot = 33984 + maxTextures - 1;
        if (currentTextureSlot !== webglSlot) {
            gl.activeTexture(webglSlot);
            currentTextureSlot = webglSlot;
        }
    }
    function bindTexture(webglType, webglTexture, webglSlot) {
        if (webglSlot === undefined) {
            if (currentTextureSlot === null) webglSlot = 33984 + maxTextures - 1;
            else webglSlot = currentTextureSlot;
        }
        let boundTexture = currentBoundTextures[webglSlot];
        if (boundTexture === undefined) {
            boundTexture = {
                type: undefined,
                texture: undefined
            };
            currentBoundTextures[webglSlot] = boundTexture;
        }
        if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
            if (currentTextureSlot !== webglSlot) {
                gl.activeTexture(webglSlot);
                currentTextureSlot = webglSlot;
            }
            gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
            boundTexture.type = webglType;
            boundTexture.texture = webglTexture;
        }
    }
    function unbindTexture() {
        const boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture !== undefined && boundTexture.type !== undefined) {
            gl.bindTexture(boundTexture.type, null);
            boundTexture.type = undefined;
            boundTexture.texture = undefined;
        }
    }
    function compressedTexImage2D() {
        try {
            gl.compressedTexImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function compressedTexImage3D() {
        try {
            gl.compressedTexImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texSubImage2D() {
        try {
            gl.texSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texSubImage3D() {
        try {
            gl.texSubImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function compressedTexSubImage2D() {
        try {
            gl.compressedTexSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function compressedTexSubImage3D() {
        try {
            gl.compressedTexSubImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texStorage2D() {
        try {
            gl.texStorage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texStorage3D() {
        try {
            gl.texStorage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texImage2D() {
        try {
            gl.texImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texImage3D() {
        try {
            gl.texImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    //
    function scissor(scissor) {
        if (currentScissor.equals(scissor) === false) {
            gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
            currentScissor.copy(scissor);
        }
    }
    function viewport(viewport) {
        if (currentViewport.equals(viewport) === false) {
            gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
            currentViewport.copy(viewport);
        }
    }
    function updateUBOMapping(uniformsGroup, program) {
        let mapping = uboProgramMap.get(program);
        if (mapping === undefined) {
            mapping = new WeakMap();
            uboProgramMap.set(program, mapping);
        }
        let blockIndex = mapping.get(uniformsGroup);
        if (blockIndex === undefined) {
            blockIndex = gl.getUniformBlockIndex(program, uniformsGroup.name);
            mapping.set(uniformsGroup, blockIndex);
        }
    }
    function uniformBlockBinding(uniformsGroup, program) {
        const mapping = uboProgramMap.get(program);
        const blockIndex = mapping.get(uniformsGroup);
        if (uboBindings.get(program) !== blockIndex) {
            // bind shader specific block index to global block point
            gl.uniformBlockBinding(program, blockIndex, uniformsGroup.__bindingPointIndex);
            uboBindings.set(program, blockIndex);
        }
    }
    //
    function reset() {
        // reset state
        gl.disable(3042);
        gl.disable(2884);
        gl.disable(2929);
        gl.disable(32823);
        gl.disable(3089);
        gl.disable(2960);
        gl.disable(32926);
        gl.blendEquation(32774);
        gl.blendFunc(1, 0);
        gl.blendFuncSeparate(1, 0, 1, 0);
        gl.colorMask(true, true, true, true);
        gl.clearColor(0, 0, 0, 0);
        gl.depthMask(true);
        gl.depthFunc(513);
        gl.clearDepth(1);
        gl.stencilMask(0xffffffff);
        gl.stencilFunc(519, 0, 0xffffffff);
        gl.stencilOp(7680, 7680, 7680);
        gl.clearStencil(0);
        gl.cullFace(1029);
        gl.frontFace(2305);
        gl.polygonOffset(0, 0);
        gl.activeTexture(33984);
        gl.bindFramebuffer(36160, null);
        if (isWebGL2 === true) {
            gl.bindFramebuffer(36009, null);
            gl.bindFramebuffer(36008, null);
        }
        gl.useProgram(null);
        gl.lineWidth(1);
        gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        // reset internals
        enabledCapabilities = {};
        currentTextureSlot = null;
        currentBoundTextures = {};
        currentBoundFramebuffers = {};
        currentDrawbuffers = new WeakMap();
        defaultDrawbuffers = [];
        currentProgram = null;
        currentBlendingEnabled = false;
        currentBlending = null;
        currentBlendEquation = null;
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendEquationAlpha = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentPremultipledAlpha = false;
        currentFlipSided = null;
        currentCullFace = null;
        currentLineWidth = null;
        currentPolygonOffsetFactor = null;
        currentPolygonOffsetUnits = null;
        currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
        currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
        colorBuffer.reset();
        depthBuffer.reset();
        stencilBuffer.reset();
    }
    return {
        buffers: {
            color: colorBuffer,
            depth: depthBuffer,
            stencil: stencilBuffer
        },
        enable: enable,
        disable: disable,
        bindFramebuffer: bindFramebuffer,
        drawBuffers: drawBuffers,
        useProgram: useProgram,
        setBlending: setBlending,
        setMaterial: setMaterial,
        setFlipSided: setFlipSided,
        setCullFace: setCullFace,
        setLineWidth: setLineWidth,
        setPolygonOffset: setPolygonOffset,
        setScissorTest: setScissorTest,
        activeTexture: activeTexture,
        bindTexture: bindTexture,
        unbindTexture: unbindTexture,
        compressedTexImage2D: compressedTexImage2D,
        compressedTexImage3D: compressedTexImage3D,
        texImage2D: texImage2D,
        texImage3D: texImage3D,
        updateUBOMapping: updateUBOMapping,
        uniformBlockBinding: uniformBlockBinding,
        texStorage2D: texStorage2D,
        texStorage3D: texStorage3D,
        texSubImage2D: texSubImage2D,
        texSubImage3D: texSubImage3D,
        compressedTexSubImage2D: compressedTexSubImage2D,
        compressedTexSubImage3D: compressedTexSubImage3D,
        scissor: scissor,
        viewport: viewport,
        reset: reset
    };
}
function $e8ea6a63d48a4fea$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
    const isWebGL2 = capabilities.isWebGL2;
    const maxTextures = capabilities.maxTextures;
    const maxCubemapSize = capabilities.maxCubemapSize;
    const maxTextureSize = capabilities.maxTextureSize;
    const maxSamples = capabilities.maxSamples;
    const multisampledRTTExt = extensions.has("WEBGL_multisampled_render_to_texture") ? extensions.get("WEBGL_multisampled_render_to_texture") : null;
    const supportsInvalidateFramebuffer = typeof navigator === "undefined" ? false : /OculusBrowser/g.test(navigator.userAgent);
    const _videoTextures = new WeakMap();
    let _canvas;
    const _sources = new WeakMap(); // maps WebglTexture objects to instances of Source
    // cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
    // also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
    // Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).
    let useOffscreenCanvas = false;
    try {
        useOffscreenCanvas = typeof OffscreenCanvas !== "undefined" && new OffscreenCanvas(1, 1).getContext("2d") !== null;
    } catch (err) {
    // Ignore any errors
    }
    function createCanvas(width, height) {
        // Use OffscreenCanvas when available. Specially needed in web workers
        return useOffscreenCanvas ? // eslint-disable-next-line compat/compat
        new OffscreenCanvas(width, height) : $e8ea6a63d48a4fea$var$createElementNS("canvas");
    }
    function resizeImage(image, needsPowerOfTwo, needsNewCanvas, maxSize) {
        let scale = 1;
        // handle case if texture exceeds max size
        if (image.width > maxSize || image.height > maxSize) scale = maxSize / Math.max(image.width, image.height);
        // only perform resize if necessary
        if (scale < 1 || needsPowerOfTwo === true) {
            // only perform resize for certain image types
            if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
                const floor = needsPowerOfTwo ? $e8ea6a63d48a4fea$var$floorPowerOfTwo : Math.floor;
                const width = floor(scale * image.width);
                const height = floor(scale * image.height);
                if (_canvas === undefined) _canvas = createCanvas(width, height);
                // cube textures can't reuse the same canvas
                const canvas = needsNewCanvas ? createCanvas(width, height) : _canvas;
                canvas.width = width;
                canvas.height = height;
                const context = canvas.getContext("2d");
                context.drawImage(image, 0, 0, width, height);
                console.warn("THREE.WebGLRenderer: Texture has been resized from (" + image.width + "x" + image.height + ") to (" + width + "x" + height + ").");
                return canvas;
            } else {
                if ("data" in image) console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + image.width + "x" + image.height + ").");
                return image;
            }
        }
        return image;
    }
    function isPowerOfTwo$1(image) {
        return $e8ea6a63d48a4fea$var$isPowerOfTwo(image.width) && $e8ea6a63d48a4fea$var$isPowerOfTwo(image.height);
    }
    function textureNeedsPowerOfTwo(texture) {
        if (isWebGL2) return false;
        return texture.wrapS !== $e8ea6a63d48a4fea$export$9d9334239a5a5e06 || texture.wrapT !== $e8ea6a63d48a4fea$export$9d9334239a5a5e06 || texture.minFilter !== $e8ea6a63d48a4fea$export$727aa5ec3fe39bf0 && texture.minFilter !== $e8ea6a63d48a4fea$export$8a72f490b25c56c8;
    }
    function textureNeedsGenerateMipmaps(texture, supportsMips) {
        return texture.generateMipmaps && supportsMips && texture.minFilter !== $e8ea6a63d48a4fea$export$727aa5ec3fe39bf0 && texture.minFilter !== $e8ea6a63d48a4fea$export$8a72f490b25c56c8;
    }
    function generateMipmap(target) {
        _gl.generateMipmap(target);
    }
    function getInternalFormat(internalFormatName, glFormat, glType, encoding, forceLinearEncoding = false) {
        if (isWebGL2 === false) return glFormat;
        if (internalFormatName !== null) {
            if (_gl[internalFormatName] !== undefined) return _gl[internalFormatName];
            console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + internalFormatName + "'");
        }
        let internalFormat = glFormat;
        if (glFormat === 6403) {
            if (glType === 5126) internalFormat = 33326;
            if (glType === 5131) internalFormat = 33325;
            if (glType === 5121) internalFormat = 33321;
        }
        if (glFormat === 33319) {
            if (glType === 5126) internalFormat = 33328;
            if (glType === 5131) internalFormat = 33327;
            if (glType === 5121) internalFormat = 33323;
        }
        if (glFormat === 6408) {
            if (glType === 5126) internalFormat = 34836;
            if (glType === 5131) internalFormat = 34842;
            if (glType === 5121) internalFormat = encoding === $e8ea6a63d48a4fea$export$f32388edbb32674 && forceLinearEncoding === false ? 35907 : 32856;
            if (glType === 32819) internalFormat = 32854;
            if (glType === 32820) internalFormat = 32855;
        }
        if (internalFormat === 33325 || internalFormat === 33326 || internalFormat === 33327 || internalFormat === 33328 || internalFormat === 34842 || internalFormat === 34836) extensions.get("EXT_color_buffer_float");
        return internalFormat;
    }
    function getMipLevels(texture, image, supportsMips) {
        if (textureNeedsGenerateMipmaps(texture, supportsMips) === true || texture.isFramebufferTexture && texture.minFilter !== $e8ea6a63d48a4fea$export$727aa5ec3fe39bf0 && texture.minFilter !== $e8ea6a63d48a4fea$export$8a72f490b25c56c8) return Math.log2(Math.max(image.width, image.height)) + 1;
        else if (texture.mipmaps !== undefined && texture.mipmaps.length > 0) // user-defined mipmaps
        return texture.mipmaps.length;
        else if (texture.isCompressedTexture && Array.isArray(texture.image)) return image.mipmaps.length;
        else // texture without mipmaps (only base level)
        return 1;
    }
    // Fallback filters for non-power-of-2 textures
    function filterFallback(f) {
        if (f === $e8ea6a63d48a4fea$export$727aa5ec3fe39bf0 || f === $e8ea6a63d48a4fea$export$d129e38cf6feaa8c || f === $e8ea6a63d48a4fea$export$d2327c1afe5bfdf2) return 9728;
        return 9729;
    }
    //
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener("dispose", onTextureDispose);
        deallocateTexture(texture);
        if (texture.isVideoTexture) _videoTextures.delete(texture);
    }
    function onRenderTargetDispose(event) {
        const renderTarget = event.target;
        renderTarget.removeEventListener("dispose", onRenderTargetDispose);
        deallocateRenderTarget(renderTarget);
    }
    //
    function deallocateTexture(texture) {
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglInit === undefined) return;
        // check if it's necessary to remove the WebGLTexture object
        const source = texture.source;
        const webglTextures = _sources.get(source);
        if (webglTextures) {
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            webglTexture.usedTimes--;
            // the WebGLTexture object is not used anymore, remove it
            if (webglTexture.usedTimes === 0) deleteTexture(texture);
            // remove the weak map entry if no WebGLTexture uses the source anymore
            if (Object.keys(webglTextures).length === 0) _sources.delete(source);
        }
        properties.remove(texture);
    }
    function deleteTexture(texture) {
        const textureProperties = properties.get(texture);
        _gl.deleteTexture(textureProperties.__webglTexture);
        const source = texture.source;
        const webglTextures = _sources.get(source);
        delete webglTextures[textureProperties.__cacheKey];
        info.memory.textures--;
    }
    function deallocateRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglTexture !== undefined) {
            _gl.deleteTexture(textureProperties.__webglTexture);
            info.memory.textures--;
        }
        if (renderTarget.depthTexture) renderTarget.depthTexture.dispose();
        if (renderTarget.isWebGLCubeRenderTarget) for(let i = 0; i < 6; i++){
            _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
        }
        else {
            _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
            if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
            if (renderTargetProperties.__webglColorRenderbuffer) {
                for(let i = 0; i < renderTargetProperties.__webglColorRenderbuffer.length; i++)if (renderTargetProperties.__webglColorRenderbuffer[i]) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer[i]);
            }
            if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
        }
        if (renderTarget.isWebGLMultipleRenderTargets) for(let i = 0, il = texture.length; i < il; i++){
            const attachmentProperties = properties.get(texture[i]);
            if (attachmentProperties.__webglTexture) {
                _gl.deleteTexture(attachmentProperties.__webglTexture);
                info.memory.textures--;
            }
            properties.remove(texture[i]);
        }
        properties.remove(texture);
        properties.remove(renderTarget);
    }
    //
    let textureUnits = 0;
    function resetTextureUnits() {
        textureUnits = 0;
    }
    function allocateTextureUnit() {
        const textureUnit = textureUnits;
        if (textureUnit >= maxTextures) console.warn("THREE.WebGLTextures: Trying to use " + textureUnit + " texture units while this GPU supports only " + maxTextures);
        textureUnits += 1;
        return textureUnit;
    }
    function getTextureCacheKey(texture) {
        const array = [];
        array.push(texture.wrapS);
        array.push(texture.wrapT);
        array.push(texture.wrapR || 0);
        array.push(texture.magFilter);
        array.push(texture.minFilter);
        array.push(texture.anisotropy);
        array.push(texture.internalFormat);
        array.push(texture.format);
        array.push(texture.type);
        array.push(texture.generateMipmaps);
        array.push(texture.premultiplyAlpha);
        array.push(texture.flipY);
        array.push(texture.unpackAlignment);
        array.push(texture.encoding);
        return array.join();
    }
    //
    function setTexture2D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isVideoTexture) updateVideoTexture(texture);
        if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
            const image = texture.image;
            if (image === null) console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");
            else if (image.complete === false) console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
            else {
                uploadTexture(textureProperties, texture, slot);
                return;
            }
        }
        state.bindTexture(3553, textureProperties.__webglTexture, 33984 + slot);
    }
    function setTexture2DArray(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(35866, textureProperties.__webglTexture, 33984 + slot);
    }
    function setTexture3D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(32879, textureProperties.__webglTexture, 33984 + slot);
    }
    function setTextureCube(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadCubeTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(34067, textureProperties.__webglTexture, 33984 + slot);
    }
    const wrappingToGL = {
        [$e8ea6a63d48a4fea$export$533346c8e8dac0f5]: 10497,
        [$e8ea6a63d48a4fea$export$9d9334239a5a5e06]: 33071,
        [$e8ea6a63d48a4fea$export$c7e7c00b14f51a4f]: 33648
    };
    const filterToGL = {
        [$e8ea6a63d48a4fea$export$727aa5ec3fe39bf0]: 9728,
        [$e8ea6a63d48a4fea$export$d129e38cf6feaa8c]: 9984,
        [$e8ea6a63d48a4fea$export$d2327c1afe5bfdf2]: 9986,
        [$e8ea6a63d48a4fea$export$8a72f490b25c56c8]: 9729,
        [$e8ea6a63d48a4fea$export$19a719f377145a13]: 9985,
        [$e8ea6a63d48a4fea$export$5d8599b6a933fb1b]: 9987
    };
    function setTextureParameters(textureType, texture, supportsMips) {
        if (supportsMips) {
            _gl.texParameteri(textureType, 10242, wrappingToGL[texture.wrapS]);
            _gl.texParameteri(textureType, 10243, wrappingToGL[texture.wrapT]);
            if (textureType === 32879 || textureType === 35866) _gl.texParameteri(textureType, 32882, wrappingToGL[texture.wrapR]);
            _gl.texParameteri(textureType, 10240, filterToGL[texture.magFilter]);
            _gl.texParameteri(textureType, 10241, filterToGL[texture.minFilter]);
        } else {
            _gl.texParameteri(textureType, 10242, 33071);
            _gl.texParameteri(textureType, 10243, 33071);
            if (textureType === 32879 || textureType === 35866) _gl.texParameteri(textureType, 32882, 33071);
            if (texture.wrapS !== $e8ea6a63d48a4fea$export$9d9334239a5a5e06 || texture.wrapT !== $e8ea6a63d48a4fea$export$9d9334239a5a5e06) console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping.");
            _gl.texParameteri(textureType, 10240, filterFallback(texture.magFilter));
            _gl.texParameteri(textureType, 10241, filterFallback(texture.minFilter));
            if (texture.minFilter !== $e8ea6a63d48a4fea$export$727aa5ec3fe39bf0 && texture.minFilter !== $e8ea6a63d48a4fea$export$8a72f490b25c56c8) console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.");
        }
        if (extensions.has("EXT_texture_filter_anisotropic") === true) {
            const extension = extensions.get("EXT_texture_filter_anisotropic");
            if (texture.magFilter === $e8ea6a63d48a4fea$export$727aa5ec3fe39bf0) return;
            if (texture.minFilter !== $e8ea6a63d48a4fea$export$d2327c1afe5bfdf2 && texture.minFilter !== $e8ea6a63d48a4fea$export$5d8599b6a933fb1b) return;
            if (texture.type === $e8ea6a63d48a4fea$export$f6d331659b644596 && extensions.has("OES_texture_float_linear") === false) return; // verify extension for WebGL 1 and WebGL 2
            if (isWebGL2 === false && texture.type === $e8ea6a63d48a4fea$export$2697304443f382bc && extensions.has("OES_texture_half_float_linear") === false) return; // verify extension for WebGL 1 only
            if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
                _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
                properties.get(texture).__currentAnisotropy = texture.anisotropy;
            }
        }
    }
    function initTexture(textureProperties, texture) {
        let forceUpload = false;
        if (textureProperties.__webglInit === undefined) {
            textureProperties.__webglInit = true;
            texture.addEventListener("dispose", onTextureDispose);
        }
        // create Source <-> WebGLTextures mapping if necessary
        const source = texture.source;
        let webglTextures = _sources.get(source);
        if (webglTextures === undefined) {
            webglTextures = {};
            _sources.set(source, webglTextures);
        }
        // check if there is already a WebGLTexture object for the given texture parameters
        const textureCacheKey = getTextureCacheKey(texture);
        if (textureCacheKey !== textureProperties.__cacheKey) {
            // if not, create a new instance of WebGLTexture
            if (webglTextures[textureCacheKey] === undefined) {
                // create new entry
                webglTextures[textureCacheKey] = {
                    texture: _gl.createTexture(),
                    usedTimes: 0
                };
                info.memory.textures++;
                // when a new instance of WebGLTexture was created, a texture upload is required
                // even if the image contents are identical
                forceUpload = true;
            }
            webglTextures[textureCacheKey].usedTimes++;
            // every time the texture cache key changes, it's necessary to check if an instance of
            // WebGLTexture can be deleted in order to avoid a memory leak.
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            if (webglTexture !== undefined) {
                webglTextures[textureProperties.__cacheKey].usedTimes--;
                if (webglTexture.usedTimes === 0) deleteTexture(texture);
            }
            // store references to cache key and WebGLTexture object
            textureProperties.__cacheKey = textureCacheKey;
            textureProperties.__webglTexture = webglTextures[textureCacheKey].texture;
        }
        return forceUpload;
    }
    function uploadTexture(textureProperties, texture, slot) {
        let textureType = 3553;
        if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textureType = 35866;
        if (texture.isData3DTexture) textureType = 32879;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(textureType, textureProperties.__webglTexture, 33984 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(33984 + slot);
            _gl.pixelStorei(37440, texture.flipY);
            _gl.pixelStorei(37441, texture.premultiplyAlpha);
            _gl.pixelStorei(3317, texture.unpackAlignment);
            _gl.pixelStorei(37443, 0);
            const needsPowerOfTwo = textureNeedsPowerOfTwo(texture) && isPowerOfTwo$1(texture.image) === false;
            let image = resizeImage(texture.image, needsPowerOfTwo, false, maxTextureSize);
            image = verifyColorSpace(texture, image);
            const supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils.convert(texture.format, texture.encoding);
            let glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding, texture.isVideoTexture);
            setTextureParameters(textureType, texture, supportsMips);
            let mipmap;
            const mipmaps = texture.mipmaps;
            const useTexStorage = isWebGL2 && texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            const levels = getMipLevels(texture, image, supportsMips);
            if (texture.isDepthTexture) {
                // populate depth texture with dummy data
                glInternalFormat = 6402;
                if (isWebGL2) {
                    if (texture.type === $e8ea6a63d48a4fea$export$f6d331659b644596) glInternalFormat = 36012;
                    else if (texture.type === $e8ea6a63d48a4fea$export$c3c7fc4518ebba96) glInternalFormat = 33190;
                    else if (texture.type === $e8ea6a63d48a4fea$export$6c8ea339bfab1301) glInternalFormat = 35056;
                    else glInternalFormat = 33189; // WebGL2 requires sized internalformat for glTexImage2D
                } else if (texture.type === $e8ea6a63d48a4fea$export$f6d331659b644596) console.error("WebGLRenderer: Floating point depth texture requires WebGL2.");
                // validation checks for WebGL 1
                if (texture.format === $e8ea6a63d48a4fea$export$c1b6b5136be58045 && glInternalFormat === 6402) // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
                // DEPTH_COMPONENT and type is not UNSIGNED_SHORT or UNSIGNED_INT
                // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                {
                    if (texture.type !== $e8ea6a63d48a4fea$export$c63dc51868b06a9d && texture.type !== $e8ea6a63d48a4fea$export$c3c7fc4518ebba96) {
                        console.warn("THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture.");
                        texture.type = $e8ea6a63d48a4fea$export$c3c7fc4518ebba96;
                        glType = utils.convert(texture.type);
                    }
                }
                if (texture.format === $e8ea6a63d48a4fea$export$1e113ac2d0905829 && glInternalFormat === 6402) {
                    // Depth stencil textures need the DEPTH_STENCIL internal format
                    // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                    glInternalFormat = 34041;
                    // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
                    // DEPTH_STENCIL and type is not UNSIGNED_INT_24_8_WEBGL.
                    // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                    if (texture.type !== $e8ea6a63d48a4fea$export$6c8ea339bfab1301) {
                        console.warn("THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture.");
                        texture.type = $e8ea6a63d48a4fea$export$6c8ea339bfab1301;
                        glType = utils.convert(texture.type);
                    }
                }
                //
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(3553, 1, glInternalFormat, image.width, image.height);
                    else state.texImage2D(3553, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
                }
            } else if (texture.isDataTexture) {
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0 && supportsMips) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(3553, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) state.texSubImage2D(3553, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        else state.texImage2D(3553, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(3553, levels, glInternalFormat, image.width, image.height);
                    state.texSubImage2D(3553, 0, 0, 0, image.width, image.height, glFormat, glType, image.data);
                } else state.texImage2D(3553, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
            } else if (texture.isCompressedTexture) {
                if (texture.isCompressedArrayTexture) {
                    if (useTexStorage && allocateMemory) state.texStorage3D(35866, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height, image.depth);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== $e8ea6a63d48a4fea$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) state.compressedTexSubImage3D(35866, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, mipmap.data, 0, 0);
                                else state.compressedTexImage3D(35866, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, mipmap.data, 0, 0);
                            } else console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
                        } else if (useTexStorage) state.texSubImage3D(35866, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, glType, mipmap.data);
                        else state.texImage3D(35866, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, glFormat, glType, mipmap.data);
                    }
                } else {
                    if (useTexStorage && allocateMemory) state.texStorage2D(3553, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== $e8ea6a63d48a4fea$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) state.compressedTexSubImage2D(3553, i, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                else state.compressedTexImage2D(3553, i, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
                        } else if (useTexStorage) state.texSubImage2D(3553, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        else state.texImage2D(3553, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                }
            } else if (texture.isDataArrayTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(35866, levels, glInternalFormat, image.width, image.height, image.depth);
                    state.texSubImage3D(35866, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(35866, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isData3DTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(32879, levels, glInternalFormat, image.width, image.height, image.depth);
                    state.texSubImage3D(32879, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(32879, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isFramebufferTexture) {
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(3553, levels, glInternalFormat, image.width, image.height);
                    else {
                        let width = image.width, height = image.height;
                        for(let i = 0; i < levels; i++){
                            state.texImage2D(3553, i, glInternalFormat, width, height, 0, glFormat, glType, null);
                            width >>= 1;
                            height >>= 1;
                        }
                    }
                }
            } else {
                // regular Texture (image, video, canvas)
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0 && supportsMips) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(3553, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) state.texSubImage2D(3553, i, 0, 0, glFormat, glType, mipmap);
                        else state.texImage2D(3553, i, glInternalFormat, glFormat, glType, mipmap);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(3553, levels, glInternalFormat, image.width, image.height);
                    state.texSubImage2D(3553, 0, 0, 0, glFormat, glType, image);
                } else state.texImage2D(3553, 0, glInternalFormat, glFormat, glType, image);
            }
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(textureType);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    function uploadCubeTexture(textureProperties, texture, slot) {
        if (texture.image.length !== 6) return;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(34067, textureProperties.__webglTexture, 33984 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(33984 + slot);
            _gl.pixelStorei(37440, texture.flipY);
            _gl.pixelStorei(37441, texture.premultiplyAlpha);
            _gl.pixelStorei(3317, texture.unpackAlignment);
            _gl.pixelStorei(37443, 0);
            const isCompressed = texture.isCompressedTexture || texture.image[0].isCompressedTexture;
            const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
            const cubeImage = [];
            for(let i = 0; i < 6; i++){
                if (!isCompressed && !isDataTexture) cubeImage[i] = resizeImage(texture.image[i], false, true, maxCubemapSize);
                else cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
                cubeImage[i] = verifyColorSpace(texture, cubeImage[i]);
            }
            const image = cubeImage[0], supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils.convert(texture.format, texture.encoding), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding);
            const useTexStorage = isWebGL2 && texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            let levels = getMipLevels(texture, image, supportsMips);
            setTextureParameters(34067, texture, supportsMips);
            let mipmaps;
            if (isCompressed) {
                if (useTexStorage && allocateMemory) state.texStorage2D(34067, levels, glInternalFormat, image.width, image.height);
                for(let i = 0; i < 6; i++){
                    mipmaps = cubeImage[i].mipmaps;
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (texture.format !== $e8ea6a63d48a4fea$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) state.compressedTexSubImage2D(34069 + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                else state.compressedTexImage2D(34069 + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()");
                        } else if (useTexStorage) state.texSubImage2D(34069 + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        else state.texImage2D(34069 + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                }
            } else {
                mipmaps = texture.mipmaps;
                if (useTexStorage && allocateMemory) {
                    // TODO: Uniformly handle mipmap definitions
                    // Normal textures and compressed cube textures define base level + mips with their mipmap array
                    // Uncompressed cube textures use their mipmap array only for mips (no base level)
                    if (mipmaps.length > 0) levels++;
                    state.texStorage2D(34067, levels, glInternalFormat, cubeImage[0].width, cubeImage[0].height);
                }
                for(let i = 0; i < 6; i++)if (isDataTexture) {
                    if (useTexStorage) state.texSubImage2D(34069 + i, 0, 0, 0, cubeImage[i].width, cubeImage[i].height, glFormat, glType, cubeImage[i].data);
                    else state.texImage2D(34069 + i, 0, glInternalFormat, cubeImage[i].width, cubeImage[i].height, 0, glFormat, glType, cubeImage[i].data);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        const mipmapImage = mipmap.image[i].image;
                        if (useTexStorage) state.texSubImage2D(34069 + i, j + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data);
                        else state.texImage2D(34069 + i, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
                    }
                } else {
                    if (useTexStorage) state.texSubImage2D(34069 + i, 0, 0, 0, glFormat, glType, cubeImage[i]);
                    else state.texImage2D(34069 + i, 0, glInternalFormat, glFormat, glType, cubeImage[i]);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (useTexStorage) state.texSubImage2D(34069 + i, j + 1, 0, 0, glFormat, glType, mipmap.image[i]);
                        else state.texImage2D(34069 + i, j + 1, glInternalFormat, glFormat, glType, mipmap.image[i]);
                    }
                }
            }
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) // We assume images for cube map have the same size.
            generateMipmap(34067);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    // Render targets
    // Setup storage for target texture and bind it to correct framebuffer
    function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget) {
        const glFormat = utils.convert(texture.format, texture.encoding);
        const glType = utils.convert(texture.type);
        const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding);
        const renderTargetProperties = properties.get(renderTarget);
        if (!renderTargetProperties.__hasExternalTextures) {
            if (textureTarget === 32879 || textureTarget === 35866) state.texImage3D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, renderTarget.depth, 0, glFormat, glType, null);
            else state.texImage2D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, 0, glFormat, glType, null);
        }
        state.bindFramebuffer(36160, framebuffer);
        if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(36160, attachment, textureTarget, properties.get(texture).__webglTexture, 0, getRenderTargetSamples(renderTarget));
        else if (textureTarget === 3553 || textureTarget >= 34069 && textureTarget <= 34074) _gl.framebufferTexture2D(36160, attachment, textureTarget, properties.get(texture).__webglTexture, 0);
        state.bindFramebuffer(36160, null);
    }
    // Setup storage for internal depth/stencil buffers and bind to correct framebuffer
    function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
        _gl.bindRenderbuffer(36161, renderbuffer);
        if (renderTarget.depthBuffer && !renderTarget.stencilBuffer) {
            let glInternalFormat = 33189;
            if (isMultisample || useMultisampledRTT(renderTarget)) {
                const depthTexture = renderTarget.depthTexture;
                if (depthTexture && depthTexture.isDepthTexture) {
                    if (depthTexture.type === $e8ea6a63d48a4fea$export$f6d331659b644596) glInternalFormat = 36012;
                    else if (depthTexture.type === $e8ea6a63d48a4fea$export$c3c7fc4518ebba96) glInternalFormat = 33190;
                }
                const samples = getRenderTargetSamples(renderTarget);
                if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            } else _gl.renderbufferStorage(36161, glInternalFormat, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(36160, 36096, 36161, renderbuffer);
        } else if (renderTarget.depthBuffer && renderTarget.stencilBuffer) {
            const samples = getRenderTargetSamples(renderTarget);
            if (isMultisample && useMultisampledRTT(renderTarget) === false) _gl.renderbufferStorageMultisample(36161, samples, 35056, renderTarget.width, renderTarget.height);
            else if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(36161, samples, 35056, renderTarget.width, renderTarget.height);
            else _gl.renderbufferStorage(36161, 34041, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(36160, 33306, 36161, renderbuffer);
        } else {
            const textures = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture : [
                renderTarget.texture
            ];
            for(let i = 0; i < textures.length; i++){
                const texture = textures[i];
                const glFormat = utils.convert(texture.format, texture.encoding);
                const glType = utils.convert(texture.type);
                const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding);
                const samples = getRenderTargetSamples(renderTarget);
                if (isMultisample && useMultisampledRTT(renderTarget) === false) _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorage(36161, glInternalFormat, renderTarget.width, renderTarget.height);
            }
        }
        _gl.bindRenderbuffer(36161, null);
    }
    // Setup resources for a Depth Texture for a FBO (needs an extension)
    function setupDepthTexture(framebuffer, renderTarget) {
        const isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
        if (isCube) throw new Error("Depth Texture with cube render targets is not supported");
        state.bindFramebuffer(36160, framebuffer);
        if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
        // upload an empty depth texture with framebuffer size
        if (!properties.get(renderTarget.depthTexture).__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
            renderTarget.depthTexture.image.width = renderTarget.width;
            renderTarget.depthTexture.image.height = renderTarget.height;
            renderTarget.depthTexture.needsUpdate = true;
        }
        setTexture2D(renderTarget.depthTexture, 0);
        const webglDepthTexture = properties.get(renderTarget.depthTexture).__webglTexture;
        const samples = getRenderTargetSamples(renderTarget);
        if (renderTarget.depthTexture.format === $e8ea6a63d48a4fea$export$c1b6b5136be58045) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(36160, 36096, 3553, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(36160, 36096, 3553, webglDepthTexture, 0);
        } else if (renderTarget.depthTexture.format === $e8ea6a63d48a4fea$export$1e113ac2d0905829) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(36160, 33306, 3553, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(36160, 33306, 3553, webglDepthTexture, 0);
        } else throw new Error("Unknown depthTexture format");
    }
    // Setup GL resources for a non-texture depth buffer
    function setupDepthRenderbuffer(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        if (renderTarget.depthTexture && !renderTargetProperties.__autoAllocateDepthBuffer) {
            if (isCube) throw new Error("target.depthTexture not supported in Cube render targets");
            setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
        } else if (isCube) {
            renderTargetProperties.__webglDepthbuffer = [];
            for(let i = 0; i < 6; i++){
                state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer[i]);
                renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
                setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
            }
        } else {
            state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer);
            renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
            setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
        }
        state.bindFramebuffer(36160, null);
    }
    // rebind framebuffer with external textures
    function rebindTextures(renderTarget, colorTexture, depthTexture) {
        const renderTargetProperties = properties.get(renderTarget);
        if (colorTexture !== undefined) setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, 36064, 3553);
        if (depthTexture !== undefined) setupDepthRenderbuffer(renderTarget);
    }
    // Set up GL resources for the render target
    function setupRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        renderTarget.addEventListener("dispose", onRenderTargetDispose);
        if (renderTarget.isWebGLMultipleRenderTargets !== true) {
            if (textureProperties.__webglTexture === undefined) textureProperties.__webglTexture = _gl.createTexture();
            textureProperties.__version = texture.version;
            info.memory.textures++;
        }
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        const isMultipleRenderTargets = renderTarget.isWebGLMultipleRenderTargets === true;
        const supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
        // Setup framebuffer
        if (isCube) {
            renderTargetProperties.__webglFramebuffer = [];
            for(let i = 0; i < 6; i++)renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
        } else {
            renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
            if (isMultipleRenderTargets) {
                if (capabilities.drawBuffers) {
                    const textures = renderTarget.texture;
                    for(let i = 0, il = textures.length; i < il; i++){
                        const attachmentProperties = properties.get(textures[i]);
                        if (attachmentProperties.__webglTexture === undefined) {
                            attachmentProperties.__webglTexture = _gl.createTexture();
                            info.memory.textures++;
                        }
                    }
                } else console.warn("THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.");
            }
            if (isWebGL2 && renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
                const textures = isMultipleRenderTargets ? texture : [
                    texture
                ];
                renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
                renderTargetProperties.__webglColorRenderbuffer = [];
                state.bindFramebuffer(36160, renderTargetProperties.__webglMultisampledFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    const texture = textures[i];
                    renderTargetProperties.__webglColorRenderbuffer[i] = _gl.createRenderbuffer();
                    _gl.bindRenderbuffer(36161, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const glFormat = utils.convert(texture.format, texture.encoding);
                    const glType = utils.convert(texture.type);
                    const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding, renderTarget.isXRRenderTarget === true);
                    const samples = getRenderTargetSamples(renderTarget);
                    _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                    _gl.framebufferRenderbuffer(36160, 36064 + i, 36161, renderTargetProperties.__webglColorRenderbuffer[i]);
                }
                _gl.bindRenderbuffer(36161, null);
                if (renderTarget.depthBuffer) {
                    renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
                }
                state.bindFramebuffer(36160, null);
            }
        }
        // Setup color buffer
        if (isCube) {
            state.bindTexture(34067, textureProperties.__webglTexture);
            setTextureParameters(34067, texture, supportsMips);
            for(let i = 0; i < 6; i++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i], renderTarget, texture, 36064, 34069 + i);
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(34067);
            state.unbindTexture();
        } else if (isMultipleRenderTargets) {
            const textures = renderTarget.texture;
            for(let i = 0, il = textures.length; i < il; i++){
                const attachment = textures[i];
                const attachmentProperties = properties.get(attachment);
                state.bindTexture(3553, attachmentProperties.__webglTexture);
                setTextureParameters(3553, attachment, supportsMips);
                setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, 36064 + i, 3553);
                if (textureNeedsGenerateMipmaps(attachment, supportsMips)) generateMipmap(3553);
            }
            state.unbindTexture();
        } else {
            let glTextureType = 3553;
            if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) {
                if (isWebGL2) glTextureType = renderTarget.isWebGL3DRenderTarget ? 32879 : 35866;
                else console.error("THREE.WebGLTextures: THREE.Data3DTexture and THREE.DataArrayTexture only supported with WebGL2.");
            }
            state.bindTexture(glTextureType, textureProperties.__webglTexture);
            setTextureParameters(glTextureType, texture, supportsMips);
            setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, 36064, glTextureType);
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(glTextureType);
            state.unbindTexture();
        }
        // Setup depth and stencil buffers
        if (renderTarget.depthBuffer) setupDepthRenderbuffer(renderTarget);
    }
    function updateRenderTargetMipmap(renderTarget) {
        const supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
        const textures = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture : [
            renderTarget.texture
        ];
        for(let i = 0, il = textures.length; i < il; i++){
            const texture = textures[i];
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
                const target = renderTarget.isWebGLCubeRenderTarget ? 34067 : 3553;
                const webglTexture = properties.get(texture).__webglTexture;
                state.bindTexture(target, webglTexture);
                generateMipmap(target);
                state.unbindTexture();
            }
        }
    }
    function updateMultisampleRenderTarget(renderTarget) {
        if (isWebGL2 && renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
            const textures = renderTarget.isWebGLMultipleRenderTargets ? renderTarget.texture : [
                renderTarget.texture
            ];
            const width = renderTarget.width;
            const height = renderTarget.height;
            let mask = 16384;
            const invalidationArray = [];
            const depthStyle = renderTarget.stencilBuffer ? 33306 : 36096;
            const renderTargetProperties = properties.get(renderTarget);
            const isMultipleRenderTargets = renderTarget.isWebGLMultipleRenderTargets === true;
            // If MRT we need to remove FBO attachments
            if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                state.bindFramebuffer(36160, renderTargetProperties.__webglMultisampledFramebuffer);
                _gl.framebufferRenderbuffer(36160, 36064 + i, 36161, null);
                state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer);
                _gl.framebufferTexture2D(36009, 36064 + i, 3553, null, 0);
            }
            state.bindFramebuffer(36008, renderTargetProperties.__webglMultisampledFramebuffer);
            state.bindFramebuffer(36009, renderTargetProperties.__webglFramebuffer);
            for(let i = 0; i < textures.length; i++){
                invalidationArray.push(36064 + i);
                if (renderTarget.depthBuffer) invalidationArray.push(depthStyle);
                const ignoreDepthValues = renderTargetProperties.__ignoreDepthValues !== undefined ? renderTargetProperties.__ignoreDepthValues : false;
                if (ignoreDepthValues === false) {
                    if (renderTarget.depthBuffer) mask |= 256;
                    if (renderTarget.stencilBuffer) mask |= 1024;
                }
                if (isMultipleRenderTargets) _gl.framebufferRenderbuffer(36008, 36064, 36161, renderTargetProperties.__webglColorRenderbuffer[i]);
                if (ignoreDepthValues === true) {
                    _gl.invalidateFramebuffer(36008, [
                        depthStyle
                    ]);
                    _gl.invalidateFramebuffer(36009, [
                        depthStyle
                    ]);
                }
                if (isMultipleRenderTargets) {
                    const webglTexture = properties.get(textures[i]).__webglTexture;
                    _gl.framebufferTexture2D(36009, 36064, 3553, webglTexture, 0);
                }
                _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, 9728);
                if (supportsInvalidateFramebuffer) _gl.invalidateFramebuffer(36008, invalidationArray);
            }
            state.bindFramebuffer(36008, null);
            state.bindFramebuffer(36009, null);
            // If MRT since pre-blit we removed the FBO we need to reconstruct the attachments
            if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                state.bindFramebuffer(36160, renderTargetProperties.__webglMultisampledFramebuffer);
                _gl.framebufferRenderbuffer(36160, 36064 + i, 36161, renderTargetProperties.__webglColorRenderbuffer[i]);
                const webglTexture = properties.get(textures[i]).__webglTexture;
                state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer);
                _gl.framebufferTexture2D(36009, 36064 + i, 3553, webglTexture, 0);
            }
            state.bindFramebuffer(36009, renderTargetProperties.__webglMultisampledFramebuffer);
        }
    }
    function getRenderTargetSamples(renderTarget) {
        return Math.min(maxSamples, renderTarget.samples);
    }
    function useMultisampledRTT(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        return isWebGL2 && renderTarget.samples > 0 && extensions.has("WEBGL_multisampled_render_to_texture") === true && renderTargetProperties.__useRenderToTexture !== false;
    }
    function updateVideoTexture(texture) {
        const frame = info.render.frame;
        // Check the last frame we updated the VideoTexture
        if (_videoTextures.get(texture) !== frame) {
            _videoTextures.set(texture, frame);
            texture.update();
        }
    }
    function verifyColorSpace(texture, image) {
        const encoding = texture.encoding;
        const format = texture.format;
        const type = texture.type;
        if (texture.isCompressedTexture === true || texture.isVideoTexture === true || texture.format === $e8ea6a63d48a4fea$export$ca1dce8b5e1de74d) return image;
        if (encoding !== $e8ea6a63d48a4fea$export$7207336e4151a112) {
            // sRGB
            if (encoding === $e8ea6a63d48a4fea$export$f32388edbb32674) {
                if (isWebGL2 === false) {
                    // in WebGL 1, try to use EXT_sRGB extension and unsized formats
                    if (extensions.has("EXT_sRGB") === true && format === $e8ea6a63d48a4fea$export$3f8bb04b555a363c) {
                        texture.format = $e8ea6a63d48a4fea$export$ca1dce8b5e1de74d;
                        // it's not possible to generate mips in WebGL 1 with this extension
                        texture.minFilter = $e8ea6a63d48a4fea$export$8a72f490b25c56c8;
                        texture.generateMipmaps = false;
                    } else // slow fallback (CPU decode)
                    image = $e8ea6a63d48a4fea$export$698882cf06df44aa.sRGBToLinear(image);
                } else // in WebGL 2 uncompressed textures can only be sRGB encoded if they have the RGBA8 format
                if (format !== $e8ea6a63d48a4fea$export$3f8bb04b555a363c || type !== $e8ea6a63d48a4fea$export$2e8ce08d3f6f5e10) console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.");
            } else console.error("THREE.WebGLTextures: Unsupported texture encoding:", encoding);
        }
        return image;
    }
    //
    this.allocateTextureUnit = allocateTextureUnit;
    this.resetTextureUnits = resetTextureUnits;
    this.setTexture2D = setTexture2D;
    this.setTexture2DArray = setTexture2DArray;
    this.setTexture3D = setTexture3D;
    this.setTextureCube = setTextureCube;
    this.rebindTextures = rebindTextures;
    this.setupRenderTarget = setupRenderTarget;
    this.updateRenderTargetMipmap = updateRenderTargetMipmap;
    this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
    this.setupDepthRenderbuffer = setupDepthRenderbuffer;
    this.setupFrameBufferTexture = setupFrameBufferTexture;
    this.useMultisampledRTT = useMultisampledRTT;
}
function $e8ea6a63d48a4fea$export$ddaebcad857649a8(gl, extensions, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    function convert(p, encoding = null) {
        let extension;
        if (p === $e8ea6a63d48a4fea$export$2e8ce08d3f6f5e10) return 5121;
        if (p === $e8ea6a63d48a4fea$export$b3969b01faf587f2) return 32819;
        if (p === $e8ea6a63d48a4fea$export$18886f8ae33e90de) return 32820;
        if (p === $e8ea6a63d48a4fea$export$545fce0311a9796a) return 5120;
        if (p === $e8ea6a63d48a4fea$export$88572337f312435f) return 5122;
        if (p === $e8ea6a63d48a4fea$export$c63dc51868b06a9d) return 5123;
        if (p === $e8ea6a63d48a4fea$export$5c612977753abe2) return 5124;
        if (p === $e8ea6a63d48a4fea$export$c3c7fc4518ebba96) return 5125;
        if (p === $e8ea6a63d48a4fea$export$f6d331659b644596) return 5126;
        if (p === $e8ea6a63d48a4fea$export$2697304443f382bc) {
            if (isWebGL2) return 5131;
            extension = extensions.get("OES_texture_half_float");
            if (extension !== null) return extension.HALF_FLOAT_OES;
            else return null;
        }
        if (p === $e8ea6a63d48a4fea$export$988473390501ed4b) return 6406;
        if (p === $e8ea6a63d48a4fea$export$3f8bb04b555a363c) return 6408;
        if (p === $e8ea6a63d48a4fea$export$cc09ccbf6d1ed449) return 6409;
        if (p === $e8ea6a63d48a4fea$export$9053a81c4a69c289) return 6410;
        if (p === $e8ea6a63d48a4fea$export$c1b6b5136be58045) return 6402;
        if (p === $e8ea6a63d48a4fea$export$1e113ac2d0905829) return 34041;
        // WebGL 1 sRGB fallback
        if (p === $e8ea6a63d48a4fea$export$ca1dce8b5e1de74d) {
            extension = extensions.get("EXT_sRGB");
            if (extension !== null) return extension.SRGB_ALPHA_EXT;
            else return null;
        }
        // WebGL2 formats.
        if (p === $e8ea6a63d48a4fea$export$4e041a7967d15c4b) return 6403;
        if (p === $e8ea6a63d48a4fea$export$aa92e870a709d190) return 36244;
        if (p === $e8ea6a63d48a4fea$export$6cdf0b461c7ce8a0) return 33319;
        if (p === $e8ea6a63d48a4fea$export$1ba1c45f9f77d4d7) return 33320;
        if (p === $e8ea6a63d48a4fea$export$c200e7d26f592f21) return 36249;
        // S3TC
        if (p === $e8ea6a63d48a4fea$export$21d1799c6d552fc0 || p === $e8ea6a63d48a4fea$export$afa304c3e981b668 || p === $e8ea6a63d48a4fea$export$d2a1a68024a3e56c || p === $e8ea6a63d48a4fea$export$9a79c424327dacf9) {
            if (encoding === $e8ea6a63d48a4fea$export$f32388edbb32674) {
                extension = extensions.get("WEBGL_compressed_texture_s3tc_srgb");
                if (extension !== null) {
                    if (p === $e8ea6a63d48a4fea$export$21d1799c6d552fc0) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (p === $e8ea6a63d48a4fea$export$afa304c3e981b668) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (p === $e8ea6a63d48a4fea$export$d2a1a68024a3e56c) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (p === $e8ea6a63d48a4fea$export$9a79c424327dacf9) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else {
                extension = extensions.get("WEBGL_compressed_texture_s3tc");
                if (extension !== null) {
                    if (p === $e8ea6a63d48a4fea$export$21d1799c6d552fc0) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                    if (p === $e8ea6a63d48a4fea$export$afa304c3e981b668) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                    if (p === $e8ea6a63d48a4fea$export$d2a1a68024a3e56c) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                    if (p === $e8ea6a63d48a4fea$export$9a79c424327dacf9) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                } else return null;
            }
        }
        // PVRTC
        if (p === $e8ea6a63d48a4fea$export$19ada9bbb1af3573 || p === $e8ea6a63d48a4fea$export$d0f0355bb3d948e4 || p === $e8ea6a63d48a4fea$export$b82296714358084c || p === $e8ea6a63d48a4fea$export$b71692456c47b6c3) {
            extension = extensions.get("WEBGL_compressed_texture_pvrtc");
            if (extension !== null) {
                if (p === $e8ea6a63d48a4fea$export$19ada9bbb1af3573) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (p === $e8ea6a63d48a4fea$export$d0f0355bb3d948e4) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (p === $e8ea6a63d48a4fea$export$b82296714358084c) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (p === $e8ea6a63d48a4fea$export$b71692456c47b6c3) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        // ETC1
        if (p === $e8ea6a63d48a4fea$export$6ab91af2d757aee7) {
            extension = extensions.get("WEBGL_compressed_texture_etc1");
            if (extension !== null) return extension.COMPRESSED_RGB_ETC1_WEBGL;
            else return null;
        }
        // ETC2
        if (p === $e8ea6a63d48a4fea$export$7800993ef8106a6a || p === $e8ea6a63d48a4fea$export$23ed8300a860e7d8) {
            extension = extensions.get("WEBGL_compressed_texture_etc");
            if (extension !== null) {
                if (p === $e8ea6a63d48a4fea$export$7800993ef8106a6a) return encoding === $e8ea6a63d48a4fea$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
                if (p === $e8ea6a63d48a4fea$export$23ed8300a860e7d8) return encoding === $e8ea6a63d48a4fea$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
            } else return null;
        }
        // ASTC
        if (p === $e8ea6a63d48a4fea$export$dc5570b4a2b92d48 || p === $e8ea6a63d48a4fea$export$68880cd325f8b2fb || p === $e8ea6a63d48a4fea$export$7d2c0be323373d95 || p === $e8ea6a63d48a4fea$export$22b52da301fc3a3e || p === $e8ea6a63d48a4fea$export$c009e2cb4a66485e || p === $e8ea6a63d48a4fea$export$118fff5afa255b63 || p === $e8ea6a63d48a4fea$export$120713c829ae0667 || p === $e8ea6a63d48a4fea$export$c79eeabbf53313e9 || p === $e8ea6a63d48a4fea$export$443cf6567cdd6424 || p === $e8ea6a63d48a4fea$export$6573984fc9840780 || p === $e8ea6a63d48a4fea$export$e7aee563f30091de || p === $e8ea6a63d48a4fea$export$2eb8634622ddeab7 || p === $e8ea6a63d48a4fea$export$202b1ce7b5d25742 || p === $e8ea6a63d48a4fea$export$18ab77abd087e467) {
            extension = extensions.get("WEBGL_compressed_texture_astc");
            if (extension !== null) {
                if (p === $e8ea6a63d48a4fea$export$dc5570b4a2b92d48) return encoding === $e8ea6a63d48a4fea$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (p === $e8ea6a63d48a4fea$export$68880cd325f8b2fb) return encoding === $e8ea6a63d48a4fea$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (p === $e8ea6a63d48a4fea$export$7d2c0be323373d95) return encoding === $e8ea6a63d48a4fea$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (p === $e8ea6a63d48a4fea$export$22b52da301fc3a3e) return encoding === $e8ea6a63d48a4fea$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (p === $e8ea6a63d48a4fea$export$c009e2cb4a66485e) return encoding === $e8ea6a63d48a4fea$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (p === $e8ea6a63d48a4fea$export$118fff5afa255b63) return encoding === $e8ea6a63d48a4fea$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (p === $e8ea6a63d48a4fea$export$120713c829ae0667) return encoding === $e8ea6a63d48a4fea$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (p === $e8ea6a63d48a4fea$export$c79eeabbf53313e9) return encoding === $e8ea6a63d48a4fea$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (p === $e8ea6a63d48a4fea$export$443cf6567cdd6424) return encoding === $e8ea6a63d48a4fea$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (p === $e8ea6a63d48a4fea$export$6573984fc9840780) return encoding === $e8ea6a63d48a4fea$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (p === $e8ea6a63d48a4fea$export$e7aee563f30091de) return encoding === $e8ea6a63d48a4fea$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (p === $e8ea6a63d48a4fea$export$2eb8634622ddeab7) return encoding === $e8ea6a63d48a4fea$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (p === $e8ea6a63d48a4fea$export$202b1ce7b5d25742) return encoding === $e8ea6a63d48a4fea$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (p === $e8ea6a63d48a4fea$export$18ab77abd087e467) return encoding === $e8ea6a63d48a4fea$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        // BPTC
        if (p === $e8ea6a63d48a4fea$export$ce40b115e188bc81) {
            extension = extensions.get("EXT_texture_compression_bptc");
            if (extension !== null) {
                if (p === $e8ea6a63d48a4fea$export$ce40b115e188bc81) return encoding === $e8ea6a63d48a4fea$export$f32388edbb32674 ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
            } else return null;
        }
        // RGTC
        if (p === $e8ea6a63d48a4fea$export$b1688df4c4c21670 || p === $e8ea6a63d48a4fea$export$fc15e5d8261eed58 || p === $e8ea6a63d48a4fea$export$d220f6ade8463a0f || p === $e8ea6a63d48a4fea$export$768646d09dc1b6ef) {
            extension = extensions.get("EXT_texture_compression_rgtc");
            if (extension !== null) {
                if (p === $e8ea6a63d48a4fea$export$ce40b115e188bc81) return extension.COMPRESSED_RED_RGTC1_EXT;
                if (p === $e8ea6a63d48a4fea$export$fc15e5d8261eed58) return extension.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                if (p === $e8ea6a63d48a4fea$export$d220f6ade8463a0f) return extension.COMPRESSED_RED_GREEN_RGTC2_EXT;
                if (p === $e8ea6a63d48a4fea$export$768646d09dc1b6ef) return extension.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
            } else return null;
        }
        //
        if (p === $e8ea6a63d48a4fea$export$6c8ea339bfab1301) {
            if (isWebGL2) return 34042;
            extension = extensions.get("WEBGL_depth_texture");
            if (extension !== null) return extension.UNSIGNED_INT_24_8_WEBGL;
            else return null;
        }
        // if "p" can't be resolved, assume the user defines a WebGL constant as a string (fallback/workaround for packed RGB formats)
        return gl[p] !== undefined ? gl[p] : null;
    }
    return {
        convert: convert
    };
}
class $e8ea6a63d48a4fea$export$56b937d9e5581166 extends $e8ea6a63d48a4fea$export$74e4ae24825f68d7 {
    constructor(array = []){
        super();
        this.isArrayCamera = true;
        this.cameras = array;
    }
}
class $e8ea6a63d48a4fea$export$eb2fcfdbd7ba97d4 extends $e8ea6a63d48a4fea$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isGroup = true;
        this.type = "Group";
    }
}
const $e8ea6a63d48a4fea$var$_moveEvent = {
    type: "move"
};
class $e8ea6a63d48a4fea$var$WebXRController {
    constructor(){
        this._targetRay = null;
        this._grip = null;
        this._hand = null;
    }
    getHandSpace() {
        if (this._hand === null) {
            this._hand = new $e8ea6a63d48a4fea$export$eb2fcfdbd7ba97d4();
            this._hand.matrixAutoUpdate = false;
            this._hand.visible = false;
            this._hand.joints = {};
            this._hand.inputState = {
                pinching: false
            };
        }
        return this._hand;
    }
    getTargetRaySpace() {
        if (this._targetRay === null) {
            this._targetRay = new $e8ea6a63d48a4fea$export$eb2fcfdbd7ba97d4();
            this._targetRay.matrixAutoUpdate = false;
            this._targetRay.visible = false;
            this._targetRay.hasLinearVelocity = false;
            this._targetRay.linearVelocity = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
            this._targetRay.hasAngularVelocity = false;
            this._targetRay.angularVelocity = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        }
        return this._targetRay;
    }
    getGripSpace() {
        if (this._grip === null) {
            this._grip = new $e8ea6a63d48a4fea$export$eb2fcfdbd7ba97d4();
            this._grip.matrixAutoUpdate = false;
            this._grip.visible = false;
            this._grip.hasLinearVelocity = false;
            this._grip.linearVelocity = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
            this._grip.hasAngularVelocity = false;
            this._grip.angularVelocity = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        }
        return this._grip;
    }
    dispatchEvent(event) {
        if (this._targetRay !== null) this._targetRay.dispatchEvent(event);
        if (this._grip !== null) this._grip.dispatchEvent(event);
        if (this._hand !== null) this._hand.dispatchEvent(event);
        return this;
    }
    connect(inputSource) {
        if (inputSource && inputSource.hand) {
            const hand = this._hand;
            if (hand) for (const inputjoint of inputSource.hand.values())// Initialize hand with joints when connected
            this._getHandJoint(hand, inputjoint);
        }
        this.dispatchEvent({
            type: "connected",
            data: inputSource
        });
        return this;
    }
    disconnect(inputSource) {
        this.dispatchEvent({
            type: "disconnected",
            data: inputSource
        });
        if (this._targetRay !== null) this._targetRay.visible = false;
        if (this._grip !== null) this._grip.visible = false;
        if (this._hand !== null) this._hand.visible = false;
        return this;
    }
    update(inputSource, frame, referenceSpace) {
        let inputPose = null;
        let gripPose = null;
        let handPose = null;
        const targetRay = this._targetRay;
        const grip = this._grip;
        const hand = this._hand;
        if (inputSource && frame.session.visibilityState !== "visible-blurred") {
            if (hand && inputSource.hand) {
                handPose = true;
                for (const inputjoint of inputSource.hand.values()){
                    // Update the joints groups with the XRJoint poses
                    const jointPose = frame.getJointPose(inputjoint, referenceSpace);
                    // The transform of this joint will be updated with the joint pose on each frame
                    const joint = this._getHandJoint(hand, inputjoint);
                    if (jointPose !== null) {
                        joint.matrix.fromArray(jointPose.transform.matrix);
                        joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
                        joint.jointRadius = jointPose.radius;
                    }
                    joint.visible = jointPose !== null;
                }
                // Custom events
                // Check pinchz
                const indexTip = hand.joints["index-finger-tip"];
                const thumbTip = hand.joints["thumb-tip"];
                const distance = indexTip.position.distanceTo(thumbTip.position);
                const distanceToPinch = 0.02;
                const threshold = 0.005;
                if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
                    hand.inputState.pinching = false;
                    this.dispatchEvent({
                        type: "pinchend",
                        handedness: inputSource.handedness,
                        target: this
                    });
                } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
                    hand.inputState.pinching = true;
                    this.dispatchEvent({
                        type: "pinchstart",
                        handedness: inputSource.handedness,
                        target: this
                    });
                }
            } else if (grip !== null && inputSource.gripSpace) {
                gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
                if (gripPose !== null) {
                    grip.matrix.fromArray(gripPose.transform.matrix);
                    grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
                    if (gripPose.linearVelocity) {
                        grip.hasLinearVelocity = true;
                        grip.linearVelocity.copy(gripPose.linearVelocity);
                    } else grip.hasLinearVelocity = false;
                    if (gripPose.angularVelocity) {
                        grip.hasAngularVelocity = true;
                        grip.angularVelocity.copy(gripPose.angularVelocity);
                    } else grip.hasAngularVelocity = false;
                }
            }
            if (targetRay !== null) {
                inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
                // Some runtimes (namely Vive Cosmos with Vive OpenXR Runtime) have only grip space and ray space is equal to it
                if (inputPose === null && gripPose !== null) inputPose = gripPose;
                if (inputPose !== null) {
                    targetRay.matrix.fromArray(inputPose.transform.matrix);
                    targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
                    if (inputPose.linearVelocity) {
                        targetRay.hasLinearVelocity = true;
                        targetRay.linearVelocity.copy(inputPose.linearVelocity);
                    } else targetRay.hasLinearVelocity = false;
                    if (inputPose.angularVelocity) {
                        targetRay.hasAngularVelocity = true;
                        targetRay.angularVelocity.copy(inputPose.angularVelocity);
                    } else targetRay.hasAngularVelocity = false;
                    this.dispatchEvent($e8ea6a63d48a4fea$var$_moveEvent);
                }
            }
        }
        if (targetRay !== null) targetRay.visible = inputPose !== null;
        if (grip !== null) grip.visible = gripPose !== null;
        if (hand !== null) hand.visible = handPose !== null;
        return this;
    }
    // private method
    _getHandJoint(hand, inputjoint) {
        if (hand.joints[inputjoint.jointName] === undefined) {
            const joint = new $e8ea6a63d48a4fea$export$eb2fcfdbd7ba97d4();
            joint.matrixAutoUpdate = false;
            joint.visible = false;
            hand.joints[inputjoint.jointName] = joint;
            hand.add(joint);
        }
        return hand.joints[inputjoint.jointName];
    }
}
class $e8ea6a63d48a4fea$export$fc830aa069cc8c2f extends $e8ea6a63d48a4fea$export$5431306cf43de24a {
    constructor(width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format){
        format = format !== undefined ? format : $e8ea6a63d48a4fea$export$c1b6b5136be58045;
        if (format !== $e8ea6a63d48a4fea$export$c1b6b5136be58045 && format !== $e8ea6a63d48a4fea$export$1e113ac2d0905829) throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
        if (type === undefined && format === $e8ea6a63d48a4fea$export$c1b6b5136be58045) type = $e8ea6a63d48a4fea$export$c3c7fc4518ebba96;
        if (type === undefined && format === $e8ea6a63d48a4fea$export$1e113ac2d0905829) type = $e8ea6a63d48a4fea$export$6c8ea339bfab1301;
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isDepthTexture = true;
        this.image = {
            width: width,
            height: height
        };
        this.magFilter = magFilter !== undefined ? magFilter : $e8ea6a63d48a4fea$export$727aa5ec3fe39bf0;
        this.minFilter = minFilter !== undefined ? minFilter : $e8ea6a63d48a4fea$export$727aa5ec3fe39bf0;
        this.flipY = false;
        this.generateMipmaps = false;
    }
}
class $e8ea6a63d48a4fea$var$WebXRManager extends $e8ea6a63d48a4fea$export$ec8b666c5fe2c75a {
    constructor(renderer, gl){
        super();
        const scope = this;
        let session = null;
        let framebufferScaleFactor = 1.0;
        let referenceSpace = null;
        let referenceSpaceType = "local-floor";
        // Set default foveation to maximum.
        let foveation = 1.0;
        let customReferenceSpace = null;
        let pose = null;
        let glBinding = null;
        let glProjLayer = null;
        let glBaseLayer = null;
        let xrFrame = null;
        const attributes = gl.getContextAttributes();
        let initialRenderTarget = null;
        let newRenderTarget = null;
        const controllers = [];
        const controllerInputSources = [];
        const planes = new Set();
        const planesLastChangedTimes = new Map();
        //
        const cameraL = new $e8ea6a63d48a4fea$export$74e4ae24825f68d7();
        cameraL.layers.enable(1);
        cameraL.viewport = new $e8ea6a63d48a4fea$export$fa7daccca11cdbe3();
        const cameraR = new $e8ea6a63d48a4fea$export$74e4ae24825f68d7();
        cameraR.layers.enable(2);
        cameraR.viewport = new $e8ea6a63d48a4fea$export$fa7daccca11cdbe3();
        const cameras = [
            cameraL,
            cameraR
        ];
        const cameraVR = new $e8ea6a63d48a4fea$export$56b937d9e5581166();
        cameraVR.layers.enable(1);
        cameraVR.layers.enable(2);
        let _currentDepthNear = null;
        let _currentDepthFar = null;
        //
        this.cameraAutoUpdate = true;
        this.enabled = false;
        this.isPresenting = false;
        this.getController = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $e8ea6a63d48a4fea$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getTargetRaySpace();
        };
        this.getControllerGrip = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $e8ea6a63d48a4fea$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getGripSpace();
        };
        this.getHand = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $e8ea6a63d48a4fea$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getHandSpace();
        };
        //
        function onSessionEvent(event) {
            const controllerIndex = controllerInputSources.indexOf(event.inputSource);
            if (controllerIndex === -1) return;
            const controller = controllers[controllerIndex];
            if (controller !== undefined) controller.dispatchEvent({
                type: event.type,
                data: event.inputSource
            });
        }
        function onSessionEnd() {
            session.removeEventListener("select", onSessionEvent);
            session.removeEventListener("selectstart", onSessionEvent);
            session.removeEventListener("selectend", onSessionEvent);
            session.removeEventListener("squeeze", onSessionEvent);
            session.removeEventListener("squeezestart", onSessionEvent);
            session.removeEventListener("squeezeend", onSessionEvent);
            session.removeEventListener("end", onSessionEnd);
            session.removeEventListener("inputsourceschange", onInputSourcesChange);
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                if (inputSource === null) continue;
                controllerInputSources[i] = null;
                controllers[i].disconnect(inputSource);
            }
            _currentDepthNear = null;
            _currentDepthFar = null;
            // restore framebuffer/rendering state
            renderer.setRenderTarget(initialRenderTarget);
            glBaseLayer = null;
            glProjLayer = null;
            glBinding = null;
            session = null;
            newRenderTarget = null;
            //
            animation.stop();
            scope.isPresenting = false;
            scope.dispatchEvent({
                type: "sessionend"
            });
        }
        this.setFramebufferScaleFactor = function(value) {
            framebufferScaleFactor = value;
            if (scope.isPresenting === true) console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
        };
        this.setReferenceSpaceType = function(value) {
            referenceSpaceType = value;
            if (scope.isPresenting === true) console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
        };
        this.getReferenceSpace = function() {
            return customReferenceSpace || referenceSpace;
        };
        this.setReferenceSpace = function(space) {
            customReferenceSpace = space;
        };
        this.getBaseLayer = function() {
            return glProjLayer !== null ? glProjLayer : glBaseLayer;
        };
        this.getBinding = function() {
            return glBinding;
        };
        this.getFrame = function() {
            return xrFrame;
        };
        this.getSession = function() {
            return session;
        };
        this.setSession = async function(value) {
            session = value;
            if (session !== null) {
                initialRenderTarget = renderer.getRenderTarget();
                session.addEventListener("select", onSessionEvent);
                session.addEventListener("selectstart", onSessionEvent);
                session.addEventListener("selectend", onSessionEvent);
                session.addEventListener("squeeze", onSessionEvent);
                session.addEventListener("squeezestart", onSessionEvent);
                session.addEventListener("squeezeend", onSessionEvent);
                session.addEventListener("end", onSessionEnd);
                session.addEventListener("inputsourceschange", onInputSourcesChange);
                if (attributes.xrCompatible !== true) await gl.makeXRCompatible();
                if (session.renderState.layers === undefined || renderer.capabilities.isWebGL2 === false) {
                    const layerInit = {
                        antialias: session.renderState.layers === undefined ? attributes.antialias : true,
                        alpha: attributes.alpha,
                        depth: attributes.depth,
                        stencil: attributes.stencil,
                        framebufferScaleFactor: framebufferScaleFactor
                    };
                    glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
                    session.updateRenderState({
                        baseLayer: glBaseLayer
                    });
                    newRenderTarget = new $e8ea6a63d48a4fea$export$3c052beb2e51e23f(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, {
                        format: $e8ea6a63d48a4fea$export$3f8bb04b555a363c,
                        type: $e8ea6a63d48a4fea$export$2e8ce08d3f6f5e10,
                        encoding: renderer.outputEncoding,
                        stencilBuffer: attributes.stencil
                    });
                } else {
                    let depthFormat = null;
                    let depthType = null;
                    let glDepthFormat = null;
                    if (attributes.depth) {
                        glDepthFormat = attributes.stencil ? 35056 : 33190;
                        depthFormat = attributes.stencil ? $e8ea6a63d48a4fea$export$1e113ac2d0905829 : $e8ea6a63d48a4fea$export$c1b6b5136be58045;
                        depthType = attributes.stencil ? $e8ea6a63d48a4fea$export$6c8ea339bfab1301 : $e8ea6a63d48a4fea$export$c3c7fc4518ebba96;
                    }
                    const projectionlayerInit = {
                        colorFormat: 32856,
                        depthFormat: glDepthFormat,
                        scaleFactor: framebufferScaleFactor
                    };
                    glBinding = new XRWebGLBinding(session, gl);
                    glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
                    session.updateRenderState({
                        layers: [
                            glProjLayer
                        ]
                    });
                    newRenderTarget = new $e8ea6a63d48a4fea$export$3c052beb2e51e23f(glProjLayer.textureWidth, glProjLayer.textureHeight, {
                        format: $e8ea6a63d48a4fea$export$3f8bb04b555a363c,
                        type: $e8ea6a63d48a4fea$export$2e8ce08d3f6f5e10,
                        depthTexture: new $e8ea6a63d48a4fea$export$fc830aa069cc8c2f(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat),
                        stencilBuffer: attributes.stencil,
                        encoding: renderer.outputEncoding,
                        samples: attributes.antialias ? 4 : 0
                    });
                    const renderTargetProperties = renderer.properties.get(newRenderTarget);
                    renderTargetProperties.__ignoreDepthValues = glProjLayer.ignoreDepthValues;
                }
                newRenderTarget.isXRRenderTarget = true; // TODO Remove this when possible, see #23278
                this.setFoveation(foveation);
                customReferenceSpace = null;
                referenceSpace = await session.requestReferenceSpace(referenceSpaceType);
                animation.setContext(session);
                animation.start();
                scope.isPresenting = true;
                scope.dispatchEvent({
                    type: "sessionstart"
                });
            }
        };
        function onInputSourcesChange(event) {
            // Notify disconnected
            for(let i = 0; i < event.removed.length; i++){
                const inputSource = event.removed[i];
                const index = controllerInputSources.indexOf(inputSource);
                if (index >= 0) {
                    controllerInputSources[index] = null;
                    controllers[index].disconnect(inputSource);
                }
            }
            // Notify connected
            for(let i = 0; i < event.added.length; i++){
                const inputSource = event.added[i];
                let controllerIndex = controllerInputSources.indexOf(inputSource);
                if (controllerIndex === -1) {
                    // Assign input source a controller that currently has no input source
                    for(let i = 0; i < controllers.length; i++){
                        if (i >= controllerInputSources.length) {
                            controllerInputSources.push(inputSource);
                            controllerIndex = i;
                            break;
                        } else if (controllerInputSources[i] === null) {
                            controllerInputSources[i] = inputSource;
                            controllerIndex = i;
                            break;
                        }
                    }
                    // If all controllers do currently receive input we ignore new ones
                    if (controllerIndex === -1) break;
                }
                const controller = controllers[controllerIndex];
                if (controller) controller.connect(inputSource);
            }
        }
        //
        const cameraLPos = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        const cameraRPos = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        /**
		 * Assumes 2 cameras that are parallel and share an X-axis, and that
		 * the cameras' projection and world matrices have already been set.
		 * And that near and far planes are identical for both cameras.
		 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
		 */ function setProjectionFromUnion(camera, cameraL, cameraR) {
            cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
            cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
            const ipd = cameraLPos.distanceTo(cameraRPos);
            const projL = cameraL.projectionMatrix.elements;
            const projR = cameraR.projectionMatrix.elements;
            // VR systems will have identical far and near planes, and
            // most likely identical top and bottom frustum extents.
            // Use the left camera for these values.
            const near = projL[14] / (projL[10] - 1);
            const far = projL[14] / (projL[10] + 1);
            const topFov = (projL[9] + 1) / projL[5];
            const bottomFov = (projL[9] - 1) / projL[5];
            const leftFov = (projL[8] - 1) / projL[0];
            const rightFov = (projR[8] + 1) / projR[0];
            const left = near * leftFov;
            const right = near * rightFov;
            // Calculate the new camera's position offset from the
            // left camera. xOffset should be roughly half `ipd`.
            const zOffset = ipd / (-leftFov + rightFov);
            const xOffset = zOffset * -leftFov;
            // TODO: Better way to apply this offset?
            cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
            camera.translateX(xOffset);
            camera.translateZ(zOffset);
            camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
            // Find the union of the frustum values of the cameras and scale
            // the values so that the near plane's position does not change in world space,
            // although must now be relative to the new union camera.
            const near2 = near + zOffset;
            const far2 = far + zOffset;
            const left2 = left - xOffset;
            const right2 = right + (ipd - xOffset);
            const top2 = topFov * far / far2 * near2;
            const bottom2 = bottomFov * far / far2 * near2;
            camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
            camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
        }
        function updateCamera(camera, parent) {
            if (parent === null) camera.matrixWorld.copy(camera.matrix);
            else camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
        }
        this.updateCamera = function(camera) {
            if (session === null) return;
            cameraVR.near = cameraR.near = cameraL.near = camera.near;
            cameraVR.far = cameraR.far = cameraL.far = camera.far;
            if (_currentDepthNear !== cameraVR.near || _currentDepthFar !== cameraVR.far) {
                // Note that the new renderState won't apply until the next frame. See #18320
                session.updateRenderState({
                    depthNear: cameraVR.near,
                    depthFar: cameraVR.far
                });
                _currentDepthNear = cameraVR.near;
                _currentDepthFar = cameraVR.far;
            }
            const parent = camera.parent;
            const cameras = cameraVR.cameras;
            updateCamera(cameraVR, parent);
            for(let i = 0; i < cameras.length; i++)updateCamera(cameras[i], parent);
            // update projection matrix for proper view frustum culling
            if (cameras.length === 2) setProjectionFromUnion(cameraVR, cameraL, cameraR);
            else // assume single camera setup (AR)
            cameraVR.projectionMatrix.copy(cameraL.projectionMatrix);
            // update user camera and its children
            updateUserCamera(camera, cameraVR, parent);
        };
        function updateUserCamera(camera, cameraVR, parent) {
            if (parent === null) camera.matrix.copy(cameraVR.matrixWorld);
            else {
                camera.matrix.copy(parent.matrixWorld);
                camera.matrix.invert();
                camera.matrix.multiply(cameraVR.matrixWorld);
            }
            camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
            camera.updateMatrixWorld(true);
            const children = camera.children;
            for(let i = 0, l = children.length; i < l; i++)children[i].updateMatrixWorld(true);
            camera.projectionMatrix.copy(cameraVR.projectionMatrix);
            camera.projectionMatrixInverse.copy(cameraVR.projectionMatrixInverse);
            if (camera.isPerspectiveCamera) {
                camera.fov = $e8ea6a63d48a4fea$var$RAD2DEG * 2 * Math.atan(1 / camera.projectionMatrix.elements[5]);
                camera.zoom = 1;
            }
        }
        this.getCamera = function() {
            return cameraVR;
        };
        this.getFoveation = function() {
            if (glProjLayer === null && glBaseLayer === null) return undefined;
            return foveation;
        };
        this.setFoveation = function(value) {
            // 0 = no foveation = full resolution
            // 1 = maximum foveation = the edges render at lower resolution
            foveation = value;
            if (glProjLayer !== null) glProjLayer.fixedFoveation = value;
            if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== undefined) glBaseLayer.fixedFoveation = value;
        };
        this.getPlanes = function() {
            return planes;
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time, frame) {
            pose = frame.getViewerPose(customReferenceSpace || referenceSpace);
            xrFrame = frame;
            if (pose !== null) {
                const views = pose.views;
                if (glBaseLayer !== null) {
                    renderer.setRenderTargetFramebuffer(newRenderTarget, glBaseLayer.framebuffer);
                    renderer.setRenderTarget(newRenderTarget);
                }
                let cameraVRNeedsUpdate = false;
                // check if it's necessary to rebuild cameraVR's camera list
                if (views.length !== cameraVR.cameras.length) {
                    cameraVR.cameras.length = 0;
                    cameraVRNeedsUpdate = true;
                }
                for(let i = 0; i < views.length; i++){
                    const view = views[i];
                    let viewport = null;
                    if (glBaseLayer !== null) viewport = glBaseLayer.getViewport(view);
                    else {
                        const glSubImage = glBinding.getViewSubImage(glProjLayer, view);
                        viewport = glSubImage.viewport;
                        // For side-by-side projection, we only produce a single texture for both eyes.
                        if (i === 0) {
                            renderer.setRenderTargetTextures(newRenderTarget, glSubImage.colorTexture, glProjLayer.ignoreDepthValues ? undefined : glSubImage.depthStencilTexture);
                            renderer.setRenderTarget(newRenderTarget);
                        }
                    }
                    let camera = cameras[i];
                    if (camera === undefined) {
                        camera = new $e8ea6a63d48a4fea$export$74e4ae24825f68d7();
                        camera.layers.enable(i);
                        camera.viewport = new $e8ea6a63d48a4fea$export$fa7daccca11cdbe3();
                        cameras[i] = camera;
                    }
                    camera.matrix.fromArray(view.transform.matrix);
                    camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
                    camera.projectionMatrix.fromArray(view.projectionMatrix);
                    camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
                    camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
                    if (i === 0) {
                        cameraVR.matrix.copy(camera.matrix);
                        cameraVR.matrix.decompose(cameraVR.position, cameraVR.quaternion, cameraVR.scale);
                    }
                    if (cameraVRNeedsUpdate === true) cameraVR.cameras.push(camera);
                }
            }
            //
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                const controller = controllers[i];
                if (inputSource !== null && controller !== undefined) controller.update(inputSource, frame, customReferenceSpace || referenceSpace);
            }
            if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
            if (frame.detectedPlanes) {
                scope.dispatchEvent({
                    type: "planesdetected",
                    data: frame.detectedPlanes
                });
                let planesToRemove = null;
                for (const plane of planes)if (!frame.detectedPlanes.has(plane)) {
                    if (planesToRemove === null) planesToRemove = [];
                    planesToRemove.push(plane);
                }
                if (planesToRemove !== null) for (const plane of planesToRemove){
                    planes.delete(plane);
                    planesLastChangedTimes.delete(plane);
                    scope.dispatchEvent({
                        type: "planeremoved",
                        data: plane
                    });
                }
                for (const plane of frame.detectedPlanes)if (!planes.has(plane)) {
                    planes.add(plane);
                    planesLastChangedTimes.set(plane, frame.lastChangedTime);
                    scope.dispatchEvent({
                        type: "planeadded",
                        data: plane
                    });
                } else {
                    const lastKnownTime = planesLastChangedTimes.get(plane);
                    if (plane.lastChangedTime > lastKnownTime) {
                        planesLastChangedTimes.set(plane, plane.lastChangedTime);
                        scope.dispatchEvent({
                            type: "planechanged",
                            data: plane
                        });
                    }
                }
            }
            xrFrame = null;
        }
        const animation = new $e8ea6a63d48a4fea$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
        };
        this.dispose = function() {};
    }
}
function $e8ea6a63d48a4fea$var$WebGLMaterials(renderer, properties) {
    function refreshTransformUniform(map, uniform) {
        if (map.matrixAutoUpdate === true) map.updateMatrix();
        uniform.value.copy(map.matrix);
    }
    function refreshFogUniforms(uniforms, fog) {
        fog.color.getRGB(uniforms.fogColor.value, $e8ea6a63d48a4fea$var$getUnlitUniformColorSpace(renderer));
        if (fog.isFog) {
            uniforms.fogNear.value = fog.near;
            uniforms.fogFar.value = fog.far;
        } else if (fog.isFogExp2) uniforms.fogDensity.value = fog.density;
    }
    function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
        if (material.isMeshBasicMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshLambertMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshToonMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsToon(uniforms, material);
        } else if (material.isMeshPhongMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsPhong(uniforms, material);
        } else if (material.isMeshStandardMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsStandard(uniforms, material);
            if (material.isMeshPhysicalMaterial) refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
        } else if (material.isMeshMatcapMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsMatcap(uniforms, material);
        } else if (material.isMeshDepthMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshDistanceMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDistance(uniforms, material);
        } else if (material.isMeshNormalMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isLineBasicMaterial) {
            refreshUniformsLine(uniforms, material);
            if (material.isLineDashedMaterial) refreshUniformsDash(uniforms, material);
        } else if (material.isPointsMaterial) refreshUniformsPoints(uniforms, material, pixelRatio, height);
        else if (material.isSpriteMaterial) refreshUniformsSprites(uniforms, material);
        else if (material.isShadowMaterial) {
            uniforms.color.value.copy(material.color);
            uniforms.opacity.value = material.opacity;
        } else if (material.isShaderMaterial) material.uniformsNeedUpdate = false; // #15581
    }
    function refreshUniformsCommon(uniforms, material) {
        uniforms.opacity.value = material.opacity;
        if (material.color) uniforms.diffuse.value.copy(material.color);
        if (material.emissive) uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            refreshTransformUniform(material.bumpMap, uniforms.bumpMapTransform);
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $e8ea6a63d48a4fea$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            refreshTransformUniform(material.normalMap, uniforms.normalMapTransform);
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $e8ea6a63d48a4fea$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            refreshTransformUniform(material.displacementMap, uniforms.displacementMapTransform);
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        if (material.emissiveMap) {
            uniforms.emissiveMap.value = material.emissiveMap;
            refreshTransformUniform(material.emissiveMap, uniforms.emissiveMapTransform);
        }
        if (material.specularMap) {
            uniforms.specularMap.value = material.specularMap;
            refreshTransformUniform(material.specularMap, uniforms.specularMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        const envMap = properties.get(material).envMap;
        if (envMap) {
            uniforms.envMap.value = envMap;
            uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            uniforms.reflectivity.value = material.reflectivity;
            uniforms.ior.value = material.ior;
            uniforms.refractionRatio.value = material.refractionRatio;
        }
        if (material.lightMap) {
            uniforms.lightMap.value = material.lightMap;
            // artist-friendly light intensity scaling factor
            const scaleFactor = renderer.useLegacyLights === true ? Math.PI : 1;
            uniforms.lightMapIntensity.value = material.lightMapIntensity * scaleFactor;
            refreshTransformUniform(material.lightMap, uniforms.lightMapTransform);
        }
        if (material.aoMap) {
            uniforms.aoMap.value = material.aoMap;
            uniforms.aoMapIntensity.value = material.aoMapIntensity;
            refreshTransformUniform(material.aoMap, uniforms.aoMapTransform);
        }
    }
    function refreshUniformsLine(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
    }
    function refreshUniformsDash(uniforms, material) {
        uniforms.dashSize.value = material.dashSize;
        uniforms.totalSize.value = material.dashSize + material.gapSize;
        uniforms.scale.value = material.scale;
    }
    function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.size.value = material.size * pixelRatio;
        uniforms.scale.value = height * 0.5;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.uvTransform);
        }
        if (material.alphaMap) uniforms.alphaMap.value = material.alphaMap;
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsSprites(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.rotation.value = material.rotation;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) uniforms.alphaMap.value = material.alphaMap;
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsPhong(uniforms, material) {
        uniforms.specular.value.copy(material.specular);
        uniforms.shininess.value = Math.max(material.shininess, 1e-4); // to prevent pow( 0.0, 0.0 )
    }
    function refreshUniformsToon(uniforms, material) {
        if (material.gradientMap) uniforms.gradientMap.value = material.gradientMap;
    }
    function refreshUniformsStandard(uniforms, material) {
        uniforms.metalness.value = material.metalness;
        if (material.metalnessMap) {
            uniforms.metalnessMap.value = material.metalnessMap;
            refreshTransformUniform(material.metalnessMap, uniforms.metalnessMapTransform);
        }
        uniforms.roughness.value = material.roughness;
        if (material.roughnessMap) {
            uniforms.roughnessMap.value = material.roughnessMap;
            refreshTransformUniform(material.roughnessMap, uniforms.roughnessMapTransform);
        }
        const envMap = properties.get(material).envMap;
        if (envMap) //uniforms.envMap.value = material.envMap; // part of uniforms common
        uniforms.envMapIntensity.value = material.envMapIntensity;
    }
    function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
        uniforms.ior.value = material.ior; // also part of uniforms common
        if (material.sheen > 0) {
            uniforms.sheenColor.value.copy(material.sheenColor).multiplyScalar(material.sheen);
            uniforms.sheenRoughness.value = material.sheenRoughness;
            if (material.sheenColorMap) {
                uniforms.sheenColorMap.value = material.sheenColorMap;
                refreshTransformUniform(material.sheenColorMap, uniforms.sheenColorMapTransform);
            }
            if (material.sheenRoughnessMap) {
                uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;
                refreshTransformUniform(material.sheenRoughnessMap, uniforms.sheenRoughnessMapTransform);
            }
        }
        if (material.clearcoat > 0) {
            uniforms.clearcoat.value = material.clearcoat;
            uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
            if (material.clearcoatMap) {
                uniforms.clearcoatMap.value = material.clearcoatMap;
                refreshTransformUniform(material.clearcoatMap, uniforms.clearcoatMapTransform);
            }
            if (material.clearcoatRoughnessMap) {
                uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
                refreshTransformUniform(material.clearcoatRoughnessMap, uniforms.clearcoatRoughnessMapTransform);
            }
            if (material.clearcoatNormalMap) {
                uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
                refreshTransformUniform(material.clearcoatNormalMap, uniforms.clearcoatNormalMapTransform);
                uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
                if (material.side === $e8ea6a63d48a4fea$export$d9f0486e75b5ace) uniforms.clearcoatNormalScale.value.negate();
            }
        }
        if (material.iridescence > 0) {
            uniforms.iridescence.value = material.iridescence;
            uniforms.iridescenceIOR.value = material.iridescenceIOR;
            uniforms.iridescenceThicknessMinimum.value = material.iridescenceThicknessRange[0];
            uniforms.iridescenceThicknessMaximum.value = material.iridescenceThicknessRange[1];
            if (material.iridescenceMap) {
                uniforms.iridescenceMap.value = material.iridescenceMap;
                refreshTransformUniform(material.iridescenceMap, uniforms.iridescenceMapTransform);
            }
            if (material.iridescenceThicknessMap) {
                uniforms.iridescenceThicknessMap.value = material.iridescenceThicknessMap;
                refreshTransformUniform(material.iridescenceThicknessMap, uniforms.iridescenceThicknessMapTransform);
            }
        }
        if (material.transmission > 0) {
            uniforms.transmission.value = material.transmission;
            uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
            uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
            if (material.transmissionMap) {
                uniforms.transmissionMap.value = material.transmissionMap;
                refreshTransformUniform(material.transmissionMap, uniforms.transmissionMapTransform);
            }
            uniforms.thickness.value = material.thickness;
            if (material.thicknessMap) {
                uniforms.thicknessMap.value = material.thicknessMap;
                refreshTransformUniform(material.thicknessMap, uniforms.thicknessMapTransform);
            }
            uniforms.attenuationDistance.value = material.attenuationDistance;
            uniforms.attenuationColor.value.copy(material.attenuationColor);
        }
        uniforms.specularIntensity.value = material.specularIntensity;
        uniforms.specularColor.value.copy(material.specularColor);
        if (material.specularColorMap) {
            uniforms.specularColorMap.value = material.specularColorMap;
            refreshTransformUniform(material.specularColorMap, uniforms.specularColorMapTransform);
        }
        if (material.specularIntensityMap) {
            uniforms.specularIntensityMap.value = material.specularIntensityMap;
            refreshTransformUniform(material.specularIntensityMap, uniforms.specularIntensityMapTransform);
        }
    }
    function refreshUniformsMatcap(uniforms, material) {
        if (material.matcap) uniforms.matcap.value = material.matcap;
    }
    function refreshUniformsDistance(uniforms, material) {
        const light = properties.get(material).light;
        uniforms.referencePosition.value.setFromMatrixPosition(light.matrixWorld);
        uniforms.nearDistance.value = light.shadow.camera.near;
        uniforms.farDistance.value = light.shadow.camera.far;
    }
    return {
        refreshFogUniforms: refreshFogUniforms,
        refreshMaterialUniforms: refreshMaterialUniforms
    };
}
function $e8ea6a63d48a4fea$var$WebGLUniformsGroups(gl, info, capabilities, state) {
    let buffers = {};
    let updateList = {};
    let allocatedBindingPoints = [];
    const maxBindingPoints = capabilities.isWebGL2 ? gl.getParameter(35375) : 0; // binding points are global whereas block indices are per shader program
    function bind(uniformsGroup, program) {
        const webglProgram = program.program;
        state.uniformBlockBinding(uniformsGroup, webglProgram);
    }
    function update(uniformsGroup, program) {
        let buffer = buffers[uniformsGroup.id];
        if (buffer === undefined) {
            prepareUniformsGroup(uniformsGroup);
            buffer = createBuffer(uniformsGroup);
            buffers[uniformsGroup.id] = buffer;
            uniformsGroup.addEventListener("dispose", onUniformsGroupsDispose);
        }
        // ensure to update the binding points/block indices mapping for this program
        const webglProgram = program.program;
        state.updateUBOMapping(uniformsGroup, webglProgram);
        // update UBO once per frame
        const frame = info.render.frame;
        if (updateList[uniformsGroup.id] !== frame) {
            updateBufferData(uniformsGroup);
            updateList[uniformsGroup.id] = frame;
        }
    }
    function createBuffer(uniformsGroup) {
        // the setup of an UBO is independent of a particular shader program but global
        const bindingPointIndex = allocateBindingPointIndex();
        uniformsGroup.__bindingPointIndex = bindingPointIndex;
        const buffer = gl.createBuffer();
        const size = uniformsGroup.__size;
        const usage = uniformsGroup.usage;
        gl.bindBuffer(35345, buffer);
        gl.bufferData(35345, size, usage);
        gl.bindBuffer(35345, null);
        gl.bindBufferBase(35345, bindingPointIndex, buffer);
        return buffer;
    }
    function allocateBindingPointIndex() {
        for(let i = 0; i < maxBindingPoints; i++)if (allocatedBindingPoints.indexOf(i) === -1) {
            allocatedBindingPoints.push(i);
            return i;
        }
        console.error("THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.");
        return 0;
    }
    function updateBufferData(uniformsGroup) {
        const buffer = buffers[uniformsGroup.id];
        const uniforms = uniformsGroup.uniforms;
        const cache = uniformsGroup.__cache;
        gl.bindBuffer(35345, buffer);
        for(let i = 0, il = uniforms.length; i < il; i++){
            const uniform = uniforms[i];
            // partly update the buffer if necessary
            if (hasUniformChanged(uniform, i, cache) === true) {
                const offset = uniform.__offset;
                const values = Array.isArray(uniform.value) ? uniform.value : [
                    uniform.value
                ];
                let arrayOffset = 0;
                for(let i = 0; i < values.length; i++){
                    const value = values[i];
                    const info = getUniformSize(value);
                    if (typeof value === "number") {
                        uniform.__data[0] = value;
                        gl.bufferSubData(35345, offset + arrayOffset, uniform.__data);
                    } else if (value.isMatrix3) {
                        // manually converting 3x3 to 3x4
                        uniform.__data[0] = value.elements[0];
                        uniform.__data[1] = value.elements[1];
                        uniform.__data[2] = value.elements[2];
                        uniform.__data[3] = value.elements[0];
                        uniform.__data[4] = value.elements[3];
                        uniform.__data[5] = value.elements[4];
                        uniform.__data[6] = value.elements[5];
                        uniform.__data[7] = value.elements[0];
                        uniform.__data[8] = value.elements[6];
                        uniform.__data[9] = value.elements[7];
                        uniform.__data[10] = value.elements[8];
                        uniform.__data[11] = value.elements[0];
                    } else {
                        value.toArray(uniform.__data, arrayOffset);
                        arrayOffset += info.storage / Float32Array.BYTES_PER_ELEMENT;
                    }
                }
                gl.bufferSubData(35345, offset, uniform.__data);
            }
        }
        gl.bindBuffer(35345, null);
    }
    function hasUniformChanged(uniform, index, cache) {
        const value = uniform.value;
        if (cache[index] === undefined) {
            // cache entry does not exist so far
            if (typeof value === "number") cache[index] = value;
            else {
                const values = Array.isArray(value) ? value : [
                    value
                ];
                const tempValues = [];
                for(let i = 0; i < values.length; i++)tempValues.push(values[i].clone());
                cache[index] = tempValues;
            }
            return true;
        } else {
            // compare current value with cached entry
            if (typeof value === "number") {
                if (cache[index] !== value) {
                    cache[index] = value;
                    return true;
                }
            } else {
                const cachedObjects = Array.isArray(cache[index]) ? cache[index] : [
                    cache[index]
                ];
                const values = Array.isArray(value) ? value : [
                    value
                ];
                for(let i = 0; i < cachedObjects.length; i++){
                    const cachedObject = cachedObjects[i];
                    if (cachedObject.equals(values[i]) === false) {
                        cachedObject.copy(values[i]);
                        return true;
                    }
                }
            }
        }
        return false;
    }
    function prepareUniformsGroup(uniformsGroup) {
        // determine total buffer size according to the STD140 layout
        // Hint: STD140 is the only supported layout in WebGL 2
        const uniforms = uniformsGroup.uniforms;
        let offset = 0; // global buffer offset in bytes
        const chunkSize = 16; // size of a chunk in bytes
        let chunkOffset = 0; // offset within a single chunk in bytes
        for(let i = 0, l = uniforms.length; i < l; i++){
            const uniform = uniforms[i];
            const infos = {
                boundary: 0,
                storage: 0 // bytes
            };
            const values = Array.isArray(uniform.value) ? uniform.value : [
                uniform.value
            ];
            for(let j = 0, jl = values.length; j < jl; j++){
                const value = values[j];
                const info = getUniformSize(value);
                infos.boundary += info.boundary;
                infos.storage += info.storage;
            }
            // the following two properties will be used for partial buffer updates
            uniform.__data = new Float32Array(infos.storage / Float32Array.BYTES_PER_ELEMENT);
            uniform.__offset = offset;
            //
            if (i > 0) {
                chunkOffset = offset % chunkSize;
                const remainingSizeInChunk = chunkSize - chunkOffset;
                // check for chunk overflow
                if (chunkOffset !== 0 && remainingSizeInChunk - infos.boundary < 0) {
                    // add padding and adjust offset
                    offset += chunkSize - chunkOffset;
                    uniform.__offset = offset;
                }
            }
            offset += infos.storage;
        }
        // ensure correct final padding
        chunkOffset = offset % chunkSize;
        if (chunkOffset > 0) offset += chunkSize - chunkOffset;
        //
        uniformsGroup.__size = offset;
        uniformsGroup.__cache = {};
        return this;
    }
    function getUniformSize(value) {
        const info = {
            boundary: 0,
            storage: 0 // bytes
        };
        // determine sizes according to STD140
        if (typeof value === "number") {
            // float/int
            info.boundary = 4;
            info.storage = 4;
        } else if (value.isVector2) {
            // vec2
            info.boundary = 8;
            info.storage = 8;
        } else if (value.isVector3 || value.isColor) {
            // vec3
            info.boundary = 16;
            info.storage = 12; // evil: vec3 must start on a 16-byte boundary but it only consumes 12 bytes
        } else if (value.isVector4) {
            // vec4
            info.boundary = 16;
            info.storage = 16;
        } else if (value.isMatrix3) {
            // mat3 (in STD140 a 3x3 matrix is represented as 3x4)
            info.boundary = 48;
            info.storage = 48;
        } else if (value.isMatrix4) {
            // mat4
            info.boundary = 64;
            info.storage = 64;
        } else if (value.isTexture) console.warn("THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.");
        else console.warn("THREE.WebGLRenderer: Unsupported uniform value type.", value);
        return info;
    }
    function onUniformsGroupsDispose(event) {
        const uniformsGroup = event.target;
        uniformsGroup.removeEventListener("dispose", onUniformsGroupsDispose);
        const index = allocatedBindingPoints.indexOf(uniformsGroup.__bindingPointIndex);
        allocatedBindingPoints.splice(index, 1);
        gl.deleteBuffer(buffers[uniformsGroup.id]);
        delete buffers[uniformsGroup.id];
        delete updateList[uniformsGroup.id];
    }
    function dispose() {
        for(const id in buffers)gl.deleteBuffer(buffers[id]);
        allocatedBindingPoints = [];
        buffers = {};
        updateList = {};
    }
    return {
        bind: bind,
        update: update,
        dispose: dispose
    };
}
function $e8ea6a63d48a4fea$var$createCanvasElement() {
    const canvas = $e8ea6a63d48a4fea$var$createElementNS("canvas");
    canvas.style.display = "block";
    return canvas;
}
class $e8ea6a63d48a4fea$export$f6cc00ef28d7cf97 {
    constructor(parameters = {}){
        const { canvas: canvas = $e8ea6a63d48a4fea$var$createCanvasElement() , context: context = null , depth: depth = true , stencil: stencil = true , alpha: alpha = false , antialias: antialias = false , premultipliedAlpha: premultipliedAlpha = true , preserveDrawingBuffer: preserveDrawingBuffer = false , powerPreference: powerPreference = "default" , failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat = false  } = parameters;
        this.isWebGLRenderer = true;
        let _alpha;
        if (context !== null) _alpha = context.getContextAttributes().alpha;
        else _alpha = alpha;
        let currentRenderList = null;
        let currentRenderState = null;
        // render() can be called from within a callback triggered by another render.
        // We track this so that the nested render call gets its list and state isolated from the parent render call.
        const renderListStack = [];
        const renderStateStack = [];
        // public properties
        this.domElement = canvas;
        // Debug configuration container
        this.debug = {
            /**
			 * Enables error checking and reporting when shader programs are being compiled
			 * @type {boolean}
			 */ checkShaderErrors: true,
            /**
			 * Callback for custom error reporting.
			 * @type {?Function}
			 */ onShaderError: null
        };
        // clearing
        this.autoClear = true;
        this.autoClearColor = true;
        this.autoClearDepth = true;
        this.autoClearStencil = true;
        // scene graph
        this.sortObjects = true;
        // user-defined clipping
        this.clippingPlanes = [];
        this.localClippingEnabled = false;
        // physically based shading
        this.outputEncoding = $e8ea6a63d48a4fea$export$7207336e4151a112;
        // physical lights
        this.useLegacyLights = true;
        // tone mapping
        this.toneMapping = $e8ea6a63d48a4fea$export$9fcb6b4294603b2;
        this.toneMappingExposure = 1.0;
        // internal properties
        const _this = this;
        let _isContextLost = false;
        // internal state cache
        let _currentActiveCubeFace = 0;
        let _currentActiveMipmapLevel = 0;
        let _currentRenderTarget = null;
        let _currentMaterialId = -1;
        let _currentCamera = null;
        const _currentViewport = new $e8ea6a63d48a4fea$export$fa7daccca11cdbe3();
        const _currentScissor = new $e8ea6a63d48a4fea$export$fa7daccca11cdbe3();
        let _currentScissorTest = null;
        //
        let _width = canvas.width;
        let _height = canvas.height;
        let _pixelRatio = 1;
        let _opaqueSort = null;
        let _transparentSort = null;
        const _viewport = new $e8ea6a63d48a4fea$export$fa7daccca11cdbe3(0, 0, _width, _height);
        const _scissor = new $e8ea6a63d48a4fea$export$fa7daccca11cdbe3(0, 0, _width, _height);
        let _scissorTest = false;
        // frustum
        const _frustum = new $e8ea6a63d48a4fea$export$35efe6f4c85463d2();
        // clipping
        let _clippingEnabled = false;
        let _localClippingEnabled = false;
        // transmission
        let _transmissionRenderTarget = null;
        // camera matrices cache
        const _projScreenMatrix = new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5();
        const _vector3 = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        const _emptyScene = {
            background: null,
            fog: null,
            environment: null,
            overrideMaterial: null,
            isScene: true
        };
        function getTargetPixelRatio() {
            return _currentRenderTarget === null ? _pixelRatio : 1;
        }
        // initialize
        let _gl = context;
        function getContext(contextNames, contextAttributes) {
            for(let i = 0; i < contextNames.length; i++){
                const contextName = contextNames[i];
                const context = canvas.getContext(contextName, contextAttributes);
                if (context !== null) return context;
            }
            return null;
        }
        try {
            const contextAttributes = {
                alpha: true,
                depth: depth,
                stencil: stencil,
                antialias: antialias,
                premultipliedAlpha: premultipliedAlpha,
                preserveDrawingBuffer: preserveDrawingBuffer,
                powerPreference: powerPreference,
                failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat
            };
            // OffscreenCanvas does not have setAttribute, see #22811
            if ("setAttribute" in canvas) canvas.setAttribute("data-engine", `three.js r${$e8ea6a63d48a4fea$export$3545e07a80636437}`);
            // event listeners must be registered before WebGL context is created, see #12753
            canvas.addEventListener("webglcontextlost", onContextLost, false);
            canvas.addEventListener("webglcontextrestored", onContextRestore, false);
            canvas.addEventListener("webglcontextcreationerror", onContextCreationError, false);
            if (_gl === null) {
                const contextNames = [
                    "webgl2",
                    "webgl",
                    "experimental-webgl"
                ];
                if (_this.isWebGL1Renderer === true) contextNames.shift();
                _gl = getContext(contextNames, contextAttributes);
                if (_gl === null) {
                    if (getContext(contextNames)) throw new Error("Error creating WebGL context with your selected attributes.");
                    else throw new Error("Error creating WebGL context.");
                }
            }
            // Some experimental-webgl implementations do not have getShaderPrecisionFormat
            if (_gl.getShaderPrecisionFormat === undefined) _gl.getShaderPrecisionFormat = function() {
                return {
                    "rangeMin": 1,
                    "rangeMax": 1,
                    "precision": 1
                };
            };
        } catch (error) {
            console.error("THREE.WebGLRenderer: " + error.message);
            throw error;
        }
        let extensions, capabilities, state, info;
        let properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
        let programCache, materials, renderLists, renderStates, clipping, shadowMap;
        let background, morphtargets, bufferRenderer, indexedBufferRenderer;
        let utils, bindingStates, uniformsGroups;
        function initGLContext() {
            extensions = new $e8ea6a63d48a4fea$var$WebGLExtensions(_gl);
            capabilities = new $e8ea6a63d48a4fea$var$WebGLCapabilities(_gl, extensions, parameters);
            extensions.init(capabilities);
            utils = new $e8ea6a63d48a4fea$export$ddaebcad857649a8(_gl, extensions, capabilities);
            state = new $e8ea6a63d48a4fea$var$WebGLState(_gl, extensions, capabilities);
            info = new $e8ea6a63d48a4fea$var$WebGLInfo();
            properties = new $e8ea6a63d48a4fea$var$WebGLProperties();
            textures = new $e8ea6a63d48a4fea$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
            cubemaps = new $e8ea6a63d48a4fea$var$WebGLCubeMaps(_this);
            cubeuvmaps = new $e8ea6a63d48a4fea$var$WebGLCubeUVMaps(_this);
            attributes = new $e8ea6a63d48a4fea$var$WebGLAttributes(_gl, capabilities);
            bindingStates = new $e8ea6a63d48a4fea$var$WebGLBindingStates(_gl, extensions, attributes, capabilities);
            geometries = new $e8ea6a63d48a4fea$var$WebGLGeometries(_gl, attributes, info, bindingStates);
            objects = new $e8ea6a63d48a4fea$var$WebGLObjects(_gl, geometries, attributes, info);
            morphtargets = new $e8ea6a63d48a4fea$var$WebGLMorphtargets(_gl, capabilities, textures);
            clipping = new $e8ea6a63d48a4fea$var$WebGLClipping(properties);
            programCache = new $e8ea6a63d48a4fea$var$WebGLPrograms(_this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping);
            materials = new $e8ea6a63d48a4fea$var$WebGLMaterials(_this, properties);
            renderLists = new $e8ea6a63d48a4fea$var$WebGLRenderLists();
            renderStates = new $e8ea6a63d48a4fea$var$WebGLRenderStates(extensions, capabilities);
            background = new $e8ea6a63d48a4fea$var$WebGLBackground(_this, cubemaps, cubeuvmaps, state, objects, _alpha, premultipliedAlpha);
            shadowMap = new $e8ea6a63d48a4fea$var$WebGLShadowMap(_this, objects, capabilities);
            uniformsGroups = new $e8ea6a63d48a4fea$var$WebGLUniformsGroups(_gl, info, capabilities, state);
            bufferRenderer = new $e8ea6a63d48a4fea$var$WebGLBufferRenderer(_gl, extensions, info, capabilities);
            indexedBufferRenderer = new $e8ea6a63d48a4fea$var$WebGLIndexedBufferRenderer(_gl, extensions, info, capabilities);
            info.programs = programCache.programs;
            _this.capabilities = capabilities;
            _this.extensions = extensions;
            _this.properties = properties;
            _this.renderLists = renderLists;
            _this.shadowMap = shadowMap;
            _this.state = state;
            _this.info = info;
        }
        initGLContext();
        // xr
        const xr = new $e8ea6a63d48a4fea$var$WebXRManager(_this, _gl);
        this.xr = xr;
        // API
        this.getContext = function() {
            return _gl;
        };
        this.getContextAttributes = function() {
            return _gl.getContextAttributes();
        };
        this.forceContextLoss = function() {
            const extension = extensions.get("WEBGL_lose_context");
            if (extension) extension.loseContext();
        };
        this.forceContextRestore = function() {
            const extension = extensions.get("WEBGL_lose_context");
            if (extension) extension.restoreContext();
        };
        this.getPixelRatio = function() {
            return _pixelRatio;
        };
        this.setPixelRatio = function(value) {
            if (value === undefined) return;
            _pixelRatio = value;
            this.setSize(_width, _height, false);
        };
        this.getSize = function(target) {
            return target.set(_width, _height);
        };
        this.setSize = function(width, height, updateStyle = true) {
            if (xr.isPresenting) {
                console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.");
                return;
            }
            _width = width;
            _height = height;
            canvas.width = Math.floor(width * _pixelRatio);
            canvas.height = Math.floor(height * _pixelRatio);
            if (updateStyle === true) {
                canvas.style.width = width + "px";
                canvas.style.height = height + "px";
            }
            this.setViewport(0, 0, width, height);
        };
        this.getDrawingBufferSize = function(target) {
            return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
        };
        this.setDrawingBufferSize = function(width, height, pixelRatio) {
            _width = width;
            _height = height;
            _pixelRatio = pixelRatio;
            canvas.width = Math.floor(width * pixelRatio);
            canvas.height = Math.floor(height * pixelRatio);
            this.setViewport(0, 0, width, height);
        };
        this.getCurrentViewport = function(target) {
            return target.copy(_currentViewport);
        };
        this.getViewport = function(target) {
            return target.copy(_viewport);
        };
        this.setViewport = function(x, y, width, height) {
            if (x.isVector4) _viewport.set(x.x, x.y, x.z, x.w);
            else _viewport.set(x, y, width, height);
            state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor());
        };
        this.getScissor = function(target) {
            return target.copy(_scissor);
        };
        this.setScissor = function(x, y, width, height) {
            if (x.isVector4) _scissor.set(x.x, x.y, x.z, x.w);
            else _scissor.set(x, y, width, height);
            state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor());
        };
        this.getScissorTest = function() {
            return _scissorTest;
        };
        this.setScissorTest = function(boolean) {
            state.setScissorTest(_scissorTest = boolean);
        };
        this.setOpaqueSort = function(method) {
            _opaqueSort = method;
        };
        this.setTransparentSort = function(method) {
            _transparentSort = method;
        };
        // Clearing
        this.getClearColor = function(target) {
            return target.copy(background.getClearColor());
        };
        this.setClearColor = function() {
            background.setClearColor.apply(background, arguments);
        };
        this.getClearAlpha = function() {
            return background.getClearAlpha();
        };
        this.setClearAlpha = function() {
            background.setClearAlpha.apply(background, arguments);
        };
        this.clear = function(color = true, depth = true, stencil = true) {
            let bits = 0;
            if (color) bits |= 16384;
            if (depth) bits |= 256;
            if (stencil) bits |= 1024;
            _gl.clear(bits);
        };
        this.clearColor = function() {
            this.clear(true, false, false);
        };
        this.clearDepth = function() {
            this.clear(false, true, false);
        };
        this.clearStencil = function() {
            this.clear(false, false, true);
        };
        //
        this.dispose = function() {
            canvas.removeEventListener("webglcontextlost", onContextLost, false);
            canvas.removeEventListener("webglcontextrestored", onContextRestore, false);
            canvas.removeEventListener("webglcontextcreationerror", onContextCreationError, false);
            renderLists.dispose();
            renderStates.dispose();
            properties.dispose();
            cubemaps.dispose();
            cubeuvmaps.dispose();
            objects.dispose();
            bindingStates.dispose();
            uniformsGroups.dispose();
            programCache.dispose();
            xr.dispose();
            xr.removeEventListener("sessionstart", onXRSessionStart);
            xr.removeEventListener("sessionend", onXRSessionEnd);
            if (_transmissionRenderTarget) {
                _transmissionRenderTarget.dispose();
                _transmissionRenderTarget = null;
            }
            animation.stop();
        };
        // Events
        function onContextLost(event) {
            event.preventDefault();
            console.log("THREE.WebGLRenderer: Context Lost.");
            _isContextLost = true;
        }
        function onContextRestore() {
            console.log("THREE.WebGLRenderer: Context Restored.");
            _isContextLost = false;
            const infoAutoReset = info.autoReset;
            const shadowMapEnabled = shadowMap.enabled;
            const shadowMapAutoUpdate = shadowMap.autoUpdate;
            const shadowMapNeedsUpdate = shadowMap.needsUpdate;
            const shadowMapType = shadowMap.type;
            initGLContext();
            info.autoReset = infoAutoReset;
            shadowMap.enabled = shadowMapEnabled;
            shadowMap.autoUpdate = shadowMapAutoUpdate;
            shadowMap.needsUpdate = shadowMapNeedsUpdate;
            shadowMap.type = shadowMapType;
        }
        function onContextCreationError(event) {
            console.error("THREE.WebGLRenderer: A WebGL context could not be created. Reason: ", event.statusMessage);
        }
        function onMaterialDispose(event) {
            const material = event.target;
            material.removeEventListener("dispose", onMaterialDispose);
            deallocateMaterial(material);
        }
        // Buffer deallocation
        function deallocateMaterial(material) {
            releaseMaterialProgramReferences(material);
            properties.remove(material);
        }
        function releaseMaterialProgramReferences(material) {
            const programs = properties.get(material).programs;
            if (programs !== undefined) {
                programs.forEach(function(program) {
                    programCache.releaseProgram(program);
                });
                if (material.isShaderMaterial) programCache.releaseShaderCache(material);
            }
        }
        // Buffer rendering
        this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
            if (scene === null) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)
            const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
            const program = setProgram(camera, scene, geometry, material, object);
            state.setMaterial(material, frontFaceCW);
            //
            let index = geometry.index;
            let rangeFactor = 1;
            if (material.wireframe === true) {
                index = geometries.getWireframeAttribute(geometry);
                rangeFactor = 2;
            }
            //
            const drawRange = geometry.drawRange;
            const position = geometry.attributes.position;
            let drawStart = drawRange.start * rangeFactor;
            let drawEnd = (drawRange.start + drawRange.count) * rangeFactor;
            if (group !== null) {
                drawStart = Math.max(drawStart, group.start * rangeFactor);
                drawEnd = Math.min(drawEnd, (group.start + group.count) * rangeFactor);
            }
            if (index !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, index.count);
            } else if (position !== undefined && position !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, position.count);
            }
            const drawCount = drawEnd - drawStart;
            if (drawCount < 0 || drawCount === Infinity) return;
            //
            bindingStates.setup(object, material, program, geometry, index);
            let attribute;
            let renderer = bufferRenderer;
            if (index !== null) {
                attribute = attributes.get(index);
                renderer = indexedBufferRenderer;
                renderer.setIndex(attribute);
            }
            //
            if (object.isMesh) {
                if (material.wireframe === true) {
                    state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
                    renderer.setMode(1);
                } else renderer.setMode(4);
            } else if (object.isLine) {
                let lineWidth = material.linewidth;
                if (lineWidth === undefined) lineWidth = 1; // Not using Line*Material
                state.setLineWidth(lineWidth * getTargetPixelRatio());
                if (object.isLineSegments) renderer.setMode(1);
                else if (object.isLineLoop) renderer.setMode(2);
                else renderer.setMode(3);
            } else if (object.isPoints) renderer.setMode(0);
            else if (object.isSprite) renderer.setMode(4);
            if (object.isInstancedMesh) renderer.renderInstances(drawStart, drawCount, object.count);
            else if (geometry.isInstancedBufferGeometry) {
                const maxInstanceCount = geometry._maxInstanceCount !== undefined ? geometry._maxInstanceCount : Infinity;
                const instanceCount = Math.min(geometry.instanceCount, maxInstanceCount);
                renderer.renderInstances(drawStart, drawCount, instanceCount);
            } else renderer.render(drawStart, drawCount);
        };
        // Compile
        this.compile = function(scene, camera) {
            function prepare(material, scene, object) {
                if (material.transparent === true && material.side === $e8ea6a63d48a4fea$export$3b296b6f144d5b03 && material.forceSinglePass === false) {
                    material.side = $e8ea6a63d48a4fea$export$d9f0486e75b5ace;
                    material.needsUpdate = true;
                    getProgram(material, scene, object);
                    material.side = $e8ea6a63d48a4fea$export$2ede184fc2998901;
                    material.needsUpdate = true;
                    getProgram(material, scene, object);
                    material.side = $e8ea6a63d48a4fea$export$3b296b6f144d5b03;
                } else getProgram(material, scene, object);
            }
            currentRenderState = renderStates.get(scene);
            currentRenderState.init();
            renderStateStack.push(currentRenderState);
            scene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            currentRenderState.setupLights(_this.useLegacyLights);
            scene.traverse(function(object) {
                const material = object.material;
                if (material) {
                    if (Array.isArray(material)) for(let i = 0; i < material.length; i++){
                        const material2 = material[i];
                        prepare(material2, scene, object);
                    }
                    else prepare(material, scene, object);
                }
            });
            renderStateStack.pop();
            currentRenderState = null;
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time) {
            if (onAnimationFrameCallback) onAnimationFrameCallback(time);
        }
        function onXRSessionStart() {
            animation.stop();
        }
        function onXRSessionEnd() {
            animation.start();
        }
        const animation = new $e8ea6a63d48a4fea$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        if (typeof self !== "undefined") animation.setContext(self);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
            xr.setAnimationLoop(callback);
            callback === null ? animation.stop() : animation.start();
        };
        xr.addEventListener("sessionstart", onXRSessionStart);
        xr.addEventListener("sessionend", onXRSessionEnd);
        // Rendering
        this.render = function(scene, camera) {
            if (camera !== undefined && camera.isCamera !== true) {
                console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
                return;
            }
            if (_isContextLost === true) return;
            // update scene graph
            if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
            // update camera matrices and frustum
            if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
            if (xr.enabled === true && xr.isPresenting === true) {
                if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
                camera = xr.getCamera(); // use XR camera for rendering
            }
            //
            if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
            currentRenderState = renderStates.get(scene, renderStateStack.length);
            currentRenderState.init();
            renderStateStack.push(currentRenderState);
            _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            _frustum.setFromProjectionMatrix(_projScreenMatrix);
            _localClippingEnabled = this.localClippingEnabled;
            _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled);
            currentRenderList = renderLists.get(scene, renderListStack.length);
            currentRenderList.init();
            renderListStack.push(currentRenderList);
            projectObject(scene, camera, 0, _this.sortObjects);
            currentRenderList.finish();
            if (_this.sortObjects === true) currentRenderList.sort(_opaqueSort, _transparentSort);
            //
            if (_clippingEnabled === true) clipping.beginShadows();
            const shadowsArray = currentRenderState.state.shadowsArray;
            shadowMap.render(shadowsArray, scene, camera);
            if (_clippingEnabled === true) clipping.endShadows();
            //
            if (this.info.autoReset === true) this.info.reset();
            //
            background.render(currentRenderList, scene);
            // render scene
            currentRenderState.setupLights(_this.useLegacyLights);
            if (camera.isArrayCamera) {
                const cameras = camera.cameras;
                for(let i = 0, l = cameras.length; i < l; i++){
                    const camera2 = cameras[i];
                    renderScene(currentRenderList, scene, camera2, camera2.viewport);
                }
            } else renderScene(currentRenderList, scene, camera);
            //
            if (_currentRenderTarget !== null) {
                // resolve multisample renderbuffers to a single-sample texture if necessary
                textures.updateMultisampleRenderTarget(_currentRenderTarget);
                // Generate mipmap if we're using any kind of mipmap filtering
                textures.updateRenderTargetMipmap(_currentRenderTarget);
            }
            //
            if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
            // _gl.finish();
            bindingStates.resetDefaultState();
            _currentMaterialId = -1;
            _currentCamera = null;
            renderStateStack.pop();
            if (renderStateStack.length > 0) currentRenderState = renderStateStack[renderStateStack.length - 1];
            else currentRenderState = null;
            renderListStack.pop();
            if (renderListStack.length > 0) currentRenderList = renderListStack[renderListStack.length - 1];
            else currentRenderList = null;
        };
        function projectObject(object, camera, groupOrder, sortObjects) {
            if (object.visible === false) return;
            const visible = object.layers.test(camera.layers);
            if (visible) {
                if (object.isGroup) groupOrder = object.renderOrder;
                else if (object.isLOD) {
                    if (object.autoUpdate === true) object.update(camera);
                } else if (object.isLight) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                } else if (object.isSprite) {
                    if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
                        if (sortObjects) _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                    }
                } else if (object.isMesh || object.isLine || object.isPoints) {
                    if (object.isSkinnedMesh) // update skeleton only once in a frame
                    {
                        if (object.skeleton.frame !== info.render.frame) {
                            object.skeleton.update();
                            object.skeleton.frame = info.render.frame;
                        }
                    }
                    if (!object.frustumCulled || _frustum.intersectsObject(object)) {
                        if (sortObjects) _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (Array.isArray(material)) {
                            const groups = geometry.groups;
                            for(let i = 0, l = groups.length; i < l; i++){
                                const group = groups[i];
                                const groupMaterial = material[group.materialIndex];
                                if (groupMaterial && groupMaterial.visible) currentRenderList.push(object, geometry, groupMaterial, groupOrder, _vector3.z, group);
                            }
                        } else if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                    }
                }
            }
            const children = object.children;
            for(let i = 0, l = children.length; i < l; i++)projectObject(children[i], camera, groupOrder, sortObjects);
        }
        function renderScene(currentRenderList, scene, camera, viewport) {
            const opaqueObjects = currentRenderList.opaque;
            const transmissiveObjects = currentRenderList.transmissive;
            const transparentObjects = currentRenderList.transparent;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            if (transmissiveObjects.length > 0) renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera);
            if (viewport) state.viewport(_currentViewport.copy(viewport));
            if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
            if (transmissiveObjects.length > 0) renderObjects(transmissiveObjects, scene, camera);
            if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
            // Ensure depth buffer writing is enabled so it can be cleared on next render
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            state.setPolygonOffset(false);
        }
        function renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera) {
            if (_transmissionRenderTarget === null) {
                const isWebGL2 = capabilities.isWebGL2;
                _transmissionRenderTarget = new $e8ea6a63d48a4fea$export$3c052beb2e51e23f(1024, 1024, {
                    generateMipmaps: true,
                    type: extensions.has("EXT_color_buffer_half_float") ? $e8ea6a63d48a4fea$export$2697304443f382bc : $e8ea6a63d48a4fea$export$2e8ce08d3f6f5e10,
                    minFilter: $e8ea6a63d48a4fea$export$5d8599b6a933fb1b,
                    samples: isWebGL2 && antialias === true ? 4 : 0
                });
            // debug
            /*
				const geometry = new PlaneGeometry();
				const material = new MeshBasicMaterial( { map: _transmissionRenderTarget.texture } );

				const mesh = new Mesh( geometry, material );
				scene.add( mesh );
				*/ }
            //
            const currentRenderTarget = _this.getRenderTarget();
            _this.setRenderTarget(_transmissionRenderTarget);
            _this.clear();
            // Turn off the features which can affect the frag color for opaque objects pass.
            // Otherwise they are applied twice in opaque objects pass and transmission objects pass.
            const currentToneMapping = _this.toneMapping;
            _this.toneMapping = $e8ea6a63d48a4fea$export$9fcb6b4294603b2;
            renderObjects(opaqueObjects, scene, camera);
            textures.updateMultisampleRenderTarget(_transmissionRenderTarget);
            textures.updateRenderTargetMipmap(_transmissionRenderTarget);
            let renderTargetNeedsUpdate = false;
            for(let i = 0, l = transmissiveObjects.length; i < l; i++){
                const renderItem = transmissiveObjects[i];
                const object = renderItem.object;
                const geometry = renderItem.geometry;
                const material = renderItem.material;
                const group = renderItem.group;
                if (material.side === $e8ea6a63d48a4fea$export$3b296b6f144d5b03 && object.layers.test(camera.layers)) {
                    const currentSide = material.side;
                    material.side = $e8ea6a63d48a4fea$export$d9f0486e75b5ace;
                    material.needsUpdate = true;
                    renderObject(object, scene, camera, geometry, material, group);
                    material.side = currentSide;
                    material.needsUpdate = true;
                    renderTargetNeedsUpdate = true;
                }
            }
            if (renderTargetNeedsUpdate === true) {
                textures.updateMultisampleRenderTarget(_transmissionRenderTarget);
                textures.updateRenderTargetMipmap(_transmissionRenderTarget);
            }
            _this.setRenderTarget(currentRenderTarget);
            _this.toneMapping = currentToneMapping;
        }
        function renderObjects(renderList, scene, camera) {
            const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            for(let i = 0, l = renderList.length; i < l; i++){
                const renderItem = renderList[i];
                const object = renderItem.object;
                const geometry = renderItem.geometry;
                const material = overrideMaterial === null ? renderItem.material : overrideMaterial;
                const group = renderItem.group;
                if (object.layers.test(camera.layers)) renderObject(object, scene, camera, geometry, material, group);
            }
        }
        function renderObject(object, scene, camera, geometry, material, group) {
            object.onBeforeRender(_this, scene, camera, geometry, material, group);
            object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
            object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
            material.onBeforeRender(_this, scene, camera, geometry, object, group);
            if (material.transparent === true && material.side === $e8ea6a63d48a4fea$export$3b296b6f144d5b03 && material.forceSinglePass === false) {
                material.side = $e8ea6a63d48a4fea$export$d9f0486e75b5ace;
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = $e8ea6a63d48a4fea$export$2ede184fc2998901;
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = $e8ea6a63d48a4fea$export$3b296b6f144d5b03;
            } else _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            object.onAfterRender(_this, scene, camera, geometry, material, group);
        }
        function getProgram(material, scene, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            const shadowsArray = currentRenderState.state.shadowsArray;
            const lightsStateVersion = lights.state.version;
            const parameters = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
            const programCacheKey = programCache.getProgramCacheKey(parameters);
            let programs = materialProperties.programs;
            // always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change
            materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
            materialProperties.fog = scene.fog;
            materialProperties.envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || materialProperties.environment);
            if (programs === undefined) {
                // new material
                material.addEventListener("dispose", onMaterialDispose);
                programs = new Map();
                materialProperties.programs = programs;
            }
            let program = programs.get(programCacheKey);
            if (program !== undefined) // early out if program and light state is identical
            {
                if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
                    updateCommonMaterialProperties(material, parameters);
                    return program;
                }
            } else {
                parameters.uniforms = programCache.getUniforms(material);
                material.onBuild(object, parameters, _this);
                material.onBeforeCompile(parameters, _this);
                program = programCache.acquireProgram(parameters, programCacheKey);
                programs.set(programCacheKey, program);
                materialProperties.uniforms = parameters.uniforms;
            }
            const uniforms = materialProperties.uniforms;
            if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) uniforms.clippingPlanes = clipping.uniform;
            updateCommonMaterialProperties(material, parameters);
            // store the light setup it was created for
            materialProperties.needsLights = materialNeedsLights(material);
            materialProperties.lightsStateVersion = lightsStateVersion;
            if (materialProperties.needsLights) {
                // wire up the material to this renderer's lighting state
                uniforms.ambientLightColor.value = lights.state.ambient;
                uniforms.lightProbe.value = lights.state.probe;
                uniforms.directionalLights.value = lights.state.directional;
                uniforms.directionalLightShadows.value = lights.state.directionalShadow;
                uniforms.spotLights.value = lights.state.spot;
                uniforms.spotLightShadows.value = lights.state.spotShadow;
                uniforms.rectAreaLights.value = lights.state.rectArea;
                uniforms.ltc_1.value = lights.state.rectAreaLTC1;
                uniforms.ltc_2.value = lights.state.rectAreaLTC2;
                uniforms.pointLights.value = lights.state.point;
                uniforms.pointLightShadows.value = lights.state.pointShadow;
                uniforms.hemisphereLights.value = lights.state.hemi;
                uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
                uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
                uniforms.spotShadowMap.value = lights.state.spotShadowMap;
                uniforms.spotLightMatrix.value = lights.state.spotLightMatrix;
                uniforms.spotLightMap.value = lights.state.spotLightMap;
                uniforms.pointShadowMap.value = lights.state.pointShadowMap;
                uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
            // TODO (abelnation): add area lights shadow info to uniforms
            }
            const progUniforms = program.getUniforms();
            const uniformsList = $e8ea6a63d48a4fea$var$WebGLUniforms.seqWithValue(progUniforms.seq, uniforms);
            materialProperties.currentProgram = program;
            materialProperties.uniformsList = uniformsList;
            return program;
        }
        function updateCommonMaterialProperties(material, parameters) {
            const materialProperties = properties.get(material);
            materialProperties.outputEncoding = parameters.outputEncoding;
            materialProperties.instancing = parameters.instancing;
            materialProperties.skinning = parameters.skinning;
            materialProperties.morphTargets = parameters.morphTargets;
            materialProperties.morphNormals = parameters.morphNormals;
            materialProperties.morphColors = parameters.morphColors;
            materialProperties.morphTargetsCount = parameters.morphTargetsCount;
            materialProperties.numClippingPlanes = parameters.numClippingPlanes;
            materialProperties.numIntersection = parameters.numClipIntersection;
            materialProperties.vertexAlphas = parameters.vertexAlphas;
            materialProperties.vertexTangents = parameters.vertexTangents;
            materialProperties.toneMapping = parameters.toneMapping;
        }
        function setProgram(camera, scene, geometry, material, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            textures.resetTextureUnits();
            const fog = scene.fog;
            const environment = material.isMeshStandardMaterial ? scene.environment : null;
            const encoding = _currentRenderTarget === null ? _this.outputEncoding : _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.encoding : $e8ea6a63d48a4fea$export$7207336e4151a112;
            const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
            const vertexAlphas = material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4;
            const vertexTangents = !!material.normalMap && !!geometry.attributes.tangent;
            const morphTargets = !!geometry.morphAttributes.position;
            const morphNormals = !!geometry.morphAttributes.normal;
            const morphColors = !!geometry.morphAttributes.color;
            const toneMapping = material.toneMapped ? _this.toneMapping : $e8ea6a63d48a4fea$export$9fcb6b4294603b2;
            const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
            const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            if (_clippingEnabled === true) {
                if (_localClippingEnabled === true || camera !== _currentCamera) {
                    const useCache = camera === _currentCamera && material.id === _currentMaterialId;
                    // we might want to call this function with some ClippingGroup
                    // object instead of the material, once it becomes feasible
                    // (#8465, #8379)
                    clipping.setState(material, camera, useCache);
                }
            }
            //
            let needsProgramChange = false;
            if (material.version === materialProperties.__version) {
                if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) needsProgramChange = true;
                else if (materialProperties.outputEncoding !== encoding) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancing === false) needsProgramChange = true;
                else if (!object.isInstancedMesh && materialProperties.instancing === true) needsProgramChange = true;
                else if (object.isSkinnedMesh && materialProperties.skinning === false) needsProgramChange = true;
                else if (!object.isSkinnedMesh && materialProperties.skinning === true) needsProgramChange = true;
                else if (materialProperties.envMap !== envMap) needsProgramChange = true;
                else if (material.fog === true && materialProperties.fog !== fog) needsProgramChange = true;
                else if (materialProperties.numClippingPlanes !== undefined && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) needsProgramChange = true;
                else if (materialProperties.vertexAlphas !== vertexAlphas) needsProgramChange = true;
                else if (materialProperties.vertexTangents !== vertexTangents) needsProgramChange = true;
                else if (materialProperties.morphTargets !== morphTargets) needsProgramChange = true;
                else if (materialProperties.morphNormals !== morphNormals) needsProgramChange = true;
                else if (materialProperties.morphColors !== morphColors) needsProgramChange = true;
                else if (materialProperties.toneMapping !== toneMapping) needsProgramChange = true;
                else if (capabilities.isWebGL2 === true && materialProperties.morphTargetsCount !== morphTargetsCount) needsProgramChange = true;
            } else {
                needsProgramChange = true;
                materialProperties.__version = material.version;
            }
            //
            let program = materialProperties.currentProgram;
            if (needsProgramChange === true) program = getProgram(material, scene, object);
            let refreshProgram = false;
            let refreshMaterial = false;
            let refreshLights = false;
            const p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
            if (state.useProgram(program.program)) {
                refreshProgram = true;
                refreshMaterial = true;
                refreshLights = true;
            }
            if (material.id !== _currentMaterialId) {
                _currentMaterialId = material.id;
                refreshMaterial = true;
            }
            if (refreshProgram || _currentCamera !== camera) {
                p_uniforms.setValue(_gl, "projectionMatrix", camera.projectionMatrix);
                if (capabilities.logarithmicDepthBuffer) p_uniforms.setValue(_gl, "logDepthBufFC", 2.0 / (Math.log(camera.far + 1.0) / Math.LN2));
                if (_currentCamera !== camera) {
                    _currentCamera = camera;
                    // lighting uniforms depend on the camera so enforce an update
                    // now, in case this material supports lights - or later, when
                    // the next material that does gets activated:
                    refreshMaterial = true; // set to true on material change
                    refreshLights = true; // remains set until update done
                }
                // load material specific uniforms
                // (shader material also gets them for the sake of genericity)
                if (material.isShaderMaterial || material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshStandardMaterial || material.envMap) {
                    const uCamPos = p_uniforms.map.cameraPosition;
                    if (uCamPos !== undefined) uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
                }
                if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) p_uniforms.setValue(_gl, "isOrthographic", camera.isOrthographicCamera === true);
                if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial || material.isShadowMaterial || object.isSkinnedMesh) p_uniforms.setValue(_gl, "viewMatrix", camera.matrixWorldInverse);
            }
            // skinning and morph target uniforms must be set even if material didn't change
            // auto-setting of texture unit for bone and morph texture must go before other textures
            // otherwise textures used for skinning and morphing can take over texture units reserved for other material textures
            if (object.isSkinnedMesh) {
                p_uniforms.setOptional(_gl, object, "bindMatrix");
                p_uniforms.setOptional(_gl, object, "bindMatrixInverse");
                const skeleton = object.skeleton;
                if (skeleton) {
                    if (capabilities.floatVertexTextures) {
                        if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
                        p_uniforms.setValue(_gl, "boneTexture", skeleton.boneTexture, textures);
                        p_uniforms.setValue(_gl, "boneTextureSize", skeleton.boneTextureSize);
                    } else console.warn("THREE.WebGLRenderer: SkinnedMesh can only be used with WebGL 2. With WebGL 1 OES_texture_float and vertex textures support is required.");
                }
            }
            const morphAttributes = geometry.morphAttributes;
            if (morphAttributes.position !== undefined || morphAttributes.normal !== undefined || morphAttributes.color !== undefined && capabilities.isWebGL2 === true) morphtargets.update(object, geometry, program);
            if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
                materialProperties.receiveShadow = object.receiveShadow;
                p_uniforms.setValue(_gl, "receiveShadow", object.receiveShadow);
            }
            // https://github.com/mrdoob/three.js/pull/24467#issuecomment-1209031512
            if (material.isMeshGouraudMaterial && material.envMap !== null) {
                m_uniforms.envMap.value = envMap;
                m_uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            }
            if (refreshMaterial) {
                p_uniforms.setValue(_gl, "toneMappingExposure", _this.toneMappingExposure);
                if (materialProperties.needsLights) // the current material requires lighting info
                // note: all lighting uniforms are always set correctly
                // they simply reference the renderer's state for their
                // values
                //
                // use the current material's .needsUpdate flags to set
                // the GL state when required
                markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
                // refresh uniforms common to several materials
                if (fog && material.fog === true) materials.refreshFogUniforms(m_uniforms, fog);
                materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, _transmissionRenderTarget);
                $e8ea6a63d48a4fea$var$WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
            }
            if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
                $e8ea6a63d48a4fea$var$WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
                material.uniformsNeedUpdate = false;
            }
            if (material.isSpriteMaterial) p_uniforms.setValue(_gl, "center", object.center);
            // common matrices
            p_uniforms.setValue(_gl, "modelViewMatrix", object.modelViewMatrix);
            p_uniforms.setValue(_gl, "normalMatrix", object.normalMatrix);
            p_uniforms.setValue(_gl, "modelMatrix", object.matrixWorld);
            // UBOs
            if (material.isShaderMaterial || material.isRawShaderMaterial) {
                const groups = material.uniformsGroups;
                for(let i = 0, l = groups.length; i < l; i++)if (capabilities.isWebGL2) {
                    const group = groups[i];
                    uniformsGroups.update(group, program);
                    uniformsGroups.bind(group, program);
                } else console.warn("THREE.WebGLRenderer: Uniform Buffer Objects can only be used with WebGL 2.");
            }
            return program;
        }
        // If uniforms are marked as clean, they don't need to be loaded to the GPU.
        function markUniformsLightsNeedsUpdate(uniforms, value) {
            uniforms.ambientLightColor.needsUpdate = value;
            uniforms.lightProbe.needsUpdate = value;
            uniforms.directionalLights.needsUpdate = value;
            uniforms.directionalLightShadows.needsUpdate = value;
            uniforms.pointLights.needsUpdate = value;
            uniforms.pointLightShadows.needsUpdate = value;
            uniforms.spotLights.needsUpdate = value;
            uniforms.spotLightShadows.needsUpdate = value;
            uniforms.rectAreaLights.needsUpdate = value;
            uniforms.hemisphereLights.needsUpdate = value;
        }
        function materialNeedsLights(material) {
            return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
        }
        this.getActiveCubeFace = function() {
            return _currentActiveCubeFace;
        };
        this.getActiveMipmapLevel = function() {
            return _currentActiveMipmapLevel;
        };
        this.getRenderTarget = function() {
            return _currentRenderTarget;
        };
        this.setRenderTargetTextures = function(renderTarget, colorTexture, depthTexture) {
            properties.get(renderTarget.texture).__webglTexture = colorTexture;
            properties.get(renderTarget.depthTexture).__webglTexture = depthTexture;
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__hasExternalTextures = true;
            if (renderTargetProperties.__hasExternalTextures) {
                renderTargetProperties.__autoAllocateDepthBuffer = depthTexture === undefined;
                if (!renderTargetProperties.__autoAllocateDepthBuffer) // The multisample_render_to_texture extension doesn't work properly if there
                // are midframe flushes and an external depth buffer. Disable use of the extension.
                {
                    if (extensions.has("WEBGL_multisampled_render_to_texture") === true) {
                        console.warn("THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided");
                        renderTargetProperties.__useRenderToTexture = false;
                    }
                }
            }
        };
        this.setRenderTargetFramebuffer = function(renderTarget, defaultFramebuffer) {
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
            renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === undefined;
        };
        this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
            _currentRenderTarget = renderTarget;
            _currentActiveCubeFace = activeCubeFace;
            _currentActiveMipmapLevel = activeMipmapLevel;
            let useDefaultFramebuffer = true;
            let framebuffer = null;
            let isCube = false;
            let isRenderTarget3D = false;
            if (renderTarget) {
                const renderTargetProperties = properties.get(renderTarget);
                if (renderTargetProperties.__useDefaultFramebuffer !== undefined) {
                    // We need to make sure to rebind the framebuffer.
                    state.bindFramebuffer(36160, null);
                    useDefaultFramebuffer = false;
                } else if (renderTargetProperties.__webglFramebuffer === undefined) textures.setupRenderTarget(renderTarget);
                else if (renderTargetProperties.__hasExternalTextures) // Color and depth texture must be rebound in order for the swapchain to update.
                textures.rebindTextures(renderTarget, properties.get(renderTarget.texture).__webglTexture, properties.get(renderTarget.depthTexture).__webglTexture);
                const texture = renderTarget.texture;
                if (texture.isData3DTexture || texture.isDataArrayTexture || texture.isCompressedArrayTexture) isRenderTarget3D = true;
                const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
                if (renderTarget.isWebGLCubeRenderTarget) {
                    framebuffer = __webglFramebuffer[activeCubeFace];
                    isCube = true;
                } else if (capabilities.isWebGL2 && renderTarget.samples > 0 && textures.useMultisampledRTT(renderTarget) === false) framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
                else framebuffer = __webglFramebuffer;
                _currentViewport.copy(renderTarget.viewport);
                _currentScissor.copy(renderTarget.scissor);
                _currentScissorTest = renderTarget.scissorTest;
            } else {
                _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
                _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
                _currentScissorTest = _scissorTest;
            }
            const framebufferBound = state.bindFramebuffer(36160, framebuffer);
            if (framebufferBound && capabilities.drawBuffers && useDefaultFramebuffer) state.drawBuffers(renderTarget, framebuffer);
            state.viewport(_currentViewport);
            state.scissor(_currentScissor);
            state.setScissorTest(_currentScissorTest);
            if (isCube) {
                const textureProperties = properties.get(renderTarget.texture);
                _gl.framebufferTexture2D(36160, 36064, 34069 + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
            } else if (isRenderTarget3D) {
                const textureProperties = properties.get(renderTarget.texture);
                const layer = activeCubeFace || 0;
                _gl.framebufferTextureLayer(36160, 36064, textureProperties.__webglTexture, activeMipmapLevel || 0, layer);
            }
            _currentMaterialId = -1; // reset current material to ensure correct uniform bindings
        };
        this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
                console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
                return;
            }
            let framebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
            if (framebuffer) {
                state.bindFramebuffer(36160, framebuffer);
                try {
                    const texture = renderTarget.texture;
                    const textureFormat = texture.format;
                    const textureType = texture.type;
                    if (textureFormat !== $e8ea6a63d48a4fea$export$3f8bb04b555a363c && utils.convert(textureFormat) !== _gl.getParameter(35739)) {
                        console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
                        return;
                    }
                    const halfFloatSupportedByExt = textureType === $e8ea6a63d48a4fea$export$2697304443f382bc && (extensions.has("EXT_color_buffer_half_float") || capabilities.isWebGL2 && extensions.has("EXT_color_buffer_float"));
                    if (textureType !== $e8ea6a63d48a4fea$export$2e8ce08d3f6f5e10 && utils.convert(textureType) !== _gl.getParameter(35738) && // Edge and Chrome Mac < 52 (#9513)
                    !(textureType === $e8ea6a63d48a4fea$export$f6d331659b644596 && (capabilities.isWebGL2 || extensions.has("OES_texture_float") || extensions.has("WEBGL_color_buffer_float"))) && // Chrome Mac >= 52 and Firefox
                    !halfFloatSupportedByExt) {
                        console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
                        return;
                    }
                    // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                    if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
                } finally{
                    // restore framebuffer of current render target if necessary
                    const framebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                    state.bindFramebuffer(36160, framebuffer);
                }
            }
        };
        this.copyFramebufferToTexture = function(position, texture, level = 0) {
            const levelScale = Math.pow(2, -level);
            const width = Math.floor(texture.image.width * levelScale);
            const height = Math.floor(texture.image.height * levelScale);
            textures.setTexture2D(texture, 0);
            _gl.copyTexSubImage2D(3553, level, 0, 0, position.x, position.y, width, height);
            state.unbindTexture();
        };
        this.copyTextureToTexture = function(position, srcTexture, dstTexture, level = 0) {
            const width = srcTexture.image.width;
            const height = srcTexture.image.height;
            const glFormat = utils.convert(dstTexture.format);
            const glType = utils.convert(dstTexture.type);
            textures.setTexture2D(dstTexture, 0);
            // As another texture upload may have changed pixelStorei
            // parameters, make sure they are correct for the dstTexture
            _gl.pixelStorei(37440, dstTexture.flipY);
            _gl.pixelStorei(37441, dstTexture.premultiplyAlpha);
            _gl.pixelStorei(3317, dstTexture.unpackAlignment);
            if (srcTexture.isDataTexture) _gl.texSubImage2D(3553, level, position.x, position.y, width, height, glFormat, glType, srcTexture.image.data);
            else if (srcTexture.isCompressedTexture) _gl.compressedTexSubImage2D(3553, level, position.x, position.y, srcTexture.mipmaps[0].width, srcTexture.mipmaps[0].height, glFormat, srcTexture.mipmaps[0].data);
            else _gl.texSubImage2D(3553, level, position.x, position.y, glFormat, glType, srcTexture.image);
            // Generate mipmaps only when copying level 0
            if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(3553);
            state.unbindTexture();
        };
        this.copyTextureToTexture3D = function(sourceBox, position, srcTexture, dstTexture, level = 0) {
            if (_this.isWebGL1Renderer) {
                console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.");
                return;
            }
            const width = sourceBox.max.x - sourceBox.min.x + 1;
            const height = sourceBox.max.y - sourceBox.min.y + 1;
            const depth = sourceBox.max.z - sourceBox.min.z + 1;
            const glFormat = utils.convert(dstTexture.format);
            const glType = utils.convert(dstTexture.type);
            let glTarget;
            if (dstTexture.isData3DTexture) {
                textures.setTexture3D(dstTexture, 0);
                glTarget = 32879;
            } else if (dstTexture.isDataArrayTexture) {
                textures.setTexture2DArray(dstTexture, 0);
                glTarget = 35866;
            } else {
                console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.");
                return;
            }
            _gl.pixelStorei(37440, dstTexture.flipY);
            _gl.pixelStorei(37441, dstTexture.premultiplyAlpha);
            _gl.pixelStorei(3317, dstTexture.unpackAlignment);
            const unpackRowLen = _gl.getParameter(3314);
            const unpackImageHeight = _gl.getParameter(32878);
            const unpackSkipPixels = _gl.getParameter(3316);
            const unpackSkipRows = _gl.getParameter(3315);
            const unpackSkipImages = _gl.getParameter(32877);
            const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[0] : srcTexture.image;
            _gl.pixelStorei(3314, image.width);
            _gl.pixelStorei(32878, image.height);
            _gl.pixelStorei(3316, sourceBox.min.x);
            _gl.pixelStorei(3315, sourceBox.min.y);
            _gl.pixelStorei(32877, sourceBox.min.z);
            if (srcTexture.isDataTexture || srcTexture.isData3DTexture) _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image.data);
            else if (srcTexture.isCompressedArrayTexture) {
                console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture.");
                _gl.compressedTexSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, image.data);
            } else _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image);
            _gl.pixelStorei(3314, unpackRowLen);
            _gl.pixelStorei(32878, unpackImageHeight);
            _gl.pixelStorei(3316, unpackSkipPixels);
            _gl.pixelStorei(3315, unpackSkipRows);
            _gl.pixelStorei(32877, unpackSkipImages);
            // Generate mipmaps only when copying level 0
            if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(glTarget);
            state.unbindTexture();
        };
        this.initTexture = function(texture) {
            if (texture.isCubeTexture) textures.setTextureCube(texture, 0);
            else if (texture.isData3DTexture) textures.setTexture3D(texture, 0);
            else if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textures.setTexture2DArray(texture, 0);
            else textures.setTexture2D(texture, 0);
            state.unbindTexture();
        };
        this.resetState = function() {
            _currentActiveCubeFace = 0;
            _currentActiveMipmapLevel = 0;
            _currentRenderTarget = null;
            state.reset();
            bindingStates.reset();
        };
        if (typeof __THREE_DEVTOOLS__ !== "undefined") __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
            detail: this
        }));
    }
    get physicallyCorrectLights() {
        console.warn("THREE.WebGLRenderer: the property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead.");
        return !this.useLegacyLights;
    }
    set physicallyCorrectLights(value) {
        console.warn("THREE.WebGLRenderer: the property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead.");
        this.useLegacyLights = !value;
    }
}
class $e8ea6a63d48a4fea$export$a2f65229194348f9 extends $e8ea6a63d48a4fea$export$f6cc00ef28d7cf97 {
}
$e8ea6a63d48a4fea$export$a2f65229194348f9.prototype.isWebGL1Renderer = true;
class $e8ea6a63d48a4fea$export$6f1519f023b8d0f6 {
    constructor(color, density = 0.00025){
        this.isFogExp2 = true;
        this.name = "";
        this.color = new $e8ea6a63d48a4fea$export$892596cec99bc70e(color);
        this.density = density;
    }
    clone() {
        return new $e8ea6a63d48a4fea$export$6f1519f023b8d0f6(this.color, this.density);
    }
    toJSON() {
        return {
            type: "FogExp2",
            color: this.color.getHex(),
            density: this.density
        };
    }
}
class $e8ea6a63d48a4fea$export$3c890837b09508d4 {
    constructor(color, near = 1, far = 1000){
        this.isFog = true;
        this.name = "";
        this.color = new $e8ea6a63d48a4fea$export$892596cec99bc70e(color);
        this.near = near;
        this.far = far;
    }
    clone() {
        return new $e8ea6a63d48a4fea$export$3c890837b09508d4(this.color, this.near, this.far);
    }
    toJSON() {
        return {
            type: "Fog",
            color: this.color.getHex(),
            near: this.near,
            far: this.far
        };
    }
}
class $e8ea6a63d48a4fea$export$38af1803e3442a7f extends $e8ea6a63d48a4fea$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isScene = true;
        this.type = "Scene";
        this.background = null;
        this.environment = null;
        this.fog = null;
        this.backgroundBlurriness = 0;
        this.backgroundIntensity = 1;
        this.overrideMaterial = null;
        if (typeof __THREE_DEVTOOLS__ !== "undefined") __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
            detail: this
        }));
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.background !== null) this.background = source.background.clone();
        if (source.environment !== null) this.environment = source.environment.clone();
        if (source.fog !== null) this.fog = source.fog.clone();
        this.backgroundBlurriness = source.backgroundBlurriness;
        this.backgroundIntensity = source.backgroundIntensity;
        if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.fog !== null) data.object.fog = this.fog.toJSON();
        if (this.backgroundBlurriness > 0) data.object.backgroundBlurriness = this.backgroundBlurriness;
        if (this.backgroundIntensity !== 1) data.object.backgroundIntensity = this.backgroundIntensity;
        return data;
    }
    get autoUpdate() {
        console.warn("THREE.Scene: autoUpdate was renamed to matrixWorldAutoUpdate in r144.");
        return this.matrixWorldAutoUpdate;
    }
    set autoUpdate(value) {
        console.warn("THREE.Scene: autoUpdate was renamed to matrixWorldAutoUpdate in r144.");
        this.matrixWorldAutoUpdate = value;
    }
}
class $e8ea6a63d48a4fea$export$3d5cd879f108f53f {
    constructor(array, stride){
        this.isInterleavedBuffer = true;
        this.array = array;
        this.stride = stride;
        this.count = array !== undefined ? array.length / stride : 0;
        this.usage = $e8ea6a63d48a4fea$export$763e8360f4d7f77d;
        this.updateRange = {
            offset: 0,
            count: -1
        };
        this.version = 0;
        this.uuid = $e8ea6a63d48a4fea$var$generateUUID();
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    copy(source) {
        this.array = new source.array.constructor(source.array);
        this.count = source.count;
        this.stride = source.stride;
        this.usage = source.usage;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.stride;
        index2 *= attribute.stride;
        for(let i = 0, l = this.stride; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    }
    clone(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $e8ea6a63d48a4fea$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
        const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
        const ib = new this.constructor(array, this.stride);
        ib.setUsage(this.usage);
        return ib;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    toJSON(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        // generate UUID for array buffer if necessary
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $e8ea6a63d48a4fea$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer));
        //
        return {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
}
const $e8ea6a63d48a4fea$var$_vector$5 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
class $e8ea6a63d48a4fea$export$920b6d07334599c7 {
    constructor(interleavedBuffer, itemSize, offset, normalized = false){
        this.isInterleavedBufferAttribute = true;
        this.name = "";
        this.data = interleavedBuffer;
        this.itemSize = itemSize;
        this.offset = offset;
        this.normalized = normalized;
    }
    get count() {
        return this.data.count;
    }
    get array() {
        return this.data.array;
    }
    set needsUpdate(value) {
        this.data.needsUpdate = value;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.data.count; i < l; i++){
            $e8ea6a63d48a4fea$var$_vector$5.fromBufferAttribute(this, i);
            $e8ea6a63d48a4fea$var$_vector$5.applyMatrix4(m);
            this.setXYZ(i, $e8ea6a63d48a4fea$var$_vector$5.x, $e8ea6a63d48a4fea$var$_vector$5.y, $e8ea6a63d48a4fea$var$_vector$5.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $e8ea6a63d48a4fea$var$_vector$5.fromBufferAttribute(this, i);
            $e8ea6a63d48a4fea$var$_vector$5.applyNormalMatrix(m);
            this.setXYZ(i, $e8ea6a63d48a4fea$var$_vector$5.x, $e8ea6a63d48a4fea$var$_vector$5.y, $e8ea6a63d48a4fea$var$_vector$5.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $e8ea6a63d48a4fea$var$_vector$5.fromBufferAttribute(this, i);
            $e8ea6a63d48a4fea$var$_vector$5.transformDirection(m);
            this.setXYZ(i, $e8ea6a63d48a4fea$var$_vector$5.x, $e8ea6a63d48a4fea$var$_vector$5.y, $e8ea6a63d48a4fea$var$_vector$5.z);
        }
        return this;
    }
    setX(index, x) {
        if (this.normalized) x = $e8ea6a63d48a4fea$var$normalize(x, this.array);
        this.data.array[index * this.data.stride + this.offset] = x;
        return this;
    }
    setY(index, y) {
        if (this.normalized) y = $e8ea6a63d48a4fea$var$normalize(y, this.array);
        this.data.array[index * this.data.stride + this.offset + 1] = y;
        return this;
    }
    setZ(index, z) {
        if (this.normalized) z = $e8ea6a63d48a4fea$var$normalize(z, this.array);
        this.data.array[index * this.data.stride + this.offset + 2] = z;
        return this;
    }
    setW(index, w) {
        if (this.normalized) w = $e8ea6a63d48a4fea$var$normalize(w, this.array);
        this.data.array[index * this.data.stride + this.offset + 3] = w;
        return this;
    }
    getX(index) {
        let x = this.data.array[index * this.data.stride + this.offset];
        if (this.normalized) x = $e8ea6a63d48a4fea$var$denormalize(x, this.array);
        return x;
    }
    getY(index) {
        let y = this.data.array[index * this.data.stride + this.offset + 1];
        if (this.normalized) y = $e8ea6a63d48a4fea$var$denormalize(y, this.array);
        return y;
    }
    getZ(index) {
        let z = this.data.array[index * this.data.stride + this.offset + 2];
        if (this.normalized) z = $e8ea6a63d48a4fea$var$denormalize(z, this.array);
        return z;
    }
    getW(index) {
        let w = this.data.array[index * this.data.stride + this.offset + 3];
        if (this.normalized) w = $e8ea6a63d48a4fea$var$denormalize(w, this.array);
        return w;
    }
    setXY(index, x, y) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $e8ea6a63d48a4fea$var$normalize(x, this.array);
            y = $e8ea6a63d48a4fea$var$normalize(y, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $e8ea6a63d48a4fea$var$normalize(x, this.array);
            y = $e8ea6a63d48a4fea$var$normalize(y, this.array);
            z = $e8ea6a63d48a4fea$var$normalize(z, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $e8ea6a63d48a4fea$var$normalize(x, this.array);
            y = $e8ea6a63d48a4fea$var$normalize(y, this.array);
            z = $e8ea6a63d48a4fea$var$normalize(z, this.array);
            w = $e8ea6a63d48a4fea$var$normalize(w, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        this.data.array[index + 3] = w;
        return this;
    }
    clone(data) {
        if (data === undefined) {
            console.log("THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.");
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            return new $e8ea6a63d48a4fea$export$8dea267bd6bde117(new this.array.constructor(array), this.itemSize, this.normalized);
        } else {
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
            return new $e8ea6a63d48a4fea$export$920b6d07334599c7(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
        }
    }
    toJSON(data) {
        if (data === undefined) {
            console.log("THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.");
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            // de-interleave data and save it as an ordinary buffer attribute for now
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: array,
                normalized: this.normalized
            };
        } else {
            // save as true interleaved attribute
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
            return {
                isInterleavedBufferAttribute: true,
                itemSize: this.itemSize,
                data: this.data.uuid,
                offset: this.offset,
                normalized: this.normalized
            };
        }
    }
}
class $e8ea6a63d48a4fea$export$5ec7dd1c6994bf8e extends $e8ea6a63d48a4fea$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isSpriteMaterial = true;
        this.type = "SpriteMaterial";
        this.color = new $e8ea6a63d48a4fea$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.rotation = 0;
        this.sizeAttenuation = true;
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.rotation = source.rotation;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
let $e8ea6a63d48a4fea$var$_geometry;
const $e8ea6a63d48a4fea$var$_intersectPoint = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_worldScale = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_mvPosition = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_alignedPosition = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$c977b3e384af9ae1();
const $e8ea6a63d48a4fea$var$_rotatedPosition = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$c977b3e384af9ae1();
const $e8ea6a63d48a4fea$var$_viewWorldMatrix = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5();
const $e8ea6a63d48a4fea$var$_vA = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_vB = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_vC = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_uvA = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$c977b3e384af9ae1();
const $e8ea6a63d48a4fea$var$_uvB = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$c977b3e384af9ae1();
const $e8ea6a63d48a4fea$var$_uvC = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$c977b3e384af9ae1();
class $e8ea6a63d48a4fea$export$3075603db8e6204c extends $e8ea6a63d48a4fea$export$e4dd07dff30cc924 {
    constructor(material){
        super();
        this.isSprite = true;
        this.type = "Sprite";
        if ($e8ea6a63d48a4fea$var$_geometry === undefined) {
            $e8ea6a63d48a4fea$var$_geometry = new $e8ea6a63d48a4fea$export$b7be63a67df8959();
            const float32Array = new Float32Array([
                -0.5,
                -0.5,
                0,
                0,
                0,
                0.5,
                -0.5,
                0,
                1,
                0,
                0.5,
                0.5,
                0,
                1,
                1,
                -0.5,
                0.5,
                0,
                0,
                1
            ]);
            const interleavedBuffer = new $e8ea6a63d48a4fea$export$3d5cd879f108f53f(float32Array, 5);
            $e8ea6a63d48a4fea$var$_geometry.setIndex([
                0,
                1,
                2,
                0,
                2,
                3
            ]);
            $e8ea6a63d48a4fea$var$_geometry.setAttribute("position", new $e8ea6a63d48a4fea$export$920b6d07334599c7(interleavedBuffer, 3, 0, false));
            $e8ea6a63d48a4fea$var$_geometry.setAttribute("uv", new $e8ea6a63d48a4fea$export$920b6d07334599c7(interleavedBuffer, 2, 3, false));
        }
        this.geometry = $e8ea6a63d48a4fea$var$_geometry;
        this.material = material !== undefined ? material : new $e8ea6a63d48a4fea$export$5ec7dd1c6994bf8e();
        this.center = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(0.5, 0.5);
    }
    raycast(raycaster, intersects) {
        if (raycaster.camera === null) console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
        $e8ea6a63d48a4fea$var$_worldScale.setFromMatrixScale(this.matrixWorld);
        $e8ea6a63d48a4fea$var$_viewWorldMatrix.copy(raycaster.camera.matrixWorld);
        this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
        $e8ea6a63d48a4fea$var$_mvPosition.setFromMatrixPosition(this.modelViewMatrix);
        if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) $e8ea6a63d48a4fea$var$_worldScale.multiplyScalar(-$e8ea6a63d48a4fea$var$_mvPosition.z);
        const rotation = this.material.rotation;
        let sin, cos;
        if (rotation !== 0) {
            cos = Math.cos(rotation);
            sin = Math.sin(rotation);
        }
        const center = this.center;
        $e8ea6a63d48a4fea$var$transformVertex($e8ea6a63d48a4fea$var$_vA.set(-0.5, -0.5, 0), $e8ea6a63d48a4fea$var$_mvPosition, center, $e8ea6a63d48a4fea$var$_worldScale, sin, cos);
        $e8ea6a63d48a4fea$var$transformVertex($e8ea6a63d48a4fea$var$_vB.set(0.5, -0.5, 0), $e8ea6a63d48a4fea$var$_mvPosition, center, $e8ea6a63d48a4fea$var$_worldScale, sin, cos);
        $e8ea6a63d48a4fea$var$transformVertex($e8ea6a63d48a4fea$var$_vC.set(0.5, 0.5, 0), $e8ea6a63d48a4fea$var$_mvPosition, center, $e8ea6a63d48a4fea$var$_worldScale, sin, cos);
        $e8ea6a63d48a4fea$var$_uvA.set(0, 0);
        $e8ea6a63d48a4fea$var$_uvB.set(1, 0);
        $e8ea6a63d48a4fea$var$_uvC.set(1, 1);
        // check first triangle
        let intersect = raycaster.ray.intersectTriangle($e8ea6a63d48a4fea$var$_vA, $e8ea6a63d48a4fea$var$_vB, $e8ea6a63d48a4fea$var$_vC, false, $e8ea6a63d48a4fea$var$_intersectPoint);
        if (intersect === null) {
            // check second triangle
            $e8ea6a63d48a4fea$var$transformVertex($e8ea6a63d48a4fea$var$_vB.set(-0.5, 0.5, 0), $e8ea6a63d48a4fea$var$_mvPosition, center, $e8ea6a63d48a4fea$var$_worldScale, sin, cos);
            $e8ea6a63d48a4fea$var$_uvB.set(0, 1);
            intersect = raycaster.ray.intersectTriangle($e8ea6a63d48a4fea$var$_vA, $e8ea6a63d48a4fea$var$_vC, $e8ea6a63d48a4fea$var$_vB, false, $e8ea6a63d48a4fea$var$_intersectPoint);
            if (intersect === null) return;
        }
        const distance = raycaster.ray.origin.distanceTo($e8ea6a63d48a4fea$var$_intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            point: $e8ea6a63d48a4fea$var$_intersectPoint.clone(),
            uv: $e8ea6a63d48a4fea$export$5a465592bfe74b48.getInterpolation($e8ea6a63d48a4fea$var$_intersectPoint, $e8ea6a63d48a4fea$var$_vA, $e8ea6a63d48a4fea$var$_vB, $e8ea6a63d48a4fea$var$_vC, $e8ea6a63d48a4fea$var$_uvA, $e8ea6a63d48a4fea$var$_uvB, $e8ea6a63d48a4fea$var$_uvC, new $e8ea6a63d48a4fea$export$c977b3e384af9ae1()),
            face: null,
            object: this
        });
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.center !== undefined) this.center.copy(source.center);
        this.material = source.material;
        return this;
    }
}
function $e8ea6a63d48a4fea$var$transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
    // compute position in camera space
    $e8ea6a63d48a4fea$var$_alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
    // to check if rotation is not zero
    if (sin !== undefined) {
        $e8ea6a63d48a4fea$var$_rotatedPosition.x = cos * $e8ea6a63d48a4fea$var$_alignedPosition.x - sin * $e8ea6a63d48a4fea$var$_alignedPosition.y;
        $e8ea6a63d48a4fea$var$_rotatedPosition.y = sin * $e8ea6a63d48a4fea$var$_alignedPosition.x + cos * $e8ea6a63d48a4fea$var$_alignedPosition.y;
    } else $e8ea6a63d48a4fea$var$_rotatedPosition.copy($e8ea6a63d48a4fea$var$_alignedPosition);
    vertexPosition.copy(mvPosition);
    vertexPosition.x += $e8ea6a63d48a4fea$var$_rotatedPosition.x;
    vertexPosition.y += $e8ea6a63d48a4fea$var$_rotatedPosition.y;
    // transform to world space
    vertexPosition.applyMatrix4($e8ea6a63d48a4fea$var$_viewWorldMatrix);
}
const $e8ea6a63d48a4fea$var$_v1$2 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_v2$1 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
class $e8ea6a63d48a4fea$export$112e7237be0c5f30 extends $e8ea6a63d48a4fea$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this._currentLevel = 0;
        this.type = "LOD";
        Object.defineProperties(this, {
            levels: {
                enumerable: true,
                value: []
            },
            isLOD: {
                value: true
            }
        });
        this.autoUpdate = true;
    }
    copy(source) {
        super.copy(source, false);
        const levels = source.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            this.addLevel(level.object.clone(), level.distance, level.hysteresis);
        }
        this.autoUpdate = source.autoUpdate;
        return this;
    }
    addLevel(object, distance = 0, hysteresis = 0) {
        distance = Math.abs(distance);
        const levels = this.levels;
        let l;
        for(l = 0; l < levels.length; l++){
            if (distance < levels[l].distance) break;
        }
        levels.splice(l, 0, {
            distance: distance,
            hysteresis: hysteresis,
            object: object
        });
        this.add(object);
        return this;
    }
    getCurrentLevel() {
        return this._currentLevel;
    }
    getObjectForDistance(distance) {
        const levels = this.levels;
        if (levels.length > 0) {
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance < levelDistance) break;
            }
            return levels[i - 1].object;
        }
        return null;
    }
    raycast(raycaster, intersects) {
        const levels = this.levels;
        if (levels.length > 0) {
            $e8ea6a63d48a4fea$var$_v1$2.setFromMatrixPosition(this.matrixWorld);
            const distance = raycaster.ray.origin.distanceTo($e8ea6a63d48a4fea$var$_v1$2);
            this.getObjectForDistance(distance).raycast(raycaster, intersects);
        }
    }
    update(camera) {
        const levels = this.levels;
        if (levels.length > 1) {
            $e8ea6a63d48a4fea$var$_v1$2.setFromMatrixPosition(camera.matrixWorld);
            $e8ea6a63d48a4fea$var$_v2$1.setFromMatrixPosition(this.matrixWorld);
            const distance = $e8ea6a63d48a4fea$var$_v1$2.distanceTo($e8ea6a63d48a4fea$var$_v2$1) / camera.zoom;
            levels[0].object.visible = true;
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance >= levelDistance) {
                    levels[i - 1].object.visible = false;
                    levels[i].object.visible = true;
                } else break;
            }
            this._currentLevel = i - 1;
            for(; i < l; i++)levels[i].object.visible = false;
        }
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.autoUpdate === false) data.object.autoUpdate = false;
        data.object.levels = [];
        const levels = this.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            data.object.levels.push({
                object: level.object.uuid,
                distance: level.distance,
                hysteresis: level.hysteresis
            });
        }
        return data;
    }
}
const $e8ea6a63d48a4fea$var$_basePosition = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_skinIndex = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$fa7daccca11cdbe3();
const $e8ea6a63d48a4fea$var$_skinWeight = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$fa7daccca11cdbe3();
const $e8ea6a63d48a4fea$var$_vector3 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_matrix4 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5();
const $e8ea6a63d48a4fea$var$_vertex = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
class $e8ea6a63d48a4fea$export$b303577035157ecf extends $e8ea6a63d48a4fea$export$e176487c05830cc5 {
    constructor(geometry, material){
        super(geometry, material);
        this.isSkinnedMesh = true;
        this.type = "SkinnedMesh";
        this.bindMode = "attached";
        this.bindMatrix = new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5();
        this.bindMatrixInverse = new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5();
        this.boundingBox = null;
        this.boundingSphere = null;
    }
    computeBoundingBox() {
        const geometry = this.geometry;
        if (this.boundingBox === null) this.boundingBox = new $e8ea6a63d48a4fea$export$6f7d5a9418ab2aa3();
        this.boundingBox.makeEmpty();
        const positionAttribute = geometry.getAttribute("position");
        for(let i = 0; i < positionAttribute.count; i++){
            $e8ea6a63d48a4fea$var$_vertex.fromBufferAttribute(positionAttribute, i);
            this.applyBoneTransform(i, $e8ea6a63d48a4fea$var$_vertex);
            this.boundingBox.expandByPoint($e8ea6a63d48a4fea$var$_vertex);
        }
    }
    computeBoundingSphere() {
        const geometry = this.geometry;
        if (this.boundingSphere === null) this.boundingSphere = new $e8ea6a63d48a4fea$export$805e8b72413ccaba();
        this.boundingSphere.makeEmpty();
        const positionAttribute = geometry.getAttribute("position");
        for(let i = 0; i < positionAttribute.count; i++){
            $e8ea6a63d48a4fea$var$_vertex.fromBufferAttribute(positionAttribute, i);
            this.applyBoneTransform(i, $e8ea6a63d48a4fea$var$_vertex);
            this.boundingSphere.expandByPoint($e8ea6a63d48a4fea$var$_vertex);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.bindMode = source.bindMode;
        this.bindMatrix.copy(source.bindMatrix);
        this.bindMatrixInverse.copy(source.bindMatrixInverse);
        this.skeleton = source.skeleton;
        return this;
    }
    bind(skeleton, bindMatrix) {
        this.skeleton = skeleton;
        if (bindMatrix === undefined) {
            this.updateMatrixWorld(true);
            this.skeleton.calculateInverses();
            bindMatrix = this.matrixWorld;
        }
        this.bindMatrix.copy(bindMatrix);
        this.bindMatrixInverse.copy(bindMatrix).invert();
    }
    pose() {
        this.skeleton.pose();
    }
    normalizeSkinWeights() {
        const vector = new $e8ea6a63d48a4fea$export$fa7daccca11cdbe3();
        const skinWeight = this.geometry.attributes.skinWeight;
        for(let i = 0, l = skinWeight.count; i < l; i++){
            vector.fromBufferAttribute(skinWeight, i);
            const scale = 1.0 / vector.manhattanLength();
            if (scale !== Infinity) vector.multiplyScalar(scale);
            else vector.set(1, 0, 0, 0); // do something reasonable
            skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
        }
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.bindMode === "attached") this.bindMatrixInverse.copy(this.matrixWorld).invert();
        else if (this.bindMode === "detached") this.bindMatrixInverse.copy(this.bindMatrix).invert();
        else console.warn("THREE.SkinnedMesh: Unrecognized bindMode: " + this.bindMode);
    }
    applyBoneTransform(index, vector) {
        const skeleton = this.skeleton;
        const geometry = this.geometry;
        $e8ea6a63d48a4fea$var$_skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
        $e8ea6a63d48a4fea$var$_skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
        $e8ea6a63d48a4fea$var$_basePosition.copy(vector).applyMatrix4(this.bindMatrix);
        vector.set(0, 0, 0);
        for(let i = 0; i < 4; i++){
            const weight = $e8ea6a63d48a4fea$var$_skinWeight.getComponent(i);
            if (weight !== 0) {
                const boneIndex = $e8ea6a63d48a4fea$var$_skinIndex.getComponent(i);
                $e8ea6a63d48a4fea$var$_matrix4.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
                vector.addScaledVector($e8ea6a63d48a4fea$var$_vector3.copy($e8ea6a63d48a4fea$var$_basePosition).applyMatrix4($e8ea6a63d48a4fea$var$_matrix4), weight);
            }
        }
        return vector.applyMatrix4(this.bindMatrixInverse);
    }
    boneTransform(index, vector) {
        console.warn("THREE.SkinnedMesh: .boneTransform() was renamed to .applyBoneTransform() in r151.");
        return this.applyBoneTransform(index, vector);
    }
}
class $e8ea6a63d48a4fea$export$b127726e56765aa4 extends $e8ea6a63d48a4fea$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isBone = true;
        this.type = "Bone";
    }
}
class $e8ea6a63d48a4fea$export$b691f601014eabe1 extends $e8ea6a63d48a4fea$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, format, type, mapping, wrapS, wrapT, magFilter = $e8ea6a63d48a4fea$export$727aa5ec3fe39bf0, minFilter = $e8ea6a63d48a4fea$export$727aa5ec3fe39bf0, anisotropy, encoding){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
        this.isDataTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height
        };
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
const $e8ea6a63d48a4fea$var$_offsetMatrix = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5();
const $e8ea6a63d48a4fea$var$_identityMatrix = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5();
class $e8ea6a63d48a4fea$export$8f31e4c4a37b8e9c {
    constructor(bones = [], boneInverses = []){
        this.uuid = $e8ea6a63d48a4fea$var$generateUUID();
        this.bones = bones.slice(0);
        this.boneInverses = boneInverses;
        this.boneMatrices = null;
        this.boneTexture = null;
        this.boneTextureSize = 0;
        this.frame = -1;
        this.init();
    }
    init() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        this.boneMatrices = new Float32Array(bones.length * 16);
        // calculate inverse bone matrices if necessary
        if (boneInverses.length === 0) this.calculateInverses();
        else // handle special case
        if (bones.length !== boneInverses.length) {
            console.warn("THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.");
            this.boneInverses = [];
            for(let i = 0, il = this.bones.length; i < il; i++)this.boneInverses.push(new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5());
        }
    }
    calculateInverses() {
        this.boneInverses.length = 0;
        for(let i = 0, il = this.bones.length; i < il; i++){
            const inverse = new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5();
            if (this.bones[i]) inverse.copy(this.bones[i].matrixWorld).invert();
            this.boneInverses.push(inverse);
        }
    }
    pose() {
        // recover the bind-time world matrices
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) bone.matrixWorld.copy(this.boneInverses[i]).invert();
        }
        // compute the local matrices, positions, rotations and scales
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) {
                if (bone.parent && bone.parent.isBone) {
                    bone.matrix.copy(bone.parent.matrixWorld).invert();
                    bone.matrix.multiply(bone.matrixWorld);
                } else bone.matrix.copy(bone.matrixWorld);
                bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
            }
        }
    }
    update() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        const boneMatrices = this.boneMatrices;
        const boneTexture = this.boneTexture;
        // flatten bone matrices to array
        for(let i = 0, il = bones.length; i < il; i++){
            // compute the offset between the current and the original transform
            const matrix = bones[i] ? bones[i].matrixWorld : $e8ea6a63d48a4fea$var$_identityMatrix;
            $e8ea6a63d48a4fea$var$_offsetMatrix.multiplyMatrices(matrix, boneInverses[i]);
            $e8ea6a63d48a4fea$var$_offsetMatrix.toArray(boneMatrices, i * 16);
        }
        if (boneTexture !== null) boneTexture.needsUpdate = true;
    }
    clone() {
        return new $e8ea6a63d48a4fea$export$8f31e4c4a37b8e9c(this.bones, this.boneInverses);
    }
    computeBoneTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
        let size = Math.sqrt(this.bones.length * 4); // 4 pixels needed for 1 matrix
        size = $e8ea6a63d48a4fea$var$ceilPowerOfTwo(size);
        size = Math.max(size, 4);
        const boneMatrices = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        boneMatrices.set(this.boneMatrices); // copy current values
        const boneTexture = new $e8ea6a63d48a4fea$export$b691f601014eabe1(boneMatrices, size, size, $e8ea6a63d48a4fea$export$3f8bb04b555a363c, $e8ea6a63d48a4fea$export$f6d331659b644596);
        boneTexture.needsUpdate = true;
        this.boneMatrices = boneMatrices;
        this.boneTexture = boneTexture;
        this.boneTextureSize = size;
        return this;
    }
    getBoneByName(name) {
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone.name === name) return bone;
        }
        return undefined;
    }
    dispose() {
        if (this.boneTexture !== null) {
            this.boneTexture.dispose();
            this.boneTexture = null;
        }
    }
    fromJSON(json, bones) {
        this.uuid = json.uuid;
        for(let i = 0, l = json.bones.length; i < l; i++){
            const uuid = json.bones[i];
            let bone = bones[uuid];
            if (bone === undefined) {
                console.warn("THREE.Skeleton: No bone found with UUID:", uuid);
                bone = new $e8ea6a63d48a4fea$export$b127726e56765aa4();
            }
            this.bones.push(bone);
            this.boneInverses.push(new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5().fromArray(json.boneInverses[i]));
        }
        this.init();
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.5,
                type: "Skeleton",
                generator: "Skeleton.toJSON"
            },
            bones: [],
            boneInverses: []
        };
        data.uuid = this.uuid;
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        for(let i = 0, l = bones.length; i < l; i++){
            const bone = bones[i];
            data.bones.push(bone.uuid);
            const boneInverse = boneInverses[i];
            data.boneInverses.push(boneInverse.toArray());
        }
        return data;
    }
}
class $e8ea6a63d48a4fea$export$32ea87a8b54d744a extends $e8ea6a63d48a4fea$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized, meshPerAttribute = 1){
        super(array, itemSize, normalized);
        this.isInstancedBufferAttribute = true;
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.meshPerAttribute = this.meshPerAttribute;
        data.isInstancedBufferAttribute = true;
        return data;
    }
}
const $e8ea6a63d48a4fea$var$_instanceLocalMatrix = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5();
const $e8ea6a63d48a4fea$var$_instanceWorldMatrix = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5();
const $e8ea6a63d48a4fea$var$_instanceIntersects = [];
const $e8ea6a63d48a4fea$var$_box3 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$6f7d5a9418ab2aa3();
const $e8ea6a63d48a4fea$var$_identity = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5();
const $e8ea6a63d48a4fea$var$_mesh = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$e176487c05830cc5();
const $e8ea6a63d48a4fea$var$_sphere$2 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$805e8b72413ccaba();
class $e8ea6a63d48a4fea$export$f3c979c331175ad7 extends $e8ea6a63d48a4fea$export$e176487c05830cc5 {
    constructor(geometry, material, count){
        super(geometry, material);
        this.isInstancedMesh = true;
        this.instanceMatrix = new $e8ea6a63d48a4fea$export$32ea87a8b54d744a(new Float32Array(count * 16), 16);
        this.instanceColor = null;
        this.count = count;
        this.boundingBox = null;
        this.boundingSphere = null;
        for(let i = 0; i < count; i++)this.setMatrixAt(i, $e8ea6a63d48a4fea$var$_identity);
    }
    computeBoundingBox() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingBox === null) this.boundingBox = new $e8ea6a63d48a4fea$export$6f7d5a9418ab2aa3();
        if (geometry.boundingBox === null) geometry.computeBoundingBox();
        this.boundingBox.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $e8ea6a63d48a4fea$var$_instanceLocalMatrix);
            $e8ea6a63d48a4fea$var$_box3.copy(geometry.boundingBox).applyMatrix4($e8ea6a63d48a4fea$var$_instanceLocalMatrix);
            this.boundingBox.union($e8ea6a63d48a4fea$var$_box3);
        }
    }
    computeBoundingSphere() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingSphere === null) this.boundingSphere = new $e8ea6a63d48a4fea$export$805e8b72413ccaba();
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        this.boundingSphere.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $e8ea6a63d48a4fea$var$_instanceLocalMatrix);
            $e8ea6a63d48a4fea$var$_sphere$2.copy(geometry.boundingSphere).applyMatrix4($e8ea6a63d48a4fea$var$_instanceLocalMatrix);
            this.boundingSphere.union($e8ea6a63d48a4fea$var$_sphere$2);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.instanceMatrix.copy(source.instanceMatrix);
        if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
        this.count = source.count;
        return this;
    }
    getColorAt(index, color) {
        color.fromArray(this.instanceColor.array, index * 3);
    }
    getMatrixAt(index, matrix) {
        matrix.fromArray(this.instanceMatrix.array, index * 16);
    }
    raycast(raycaster, intersects) {
        const matrixWorld = this.matrixWorld;
        const raycastTimes = this.count;
        $e8ea6a63d48a4fea$var$_mesh.geometry = this.geometry;
        $e8ea6a63d48a4fea$var$_mesh.material = this.material;
        if ($e8ea6a63d48a4fea$var$_mesh.material === undefined) return;
        // test with bounding sphere first
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $e8ea6a63d48a4fea$var$_sphere$2.copy(this.boundingSphere);
        $e8ea6a63d48a4fea$var$_sphere$2.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($e8ea6a63d48a4fea$var$_sphere$2) === false) return;
        // now test each instance
        for(let instanceId = 0; instanceId < raycastTimes; instanceId++){
            // calculate the world matrix for each instance
            this.getMatrixAt(instanceId, $e8ea6a63d48a4fea$var$_instanceLocalMatrix);
            $e8ea6a63d48a4fea$var$_instanceWorldMatrix.multiplyMatrices(matrixWorld, $e8ea6a63d48a4fea$var$_instanceLocalMatrix);
            // the mesh represents this single instance
            $e8ea6a63d48a4fea$var$_mesh.matrixWorld = $e8ea6a63d48a4fea$var$_instanceWorldMatrix;
            $e8ea6a63d48a4fea$var$_mesh.raycast(raycaster, $e8ea6a63d48a4fea$var$_instanceIntersects);
            // process the result of raycast
            for(let i = 0, l = $e8ea6a63d48a4fea$var$_instanceIntersects.length; i < l; i++){
                const intersect = $e8ea6a63d48a4fea$var$_instanceIntersects[i];
                intersect.instanceId = instanceId;
                intersect.object = this;
                intersects.push(intersect);
            }
            $e8ea6a63d48a4fea$var$_instanceIntersects.length = 0;
        }
    }
    setColorAt(index, color) {
        if (this.instanceColor === null) this.instanceColor = new $e8ea6a63d48a4fea$export$32ea87a8b54d744a(new Float32Array(this.instanceMatrix.count * 3), 3);
        color.toArray(this.instanceColor.array, index * 3);
    }
    setMatrixAt(index, matrix) {
        matrix.toArray(this.instanceMatrix.array, index * 16);
    }
    updateMorphTargets() {}
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
class $e8ea6a63d48a4fea$export$fbaaa33907730a0c extends $e8ea6a63d48a4fea$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isLineBasicMaterial = true;
        this.type = "LineBasicMaterial";
        this.color = new $e8ea6a63d48a4fea$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.linewidth = 1;
        this.linecap = "round";
        this.linejoin = "round";
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.linewidth = source.linewidth;
        this.linecap = source.linecap;
        this.linejoin = source.linejoin;
        this.fog = source.fog;
        return this;
    }
}
const $e8ea6a63d48a4fea$var$_start$1 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_end$1 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_inverseMatrix$1 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5();
const $e8ea6a63d48a4fea$var$_ray$1 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$a186db52eed6d40e();
const $e8ea6a63d48a4fea$var$_sphere$1 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$805e8b72413ccaba();
class $e8ea6a63d48a4fea$export$17d680238e50603e extends $e8ea6a63d48a4fea$export$e4dd07dff30cc924 {
    constructor(geometry = new $e8ea6a63d48a4fea$export$b7be63a67df8959(), material = new $e8ea6a63d48a4fea$export$fbaaa33907730a0c()){
        super();
        this.isLine = true;
        this.type = "Line";
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [
                0
            ];
            for(let i = 1, l = positionAttribute.count; i < l; i++){
                $e8ea6a63d48a4fea$var$_start$1.fromBufferAttribute(positionAttribute, i - 1);
                $e8ea6a63d48a4fea$var$_end$1.fromBufferAttribute(positionAttribute, i);
                lineDistances[i] = lineDistances[i - 1];
                lineDistances[i] += $e8ea6a63d48a4fea$var$_start$1.distanceTo($e8ea6a63d48a4fea$var$_end$1);
            }
            geometry.setAttribute("lineDistance", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Line.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $e8ea6a63d48a4fea$var$_sphere$1.copy(geometry.boundingSphere);
        $e8ea6a63d48a4fea$var$_sphere$1.applyMatrix4(matrixWorld);
        $e8ea6a63d48a4fea$var$_sphere$1.radius += threshold;
        if (raycaster.ray.intersectsSphere($e8ea6a63d48a4fea$var$_sphere$1) === false) return;
        //
        $e8ea6a63d48a4fea$var$_inverseMatrix$1.copy(matrixWorld).invert();
        $e8ea6a63d48a4fea$var$_ray$1.copy(raycaster.ray).applyMatrix4($e8ea6a63d48a4fea$var$_inverseMatrix$1);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const vStart = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        const vEnd = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        const interSegment = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        const interRay = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        const step = this.isLineSegments ? 2 : 1;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const a = index.getX(i);
                const b = index.getX(i + 1);
                vStart.fromBufferAttribute(positionAttribute, a);
                vEnd.fromBufferAttribute(positionAttribute, b);
                const distSq = $e8ea6a63d48a4fea$var$_ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                if (distSq > localThresholdSq) continue;
                interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                const distance = raycaster.ray.origin.distanceTo(interRay);
                if (distance < raycaster.near || distance > raycaster.far) continue;
                intersects.push({
                    distance: distance,
                    // What do we want? intersection point on the ray or on the segment??
                    // point: raycaster.ray.at( distance ),
                    point: interSegment.clone().applyMatrix4(this.matrixWorld),
                    index: i,
                    face: null,
                    faceIndex: null,
                    object: this
                });
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                vStart.fromBufferAttribute(positionAttribute, i);
                vEnd.fromBufferAttribute(positionAttribute, i + 1);
                const distSq = $e8ea6a63d48a4fea$var$_ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                if (distSq > localThresholdSq) continue;
                interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                const distance = raycaster.ray.origin.distanceTo(interRay);
                if (distance < raycaster.near || distance > raycaster.far) continue;
                intersects.push({
                    distance: distance,
                    // What do we want? intersection point on the ray or on the segment??
                    // point: raycaster.ray.at( distance ),
                    point: interSegment.clone().applyMatrix4(this.matrixWorld),
                    index: i,
                    face: null,
                    faceIndex: null,
                    object: this
                });
            }
        }
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
const $e8ea6a63d48a4fea$var$_start = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_end = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
class $e8ea6a63d48a4fea$export$ff1ed10fedfdd604 extends $e8ea6a63d48a4fea$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.isLineSegments = true;
        this.type = "LineSegments";
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [];
            for(let i = 0, l = positionAttribute.count; i < l; i += 2){
                $e8ea6a63d48a4fea$var$_start.fromBufferAttribute(positionAttribute, i);
                $e8ea6a63d48a4fea$var$_end.fromBufferAttribute(positionAttribute, i + 1);
                lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
                lineDistances[i + 1] = lineDistances[i] + $e8ea6a63d48a4fea$var$_start.distanceTo($e8ea6a63d48a4fea$var$_end);
            }
            geometry.setAttribute("lineDistance", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        return this;
    }
}
class $e8ea6a63d48a4fea$export$f85a24d745e4f17d extends $e8ea6a63d48a4fea$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.isLineLoop = true;
        this.type = "LineLoop";
    }
}
class $e8ea6a63d48a4fea$export$a178c45366ce5d6b extends $e8ea6a63d48a4fea$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isPointsMaterial = true;
        this.type = "PointsMaterial";
        this.color = new $e8ea6a63d48a4fea$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.size = 1;
        this.sizeAttenuation = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.size = source.size;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
const $e8ea6a63d48a4fea$var$_inverseMatrix = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5();
const $e8ea6a63d48a4fea$var$_ray = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$a186db52eed6d40e();
const $e8ea6a63d48a4fea$var$_sphere = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$805e8b72413ccaba();
const $e8ea6a63d48a4fea$var$_position$2 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
class $e8ea6a63d48a4fea$export$1c787534cb11aa3e extends $e8ea6a63d48a4fea$export$e4dd07dff30cc924 {
    constructor(geometry = new $e8ea6a63d48a4fea$export$b7be63a67df8959(), material = new $e8ea6a63d48a4fea$export$a178c45366ce5d6b()){
        super();
        this.isPoints = true;
        this.type = "Points";
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Points.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $e8ea6a63d48a4fea$var$_sphere.copy(geometry.boundingSphere);
        $e8ea6a63d48a4fea$var$_sphere.applyMatrix4(matrixWorld);
        $e8ea6a63d48a4fea$var$_sphere.radius += threshold;
        if (raycaster.ray.intersectsSphere($e8ea6a63d48a4fea$var$_sphere) === false) return;
        //
        $e8ea6a63d48a4fea$var$_inverseMatrix.copy(matrixWorld).invert();
        $e8ea6a63d48a4fea$var$_ray.copy(raycaster.ray).applyMatrix4($e8ea6a63d48a4fea$var$_inverseMatrix);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, il = end; i < il; i++){
                const a = index.getX(i);
                $e8ea6a63d48a4fea$var$_position$2.fromBufferAttribute(positionAttribute, a);
                $e8ea6a63d48a4fea$var$testPoint($e8ea6a63d48a4fea$var$_position$2, a, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end; i < l; i++){
                $e8ea6a63d48a4fea$var$_position$2.fromBufferAttribute(positionAttribute, i);
                $e8ea6a63d48a4fea$var$testPoint($e8ea6a63d48a4fea$var$_position$2, i, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        }
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
function $e8ea6a63d48a4fea$var$testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects, object) {
    const rayPointDistanceSq = $e8ea6a63d48a4fea$var$_ray.distanceSqToPoint(point);
    if (rayPointDistanceSq < localThresholdSq) {
        const intersectPoint = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        $e8ea6a63d48a4fea$var$_ray.closestPointToPoint(point, intersectPoint);
        intersectPoint.applyMatrix4(matrixWorld);
        const distance = raycaster.ray.origin.distanceTo(intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            distanceToRay: Math.sqrt(rayPointDistanceSq),
            point: intersectPoint,
            index: index,
            face: null,
            object: object
        });
    }
}
class $e8ea6a63d48a4fea$export$6e09d1edf8d5a25c extends $e8ea6a63d48a4fea$export$5431306cf43de24a {
    constructor(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isVideoTexture = true;
        this.minFilter = minFilter !== undefined ? minFilter : $e8ea6a63d48a4fea$export$8a72f490b25c56c8;
        this.magFilter = magFilter !== undefined ? magFilter : $e8ea6a63d48a4fea$export$8a72f490b25c56c8;
        this.generateMipmaps = false;
        const scope = this;
        function updateVideo() {
            scope.needsUpdate = true;
            video.requestVideoFrameCallback(updateVideo);
        }
        if ("requestVideoFrameCallback" in video) video.requestVideoFrameCallback(updateVideo);
    }
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    update() {
        const video = this.image;
        const hasVideoFrameCallback = "requestVideoFrameCallback" in video;
        if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) this.needsUpdate = true;
    }
}
class $e8ea6a63d48a4fea$export$9270d786f73ce6fe extends $e8ea6a63d48a4fea$export$5431306cf43de24a {
    constructor(width, height, format){
        super({
            width: width,
            height: height
        });
        this.isFramebufferTexture = true;
        this.format = format;
        this.magFilter = $e8ea6a63d48a4fea$export$727aa5ec3fe39bf0;
        this.minFilter = $e8ea6a63d48a4fea$export$727aa5ec3fe39bf0;
        this.generateMipmaps = false;
        this.needsUpdate = true;
    }
}
class $e8ea6a63d48a4fea$export$3466bac9141a5cc4 extends $e8ea6a63d48a4fea$export$5431306cf43de24a {
    constructor(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, encoding){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
        this.isCompressedTexture = true;
        this.image = {
            width: width,
            height: height
        };
        this.mipmaps = mipmaps;
        // no flipping for cube textures
        // (also flipping doesn't work for compressed textures )
        this.flipY = false;
        // can't generate mipmaps for compressed textures
        // mips must be embedded in DDS files
        this.generateMipmaps = false;
    }
}
class $e8ea6a63d48a4fea$export$5fe6b8e34b274fcb extends $e8ea6a63d48a4fea$export$3466bac9141a5cc4 {
    constructor(mipmaps, width, height, depth, format, type){
        super(mipmaps, width, height, format, type);
        this.isCompressedArrayTexture = true;
        this.image.depth = depth;
        this.wrapR = $e8ea6a63d48a4fea$export$9d9334239a5a5e06;
    }
}
class $e8ea6a63d48a4fea$export$f7189e49152d1c13 extends $e8ea6a63d48a4fea$export$5431306cf43de24a {
    constructor(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isCanvasTexture = true;
        this.needsUpdate = true;
    }
}
/**
 * Extensible curve object.
 *
 * Some common of curve methods:
 * .getPoint( t, optionalTarget ), .getTangent( t, optionalTarget )
 * .getPointAt( u, optionalTarget ), .getTangentAt( u, optionalTarget )
 * .getPoints(), .getSpacedPoints()
 * .getLength()
 * .updateArcLengths()
 *
 * This following curves inherit from THREE.Curve:
 *
 * -- 2D curves --
 * THREE.ArcCurve
 * THREE.CubicBezierCurve
 * THREE.EllipseCurve
 * THREE.LineCurve
 * THREE.QuadraticBezierCurve
 * THREE.SplineCurve
 *
 * -- 3D curves --
 * THREE.CatmullRomCurve3
 * THREE.CubicBezierCurve3
 * THREE.LineCurve3
 * THREE.QuadraticBezierCurve3
 *
 * A series of curves can be represented as a THREE.CurvePath.
 *
 **/ class $e8ea6a63d48a4fea$export$b0e83c3ef8d2db1 {
    constructor(){
        this.type = "Curve";
        this.arcLengthDivisions = 200;
    }
    // Virtual base class method to overwrite and implement in subclasses
    //	- t [0 .. 1]
    getPoint() {
        console.warn("THREE.Curve: .getPoint() not implemented.");
        return null;
    }
    // Get point at relative position in curve according to arc length
    // - u [0 .. 1]
    getPointAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getPoint(t, optionalTarget);
    }
    // Get sequence of points using getPoint( t )
    getPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPoint(d / divisions));
        return points;
    }
    // Get sequence of points using getPointAt( u )
    getSpacedPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPointAt(d / divisions));
        return points;
    }
    // Get total curve arc length
    getLength() {
        const lengths = this.getLengths();
        return lengths[lengths.length - 1];
    }
    // Get list of cumulative segment lengths
    getLengths(divisions = this.arcLengthDivisions) {
        if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = false;
        const cache = [];
        let current, last = this.getPoint(0);
        let sum = 0;
        cache.push(0);
        for(let p = 1; p <= divisions; p++){
            current = this.getPoint(p / divisions);
            sum += current.distanceTo(last);
            cache.push(sum);
            last = current;
        }
        this.cacheArcLengths = cache;
        return cache; // { sums: cache, sum: sum }; Sum is in the last element.
    }
    updateArcLengths() {
        this.needsUpdate = true;
        this.getLengths();
    }
    // Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant
    getUtoTmapping(u, distance) {
        const arcLengths = this.getLengths();
        let i = 0;
        const il = arcLengths.length;
        let targetArcLength; // The targeted u distance value to get
        if (distance) targetArcLength = distance;
        else targetArcLength = u * arcLengths[il - 1];
        // binary search for the index with largest value smaller than target u distance
        let low = 0, high = il - 1, comparison;
        while(low <= high){
            i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
            comparison = arcLengths[i] - targetArcLength;
            if (comparison < 0) low = i + 1;
            else if (comparison > 0) high = i - 1;
            else {
                high = i;
                break;
            // DONE
            }
        }
        i = high;
        if (arcLengths[i] === targetArcLength) return i / (il - 1);
        // we could get finer grain at lengths, or use simple interpolation between two points
        const lengthBefore = arcLengths[i];
        const lengthAfter = arcLengths[i + 1];
        const segmentLength = lengthAfter - lengthBefore;
        // determine where we are between the 'before' and 'after' points
        const segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
        // add that fractional amount to t
        const t = (i + segmentFraction) / (il - 1);
        return t;
    }
    // Returns a unit vector tangent at t
    // In case any sub curve does not implement its tangent derivation,
    // 2 points a small delta apart will be used to find its gradient
    // which seems to give a reasonable approximation
    getTangent(t, optionalTarget) {
        const delta = 0.0001;
        let t1 = t - delta;
        let t2 = t + delta;
        // Capping in case of danger
        if (t1 < 0) t1 = 0;
        if (t2 > 1) t2 = 1;
        const pt1 = this.getPoint(t1);
        const pt2 = this.getPoint(t2);
        const tangent = optionalTarget || (pt1.isVector2 ? new $e8ea6a63d48a4fea$export$c977b3e384af9ae1() : new $e8ea6a63d48a4fea$export$64b5c384219d3699());
        tangent.copy(pt2).sub(pt1).normalize();
        return tangent;
    }
    getTangentAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getTangent(t, optionalTarget);
    }
    computeFrenetFrames(segments, closed) {
        // see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
        const normal = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        const tangents = [];
        const normals = [];
        const binormals = [];
        const vec = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        const mat = new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5();
        // compute the tangent vectors for each segment on the curve
        for(let i = 0; i <= segments; i++){
            const u = i / segments;
            tangents[i] = this.getTangentAt(u, new $e8ea6a63d48a4fea$export$64b5c384219d3699());
        }
        // select an initial normal vector perpendicular to the first tangent vector,
        // and in the direction of the minimum tangent xyz component
        normals[0] = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        binormals[0] = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        let min = Number.MAX_VALUE;
        const tx = Math.abs(tangents[0].x);
        const ty = Math.abs(tangents[0].y);
        const tz = Math.abs(tangents[0].z);
        if (tx <= min) {
            min = tx;
            normal.set(1, 0, 0);
        }
        if (ty <= min) {
            min = ty;
            normal.set(0, 1, 0);
        }
        if (tz <= min) normal.set(0, 0, 1);
        vec.crossVectors(tangents[0], normal).normalize();
        normals[0].crossVectors(tangents[0], vec);
        binormals[0].crossVectors(tangents[0], normals[0]);
        // compute the slowly-varying normal and binormal vectors for each segment on the curve
        for(let i = 1; i <= segments; i++){
            normals[i] = normals[i - 1].clone();
            binormals[i] = binormals[i - 1].clone();
            vec.crossVectors(tangents[i - 1], tangents[i]);
            if (vec.length() > Number.EPSILON) {
                vec.normalize();
                const theta = Math.acos($e8ea6a63d48a4fea$var$clamp(tangents[i - 1].dot(tangents[i]), -1, 1)); // clamp for floating pt errors
                normals[i].applyMatrix4(mat.makeRotationAxis(vec, theta));
            }
            binormals[i].crossVectors(tangents[i], normals[i]);
        }
        // if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
        if (closed === true) {
            let theta = Math.acos($e8ea6a63d48a4fea$var$clamp(normals[0].dot(normals[segments]), -1, 1));
            theta /= segments;
            if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) theta = -theta;
            for(let i = 1; i <= segments; i++){
                // twist a little...
                normals[i].applyMatrix4(mat.makeRotationAxis(tangents[i], theta * i));
                binormals[i].crossVectors(tangents[i], normals[i]);
            }
        }
        return {
            tangents: tangents,
            normals: normals,
            binormals: binormals
        };
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.arcLengthDivisions = source.arcLengthDivisions;
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.5,
                type: "Curve",
                generator: "Curve.toJSON"
            }
        };
        data.arcLengthDivisions = this.arcLengthDivisions;
        data.type = this.type;
        return data;
    }
    fromJSON(json) {
        this.arcLengthDivisions = json.arcLengthDivisions;
        return this;
    }
}
class $e8ea6a63d48a4fea$export$3f87a931616cde04 extends $e8ea6a63d48a4fea$export$b0e83c3ef8d2db1 {
    constructor(aX = 0, aY = 0, xRadius = 1, yRadius = 1, aStartAngle = 0, aEndAngle = Math.PI * 2, aClockwise = false, aRotation = 0){
        super();
        this.isEllipseCurve = true;
        this.type = "EllipseCurve";
        this.aX = aX;
        this.aY = aY;
        this.xRadius = xRadius;
        this.yRadius = yRadius;
        this.aStartAngle = aStartAngle;
        this.aEndAngle = aEndAngle;
        this.aClockwise = aClockwise;
        this.aRotation = aRotation;
    }
    getPoint(t, optionalTarget) {
        const point = optionalTarget || new $e8ea6a63d48a4fea$export$c977b3e384af9ae1();
        const twoPi = Math.PI * 2;
        let deltaAngle = this.aEndAngle - this.aStartAngle;
        const samePoints = Math.abs(deltaAngle) < Number.EPSILON;
        // ensures that deltaAngle is 0 .. 2 PI
        while(deltaAngle < 0)deltaAngle += twoPi;
        while(deltaAngle > twoPi)deltaAngle -= twoPi;
        if (deltaAngle < Number.EPSILON) {
            if (samePoints) deltaAngle = 0;
            else deltaAngle = twoPi;
        }
        if (this.aClockwise === true && !samePoints) {
            if (deltaAngle === twoPi) deltaAngle = -twoPi;
            else deltaAngle = deltaAngle - twoPi;
        }
        const angle = this.aStartAngle + t * deltaAngle;
        let x = this.aX + this.xRadius * Math.cos(angle);
        let y = this.aY + this.yRadius * Math.sin(angle);
        if (this.aRotation !== 0) {
            const cos = Math.cos(this.aRotation);
            const sin = Math.sin(this.aRotation);
            const tx = x - this.aX;
            const ty = y - this.aY;
            // Rotate the point about the center of the ellipse.
            x = tx * cos - ty * sin + this.aX;
            y = tx * sin + ty * cos + this.aY;
        }
        return point.set(x, y);
    }
    copy(source) {
        super.copy(source);
        this.aX = source.aX;
        this.aY = source.aY;
        this.xRadius = source.xRadius;
        this.yRadius = source.yRadius;
        this.aStartAngle = source.aStartAngle;
        this.aEndAngle = source.aEndAngle;
        this.aClockwise = source.aClockwise;
        this.aRotation = source.aRotation;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.aX = this.aX;
        data.aY = this.aY;
        data.xRadius = this.xRadius;
        data.yRadius = this.yRadius;
        data.aStartAngle = this.aStartAngle;
        data.aEndAngle = this.aEndAngle;
        data.aClockwise = this.aClockwise;
        data.aRotation = this.aRotation;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.aX = json.aX;
        this.aY = json.aY;
        this.xRadius = json.xRadius;
        this.yRadius = json.yRadius;
        this.aStartAngle = json.aStartAngle;
        this.aEndAngle = json.aEndAngle;
        this.aClockwise = json.aClockwise;
        this.aRotation = json.aRotation;
        return this;
    }
}
class $e8ea6a63d48a4fea$export$b1eedc9aab6300e8 extends $e8ea6a63d48a4fea$export$3f87a931616cde04 {
    constructor(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise){
        super(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        this.isArcCurve = true;
        this.type = "ArcCurve";
    }
}
/**
 * Centripetal CatmullRom Curve - which is useful for avoiding
 * cusps and self-intersections in non-uniform catmull rom curves.
 * http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
 *
 * curve.type accepts centripetal(default), chordal and catmullrom
 * curve.tension is used for catmullrom which defaults to 0.5
 */ /*
Based on an optimized c++ solution in
 - http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
 - http://ideone.com/NoEbVM

This CubicPoly class could be used for reusing some variables and calculations,
but for three.js curve use, it could be possible inlined and flatten into a single function call
which can be placed in CurveUtils.
*/ function $e8ea6a63d48a4fea$var$CubicPoly() {
    let c0 = 0, c1 = 0, c2 = 0, c3 = 0;
    /*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */ function init(x0, x1, t0, t1) {
        c0 = x0;
        c1 = t0;
        c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
        c3 = 2 * x0 - 2 * x1 + t0 + t1;
    }
    return {
        initCatmullRom: function(x0, x1, x2, x3, tension) {
            init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
        },
        initNonuniformCatmullRom: function(x0, x1, x2, x3, dt0, dt1, dt2) {
            // compute tangents when parameterized in [t1,t2]
            let t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
            let t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
            // rescale tangents for parametrization in [0,1]
            t1 *= dt1;
            t2 *= dt1;
            init(x1, x2, t1, t2);
        },
        calc: function(t) {
            const t2 = t * t;
            const t3 = t2 * t;
            return c0 + c1 * t + c2 * t2 + c3 * t3;
        }
    };
}
//
const $e8ea6a63d48a4fea$var$tmp = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$px = /*@__PURE__*/ new $e8ea6a63d48a4fea$var$CubicPoly();
const $e8ea6a63d48a4fea$var$py = /*@__PURE__*/ new $e8ea6a63d48a4fea$var$CubicPoly();
const $e8ea6a63d48a4fea$var$pz = /*@__PURE__*/ new $e8ea6a63d48a4fea$var$CubicPoly();
class $e8ea6a63d48a4fea$export$b9146b27c24b744c extends $e8ea6a63d48a4fea$export$b0e83c3ef8d2db1 {
    constructor(points = [], closed = false, curveType = "centripetal", tension = 0.5){
        super();
        this.isCatmullRomCurve3 = true;
        this.type = "CatmullRomCurve3";
        this.points = points;
        this.closed = closed;
        this.curveType = curveType;
        this.tension = tension;
    }
    getPoint(t, optionalTarget = new $e8ea6a63d48a4fea$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const points = this.points;
        const l = points.length;
        const p = (l - (this.closed ? 0 : 1)) * t;
        let intPoint = Math.floor(p);
        let weight = p - intPoint;
        if (this.closed) intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
        else if (weight === 0 && intPoint === l - 1) {
            intPoint = l - 2;
            weight = 1;
        }
        let p0, p3; // 4 points (p1 & p2 defined below)
        if (this.closed || intPoint > 0) p0 = points[(intPoint - 1) % l];
        else {
            // extrapolate first point
            $e8ea6a63d48a4fea$var$tmp.subVectors(points[0], points[1]).add(points[0]);
            p0 = $e8ea6a63d48a4fea$var$tmp;
        }
        const p1 = points[intPoint % l];
        const p2 = points[(intPoint + 1) % l];
        if (this.closed || intPoint + 2 < l) p3 = points[(intPoint + 2) % l];
        else {
            // extrapolate last point
            $e8ea6a63d48a4fea$var$tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
            p3 = $e8ea6a63d48a4fea$var$tmp;
        }
        if (this.curveType === "centripetal" || this.curveType === "chordal") {
            // init Centripetal / Chordal Catmull-Rom
            const pow = this.curveType === "chordal" ? 0.5 : 0.25;
            let dt0 = Math.pow(p0.distanceToSquared(p1), pow);
            let dt1 = Math.pow(p1.distanceToSquared(p2), pow);
            let dt2 = Math.pow(p2.distanceToSquared(p3), pow);
            // safety check for repeated points
            if (dt1 < 1e-4) dt1 = 1.0;
            if (dt0 < 1e-4) dt0 = dt1;
            if (dt2 < 1e-4) dt2 = dt1;
            $e8ea6a63d48a4fea$var$px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
            $e8ea6a63d48a4fea$var$py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
            $e8ea6a63d48a4fea$var$pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
        } else if (this.curveType === "catmullrom") {
            $e8ea6a63d48a4fea$var$px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
            $e8ea6a63d48a4fea$var$py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
            $e8ea6a63d48a4fea$var$pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
        }
        point.set($e8ea6a63d48a4fea$var$px.calc(weight), $e8ea6a63d48a4fea$var$py.calc(weight), $e8ea6a63d48a4fea$var$pz.calc(weight));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        this.closed = source.closed;
        this.curveType = source.curveType;
        this.tension = source.tension;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        data.closed = this.closed;
        data.curveType = this.curveType;
        data.tension = this.tension;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $e8ea6a63d48a4fea$export$64b5c384219d3699().fromArray(point));
        }
        this.closed = json.closed;
        this.curveType = json.curveType;
        this.tension = json.tension;
        return this;
    }
}
/**
 * Bezier Curves formulas obtained from
 * https://en.wikipedia.org/wiki/B%C3%A9zier_curve
 */ function $e8ea6a63d48a4fea$var$CatmullRom(t, p0, p1, p2, p3) {
    const v0 = (p2 - p0) * 0.5;
    const v1 = (p3 - p1) * 0.5;
    const t2 = t * t;
    const t3 = t * t2;
    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}
//
function $e8ea6a63d48a4fea$var$QuadraticBezierP0(t, p) {
    const k = 1 - t;
    return k * k * p;
}
function $e8ea6a63d48a4fea$var$QuadraticBezierP1(t, p) {
    return 2 * (1 - t) * t * p;
}
function $e8ea6a63d48a4fea$var$QuadraticBezierP2(t, p) {
    return t * t * p;
}
function $e8ea6a63d48a4fea$var$QuadraticBezier(t, p0, p1, p2) {
    return $e8ea6a63d48a4fea$var$QuadraticBezierP0(t, p0) + $e8ea6a63d48a4fea$var$QuadraticBezierP1(t, p1) + $e8ea6a63d48a4fea$var$QuadraticBezierP2(t, p2);
}
//
function $e8ea6a63d48a4fea$var$CubicBezierP0(t, p) {
    const k = 1 - t;
    return k * k * k * p;
}
function $e8ea6a63d48a4fea$var$CubicBezierP1(t, p) {
    const k = 1 - t;
    return 3 * k * k * t * p;
}
function $e8ea6a63d48a4fea$var$CubicBezierP2(t, p) {
    return 3 * (1 - t) * t * t * p;
}
function $e8ea6a63d48a4fea$var$CubicBezierP3(t, p) {
    return t * t * t * p;
}
function $e8ea6a63d48a4fea$var$CubicBezier(t, p0, p1, p2, p3) {
    return $e8ea6a63d48a4fea$var$CubicBezierP0(t, p0) + $e8ea6a63d48a4fea$var$CubicBezierP1(t, p1) + $e8ea6a63d48a4fea$var$CubicBezierP2(t, p2) + $e8ea6a63d48a4fea$var$CubicBezierP3(t, p3);
}
class $e8ea6a63d48a4fea$export$e36650d36468bb39 extends $e8ea6a63d48a4fea$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(), v1 = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(), v2 = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(), v3 = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1()){
        super();
        this.isCubicBezierCurve = true;
        this.type = "CubicBezierCurve";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($e8ea6a63d48a4fea$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $e8ea6a63d48a4fea$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
class $e8ea6a63d48a4fea$export$13d5f1c9525f246c extends $e8ea6a63d48a4fea$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $e8ea6a63d48a4fea$export$64b5c384219d3699(), v1 = new $e8ea6a63d48a4fea$export$64b5c384219d3699(), v2 = new $e8ea6a63d48a4fea$export$64b5c384219d3699(), v3 = new $e8ea6a63d48a4fea$export$64b5c384219d3699()){
        super();
        this.isCubicBezierCurve3 = true;
        this.type = "CubicBezierCurve3";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $e8ea6a63d48a4fea$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($e8ea6a63d48a4fea$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $e8ea6a63d48a4fea$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y), $e8ea6a63d48a4fea$var$CubicBezier(t, v0.z, v1.z, v2.z, v3.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
class $e8ea6a63d48a4fea$export$ab2e07e76531a47e extends $e8ea6a63d48a4fea$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(), v2 = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1()){
        super();
        this.isLineCurve = true;
        this.type = "LineCurve";
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $e8ea6a63d48a4fea$export$1fdfd9d9cf487600 extends $e8ea6a63d48a4fea$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $e8ea6a63d48a4fea$export$64b5c384219d3699(), v2 = new $e8ea6a63d48a4fea$export$64b5c384219d3699()){
        super();
        this.isLineCurve3 = true;
        this.type = "LineCurve3";
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $e8ea6a63d48a4fea$export$64b5c384219d3699()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $e8ea6a63d48a4fea$export$64b5c384219d3699()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $e8ea6a63d48a4fea$export$5938c4ee491a43ad extends $e8ea6a63d48a4fea$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(), v1 = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(), v2 = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1()){
        super();
        this.isQuadraticBezierCurve = true;
        this.type = "QuadraticBezierCurve";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($e8ea6a63d48a4fea$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $e8ea6a63d48a4fea$var$QuadraticBezier(t, v0.y, v1.y, v2.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $e8ea6a63d48a4fea$export$bf3f4c7e459f90fc extends $e8ea6a63d48a4fea$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $e8ea6a63d48a4fea$export$64b5c384219d3699(), v1 = new $e8ea6a63d48a4fea$export$64b5c384219d3699(), v2 = new $e8ea6a63d48a4fea$export$64b5c384219d3699()){
        super();
        this.isQuadraticBezierCurve3 = true;
        this.type = "QuadraticBezierCurve3";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $e8ea6a63d48a4fea$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($e8ea6a63d48a4fea$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $e8ea6a63d48a4fea$var$QuadraticBezier(t, v0.y, v1.y, v2.y), $e8ea6a63d48a4fea$var$QuadraticBezier(t, v0.z, v1.z, v2.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $e8ea6a63d48a4fea$export$d3bdd77da77afc1b extends $e8ea6a63d48a4fea$export$b0e83c3ef8d2db1 {
    constructor(points = []){
        super();
        this.isSplineCurve = true;
        this.type = "SplineCurve";
        this.points = points;
    }
    getPoint(t, optionalTarget = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const points = this.points;
        const p = (points.length - 1) * t;
        const intPoint = Math.floor(p);
        const weight = p - intPoint;
        const p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
        const p1 = points[intPoint];
        const p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
        const p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
        point.set($e8ea6a63d48a4fea$var$CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), $e8ea6a63d48a4fea$var$CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $e8ea6a63d48a4fea$export$c977b3e384af9ae1().fromArray(point));
        }
        return this;
    }
}
var $e8ea6a63d48a4fea$var$Curves = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcCurve: $e8ea6a63d48a4fea$export$b1eedc9aab6300e8,
    CatmullRomCurve3: $e8ea6a63d48a4fea$export$b9146b27c24b744c,
    CubicBezierCurve: $e8ea6a63d48a4fea$export$e36650d36468bb39,
    CubicBezierCurve3: $e8ea6a63d48a4fea$export$13d5f1c9525f246c,
    EllipseCurve: $e8ea6a63d48a4fea$export$3f87a931616cde04,
    LineCurve: $e8ea6a63d48a4fea$export$ab2e07e76531a47e,
    LineCurve3: $e8ea6a63d48a4fea$export$1fdfd9d9cf487600,
    QuadraticBezierCurve: $e8ea6a63d48a4fea$export$5938c4ee491a43ad,
    QuadraticBezierCurve3: $e8ea6a63d48a4fea$export$bf3f4c7e459f90fc,
    SplineCurve: $e8ea6a63d48a4fea$export$d3bdd77da77afc1b
});
/**************************************************************
 *	Curved Path - a curve path is simply a array of connected
 *  curves, but retains the api of a curve
 **************************************************************/ class $e8ea6a63d48a4fea$export$4aaf9b66af1bbf2c extends $e8ea6a63d48a4fea$export$b0e83c3ef8d2db1 {
    constructor(){
        super();
        this.type = "CurvePath";
        this.curves = [];
        this.autoClose = false; // Automatically closes the path
    }
    add(curve) {
        this.curves.push(curve);
    }
    closePath() {
        // Add a line curve if start and end of lines are not connected
        const startPoint = this.curves[0].getPoint(0);
        const endPoint = this.curves[this.curves.length - 1].getPoint(1);
        if (!startPoint.equals(endPoint)) this.curves.push(new $e8ea6a63d48a4fea$export$ab2e07e76531a47e(endPoint, startPoint));
    }
    // To get accurate point with reference to
    // entire path distance at time t,
    // following has to be done:
    // 1. Length of each sub path have to be known
    // 2. Locate and identify type of curve
    // 3. Get t for the curve
    // 4. Return curve.getPointAt(t')
    getPoint(t, optionalTarget) {
        const d = t * this.getLength();
        const curveLengths = this.getCurveLengths();
        let i = 0;
        // To think about boundaries points.
        while(i < curveLengths.length){
            if (curveLengths[i] >= d) {
                const diff = curveLengths[i] - d;
                const curve = this.curves[i];
                const segmentLength = curve.getLength();
                const u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                return curve.getPointAt(u, optionalTarget);
            }
            i++;
        }
        return null;
    // loop where sum != 0, sum > d , sum+1 <d
    }
    // We cannot use the default THREE.Curve getPoint() with getLength() because in
    // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
    // getPoint() depends on getLength
    getLength() {
        const lens = this.getCurveLengths();
        return lens[lens.length - 1];
    }
    // cacheLengths must be recalculated.
    updateArcLengths() {
        this.needsUpdate = true;
        this.cacheLengths = null;
        this.getCurveLengths();
    }
    // Compute lengths and cache them
    // We cannot overwrite getLengths() because UtoT mapping uses it.
    getCurveLengths() {
        // We use cache values if curves and cache array are same length
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        // Get length of sub-curve
        // Push sums into cached array
        const lengths = [];
        let sums = 0;
        for(let i = 0, l = this.curves.length; i < l; i++){
            sums += this.curves[i].getLength();
            lengths.push(sums);
        }
        this.cacheLengths = lengths;
        return lengths;
    }
    getSpacedPoints(divisions = 40) {
        const points = [];
        for(let i = 0; i <= divisions; i++)points.push(this.getPoint(i / divisions));
        if (this.autoClose) points.push(points[0]);
        return points;
    }
    getPoints(divisions = 12) {
        const points = [];
        let last;
        for(let i = 0, curves = this.curves; i < curves.length; i++){
            const curve = curves[i];
            const resolution = curve.isEllipseCurve ? divisions * 2 : curve.isLineCurve || curve.isLineCurve3 ? 1 : curve.isSplineCurve ? divisions * curve.points.length : divisions;
            const pts = curve.getPoints(resolution);
            for(let j = 0; j < pts.length; j++){
                const point = pts[j];
                if (last && last.equals(point)) continue; // ensures no consecutive points are duplicates
                points.push(point);
                last = point;
            }
        }
        if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) points.push(points[0]);
        return points;
    }
    copy(source) {
        super.copy(source);
        this.curves = [];
        for(let i = 0, l = source.curves.length; i < l; i++){
            const curve = source.curves[i];
            this.curves.push(curve.clone());
        }
        this.autoClose = source.autoClose;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.autoClose = this.autoClose;
        data.curves = [];
        for(let i = 0, l = this.curves.length; i < l; i++){
            const curve = this.curves[i];
            data.curves.push(curve.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.autoClose = json.autoClose;
        this.curves = [];
        for(let i = 0, l = json.curves.length; i < l; i++){
            const curve = json.curves[i];
            this.curves.push(new $e8ea6a63d48a4fea$var$Curves[curve.type]().fromJSON(curve));
        }
        return this;
    }
}
class $e8ea6a63d48a4fea$export$4b2950bdac9b6ee9 extends $e8ea6a63d48a4fea$export$4aaf9b66af1bbf2c {
    constructor(points){
        super();
        this.type = "Path";
        this.currentPoint = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1();
        if (points) this.setFromPoints(points);
    }
    setFromPoints(points) {
        this.moveTo(points[0].x, points[0].y);
        for(let i = 1, l = points.length; i < l; i++)this.lineTo(points[i].x, points[i].y);
        return this;
    }
    moveTo(x, y) {
        this.currentPoint.set(x, y); // TODO consider referencing vectors instead of copying?
        return this;
    }
    lineTo(x, y) {
        const curve = new $e8ea6a63d48a4fea$export$ab2e07e76531a47e(this.currentPoint.clone(), new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(x, y));
        this.curves.push(curve);
        this.currentPoint.set(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        const curve = new $e8ea6a63d48a4fea$export$5938c4ee491a43ad(this.currentPoint.clone(), new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(aCPx, aCPy), new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        const curve = new $e8ea6a63d48a4fea$export$e36650d36468bb39(this.currentPoint.clone(), new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(aCP1x, aCP1y), new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(aCP2x, aCP2y), new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    splineThru(pts /*Array of Vector*/ ) {
        const npts = [
            this.currentPoint.clone()
        ].concat(pts);
        const curve = new $e8ea6a63d48a4fea$export$d3bdd77da77afc1b(npts);
        this.curves.push(curve);
        this.currentPoint.copy(pts[pts.length - 1]);
        return this;
    }
    arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absarc(aX + x0, aY + y0, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        return this;
    }
    absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const curve = new $e8ea6a63d48a4fea$export$3f87a931616cde04(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        if (this.curves.length > 0) {
            // if a previous curve is present, attempt to join
            const firstPoint = curve.getPoint(0);
            if (!firstPoint.equals(this.currentPoint)) this.lineTo(firstPoint.x, firstPoint.y);
        }
        this.curves.push(curve);
        const lastPoint = curve.getPoint(1);
        this.currentPoint.copy(lastPoint);
        return this;
    }
    copy(source) {
        super.copy(source);
        this.currentPoint.copy(source.currentPoint);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.currentPoint = this.currentPoint.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.currentPoint.fromArray(json.currentPoint);
        return this;
    }
}
class $e8ea6a63d48a4fea$export$6d839803fcd1882c extends $e8ea6a63d48a4fea$export$b7be63a67df8959 {
    constructor(points = [
        new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(0, -0.5),
        new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(0.5, 0),
        new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(0, 0.5)
    ], segments = 12, phiStart = 0, phiLength = Math.PI * 2){
        super();
        this.type = "LatheGeometry";
        this.parameters = {
            points: points,
            segments: segments,
            phiStart: phiStart,
            phiLength: phiLength
        };
        segments = Math.floor(segments);
        // clamp phiLength so it's in range of [ 0, 2PI ]
        phiLength = $e8ea6a63d48a4fea$var$clamp(phiLength, 0, Math.PI * 2);
        // buffers
        const indices = [];
        const vertices = [];
        const uvs = [];
        const initNormals = [];
        const normals = [];
        // helper variables
        const inverseSegments = 1.0 / segments;
        const vertex = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        const uv = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1();
        const normal = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        const curNormal = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        const prevNormal = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        let dx = 0;
        let dy = 0;
        // pre-compute normals for initial "meridian"
        for(let j = 0; j <= points.length - 1; j++)switch(j){
            case 0:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                prevNormal.copy(normal);
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                break;
            case points.length - 1:
                initNormals.push(prevNormal.x, prevNormal.y, prevNormal.z);
                break;
            default:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                curNormal.copy(normal);
                normal.x += prevNormal.x;
                normal.y += prevNormal.y;
                normal.z += prevNormal.z;
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                prevNormal.copy(curNormal);
        }
        // generate vertices, uvs and normals
        for(let i = 0; i <= segments; i++){
            const phi = phiStart + i * inverseSegments * phiLength;
            const sin = Math.sin(phi);
            const cos = Math.cos(phi);
            for(let j = 0; j <= points.length - 1; j++){
                // vertex
                vertex.x = points[j].x * sin;
                vertex.y = points[j].y;
                vertex.z = points[j].x * cos;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // uv
                uv.x = i / segments;
                uv.y = j / (points.length - 1);
                uvs.push(uv.x, uv.y);
                // normal
                const x = initNormals[3 * j + 0] * sin;
                const y = initNormals[3 * j + 1];
                const z = initNormals[3 * j + 0] * cos;
                normals.push(x, y, z);
            }
        }
        // indices
        for(let i = 0; i < segments; i++)for(let j = 0; j < points.length - 1; j++){
            const base = j + i * points.length;
            const a = base;
            const b = base + points.length;
            const c = base + points.length + 1;
            const d = base + 1;
            // faces
            indices.push(a, b, d);
            indices.push(c, d, b);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("uv", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(uvs, 2));
        this.setAttribute("normal", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(normals, 3));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $e8ea6a63d48a4fea$export$6d839803fcd1882c(data.points, data.segments, data.phiStart, data.phiLength);
    }
}
class $e8ea6a63d48a4fea$export$41680e8551036033 extends $e8ea6a63d48a4fea$export$6d839803fcd1882c {
    constructor(radius = 1, length = 1, capSegments = 4, radialSegments = 8){
        const path = new $e8ea6a63d48a4fea$export$4b2950bdac9b6ee9();
        path.absarc(0, -length / 2, radius, Math.PI * 1.5, 0);
        path.absarc(0, length / 2, radius, 0, Math.PI * 0.5);
        super(path.getPoints(capSegments), radialSegments);
        this.type = "CapsuleGeometry";
        this.parameters = {
            radius: radius,
            height: length,
            capSegments: capSegments,
            radialSegments: radialSegments
        };
    }
    static fromJSON(data) {
        return new $e8ea6a63d48a4fea$export$41680e8551036033(data.radius, data.length, data.capSegments, data.radialSegments);
    }
}
class $e8ea6a63d48a4fea$export$d5c0e8d607467193 extends $e8ea6a63d48a4fea$export$b7be63a67df8959 {
    constructor(radius = 1, segments = 32, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = "CircleGeometry";
        this.parameters = {
            radius: radius,
            segments: segments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        segments = Math.max(3, segments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        const uv = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1();
        // center point
        vertices.push(0, 0, 0);
        normals.push(0, 0, 1);
        uvs.push(0.5, 0.5);
        for(let s = 0, i = 3; s <= segments; s++, i += 3){
            const segment = thetaStart + s / segments * thetaLength;
            // vertex
            vertex.x = radius * Math.cos(segment);
            vertex.y = radius * Math.sin(segment);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normals.push(0, 0, 1);
            // uvs
            uv.x = (vertices[i] / radius + 1) / 2;
            uv.y = (vertices[i + 1] / radius + 1) / 2;
            uvs.push(uv.x, uv.y);
        }
        // indices
        for(let i = 1; i <= segments; i++)indices.push(i, i + 1, 0);
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $e8ea6a63d48a4fea$export$d5c0e8d607467193(data.radius, data.segments, data.thetaStart, data.thetaLength);
    }
}
class $e8ea6a63d48a4fea$export$68f745719dbe5198 extends $e8ea6a63d48a4fea$export$b7be63a67df8959 {
    constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = "CylinderGeometry";
        this.parameters = {
            radiusTop: radiusTop,
            radiusBottom: radiusBottom,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        const scope = this;
        radialSegments = Math.floor(radialSegments);
        heightSegments = Math.floor(heightSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let index = 0;
        const indexArray = [];
        const halfHeight = height / 2;
        let groupStart = 0;
        // generate geometry
        generateTorso();
        if (openEnded === false) {
            if (radiusTop > 0) generateCap(true);
            if (radiusBottom > 0) generateCap(false);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(uvs, 2));
        function generateTorso() {
            const normal = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
            const vertex = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
            let groupCount = 0;
            // this will be used to calculate the normal
            const slope = (radiusBottom - radiusTop) / height;
            // generate vertices, normals and uvs
            for(let y = 0; y <= heightSegments; y++){
                const indexRow = [];
                const v = y / heightSegments;
                // calculate the radius of the current row
                const radius = v * (radiusBottom - radiusTop) + radiusTop;
                for(let x = 0; x <= radialSegments; x++){
                    const u = x / radialSegments;
                    const theta = u * thetaLength + thetaStart;
                    const sinTheta = Math.sin(theta);
                    const cosTheta = Math.cos(theta);
                    // vertex
                    vertex.x = radius * sinTheta;
                    vertex.y = -v * height + halfHeight;
                    vertex.z = radius * cosTheta;
                    vertices.push(vertex.x, vertex.y, vertex.z);
                    // normal
                    normal.set(sinTheta, slope, cosTheta).normalize();
                    normals.push(normal.x, normal.y, normal.z);
                    // uv
                    uvs.push(u, 1 - v);
                    // save index of vertex in respective row
                    indexRow.push(index++);
                }
                // now save vertices of the row in our index array
                indexArray.push(indexRow);
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++)for(let y = 0; y < heightSegments; y++){
                // we use the index array to access the correct indices
                const a = indexArray[y][x];
                const b = indexArray[y + 1][x];
                const c = indexArray[y + 1][x + 1];
                const d = indexArray[y][x + 1];
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // update group counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, 0);
            // calculate new start value for groups
            groupStart += groupCount;
        }
        function generateCap(top) {
            // save the index of the first center vertex
            const centerIndexStart = index;
            const uv = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1();
            const vertex = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
            let groupCount = 0;
            const radius = top === true ? radiusTop : radiusBottom;
            const sign = top === true ? 1 : -1;
            // first we generate the center vertex data of the cap.
            // because the geometry needs one set of uvs per face,
            // we must generate a center vertex per face/segment
            for(let x = 1; x <= radialSegments; x++){
                // vertex
                vertices.push(0, halfHeight * sign, 0);
                // normal
                normals.push(0, sign, 0);
                // uv
                uvs.push(0.5, 0.5);
                // increase index
                index++;
            }
            // save the index of the last center vertex
            const centerIndexEnd = index;
            // now we generate the surrounding vertices, normals and uvs
            for(let x = 0; x <= radialSegments; x++){
                const u = x / radialSegments;
                const theta = u * thetaLength + thetaStart;
                const cosTheta = Math.cos(theta);
                const sinTheta = Math.sin(theta);
                // vertex
                vertex.x = radius * sinTheta;
                vertex.y = halfHeight * sign;
                vertex.z = radius * cosTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, sign, 0);
                // uv
                uv.x = cosTheta * 0.5 + 0.5;
                uv.y = sinTheta * 0.5 * sign + 0.5;
                uvs.push(uv.x, uv.y);
                // increase index
                index++;
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++){
                const c = centerIndexStart + x;
                const i = centerIndexEnd + x;
                if (top === true) // face top
                indices.push(i, i + 1, c);
                else // face bottom
                indices.push(i + 1, i, c);
                groupCount += 3;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
            // calculate new start value for groups
            groupStart += groupCount;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $e8ea6a63d48a4fea$export$68f745719dbe5198(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $e8ea6a63d48a4fea$export$a7a48974f285c9b3 extends $e8ea6a63d48a4fea$export$68f745719dbe5198 {
    constructor(radius = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super(0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
        this.type = "ConeGeometry";
        this.parameters = {
            radius: radius,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
    }
    static fromJSON(data) {
        return new $e8ea6a63d48a4fea$export$a7a48974f285c9b3(data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $e8ea6a63d48a4fea$export$60e57a7d3f20ff65 extends $e8ea6a63d48a4fea$export$b7be63a67df8959 {
    constructor(vertices = [], indices = [], radius = 1, detail = 0){
        super();
        this.type = "PolyhedronGeometry";
        this.parameters = {
            vertices: vertices,
            indices: indices,
            radius: radius,
            detail: detail
        };
        // default buffer data
        const vertexBuffer = [];
        const uvBuffer = [];
        // the subdivision creates the vertex buffer data
        subdivide(detail);
        // all vertices should lie on a conceptual sphere with a given radius
        applyRadius(radius);
        // finally, create the uv data
        generateUVs();
        // build non-indexed geometry
        this.setAttribute("position", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(vertexBuffer, 3));
        this.setAttribute("normal", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(vertexBuffer.slice(), 3));
        this.setAttribute("uv", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(uvBuffer, 2));
        if (detail === 0) this.computeVertexNormals(); // flat normals
        else this.normalizeNormals(); // smooth normals
        // helper functions
        function subdivide(detail) {
            const a = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
            const b = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
            const c = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
            // iterate over all faces and apply a subdivision with the given detail value
            for(let i = 0; i < indices.length; i += 3){
                // get the vertices of the face
                getVertexByIndex(indices[i + 0], a);
                getVertexByIndex(indices[i + 1], b);
                getVertexByIndex(indices[i + 2], c);
                // perform subdivision
                subdivideFace(a, b, c, detail);
            }
        }
        function subdivideFace(a, b, c, detail) {
            const cols = detail + 1;
            // we use this multidimensional array as a data structure for creating the subdivision
            const v = [];
            // construct all of the vertices for this subdivision
            for(let i = 0; i <= cols; i++){
                v[i] = [];
                const aj = a.clone().lerp(c, i / cols);
                const bj = b.clone().lerp(c, i / cols);
                const rows = cols - i;
                for(let j = 0; j <= rows; j++)if (j === 0 && i === cols) v[i][j] = aj;
                else v[i][j] = aj.clone().lerp(bj, j / rows);
            }
            // construct all of the faces
            for(let i = 0; i < cols; i++)for(let j = 0; j < 2 * (cols - i) - 1; j++){
                const k = Math.floor(j / 2);
                if (j % 2 === 0) {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k]);
                    pushVertex(v[i][k]);
                } else {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k + 1]);
                    pushVertex(v[i + 1][k]);
                }
            }
        }
        function applyRadius(radius) {
            const vertex = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
            // iterate over the entire buffer and apply the radius to each vertex
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                vertex.normalize().multiplyScalar(radius);
                vertexBuffer[i + 0] = vertex.x;
                vertexBuffer[i + 1] = vertex.y;
                vertexBuffer[i + 2] = vertex.z;
            }
        }
        function generateUVs() {
            const vertex = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                const u = azimuth(vertex) / 2 / Math.PI + 0.5;
                const v = inclination(vertex) / Math.PI + 0.5;
                uvBuffer.push(u, 1 - v);
            }
            correctUVs();
            correctSeam();
        }
        function correctSeam() {
            // handle case when face straddles the seam, see #3269
            for(let i = 0; i < uvBuffer.length; i += 6){
                // uv data of a single face
                const x0 = uvBuffer[i + 0];
                const x1 = uvBuffer[i + 2];
                const x2 = uvBuffer[i + 4];
                const max = Math.max(x0, x1, x2);
                const min = Math.min(x0, x1, x2);
                // 0.9 is somewhat arbitrary
                if (max > 0.9 && min < 0.1) {
                    if (x0 < 0.2) uvBuffer[i + 0] += 1;
                    if (x1 < 0.2) uvBuffer[i + 2] += 1;
                    if (x2 < 0.2) uvBuffer[i + 4] += 1;
                }
            }
        }
        function pushVertex(vertex) {
            vertexBuffer.push(vertex.x, vertex.y, vertex.z);
        }
        function getVertexByIndex(index, vertex) {
            const stride = index * 3;
            vertex.x = vertices[stride + 0];
            vertex.y = vertices[stride + 1];
            vertex.z = vertices[stride + 2];
        }
        function correctUVs() {
            const a = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
            const b = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
            const c = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
            const centroid = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
            const uvA = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1();
            const uvB = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1();
            const uvC = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1();
            for(let i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6){
                a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
                b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
                c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);
                uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
                uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
                uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
                centroid.copy(a).add(b).add(c).divideScalar(3);
                const azi = azimuth(centroid);
                correctUV(uvA, j + 0, a, azi);
                correctUV(uvB, j + 2, b, azi);
                correctUV(uvC, j + 4, c, azi);
            }
        }
        function correctUV(uv, stride, vector, azimuth) {
            if (azimuth < 0 && uv.x === 1) uvBuffer[stride] = uv.x - 1;
            if (vector.x === 0 && vector.z === 0) uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;
        }
        // Angle around the Y axis, counter-clockwise when looking from above.
        function azimuth(vector) {
            return Math.atan2(vector.z, -vector.x);
        }
        // Angle above the XZ plane.
        function inclination(vector) {
            return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $e8ea6a63d48a4fea$export$60e57a7d3f20ff65(data.vertices, data.indices, data.radius, data.details);
    }
}
class $e8ea6a63d48a4fea$export$c0babfeb8708fc9c extends $e8ea6a63d48a4fea$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const r = 1 / t;
        const vertices = [
            // (±1, ±1, ±1)
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            // (0, ±1/φ, ±φ)
            0,
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            // (±1/φ, ±φ, 0)
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            0,
            // (±φ, 0, ±1/φ)
            -t,
            0,
            -r,
            t,
            0,
            -r,
            -t,
            0,
            r,
            t,
            0,
            r
        ];
        const indices = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        super(vertices, indices, radius, detail);
        this.type = "DodecahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $e8ea6a63d48a4fea$export$c0babfeb8708fc9c(data.radius, data.detail);
    }
}
const $e8ea6a63d48a4fea$var$_v0 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_v1$1 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_normal = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_triangle = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$5a465592bfe74b48();
class $e8ea6a63d48a4fea$export$4730b1542707547f extends $e8ea6a63d48a4fea$export$b7be63a67df8959 {
    constructor(geometry = null, thresholdAngle = 1){
        super();
        this.type = "EdgesGeometry";
        this.parameters = {
            geometry: geometry,
            thresholdAngle: thresholdAngle
        };
        if (geometry !== null) {
            const precisionPoints = 4;
            const precision = Math.pow(10, precisionPoints);
            const thresholdDot = Math.cos($e8ea6a63d48a4fea$var$DEG2RAD * thresholdAngle);
            const indexAttr = geometry.getIndex();
            const positionAttr = geometry.getAttribute("position");
            const indexCount = indexAttr ? indexAttr.count : positionAttr.count;
            const indexArr = [
                0,
                0,
                0
            ];
            const vertKeys = [
                "a",
                "b",
                "c"
            ];
            const hashes = new Array(3);
            const edgeData = {};
            const vertices = [];
            for(let i = 0; i < indexCount; i += 3){
                if (indexAttr) {
                    indexArr[0] = indexAttr.getX(i);
                    indexArr[1] = indexAttr.getX(i + 1);
                    indexArr[2] = indexAttr.getX(i + 2);
                } else {
                    indexArr[0] = i;
                    indexArr[1] = i + 1;
                    indexArr[2] = i + 2;
                }
                const { a: a , b: b , c: c  } = $e8ea6a63d48a4fea$var$_triangle;
                a.fromBufferAttribute(positionAttr, indexArr[0]);
                b.fromBufferAttribute(positionAttr, indexArr[1]);
                c.fromBufferAttribute(positionAttr, indexArr[2]);
                $e8ea6a63d48a4fea$var$_triangle.getNormal($e8ea6a63d48a4fea$var$_normal);
                // create hashes for the edge from the vertices
                hashes[0] = `${Math.round(a.x * precision)},${Math.round(a.y * precision)},${Math.round(a.z * precision)}`;
                hashes[1] = `${Math.round(b.x * precision)},${Math.round(b.y * precision)},${Math.round(b.z * precision)}`;
                hashes[2] = `${Math.round(c.x * precision)},${Math.round(c.y * precision)},${Math.round(c.z * precision)}`;
                // skip degenerate triangles
                if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) continue;
                // iterate over every edge
                for(let j = 0; j < 3; j++){
                    // get the first and next vertex making up the edge
                    const jNext = (j + 1) % 3;
                    const vecHash0 = hashes[j];
                    const vecHash1 = hashes[jNext];
                    const v0 = $e8ea6a63d48a4fea$var$_triangle[vertKeys[j]];
                    const v1 = $e8ea6a63d48a4fea$var$_triangle[vertKeys[jNext]];
                    const hash = `${vecHash0}_${vecHash1}`;
                    const reverseHash = `${vecHash1}_${vecHash0}`;
                    if (reverseHash in edgeData && edgeData[reverseHash]) {
                        // if we found a sibling edge add it into the vertex array if
                        // it meets the angle threshold and delete the edge from the map.
                        if ($e8ea6a63d48a4fea$var$_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {
                            vertices.push(v0.x, v0.y, v0.z);
                            vertices.push(v1.x, v1.y, v1.z);
                        }
                        edgeData[reverseHash] = null;
                    } else if (!(hash in edgeData)) // if we've already got an edge here then skip adding a new one
                    edgeData[hash] = {
                        index0: indexArr[j],
                        index1: indexArr[jNext],
                        normal: $e8ea6a63d48a4fea$var$_normal.clone()
                    };
                }
            }
            // iterate over all remaining, unmatched edges and add them to the vertex array
            for(const key in edgeData)if (edgeData[key]) {
                const { index0: index0 , index1: index1  } = edgeData[key];
                $e8ea6a63d48a4fea$var$_v0.fromBufferAttribute(positionAttr, index0);
                $e8ea6a63d48a4fea$var$_v1$1.fromBufferAttribute(positionAttr, index1);
                vertices.push($e8ea6a63d48a4fea$var$_v0.x, $e8ea6a63d48a4fea$var$_v0.y, $e8ea6a63d48a4fea$var$_v0.z);
                vertices.push($e8ea6a63d48a4fea$var$_v1$1.x, $e8ea6a63d48a4fea$var$_v1$1.y, $e8ea6a63d48a4fea$var$_v1$1.z);
            }
            this.setAttribute("position", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
class $e8ea6a63d48a4fea$export$6428a7f2611ef1fa extends $e8ea6a63d48a4fea$export$4b2950bdac9b6ee9 {
    constructor(points){
        super(points);
        this.uuid = $e8ea6a63d48a4fea$var$generateUUID();
        this.type = "Shape";
        this.holes = [];
    }
    getPointsHoles(divisions) {
        const holesPts = [];
        for(let i = 0, l = this.holes.length; i < l; i++)holesPts[i] = this.holes[i].getPoints(divisions);
        return holesPts;
    }
    // get points of shape and holes (keypoints based on segments parameter)
    extractPoints(divisions) {
        return {
            shape: this.getPoints(divisions),
            holes: this.getPointsHoles(divisions)
        };
    }
    copy(source) {
        super.copy(source);
        this.holes = [];
        for(let i = 0, l = source.holes.length; i < l; i++){
            const hole = source.holes[i];
            this.holes.push(hole.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.uuid = this.uuid;
        data.holes = [];
        for(let i = 0, l = this.holes.length; i < l; i++){
            const hole = this.holes[i];
            data.holes.push(hole.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.uuid = json.uuid;
        this.holes = [];
        for(let i = 0, l = json.holes.length; i < l; i++){
            const hole = json.holes[i];
            this.holes.push(new $e8ea6a63d48a4fea$export$4b2950bdac9b6ee9().fromJSON(hole));
        }
        return this;
    }
}
/**
 * Port from https://github.com/mapbox/earcut (v2.2.4)
 */ const $e8ea6a63d48a4fea$var$Earcut = {
    triangulate: function(data, holeIndices, dim = 2) {
        const hasHoles = holeIndices && holeIndices.length;
        const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
        let outerNode = $e8ea6a63d48a4fea$var$linkedList(data, 0, outerLen, dim, true);
        const triangles = [];
        if (!outerNode || outerNode.next === outerNode.prev) return triangles;
        let minX, minY, maxX, maxY, x, y, invSize;
        if (hasHoles) outerNode = $e8ea6a63d48a4fea$var$eliminateHoles(data, holeIndices, outerNode, dim);
        // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
        if (data.length > 80 * dim) {
            minX = maxX = data[0];
            minY = maxY = data[1];
            for(let i = dim; i < outerLen; i += dim){
                x = data[i];
                y = data[i + 1];
                if (x < minX) minX = x;
                if (y < minY) minY = y;
                if (x > maxX) maxX = x;
                if (y > maxY) maxY = y;
            }
            // minX, minY and invSize are later used to transform coords into integers for z-order calculation
            invSize = Math.max(maxX - minX, maxY - minY);
            invSize = invSize !== 0 ? 32767 / invSize : 0;
        }
        $e8ea6a63d48a4fea$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
        return triangles;
    }
};
// create a circular doubly linked list from polygon points in the specified winding order
function $e8ea6a63d48a4fea$var$linkedList(data, start, end, dim, clockwise) {
    let i, last;
    if (clockwise === $e8ea6a63d48a4fea$var$signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = $e8ea6a63d48a4fea$var$insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = $e8ea6a63d48a4fea$var$insertNode(i, data[i], data[i + 1], last);
    if (last && $e8ea6a63d48a4fea$var$equals(last, last.next)) {
        $e8ea6a63d48a4fea$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $e8ea6a63d48a4fea$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && ($e8ea6a63d48a4fea$var$equals(p, p.next) || $e8ea6a63d48a4fea$var$area(p.prev, p, p.next) === 0)) {
            $e8ea6a63d48a4fea$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $e8ea6a63d48a4fea$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $e8ea6a63d48a4fea$var$indexCurve(ear, minX, minY, invSize);
    let stop = ear, prev, next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? $e8ea6a63d48a4fea$var$isEarHashed(ear, minX, minY, invSize) : $e8ea6a63d48a4fea$var$isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim | 0);
            triangles.push(ear.i / dim | 0);
            triangles.push(next.i / dim | 0);
            $e8ea6a63d48a4fea$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $e8ea6a63d48a4fea$var$earcutLinked($e8ea6a63d48a4fea$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $e8ea6a63d48a4fea$var$cureLocalIntersections($e8ea6a63d48a4fea$var$filterPoints(ear), triangles, dim);
                $e8ea6a63d48a4fea$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $e8ea6a63d48a4fea$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $e8ea6a63d48a4fea$var$isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($e8ea6a63d48a4fea$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    const x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    let p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $e8ea6a63d48a4fea$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $e8ea6a63d48a4fea$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $e8ea6a63d48a4fea$var$isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($e8ea6a63d48a4fea$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    const x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    // z-order range for the current triangle bbox;
    const minZ = $e8ea6a63d48a4fea$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $e8ea6a63d48a4fea$var$zOrder(x1, y1, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $e8ea6a63d48a4fea$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $e8ea6a63d48a4fea$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $e8ea6a63d48a4fea$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $e8ea6a63d48a4fea$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $e8ea6a63d48a4fea$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $e8ea6a63d48a4fea$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $e8ea6a63d48a4fea$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $e8ea6a63d48a4fea$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $e8ea6a63d48a4fea$var$cureLocalIntersections(start, triangles, dim) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!$e8ea6a63d48a4fea$var$equals(a, b) && $e8ea6a63d48a4fea$var$intersects(a, p, p.next, b) && $e8ea6a63d48a4fea$var$locallyInside(a, b) && $e8ea6a63d48a4fea$var$locallyInside(b, a)) {
            triangles.push(a.i / dim | 0);
            triangles.push(p.i / dim | 0);
            triangles.push(b.i / dim | 0);
            // remove two nodes involved
            $e8ea6a63d48a4fea$var$removeNode(p);
            $e8ea6a63d48a4fea$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $e8ea6a63d48a4fea$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $e8ea6a63d48a4fea$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $e8ea6a63d48a4fea$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = $e8ea6a63d48a4fea$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $e8ea6a63d48a4fea$var$filterPoints(a, a.next);
                c = $e8ea6a63d48a4fea$var$filterPoints(c, c.next);
                // run earcut on each half
                $e8ea6a63d48a4fea$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $e8ea6a63d48a4fea$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $e8ea6a63d48a4fea$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    let i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = $e8ea6a63d48a4fea$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($e8ea6a63d48a4fea$var$getLeftmost(list));
    }
    queue.sort($e8ea6a63d48a4fea$var$compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++)outerNode = $e8ea6a63d48a4fea$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $e8ea6a63d48a4fea$var$compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and link it
function $e8ea6a63d48a4fea$var$eliminateHole(hole, outerNode) {
    const bridge = $e8ea6a63d48a4fea$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    const bridgeReverse = $e8ea6a63d48a4fea$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $e8ea6a63d48a4fea$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $e8ea6a63d48a4fea$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $e8ea6a63d48a4fea$var$findHoleBridge(hole, outerNode) {
    let p = outerNode, qx = -Infinity, m;
    const hx = hole.x, hy = hole.y;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m, mx = m.x, my = m.y;
    let tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $e8ea6a63d48a4fea$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($e8ea6a63d48a4fea$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $e8ea6a63d48a4fea$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $e8ea6a63d48a4fea$var$sectorContainsSector(m, p) {
    return $e8ea6a63d48a4fea$var$area(m.prev, m, p.prev) < 0 && $e8ea6a63d48a4fea$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $e8ea6a63d48a4fea$var$indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === 0) p.z = $e8ea6a63d48a4fea$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $e8ea6a63d48a4fea$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $e8ea6a63d48a4fea$var$sortLinked(list) {
    let i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $e8ea6a63d48a4fea$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $e8ea6a63d48a4fea$var$getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $e8ea6a63d48a4fea$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $e8ea6a63d48a4fea$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$e8ea6a63d48a4fea$var$intersectsPolygon(a, b) && // dones't intersect other edges
    ($e8ea6a63d48a4fea$var$locallyInside(a, b) && $e8ea6a63d48a4fea$var$locallyInside(b, a) && $e8ea6a63d48a4fea$var$middleInside(a, b) && // locally visible
    ($e8ea6a63d48a4fea$var$area(a.prev, a, b.prev) || $e8ea6a63d48a4fea$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $e8ea6a63d48a4fea$var$equals(a, b) && $e8ea6a63d48a4fea$var$area(a.prev, a, a.next) > 0 && $e8ea6a63d48a4fea$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $e8ea6a63d48a4fea$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $e8ea6a63d48a4fea$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $e8ea6a63d48a4fea$var$intersects(p1, q1, p2, q2) {
    const o1 = $e8ea6a63d48a4fea$var$sign($e8ea6a63d48a4fea$var$area(p1, q1, p2));
    const o2 = $e8ea6a63d48a4fea$var$sign($e8ea6a63d48a4fea$var$area(p1, q1, q2));
    const o3 = $e8ea6a63d48a4fea$var$sign($e8ea6a63d48a4fea$var$area(p2, q2, p1));
    const o4 = $e8ea6a63d48a4fea$var$sign($e8ea6a63d48a4fea$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $e8ea6a63d48a4fea$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $e8ea6a63d48a4fea$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $e8ea6a63d48a4fea$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $e8ea6a63d48a4fea$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $e8ea6a63d48a4fea$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $e8ea6a63d48a4fea$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $e8ea6a63d48a4fea$var$intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $e8ea6a63d48a4fea$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $e8ea6a63d48a4fea$var$locallyInside(a, b) {
    return $e8ea6a63d48a4fea$var$area(a.prev, a, a.next) < 0 ? $e8ea6a63d48a4fea$var$area(a, b, a.next) >= 0 && $e8ea6a63d48a4fea$var$area(a, a.prev, b) >= 0 : $e8ea6a63d48a4fea$var$area(a, b, a.prev) < 0 || $e8ea6a63d48a4fea$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $e8ea6a63d48a4fea$var$middleInside(a, b) {
    let p = a, inside = false;
    const px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $e8ea6a63d48a4fea$var$splitPolygon(a, b) {
    const a2 = new $e8ea6a63d48a4fea$var$Node(a.i, a.x, a.y), b2 = new $e8ea6a63d48a4fea$var$Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $e8ea6a63d48a4fea$var$insertNode(i, x, y, last) {
    const p = new $e8ea6a63d48a4fea$var$Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $e8ea6a63d48a4fea$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $e8ea6a63d48a4fea$var$Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;
    // vertex coordinates
    this.x = x;
    this.y = y;
    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;
    // z-order curve value
    this.z = 0;
    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;
    // indicates whether this is a steiner point
    this.steiner = false;
}
function $e8ea6a63d48a4fea$var$signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
class $e8ea6a63d48a4fea$export$96bdf6d9c66d7ba8 {
    // calculate area of the contour polygon
    static area(contour) {
        const n = contour.length;
        let a = 0.0;
        for(let p = n - 1, q = 0; q < n; p = q++)a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
        return a * 0.5;
    }
    static isClockWise(pts) {
        return $e8ea6a63d48a4fea$export$96bdf6d9c66d7ba8.area(pts) < 0;
    }
    static triangulateShape(contour, holes) {
        const vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
        const holeIndices = []; // array of hole indices
        const faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]
        $e8ea6a63d48a4fea$var$removeDupEndPts(contour);
        $e8ea6a63d48a4fea$var$addContour(vertices, contour);
        //
        let holeIndex = contour.length;
        holes.forEach($e8ea6a63d48a4fea$var$removeDupEndPts);
        for(let i = 0; i < holes.length; i++){
            holeIndices.push(holeIndex);
            holeIndex += holes[i].length;
            $e8ea6a63d48a4fea$var$addContour(vertices, holes[i]);
        }
        //
        const triangles = $e8ea6a63d48a4fea$var$Earcut.triangulate(vertices, holeIndices);
        //
        for(let i = 0; i < triangles.length; i += 3)faces.push(triangles.slice(i, i + 3));
        return faces;
    }
}
function $e8ea6a63d48a4fea$var$removeDupEndPts(points) {
    const l = points.length;
    if (l > 2 && points[l - 1].equals(points[0])) points.pop();
}
function $e8ea6a63d48a4fea$var$addContour(vertices, contour) {
    for(let i = 0; i < contour.length; i++){
        vertices.push(contour[i].x);
        vertices.push(contour[i].y);
    }
}
/**
 * Creates extruded geometry from a path shape.
 *
 * parameters = {
 *
 *  curveSegments: <int>, // number of points on the curves
 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
 *  depth: <float>, // Depth to extrude the shape
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into the original shape bevel goes
 *  bevelSize: <float>, // how far from shape outline (including bevelOffset) is bevel
 *  bevelOffset: <float>, // how far from shape outline does bevel start
 *  bevelSegments: <int>, // number of bevel layers
 *
 *  extrudePath: <THREE.Curve> // curve to extrude shape along
 *
 *  UVGenerator: <Object> // object that provides UV generator functions
 *
 * }
 */ class $e8ea6a63d48a4fea$export$598697a1efa63ca7 extends $e8ea6a63d48a4fea$export$b7be63a67df8959 {
    constructor(shapes = new $e8ea6a63d48a4fea$export$6428a7f2611ef1fa([
        new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(0.5, 0.5),
        new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(-0.5, 0.5),
        new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(-0.5, -0.5),
        new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(0.5, -0.5)
    ]), options = {}){
        super();
        this.type = "ExtrudeGeometry";
        this.parameters = {
            shapes: shapes,
            options: options
        };
        shapes = Array.isArray(shapes) ? shapes : [
            shapes
        ];
        const scope = this;
        const verticesArray = [];
        const uvArray = [];
        for(let i = 0, l = shapes.length; i < l; i++){
            const shape = shapes[i];
            addShape(shape);
        }
        // build geometry
        this.setAttribute("position", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(verticesArray, 3));
        this.setAttribute("uv", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(uvArray, 2));
        this.computeVertexNormals();
        // functions
        function addShape(shape) {
            const placeholder = [];
            // options
            const curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
            const steps = options.steps !== undefined ? options.steps : 1;
            const depth = options.depth !== undefined ? options.depth : 1;
            let bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
            let bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 0.2;
            let bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 0.1;
            let bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
            let bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
            const extrudePath = options.extrudePath;
            const uvgen = options.UVGenerator !== undefined ? options.UVGenerator : $e8ea6a63d48a4fea$var$WorldUVGenerator;
            //
            let extrudePts, extrudeByPath = false;
            let splineTube, binormal, normal, position2;
            if (extrudePath) {
                extrudePts = extrudePath.getSpacedPoints(steps);
                extrudeByPath = true;
                bevelEnabled = false; // bevels not supported for path extrusion
                // SETUP TNB variables
                // TODO1 - have a .isClosed in spline?
                splineTube = extrudePath.computeFrenetFrames(steps, false);
                // console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
                binormal = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
                normal = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
                position2 = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
            }
            // Safeguards if bevels are not enabled
            if (!bevelEnabled) {
                bevelSegments = 0;
                bevelThickness = 0;
                bevelSize = 0;
                bevelOffset = 0;
            }
            // Variables initialization
            const shapePoints = shape.extractPoints(curveSegments);
            let vertices = shapePoints.shape;
            const holes = shapePoints.holes;
            const reverse = !$e8ea6a63d48a4fea$export$96bdf6d9c66d7ba8.isClockWise(vertices);
            if (reverse) {
                vertices = vertices.reverse();
                // Maybe we should also check if holes are in the opposite direction, just to be safe ...
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    if ($e8ea6a63d48a4fea$export$96bdf6d9c66d7ba8.isClockWise(ahole)) holes[h] = ahole.reverse();
                }
            }
            const faces = $e8ea6a63d48a4fea$export$96bdf6d9c66d7ba8.triangulateShape(vertices, holes);
            /* Vertices */ const contour = vertices; // vertices has all points but contour has only points of circumference
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                vertices = vertices.concat(ahole);
            }
            function scalePt2(pt, vec, size) {
                if (!vec) console.error("THREE.ExtrudeGeometry: vec does not exist");
                return pt.clone().addScaledVector(vec, size);
            }
            const vlen = vertices.length, flen = faces.length;
            // Find directions for point movement
            function getBevelVec(inPt, inPrev, inNext) {
                // computes for inPt the corresponding point inPt' on a new contour
                //   shifted by 1 unit (length of normalized vector) to the left
                // if we walk along contour clockwise, this new contour is outside the old one
                //
                // inPt' is the intersection of the two lines parallel to the two
                //  adjacent edges of inPt at a distance of 1 unit on the left side.
                let v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
                // good reading for geometry algorithms (here: line-line intersection)
                // http://geomalgorithms.com/a05-_intersect-1.html
                const v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
                const v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
                const v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
                // check for collinear edges
                const collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
                if (Math.abs(collinear0) > Number.EPSILON) {
                    // not collinear
                    // length of vectors for normalizing
                    const v_prev_len = Math.sqrt(v_prev_lensq);
                    const v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
                    // shift adjacent points by unit vectors to the left
                    const ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
                    const ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
                    const ptNextShift_x = inNext.x - v_next_y / v_next_len;
                    const ptNextShift_y = inNext.y + v_next_x / v_next_len;
                    // scaling factor for v_prev to intersection point
                    const sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
                    // vector from inPt to intersection point
                    v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
                    v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
                    // Don't normalize!, otherwise sharp corners become ugly
                    //  but prevent crazy spikes
                    const v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
                    if (v_trans_lensq <= 2) return new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(v_trans_x, v_trans_y);
                    else shrink_by = Math.sqrt(v_trans_lensq / 2);
                } else {
                    // handle special case of collinear edges
                    let direction_eq = false; // assumes: opposite
                    if (v_prev_x > Number.EPSILON) {
                        if (v_next_x > Number.EPSILON) direction_eq = true;
                    } else {
                        if (v_prev_x < -Number.EPSILON) {
                            if (v_next_x < -Number.EPSILON) direction_eq = true;
                        } else if (Math.sign(v_prev_y) === Math.sign(v_next_y)) direction_eq = true;
                    }
                    if (direction_eq) {
                        // console.log("Warning: lines are a straight sequence");
                        v_trans_x = -v_prev_y;
                        v_trans_y = v_prev_x;
                        shrink_by = Math.sqrt(v_prev_lensq);
                    } else {
                        // console.log("Warning: lines are a straight spike");
                        v_trans_x = v_prev_x;
                        v_trans_y = v_prev_y;
                        shrink_by = Math.sqrt(v_prev_lensq / 2);
                    }
                }
                return new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(v_trans_x / shrink_by, v_trans_y / shrink_by);
            }
            const contourMovements = [];
            for(let i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                if (j === il) j = 0;
                if (k === il) k = 0;
                //  (j)---(i)---(k)
                // console.log('i,j,k', i, j , k)
                contourMovements[i] = getBevelVec(contour[i], contour[j], contour[k]);
            }
            const holesMovements = [];
            let oneHoleMovements, verticesMovements = contourMovements.concat();
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                oneHoleMovements = [];
                for(let i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                    if (j === il) j = 0;
                    if (k === il) k = 0;
                    //  (j)---(i)---(k)
                    oneHoleMovements[i] = getBevelVec(ahole[i], ahole[j], ahole[k]);
                }
                holesMovements.push(oneHoleMovements);
                verticesMovements = verticesMovements.concat(oneHoleMovements);
            }
            // Loop bevelSegments, 1 for the front, 1 for the back
            for(let b = 0; b < bevelSegments; b++){
                //for ( b = bevelSegments; b > 0; b -- ) {
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, -z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        v(vert.x, vert.y, -z);
                    }
                }
            }
            const bs = bevelSize + bevelOffset;
            // Back facing vertices
            for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, 0);
                else {
                    // v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
                    normal.copy(splineTube.normals[0]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[0]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add stepped vertices...
            // Including front facing vertices
            for(let s = 1; s <= steps; s++)for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, depth / steps * s);
                else {
                    // v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
                    normal.copy(splineTube.normals[s]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[s]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[s]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add bevel segments planes
            //for ( b = 1; b <= bevelSegments; b ++ ) {
            for(let b = bevelSegments - 1; b >= 0; b--){
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, depth + z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        if (!extrudeByPath) v(vert.x, vert.y, depth + z);
                        else v(vert.x, vert.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z);
                    }
                }
            }
            /* Faces */ // Top and bottom faces
            buildLidFaces();
            // Sides faces
            buildSideFaces();
            /////  Internal functions
            function buildLidFaces() {
                const start = verticesArray.length / 3;
                if (bevelEnabled) {
                    let layer = 0; // steps + 1
                    let offset = vlen * layer;
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2] + offset, face[1] + offset, face[0] + offset);
                    }
                    layer = steps + bevelSegments * 2;
                    offset = vlen * layer;
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + offset, face[1] + offset, face[2] + offset);
                    }
                } else {
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2], face[1], face[0]);
                    }
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + vlen * steps, face[1] + vlen * steps, face[2] + vlen * steps);
                    }
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 0);
            }
            // Create faces for the z-sides of the shape
            function buildSideFaces() {
                const start = verticesArray.length / 3;
                let layeroffset = 0;
                sidewalls(contour, layeroffset);
                layeroffset += contour.length;
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    sidewalls(ahole, layeroffset);
                    //, true
                    layeroffset += ahole.length;
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 1);
            }
            function sidewalls(contour, layeroffset) {
                let i = contour.length;
                while(--i >= 0){
                    const j = i;
                    let k = i - 1;
                    if (k < 0) k = contour.length - 1;
                    //console.log('b', i,j, i-1, k,vertices.length);
                    for(let s = 0, sl = steps + bevelSegments * 2; s < sl; s++){
                        const slen1 = vlen * s;
                        const slen2 = vlen * (s + 1);
                        const a = layeroffset + j + slen1, b = layeroffset + k + slen1, c = layeroffset + k + slen2, d = layeroffset + j + slen2;
                        f4(a, b, c, d);
                    }
                }
            }
            function v(x, y, z) {
                placeholder.push(x);
                placeholder.push(y);
                placeholder.push(z);
            }
            function f3(a, b, c) {
                addVertex(a);
                addVertex(b);
                addVertex(c);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[2]);
            }
            function f4(a, b, c, d) {
                addVertex(a);
                addVertex(b);
                addVertex(d);
                addVertex(b);
                addVertex(c);
                addVertex(d);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[3]);
                addUV(uvs[1]);
                addUV(uvs[2]);
                addUV(uvs[3]);
            }
            function addVertex(index) {
                verticesArray.push(placeholder[index * 3 + 0]);
                verticesArray.push(placeholder[index * 3 + 1]);
                verticesArray.push(placeholder[index * 3 + 2]);
            }
            function addUV(vector2) {
                uvArray.push(vector2.x);
                uvArray.push(vector2.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        const options = this.parameters.options;
        return $e8ea6a63d48a4fea$var$toJSON$1(shapes, options, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        const extrudePath = data.options.extrudePath;
        if (extrudePath !== undefined) data.options.extrudePath = new $e8ea6a63d48a4fea$var$Curves[extrudePath.type]().fromJSON(extrudePath);
        return new $e8ea6a63d48a4fea$export$598697a1efa63ca7(geometryShapes, data.options);
    }
}
const $e8ea6a63d48a4fea$var$WorldUVGenerator = {
    generateTopUV: function(geometry, vertices, indexA, indexB, indexC) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        return [
            new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(a_x, a_y),
            new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(b_x, b_y),
            new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(c_x, c_y)
        ];
    },
    generateSideWallUV: function(geometry, vertices, indexA, indexB, indexC, indexD) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const a_z = vertices[indexA * 3 + 2];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const b_z = vertices[indexB * 3 + 2];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        const c_z = vertices[indexC * 3 + 2];
        const d_x = vertices[indexD * 3];
        const d_y = vertices[indexD * 3 + 1];
        const d_z = vertices[indexD * 3 + 2];
        if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) return [
            new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(a_x, 1 - a_z),
            new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(b_x, 1 - b_z),
            new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(c_x, 1 - c_z),
            new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(d_x, 1 - d_z)
        ];
        else return [
            new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(a_y, 1 - a_z),
            new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(b_y, 1 - b_z),
            new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(c_y, 1 - c_z),
            new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(d_y, 1 - d_z)
        ];
    }
};
function $e8ea6a63d48a4fea$var$toJSON$1(shapes, options, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    data.options = Object.assign({}, options);
    if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();
    return data;
}
class $e8ea6a63d48a4fea$export$9567cc828c9535da extends $e8ea6a63d48a4fea$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const vertices = [
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            0,
            0,
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            t,
            0,
            -1,
            t,
            0,
            1,
            -t,
            0,
            -1,
            -t,
            0,
            1
        ];
        const indices = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = "IcosahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $e8ea6a63d48a4fea$export$9567cc828c9535da(data.radius, data.detail);
    }
}
class $e8ea6a63d48a4fea$export$1954e2b809fe361e extends $e8ea6a63d48a4fea$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1
        ];
        const indices = [
            0,
            2,
            4,
            0,
            4,
            3,
            0,
            3,
            5,
            0,
            5,
            2,
            1,
            2,
            5,
            1,
            5,
            3,
            1,
            3,
            4,
            1,
            4,
            2
        ];
        super(vertices, indices, radius, detail);
        this.type = "OctahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $e8ea6a63d48a4fea$export$1954e2b809fe361e(data.radius, data.detail);
    }
}
class $e8ea6a63d48a4fea$export$68cb731f50f614af extends $e8ea6a63d48a4fea$export$b7be63a67df8959 {
    constructor(innerRadius = 0.5, outerRadius = 1, thetaSegments = 32, phiSegments = 1, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = "RingGeometry";
        this.parameters = {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            thetaSegments: thetaSegments,
            phiSegments: phiSegments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        thetaSegments = Math.max(3, thetaSegments);
        phiSegments = Math.max(1, phiSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // some helper variables
        let radius = innerRadius;
        const radiusStep = (outerRadius - innerRadius) / phiSegments;
        const vertex = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        const uv = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1();
        // generate vertices, normals and uvs
        for(let j = 0; j <= phiSegments; j++){
            for(let i = 0; i <= thetaSegments; i++){
                // values are generate from the inside of the ring to the outside
                const segment = thetaStart + i / thetaSegments * thetaLength;
                // vertex
                vertex.x = radius * Math.cos(segment);
                vertex.y = radius * Math.sin(segment);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, 0, 1);
                // uv
                uv.x = (vertex.x / outerRadius + 1) / 2;
                uv.y = (vertex.y / outerRadius + 1) / 2;
                uvs.push(uv.x, uv.y);
            }
            // increase the radius for next row of vertices
            radius += radiusStep;
        }
        // indices
        for(let j = 0; j < phiSegments; j++){
            const thetaSegmentLevel = j * (thetaSegments + 1);
            for(let i = 0; i < thetaSegments; i++){
                const segment = i + thetaSegmentLevel;
                const a = segment;
                const b = segment + thetaSegments + 1;
                const c = segment + thetaSegments + 2;
                const d = segment + 1;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $e8ea6a63d48a4fea$export$68cb731f50f614af(data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
    }
}
class $e8ea6a63d48a4fea$export$57a29a1c803e9065 extends $e8ea6a63d48a4fea$export$b7be63a67df8959 {
    constructor(shapes = new $e8ea6a63d48a4fea$export$6428a7f2611ef1fa([
        new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(0, 0.5),
        new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(-0.5, -0.5),
        new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(0.5, -0.5)
    ]), curveSegments = 12){
        super();
        this.type = "ShapeGeometry";
        this.parameters = {
            shapes: shapes,
            curveSegments: curveSegments
        };
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let groupStart = 0;
        let groupCount = 0;
        // allow single and array values for "shapes" parameter
        if (Array.isArray(shapes) === false) addShape(shapes);
        else for(let i = 0; i < shapes.length; i++){
            addShape(shapes[i]);
            this.addGroup(groupStart, groupCount, i); // enables MultiMaterial support
            groupStart += groupCount;
            groupCount = 0;
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(uvs, 2));
        // helper functions
        function addShape(shape) {
            const indexOffset = vertices.length / 3;
            const points = shape.extractPoints(curveSegments);
            let shapeVertices = points.shape;
            const shapeHoles = points.holes;
            // check direction of vertices
            if ($e8ea6a63d48a4fea$export$96bdf6d9c66d7ba8.isClockWise(shapeVertices) === false) shapeVertices = shapeVertices.reverse();
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                if ($e8ea6a63d48a4fea$export$96bdf6d9c66d7ba8.isClockWise(shapeHole) === true) shapeHoles[i] = shapeHole.reverse();
            }
            const faces = $e8ea6a63d48a4fea$export$96bdf6d9c66d7ba8.triangulateShape(shapeVertices, shapeHoles);
            // join vertices of inner and outer paths to a single array
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                shapeVertices = shapeVertices.concat(shapeHole);
            }
            // vertices, normals, uvs
            for(let i = 0, l = shapeVertices.length; i < l; i++){
                const vertex = shapeVertices[i];
                vertices.push(vertex.x, vertex.y, 0);
                normals.push(0, 0, 1);
                uvs.push(vertex.x, vertex.y); // world uvs
            }
            // indices
            for(let i = 0, l = faces.length; i < l; i++){
                const face = faces[i];
                const a = face[0] + indexOffset;
                const b = face[1] + indexOffset;
                const c = face[2] + indexOffset;
                indices.push(a, b, c);
                groupCount += 3;
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        return $e8ea6a63d48a4fea$var$toJSON(shapes, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        return new $e8ea6a63d48a4fea$export$57a29a1c803e9065(geometryShapes, data.curveSegments);
    }
}
function $e8ea6a63d48a4fea$var$toJSON(shapes, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    return data;
}
class $e8ea6a63d48a4fea$export$1b417fc3b307a251 extends $e8ea6a63d48a4fea$export$b7be63a67df8959 {
    constructor(radius = 1, widthSegments = 32, heightSegments = 16, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI){
        super();
        this.type = "SphereGeometry";
        this.parameters = {
            radius: radius,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            phiStart: phiStart,
            phiLength: phiLength,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        widthSegments = Math.max(3, Math.floor(widthSegments));
        heightSegments = Math.max(2, Math.floor(heightSegments));
        const thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
        let index = 0;
        const grid = [];
        const vertex = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        const normal = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // generate vertices, normals and uvs
        for(let iy = 0; iy <= heightSegments; iy++){
            const verticesRow = [];
            const v = iy / heightSegments;
            // special case for the poles
            let uOffset = 0;
            if (iy === 0 && thetaStart === 0) uOffset = 0.5 / widthSegments;
            else if (iy === heightSegments && thetaEnd === Math.PI) uOffset = -0.5 / widthSegments;
            for(let ix = 0; ix <= widthSegments; ix++){
                const u = ix / widthSegments;
                // vertex
                vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
                vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.copy(vertex).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, 1 - v);
                verticesRow.push(index++);
            }
            grid.push(verticesRow);
        }
        // indices
        for(let iy = 0; iy < heightSegments; iy++)for(let ix = 0; ix < widthSegments; ix++){
            const a = grid[iy][ix + 1];
            const b = grid[iy][ix];
            const c = grid[iy + 1][ix];
            const d = grid[iy + 1][ix + 1];
            if (iy !== 0 || thetaStart > 0) indices.push(a, b, d);
            if (iy !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $e8ea6a63d48a4fea$export$1b417fc3b307a251(data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
    }
}
class $e8ea6a63d48a4fea$export$fb3f7adc68bd6e02 extends $e8ea6a63d48a4fea$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1
        ];
        const indices = [
            2,
            1,
            0,
            0,
            3,
            2,
            1,
            3,
            0,
            2,
            3,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = "TetrahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $e8ea6a63d48a4fea$export$fb3f7adc68bd6e02(data.radius, data.detail);
    }
}
class $e8ea6a63d48a4fea$export$a2312a2a1fa56495 extends $e8ea6a63d48a4fea$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, radialSegments = 12, tubularSegments = 48, arc = Math.PI * 2){
        super();
        this.type = "TorusGeometry";
        this.parameters = {
            radius: radius,
            tube: tube,
            radialSegments: radialSegments,
            tubularSegments: tubularSegments,
            arc: arc
        };
        radialSegments = Math.floor(radialSegments);
        tubularSegments = Math.floor(tubularSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const center = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        const vertex = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        const normal = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let j = 0; j <= radialSegments; j++)for(let i = 0; i <= tubularSegments; i++){
            const u = i / tubularSegments * arc;
            const v = j / radialSegments * Math.PI * 2;
            // vertex
            vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
            vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
            vertex.z = tube * Math.sin(v);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            center.x = radius * Math.cos(u);
            center.y = radius * Math.sin(u);
            normal.subVectors(vertex, center).normalize();
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(i / tubularSegments);
            uvs.push(j / radialSegments);
        }
        // generate indices
        for(let j = 1; j <= radialSegments; j++)for(let i = 1; i <= tubularSegments; i++){
            // indices
            const a = (tubularSegments + 1) * j + i - 1;
            const b = (tubularSegments + 1) * (j - 1) + i - 1;
            const c = (tubularSegments + 1) * (j - 1) + i;
            const d = (tubularSegments + 1) * j + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $e8ea6a63d48a4fea$export$a2312a2a1fa56495(data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
    }
}
class $e8ea6a63d48a4fea$export$77e9bfadfb9ab8c8 extends $e8ea6a63d48a4fea$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, tubularSegments = 64, radialSegments = 8, p = 2, q = 3){
        super();
        this.type = "TorusKnotGeometry";
        this.parameters = {
            radius: radius,
            tube: tube,
            tubularSegments: tubularSegments,
            radialSegments: radialSegments,
            p: p,
            q: q
        };
        tubularSegments = Math.floor(tubularSegments);
        radialSegments = Math.floor(radialSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        const normal = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        const P1 = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        const P2 = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        const B = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        const T = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        const N = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let i = 0; i <= tubularSegments; ++i){
            // the radian "u" is used to calculate the position on the torus curve of the current tubular segment
            const u = i / tubularSegments * p * Math.PI * 2;
            // now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
            // these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
            calculatePositionOnCurve(u, p, q, radius, P1);
            calculatePositionOnCurve(u + 0.01, p, q, radius, P2);
            // calculate orthonormal basis
            T.subVectors(P2, P1);
            N.addVectors(P2, P1);
            B.crossVectors(T, N);
            N.crossVectors(B, T);
            // normalize B, N. T can be ignored, we don't use it
            B.normalize();
            N.normalize();
            for(let j = 0; j <= radialSegments; ++j){
                // now calculate the vertices. they are nothing more than an extrusion of the torus curve.
                // because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
                const v = j / radialSegments * Math.PI * 2;
                const cx = -tube * Math.cos(v);
                const cy = tube * Math.sin(v);
                // now calculate the final vertex position.
                // first we orient the extrusion with our basis vectors, then we add it to the current position on the curve
                vertex.x = P1.x + (cx * N.x + cy * B.x);
                vertex.y = P1.y + (cx * N.y + cy * B.y);
                vertex.z = P1.z + (cx * N.z + cy * B.z);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
                normal.subVectors(vertex, P1).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(i / tubularSegments);
                uvs.push(j / radialSegments);
            }
        }
        // generate indices
        for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
            // indices
            const a = (radialSegments + 1) * (j - 1) + (i - 1);
            const b = (radialSegments + 1) * j + (i - 1);
            const c = (radialSegments + 1) * j + i;
            const d = (radialSegments + 1) * (j - 1) + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(uvs, 2));
        // this function calculates the current position on the torus curve
        function calculatePositionOnCurve(u, p, q, radius, position) {
            const cu = Math.cos(u);
            const su = Math.sin(u);
            const quOverP = q / p * u;
            const cs = Math.cos(quOverP);
            position.x = radius * (2 + cs) * 0.5 * cu;
            position.y = radius * (2 + cs) * su * 0.5;
            position.z = radius * Math.sin(quOverP) * 0.5;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $e8ea6a63d48a4fea$export$77e9bfadfb9ab8c8(data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
    }
}
class $e8ea6a63d48a4fea$export$7897d9d48904490c extends $e8ea6a63d48a4fea$export$b7be63a67df8959 {
    constructor(path = new $e8ea6a63d48a4fea$export$bf3f4c7e459f90fc(new $e8ea6a63d48a4fea$export$64b5c384219d3699(-1, -1, 0), new $e8ea6a63d48a4fea$export$64b5c384219d3699(-1, 1, 0), new $e8ea6a63d48a4fea$export$64b5c384219d3699(1, 1, 0)), tubularSegments = 64, radius = 1, radialSegments = 8, closed = false){
        super();
        this.type = "TubeGeometry";
        this.parameters = {
            path: path,
            tubularSegments: tubularSegments,
            radius: radius,
            radialSegments: radialSegments,
            closed: closed
        };
        const frames = path.computeFrenetFrames(tubularSegments, closed);
        // expose internals
        this.tangents = frames.tangents;
        this.normals = frames.normals;
        this.binormals = frames.binormals;
        // helper variables
        const vertex = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        const normal = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        const uv = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1();
        let P = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        // buffer
        const vertices = [];
        const normals = [];
        const uvs = [];
        const indices = [];
        // create buffer data
        generateBufferData();
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(uvs, 2));
        // functions
        function generateBufferData() {
            for(let i = 0; i < tubularSegments; i++)generateSegment(i);
            // if the geometry is not closed, generate the last row of vertices and normals
            // at the regular position on the given path
            //
            // if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
            generateSegment(closed === false ? tubularSegments : 0);
            // uvs are generated in a separate function.
            // this makes it easy compute correct values for closed geometries
            generateUVs();
            // finally create faces
            generateIndices();
        }
        function generateSegment(i) {
            // we use getPointAt to sample evenly distributed points from the given path
            P = path.getPointAt(i / tubularSegments, P);
            // retrieve corresponding normal and binormal
            const N = frames.normals[i];
            const B = frames.binormals[i];
            // generate normals and vertices for the current segment
            for(let j = 0; j <= radialSegments; j++){
                const v = j / radialSegments * Math.PI * 2;
                const sin = Math.sin(v);
                const cos = -Math.cos(v);
                // normal
                normal.x = cos * N.x + sin * B.x;
                normal.y = cos * N.y + sin * B.y;
                normal.z = cos * N.z + sin * B.z;
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // vertex
                vertex.x = P.x + radius * normal.x;
                vertex.y = P.y + radius * normal.y;
                vertex.z = P.z + radius * normal.z;
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        }
        function generateIndices() {
            for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
                const a = (radialSegments + 1) * (j - 1) + (i - 1);
                const b = (radialSegments + 1) * j + (i - 1);
                const c = (radialSegments + 1) * j + i;
                const d = (radialSegments + 1) * (j - 1) + i;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        function generateUVs() {
            for(let i = 0; i <= tubularSegments; i++)for(let j = 0; j <= radialSegments; j++){
                uv.x = i / tubularSegments;
                uv.y = j / radialSegments;
                uvs.push(uv.x, uv.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.path = this.parameters.path.toJSON();
        return data;
    }
    static fromJSON(data) {
        // This only works for built-in curves (e.g. CatmullRomCurve3).
        // User defined curves or instances of CurvePath will not be deserialized.
        return new $e8ea6a63d48a4fea$export$7897d9d48904490c(new $e8ea6a63d48a4fea$var$Curves[data.path.type]().fromJSON(data.path), data.tubularSegments, data.radius, data.radialSegments, data.closed);
    }
}
class $e8ea6a63d48a4fea$export$4b739da06d24892b extends $e8ea6a63d48a4fea$export$b7be63a67df8959 {
    constructor(geometry = null){
        super();
        this.type = "WireframeGeometry";
        this.parameters = {
            geometry: geometry
        };
        if (geometry !== null) {
            // buffer
            const vertices = [];
            const edges = new Set();
            // helper variables
            const start = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
            const end = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
            if (geometry.index !== null) {
                // indexed BufferGeometry
                const position = geometry.attributes.position;
                const indices = geometry.index;
                let groups = geometry.groups;
                if (groups.length === 0) groups = [
                    {
                        start: 0,
                        count: indices.count,
                        materialIndex: 0
                    }
                ];
                // create a data structure that contains all edges without duplicates
                for(let o = 0, ol = groups.length; o < ol; ++o){
                    const group = groups[o];
                    const groupStart = group.start;
                    const groupCount = group.count;
                    for(let i = groupStart, l = groupStart + groupCount; i < l; i += 3)for(let j = 0; j < 3; j++){
                        const index1 = indices.getX(i + j);
                        const index2 = indices.getX(i + (j + 1) % 3);
                        start.fromBufferAttribute(position, index1);
                        end.fromBufferAttribute(position, index2);
                        if ($e8ea6a63d48a4fea$var$isUniqueEdge(start, end, edges) === true) {
                            vertices.push(start.x, start.y, start.z);
                            vertices.push(end.x, end.y, end.z);
                        }
                    }
                }
            } else {
                // non-indexed BufferGeometry
                const position = geometry.attributes.position;
                for(let i = 0, l = position.count / 3; i < l; i++)for(let j = 0; j < 3; j++){
                    // three edges per triangle, an edge is represented as (index1, index2)
                    // e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
                    const index1 = 3 * i + j;
                    const index2 = 3 * i + (j + 1) % 3;
                    start.fromBufferAttribute(position, index1);
                    end.fromBufferAttribute(position, index2);
                    if ($e8ea6a63d48a4fea$var$isUniqueEdge(start, end, edges) === true) {
                        vertices.push(start.x, start.y, start.z);
                        vertices.push(end.x, end.y, end.z);
                    }
                }
            }
            // build geometry
            this.setAttribute("position", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
function $e8ea6a63d48a4fea$var$isUniqueEdge(start, end, edges) {
    const hash1 = `${start.x},${start.y},${start.z}-${end.x},${end.y},${end.z}`;
    const hash2 = `${end.x},${end.y},${end.z}-${start.x},${start.y},${start.z}`; // coincident edge
    if (edges.has(hash1) === true || edges.has(hash2) === true) return false;
    else {
        edges.add(hash1);
        edges.add(hash2);
        return true;
    }
}
var $e8ea6a63d48a4fea$var$Geometries = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BoxGeometry: $e8ea6a63d48a4fea$export$33e43285f7406bd5,
    CapsuleGeometry: $e8ea6a63d48a4fea$export$41680e8551036033,
    CircleGeometry: $e8ea6a63d48a4fea$export$d5c0e8d607467193,
    ConeGeometry: $e8ea6a63d48a4fea$export$a7a48974f285c9b3,
    CylinderGeometry: $e8ea6a63d48a4fea$export$68f745719dbe5198,
    DodecahedronGeometry: $e8ea6a63d48a4fea$export$c0babfeb8708fc9c,
    EdgesGeometry: $e8ea6a63d48a4fea$export$4730b1542707547f,
    ExtrudeGeometry: $e8ea6a63d48a4fea$export$598697a1efa63ca7,
    IcosahedronGeometry: $e8ea6a63d48a4fea$export$9567cc828c9535da,
    LatheGeometry: $e8ea6a63d48a4fea$export$6d839803fcd1882c,
    OctahedronGeometry: $e8ea6a63d48a4fea$export$1954e2b809fe361e,
    PlaneGeometry: $e8ea6a63d48a4fea$export$967d831af31f69ce,
    PolyhedronGeometry: $e8ea6a63d48a4fea$export$60e57a7d3f20ff65,
    RingGeometry: $e8ea6a63d48a4fea$export$68cb731f50f614af,
    ShapeGeometry: $e8ea6a63d48a4fea$export$57a29a1c803e9065,
    SphereGeometry: $e8ea6a63d48a4fea$export$1b417fc3b307a251,
    TetrahedronGeometry: $e8ea6a63d48a4fea$export$fb3f7adc68bd6e02,
    TorusGeometry: $e8ea6a63d48a4fea$export$a2312a2a1fa56495,
    TorusKnotGeometry: $e8ea6a63d48a4fea$export$77e9bfadfb9ab8c8,
    TubeGeometry: $e8ea6a63d48a4fea$export$7897d9d48904490c,
    WireframeGeometry: $e8ea6a63d48a4fea$export$4b739da06d24892b
});
class $e8ea6a63d48a4fea$export$e8564da406055a3 extends $e8ea6a63d48a4fea$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isShadowMaterial = true;
        this.type = "ShadowMaterial";
        this.color = new $e8ea6a63d48a4fea$export$892596cec99bc70e(0x000000);
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.fog = source.fog;
        return this;
    }
}
class $e8ea6a63d48a4fea$export$21c421a2e1df9d22 extends $e8ea6a63d48a4fea$export$83c7d75d550a8b0d {
    constructor(parameters){
        super(parameters);
        this.isRawShaderMaterial = true;
        this.type = "RawShaderMaterial";
    }
}
class $e8ea6a63d48a4fea$export$f2980790215acccd extends $e8ea6a63d48a4fea$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshStandardMaterial = true;
        this.defines = {
            "STANDARD": ""
        };
        this.type = "MeshStandardMaterial";
        this.color = new $e8ea6a63d48a4fea$export$892596cec99bc70e(0xffffff); // diffuse
        this.roughness = 1.0;
        this.metalness = 0.0;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $e8ea6a63d48a4fea$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $e8ea6a63d48a4fea$export$2852a58ebdac27b8;
        this.normalScale = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.roughnessMap = null;
        this.metalnessMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapIntensity = 1.0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            "STANDARD": ""
        };
        this.color.copy(source.color);
        this.roughness = source.roughness;
        this.metalness = source.metalness;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.roughnessMap = source.roughnessMap;
        this.metalnessMap = source.metalnessMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapIntensity = source.envMapIntensity;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $e8ea6a63d48a4fea$export$28d04986c4269c9f extends $e8ea6a63d48a4fea$export$f2980790215acccd {
    constructor(parameters){
        super();
        this.isMeshPhysicalMaterial = true;
        this.defines = {
            "STANDARD": "",
            "PHYSICAL": ""
        };
        this.type = "MeshPhysicalMaterial";
        this.clearcoatMap = null;
        this.clearcoatRoughness = 0.0;
        this.clearcoatRoughnessMap = null;
        this.clearcoatNormalScale = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(1, 1);
        this.clearcoatNormalMap = null;
        this.ior = 1.5;
        Object.defineProperty(this, "reflectivity", {
            get: function() {
                return $e8ea6a63d48a4fea$var$clamp(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
            },
            set: function(reflectivity) {
                this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
            }
        });
        this.iridescenceMap = null;
        this.iridescenceIOR = 1.3;
        this.iridescenceThicknessRange = [
            100,
            400
        ];
        this.iridescenceThicknessMap = null;
        this.sheenColor = new $e8ea6a63d48a4fea$export$892596cec99bc70e(0x000000);
        this.sheenColorMap = null;
        this.sheenRoughness = 1.0;
        this.sheenRoughnessMap = null;
        this.transmissionMap = null;
        this.thickness = 0;
        this.thicknessMap = null;
        this.attenuationDistance = Infinity;
        this.attenuationColor = new $e8ea6a63d48a4fea$export$892596cec99bc70e(1, 1, 1);
        this.specularIntensity = 1.0;
        this.specularIntensityMap = null;
        this.specularColor = new $e8ea6a63d48a4fea$export$892596cec99bc70e(1, 1, 1);
        this.specularColorMap = null;
        this._sheen = 0.0;
        this._clearcoat = 0;
        this._iridescence = 0;
        this._transmission = 0;
        this.setValues(parameters);
    }
    get sheen() {
        return this._sheen;
    }
    set sheen(value) {
        if (this._sheen > 0 !== value > 0) this.version++;
        this._sheen = value;
    }
    get clearcoat() {
        return this._clearcoat;
    }
    set clearcoat(value) {
        if (this._clearcoat > 0 !== value > 0) this.version++;
        this._clearcoat = value;
    }
    get iridescence() {
        return this._iridescence;
    }
    set iridescence(value) {
        if (this._iridescence > 0 !== value > 0) this.version++;
        this._iridescence = value;
    }
    get transmission() {
        return this._transmission;
    }
    set transmission(value) {
        if (this._transmission > 0 !== value > 0) this.version++;
        this._transmission = value;
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            "STANDARD": "",
            "PHYSICAL": ""
        };
        this.clearcoat = source.clearcoat;
        this.clearcoatMap = source.clearcoatMap;
        this.clearcoatRoughness = source.clearcoatRoughness;
        this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
        this.clearcoatNormalMap = source.clearcoatNormalMap;
        this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
        this.ior = source.ior;
        this.iridescence = source.iridescence;
        this.iridescenceMap = source.iridescenceMap;
        this.iridescenceIOR = source.iridescenceIOR;
        this.iridescenceThicknessRange = [
            ...source.iridescenceThicknessRange
        ];
        this.iridescenceThicknessMap = source.iridescenceThicknessMap;
        this.sheen = source.sheen;
        this.sheenColor.copy(source.sheenColor);
        this.sheenColorMap = source.sheenColorMap;
        this.sheenRoughness = source.sheenRoughness;
        this.sheenRoughnessMap = source.sheenRoughnessMap;
        this.transmission = source.transmission;
        this.transmissionMap = source.transmissionMap;
        this.thickness = source.thickness;
        this.thicknessMap = source.thicknessMap;
        this.attenuationDistance = source.attenuationDistance;
        this.attenuationColor.copy(source.attenuationColor);
        this.specularIntensity = source.specularIntensity;
        this.specularIntensityMap = source.specularIntensityMap;
        this.specularColor.copy(source.specularColor);
        this.specularColorMap = source.specularColorMap;
        return this;
    }
}
class $e8ea6a63d48a4fea$export$24c72f71cbaf0678 extends $e8ea6a63d48a4fea$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshPhongMaterial = true;
        this.type = "MeshPhongMaterial";
        this.color = new $e8ea6a63d48a4fea$export$892596cec99bc70e(0xffffff); // diffuse
        this.specular = new $e8ea6a63d48a4fea$export$892596cec99bc70e(0x111111);
        this.shininess = 30;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $e8ea6a63d48a4fea$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $e8ea6a63d48a4fea$export$2852a58ebdac27b8;
        this.normalScale = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $e8ea6a63d48a4fea$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.specular.copy(source.specular);
        this.shininess = source.shininess;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $e8ea6a63d48a4fea$export$df893cf97e765622 extends $e8ea6a63d48a4fea$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshToonMaterial = true;
        this.defines = {
            "TOON": ""
        };
        this.type = "MeshToonMaterial";
        this.color = new $e8ea6a63d48a4fea$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.gradientMap = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $e8ea6a63d48a4fea$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $e8ea6a63d48a4fea$export$2852a58ebdac27b8;
        this.normalScale = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.gradientMap = source.gradientMap;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
class $e8ea6a63d48a4fea$export$bfe8c0a091f41ae7 extends $e8ea6a63d48a4fea$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshNormalMaterial = true;
        this.type = "MeshNormalMaterial";
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $e8ea6a63d48a4fea$export$2852a58ebdac27b8;
        this.normalScale = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.flatShading = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.flatShading = source.flatShading;
        return this;
    }
}
class $e8ea6a63d48a4fea$export$5023a9a8114806b8 extends $e8ea6a63d48a4fea$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshLambertMaterial = true;
        this.type = "MeshLambertMaterial";
        this.color = new $e8ea6a63d48a4fea$export$892596cec99bc70e(0xffffff); // diffuse
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $e8ea6a63d48a4fea$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $e8ea6a63d48a4fea$export$2852a58ebdac27b8;
        this.normalScale = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $e8ea6a63d48a4fea$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $e8ea6a63d48a4fea$export$6f5fef6235ec12ee extends $e8ea6a63d48a4fea$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshMatcapMaterial = true;
        this.defines = {
            "MATCAP": ""
        };
        this.type = "MeshMatcapMaterial";
        this.color = new $e8ea6a63d48a4fea$export$892596cec99bc70e(0xffffff); // diffuse
        this.matcap = null;
        this.map = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $e8ea6a63d48a4fea$export$2852a58ebdac27b8;
        this.normalScale = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            "MATCAP": ""
        };
        this.color.copy(source.color);
        this.matcap = source.matcap;
        this.map = source.map;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $e8ea6a63d48a4fea$export$327886a3efaeaebe extends $e8ea6a63d48a4fea$export$fbaaa33907730a0c {
    constructor(parameters){
        super();
        this.isLineDashedMaterial = true;
        this.type = "LineDashedMaterial";
        this.scale = 1;
        this.dashSize = 3;
        this.gapSize = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.scale = source.scale;
        this.dashSize = source.dashSize;
        this.gapSize = source.gapSize;
        return this;
    }
}
// same as Array.prototype.slice, but also works on typed arrays
function $e8ea6a63d48a4fea$var$arraySlice(array, from, to) {
    if ($e8ea6a63d48a4fea$var$isTypedArray(array)) // in ios9 array.subarray(from, undefined) will return empty array
    // but array.subarray(from) or array.subarray(from, len) is correct
    return new array.constructor(array.subarray(from, to !== undefined ? to : array.length));
    return array.slice(from, to);
}
// converts an array to a specific type
function $e8ea6a63d48a4fea$var$convertArray(array, type, forceClone) {
    if (!array || // let 'undefined' and 'null' pass
    !forceClone && array.constructor === type) return array;
    if (typeof type.BYTES_PER_ELEMENT === "number") return new type(array); // create typed array
    return Array.prototype.slice.call(array); // create Array
}
function $e8ea6a63d48a4fea$var$isTypedArray(object) {
    return ArrayBuffer.isView(object) && !(object instanceof DataView);
}
// returns an array by which times and values can be sorted
function $e8ea6a63d48a4fea$var$getKeyframeOrder(times) {
    function compareTime(i, j) {
        return times[i] - times[j];
    }
    const n = times.length;
    const result = new Array(n);
    for(let i = 0; i !== n; ++i)result[i] = i;
    result.sort(compareTime);
    return result;
}
// uses the array previously returned by 'getKeyframeOrder' to sort data
function $e8ea6a63d48a4fea$var$sortedArray(values, stride, order) {
    const nValues = values.length;
    const result = new values.constructor(nValues);
    for(let i = 0, dstOffset = 0; dstOffset !== nValues; ++i){
        const srcOffset = order[i] * stride;
        for(let j = 0; j !== stride; ++j)result[dstOffset++] = values[srcOffset + j];
    }
    return result;
}
// function for parsing AOS keyframe formats
function $e8ea6a63d48a4fea$var$flattenJSON(jsonKeys, times, values, valuePropertyName) {
    let i = 1, key = jsonKeys[0];
    while(key !== undefined && key[valuePropertyName] === undefined)key = jsonKeys[i++];
    if (key === undefined) return; // no data
    let value = key[valuePropertyName];
    if (value === undefined) return; // no data
    if (Array.isArray(value)) do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push.apply(values, value); // push all elements
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else if (value.toArray !== undefined) // ...assume THREE.Math-ish
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            value.toArray(values, values.length);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else // otherwise push as-is
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push(value);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
}
function $e8ea6a63d48a4fea$var$subclip(sourceClip, name, startFrame, endFrame, fps = 30) {
    const clip = sourceClip.clone();
    clip.name = name;
    const tracks = [];
    for(let i = 0; i < clip.tracks.length; ++i){
        const track = clip.tracks[i];
        const valueSize = track.getValueSize();
        const times = [];
        const values = [];
        for(let j = 0; j < track.times.length; ++j){
            const frame = track.times[j] * fps;
            if (frame < startFrame || frame >= endFrame) continue;
            times.push(track.times[j]);
            for(let k = 0; k < valueSize; ++k)values.push(track.values[j * valueSize + k]);
        }
        if (times.length === 0) continue;
        track.times = $e8ea6a63d48a4fea$var$convertArray(times, track.times.constructor);
        track.values = $e8ea6a63d48a4fea$var$convertArray(values, track.values.constructor);
        tracks.push(track);
    }
    clip.tracks = tracks;
    // find minimum .times value across all tracks in the trimmed clip
    let minStartTime = Infinity;
    for(let i = 0; i < clip.tracks.length; ++i)if (minStartTime > clip.tracks[i].times[0]) minStartTime = clip.tracks[i].times[0];
    // shift all tracks such that clip begins at t=0
    for(let i = 0; i < clip.tracks.length; ++i)clip.tracks[i].shift(-1 * minStartTime);
    clip.resetDuration();
    return clip;
}
function $e8ea6a63d48a4fea$var$makeClipAdditive(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
    if (fps <= 0) fps = 30;
    const numTracks = referenceClip.tracks.length;
    const referenceTime = referenceFrame / fps;
    // Make each track's values relative to the values at the reference frame
    for(let i = 0; i < numTracks; ++i){
        const referenceTrack = referenceClip.tracks[i];
        const referenceTrackType = referenceTrack.ValueTypeName;
        // Skip this track if it's non-numeric
        if (referenceTrackType === "bool" || referenceTrackType === "string") continue;
        // Find the track in the target clip whose name and type matches the reference track
        const targetTrack = targetClip.tracks.find(function(track) {
            return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
        });
        if (targetTrack === undefined) continue;
        let referenceOffset = 0;
        const referenceValueSize = referenceTrack.getValueSize();
        if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) referenceOffset = referenceValueSize / 3;
        let targetOffset = 0;
        const targetValueSize = targetTrack.getValueSize();
        if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) targetOffset = targetValueSize / 3;
        const lastIndex = referenceTrack.times.length - 1;
        let referenceValue;
        // Find the value to subtract out of the track
        if (referenceTime <= referenceTrack.times[0]) {
            // Reference frame is earlier than the first keyframe, so just use the first keyframe
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            referenceValue = $e8ea6a63d48a4fea$var$arraySlice(referenceTrack.values, startIndex, endIndex);
        } else if (referenceTime >= referenceTrack.times[lastIndex]) {
            // Reference frame is after the last keyframe, so just use the last keyframe
            const startIndex = lastIndex * referenceValueSize + referenceOffset;
            const endIndex = startIndex + referenceValueSize - referenceOffset;
            referenceValue = $e8ea6a63d48a4fea$var$arraySlice(referenceTrack.values, startIndex, endIndex);
        } else {
            // Interpolate to the reference value
            const interpolant = referenceTrack.createInterpolant();
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            interpolant.evaluate(referenceTime);
            referenceValue = $e8ea6a63d48a4fea$var$arraySlice(interpolant.resultBuffer, startIndex, endIndex);
        }
        // Conjugate the quaternion
        if (referenceTrackType === "quaternion") {
            const referenceQuat = new $e8ea6a63d48a4fea$export$23d6a54f0bbc85a3().fromArray(referenceValue).normalize().conjugate();
            referenceQuat.toArray(referenceValue);
        }
        // Subtract the reference value from all of the track values
        const numTimes = targetTrack.times.length;
        for(let j = 0; j < numTimes; ++j){
            const valueStart = j * targetValueSize + targetOffset;
            if (referenceTrackType === "quaternion") // Multiply the conjugate for quaternion track types
            $e8ea6a63d48a4fea$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(targetTrack.values, valueStart, referenceValue, 0, targetTrack.values, valueStart);
            else {
                const valueEnd = targetValueSize - targetOffset * 2;
                // Subtract each value for all other numeric track types
                for(let k = 0; k < valueEnd; ++k)targetTrack.values[valueStart + k] -= referenceValue[k];
            }
        }
    }
    targetClip.blendMode = $e8ea6a63d48a4fea$export$d875e029ef558d3;
    return targetClip;
}
const $e8ea6a63d48a4fea$export$7ee8caa573e71ad1 = {
    arraySlice: $e8ea6a63d48a4fea$var$arraySlice,
    convertArray: $e8ea6a63d48a4fea$var$convertArray,
    isTypedArray: $e8ea6a63d48a4fea$var$isTypedArray,
    getKeyframeOrder: $e8ea6a63d48a4fea$var$getKeyframeOrder,
    sortedArray: $e8ea6a63d48a4fea$var$sortedArray,
    flattenJSON: $e8ea6a63d48a4fea$var$flattenJSON,
    subclip: $e8ea6a63d48a4fea$var$subclip,
    makeClipAdditive: $e8ea6a63d48a4fea$var$makeClipAdditive
};
/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References:
 *
 * 		http://www.oodesign.com/template-method-pattern.html
 *
 */ class $e8ea6a63d48a4fea$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        this.parameterPositions = parameterPositions;
        this._cachedIndex = 0;
        this.resultBuffer = resultBuffer !== undefined ? resultBuffer : new sampleValues.constructor(sampleSize);
        this.sampleValues = sampleValues;
        this.valueSize = sampleSize;
        this.settings = null;
        this.DefaultSettings_ = {};
    }
    evaluate(t) {
        const pp = this.parameterPositions;
        let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
        validate_interval: {
            seek: {
                let right;
                linear_scan: {
                    //- See http://jsperf.com/comparison-to-undefined/3
                    //- slower code:
                    //-
                    //- 				if ( t >= t1 || t1 === undefined ) {
                    forward_scan: if (!(t < t1)) {
                        for(let giveUpAt = i1 + 2;;){
                            if (t1 === undefined) {
                                if (t < t0) break forward_scan;
                                // after end
                                i1 = pp.length;
                                this._cachedIndex = i1;
                                return this.copySampleValue_(i1 - 1);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t0 = t1;
                            t1 = pp[++i1];
                            if (t < t1) break seek;
                        }
                        // prepare binary search on the right side of the index
                        right = pp.length;
                        break linear_scan;
                    }
                    //- slower code:
                    //-					if ( t < t0 || t0 === undefined ) {
                    if (!(t >= t0)) {
                        // looping?
                        const t1global = pp[1];
                        if (t < t1global) {
                            i1 = 2; // + 1, using the scan for the details
                            t0 = t1global;
                        }
                        // linear reverse scan
                        for(let giveUpAt = i1 - 2;;){
                            if (t0 === undefined) {
                                // before start
                                this._cachedIndex = 0;
                                return this.copySampleValue_(0);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t1 = t0;
                            t0 = pp[--i1 - 1];
                            if (t >= t0) break seek;
                        }
                        // prepare binary search on the left side of the index
                        right = i1;
                        i1 = 0;
                        break linear_scan;
                    }
                    break validate_interval;
                } // linear scan
                // binary search
                while(i1 < right){
                    const mid = i1 + right >>> 1;
                    if (t < pp[mid]) right = mid;
                    else i1 = mid + 1;
                }
                t1 = pp[i1];
                t0 = pp[i1 - 1];
                // check boundary cases, again
                if (t0 === undefined) {
                    this._cachedIndex = 0;
                    return this.copySampleValue_(0);
                }
                if (t1 === undefined) {
                    i1 = pp.length;
                    this._cachedIndex = i1;
                    return this.copySampleValue_(i1 - 1);
                }
            } // seek
            this._cachedIndex = i1;
            this.intervalChanged_(i1, t0, t1);
        } // validate_interval
        return this.interpolate_(i1, t0, t, t1);
    }
    getSettings_() {
        return this.settings || this.DefaultSettings_;
    }
    copySampleValue_(index) {
        // copies a sample value to the result buffer
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset + i];
        return result;
    }
    // Template methods for derived classes:
    interpolate_() {
        throw new Error("call to abstract method");
    // implementations shall return this.resultBuffer
    }
    intervalChanged_() {
    // empty
    }
}
/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 */ class $e8ea6a63d48a4fea$export$3646682e7a3959 extends $e8ea6a63d48a4fea$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
        this._weightPrev = -0;
        this._offsetPrev = -0;
        this._weightNext = -0;
        this._offsetNext = -0;
        this.DefaultSettings_ = {
            endingStart: $e8ea6a63d48a4fea$export$7f795934b84ab523,
            endingEnd: $e8ea6a63d48a4fea$export$7f795934b84ab523
        };
    }
    intervalChanged_(i1, t0, t1) {
        const pp = this.parameterPositions;
        let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
        if (tPrev === undefined) switch(this.getSettings_().endingStart){
            case $e8ea6a63d48a4fea$export$24a4ccb5099273b5:
                // f'(t0) = 0
                iPrev = i1;
                tPrev = 2 * t0 - t1;
                break;
            case $e8ea6a63d48a4fea$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iPrev = pp.length - 2;
                tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
                break;
            default:
                // f''(t0) = 0 a.k.a. Natural Spline
                iPrev = i1;
                tPrev = t1;
        }
        if (tNext === undefined) switch(this.getSettings_().endingEnd){
            case $e8ea6a63d48a4fea$export$24a4ccb5099273b5:
                // f'(tN) = 0
                iNext = i1;
                tNext = 2 * t1 - t0;
                break;
            case $e8ea6a63d48a4fea$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iNext = 1;
                tNext = t1 + pp[1] - pp[0];
                break;
            default:
                // f''(tN) = 0, a.k.a. Natural Spline
                iNext = i1 - 1;
                tNext = t0;
        }
        const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
        this._weightPrev = halfDt / (t0 - tPrev);
        this._weightNext = halfDt / (tNext - t1);
        this._offsetPrev = iPrev * stride;
        this._offsetNext = iNext * stride;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p = (t - t0) / (t1 - t0), pp = p * p, ppp = pp * p;
        // evaluate polynomials
        const sP = -wP * ppp + 2 * wP * pp - wP * p;
        const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
        const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
        const sN = wN * ppp - wN * pp;
        // combine data linearly
        for(let i = 0; i !== stride; ++i)result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
        return result;
    }
}
class $e8ea6a63d48a4fea$export$a8e6009059f51e1a extends $e8ea6a63d48a4fea$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t - t0) / (t1 - t0), weight0 = 1 - weight1;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
        return result;
    }
}
/**
 *
 * Interpolant that evaluates to the sample value at the position preceding
 * the parameter.
 */ class $e8ea6a63d48a4fea$export$fb9758ef7ef8d5cc extends $e8ea6a63d48a4fea$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1 /*, t0, t, t1 */ ) {
        return this.copySampleValue_(i1 - 1);
    }
}
class $e8ea6a63d48a4fea$export$b0e479f45b7006d6 {
    constructor(name, times, values, interpolation){
        if (name === undefined) throw new Error("THREE.KeyframeTrack: track name is undefined");
        if (times === undefined || times.length === 0) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + name);
        this.name = name;
        this.times = $e8ea6a63d48a4fea$var$convertArray(times, this.TimeBufferType);
        this.values = $e8ea6a63d48a4fea$var$convertArray(values, this.ValueBufferType);
        this.setInterpolation(interpolation || this.DefaultInterpolation);
    }
    // Serialization (in static context, because of constructor invocation
    // and automatic invocation of .toJSON):
    static toJSON(track) {
        const trackType = track.constructor;
        let json;
        // derived classes can define a static toJSON method
        if (trackType.toJSON !== this.toJSON) json = trackType.toJSON(track);
        else {
            // by default, we assume the data can be serialized as-is
            json = {
                "name": track.name,
                "times": $e8ea6a63d48a4fea$var$convertArray(track.times, Array),
                "values": $e8ea6a63d48a4fea$var$convertArray(track.values, Array)
            };
            const interpolation = track.getInterpolation();
            if (interpolation !== track.DefaultInterpolation) json.interpolation = interpolation;
        }
        json.type = track.ValueTypeName; // mandatory
        return json;
    }
    InterpolantFactoryMethodDiscrete(result) {
        return new $e8ea6a63d48a4fea$export$fb9758ef7ef8d5cc(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodLinear(result) {
        return new $e8ea6a63d48a4fea$export$a8e6009059f51e1a(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodSmooth(result) {
        return new $e8ea6a63d48a4fea$export$3646682e7a3959(this.times, this.values, this.getValueSize(), result);
    }
    setInterpolation(interpolation) {
        let factoryMethod;
        switch(interpolation){
            case $e8ea6a63d48a4fea$export$995b32462a65e855:
                factoryMethod = this.InterpolantFactoryMethodDiscrete;
                break;
            case $e8ea6a63d48a4fea$export$30fac1aace31cf4d:
                factoryMethod = this.InterpolantFactoryMethodLinear;
                break;
            case $e8ea6a63d48a4fea$export$198b11ff4c72bb30:
                factoryMethod = this.InterpolantFactoryMethodSmooth;
                break;
        }
        if (factoryMethod === undefined) {
            const message = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
            if (this.createInterpolant === undefined) {
                // fall back to default, unless the default itself is messed up
                if (interpolation !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                else throw new Error(message); // fatal, in this case
            }
            console.warn("THREE.KeyframeTrack:", message);
            return this;
        }
        this.createInterpolant = factoryMethod;
        return this;
    }
    getInterpolation() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return $e8ea6a63d48a4fea$export$995b32462a65e855;
            case this.InterpolantFactoryMethodLinear:
                return $e8ea6a63d48a4fea$export$30fac1aace31cf4d;
            case this.InterpolantFactoryMethodSmooth:
                return $e8ea6a63d48a4fea$export$198b11ff4c72bb30;
        }
    }
    getValueSize() {
        return this.values.length / this.times.length;
    }
    // move all keyframes either forwards or backwards in time
    shift(timeOffset) {
        if (timeOffset !== 0.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] += timeOffset;
        }
        return this;
    }
    // scale all keyframe times by a factor (useful for frame <-> seconds conversions)
    scale(timeScale) {
        if (timeScale !== 1.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] *= timeScale;
        }
        return this;
    }
    // removes keyframes before and after animation without changing any values within the range [startTime, endTime].
    // IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
    trim(startTime, endTime) {
        const times = this.times, nKeys = times.length;
        let from = 0, to = nKeys - 1;
        while(from !== nKeys && times[from] < startTime)++from;
        while(to !== -1 && times[to] > endTime)--to;
        ++to; // inclusive -> exclusive bound
        if (from !== 0 || to !== nKeys) {
            // empty tracks are forbidden, so keep at least one keyframe
            if (from >= to) {
                to = Math.max(to, 1);
                from = to - 1;
            }
            const stride = this.getValueSize();
            this.times = $e8ea6a63d48a4fea$var$arraySlice(times, from, to);
            this.values = $e8ea6a63d48a4fea$var$arraySlice(this.values, from * stride, to * stride);
        }
        return this;
    }
    // ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
    validate() {
        let valid = true;
        const valueSize = this.getValueSize();
        if (valueSize - Math.floor(valueSize) !== 0) {
            console.error("THREE.KeyframeTrack: Invalid value size in track.", this);
            valid = false;
        }
        const times = this.times, values = this.values, nKeys = times.length;
        if (nKeys === 0) {
            console.error("THREE.KeyframeTrack: Track is empty.", this);
            valid = false;
        }
        let prevTime = null;
        for(let i = 0; i !== nKeys; i++){
            const currTime = times[i];
            if (typeof currTime === "number" && isNaN(currTime)) {
                console.error("THREE.KeyframeTrack: Time is not a valid number.", this, i, currTime);
                valid = false;
                break;
            }
            if (prevTime !== null && prevTime > currTime) {
                console.error("THREE.KeyframeTrack: Out of order keys.", this, i, currTime, prevTime);
                valid = false;
                break;
            }
            prevTime = currTime;
        }
        if (values !== undefined) {
            if ($e8ea6a63d48a4fea$var$isTypedArray(values)) for(let i = 0, n = values.length; i !== n; ++i){
                const value = values[i];
                if (isNaN(value)) {
                    console.error("THREE.KeyframeTrack: Value is not a valid number.", this, i, value);
                    valid = false;
                    break;
                }
            }
        }
        return valid;
    }
    // removes equivalent sequential keys as common in morph target sequences
    // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
    optimize() {
        // times or values may be shared with other tracks, so overwriting is unsafe
        const times = $e8ea6a63d48a4fea$var$arraySlice(this.times), values = $e8ea6a63d48a4fea$var$arraySlice(this.values), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === $e8ea6a63d48a4fea$export$198b11ff4c72bb30, lastIndex = times.length - 1;
        let writeIndex = 1;
        for(let i = 1; i < lastIndex; ++i){
            let keep = false;
            const time = times[i];
            const timeNext = times[i + 1];
            // remove adjacent keyframes scheduled at the same time
            if (time !== timeNext && (i !== 1 || time !== times[0])) {
                if (!smoothInterpolation) {
                    // remove unnecessary keyframes same as their neighbors
                    const offset = i * stride, offsetP = offset - stride, offsetN = offset + stride;
                    for(let j = 0; j !== stride; ++j){
                        const value = values[offset + j];
                        if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
                            keep = true;
                            break;
                        }
                    }
                } else keep = true;
            }
            // in-place compaction
            if (keep) {
                if (i !== writeIndex) {
                    times[writeIndex] = times[i];
                    const readOffset = i * stride, writeOffset = writeIndex * stride;
                    for(let j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
                }
                ++writeIndex;
            }
        }
        // flush last keyframe (compaction looks ahead)
        if (lastIndex > 0) {
            times[writeIndex] = times[lastIndex];
            for(let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
            ++writeIndex;
        }
        if (writeIndex !== times.length) {
            this.times = $e8ea6a63d48a4fea$var$arraySlice(times, 0, writeIndex);
            this.values = $e8ea6a63d48a4fea$var$arraySlice(values, 0, writeIndex * stride);
        } else {
            this.times = times;
            this.values = values;
        }
        return this;
    }
    clone() {
        const times = $e8ea6a63d48a4fea$var$arraySlice(this.times, 0);
        const values = $e8ea6a63d48a4fea$var$arraySlice(this.values, 0);
        const TypedKeyframeTrack = this.constructor;
        const track = new TypedKeyframeTrack(this.name, times, values);
        // Interpolant argument to constructor is not saved, so copy the factory method directly.
        track.createInterpolant = this.createInterpolant;
        return track;
    }
}
$e8ea6a63d48a4fea$export$b0e479f45b7006d6.prototype.TimeBufferType = Float32Array;
$e8ea6a63d48a4fea$export$b0e479f45b7006d6.prototype.ValueBufferType = Float32Array;
$e8ea6a63d48a4fea$export$b0e479f45b7006d6.prototype.DefaultInterpolation = $e8ea6a63d48a4fea$export$30fac1aace31cf4d;
/**
 * A Track of Boolean keyframe values.
 */ class $e8ea6a63d48a4fea$export$d3a344b98cf0b775 extends $e8ea6a63d48a4fea$export$b0e479f45b7006d6 {
}
$e8ea6a63d48a4fea$export$d3a344b98cf0b775.prototype.ValueTypeName = "bool";
$e8ea6a63d48a4fea$export$d3a344b98cf0b775.prototype.ValueBufferType = Array;
$e8ea6a63d48a4fea$export$d3a344b98cf0b775.prototype.DefaultInterpolation = $e8ea6a63d48a4fea$export$995b32462a65e855;
$e8ea6a63d48a4fea$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodLinear = undefined;
$e8ea6a63d48a4fea$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of keyframe values that represent color.
 */ class $e8ea6a63d48a4fea$export$83444c5d885347d8 extends $e8ea6a63d48a4fea$export$b0e479f45b7006d6 {
}
$e8ea6a63d48a4fea$export$83444c5d885347d8.prototype.ValueTypeName = "color";
/**
 * A Track of numeric keyframe values.
 */ class $e8ea6a63d48a4fea$export$d45f0d1a4d9a9314 extends $e8ea6a63d48a4fea$export$b0e479f45b7006d6 {
}
$e8ea6a63d48a4fea$export$d45f0d1a4d9a9314.prototype.ValueTypeName = "number";
/**
 * Spherical linear unit quaternion interpolant.
 */ class $e8ea6a63d48a4fea$export$2db1cfb7923d931e extends $e8ea6a63d48a4fea$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t - t0) / (t1 - t0);
        let offset = i1 * stride;
        for(let end = offset + stride; offset !== end; offset += 4)$e8ea6a63d48a4fea$export$23d6a54f0bbc85a3.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
        return result;
    }
}
/**
 * A Track of quaternion keyframe values.
 */ class $e8ea6a63d48a4fea$export$b8043f12b5aafbd7 extends $e8ea6a63d48a4fea$export$b0e479f45b7006d6 {
    InterpolantFactoryMethodLinear(result) {
        return new $e8ea6a63d48a4fea$export$2db1cfb7923d931e(this.times, this.values, this.getValueSize(), result);
    }
}
$e8ea6a63d48a4fea$export$b8043f12b5aafbd7.prototype.ValueTypeName = "quaternion";
// ValueBufferType is inherited
$e8ea6a63d48a4fea$export$b8043f12b5aafbd7.prototype.DefaultInterpolation = $e8ea6a63d48a4fea$export$30fac1aace31cf4d;
$e8ea6a63d48a4fea$export$b8043f12b5aafbd7.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track that interpolates Strings
 */ class $e8ea6a63d48a4fea$export$6ce41d4f3a8df9cd extends $e8ea6a63d48a4fea$export$b0e479f45b7006d6 {
}
$e8ea6a63d48a4fea$export$6ce41d4f3a8df9cd.prototype.ValueTypeName = "string";
$e8ea6a63d48a4fea$export$6ce41d4f3a8df9cd.prototype.ValueBufferType = Array;
$e8ea6a63d48a4fea$export$6ce41d4f3a8df9cd.prototype.DefaultInterpolation = $e8ea6a63d48a4fea$export$995b32462a65e855;
$e8ea6a63d48a4fea$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodLinear = undefined;
$e8ea6a63d48a4fea$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of vectored keyframe values.
 */ class $e8ea6a63d48a4fea$export$5ce2dcb4cc9f2bff extends $e8ea6a63d48a4fea$export$b0e479f45b7006d6 {
}
$e8ea6a63d48a4fea$export$5ce2dcb4cc9f2bff.prototype.ValueTypeName = "vector";
class $e8ea6a63d48a4fea$export$d942c706bf23829c {
    constructor(name, duration = -1, tracks, blendMode = $e8ea6a63d48a4fea$export$bcfbbdcf8de7f8cd){
        this.name = name;
        this.tracks = tracks;
        this.duration = duration;
        this.blendMode = blendMode;
        this.uuid = $e8ea6a63d48a4fea$var$generateUUID();
        // this means it should figure out its duration by scanning the tracks
        if (this.duration < 0) this.resetDuration();
    }
    static parse(json) {
        const tracks = [], jsonTracks = json.tracks, frameTime = 1.0 / (json.fps || 1.0);
        for(let i = 0, n = jsonTracks.length; i !== n; ++i)tracks.push($e8ea6a63d48a4fea$var$parseKeyframeTrack(jsonTracks[i]).scale(frameTime));
        const clip = new this(json.name, json.duration, tracks, json.blendMode);
        clip.uuid = json.uuid;
        return clip;
    }
    static toJSON(clip) {
        const tracks = [], clipTracks = clip.tracks;
        const json = {
            "name": clip.name,
            "duration": clip.duration,
            "tracks": tracks,
            "uuid": clip.uuid,
            "blendMode": clip.blendMode
        };
        for(let i = 0, n = clipTracks.length; i !== n; ++i)tracks.push($e8ea6a63d48a4fea$export$b0e479f45b7006d6.toJSON(clipTracks[i]));
        return json;
    }
    static CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
        const numMorphTargets = morphTargetSequence.length;
        const tracks = [];
        for(let i = 0; i < numMorphTargets; i++){
            let times = [];
            let values = [];
            times.push((i + numMorphTargets - 1) % numMorphTargets, i, (i + 1) % numMorphTargets);
            values.push(0, 1, 0);
            const order = $e8ea6a63d48a4fea$var$getKeyframeOrder(times);
            times = $e8ea6a63d48a4fea$var$sortedArray(times, 1, order);
            values = $e8ea6a63d48a4fea$var$sortedArray(values, 1, order);
            // if there is a key at the first frame, duplicate it as the
            // last frame as well for perfect loop.
            if (!noLoop && times[0] === 0) {
                times.push(numMorphTargets);
                values.push(values[0]);
            }
            tracks.push(new $e8ea6a63d48a4fea$export$d45f0d1a4d9a9314(".morphTargetInfluences[" + morphTargetSequence[i].name + "]", times, values).scale(1.0 / fps));
        }
        return new this(name, -1, tracks);
    }
    static findByName(objectOrClipArray, name) {
        let clipArray = objectOrClipArray;
        if (!Array.isArray(objectOrClipArray)) {
            const o = objectOrClipArray;
            clipArray = o.geometry && o.geometry.animations || o.animations;
        }
        for(let i = 0; i < clipArray.length; i++){
            if (clipArray[i].name === name) return clipArray[i];
        }
        return null;
    }
    static CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
        const animationToMorphTargets = {};
        // tested with https://regex101.com/ on trick sequences
        // such flamingo_flyA_003, flamingo_run1_003, crdeath0059
        const pattern = /^([\w-]*?)([\d]+)$/;
        // sort morph target names into animation groups based
        // patterns like Walk_001, Walk_002, Run_001, Run_002
        for(let i = 0, il = morphTargets.length; i < il; i++){
            const morphTarget = morphTargets[i];
            const parts = morphTarget.name.match(pattern);
            if (parts && parts.length > 1) {
                const name = parts[1];
                let animationMorphTargets = animationToMorphTargets[name];
                if (!animationMorphTargets) animationToMorphTargets[name] = animationMorphTargets = [];
                animationMorphTargets.push(morphTarget);
            }
        }
        const clips = [];
        for(const name in animationToMorphTargets)clips.push(this.CreateFromMorphTargetSequence(name, animationToMorphTargets[name], fps, noLoop));
        return clips;
    }
    // parse the animation.hierarchy format
    static parseAnimation(animation, bones) {
        if (!animation) {
            console.error("THREE.AnimationClip: No animation in JSONLoader data.");
            return null;
        }
        const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
            // only return track if there are actually keys.
            if (animationKeys.length !== 0) {
                const times = [];
                const values = [];
                $e8ea6a63d48a4fea$var$flattenJSON(animationKeys, times, values, propertyName);
                // empty keys are filtered out, so check again
                if (times.length !== 0) destTracks.push(new trackType(trackName, times, values));
            }
        };
        const tracks = [];
        const clipName = animation.name || "default";
        const fps = animation.fps || 30;
        const blendMode = animation.blendMode;
        // automatic length determination in AnimationClip.
        let duration = animation.length || -1;
        const hierarchyTracks = animation.hierarchy || [];
        for(let h = 0; h < hierarchyTracks.length; h++){
            const animationKeys = hierarchyTracks[h].keys;
            // skip empty tracks
            if (!animationKeys || animationKeys.length === 0) continue;
            // process morph targets
            if (animationKeys[0].morphTargets) {
                // figure out all morph targets used in this track
                const morphTargetNames = {};
                let k;
                for(k = 0; k < animationKeys.length; k++){
                    if (animationKeys[k].morphTargets) for(let m = 0; m < animationKeys[k].morphTargets.length; m++)morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
                }
                // create a track for each morph target with all zero
                // morphTargetInfluences except for the keys in which
                // the morphTarget is named.
                for(const morphTargetName in morphTargetNames){
                    const times = [];
                    const values = [];
                    for(let m = 0; m !== animationKeys[k].morphTargets.length; ++m){
                        const animationKey = animationKeys[k];
                        times.push(animationKey.time);
                        values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
                    }
                    tracks.push(new $e8ea6a63d48a4fea$export$d45f0d1a4d9a9314(".morphTargetInfluence[" + morphTargetName + "]", times, values));
                }
                duration = morphTargetNames.length * fps;
            } else {
                // ...assume skeletal animation
                const boneName = ".bones[" + bones[h].name + "]";
                addNonemptyTrack($e8ea6a63d48a4fea$export$5ce2dcb4cc9f2bff, boneName + ".position", animationKeys, "pos", tracks);
                addNonemptyTrack($e8ea6a63d48a4fea$export$b8043f12b5aafbd7, boneName + ".quaternion", animationKeys, "rot", tracks);
                addNonemptyTrack($e8ea6a63d48a4fea$export$5ce2dcb4cc9f2bff, boneName + ".scale", animationKeys, "scl", tracks);
            }
        }
        if (tracks.length === 0) return null;
        const clip = new this(clipName, duration, tracks, blendMode);
        return clip;
    }
    resetDuration() {
        const tracks = this.tracks;
        let duration = 0;
        for(let i = 0, n = tracks.length; i !== n; ++i){
            const track = this.tracks[i];
            duration = Math.max(duration, track.times[track.times.length - 1]);
        }
        this.duration = duration;
        return this;
    }
    trim() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].trim(0, this.duration);
        return this;
    }
    validate() {
        let valid = true;
        for(let i = 0; i < this.tracks.length; i++)valid = valid && this.tracks[i].validate();
        return valid;
    }
    optimize() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].optimize();
        return this;
    }
    clone() {
        const tracks = [];
        for(let i = 0; i < this.tracks.length; i++)tracks.push(this.tracks[i].clone());
        return new this.constructor(this.name, this.duration, tracks, this.blendMode);
    }
    toJSON() {
        return this.constructor.toJSON(this);
    }
}
function $e8ea6a63d48a4fea$var$getTrackTypeForValueTypeName(typeName) {
    switch(typeName.toLowerCase()){
        case "scalar":
        case "double":
        case "float":
        case "number":
        case "integer":
            return $e8ea6a63d48a4fea$export$d45f0d1a4d9a9314;
        case "vector":
        case "vector2":
        case "vector3":
        case "vector4":
            return $e8ea6a63d48a4fea$export$5ce2dcb4cc9f2bff;
        case "color":
            return $e8ea6a63d48a4fea$export$83444c5d885347d8;
        case "quaternion":
            return $e8ea6a63d48a4fea$export$b8043f12b5aafbd7;
        case "bool":
        case "boolean":
            return $e8ea6a63d48a4fea$export$d3a344b98cf0b775;
        case "string":
            return $e8ea6a63d48a4fea$export$6ce41d4f3a8df9cd;
    }
    throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + typeName);
}
function $e8ea6a63d48a4fea$var$parseKeyframeTrack(json) {
    if (json.type === undefined) throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");
    const trackType = $e8ea6a63d48a4fea$var$getTrackTypeForValueTypeName(json.type);
    if (json.times === undefined) {
        const times = [], values = [];
        $e8ea6a63d48a4fea$var$flattenJSON(json.keys, times, values, "value");
        json.times = times;
        json.values = values;
    }
    // derived classes can define a static parse method
    if (trackType.parse !== undefined) return trackType.parse(json);
    else // by default, we assume a constructor compatible with the base
    return new trackType(json.name, json.times, json.values, json.interpolation);
}
const $e8ea6a63d48a4fea$export$94affb487e701bf2 = {
    enabled: false,
    files: {},
    add: function(key, file) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Adding key:', key );
        this.files[key] = file;
    },
    get: function(key) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Checking key:', key );
        return this.files[key];
    },
    remove: function(key) {
        delete this.files[key];
    },
    clear: function() {
        this.files = {};
    }
};
class $e8ea6a63d48a4fea$export$99cc795e99919eed {
    constructor(onLoad, onProgress, onError){
        const scope = this;
        let isLoading = false;
        let itemsLoaded = 0;
        let itemsTotal = 0;
        let urlModifier = undefined;
        const handlers = [];
        // Refer to #5689 for the reason why we don't set .onStart
        // in the constructor
        this.onStart = undefined;
        this.onLoad = onLoad;
        this.onProgress = onProgress;
        this.onError = onError;
        this.itemStart = function(url) {
            itemsTotal++;
            if (isLoading === false) {
                if (scope.onStart !== undefined) scope.onStart(url, itemsLoaded, itemsTotal);
            }
            isLoading = true;
        };
        this.itemEnd = function(url) {
            itemsLoaded++;
            if (scope.onProgress !== undefined) scope.onProgress(url, itemsLoaded, itemsTotal);
            if (itemsLoaded === itemsTotal) {
                isLoading = false;
                if (scope.onLoad !== undefined) scope.onLoad();
            }
        };
        this.itemError = function(url) {
            if (scope.onError !== undefined) scope.onError(url);
        };
        this.resolveURL = function(url) {
            if (urlModifier) return urlModifier(url);
            return url;
        };
        this.setURLModifier = function(transform) {
            urlModifier = transform;
            return this;
        };
        this.addHandler = function(regex, loader) {
            handlers.push(regex, loader);
            return this;
        };
        this.removeHandler = function(regex) {
            const index = handlers.indexOf(regex);
            if (index !== -1) handlers.splice(index, 2);
            return this;
        };
        this.getHandler = function(file) {
            for(let i = 0, l = handlers.length; i < l; i += 2){
                const regex = handlers[i];
                const loader = handlers[i + 1];
                if (regex.global) regex.lastIndex = 0; // see #17920
                if (regex.test(file)) return loader;
            }
            return null;
        };
    }
}
const $e8ea6a63d48a4fea$export$b033c3f9a95c6a16 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$99cc795e99919eed();
class $e8ea6a63d48a4fea$export$3b0d6d7590275603 {
    constructor(manager){
        this.manager = manager !== undefined ? manager : $e8ea6a63d48a4fea$export$b033c3f9a95c6a16;
        this.crossOrigin = "anonymous";
        this.withCredentials = false;
        this.path = "";
        this.resourcePath = "";
        this.requestHeader = {};
    }
    load() {}
    loadAsync(url, onProgress) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.load(url, resolve, onProgress, reject);
        });
    }
    parse() {}
    setCrossOrigin(crossOrigin) {
        this.crossOrigin = crossOrigin;
        return this;
    }
    setWithCredentials(value) {
        this.withCredentials = value;
        return this;
    }
    setPath(path) {
        this.path = path;
        return this;
    }
    setResourcePath(resourcePath) {
        this.resourcePath = resourcePath;
        return this;
    }
    setRequestHeader(requestHeader) {
        this.requestHeader = requestHeader;
        return this;
    }
}
const $e8ea6a63d48a4fea$var$loading = {};
class $e8ea6a63d48a4fea$var$HttpError extends Error {
    constructor(message, response){
        super(message);
        this.response = response;
    }
}
class $e8ea6a63d48a4fea$export$98435a25b5cf7b2b extends $e8ea6a63d48a4fea$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = "";
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const cached = $e8ea6a63d48a4fea$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            this.manager.itemStart(url);
            setTimeout(()=>{
                if (onLoad) onLoad(cached);
                this.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        // Check if request is duplicate
        if ($e8ea6a63d48a4fea$var$loading[url] !== undefined) {
            $e8ea6a63d48a4fea$var$loading[url].push({
                onLoad: onLoad,
                onProgress: onProgress,
                onError: onError
            });
            return;
        }
        // Initialise array for duplicate requests
        $e8ea6a63d48a4fea$var$loading[url] = [];
        $e8ea6a63d48a4fea$var$loading[url].push({
            onLoad: onLoad,
            onProgress: onProgress,
            onError: onError
        });
        // create request
        const req = new Request(url, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? "include" : "same-origin"
        });
        // record states ( avoid data race )
        const mimeType = this.mimeType;
        const responseType = this.responseType;
        // start the fetch
        fetch(req).then((response)=>{
            if (response.status === 200 || response.status === 0) {
                // Some browsers return HTTP Status 0 when using non-http protocol
                // e.g. 'file://' or 'data://'. Handle as success.
                if (response.status === 0) console.warn("THREE.FileLoader: HTTP Status 0 received.");
                // Workaround: Checking if response.body === undefined for Alipay browser #23548
                if (typeof ReadableStream === "undefined" || response.body === undefined || response.body.getReader === undefined) return response;
                const callbacks = $e8ea6a63d48a4fea$var$loading[url];
                const reader = response.body.getReader();
                // Nginx needs X-File-Size check
                // https://serverfault.com/questions/482875/why-does-nginx-remove-content-length-header-for-chunked-content
                const contentLength = response.headers.get("Content-Length") || response.headers.get("X-File-Size");
                const total = contentLength ? parseInt(contentLength) : 0;
                const lengthComputable = total !== 0;
                let loaded = 0;
                // periodically read data into the new stream tracking while download progress
                const stream = new ReadableStream({
                    start (controller) {
                        readData();
                        function readData() {
                            reader.read().then(({ done: done , value: value  })=>{
                                if (done) controller.close();
                                else {
                                    loaded += value.byteLength;
                                    const event = new ProgressEvent("progress", {
                                        lengthComputable: lengthComputable,
                                        loaded: loaded,
                                        total: total
                                    });
                                    for(let i = 0, il = callbacks.length; i < il; i++){
                                        const callback = callbacks[i];
                                        if (callback.onProgress) callback.onProgress(event);
                                    }
                                    controller.enqueue(value);
                                    readData();
                                }
                            });
                        }
                    }
                });
                return new Response(stream);
            } else throw new $e8ea6a63d48a4fea$var$HttpError(`fetch for "${response.url}" responded with ${response.status}: ${response.statusText}`, response);
        }).then((response)=>{
            switch(responseType){
                case "arraybuffer":
                    return response.arrayBuffer();
                case "blob":
                    return response.blob();
                case "document":
                    return response.text().then((text)=>{
                        const parser = new DOMParser();
                        return parser.parseFromString(text, mimeType);
                    });
                case "json":
                    return response.json();
                default:
                    if (mimeType === undefined) return response.text();
                    else {
                        // sniff encoding
                        const re = /charset="?([^;"\s]*)"?/i;
                        const exec = re.exec(mimeType);
                        const label = exec && exec[1] ? exec[1].toLowerCase() : undefined;
                        const decoder = new TextDecoder(label);
                        return response.arrayBuffer().then((ab)=>decoder.decode(ab));
                    }
            }
        }).then((data)=>{
            // Add to cache only on HTTP success, so that we do not cache
            // error response bodies as proper responses to requests.
            $e8ea6a63d48a4fea$export$94affb487e701bf2.add(url, data);
            const callbacks = $e8ea6a63d48a4fea$var$loading[url];
            delete $e8ea6a63d48a4fea$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onLoad) callback.onLoad(data);
            }
        }).catch((err)=>{
            // Abort errors and other errors are handled the same
            const callbacks = $e8ea6a63d48a4fea$var$loading[url];
            if (callbacks === undefined) {
                // When onLoad was called and url was deleted in `loading`
                this.manager.itemError(url);
                throw err;
            }
            delete $e8ea6a63d48a4fea$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onError) callback.onError(err);
            }
            this.manager.itemError(url);
        }).finally(()=>{
            this.manager.itemEnd(url);
        });
        this.manager.itemStart(url);
    }
    setResponseType(value) {
        this.responseType = value;
        return this;
    }
    setMimeType(value) {
        this.mimeType = value;
        return this;
    }
}
class $e8ea6a63d48a4fea$export$29711c7e14f61db extends $e8ea6a63d48a4fea$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $e8ea6a63d48a4fea$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const animations = [];
        for(let i = 0; i < json.length; i++){
            const clip = $e8ea6a63d48a4fea$export$d942c706bf23829c.parse(json[i]);
            animations.push(clip);
        }
        return animations;
    }
}
/**
 * Abstract Base class to block based textures loader (dds, pvr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $e8ea6a63d48a4fea$export$bd73ce947a280350 extends $e8ea6a63d48a4fea$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const images = [];
        const texture = new $e8ea6a63d48a4fea$export$3466bac9141a5cc4();
        const loader = new $e8ea6a63d48a4fea$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(url[i], function(buffer) {
                const texDatas = scope.parse(buffer, true);
                images[i] = {
                    width: texDatas.width,
                    height: texDatas.height,
                    format: texDatas.format,
                    mipmaps: texDatas.mipmaps
                };
                loaded += 1;
                if (loaded === 6) {
                    if (texDatas.mipmapCount === 1) texture.minFilter = $e8ea6a63d48a4fea$export$8a72f490b25c56c8;
                    texture.image = images;
                    texture.format = texDatas.format;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, onProgress, onError);
        }
        if (Array.isArray(url)) for(let i = 0, il = url.length; i < il; ++i)loadTexture(i);
        else // compressed cubemap texture stored in a single DDS file
        loader.load(url, function(buffer) {
            const texDatas = scope.parse(buffer, true);
            if (texDatas.isCubemap) {
                const faces = texDatas.mipmaps.length / texDatas.mipmapCount;
                for(let f = 0; f < faces; f++){
                    images[f] = {
                        mipmaps: []
                    };
                    for(let i = 0; i < texDatas.mipmapCount; i++){
                        images[f].mipmaps.push(texDatas.mipmaps[f * texDatas.mipmapCount + i]);
                        images[f].format = texDatas.format;
                        images[f].width = texDatas.width;
                        images[f].height = texDatas.height;
                    }
                }
                texture.image = images;
            } else {
                texture.image.width = texDatas.width;
                texture.image.height = texDatas.height;
                texture.mipmaps = texDatas.mipmaps;
            }
            if (texDatas.mipmapCount === 1) texture.minFilter = $e8ea6a63d48a4fea$export$8a72f490b25c56c8;
            texture.format = texDatas.format;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $e8ea6a63d48a4fea$export$8905ce1c7a2464a1 extends $e8ea6a63d48a4fea$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $e8ea6a63d48a4fea$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const image = $e8ea6a63d48a4fea$var$createElementNS("img");
        function onImageLoad() {
            removeEventListeners();
            $e8ea6a63d48a4fea$export$94affb487e701bf2.add(url, this);
            if (onLoad) onLoad(this);
            scope.manager.itemEnd(url);
        }
        function onImageError(event) {
            removeEventListeners();
            if (onError) onError(event);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        }
        function removeEventListeners() {
            image.removeEventListener("load", onImageLoad, false);
            image.removeEventListener("error", onImageError, false);
        }
        image.addEventListener("load", onImageLoad, false);
        image.addEventListener("error", onImageError, false);
        if (url.slice(0, 5) !== "data:") {
            if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
        }
        scope.manager.itemStart(url);
        image.src = url;
        return image;
    }
}
class $e8ea6a63d48a4fea$export$2ec114afc2cf6308 extends $e8ea6a63d48a4fea$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(urls, onLoad, onProgress, onError) {
        const texture = new $e8ea6a63d48a4fea$export$ee2e5a18258a4049();
        const loader = new $e8ea6a63d48a4fea$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(urls[i], function(image) {
                texture.images[i] = image;
                loaded++;
                if (loaded === 6) {
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, undefined, onError);
        }
        for(let i = 0; i < urls.length; ++i)loadTexture(i);
        return texture;
    }
}
/**
 * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $e8ea6a63d48a4fea$export$792d8a18f2c55855 extends $e8ea6a63d48a4fea$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const texture = new $e8ea6a63d48a4fea$export$b691f601014eabe1();
        const loader = new $e8ea6a63d48a4fea$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setPath(this.path);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(buffer) {
            const texData = scope.parse(buffer);
            if (!texData) return;
            if (texData.image !== undefined) texture.image = texData.image;
            else if (texData.data !== undefined) {
                texture.image.width = texData.width;
                texture.image.height = texData.height;
                texture.image.data = texData.data;
            }
            texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : $e8ea6a63d48a4fea$export$9d9334239a5a5e06;
            texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : $e8ea6a63d48a4fea$export$9d9334239a5a5e06;
            texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : $e8ea6a63d48a4fea$export$8a72f490b25c56c8;
            texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : $e8ea6a63d48a4fea$export$8a72f490b25c56c8;
            texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;
            if (texData.encoding !== undefined) texture.encoding = texData.encoding;
            if (texData.flipY !== undefined) texture.flipY = texData.flipY;
            if (texData.format !== undefined) texture.format = texData.format;
            if (texData.type !== undefined) texture.type = texData.type;
            if (texData.mipmaps !== undefined) {
                texture.mipmaps = texData.mipmaps;
                texture.minFilter = $e8ea6a63d48a4fea$export$5d8599b6a933fb1b; // presumably...
            }
            if (texData.mipmapCount === 1) texture.minFilter = $e8ea6a63d48a4fea$export$8a72f490b25c56c8;
            if (texData.generateMipmaps !== undefined) texture.generateMipmaps = texData.generateMipmaps;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture, texData);
        }, onProgress, onError);
        return texture;
    }
}
class $e8ea6a63d48a4fea$export$fd1bfc71f64c538c extends $e8ea6a63d48a4fea$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const texture = new $e8ea6a63d48a4fea$export$5431306cf43de24a();
        const loader = new $e8ea6a63d48a4fea$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        loader.load(url, function(image) {
            texture.image = image;
            texture.needsUpdate = true;
            if (onLoad !== undefined) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $e8ea6a63d48a4fea$export$6ecadb6ed240d696 extends $e8ea6a63d48a4fea$export$e4dd07dff30cc924 {
    constructor(color, intensity = 1){
        super();
        this.isLight = true;
        this.type = "Light";
        this.color = new $e8ea6a63d48a4fea$export$892596cec99bc70e(color);
        this.intensity = intensity;
    }
    dispose() {
    // Empty here in base class; some subclasses override.
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.color.copy(source.color);
        this.intensity = source.intensity;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.color = this.color.getHex();
        data.object.intensity = this.intensity;
        if (this.groundColor !== undefined) data.object.groundColor = this.groundColor.getHex();
        if (this.distance !== undefined) data.object.distance = this.distance;
        if (this.angle !== undefined) data.object.angle = this.angle;
        if (this.decay !== undefined) data.object.decay = this.decay;
        if (this.penumbra !== undefined) data.object.penumbra = this.penumbra;
        if (this.shadow !== undefined) data.object.shadow = this.shadow.toJSON();
        return data;
    }
}
class $e8ea6a63d48a4fea$export$8d474f55edbb9624 extends $e8ea6a63d48a4fea$export$6ecadb6ed240d696 {
    constructor(skyColor, groundColor, intensity){
        super(skyColor, intensity);
        this.isHemisphereLight = true;
        this.type = "HemisphereLight";
        this.position.copy($e8ea6a63d48a4fea$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.groundColor = new $e8ea6a63d48a4fea$export$892596cec99bc70e(groundColor);
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.groundColor.copy(source.groundColor);
        return this;
    }
}
const $e8ea6a63d48a4fea$var$_projScreenMatrix$1 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5();
const $e8ea6a63d48a4fea$var$_lightPositionWorld$1 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_lookTarget$1 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
class $e8ea6a63d48a4fea$var$LightShadow {
    constructor(camera){
        this.camera = camera;
        this.bias = 0;
        this.normalBias = 0;
        this.radius = 1;
        this.blurSamples = 8;
        this.mapSize = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(512, 512);
        this.map = null;
        this.mapPass = null;
        this.matrix = new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5();
        this.autoUpdate = true;
        this.needsUpdate = false;
        this._frustum = new $e8ea6a63d48a4fea$export$35efe6f4c85463d2();
        this._frameExtents = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(1, 1);
        this._viewportCount = 1;
        this._viewports = [
            new $e8ea6a63d48a4fea$export$fa7daccca11cdbe3(0, 0, 1, 1)
        ];
    }
    getViewportCount() {
        return this._viewportCount;
    }
    getFrustum() {
        return this._frustum;
    }
    updateMatrices(light) {
        const shadowCamera = this.camera;
        const shadowMatrix = this.matrix;
        $e8ea6a63d48a4fea$var$_lightPositionWorld$1.setFromMatrixPosition(light.matrixWorld);
        shadowCamera.position.copy($e8ea6a63d48a4fea$var$_lightPositionWorld$1);
        $e8ea6a63d48a4fea$var$_lookTarget$1.setFromMatrixPosition(light.target.matrixWorld);
        shadowCamera.lookAt($e8ea6a63d48a4fea$var$_lookTarget$1);
        shadowCamera.updateMatrixWorld();
        $e8ea6a63d48a4fea$var$_projScreenMatrix$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($e8ea6a63d48a4fea$var$_projScreenMatrix$1);
        shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
        shadowMatrix.multiply($e8ea6a63d48a4fea$var$_projScreenMatrix$1);
    }
    getViewport(viewportIndex) {
        return this._viewports[viewportIndex];
    }
    getFrameExtents() {
        return this._frameExtents;
    }
    dispose() {
        if (this.map) this.map.dispose();
        if (this.mapPass) this.mapPass.dispose();
    }
    copy(source) {
        this.camera = source.camera.clone();
        this.bias = source.bias;
        this.radius = source.radius;
        this.mapSize.copy(source.mapSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    toJSON() {
        const object = {};
        if (this.bias !== 0) object.bias = this.bias;
        if (this.normalBias !== 0) object.normalBias = this.normalBias;
        if (this.radius !== 1) object.radius = this.radius;
        if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
        object.camera = this.camera.toJSON(false).object;
        delete object.camera.matrix;
        return object;
    }
}
class $e8ea6a63d48a4fea$var$SpotLightShadow extends $e8ea6a63d48a4fea$var$LightShadow {
    constructor(){
        super(new $e8ea6a63d48a4fea$export$74e4ae24825f68d7(50, 1, 0.5, 500));
        this.isSpotLightShadow = true;
        this.focus = 1;
    }
    updateMatrices(light) {
        const camera = this.camera;
        const fov = $e8ea6a63d48a4fea$var$RAD2DEG * 2 * light.angle * this.focus;
        const aspect = this.mapSize.width / this.mapSize.height;
        const far = light.distance || camera.far;
        if (fov !== camera.fov || aspect !== camera.aspect || far !== camera.far) {
            camera.fov = fov;
            camera.aspect = aspect;
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        super.updateMatrices(light);
    }
    copy(source) {
        super.copy(source);
        this.focus = source.focus;
        return this;
    }
}
class $e8ea6a63d48a4fea$export$81495cbb73897362 extends $e8ea6a63d48a4fea$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, angle = Math.PI / 3, penumbra = 0, decay = 2){
        super(color, intensity);
        this.isSpotLight = true;
        this.type = "SpotLight";
        this.position.copy($e8ea6a63d48a4fea$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.target = new $e8ea6a63d48a4fea$export$e4dd07dff30cc924();
        this.distance = distance;
        this.angle = angle;
        this.penumbra = penumbra;
        this.decay = decay;
        this.map = null;
        this.shadow = new $e8ea6a63d48a4fea$var$SpotLightShadow();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // by convention for a spotlight, luminous power (lm) = π * luminous intensity (cd)
        return this.intensity * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / Math.PI;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.angle = source.angle;
        this.penumbra = source.penumbra;
        this.decay = source.decay;
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
const $e8ea6a63d48a4fea$var$_projScreenMatrix = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5();
const $e8ea6a63d48a4fea$var$_lightPositionWorld = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_lookTarget = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
class $e8ea6a63d48a4fea$var$PointLightShadow extends $e8ea6a63d48a4fea$var$LightShadow {
    constructor(){
        super(new $e8ea6a63d48a4fea$export$74e4ae24825f68d7(90, 1, 0.5, 500));
        this.isPointLightShadow = true;
        this._frameExtents = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(4, 2);
        this._viewportCount = 6;
        this._viewports = [
            // These viewports map a cube-map onto a 2D texture with the
            // following orientation:
            //
            //  xzXZ
            //   y Y
            //
            // X - Positive x direction
            // x - Negative x direction
            // Y - Positive y direction
            // y - Negative y direction
            // Z - Positive z direction
            // z - Negative z direction
            // positive X
            new $e8ea6a63d48a4fea$export$fa7daccca11cdbe3(2, 1, 1, 1),
            // negative X
            new $e8ea6a63d48a4fea$export$fa7daccca11cdbe3(0, 1, 1, 1),
            // positive Z
            new $e8ea6a63d48a4fea$export$fa7daccca11cdbe3(3, 1, 1, 1),
            // negative Z
            new $e8ea6a63d48a4fea$export$fa7daccca11cdbe3(1, 1, 1, 1),
            // positive Y
            new $e8ea6a63d48a4fea$export$fa7daccca11cdbe3(3, 0, 1, 1),
            // negative Y
            new $e8ea6a63d48a4fea$export$fa7daccca11cdbe3(1, 0, 1, 1)
        ];
        this._cubeDirections = [
            new $e8ea6a63d48a4fea$export$64b5c384219d3699(1, 0, 0),
            new $e8ea6a63d48a4fea$export$64b5c384219d3699(-1, 0, 0),
            new $e8ea6a63d48a4fea$export$64b5c384219d3699(0, 0, 1),
            new $e8ea6a63d48a4fea$export$64b5c384219d3699(0, 0, -1),
            new $e8ea6a63d48a4fea$export$64b5c384219d3699(0, 1, 0),
            new $e8ea6a63d48a4fea$export$64b5c384219d3699(0, -1, 0)
        ];
        this._cubeUps = [
            new $e8ea6a63d48a4fea$export$64b5c384219d3699(0, 1, 0),
            new $e8ea6a63d48a4fea$export$64b5c384219d3699(0, 1, 0),
            new $e8ea6a63d48a4fea$export$64b5c384219d3699(0, 1, 0),
            new $e8ea6a63d48a4fea$export$64b5c384219d3699(0, 1, 0),
            new $e8ea6a63d48a4fea$export$64b5c384219d3699(0, 0, 1),
            new $e8ea6a63d48a4fea$export$64b5c384219d3699(0, 0, -1)
        ];
    }
    updateMatrices(light, viewportIndex = 0) {
        const camera = this.camera;
        const shadowMatrix = this.matrix;
        const far = light.distance || camera.far;
        if (far !== camera.far) {
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        $e8ea6a63d48a4fea$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
        camera.position.copy($e8ea6a63d48a4fea$var$_lightPositionWorld);
        $e8ea6a63d48a4fea$var$_lookTarget.copy(camera.position);
        $e8ea6a63d48a4fea$var$_lookTarget.add(this._cubeDirections[viewportIndex]);
        camera.up.copy(this._cubeUps[viewportIndex]);
        camera.lookAt($e8ea6a63d48a4fea$var$_lookTarget);
        camera.updateMatrixWorld();
        shadowMatrix.makeTranslation(-$e8ea6a63d48a4fea$var$_lightPositionWorld.x, -$e8ea6a63d48a4fea$var$_lightPositionWorld.y, -$e8ea6a63d48a4fea$var$_lightPositionWorld.z);
        $e8ea6a63d48a4fea$var$_projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($e8ea6a63d48a4fea$var$_projScreenMatrix);
    }
}
class $e8ea6a63d48a4fea$export$4c9c1cb3f0b6f455 extends $e8ea6a63d48a4fea$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, decay = 2){
        super(color, intensity);
        this.isPointLight = true;
        this.type = "PointLight";
        this.distance = distance;
        this.decay = decay;
        this.shadow = new $e8ea6a63d48a4fea$var$PointLightShadow();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // for an isotropic light source, luminous power (lm) = 4 π luminous intensity (cd)
        return this.intensity * 4 * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / (4 * Math.PI);
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.decay = source.decay;
        this.shadow = source.shadow.clone();
        return this;
    }
}
class $e8ea6a63d48a4fea$var$DirectionalLightShadow extends $e8ea6a63d48a4fea$var$LightShadow {
    constructor(){
        super(new $e8ea6a63d48a4fea$export$9ebf355ee4ed261b(-5, 5, 5, -5, 0.5, 500));
        this.isDirectionalLightShadow = true;
    }
}
class $e8ea6a63d48a4fea$export$3fea33cc9972c868 extends $e8ea6a63d48a4fea$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.isDirectionalLight = true;
        this.type = "DirectionalLight";
        this.position.copy($e8ea6a63d48a4fea$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.target = new $e8ea6a63d48a4fea$export$e4dd07dff30cc924();
        this.shadow = new $e8ea6a63d48a4fea$var$DirectionalLightShadow();
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
class $e8ea6a63d48a4fea$export$af279bfef9ec2c96 extends $e8ea6a63d48a4fea$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.isAmbientLight = true;
        this.type = "AmbientLight";
    }
}
class $e8ea6a63d48a4fea$export$61db2d908bbd2429 extends $e8ea6a63d48a4fea$export$6ecadb6ed240d696 {
    constructor(color, intensity, width = 10, height = 10){
        super(color, intensity);
        this.isRectAreaLight = true;
        this.type = "RectAreaLight";
        this.width = width;
        this.height = height;
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in nits)
        return this.intensity * this.width * this.height * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in nits) from the desired luminous power (in lumens)
        this.intensity = power / (this.width * this.height * Math.PI);
    }
    copy(source) {
        super.copy(source);
        this.width = source.width;
        this.height = source.height;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.width = this.width;
        data.object.height = this.height;
        return data;
    }
}
/**
 * Primary reference:
 *   https://graphics.stanford.edu/papers/envmap/envmap.pdf
 *
 * Secondary reference:
 *   https://www.ppsloan.org/publications/StupidSH36.pdf
 */ // 3-band SH defined by 9 coefficients
class $e8ea6a63d48a4fea$export$ba61ce607e1f405a {
    constructor(){
        this.isSphericalHarmonics3 = true;
        this.coefficients = [];
        for(let i = 0; i < 9; i++)this.coefficients.push(new $e8ea6a63d48a4fea$export$64b5c384219d3699());
    }
    set(coefficients) {
        for(let i = 0; i < 9; i++)this.coefficients[i].copy(coefficients[i]);
        return this;
    }
    zero() {
        for(let i = 0; i < 9; i++)this.coefficients[i].set(0, 0, 0);
        return this;
    }
    // get the radiance in the direction of the normal
    // target is a Vector3
    getAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.282095);
        // band 1
        target.addScaledVector(coeff[1], 0.488603 * y);
        target.addScaledVector(coeff[2], 0.488603 * z);
        target.addScaledVector(coeff[3], 0.488603 * x);
        // band 2
        target.addScaledVector(coeff[4], 1.092548 * (x * y));
        target.addScaledVector(coeff[5], 1.092548 * (y * z));
        target.addScaledVector(coeff[6], 0.315392 * (3.0 * z * z - 1.0));
        target.addScaledVector(coeff[7], 1.092548 * (x * z));
        target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
        return target;
    }
    // get the irradiance (radiance convolved with cosine lobe) in the direction of the normal
    // target is a Vector3
    // https://graphics.stanford.edu/papers/envmap/envmap.pdf
    getIrradianceAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.886227); // π * 0.282095
        // band 1
        target.addScaledVector(coeff[1], 1.023328 * y); // ( 2 * π / 3 ) * 0.488603
        target.addScaledVector(coeff[2], 1.023328 * z);
        target.addScaledVector(coeff[3], 1.023328 * x);
        // band 2
        target.addScaledVector(coeff[4], 0.858086 * x * y); // ( π / 4 ) * 1.092548
        target.addScaledVector(coeff[5], 0.858086 * y * z);
        target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708); // ( π / 4 ) * 0.315392 * 3
        target.addScaledVector(coeff[7], 0.858086 * x * z);
        target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y)); // ( π / 4 ) * 0.546274
        return target;
    }
    add(sh) {
        for(let i = 0; i < 9; i++)this.coefficients[i].add(sh.coefficients[i]);
        return this;
    }
    addScaledSH(sh, s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].addScaledVector(sh.coefficients[i], s);
        return this;
    }
    scale(s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].multiplyScalar(s);
        return this;
    }
    lerp(sh, alpha) {
        for(let i = 0; i < 9; i++)this.coefficients[i].lerp(sh.coefficients[i], alpha);
        return this;
    }
    equals(sh) {
        for(let i = 0; i < 9; i++){
            if (!this.coefficients[i].equals(sh.coefficients[i])) return false;
        }
        return true;
    }
    copy(sh) {
        return this.set(sh.coefficients);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    fromArray(array, offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].fromArray(array, offset + i * 3);
        return this;
    }
    toArray(array = [], offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].toArray(array, offset + i * 3);
        return array;
    }
    // evaluate the basis functions
    // shBasis is an Array[ 9 ]
    static getBasisAt(normal, shBasis) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        // band 0
        shBasis[0] = 0.282095;
        // band 1
        shBasis[1] = 0.488603 * y;
        shBasis[2] = 0.488603 * z;
        shBasis[3] = 0.488603 * x;
        // band 2
        shBasis[4] = 1.092548 * x * y;
        shBasis[5] = 1.092548 * y * z;
        shBasis[6] = 0.315392 * (3 * z * z - 1);
        shBasis[7] = 1.092548 * x * z;
        shBasis[8] = 0.546274 * (x * x - y * y);
    }
}
class $e8ea6a63d48a4fea$export$e7ef036e309b38d2 extends $e8ea6a63d48a4fea$export$6ecadb6ed240d696 {
    constructor(sh = new $e8ea6a63d48a4fea$export$ba61ce607e1f405a(), intensity = 1){
        super(undefined, intensity);
        this.isLightProbe = true;
        this.sh = sh;
    }
    copy(source) {
        super.copy(source);
        this.sh.copy(source.sh);
        return this;
    }
    fromJSON(json) {
        this.intensity = json.intensity; // TODO: Move this bit to Light.fromJSON();
        this.sh.fromArray(json.sh);
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.sh = this.sh.toArray();
        return data;
    }
}
class $e8ea6a63d48a4fea$export$3bd6d323353dcf96 extends $e8ea6a63d48a4fea$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        this.textures = {};
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $e8ea6a63d48a4fea$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const textures = this.textures;
        function getTexture(name) {
            if (textures[name] === undefined) console.warn("THREE.MaterialLoader: Undefined texture", name);
            return textures[name];
        }
        const material = $e8ea6a63d48a4fea$export$3bd6d323353dcf96.createMaterialFromType(json.type);
        if (json.uuid !== undefined) material.uuid = json.uuid;
        if (json.name !== undefined) material.name = json.name;
        if (json.color !== undefined && material.color !== undefined) material.color.setHex(json.color);
        if (json.roughness !== undefined) material.roughness = json.roughness;
        if (json.metalness !== undefined) material.metalness = json.metalness;
        if (json.sheen !== undefined) material.sheen = json.sheen;
        if (json.sheenColor !== undefined) material.sheenColor = new $e8ea6a63d48a4fea$export$892596cec99bc70e().setHex(json.sheenColor);
        if (json.sheenRoughness !== undefined) material.sheenRoughness = json.sheenRoughness;
        if (json.emissive !== undefined && material.emissive !== undefined) material.emissive.setHex(json.emissive);
        if (json.specular !== undefined && material.specular !== undefined) material.specular.setHex(json.specular);
        if (json.specularIntensity !== undefined) material.specularIntensity = json.specularIntensity;
        if (json.specularColor !== undefined && material.specularColor !== undefined) material.specularColor.setHex(json.specularColor);
        if (json.shininess !== undefined) material.shininess = json.shininess;
        if (json.clearcoat !== undefined) material.clearcoat = json.clearcoat;
        if (json.clearcoatRoughness !== undefined) material.clearcoatRoughness = json.clearcoatRoughness;
        if (json.iridescence !== undefined) material.iridescence = json.iridescence;
        if (json.iridescenceIOR !== undefined) material.iridescenceIOR = json.iridescenceIOR;
        if (json.iridescenceThicknessRange !== undefined) material.iridescenceThicknessRange = json.iridescenceThicknessRange;
        if (json.transmission !== undefined) material.transmission = json.transmission;
        if (json.thickness !== undefined) material.thickness = json.thickness;
        if (json.attenuationDistance !== undefined) material.attenuationDistance = json.attenuationDistance;
        if (json.attenuationColor !== undefined && material.attenuationColor !== undefined) material.attenuationColor.setHex(json.attenuationColor);
        if (json.fog !== undefined) material.fog = json.fog;
        if (json.flatShading !== undefined) material.flatShading = json.flatShading;
        if (json.blending !== undefined) material.blending = json.blending;
        if (json.combine !== undefined) material.combine = json.combine;
        if (json.side !== undefined) material.side = json.side;
        if (json.shadowSide !== undefined) material.shadowSide = json.shadowSide;
        if (json.opacity !== undefined) material.opacity = json.opacity;
        if (json.transparent !== undefined) material.transparent = json.transparent;
        if (json.alphaTest !== undefined) material.alphaTest = json.alphaTest;
        if (json.depthTest !== undefined) material.depthTest = json.depthTest;
        if (json.depthWrite !== undefined) material.depthWrite = json.depthWrite;
        if (json.colorWrite !== undefined) material.colorWrite = json.colorWrite;
        if (json.stencilWrite !== undefined) material.stencilWrite = json.stencilWrite;
        if (json.stencilWriteMask !== undefined) material.stencilWriteMask = json.stencilWriteMask;
        if (json.stencilFunc !== undefined) material.stencilFunc = json.stencilFunc;
        if (json.stencilRef !== undefined) material.stencilRef = json.stencilRef;
        if (json.stencilFuncMask !== undefined) material.stencilFuncMask = json.stencilFuncMask;
        if (json.stencilFail !== undefined) material.stencilFail = json.stencilFail;
        if (json.stencilZFail !== undefined) material.stencilZFail = json.stencilZFail;
        if (json.stencilZPass !== undefined) material.stencilZPass = json.stencilZPass;
        if (json.wireframe !== undefined) material.wireframe = json.wireframe;
        if (json.wireframeLinewidth !== undefined) material.wireframeLinewidth = json.wireframeLinewidth;
        if (json.wireframeLinecap !== undefined) material.wireframeLinecap = json.wireframeLinecap;
        if (json.wireframeLinejoin !== undefined) material.wireframeLinejoin = json.wireframeLinejoin;
        if (json.rotation !== undefined) material.rotation = json.rotation;
        if (json.linewidth !== 1) material.linewidth = json.linewidth;
        if (json.dashSize !== undefined) material.dashSize = json.dashSize;
        if (json.gapSize !== undefined) material.gapSize = json.gapSize;
        if (json.scale !== undefined) material.scale = json.scale;
        if (json.polygonOffset !== undefined) material.polygonOffset = json.polygonOffset;
        if (json.polygonOffsetFactor !== undefined) material.polygonOffsetFactor = json.polygonOffsetFactor;
        if (json.polygonOffsetUnits !== undefined) material.polygonOffsetUnits = json.polygonOffsetUnits;
        if (json.dithering !== undefined) material.dithering = json.dithering;
        if (json.alphaToCoverage !== undefined) material.alphaToCoverage = json.alphaToCoverage;
        if (json.premultipliedAlpha !== undefined) material.premultipliedAlpha = json.premultipliedAlpha;
        if (json.forceSinglePass !== undefined) material.forceSinglePass = json.forceSinglePass;
        if (json.visible !== undefined) material.visible = json.visible;
        if (json.toneMapped !== undefined) material.toneMapped = json.toneMapped;
        if (json.userData !== undefined) material.userData = json.userData;
        if (json.vertexColors !== undefined) {
            if (typeof json.vertexColors === "number") material.vertexColors = json.vertexColors > 0 ? true : false;
            else material.vertexColors = json.vertexColors;
        }
        // Shader Material
        if (json.uniforms !== undefined) for(const name in json.uniforms){
            const uniform = json.uniforms[name];
            material.uniforms[name] = {};
            switch(uniform.type){
                case "t":
                    material.uniforms[name].value = getTexture(uniform.value);
                    break;
                case "c":
                    material.uniforms[name].value = new $e8ea6a63d48a4fea$export$892596cec99bc70e().setHex(uniform.value);
                    break;
                case "v2":
                    material.uniforms[name].value = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1().fromArray(uniform.value);
                    break;
                case "v3":
                    material.uniforms[name].value = new $e8ea6a63d48a4fea$export$64b5c384219d3699().fromArray(uniform.value);
                    break;
                case "v4":
                    material.uniforms[name].value = new $e8ea6a63d48a4fea$export$fa7daccca11cdbe3().fromArray(uniform.value);
                    break;
                case "m3":
                    material.uniforms[name].value = new $e8ea6a63d48a4fea$export$8ff26dafa08918().fromArray(uniform.value);
                    break;
                case "m4":
                    material.uniforms[name].value = new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5().fromArray(uniform.value);
                    break;
                default:
                    material.uniforms[name].value = uniform.value;
            }
        }
        if (json.defines !== undefined) material.defines = json.defines;
        if (json.vertexShader !== undefined) material.vertexShader = json.vertexShader;
        if (json.fragmentShader !== undefined) material.fragmentShader = json.fragmentShader;
        if (json.glslVersion !== undefined) material.glslVersion = json.glslVersion;
        if (json.extensions !== undefined) for(const key in json.extensions)material.extensions[key] = json.extensions[key];
        // for PointsMaterial
        if (json.size !== undefined) material.size = json.size;
        if (json.sizeAttenuation !== undefined) material.sizeAttenuation = json.sizeAttenuation;
        // maps
        if (json.map !== undefined) material.map = getTexture(json.map);
        if (json.matcap !== undefined) material.matcap = getTexture(json.matcap);
        if (json.alphaMap !== undefined) material.alphaMap = getTexture(json.alphaMap);
        if (json.bumpMap !== undefined) material.bumpMap = getTexture(json.bumpMap);
        if (json.bumpScale !== undefined) material.bumpScale = json.bumpScale;
        if (json.normalMap !== undefined) material.normalMap = getTexture(json.normalMap);
        if (json.normalMapType !== undefined) material.normalMapType = json.normalMapType;
        if (json.normalScale !== undefined) {
            let normalScale = json.normalScale;
            if (Array.isArray(normalScale) === false) // Blender exporter used to export a scalar. See #7459
            normalScale = [
                normalScale,
                normalScale
            ];
            material.normalScale = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1().fromArray(normalScale);
        }
        if (json.displacementMap !== undefined) material.displacementMap = getTexture(json.displacementMap);
        if (json.displacementScale !== undefined) material.displacementScale = json.displacementScale;
        if (json.displacementBias !== undefined) material.displacementBias = json.displacementBias;
        if (json.roughnessMap !== undefined) material.roughnessMap = getTexture(json.roughnessMap);
        if (json.metalnessMap !== undefined) material.metalnessMap = getTexture(json.metalnessMap);
        if (json.emissiveMap !== undefined) material.emissiveMap = getTexture(json.emissiveMap);
        if (json.emissiveIntensity !== undefined) material.emissiveIntensity = json.emissiveIntensity;
        if (json.specularMap !== undefined) material.specularMap = getTexture(json.specularMap);
        if (json.specularIntensityMap !== undefined) material.specularIntensityMap = getTexture(json.specularIntensityMap);
        if (json.specularColorMap !== undefined) material.specularColorMap = getTexture(json.specularColorMap);
        if (json.envMap !== undefined) material.envMap = getTexture(json.envMap);
        if (json.envMapIntensity !== undefined) material.envMapIntensity = json.envMapIntensity;
        if (json.reflectivity !== undefined) material.reflectivity = json.reflectivity;
        if (json.refractionRatio !== undefined) material.refractionRatio = json.refractionRatio;
        if (json.lightMap !== undefined) material.lightMap = getTexture(json.lightMap);
        if (json.lightMapIntensity !== undefined) material.lightMapIntensity = json.lightMapIntensity;
        if (json.aoMap !== undefined) material.aoMap = getTexture(json.aoMap);
        if (json.aoMapIntensity !== undefined) material.aoMapIntensity = json.aoMapIntensity;
        if (json.gradientMap !== undefined) material.gradientMap = getTexture(json.gradientMap);
        if (json.clearcoatMap !== undefined) material.clearcoatMap = getTexture(json.clearcoatMap);
        if (json.clearcoatRoughnessMap !== undefined) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
        if (json.clearcoatNormalMap !== undefined) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
        if (json.clearcoatNormalScale !== undefined) material.clearcoatNormalScale = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1().fromArray(json.clearcoatNormalScale);
        if (json.iridescenceMap !== undefined) material.iridescenceMap = getTexture(json.iridescenceMap);
        if (json.iridescenceThicknessMap !== undefined) material.iridescenceThicknessMap = getTexture(json.iridescenceThicknessMap);
        if (json.transmissionMap !== undefined) material.transmissionMap = getTexture(json.transmissionMap);
        if (json.thicknessMap !== undefined) material.thicknessMap = getTexture(json.thicknessMap);
        if (json.sheenColorMap !== undefined) material.sheenColorMap = getTexture(json.sheenColorMap);
        if (json.sheenRoughnessMap !== undefined) material.sheenRoughnessMap = getTexture(json.sheenRoughnessMap);
        return material;
    }
    setTextures(value) {
        this.textures = value;
        return this;
    }
    static createMaterialFromType(type) {
        const materialLib = {
            ShadowMaterial: $e8ea6a63d48a4fea$export$e8564da406055a3,
            SpriteMaterial: $e8ea6a63d48a4fea$export$5ec7dd1c6994bf8e,
            RawShaderMaterial: $e8ea6a63d48a4fea$export$21c421a2e1df9d22,
            ShaderMaterial: $e8ea6a63d48a4fea$export$83c7d75d550a8b0d,
            PointsMaterial: $e8ea6a63d48a4fea$export$a178c45366ce5d6b,
            MeshPhysicalMaterial: $e8ea6a63d48a4fea$export$28d04986c4269c9f,
            MeshStandardMaterial: $e8ea6a63d48a4fea$export$f2980790215acccd,
            MeshPhongMaterial: $e8ea6a63d48a4fea$export$24c72f71cbaf0678,
            MeshToonMaterial: $e8ea6a63d48a4fea$export$df893cf97e765622,
            MeshNormalMaterial: $e8ea6a63d48a4fea$export$bfe8c0a091f41ae7,
            MeshLambertMaterial: $e8ea6a63d48a4fea$export$5023a9a8114806b8,
            MeshDepthMaterial: $e8ea6a63d48a4fea$export$2698c22ec13825db,
            MeshDistanceMaterial: $e8ea6a63d48a4fea$export$33e187ed002f2a19,
            MeshBasicMaterial: $e8ea6a63d48a4fea$export$55cbcc9b622fe1f5,
            MeshMatcapMaterial: $e8ea6a63d48a4fea$export$6f5fef6235ec12ee,
            LineDashedMaterial: $e8ea6a63d48a4fea$export$327886a3efaeaebe,
            LineBasicMaterial: $e8ea6a63d48a4fea$export$fbaaa33907730a0c,
            Material: $e8ea6a63d48a4fea$export$a2d8b23205c25948
        };
        return new materialLib[type]();
    }
}
class $e8ea6a63d48a4fea$export$b5d2dc08d867e41a {
    static decodeText(array) {
        if (typeof TextDecoder !== "undefined") return new TextDecoder().decode(array);
        // Avoid the String.fromCharCode.apply(null, array) shortcut, which
        // throws a "maximum call stack size exceeded" error for large arrays.
        let s = "";
        for(let i = 0, il = array.length; i < il; i++)// Implicitly assumes little-endian.
        s += String.fromCharCode(array[i]);
        try {
            // merges multi-byte utf-8 characters.
            return decodeURIComponent(escape(s));
        } catch (e) {
            return s;
        }
    }
    static extractUrlBase(url) {
        const index = url.lastIndexOf("/");
        if (index === -1) return "./";
        return url.slice(0, index + 1);
    }
    static resolveURL(url, path) {
        // Invalid URL
        if (typeof url !== "string" || url === "") return "";
        // Host Relative URL
        if (/^https?:\/\//i.test(path) && /^\//.test(url)) path = path.replace(/(^https?:\/\/[^\/]+).*/i, "$1");
        // Absolute URL http://,https://,//
        if (/^(https?:)?\/\//i.test(url)) return url;
        // Data URI
        if (/^data:.*,.*$/i.test(url)) return url;
        // Blob URL
        if (/^blob:.*$/i.test(url)) return url;
        // Relative URL
        return path + url;
    }
}
class $e8ea6a63d48a4fea$export$231f009cbe414146 extends $e8ea6a63d48a4fea$export$b7be63a67df8959 {
    constructor(){
        super();
        this.isInstancedBufferGeometry = true;
        this.type = "InstancedBufferGeometry";
        this.instanceCount = Infinity;
    }
    copy(source) {
        super.copy(source);
        this.instanceCount = source.instanceCount;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.instanceCount = this.instanceCount;
        data.isInstancedBufferGeometry = true;
        return data;
    }
}
class $e8ea6a63d48a4fea$export$dc275bb96327833a extends $e8ea6a63d48a4fea$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $e8ea6a63d48a4fea$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const interleavedBufferMap = {};
        const arrayBufferMap = {};
        function getInterleavedBuffer(json, uuid) {
            if (interleavedBufferMap[uuid] !== undefined) return interleavedBufferMap[uuid];
            const interleavedBuffers = json.interleavedBuffers;
            const interleavedBuffer = interleavedBuffers[uuid];
            const buffer = getArrayBuffer(json, interleavedBuffer.buffer);
            const array = $e8ea6a63d48a4fea$var$getTypedArray(interleavedBuffer.type, buffer);
            const ib = new $e8ea6a63d48a4fea$export$3d5cd879f108f53f(array, interleavedBuffer.stride);
            ib.uuid = interleavedBuffer.uuid;
            interleavedBufferMap[uuid] = ib;
            return ib;
        }
        function getArrayBuffer(json, uuid) {
            if (arrayBufferMap[uuid] !== undefined) return arrayBufferMap[uuid];
            const arrayBuffers = json.arrayBuffers;
            const arrayBuffer = arrayBuffers[uuid];
            const ab = new Uint32Array(arrayBuffer).buffer;
            arrayBufferMap[uuid] = ab;
            return ab;
        }
        const geometry = json.isInstancedBufferGeometry ? new $e8ea6a63d48a4fea$export$231f009cbe414146() : new $e8ea6a63d48a4fea$export$b7be63a67df8959();
        const index = json.data.index;
        if (index !== undefined) {
            const typedArray = $e8ea6a63d48a4fea$var$getTypedArray(index.type, index.array);
            geometry.setIndex(new $e8ea6a63d48a4fea$export$8dea267bd6bde117(typedArray, 1));
        }
        const attributes = json.data.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            let bufferAttribute;
            if (attribute.isInterleavedBufferAttribute) {
                const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                bufferAttribute = new $e8ea6a63d48a4fea$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
            } else {
                const typedArray = $e8ea6a63d48a4fea$var$getTypedArray(attribute.type, attribute.array);
                const bufferAttributeConstr = attribute.isInstancedBufferAttribute ? $e8ea6a63d48a4fea$export$32ea87a8b54d744a : $e8ea6a63d48a4fea$export$8dea267bd6bde117;
                bufferAttribute = new bufferAttributeConstr(typedArray, attribute.itemSize, attribute.normalized);
            }
            if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
            if (attribute.usage !== undefined) bufferAttribute.setUsage(attribute.usage);
            if (attribute.updateRange !== undefined) {
                bufferAttribute.updateRange.offset = attribute.updateRange.offset;
                bufferAttribute.updateRange.count = attribute.updateRange.count;
            }
            geometry.setAttribute(key, bufferAttribute);
        }
        const morphAttributes = json.data.morphAttributes;
        if (morphAttributes) for(const key in morphAttributes){
            const attributeArray = morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                let bufferAttribute;
                if (attribute.isInterleavedBufferAttribute) {
                    const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                    bufferAttribute = new $e8ea6a63d48a4fea$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
                } else {
                    const typedArray = $e8ea6a63d48a4fea$var$getTypedArray(attribute.type, attribute.array);
                    bufferAttribute = new $e8ea6a63d48a4fea$export$8dea267bd6bde117(typedArray, attribute.itemSize, attribute.normalized);
                }
                if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
                array.push(bufferAttribute);
            }
            geometry.morphAttributes[key] = array;
        }
        const morphTargetsRelative = json.data.morphTargetsRelative;
        if (morphTargetsRelative) geometry.morphTargetsRelative = true;
        const groups = json.data.groups || json.data.drawcalls || json.data.offsets;
        if (groups !== undefined) for(let i = 0, n = groups.length; i !== n; ++i){
            const group = groups[i];
            geometry.addGroup(group.start, group.count, group.materialIndex);
        }
        const boundingSphere = json.data.boundingSphere;
        if (boundingSphere !== undefined) {
            const center = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
            if (boundingSphere.center !== undefined) center.fromArray(boundingSphere.center);
            geometry.boundingSphere = new $e8ea6a63d48a4fea$export$805e8b72413ccaba(center, boundingSphere.radius);
        }
        if (json.name) geometry.name = json.name;
        if (json.userData) geometry.userData = json.userData;
        return geometry;
    }
}
class $e8ea6a63d48a4fea$export$40110c8505c5ad19 extends $e8ea6a63d48a4fea$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const path = this.path === "" ? $e8ea6a63d48a4fea$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $e8ea6a63d48a4fea$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            let json = null;
            try {
                json = JSON.parse(text);
            } catch (error) {
                if (onError !== undefined) onError(error);
                console.error("THREE:ObjectLoader: Can't parse " + url + ".", error.message);
                return;
            }
            const metadata = json.metadata;
            if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === "geometry") {
                if (onError !== undefined) onError(new Error("THREE.ObjectLoader: Can't load " + url));
                console.error("THREE.ObjectLoader: Can't load " + url);
                return;
            }
            scope.parse(json, onLoad);
        }, onProgress, onError);
    }
    async loadAsync(url, onProgress) {
        const scope = this;
        const path = this.path === "" ? $e8ea6a63d48a4fea$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $e8ea6a63d48a4fea$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        const text = await loader.loadAsync(url, onProgress);
        const json = JSON.parse(text);
        const metadata = json.metadata;
        if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === "geometry") throw new Error("THREE.ObjectLoader: Can't load " + url);
        return await scope.parseAsync(json);
    }
    parse(json, onLoad) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = this.parseImages(json.images, function() {
            if (onLoad !== undefined) onLoad(object);
        });
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        //
        if (onLoad !== undefined) {
            let hasImages = false;
            for(const uuid in images)if (images[uuid].data instanceof HTMLImageElement) {
                hasImages = true;
                break;
            }
            if (hasImages === false) onLoad(object);
        }
        return object;
    }
    async parseAsync(json) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = await this.parseImagesAsync(json.images);
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        return object;
    }
    parseShapes(json) {
        const shapes = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const shape = new $e8ea6a63d48a4fea$export$6428a7f2611ef1fa().fromJSON(json[i]);
            shapes[shape.uuid] = shape;
        }
        return shapes;
    }
    parseSkeletons(json, object) {
        const skeletons = {};
        const bones = {};
        // generate bone lookup table
        object.traverse(function(child) {
            if (child.isBone) bones[child.uuid] = child;
        });
        // create skeletons
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const skeleton = new $e8ea6a63d48a4fea$export$8f31e4c4a37b8e9c().fromJSON(json[i], bones);
            skeletons[skeleton.uuid] = skeleton;
        }
        return skeletons;
    }
    parseGeometries(json, shapes) {
        const geometries = {};
        if (json !== undefined) {
            const bufferGeometryLoader = new $e8ea6a63d48a4fea$export$dc275bb96327833a();
            for(let i = 0, l = json.length; i < l; i++){
                let geometry;
                const data = json[i];
                switch(data.type){
                    case "BufferGeometry":
                    case "InstancedBufferGeometry":
                        geometry = bufferGeometryLoader.parse(data);
                        break;
                    default:
                        if (data.type in $e8ea6a63d48a4fea$var$Geometries) geometry = $e8ea6a63d48a4fea$var$Geometries[data.type].fromJSON(data, shapes);
                        else console.warn(`THREE.ObjectLoader: Unsupported geometry type "${data.type}"`);
                }
                geometry.uuid = data.uuid;
                if (data.name !== undefined) geometry.name = data.name;
                if (data.userData !== undefined) geometry.userData = data.userData;
                geometries[data.uuid] = geometry;
            }
        }
        return geometries;
    }
    parseMaterials(json, textures) {
        const cache = {}; // MultiMaterial
        const materials = {};
        if (json !== undefined) {
            const loader = new $e8ea6a63d48a4fea$export$3bd6d323353dcf96();
            loader.setTextures(textures);
            for(let i = 0, l = json.length; i < l; i++){
                const data = json[i];
                if (cache[data.uuid] === undefined) cache[data.uuid] = loader.parse(data);
                materials[data.uuid] = cache[data.uuid];
            }
        }
        return materials;
    }
    parseAnimations(json) {
        const animations = {};
        if (json !== undefined) for(let i = 0; i < json.length; i++){
            const data = json[i];
            const clip = $e8ea6a63d48a4fea$export$d942c706bf23829c.parse(data);
            animations[clip.uuid] = clip;
        }
        return animations;
    }
    parseImages(json, onLoad) {
        const scope = this;
        const images = {};
        let loader;
        function loadImage(url) {
            scope.manager.itemStart(url);
            return loader.load(url, function() {
                scope.manager.itemEnd(url);
            }, undefined, function() {
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            });
        }
        function deserializeImage(image) {
            if (typeof image === "string") {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return loadImage(path);
            } else {
                if (image.data) return {
                    data: $e8ea6a63d48a4fea$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            const manager = new $e8ea6a63d48a4fea$export$99cc795e99919eed(onLoad);
            loader = new $e8ea6a63d48a4fea$export$8905ce1c7a2464a1(manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $e8ea6a63d48a4fea$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $e8ea6a63d48a4fea$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = deserializeImage(image.url);
                    images[image.uuid] = new $e8ea6a63d48a4fea$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    async parseImagesAsync(json) {
        const scope = this;
        const images = {};
        let loader;
        async function deserializeImage(image) {
            if (typeof image === "string") {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return await loader.loadAsync(path);
            } else {
                if (image.data) return {
                    data: $e8ea6a63d48a4fea$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            loader = new $e8ea6a63d48a4fea$export$8905ce1c7a2464a1(this.manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = await deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $e8ea6a63d48a4fea$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $e8ea6a63d48a4fea$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = await deserializeImage(image.url);
                    images[image.uuid] = new $e8ea6a63d48a4fea$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    parseTextures(json, images) {
        function parseConstant(value, type) {
            if (typeof value === "number") return value;
            console.warn("THREE.ObjectLoader.parseTexture: Constant should be in numeric form.", value);
            return type[value];
        }
        const textures = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const data = json[i];
            if (data.image === undefined) console.warn('THREE.ObjectLoader: No "image" specified for', data.uuid);
            if (images[data.image] === undefined) console.warn("THREE.ObjectLoader: Undefined image", data.image);
            const source = images[data.image];
            const image = source.data;
            let texture;
            if (Array.isArray(image)) {
                texture = new $e8ea6a63d48a4fea$export$ee2e5a18258a4049();
                if (image.length === 6) texture.needsUpdate = true;
            } else {
                if (image && image.data) texture = new $e8ea6a63d48a4fea$export$b691f601014eabe1();
                else texture = new $e8ea6a63d48a4fea$export$5431306cf43de24a();
                if (image) texture.needsUpdate = true; // textures can have undefined image data
            }
            texture.source = source;
            texture.uuid = data.uuid;
            if (data.name !== undefined) texture.name = data.name;
            if (data.mapping !== undefined) texture.mapping = parseConstant(data.mapping, $e8ea6a63d48a4fea$var$TEXTURE_MAPPING);
            if (data.channel !== undefined) texture.channel = data.channel;
            if (data.offset !== undefined) texture.offset.fromArray(data.offset);
            if (data.repeat !== undefined) texture.repeat.fromArray(data.repeat);
            if (data.center !== undefined) texture.center.fromArray(data.center);
            if (data.rotation !== undefined) texture.rotation = data.rotation;
            if (data.wrap !== undefined) {
                texture.wrapS = parseConstant(data.wrap[0], $e8ea6a63d48a4fea$var$TEXTURE_WRAPPING);
                texture.wrapT = parseConstant(data.wrap[1], $e8ea6a63d48a4fea$var$TEXTURE_WRAPPING);
            }
            if (data.format !== undefined) texture.format = data.format;
            if (data.internalFormat !== undefined) texture.internalFormat = data.internalFormat;
            if (data.type !== undefined) texture.type = data.type;
            if (data.encoding !== undefined) texture.encoding = data.encoding;
            if (data.minFilter !== undefined) texture.minFilter = parseConstant(data.minFilter, $e8ea6a63d48a4fea$var$TEXTURE_FILTER);
            if (data.magFilter !== undefined) texture.magFilter = parseConstant(data.magFilter, $e8ea6a63d48a4fea$var$TEXTURE_FILTER);
            if (data.anisotropy !== undefined) texture.anisotropy = data.anisotropy;
            if (data.flipY !== undefined) texture.flipY = data.flipY;
            if (data.generateMipmaps !== undefined) texture.generateMipmaps = data.generateMipmaps;
            if (data.premultiplyAlpha !== undefined) texture.premultiplyAlpha = data.premultiplyAlpha;
            if (data.unpackAlignment !== undefined) texture.unpackAlignment = data.unpackAlignment;
            if (data.userData !== undefined) texture.userData = data.userData;
            textures[data.uuid] = texture;
        }
        return textures;
    }
    parseObject(data, geometries, materials, textures, animations) {
        let object;
        function getGeometry(name) {
            if (geometries[name] === undefined) console.warn("THREE.ObjectLoader: Undefined geometry", name);
            return geometries[name];
        }
        function getMaterial(name) {
            if (name === undefined) return undefined;
            if (Array.isArray(name)) {
                const array = [];
                for(let i = 0, l = name.length; i < l; i++){
                    const uuid = name[i];
                    if (materials[uuid] === undefined) console.warn("THREE.ObjectLoader: Undefined material", uuid);
                    array.push(materials[uuid]);
                }
                return array;
            }
            if (materials[name] === undefined) console.warn("THREE.ObjectLoader: Undefined material", name);
            return materials[name];
        }
        function getTexture(uuid) {
            if (textures[uuid] === undefined) console.warn("THREE.ObjectLoader: Undefined texture", uuid);
            return textures[uuid];
        }
        let geometry, material;
        switch(data.type){
            case "Scene":
                object = new $e8ea6a63d48a4fea$export$38af1803e3442a7f();
                if (data.background !== undefined) {
                    if (Number.isInteger(data.background)) object.background = new $e8ea6a63d48a4fea$export$892596cec99bc70e(data.background);
                    else object.background = getTexture(data.background);
                }
                if (data.environment !== undefined) object.environment = getTexture(data.environment);
                if (data.fog !== undefined) {
                    if (data.fog.type === "Fog") object.fog = new $e8ea6a63d48a4fea$export$3c890837b09508d4(data.fog.color, data.fog.near, data.fog.far);
                    else if (data.fog.type === "FogExp2") object.fog = new $e8ea6a63d48a4fea$export$6f1519f023b8d0f6(data.fog.color, data.fog.density);
                }
                if (data.backgroundBlurriness !== undefined) object.backgroundBlurriness = data.backgroundBlurriness;
                if (data.backgroundIntensity !== undefined) object.backgroundIntensity = data.backgroundIntensity;
                break;
            case "PerspectiveCamera":
                object = new $e8ea6a63d48a4fea$export$74e4ae24825f68d7(data.fov, data.aspect, data.near, data.far);
                if (data.focus !== undefined) object.focus = data.focus;
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.filmGauge !== undefined) object.filmGauge = data.filmGauge;
                if (data.filmOffset !== undefined) object.filmOffset = data.filmOffset;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case "OrthographicCamera":
                object = new $e8ea6a63d48a4fea$export$9ebf355ee4ed261b(data.left, data.right, data.top, data.bottom, data.near, data.far);
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case "AmbientLight":
                object = new $e8ea6a63d48a4fea$export$af279bfef9ec2c96(data.color, data.intensity);
                break;
            case "DirectionalLight":
                object = new $e8ea6a63d48a4fea$export$3fea33cc9972c868(data.color, data.intensity);
                break;
            case "PointLight":
                object = new $e8ea6a63d48a4fea$export$4c9c1cb3f0b6f455(data.color, data.intensity, data.distance, data.decay);
                break;
            case "RectAreaLight":
                object = new $e8ea6a63d48a4fea$export$61db2d908bbd2429(data.color, data.intensity, data.width, data.height);
                break;
            case "SpotLight":
                object = new $e8ea6a63d48a4fea$export$81495cbb73897362(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);
                break;
            case "HemisphereLight":
                object = new $e8ea6a63d48a4fea$export$8d474f55edbb9624(data.color, data.groundColor, data.intensity);
                break;
            case "LightProbe":
                object = new $e8ea6a63d48a4fea$export$e7ef036e309b38d2().fromJSON(data);
                break;
            case "SkinnedMesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $e8ea6a63d48a4fea$export$b303577035157ecf(geometry, material);
                if (data.bindMode !== undefined) object.bindMode = data.bindMode;
                if (data.bindMatrix !== undefined) object.bindMatrix.fromArray(data.bindMatrix);
                if (data.skeleton !== undefined) object.skeleton = data.skeleton;
                break;
            case "Mesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $e8ea6a63d48a4fea$export$e176487c05830cc5(geometry, material);
                break;
            case "InstancedMesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                const count = data.count;
                const instanceMatrix = data.instanceMatrix;
                const instanceColor = data.instanceColor;
                object = new $e8ea6a63d48a4fea$export$f3c979c331175ad7(geometry, material, count);
                object.instanceMatrix = new $e8ea6a63d48a4fea$export$32ea87a8b54d744a(new Float32Array(instanceMatrix.array), 16);
                if (instanceColor !== undefined) object.instanceColor = new $e8ea6a63d48a4fea$export$32ea87a8b54d744a(new Float32Array(instanceColor.array), instanceColor.itemSize);
                break;
            case "LOD":
                object = new $e8ea6a63d48a4fea$export$112e7237be0c5f30();
                break;
            case "Line":
                object = new $e8ea6a63d48a4fea$export$17d680238e50603e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "LineLoop":
                object = new $e8ea6a63d48a4fea$export$f85a24d745e4f17d(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "LineSegments":
                object = new $e8ea6a63d48a4fea$export$ff1ed10fedfdd604(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "PointCloud":
            case "Points":
                object = new $e8ea6a63d48a4fea$export$1c787534cb11aa3e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "Sprite":
                object = new $e8ea6a63d48a4fea$export$3075603db8e6204c(getMaterial(data.material));
                break;
            case "Group":
                object = new $e8ea6a63d48a4fea$export$eb2fcfdbd7ba97d4();
                break;
            case "Bone":
                object = new $e8ea6a63d48a4fea$export$b127726e56765aa4();
                break;
            default:
                object = new $e8ea6a63d48a4fea$export$e4dd07dff30cc924();
        }
        object.uuid = data.uuid;
        if (data.name !== undefined) object.name = data.name;
        if (data.matrix !== undefined) {
            object.matrix.fromArray(data.matrix);
            if (data.matrixAutoUpdate !== undefined) object.matrixAutoUpdate = data.matrixAutoUpdate;
            if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
        } else {
            if (data.position !== undefined) object.position.fromArray(data.position);
            if (data.rotation !== undefined) object.rotation.fromArray(data.rotation);
            if (data.quaternion !== undefined) object.quaternion.fromArray(data.quaternion);
            if (data.scale !== undefined) object.scale.fromArray(data.scale);
        }
        if (data.up !== undefined) object.up.fromArray(data.up);
        if (data.castShadow !== undefined) object.castShadow = data.castShadow;
        if (data.receiveShadow !== undefined) object.receiveShadow = data.receiveShadow;
        if (data.shadow) {
            if (data.shadow.bias !== undefined) object.shadow.bias = data.shadow.bias;
            if (data.shadow.normalBias !== undefined) object.shadow.normalBias = data.shadow.normalBias;
            if (data.shadow.radius !== undefined) object.shadow.radius = data.shadow.radius;
            if (data.shadow.mapSize !== undefined) object.shadow.mapSize.fromArray(data.shadow.mapSize);
            if (data.shadow.camera !== undefined) object.shadow.camera = this.parseObject(data.shadow.camera);
        }
        if (data.visible !== undefined) object.visible = data.visible;
        if (data.frustumCulled !== undefined) object.frustumCulled = data.frustumCulled;
        if (data.renderOrder !== undefined) object.renderOrder = data.renderOrder;
        if (data.userData !== undefined) object.userData = data.userData;
        if (data.layers !== undefined) object.layers.mask = data.layers;
        if (data.children !== undefined) {
            const children = data.children;
            for(let i = 0; i < children.length; i++)object.add(this.parseObject(children[i], geometries, materials, textures, animations));
        }
        if (data.animations !== undefined) {
            const objectAnimations = data.animations;
            for(let i = 0; i < objectAnimations.length; i++){
                const uuid = objectAnimations[i];
                object.animations.push(animations[uuid]);
            }
        }
        if (data.type === "LOD") {
            if (data.autoUpdate !== undefined) object.autoUpdate = data.autoUpdate;
            const levels = data.levels;
            for(let l = 0; l < levels.length; l++){
                const level = levels[l];
                const child = object.getObjectByProperty("uuid", level.object);
                if (child !== undefined) object.addLevel(child, level.distance, level.hysteresis);
            }
        }
        return object;
    }
    bindSkeletons(object, skeletons) {
        if (Object.keys(skeletons).length === 0) return;
        object.traverse(function(child) {
            if (child.isSkinnedMesh === true && child.skeleton !== undefined) {
                const skeleton = skeletons[child.skeleton];
                if (skeleton === undefined) console.warn("THREE.ObjectLoader: No skeleton found with UUID:", child.skeleton);
                else child.bind(skeleton, child.bindMatrix);
            }
        });
    }
}
const $e8ea6a63d48a4fea$var$TEXTURE_MAPPING = {
    UVMapping: $e8ea6a63d48a4fea$export$1beec6768cbb3d2d,
    CubeReflectionMapping: $e8ea6a63d48a4fea$export$8759762a6477f2c4,
    CubeRefractionMapping: $e8ea6a63d48a4fea$export$dc59f8aed047f61d,
    EquirectangularReflectionMapping: $e8ea6a63d48a4fea$export$d64030b316d3b087,
    EquirectangularRefractionMapping: $e8ea6a63d48a4fea$export$ee99d97d46898098,
    CubeUVReflectionMapping: $e8ea6a63d48a4fea$export$dbf3e70ff37af79
};
const $e8ea6a63d48a4fea$var$TEXTURE_WRAPPING = {
    RepeatWrapping: $e8ea6a63d48a4fea$export$533346c8e8dac0f5,
    ClampToEdgeWrapping: $e8ea6a63d48a4fea$export$9d9334239a5a5e06,
    MirroredRepeatWrapping: $e8ea6a63d48a4fea$export$c7e7c00b14f51a4f
};
const $e8ea6a63d48a4fea$var$TEXTURE_FILTER = {
    NearestFilter: $e8ea6a63d48a4fea$export$727aa5ec3fe39bf0,
    NearestMipmapNearestFilter: $e8ea6a63d48a4fea$export$d129e38cf6feaa8c,
    NearestMipmapLinearFilter: $e8ea6a63d48a4fea$export$d2327c1afe5bfdf2,
    LinearFilter: $e8ea6a63d48a4fea$export$8a72f490b25c56c8,
    LinearMipmapNearestFilter: $e8ea6a63d48a4fea$export$19a719f377145a13,
    LinearMipmapLinearFilter: $e8ea6a63d48a4fea$export$5d8599b6a933fb1b
};
class $e8ea6a63d48a4fea$export$52286b55c4a9b51f extends $e8ea6a63d48a4fea$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        this.isImageBitmapLoader = true;
        if (typeof createImageBitmap === "undefined") console.warn("THREE.ImageBitmapLoader: createImageBitmap() not supported.");
        if (typeof fetch === "undefined") console.warn("THREE.ImageBitmapLoader: fetch() not supported.");
        this.options = {
            premultiplyAlpha: "none"
        };
    }
    setOptions(options) {
        this.options = options;
        return this;
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = "";
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $e8ea6a63d48a4fea$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const fetchOptions = {};
        fetchOptions.credentials = this.crossOrigin === "anonymous" ? "same-origin" : "include";
        fetchOptions.headers = this.requestHeader;
        fetch(url, fetchOptions).then(function(res) {
            return res.blob();
        }).then(function(blob) {
            return createImageBitmap(blob, Object.assign(scope.options, {
                colorSpaceConversion: "none"
            }));
        }).then(function(imageBitmap) {
            $e8ea6a63d48a4fea$export$94affb487e701bf2.add(url, imageBitmap);
            if (onLoad) onLoad(imageBitmap);
            scope.manager.itemEnd(url);
        }).catch(function(e) {
            if (onError) onError(e);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        });
        scope.manager.itemStart(url);
    }
}
let $e8ea6a63d48a4fea$var$_context;
class $e8ea6a63d48a4fea$export$fcbc63750ec2a81f {
    static getContext() {
        if ($e8ea6a63d48a4fea$var$_context === undefined) $e8ea6a63d48a4fea$var$_context = new (window.AudioContext || window.webkitAudioContext)();
        return $e8ea6a63d48a4fea$var$_context;
    }
    static setContext(value) {
        $e8ea6a63d48a4fea$var$_context = value;
    }
}
class $e8ea6a63d48a4fea$export$d8d5fccfbf47714e extends $e8ea6a63d48a4fea$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $e8ea6a63d48a4fea$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType("arraybuffer");
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(buffer) {
            try {
                // Create a copy of the buffer. The `decodeAudioData` method
                // detaches the buffer when complete, preventing reuse.
                const bufferCopy = buffer.slice(0);
                const context = $e8ea6a63d48a4fea$export$fcbc63750ec2a81f.getContext();
                context.decodeAudioData(bufferCopy, function(audioBuffer) {
                    onLoad(audioBuffer);
                });
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
}
class $e8ea6a63d48a4fea$export$2f22dadc8bc42820 extends $e8ea6a63d48a4fea$export$e7ef036e309b38d2 {
    constructor(skyColor, groundColor, intensity = 1){
        super(undefined, intensity);
        this.isHemisphereLightProbe = true;
        const color1 = new $e8ea6a63d48a4fea$export$892596cec99bc70e().set(skyColor);
        const color2 = new $e8ea6a63d48a4fea$export$892596cec99bc70e().set(groundColor);
        const sky = new $e8ea6a63d48a4fea$export$64b5c384219d3699(color1.r, color1.g, color1.b);
        const ground = new $e8ea6a63d48a4fea$export$64b5c384219d3699(color2.r, color2.g, color2.b);
        // without extra factor of PI in the shader, should = 1 / Math.sqrt( Math.PI );
        const c0 = Math.sqrt(Math.PI);
        const c1 = c0 * Math.sqrt(0.75);
        this.sh.coefficients[0].copy(sky).add(ground).multiplyScalar(c0);
        this.sh.coefficients[1].copy(sky).sub(ground).multiplyScalar(c1);
    }
}
class $e8ea6a63d48a4fea$export$afe310a21c86023d extends $e8ea6a63d48a4fea$export$e7ef036e309b38d2 {
    constructor(color, intensity = 1){
        super(undefined, intensity);
        this.isAmbientLightProbe = true;
        const color1 = new $e8ea6a63d48a4fea$export$892596cec99bc70e().set(color);
        // without extra factor of PI in the shader, would be 2 / Math.sqrt( Math.PI );
        this.sh.coefficients[0].set(color1.r, color1.g, color1.b).multiplyScalar(2 * Math.sqrt(Math.PI));
    }
}
const $e8ea6a63d48a4fea$var$_eyeRight = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5();
const $e8ea6a63d48a4fea$var$_eyeLeft = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5();
const $e8ea6a63d48a4fea$var$_projectionMatrix = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5();
class $e8ea6a63d48a4fea$export$bc7f73a1065bee0c {
    constructor(){
        this.type = "StereoCamera";
        this.aspect = 1;
        this.eyeSep = 0.064;
        this.cameraL = new $e8ea6a63d48a4fea$export$74e4ae24825f68d7();
        this.cameraL.layers.enable(1);
        this.cameraL.matrixAutoUpdate = false;
        this.cameraR = new $e8ea6a63d48a4fea$export$74e4ae24825f68d7();
        this.cameraR.layers.enable(2);
        this.cameraR.matrixAutoUpdate = false;
        this._cache = {
            focus: null,
            fov: null,
            aspect: null,
            near: null,
            far: null,
            zoom: null,
            eyeSep: null
        };
    }
    update(camera) {
        const cache = this._cache;
        const needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;
        if (needsUpdate) {
            cache.focus = camera.focus;
            cache.fov = camera.fov;
            cache.aspect = camera.aspect * this.aspect;
            cache.near = camera.near;
            cache.far = camera.far;
            cache.zoom = camera.zoom;
            cache.eyeSep = this.eyeSep;
            // Off-axis stereoscopic effect based on
            // http://paulbourke.net/stereographics/stereorender/
            $e8ea6a63d48a4fea$var$_projectionMatrix.copy(camera.projectionMatrix);
            const eyeSepHalf = cache.eyeSep / 2;
            const eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
            const ymax = cache.near * Math.tan($e8ea6a63d48a4fea$var$DEG2RAD * cache.fov * 0.5) / cache.zoom;
            let xmin, xmax;
            // translate xOffset
            $e8ea6a63d48a4fea$var$_eyeLeft.elements[12] = -eyeSepHalf;
            $e8ea6a63d48a4fea$var$_eyeRight.elements[12] = eyeSepHalf;
            // for left eye
            xmin = -ymax * cache.aspect + eyeSepOnProjection;
            xmax = ymax * cache.aspect + eyeSepOnProjection;
            $e8ea6a63d48a4fea$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $e8ea6a63d48a4fea$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraL.projectionMatrix.copy($e8ea6a63d48a4fea$var$_projectionMatrix);
            // for right eye
            xmin = -ymax * cache.aspect - eyeSepOnProjection;
            xmax = ymax * cache.aspect - eyeSepOnProjection;
            $e8ea6a63d48a4fea$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $e8ea6a63d48a4fea$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraR.projectionMatrix.copy($e8ea6a63d48a4fea$var$_projectionMatrix);
        }
        this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply($e8ea6a63d48a4fea$var$_eyeLeft);
        this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply($e8ea6a63d48a4fea$var$_eyeRight);
    }
}
class $e8ea6a63d48a4fea$export$9735c82c4bae3302 {
    constructor(autoStart = true){
        this.autoStart = autoStart;
        this.startTime = 0;
        this.oldTime = 0;
        this.elapsedTime = 0;
        this.running = false;
    }
    start() {
        this.startTime = $e8ea6a63d48a4fea$var$now();
        this.oldTime = this.startTime;
        this.elapsedTime = 0;
        this.running = true;
    }
    stop() {
        this.getElapsedTime();
        this.running = false;
        this.autoStart = false;
    }
    getElapsedTime() {
        this.getDelta();
        return this.elapsedTime;
    }
    getDelta() {
        let diff = 0;
        if (this.autoStart && !this.running) {
            this.start();
            return 0;
        }
        if (this.running) {
            const newTime = $e8ea6a63d48a4fea$var$now();
            diff = (newTime - this.oldTime) / 1000;
            this.oldTime = newTime;
            this.elapsedTime += diff;
        }
        return diff;
    }
}
function $e8ea6a63d48a4fea$var$now() {
    return (typeof performance === "undefined" ? Date : performance).now(); // see #10732
}
const $e8ea6a63d48a4fea$var$_position$1 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_quaternion$1 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$23d6a54f0bbc85a3();
const $e8ea6a63d48a4fea$var$_scale$1 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_orientation$1 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
class $e8ea6a63d48a4fea$export$8a1b810c6fde8951 extends $e8ea6a63d48a4fea$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.type = "AudioListener";
        this.context = $e8ea6a63d48a4fea$export$fcbc63750ec2a81f.getContext();
        this.gain = this.context.createGain();
        this.gain.connect(this.context.destination);
        this.filter = null;
        this.timeDelta = 0;
        // private
        this._clock = new $e8ea6a63d48a4fea$export$9735c82c4bae3302();
    }
    getInput() {
        return this.gain;
    }
    removeFilter() {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
            this.gain.connect(this.context.destination);
            this.filter = null;
        }
        return this;
    }
    getFilter() {
        return this.filter;
    }
    setFilter(value) {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
        } else this.gain.disconnect(this.context.destination);
        this.filter = value;
        this.gain.connect(this.filter);
        this.filter.connect(this.context.destination);
        return this;
    }
    getMasterVolume() {
        return this.gain.gain.value;
    }
    setMasterVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        const listener = this.context.listener;
        const up = this.up;
        this.timeDelta = this._clock.getDelta();
        this.matrixWorld.decompose($e8ea6a63d48a4fea$var$_position$1, $e8ea6a63d48a4fea$var$_quaternion$1, $e8ea6a63d48a4fea$var$_scale$1);
        $e8ea6a63d48a4fea$var$_orientation$1.set(0, 0, -1).applyQuaternion($e8ea6a63d48a4fea$var$_quaternion$1);
        if (listener.positionX) {
            // code path for Chrome (see #14393)
            const endTime = this.context.currentTime + this.timeDelta;
            listener.positionX.linearRampToValueAtTime($e8ea6a63d48a4fea$var$_position$1.x, endTime);
            listener.positionY.linearRampToValueAtTime($e8ea6a63d48a4fea$var$_position$1.y, endTime);
            listener.positionZ.linearRampToValueAtTime($e8ea6a63d48a4fea$var$_position$1.z, endTime);
            listener.forwardX.linearRampToValueAtTime($e8ea6a63d48a4fea$var$_orientation$1.x, endTime);
            listener.forwardY.linearRampToValueAtTime($e8ea6a63d48a4fea$var$_orientation$1.y, endTime);
            listener.forwardZ.linearRampToValueAtTime($e8ea6a63d48a4fea$var$_orientation$1.z, endTime);
            listener.upX.linearRampToValueAtTime(up.x, endTime);
            listener.upY.linearRampToValueAtTime(up.y, endTime);
            listener.upZ.linearRampToValueAtTime(up.z, endTime);
        } else {
            listener.setPosition($e8ea6a63d48a4fea$var$_position$1.x, $e8ea6a63d48a4fea$var$_position$1.y, $e8ea6a63d48a4fea$var$_position$1.z);
            listener.setOrientation($e8ea6a63d48a4fea$var$_orientation$1.x, $e8ea6a63d48a4fea$var$_orientation$1.y, $e8ea6a63d48a4fea$var$_orientation$1.z, up.x, up.y, up.z);
        }
    }
}
class $e8ea6a63d48a4fea$export$153755f98d9861de extends $e8ea6a63d48a4fea$export$e4dd07dff30cc924 {
    constructor(listener){
        super();
        this.type = "Audio";
        this.listener = listener;
        this.context = listener.context;
        this.gain = this.context.createGain();
        this.gain.connect(listener.getInput());
        this.autoplay = false;
        this.buffer = null;
        this.detune = 0;
        this.loop = false;
        this.loopStart = 0;
        this.loopEnd = 0;
        this.offset = 0;
        this.duration = undefined;
        this.playbackRate = 1;
        this.isPlaying = false;
        this.hasPlaybackControl = true;
        this.source = null;
        this.sourceType = "empty";
        this._startedAt = 0;
        this._progress = 0;
        this._connected = false;
        this.filters = [];
    }
    getOutput() {
        return this.gain;
    }
    setNodeSource(audioNode) {
        this.hasPlaybackControl = false;
        this.sourceType = "audioNode";
        this.source = audioNode;
        this.connect();
        return this;
    }
    setMediaElementSource(mediaElement) {
        this.hasPlaybackControl = false;
        this.sourceType = "mediaNode";
        this.source = this.context.createMediaElementSource(mediaElement);
        this.connect();
        return this;
    }
    setMediaStreamSource(mediaStream) {
        this.hasPlaybackControl = false;
        this.sourceType = "mediaStreamNode";
        this.source = this.context.createMediaStreamSource(mediaStream);
        this.connect();
        return this;
    }
    setBuffer(audioBuffer) {
        this.buffer = audioBuffer;
        this.sourceType = "buffer";
        if (this.autoplay) this.play();
        return this;
    }
    play(delay = 0) {
        if (this.isPlaying === true) {
            console.warn("THREE.Audio: Audio is already playing.");
            return;
        }
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this._startedAt = this.context.currentTime + delay;
        const source = this.context.createBufferSource();
        source.buffer = this.buffer;
        source.loop = this.loop;
        source.loopStart = this.loopStart;
        source.loopEnd = this.loopEnd;
        source.onended = this.onEnded.bind(this);
        source.start(this._startedAt, this._progress + this.offset, this.duration);
        this.isPlaying = true;
        this.source = source;
        this.setDetune(this.detune);
        this.setPlaybackRate(this.playbackRate);
        return this.connect();
    }
    pause() {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        if (this.isPlaying === true) {
            // update current progress
            this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
            if (this.loop === true) // ensure _progress does not exceed duration with looped audios
            this._progress = this._progress % (this.duration || this.buffer.duration);
            this.source.stop();
            this.source.onended = null;
            this.isPlaying = false;
        }
        return this;
    }
    stop() {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this._progress = 0;
        if (this.source !== null) {
            this.source.stop();
            this.source.onended = null;
        }
        this.isPlaying = false;
        return this;
    }
    connect() {
        if (this.filters.length > 0) {
            this.source.connect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].connect(this.filters[i]);
            this.filters[this.filters.length - 1].connect(this.getOutput());
        } else this.source.connect(this.getOutput());
        this._connected = true;
        return this;
    }
    disconnect() {
        if (this.filters.length > 0) {
            this.source.disconnect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].disconnect(this.filters[i]);
            this.filters[this.filters.length - 1].disconnect(this.getOutput());
        } else this.source.disconnect(this.getOutput());
        this._connected = false;
        return this;
    }
    getFilters() {
        return this.filters;
    }
    setFilters(value) {
        if (!value) value = [];
        if (this._connected === true) {
            this.disconnect();
            this.filters = value.slice();
            this.connect();
        } else this.filters = value.slice();
        return this;
    }
    setDetune(value) {
        this.detune = value;
        if (this.source.detune === undefined) return; // only set detune when available
        if (this.isPlaying === true) this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
        return this;
    }
    getDetune() {
        return this.detune;
    }
    getFilter() {
        return this.getFilters()[0];
    }
    setFilter(filter) {
        return this.setFilters(filter ? [
            filter
        ] : []);
    }
    setPlaybackRate(value) {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this.playbackRate = value;
        if (this.isPlaying === true) this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
        return this;
    }
    getPlaybackRate() {
        return this.playbackRate;
    }
    onEnded() {
        this.isPlaying = false;
    }
    getLoop() {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return false;
        }
        return this.loop;
    }
    setLoop(value) {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this.loop = value;
        if (this.isPlaying === true) this.source.loop = this.loop;
        return this;
    }
    setLoopStart(value) {
        this.loopStart = value;
        return this;
    }
    setLoopEnd(value) {
        this.loopEnd = value;
        return this;
    }
    getVolume() {
        return this.gain.gain.value;
    }
    setVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
}
const $e8ea6a63d48a4fea$var$_position = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_quaternion = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$23d6a54f0bbc85a3();
const $e8ea6a63d48a4fea$var$_scale = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_orientation = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
class $e8ea6a63d48a4fea$export$4b3e397ef1832507 extends $e8ea6a63d48a4fea$export$153755f98d9861de {
    constructor(listener){
        super(listener);
        this.panner = this.context.createPanner();
        this.panner.panningModel = "HRTF";
        this.panner.connect(this.gain);
    }
    disconnect() {
        super.disconnect();
        this.panner.disconnect(this.gain);
    }
    getOutput() {
        return this.panner;
    }
    getRefDistance() {
        return this.panner.refDistance;
    }
    setRefDistance(value) {
        this.panner.refDistance = value;
        return this;
    }
    getRolloffFactor() {
        return this.panner.rolloffFactor;
    }
    setRolloffFactor(value) {
        this.panner.rolloffFactor = value;
        return this;
    }
    getDistanceModel() {
        return this.panner.distanceModel;
    }
    setDistanceModel(value) {
        this.panner.distanceModel = value;
        return this;
    }
    getMaxDistance() {
        return this.panner.maxDistance;
    }
    setMaxDistance(value) {
        this.panner.maxDistance = value;
        return this;
    }
    setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
        this.panner.coneInnerAngle = coneInnerAngle;
        this.panner.coneOuterAngle = coneOuterAngle;
        this.panner.coneOuterGain = coneOuterGain;
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.hasPlaybackControl === true && this.isPlaying === false) return;
        this.matrixWorld.decompose($e8ea6a63d48a4fea$var$_position, $e8ea6a63d48a4fea$var$_quaternion, $e8ea6a63d48a4fea$var$_scale);
        $e8ea6a63d48a4fea$var$_orientation.set(0, 0, 1).applyQuaternion($e8ea6a63d48a4fea$var$_quaternion);
        const panner = this.panner;
        if (panner.positionX) {
            // code path for Chrome and Firefox (see #14393)
            const endTime = this.context.currentTime + this.listener.timeDelta;
            panner.positionX.linearRampToValueAtTime($e8ea6a63d48a4fea$var$_position.x, endTime);
            panner.positionY.linearRampToValueAtTime($e8ea6a63d48a4fea$var$_position.y, endTime);
            panner.positionZ.linearRampToValueAtTime($e8ea6a63d48a4fea$var$_position.z, endTime);
            panner.orientationX.linearRampToValueAtTime($e8ea6a63d48a4fea$var$_orientation.x, endTime);
            panner.orientationY.linearRampToValueAtTime($e8ea6a63d48a4fea$var$_orientation.y, endTime);
            panner.orientationZ.linearRampToValueAtTime($e8ea6a63d48a4fea$var$_orientation.z, endTime);
        } else {
            panner.setPosition($e8ea6a63d48a4fea$var$_position.x, $e8ea6a63d48a4fea$var$_position.y, $e8ea6a63d48a4fea$var$_position.z);
            panner.setOrientation($e8ea6a63d48a4fea$var$_orientation.x, $e8ea6a63d48a4fea$var$_orientation.y, $e8ea6a63d48a4fea$var$_orientation.z);
        }
    }
}
class $e8ea6a63d48a4fea$export$d47da1ef3d382827 {
    constructor(audio, fftSize = 2048){
        this.analyser = audio.context.createAnalyser();
        this.analyser.fftSize = fftSize;
        this.data = new Uint8Array(this.analyser.frequencyBinCount);
        audio.getOutput().connect(this.analyser);
    }
    getFrequencyData() {
        this.analyser.getByteFrequencyData(this.data);
        return this.data;
    }
    getAverageFrequency() {
        let value = 0;
        const data = this.getFrequencyData();
        for(let i = 0; i < data.length; i++)value += data[i];
        return value / data.length;
    }
}
class $e8ea6a63d48a4fea$export$dfe0af1ca1acb78a {
    constructor(binding, typeName, valueSize){
        this.binding = binding;
        this.valueSize = valueSize;
        let mixFunction, mixFunctionAdditive, setIdentity;
        // buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
        //
        // interpolators can use .buffer as their .result
        // the data then goes to 'incoming'
        //
        // 'accu0' and 'accu1' are used frame-interleaved for
        // the cumulative result and are compared to detect
        // changes
        //
        // 'orig' stores the original state of the property
        //
        // 'add' is used for additive cumulative results
        //
        // 'work' is optional and is only present for quaternion types. It is used
        // to store intermediate quaternion multiplication results
        switch(typeName){
            case "quaternion":
                mixFunction = this._slerp;
                mixFunctionAdditive = this._slerpAdditive;
                setIdentity = this._setAdditiveIdentityQuaternion;
                this.buffer = new Float64Array(valueSize * 6);
                this._workIndex = 5;
                break;
            case "string":
            case "bool":
                mixFunction = this._select;
                // Use the regular mix function and for additive on these types,
                // additive is not relevant for non-numeric types
                mixFunctionAdditive = this._select;
                setIdentity = this._setAdditiveIdentityOther;
                this.buffer = new Array(valueSize * 5);
                break;
            default:
                mixFunction = this._lerp;
                mixFunctionAdditive = this._lerpAdditive;
                setIdentity = this._setAdditiveIdentityNumeric;
                this.buffer = new Float64Array(valueSize * 5);
        }
        this._mixBufferRegion = mixFunction;
        this._mixBufferRegionAdditive = mixFunctionAdditive;
        this._setIdentity = setIdentity;
        this._origIndex = 3;
        this._addIndex = 4;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        this.useCount = 0;
        this.referenceCount = 0;
    }
    // accumulate data in the 'incoming' region into 'accu<i>'
    accumulate(accuIndex, weight) {
        // note: happily accumulating nothing when weight = 0, the caller knows
        // the weight and shouldn't have made the call in the first place
        const buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
        let currentWeight = this.cumulativeWeight;
        if (currentWeight === 0) {
            // accuN := incoming * weight
            for(let i = 0; i !== stride; ++i)buffer[offset + i] = buffer[i];
            currentWeight = weight;
        } else {
            // accuN := accuN + incoming * weight
            currentWeight += weight;
            const mix = weight / currentWeight;
            this._mixBufferRegion(buffer, offset, 0, mix, stride);
        }
        this.cumulativeWeight = currentWeight;
    }
    // accumulate data in the 'incoming' region into 'add'
    accumulateAdditive(weight) {
        const buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
        if (this.cumulativeWeightAdditive === 0) // add = identity
        this._setIdentity();
        // add := add + incoming * weight
        this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
        this.cumulativeWeightAdditive += weight;
    }
    // apply the state of 'accu<i>' to the binding when accus differ
    apply(accuIndex) {
        const stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        if (weight < 1) {
            // accuN := accuN + original * ( 1 - cumulativeWeight )
            const originalValueOffset = stride * this._origIndex;
            this._mixBufferRegion(buffer, offset, originalValueOffset, 1 - weight, stride);
        }
        if (weightAdditive > 0) // accuN := accuN + additive accuN
        this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
        for(let i = stride, e = stride + stride; i !== e; ++i)if (buffer[i] !== buffer[i + stride]) {
            // value has changed -> update scene graph
            binding.setValue(buffer, offset);
            break;
        }
    }
    // remember the state of the bound property and copy it to both accus
    saveOriginalState() {
        const binding = this.binding;
        const buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
        binding.getValue(buffer, originalValueOffset);
        // accu[0..1] := orig -- initially detect changes against the original
        for(let i = stride, e = originalValueOffset; i !== e; ++i)buffer[i] = buffer[originalValueOffset + i % stride];
        // Add to identity for additive
        this._setIdentity();
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
    }
    // apply the state previously taken via 'saveOriginalState' to the binding
    restoreOriginalState() {
        const originalValueOffset = this.valueSize * 3;
        this.binding.setValue(this.buffer, originalValueOffset);
    }
    _setAdditiveIdentityNumeric() {
        const startIndex = this._addIndex * this.valueSize;
        const endIndex = startIndex + this.valueSize;
        for(let i = startIndex; i < endIndex; i++)this.buffer[i] = 0;
    }
    _setAdditiveIdentityQuaternion() {
        this._setAdditiveIdentityNumeric();
        this.buffer[this._addIndex * this.valueSize + 3] = 1;
    }
    _setAdditiveIdentityOther() {
        const startIndex = this._origIndex * this.valueSize;
        const targetIndex = this._addIndex * this.valueSize;
        for(let i = 0; i < this.valueSize; i++)this.buffer[targetIndex + i] = this.buffer[startIndex + i];
    }
    // mix functions
    _select(buffer, dstOffset, srcOffset, t, stride) {
        if (t >= 0.5) for(let i = 0; i !== stride; ++i)buffer[dstOffset + i] = buffer[srcOffset + i];
    }
    _slerp(buffer, dstOffset, srcOffset, t) {
        $e8ea6a63d48a4fea$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t);
    }
    _slerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        const workOffset = this._workIndex * stride;
        // Store result in intermediate buffer offset
        $e8ea6a63d48a4fea$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
        // Slerp to the intermediate result
        $e8ea6a63d48a4fea$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t);
    }
    _lerp(buffer, dstOffset, srcOffset, t, stride) {
        const s = 1 - t;
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] * s + buffer[srcOffset + i] * t;
        }
    }
    _lerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] + buffer[srcOffset + i] * t;
        }
    }
}
// Characters [].:/ are reserved for track binding syntax.
const $e8ea6a63d48a4fea$var$_RESERVED_CHARS_RE = "\\[\\]\\.:\\/";
const $e8ea6a63d48a4fea$var$_reservedRe = new RegExp("[" + $e8ea6a63d48a4fea$var$_RESERVED_CHARS_RE + "]", "g");
// Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.
const $e8ea6a63d48a4fea$var$_wordChar = "[^" + $e8ea6a63d48a4fea$var$_RESERVED_CHARS_RE + "]";
const $e8ea6a63d48a4fea$var$_wordCharOrDot = "[^" + $e8ea6a63d48a4fea$var$_RESERVED_CHARS_RE.replace("\\.", "") + "]";
// Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.
const $e8ea6a63d48a4fea$var$_directoryRe = /*@__PURE__*/ /((?:WC+[\/:])*)/.source.replace("WC", $e8ea6a63d48a4fea$var$_wordChar);
// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
const $e8ea6a63d48a4fea$var$_nodeRe = /*@__PURE__*/ /(WCOD+)?/.source.replace("WCOD", $e8ea6a63d48a4fea$var$_wordCharOrDot);
// Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.
const $e8ea6a63d48a4fea$var$_objectRe = /*@__PURE__*/ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", $e8ea6a63d48a4fea$var$_wordChar);
// Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.
const $e8ea6a63d48a4fea$var$_propertyRe = /*@__PURE__*/ /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", $e8ea6a63d48a4fea$var$_wordChar);
const $e8ea6a63d48a4fea$var$_trackRe = new RegExp("^" + $e8ea6a63d48a4fea$var$_directoryRe + $e8ea6a63d48a4fea$var$_nodeRe + $e8ea6a63d48a4fea$var$_objectRe + $e8ea6a63d48a4fea$var$_propertyRe + "$");
const $e8ea6a63d48a4fea$var$_supportedObjectNames = [
    "material",
    "materials",
    "bones",
    "map"
];
class $e8ea6a63d48a4fea$var$Composite {
    constructor(targetGroup, path, optionalParsedPath){
        const parsedPath = optionalParsedPath || $e8ea6a63d48a4fea$export$7bf70fcf9f891893.parseTrackName(path);
        this._targetGroup = targetGroup;
        this._bindings = targetGroup.subscribe_(path, parsedPath);
    }
    getValue(array, offset) {
        this.bind(); // bind all binding
        const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
        // and only call .getValue on the first
        if (binding !== undefined) binding.getValue(array, offset);
    }
    setValue(array, offset) {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].setValue(array, offset);
    }
    bind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].bind();
    }
    unbind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].unbind();
    }
}
// Note: This class uses a State pattern on a per-method basis:
// 'bind' sets 'this.getValue' / 'setValue' and shadows the
// prototype version of these methods with one that represents
// the bound state. When the property is not found, the methods
// become no-ops.
class $e8ea6a63d48a4fea$export$7bf70fcf9f891893 {
    constructor(rootNode, path, parsedPath){
        this.path = path;
        this.parsedPath = parsedPath || $e8ea6a63d48a4fea$export$7bf70fcf9f891893.parseTrackName(path);
        this.node = $e8ea6a63d48a4fea$export$7bf70fcf9f891893.findNode(rootNode, this.parsedPath.nodeName);
        this.rootNode = rootNode;
        // initial state of these methods that calls 'bind'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
    static create(root, path, parsedPath) {
        if (!(root && root.isAnimationObjectGroup)) return new $e8ea6a63d48a4fea$export$7bf70fcf9f891893(root, path, parsedPath);
        else return new $e8ea6a63d48a4fea$export$7bf70fcf9f891893.Composite(root, path, parsedPath);
    }
    /**
	 * Replaces spaces with underscores and removes unsupported characters from
	 * node names, to ensure compatibility with parseTrackName().
	 *
	 * @param {string} name Node name to be sanitized.
	 * @return {string}
	 */ static sanitizeNodeName(name) {
        return name.replace(/\s/g, "_").replace($e8ea6a63d48a4fea$var$_reservedRe, "");
    }
    static parseTrackName(trackName) {
        const matches = $e8ea6a63d48a4fea$var$_trackRe.exec(trackName);
        if (matches === null) throw new Error("PropertyBinding: Cannot parse trackName: " + trackName);
        const results = {
            // directoryName: matches[ 1 ], // (tschw) currently unused
            nodeName: matches[2],
            objectName: matches[3],
            objectIndex: matches[4],
            propertyName: matches[5],
            propertyIndex: matches[6]
        };
        const lastDot = results.nodeName && results.nodeName.lastIndexOf(".");
        if (lastDot !== undefined && lastDot !== -1) {
            const objectName = results.nodeName.substring(lastDot + 1);
            // Object names must be checked against an allowlist. Otherwise, there
            // is no way to parse 'foo.bar.baz': 'baz' must be a property, but
            // 'bar' could be the objectName, or part of a nodeName (which can
            // include '.' characters).
            if ($e8ea6a63d48a4fea$var$_supportedObjectNames.indexOf(objectName) !== -1) {
                results.nodeName = results.nodeName.substring(0, lastDot);
                results.objectName = objectName;
            }
        }
        if (results.propertyName === null || results.propertyName.length === 0) throw new Error("PropertyBinding: can not parse propertyName from trackName: " + trackName);
        return results;
    }
    static findNode(root, nodeName) {
        if (nodeName === undefined || nodeName === "" || nodeName === "." || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) return root;
        // search into skeleton bones.
        if (root.skeleton) {
            const bone = root.skeleton.getBoneByName(nodeName);
            if (bone !== undefined) return bone;
        }
        // search into node subtree.
        if (root.children) {
            const searchNodeSubtree = function(children) {
                for(let i = 0; i < children.length; i++){
                    const childNode = children[i];
                    if (childNode.name === nodeName || childNode.uuid === nodeName) return childNode;
                    const result = searchNodeSubtree(childNode.children);
                    if (result) return result;
                }
                return null;
            };
            const subTreeNode = searchNodeSubtree(root.children);
            if (subTreeNode) return subTreeNode;
        }
        return null;
    }
    // these are used to "bind" a nonexistent property
    _getValue_unavailable() {}
    _setValue_unavailable() {}
    // Getters
    _getValue_direct(buffer, offset) {
        buffer[offset] = this.targetObject[this.propertyName];
    }
    _getValue_array(buffer, offset) {
        const source = this.resolvedProperty;
        for(let i = 0, n = source.length; i !== n; ++i)buffer[offset++] = source[i];
    }
    _getValue_arrayElement(buffer, offset) {
        buffer[offset] = this.resolvedProperty[this.propertyIndex];
    }
    _getValue_toArray(buffer, offset) {
        this.resolvedProperty.toArray(buffer, offset);
    }
    // Direct
    _setValue_direct(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
    }
    _setValue_direct_setNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // EntireArray
    _setValue_array(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
    }
    _setValue_array_setNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.needsUpdate = true;
    }
    _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // ArrayElement
    _setValue_arrayElement(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
    }
    _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // HasToFromArray
    _setValue_fromArray(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
    }
    _setValue_fromArray_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.needsUpdate = true;
    }
    _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    _getValue_unbound(targetArray, offset) {
        this.bind();
        this.getValue(targetArray, offset);
    }
    _setValue_unbound(sourceArray, offset) {
        this.bind();
        this.setValue(sourceArray, offset);
    }
    // create getter / setter pair for a property in the scene graph
    bind() {
        let targetObject = this.node;
        const parsedPath = this.parsedPath;
        const objectName = parsedPath.objectName;
        const propertyName = parsedPath.propertyName;
        let propertyIndex = parsedPath.propertyIndex;
        if (!targetObject) {
            targetObject = $e8ea6a63d48a4fea$export$7bf70fcf9f891893.findNode(this.rootNode, parsedPath.nodeName);
            this.node = targetObject;
        }
        // set fail state so we can just 'return' on error
        this.getValue = this._getValue_unavailable;
        this.setValue = this._setValue_unavailable;
        // ensure there is a value node
        if (!targetObject) {
            console.error("THREE.PropertyBinding: Trying to update node for track: " + this.path + " but it wasn't found.");
            return;
        }
        if (objectName) {
            let objectIndex = parsedPath.objectIndex;
            // special cases were we need to reach deeper into the hierarchy to get the face materials....
            switch(objectName){
                case "materials":
                    if (!targetObject.material) {
                        console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                        return;
                    }
                    if (!targetObject.material.materials) {
                        console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
                        return;
                    }
                    targetObject = targetObject.material.materials;
                    break;
                case "bones":
                    if (!targetObject.skeleton) {
                        console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
                        return;
                    }
                    // potential future optimization: skip this if propertyIndex is already an integer
                    // and convert the integer string to a true integer.
                    targetObject = targetObject.skeleton.bones;
                    // support resolving morphTarget names into indices.
                    for(let i = 0; i < targetObject.length; i++)if (targetObject[i].name === objectIndex) {
                        objectIndex = i;
                        break;
                    }
                    break;
                case "map":
                    if ("map" in targetObject) {
                        targetObject = targetObject.map;
                        break;
                    }
                    if (!targetObject.material) {
                        console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                        return;
                    }
                    if (!targetObject.material.map) {
                        console.error("THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.", this);
                        return;
                    }
                    targetObject = targetObject.material.map;
                    break;
                default:
                    if (targetObject[objectName] === undefined) {
                        console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
                        return;
                    }
                    targetObject = targetObject[objectName];
            }
            if (objectIndex !== undefined) {
                if (targetObject[objectIndex] === undefined) {
                    console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, targetObject);
                    return;
                }
                targetObject = targetObject[objectIndex];
            }
        }
        // resolve property
        const nodeProperty = targetObject[propertyName];
        if (nodeProperty === undefined) {
            const nodeName = parsedPath.nodeName;
            console.error("THREE.PropertyBinding: Trying to update property for track: " + nodeName + "." + propertyName + " but it wasn't found.", targetObject);
            return;
        }
        // determine versioning scheme
        let versioning = this.Versioning.None;
        this.targetObject = targetObject;
        if (targetObject.needsUpdate !== undefined) versioning = this.Versioning.NeedsUpdate;
        else if (targetObject.matrixWorldNeedsUpdate !== undefined) versioning = this.Versioning.MatrixWorldNeedsUpdate;
        // determine how the property gets bound
        let bindingType = this.BindingType.Direct;
        if (propertyIndex !== undefined) {
            // access a sub element of the property array (only primitives are supported right now)
            if (propertyName === "morphTargetInfluences") {
                // potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
                // support resolving morphTarget names into indices.
                if (!targetObject.geometry) {
                    console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
                    return;
                }
                if (!targetObject.geometry.morphAttributes) {
                    console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
                    return;
                }
                if (targetObject.morphTargetDictionary[propertyIndex] !== undefined) propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
            }
            bindingType = this.BindingType.ArrayElement;
            this.resolvedProperty = nodeProperty;
            this.propertyIndex = propertyIndex;
        } else if (nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined) {
            // must use copy for Object3D.Euler/Quaternion
            bindingType = this.BindingType.HasFromToArray;
            this.resolvedProperty = nodeProperty;
        } else if (Array.isArray(nodeProperty)) {
            bindingType = this.BindingType.EntireArray;
            this.resolvedProperty = nodeProperty;
        } else this.propertyName = propertyName;
        // select getter / setter
        this.getValue = this.GetterByBindingType[bindingType];
        this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
    }
    unbind() {
        this.node = null;
        // back to the prototype version of getValue / setValue
        // note: avoiding to mutate the shape of 'this' via 'delete'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
}
$e8ea6a63d48a4fea$export$7bf70fcf9f891893.Composite = $e8ea6a63d48a4fea$var$Composite;
$e8ea6a63d48a4fea$export$7bf70fcf9f891893.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
};
$e8ea6a63d48a4fea$export$7bf70fcf9f891893.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
};
$e8ea6a63d48a4fea$export$7bf70fcf9f891893.prototype.GetterByBindingType = [
    $e8ea6a63d48a4fea$export$7bf70fcf9f891893.prototype._getValue_direct,
    $e8ea6a63d48a4fea$export$7bf70fcf9f891893.prototype._getValue_array,
    $e8ea6a63d48a4fea$export$7bf70fcf9f891893.prototype._getValue_arrayElement,
    $e8ea6a63d48a4fea$export$7bf70fcf9f891893.prototype._getValue_toArray
];
$e8ea6a63d48a4fea$export$7bf70fcf9f891893.prototype.SetterByBindingTypeAndVersioning = [
    [
        // Direct
        $e8ea6a63d48a4fea$export$7bf70fcf9f891893.prototype._setValue_direct,
        $e8ea6a63d48a4fea$export$7bf70fcf9f891893.prototype._setValue_direct_setNeedsUpdate,
        $e8ea6a63d48a4fea$export$7bf70fcf9f891893.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        // EntireArray
        $e8ea6a63d48a4fea$export$7bf70fcf9f891893.prototype._setValue_array,
        $e8ea6a63d48a4fea$export$7bf70fcf9f891893.prototype._setValue_array_setNeedsUpdate,
        $e8ea6a63d48a4fea$export$7bf70fcf9f891893.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        // ArrayElement
        $e8ea6a63d48a4fea$export$7bf70fcf9f891893.prototype._setValue_arrayElement,
        $e8ea6a63d48a4fea$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setNeedsUpdate,
        $e8ea6a63d48a4fea$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        // HasToFromArray
        $e8ea6a63d48a4fea$export$7bf70fcf9f891893.prototype._setValue_fromArray,
        $e8ea6a63d48a4fea$export$7bf70fcf9f891893.prototype._setValue_fromArray_setNeedsUpdate,
        $e8ea6a63d48a4fea$export$7bf70fcf9f891893.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
/**
 *
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 *  - Add objects you would otherwise pass as 'root' to the
 *    constructor or the .clipAction method of AnimationMixer.
 *
 *  - Instead pass this object as 'root'.
 *
 *  - You can also add and remove objects later when the mixer
 *    is running.
 *
 * Note:
 *
 *    Objects of this class appear as one object to the mixer,
 *    so cache control of the individual objects must be done
 *    on the group.
 *
 * Limitation:
 *
 *  - The animated properties must be compatible among the
 *    all objects in the group.
 *
 *  - A single property can either be controlled through a
 *    target group or directly, but not both.
 */ class $e8ea6a63d48a4fea$export$30619c2afd3f34db {
    constructor(){
        this.isAnimationObjectGroup = true;
        this.uuid = $e8ea6a63d48a4fea$var$generateUUID();
        // cached objects followed by the active ones
        this._objects = Array.prototype.slice.call(arguments);
        this.nCachedObjects_ = 0; // threshold
        // note: read by PropertyBinding.Composite
        const indices = {};
        this._indicesByUUID = indices; // for bookkeeping
        for(let i = 0, n = arguments.length; i !== n; ++i)indices[arguments[i].uuid] = i;
        this._paths = []; // inside: string
        this._parsedPaths = []; // inside: { we don't care, here }
        this._bindings = []; // inside: Array< PropertyBinding >
        this._bindingsIndicesByPath = {}; // inside: indices in these arrays
        const scope = this;
        this.stats = {
            objects: {
                get total () {
                    return scope._objects.length;
                },
                get inUse () {
                    return this.total - scope.nCachedObjects_;
                }
            },
            get bindingsPerObject () {
                return scope._bindings.length;
            }
        };
    }
    add() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, nBindings = bindings.length;
        let knownObject = undefined, nObjects = objects.length, nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid;
            let index = indicesByUUID[uuid];
            if (index === undefined) {
                // unknown object -> add it to the ACTIVE region
                index = nObjects++;
                indicesByUUID[uuid] = index;
                objects.push(object);
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j)bindings[j].push(new $e8ea6a63d48a4fea$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]));
            } else if (index < nCachedObjects) {
                knownObject = objects[index];
                // move existing object to the ACTIVE region
                const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex];
                indicesByUUID[lastCachedObject.uuid] = index;
                objects[index] = lastCachedObject;
                indicesByUUID[uuid] = firstActiveIndex;
                objects[firstActiveIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex];
                    let binding = bindingsForPath[index];
                    bindingsForPath[index] = lastCached;
                    if (binding === undefined) // since we do not bother to create new bindings
                    // for objects that are cached, the binding may
                    // or may not exist
                    binding = new $e8ea6a63d48a4fea$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]);
                    bindingsForPath[firstActiveIndex] = binding;
                }
            } else if (objects[index] !== knownObject) console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
             // else the object is already where we want it to be
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    remove() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined && index >= nCachedObjects) {
                // move existing object into the CACHED region
                const lastCachedIndex = nCachedObjects++, firstActiveObject = objects[lastCachedIndex];
                indicesByUUID[firstActiveObject.uuid] = index;
                objects[index] = firstActiveObject;
                indicesByUUID[uuid] = lastCachedIndex;
                objects[lastCachedIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], firstActive = bindingsForPath[lastCachedIndex], binding = bindingsForPath[index];
                    bindingsForPath[index] = firstActive;
                    bindingsForPath[lastCachedIndex] = binding;
                }
            }
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // remove & forget
    uncache() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_, nObjects = objects.length;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined) {
                delete indicesByUUID[uuid];
                if (index < nCachedObjects) {
                    // object is cached, shrink the CACHED region
                    const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex], lastIndex = --nObjects, lastObject = objects[lastIndex];
                    // last cached object takes this object's place
                    indicesByUUID[lastCachedObject.uuid] = index;
                    objects[index] = lastCachedObject;
                    // last object goes to the activated slot and pop
                    indicesByUUID[lastObject.uuid] = firstActiveIndex;
                    objects[firstActiveIndex] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex], last = bindingsForPath[lastIndex];
                        bindingsForPath[index] = lastCached;
                        bindingsForPath[firstActiveIndex] = last;
                        bindingsForPath.pop();
                    }
                } else {
                    // object is active, just swap with the last and pop
                    const lastIndex = --nObjects, lastObject = objects[lastIndex];
                    if (lastIndex > 0) indicesByUUID[lastObject.uuid] = index;
                    objects[index] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j];
                        bindingsForPath[index] = bindingsForPath[lastIndex];
                        bindingsForPath.pop();
                    }
                } // cached or active
            } // if object is known
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // Internal interface used by befriended PropertyBinding.Composite:
    subscribe_(path, parsedPath) {
        // returns an array of bindings for the given path that is changed
        // according to the contained objects in the group
        const indicesByPath = this._bindingsIndicesByPath;
        let index = indicesByPath[path];
        const bindings = this._bindings;
        if (index !== undefined) return bindings[index];
        const paths = this._paths, parsedPaths = this._parsedPaths, objects = this._objects, nObjects = objects.length, nCachedObjects = this.nCachedObjects_, bindingsForPath = new Array(nObjects);
        index = bindings.length;
        indicesByPath[path] = index;
        paths.push(path);
        parsedPaths.push(parsedPath);
        bindings.push(bindingsForPath);
        for(let i = nCachedObjects, n = objects.length; i !== n; ++i){
            const object = objects[i];
            bindingsForPath[i] = new $e8ea6a63d48a4fea$export$7bf70fcf9f891893(object, path, parsedPath);
        }
        return bindingsForPath;
    }
    unsubscribe_(path) {
        // tells the group to forget about a property path and no longer
        // update the array previously obtained with 'subscribe_'
        const indicesByPath = this._bindingsIndicesByPath, index = indicesByPath[path];
        if (index !== undefined) {
            const paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, lastBindingsIndex = bindings.length - 1, lastBindings = bindings[lastBindingsIndex], lastBindingsPath = path[lastBindingsIndex];
            indicesByPath[lastBindingsPath] = index;
            bindings[index] = lastBindings;
            bindings.pop();
            parsedPaths[index] = parsedPaths[lastBindingsIndex];
            parsedPaths.pop();
            paths[index] = paths[lastBindingsIndex];
            paths.pop();
        }
    }
}
class $e8ea6a63d48a4fea$export$6946940a69e799e {
    constructor(mixer, clip, localRoot = null, blendMode = clip.blendMode){
        this._mixer = mixer;
        this._clip = clip;
        this._localRoot = localRoot;
        this.blendMode = blendMode;
        const tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
        const interpolantSettings = {
            endingStart: $e8ea6a63d48a4fea$export$7f795934b84ab523,
            endingEnd: $e8ea6a63d48a4fea$export$7f795934b84ab523
        };
        for(let i = 0; i !== nTracks; ++i){
            const interpolant = tracks[i].createInterpolant(null);
            interpolants[i] = interpolant;
            interpolant.settings = interpolantSettings;
        }
        this._interpolantSettings = interpolantSettings;
        this._interpolants = interpolants; // bound by the mixer
        // inside: PropertyMixer (managed by the mixer)
        this._propertyBindings = new Array(nTracks);
        this._cacheIndex = null; // for the memory manager
        this._byClipCacheIndex = null; // for the memory manager
        this._timeScaleInterpolant = null;
        this._weightInterpolant = null;
        this.loop = $e8ea6a63d48a4fea$export$dfaf4422ce096e29;
        this._loopCount = -1;
        // global mixer time when the action is to be started
        // it's set back to 'null' upon start of the action
        this._startTime = null;
        // scaled local time of the action
        // gets clamped or wrapped to 0..clip.duration according to loop
        this.time = 0;
        this.timeScale = 1;
        this._effectiveTimeScale = 1;
        this.weight = 1;
        this._effectiveWeight = 1;
        this.repetitions = Infinity; // no. of repetitions when looping
        this.paused = false; // true -> zero effective time scale
        this.enabled = true; // false -> zero effective weight
        this.clampWhenFinished = false; // keep feeding the last frame?
        this.zeroSlopeAtStart = true; // for smooth interpolation w/o separate
        this.zeroSlopeAtEnd = true; // clips for start, loop and end
    }
    // State & Scheduling
    play() {
        this._mixer._activateAction(this);
        return this;
    }
    stop() {
        this._mixer._deactivateAction(this);
        return this.reset();
    }
    reset() {
        this.paused = false;
        this.enabled = true;
        this.time = 0; // restart clip
        this._loopCount = -1; // forget previous loops
        this._startTime = null; // forget scheduling
        return this.stopFading().stopWarping();
    }
    isRunning() {
        return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
    }
    // return true when play has been called
    isScheduled() {
        return this._mixer._isActiveAction(this);
    }
    startAt(time) {
        this._startTime = time;
        return this;
    }
    setLoop(mode, repetitions) {
        this.loop = mode;
        this.repetitions = repetitions;
        return this;
    }
    // Weight
    // set the weight stopping any scheduled fading
    // although .enabled = false yields an effective weight of zero, this
    // method does *not* change .enabled, because it would be confusing
    setEffectiveWeight(weight) {
        this.weight = weight;
        // note: same logic as when updated at runtime
        this._effectiveWeight = this.enabled ? weight : 0;
        return this.stopFading();
    }
    // return the weight considering fading and .enabled
    getEffectiveWeight() {
        return this._effectiveWeight;
    }
    fadeIn(duration) {
        return this._scheduleFading(duration, 0, 1);
    }
    fadeOut(duration) {
        return this._scheduleFading(duration, 1, 0);
    }
    crossFadeFrom(fadeOutAction, duration, warp) {
        fadeOutAction.fadeOut(duration);
        this.fadeIn(duration);
        if (warp) {
            const fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
            fadeOutAction.warp(1.0, startEndRatio, duration);
            this.warp(endStartRatio, 1.0, duration);
        }
        return this;
    }
    crossFadeTo(fadeInAction, duration, warp) {
        return fadeInAction.crossFadeFrom(this, duration, warp);
    }
    stopFading() {
        const weightInterpolant = this._weightInterpolant;
        if (weightInterpolant !== null) {
            this._weightInterpolant = null;
            this._mixer._takeBackControlInterpolant(weightInterpolant);
        }
        return this;
    }
    // Time Scale Control
    // set the time scale stopping any scheduled warping
    // although .paused = true yields an effective time scale of zero, this
    // method does *not* change .paused, because it would be confusing
    setEffectiveTimeScale(timeScale) {
        this.timeScale = timeScale;
        this._effectiveTimeScale = this.paused ? 0 : timeScale;
        return this.stopWarping();
    }
    // return the time scale considering warping and .paused
    getEffectiveTimeScale() {
        return this._effectiveTimeScale;
    }
    setDuration(duration) {
        this.timeScale = this._clip.duration / duration;
        return this.stopWarping();
    }
    syncWith(action) {
        this.time = action.time;
        this.timeScale = action.timeScale;
        return this.stopWarping();
    }
    halt(duration) {
        return this.warp(this._effectiveTimeScale, 0, duration);
    }
    warp(startTimeScale, endTimeScale, duration) {
        const mixer = this._mixer, now = mixer.time, timeScale = this.timeScale;
        let interpolant = this._timeScaleInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._timeScaleInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        times[1] = now + duration;
        values[0] = startTimeScale / timeScale;
        values[1] = endTimeScale / timeScale;
        return this;
    }
    stopWarping() {
        const timeScaleInterpolant = this._timeScaleInterpolant;
        if (timeScaleInterpolant !== null) {
            this._timeScaleInterpolant = null;
            this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
        }
        return this;
    }
    // Object Accessors
    getMixer() {
        return this._mixer;
    }
    getClip() {
        return this._clip;
    }
    getRoot() {
        return this._localRoot || this._mixer._root;
    }
    // Interna
    _update(time, deltaTime, timeDirection, accuIndex) {
        // called by the mixer
        if (!this.enabled) {
            // call ._updateWeight() to update ._effectiveWeight
            this._updateWeight(time);
            return;
        }
        const startTime = this._startTime;
        if (startTime !== null) {
            // check for scheduled start of action
            const timeRunning = (time - startTime) * timeDirection;
            if (timeRunning < 0 || timeDirection === 0) deltaTime = 0;
            else {
                this._startTime = null; // unschedule
                deltaTime = timeDirection * timeRunning;
            }
        }
        // apply time scale and advance time
        deltaTime *= this._updateTimeScale(time);
        const clipTime = this._updateTime(deltaTime);
        // note: _updateTime may disable the action resulting in
        // an effective weight of 0
        const weight = this._updateWeight(time);
        if (weight > 0) {
            const interpolants = this._interpolants;
            const propertyMixers = this._propertyBindings;
            switch(this.blendMode){
                case $e8ea6a63d48a4fea$export$d875e029ef558d3:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulateAdditive(weight);
                    }
                    break;
                case $e8ea6a63d48a4fea$export$bcfbbdcf8de7f8cd:
                default:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulate(accuIndex, weight);
                    }
            }
        }
    }
    _updateWeight(time) {
        let weight = 0;
        if (this.enabled) {
            weight = this.weight;
            const interpolant = this._weightInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                weight *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopFading();
                    if (interpolantValue === 0) // faded out, disable
                    this.enabled = false;
                }
            }
        }
        this._effectiveWeight = weight;
        return weight;
    }
    _updateTimeScale(time) {
        let timeScale = 0;
        if (!this.paused) {
            timeScale = this.timeScale;
            const interpolant = this._timeScaleInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                timeScale *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopWarping();
                    if (timeScale === 0) // motion has halted, pause
                    this.paused = true;
                    else // warp done - apply final time scale
                    this.timeScale = timeScale;
                }
            }
        }
        this._effectiveTimeScale = timeScale;
        return timeScale;
    }
    _updateTime(deltaTime) {
        const duration = this._clip.duration;
        const loop = this.loop;
        let time = this.time + deltaTime;
        let loopCount = this._loopCount;
        const pingPong = loop === $e8ea6a63d48a4fea$export$f8f6f2041b78e210;
        if (deltaTime === 0) {
            if (loopCount === -1) return time;
            return pingPong && (loopCount & 1) === 1 ? duration - time : time;
        }
        if (loop === $e8ea6a63d48a4fea$export$d62fdc9d1b1cccad) {
            if (loopCount === -1) {
                // just started
                this._loopCount = 0;
                this._setEndings(true, true, false);
            }
            handle_stop: {
                if (time >= duration) time = duration;
                else if (time < 0) time = 0;
                else {
                    this.time = time;
                    break handle_stop;
                }
                if (this.clampWhenFinished) this.paused = true;
                else this.enabled = false;
                this.time = time;
                this._mixer.dispatchEvent({
                    type: "finished",
                    action: this,
                    direction: deltaTime < 0 ? -1 : 1
                });
            }
        } else {
            if (loopCount === -1) {
                // just started
                if (deltaTime >= 0) {
                    loopCount = 0;
                    this._setEndings(true, this.repetitions === 0, pingPong);
                } else // when looping in reverse direction, the initial
                // transition through zero counts as a repetition,
                // so leave loopCount at -1
                this._setEndings(this.repetitions === 0, true, pingPong);
            }
            if (time >= duration || time < 0) {
                // wrap around
                const loopDelta = Math.floor(time / duration); // signed
                time -= duration * loopDelta;
                loopCount += Math.abs(loopDelta);
                const pending = this.repetitions - loopCount;
                if (pending <= 0) {
                    // have to stop (switch state, clamp time, fire event)
                    if (this.clampWhenFinished) this.paused = true;
                    else this.enabled = false;
                    time = deltaTime > 0 ? duration : 0;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: "finished",
                        action: this,
                        direction: deltaTime > 0 ? 1 : -1
                    });
                } else {
                    // keep running
                    if (pending === 1) {
                        // entering the last round
                        const atStart = deltaTime < 0;
                        this._setEndings(atStart, !atStart, pingPong);
                    } else this._setEndings(false, false, pingPong);
                    this._loopCount = loopCount;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: "loop",
                        action: this,
                        loopDelta: loopDelta
                    });
                }
            } else this.time = time;
            if (pingPong && (loopCount & 1) === 1) // invert time for the "pong round"
            return duration - time;
        }
        return time;
    }
    _setEndings(atStart, atEnd, pingPong) {
        const settings = this._interpolantSettings;
        if (pingPong) {
            settings.endingStart = $e8ea6a63d48a4fea$export$24a4ccb5099273b5;
            settings.endingEnd = $e8ea6a63d48a4fea$export$24a4ccb5099273b5;
        } else {
            // assuming for LoopOnce atStart == atEnd == true
            if (atStart) settings.endingStart = this.zeroSlopeAtStart ? $e8ea6a63d48a4fea$export$24a4ccb5099273b5 : $e8ea6a63d48a4fea$export$7f795934b84ab523;
            else settings.endingStart = $e8ea6a63d48a4fea$export$8e8c3ecdcd8e1fee;
            if (atEnd) settings.endingEnd = this.zeroSlopeAtEnd ? $e8ea6a63d48a4fea$export$24a4ccb5099273b5 : $e8ea6a63d48a4fea$export$7f795934b84ab523;
            else settings.endingEnd = $e8ea6a63d48a4fea$export$8e8c3ecdcd8e1fee;
        }
    }
    _scheduleFading(duration, weightNow, weightThen) {
        const mixer = this._mixer, now = mixer.time;
        let interpolant = this._weightInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._weightInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        values[0] = weightNow;
        times[1] = now + duration;
        values[1] = weightThen;
        return this;
    }
}
const $e8ea6a63d48a4fea$var$_controlInterpolantsResultBuffer = new Float32Array(1);
class $e8ea6a63d48a4fea$export$fbd77e5aefaa0102 extends $e8ea6a63d48a4fea$export$ec8b666c5fe2c75a {
    constructor(root){
        super();
        this._root = root;
        this._initMemoryManager();
        this._accuIndex = 0;
        this.time = 0;
        this.timeScale = 1.0;
    }
    _bindAction(action, prototypeAction) {
        const root = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root.uuid, bindingsByRoot = this._bindingsByRootAndName;
        let bindingsByName = bindingsByRoot[rootUuid];
        if (bindingsByName === undefined) {
            bindingsByName = {};
            bindingsByRoot[rootUuid] = bindingsByName;
        }
        for(let i = 0; i !== nTracks; ++i){
            const track = tracks[i], trackName = track.name;
            let binding = bindingsByName[trackName];
            if (binding !== undefined) {
                ++binding.referenceCount;
                bindings[i] = binding;
            } else {
                binding = bindings[i];
                if (binding !== undefined) {
                    // existing binding, make sure the cache knows
                    if (binding._cacheIndex === null) {
                        ++binding.referenceCount;
                        this._addInactiveBinding(binding, rootUuid, trackName);
                    }
                    continue;
                }
                const path = prototypeAction && prototypeAction._propertyBindings[i].binding.parsedPath;
                binding = new $e8ea6a63d48a4fea$export$dfe0af1ca1acb78a($e8ea6a63d48a4fea$export$7bf70fcf9f891893.create(root, trackName, path), track.ValueTypeName, track.getValueSize());
                ++binding.referenceCount;
                this._addInactiveBinding(binding, rootUuid, trackName);
                bindings[i] = binding;
            }
            interpolants[i].resultBuffer = binding.buffer;
        }
    }
    _activateAction(action) {
        if (!this._isActiveAction(action)) {
            if (action._cacheIndex === null) {
                // this action has been forgotten by the cache, but the user
                // appears to be still using it -> rebind
                const rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
                this._bindAction(action, actionsForClip && actionsForClip.knownActions[0]);
                this._addInactiveAction(action, clipUuid, rootUuid);
            }
            const bindings = action._propertyBindings;
            // increment reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (binding.useCount++ === 0) {
                    this._lendBinding(binding);
                    binding.saveOriginalState();
                }
            }
            this._lendAction(action);
        }
    }
    _deactivateAction(action) {
        if (this._isActiveAction(action)) {
            const bindings = action._propertyBindings;
            // decrement reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (--binding.useCount === 0) {
                    binding.restoreOriginalState();
                    this._takeBackBinding(binding);
                }
            }
            this._takeBackAction(action);
        }
    }
    // Memory manager
    _initMemoryManager() {
        this._actions = []; // 'nActiveActions' followed by inactive ones
        this._nActiveActions = 0;
        this._actionsByClip = {};
        // inside:
        // {
        // 	knownActions: Array< AnimationAction > - used as prototypes
        // 	actionByRoot: AnimationAction - lookup
        // }
        this._bindings = []; // 'nActiveBindings' followed by inactive ones
        this._nActiveBindings = 0;
        this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
        this._controlInterpolants = []; // same game as above
        this._nActiveControlInterpolants = 0;
        const scope = this;
        this.stats = {
            actions: {
                get total () {
                    return scope._actions.length;
                },
                get inUse () {
                    return scope._nActiveActions;
                }
            },
            bindings: {
                get total () {
                    return scope._bindings.length;
                },
                get inUse () {
                    return scope._nActiveBindings;
                }
            },
            controlInterpolants: {
                get total () {
                    return scope._controlInterpolants.length;
                },
                get inUse () {
                    return scope._nActiveControlInterpolants;
                }
            }
        };
    }
    // Memory management for AnimationAction objects
    _isActiveAction(action) {
        const index = action._cacheIndex;
        return index !== null && index < this._nActiveActions;
    }
    _addInactiveAction(action, clipUuid, rootUuid) {
        const actions = this._actions, actionsByClip = this._actionsByClip;
        let actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip === undefined) {
            actionsForClip = {
                knownActions: [
                    action
                ],
                actionByRoot: {}
            };
            action._byClipCacheIndex = 0;
            actionsByClip[clipUuid] = actionsForClip;
        } else {
            const knownActions = actionsForClip.knownActions;
            action._byClipCacheIndex = knownActions.length;
            knownActions.push(action);
        }
        action._cacheIndex = actions.length;
        actions.push(action);
        actionsForClip.actionByRoot[rootUuid] = action;
    }
    _removeInactiveAction(action) {
        const actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
        lastInactiveAction._cacheIndex = cacheIndex;
        actions[cacheIndex] = lastInactiveAction;
        actions.pop();
        action._cacheIndex = null;
        const clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
        lastKnownAction._byClipCacheIndex = byClipCacheIndex;
        knownActionsForClip[byClipCacheIndex] = lastKnownAction;
        knownActionsForClip.pop();
        action._byClipCacheIndex = null;
        const actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
        delete actionByRoot[rootUuid];
        if (knownActionsForClip.length === 0) delete actionsByClip[clipUuid];
        this._removeInactiveBindingsForAction(action);
    }
    _removeInactiveBindingsForAction(action) {
        const bindings = action._propertyBindings;
        for(let i = 0, n = bindings.length; i !== n; ++i){
            const binding = bindings[i];
            if (--binding.referenceCount === 0) this._removeInactiveBinding(binding);
        }
    }
    _lendAction(action) {
        // [ active actions |  inactive actions  ]
        // [  active actions >| inactive actions ]
        //                 s        a
        //                  <-swap->
        //                 a        s
        const actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
        action._cacheIndex = lastActiveIndex;
        actions[lastActiveIndex] = action;
        firstInactiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = firstInactiveAction;
    }
    _takeBackAction(action) {
        // [  active actions  | inactive actions ]
        // [ active actions |< inactive actions  ]
        //        a        s
        //         <-swap->
        //        s        a
        const actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
        action._cacheIndex = firstInactiveIndex;
        actions[firstInactiveIndex] = action;
        lastActiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = lastActiveAction;
    }
    // Memory management for PropertyMixer objects
    _addInactiveBinding(binding, rootUuid, trackName) {
        const bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
        let bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName === undefined) {
            bindingByName = {};
            bindingsByRoot[rootUuid] = bindingByName;
        }
        bindingByName[trackName] = binding;
        binding._cacheIndex = bindings.length;
        bindings.push(binding);
    }
    _removeInactiveBinding(binding) {
        const bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
        lastInactiveBinding._cacheIndex = cacheIndex;
        bindings[cacheIndex] = lastInactiveBinding;
        bindings.pop();
        delete bindingByName[trackName];
        if (Object.keys(bindingByName).length === 0) delete bindingsByRoot[rootUuid];
    }
    _lendBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
        binding._cacheIndex = lastActiveIndex;
        bindings[lastActiveIndex] = binding;
        firstInactiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = firstInactiveBinding;
    }
    _takeBackBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
        binding._cacheIndex = firstInactiveIndex;
        bindings[firstInactiveIndex] = binding;
        lastActiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = lastActiveBinding;
    }
    // Memory management of Interpolants for weight and time scale
    _lendControlInterpolant() {
        const interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
        let interpolant = interpolants[lastActiveIndex];
        if (interpolant === undefined) {
            interpolant = new $e8ea6a63d48a4fea$export$a8e6009059f51e1a(new Float32Array(2), new Float32Array(2), 1, $e8ea6a63d48a4fea$var$_controlInterpolantsResultBuffer);
            interpolant.__cacheIndex = lastActiveIndex;
            interpolants[lastActiveIndex] = interpolant;
        }
        return interpolant;
    }
    _takeBackControlInterpolant(interpolant) {
        const interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
        interpolant.__cacheIndex = firstInactiveIndex;
        interpolants[firstInactiveIndex] = interpolant;
        lastActiveInterpolant.__cacheIndex = prevIndex;
        interpolants[prevIndex] = lastActiveInterpolant;
    }
    // return an action for a clip optionally using a custom root target
    // object (this method allocates a lot of dynamic memory in case a
    // previously unknown clip/root combination is specified)
    clipAction(clip, optionalRoot, blendMode) {
        const root = optionalRoot || this._root, rootUuid = root.uuid;
        let clipObject = typeof clip === "string" ? $e8ea6a63d48a4fea$export$d942c706bf23829c.findByName(root, clip) : clip;
        const clipUuid = clipObject !== null ? clipObject.uuid : clip;
        const actionsForClip = this._actionsByClip[clipUuid];
        let prototypeAction = null;
        if (blendMode === undefined) {
            if (clipObject !== null) blendMode = clipObject.blendMode;
            else blendMode = $e8ea6a63d48a4fea$export$bcfbbdcf8de7f8cd;
        }
        if (actionsForClip !== undefined) {
            const existingAction = actionsForClip.actionByRoot[rootUuid];
            if (existingAction !== undefined && existingAction.blendMode === blendMode) return existingAction;
            // we know the clip, so we don't have to parse all
            // the bindings again but can just copy
            prototypeAction = actionsForClip.knownActions[0];
            // also, take the clip from the prototype action
            if (clipObject === null) clipObject = prototypeAction._clip;
        }
        // clip must be known when specified via string
        if (clipObject === null) return null;
        // allocate all resources required to run it
        const newAction = new $e8ea6a63d48a4fea$export$6946940a69e799e(this, clipObject, optionalRoot, blendMode);
        this._bindAction(newAction, prototypeAction);
        // and make the action known to the memory manager
        this._addInactiveAction(newAction, clipUuid, rootUuid);
        return newAction;
    }
    // get an existing action
    existingAction(clip, optionalRoot) {
        const root = optionalRoot || this._root, rootUuid = root.uuid, clipObject = typeof clip === "string" ? $e8ea6a63d48a4fea$export$d942c706bf23829c.findByName(root, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
        if (actionsForClip !== undefined) return actionsForClip.actionByRoot[rootUuid] || null;
        return null;
    }
    // deactivates all previously scheduled actions
    stopAllAction() {
        const actions = this._actions, nActions = this._nActiveActions;
        for(let i = nActions - 1; i >= 0; --i)actions[i].stop();
        return this;
    }
    // advance the time and update apply the animation
    update(deltaTime) {
        deltaTime *= this.timeScale;
        const actions = this._actions, nActions = this._nActiveActions, time = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
        // run active actions
        for(let i = 0; i !== nActions; ++i){
            const action = actions[i];
            action._update(time, deltaTime, timeDirection, accuIndex);
        }
        // update scene graph
        const bindings = this._bindings, nBindings = this._nActiveBindings;
        for(let i = 0; i !== nBindings; ++i)bindings[i].apply(accuIndex);
        return this;
    }
    // Allows you to seek to a specific time in an animation.
    setTime(timeInSeconds) {
        this.time = 0; // Zero out time attribute for AnimationMixer object;
        for(let i = 0; i < this._actions.length; i++)this._actions[i].time = 0; // Zero out time attribute for all associated AnimationAction objects.
        return this.update(timeInSeconds); // Update used to set exact time. Returns "this" AnimationMixer object.
    }
    // return this mixer's root target object
    getRoot() {
        return this._root;
    }
    // free all resources specific to a particular clip
    uncacheClip(clip) {
        const actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip !== undefined) {
            // note: just calling _removeInactiveAction would mess up the
            // iteration state and also require updating the state we can
            // just throw away
            const actionsToRemove = actionsForClip.knownActions;
            for(let i = 0, n = actionsToRemove.length; i !== n; ++i){
                const action = actionsToRemove[i];
                this._deactivateAction(action);
                const cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
                action._cacheIndex = null;
                action._byClipCacheIndex = null;
                lastInactiveAction._cacheIndex = cacheIndex;
                actions[cacheIndex] = lastInactiveAction;
                actions.pop();
                this._removeInactiveBindingsForAction(action);
            }
            delete actionsByClip[clipUuid];
        }
    }
    // free all resources specific to a particular root target object
    uncacheRoot(root) {
        const rootUuid = root.uuid, actionsByClip = this._actionsByClip;
        for(const clipUuid in actionsByClip){
            const actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
            if (action !== undefined) {
                this._deactivateAction(action);
                this._removeInactiveAction(action);
            }
        }
        const bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName !== undefined) for(const trackName in bindingByName){
            const binding = bindingByName[trackName];
            binding.restoreOriginalState();
            this._removeInactiveBinding(binding);
        }
    }
    // remove a targeted clip from the cache
    uncacheAction(clip, optionalRoot) {
        const action = this.existingAction(clip, optionalRoot);
        if (action !== null) {
            this._deactivateAction(action);
            this._removeInactiveAction(action);
        }
    }
}
class $e8ea6a63d48a4fea$export$2947cebfe91c02f8 {
    constructor(value){
        this.value = value;
    }
    clone() {
        return new $e8ea6a63d48a4fea$export$2947cebfe91c02f8(this.value.clone === undefined ? this.value : this.value.clone());
    }
}
let $e8ea6a63d48a4fea$var$id = 0;
class $e8ea6a63d48a4fea$export$c412d5ffe1f79209 extends $e8ea6a63d48a4fea$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isUniformsGroup = true;
        Object.defineProperty(this, "id", {
            value: $e8ea6a63d48a4fea$var$id++
        });
        this.name = "";
        this.usage = $e8ea6a63d48a4fea$export$763e8360f4d7f77d;
        this.uniforms = [];
    }
    add(uniform) {
        this.uniforms.push(uniform);
        return this;
    }
    remove(uniform) {
        const index = this.uniforms.indexOf(uniform);
        if (index !== -1) this.uniforms.splice(index, 1);
        return this;
    }
    setName(name) {
        this.name = name;
        return this;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
        return this;
    }
    copy(source) {
        this.name = source.name;
        this.usage = source.usage;
        const uniformsSource = source.uniforms;
        this.uniforms.length = 0;
        for(let i = 0, l = uniformsSource.length; i < l; i++)this.uniforms.push(uniformsSource[i].clone());
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $e8ea6a63d48a4fea$export$25ec0e1af1389358 extends $e8ea6a63d48a4fea$export$3d5cd879f108f53f {
    constructor(array, stride, meshPerAttribute = 1){
        super(array, stride);
        this.isInstancedInterleavedBuffer = true;
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    clone(data) {
        const ib = super.clone(data);
        ib.meshPerAttribute = this.meshPerAttribute;
        return ib;
    }
    toJSON(data) {
        const json = super.toJSON(data);
        json.isInstancedInterleavedBuffer = true;
        json.meshPerAttribute = this.meshPerAttribute;
        return json;
    }
}
class $e8ea6a63d48a4fea$export$6b7339ae8dbddf73 {
    constructor(buffer, type, itemSize, elementSize, count){
        this.isGLBufferAttribute = true;
        this.name = "";
        this.buffer = buffer;
        this.type = type;
        this.itemSize = itemSize;
        this.elementSize = elementSize;
        this.count = count;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setBuffer(buffer) {
        this.buffer = buffer;
        return this;
    }
    setType(type, elementSize) {
        this.type = type;
        this.elementSize = elementSize;
        return this;
    }
    setItemSize(itemSize) {
        this.itemSize = itemSize;
        return this;
    }
    setCount(count) {
        this.count = count;
        return this;
    }
}
class $e8ea6a63d48a4fea$export$8b7aaceff00bd2f {
    constructor(origin, direction, near = 0, far = Infinity){
        this.ray = new $e8ea6a63d48a4fea$export$a186db52eed6d40e(origin, direction);
        // direction is assumed to be normalized (for accurate distance calculations)
        this.near = near;
        this.far = far;
        this.camera = null;
        this.layers = new $e8ea6a63d48a4fea$export$89312ce47c0ca777();
        this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    set(origin, direction) {
        // direction is assumed to be normalized (for accurate distance calculations)
        this.ray.set(origin, direction);
    }
    setFromCamera(coords, camera) {
        if (camera.isPerspectiveCamera) {
            this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
            this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
            this.camera = camera;
        } else if (camera.isOrthographicCamera) {
            this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera
            this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
            this.camera = camera;
        } else console.error("THREE.Raycaster: Unsupported camera type: " + camera.type);
    }
    intersectObject(object, recursive = true, intersects = []) {
        $e8ea6a63d48a4fea$var$intersectObject(object, this, intersects, recursive);
        intersects.sort($e8ea6a63d48a4fea$var$ascSort);
        return intersects;
    }
    intersectObjects(objects, recursive = true, intersects = []) {
        for(let i = 0, l = objects.length; i < l; i++)$e8ea6a63d48a4fea$var$intersectObject(objects[i], this, intersects, recursive);
        intersects.sort($e8ea6a63d48a4fea$var$ascSort);
        return intersects;
    }
}
function $e8ea6a63d48a4fea$var$ascSort(a, b) {
    return a.distance - b.distance;
}
function $e8ea6a63d48a4fea$var$intersectObject(object, raycaster, intersects, recursive) {
    if (object.layers.test(raycaster.layers)) object.raycast(raycaster, intersects);
    if (recursive === true) {
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)$e8ea6a63d48a4fea$var$intersectObject(children[i], raycaster, intersects, true);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
 *
 * The polar angle (phi) is measured from the positive y-axis. The positive y-axis is up.
 * The azimuthal angle (theta) is measured from the positive z-axis.
 */ class $e8ea6a63d48a4fea$export$d712cd887b4a00f7 {
    constructor(radius = 1, phi = 0, theta = 0){
        this.radius = radius;
        this.phi = phi; // polar angle
        this.theta = theta; // azimuthal angle
        return this;
    }
    set(radius, phi, theta) {
        this.radius = radius;
        this.phi = phi;
        this.theta = theta;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.phi = other.phi;
        this.theta = other.theta;
        return this;
    }
    // restrict phi to be between EPS and PI-EPS
    makeSafe() {
        const EPS = 0.000001;
        this.phi = Math.max(EPS, Math.min(Math.PI - EPS, this.phi));
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + y * y + z * z);
        if (this.radius === 0) {
            this.theta = 0;
            this.phi = 0;
        } else {
            this.theta = Math.atan2(x, z);
            this.phi = Math.acos($e8ea6a63d48a4fea$var$clamp(y / this.radius, -1, 1));
        }
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system
 */ class $e8ea6a63d48a4fea$export$287165bb2177f4fd {
    constructor(radius = 1, theta = 0, y = 0){
        this.radius = radius; // distance from the origin to a point in the x-z plane
        this.theta = theta; // counterclockwise angle in the x-z plane measured in radians from the positive z-axis
        this.y = y; // height above the x-z plane
        return this;
    }
    set(radius, theta, y) {
        this.radius = radius;
        this.theta = theta;
        this.y = y;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.theta = other.theta;
        this.y = other.y;
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + z * z);
        this.theta = Math.atan2(x, z);
        this.y = y;
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $e8ea6a63d48a4fea$var$_vector$4 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$c977b3e384af9ae1();
class $e8ea6a63d48a4fea$export$60f553fa130f08b0 {
    constructor(min = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(Infinity, Infinity), max = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(-Infinity, -Infinity)){
        this.isBox2 = true;
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $e8ea6a63d48a4fea$var$_vector$4.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = Infinity;
        this.max.x = this.max.y = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y));
    }
    intersectsBox(box) {
        // using 4 splitting planes to rule out intersections
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y ? false : true;
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        return this.clampPoint(point, $e8ea6a63d48a4fea$var$_vector$4).distanceTo(point);
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $e8ea6a63d48a4fea$var$_startP = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_startEnd = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
class $e8ea6a63d48a4fea$export$e0ba6359f1954fd3 {
    constructor(start = new $e8ea6a63d48a4fea$export$64b5c384219d3699(), end = new $e8ea6a63d48a4fea$export$64b5c384219d3699()){
        this.start = start;
        this.end = end;
    }
    set(start, end) {
        this.start.copy(start);
        this.end.copy(end);
        return this;
    }
    copy(line) {
        this.start.copy(line.start);
        this.end.copy(line.end);
        return this;
    }
    getCenter(target) {
        return target.addVectors(this.start, this.end).multiplyScalar(0.5);
    }
    delta(target) {
        return target.subVectors(this.end, this.start);
    }
    distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    distance() {
        return this.start.distanceTo(this.end);
    }
    at(t, target) {
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    closestPointToPointParameter(point, clampToLine) {
        $e8ea6a63d48a4fea$var$_startP.subVectors(point, this.start);
        $e8ea6a63d48a4fea$var$_startEnd.subVectors(this.end, this.start);
        const startEnd2 = $e8ea6a63d48a4fea$var$_startEnd.dot($e8ea6a63d48a4fea$var$_startEnd);
        const startEnd_startP = $e8ea6a63d48a4fea$var$_startEnd.dot($e8ea6a63d48a4fea$var$_startP);
        let t = startEnd_startP / startEnd2;
        if (clampToLine) t = $e8ea6a63d48a4fea$var$clamp(t, 0, 1);
        return t;
    }
    closestPointToPoint(point, clampToLine, target) {
        const t = this.closestPointToPointParameter(point, clampToLine);
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    applyMatrix4(matrix) {
        this.start.applyMatrix4(matrix);
        this.end.applyMatrix4(matrix);
        return this;
    }
    equals(line) {
        return line.start.equals(this.start) && line.end.equals(this.end);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $e8ea6a63d48a4fea$var$_vector$3 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
class $e8ea6a63d48a4fea$export$4b14638ffdd81e68 extends $e8ea6a63d48a4fea$export$e4dd07dff30cc924 {
    constructor(light, color){
        super();
        this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = "SpotLightHelper";
        const geometry = new $e8ea6a63d48a4fea$export$b7be63a67df8959();
        const positions = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(let i = 0, j = 1, l = 32; i < l; i++, j++){
            const p1 = i / l * Math.PI * 2;
            const p2 = j / l * Math.PI * 2;
            positions.push(Math.cos(p1), Math.sin(p1), 1, Math.cos(p2), Math.sin(p2), 1);
        }
        geometry.setAttribute("position", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(positions, 3));
        const material = new $e8ea6a63d48a4fea$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.cone = new $e8ea6a63d48a4fea$export$ff1ed10fedfdd604(geometry, material);
        this.add(this.cone);
        this.update();
    }
    dispose() {
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        const coneLength = this.light.distance ? this.light.distance : 1000;
        const coneWidth = coneLength * Math.tan(this.light.angle);
        this.cone.scale.set(coneWidth, coneWidth, coneLength);
        $e8ea6a63d48a4fea$var$_vector$3.setFromMatrixPosition(this.light.target.matrixWorld);
        this.cone.lookAt($e8ea6a63d48a4fea$var$_vector$3);
        if (this.color !== undefined) this.cone.material.color.set(this.color);
        else this.cone.material.color.copy(this.light.color);
    }
}
const $e8ea6a63d48a4fea$var$_vector$2 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_boneMatrix = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5();
const $e8ea6a63d48a4fea$var$_matrixWorldInv = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5();
class $e8ea6a63d48a4fea$export$5277df3c9e732259 extends $e8ea6a63d48a4fea$export$ff1ed10fedfdd604 {
    constructor(object){
        const bones = $e8ea6a63d48a4fea$var$getBoneList(object);
        const geometry = new $e8ea6a63d48a4fea$export$b7be63a67df8959();
        const vertices = [];
        const colors = [];
        const color1 = new $e8ea6a63d48a4fea$export$892596cec99bc70e(0, 0, 1);
        const color2 = new $e8ea6a63d48a4fea$export$892596cec99bc70e(0, 1, 0);
        for(let i = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                vertices.push(0, 0, 0);
                vertices.push(0, 0, 0);
                colors.push(color1.r, color1.g, color1.b);
                colors.push(color2.r, color2.g, color2.b);
            }
        }
        geometry.setAttribute("position", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(colors, 3));
        const material = new $e8ea6a63d48a4fea$export$fbaaa33907730a0c({
            vertexColors: true,
            depthTest: false,
            depthWrite: false,
            toneMapped: false,
            transparent: true
        });
        super(geometry, material);
        this.isSkeletonHelper = true;
        this.type = "SkeletonHelper";
        this.root = object;
        this.bones = bones;
        this.matrix = object.matrixWorld;
        this.matrixAutoUpdate = false;
    }
    updateMatrixWorld(force) {
        const bones = this.bones;
        const geometry = this.geometry;
        const position = geometry.getAttribute("position");
        $e8ea6a63d48a4fea$var$_matrixWorldInv.copy(this.root.matrixWorld).invert();
        for(let i = 0, j = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                $e8ea6a63d48a4fea$var$_boneMatrix.multiplyMatrices($e8ea6a63d48a4fea$var$_matrixWorldInv, bone.matrixWorld);
                $e8ea6a63d48a4fea$var$_vector$2.setFromMatrixPosition($e8ea6a63d48a4fea$var$_boneMatrix);
                position.setXYZ(j, $e8ea6a63d48a4fea$var$_vector$2.x, $e8ea6a63d48a4fea$var$_vector$2.y, $e8ea6a63d48a4fea$var$_vector$2.z);
                $e8ea6a63d48a4fea$var$_boneMatrix.multiplyMatrices($e8ea6a63d48a4fea$var$_matrixWorldInv, bone.parent.matrixWorld);
                $e8ea6a63d48a4fea$var$_vector$2.setFromMatrixPosition($e8ea6a63d48a4fea$var$_boneMatrix);
                position.setXYZ(j + 1, $e8ea6a63d48a4fea$var$_vector$2.x, $e8ea6a63d48a4fea$var$_vector$2.y, $e8ea6a63d48a4fea$var$_vector$2.z);
                j += 2;
            }
        }
        geometry.getAttribute("position").needsUpdate = true;
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $e8ea6a63d48a4fea$var$getBoneList(object) {
    const boneList = [];
    if (object.isBone === true) boneList.push(object);
    for(let i = 0; i < object.children.length; i++)boneList.push.apply(boneList, $e8ea6a63d48a4fea$var$getBoneList(object.children[i]));
    return boneList;
}
class $e8ea6a63d48a4fea$export$9a9291685b9e4023 extends $e8ea6a63d48a4fea$export$e176487c05830cc5 {
    constructor(light, sphereSize, color){
        const geometry = new $e8ea6a63d48a4fea$export$1b417fc3b307a251(sphereSize, 4, 2);
        const material = new $e8ea6a63d48a4fea$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        super(geometry, material);
        this.light = light;
        this.color = color;
        this.type = "PointLightHelper";
        this.matrix = this.light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.update();
    /*
	// TODO: delete this comment?
	const distanceGeometry = new THREE.IcosahedronGeometry( 1, 2 );
	const distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );

	this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
	this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );

	const d = light.distance;

	if ( d === 0.0 ) {

		this.lightDistance.visible = false;

	} else {

		this.lightDistance.scale.set( d, d, d );

	}

	this.add( this.lightDistance );
	*/ }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        if (this.color !== undefined) this.material.color.set(this.color);
        else this.material.color.copy(this.light.color);
    /*
		const d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/ }
}
const $e8ea6a63d48a4fea$var$_vector$1 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_color1 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$892596cec99bc70e();
const $e8ea6a63d48a4fea$var$_color2 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$892596cec99bc70e();
class $e8ea6a63d48a4fea$export$8dca15f13f4f8172 extends $e8ea6a63d48a4fea$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = "HemisphereLightHelper";
        const geometry = new $e8ea6a63d48a4fea$export$1954e2b809fe361e(size);
        geometry.rotateY(Math.PI * 0.5);
        this.material = new $e8ea6a63d48a4fea$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        if (this.color === undefined) this.material.vertexColors = true;
        const position = geometry.getAttribute("position");
        const colors = new Float32Array(position.count * 3);
        geometry.setAttribute("color", new $e8ea6a63d48a4fea$export$8dea267bd6bde117(colors, 3));
        this.add(new $e8ea6a63d48a4fea$export$e176487c05830cc5(geometry, this.material));
        this.update();
    }
    dispose() {
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
    update() {
        const mesh = this.children[0];
        if (this.color !== undefined) this.material.color.set(this.color);
        else {
            const colors = mesh.geometry.getAttribute("color");
            $e8ea6a63d48a4fea$var$_color1.copy(this.light.color);
            $e8ea6a63d48a4fea$var$_color2.copy(this.light.groundColor);
            for(let i = 0, l = colors.count; i < l; i++){
                const color = i < l / 2 ? $e8ea6a63d48a4fea$var$_color1 : $e8ea6a63d48a4fea$var$_color2;
                colors.setXYZ(i, color.r, color.g, color.b);
            }
            colors.needsUpdate = true;
        }
        this.light.updateWorldMatrix(true, false);
        mesh.lookAt($e8ea6a63d48a4fea$var$_vector$1.setFromMatrixPosition(this.light.matrixWorld).negate());
    }
}
class $e8ea6a63d48a4fea$export$3875d39926561055 extends $e8ea6a63d48a4fea$export$ff1ed10fedfdd604 {
    constructor(size = 10, divisions = 10, color1 = 0x444444, color2 = 0x888888){
        color1 = new $e8ea6a63d48a4fea$export$892596cec99bc70e(color1);
        color2 = new $e8ea6a63d48a4fea$export$892596cec99bc70e(color2);
        const center = divisions / 2;
        const step = size / divisions;
        const halfSize = size / 2;
        const vertices = [], colors = [];
        for(let i = 0, j = 0, k = -halfSize; i <= divisions; i++, k += step){
            vertices.push(-halfSize, 0, k, halfSize, 0, k);
            vertices.push(k, 0, -halfSize, k, 0, halfSize);
            const color = i === center ? color1 : color2;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
        }
        const geometry = new $e8ea6a63d48a4fea$export$b7be63a67df8959();
        geometry.setAttribute("position", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(colors, 3));
        const material = new $e8ea6a63d48a4fea$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = "GridHelper";
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $e8ea6a63d48a4fea$export$361430a10f533cd3 extends $e8ea6a63d48a4fea$export$ff1ed10fedfdd604 {
    constructor(radius = 10, sectors = 16, rings = 8, divisions = 64, color1 = 0x444444, color2 = 0x888888){
        color1 = new $e8ea6a63d48a4fea$export$892596cec99bc70e(color1);
        color2 = new $e8ea6a63d48a4fea$export$892596cec99bc70e(color2);
        const vertices = [];
        const colors = [];
        // create the sectors
        if (sectors > 1) for(let i = 0; i < sectors; i++){
            const v = i / sectors * (Math.PI * 2);
            const x = Math.sin(v) * radius;
            const z = Math.cos(v) * radius;
            vertices.push(0, 0, 0);
            vertices.push(x, 0, z);
            const color = i & 1 ? color1 : color2;
            colors.push(color.r, color.g, color.b);
            colors.push(color.r, color.g, color.b);
        }
        // create the rings
        for(let i = 0; i < rings; i++){
            const color = i & 1 ? color1 : color2;
            const r = radius - radius / rings * i;
            for(let j = 0; j < divisions; j++){
                // first vertex
                let v = j / divisions * (Math.PI * 2);
                let x = Math.sin(v) * r;
                let z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
                // second vertex
                v = (j + 1) / divisions * (Math.PI * 2);
                x = Math.sin(v) * r;
                z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
            }
        }
        const geometry = new $e8ea6a63d48a4fea$export$b7be63a67df8959();
        geometry.setAttribute("position", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(colors, 3));
        const material = new $e8ea6a63d48a4fea$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = "PolarGridHelper";
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
const $e8ea6a63d48a4fea$var$_v1 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_v2 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_v3 = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
class $e8ea6a63d48a4fea$export$f8e434dc14203e7d extends $e8ea6a63d48a4fea$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = "DirectionalLightHelper";
        if (size === undefined) size = 1;
        let geometry = new $e8ea6a63d48a4fea$export$b7be63a67df8959();
        geometry.setAttribute("position", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd([
            -size,
            size,
            0,
            size,
            size,
            0,
            size,
            -size,
            0,
            -size,
            -size,
            0,
            -size,
            size,
            0
        ], 3));
        const material = new $e8ea6a63d48a4fea$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.lightPlane = new $e8ea6a63d48a4fea$export$17d680238e50603e(geometry, material);
        this.add(this.lightPlane);
        geometry = new $e8ea6a63d48a4fea$export$b7be63a67df8959();
        geometry.setAttribute("position", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3));
        this.targetLine = new $e8ea6a63d48a4fea$export$17d680238e50603e(geometry, material);
        this.add(this.targetLine);
        this.update();
    }
    dispose() {
        this.lightPlane.geometry.dispose();
        this.lightPlane.material.dispose();
        this.targetLine.geometry.dispose();
        this.targetLine.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        $e8ea6a63d48a4fea$var$_v1.setFromMatrixPosition(this.light.matrixWorld);
        $e8ea6a63d48a4fea$var$_v2.setFromMatrixPosition(this.light.target.matrixWorld);
        $e8ea6a63d48a4fea$var$_v3.subVectors($e8ea6a63d48a4fea$var$_v2, $e8ea6a63d48a4fea$var$_v1);
        this.lightPlane.lookAt($e8ea6a63d48a4fea$var$_v2);
        if (this.color !== undefined) {
            this.lightPlane.material.color.set(this.color);
            this.targetLine.material.color.set(this.color);
        } else {
            this.lightPlane.material.color.copy(this.light.color);
            this.targetLine.material.color.copy(this.light.color);
        }
        this.targetLine.lookAt($e8ea6a63d48a4fea$var$_v2);
        this.targetLine.scale.z = $e8ea6a63d48a4fea$var$_v3.length();
    }
}
const $e8ea6a63d48a4fea$var$_vector = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
const $e8ea6a63d48a4fea$var$_camera = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$79f141de891a5fed();
/**
 *	- shows frustum, line of sight and up of the camera
 *	- suitable for fast updates
 * 	- based on frustum visualization in lightgl.js shadowmap example
 *		https://github.com/evanw/lightgl.js/blob/master/tests/shadowmap.html
 */ class $e8ea6a63d48a4fea$export$ed8e93f853cd795 extends $e8ea6a63d48a4fea$export$ff1ed10fedfdd604 {
    constructor(camera){
        const geometry = new $e8ea6a63d48a4fea$export$b7be63a67df8959();
        const material = new $e8ea6a63d48a4fea$export$fbaaa33907730a0c({
            color: 0xffffff,
            vertexColors: true,
            toneMapped: false
        });
        const vertices = [];
        const colors = [];
        const pointMap = {};
        // near
        addLine("n1", "n2");
        addLine("n2", "n4");
        addLine("n4", "n3");
        addLine("n3", "n1");
        // far
        addLine("f1", "f2");
        addLine("f2", "f4");
        addLine("f4", "f3");
        addLine("f3", "f1");
        // sides
        addLine("n1", "f1");
        addLine("n2", "f2");
        addLine("n3", "f3");
        addLine("n4", "f4");
        // cone
        addLine("p", "n1");
        addLine("p", "n2");
        addLine("p", "n3");
        addLine("p", "n4");
        // up
        addLine("u1", "u2");
        addLine("u2", "u3");
        addLine("u3", "u1");
        // target
        addLine("c", "t");
        addLine("p", "c");
        // cross
        addLine("cn1", "cn2");
        addLine("cn3", "cn4");
        addLine("cf1", "cf2");
        addLine("cf3", "cf4");
        function addLine(a, b) {
            addPoint(a);
            addPoint(b);
        }
        function addPoint(id) {
            vertices.push(0, 0, 0);
            colors.push(0, 0, 0);
            if (pointMap[id] === undefined) pointMap[id] = [];
            pointMap[id].push(vertices.length / 3 - 1);
        }
        geometry.setAttribute("position", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(colors, 3));
        super(geometry, material);
        this.type = "CameraHelper";
        this.camera = camera;
        if (this.camera.updateProjectionMatrix) this.camera.updateProjectionMatrix();
        this.matrix = camera.matrixWorld;
        this.matrixAutoUpdate = false;
        this.pointMap = pointMap;
        this.update();
        // colors
        const colorFrustum = new $e8ea6a63d48a4fea$export$892596cec99bc70e(0xffaa00);
        const colorCone = new $e8ea6a63d48a4fea$export$892596cec99bc70e(0xff0000);
        const colorUp = new $e8ea6a63d48a4fea$export$892596cec99bc70e(0x00aaff);
        const colorTarget = new $e8ea6a63d48a4fea$export$892596cec99bc70e(0xffffff);
        const colorCross = new $e8ea6a63d48a4fea$export$892596cec99bc70e(0x333333);
        this.setColors(colorFrustum, colorCone, colorUp, colorTarget, colorCross);
    }
    setColors(frustum, cone, up, target, cross) {
        const geometry = this.geometry;
        const colorAttribute = geometry.getAttribute("color");
        // near
        colorAttribute.setXYZ(0, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(1, frustum.r, frustum.g, frustum.b); // n1, n2
        colorAttribute.setXYZ(2, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(3, frustum.r, frustum.g, frustum.b); // n2, n4
        colorAttribute.setXYZ(4, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(5, frustum.r, frustum.g, frustum.b); // n4, n3
        colorAttribute.setXYZ(6, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(7, frustum.r, frustum.g, frustum.b); // n3, n1
        // far
        colorAttribute.setXYZ(8, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(9, frustum.r, frustum.g, frustum.b); // f1, f2
        colorAttribute.setXYZ(10, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(11, frustum.r, frustum.g, frustum.b); // f2, f4
        colorAttribute.setXYZ(12, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(13, frustum.r, frustum.g, frustum.b); // f4, f3
        colorAttribute.setXYZ(14, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(15, frustum.r, frustum.g, frustum.b); // f3, f1
        // sides
        colorAttribute.setXYZ(16, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(17, frustum.r, frustum.g, frustum.b); // n1, f1
        colorAttribute.setXYZ(18, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(19, frustum.r, frustum.g, frustum.b); // n2, f2
        colorAttribute.setXYZ(20, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(21, frustum.r, frustum.g, frustum.b); // n3, f3
        colorAttribute.setXYZ(22, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(23, frustum.r, frustum.g, frustum.b); // n4, f4
        // cone
        colorAttribute.setXYZ(24, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(25, cone.r, cone.g, cone.b); // p, n1
        colorAttribute.setXYZ(26, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(27, cone.r, cone.g, cone.b); // p, n2
        colorAttribute.setXYZ(28, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(29, cone.r, cone.g, cone.b); // p, n3
        colorAttribute.setXYZ(30, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(31, cone.r, cone.g, cone.b); // p, n4
        // up
        colorAttribute.setXYZ(32, up.r, up.g, up.b);
        colorAttribute.setXYZ(33, up.r, up.g, up.b); // u1, u2
        colorAttribute.setXYZ(34, up.r, up.g, up.b);
        colorAttribute.setXYZ(35, up.r, up.g, up.b); // u2, u3
        colorAttribute.setXYZ(36, up.r, up.g, up.b);
        colorAttribute.setXYZ(37, up.r, up.g, up.b); // u3, u1
        // target
        colorAttribute.setXYZ(38, target.r, target.g, target.b);
        colorAttribute.setXYZ(39, target.r, target.g, target.b); // c, t
        colorAttribute.setXYZ(40, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(41, cross.r, cross.g, cross.b); // p, c
        // cross
        colorAttribute.setXYZ(42, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(43, cross.r, cross.g, cross.b); // cn1, cn2
        colorAttribute.setXYZ(44, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(45, cross.r, cross.g, cross.b); // cn3, cn4
        colorAttribute.setXYZ(46, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(47, cross.r, cross.g, cross.b); // cf1, cf2
        colorAttribute.setXYZ(48, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(49, cross.r, cross.g, cross.b); // cf3, cf4
        colorAttribute.needsUpdate = true;
    }
    update() {
        const geometry = this.geometry;
        const pointMap = this.pointMap;
        const w = 1, h = 1;
        // we need just camera projection matrix inverse
        // world matrix must be identity
        $e8ea6a63d48a4fea$var$_camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
        // center / target
        $e8ea6a63d48a4fea$var$setPoint("c", pointMap, geometry, $e8ea6a63d48a4fea$var$_camera, 0, 0, -1);
        $e8ea6a63d48a4fea$var$setPoint("t", pointMap, geometry, $e8ea6a63d48a4fea$var$_camera, 0, 0, 1);
        // near
        $e8ea6a63d48a4fea$var$setPoint("n1", pointMap, geometry, $e8ea6a63d48a4fea$var$_camera, -w, -h, -1);
        $e8ea6a63d48a4fea$var$setPoint("n2", pointMap, geometry, $e8ea6a63d48a4fea$var$_camera, w, -h, -1);
        $e8ea6a63d48a4fea$var$setPoint("n3", pointMap, geometry, $e8ea6a63d48a4fea$var$_camera, -w, h, -1);
        $e8ea6a63d48a4fea$var$setPoint("n4", pointMap, geometry, $e8ea6a63d48a4fea$var$_camera, w, h, -1);
        // far
        $e8ea6a63d48a4fea$var$setPoint("f1", pointMap, geometry, $e8ea6a63d48a4fea$var$_camera, -w, -h, 1);
        $e8ea6a63d48a4fea$var$setPoint("f2", pointMap, geometry, $e8ea6a63d48a4fea$var$_camera, w, -h, 1);
        $e8ea6a63d48a4fea$var$setPoint("f3", pointMap, geometry, $e8ea6a63d48a4fea$var$_camera, -w, h, 1);
        $e8ea6a63d48a4fea$var$setPoint("f4", pointMap, geometry, $e8ea6a63d48a4fea$var$_camera, w, h, 1);
        // up
        $e8ea6a63d48a4fea$var$setPoint("u1", pointMap, geometry, $e8ea6a63d48a4fea$var$_camera, w * 0.7, h * 1.1, -1);
        $e8ea6a63d48a4fea$var$setPoint("u2", pointMap, geometry, $e8ea6a63d48a4fea$var$_camera, -w * 0.7, h * 1.1, -1);
        $e8ea6a63d48a4fea$var$setPoint("u3", pointMap, geometry, $e8ea6a63d48a4fea$var$_camera, 0, h * 2, -1);
        // cross
        $e8ea6a63d48a4fea$var$setPoint("cf1", pointMap, geometry, $e8ea6a63d48a4fea$var$_camera, -w, 0, 1);
        $e8ea6a63d48a4fea$var$setPoint("cf2", pointMap, geometry, $e8ea6a63d48a4fea$var$_camera, w, 0, 1);
        $e8ea6a63d48a4fea$var$setPoint("cf3", pointMap, geometry, $e8ea6a63d48a4fea$var$_camera, 0, -h, 1);
        $e8ea6a63d48a4fea$var$setPoint("cf4", pointMap, geometry, $e8ea6a63d48a4fea$var$_camera, 0, h, 1);
        $e8ea6a63d48a4fea$var$setPoint("cn1", pointMap, geometry, $e8ea6a63d48a4fea$var$_camera, -w, 0, -1);
        $e8ea6a63d48a4fea$var$setPoint("cn2", pointMap, geometry, $e8ea6a63d48a4fea$var$_camera, w, 0, -1);
        $e8ea6a63d48a4fea$var$setPoint("cn3", pointMap, geometry, $e8ea6a63d48a4fea$var$_camera, 0, -h, -1);
        $e8ea6a63d48a4fea$var$setPoint("cn4", pointMap, geometry, $e8ea6a63d48a4fea$var$_camera, 0, h, -1);
        geometry.getAttribute("position").needsUpdate = true;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $e8ea6a63d48a4fea$var$setPoint(point, pointMap, geometry, camera, x, y, z) {
    $e8ea6a63d48a4fea$var$_vector.set(x, y, z).unproject(camera);
    const points = pointMap[point];
    if (points !== undefined) {
        const position = geometry.getAttribute("position");
        for(let i = 0, l = points.length; i < l; i++)position.setXYZ(points[i], $e8ea6a63d48a4fea$var$_vector.x, $e8ea6a63d48a4fea$var$_vector.y, $e8ea6a63d48a4fea$var$_vector.z);
    }
}
const $e8ea6a63d48a4fea$var$_box = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$6f7d5a9418ab2aa3();
class $e8ea6a63d48a4fea$export$38a664cc862a6a9d extends $e8ea6a63d48a4fea$export$ff1ed10fedfdd604 {
    constructor(object, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = new Float32Array(24);
        const geometry = new $e8ea6a63d48a4fea$export$b7be63a67df8959();
        geometry.setIndex(new $e8ea6a63d48a4fea$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute("position", new $e8ea6a63d48a4fea$export$8dea267bd6bde117(positions, 3));
        super(geometry, new $e8ea6a63d48a4fea$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.object = object;
        this.type = "BoxHelper";
        this.matrixAutoUpdate = false;
        this.update();
    }
    update(object) {
        if (object !== undefined) console.warn("THREE.BoxHelper: .update() has no longer arguments.");
        if (this.object !== undefined) $e8ea6a63d48a4fea$var$_box.setFromObject(this.object);
        if ($e8ea6a63d48a4fea$var$_box.isEmpty()) return;
        const min = $e8ea6a63d48a4fea$var$_box.min;
        const max = $e8ea6a63d48a4fea$var$_box.max;
        /*
			5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/ const position = this.geometry.attributes.position;
        const array = position.array;
        array[0] = max.x;
        array[1] = max.y;
        array[2] = max.z;
        array[3] = min.x;
        array[4] = max.y;
        array[5] = max.z;
        array[6] = min.x;
        array[7] = min.y;
        array[8] = max.z;
        array[9] = max.x;
        array[10] = min.y;
        array[11] = max.z;
        array[12] = max.x;
        array[13] = max.y;
        array[14] = min.z;
        array[15] = min.x;
        array[16] = max.y;
        array[17] = min.z;
        array[18] = min.x;
        array[19] = min.y;
        array[20] = min.z;
        array[21] = max.x;
        array[22] = min.y;
        array[23] = min.z;
        position.needsUpdate = true;
        this.geometry.computeBoundingSphere();
    }
    setFromObject(object) {
        this.object = object;
        this.update();
        return this;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.object = source.object;
        return this;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $e8ea6a63d48a4fea$export$ce39f4bb96c9a290 extends $e8ea6a63d48a4fea$export$ff1ed10fedfdd604 {
    constructor(box, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ];
        const geometry = new $e8ea6a63d48a4fea$export$b7be63a67df8959();
        geometry.setIndex(new $e8ea6a63d48a4fea$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute("position", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(positions, 3));
        super(geometry, new $e8ea6a63d48a4fea$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.box = box;
        this.type = "Box3Helper";
        this.geometry.computeBoundingSphere();
    }
    updateMatrixWorld(force) {
        const box = this.box;
        if (box.isEmpty()) return;
        box.getCenter(this.position);
        box.getSize(this.scale);
        this.scale.multiplyScalar(0.5);
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $e8ea6a63d48a4fea$export$a34fe8156c66e5d7 extends $e8ea6a63d48a4fea$export$17d680238e50603e {
    constructor(plane, size = 1, hex = 0xffff00){
        const color = hex;
        const positions = [
            1,
            -1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0,
            1,
            1,
            0
        ];
        const geometry = new $e8ea6a63d48a4fea$export$b7be63a67df8959();
        geometry.setAttribute("position", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(positions, 3));
        geometry.computeBoundingSphere();
        super(geometry, new $e8ea6a63d48a4fea$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.type = "PlaneHelper";
        this.plane = plane;
        this.size = size;
        const positions2 = [
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0
        ];
        const geometry2 = new $e8ea6a63d48a4fea$export$b7be63a67df8959();
        geometry2.setAttribute("position", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(positions2, 3));
        geometry2.computeBoundingSphere();
        this.add(new $e8ea6a63d48a4fea$export$e176487c05830cc5(geometry2, new $e8ea6a63d48a4fea$export$55cbcc9b622fe1f5({
            color: color,
            opacity: 0.2,
            transparent: true,
            depthWrite: false,
            toneMapped: false
        })));
    }
    updateMatrixWorld(force) {
        this.position.set(0, 0, 0);
        this.scale.set(0.5 * this.size, 0.5 * this.size, 1);
        this.lookAt(this.plane.normal);
        this.translateZ(-this.plane.constant);
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
}
const $e8ea6a63d48a4fea$var$_axis = /*@__PURE__*/ new $e8ea6a63d48a4fea$export$64b5c384219d3699();
let $e8ea6a63d48a4fea$var$_lineGeometry, $e8ea6a63d48a4fea$var$_coneGeometry;
class $e8ea6a63d48a4fea$export$a3008e7bd8d2cbe7 extends $e8ea6a63d48a4fea$export$e4dd07dff30cc924 {
    // dir is assumed to be normalized
    constructor(dir = new $e8ea6a63d48a4fea$export$64b5c384219d3699(0, 0, 1), origin = new $e8ea6a63d48a4fea$export$64b5c384219d3699(0, 0, 0), length = 1, color = 0xffff00, headLength = length * 0.2, headWidth = headLength * 0.2){
        super();
        this.type = "ArrowHelper";
        if ($e8ea6a63d48a4fea$var$_lineGeometry === undefined) {
            $e8ea6a63d48a4fea$var$_lineGeometry = new $e8ea6a63d48a4fea$export$b7be63a67df8959();
            $e8ea6a63d48a4fea$var$_lineGeometry.setAttribute("position", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd([
                0,
                0,
                0,
                0,
                1,
                0
            ], 3));
            $e8ea6a63d48a4fea$var$_coneGeometry = new $e8ea6a63d48a4fea$export$68f745719dbe5198(0, 0.5, 1, 5, 1);
            $e8ea6a63d48a4fea$var$_coneGeometry.translate(0, -0.5, 0);
        }
        this.position.copy(origin);
        this.line = new $e8ea6a63d48a4fea$export$17d680238e50603e($e8ea6a63d48a4fea$var$_lineGeometry, new $e8ea6a63d48a4fea$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.line.matrixAutoUpdate = false;
        this.add(this.line);
        this.cone = new $e8ea6a63d48a4fea$export$e176487c05830cc5($e8ea6a63d48a4fea$var$_coneGeometry, new $e8ea6a63d48a4fea$export$55cbcc9b622fe1f5({
            color: color,
            toneMapped: false
        }));
        this.cone.matrixAutoUpdate = false;
        this.add(this.cone);
        this.setDirection(dir);
        this.setLength(length, headLength, headWidth);
    }
    setDirection(dir) {
        // dir is assumed to be normalized
        if (dir.y > 0.99999) this.quaternion.set(0, 0, 0, 1);
        else if (dir.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
        else {
            $e8ea6a63d48a4fea$var$_axis.set(dir.z, 0, -dir.x).normalize();
            const radians = Math.acos(dir.y);
            this.quaternion.setFromAxisAngle($e8ea6a63d48a4fea$var$_axis, radians);
        }
    }
    setLength(length, headLength = length * 0.2, headWidth = headLength * 0.2) {
        this.line.scale.set(1, Math.max(0.0001, length - headLength), 1); // see #17458
        this.line.updateMatrix();
        this.cone.scale.set(headWidth, headLength, headWidth);
        this.cone.position.y = length;
        this.cone.updateMatrix();
    }
    setColor(color) {
        this.line.material.color.set(color);
        this.cone.material.color.set(color);
    }
    copy(source) {
        super.copy(source, false);
        this.line.copy(source.line);
        this.cone.copy(source.cone);
        return this;
    }
    dispose() {
        this.line.geometry.dispose();
        this.line.material.dispose();
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
}
class $e8ea6a63d48a4fea$export$6c8303f35b8578fd extends $e8ea6a63d48a4fea$export$ff1ed10fedfdd604 {
    constructor(size = 1){
        const vertices = [
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size
        ];
        const colors = [
            1,
            0,
            0,
            1,
            0.6,
            0,
            0,
            1,
            0,
            0.6,
            1,
            0,
            0,
            0,
            1,
            0,
            0.6,
            1
        ];
        const geometry = new $e8ea6a63d48a4fea$export$b7be63a67df8959();
        geometry.setAttribute("position", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $e8ea6a63d48a4fea$export$cbe7a62641830ebd(colors, 3));
        const material = new $e8ea6a63d48a4fea$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = "AxesHelper";
    }
    setColors(xAxisColor, yAxisColor, zAxisColor) {
        const color = new $e8ea6a63d48a4fea$export$892596cec99bc70e();
        const array = this.geometry.attributes.color.array;
        color.set(xAxisColor);
        color.toArray(array, 0);
        color.toArray(array, 3);
        color.set(yAxisColor);
        color.toArray(array, 6);
        color.toArray(array, 9);
        color.set(zAxisColor);
        color.toArray(array, 12);
        color.toArray(array, 15);
        this.geometry.attributes.color.needsUpdate = true;
        return this;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $e8ea6a63d48a4fea$export$148534a3c727230b {
    constructor(){
        this.type = "ShapePath";
        this.color = new $e8ea6a63d48a4fea$export$892596cec99bc70e();
        this.subPaths = [];
        this.currentPath = null;
    }
    moveTo(x, y) {
        this.currentPath = new $e8ea6a63d48a4fea$export$4b2950bdac9b6ee9();
        this.subPaths.push(this.currentPath);
        this.currentPath.moveTo(x, y);
        return this;
    }
    lineTo(x, y) {
        this.currentPath.lineTo(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);
        return this;
    }
    splineThru(pts) {
        this.currentPath.splineThru(pts);
        return this;
    }
    toShapes(isCCW) {
        function toShapesNoHoles(inSubpaths) {
            const shapes = [];
            for(let i = 0, l = inSubpaths.length; i < l; i++){
                const tmpPath = inSubpaths[i];
                const tmpShape = new $e8ea6a63d48a4fea$export$6428a7f2611ef1fa();
                tmpShape.curves = tmpPath.curves;
                shapes.push(tmpShape);
            }
            return shapes;
        }
        function isPointInsidePolygon(inPt, inPolygon) {
            const polyLen = inPolygon.length;
            // inPt on polygon contour => immediate success    or
            // toggling of inside/outside at every single! intersection point of an edge
            //  with the horizontal line through inPt, left of inPt
            //  not counting lowerY endpoints of edges and whole edges on that line
            let inside = false;
            for(let p = polyLen - 1, q = 0; q < polyLen; p = q++){
                let edgeLowPt = inPolygon[p];
                let edgeHighPt = inPolygon[q];
                let edgeDx = edgeHighPt.x - edgeLowPt.x;
                let edgeDy = edgeHighPt.y - edgeLowPt.y;
                if (Math.abs(edgeDy) > Number.EPSILON) {
                    // not parallel
                    if (edgeDy < 0) {
                        edgeLowPt = inPolygon[q];
                        edgeDx = -edgeDx;
                        edgeHighPt = inPolygon[p];
                        edgeDy = -edgeDy;
                    }
                    if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;
                    if (inPt.y === edgeLowPt.y) {
                        if (inPt.x === edgeLowPt.x) return true; // inPt is on contour ?
                    // continue;				// no intersection or edgeLowPt => doesn't count !!!
                    } else {
                        const perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
                        if (perpEdge === 0) return true; // inPt is on contour ?
                        if (perpEdge < 0) continue;
                        inside = !inside; // true intersection left of inPt
                    }
                } else {
                    // parallel or collinear
                    if (inPt.y !== edgeLowPt.y) continue; // parallel
                    // edge lies on the same horizontal line as inPt
                    if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true; // inPt: Point on contour !
                // continue;
                }
            }
            return inside;
        }
        const isClockWise = $e8ea6a63d48a4fea$export$96bdf6d9c66d7ba8.isClockWise;
        const subPaths = this.subPaths;
        if (subPaths.length === 0) return [];
        let solid, tmpPath, tmpShape;
        const shapes = [];
        if (subPaths.length === 1) {
            tmpPath = subPaths[0];
            tmpShape = new $e8ea6a63d48a4fea$export$6428a7f2611ef1fa();
            tmpShape.curves = tmpPath.curves;
            shapes.push(tmpShape);
            return shapes;
        }
        let holesFirst = !isClockWise(subPaths[0].getPoints());
        holesFirst = isCCW ? !holesFirst : holesFirst;
        // console.log("Holes first", holesFirst);
        const betterShapeHoles = [];
        const newShapes = [];
        let newShapeHoles = [];
        let mainIdx = 0;
        let tmpPoints;
        newShapes[mainIdx] = undefined;
        newShapeHoles[mainIdx] = [];
        for(let i = 0, l = subPaths.length; i < l; i++){
            tmpPath = subPaths[i];
            tmpPoints = tmpPath.getPoints();
            solid = isClockWise(tmpPoints);
            solid = isCCW ? !solid : solid;
            if (solid) {
                if (!holesFirst && newShapes[mainIdx]) mainIdx++;
                newShapes[mainIdx] = {
                    s: new $e8ea6a63d48a4fea$export$6428a7f2611ef1fa(),
                    p: tmpPoints
                };
                newShapes[mainIdx].s.curves = tmpPath.curves;
                if (holesFirst) mainIdx++;
                newShapeHoles[mainIdx] = [];
            //console.log('cw', i);
            } else newShapeHoles[mainIdx].push({
                h: tmpPath,
                p: tmpPoints[0]
            });
        }
        // only Holes? -> probably all Shapes with wrong orientation
        if (!newShapes[0]) return toShapesNoHoles(subPaths);
        if (newShapes.length > 1) {
            let ambiguous = false;
            let toChange = 0;
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++)betterShapeHoles[sIdx] = [];
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++){
                const sho = newShapeHoles[sIdx];
                for(let hIdx = 0; hIdx < sho.length; hIdx++){
                    const ho = sho[hIdx];
                    let hole_unassigned = true;
                    for(let s2Idx = 0; s2Idx < newShapes.length; s2Idx++)if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
                        if (sIdx !== s2Idx) toChange++;
                        if (hole_unassigned) {
                            hole_unassigned = false;
                            betterShapeHoles[s2Idx].push(ho);
                        } else ambiguous = true;
                    }
                    if (hole_unassigned) betterShapeHoles[sIdx].push(ho);
                }
            }
            if (toChange > 0 && ambiguous === false) newShapeHoles = betterShapeHoles;
        }
        let tmpHoles;
        for(let i = 0, il = newShapes.length; i < il; i++){
            tmpShape = newShapes[i].s;
            shapes.push(tmpShape);
            tmpHoles = newShapeHoles[i];
            for(let j = 0, jl = tmpHoles.length; j < jl; j++)tmpShape.holes.push(tmpHoles[j].h);
        }
        //console.log("shape", shapes);
        return shapes;
    }
}
class $e8ea6a63d48a4fea$export$ab3456a079aa7d80 extends $e8ea6a63d48a4fea$export$33e43285f7406bd5 {
    constructor(width, height, depth, widthSegments, heightSegments, depthSegments){
        console.warn("THREE.BoxBufferGeometry has been renamed to THREE.BoxGeometry.");
        super(width, height, depth, widthSegments, heightSegments, depthSegments);
    }
}
class $e8ea6a63d48a4fea$export$f036d76f832848a extends $e8ea6a63d48a4fea$export$41680e8551036033 {
    constructor(radius, length, capSegments, radialSegments){
        console.warn("THREE.CapsuleBufferGeometry has been renamed to THREE.CapsuleGeometry.");
        super(radius, length, capSegments, radialSegments);
    }
}
class $e8ea6a63d48a4fea$export$3f74fe60decf7462 extends $e8ea6a63d48a4fea$export$d5c0e8d607467193 {
    constructor(radius, segments, thetaStart, thetaLength){
        console.warn("THREE.CircleBufferGeometry has been renamed to THREE.CircleGeometry.");
        super(radius, segments, thetaStart, thetaLength);
    }
}
class $e8ea6a63d48a4fea$export$59d971120dc8b6e7 extends $e8ea6a63d48a4fea$export$a7a48974f285c9b3 {
    constructor(radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength){
        console.warn("THREE.ConeBufferGeometry has been renamed to THREE.ConeGeometry.");
        super(radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
    }
}
class $e8ea6a63d48a4fea$export$d4345c83207d7c68 extends $e8ea6a63d48a4fea$export$68f745719dbe5198 {
    constructor(radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength){
        console.warn("THREE.CylinderBufferGeometry has been renamed to THREE.CylinderGeometry.");
        super(radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
    }
}
class $e8ea6a63d48a4fea$export$37cd4e52cce48c4c extends $e8ea6a63d48a4fea$export$c0babfeb8708fc9c {
    constructor(radius, detail){
        console.warn("THREE.DodecahedronBufferGeometry has been renamed to THREE.DodecahedronGeometry.");
        super(radius, detail);
    }
}
class $e8ea6a63d48a4fea$export$91836d01b9f75a58 extends $e8ea6a63d48a4fea$export$598697a1efa63ca7 {
    constructor(shapes, options){
        console.warn("THREE.ExtrudeBufferGeometry has been renamed to THREE.ExtrudeGeometry.");
        super(shapes, options);
    }
}
class $e8ea6a63d48a4fea$export$731fd4feef063ea2 extends $e8ea6a63d48a4fea$export$9567cc828c9535da {
    constructor(radius, detail){
        console.warn("THREE.IcosahedronBufferGeometry has been renamed to THREE.IcosahedronGeometry.");
        super(radius, detail);
    }
}
class $e8ea6a63d48a4fea$export$dc3e1273c1dd9240 extends $e8ea6a63d48a4fea$export$6d839803fcd1882c {
    constructor(points, segments, phiStart, phiLength){
        console.warn("THREE.LatheBufferGeometry has been renamed to THREE.LatheGeometry.");
        super(points, segments, phiStart, phiLength);
    }
}
class $e8ea6a63d48a4fea$export$8e05fc91596f4752 extends $e8ea6a63d48a4fea$export$1954e2b809fe361e {
    constructor(radius, detail){
        console.warn("THREE.OctahedronBufferGeometry has been renamed to THREE.OctahedronGeometry.");
        super(radius, detail);
    }
}
class $e8ea6a63d48a4fea$export$e789a11a194ca4e0 extends $e8ea6a63d48a4fea$export$967d831af31f69ce {
    constructor(width, height, widthSegments, heightSegments){
        console.warn("THREE.PlaneBufferGeometry has been renamed to THREE.PlaneGeometry.");
        super(width, height, widthSegments, heightSegments);
    }
}
class $e8ea6a63d48a4fea$export$38789b531813345c extends $e8ea6a63d48a4fea$export$60e57a7d3f20ff65 {
    constructor(vertices, indices, radius, detail){
        console.warn("THREE.PolyhedronBufferGeometry has been renamed to THREE.PolyhedronGeometry.");
        super(vertices, indices, radius, detail);
    }
}
class $e8ea6a63d48a4fea$export$ee8b85b34b7d9cad extends $e8ea6a63d48a4fea$export$68cb731f50f614af {
    constructor(innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength){
        console.warn("THREE.RingBufferGeometry has been renamed to THREE.RingGeometry.");
        super(innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength);
    }
}
class $e8ea6a63d48a4fea$export$233afc324766bed8 extends $e8ea6a63d48a4fea$export$57a29a1c803e9065 {
    constructor(shapes, curveSegments){
        console.warn("THREE.ShapeBufferGeometry has been renamed to THREE.ShapeGeometry.");
        super(shapes, curveSegments);
    }
}
class $e8ea6a63d48a4fea$export$d5d06a966fec4192 extends $e8ea6a63d48a4fea$export$1b417fc3b307a251 {
    constructor(radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength){
        console.warn("THREE.SphereBufferGeometry has been renamed to THREE.SphereGeometry.");
        super(radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength);
    }
}
class $e8ea6a63d48a4fea$export$369e08f62a796c65 extends $e8ea6a63d48a4fea$export$fb3f7adc68bd6e02 {
    constructor(radius, detail){
        console.warn("THREE.TetrahedronBufferGeometry has been renamed to THREE.TetrahedronGeometry.");
        super(radius, detail);
    }
}
class $e8ea6a63d48a4fea$export$19d55f905fa4f2cb extends $e8ea6a63d48a4fea$export$a2312a2a1fa56495 {
    constructor(radius, tube, radialSegments, tubularSegments, arc){
        console.warn("THREE.TorusBufferGeometry has been renamed to THREE.TorusGeometry.");
        super(radius, tube, radialSegments, tubularSegments, arc);
    }
}
class $e8ea6a63d48a4fea$export$2b32466f4274fe5c extends $e8ea6a63d48a4fea$export$77e9bfadfb9ab8c8 {
    constructor(radius, tube, tubularSegments, radialSegments, p, q){
        console.warn("THREE.TorusKnotBufferGeometry has been renamed to THREE.TorusKnotGeometry.");
        super(radius, tube, tubularSegments, radialSegments, p, q);
    }
}
class $e8ea6a63d48a4fea$export$d97a193ce44e691b extends $e8ea6a63d48a4fea$export$7897d9d48904490c {
    constructor(path, tubularSegments, radius, radialSegments, closed){
        console.warn("THREE.TubeBufferGeometry has been renamed to THREE.TubeGeometry.");
        super(path, tubularSegments, radius, radialSegments, closed);
    }
}
if (typeof __THREE_DEVTOOLS__ !== "undefined") __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", {
    detail: {
        revision: $e8ea6a63d48a4fea$export$3545e07a80636437
    }
}));
if (typeof window !== "undefined") {
    if (window.__THREE__) console.warn("WARNING: Multiple instances of Three.js being imported.");
    else window.__THREE__ = $e8ea6a63d48a4fea$export$3545e07a80636437;
}



const $29132154d539ae7a$var$_size = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
class $29132154d539ae7a$export$6b9ee88e8021e83a {
    static #_ = (()=>{
        this.defaultOptions = {
            maxDepth: 8,
            maxElements: 8000,
            octree: false
        };
    })();
    constructor(root, nodes){
        this.root = root;
        this.nodes = nodes || this.buildNodeMap(root);
    }
    buildNodeMap(root) {
        const nodes = new Map();
        const addNode = (node)=>{
            nodes.set(node.id, node);
            node.children.forEach((child)=>addNode(child));
        };
        addNode(root);
        return nodes;
    }
    createNode(parent, offset, count) {
        const node = {
            id: this.nodes.size,
            offset: offset,
            count: count,
            depth: parent.depth + 1,
            index: this.root.index.subarray(offset, offset + count),
            boundingBox: parent.boundingBox.clone(),
            children: []
        };
        this.nodes.set(node.id, node);
        return node;
    }
    static empty() {
        return new this({
            id: 0,
            offset: 0,
            count: 0,
            depth: 0,
            children: [],
            index: new Uint32Array(0),
            boundingBox: new $e8ea6a63d48a4fea$export$6f7d5a9418ab2aa3()
        });
    }
    static fromPositions(positions, options) {
        const tree = $29132154d539ae7a$export$6b9ee88e8021e83a.empty();
        tree.setFromPositions(positions, options);
        return tree;
    }
    setFromPositions(positions, options) {
        if (positions.length === 0) return this;
        console.time("Build tree");
        // Create index for positions
        const count = Math.ceil(positions.length / 3);
        const index = new Uint32Array(count);
        for(let i = 0; i < count; i++)index[i] = i;
        this.setFromIndex(index, positions, options);
        console.timeEnd("Build tree");
        console.info("box tree created with", this.nodes.size, "nodes.");
        return this;
    }
    setFromIndex(index, positions, options) {
        const count = index.length;
        const position = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        this.root.count = count;
        this.root.index = index;
        // Root bounding box
        this.root.boundingBox.makeEmpty();
        for(let i = 0; i < this.root.count; i++){
            position.fromArray(positions, 3 * this.root.index[i]);
            this.root.boundingBox.expandByPoint(position);
        }
        if (this.root.count > 0) this.splitNode(this.root, index, positions, options);
        return this;
    }
    splitNode(node, rootIndex, positions, options) {
        const index = rootIndex;
        const count = node.count;
        const slices = options?.octree ? 8 : 4;
        const maxDepth = options?.maxDepth || $29132154d539ae7a$export$6b9ee88e8021e83a.defaultOptions.maxDepth;
        const maxElements = options?.maxElements || $29132154d539ae7a$export$6b9ee88e8021e83a.defaultOptions.maxElements;
        const counts = new Uint32Array(8);
        const offsets = new Uint32Array(8);
        const tmpIndex = new Uint32Array(count);
        const tmpKeys = new Uint8Array(count);
        const position = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        const center = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        // Recursively split nodes by quadrant
        const split = (node)=>{
            tmpIndex.set(index.subarray(node.offset, node.offset + node.count));
            offsets.fill(0);
            counts.fill(0);
            // Compute keys and count elements
            node.boundingBox.getCenter(center);
            for(let i = 0; i < node.count; i++){
                tmpKeys[i] = positions[tmpIndex[i] * 3] > center.x ? 1 : 0;
                tmpKeys[i] += positions[tmpIndex[i] * 3 + 1] > center.y ? 2 : 0;
                if (options?.octree) tmpKeys[i] += positions[tmpIndex[i] * 3 + 2] > center.z ? 4 : 0;
                counts[tmpKeys[i]]++;
            }
            // Compute key offsets
            let offset = node.offset;
            for(let k = 0; k < slices; k++){
                offsets[k] = offset;
                offset += counts[k];
            }
            const children = [];
            for(let k = 0; k < slices; k++){
                const child = this.createNode(node, offsets[k], counts[k]);
                child.boundingBox.makeEmpty();
                children.push(child);
            }
            for(let i = 0; i < node.count; i++){
                // Sort index
                const key = tmpKeys[i];
                index[offsets[key]++] = tmpIndex[i];
                // Compute bounding box
                position.fromArray(positions, tmpIndex[i] * 3);
                children[key].boundingBox.expandByPoint(position);
            }
            // Recursive split call
            node.children = children;
            for (const child of children){
                child.boundingBox.getSize($29132154d539ae7a$var$_size);
                if (child.count > maxElements && child.depth < maxDepth) split(child);
            }
        };
        if (count > 0) split(node);
    }
    get index() {
        return this.root.index;
    }
    get count() {
        return this.root.count;
    }
    getIndexForNodes(nodes) {
        const count = nodes.reduce((total, node)=>total + node.count, 0);
        let offset = 0;
        const index = new Uint32Array(count);
        for (const node of nodes)for(let i = 0; i < node.count; i++)index[offset++] = this.index[node.offset + i];
        return index;
    }
    queryNodes(match, maxDepth = Infinity) {
        const nodes = [];
        const visit = (node)=>{
            if (!match(node)) return;
            if (node.children.length === 0 || node.depth >= maxDepth) {
                nodes.push(node);
                return;
            }
            node.children.forEach((child)=>visit(child));
        };
        visit(this.root);
        return nodes;
    }
    traverse(callback, node = this.root) {
        if (callback(node) === false) return;
        for(let i = 0; i < node.children.length; i++)this.traverse(callback, node.children[i]);
    }
    queryIndex(match, maxDepth = Infinity) {
        return this.getIndexForNodes(this.queryNodes(match, maxDepth));
    }
    copy(source) {
        this.root = source.root;
        this.nodes = source.nodes;
        return this;
    }
}
var $29132154d539ae7a$export$2e2bcd8739ae039 = $29132154d539ae7a$export$6b9ee88e8021e83a;







var $4f0c4c686d4b1bad$export$2e2bcd8739ae039 = [
    {
        name: "Default",
        texture: (parcelRequire("j0uTL"))
    },
    {
        name: "Pastel",
        texture: (parcelRequire("bU6e0"))
    },
    {
        name: "Range",
        texture: (parcelRequire("5fHJD"))
    },
    {
        name: "Range Flipped",
        texture: (parcelRequire("jxRGc"))
    }
];


const $ff1962c46896fdbd$export$772cdd5f573abcc9 = (0, $ca0ed0868e4d0815$exports.create)((set)=>({
        pointSize: 6,
        setPointSize: (pointSize)=>set({
                pointSize: pointSize
            }),
        colorPalette: (0, $4f0c4c686d4b1bad$export$2e2bcd8739ae039)[3],
        setColorPalette: (colorPalette)=>set({
                colorPalette: colorPalette
            }),
        colorPaletteLength: 0,
        setColorPaletteLength: (colorPaletteLength)=>set({
                colorPaletteLength: colorPaletteLength
            }),
        showColorLegend: true,
        setShowColorLegend: (showColorLegend)=>set({
                showColorLegend: showColorLegend
            })
    }));


class $37e478c31cd764cc$export$925275dda63be28e extends $e8ea6a63d48a4fea$export$b7be63a67df8959 {
    constructor(positions){
        super();
        this.version = 0;
        this.positions = this.setPositions(positions);
        this.boxTree = this.computeBoxTree(positions);
        this.count = positions.length / 3;
        this.zeros = new Float32Array(this.count);
        this.colors = new Float32Array(this.count);
        // Set ids
        this.ids = new Uint32Array(this.count);
        for(let i = 0; i < this.count; i++)this.ids[i] = i;
        // Geometry attributes
        this.setAttribute("zero", new $e8ea6a63d48a4fea$export$8dea267bd6bde117(this.zeros, 1));
        this.setAttribute("color", new $e8ea6a63d48a4fea$export$8dea267bd6bde117(this.colors, 1));
        this.setAttribute("id", new $e8ea6a63d48a4fea$export$8dea267bd6bde117(this.ids, 1));
    }
    computeBoxTree(positions) {
        this.boxTree = (0, $29132154d539ae7a$export$6b9ee88e8021e83a).fromPositions(positions, {
            maxDepth: 10,
            maxElements: 1000,
            octree: true
        });
        return this.boxTree;
    }
    setPositions(values) {
        this.setAttribute("position", new $e8ea6a63d48a4fea$export$8dea267bd6bde117(values, 3));
        this.positions = values;
        return this.positions;
    }
    resetIndex() {
        this.index = new $e8ea6a63d48a4fea$export$8dea267bd6bde117(this.ids, 1);
    }
    setColorAttribute(name, values, range) {
        const { colorPaletteLength: colorPaletteLength  } = (0, $ff1962c46896fdbd$export$772cdd5f573abcc9).getState();
        let paletteLength = 10;
        if (colorPaletteLength) paletteLength = colorPaletteLength;
        if (!name) {
            this.colors.fill(255);
            this.getAttribute("color").needsUpdate = true;
            return;
        }
        if (!values || !range) throw new Error("Values and range must be set");
        const [min, max] = range;
        const color = this.getAttribute("color");
        for(let i = 0; i < values.length; i++)this.colors[i] = Math.floor((values[i] - min) / (max - min) * paletteLength) / paletteLength + 0.5 / paletteLength;
        color.needsUpdate = true;
    }
}



const $a2bde23ea9c8df05$var$defaultColorAttributes = [
    "color",
    "label",
    "category",
    "project_name",
    "z",
    "rating (1-5)"
];
const $a2bde23ea9c8df05$export$26531d8e255edf16 = (0, $ca0ed0868e4d0815$exports.create)((set, get)=>({
        count: 0,
        attributeNames: [],
        loading: false,
        async loadDataset (dataset) {
            set({
                dataset: dataset,
                loading: true
            });
            console.log(dataset);
            // Create geometry and indices
            get().createGeometry(dataset);
            await dataset.buildIndices();
            // Set default x and y
            get().setDefaultCameraForDataset(dataset);
            set({
                loading: false
            });
        },
        createGeometry (dataset) {
            if (dataset.projections) {
                const geometry = new (0, $37e478c31cd764cc$export$925275dda63be28e)(dataset.projections.values);
                const colorAttribute = $a2bde23ea9c8df05$var$defaultColorAttributes.find((name)=>dataset.attributes.find((a)=>a.name === name));
                set({
                    geometry: geometry
                });
                if (colorAttribute) get().setColorAttribute(colorAttribute);
            }
        },
        setColorAttribute (name) {
            const { dataset: dataset , geometry: geometry  } = get();
            if (!geometry || !dataset) return;
            const attribute = dataset.attributes.find((a)=>a.name === name);
            if (attribute && attribute.values) {
                geometry.setColorAttribute(name, attribute.values, attribute.getRange());
                set({
                    colorAttribute: name
                });
            } else {
                geometry.setColorAttribute();
                set({
                    colorAttribute: undefined
                });
            }
        },
        setDefaultCameraForDataset (dataset) {
            const average = (a)=>a.reduce((x, y)=>x + y) / a.length;
            const xAttribute = dataset.attributes.find((a)=>a.name === "x");
            const yAttribute = dataset.attributes.find((a)=>a.name === "y");
            if (xAttribute?.values?.length) {
                const x = average([
                    ...xAttribute.values
                ]);
                set({
                    defaultCamera: {
                        ...get().defaultCamera,
                        defaultX: x
                    }
                });
            }
            if (yAttribute?.values?.length) {
                const y = average([
                    ...yAttribute.values
                ]);
                set({
                    defaultCamera: {
                        ...get().defaultCamera,
                        defaultY: y
                    }
                });
            }
            if (xAttribute?.getRange() && yAttribute?.getRange()) set({
                defaultCamera: {
                    ...get().defaultCamera,
                    defaultBox: new $e8ea6a63d48a4fea$export$6f7d5a9418ab2aa3(new $e8ea6a63d48a4fea$export$64b5c384219d3699(xAttribute.getRange()[0], yAttribute.getRange()[0]), new $e8ea6a63d48a4fea$export$64b5c384219d3699(xAttribute.getRange()[1], yAttribute.getRange()[1])),
                    defaultPaddingX: (xAttribute.getRange()[1] - xAttribute.getRange()[0]) / 2,
                    defaultPaddingY: (yAttribute.getRange()[1] - yAttribute.getRange()[0]) / 2
                }
            });
        }
    }));


var $7e5984aeec72c076$exports = {};
"use strict";
var $83471781e862547b$exports = {};
function $83471781e862547b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
$83471781e862547b$exports = $83471781e862547b$var$_interopRequireDefault, $83471781e862547b$exports.__esModule = true, $83471781e862547b$exports["default"] = $83471781e862547b$exports;


Object.defineProperty($7e5984aeec72c076$exports, "__esModule", {
    value: true
});
$7e5984aeec72c076$exports.default = void 0;

var $7e5984aeec72c076$var$_createSvgIcon = $83471781e862547b$exports((parcelRequire("ek3fl")));

var $cVgDf = parcelRequire("cVgDf");
var $7e5984aeec72c076$var$_default = (0, $7e5984aeec72c076$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cVgDf.jsx)("path", {
    d: "M15.41 16.59 10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), "KeyboardArrowLeft");
$7e5984aeec72c076$exports.default = $7e5984aeec72c076$var$_default;


var $b76fecb61555c6b7$exports = {};
"use strict";

Object.defineProperty($b76fecb61555c6b7$exports, "__esModule", {
    value: true
});
$b76fecb61555c6b7$exports.default = void 0;

var $b76fecb61555c6b7$var$_createSvgIcon = $83471781e862547b$exports((parcelRequire("ek3fl")));

var $cVgDf = parcelRequire("cVgDf");
var $b76fecb61555c6b7$var$_default = (0, $b76fecb61555c6b7$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cVgDf.jsx)("path", {
    d: "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), "KeyboardArrowRight");
$b76fecb61555c6b7$exports.default = $b76fecb61555c6b7$var$_default;



var $cVgDf = parcelRequire("cVgDf");
parcelRequire("1bdO8");


/**
 *
 * Demos:
 *
 * - [Stack (Joy UI)](https://mui.com/joy-ui/react-stack/)
 * - [Stack (Material UI)](https://mui.com/material-ui/react-stack/)
 * - [Stack (MUI System)](https://mui.com/system/react-stack/)
 *
 * API:
 *
 * - [Stack API](https://mui.com/system/api/stack/)
 */ const $5ee5a2b70316870a$var$Stack = (0, $84db172a01177155$export$2e2bcd8739ae039)();
var $5ee5a2b70316870a$export$2e2bcd8739ae039 = $5ee5a2b70316870a$var$Stack;


const $6f831554a3337c89$var$StyledStack = (0, $e46d01b4fa5ffeed$export$2e2bcd8739ae039)((0, $5ee5a2b70316870a$export$2e2bcd8739ae039))(({ theme: theme  })=>({
        paddingBottom: "16px",
        paddingTop: "10px",
        overflowY: "scroll",
        overflowX: "hidden",
        maskImage: `linear-gradient(to bottom, transparent 0%, black 16px, black calc(100% - 16px), transparent 100%)`
    }));
function $6f831554a3337c89$export$708ca8fd39af381b(props) {
    return /*#__PURE__*/ (0, $cVgDf.jsx)($6f831554a3337c89$var$StyledStack, {
        onWheel: (e)=>e.stopPropagation(),
        ...props
    });
}



var $cVgDf = parcelRequire("cVgDf");

var $fZ2DJ = parcelRequire("fZ2DJ");

var $63nUy = parcelRequire("63nUy");

var $1bdO8 = parcelRequire("1bdO8");


var $gJjS7 = parcelRequire("gJjS7");

var $9H0b9 = parcelRequire("9H0b9");

var $b8tOr = parcelRequire("b8tOr");
parcelRequire("1bdO8");

var $6wXS5 = parcelRequire("6wXS5");

var $cVgDf = parcelRequire("cVgDf");
var $ccd86ab9f3f9ce0d$export$2e2bcd8739ae039 = (0, $6wXS5.default)(/*#__PURE__*/ (0, $cVgDf.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");





var $82mcY = parcelRequire("82mcY");


var $dHuM2 = parcelRequire("dHuM2");

var $gIzLq = parcelRequire("gIzLq");

var $itJr1 = parcelRequire("itJr1");

var $9nXgc = parcelRequire("9nXgc");
function $a31e8119d99ea69c$export$31444911e4ee6fdd(slot) {
    return (0, $9nXgc.default)("MuiChip", slot);
}
const $a31e8119d99ea69c$var$chipClasses = (0, $itJr1.default)("MuiChip", [
    "root",
    "sizeSmall",
    "sizeMedium",
    "colorError",
    "colorInfo",
    "colorPrimary",
    "colorSecondary",
    "colorSuccess",
    "colorWarning",
    "disabled",
    "clickable",
    "clickableColorPrimary",
    "clickableColorSecondary",
    "deletable",
    "deletableColorPrimary",
    "deletableColorSecondary",
    "outlined",
    "filled",
    "outlinedPrimary",
    "outlinedSecondary",
    "filledPrimary",
    "filledSecondary",
    "avatar",
    "avatarSmall",
    "avatarMedium",
    "avatarColorPrimary",
    "avatarColorSecondary",
    "icon",
    "iconSmall",
    "iconMedium",
    "iconColorPrimary",
    "iconColorSecondary",
    "label",
    "labelSmall",
    "labelMedium",
    "deleteIcon",
    "deleteIconSmall",
    "deleteIconMedium",
    "deleteIconColorPrimary",
    "deleteIconColorSecondary",
    "deleteIconOutlinedColorPrimary",
    "deleteIconOutlinedColorSecondary",
    "deleteIconFilledColorPrimary",
    "deleteIconFilledColorSecondary",
    "focusVisible"
]);
var $a31e8119d99ea69c$export$2e2bcd8739ae039 = $a31e8119d99ea69c$var$chipClasses;



var $cVgDf = parcelRequire("cVgDf");
const $3fa621b39a3d0d49$var$_excluded = [
    "avatar",
    "className",
    "clickable",
    "color",
    "component",
    "deleteIcon",
    "disabled",
    "icon",
    "label",
    "onClick",
    "onDelete",
    "onKeyDown",
    "onKeyUp",
    "size",
    "variant",
    "tabIndex",
    "skipFocusWhenDisabled"
];
const $3fa621b39a3d0d49$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , disabled: disabled , size: size , color: color , iconColor: iconColor , onDelete: onDelete , clickable: clickable , variant: variant  } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            disabled && "disabled",
            `size${(0, $82mcY.default)(size)}`,
            `color${(0, $82mcY.default)(color)}`,
            clickable && "clickable",
            clickable && `clickableColor${(0, $82mcY.default)(color)}`,
            onDelete && "deletable",
            onDelete && `deletableColor${(0, $82mcY.default)(color)}`,
            `${variant}${(0, $82mcY.default)(color)}`
        ],
        label: [
            "label",
            `label${(0, $82mcY.default)(size)}`
        ],
        avatar: [
            "avatar",
            `avatar${(0, $82mcY.default)(size)}`,
            `avatarColor${(0, $82mcY.default)(color)}`
        ],
        icon: [
            "icon",
            `icon${(0, $82mcY.default)(size)}`,
            `iconColor${(0, $82mcY.default)(iconColor)}`
        ],
        deleteIcon: [
            "deleteIcon",
            `deleteIcon${(0, $82mcY.default)(size)}`,
            `deleteIconColor${(0, $82mcY.default)(color)}`,
            `deleteIcon${(0, $82mcY.default)(variant)}Color${(0, $82mcY.default)(color)}`
        ]
    };
    return (0, $9H0b9.default)(slots, (0, $a31e8119d99ea69c$export$31444911e4ee6fdd), classes);
};
const $3fa621b39a3d0d49$var$ChipRoot = (0, $gIzLq.default)("div", {
    name: "MuiChip",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        const { color: color , iconColor: iconColor , clickable: clickable , onDelete: onDelete , size: size , variant: variant  } = ownerState;
        return [
            {
                [`& .${(0, $a31e8119d99ea69c$export$2e2bcd8739ae039).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $a31e8119d99ea69c$export$2e2bcd8739ae039).avatar}`]: styles[`avatar${(0, $82mcY.default)(size)}`]
            },
            {
                [`& .${(0, $a31e8119d99ea69c$export$2e2bcd8739ae039).avatar}`]: styles[`avatarColor${(0, $82mcY.default)(color)}`]
            },
            {
                [`& .${(0, $a31e8119d99ea69c$export$2e2bcd8739ae039).icon}`]: styles.icon
            },
            {
                [`& .${(0, $a31e8119d99ea69c$export$2e2bcd8739ae039).icon}`]: styles[`icon${(0, $82mcY.default)(size)}`]
            },
            {
                [`& .${(0, $a31e8119d99ea69c$export$2e2bcd8739ae039).icon}`]: styles[`iconColor${(0, $82mcY.default)(iconColor)}`]
            },
            {
                [`& .${(0, $a31e8119d99ea69c$export$2e2bcd8739ae039).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $a31e8119d99ea69c$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $82mcY.default)(size)}`]
            },
            {
                [`& .${(0, $a31e8119d99ea69c$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIconColor${(0, $82mcY.default)(color)}`]
            },
            {
                [`& .${(0, $a31e8119d99ea69c$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $82mcY.default)(variant)}Color${(0, $82mcY.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, $82mcY.default)(size)}`],
            styles[`color${(0, $82mcY.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== "default" && styles[`clickableColor${(0, $82mcY.default)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== "default" && styles[`deletableColor${(0, $82mcY.default)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $82mcY.default)(color)}`]
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>{
    const textColor = theme.palette.mode === "light" ? theme.palette.grey[700] : theme.palette.grey[300];
    return (0, $63nUy.default)({
        maxWidth: "100%",
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: "nowrap",
        transition: theme.transitions.create([
            "background-color",
            "box-shadow"
        ]),
        // label will inherit this from root, then `clickable` class overrides this for both
        cursor: "default",
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: "none",
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: "middle",
        boxSizing: "border-box",
        [`&.${(0, $a31e8119d99ea69c$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: "none"
        },
        [`& .${(0, $a31e8119d99ea69c$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $a31e8119d99ea69c$export$2e2bcd8739ae039).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, $a31e8119d99ea69c$export$2e2bcd8739ae039).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, $a31e8119d99ea69c$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $a31e8119d99ea69c$export$2e2bcd8739ae039).icon}`]: (0, $63nUy.default)({
            marginLeft: 5,
            marginRight: -6
        }, ownerState.size === "small" && {
            fontSize: 18,
            marginLeft: 4,
            marginRight: -4
        }, ownerState.iconColor === ownerState.color && (0, $63nUy.default)({
            color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
        }, ownerState.color !== "default" && {
            color: "inherit"
        })),
        [`& .${(0, $a31e8119d99ea69c$export$2e2bcd8739ae039).deleteIcon}`]: (0, $63nUy.default)({
            WebkitTapHighlightColor: "transparent",
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, $b8tOr.alpha)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: "pointer",
            margin: "0 5px 0 -6px",
            "&:hover": {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $b8tOr.alpha)(theme.palette.text.primary, 0.4)
            }
        }, ownerState.size === "small" && {
            fontSize: 16,
            marginRight: 4,
            marginLeft: -4
        }, ownerState.color !== "default" && {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].contrastTextChannel} / 0.7)` : (0, $b8tOr.alpha)(theme.palette[ownerState.color].contrastText, 0.7),
            "&:hover, &:active": {
                color: (theme.vars || theme).palette[ownerState.color].contrastText
            }
        })
    }, ownerState.size === "small" && {
        height: 24
    }, ownerState.color !== "default" && {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        color: (theme.vars || theme).palette[ownerState.color].contrastText
    }, ownerState.onDelete && {
        [`&.${(0, $a31e8119d99ea69c$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $b8tOr.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        }
    }, ownerState.onDelete && ownerState.color !== "default" && {
        [`&.${(0, $a31e8119d99ea69c$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    });
}, ({ theme: theme , ownerState: ownerState  })=>(0, $63nUy.default)({}, ownerState.clickable && {
        userSelect: "none",
        WebkitTapHighlightColor: "transparent",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $b8tOr.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $a31e8119d99ea69c$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $b8tOr.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        },
        "&:active": {
            boxShadow: (theme.vars || theme).shadows[1]
        }
    }, ownerState.clickable && ownerState.color !== "default" && {
        [`&:hover, &.${(0, $a31e8119d99ea69c$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    }), ({ theme: theme , ownerState: ownerState  })=>(0, $63nUy.default)({}, ownerState.variant === "outlined" && {
        backgroundColor: "transparent",
        border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === "light" ? theme.palette.grey[400] : theme.palette.grey[700]}`,
        [`&.${(0, $a31e8119d99ea69c$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $a31e8119d99ea69c$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`& .${(0, $a31e8119d99ea69c$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 4
        },
        [`& .${(0, $a31e8119d99ea69c$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $a31e8119d99ea69c$export$2e2bcd8739ae039).icon}`]: {
            marginLeft: 4
        },
        [`& .${(0, $a31e8119d99ea69c$export$2e2bcd8739ae039).iconSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $a31e8119d99ea69c$export$2e2bcd8739ae039).deleteIcon}`]: {
            marginRight: 5
        },
        [`& .${(0, $a31e8119d99ea69c$export$2e2bcd8739ae039).deleteIconSmall}`]: {
            marginRight: 3
        }
    }, ownerState.variant === "outlined" && ownerState.color !== "default" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $b8tOr.alpha)(theme.palette[ownerState.color].main, 0.7)}`,
        [`&.${(0, $a31e8119d99ea69c$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $b8tOr.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $a31e8119d99ea69c$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $b8tOr.alpha)(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
        },
        [`& .${(0, $a31e8119d99ea69c$export$2e2bcd8739ae039).deleteIcon}`]: {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $b8tOr.alpha)(theme.palette[ownerState.color].main, 0.7),
            "&:hover, &:active": {
                color: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }));
const $3fa621b39a3d0d49$var$ChipLabel = (0, $gIzLq.default)("span", {
    name: "MuiChip",
    slot: "Label",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        const { size: size  } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $82mcY.default)(size)}`]
        ];
    }
})(({ ownerState: ownerState  })=>(0, $63nUy.default)({
        overflow: "hidden",
        textOverflow: "ellipsis",
        paddingLeft: 12,
        paddingRight: 12,
        whiteSpace: "nowrap"
    }, ownerState.size === "small" && {
        paddingLeft: 8,
        paddingRight: 8
    }));
function $3fa621b39a3d0d49$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === "Backspace" || keyboardEvent.key === "Delete";
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $3fa621b39a3d0d49$var$Chip = /*#__PURE__*/ $1bdO8.forwardRef(function Chip(inProps, ref) {
    const props = (0, $dHuM2.default)({
        props: inProps,
        name: "MuiChip"
    });
    const { avatar: avatarProp , className: className , clickable: clickableProp , color: color = "default" , component: ComponentProp , deleteIcon: deleteIconProp , disabled: disabled = false , icon: iconProp , label: label , onClick: onClick , onDelete: onDelete , onKeyDown: onKeyDown , onKeyUp: onKeyUp , size: size = "medium" , variant: variant = "filled" , tabIndex: tabIndex , skipFocusWhenDisabled: skipFocusWhenDisabled = false // TODO v6: Rename to `focusableWhenDisabled`.
      } = props, other = (0, $fZ2DJ.default)(props, $3fa621b39a3d0d49$var$_excluded);
    const chipRef = $1bdO8.useRef(null);
    const handleRef = (0, $428a291d5bcff83c$export$2e2bcd8739ae039)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $3fa621b39a3d0d49$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $3fa621b39a3d0d49$var$isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === "Escape" && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $22f13692c22c9568$export$2e2bcd8739ae039) : ComponentProp || "div";
    const ownerState = (0, $63nUy.default)({}, props, {
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $1bdO8.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    });
    const classes = $3fa621b39a3d0d49$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $22f13692c22c9568$export$2e2bcd8739ae039) ? (0, $63nUy.default)({
        component: ComponentProp || "div",
        focusVisibleClassName: classes.focusVisible
    }, onDelete && {
        disableRipple: true
    }) : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $1bdO8.isValidElement(deleteIconProp) ? /*#__PURE__*/ $1bdO8.cloneElement(deleteIconProp, {
        className: (0, $gJjS7.default)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $cVgDf.jsx)((0, $ccd86ab9f3f9ce0d$export$2e2bcd8739ae039), {
        className: (0, $gJjS7.default)(classes.deleteIcon),
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $1bdO8.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $1bdO8.cloneElement(avatarProp, {
        className: (0, $gJjS7.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $1bdO8.isValidElement(iconProp)) icon = /*#__PURE__*/ $1bdO8.cloneElement(iconProp, {
        className: (0, $gJjS7.default)(classes.icon, iconProp.props.className)
    });
    return /*#__PURE__*/ (0, $cVgDf.jsxs)($3fa621b39a3d0d49$var$ChipRoot, (0, $63nUy.default)({
        as: component,
        className: (0, $gJjS7.default)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
        ownerState: ownerState
    }, moreProps, other, {
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $cVgDf.jsx)($3fa621b39a3d0d49$var$ChipLabel, {
                className: (0, $gJjS7.default)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    }));
});
var $3fa621b39a3d0d49$export$2e2bcd8739ae039 = $3fa621b39a3d0d49$var$Chip;



var $1bdO8 = parcelRequire("1bdO8");



function $6f38dee70ca95ea0$var$TopWordChip({ word: word , rate: rate , active: active , onClick: onClick , onHover: onHover , onLeave: onLeave  }) {
    return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $b679af97cafc2a91$export$2e2bcd8739ae039), {
        title: `${rate?.toFixed(2)}`,
        placement: "top",
        children: /*#__PURE__*/ (0, $cVgDf.jsx)((0, $3fa621b39a3d0d49$export$2e2bcd8739ae039), {
            label: word,
            onClick: onClick,
            onMouseEnter: onHover,
            onMouseLeave: onLeave,
            sx: {
                fontWeight: active ? "bold" : "normal"
            }
        })
    });
}
function $6f38dee70ca95ea0$export$befd77afc753cb84() {
    const [shiftPressed] = (0, $b0ad4098c2db7014$export$2e2bcd8739ae039)("Shift");
    const [altPressed] = (0, $b0ad4098c2db7014$export$2e2bcd8739ae039)("Alt");
    const { dataset: dataset  } = (0, $a2bde23ea9c8df05$export$26531d8e255edf16)();
    const { selectedIds: selectedIds , searchText: searchText , setSearchText: setSearchText  } = (0, $91a6458dd589bbd0$export$4b4c417a6113a34c)();
    const [topWords, setTopWords] = (0, $1bdO8.useState)();
    const [hoveredWord, setHoveredWord] = (0, $1bdO8.useState)();
    (0, $1bdO8.useEffect)(()=>{
        setTopWords([]);
        if (dataset && selectedIds) dataset.textIndex.getTopWords(5, selectedIds).then((topWords)=>{
            setTopWords(Array.from(topWords).filter(([word])=>!!word));
        });
    }, [
        dataset,
        selectedIds
    ]);
    const getSearchTerm = (0, $1bdO8.useCallback)((word)=>{
        if (shiftPressed) return `+${word}`;
        else if (altPressed) return `-${word}`;
        else return word;
    }, [
        shiftPressed,
        altPressed
    ]);
    const handleSelectWord = (0, $1bdO8.useCallback)((word)=>{
        const term = getSearchTerm(word);
        setSearchText(searchText ? `${searchText} ${term}` : term);
    }, [
        searchText,
        shiftPressed,
        altPressed,
        setSearchText
    ]);
    const searchWords = (0, $1bdO8.useMemo)(()=>{
        return searchText.split(" ").filter(Boolean);
    }, [
        searchText
    ]);
    const total = selectedIds?.length || dataset?.count;
    if (!selectedIds || !total) return null;
    if (!topWords || topWords.length === 0) return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $89216f20f1c77281$export$2e2bcd8739ae039), {
        direction: "row",
        spacing: 1,
        height: 24
    });
    return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $89216f20f1c77281$export$2e2bcd8739ae039), {
        direction: "row",
        spacing: 1,
        height: 24,
        children: topWords.map(([word, count])=>/*#__PURE__*/ (0, $cVgDf.jsx)($6f38dee70ca95ea0$var$TopWordChip, {
                word: word,
                rate: count / total,
                active: searchWords.includes(word),
                onClick: ()=>handleSelectWord(word)
            }, word))
    });
}



var $cVgDf = parcelRequire("cVgDf");
parcelRequire("1bdO8");

var $15441e1a7a076f8e$exports = {};
"use strict";

Object.defineProperty($15441e1a7a076f8e$exports, "__esModule", {
    value: true
});
$15441e1a7a076f8e$exports.default = void 0;

var $15441e1a7a076f8e$var$_createSvgIcon = $83471781e862547b$exports((parcelRequire("ek3fl")));

var $cVgDf = parcelRequire("cVgDf");
var $15441e1a7a076f8e$var$_default = (0, $15441e1a7a076f8e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cVgDf.jsx)("path", {
    d: "M5 20h14v-2H5v2zM19 9h-4V3H9v6H5l7 7 7-7z"
}), "Download");
$15441e1a7a076f8e$exports.default = $15441e1a7a076f8e$var$_default;


function $2503e7c20b0a1ec5$export$c5a53c0801b32193(ids) {
    const blob = new Blob([
        ids.join("\n")
    ], {
        type: "text/plain"
    });
    const url = URL.createObjectURL(blob);
    // File name with selection and current timestamp
    const fileName = `selection-${Date.now()}.txt`;
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(url);
}
function $2503e7c20b0a1ec5$export$56f1789b3fbc7300({ selection: selection  }) {
    return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $b679af97cafc2a91$export$2e2bcd8739ae039), {
        title: "Download selected IDs",
        children: /*#__PURE__*/ (0, $cVgDf.jsx)((0, $7845ddbb24692f34$export$2e2bcd8739ae039), {
            onClick: ()=>{
                $2503e7c20b0a1ec5$export$c5a53c0801b32193(selection);
            },
            children: /*#__PURE__*/ (0, $cVgDf.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($15441e1a7a076f8e$exports))), {})
        })
    });
}



var $cVgDf = parcelRequire("cVgDf");
parcelRequire("1bdO8");


var $9bf70d838cc059fc$exports = {};
"use strict";

Object.defineProperty($9bf70d838cc059fc$exports, "__esModule", {
    value: true
});
$9bf70d838cc059fc$exports.default = void 0;

var $9bf70d838cc059fc$var$_createSvgIcon = $83471781e862547b$exports((parcelRequire("ek3fl")));

var $cVgDf = parcelRequire("cVgDf");
var $9bf70d838cc059fc$var$_default = (0, $9bf70d838cc059fc$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cVgDf.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
}), "ClearOutlined");
$9bf70d838cc059fc$exports.default = $9bf70d838cc059fc$var$_default;


function $5ef19184211c73de$export$bbfc8ae83c2d15c2() {
    const clear = (0, $91a6458dd589bbd0$export$4b4c417a6113a34c)((s)=>s.clearSelection);
    return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $b679af97cafc2a91$export$2e2bcd8739ae039), {
        title: "Clear selection",
        children: /*#__PURE__*/ (0, $cVgDf.jsx)((0, $7845ddbb24692f34$export$2e2bcd8739ae039), {
            onClick: clear,
            size: "small",
            children: /*#__PURE__*/ (0, $cVgDf.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9bf70d838cc059fc$exports))), {})
        })
    });
}



var $cVgDf = parcelRequire("cVgDf");

var $1bdO8 = parcelRequire("1bdO8");

var $63nUy = parcelRequire("63nUy");

var $fZ2DJ = parcelRequire("fZ2DJ");

var $1bdO8 = parcelRequire("1bdO8");


var $gJjS7 = parcelRequire("gJjS7");


var $9H0b9 = parcelRequire("9H0b9");

var $gIzLq = parcelRequire("gIzLq");

var $dHuM2 = parcelRequire("dHuM2");

var $fZ2DJ = parcelRequire("fZ2DJ");

var $63nUy = parcelRequire("63nUy");

var $1bdO8 = parcelRequire("1bdO8");


var $gJjS7 = parcelRequire("gJjS7");


var $9H0b9 = parcelRequire("9H0b9");

var $b8tOr = parcelRequire("b8tOr");

var $gIzLq = parcelRequire("gIzLq");
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $c62a7874592af22b$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $c62a7874592af22b$export$2e2bcd8739ae039 = $c62a7874592af22b$var$getOverlayAlpha;



var $dHuM2 = parcelRequire("dHuM2");


var $itJr1 = parcelRequire("itJr1");

var $9nXgc = parcelRequire("9nXgc");
function $b427243c31bbf50a$export$29cdb466b9b6f20b(slot) {
    return (0, $9nXgc.default)("MuiPaper", slot);
}
const $b427243c31bbf50a$var$paperClasses = (0, $itJr1.default)("MuiPaper", [
    "root",
    "rounded",
    "outlined",
    "elevation",
    "elevation0",
    "elevation1",
    "elevation2",
    "elevation3",
    "elevation4",
    "elevation5",
    "elevation6",
    "elevation7",
    "elevation8",
    "elevation9",
    "elevation10",
    "elevation11",
    "elevation12",
    "elevation13",
    "elevation14",
    "elevation15",
    "elevation16",
    "elevation17",
    "elevation18",
    "elevation19",
    "elevation20",
    "elevation21",
    "elevation22",
    "elevation23",
    "elevation24"
]);
var $b427243c31bbf50a$export$2e2bcd8739ae039 = $b427243c31bbf50a$var$paperClasses;



var $cVgDf = parcelRequire("cVgDf");
const $39353411c1daa853$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $39353411c1daa853$var$useUtilityClasses = (ownerState)=>{
    const { square: square , elevation: elevation , variant: variant , classes: classes  } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            !square && "rounded",
            variant === "elevation" && `elevation${elevation}`
        ]
    };
    return (0, $9H0b9.default)(slots, (0, $b427243c31bbf50a$export$29cdb466b9b6f20b), classes);
};
const $39353411c1daa853$var$PaperRoot = (0, $gIzLq.default)("div", {
    name: "MuiPaper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === "elevation" && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>{
    var _theme$vars$overlays;
    return (0, $63nUy.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create("box-shadow")
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === "outlined" && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === "elevation" && (0, $63nUy.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === "dark" && {
        backgroundImage: `linear-gradient(${(0, $b8tOr.alpha)("#fff", (0, $c62a7874592af22b$export$2e2bcd8739ae039)(ownerState.elevation))}, ${(0, $b8tOr.alpha)("#fff", (0, $c62a7874592af22b$export$2e2bcd8739ae039)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $39353411c1daa853$var$Paper = /*#__PURE__*/ $1bdO8.forwardRef(function Paper(inProps, ref) {
    const props = (0, $dHuM2.default)({
        props: inProps,
        name: "MuiPaper"
    });
    const { className: className , component: component = "div" , elevation: elevation = 1 , square: square = false , variant: variant = "elevation"  } = props, other = (0, $fZ2DJ.default)(props, $39353411c1daa853$var$_excluded);
    const ownerState = (0, $63nUy.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $39353411c1daa853$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $cVgDf.jsx)($39353411c1daa853$var$PaperRoot, (0, $63nUy.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $gJjS7.default)(classes.root, className),
        ref: ref
    }, other));
});
var $39353411c1daa853$export$2e2bcd8739ae039 = $39353411c1daa853$var$Paper;



var $itJr1 = parcelRequire("itJr1");

var $9nXgc = parcelRequire("9nXgc");
function $67863613e4a04519$export$f3b76d2cce458caa(slot) {
    return (0, $9nXgc.default)("MuiCard", slot);
}
const $67863613e4a04519$var$cardClasses = (0, $itJr1.default)("MuiCard", [
    "root"
]);
var $67863613e4a04519$export$2e2bcd8739ae039 = $67863613e4a04519$var$cardClasses;



var $cVgDf = parcelRequire("cVgDf");
const $bab588839ada6019$var$_excluded = [
    "className",
    "raised"
];
const $bab588839ada6019$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes  } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $9H0b9.default)(slots, (0, $67863613e4a04519$export$f3b76d2cce458caa), classes);
};
const $bab588839ada6019$var$CardRoot = (0, $gIzLq.default)((0, $39353411c1daa853$export$2e2bcd8739ae039), {
    name: "MuiCard",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        overflow: "hidden"
    };
});
const $bab588839ada6019$var$Card = /*#__PURE__*/ $1bdO8.forwardRef(function Card(inProps, ref) {
    const props = (0, $dHuM2.default)({
        props: inProps,
        name: "MuiCard"
    });
    const { className: className , raised: raised = false  } = props, other = (0, $fZ2DJ.default)(props, $bab588839ada6019$var$_excluded);
    const ownerState = (0, $63nUy.default)({}, props, {
        raised: raised
    });
    const classes = $bab588839ada6019$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $cVgDf.jsx)($bab588839ada6019$var$CardRoot, (0, $63nUy.default)({
        className: (0, $gJjS7.default)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $bab588839ada6019$export$2e2bcd8739ae039 = $bab588839ada6019$var$Card;


var $gIzLq = parcelRequire("gIzLq");
var $f67fa4407caafe12$exports = {};

$parcel$export($f67fa4407caafe12$exports, "Resizable", () => $f67fa4407caafe12$export$e82068809229c83c);

var $1bdO8 = parcelRequire("1bdO8");

var $9d8c463e652bc19f$exports = {};

$parcel$export($9d8c463e652bc19f$exports, "Resizer", () => $9d8c463e652bc19f$export$48a76196cafe3b93);

var $1bdO8 = parcelRequire("1bdO8");
var $9d8c463e652bc19f$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $9d8c463e652bc19f$var$__assign = undefined && undefined.__assign || function() {
    $9d8c463e652bc19f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9d8c463e652bc19f$var$__assign.apply(this, arguments);
};
var $9d8c463e652bc19f$var$rowSizeBase = {
    width: "100%",
    height: "10px",
    top: "0px",
    left: "0px",
    cursor: "row-resize"
};
var $9d8c463e652bc19f$var$colSizeBase = {
    width: "10px",
    height: "100%",
    top: "0px",
    left: "0px",
    cursor: "col-resize"
};
var $9d8c463e652bc19f$var$edgeBase = {
    width: "20px",
    height: "20px",
    position: "absolute"
};
var $9d8c463e652bc19f$var$styles = {
    top: $9d8c463e652bc19f$var$__assign($9d8c463e652bc19f$var$__assign({}, $9d8c463e652bc19f$var$rowSizeBase), {
        top: "-5px"
    }),
    right: $9d8c463e652bc19f$var$__assign($9d8c463e652bc19f$var$__assign({}, $9d8c463e652bc19f$var$colSizeBase), {
        left: undefined,
        right: "-5px"
    }),
    bottom: $9d8c463e652bc19f$var$__assign($9d8c463e652bc19f$var$__assign({}, $9d8c463e652bc19f$var$rowSizeBase), {
        top: undefined,
        bottom: "-5px"
    }),
    left: $9d8c463e652bc19f$var$__assign($9d8c463e652bc19f$var$__assign({}, $9d8c463e652bc19f$var$colSizeBase), {
        left: "-5px"
    }),
    topRight: $9d8c463e652bc19f$var$__assign($9d8c463e652bc19f$var$__assign({}, $9d8c463e652bc19f$var$edgeBase), {
        right: "-10px",
        top: "-10px",
        cursor: "ne-resize"
    }),
    bottomRight: $9d8c463e652bc19f$var$__assign($9d8c463e652bc19f$var$__assign({}, $9d8c463e652bc19f$var$edgeBase), {
        right: "-10px",
        bottom: "-10px",
        cursor: "se-resize"
    }),
    bottomLeft: $9d8c463e652bc19f$var$__assign($9d8c463e652bc19f$var$__assign({}, $9d8c463e652bc19f$var$edgeBase), {
        left: "-10px",
        bottom: "-10px",
        cursor: "sw-resize"
    }),
    topLeft: $9d8c463e652bc19f$var$__assign($9d8c463e652bc19f$var$__assign({}, $9d8c463e652bc19f$var$edgeBase), {
        left: "-10px",
        top: "-10px",
        cursor: "nw-resize"
    })
};
var $9d8c463e652bc19f$export$48a76196cafe3b93 = /** @class */ function(_super) {
    $9d8c463e652bc19f$var$__extends(Resizer, _super);
    function Resizer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onMouseDown = function(e) {
            _this.props.onResizeStart(e, _this.props.direction);
        };
        _this.onTouchStart = function(e) {
            _this.props.onResizeStart(e, _this.props.direction);
        };
        return _this;
    }
    Resizer.prototype.render = function() {
        return $1bdO8.createElement("div", {
            className: this.props.className || "",
            style: $9d8c463e652bc19f$var$__assign($9d8c463e652bc19f$var$__assign({
                position: "absolute",
                userSelect: "none"
            }, $9d8c463e652bc19f$var$styles[this.props.direction]), this.props.replaceStyles || {}),
            onMouseDown: this.onMouseDown,
            onTouchStart: this.onTouchStart
        }, this.props.children);
    };
    return Resizer;
}($1bdO8.PureComponent);


var $f67fa4407caafe12$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $f67fa4407caafe12$var$__assign = undefined && undefined.__assign || function() {
    $f67fa4407caafe12$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f67fa4407caafe12$var$__assign.apply(this, arguments);
};
var $f67fa4407caafe12$var$DEFAULT_SIZE = {
    width: "auto",
    height: "auto"
};
var $f67fa4407caafe12$var$clamp = function(n, min, max) {
    return Math.max(Math.min(n, max), min);
};
var $f67fa4407caafe12$var$snap = function(n, size) {
    return Math.round(n / size) * size;
};
var $f67fa4407caafe12$var$hasDirection = function(dir, target) {
    return new RegExp(dir, "i").test(target);
};
// INFO: In case of window is a Proxy and does not porxy Events correctly, use isTouchEvent & isMouseEvent to distinguish event type instead of `instanceof`.
var $f67fa4407caafe12$var$isTouchEvent = function(event) {
    return Boolean(event.touches && event.touches.length);
};
var $f67fa4407caafe12$var$isMouseEvent = function(event) {
    return Boolean((event.clientX || event.clientX === 0) && (event.clientY || event.clientY === 0));
};
var $f67fa4407caafe12$var$findClosestSnap = function(n, snapArray, snapGap) {
    if (snapGap === void 0) snapGap = 0;
    var closestGapIndex = snapArray.reduce(function(prev, curr, index) {
        return Math.abs(curr - n) < Math.abs(snapArray[prev] - n) ? index : prev;
    }, 0);
    var gap = Math.abs(snapArray[closestGapIndex] - n);
    return snapGap === 0 || gap < snapGap ? snapArray[closestGapIndex] : n;
};
var $f67fa4407caafe12$var$getStringSize = function(n) {
    n = n.toString();
    if (n === "auto") return n;
    if (n.endsWith("px")) return n;
    if (n.endsWith("%")) return n;
    if (n.endsWith("vh")) return n;
    if (n.endsWith("vw")) return n;
    if (n.endsWith("vmax")) return n;
    if (n.endsWith("vmin")) return n;
    return n + "px";
};
var $f67fa4407caafe12$var$getPixelSize = function(size, parentSize, innerWidth, innerHeight) {
    if (size && typeof size === "string") {
        if (size.endsWith("px")) return Number(size.replace("px", ""));
        if (size.endsWith("%")) {
            var ratio = Number(size.replace("%", "")) / 100;
            return parentSize * ratio;
        }
        if (size.endsWith("vw")) {
            var ratio = Number(size.replace("vw", "")) / 100;
            return innerWidth * ratio;
        }
        if (size.endsWith("vh")) {
            var ratio = Number(size.replace("vh", "")) / 100;
            return innerHeight * ratio;
        }
    }
    return size;
};
var $f67fa4407caafe12$var$calculateNewMax = function(parentSize, innerWidth, innerHeight, maxWidth, maxHeight, minWidth, minHeight) {
    maxWidth = $f67fa4407caafe12$var$getPixelSize(maxWidth, parentSize.width, innerWidth, innerHeight);
    maxHeight = $f67fa4407caafe12$var$getPixelSize(maxHeight, parentSize.height, innerWidth, innerHeight);
    minWidth = $f67fa4407caafe12$var$getPixelSize(minWidth, parentSize.width, innerWidth, innerHeight);
    minHeight = $f67fa4407caafe12$var$getPixelSize(minHeight, parentSize.height, innerWidth, innerHeight);
    return {
        maxWidth: typeof maxWidth === "undefined" ? undefined : Number(maxWidth),
        maxHeight: typeof maxHeight === "undefined" ? undefined : Number(maxHeight),
        minWidth: typeof minWidth === "undefined" ? undefined : Number(minWidth),
        minHeight: typeof minHeight === "undefined" ? undefined : Number(minHeight)
    };
};
var $f67fa4407caafe12$var$definedProps = [
    "as",
    "style",
    "className",
    "grid",
    "snap",
    "bounds",
    "boundsByDirection",
    "size",
    "defaultSize",
    "minWidth",
    "minHeight",
    "maxWidth",
    "maxHeight",
    "lockAspectRatio",
    "lockAspectRatioExtraWidth",
    "lockAspectRatioExtraHeight",
    "enable",
    "handleStyles",
    "handleClasses",
    "handleWrapperStyle",
    "handleWrapperClass",
    "children",
    "onResizeStart",
    "onResize",
    "onResizeStop",
    "handleComponent",
    "scale",
    "resizeRatio",
    "snapGap"
];
// HACK: This class is used to calculate % size.
var $f67fa4407caafe12$var$baseClassName = "__resizable_base__";
var $f67fa4407caafe12$export$e82068809229c83c = /** @class */ function(_super) {
    $f67fa4407caafe12$var$__extends(Resizable, _super);
    function Resizable(props) {
        var _this = _super.call(this, props) || this;
        _this.ratio = 1;
        _this.resizable = null;
        // For parent boundary
        _this.parentLeft = 0;
        _this.parentTop = 0;
        // For boundary
        _this.resizableLeft = 0;
        _this.resizableRight = 0;
        _this.resizableTop = 0;
        _this.resizableBottom = 0;
        // For target boundary
        _this.targetLeft = 0;
        _this.targetTop = 0;
        _this.appendBase = function() {
            if (!_this.resizable || !_this.window) return null;
            var parent = _this.parentNode;
            if (!parent) return null;
            var element = _this.window.document.createElement("div");
            element.style.width = "100%";
            element.style.height = "100%";
            element.style.position = "absolute";
            element.style.transform = "scale(0, 0)";
            element.style.left = "0";
            element.style.flex = "0 0 100%";
            if (element.classList) element.classList.add($f67fa4407caafe12$var$baseClassName);
            else element.className += $f67fa4407caafe12$var$baseClassName;
            parent.appendChild(element);
            return element;
        };
        _this.removeBase = function(base) {
            var parent = _this.parentNode;
            if (!parent) return;
            parent.removeChild(base);
        };
        _this.ref = function(c) {
            if (c) _this.resizable = c;
        };
        _this.state = {
            isResizing: false,
            width: typeof (_this.propsSize && _this.propsSize.width) === "undefined" ? "auto" : _this.propsSize && _this.propsSize.width,
            height: typeof (_this.propsSize && _this.propsSize.height) === "undefined" ? "auto" : _this.propsSize && _this.propsSize.height,
            direction: "right",
            original: {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            },
            backgroundStyle: {
                height: "100%",
                width: "100%",
                backgroundColor: "rgba(0,0,0,0)",
                cursor: "auto",
                opacity: 0,
                position: "fixed",
                zIndex: 9999,
                top: "0",
                left: "0",
                bottom: "0",
                right: "0"
            },
            flexBasis: undefined
        };
        _this.onResizeStart = _this.onResizeStart.bind(_this);
        _this.onMouseMove = _this.onMouseMove.bind(_this);
        _this.onMouseUp = _this.onMouseUp.bind(_this);
        return _this;
    }
    Object.defineProperty(Resizable.prototype, "parentNode", {
        get: function() {
            if (!this.resizable) return null;
            return this.resizable.parentNode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "window", {
        get: function() {
            if (!this.resizable) return null;
            if (!this.resizable.ownerDocument) return null;
            return this.resizable.ownerDocument.defaultView;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "propsSize", {
        get: function() {
            return this.props.size || this.props.defaultSize || $f67fa4407caafe12$var$DEFAULT_SIZE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "size", {
        get: function() {
            var width = 0;
            var height = 0;
            if (this.resizable && this.window) {
                var orgWidth = this.resizable.offsetWidth;
                var orgHeight = this.resizable.offsetHeight;
                // HACK: Set position `relative` to get parent size.
                //       This is because when re-resizable set `absolute`, I can not get base width correctly.
                var orgPosition = this.resizable.style.position;
                if (orgPosition !== "relative") this.resizable.style.position = "relative";
                // INFO: Use original width or height if set auto.
                width = this.resizable.style.width !== "auto" ? this.resizable.offsetWidth : orgWidth;
                height = this.resizable.style.height !== "auto" ? this.resizable.offsetHeight : orgHeight;
                // Restore original position
                this.resizable.style.position = orgPosition;
            }
            return {
                width: width,
                height: height
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "sizeStyle", {
        get: function() {
            var _this = this;
            var size = this.props.size;
            var getSize = function(key) {
                if (typeof _this.state[key] === "undefined" || _this.state[key] === "auto") return "auto";
                if (_this.propsSize && _this.propsSize[key] && _this.propsSize[key].toString().endsWith("%")) {
                    if (_this.state[key].toString().endsWith("%")) return _this.state[key].toString();
                    var parentSize = _this.getParentSize();
                    var value = Number(_this.state[key].toString().replace("px", ""));
                    var percent = value / parentSize[key] * 100;
                    return percent + "%";
                }
                return $f67fa4407caafe12$var$getStringSize(_this.state[key]);
            };
            var width = size && typeof size.width !== "undefined" && !this.state.isResizing ? $f67fa4407caafe12$var$getStringSize(size.width) : getSize("width");
            var height = size && typeof size.height !== "undefined" && !this.state.isResizing ? $f67fa4407caafe12$var$getStringSize(size.height) : getSize("height");
            return {
                width: width,
                height: height
            };
        },
        enumerable: false,
        configurable: true
    });
    Resizable.prototype.getParentSize = function() {
        if (!this.parentNode) {
            if (!this.window) return {
                width: 0,
                height: 0
            };
            return {
                width: this.window.innerWidth,
                height: this.window.innerHeight
            };
        }
        var base = this.appendBase();
        if (!base) return {
            width: 0,
            height: 0
        };
        // INFO: To calculate parent width with flex layout
        var wrapChanged = false;
        var wrap = this.parentNode.style.flexWrap;
        if (wrap !== "wrap") {
            wrapChanged = true;
            this.parentNode.style.flexWrap = "wrap";
        // HACK: Use relative to get parent padding size
        }
        base.style.position = "relative";
        base.style.minWidth = "100%";
        base.style.minHeight = "100%";
        var size = {
            width: base.offsetWidth,
            height: base.offsetHeight
        };
        if (wrapChanged) this.parentNode.style.flexWrap = wrap;
        this.removeBase(base);
        return size;
    };
    Resizable.prototype.bindEvents = function() {
        if (this.window) {
            this.window.addEventListener("mouseup", this.onMouseUp);
            this.window.addEventListener("mousemove", this.onMouseMove);
            this.window.addEventListener("mouseleave", this.onMouseUp);
            this.window.addEventListener("touchmove", this.onMouseMove, {
                capture: true,
                passive: false
            });
            this.window.addEventListener("touchend", this.onMouseUp);
        }
    };
    Resizable.prototype.unbindEvents = function() {
        if (this.window) {
            this.window.removeEventListener("mouseup", this.onMouseUp);
            this.window.removeEventListener("mousemove", this.onMouseMove);
            this.window.removeEventListener("mouseleave", this.onMouseUp);
            this.window.removeEventListener("touchmove", this.onMouseMove, true);
            this.window.removeEventListener("touchend", this.onMouseUp);
        }
    };
    Resizable.prototype.componentDidMount = function() {
        if (!this.resizable || !this.window) return;
        var computedStyle = this.window.getComputedStyle(this.resizable);
        this.setState({
            width: this.state.width || this.size.width,
            height: this.state.height || this.size.height,
            flexBasis: computedStyle.flexBasis !== "auto" ? computedStyle.flexBasis : undefined
        });
    };
    Resizable.prototype.componentWillUnmount = function() {
        if (this.window) this.unbindEvents();
    };
    Resizable.prototype.createSizeForCssProperty = function(newSize, kind) {
        var propsSize = this.propsSize && this.propsSize[kind];
        return this.state[kind] === "auto" && this.state.original[kind] === newSize && (typeof propsSize === "undefined" || propsSize === "auto") ? "auto" : newSize;
    };
    Resizable.prototype.calculateNewMaxFromBoundary = function(maxWidth, maxHeight) {
        var boundsByDirection = this.props.boundsByDirection;
        var direction = this.state.direction;
        var widthByDirection = boundsByDirection && $f67fa4407caafe12$var$hasDirection("left", direction);
        var heightByDirection = boundsByDirection && $f67fa4407caafe12$var$hasDirection("top", direction);
        var boundWidth;
        var boundHeight;
        if (this.props.bounds === "parent") {
            var parent_1 = this.parentNode;
            if (parent_1) {
                boundWidth = widthByDirection ? this.resizableRight - this.parentLeft : parent_1.offsetWidth + (this.parentLeft - this.resizableLeft);
                boundHeight = heightByDirection ? this.resizableBottom - this.parentTop : parent_1.offsetHeight + (this.parentTop - this.resizableTop);
            }
        } else if (this.props.bounds === "window") {
            if (this.window) {
                boundWidth = widthByDirection ? this.resizableRight : this.window.innerWidth - this.resizableLeft;
                boundHeight = heightByDirection ? this.resizableBottom : this.window.innerHeight - this.resizableTop;
            }
        } else if (this.props.bounds) {
            boundWidth = widthByDirection ? this.resizableRight - this.targetLeft : this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft);
            boundHeight = heightByDirection ? this.resizableBottom - this.targetTop : this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop);
        }
        if (boundWidth && Number.isFinite(boundWidth)) maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
        if (boundHeight && Number.isFinite(boundHeight)) maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
        return {
            maxWidth: maxWidth,
            maxHeight: maxHeight
        };
    };
    Resizable.prototype.calculateNewSizeFromDirection = function(clientX, clientY) {
        var scale = this.props.scale || 1;
        var resizeRatio = this.props.resizeRatio || 1;
        var _a = this.state, direction = _a.direction, original = _a.original;
        var _b = this.props, lockAspectRatio = _b.lockAspectRatio, lockAspectRatioExtraHeight = _b.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _b.lockAspectRatioExtraWidth;
        var newWidth = original.width;
        var newHeight = original.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if ($f67fa4407caafe12$var$hasDirection("right", direction)) {
            newWidth = original.width + (clientX - original.x) * resizeRatio / scale;
            if (lockAspectRatio) newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
        }
        if ($f67fa4407caafe12$var$hasDirection("left", direction)) {
            newWidth = original.width - (clientX - original.x) * resizeRatio / scale;
            if (lockAspectRatio) newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
        }
        if ($f67fa4407caafe12$var$hasDirection("bottom", direction)) {
            newHeight = original.height + (clientY - original.y) * resizeRatio / scale;
            if (lockAspectRatio) newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
        }
        if ($f67fa4407caafe12$var$hasDirection("top", direction)) {
            newHeight = original.height - (clientY - original.y) * resizeRatio / scale;
            if (lockAspectRatio) newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
        }
        return {
            newWidth: newWidth,
            newHeight: newHeight
        };
    };
    Resizable.prototype.calculateNewSizeFromAspectRatio = function(newWidth, newHeight, max, min) {
        var _a = this.props, lockAspectRatio = _a.lockAspectRatio, lockAspectRatioExtraHeight = _a.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _a.lockAspectRatioExtraWidth;
        var computedMinWidth = typeof min.width === "undefined" ? 10 : min.width;
        var computedMaxWidth = typeof max.width === "undefined" || max.width < 0 ? newWidth : max.width;
        var computedMinHeight = typeof min.height === "undefined" ? 10 : min.height;
        var computedMaxHeight = typeof max.height === "undefined" || max.height < 0 ? newHeight : max.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if (lockAspectRatio) {
            var extraMinWidth = (computedMinHeight - extraHeight) * this.ratio + extraWidth;
            var extraMaxWidth = (computedMaxHeight - extraHeight) * this.ratio + extraWidth;
            var extraMinHeight = (computedMinWidth - extraWidth) / this.ratio + extraHeight;
            var extraMaxHeight = (computedMaxWidth - extraWidth) / this.ratio + extraHeight;
            var lockedMinWidth = Math.max(computedMinWidth, extraMinWidth);
            var lockedMaxWidth = Math.min(computedMaxWidth, extraMaxWidth);
            var lockedMinHeight = Math.max(computedMinHeight, extraMinHeight);
            var lockedMaxHeight = Math.min(computedMaxHeight, extraMaxHeight);
            newWidth = $f67fa4407caafe12$var$clamp(newWidth, lockedMinWidth, lockedMaxWidth);
            newHeight = $f67fa4407caafe12$var$clamp(newHeight, lockedMinHeight, lockedMaxHeight);
        } else {
            newWidth = $f67fa4407caafe12$var$clamp(newWidth, computedMinWidth, computedMaxWidth);
            newHeight = $f67fa4407caafe12$var$clamp(newHeight, computedMinHeight, computedMaxHeight);
        }
        return {
            newWidth: newWidth,
            newHeight: newHeight
        };
    };
    Resizable.prototype.setBoundingClientRect = function() {
        // For parent boundary
        if (this.props.bounds === "parent") {
            var parent_2 = this.parentNode;
            if (parent_2) {
                var parentRect = parent_2.getBoundingClientRect();
                this.parentLeft = parentRect.left;
                this.parentTop = parentRect.top;
            }
        }
        // For target(html element) boundary
        if (this.props.bounds && typeof this.props.bounds !== "string") {
            var targetRect = this.props.bounds.getBoundingClientRect();
            this.targetLeft = targetRect.left;
            this.targetTop = targetRect.top;
        }
        // For boundary
        if (this.resizable) {
            var _a = this.resizable.getBoundingClientRect(), left = _a.left, top_1 = _a.top, right = _a.right, bottom = _a.bottom;
            this.resizableLeft = left;
            this.resizableRight = right;
            this.resizableTop = top_1;
            this.resizableBottom = bottom;
        }
    };
    Resizable.prototype.onResizeStart = function(event, direction) {
        if (!this.resizable || !this.window) return;
        var clientX = 0;
        var clientY = 0;
        if (event.nativeEvent && $f67fa4407caafe12$var$isMouseEvent(event.nativeEvent)) {
            clientX = event.nativeEvent.clientX;
            clientY = event.nativeEvent.clientY;
        } else if (event.nativeEvent && $f67fa4407caafe12$var$isTouchEvent(event.nativeEvent)) {
            clientX = event.nativeEvent.touches[0].clientX;
            clientY = event.nativeEvent.touches[0].clientY;
        }
        if (this.props.onResizeStart) {
            if (this.resizable) {
                var startResize = this.props.onResizeStart(event, direction, this.resizable);
                if (startResize === false) return;
            }
        }
        // Fix #168
        if (this.props.size) {
            if (typeof this.props.size.height !== "undefined" && this.props.size.height !== this.state.height) this.setState({
                height: this.props.size.height
            });
            if (typeof this.props.size.width !== "undefined" && this.props.size.width !== this.state.width) this.setState({
                width: this.props.size.width
            });
        }
        // For lockAspectRatio case
        this.ratio = typeof this.props.lockAspectRatio === "number" ? this.props.lockAspectRatio : this.size.width / this.size.height;
        var flexBasis;
        var computedStyle = this.window.getComputedStyle(this.resizable);
        if (computedStyle.flexBasis !== "auto") {
            var parent_3 = this.parentNode;
            if (parent_3) {
                var dir = this.window.getComputedStyle(parent_3).flexDirection;
                this.flexDir = dir.startsWith("row") ? "row" : "column";
                flexBasis = computedStyle.flexBasis;
            }
        }
        // For boundary
        this.setBoundingClientRect();
        this.bindEvents();
        var state = {
            original: {
                x: clientX,
                y: clientY,
                width: this.size.width,
                height: this.size.height
            },
            isResizing: true,
            backgroundStyle: $f67fa4407caafe12$var$__assign($f67fa4407caafe12$var$__assign({}, this.state.backgroundStyle), {
                cursor: this.window.getComputedStyle(event.target).cursor || "auto"
            }),
            direction: direction,
            flexBasis: flexBasis
        };
        this.setState(state);
    };
    Resizable.prototype.onMouseMove = function(event) {
        var _this = this;
        if (!this.state.isResizing || !this.resizable || !this.window) return;
        if (this.window.TouchEvent && $f67fa4407caafe12$var$isTouchEvent(event)) try {
            event.preventDefault();
            event.stopPropagation();
        } catch (e) {
        // Ignore on fail
        }
        var _a = this.props, maxWidth = _a.maxWidth, maxHeight = _a.maxHeight, minWidth = _a.minWidth, minHeight = _a.minHeight;
        var clientX = $f67fa4407caafe12$var$isTouchEvent(event) ? event.touches[0].clientX : event.clientX;
        var clientY = $f67fa4407caafe12$var$isTouchEvent(event) ? event.touches[0].clientY : event.clientY;
        var _b = this.state, direction = _b.direction, original = _b.original, width = _b.width, height = _b.height;
        var parentSize = this.getParentSize();
        var max = $f67fa4407caafe12$var$calculateNewMax(parentSize, this.window.innerWidth, this.window.innerHeight, maxWidth, maxHeight, minWidth, minHeight);
        maxWidth = max.maxWidth;
        maxHeight = max.maxHeight;
        minWidth = max.minWidth;
        minHeight = max.minHeight;
        // Calculate new size
        var _c = this.calculateNewSizeFromDirection(clientX, clientY), newHeight = _c.newHeight, newWidth = _c.newWidth;
        // Calculate max size from boundary settings
        var boundaryMax = this.calculateNewMaxFromBoundary(maxWidth, maxHeight);
        if (this.props.snap && this.props.snap.x) newWidth = $f67fa4407caafe12$var$findClosestSnap(newWidth, this.props.snap.x, this.props.snapGap);
        if (this.props.snap && this.props.snap.y) newHeight = $f67fa4407caafe12$var$findClosestSnap(newHeight, this.props.snap.y, this.props.snapGap);
        // Calculate new size from aspect ratio
        var newSize = this.calculateNewSizeFromAspectRatio(newWidth, newHeight, {
            width: boundaryMax.maxWidth,
            height: boundaryMax.maxHeight
        }, {
            width: minWidth,
            height: minHeight
        });
        newWidth = newSize.newWidth;
        newHeight = newSize.newHeight;
        if (this.props.grid) {
            var newGridWidth = $f67fa4407caafe12$var$snap(newWidth, this.props.grid[0]);
            var newGridHeight = $f67fa4407caafe12$var$snap(newHeight, this.props.grid[1]);
            var gap = this.props.snapGap || 0;
            newWidth = gap === 0 || Math.abs(newGridWidth - newWidth) <= gap ? newGridWidth : newWidth;
            newHeight = gap === 0 || Math.abs(newGridHeight - newHeight) <= gap ? newGridHeight : newHeight;
        }
        var delta = {
            width: newWidth - original.width,
            height: newHeight - original.height
        };
        if (width && typeof width === "string") {
            if (width.endsWith("%")) {
                var percent = newWidth / parentSize.width * 100;
                newWidth = percent + "%";
            } else if (width.endsWith("vw")) {
                var vw = newWidth / this.window.innerWidth * 100;
                newWidth = vw + "vw";
            } else if (width.endsWith("vh")) {
                var vh = newWidth / this.window.innerHeight * 100;
                newWidth = vh + "vh";
            }
        }
        if (height && typeof height === "string") {
            if (height.endsWith("%")) {
                var percent = newHeight / parentSize.height * 100;
                newHeight = percent + "%";
            } else if (height.endsWith("vw")) {
                var vw = newHeight / this.window.innerWidth * 100;
                newHeight = vw + "vw";
            } else if (height.endsWith("vh")) {
                var vh = newHeight / this.window.innerHeight * 100;
                newHeight = vh + "vh";
            }
        }
        var newState = {
            width: this.createSizeForCssProperty(newWidth, "width"),
            height: this.createSizeForCssProperty(newHeight, "height")
        };
        if (this.flexDir === "row") newState.flexBasis = newState.width;
        else if (this.flexDir === "column") newState.flexBasis = newState.height;
        // For v18, update state sync
        (0, $82db826d323863e6$exports.flushSync)(function() {
            _this.setState(newState);
        });
        if (this.props.onResize) this.props.onResize(event, direction, this.resizable, delta);
    };
    Resizable.prototype.onMouseUp = function(event) {
        var _a = this.state, isResizing = _a.isResizing, direction = _a.direction, original = _a.original;
        if (!isResizing || !this.resizable) return;
        var delta = {
            width: this.size.width - original.width,
            height: this.size.height - original.height
        };
        if (this.props.onResizeStop) this.props.onResizeStop(event, direction, this.resizable, delta);
        if (this.props.size) this.setState(this.props.size);
        this.unbindEvents();
        this.setState({
            isResizing: false,
            backgroundStyle: $f67fa4407caafe12$var$__assign($f67fa4407caafe12$var$__assign({}, this.state.backgroundStyle), {
                cursor: "auto"
            })
        });
    };
    Resizable.prototype.updateSize = function(size) {
        this.setState({
            width: size.width,
            height: size.height
        });
    };
    Resizable.prototype.renderResizer = function() {
        var _this = this;
        var _a = this.props, enable = _a.enable, handleStyles = _a.handleStyles, handleClasses = _a.handleClasses, handleWrapperStyle = _a.handleWrapperStyle, handleWrapperClass = _a.handleWrapperClass, handleComponent = _a.handleComponent;
        if (!enable) return null;
        var resizers = Object.keys(enable).map(function(dir) {
            if (enable[dir] !== false) return $1bdO8.createElement((0, $9d8c463e652bc19f$exports.Resizer), {
                key: dir,
                direction: dir,
                onResizeStart: _this.onResizeStart,
                replaceStyles: handleStyles && handleStyles[dir],
                className: handleClasses && handleClasses[dir]
            }, handleComponent && handleComponent[dir] ? handleComponent[dir] : null);
            return null;
        });
        // #93 Wrap the resize box in span (will not break 100% width/height)
        return $1bdO8.createElement("div", {
            className: handleWrapperClass,
            style: handleWrapperStyle
        }, resizers);
    };
    Resizable.prototype.render = function() {
        var _this = this;
        var extendsProps = Object.keys(this.props).reduce(function(acc, key) {
            if ($f67fa4407caafe12$var$definedProps.indexOf(key) !== -1) return acc;
            acc[key] = _this.props[key];
            return acc;
        }, {});
        var style = $f67fa4407caafe12$var$__assign($f67fa4407caafe12$var$__assign($f67fa4407caafe12$var$__assign({
            position: "relative",
            userSelect: this.state.isResizing ? "none" : "auto"
        }, this.props.style), this.sizeStyle), {
            maxWidth: this.props.maxWidth,
            maxHeight: this.props.maxHeight,
            minWidth: this.props.minWidth,
            minHeight: this.props.minHeight,
            boxSizing: "border-box",
            flexShrink: 0
        });
        if (this.state.flexBasis) style.flexBasis = this.state.flexBasis;
        var Wrapper = this.props.as || "div";
        return $1bdO8.createElement(Wrapper, $f67fa4407caafe12$var$__assign({
            ref: this.ref,
            style: style,
            className: this.props.className
        }, extendsProps), this.state.isResizing && $1bdO8.createElement("div", {
            style: this.state.backgroundStyle
        }), this.props.children, this.renderResizer());
    };
    Resizable.defaultProps = {
        as: "div",
        onResizeStart: function() {},
        onResize: function() {},
        onResizeStop: function() {},
        enable: {
            top: true,
            right: true,
            bottom: true,
            left: true,
            topRight: true,
            bottomRight: true,
            bottomLeft: true,
            topLeft: true
        },
        style: {},
        grid: [
            1,
            1
        ],
        lockAspectRatio: false,
        lockAspectRatioExtraWidth: 0,
        lockAspectRatioExtraHeight: 0,
        scale: 1,
        resizeRatio: 1,
        snapGap: 0
    };
    return Resizable;
}($1bdO8.PureComponent);


const $2fb6a1736516e874$var$StyledCard = (0, $gIzLq.default)((0, $bab588839ada6019$export$2e2bcd8739ae039))({
    width: "100%",
    height: "100%",
    pointerEvents: "auto",
    position: "relative",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column"
});
function $2fb6a1736516e874$export$c9c6445c4bdbecee({ enabled: enabled = true , width: width = 300 , height: height = 300 , minWidth: minWidth = 300 , minHeight: minHeight = 300 , maxWidth: maxWidth = 800 , maxHeight: maxHeight = 800 , areas: areas = [] , ...props }) {
    const enable = (0, $1bdO8.useMemo)(()=>{
        return Object.fromEntries(areas.map((area)=>[
                area,
                enabled
            ]));
    }, [
        areas,
        enabled
    ]);
    return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $f67fa4407caafe12$exports.Resizable), {
        defaultSize: {
            width: width,
            height: height
        },
        minWidth: minWidth,
        minHeight: minHeight,
        maxWidth: maxWidth,
        maxHeight: maxHeight,
        enable: enable,
        style: {
            maxHeight: "100%",
            pointerEvents: enabled ? "auto" : "none"
        },
        children: enabled && /*#__PURE__*/ (0, $cVgDf.jsx)($2fb6a1736516e874$var$StyledCard, {
            ...props
        })
    });
}


function $e385011a49baa960$var$Row({ label: label , value: value  }) {
    return /*#__PURE__*/ (0, $cVgDf.jsxs)((0, $15020dfde881caab$export$2e2bcd8739ae039), {
        sx: {
            lineHeight: 1.25,
            overflow: "hidden",
            textOverflow: "ellipsis"
        },
        children: [
            /*#__PURE__*/ (0, $cVgDf.jsxs)("b", {
                children: [
                    label,
                    ": "
                ]
            }),
            value
        ]
    });
}
function $e385011a49baa960$var$Title({ id: id , position: position  }) {
    return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $89216f20f1c77281$export$2e2bcd8739ae039), {
        padding: 2,
        overflow: "hidden",
        children: /*#__PURE__*/ (0, $cVgDf.jsxs)((0, $89216f20f1c77281$export$2e2bcd8739ae039), {
            direction: "row",
            spacing: 3,
            children: [
                /*#__PURE__*/ (0, $cVgDf.jsxs)((0, $15020dfde881caab$export$2e2bcd8739ae039), {
                    color: "primary",
                    children: [
                        /*#__PURE__*/ (0, $cVgDf.jsx)("b", {
                            children: "ID: "
                        }),
                        /*#__PURE__*/ (0, $cVgDf.jsx)("span", {
                            children: id
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $cVgDf.jsx)((0, $15020dfde881caab$export$2e2bcd8739ae039), {
                    color: "secondary",
                    children: position
                })
            ]
        })
    });
}
function $e385011a49baa960$var$Document({ id: id , values: values  }) {
    const rows = (0, $1bdO8.useMemo)(()=>{
        const rows = [];
        if (values) rows.push(...values.entries());
        return rows.filter((row)=>![
                "x",
                "y",
                "z"
            ].includes(row[0]));
    }, [
        values
    ]);
    return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $89216f20f1c77281$export$2e2bcd8739ae039), {
        spacing: 2,
        children: rows.map(([key, value])=>/*#__PURE__*/ (0, $cVgDf.jsx)($e385011a49baa960$var$Row, {
                label: key,
                value: value
            }, key))
    });
}
function $e385011a49baa960$export$85da36fd8391a81() {
    const [currentId, setCurrentId] = (0, $1bdO8.useState)(0);
    const { dataset: dataset  } = (0, $a2bde23ea9c8df05$export$26531d8e255edf16)();
    const selection = (0, $91a6458dd589bbd0$export$4b4c417a6113a34c)((s)=>s.selectedIds);
    const highlighted = (0, $91a6458dd589bbd0$export$4b4c417a6113a34c)((s)=>s.highlightIds);
    const showingId = highlighted[0] ?? selection[currentId];
    const isHighlight = highlighted.length > 0;
    const [shiftPressed] = (0, $b0ad4098c2db7014$export$2e2bcd8739ae039)("Shift");
    const [currentValues, setCurrentValues] = (0, $1bdO8.useState)();
    const [projection, setProjection] = (0, $1bdO8.useState)();
    (0, $1bdO8.useEffect)(()=>{
        if (showingId !== undefined) {
            const values = dataset?.getDisplayValues(showingId);
            const projection = dataset?.projections?.getDisplayValue(showingId);
            setCurrentValues(values);
            setProjection(projection);
        }
    }, [
        showingId,
        selection,
        dataset
    ]);
    const count = selection.length;
    const handleReset = (0, $1bdO8.useCallback)(()=>{
        setCurrentId(0);
    }, []);
    const handleMove = (0, $1bdO8.useCallback)((delta)=>{
        setCurrentId((i)=>Math.min(count - 1, Math.max(0, i + delta)));
    }, [
        count
    ]);
    const handlePrevious = (0, $1bdO8.useCallback)(()=>handleMove(shiftPressed ? -5 : -1), [
        handleMove,
        shiftPressed
    ]);
    const handleNext = (0, $1bdO8.useCallback)(()=>handleMove(shiftPressed ? 5 : 1), [
        handleMove,
        shiftPressed
    ]);
    (0, $06a60cf932bc70f9$export$2e2bcd8739ae039)("ArrowLeft", handlePrevious, {}, [
        handlePrevious
    ]);
    (0, $06a60cf932bc70f9$export$2e2bcd8739ae039)("ArrowRight", handleNext, {}, [
        handlePrevious
    ]);
    (0, $1bdO8.useEffect)(handleReset, [
        count
    ]);
    const handleWheel = (0, $1bdO8.useCallback)((event)=>{
        const sign = Math.sign(event.deltaY);
        handleMove(sign * Math.ceil(Math.abs(event.deltaY) / 10));
    }, [
        handleMove
    ]);
    const enabled = showingId !== undefined;
    if (!dataset) return null;
    return /*#__PURE__*/ (0, $cVgDf.jsxs)((0, $2fb6a1736516e874$export$c9c6445c4bdbecee), {
        width: 400,
        height: 400,
        areas: [
            "top",
            "right",
            "topRight"
        ],
        enabled: enabled,
        children: [
            /*#__PURE__*/ (0, $cVgDf.jsxs)((0, $89216f20f1c77281$export$2e2bcd8739ae039), {
                direction: "row",
                alignItems: "center",
                justifyContent: "space-between",
                padding: 2,
                paddingBottom: 0,
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0, $cVgDf.jsx)($e385011a49baa960$var$Title, {
                        id: showingId,
                        position: projection
                    }),
                    /*#__PURE__*/ (0, $cVgDf.jsxs)((0, $89216f20f1c77281$export$2e2bcd8739ae039), {
                        direction: "row",
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0, $cVgDf.jsx)((0, $2503e7c20b0a1ec5$export$56f1789b3fbc7300), {
                                selection: selection
                            }),
                            /*#__PURE__*/ (0, $cVgDf.jsx)((0, $5ef19184211c73de$export$bbfc8ae83c2d15c2), {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cVgDf.jsx)((0, $89216f20f1c77281$export$2e2bcd8739ae039), {
                marginTop: -2,
                flexGrow: 1,
                flexShrink: 1,
                overflow: "hidden",
                children: /*#__PURE__*/ (0, $cVgDf.jsx)((0, $6f831554a3337c89$export$708ca8fd39af381b), {
                    paddingLeft: 4,
                    paddingRight: 4,
                    children: enabled && /*#__PURE__*/ (0, $cVgDf.jsx)($e385011a49baa960$var$Document, {
                        id: showingId,
                        values: currentValues
                    })
                })
            }),
            /*#__PURE__*/ (0, $cVgDf.jsx)((0, $89216f20f1c77281$export$2e2bcd8739ae039), {
                padding: 3,
                direction: "row",
                gap: 1,
                flexWrap: "nowrap",
                children: /*#__PURE__*/ (0, $cVgDf.jsx)((0, $6f38dee70ca95ea0$export$befd77afc753cb84), {})
            }),
            /*#__PURE__*/ (0, $cVgDf.jsxs)((0, $89216f20f1c77281$export$2e2bcd8739ae039), {
                padding: 3,
                direction: "row",
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $cVgDf.jsx)((0, $b679af97cafc2a91$export$2e2bcd8739ae039), {
                        title: "Previous",
                        children: /*#__PURE__*/ (0, $cVgDf.jsx)((0, $7845ddbb24692f34$export$2e2bcd8739ae039), {
                            onClick: handlePrevious,
                            children: /*#__PURE__*/ (0, $cVgDf.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7e5984aeec72c076$exports))), {})
                        })
                    }),
                    !isHighlight && /*#__PURE__*/ (0, $cVgDf.jsxs)("div", {
                        onWheel: handleWheel,
                        style: {
                            cursor: "ns-resize"
                        },
                        children: [
                            currentId + 1,
                            " / ",
                            selection.length
                        ]
                    }),
                    /*#__PURE__*/ (0, $cVgDf.jsx)((0, $b679af97cafc2a91$export$2e2bcd8739ae039), {
                        title: "Next",
                        children: /*#__PURE__*/ (0, $cVgDf.jsx)((0, $7845ddbb24692f34$export$2e2bcd8739ae039), {
                            onClick: handleNext,
                            children: /*#__PURE__*/ (0, $cVgDf.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b76fecb61555c6b7$exports))), {})
                        })
                    })
                ]
            })
        ]
    });
}




var $gIzLq = parcelRequire("gIzLq");
const $81ec01875ae6fe97$var$Layer = (0, $gIzLq.default)("div")(({ theme: theme  })=>({
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        overflow: "hidden",
        pointerEvents: "none"
    }));
var $81ec01875ae6fe97$export$2e2bcd8739ae039 = $81ec01875ae6fe97$var$Layer;



var $cVgDf = parcelRequire("cVgDf");
parcelRequire("1bdO8");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $95347920fa955761$var$extendStatics = function(d, b) {
    $95347920fa955761$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $95347920fa955761$var$extendStatics(d, b);
};
function $95347920fa955761$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $95347920fa955761$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $95347920fa955761$export$18ce0697a983be9b = function() {
    $95347920fa955761$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $95347920fa955761$export$18ce0697a983be9b.apply(this, arguments);
};
function $95347920fa955761$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $95347920fa955761$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $95347920fa955761$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $95347920fa955761$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $95347920fa955761$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $95347920fa955761$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $95347920fa955761$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $95347920fa955761$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $95347920fa955761$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $95347920fa955761$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $95347920fa955761$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $95347920fa955761$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $95347920fa955761$export$45d3717a4c69092e(o, m, p);
}
function $95347920fa955761$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $95347920fa955761$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $95347920fa955761$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($95347920fa955761$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $95347920fa955761$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $95347920fa955761$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $95347920fa955761$export$10c90e4f7922046c(v) {
    return this instanceof $95347920fa955761$export$10c90e4f7922046c ? (this.v = v, this) : new $95347920fa955761$export$10c90e4f7922046c(v);
}
function $95347920fa955761$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $95347920fa955761$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $95347920fa955761$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $95347920fa955761$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $95347920fa955761$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $95347920fa955761$export$19a8beecd37a4c45 === "function" ? $95347920fa955761$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $95347920fa955761$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $95347920fa955761$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $95347920fa955761$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $95347920fa955761$export$45d3717a4c69092e(result, mod, k);
    }
    $95347920fa955761$var$__setModuleDefault(result, mod);
    return result;
}
function $95347920fa955761$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $95347920fa955761$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $95347920fa955761$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $95347920fa955761$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
var $95347920fa955761$export$2e2bcd8739ae039 = {
    __extends: $95347920fa955761$export$a8ba968b8961cb8a,
    __assign: $95347920fa955761$export$18ce0697a983be9b,
    __rest: $95347920fa955761$export$3c9a16f847548506,
    __decorate: $95347920fa955761$export$29e00dfd3077644b,
    __param: $95347920fa955761$export$d5ad3fd78186038f,
    __metadata: $95347920fa955761$export$f1db080c865becb9,
    __awaiter: $95347920fa955761$export$1050f835b63b671e,
    __generator: $95347920fa955761$export$67ebef60e6f28a6,
    __createBinding: $95347920fa955761$export$45d3717a4c69092e,
    __exportStar: $95347920fa955761$export$f33643c0debef087,
    __values: $95347920fa955761$export$19a8beecd37a4c45,
    __read: $95347920fa955761$export$8d051b38c9118094,
    __spread: $95347920fa955761$export$afc72e2116322959,
    __spreadArrays: $95347920fa955761$export$6388937ca91ccae8,
    __spreadArray: $95347920fa955761$export$1216008129fb82ed,
    __await: $95347920fa955761$export$10c90e4f7922046c,
    __asyncGenerator: $95347920fa955761$export$e427f37a30a4de9b,
    __asyncDelegator: $95347920fa955761$export$bbd80228419bb833,
    __asyncValues: $95347920fa955761$export$e3b29a3d6162315f,
    __makeTemplateObject: $95347920fa955761$export$4fb47efe1390b86f,
    __importStar: $95347920fa955761$export$c21735bcef00d192,
    __importDefault: $95347920fa955761$export$da59b14a69baef04,
    __classPrivateFieldGet: $95347920fa955761$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $95347920fa955761$export$d40a35129aaff81f,
    __classPrivateFieldIn: $95347920fa955761$export$81fdc39f203e4e04
};



var $1bdO8 = parcelRequire("1bdO8");

var $e74ae269af9e7da4$var$createProcess = function(options) {
    return function(dataTransfer, event) {
        var uri = dataTransfer.getData("text/uri-list");
        if (uri) {
            (options.onUri || (0, $6f6a414f7b6d6705$export$8793edee2d425525))(uri, event);
            return;
        }
        if (dataTransfer.files && dataTransfer.files.length) {
            (options.onFiles || (0, $6f6a414f7b6d6705$export$8793edee2d425525))(Array.from(dataTransfer.files), event);
            return;
        }
        if (event.clipboardData) {
            var text = event.clipboardData.getData("text");
            (options.onText || (0, $6f6a414f7b6d6705$export$8793edee2d425525))(text, event);
            return;
        }
    };
};
var $e74ae269af9e7da4$var$useDrop = function(options, args) {
    if (options === void 0) options = {};
    if (args === void 0) args = [];
    var onFiles = options.onFiles, onText = options.onText, onUri = options.onUri;
    var _a = (0, $1bdO8.useState)(false), over = _a[0], setOverRaw = _a[1];
    var setOver = (0, $1bdO8.useCallback)(setOverRaw, []);
    var process = (0, $1bdO8.useMemo)(function() {
        return $e74ae269af9e7da4$var$createProcess(options);
    }, [
        onFiles,
        onText,
        onUri
    ]);
    (0, $1bdO8.useEffect)(function() {
        var onDragOver = function(event) {
            event.preventDefault();
            setOver(true);
        };
        var onDragEnter = function(event) {
            event.preventDefault();
            setOver(true);
        };
        var onDragLeave = function() {
            setOver(false);
        };
        var onDragExit = function() {
            setOver(false);
        };
        var onDrop = function(event) {
            event.preventDefault();
            setOver(false);
            process(event.dataTransfer, event);
        };
        var onPaste = function(event) {
            process(event.clipboardData, event);
        };
        (0, $6f6a414f7b6d6705$export$af631764ddc44097)(document, "dragover", onDragOver);
        (0, $6f6a414f7b6d6705$export$af631764ddc44097)(document, "dragenter", onDragEnter);
        (0, $6f6a414f7b6d6705$export$af631764ddc44097)(document, "dragleave", onDragLeave);
        (0, $6f6a414f7b6d6705$export$af631764ddc44097)(document, "dragexit", onDragExit);
        (0, $6f6a414f7b6d6705$export$af631764ddc44097)(document, "drop", onDrop);
        if (onText) (0, $6f6a414f7b6d6705$export$af631764ddc44097)(document, "paste", onPaste);
        return function() {
            (0, $6f6a414f7b6d6705$export$8c8705df4a2dcec9)(document, "dragover", onDragOver);
            (0, $6f6a414f7b6d6705$export$8c8705df4a2dcec9)(document, "dragenter", onDragEnter);
            (0, $6f6a414f7b6d6705$export$8c8705df4a2dcec9)(document, "dragleave", onDragLeave);
            (0, $6f6a414f7b6d6705$export$8c8705df4a2dcec9)(document, "dragexit", onDragExit);
            (0, $6f6a414f7b6d6705$export$8c8705df4a2dcec9)(document, "drop", onDrop);
            (0, $6f6a414f7b6d6705$export$8c8705df4a2dcec9)(document, "paste", onPaste);
        };
    }, (0, $95347920fa955761$export$6388937ca91ccae8)([
        process
    ], args));
    return {
        over: over
    };
};
var $e74ae269af9e7da4$export$2e2bcd8739ae039 = $e74ae269af9e7da4$var$useDrop;



function $ff5ea5bd6380e79a$export$3af09e5af73c5f4f() {
    const { over: over  } = (0, $e74ae269af9e7da4$export$2e2bcd8739ae039)();
    if (!over) return null;
    return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $81ec01875ae6fe97$export$2e2bcd8739ae039), {
        style: {
            background: "rgba(255,255,255,0.1)"
        }
    });
}



var $cVgDf = parcelRequire("cVgDf");
parcelRequire("1bdO8");

var $1bdO8 = parcelRequire("1bdO8");


var $8oBBS = parcelRequire("8oBBS");
const $205d51f2000f9e59$var$TYPES = {
    int8: Int8Array,
    uint8: Uint8Array,
    int16: Int16Array,
    uint16: Uint16Array,
    int32: Int32Array,
    uint32: Uint32Array,
    float32: Float32Array
};
function $205d51f2000f9e59$var$parseHeader(buffer) {
    const data = new Uint8Array(buffer);
    const headerLength = data.indexOf(0);
    const headerData = new Uint8Array(buffer, 0, headerLength);
    const headerJson = new TextDecoder("utf-8").decode(headerData);
    if (!headerJson.startsWith("{")) throw new Error("Invalid header");
    const header = JSON.parse(headerJson);
    const items = header.$items;
    delete header.$items;
    return {
        header: header,
        headerLength: headerLength,
        items: items
    };
}
function $205d51f2000f9e59$export$98e6a39c04603d36(buffer) {
    const { header: header , headerLength: headerLength , items: items  } = $205d51f2000f9e59$var$parseHeader(buffer);
    for (const item of items){
        const ArrayConstructor = $205d51f2000f9e59$var$TYPES[item.dtype] || Uint8Array;
        const value = new ArrayConstructor(buffer, headerLength + item.offset, item.length / ArrayConstructor.BYTES_PER_ELEMENT);
        (0, (/*@__PURE__*/$parcel$interopDefault($8oBBS))).set(header, item.keys, value);
    }
    return header;
}
function $205d51f2000f9e59$export$fac44ee5b035f737(obj) {
    let offset = 8;
    const items = [];
    const binaries = [];
    // TODO: Make it TS friendly
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const iterate = (obj, keys)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($8oBBS))).isPlainObject(obj)) {
            for (const [key, value] of (0, (/*@__PURE__*/$parcel$interopDefault($8oBBS))).toPairs(obj))obj[key] = iterate(value, [
                ...keys,
                key
            ]);
            return obj;
        }
        if ((0, (/*@__PURE__*/$parcel$interopDefault($8oBBS))).isArray(obj)) {
            // TODO: Make it TS friendly
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            for (const [key, value] of obj.entries())obj[key] = iterate(value, [
                ...keys,
                key
            ]);
            return obj;
        }
        for (const [dtype, Constructor] of (0, (/*@__PURE__*/$parcel$interopDefault($8oBBS))).toPairs($205d51f2000f9e59$var$TYPES)){
            if (obj === undefined || obj === null) {
                // This value will be ignore in output
                console.debug(keys.map((k)=>`${k} =>`).join(" ") + " is " + obj);
                return obj;
            }
            if (obj.constructor === Constructor) {
                const length = obj.byteLength;
                items.push({
                    keys: keys,
                    dtype: dtype,
                    length: length,
                    offset: offset
                });
                binaries.push(new Uint8Array(obj.buffer, obj.byteOffset, obj.byteLength));
                offset += length + (8 - obj.byteLength % 8);
                return "";
            }
        }
        return obj;
    };
    const header = {
        ...iterate(obj, []),
        $items: items
    };
    const bodyLength = offset;
    const encodedHeader = new TextEncoder().encode(JSON.stringify(header));
    const headerPadding = 8 - encodedHeader.length % 8;
    const headerLength = encodedHeader.length + headerPadding;
    const result = new Uint8Array(headerLength + bodyLength);
    result.set(encodedHeader);
    for(let i = encodedHeader.length; i < headerLength; i++)result[i] = 32; // Fill with spaces
    binaries.forEach((binary, index)=>{
        result.set(binary, headerLength + items[index].offset);
    });
    return result;
}


const $940b16c81a35e715$export$368d8538add69d6b = new Set([
    "a",
    "an",
    "and",
    "are",
    "as",
    "at",
    "be",
    "by",
    "for",
    "from",
    "has",
    "he",
    "in",
    "is",
    "it",
    "its",
    "of",
    "on",
    "that",
    "the",
    "to",
    "was",
    "were",
    "will",
    "with",
    ""
]);


const $6385f6788262e86e$var$stopWordsRegex = new RegExp(`\\b(${Array.from((0, $940b16c81a35e715$export$368d8538add69d6b)).join("|")})\\b`, "gi");
function $6385f6788262e86e$export$ec1aa2132e0d58db(values) {
    let min = Infinity;
    let max = -Infinity;
    for(let i = 0; i < values.length; i++){
        if (isNaN(values[i])) continue;
        min = Math.min(min, values[i]);
        max = Math.max(max, values[i]);
    }
    return [
        min,
        max
    ];
}
function $6385f6788262e86e$export$8f561980df117376(values, min, max) {
    if (min === undefined || max === undefined) [min, max] = $6385f6788262e86e$export$ec1aa2132e0d58db(values);
    const invRange = 1 / (max - min);
    for(let i = 0; i < values.length; i++)values[i] = (values[i] - min) * invRange;
    return values;
}
function $6385f6788262e86e$export$694f33c8dbf28c04(text) {
    return text.toLowerCase().match(/\b\w+\b/g)?.filter((word)=>word.length > 1 && !(0, $940b16c81a35e715$export$368d8538add69d6b).has(word)) ?? [];
}
function $6385f6788262e86e$export$9cb09a71b7d66923(...values) {
    const count = values[0].length;
    const result = new Float32Array(values.length * count);
    for(let i = 0; i < count; i++)for(let j = 0; j < values.length; j++)result[i * values.length + j] = values[j][i];
    return result;
}
function $6385f6788262e86e$export$9969a4003296a2a3(values, count) {
    const result = new Array(count);
    const top = new Array(count).fill(-Infinity);
    let n = 0;
    for (const value of values){
        let j = 0;
        while(j < count && value < top[j])j++;
        if (j < count) {
            for(let k = count - 1; k > j; k--){
                top[k] = top[k - 1];
                result[k] = result[k - 1];
            }
            top[j] = value;
            result[j] = n;
        }
        n++;
    }
    return result;
}


class $a5bce90c27c1829b$export$ab9c25261cd8c720 {
    static fromObject(obj) {
        throw new Error("Not implemented");
    }
    constructor(name, count){
        this.type = "attribute";
        this.name = name;
        this.count = count;
    }
}



class $a273dbb9d489328f$var$EmbeddingsProjector {
}
class $a273dbb9d489328f$export$a01bf676f0d4fa42 extends $a273dbb9d489328f$var$EmbeddingsProjector {
    constructor(dimensions = 3){
        super();
        this.dimensions = 3;
        this.dimensions = dimensions;
    }
    project(embeddings) {
        const values = embeddings.values;
        const positions = new Float32Array(values.length / embeddings.dimensions * 3);
        const is3D = this.dimensions === 3 && embeddings.dimensions >= 3;
        let offset = 0;
        for(let i = 0; i < values.length; i += embeddings.dimensions){
            positions[offset++] = values[i];
            positions[offset++] = values[i + 1];
            positions[offset++] = is3D ? values[i + 2] : 0;
        }
        (0, $6385f6788262e86e$export$8f561980df117376)(positions);
        return positions;
    }
}
const $a273dbb9d489328f$var$defaultProjector = new $a273dbb9d489328f$export$a01bf676f0d4fa42();
class $a273dbb9d489328f$export$2cac644111941a35 extends (0, $a5bce90c27c1829b$export$ab9c25261cd8c720) {
    static fromObject(obj) {
        return new $a273dbb9d489328f$export$2cac644111941a35(obj.values, obj.dimensions);
    }
    constructor(values, dimensions){
        super("embeddings", values.length / dimensions);
        this.type = "embeddings";
        this.range = [
            0,
            1
        ];
        this.values = values;
        this.dimensions = dimensions;
        this.range = (0, $6385f6788262e86e$export$ec1aa2132e0d58db)(values);
    }
    project(projector = $a273dbb9d489328f$var$defaultProjector) {
        return projector.project(this);
    }
    getRange() {
        return this.range;
    }
    getValue(index) {
        return this.values[index];
    }
    getDisplayValue(index) {
        return this.getValue(index).toFixed(2);
    }
    toObject() {
        return {
            type: "embedding",
            name: this.name,
            values: this.values,
            dimensions: this.dimensions
        };
    }
}






class $3b50a40f06aa29f2$export$e366f2d5541625d7 extends (0, $a5bce90c27c1829b$export$ab9c25261cd8c720) {
    static fromObject(obj) {
        return new $3b50a40f06aa29f2$export$e366f2d5541625d7(obj.values);
    }
    constructor(values){
        super("position", values.length / 3);
        this.type = "position";
        this.values = values;
        this.range = (0, $6385f6788262e86e$export$ec1aa2132e0d58db)(values);
    }
    getPosition(index, target = new $e8ea6a63d48a4fea$export$64b5c384219d3699()) {
        return target.fromArray(this.values, index * 3);
    }
    getValue(index) {
        return this.values[index];
    }
    getRange() {
        return this.range;
    }
    getDisplayValue(index) {
        const { x: x , y: y , z: z  } = this.getPosition(index);
        return `(${x.toFixed(2)}, ${y.toFixed(2)}, ${z.toFixed(2)})`;
    }
    toObject() {
        return {
            type: "position",
            name: this.name,
            values: this.values
        };
    }
}




class $06f8b1ca3fe54dd2$export$aac0c9b76a8647d7 extends (0, $a5bce90c27c1829b$export$ab9c25261cd8c720) {
    static fromObject(obj) {
        return new $06f8b1ca3fe54dd2$export$aac0c9b76a8647d7(obj.name, obj.values);
    }
    static fromArray(name, values) {
        return new $06f8b1ca3fe54dd2$export$aac0c9b76a8647d7(name, new Float32Array(values));
    }
    static zero(name, count) {
        return new $06f8b1ca3fe54dd2$export$aac0c9b76a8647d7(name, new Float32Array(count));
    }
    constructor(name, values, range){
        super(name, values.length);
        this.type = "number";
        this.values = values;
        this.range = range || (0, $6385f6788262e86e$export$ec1aa2132e0d58db)(values);
    }
    map(fn) {
        this.values = this.values.map(fn);
        return this;
    }
    updateRange() {
        this.range = (0, $6385f6788262e86e$export$ec1aa2132e0d58db)(this.values);
    }
    getValue(index) {
        return this.values[index];
    }
    getRange() {
        return this.range;
    }
    getDisplayValue(index) {
        return this.getValue(index).toFixed(4);
    }
    toObject() {
        return {
            type: "number",
            name: this.name,
            values: this.values
        };
    }
}


// import { TextIndex } from "~dataset/TextIndex";


class $e4c684e9a602935b$export$524ab8b6c1ca9de3 extends (0, $a5bce90c27c1829b$export$ab9c25261cd8c720) {
    // index: TextIndex;
    static fromObject(obj) {
        return new $e4c684e9a602935b$export$524ab8b6c1ca9de3(obj.name, obj.data, obj.offsets);
    }
    static fromCategories(name, values, categories) {
        const textValues = [];
        for(let i = 0; i < values.length; i++){
            const range = (0, $6385f6788262e86e$export$ec1aa2132e0d58db)(values);
            const normalized = (values[i] - range[0]) / (range[1] - range[0]);
            const index = Math.round(normalized * (categories.length - 1));
            textValues.push(categories[index]);
        }
        return $e4c684e9a602935b$export$524ab8b6c1ca9de3.fromTextValues(name, textValues);
    }
    static fromTextValues(name, textValues) {
        const encoder = new TextEncoder();
        const encodedValues = textValues.map((v)=>encoder.encode(v));
        const totalLength = encodedValues.reduce((acc, v)=>acc + v.length, 0);
        const data = new Uint8Array(totalLength);
        const offsets = new Uint32Array(encodedValues.length);
        let i = 0;
        let offset = 0;
        encodedValues.forEach((v)=>{
            data.set(v, offset);
            offsets[i] = offset;
            offset += v.length;
            i++;
        });
        return new $e4c684e9a602935b$export$524ab8b6c1ca9de3(name, data, offsets);
    }
    constructor(name, data, offsets){
        super(name, offsets.length);
        this.type = "text";
        this.data = data;
        this.offsets = offsets;
    }
    getValue(index) {
        return index;
    }
    getRange() {
        return [
            0,
            this.offsets.length - 1
        ];
    }
    getDisplayValue(index) {
        const start = this.offsets[index];
        const end = this.offsets[index + 1];
        const binary = this.data.slice(start, end);
        return new TextDecoder().decode(binary);
    }
    toObject() {
        return {
            type: "text",
            name: this.name,
            data: this.data,
            offsets: this.offsets
        };
    }
}


// import { TextIndex } from "~dataset/TextIndex";

class $5552b6bf00308611$export$fbf279eb968e391a extends (0, $a5bce90c27c1829b$export$ab9c25261cd8c720) {
    static fromObject(obj) {
        return new $5552b6bf00308611$export$fbf279eb968e391a(obj.name, obj.data, obj.offsets);
    }
    static async fromImageUrls(name, imageUrls) {
        const images = await Promise.all(imageUrls.map(async (url)=>{
            const response = await fetch(url);
            const blob = await response.blob();
            const arrayBuffer = await blob.arrayBuffer();
            return new Uint8Array(arrayBuffer);
        }));
        return $5552b6bf00308611$export$fbf279eb968e391a.fromImages(name, images);
    }
    static fromImages(name, images) {
        const totalLength = images.reduce((acc, v)=>acc + v.length, 0);
        const dataBuffer = new SharedArrayBuffer(totalLength);
        const offsetsBuffer = new SharedArrayBuffer(images.length * 4);
        const data = new Uint8Array(dataBuffer);
        const offsets = new Uint32Array(offsetsBuffer);
        let i = 0;
        let offset = 0;
        images.forEach((v)=>{
            data.set(v, offset);
            offsets[i] = offset;
            offset += v.length;
            i++;
        });
        return new $5552b6bf00308611$export$fbf279eb968e391a(name, data, offsets);
    }
    constructor(name, data, offsets){
        super(name, offsets.length);
        this.type = "image";
        this.data = data;
        this.offsets = offsets;
    }
    getValue(index) {
        return index;
    }
    getRange() {
        return [
            0,
            this.offsets.length - 1
        ];
    }
    getDisplayValue(index) {
        const start = this.offsets[index];
        const end = this.offsets[index + 1];
        const binary = this.data.slice(start, end);
        const blob = new Blob([
            binary
        ], {
            type: "image/jpeg"
        });
        return URL.createObjectURL(blob);
    }
    toObject() {
        return {
            type: "image",
            name: this.name,
            data: this.data,
            offsets: this.offsets
        };
    }
}



class $2981a5535b73e677$export$a89907aa2cab9ea9 extends (0, $a5bce90c27c1829b$export$ab9c25261cd8c720) {
    static fromObject(obj) {
        return new $2981a5535b73e677$export$a89907aa2cab9ea9(obj.name, obj.values, obj.categories);
    }
    static fromTextValues(name, textValues) {
        const values = new Int32Array(textValues.length);
        let offset = 0;
        const uniques = new Set();
        const categories = new Array();
        for(let i = 0; i < textValues.length; i++){
            if (uniques.has(textValues[i])) continue;
            uniques.add(textValues[i]);
            categories.push(textValues[i]);
            values[offset] = i;
            offset++;
        }
        return new $2981a5535b73e677$export$a89907aa2cab9ea9(name, values, categories);
    }
    constructor(name, values, categories){
        super(name, values.length);
        this.type = "category";
        if (values instanceof Float32Array) throw new Error("Values must be an Int32Array");
        this.values = values;
        this.categories = categories;
    }
    getValue(index) {
        return this.values[index];
    }
    getRange() {
        return [
            0,
            this.categories.length - 1
        ];
    }
    getDisplayValue(index) {
        return this.categories[this.getValue(index)];
    }
    toObject() {
        return {
            type: "category",
            name: this.name,
            values: this.values,
            categories: this.categories
        };
    }
}



/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const $f90f3d43e4a8d8f3$export$be5234c0b764b6e0 = Symbol("Comlink.proxy");
const $f90f3d43e4a8d8f3$export$39fb953702b7fcd7 = Symbol("Comlink.endpoint");
const $f90f3d43e4a8d8f3$export$89981d4b8d9f48aa = Symbol("Comlink.releaseProxy");
const $f90f3d43e4a8d8f3$export$ddc31dfe7c269837 = Symbol("Comlink.finalizer");
const $f90f3d43e4a8d8f3$var$throwMarker = Symbol("Comlink.thrown");
const $f90f3d43e4a8d8f3$var$isObject = (val)=>typeof val === "object" && val !== null || typeof val === "function";
/**
 * Internal transfer handle to handle objects marked to proxy.
 */ const $f90f3d43e4a8d8f3$var$proxyTransferHandler = {
    canHandle: (val)=>$f90f3d43e4a8d8f3$var$isObject(val) && val[$f90f3d43e4a8d8f3$export$be5234c0b764b6e0],
    serialize (obj) {
        const { port1: port1 , port2: port2  } = new MessageChannel();
        $f90f3d43e4a8d8f3$export$9b7f6e342a8cbd38(obj, port1);
        return [
            port2,
            [
                port2
            ]
        ];
    },
    deserialize (port) {
        port.start();
        return $f90f3d43e4a8d8f3$export$4997ffc0176396a6(port);
    }
};
/**
 * Internal transfer handler to handle thrown exceptions.
 */ const $f90f3d43e4a8d8f3$var$throwTransferHandler = {
    canHandle: (value)=>$f90f3d43e4a8d8f3$var$isObject(value) && $f90f3d43e4a8d8f3$var$throwMarker in value,
    serialize ({ value: value  }) {
        let serialized;
        if (value instanceof Error) serialized = {
            isError: true,
            value: {
                message: value.message,
                name: value.name,
                stack: value.stack
            }
        };
        else serialized = {
            isError: false,
            value: value
        };
        return [
            serialized,
            []
        ];
    },
    deserialize (serialized) {
        if (serialized.isError) throw Object.assign(new Error(serialized.value.message), serialized.value);
        throw serialized.value;
    }
};
/**
 * Allows customizing the serialization of certain values.
 */ const $f90f3d43e4a8d8f3$export$ab8f1c00731ee83e = new Map([
    [
        "proxy",
        $f90f3d43e4a8d8f3$var$proxyTransferHandler
    ],
    [
        "throw",
        $f90f3d43e4a8d8f3$var$throwTransferHandler
    ]
]);
function $f90f3d43e4a8d8f3$var$isAllowedOrigin(allowedOrigins, origin) {
    for (const allowedOrigin of allowedOrigins){
        if (origin === allowedOrigin || allowedOrigin === "*") return true;
        if (allowedOrigin instanceof RegExp && allowedOrigin.test(origin)) return true;
    }
    return false;
}
function $f90f3d43e4a8d8f3$export$9b7f6e342a8cbd38(obj, ep = globalThis, allowedOrigins = [
    "*"
]) {
    ep.addEventListener("message", function callback(ev) {
        if (!ev || !ev.data) return;
        if (!$f90f3d43e4a8d8f3$var$isAllowedOrigin(allowedOrigins, ev.origin)) {
            console.warn(`Invalid origin '${ev.origin}' for comlink proxy`);
            return;
        }
        const { id: id , type: type , path: path  } = Object.assign({
            path: []
        }, ev.data);
        const argumentList = (ev.data.argumentList || []).map($f90f3d43e4a8d8f3$var$fromWireValue);
        let returnValue;
        try {
            const parent = path.slice(0, -1).reduce((obj, prop)=>obj[prop], obj);
            const rawValue = path.reduce((obj, prop)=>obj[prop], obj);
            switch(type){
                case "GET" /* MessageType.GET */ :
                    returnValue = rawValue;
                    break;
                case "SET" /* MessageType.SET */ :
                    parent[path.slice(-1)[0]] = $f90f3d43e4a8d8f3$var$fromWireValue(ev.data.value);
                    returnValue = true;
                    break;
                case "APPLY" /* MessageType.APPLY */ :
                    returnValue = rawValue.apply(parent, argumentList);
                    break;
                case "CONSTRUCT" /* MessageType.CONSTRUCT */ :
                    {
                        const value = new rawValue(...argumentList);
                        returnValue = $f90f3d43e4a8d8f3$export$923f96dd5afa9ce6(value);
                    }
                    break;
                case "ENDPOINT" /* MessageType.ENDPOINT */ :
                    {
                        const { port1: port1 , port2: port2  } = new MessageChannel();
                        $f90f3d43e4a8d8f3$export$9b7f6e342a8cbd38(obj, port2);
                        returnValue = $f90f3d43e4a8d8f3$export$c9b234447cf4ef7c(port1, [
                            port1
                        ]);
                    }
                    break;
                case "RELEASE" /* MessageType.RELEASE */ :
                    returnValue = undefined;
                    break;
                default:
                    return;
            }
        } catch (value) {
            returnValue = {
                value: value,
                [$f90f3d43e4a8d8f3$var$throwMarker]: 0
            };
        }
        Promise.resolve(returnValue).catch((value)=>{
            return {
                value: value,
                [$f90f3d43e4a8d8f3$var$throwMarker]: 0
            };
        }).then((returnValue)=>{
            const [wireValue, transferables] = $f90f3d43e4a8d8f3$var$toWireValue(returnValue);
            ep.postMessage(Object.assign(Object.assign({}, wireValue), {
                id: id
            }), transferables);
            if (type === "RELEASE" /* MessageType.RELEASE */ ) {
                // detach and deactive after sending release response above.
                ep.removeEventListener("message", callback);
                $f90f3d43e4a8d8f3$var$closeEndPoint(ep);
                if ($f90f3d43e4a8d8f3$export$ddc31dfe7c269837 in obj && typeof obj[$f90f3d43e4a8d8f3$export$ddc31dfe7c269837] === "function") obj[$f90f3d43e4a8d8f3$export$ddc31dfe7c269837]();
            }
        }).catch((error)=>{
            // Send Serialization Error To Caller
            const [wireValue, transferables] = $f90f3d43e4a8d8f3$var$toWireValue({
                value: new TypeError("Unserializable return value"),
                [$f90f3d43e4a8d8f3$var$throwMarker]: 0
            });
            ep.postMessage(Object.assign(Object.assign({}, wireValue), {
                id: id
            }), transferables);
        });
    });
    if (ep.start) ep.start();
}
function $f90f3d43e4a8d8f3$var$isMessagePort(endpoint) {
    return endpoint.constructor.name === "MessagePort";
}
function $f90f3d43e4a8d8f3$var$closeEndPoint(endpoint) {
    if ($f90f3d43e4a8d8f3$var$isMessagePort(endpoint)) endpoint.close();
}
function $f90f3d43e4a8d8f3$export$4997ffc0176396a6(ep, target) {
    return $f90f3d43e4a8d8f3$var$createProxy(ep, [], target);
}
function $f90f3d43e4a8d8f3$var$throwIfProxyReleased(isReleased) {
    if (isReleased) throw new Error("Proxy has been released and is not useable");
}
function $f90f3d43e4a8d8f3$var$releaseEndpoint(ep) {
    return $f90f3d43e4a8d8f3$var$requestResponseMessage(ep, {
        type: "RELEASE" /* MessageType.RELEASE */ 
    }).then(()=>{
        $f90f3d43e4a8d8f3$var$closeEndPoint(ep);
    });
}
const $f90f3d43e4a8d8f3$var$proxyCounter = new WeakMap();
const $f90f3d43e4a8d8f3$var$proxyFinalizers = "FinalizationRegistry" in globalThis && new FinalizationRegistry((ep)=>{
    const newCount = ($f90f3d43e4a8d8f3$var$proxyCounter.get(ep) || 0) - 1;
    $f90f3d43e4a8d8f3$var$proxyCounter.set(ep, newCount);
    if (newCount === 0) $f90f3d43e4a8d8f3$var$releaseEndpoint(ep);
});
function $f90f3d43e4a8d8f3$var$registerProxy(proxy, ep) {
    const newCount = ($f90f3d43e4a8d8f3$var$proxyCounter.get(ep) || 0) + 1;
    $f90f3d43e4a8d8f3$var$proxyCounter.set(ep, newCount);
    if ($f90f3d43e4a8d8f3$var$proxyFinalizers) $f90f3d43e4a8d8f3$var$proxyFinalizers.register(proxy, ep, proxy);
}
function $f90f3d43e4a8d8f3$var$unregisterProxy(proxy) {
    if ($f90f3d43e4a8d8f3$var$proxyFinalizers) $f90f3d43e4a8d8f3$var$proxyFinalizers.unregister(proxy);
}
function $f90f3d43e4a8d8f3$var$createProxy(ep, path = [], target = function() {}) {
    let isProxyReleased = false;
    const proxy = new Proxy(target, {
        get (_target, prop) {
            $f90f3d43e4a8d8f3$var$throwIfProxyReleased(isProxyReleased);
            if (prop === $f90f3d43e4a8d8f3$export$89981d4b8d9f48aa) return ()=>{
                $f90f3d43e4a8d8f3$var$unregisterProxy(proxy);
                $f90f3d43e4a8d8f3$var$releaseEndpoint(ep);
                isProxyReleased = true;
            };
            if (prop === "then") {
                if (path.length === 0) return {
                    then: ()=>proxy
                };
                const r = $f90f3d43e4a8d8f3$var$requestResponseMessage(ep, {
                    type: "GET" /* MessageType.GET */ ,
                    path: path.map((p)=>p.toString())
                }).then($f90f3d43e4a8d8f3$var$fromWireValue);
                return r.then.bind(r);
            }
            return $f90f3d43e4a8d8f3$var$createProxy(ep, [
                ...path,
                prop
            ]);
        },
        set (_target, prop, rawValue) {
            $f90f3d43e4a8d8f3$var$throwIfProxyReleased(isProxyReleased);
            // FIXME: ES6 Proxy Handler `set` methods are supposed to return a
            // boolean. To show good will, we return true asynchronously ¯\_(ツ)_/¯
            const [value, transferables] = $f90f3d43e4a8d8f3$var$toWireValue(rawValue);
            return $f90f3d43e4a8d8f3$var$requestResponseMessage(ep, {
                type: "SET" /* MessageType.SET */ ,
                path: [
                    ...path,
                    prop
                ].map((p)=>p.toString()),
                value: value
            }, transferables).then($f90f3d43e4a8d8f3$var$fromWireValue);
        },
        apply (_target, _thisArg, rawArgumentList) {
            $f90f3d43e4a8d8f3$var$throwIfProxyReleased(isProxyReleased);
            const last = path[path.length - 1];
            if (last === $f90f3d43e4a8d8f3$export$39fb953702b7fcd7) return $f90f3d43e4a8d8f3$var$requestResponseMessage(ep, {
                type: "ENDPOINT" /* MessageType.ENDPOINT */ 
            }).then($f90f3d43e4a8d8f3$var$fromWireValue);
            // We just pretend that `bind()` didn’t happen.
            if (last === "bind") return $f90f3d43e4a8d8f3$var$createProxy(ep, path.slice(0, -1));
            const [argumentList, transferables] = $f90f3d43e4a8d8f3$var$processArguments(rawArgumentList);
            return $f90f3d43e4a8d8f3$var$requestResponseMessage(ep, {
                type: "APPLY" /* MessageType.APPLY */ ,
                path: path.map((p)=>p.toString()),
                argumentList: argumentList
            }, transferables).then($f90f3d43e4a8d8f3$var$fromWireValue);
        },
        construct (_target, rawArgumentList) {
            $f90f3d43e4a8d8f3$var$throwIfProxyReleased(isProxyReleased);
            const [argumentList, transferables] = $f90f3d43e4a8d8f3$var$processArguments(rawArgumentList);
            return $f90f3d43e4a8d8f3$var$requestResponseMessage(ep, {
                type: "CONSTRUCT" /* MessageType.CONSTRUCT */ ,
                path: path.map((p)=>p.toString()),
                argumentList: argumentList
            }, transferables).then($f90f3d43e4a8d8f3$var$fromWireValue);
        }
    });
    $f90f3d43e4a8d8f3$var$registerProxy(proxy, ep);
    return proxy;
}
function $f90f3d43e4a8d8f3$var$myFlat(arr) {
    return Array.prototype.concat.apply([], arr);
}
function $f90f3d43e4a8d8f3$var$processArguments(argumentList) {
    const processed = argumentList.map($f90f3d43e4a8d8f3$var$toWireValue);
    return [
        processed.map((v)=>v[0]),
        $f90f3d43e4a8d8f3$var$myFlat(processed.map((v)=>v[1]))
    ];
}
const $f90f3d43e4a8d8f3$var$transferCache = new WeakMap();
function $f90f3d43e4a8d8f3$export$c9b234447cf4ef7c(obj, transfers) {
    $f90f3d43e4a8d8f3$var$transferCache.set(obj, transfers);
    return obj;
}
function $f90f3d43e4a8d8f3$export$923f96dd5afa9ce6(obj) {
    return Object.assign(obj, {
        [$f90f3d43e4a8d8f3$export$be5234c0b764b6e0]: true
    });
}
function $f90f3d43e4a8d8f3$export$f2c03fb5a6c19546(w, context = globalThis, targetOrigin = "*") {
    return {
        postMessage: (msg, transferables)=>w.postMessage(msg, targetOrigin, transferables),
        addEventListener: context.addEventListener.bind(context),
        removeEventListener: context.removeEventListener.bind(context)
    };
}
function $f90f3d43e4a8d8f3$var$toWireValue(value) {
    for (const [name, handler] of $f90f3d43e4a8d8f3$export$ab8f1c00731ee83e)if (handler.canHandle(value)) {
        const [serializedValue, transferables] = handler.serialize(value);
        return [
            {
                type: "HANDLER" /* WireValueType.HANDLER */ ,
                name: name,
                value: serializedValue
            },
            transferables
        ];
    }
    return [
        {
            type: "RAW" /* WireValueType.RAW */ ,
            value: value
        },
        $f90f3d43e4a8d8f3$var$transferCache.get(value) || []
    ];
}
function $f90f3d43e4a8d8f3$var$fromWireValue(value) {
    switch(value.type){
        case "HANDLER" /* WireValueType.HANDLER */ :
            return $f90f3d43e4a8d8f3$export$ab8f1c00731ee83e.get(value.name).deserialize(value.value);
        case "RAW" /* WireValueType.RAW */ :
            return value.value;
    }
}
function $f90f3d43e4a8d8f3$var$requestResponseMessage(ep, msg, transfers) {
    return new Promise((resolve)=>{
        const id = $f90f3d43e4a8d8f3$var$generateUUID();
        ep.addEventListener("message", function l(ev) {
            if (!ev.data || !ev.data.id || ev.data.id !== id) return;
            ep.removeEventListener("message", l);
            resolve(ev.data);
        });
        if (ep.start) ep.start();
        ep.postMessage(Object.assign({
            id: id
        }, msg), transfers);
    });
}
function $f90f3d43e4a8d8f3$var$generateUUID() {
    return new Array(4).fill(0).map(()=>Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString(16)).join("-");
}




var $ad5ea728f676f285$exports = {};
var $14cb29900926026a$exports = {};
"use strict";
$14cb29900926026a$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? "import " + JSON.stringify(workerUrl) + ";" : "importScripts(" + JSON.stringify(workerUrl) + ");";
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: "application/javascript"
        }));
    }
};



let $ad5ea728f676f285$var$url = new URL((parcelRequire("hMn6r")).resolve("9G7Nc"), import.meta.url);
$ad5ea728f676f285$exports = $14cb29900926026a$exports($ad5ea728f676f285$var$url.toString(), $ad5ea728f676f285$var$url.origin, true);


const $69e3fc1605922bc2$var$RemoteTextIndexWorker = (0, $f90f3d43e4a8d8f3$export$4997ffc0176396a6)(new Worker($ad5ea728f676f285$exports, {
    type: "module"
}));
class $69e3fc1605922bc2$export$762cbd80e012c8db {
    constructor(dataset){
        this.worker = new $69e3fc1605922bc2$var$RemoteTextIndexWorker();
        this.dataset = dataset;
    }
    async build() {
        const worker = await this.worker;
        const objs = [];
        for (const attribute of this.dataset.attributes){
            if (attribute instanceof (0, $e4c684e9a602935b$export$524ab8b6c1ca9de3)) objs.push(attribute.toObject());
            if (attribute instanceof (0, $2981a5535b73e677$export$a89907aa2cab9ea9)) objs.push(attribute.toObject());
        }
        await worker.build(objs);
        return this;
    }
    async getTopWords(count = 10, selection) {
        const worker = await this.worker;
        return worker.getTopWords(count, selection);
    }
    async search(query, previous) {
        const worker = await this.worker;
        return worker.search(query, previous);
    }
}


const $aedec35396e1c21e$var$AttributeTypes = {
    attribute: (0, $a5bce90c27c1829b$export$ab9c25261cd8c720),
    number: (0, $06f8b1ca3fe54dd2$export$aac0c9b76a8647d7),
    category: (0, $2981a5535b73e677$export$a89907aa2cab9ea9),
    text: (0, $e4c684e9a602935b$export$524ab8b6c1ca9de3),
    position: (0, $3b50a40f06aa29f2$export$e366f2d5541625d7),
    embedding: (0, $a273dbb9d489328f$export$2cac644111941a35),
    image: (0, $5552b6bf00308611$export$fbf279eb968e391a)
};
class $aedec35396e1c21e$export$827063163a0a89f5 {
    static fromObject(obj) {
        const attributes = obj.attributes.map((a)=>{
            const AttributeType = $aedec35396e1c21e$var$AttributeTypes[a.type || "number"];
            if (!AttributeType) throw new Error(`Unknown attribute type ${a.type}`);
            // Check if it's a text attribute with category type
            if (a.type === "category" && a.categories.length > a.values.length / 2) {
                console.warn("Attribute " + a.name + " has many values.");
                return (0, $e4c684e9a602935b$export$524ab8b6c1ca9de3).fromCategories(a.name, a.values, a.categories);
            }
            return AttributeType.fromObject(a);
        });
        const dataset = new $aedec35396e1c21e$export$827063163a0a89f5(attributes);
        if (obj.embeddings) dataset.setEmbeddings(obj.embeddings.values, obj.embeddings.dimensions);
        const projections = obj.projections || dataset.computeProjections();
        if (projections) dataset.setProjections(projections);
        return dataset;
    }
    constructor(attributes = []){
        this.count = 0;
        this.attributes = [];
        attributes.forEach((attribute)=>this.addAttribute(attribute));
        this.textIndex = new (0, $69e3fc1605922bc2$export$762cbd80e012c8db)(this);
    }
    async buildIndices() {
        await this.textIndex?.build();
    }
    ensureCount(count) {
        if (this.count === 0) {
            this.count = count;
            return;
        }
        if (this.count !== count) throw new Error(`Invalid count ${count} for a dataset with count ${this.count}`);
    }
    // Attributes
    addAttribute(attribute) {
        this.ensureCount(this.count);
        this.attributes.push(attribute);
    }
    getAttributeByName(name) {
        return this.attributes.find((a)=>a.name === name);
    }
    getAttributeNames() {
        return this.attributes.map((attribute)=>attribute.name);
    }
    // Embeddings
    setEmbeddings(values, dimensions) {
        this.ensureCount(values.length / dimensions);
        this.embeddings = new (0, $a273dbb9d489328f$export$2cac644111941a35)(values, dimensions);
    }
    // Projections
    setProjections(values) {
        this.ensureCount(values.length / 3);
        this.projections = new (0, $3b50a40f06aa29f2$export$e366f2d5541625d7)(values);
    }
    computeProjections() {
        if (this.embeddings) return this.embeddings.project();
        // Set projections from x, y, z attributes
        const x = this.attributes.find((a)=>a.name === "x");
        const y = this.attributes.find((a)=>a.name === "y");
        const z = this.attributes.find((a)=>a.name === "z");
        if (x instanceof (0, $06f8b1ca3fe54dd2$export$aac0c9b76a8647d7) && y instanceof (0, $06f8b1ca3fe54dd2$export$aac0c9b76a8647d7) && z instanceof (0, $06f8b1ca3fe54dd2$export$aac0c9b76a8647d7)) return (0, $6385f6788262e86e$export$9cb09a71b7d66923)(x.values, y.values, z.values);
        if (x instanceof (0, $06f8b1ca3fe54dd2$export$aac0c9b76a8647d7) && y instanceof (0, $06f8b1ca3fe54dd2$export$aac0c9b76a8647d7)) return (0, $6385f6788262e86e$export$9cb09a71b7d66923)(x.values, y.values, new Float32Array(x.count));
    }
    // Values
    getDisplayValues(index) {
        const values = new Map();
        this.attributes.forEach((attribute)=>{
            values.set(attribute.name, attribute.getDisplayValue(index));
        });
        return values;
    }
    toObject() {
        return {
            attributes: this.attributes.map((attribute)=>attribute.toObject()),
            embeddings: this.embeddings?.toObject(),
            projections: this.projections?.values
        };
    }
}


// Retrocompatibility with old datasets
function $88569b9317805644$var$fixDatasetObject(obj) {
    // Category: keys -> categories
    if (obj.attributes) obj.attributes.forEach((a)=>{
        if (a.type === "category" && a.keys) {
            console.warn(`Keys field in category attribute ${a.name} is deprecated`);
            a.categories = a.keys;
            delete a.keys;
        }
    });
    // Text: values -> offsets
    if (obj.attributes) obj.attributes.forEach((a)=>{
        if (a.type === "text" && a.values) {
            console.warn(`Values field in text attribute ${a.name} is deprecated`);
            a.offsets = a.values;
            delete a.values;
        }
    });
    // Fix normalized category values
    if (obj.attributes) obj.attributes.forEach((a)=>{
        if (a.type === "category" && a.categories) {
            if (a.values instanceof Float32Array) {
                console.warn(`Normalized category values in attribute ${a.name} are deprecated`);
                const [min, max] = (0, $6385f6788262e86e$export$ec1aa2132e0d58db)(a.values);
                const values = new Uint32Array(a.values.length);
                if (a.categories.length > 1) for(let i = 0; i < a.values.length; i++)values[i] = Math.round((a.values[i] - min) / (max - min) * (a.categories.length - 1));
                else values.fill(0);
                a.values = values;
            }
        }
    });
    return obj;
}
async function $88569b9317805644$export$615c82c7c5f5e492(url) {
    const dataset = await fetch(url).then((response)=>response.arrayBuffer()).then((buffer)=>(0, $205d51f2000f9e59$export$98e6a39c04603d36)(buffer)).then((obj)=>(0, $aedec35396e1c21e$export$827063163a0a89f5).fromObject($88569b9317805644$var$fixDatasetObject(obj)));
    return dataset;
}
function $88569b9317805644$export$94fc13394bb9748({ onLoad: onLoad  }) {
    const handleLoadFile = async (file)=>{
        if (file.name.endsWith(".bin")) {
            const url = URL.createObjectURL(file);
            const dataset = await $88569b9317805644$export$615c82c7c5f5e492(url);
            onLoad(dataset);
        }
    };
    (0, $e74ae269af9e7da4$export$2e2bcd8739ae039)({
        onFiles: (files)=>{
            files.forEach(handleLoadFile);
        }
    });
    return null;
}
var $88569b9317805644$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bdO8))).memo($88569b9317805644$export$94fc13394bb9748);



var $1bdO8 = parcelRequire("1bdO8");



var $7939f724d555ecb5$exports = {};
/* @license
Papa Parse
v5.4.1
https://github.com/mholt/PapaParse
License: MIT
*/ !function(e, t) {
    "function" == typeof define && define.amd ? define([], t) : $7939f724d555ecb5$exports = t();
}($7939f724d555ecb5$exports, function s() {
    "use strict";
    var f = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== f ? f : {};
    var n = !f.document && !!f.postMessage, o = f.IS_PAPA_WORKER || !1, a = {}, u = 0, b = {
        parse: function(e, t) {
            var r = (t = t || {}).dynamicTyping || !1;
            J(r) && (t.dynamicTypingFunction = r, r = {});
            if (t.dynamicTyping = r, t.transform = !!J(t.transform) && t.transform, t.worker && b.WORKERS_SUPPORTED) {
                var i = function() {
                    if (!b.WORKERS_SUPPORTED) return !1;
                    var e = (r = f.URL || f.webkitURL || null, i = s.toString(), b.BLOB_URL || (b.BLOB_URL = r.createObjectURL(new Blob([
                        "var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ",
                        "(",
                        i,
                        ")();"
                    ], {
                        type: "text/javascript"
                    })))), t = new f.Worker(e);
                    var r, i;
                    return t.onmessage = _, t.id = u++, a[t.id] = t;
                }();
                return i.userStep = t.step, i.userChunk = t.chunk, i.userComplete = t.complete, i.userError = t.error, t.step = J(t.step), t.chunk = J(t.chunk), t.complete = J(t.complete), t.error = J(t.error), delete t.worker, void i.postMessage({
                    input: e,
                    config: t,
                    workerId: i.id
                });
            }
            var n = null;
            b.NODE_STREAM_INPUT, "string" == typeof e ? (e = function(e) {
                if (65279 === e.charCodeAt(0)) return e.slice(1);
                return e;
            }(e), n = t.download ? new l(t) : new p(t)) : !0 === e.readable && J(e.read) && J(e.on) ? n = new g(t) : (f.File && e instanceof File || e instanceof Object) && (n = new c(t));
            return n.stream(e);
        },
        unparse: function(e, t) {
            var n = !1, _ = !0, m = ",", y = "\r\n", s = '"', a = s + s, r = !1, i = null, o = !1;
            !function() {
                if ("object" != typeof t) return;
                "string" != typeof t.delimiter || b.BAD_DELIMITERS.filter(function(e) {
                    return -1 !== t.delimiter.indexOf(e);
                }).length || (m = t.delimiter);
                ("boolean" == typeof t.quotes || "function" == typeof t.quotes || Array.isArray(t.quotes)) && (n = t.quotes);
                "boolean" != typeof t.skipEmptyLines && "string" != typeof t.skipEmptyLines || (r = t.skipEmptyLines);
                "string" == typeof t.newline && (y = t.newline);
                "string" == typeof t.quoteChar && (s = t.quoteChar);
                "boolean" == typeof t.header && (_ = t.header);
                if (Array.isArray(t.columns)) {
                    if (0 === t.columns.length) throw new Error("Option columns is empty");
                    i = t.columns;
                }
                void 0 !== t.escapeChar && (a = t.escapeChar + s);
                ("boolean" == typeof t.escapeFormulae || t.escapeFormulae instanceof RegExp) && (o = t.escapeFormulae instanceof RegExp ? t.escapeFormulae : /^[=+\-@\t\r].*$/);
            }();
            var u = new RegExp(Q(s), "g");
            "string" == typeof e && (e = JSON.parse(e));
            if (Array.isArray(e)) {
                if (!e.length || Array.isArray(e[0])) return h(null, e, r);
                if ("object" == typeof e[0]) return h(i || Object.keys(e[0]), e, r);
            } else if ("object" == typeof e) return "string" == typeof e.data && (e.data = JSON.parse(e.data)), Array.isArray(e.data) && (e.fields || (e.fields = e.meta && e.meta.fields || i), e.fields || (e.fields = Array.isArray(e.data[0]) ? e.fields : "object" == typeof e.data[0] ? Object.keys(e.data[0]) : []), Array.isArray(e.data[0]) || "object" == typeof e.data[0] || (e.data = [
                e.data
            ])), h(e.fields || [], e.data || [], r);
            throw new Error("Unable to serialize unrecognized input");
            function h(e, t, r) {
                var i = "";
                "string" == typeof e && (e = JSON.parse(e)), "string" == typeof t && (t = JSON.parse(t));
                var n = Array.isArray(e) && 0 < e.length, s = !Array.isArray(t[0]);
                if (n && _) {
                    for(var a = 0; a < e.length; a++)0 < a && (i += m), i += v(e[a], a);
                    0 < t.length && (i += y);
                }
                for(var o = 0; o < t.length; o++){
                    var u = n ? e.length : t[o].length, h = !1, f = n ? 0 === Object.keys(t[o]).length : 0 === t[o].length;
                    if (r && !n && (h = "greedy" === r ? "" === t[o].join("").trim() : 1 === t[o].length && 0 === t[o][0].length), "greedy" === r && n) {
                        for(var d = [], l = 0; l < u; l++){
                            var c = s ? e[l] : l;
                            d.push(t[o][c]);
                        }
                        h = "" === d.join("").trim();
                    }
                    if (!h) {
                        for(var p = 0; p < u; p++){
                            0 < p && !f && (i += m);
                            var g = n && s ? e[p] : p;
                            i += v(t[o][g], p);
                        }
                        o < t.length - 1 && (!r || 0 < u && !f) && (i += y);
                    }
                }
                return i;
            }
            function v(e, t) {
                if (null == e) return "";
                if (e.constructor === Date) return JSON.stringify(e).slice(1, 25);
                var r = !1;
                o && "string" == typeof e && o.test(e) && (e = "'" + e, r = !0);
                var i = e.toString().replace(u, a);
                return (r = r || !0 === n || "function" == typeof n && n(e, t) || Array.isArray(n) && n[t] || function(e, t) {
                    for(var r = 0; r < t.length; r++)if (-1 < e.indexOf(t[r])) return !0;
                    return !1;
                }(i, b.BAD_DELIMITERS) || -1 < i.indexOf(m) || " " === i.charAt(0) || " " === i.charAt(i.length - 1)) ? s + i + s : i;
            }
        }
    };
    if (b.RECORD_SEP = String.fromCharCode(30), b.UNIT_SEP = String.fromCharCode(31), b.BYTE_ORDER_MARK = "\uFEFF", b.BAD_DELIMITERS = [
        "\r",
        "\n",
        '"',
        b.BYTE_ORDER_MARK
    ], b.WORKERS_SUPPORTED = !n && !!f.Worker, b.NODE_STREAM_INPUT = 1, b.LocalChunkSize = 10485760, b.RemoteChunkSize = 5242880, b.DefaultDelimiter = ",", b.Parser = E, b.ParserHandle = r, b.NetworkStreamer = l, b.FileStreamer = c, b.StringStreamer = p, b.ReadableStreamStreamer = g, f.jQuery) {
        var d = f.jQuery;
        d.fn.parse = function(o) {
            var r = o.config || {}, u = [];
            return this.each(function(e) {
                if (!("INPUT" === d(this).prop("tagName").toUpperCase() && "file" === d(this).attr("type").toLowerCase() && f.FileReader) || !this.files || 0 === this.files.length) return !0;
                for(var t = 0; t < this.files.length; t++)u.push({
                    file: this.files[t],
                    inputElem: this,
                    instanceConfig: d.extend({}, r)
                });
            }), e(), this;
            function e() {
                if (0 !== u.length) {
                    var e, t, r, i, n = u[0];
                    if (J(o.before)) {
                        var s = o.before(n.file, n.inputElem);
                        if ("object" == typeof s) {
                            if ("abort" === s.action) return e = "AbortError", t = n.file, r = n.inputElem, i = s.reason, void (J(o.error) && o.error({
                                name: e
                            }, t, r, i));
                            if ("skip" === s.action) return void h();
                            "object" == typeof s.config && (n.instanceConfig = d.extend(n.instanceConfig, s.config));
                        } else if ("skip" === s) return void h();
                    }
                    var a = n.instanceConfig.complete;
                    n.instanceConfig.complete = function(e) {
                        J(a) && a(e, n.file, n.inputElem), h();
                    }, b.parse(n.file, n.instanceConfig);
                } else J(o.complete) && o.complete();
            }
            function h() {
                u.splice(0, 1), e();
            }
        };
    }
    function h(e) {
        this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = {
            data: [],
            errors: [],
            meta: {}
        }, (function(e) {
            var t = w(e);
            t.chunkSize = parseInt(t.chunkSize), e.step || e.chunk || (t.chunkSize = null);
            this._handle = new r(t), (this._handle.streamer = this)._config = t;
        }).call(this, e), this.parseChunk = function(e, t) {
            if (this.isFirstChunk && J(this._config.beforeFirstChunk)) {
                var r = this._config.beforeFirstChunk(e);
                void 0 !== r && (e = r);
            }
            this.isFirstChunk = !1, this._halted = !1;
            var i = this._partialLine + e;
            this._partialLine = "";
            var n = this._handle.parse(i, this._baseIndex, !this._finished);
            if (!this._handle.paused() && !this._handle.aborted()) {
                var s = n.meta.cursor;
                this._finished || (this._partialLine = i.substring(s - this._baseIndex), this._baseIndex = s), n && n.data && (this._rowCount += n.data.length);
                var a = this._finished || this._config.preview && this._rowCount >= this._config.preview;
                if (o) f.postMessage({
                    results: n,
                    workerId: b.WORKER_ID,
                    finished: a
                });
                else if (J(this._config.chunk) && !t) {
                    if (this._config.chunk(n, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);
                    n = void 0, this._completeResults = void 0;
                }
                return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(n.data), this._completeResults.errors = this._completeResults.errors.concat(n.errors), this._completeResults.meta = n.meta), this._completed || !a || !J(this._config.complete) || n && n.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), a || n && n.meta.paused || this._nextChunk(), n;
            }
            this._halted = !0;
        }, this._sendError = function(e) {
            J(this._config.error) ? this._config.error(e) : o && this._config.error && f.postMessage({
                workerId: b.WORKER_ID,
                error: e,
                finished: !1
            });
        };
    }
    function l(e) {
        var i;
        (e = e || {}).chunkSize || (e.chunkSize = b.RemoteChunkSize), h.call(this, e), this._nextChunk = n ? function() {
            this._readChunk(), this._chunkLoaded();
        } : function() {
            this._readChunk();
        }, this.stream = function(e) {
            this._input = e, this._nextChunk();
        }, this._readChunk = function() {
            if (this._finished) this._chunkLoaded();
            else {
                if (i = new XMLHttpRequest, this._config.withCredentials && (i.withCredentials = this._config.withCredentials), n || (i.onload = v(this._chunkLoaded, this), i.onerror = v(this._chunkError, this)), i.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !n), this._config.downloadRequestHeaders) {
                    var e = this._config.downloadRequestHeaders;
                    for(var t in e)i.setRequestHeader(t, e[t]);
                }
                if (this._config.chunkSize) {
                    var r = this._start + this._config.chunkSize - 1;
                    i.setRequestHeader("Range", "bytes=" + this._start + "-" + r);
                }
                try {
                    i.send(this._config.downloadRequestBody);
                } catch (e) {
                    this._chunkError(e.message);
                }
                n && 0 === i.status && this._chunkError();
            }
        }, this._chunkLoaded = function() {
            4 === i.readyState && (i.status < 200 || 400 <= i.status ? this._chunkError() : (this._start += this._config.chunkSize ? this._config.chunkSize : i.responseText.length, this._finished = !this._config.chunkSize || this._start >= function(e) {
                var t = e.getResponseHeader("Content-Range");
                if (null === t) return -1;
                return parseInt(t.substring(t.lastIndexOf("/") + 1));
            }(i), this.parseChunk(i.responseText)));
        }, this._chunkError = function(e) {
            var t = i.statusText || e;
            this._sendError(new Error(t));
        };
    }
    function c(e) {
        var i, n;
        (e = e || {}).chunkSize || (e.chunkSize = b.LocalChunkSize), h.call(this, e);
        var s = "undefined" != typeof FileReader;
        this.stream = function(e) {
            this._input = e, n = e.slice || e.webkitSlice || e.mozSlice, s ? ((i = new FileReader).onload = v(this._chunkLoaded, this), i.onerror = v(this._chunkError, this)) : i = new FileReaderSync, this._nextChunk();
        }, this._nextChunk = function() {
            this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
        }, this._readChunk = function() {
            var e = this._input;
            if (this._config.chunkSize) {
                var t = Math.min(this._start + this._config.chunkSize, this._input.size);
                e = n.call(e, this._start, t);
            }
            var r = i.readAsText(e, this._config.encoding);
            s || this._chunkLoaded({
                target: {
                    result: r
                }
            });
        }, this._chunkLoaded = function(e) {
            this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(e.target.result);
        }, this._chunkError = function() {
            this._sendError(i.error);
        };
    }
    function p(e) {
        var r;
        h.call(this, e = e || {}), this.stream = function(e) {
            return r = e, this._nextChunk();
        }, this._nextChunk = function() {
            if (!this._finished) {
                var e, t = this._config.chunkSize;
                return t ? (e = r.substring(0, t), r = r.substring(t)) : (e = r, r = ""), this._finished = !r, this.parseChunk(e);
            }
        };
    }
    function g(e) {
        h.call(this, e = e || {});
        var t = [], r = !0, i = !1;
        this.pause = function() {
            h.prototype.pause.apply(this, arguments), this._input.pause();
        }, this.resume = function() {
            h.prototype.resume.apply(this, arguments), this._input.resume();
        }, this.stream = function(e) {
            this._input = e, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
        }, this._checkIsFinished = function() {
            i && 1 === t.length && (this._finished = !0);
        }, this._nextChunk = function() {
            this._checkIsFinished(), t.length ? this.parseChunk(t.shift()) : r = !0;
        }, this._streamData = v(function(e) {
            try {
                t.push("string" == typeof e ? e : e.toString(this._config.encoding)), r && (r = !1, this._checkIsFinished(), this.parseChunk(t.shift()));
            } catch (e) {
                this._streamError(e);
            }
        }, this), this._streamError = v(function(e) {
            this._streamCleanUp(), this._sendError(e);
        }, this), this._streamEnd = v(function() {
            this._streamCleanUp(), i = !0, this._streamData("");
        }, this), this._streamCleanUp = v(function() {
            this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
        }, this);
    }
    function r(m) {
        var a, o, u, i = Math.pow(2, 53), n = -i, s = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, h = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/, t = this, r = 0, f = 0, d = !1, e = !1, l = [], c = {
            data: [],
            errors: [],
            meta: {}
        };
        if (J(m.step)) {
            var p = m.step;
            m.step = function(e) {
                if (c = e, _()) g();
                else {
                    if (g(), 0 === c.data.length) return;
                    r += e.data.length, m.preview && r > m.preview ? o.abort() : (c.data = c.data[0], p(c, t));
                }
            };
        }
        function y(e) {
            return "greedy" === m.skipEmptyLines ? "" === e.join("").trim() : 1 === e.length && 0 === e[0].length;
        }
        function g() {
            return c && u && (k("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + b.DefaultDelimiter + "'"), u = !1), m.skipEmptyLines && (c.data = c.data.filter(function(e) {
                return !y(e);
            })), _() && function() {
                if (!c) return;
                function e(e, t) {
                    J(m.transformHeader) && (e = m.transformHeader(e, t)), l.push(e);
                }
                if (Array.isArray(c.data[0])) {
                    for(var t = 0; _() && t < c.data.length; t++)c.data[t].forEach(e);
                    c.data.splice(0, 1);
                } else c.data.forEach(e);
            }(), function() {
                if (!c || !m.header && !m.dynamicTyping && !m.transform) return c;
                function e(e, t) {
                    var r, i = m.header ? {} : [];
                    for(r = 0; r < e.length; r++){
                        var n = r, s = e[r];
                        m.header && (n = r >= l.length ? "__parsed_extra" : l[r]), m.transform && (s = m.transform(s, n)), s = v(n, s), "__parsed_extra" === n ? (i[n] = i[n] || [], i[n].push(s)) : i[n] = s;
                    }
                    return m.header && (r > l.length ? k("FieldMismatch", "TooManyFields", "Too many fields: expected " + l.length + " fields but parsed " + r, f + t) : r < l.length && k("FieldMismatch", "TooFewFields", "Too few fields: expected " + l.length + " fields but parsed " + r, f + t)), i;
                }
                var t = 1;
                !c.data.length || Array.isArray(c.data[0]) ? (c.data = c.data.map(e), t = c.data.length) : c.data = e(c.data, 0);
                m.header && c.meta && (c.meta.fields = l);
                return f += t, c;
            }();
        }
        function _() {
            return m.header && 0 === l.length;
        }
        function v(e, t) {
            var r;
            return r = e, m.dynamicTypingFunction && void 0 === m.dynamicTyping[r] && (m.dynamicTyping[r] = m.dynamicTypingFunction(r)), !0 === (m.dynamicTyping[r] || m.dynamicTyping) ? "true" === t || "TRUE" === t || "false" !== t && "FALSE" !== t && (function(e) {
                if (s.test(e)) {
                    var t = parseFloat(e);
                    if (n < t && t < i) return !0;
                }
                return !1;
            }(t) ? parseFloat(t) : h.test(t) ? new Date(t) : "" === t ? null : t) : t;
        }
        function k(e, t, r, i) {
            var n = {
                type: e,
                code: t,
                message: r
            };
            void 0 !== i && (n.row = i), c.errors.push(n);
        }
        this.parse = function(e, t, r) {
            var i = m.quoteChar || '"';
            if (m.newline || (m.newline = function(e, t) {
                e = e.substring(0, 1048576);
                var r = new RegExp(Q(t) + "([^]*?)" + Q(t), "gm"), i = (e = e.replace(r, "")).split("\r"), n = e.split("\n"), s = 1 < n.length && n[0].length < i[0].length;
                if (1 === i.length || s) return "\n";
                for(var a = 0, o = 0; o < i.length; o++)"\n" === i[o][0] && a++;
                return a >= i.length / 2 ? "\r\n" : "\r";
            }(e, i)), u = !1, m.delimiter) J(m.delimiter) && (m.delimiter = m.delimiter(e), c.meta.delimiter = m.delimiter);
            else {
                var n = function(e, t, r, i, n) {
                    var s, a, o, u;
                    n = n || [
                        ",",
                        "	",
                        "|",
                        ";",
                        b.RECORD_SEP,
                        b.UNIT_SEP
                    ];
                    for(var h = 0; h < n.length; h++){
                        var f = n[h], d = 0, l = 0, c = 0;
                        o = void 0;
                        for(var p = new E({
                            comments: i,
                            delimiter: f,
                            newline: t,
                            preview: 10
                        }).parse(e), g = 0; g < p.data.length; g++)if (r && y(p.data[g])) c++;
                        else {
                            var _ = p.data[g].length;
                            l += _, void 0 !== o ? 0 < _ && (d += Math.abs(_ - o), o = _) : o = _;
                        }
                        0 < p.data.length && (l /= p.data.length - c), (void 0 === a || d <= a) && (void 0 === u || u < l) && 1.99 < l && (a = d, s = f, u = l);
                    }
                    return {
                        successful: !!(m.delimiter = s),
                        bestDelimiter: s
                    };
                }(e, m.newline, m.skipEmptyLines, m.comments, m.delimitersToGuess);
                n.successful ? m.delimiter = n.bestDelimiter : (u = !0, m.delimiter = b.DefaultDelimiter), c.meta.delimiter = m.delimiter;
            }
            var s = w(m);
            return m.preview && m.header && s.preview++, a = e, o = new E(s), c = o.parse(a, t, r), g(), d ? {
                meta: {
                    paused: !0
                }
            } : c || {
                meta: {
                    paused: !1
                }
            };
        }, this.paused = function() {
            return d;
        }, this.pause = function() {
            d = !0, o.abort(), a = J(m.chunk) ? "" : a.substring(o.getCharIndex());
        }, this.resume = function() {
            t.streamer._halted ? (d = !1, t.streamer.parseChunk(a, !0)) : setTimeout(t.resume, 3);
        }, this.aborted = function() {
            return e;
        }, this.abort = function() {
            e = !0, o.abort(), c.meta.aborted = !0, J(m.complete) && m.complete(c), a = "";
        };
    }
    function Q(e) {
        return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    function E(j) {
        var z, M = (j = j || {}).delimiter, P = j.newline, U = j.comments, q = j.step, N = j.preview, B = j.fastMode, K = z = void 0 === j.quoteChar || null === j.quoteChar ? '"' : j.quoteChar;
        if (void 0 !== j.escapeChar && (K = j.escapeChar), ("string" != typeof M || -1 < b.BAD_DELIMITERS.indexOf(M)) && (M = ","), U === M) throw new Error("Comment character same as delimiter");
        !0 === U ? U = "#" : ("string" != typeof U || -1 < b.BAD_DELIMITERS.indexOf(U)) && (U = !1), "\n" !== P && "\r" !== P && "\r\n" !== P && (P = "\n");
        var W = 0, H = !1;
        this.parse = function(i, t, r) {
            if ("string" != typeof i) throw new Error("Input must be a string");
            var n = i.length, e = M.length, s = P.length, a = U.length, o = J(q), u = [], h = [], f = [], d = W = 0;
            if (!i) return L();
            if (j.header && !t) {
                var l = i.split(P)[0].split(M), c = [], p = {}, g = !1;
                for(var _ in l){
                    var m = l[_];
                    J(j.transformHeader) && (m = j.transformHeader(m, _));
                    var y = m, v = p[m] || 0;
                    for(0 < v && (g = !0, y = m + "_" + v), p[m] = v + 1; c.includes(y);)y = y + "_" + v;
                    c.push(y);
                }
                if (g) {
                    var k = i.split(P);
                    k[0] = c.join(M), i = k.join(P);
                }
            }
            if (B || !1 !== B && -1 === i.indexOf(z)) {
                for(var b = i.split(P), E = 0; E < b.length; E++){
                    if (f = b[E], W += f.length, E !== b.length - 1) W += P.length;
                    else if (r) return L();
                    if (!U || f.substring(0, a) !== U) {
                        if (o) {
                            if (u = [], I(f.split(M)), F(), H) return L();
                        } else I(f.split(M));
                        if (N && N <= E) return u = u.slice(0, N), L(!0);
                    }
                }
                return L();
            }
            for(var w = i.indexOf(M, W), R = i.indexOf(P, W), C = new RegExp(Q(K) + Q(z), "g"), S = i.indexOf(z, W);;)if (i[W] !== z) {
                if (U && 0 === f.length && i.substring(W, W + a) === U) {
                    if (-1 === R) return L();
                    W = R + s, R = i.indexOf(P, W), w = i.indexOf(M, W);
                } else if (-1 !== w && (w < R || -1 === R)) f.push(i.substring(W, w)), W = w + e, w = i.indexOf(M, W);
                else {
                    if (-1 === R) break;
                    if (f.push(i.substring(W, R)), D(R + s), o && (F(), H)) return L();
                    if (N && u.length >= N) return L(!0);
                }
            } else for(S = W, W++;;){
                if (-1 === (S = i.indexOf(z, S + 1))) return r || h.push({
                    type: "Quotes",
                    code: "MissingQuotes",
                    message: "Quoted field unterminated",
                    row: u.length,
                    index: W
                }), T();
                if (S === n - 1) return T(i.substring(W, S).replace(C, z));
                if (z !== K || i[S + 1] !== K) {
                    if (z === K || 0 === S || i[S - 1] !== K) {
                        -1 !== w && w < S + 1 && (w = i.indexOf(M, S + 1)), -1 !== R && R < S + 1 && (R = i.indexOf(P, S + 1));
                        var O = A(-1 === R ? w : Math.min(w, R));
                        if (i.substr(S + 1 + O, e) === M) {
                            f.push(i.substring(W, S).replace(C, z)), i[W = S + 1 + O + e] !== z && (S = i.indexOf(z, W)), w = i.indexOf(M, W), R = i.indexOf(P, W);
                            break;
                        }
                        var x = A(R);
                        if (i.substring(S + 1 + x, S + 1 + x + s) === P) {
                            if (f.push(i.substring(W, S).replace(C, z)), D(S + 1 + x + s), w = i.indexOf(M, W), S = i.indexOf(z, W), o && (F(), H)) return L();
                            if (N && u.length >= N) return L(!0);
                            break;
                        }
                        h.push({
                            type: "Quotes",
                            code: "InvalidQuotes",
                            message: "Trailing quote on quoted field is malformed",
                            row: u.length,
                            index: W
                        }), S++;
                    }
                } else S++;
            }
            return T();
            function I(e) {
                u.push(e), d = W;
            }
            function A(e) {
                var t = 0;
                if (-1 !== e) {
                    var r = i.substring(S + 1, e);
                    r && "" === r.trim() && (t = r.length);
                }
                return t;
            }
            function T(e) {
                return r || (void 0 === e && (e = i.substring(W)), f.push(e), W = n, I(f), o && F()), L();
            }
            function D(e) {
                W = e, I(f), f = [], R = i.indexOf(P, W);
            }
            function L(e) {
                return {
                    data: u,
                    errors: h,
                    meta: {
                        delimiter: M,
                        linebreak: P,
                        aborted: H,
                        truncated: !!e,
                        cursor: d + (t || 0)
                    }
                };
            }
            function F() {
                q(L()), u = [], h = [];
            }
        }, this.abort = function() {
            H = !0;
        }, this.getCharIndex = function() {
            return W;
        };
    }
    function _(e) {
        var t = e.data, r = a[t.workerId], i = !1;
        if (t.error) r.userError(t.error, t.file);
        else if (t.results && t.results.data) {
            var n = {
                abort: function() {
                    i = !0, m(t.workerId, {
                        data: [],
                        errors: [],
                        meta: {
                            aborted: !0
                        }
                    });
                },
                pause: y,
                resume: y
            };
            if (J(r.userStep)) {
                for(var s = 0; s < t.results.data.length && (r.userStep({
                    data: t.results.data[s],
                    errors: t.results.errors,
                    meta: t.results.meta
                }, n), !i); s++);
                delete t.results;
            } else J(r.userChunk) && (r.userChunk(t.results, n, t.file), delete t.results);
        }
        t.finished && !i && m(t.workerId, t.results);
    }
    function m(e, t) {
        var r = a[e];
        J(r.userComplete) && r.userComplete(t), r.terminate(), delete a[e];
    }
    function y() {
        throw new Error("Not implemented.");
    }
    function w(e) {
        if ("object" != typeof e || null === e) return e;
        var t = Array.isArray(e) ? [] : {};
        for(var r in e)t[r] = w(e[r]);
        return t;
    }
    function v(e, t) {
        return function() {
            e.apply(t, arguments);
        };
    }
    function J(e) {
        return "function" == typeof e;
    }
    return o && (f.onmessage = function(e) {
        var t = e.data;
        void 0 === b.WORKER_ID && t && (b.WORKER_ID = t.workerId);
        if ("string" == typeof t.input) f.postMessage({
            workerId: b.WORKER_ID,
            results: b.parse(t.input, t.config),
            finished: !0
        });
        else if (f.File && t.input instanceof File || t.input instanceof Object) {
            var r = b.parse(t.input, t.config);
            r && f.postMessage({
                workerId: b.WORKER_ID,
                results: r,
                finished: !0
            });
        }
    }), (l.prototype = Object.create(h.prototype)).constructor = l, (c.prototype = Object.create(h.prototype)).constructor = c, (p.prototype = Object.create(p.prototype)).constructor = p, (g.prototype = Object.create(h.prototype)).constructor = g, b;
});




function $5a7e159cdc70a008$var$parseArrayString(value) {
    try {
        return JSON.parse(value);
    } catch (e) {
        const trimmedString = value.replace(/\[|\]/g, "").trim();
        const stringValues = trimmedString.split(/\s+/);
        const array = stringValues.map((v)=>parseFloat(v));
        return array;
    }
}
const $5a7e159cdc70a008$var$isCategory = (values)=>{
    const uniqueValues = new Set(values);
    return uniqueValues.size <= values.length / 2;
};
const $5a7e159cdc70a008$var$XYZ = [
    "x",
    "y",
    "z"
];
function $5a7e159cdc70a008$export$ec89b01ff2939d3e({ onLoad: onLoad  }) {
    const handleLoadUrl = async (url)=>{
        const dataset = await fetch(url).then((response)=>response.text()).then((text)=>(0, (/*@__PURE__*/$parcel$interopDefault($7939f724d555ecb5$exports))).parse(text, {
                header: true,
                dynamicTyping: true,
                skipEmptyLines: true,
                transformHeader: (header)=>header.toLowerCase()
            })).then((result)=>{
            const dataset = new (0, $aedec35396e1c21e$export$827063163a0a89f5)();
            function buildAttribute(field) {
                const firstValue = result.data[0][field];
                if (typeof firstValue === "number") return (0, $06f8b1ca3fe54dd2$export$aac0c9b76a8647d7).fromArray(field, result.data.map((row)=>row[field]));
                if (typeof firstValue === "string") {
                    const values = result.data.map((row)=>row[field]);
                    if ($5a7e159cdc70a008$var$isCategory(values)) return (0, $2981a5535b73e677$export$a89907aa2cab9ea9).fromTextValues(field, values);
                    else return (0, $e4c684e9a602935b$export$524ab8b6c1ca9de3).fromTextValues(field, values);
                }
            }
            result.meta.fields?.forEach((field)=>{
                if (field === "embeddings") {
                    const arrays = result.data.map((row)=>$5a7e159cdc70a008$var$parseArrayString(row[field]));
                    const count = arrays.length;
                    const dimensions = arrays[0].length;
                    const values = new Float32Array(count * dimensions);
                    for(let i = 0; i < count; i++)for(let j = 0; j < dimensions; j++)values[i * dimensions + j] = arrays[i][j];
                    dataset.setEmbeddings(values, dimensions);
                    const projections = dataset.computeProjections();
                    if (projections) dataset.setProjections(projections);
                    return;
                }
                const attribute = buildAttribute(field);
                if (attribute) dataset.addAttribute(attribute);
            });
            return dataset;
        });
        onLoad(dataset);
    };
    const handleLoadFile = async (file)=>{
        if (file.name.endsWith(".csv")) handleLoadUrl(URL.createObjectURL(file));
    };
    (0, $e74ae269af9e7da4$export$2e2bcd8739ae039)({
        onFiles: (files)=>{
            files.forEach(handleLoadFile);
        }
    });
    return null;
}
var $5a7e159cdc70a008$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bdO8))).memo($5a7e159cdc70a008$export$ec89b01ff2939d3e);



var $1bdO8 = parcelRequire("1bdO8");

var $8oBBS = parcelRequire("8oBBS");




function $7a6377b8fcd7c7a4$var$concatArrays(arrays) {
    const count = (0, (/*@__PURE__*/$parcel$interopDefault($8oBBS))).sumBy(arrays, (a)=>a.length);
    const result = new Float32Array(count);
    let offset = 0;
    arrays.forEach((a)=>{
        result.set(a, offset);
        offset += a.length;
    });
    return result;
}
// Quick implementation of BS5 to Dataset conversion for debugging
function $7a6377b8fcd7c7a4$var$datasetFromBS5Scene(scene) {
    const lidar = scene?.sensors?.find((s)=>s.type === "lidar");
    if (lidar) {
        const dataset = new (0, $aedec35396e1c21e$export$827063163a0a89f5)();
        const frames = lidar.frames.slice(0, 10);
        const positions = $7a6377b8fcd7c7a4$var$concatArrays(frames.map((f)=>f.points.positions));
        const count = positions.length / 3;
        const frame = (0, $06f8b1ca3fe54dd2$export$aac0c9b76a8647d7).zero("frame", count);
        const z = (0, $06f8b1ca3fe54dd2$export$aac0c9b76a8647d7).zero("z", count);
        // Fill frames attribute
        let offset = 0;
        for(let i = 0; i < frames.length; i++){
            const frameCount = frames[i].points.positions.length / 3;
            frame.values.fill(i, offset, offset + frameCount);
            offset += frameCount;
        }
        // Fill z attribute
        for(let i = 0; i < count; i++)z.values[i] = positions[i * 3 + 2];
        frame.updateRange();
        z.updateRange();
        dataset.addAttribute(frame);
        dataset.addAttribute(z);
        dataset.setProjections(positions);
        return dataset;
    }
    throw new Error("No lidar sensor found");
}
function $7a6377b8fcd7c7a4$var$BS5SceneLoader({ onLoad: onLoad  }) {
    const handleLoadUrl = async (url)=>{
        const dataset = await fetch(url).then((response)=>response.arrayBuffer()).then((buffer)=>(0, $205d51f2000f9e59$export$98e6a39c04603d36)(buffer)).then((data)=>$7a6377b8fcd7c7a4$var$datasetFromBS5Scene(data));
        onLoad(dataset);
    };
    const handleLoadFile = async (file)=>{
        if (file.name.endsWith(".bs5")) await handleLoadUrl(URL.createObjectURL(file));
    };
    (0, $e74ae269af9e7da4$export$2e2bcd8739ae039)({
        onFiles: (files)=>{
            files.forEach(handleLoadFile);
        }
    });
    return null;
}
var $7a6377b8fcd7c7a4$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bdO8))).memo($7a6377b8fcd7c7a4$var$BS5SceneLoader);


function $c40724a2dbf728fa$export$bad241469279ac89({ onLoad: onLoad  }) {
    return /*#__PURE__*/ (0, $cVgDf.jsxs)((0, $cVgDf.Fragment), {
        children: [
            /*#__PURE__*/ (0, $cVgDf.jsx)((0, $88569b9317805644$export$2e2bcd8739ae039), {
                onLoad: onLoad
            }),
            /*#__PURE__*/ (0, $cVgDf.jsx)((0, $5a7e159cdc70a008$export$2e2bcd8739ae039), {
                onLoad: onLoad
            }),
            /*#__PURE__*/ (0, $cVgDf.jsx)((0, $7a6377b8fcd7c7a4$export$2e2bcd8739ae039), {
                onLoad: onLoad
            })
        ]
    });
}



var $1bdO8 = parcelRequire("1bdO8");
function $cd7897de12d8547b$export$b38d13258b7431d5() {
    const handler = (0, $1bdO8.useCallback)((e)=>{
        if (e.target instanceof HTMLInputElement) e.stopPropagation();
    }, []);
    (0, $1bdO8.useEffect)(()=>{
        document.addEventListener("keydown", handler);
        return ()=>{
            document.removeEventListener("keydown", handler);
        };
    }, []);
    return null;
}



var $cVgDf = parcelRequire("cVgDf");
parcelRequire("1bdO8");

var $kVGEJ = parcelRequire("kVGEJ");

var $1bdO8 = parcelRequire("1bdO8");

const $18138c912bf4d9fe$export$f735d6cbbb187197 = (0, $ca0ed0868e4d0815$exports.create)((set, get)=>({
        tools: [],
        currentTool: "pointer",
        previousTool: "pointer",
        setTool: (currentTool)=>{
            set({
                currentTool: currentTool,
                previousTool: get().currentTool
            });
        },
        setPreviousTool: ()=>{
            set({
                currentTool: get().previousTool
            });
        },
        registerTool: (tool)=>{
            set((state)=>({
                    tools: [
                        ...state.tools,
                        tool
                    ]
                }));
        },
        unregisterTool: (tool)=>{
            set((state)=>({
                    tools: state.tools.filter((t)=>t !== tool)
                }));
        }
    }));
const $18138c912bf4d9fe$export$fab2e03fdf80f55d = (tool)=>{
    (0, $1bdO8.useEffect)(()=>{
        $18138c912bf4d9fe$export$f735d6cbbb187197.getState().registerTool(tool);
        return ()=>$18138c912bf4d9fe$export$f735d6cbbb187197.getState().unregisterTool(tool);
    }, [
        tool
    ]);
};



function $3a2c5c12e4f579f2$export$b0ebbe7904d8d94a(key, onKeyDown, onKeyUp) {
    (0, $06a60cf932bc70f9$export$2e2bcd8739ae039)(key, (event)=>{
        if (event.repeat) return;
        onKeyDown?.(event);
    }, {
        event: "keydown"
    }, [
        key,
        onKeyDown
    ]);
    (0, $06a60cf932bc70f9$export$2e2bcd8739ae039)(key, (event)=>{
        if (event.repeat) return;
        onKeyUp?.(event);
    }, {
        event: "keyup"
    }, [
        key,
        onKeyUp
    ]);
}



var $cVgDf = parcelRequire("cVgDf");
parcelRequire("1bdO8");
const $69643b1078eb0975$var$SvgLasso = (props)=>/*#__PURE__*/ (0, $cVgDf.jsx)("svg", {
        viewBox: "0 0 56 56",
        ...props,
        children: /*#__PURE__*/ (0, $cVgDf.jsx)("path", {
            d: "M3.86 25.234c0 10.758 9.234 16.805 20.765 16.805.89 0 1.805-.047 2.719-.094.96.399 2.11.633 3.398.633 3.516 0 7.078-.984 10.242-2.672.07.352.094.727.094 1.102 0 2.812-1.594 5.555-4.219 7.219-.68.492-1.172.984-1.172 1.828 0 .867.704 1.617 1.805 1.617.516 0 .82-.14 1.266-.422 3.61-2.344 5.836-6.258 5.836-10.312 0-1.079-.14-2.086-.422-3.047 4.71-3.586 7.969-8.86 7.969-14.649 0-11.156-9.938-18.914-21.82-18.914-13.008 0-26.462 8.531-26.462 20.906zm3.538.024c0-10.219 11.72-17.39 22.946-17.39 9.82 0 18.281 6.093 18.281 15.35 0 4.43-2.484 8.532-6.094 11.462-1.968-2.602-5.156-4.242-8.836-4.242-5.367 0-9.421 2.812-9.421 6.96 0 .399.046.774.14 1.125C15.063 38.406 7.4 34 7.4 25.258zM27.837 37.28c0-1.968 2.742-3.281 6.14-3.281 2.344 0 4.36 1.008 5.65 2.648-2.743 1.524-5.86 2.414-8.884 2.414-1.687 0-2.906-.656-2.906-1.78z"
        })
    });
var $69643b1078eb0975$export$2e2bcd8739ae039 = $69643b1078eb0975$var$SvgLasso;



var $cVgDf = parcelRequire("cVgDf");
parcelRequire("1bdO8");
const $3e964efadd575610$var$SvgPointer = (props)=>/*#__PURE__*/ (0, $cVgDf.jsx)("svg", {
        viewBox: "0 0 203.079 203.079",
        ...props,
        children: /*#__PURE__*/ (0, $cVgDf.jsx)("path", {
            d: "M192.231 104.082V102c0-12.407-10.094-22.5-22.5-22.5-2.802 0-5.484.519-7.961 1.459C159.665 70.722 150.583 63 139.731 63c-2.947 0-5.76.575-8.341 1.61C128.667 55.162 119.624 48 109.231 48a22.01 22.01 0 0 0-8 1.516V22.5c0-12.407-10.094-22.5-22.5-22.5s-22.5 10.093-22.5 22.5v66.259c-3.938-5.029-8.673-9.412-14.169-11.671-6.133-2.52-12.587-2.219-18.667.872-11.182 5.686-15.792 19.389-10.277 30.548l27.95 56.563c.79 1.552 19.731 38.008 54.023 38.008h40c31.54 0 57.199-25.794 57.199-57.506l-.031-41.491h-.028zm-57.139 83.997h-40c-24.702 0-40.091-28.738-40.646-29.796l-27.88-56.42c-1.924-3.893-.33-8.519 3.629-10.532 2.182-1.11 4.081-1.223 6.158-.372 8.281 3.395 16.41 19.756 19.586 29.265l2.41 7.259 12.883-4.559V22.5c0-4.136 3.364-7.5 7.5-7.5s7.5 3.364 7.5 7.5V109h15.136V71c0-4.187 3.748-8 7.864-8 4.262 0 8 3.505 8 7.5v41h15v-26c0-4.136 3.364-7.5 7.5-7.5s7.5 3.364 7.5 7.5v33h15V102c0-4.136 3.364-7.5 7.5-7.5s7.5 3.364 7.5 7.5v10.727h.035l.025 32.852c-.001 23.435-18.932 42.5-42.2 42.5z"
        })
    });
var $3e964efadd575610$export$2e2bcd8739ae039 = $3e964efadd575610$var$SvgPointer;



var $cVgDf = parcelRequire("cVgDf");

var $1bdO8 = parcelRequire("1bdO8");



var $cVgDf = parcelRequire("cVgDf");

var $1bdO8 = parcelRequire("1bdO8");

var $fZ2DJ = parcelRequire("fZ2DJ");

var $63nUy = parcelRequire("63nUy");

var $1bdO8 = parcelRequire("1bdO8");


var $9H0b9 = parcelRequire("9H0b9");

var $1nBS8 = parcelRequire("1nBS8");

var $fZ2DJ = parcelRequire("fZ2DJ");

var $63nUy = parcelRequire("63nUy");

var $7xoNL = parcelRequire("7xoNL");

var $1bdO8 = parcelRequire("1bdO8");


var $gJjS7 = parcelRequire("gJjS7");

var $63nUy = parcelRequire("63nUy");

var $fZ2DJ = parcelRequire("fZ2DJ");

var $1bdO8 = parcelRequire("1bdO8");


// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $7a97632909b182ae$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}


function $a4bff6f8bf3c0872$export$2e2bcd8739ae039(node) {
    const doc = (0, $274f1134d02f9864$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}



var $cVgDf = parcelRequire("cVgDf");
const $8dee37026f5cfef8$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $8dee37026f5cfef8$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $8dee37026f5cfef8$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: "hidden",
        // Remove from the content flow
        position: "absolute",
        // Ignore the scrollbar width
        overflow: "hidden",
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: "translateZ(0)"
    }
};
function $8dee37026f5cfef8$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0 || obj.outerHeightStyle === 0 && !obj.overflow;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/base/react-textarea-autosize/)
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/base/react-textarea-autosize/components-api/#textarea-autosize)
 */ const $8dee37026f5cfef8$var$TextareaAutosize = /*#__PURE__*/ $1bdO8.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange , maxRows: maxRows , minRows: minRows = 1 , style: style , value: value  } = props, other = (0, $fZ2DJ.default)(props, $8dee37026f5cfef8$var$_excluded);
    const { current: isControlled  } = $1bdO8.useRef(value != null);
    const inputRef = $1bdO8.useRef(null);
    const handleRef = (0, $dd3d0833de97326d$export$2e2bcd8739ae039)(forwardedRef, inputRef);
    const shadowRef = $1bdO8.useRef(null);
    const renders = $1bdO8.useRef(0);
    const [state, setState] = $1bdO8.useState({
        outerHeightStyle: 0
    });
    const getUpdatedState = $1bdO8.useCallback(()=>{
        const input = inputRef.current;
        const containerWindow = (0, $a4bff6f8bf3c0872$export$2e2bcd8739ae039)(input);
        const computedStyle = containerWindow.getComputedStyle(input);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === "0px") return {
            outerHeightStyle: 0
        };
        const inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || "x";
        if (inputShallow.value.slice(-1) === "\n") // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += " ";
        const boxSizing = computedStyle.boxSizing;
        const padding = $8dee37026f5cfef8$var$getStyleValue(computedStyle.paddingBottom) + $8dee37026f5cfef8$var$getStyleValue(computedStyle.paddingTop);
        const border = $8dee37026f5cfef8$var$getStyleValue(computedStyle.borderBottomWidth) + $8dee37026f5cfef8$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = inputShallow.scrollHeight;
        // Measure height of a textarea with a single row
        inputShallow.value = "x";
        const singleRowHeight = inputShallow.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === "border-box" ? padding + border : 0);
        const overflow = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflow: overflow
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const updateState = (prevState, newState)=>{
        const { outerHeightStyle: outerHeightStyle , overflow: overflow  } = newState;
        // Need a large enough difference to update the height.
        // This prevents infinite rendering loop.
        if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
            renders.current += 1;
            return {
                overflow: overflow,
                outerHeightStyle: outerHeightStyle
            };
        }
        return prevState;
    };
    const syncHeight = $1bdO8.useCallback(()=>{
        const newState = getUpdatedState();
        if ($8dee37026f5cfef8$var$isEmpty(newState)) return;
        setState((prevState)=>{
            return updateState(prevState, newState);
        });
    }, [
        getUpdatedState
    ]);
    const syncHeightWithFlushSync = ()=>{
        const newState = getUpdatedState();
        if ($8dee37026f5cfef8$var$isEmpty(newState)) return;
        // In React 18, state updates in a ResizeObserver's callback are happening after the paint which causes flickering
        // when doing some visual updates in it. Using flushSync ensures that the dom will be painted after the states updates happen
        // Related issue - https://github.com/facebook/react/issues/24331
        $82db826d323863e6$exports.flushSync(()=>{
            setState((prevState)=>{
                return updateState(prevState, newState);
            });
        });
    };
    $1bdO8.useEffect(()=>{
        const handleResize = (0, $7a97632909b182ae$export$2e2bcd8739ae039)(()=>{
            renders.current = 0;
            // If the TextareaAutosize component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/32640
            if (inputRef.current) syncHeightWithFlushSync();
        });
        let resizeObserver;
        const input = inputRef.current;
        const containerWindow = (0, $a4bff6f8bf3c0872$export$2e2bcd8739ae039)(input);
        containerWindow.addEventListener("resize", handleResize);
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(input);
        }
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    });
    (0, $791ae28d50d58f30$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    $1bdO8.useEffect(()=>{
        renders.current = 0;
    }, [
        value
    ]);
    const handleChange = (event)=>{
        renders.current = 0;
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $cVgDf.jsxs)($1bdO8.Fragment, {
        children: [
            /*#__PURE__*/ (0, $cVgDf.jsx)("textarea", (0, $63nUy.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: (0, $63nUy.default)({
                    height: state.outerHeightStyle,
                    // Need a large enough difference to allow scrolling.
                    // This prevents infinite rendering loop.
                    overflow: state.overflow ? "hidden" : undefined
                }, style)
            }, other)),
            /*#__PURE__*/ (0, $cVgDf.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: (0, $63nUy.default)({}, $8dee37026f5cfef8$var$styles.shadow, style, {
                    padding: 0
                })
            })
        ]
    });
});
var $8dee37026f5cfef8$export$2e2bcd8739ae039 = $8dee37026f5cfef8$var$TextareaAutosize;


var $9H0b9 = parcelRequire("9H0b9");
function $65770948511e4963$export$2e2bcd8739ae039({ props: props , states: states , muiFormControl: muiFormControl  }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === "undefined") acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}



var $1bdO8 = parcelRequire("1bdO8");
/**
 * @ignore - internal component.
 */ const $81896010daa3f9ea$var$FormControlContext = /*#__PURE__*/ $1bdO8.createContext(undefined);
var $81896010daa3f9ea$export$2e2bcd8739ae039 = $81896010daa3f9ea$var$FormControlContext;



var $1bdO8 = parcelRequire("1bdO8");

function $7f8ac8bbee0785d9$export$2e2bcd8739ae039() {
    return $1bdO8.useContext((0, $81896010daa3f9ea$export$2e2bcd8739ae039));
}



var $gIzLq = parcelRequire("gIzLq");

var $dHuM2 = parcelRequire("dHuM2");

var $82mcY = parcelRequire("82mcY");


var $2365c19ceb621fef$export$2e2bcd8739ae039 = (0, $791ae28d50d58f30$export$2e2bcd8739ae039);



// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $66b4eb86f2bc6b71$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $66b4eb86f2bc6b71$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($66b4eb86f2bc6b71$export$96bdbc84526f3739(obj.value) && obj.value !== "" || SSR && $66b4eb86f2bc6b71$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== "");
}
function $66b4eb86f2bc6b71$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}



var $itJr1 = parcelRequire("itJr1");

var $9nXgc = parcelRequire("9nXgc");
function $3297da41a38bef44$export$ef57d5c8ca2278f6(slot) {
    return (0, $9nXgc.default)("MuiInputBase", slot);
}
const $3297da41a38bef44$var$inputBaseClasses = (0, $itJr1.default)("MuiInputBase", [
    "root",
    "formControl",
    "focused",
    "disabled",
    "adornedStart",
    "adornedEnd",
    "error",
    "sizeSmall",
    "multiline",
    "colorSecondary",
    "fullWidth",
    "hiddenLabel",
    "readOnly",
    "input",
    "inputSizeSmall",
    "inputMultiline",
    "inputTypeSearch",
    "inputAdornedStart",
    "inputAdornedEnd",
    "inputHiddenLabel"
]);
var $3297da41a38bef44$export$2e2bcd8739ae039 = $3297da41a38bef44$var$inputBaseClasses;



var $cVgDf = parcelRequire("cVgDf");
const $c18b36e4d6a45e73$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $c18b36e4d6a45e73$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState  } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === "small" && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $82mcY.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $c18b36e4d6a45e73$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState  } = props;
    return [
        styles.input,
        ownerState.size === "small" && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === "search" && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $c18b36e4d6a45e73$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , color: color , disabled: disabled , error: error , endAdornment: endAdornment , focused: focused , formControl: formControl , fullWidth: fullWidth , hiddenLabel: hiddenLabel , multiline: multiline , readOnly: readOnly , size: size , startAdornment: startAdornment , type: type  } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $82mcY.default)(color)}`,
            disabled && "disabled",
            error && "error",
            fullWidth && "fullWidth",
            focused && "focused",
            formControl && "formControl",
            size === "small" && "sizeSmall",
            multiline && "multiline",
            startAdornment && "adornedStart",
            endAdornment && "adornedEnd",
            hiddenLabel && "hiddenLabel",
            readOnly && "readOnly"
        ],
        input: [
            "input",
            disabled && "disabled",
            type === "search" && "inputTypeSearch",
            multiline && "inputMultiline",
            size === "small" && "inputSizeSmall",
            hiddenLabel && "inputHiddenLabel",
            startAdornment && "inputAdornedStart",
            endAdornment && "inputAdornedEnd",
            readOnly && "readOnly"
        ]
    };
    return (0, $9H0b9.default)(slots, (0, $3297da41a38bef44$export$ef57d5c8ca2278f6), classes);
};
const $c18b36e4d6a45e73$export$298a043133d72a38 = (0, $gIzLq.default)("div", {
    name: "MuiInputBase",
    slot: "Root",
    overridesResolver: $c18b36e4d6a45e73$export$965edad20a84fa75
})(({ theme: theme , ownerState: ownerState  })=>(0, $63nUy.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: "1.4375em",
        // 23px
        boxSizing: "border-box",
        // Prevent padding issue with fullWidth.
        position: "relative",
        cursor: "text",
        display: "inline-flex",
        alignItems: "center",
        [`&.${(0, $3297da41a38bef44$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: "default"
        }
    }, ownerState.multiline && (0, $63nUy.default)({
        padding: "4px 0 5px"
    }, ownerState.size === "small" && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: "100%"
    }));
const $c18b36e4d6a45e73$export$a1ad29c901026019 = (0, $gIzLq.default)("input", {
    name: "MuiInputBase",
    slot: "Input",
    overridesResolver: $c18b36e4d6a45e73$export$cf507b112810e72d
})(({ theme: theme , ownerState: ownerState  })=>{
    const light = theme.palette.mode === "light";
    const placeholder = (0, $63nUy.default)({
        color: "currentColor"
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: "0 !important"
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $63nUy.default)({
        font: "inherit",
        letterSpacing: "inherit",
        color: "currentColor",
        padding: "4px 0 5px",
        border: 0,
        boxSizing: "content-box",
        background: "none",
        height: "1.4375em",
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: "transparent",
        display: "block",
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: "100%",
        // Fix IE11 width issue
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&::-webkit-input-placeholder": placeholder,
        "&::-moz-placeholder": placeholder,
        // Firefox 19+
        "&:-ms-input-placeholder": placeholder,
        // IE11
        "&::-ms-input-placeholder": placeholder,
        // Edge
        "&:focus": {
            outline: 0
        },
        // Reset Firefox invalid required input style
        "&:invalid": {
            boxShadow: "none"
        },
        "&::-webkit-search-decoration": {
            // Remove the padding when type=search.
            WebkitAppearance: "none"
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $3297da41a38bef44$export$2e2bcd8739ae039).formControl} &`]: {
            "&::-webkit-input-placeholder": placeholderHidden,
            "&::-moz-placeholder": placeholderHidden,
            // Firefox 19+
            "&:-ms-input-placeholder": placeholderHidden,
            // IE11
            "&::-ms-input-placeholder": placeholderHidden,
            // Edge
            "&:focus::-webkit-input-placeholder": placeholderVisible,
            "&:focus::-moz-placeholder": placeholderVisible,
            // Firefox 19+
            "&:focus:-ms-input-placeholder": placeholderVisible,
            // IE11
            "&:focus::-ms-input-placeholder": placeholderVisible // Edge
        },
        [`&.${(0, $3297da41a38bef44$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        "&:-webkit-autofill": {
            animationDuration: "5000s",
            animationName: "mui-auto-fill"
        }
    }, ownerState.size === "small" && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
    }, ownerState.type === "search" && {
        // Improve type search style.
        MozAppearance: "textfield"
    });
});
const $c18b36e4d6a45e73$var$inputGlobalStyles = /*#__PURE__*/ (0, $cVgDf.jsx)((0, $23385e0944e190fb$export$2e2bcd8739ae039), {
    styles: {
        "@keyframes mui-auto-fill": {
            from: {
                display: "block"
            }
        },
        "@keyframes mui-auto-fill-cancel": {
            from: {
                display: "block"
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $c18b36e4d6a45e73$var$InputBase = /*#__PURE__*/ $1bdO8.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $dHuM2.default)({
        props: inProps,
        name: "MuiInputBase"
    });
    const { "aria-describedby": ariaDescribedby , autoComplete: autoComplete , autoFocus: autoFocus , className: className , components: components = {} , componentsProps: componentsProps = {} , defaultValue: defaultValue , disabled: disabled , disableInjectingGlobalStyles: disableInjectingGlobalStyles , endAdornment: endAdornment , fullWidth: fullWidth = false , id: id , inputComponent: inputComponent = "input" , inputProps: inputPropsProp = {} , inputRef: inputRefProp , maxRows: maxRows , minRows: minRows , multiline: multiline = false , name: name , onBlur: onBlur , onChange: onChange , onClick: onClick , onFocus: onFocus , onKeyDown: onKeyDown , onKeyUp: onKeyUp , placeholder: placeholder , readOnly: readOnly , renderSuffix: renderSuffix , rows: rows , slotProps: slotProps = {} , slots: slots = {} , startAdornment: startAdornment , type: type = "text" , value: valueProp  } = props, other = (0, $fZ2DJ.default)(props, $c18b36e4d6a45e73$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled  } = $1bdO8.useRef(value != null);
    const inputRef = $1bdO8.useRef();
    const handleInputRefWarning = $1bdO8.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $428a291d5bcff83c$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $1bdO8.useState(false);
    const muiFormControl = (0, $7f8ac8bbee0785d9$export$2e2bcd8739ae039)();
    const fcs = (0, $65770948511e4963$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "hiddenLabel",
            "size",
            "required",
            "filled"
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $1bdO8.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $1bdO8.useCallback((obj)=>{
        if ((0, $66b4eb86f2bc6b71$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $2365c19ceb621fef$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $7xoNL.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $1bdO8.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick && !fcs.disabled) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === "input") {
        if (rows) inputProps = (0, $63nUy.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $63nUy.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $8dee37026f5cfef8$export$2e2bcd8739ae039);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === "mui-auto-fill-cancel" ? inputRef.current : {
            value: "x"
        });
    };
    $1bdO8.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $63nUy.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $c18b36e4d6a45e73$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $c18b36e4d6a45e73$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $c18b36e4d6a45e73$export$a1ad29c901026019;
    inputProps = (0, $63nUy.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $cVgDf.jsxs)($1bdO8.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $c18b36e4d6a45e73$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $cVgDf.jsxs)(Root, (0, $63nUy.default)({}, rootProps, !(0, $0bca8c2e2f0c859d$export$2e2bcd8739ae039)(Root) && {
                ownerState: (0, $63nUy.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $gJjS7.default)(classes.root, rootProps.className, className, readOnly && "MuiInputBase-readOnly"),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $cVgDf.jsx)((0, $81896010daa3f9ea$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $cVgDf.jsx)(Input, (0, $63nUy.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $0bca8c2e2f0c859d$export$2e2bcd8739ae039)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $63nUy.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $gJjS7.default)(classes.input, inputProps.className, readOnly && "MuiInputBase-readOnly"),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $63nUy.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $c18b36e4d6a45e73$export$2e2bcd8739ae039 = $c18b36e4d6a45e73$var$InputBase;



var $gIzLq = parcelRequire("gIzLq");

var $dHuM2 = parcelRequire("dHuM2");

var $63nUy = parcelRequire("63nUy");

var $itJr1 = parcelRequire("itJr1");

var $9nXgc = parcelRequire("9nXgc");

function $afbf56e8f97ab479$export$cdb270390122322b(slot) {
    return (0, $9nXgc.default)("MuiInput", slot);
}
const $afbf56e8f97ab479$var$inputClasses = (0, $63nUy.default)({}, (0, $3297da41a38bef44$export$2e2bcd8739ae039), (0, $itJr1.default)("MuiInput", [
    "root",
    "underline",
    "input"
]));
var $afbf56e8f97ab479$export$2e2bcd8739ae039 = $afbf56e8f97ab479$var$inputClasses;




var $cVgDf = parcelRequire("cVgDf");
const $2fa28f938382aaac$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $2fa28f938382aaac$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , disableUnderline: disableUnderline  } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $9H0b9.default)(slots, (0, $afbf56e8f97ab479$export$cdb270390122322b), classes);
    return (0, $63nUy.default)({}, classes, composedClasses);
};
const $2fa28f938382aaac$var$InputRoot = (0, $gIzLq.default)((0, $c18b36e4d6a45e73$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $gIzLq.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            ...(0, $c18b36e4d6a45e73$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>{
    const light = theme.palette.mode === "light";
    let bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $63nUy.default)({
        position: "relative"
    }, ownerState.formControl && {
        "label + &": {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        "&:after": {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $afbf56e8f97ab479$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $afbf56e8f97ab479$export$2e2bcd8739ae039).error}`]: {
            "&:before, &:after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&:before": {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $afbf56e8f97ab479$export$2e2bcd8739ae039).disabled}, .${(0, $afbf56e8f97ab479$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $afbf56e8f97ab479$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    });
});
const $2fa28f938382aaac$var$InputInput = (0, $gIzLq.default)((0, $c18b36e4d6a45e73$export$a1ad29c901026019), {
    name: "MuiInput",
    slot: "Input",
    overridesResolver: (0, $c18b36e4d6a45e73$export$cf507b112810e72d)
})({});
const $2fa28f938382aaac$var$Input = /*#__PURE__*/ $1bdO8.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $dHuM2.default)({
        props: inProps,
        name: "MuiInput"
    });
    const { disableUnderline: disableUnderline , components: components = {} , componentsProps: componentsPropsProp , fullWidth: fullWidth = false , inputComponent: inputComponent = "input" , multiline: multiline = false , slotProps: slotProps , slots: slots = {} , type: type = "text"  } = props, other = (0, $fZ2DJ.default)(props, $2fa28f938382aaac$var$_excluded);
    const classes = $2fa28f938382aaac$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $1nBS8.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $2fa28f938382aaac$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $2fa28f938382aaac$var$InputInput;
    return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $c18b36e4d6a45e73$export$2e2bcd8739ae039), (0, $63nUy.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$2fa28f938382aaac$var$Input.muiName = "Input";
var $2fa28f938382aaac$export$2e2bcd8739ae039 = $2fa28f938382aaac$var$Input;



var $417d4d6ea4db528a$exports = {};
"use strict";

Object.defineProperty($417d4d6ea4db528a$exports, "__esModule", {
    value: true
});
$417d4d6ea4db528a$exports.default = void 0;

var $417d4d6ea4db528a$var$_createSvgIcon = $83471781e862547b$exports((parcelRequire("ek3fl")));

var $cVgDf = parcelRequire("cVgDf");
var $417d4d6ea4db528a$var$_default = (0, $417d4d6ea4db528a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cVgDf.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), "Search");
$417d4d6ea4db528a$exports.default = $417d4d6ea4db528a$var$_default;


var $eb6973a27b1a7d87$exports = {};
"use strict";

Object.defineProperty($eb6973a27b1a7d87$exports, "__esModule", {
    value: true
});
$eb6973a27b1a7d87$exports.default = void 0;

var $eb6973a27b1a7d87$var$_createSvgIcon = $83471781e862547b$exports((parcelRequire("ek3fl")));

var $cVgDf = parcelRequire("cVgDf");
var $eb6973a27b1a7d87$var$_default = (0, $eb6973a27b1a7d87$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cVgDf.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");
$eb6973a27b1a7d87$exports.default = $eb6973a27b1a7d87$var$_default;


function $ba668d2b495cf442$export$690bcf3a1f1e9f2f({ value: value , onChange: onChange , onSubmit: onSubmit , onClear: onClear , openKey: openKey = "/" , disabled: disabled = false  }) {
    const ref = (0, $1bdO8.useRef)(null);
    const [focused, setFocused] = (0, (/*@__PURE__*/$parcel$interopDefault($1bdO8))).useState(false);
    const [expanded, setExpanded] = (0, (/*@__PURE__*/$parcel$interopDefault($1bdO8))).useState(false);
    const [lastSubmitted, setLastSubmitted] = (0, (/*@__PURE__*/$parcel$interopDefault($1bdO8))).useState("");
    (0, $1bdO8.useEffect)(()=>{
        if (value) setExpanded(true);
    }, [
        value
    ]);
    const handleChange = (0, $1bdO8.useCallback)((e)=>{
        onChange?.(e.target.value);
    }, [
        onChange
    ]);
    const handleKeyDown = (0, $1bdO8.useCallback)((e)=>{
        if (e.key === "Enter") {
            const currentValue = ref.current?.value || "";
            onSubmit?.(currentValue);
            setLastSubmitted(currentValue);
        }
        if (e.key === "Escape") onClear?.();
    }, [
        onSubmit
    ]);
    const handleClick = (0, $1bdO8.useCallback)(()=>{
        if (disabled) return;
        if (expanded) {
            onChange?.("");
            onSubmit?.("");
            setLastSubmitted("");
            setExpanded(false);
            return;
        }
        setExpanded(true);
        setTimeout(()=>{
            ref.current?.focus();
        }, 100);
    }, [
        expanded,
        disabled
    ]);
    (0, $06a60cf932bc70f9$export$2e2bcd8739ae039)(openKey, ()=>{
        if (openKey) {
            setExpanded(true);
            setTimeout(()=>{
                ref.current?.focus();
            }, 100);
        }
    });
    const submitted = lastSubmitted === value;
    return /*#__PURE__*/ (0, $cVgDf.jsxs)((0, $bab588839ada6019$export$2e2bcd8739ae039), {
        className: focused ? "focused" : "",
        sx: (theme)=>({
                padding: 0,
                height: theme.spacing(11),
                minWidth: theme.spacing(11),
                pointerEvents: "auto",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                transition: theme.transitions.create([
                    "width",
                    "background-color",
                    "color",
                    "border-color"
                ]),
                overflow: "hidden",
                width: "auto",
                "&:hover": {
                    cursor: "auto"
                },
                "&.focused": {
                    borderColor: theme.palette.grey[300]
                },
                "&.focused:hover": {
                    backgroundColor: theme.palette.background.paper
                }
            }),
        children: [
            /*#__PURE__*/ (0, $cVgDf.jsx)((0, $89216f20f1c77281$export$2e2bcd8739ae039), {
                onClick: handleClick,
                sx: (theme)=>({
                        justifyContent: "center",
                        alignItems: "center",
                        paddingLeft: theme.spacing(2),
                        width: theme.spacing(9),
                        height: theme.spacing(11),
                        flexShrink: 0,
                        "&:hover": {
                            cursor: "pointer"
                        }
                    }),
                children: /*#__PURE__*/ (0, $cVgDf.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($417d4d6ea4db528a$exports))), {
                    sx: {
                        fontSize: 18
                    }
                })
            }),
            /*#__PURE__*/ (0, $cVgDf.jsx)((0, $89216f20f1c77281$export$2e2bcd8739ae039), {
                sx: (theme)=>({
                        flexGrow: 1,
                        position: "relative",
                        flexDirection: "row",
                        justifyContent: "left",
                        alignItems: "center",
                        height: theme.spacing(11),
                        transition: theme.transitions.create([
                            "width",
                            "opacity"
                        ]),
                        opacity: expanded ? 1 : 0
                    }),
                children: /*#__PURE__*/ (0, $cVgDf.jsx)((0, $2fa28f938382aaac$export$2e2bcd8739ae039), {
                    inputRef: ref,
                    value: value,
                    onChange: handleChange,
                    disableUnderline: true,
                    onClick: (e)=>e.stopPropagation(),
                    onKeyDown: handleKeyDown,
                    onFocus: ()=>setFocused(true),
                    onBlur: ()=>setFocused(false),
                    inputMode: "search",
                    inputProps: {
                        size: Math.max(20, value.length)
                    },
                    sx: (theme)=>({
                            margin: 0,
                            padding: 0,
                            width: expanded ? "auto" : 0,
                            paddingLeft: theme.spacing(1),
                            transition: theme.transitions.create([
                                "width"
                            ]),
                            color: submitted ? theme.palette.text.primary : theme.palette.text.secondary
                        })
                })
            }),
            expanded && /*#__PURE__*/ (0, $cVgDf.jsx)((0, $89216f20f1c77281$export$2e2bcd8739ae039), {
                sx: (theme)=>({
                        justifyContent: "center",
                        alignItems: "center",
                        paddingRight: theme.spacing(2),
                        width: theme.spacing(11),
                        height: theme.spacing(11),
                        flexShrink: 0
                    }),
                children: onClear && value.length > 0 && !disabled && /*#__PURE__*/ (0, $cVgDf.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eb6973a27b1a7d87$exports))), {
                    onClick: onClear,
                    sx: {
                        fontSize: 14,
                        "&:hover": {
                            cursor: "pointer"
                        }
                    }
                })
            })
        ]
    });
}




function $852d884f595b377a$export$c5f53436d402a3d0() {
    const { loading: loading , dataset: dataset  } = (0, $a2bde23ea9c8df05$export$26531d8e255edf16)();
    const searchText = (0, $91a6458dd589bbd0$export$4b4c417a6113a34c)((s)=>s.searchText);
    const setSearchText = (0, $91a6458dd589bbd0$export$4b4c417a6113a34c)((s)=>s.setSearchText);
    const setSelectedIds = (0, $91a6458dd589bbd0$export$4b4c417a6113a34c)((s)=>s.setSelectedIds);
    const [text, setText] = (0, $1bdO8.useState)("");
    const handleSearch = (0, $1bdO8.useCallback)(async (value)=>{
        const selectedIds = (0, $91a6458dd589bbd0$export$4b4c417a6113a34c).getState().selectedIds;
        const results = await dataset?.textIndex.search(value, selectedIds.length > 0 ? selectedIds : undefined);
        if (results) setSelectedIds(results);
    }, [
        dataset,
        setSelectedIds
    ]);
    (0, $1bdO8.useEffect)(()=>{
        setText(searchText);
        handleSearch(searchText);
    }, [
        searchText,
        handleSearch
    ]);
    const handleClear = (0, $1bdO8.useCallback)(()=>{
        setText("");
        setSearchText("");
    }, [
        setSearchText
    ]);
    (0, $06a60cf932bc70f9$export$2e2bcd8739ae039)("Escape", handleClear);
    if (!dataset) return null;
    const title = loading ? "Creating text index..." : "Search text";
    return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $b679af97cafc2a91$export$2e2bcd8739ae039), {
        arrow: true,
        title: title,
        children: /*#__PURE__*/ (0, $cVgDf.jsx)("span", {
            children: /*#__PURE__*/ (0, $cVgDf.jsx)((0, $ba668d2b495cf442$export$690bcf3a1f1e9f2f), {
                disabled: loading,
                value: text,
                onChange: setText,
                onSubmit: setSearchText,
                onClear: handleClear
            })
        })
    });
}



var $cVgDf = parcelRequire("cVgDf");

var $1bdO8 = parcelRequire("1bdO8");
var $d5f52d1ef7aeb1d3$exports = {};
"use strict";

Object.defineProperty($d5f52d1ef7aeb1d3$exports, "__esModule", {
    value: true
});
$d5f52d1ef7aeb1d3$exports.default = void 0;

var $d5f52d1ef7aeb1d3$var$_createSvgIcon = $83471781e862547b$exports((parcelRequire("ek3fl")));

var $cVgDf = parcelRequire("cVgDf");
var $d5f52d1ef7aeb1d3$var$_default = (0, $d5f52d1ef7aeb1d3$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cVgDf.jsx)("path", {
    d: "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"
}), "Settings");
$d5f52d1ef7aeb1d3$exports.default = $d5f52d1ef7aeb1d3$var$_default;



var $cVgDf = parcelRequire("cVgDf");

var $1bdO8 = parcelRequire("1bdO8");

var $63nUy = parcelRequire("63nUy");

var $fZ2DJ = parcelRequire("fZ2DJ");

var $1bdO8 = parcelRequire("1bdO8");


var $gJjS7 = parcelRequire("gJjS7");

var $9H0b9 = parcelRequire("9H0b9");


var $gIzLq = parcelRequire("gIzLq");

var $dHuM2 = parcelRequire("dHuM2");

var $35dcb31f3b91f8ca$export$2e2bcd8739ae039 = (0, $7a97632909b182ae$export$2e2bcd8739ae039);



var $e9b9938f25cebc56$export$2e2bcd8739ae039 = (0, $274f1134d02f9864$export$2e2bcd8739ae039);



var $99ff92081d397c14$export$2e2bcd8739ae039 = (0, $a4bff6f8bf3c0872$export$2e2bcd8739ae039);





var $fZ2DJ = parcelRequire("fZ2DJ");

var $63nUy = parcelRequire("63nUy");

var $1bdO8 = parcelRequire("1bdO8");


var $gJjS7 = parcelRequire("gJjS7");

var $63nUy = parcelRequire("63nUy");

var $fZ2DJ = parcelRequire("fZ2DJ");

var $1bdO8 = parcelRequire("1bdO8");

/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $112fe5687000d5b5$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}



var $9H0b9 = parcelRequire("9H0b9");

// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $7c6f72e8b93bb1b5$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}


// Is a vertical scrollbar displayed?
function $9e5bc77febc622ff$var$isOverflowing(container) {
    const doc = (0, $274f1134d02f9864$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $a4bff6f8bf3c0872$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $9e5bc77febc622ff$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute("aria-hidden", "true");
    else element.removeAttribute("aria-hidden");
}
function $9e5bc77febc622ff$var$getPaddingRight(element) {
    return parseInt((0, $a4bff6f8bf3c0872$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $9e5bc77febc622ff$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE",
        "LINK",
        "MAP",
        "META",
        "NOSCRIPT",
        "PICTURE",
        "COL",
        "COLGROUP",
        "PARAM",
        "SLOT",
        "SOURCE",
        "TRACK"
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === "INPUT" && element.getAttribute("type") === "hidden";
    return isForbiddenTagName || isInputHidden;
}
function $9e5bc77febc622ff$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$9e5bc77febc622ff$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $9e5bc77febc622ff$export$e1bd0c6150f13d96(element, show);
    });
}
function $9e5bc77febc622ff$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $9e5bc77febc622ff$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($9e5bc77febc622ff$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $7c6f72e8b93bb1b5$export$2e2bcd8739ae039)((0, $274f1134d02f9864$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: "padding-right",
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$9e5bc77febc622ff$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $274f1134d02f9864$export$2e2bcd8739ae039)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: "padding-right",
                    el: element
                });
                element.style.paddingRight = `${$9e5bc77febc622ff$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $274f1134d02f9864$export$2e2bcd8739ae039)(container).body;
        else {
            // Improve Gatsby support
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $a4bff6f8bf3c0872$export$2e2bcd8739ae039)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === "HTML" && containerWindow.getComputedStyle(parent).overflowY === "scroll" ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: "overflow",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: "overflow-x",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: "overflow-y",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value , el: el , property: property  })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $9e5bc77febc622ff$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute("aria-hidden") === "true") hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $9e5bc77febc622ff$export$2e2bcd8739ae039 {
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $9e5bc77febc622ff$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $9e5bc77febc622ff$var$getHiddenSiblings(container);
        $9e5bc77febc622ff$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $9e5bc77febc622ff$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $9e5bc77febc622ff$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $9e5bc77febc622ff$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $9e5bc77febc622ff$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $9e5bc77febc622ff$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $9e5bc77febc622ff$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $9e5bc77febc622ff$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}


/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex */ 
var $1bdO8 = parcelRequire("1bdO8");



var $cVgDf = parcelRequire("cVgDf");
// Inspired by https://github.com/focus-trap/tabbable
const $56e0b7025aa12649$var$candidatesSelector = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
].join(",");
function $56e0b7025aa12649$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute("tabindex") || "", 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === "true" || (node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) return 0;
    return node.tabIndex;
}
function $56e0b7025aa12649$var$isNonTabbableRadio(node) {
    if (node.tagName !== "INPUT" || node.type !== "radio") return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $56e0b7025aa12649$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === "INPUT" && node.type === "hidden" || $56e0b7025aa12649$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $56e0b7025aa12649$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($56e0b7025aa12649$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $56e0b7025aa12649$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$56e0b7025aa12649$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $56e0b7025aa12649$var$defaultIsEnabled() {
    return true;
}
/**
 * Utility component that locks focus inside the component.
 *
 * Demos:
 *
 * - [Focus Trap](https://mui.com/base/react-focus-trap/)
 *
 * API:
 *
 * - [FocusTrap API](https://mui.com/base/react-focus-trap/components-api/#focus-trap)
 */ function $56e0b7025aa12649$var$FocusTrap(props) {
    const { children: children , disableAutoFocus: disableAutoFocus = false , disableEnforceFocus: disableEnforceFocus = false , disableRestoreFocus: disableRestoreFocus = false , getTabbable: getTabbable = $56e0b7025aa12649$var$defaultGetTabbable , isEnabled: isEnabled = $56e0b7025aa12649$var$defaultIsEnabled , open: open  } = props;
    const ignoreNextEnforceFocus = $1bdO8.useRef(false);
    const sentinelStart = $1bdO8.useRef(null);
    const sentinelEnd = $1bdO8.useRef(null);
    const nodeToRestore = $1bdO8.useRef(null);
    const reactFocusEventTarget = $1bdO8.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $1bdO8.useRef(false);
    const rootRef = $1bdO8.useRef(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $dd3d0833de97326d$export$2e2bcd8739ae039)(children.ref, rootRef);
    const lastKeydown = $1bdO8.useRef(null);
    $1bdO8.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $1bdO8.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $274f1134d02f9864$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) rootRef.current.setAttribute("tabIndex", "-1");
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $1bdO8.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $274f1134d02f9864$export$2e2bcd8739ae039)(rootRef.current);
        const contain = (nativeEvent)=>{
            const { current: rootElement  } = rootRef;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            if (!rootElement.contains(doc.activeElement)) {
                // if the focus event is not coming from inside the children's react tree, reset the refs
                if (nativeEvent && reactFocusEventTarget.current !== nativeEvent.target || doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
                else if (reactFocusEventTarget.current !== null) return;
                if (!activated.current) return;
                let tabbable = [];
                if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
                if (tabbable.length > 0) {
                    var _lastKeydown$current, _lastKeydown$current2;
                    const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === "Tab");
                    const focusNext = tabbable[0];
                    const focusPrevious = tabbable[tabbable.length - 1];
                    if (typeof focusNext !== "string" && typeof focusPrevious !== "string") {
                        if (isShiftTab) focusPrevious.focus();
                        else focusNext.focus();
                    }
                } else rootElement.focus();
            }
        };
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== "Tab") return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        doc.addEventListener("focusin", contain);
        doc.addEventListener("keydown", loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === "BODY") contain(null);
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener("focusin", contain);
            doc.removeEventListener("keydown", loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $cVgDf.jsxs)($1bdO8.Fragment, {
        children: [
            /*#__PURE__*/ (0, $cVgDf.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $1bdO8.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $cVgDf.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $56e0b7025aa12649$export$2e2bcd8739ae039 = $56e0b7025aa12649$var$FocusTrap;



var $itJr1 = parcelRequire("itJr1");

var $9nXgc = parcelRequire("9nXgc");
function $a3de14ff5bf3a862$export$67960e22b12a638d(slot) {
    return (0, $9nXgc.default)("MuiModal", slot);
}
const $a3de14ff5bf3a862$var$modalClasses = (0, $itJr1.default)("MuiModal", [
    "root",
    "hidden",
    "backdrop"
]);
var $a3de14ff5bf3a862$export$2e2bcd8739ae039 = $a3de14ff5bf3a862$var$modalClasses;





var $cVgDf = parcelRequire("cVgDf");
const $1abbad40c5c46db4$var$_excluded = [
    "children",
    "closeAfterTransition",
    "container",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "manager",
    "onBackdropClick",
    "onClose",
    "onKeyDown",
    "open",
    "onTransitionEnter",
    "onTransitionExited",
    "slotProps",
    "slots"
];
const $1abbad40c5c46db4$var$useUtilityClasses = (ownerState)=>{
    const { open: open , exited: exited  } = ownerState;
    const slots = {
        root: [
            "root",
            !open && exited && "hidden"
        ],
        backdrop: [
            "backdrop"
        ]
    };
    return (0, $9H0b9.default)(slots, (0, $6daae6859fe59e44$export$b0f7603cd2f9ee15)((0, $a3de14ff5bf3a862$export$67960e22b12a638d)));
};
function $1abbad40c5c46db4$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
function $1abbad40c5c46db4$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty("in") : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $1abbad40c5c46db4$var$defaultManager = new (0, $9e5bc77febc622ff$export$2e2bcd8739ae039)();
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * *   [Dialog](https://mui.com/material-ui/api/dialog/)
 * *   [Drawer](https://mui.com/material-ui/api/drawer/)
 * *   [Menu](https://mui.com/material-ui/api/menu/)
 * *   [Popover](https://mui.com/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](https://mui.com/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base/react-modal/)
 *
 * API:
 *
 * - [Modal API](https://mui.com/base/react-modal/components-api/#modal)
 */ const $1abbad40c5c46db4$var$Modal = /*#__PURE__*/ $1bdO8.forwardRef(function Modal(props, forwardedRef) {
    var _props$ariaHidden, _slots$root;
    const { children: children , closeAfterTransition: closeAfterTransition = false , container: container , disableAutoFocus: disableAutoFocus = false , disableEnforceFocus: disableEnforceFocus = false , disableEscapeKeyDown: disableEscapeKeyDown = false , disablePortal: disablePortal = false , disableRestoreFocus: disableRestoreFocus = false , disableScrollLock: disableScrollLock = false , hideBackdrop: hideBackdrop = false , keepMounted: keepMounted = false , // private
    manager: managerProp = $1abbad40c5c46db4$var$defaultManager , onBackdropClick: onBackdropClick , onClose: onClose , onKeyDown: onKeyDown , open: open , onTransitionEnter: onTransitionEnter , onTransitionExited: onTransitionExited , slotProps: slotProps = {} , slots: slots = {}  } = props, other = (0, $fZ2DJ.default)(props, $1abbad40c5c46db4$var$_excluded);
    // TODO: `modal`` must change its type in this file to match the type of methods
    // provided by `ModalManager`
    const manager = managerProp;
    const [exited, setExited] = $1bdO8.useState(!open);
    const modal = $1bdO8.useRef({});
    const mountNodeRef = $1bdO8.useRef(null);
    const modalRef = $1bdO8.useRef(null);
    const handleRef = (0, $dd3d0833de97326d$export$2e2bcd8739ae039)(modalRef, forwardedRef);
    const hasTransition = $1abbad40c5c46db4$var$getHasTransition(children);
    const ariaHiddenProp = (_props$ariaHidden = props["aria-hidden"]) != null ? _props$ariaHidden : true;
    const getDoc = ()=>(0, $274f1134d02f9864$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mountNode = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $f10d5b4622f4a02e$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $1abbad40c5c46db4$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $1bdO8.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $f10d5b4622f4a02e$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node || !modalRef.current) return;
        if (open && isTopModal()) handleMounted();
        else (0, $9e5bc77febc622ff$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $1bdO8.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        manager,
        ariaHiddenProp
    ]);
    $1bdO8.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $1bdO8.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const ownerState = (0, $63nUy.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        exited: exited,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const classes = $1abbad40c5c46db4$var$useUtilityClasses(ownerState);
    const handleEnter = ()=>{
        setExited(false);
        if (onTransitionEnter) onTransitionEnter();
    };
    const handleExited = ()=>{
        setExited(true);
        if (onTransitionExited) onTransitionExited();
        if (closeAfterTransition) handleClose();
    };
    const handleBackdropClick = (event)=>{
        if (event.target !== event.currentTarget) return;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, "backdropClick");
    };
    const handleKeyDown = (event)=>{
        if (onKeyDown) onKeyDown(event);
        // The handler doesn't take event.defaultPrevented into account:
        //
        // event.preventDefault() is meant to stop default behaviors like
        // clicking a checkbox to check it, hitting a button to submit a form,
        // and hitting left arrow to move the cursor in a text input etc.
        // Only special HTML elements have these default behaviors.
        if (event.key !== "Escape" || !isTopModal()) return;
        if (!disableEscapeKeyDown) {
            // Swallow the event, in case someone is listening for the escape key on the body.
            event.stopPropagation();
            if (onClose) onClose(event, "escapeKeyDown");
        }
    };
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = "-1";
    // It's a Transition like component
    if (hasTransition) {
        childProps.onEnter = (0, $112fe5687000d5b5$export$2e2bcd8739ae039)(handleEnter, children.props.onEnter);
        childProps.onExited = (0, $112fe5687000d5b5$export$2e2bcd8739ae039)(handleExited, children.props.onExited);
    }
    const Root = (_slots$root = slots.root) != null ? _slots$root : "div";
    const rootProps = (0, $a3690fae0734bc5f$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            ref: handleRef,
            role: "presentation",
            onKeyDown: handleKeyDown
        },
        className: classes.root,
        ownerState: ownerState
    });
    const BackdropComponent = slots.backdrop;
    const backdropProps = (0, $a3690fae0734bc5f$export$2e2bcd8739ae039)({
        elementType: BackdropComponent,
        externalSlotProps: slotProps.backdrop,
        additionalProps: {
            "aria-hidden": true,
            onClick: handleBackdropClick,
            open: open
        },
        className: classes.backdrop,
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $1f51e0c5982a0f47$export$2e2bcd8739ae039), {
        ref: handlePortalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $cVgDf.jsxs)(Root, (0, $63nUy.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $cVgDf.jsx)(BackdropComponent, (0, $63nUy.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $cVgDf.jsx)((0, $56e0b7025aa12649$export$2e2bcd8739ae039), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $1bdO8.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $1abbad40c5c46db4$export$2e2bcd8739ae039 = $1abbad40c5c46db4$var$Modal;





var $gIzLq = parcelRequire("gIzLq");

var $dHuM2 = parcelRequire("dHuM2");

var $fZ2DJ = parcelRequire("fZ2DJ");

var $63nUy = parcelRequire("63nUy");

var $1bdO8 = parcelRequire("1bdO8");


var $gJjS7 = parcelRequire("gJjS7");

var $9H0b9 = parcelRequire("9H0b9");

var $gIzLq = parcelRequire("gIzLq");

var $dHuM2 = parcelRequire("dHuM2");

var $63nUy = parcelRequire("63nUy");

var $fZ2DJ = parcelRequire("fZ2DJ");

var $1bdO8 = parcelRequire("1bdO8");







var $cVgDf = parcelRequire("cVgDf");
const $60ab66b7092afdcc$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $60ab66b7092afdcc$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $60ab66b7092afdcc$var$Fade = /*#__PURE__*/ $1bdO8.forwardRef(function Fade(props, ref) {
    const theme = (0, $e8c20c93268b1fae$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener , appear: appear = true , children: children , easing: easing , in: inProp , onEnter: onEnter , onEntered: onEntered , onEntering: onEntering , onExit: onExit , onExited: onExited , onExiting: onExiting , style: style , timeout: timeout = defaultTimeout , TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $8c1448717d190df7$export$2e2bcd8739ae039)  } = props, other = (0, $fZ2DJ.default)(props, $60ab66b7092afdcc$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $1bdO8.useRef(null);
    const handleRef = (0, $428a291d5bcff83c$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $784b87006e28997c$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $784b87006e28997c$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $784b87006e28997c$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $cVgDf.jsx)(TransitionComponent, (0, $63nUy.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $1bdO8.cloneElement(children, (0, $63nUy.default)({
                style: (0, $63nUy.default)({
                    opacity: 0,
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $60ab66b7092afdcc$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $60ab66b7092afdcc$export$2e2bcd8739ae039 = $60ab66b7092afdcc$var$Fade;



var $itJr1 = parcelRequire("itJr1");

var $9nXgc = parcelRequire("9nXgc");
function $16b738020961fc04$export$9927a91fd93152bd(slot) {
    return (0, $9nXgc.default)("MuiBackdrop", slot);
}
const $16b738020961fc04$var$backdropClasses = (0, $itJr1.default)("MuiBackdrop", [
    "root",
    "invisible"
]);
var $16b738020961fc04$export$2e2bcd8739ae039 = $16b738020961fc04$var$backdropClasses;



var $cVgDf = parcelRequire("cVgDf");
const $dab527ab4b73c085$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $dab527ab4b73c085$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , invisible: invisible  } = ownerState;
    const slots = {
        root: [
            "root",
            invisible && "invisible"
        ]
    };
    return (0, $9H0b9.default)(slots, (0, $16b738020961fc04$export$9927a91fd93152bd), classes);
};
const $dab527ab4b73c085$var$BackdropRoot = (0, $gIzLq.default)("div", {
    name: "MuiBackdrop",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState  })=>(0, $63nUy.default)({
        position: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    }, ownerState.invisible && {
        backgroundColor: "transparent"
    }));
const $dab527ab4b73c085$var$Backdrop = /*#__PURE__*/ $1bdO8.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $dHuM2.default)({
        props: inProps,
        name: "MuiBackdrop"
    });
    const { children: children , className: className , component: component = "div" , components: components = {} , componentsProps: componentsProps = {} , invisible: invisible = false , open: open , slotProps: slotProps = {} , slots: slots = {} , TransitionComponent: TransitionComponent = (0, $60ab66b7092afdcc$export$2e2bcd8739ae039) , transitionDuration: transitionDuration  } = props, other = (0, $fZ2DJ.default)(props, $dab527ab4b73c085$var$_excluded);
    const ownerState = (0, $63nUy.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $dab527ab4b73c085$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $cVgDf.jsx)(TransitionComponent, (0, $63nUy.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $cVgDf.jsx)($dab527ab4b73c085$var$BackdropRoot, (0, $63nUy.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $gJjS7.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $63nUy.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $dab527ab4b73c085$export$2e2bcd8739ae039 = $dab527ab4b73c085$var$Backdrop;



var $cVgDf = parcelRequire("cVgDf");
const $bb150f37de559201$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $bb150f37de559201$export$eb211a494147b724 = (0, $a3de14ff5bf3a862$export$2e2bcd8739ae039);
const $bb150f37de559201$var$ModalRoot = (0, $gIzLq.default)("div", {
    name: "MuiModal",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>(0, $63nUy.default)({
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: "hidden"
    }));
const $bb150f37de559201$var$ModalBackdrop = (0, $gIzLq.default)((0, $dab527ab4b73c085$export$2e2bcd8739ae039), {
    name: "MuiModal",
    slot: "Backdrop",
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $bb150f37de559201$var$Modal = /*#__PURE__*/ $1bdO8.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $dHuM2.default)({
        name: "MuiModal",
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $bb150f37de559201$var$ModalBackdrop , BackdropProps: BackdropProps , classes: classes , className: className , closeAfterTransition: closeAfterTransition = false , children: children , container: container , component: component , components: components = {} , componentsProps: componentsProps = {} , disableAutoFocus: disableAutoFocus = false , disableEnforceFocus: disableEnforceFocus = false , disableEscapeKeyDown: disableEscapeKeyDown = false , disablePortal: disablePortal = false , disableRestoreFocus: disableRestoreFocus = false , disableScrollLock: disableScrollLock = false , hideBackdrop: hideBackdrop = false , keepMounted: keepMounted = false , onBackdropClick: onBackdropClick , onClose: onClose , open: open , slotProps: slotProps , slots: slots , theme: // eslint-disable-next-line react/prop-types
    theme  } = props, other = (0, $fZ2DJ.default)(props, $bb150f37de559201$var$_excluded);
    const [exited, setExited] = $1bdO8.useState(true);
    const commonProps = {
        container: container,
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted,
        onBackdropClick: onBackdropClick,
        onClose: onClose,
        open: open
    };
    const ownerState = (0, $63nUy.default)({}, props, commonProps, {
        exited: exited
    });
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $bb150f37de559201$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $1abbad40c5c46db4$export$2e2bcd8739ae039), (0, $63nUy.default)({
        slots: {
            root: RootSlot,
            backdrop: BackdropSlot
        },
        slotProps: {
            root: ()=>(0, $63nUy.default)({}, (0, $394749d958e9c14d$export$2e2bcd8739ae039)(rootSlotProps, ownerState), !(0, $0bca8c2e2f0c859d$export$2e2bcd8739ae039)(RootSlot) && {
                    as: component,
                    theme: theme
                }, {
                    className: (0, $gJjS7.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
                }),
            backdrop: ()=>(0, $63nUy.default)({}, BackdropProps, (0, $394749d958e9c14d$export$2e2bcd8739ae039)(backdropSlotProps, ownerState), {
                    className: (0, $gJjS7.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop)
                })
        },
        onTransitionEnter: ()=>setExited(false),
        onTransitionExited: ()=>setExited(true),
        ref: ref
    }, other, commonProps, {
        children: children
    }));
});
var $bb150f37de559201$export$2e2bcd8739ae039 = $bb150f37de559201$var$Modal;




var $itJr1 = parcelRequire("itJr1");

var $9nXgc = parcelRequire("9nXgc");
function $3af0b16f796221f9$export$88f455dd56c95edb(slot) {
    return (0, $9nXgc.default)("MuiPopover", slot);
}
const $3af0b16f796221f9$var$popoverClasses = (0, $itJr1.default)("MuiPopover", [
    "root",
    "paper"
]);
var $3af0b16f796221f9$export$2e2bcd8739ae039 = $3af0b16f796221f9$var$popoverClasses;



var $cVgDf = parcelRequire("cVgDf");
const $58c8e082952f65ad$var$_excluded = [
    "onEntering"
], $58c8e082952f65ad$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
], $58c8e082952f65ad$var$_excluded3 = [
    "slotProps"
];
function $58c8e082952f65ad$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === "number") offset = vertical;
    else if (vertical === "center") offset = rect.height / 2;
    else if (vertical === "bottom") offset = rect.height;
    return offset;
}
function $58c8e082952f65ad$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === "number") offset = horizontal;
    else if (horizontal === "center") offset = rect.width / 2;
    else if (horizontal === "right") offset = rect.width;
    return offset;
}
function $58c8e082952f65ad$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === "number" ? `${n}px` : n).join(" ");
}
function $58c8e082952f65ad$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
const $58c8e082952f65ad$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes  } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ]
    };
    return (0, $9H0b9.default)(slots, (0, $3af0b16f796221f9$export$88f455dd56c95edb), classes);
};
const $58c8e082952f65ad$export$bcce13685275fc99 = (0, $gIzLq.default)((0, $bb150f37de559201$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $58c8e082952f65ad$export$821346c38a2d9390 = (0, $gIzLq.default)((0, $39353411c1daa853$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    position: "absolute",
    overflowY: "auto",
    overflowX: "hidden",
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: "calc(100% - 32px)",
    maxHeight: "calc(100% - 32px)",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $58c8e082952f65ad$var$Popover = /*#__PURE__*/ $1bdO8.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, $dHuM2.default)({
        props: inProps,
        name: "MuiPopover"
    });
    const { action: action , anchorEl: anchorEl , anchorOrigin: anchorOrigin = {
        vertical: "top",
        horizontal: "left"
    } , anchorPosition: anchorPosition , anchorReference: anchorReference = "anchorEl" , children: children , className: className , container: containerProp , elevation: elevation = 8 , marginThreshold: marginThreshold = 16 , open: open , PaperProps: PaperPropsProp = {} , slots: slots , slotProps: slotProps , transformOrigin: transformOrigin = {
        vertical: "top",
        horizontal: "left"
    } , TransitionComponent: TransitionComponent = (0, $5f3be16a76f1a341$export$2e2bcd8739ae039) , transitionDuration: transitionDurationProp = "auto" , TransitionProps: { onEntering: onEntering  } = {}  } = props, TransitionProps = (0, $fZ2DJ.default)(props.TransitionProps, $58c8e082952f65ad$var$_excluded), other = (0, $fZ2DJ.default)(props, $58c8e082952f65ad$var$_excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = $1bdO8.useRef();
    const handlePaperRef = (0, $428a291d5bcff83c$export$2e2bcd8739ae039)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, $63nUy.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $58c8e082952f65ad$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $1bdO8.useCallback(()=>{
        if (anchorReference === "anchorPosition") return anchorPosition;
        const resolvedAnchorEl = $58c8e082952f65ad$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $e9b9938f25cebc56$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $58c8e082952f65ad$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $58c8e082952f65ad$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $1bdO8.useCallback((elemRect)=>{
        return {
            vertical: $58c8e082952f65ad$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $58c8e082952f65ad$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $1bdO8.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === "none") return {
            top: null,
            left: null,
            transformOrigin: $58c8e082952f65ad$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $99ff92081d397c14$export$2e2bcd8739ae039)($58c8e082952f65ad$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $58c8e082952f65ad$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $1bdO8.useState(open);
    const setPositioningStyles = $1bdO8.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $1bdO8.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $1bdO8.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $1bdO8.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $35dcb31f3b91f8ca$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $99ff92081d397c14$export$2e2bcd8739ae039)(anchorEl);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $e9b9938f25cebc56$export$2e2bcd8739ae039)($58c8e082952f65ad$var$resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : $58c8e082952f65ad$export$bcce13685275fc99;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : $58c8e082952f65ad$export$821346c38a2d9390;
    const paperProps = (0, $a3690fae0734bc5f$export$2e2bcd8739ae039)({
        elementType: PaperSlot,
        externalSlotProps: (0, $63nUy.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, $63nUy.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation: elevation,
            ref: handlePaperRef
        },
        ownerState: ownerState,
        className: (0, $gJjS7.default)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, $a3690fae0734bc5f$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $gJjS7.default)(classes.root, className)
    }), { slotProps: rootSlotPropsProp  } = _useSlotProps, rootProps = (0, $fZ2DJ.default)(_useSlotProps, $58c8e082952f65ad$var$_excluded3);
    return /*#__PURE__*/ (0, $cVgDf.jsx)(RootSlot, (0, $63nUy.default)({}, rootProps, !(0, $0bca8c2e2f0c859d$export$2e2bcd8739ae039)(RootSlot) && {
        slotProps: rootSlotPropsProp
    }, {
        children: /*#__PURE__*/ (0, $cVgDf.jsx)(TransitionComponent, (0, $63nUy.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $cVgDf.jsx)(PaperSlot, (0, $63nUy.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
var $58c8e082952f65ad$export$2e2bcd8739ae039 = $58c8e082952f65ad$var$Popover;



var $cVgDf = parcelRequire("cVgDf");
parcelRequire("1bdO8");

var $fZ2DJ = parcelRequire("fZ2DJ");

var $63nUy = parcelRequire("63nUy");

var $1bdO8 = parcelRequire("1bdO8");


var $gJjS7 = parcelRequire("gJjS7");

var $fEWvF = parcelRequire("fEWvF");

var $9H0b9 = parcelRequire("9H0b9");

var $b8tOr = parcelRequire("b8tOr");

var $gIzLq = parcelRequire("gIzLq");

var $dHuM2 = parcelRequire("dHuM2");


var $82mcY = parcelRequire("82mcY");

var $itJr1 = parcelRequire("itJr1");

var $9nXgc = parcelRequire("9nXgc");
function $bb1ab167428867b1$export$5a6f9035944c8119(slot) {
    return (0, $9nXgc.default)("MuiButton", slot);
}
const $bb1ab167428867b1$var$buttonClasses = (0, $itJr1.default)("MuiButton", [
    "root",
    "text",
    "textInherit",
    "textPrimary",
    "textSecondary",
    "textSuccess",
    "textError",
    "textInfo",
    "textWarning",
    "outlined",
    "outlinedInherit",
    "outlinedPrimary",
    "outlinedSecondary",
    "outlinedSuccess",
    "outlinedError",
    "outlinedInfo",
    "outlinedWarning",
    "contained",
    "containedInherit",
    "containedPrimary",
    "containedSecondary",
    "containedSuccess",
    "containedError",
    "containedInfo",
    "containedWarning",
    "disableElevation",
    "focusVisible",
    "disabled",
    "colorInherit",
    "textSizeSmall",
    "textSizeMedium",
    "textSizeLarge",
    "outlinedSizeSmall",
    "outlinedSizeMedium",
    "outlinedSizeLarge",
    "containedSizeSmall",
    "containedSizeMedium",
    "containedSizeLarge",
    "sizeMedium",
    "sizeSmall",
    "sizeLarge",
    "fullWidth",
    "startIcon",
    "endIcon",
    "iconSizeSmall",
    "iconSizeMedium",
    "iconSizeLarge"
]);
var $bb1ab167428867b1$export$2e2bcd8739ae039 = $bb1ab167428867b1$var$buttonClasses;



var $1bdO8 = parcelRequire("1bdO8");
/**
 * @ignore - internal component.
 */ const $ea977b5288384d6c$var$ButtonGroupContext = /*#__PURE__*/ $1bdO8.createContext({});
var $ea977b5288384d6c$export$2e2bcd8739ae039 = $ea977b5288384d6c$var$ButtonGroupContext;



var $cVgDf = parcelRequire("cVgDf");
const $ca9283afe73d25e1$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $ca9283afe73d25e1$var$useUtilityClasses = (ownerState)=>{
    const { color: color , disableElevation: disableElevation , fullWidth: fullWidth , size: size , variant: variant , classes: classes  } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `${variant}${(0, $82mcY.default)(color)}`,
            `size${(0, $82mcY.default)(size)}`,
            `${variant}Size${(0, $82mcY.default)(size)}`,
            color === "inherit" && "colorInherit",
            disableElevation && "disableElevation",
            fullWidth && "fullWidth"
        ],
        label: [
            "label"
        ],
        startIcon: [
            "startIcon",
            `iconSize${(0, $82mcY.default)(size)}`
        ],
        endIcon: [
            "endIcon",
            `iconSize${(0, $82mcY.default)(size)}`
        ]
    };
    const composedClasses = (0, $9H0b9.default)(slots, (0, $bb1ab167428867b1$export$5a6f9035944c8119), classes);
    return (0, $63nUy.default)({}, classes, composedClasses);
};
const $ca9283afe73d25e1$var$commonIconStyles = (ownerState)=>(0, $63nUy.default)({}, ownerState.size === "small" && {
        "& > *:nth-of-type(1)": {
            fontSize: 18
        }
    }, ownerState.size === "medium" && {
        "& > *:nth-of-type(1)": {
            fontSize: 20
        }
    }, ownerState.size === "large" && {
        "& > *:nth-of-type(1)": {
            fontSize: 22
        }
    });
const $ca9283afe73d25e1$var$ButtonRoot = (0, $gIzLq.default)((0, $22f13692c22c9568$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $gIzLq.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $82mcY.default)(ownerState.color)}`],
            styles[`size${(0, $82mcY.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $82mcY.default)(ownerState.size)}`],
            ownerState.color === "inherit" && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $63nUy.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color",
            "color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": (0, $63nUy.default)({
            textDecoration: "none",
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $b8tOr.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $b8tOr.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $b8tOr.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "contained" && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        "&:active": (0, $63nUy.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $bb1ab167428867b1$export$2e2bcd8739ae039).focusVisible}`]: (0, $63nUy.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $bb1ab167428867b1$export$2e2bcd8739ae039).disabled}`]: (0, $63nUy.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === "outlined" && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === "contained" && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === "text" && {
        padding: "6px 8px"
    }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "outlined" && {
        padding: "5px 15px",
        border: "1px solid currentColor"
    }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $b8tOr.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === "contained" && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        color: "inherit",
        borderColor: "currentColor"
    }, ownerState.size === "small" && ownerState.variant === "text" && {
        padding: "4px 5px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "text" && {
        padding: "8px 11px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        padding: "3px 9px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "outlined" && {
        padding: "7px 21px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "contained" && {
        padding: "4px 10px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "contained" && {
        padding: "8px 22px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: "100%"
    });
}, ({ ownerState: ownerState  })=>ownerState.disableElevation && {
        boxShadow: "none",
        "&:hover": {
            boxShadow: "none"
        },
        [`&.${(0, $bb1ab167428867b1$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: "none"
        },
        "&:active": {
            boxShadow: "none"
        },
        [`&.${(0, $bb1ab167428867b1$export$2e2bcd8739ae039).disabled}`]: {
            boxShadow: "none"
        }
    });
const $ca9283afe73d25e1$var$ButtonStartIcon = (0, $gIzLq.default)("span", {
    name: "MuiButton",
    slot: "StartIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $82mcY.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState  })=>(0, $63nUy.default)({
        display: "inherit",
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === "small" && {
        marginLeft: -2
    }, $ca9283afe73d25e1$var$commonIconStyles(ownerState)));
const $ca9283afe73d25e1$var$ButtonEndIcon = (0, $gIzLq.default)("span", {
    name: "MuiButton",
    slot: "EndIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $82mcY.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState  })=>(0, $63nUy.default)({
        display: "inherit",
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === "small" && {
        marginRight: -2
    }, $ca9283afe73d25e1$var$commonIconStyles(ownerState)));
const $ca9283afe73d25e1$var$Button = /*#__PURE__*/ $1bdO8.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $1bdO8.useContext((0, $ea977b5288384d6c$export$2e2bcd8739ae039));
    const resolvedProps = (0, $fEWvF.default)(contextProps, inProps);
    const props = (0, $dHuM2.default)({
        props: resolvedProps,
        name: "MuiButton"
    });
    const { children: children , color: color = "primary" , component: component = "button" , className: className , disabled: disabled = false , disableElevation: disableElevation = false , disableFocusRipple: disableFocusRipple = false , endIcon: endIconProp , focusVisibleClassName: focusVisibleClassName , fullWidth: fullWidth = false , size: size = "medium" , startIcon: startIconProp , type: type , variant: variant = "text"  } = props, other = (0, $fZ2DJ.default)(props, $ca9283afe73d25e1$var$_excluded);
    const ownerState = (0, $63nUy.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $ca9283afe73d25e1$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $cVgDf.jsx)($ca9283afe73d25e1$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $cVgDf.jsx)($ca9283afe73d25e1$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    return /*#__PURE__*/ (0, $cVgDf.jsxs)($ca9283afe73d25e1$var$ButtonRoot, (0, $63nUy.default)({
        ownerState: ownerState,
        className: (0, $gJjS7.default)(contextProps.className, classes.root, className),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $gJjS7.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $ca9283afe73d25e1$export$2e2bcd8739ae039 = $ca9283afe73d25e1$var$Button;


var $gIzLq = parcelRequire("gIzLq");
const $d25467bba40385ca$var$StyledButton = (0, $gIzLq.default)((0, $ca9283afe73d25e1$export$2e2bcd8739ae039))(({ theme: theme  })=>({
        width: theme.spacing(11),
        minWidth: theme.spacing(11),
        height: theme.spacing(11)
    }));
function $d25467bba40385ca$export$b8914901871fbdb1({ selected: selected , ...props }) {
    return /*#__PURE__*/ (0, $cVgDf.jsx)($d25467bba40385ca$var$StyledButton, {
        variant: "outlined",
        color: selected ? "secondary" : "primary",
        ...props
    });
}


function $2153fffbfe539b10$export$15fdf8ef180193c1({ children: children , icon: icon  }) {
    const [anchorEl, setAnchorEl] = (0, $1bdO8.useState)();
    const handleClick = (0, $1bdO8.useCallback)((e)=>{
        if (anchorEl) {
            setAnchorEl(undefined);
            return;
        }
        setAnchorEl(e.currentTarget);
    }, [
        anchorEl
    ]);
    return /*#__PURE__*/ (0, $cVgDf.jsxs)((0, $cVgDf.Fragment), {
        children: [
            /*#__PURE__*/ (0, $cVgDf.jsx)((0, $d25467bba40385ca$export$b8914901871fbdb1), {
                selected: !!anchorEl,
                onClick: handleClick,
                children: icon
            }),
            /*#__PURE__*/ (0, $cVgDf.jsx)((0, $58c8e082952f65ad$export$2e2bcd8739ae039), {
                open: !!anchorEl,
                anchorEl: anchorEl,
                onClose: ()=>setAnchorEl(undefined),
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "left"
                },
                sx: (theme)=>({
                        "& .MuiPopover-paper": {
                            width: 300,
                            minHeight: 20,
                            marginTop: theme.spacing(2)
                        }
                    }),
                children: children
            })
        ]
    });
}






var $cVgDf = parcelRequire("cVgDf");

var $1bdO8 = parcelRequire("1bdO8");

var $b8tOr = parcelRequire("b8tOr");

var $1bdO8 = parcelRequire("1bdO8");
// vector add
function $28b7821850e91fb9$export$ca6b5e3985063434(v1, v2) {
    return v1.map(function(v, i) {
        return v + v2[i];
    });
} // vector substract
function $28b7821850e91fb9$export$e0f232dd469378a8(v1, v2) {
    return v1.map(function(v, i) {
        return v - v2[i];
    });
}
/**
 * Calculates distance
 * @param movement the difference between current and initial vectors
 * @returns distance
 */ function $28b7821850e91fb9$var$calculateDistance(movement) {
    return Math.hypot.apply(Math, movement);
}
function $28b7821850e91fb9$var$calculateAllGeometry(movement, delta) {
    if (delta === void 0) delta = movement;
    var dl = $28b7821850e91fb9$var$calculateDistance(delta);
    var alpha = dl === 0 ? 0 : 1 / dl;
    var direction = delta.map(function(v) {
        return alpha * v;
    });
    var distance = $28b7821850e91fb9$var$calculateDistance(movement);
    return {
        distance: distance,
        direction: direction
    };
}
/**
 * Calculates all kinematics
 * @template T the expected vector type
 * @param movement the difference between current and initial vectors
 * @param delta the difference between current and previous vectors
 * @param delta_t the time difference between current and previous timestamps
 * @returns all kinematics
 */ function $28b7821850e91fb9$var$calculateAllKinematics(movement, delta, dt) {
    var dl = $28b7821850e91fb9$var$calculateDistance(delta);
    var alpha = dl === 0 ? 0 : 1 / dl;
    var beta = dt === 0 ? 0 : 1 / dt;
    var velocity = beta * dl;
    var velocities = delta.map(function(v) {
        return beta * v;
    });
    var direction = delta.map(function(v) {
        return alpha * v;
    });
    var distance = $28b7821850e91fb9$var$calculateDistance(movement);
    return {
        velocities: velocities,
        velocity: velocity,
        distance: distance,
        direction: direction
    };
}
/**
 * Because IE doesn't support `Math.sign` function, so we use the polyfill version of the function.
 * This polyfill function is suggested by Mozilla:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/sign#Polyfill
 * @param x target number
 */ function $28b7821850e91fb9$var$sign(x) {
    if (Math.sign) return Math.sign(x);
    return Number(x > 0) - Number(x < 0) || +x;
}
function $28b7821850e91fb9$var$minMax(value, min, max) {
    return Math.max(min, Math.min(value, max));
} // Based on @aholachek ;)
// https://twitter.com/chpwn/status/285540192096497664
// iOS constant = 0.55
// https://medium.com/@nathangitter/building-fluid-interfaces-ios-swift-9732bb934bf5
function $28b7821850e91fb9$var$rubberband2(distance, constant) {
    // default constant from the article is 0.7
    return Math.pow(distance, constant * 5);
}
function $28b7821850e91fb9$var$rubberband(distance, dimension, constant) {
    if (dimension === 0 || Math.abs(dimension) === Infinity) return $28b7821850e91fb9$var$rubberband2(distance, constant);
    return distance * dimension * constant / (dimension + constant * distance);
}
function $28b7821850e91fb9$export$eb62c10c9b08d9ab(position, min, max, constant) {
    if (constant === void 0) constant = 0.15;
    if (constant === 0) return $28b7821850e91fb9$var$minMax(position, min, max);
    if (position < min) return -$28b7821850e91fb9$var$rubberband(min - position, max - min, constant) + min;
    if (position > max) return +$28b7821850e91fb9$var$rubberband(position - max, max - min, constant) + max;
    return position;
}
function $28b7821850e91fb9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $28b7821850e91fb9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $28b7821850e91fb9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $28b7821850e91fb9$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $28b7821850e91fb9$var$_extends() {
    $28b7821850e91fb9$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $28b7821850e91fb9$var$_extends.apply(this, arguments);
}
function $28b7821850e91fb9$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $28b7821850e91fb9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $28b7821850e91fb9$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $28b7821850e91fb9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $28b7821850e91fb9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $28b7821850e91fb9$var$_arrayLikeToArray(o, minLen);
}
function $28b7821850e91fb9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $28b7821850e91fb9$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (it = $28b7821850e91fb9$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            return function() {
                if (i >= o.length) return {
                    done: true
                };
                return {
                    done: false,
                    value: o[i++]
                };
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    it = o[Symbol.iterator]();
    return it.next.bind(it);
}
function $28b7821850e91fb9$var$noop() {}
/**
 * TODO Beware that only optimized cases are covered in tests =)
 * TODO Need to cover general case as well
 *
 * @param fns
 */ function $28b7821850e91fb9$var$chainFns() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    if (fns.length === 0) return $28b7821850e91fb9$var$noop;
    if (fns.length === 1) return fns[0];
    return function() {
        var result;
        for(var _iterator = $28b7821850e91fb9$var$_createForOfIteratorHelperLoose(fns), _step; !(_step = _iterator()).done;){
            var fn = _step.value;
            result = fn.apply(this, arguments) || result;
        }
        return result;
    };
}
/**
 * Expects a simple value or 2D vector (an array with 2 elements) and
 * always returns 2D vector. If simple value is passed, returns a
 * vector with this value as both coordinates.
 *
 * @param value
 */ function $28b7821850e91fb9$var$ensureVector(value, fallback) {
    if (value === undefined) {
        if (fallback === undefined) throw new Error("Must define fallback value if undefined is expected");
        value = fallback;
    }
    if (Array.isArray(value)) return value;
    return [
        value,
        value
    ];
}
/**
 * Helper for defining a default value
 *
 * @param value
 * @param fallback
 */ function $28b7821850e91fb9$var$assignDefault(value, fallback) {
    return Object.assign({}, fallback, value || {});
}
/**
 * Resolves getters (functions) by calling them
 * If simple value is given it just passes through
 *
 * @param v
 */ function $28b7821850e91fb9$var$valueFn(v) {
    if (typeof v === "function") {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        // @ts-ignore
        return v.apply(void 0, args);
    } else return v;
}
function $28b7821850e91fb9$var$resolveWith(config, resolvers) {
    if (config === void 0) config = {};
    var result = {};
    for(var _i = 0, _Object$entries = Object.entries(resolvers); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = _Object$entries[_i], key = _Object$entries$_i[0], resolver = _Object$entries$_i[1];
        switch(typeof resolver){
            case "function":
                result[key] = resolver.call(result, config[key], key, config);
                break;
            case "object":
                result[key] = $28b7821850e91fb9$var$resolveWith(config[key], resolver);
                break;
            case "boolean":
                if (resolver) result[key] = config[key];
                break;
        }
    }
    return result;
}
/**
 * Whether the browser supports GestureEvent (ie Safari)
 * @returns true if the browser supports gesture event
 */ function $28b7821850e91fb9$var$supportsGestureEvents() {
    try {
        // TODO [TS] possibly find GestureEvent definitions?
        // @ts-ignore: no type definitions for webkit GestureEvents
        return "constructor" in GestureEvent;
    } catch (e) {
        return false;
    }
}
function $28b7821850e91fb9$var$supportsTouchEvents() {
    return typeof window !== "undefined" && "ontouchstart" in window;
}
function $28b7821850e91fb9$var$supportsPointerEvents() {
    return typeof window !== "undefined" && "onpointerdown" in window;
}
function $28b7821850e91fb9$var$getEventTouches(event) {
    if ("pointerId" in event) return null;
    return event.type === "touchend" ? event.changedTouches : event.targetTouches;
}
function $28b7821850e91fb9$var$getTouchIds(event) {
    return Array.from($28b7821850e91fb9$var$getEventTouches(event)).map(function(t) {
        return t.identifier;
    });
}
function $28b7821850e91fb9$var$getGenericEventData(event) {
    var buttons = "buttons" in event ? event.buttons : 0;
    var shiftKey = event.shiftKey, altKey = event.altKey, metaKey = event.metaKey, ctrlKey = event.ctrlKey; // TODO check if this might create some overrides?
    return {
        buttons: buttons,
        shiftKey: shiftKey,
        altKey: altKey,
        metaKey: metaKey,
        ctrlKey: ctrlKey
    };
}
var $28b7821850e91fb9$var$identity = function identity(xy) {
    return xy;
};
/**
 * Gets pointer event values.
 * @param event
 * @returns pointer event values
 */ function $28b7821850e91fb9$var$getPointerEventValues(event, transform) {
    if (transform === void 0) transform = $28b7821850e91fb9$var$identity;
    var touchEvents = $28b7821850e91fb9$var$getEventTouches(event);
    var _ref = touchEvents ? touchEvents[0] : event, clientX = _ref.clientX, clientY = _ref.clientY;
    return transform([
        clientX,
        clientY
    ]);
}
/**
 * Gets two touches event data
 * @param event
 * @returns two touches event data
 */ function $28b7821850e91fb9$var$getTwoTouchesEventValues(event, pointerIds, transform) {
    if (transform === void 0) transform = $28b7821850e91fb9$var$identity;
    var _Array$from$filter = Array.from(event.touches).filter(function(t) {
        return pointerIds.includes(t.identifier);
    }), A = _Array$from$filter[0], B = _Array$from$filter[1];
    if (!A || !B) throw Error("The event doesn't have two pointers matching the pointerIds");
    var dx = B.clientX - A.clientX;
    var dy = B.clientY - A.clientY;
    var cx = (B.clientX + A.clientX) / 2;
    var cy = (B.clientY + A.clientY) / 2; // const e: any = 'nativeEvent' in event ? event.nativeEvent : event
    var distance = Math.hypot(dx, dy); // FIXME rotation has inconsistant values so we're not using it atm
    // const angle = (e.rotation as number) ?? -(Math.atan2(dx, dy) * 180) / Math.PI
    var angle = -(Math.atan2(dx, dy) * 180) / Math.PI;
    var values = transform([
        distance,
        angle
    ]);
    var origin = transform([
        cx,
        cy
    ]);
    return {
        values: values,
        origin: origin
    };
}
/**
 * Gets scroll event values
 * @param event
 * @returns scroll event values
 */ function $28b7821850e91fb9$var$getScrollEventValues(event, transform) {
    if (transform === void 0) transform = $28b7821850e91fb9$var$identity;
    // If the currentTarget is the window then we return the scrollX/Y position.
    // If not (ie the currentTarget is a DOM element), then we return scrollLeft/Top
    var _event$currentTarget = event.currentTarget, scrollX = _event$currentTarget.scrollX, scrollY = _event$currentTarget.scrollY, scrollLeft = _event$currentTarget.scrollLeft, scrollTop = _event$currentTarget.scrollTop;
    return transform([
        scrollX || scrollLeft || 0,
        scrollY || scrollTop || 0
    ]);
} // wheel delta defaults from https://github.com/facebookarchive/fixed-data-table/blob/master/src/vendor_upstream/dom/normalizeWheel.js
var $28b7821850e91fb9$var$LINE_HEIGHT = 40;
var $28b7821850e91fb9$var$PAGE_HEIGHT = 800;
/**
 * Gets wheel event values.
 * @param event
 * @returns wheel event values
 */ function $28b7821850e91fb9$var$getWheelEventValues(event, transform) {
    if (transform === void 0) transform = $28b7821850e91fb9$var$identity;
    var deltaX = event.deltaX, deltaY = event.deltaY, deltaMode = event.deltaMode; // normalize wheel values, especially for Firefox
    if (deltaMode === 1) {
        deltaX *= $28b7821850e91fb9$var$LINE_HEIGHT;
        deltaY *= $28b7821850e91fb9$var$LINE_HEIGHT;
    } else if (deltaMode === 2) {
        deltaX *= $28b7821850e91fb9$var$PAGE_HEIGHT;
        deltaY *= $28b7821850e91fb9$var$PAGE_HEIGHT;
    }
    return transform([
        deltaX,
        deltaY
    ]);
}
/**
 * Gets webkit gesture event values.
 * @param event
 * @returns webkit gesture event values
 */ function $28b7821850e91fb9$var$getWebkitGestureEventValues(event, transform) {
    if (transform === void 0) transform = $28b7821850e91fb9$var$identity;
    return transform([
        event.scale,
        event.rotation
    ]);
}
var $28b7821850e91fb9$var$DEFAULT_DRAG_DELAY = 180;
var $28b7821850e91fb9$var$DEFAULT_RUBBERBAND = 0.15;
var $28b7821850e91fb9$var$DEFAULT_SWIPE_VELOCITY = 0.5;
var $28b7821850e91fb9$var$DEFAULT_SWIPE_DISTANCE = 50;
var $28b7821850e91fb9$var$DEFAULT_SWIPE_DURATION = 250;
var $28b7821850e91fb9$var$InternalGestureOptionsNormalizers = {
    threshold: function threshold(value) {
        if (value === void 0) value = 0;
        return $28b7821850e91fb9$var$ensureVector(value);
    },
    rubberband: function rubberband(value) {
        if (value === void 0) value = 0;
        switch(value){
            case true:
                return $28b7821850e91fb9$var$ensureVector($28b7821850e91fb9$var$DEFAULT_RUBBERBAND);
            case false:
                return $28b7821850e91fb9$var$ensureVector(0);
            default:
                return $28b7821850e91fb9$var$ensureVector(value);
        }
    },
    enabled: function enabled(value) {
        if (value === void 0) value = true;
        return value;
    },
    triggerAllEvents: function triggerAllEvents(value) {
        if (value === void 0) value = false;
        return value;
    },
    initial: function initial(value) {
        if (value === void 0) value = 0;
        if (typeof value === "function") return value;
        return $28b7821850e91fb9$var$ensureVector(value);
    },
    transform: true
};
var $28b7821850e91fb9$var$InternalCoordinatesOptionsNormalizers = /*#__PURE__*/ $28b7821850e91fb9$var$_extends({}, $28b7821850e91fb9$var$InternalGestureOptionsNormalizers, {
    axis: true,
    lockDirection: function lockDirection(value) {
        if (value === void 0) value = false;
        return value;
    },
    bounds: function bounds(value) {
        if (value === void 0) value = {};
        if (typeof value === "function") return function(state) {
            return $28b7821850e91fb9$var$InternalCoordinatesOptionsNormalizers.bounds(value(state));
        };
        var _value2 = value, _value2$left = _value2.left, left = _value2$left === void 0 ? -Infinity : _value2$left, _value2$right = _value2.right, right = _value2$right === void 0 ? Infinity : _value2$right, _value2$top = _value2.top, top = _value2$top === void 0 ? -Infinity : _value2$top, _value2$bottom = _value2.bottom, bottom = _value2$bottom === void 0 ? Infinity : _value2$bottom;
        return [
            [
                left,
                right
            ],
            [
                top,
                bottom
            ]
        ];
    }
});
var $28b7821850e91fb9$var$isBrowser = typeof window !== "undefined" && window.document && window.document.createElement;
var $28b7821850e91fb9$var$InternalGenericOptionsNormalizers = {
    enabled: function enabled(value) {
        if (value === void 0) value = true;
        return value;
    },
    domTarget: true,
    window: /*#__PURE__*/ function(_window) {
        function window1(_x) {
            return _window.apply(this, arguments);
        }
        window1.toString = function() {
            return _window.toString();
        };
        return window1;
    }(function(value) {
        if (value === void 0) value = $28b7821850e91fb9$var$isBrowser ? window : undefined;
        return value;
    }),
    eventOptions: function eventOptions(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, _ref$passive = _ref.passive, passive = _ref$passive === void 0 ? true : _ref$passive, _ref$capture = _ref.capture, capture = _ref$capture === void 0 ? false : _ref$capture;
        return {
            passive: passive,
            capture: capture
        };
    },
    transform: true
};
var $28b7821850e91fb9$var$InternalDistanceAngleOptionsNormalizers = /*#__PURE__*/ $28b7821850e91fb9$var$_extends({}, $28b7821850e91fb9$var$InternalGestureOptionsNormalizers, {
    bounds: function bounds(_value, _key, _ref2) {
        var _ref2$distanceBounds = _ref2.distanceBounds, distanceBounds = _ref2$distanceBounds === void 0 ? {} : _ref2$distanceBounds, _ref2$angleBounds = _ref2.angleBounds, angleBounds = _ref2$angleBounds === void 0 ? {} : _ref2$angleBounds;
        var _distanceBounds = function _distanceBounds(state) {
            var D = $28b7821850e91fb9$var$assignDefault($28b7821850e91fb9$var$valueFn(distanceBounds, state), {
                min: -Infinity,
                max: Infinity
            });
            return [
                D.min,
                D.max
            ];
        };
        var _angleBounds = function _angleBounds(state) {
            var A = $28b7821850e91fb9$var$assignDefault($28b7821850e91fb9$var$valueFn(angleBounds, state), {
                min: -Infinity,
                max: Infinity
            });
            return [
                A.min,
                A.max
            ];
        };
        if (typeof distanceBounds !== "function" && typeof angleBounds !== "function") return [
            _distanceBounds(),
            _angleBounds()
        ];
        return function(state) {
            return [
                _distanceBounds(state),
                _angleBounds(state)
            ];
        };
    }
});
var $28b7821850e91fb9$var$InternalDragOptionsNormalizers = /*#__PURE__*/ $28b7821850e91fb9$var$_extends({}, $28b7821850e91fb9$var$InternalCoordinatesOptionsNormalizers, {
    useTouch: function useTouch(value) {
        if (value === void 0) value = false;
        var supportsTouch = $28b7821850e91fb9$var$supportsTouchEvents();
        var supportsPointer = $28b7821850e91fb9$var$supportsPointerEvents();
        if (value && supportsTouch) return true;
        if (supportsTouch && !supportsPointer) return true;
        return false;
    },
    experimental_preventWindowScrollY: function experimental_preventWindowScrollY(value) {
        if (value === void 0) value = false;
        return value;
    },
    threshold: function threshold(v, _k, _ref3) {
        var _ref3$filterTaps = _ref3.filterTaps, filterTaps = _ref3$filterTaps === void 0 ? false : _ref3$filterTaps, _ref3$lockDirection = _ref3.lockDirection, lockDirection = _ref3$lockDirection === void 0 ? false : _ref3$lockDirection, _ref3$axis = _ref3.axis, axis = _ref3$axis === void 0 ? undefined : _ref3$axis;
        var A = $28b7821850e91fb9$var$ensureVector(v, filterTaps ? 3 : lockDirection ? 1 : axis ? 1 : 0);
        this.filterTaps = filterTaps;
        return A;
    },
    swipeVelocity: function swipeVelocity(v) {
        if (v === void 0) v = $28b7821850e91fb9$var$DEFAULT_SWIPE_VELOCITY;
        return $28b7821850e91fb9$var$ensureVector(v);
    },
    swipeDistance: function swipeDistance(v) {
        if (v === void 0) v = $28b7821850e91fb9$var$DEFAULT_SWIPE_DISTANCE;
        return $28b7821850e91fb9$var$ensureVector(v);
    },
    swipeDuration: function swipeDuration(value) {
        if (value === void 0) value = $28b7821850e91fb9$var$DEFAULT_SWIPE_DURATION;
        return value;
    },
    delay: function delay(value) {
        if (value === void 0) value = 0;
        switch(value){
            case true:
                return $28b7821850e91fb9$var$DEFAULT_DRAG_DELAY;
            case false:
                return 0;
            default:
                return value;
        }
    }
});
function $28b7821850e91fb9$var$getInternalGenericOptions(config) {
    if (config === void 0) config = {};
    // TODO warn when passive is set to true and domTarget is undefined
    return $28b7821850e91fb9$var$resolveWith(config, $28b7821850e91fb9$var$InternalGenericOptionsNormalizers);
}
function $28b7821850e91fb9$var$getInternalCoordinatesOptions(config) {
    if (config === void 0) config = {};
    return $28b7821850e91fb9$var$resolveWith(config, $28b7821850e91fb9$var$InternalCoordinatesOptionsNormalizers);
}
function $28b7821850e91fb9$var$getInternalDistanceAngleOptions(config) {
    if (config === void 0) config = {};
    return $28b7821850e91fb9$var$resolveWith(config, $28b7821850e91fb9$var$InternalDistanceAngleOptionsNormalizers);
}
function $28b7821850e91fb9$var$getInternalDragOptions(config) {
    if (config === void 0) config = {};
    return $28b7821850e91fb9$var$resolveWith(config, $28b7821850e91fb9$var$InternalDragOptionsNormalizers);
}
function $28b7821850e91fb9$var$_buildMoveConfig(_ref) {
    var domTarget = _ref.domTarget, eventOptions = _ref.eventOptions, window1 = _ref.window, enabled = _ref.enabled, rest = $28b7821850e91fb9$var$_objectWithoutPropertiesLoose(_ref, [
        "domTarget",
        "eventOptions",
        "window",
        "enabled"
    ]);
    var opts = $28b7821850e91fb9$var$getInternalGenericOptions({
        domTarget: domTarget,
        eventOptions: eventOptions,
        window: window1,
        enabled: enabled
    });
    opts.move = $28b7821850e91fb9$var$getInternalCoordinatesOptions(rest);
    return opts;
}
function $28b7821850e91fb9$var$_buildHoverConfig(_ref2) {
    var domTarget = _ref2.domTarget, eventOptions = _ref2.eventOptions, window1 = _ref2.window, enabled = _ref2.enabled, rest = $28b7821850e91fb9$var$_objectWithoutPropertiesLoose(_ref2, [
        "domTarget",
        "eventOptions",
        "window",
        "enabled"
    ]);
    var opts = $28b7821850e91fb9$var$getInternalGenericOptions({
        domTarget: domTarget,
        eventOptions: eventOptions,
        window: window1,
        enabled: enabled
    });
    opts.hover = $28b7821850e91fb9$var$_extends({
        enabled: true
    }, rest);
    return opts;
}
function $28b7821850e91fb9$var$_buildDragConfig(_ref3) {
    var domTarget = _ref3.domTarget, eventOptions = _ref3.eventOptions, window1 = _ref3.window, enabled = _ref3.enabled, rest = $28b7821850e91fb9$var$_objectWithoutPropertiesLoose(_ref3, [
        "domTarget",
        "eventOptions",
        "window",
        "enabled"
    ]);
    var opts = $28b7821850e91fb9$var$getInternalGenericOptions({
        domTarget: domTarget,
        eventOptions: eventOptions,
        window: window1,
        enabled: enabled
    });
    opts.drag = $28b7821850e91fb9$var$getInternalDragOptions(rest);
    return opts;
}
function $28b7821850e91fb9$var$_buildPinchConfig(_ref4) {
    var domTarget = _ref4.domTarget, eventOptions = _ref4.eventOptions, window1 = _ref4.window, enabled = _ref4.enabled, rest = $28b7821850e91fb9$var$_objectWithoutPropertiesLoose(_ref4, [
        "domTarget",
        "eventOptions",
        "window",
        "enabled"
    ]);
    var opts = $28b7821850e91fb9$var$getInternalGenericOptions({
        domTarget: domTarget,
        eventOptions: eventOptions,
        window: window1,
        enabled: enabled
    });
    opts.pinch = $28b7821850e91fb9$var$getInternalDistanceAngleOptions(rest);
    return opts;
}
function $28b7821850e91fb9$var$_buildScrollConfig(_ref5) {
    var domTarget = _ref5.domTarget, eventOptions = _ref5.eventOptions, window1 = _ref5.window, enabled = _ref5.enabled, rest = $28b7821850e91fb9$var$_objectWithoutPropertiesLoose(_ref5, [
        "domTarget",
        "eventOptions",
        "window",
        "enabled"
    ]);
    var opts = $28b7821850e91fb9$var$getInternalGenericOptions({
        domTarget: domTarget,
        eventOptions: eventOptions,
        window: window1,
        enabled: enabled
    });
    opts.scroll = $28b7821850e91fb9$var$getInternalCoordinatesOptions(rest);
    return opts;
}
function $28b7821850e91fb9$var$_buildWheelConfig(_ref6) {
    var domTarget = _ref6.domTarget, eventOptions = _ref6.eventOptions, window1 = _ref6.window, enabled = _ref6.enabled, rest = $28b7821850e91fb9$var$_objectWithoutPropertiesLoose(_ref6, [
        "domTarget",
        "eventOptions",
        "window",
        "enabled"
    ]);
    var opts = $28b7821850e91fb9$var$getInternalGenericOptions({
        domTarget: domTarget,
        eventOptions: eventOptions,
        window: window1,
        enabled: enabled
    });
    opts.wheel = $28b7821850e91fb9$var$getInternalCoordinatesOptions(rest);
    return opts;
}
function $28b7821850e91fb9$var$buildComplexConfig(config, actions) {
    if (config === void 0) config = {};
    if (actions === void 0) actions = new Set();
    var _config = config, drag = _config.drag, wheel = _config.wheel, move = _config.move, scroll = _config.scroll, pinch = _config.pinch, hover = _config.hover, eventOptions = _config.eventOptions, window1 = _config.window, transform = _config.transform, domTarget = _config.domTarget, enabled = _config.enabled;
    var mergedConfig = $28b7821850e91fb9$var$getInternalGenericOptions({
        domTarget: domTarget,
        eventOptions: eventOptions,
        transform: transform,
        window: window1,
        enabled: enabled
    });
    if (actions.has("onDrag")) mergedConfig.drag = $28b7821850e91fb9$var$getInternalDragOptions(drag);
    if (actions.has("onWheel")) mergedConfig.wheel = $28b7821850e91fb9$var$getInternalCoordinatesOptions(wheel);
    if (actions.has("onScroll")) mergedConfig.scroll = $28b7821850e91fb9$var$getInternalCoordinatesOptions(scroll);
    if (actions.has("onMove")) mergedConfig.move = $28b7821850e91fb9$var$getInternalCoordinatesOptions(move);
    if (actions.has("onPinch")) mergedConfig.pinch = $28b7821850e91fb9$var$getInternalDistanceAngleOptions(pinch);
    if (actions.has("onHover")) mergedConfig.hover = $28b7821850e91fb9$var$_extends({
        enabled: true
    }, hover);
    return mergedConfig;
}
function $28b7821850e91fb9$var$getInitial(mixed) {
    return $28b7821850e91fb9$var$_extends({
        _active: false,
        _blocked: false,
        _intentional: [
            false,
            false
        ],
        _movement: [
            0,
            0
        ],
        _initial: [
            0,
            0
        ],
        _bounds: [
            [
                -Infinity,
                Infinity
            ],
            [
                -Infinity,
                Infinity
            ]
        ],
        _threshold: [
            0,
            0
        ],
        _lastEventType: undefined,
        _dragStarted: false,
        _dragPreventScroll: false,
        _dragIsTap: true,
        _dragDelayed: false,
        event: undefined,
        intentional: false,
        values: [
            0,
            0
        ],
        velocities: [
            0,
            0
        ],
        delta: [
            0,
            0
        ],
        movement: [
            0,
            0
        ],
        offset: [
            0,
            0
        ],
        lastOffset: [
            0,
            0
        ],
        direction: [
            0,
            0
        ],
        initial: [
            0,
            0
        ],
        previous: [
            0,
            0
        ],
        first: false,
        last: false,
        active: false,
        timeStamp: 0,
        startTime: 0,
        elapsedTime: 0,
        cancel: $28b7821850e91fb9$var$noop,
        canceled: false,
        memo: undefined,
        args: undefined
    }, mixed);
}
function $28b7821850e91fb9$var$getInitialState() {
    var shared = {
        hovering: false,
        scrolling: false,
        wheeling: false,
        dragging: false,
        moving: false,
        pinching: false,
        touches: 0,
        buttons: 0,
        down: false,
        shiftKey: false,
        altKey: false,
        metaKey: false,
        ctrlKey: false,
        locked: false
    };
    var drag = $28b7821850e91fb9$var$getInitial({
        _pointerId: undefined,
        axis: undefined,
        xy: [
            0,
            0
        ],
        vxvy: [
            0,
            0
        ],
        velocity: 0,
        distance: 0,
        tap: false,
        swipe: [
            0,
            0
        ]
    });
    var pinch = $28b7821850e91fb9$var$getInitial({
        // @ts-expect-error when used _pointerIds we can assert its type will be [number, number]
        _pointerIds: [],
        da: [
            0,
            0
        ],
        vdva: [
            0,
            0
        ],
        // @ts-expect-error origin can never be passed as undefined in userland
        origin: undefined,
        turns: 0
    });
    var wheel = $28b7821850e91fb9$var$getInitial({
        axis: undefined,
        xy: [
            0,
            0
        ],
        vxvy: [
            0,
            0
        ],
        velocity: 0,
        distance: 0
    });
    var move = $28b7821850e91fb9$var$getInitial({
        axis: undefined,
        xy: [
            0,
            0
        ],
        vxvy: [
            0,
            0
        ],
        velocity: 0,
        distance: 0
    });
    var scroll = $28b7821850e91fb9$var$getInitial({
        axis: undefined,
        xy: [
            0,
            0
        ],
        vxvy: [
            0,
            0
        ],
        velocity: 0,
        distance: 0
    });
    return {
        shared: shared,
        drag: drag,
        pinch: pinch,
        wheel: wheel,
        move: move,
        scroll: scroll
    };
}
var $28b7821850e91fb9$var$RecognizersMap = /*#__PURE__*/ new Map();
var $28b7821850e91fb9$var$identity$1 = function identity(xy) {
    return xy;
};
/**
 * @private
 * Recognizer abstract class.
 */ var $28b7821850e91fb9$var$Recognizer = /*#__PURE__*/ function() {
    /**
   * Creates an instance of a gesture recognizer.
   * @param stateKey drag, move, pinch, etc.
   * @param controller the controller attached to the gesture
   * @param [args] the args that should be passed to the gesture handler
   */ function Recognizer(controller, args) {
        var _this = this;
        if (args === void 0) args = [];
        this.controller = controller;
        this.args = args;
        this.debounced = true; // Convenience method to set a timeout for a given gesture
        this.setTimeout = function(callback, ms) {
            var _window;
            if (ms === void 0) ms = 140;
            clearTimeout(_this.controller.timeouts[_this.stateKey]);
            for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
            _this.controller.timeouts[_this.stateKey] = (_window = window).setTimeout.apply(_window, [
                callback,
                ms
            ].concat(args));
        }; // Convenience method to clear a timeout for a given gesture
        this.clearTimeout = function() {
            clearTimeout(_this.controller.timeouts[_this.stateKey]);
        };
        /**
     * Fires the gesture handler
     */ this.fireGestureHandler = function(forceFlag) {
            if (forceFlag === void 0) forceFlag = false;
            /**
       * If the gesture has been blocked (this can happen when the gesture has started in an unwanted direction),
       * clean everything and don't do anything.
       */ if (_this.state._blocked) {
                // we need debounced gestures to end by themselves
                if (!_this.debounced) {
                    _this.state._active = false;
                    _this.clean();
                }
                return null;
            } // If the gesture has no intentional dimension, don't fire the handler.
            if (!forceFlag && !_this.state.intentional && !_this.config.triggerAllEvents) return null;
            if (_this.state.intentional) {
                var prev_active = _this.state.active;
                var next_active = _this.state._active;
                _this.state.active = next_active;
                _this.state.first = next_active && !prev_active;
                _this.state.last = prev_active && !next_active;
                _this.controller.state.shared[_this.ingKey] = next_active; // Sets dragging, pinching, etc. to the gesture active state
            }
            var touches = _this.controller.pointerIds.size || _this.controller.touchIds.size;
            var down = _this.controller.state.shared.buttons > 0 || touches > 0;
            var state = $28b7821850e91fb9$var$_extends({}, _this.controller.state.shared, _this.state, _this.mapStateValues(_this.state), {
                locked: !!document.pointerLockElement,
                touches: touches,
                down: down
            }); // @ts-expect-error
            var newMemo = _this.handler(state); // Sets memo to the returned value of the handler (unless it's not undefined)
            _this.state.memo = newMemo !== void 0 ? newMemo : _this.state.memo;
            return state;
        };
        this.controller = controller;
        this.args = args;
    } // Returns the gesture config
    var _proto = Recognizer.prototype;
    // Convenience method to update the shared state
    _proto.updateSharedState = function updateSharedState(sharedState) {
        Object.assign(this.controller.state.shared, sharedState);
    } // Convenience method to update the gesture state
    ;
    _proto.updateGestureState = function updateGestureState(gestureState) {
        Object.assign(this.state, gestureState);
    } /**
   * Returns state properties depending on the movement and state.
   *
   * Should be overriden for custom behavior, doesn't do anything in the implementation
   * below.
   */ ;
    _proto.checkIntentionality = function checkIntentionality(_intentional, _movement) {
        return {
            _intentional: _intentional,
            _blocked: false
        };
    } /**
   * Returns basic movement properties for the gesture based on the next values and current state.
   */ ;
    _proto.getMovement = function getMovement(values) {
        var rubberband = this.config.rubberband;
        var _this$state = this.state, _bounds = _this$state._bounds, _initial = _this$state._initial, _active = _this$state._active, wasIntentional = _this$state._intentional, lastOffset = _this$state.lastOffset, prevMovement = _this$state.movement, _T = _this$state._threshold;
        var M = this.getInternalMovement(values, this.state);
        var i0 = wasIntentional[0] === false ? $28b7821850e91fb9$var$getIntentionalDisplacement(M[0], _T[0]) : wasIntentional[0];
        var i1 = wasIntentional[1] === false ? $28b7821850e91fb9$var$getIntentionalDisplacement(M[1], _T[1]) : wasIntentional[1]; // Get gesture specific state properties based on intentionality and movement.
        var intentionalityCheck = this.checkIntentionality([
            i0,
            i1
        ], M);
        if (intentionalityCheck._blocked) return $28b7821850e91fb9$var$_extends({}, intentionalityCheck, {
            _movement: M,
            delta: [
                0,
                0
            ]
        });
        var _intentional = intentionalityCheck._intentional;
        var _movement = M;
        /**
     * The movement sent to the handler has 0 in its dimensions when intentionality is false.
     * It is calculated from the actual movement minus the threshold.
     */ var movement = [
            _intentional[0] !== false ? M[0] - _intentional[0] : 0,
            _intentional[1] !== false ? M[1] - _intentional[1] : 0
        ];
        var offset = $28b7821850e91fb9$export$ca6b5e3985063434(movement, lastOffset);
        /**
     * Rubberband should be 0 when the gesture is no longer active, so that movement
     * and offset can return within their bounds.
     */ var _rubberband = _active ? rubberband : [
            0,
            0
        ];
        movement = $28b7821850e91fb9$var$computeRubberband(_bounds, $28b7821850e91fb9$export$ca6b5e3985063434(movement, _initial), _rubberband);
        return $28b7821850e91fb9$var$_extends({}, intentionalityCheck, {
            intentional: _intentional[0] !== false || _intentional[1] !== false,
            _initial: _initial,
            _movement: _movement,
            movement: movement,
            values: values,
            offset: $28b7821850e91fb9$var$computeRubberband(_bounds, offset, _rubberband),
            delta: $28b7821850e91fb9$export$e0f232dd469378a8(movement, prevMovement)
        });
    } // Cleans the gesture. Can be overriden by gestures.
    ;
    _proto.clean = function clean() {
        this.clearTimeout();
    };
    $28b7821850e91fb9$var$_createClass(Recognizer, [
        {
            key: "config",
            get: function get() {
                return this.controller.config[this.stateKey];
            } // Is the gesture enabled
        },
        {
            key: "enabled",
            get: function get() {
                return this.controller.config.enabled && this.config.enabled;
            } // Returns the controller state for a given gesture
        },
        {
            key: "state",
            get: function get() {
                return this.controller.state[this.stateKey];
            } // Returns the gesture handler
        },
        {
            key: "handler",
            get: function get() {
                return this.controller.handlers[this.stateKey];
            }
        },
        {
            key: "transform",
            get: function get() {
                return this.config.transform || this.controller.config.transform || $28b7821850e91fb9$var$identity$1;
            }
        }
    ]);
    return Recognizer;
}(); //--------------------------------------------
function $28b7821850e91fb9$var$getIntentionalDisplacement(movement, threshold) {
    if (Math.abs(movement) >= threshold) return $28b7821850e91fb9$var$sign(movement) * threshold;
    else return false;
}
function $28b7821850e91fb9$var$computeRubberband(bounds, _ref, _ref2) {
    var Vx = _ref[0], Vy = _ref[1];
    var Rx = _ref2[0], Ry = _ref2[1];
    var _bounds$ = bounds[0], X1 = _bounds$[0], X2 = _bounds$[1], _bounds$2 = bounds[1], Y1 = _bounds$2[0], Y2 = _bounds$2[1];
    return [
        $28b7821850e91fb9$export$eb62c10c9b08d9ab(Vx, X1, X2, Rx),
        $28b7821850e91fb9$export$eb62c10c9b08d9ab(Vy, Y1, Y2, Ry)
    ];
}
/**
 * Returns a generic, common payload for all gestures from an event.
 */ function $28b7821850e91fb9$var$getGenericPayload(_ref3, event, isStartEvent) {
    var state = _ref3.state;
    var timeStamp = event.timeStamp, _lastEventType = event.type;
    var previous = state.values;
    var elapsedTime = isStartEvent ? 0 : timeStamp - state.startTime;
    return {
        _lastEventType: _lastEventType,
        event: event,
        timeStamp: timeStamp,
        elapsedTime: elapsedTime,
        previous: previous
    };
}
/**
 * Returns the reinitialized start state for the gesture.
 * Should be common to all gestures.
 */ function $28b7821850e91fb9$var$getStartGestureState(_ref4, values, event, initial) {
    var state = _ref4.state, config = _ref4.config, stateKey = _ref4.stateKey, args = _ref4.args, transform = _ref4.transform;
    var offset = state.offset;
    var startTime = event.timeStamp;
    var initialFn = config.initial, bounds = config.bounds, threshold = config.threshold; // the _threshold is the difference between a [0,0] offset converted to
    // its new space coordinates
    var _threshold = $28b7821850e91fb9$export$e0f232dd469378a8(transform(threshold), transform([
        0,
        0
    ])).map(Math.abs);
    var _state = $28b7821850e91fb9$var$_extends({}, $28b7821850e91fb9$var$getInitialState()[stateKey], {
        _active: true,
        args: args,
        values: values,
        initial: initial != null ? initial : values,
        _threshold: _threshold,
        offset: offset,
        lastOffset: offset,
        startTime: startTime
    });
    return $28b7821850e91fb9$var$_extends({}, _state, {
        _initial: $28b7821850e91fb9$var$valueFn(initialFn, _state),
        _bounds: $28b7821850e91fb9$var$valueFn(bounds, _state)
    });
}
/**
 * The controller will keep track of the state for all gestures and also keep
 * track of timeouts, and window listeners.
 */ var $28b7821850e91fb9$var$Controller = function Controller(classes) {
    var _this = this;
    this.classes = classes;
    this.pointerIds = new Set(); // register Pointer Events pointerIds
    this.touchIds = new Set(); // register Touch Events identifiers
    this.supportsTouchEvents = $28b7821850e91fb9$var$supportsTouchEvents();
    this.supportsGestureEvents = $28b7821850e91fb9$var$supportsGestureEvents();
    this.bind = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var bindings = {};
        for(var _iterator = $28b7821850e91fb9$var$_createForOfIteratorHelperLoose(_this.classes), _step; !(_step = _iterator()).done;){
            var RecognizerClass = _step.value;
            new RecognizerClass(_this, args).addBindings(bindings);
        } // // we also add event bindings for native handlers
        var _loop = function _loop(eventKey) {
            $28b7821850e91fb9$var$addBindings(bindings, eventKey, function(event) {
                return _this.nativeRefs[eventKey]($28b7821850e91fb9$var$_extends({}, _this.state.shared, {
                    event: event,
                    args: args
                }));
            });
        };
        for(var eventKey in _this.nativeRefs)_loop(eventKey);
        if (_this.config.domTarget) // If config.domTarget is set we add event listeners to it and return the clean function.
        return $28b7821850e91fb9$var$updateDomListeners(_this, bindings);
        else // If not, we return an object that contains gesture handlers mapped to react handler event keys.
        return $28b7821850e91fb9$var$getPropsListener(_this, bindings);
    };
    this.effect = function() {
        if (_this.config.domTarget) _this.bind();
        return _this.clean;
    };
    /**
   * Function ran on component unmount: cleans timeouts and removes dom listeners set by the bind function.
   */ this.clean = function() {
        var domTarget = $28b7821850e91fb9$var$getDomTargetFromConfig(_this.config);
        var eventOptions = _this.config.eventOptions;
        if (domTarget) $28b7821850e91fb9$var$removeListeners(domTarget, $28b7821850e91fb9$var$takeAll(_this.domListeners), eventOptions);
        Object.values(_this.timeouts).forEach(clearTimeout);
        $28b7821850e91fb9$var$clearAllWindowListeners(_this);
    };
    this.classes = classes;
    this.state = $28b7821850e91fb9$var$getInitialState();
    this.timeouts = {};
    this.domListeners = [];
    this.windowListeners = {};
};
function $28b7821850e91fb9$var$addEventIds(controller, event) {
    if ("pointerId" in event) controller.pointerIds.add(event.pointerId);
    else controller.touchIds = new Set($28b7821850e91fb9$var$getTouchIds(event));
}
function $28b7821850e91fb9$var$removeEventIds(controller, event) {
    if ("pointerId" in event) controller.pointerIds["delete"](event.pointerId);
    else $28b7821850e91fb9$var$getTouchIds(event).forEach(function(id) {
        return controller.touchIds["delete"](id);
    });
}
function $28b7821850e91fb9$var$clearAllWindowListeners(controller) {
    var _controller$config = controller.config, el = _controller$config.window, eventOptions = _controller$config.eventOptions, windowListeners = controller.windowListeners;
    if (!el) return;
    for(var stateKey in windowListeners){
        var handlers = windowListeners[stateKey];
        $28b7821850e91fb9$var$removeListeners(el, handlers, eventOptions);
    }
    controller.windowListeners = {};
}
function $28b7821850e91fb9$var$clearWindowListeners(_ref, stateKey, options) {
    var config = _ref.config, windowListeners = _ref.windowListeners;
    if (options === void 0) options = config.eventOptions;
    if (!config.window) return;
    $28b7821850e91fb9$var$removeListeners(config.window, windowListeners[stateKey], options);
    delete windowListeners[stateKey];
}
function $28b7821850e91fb9$var$updateWindowListeners(_ref2, stateKey, listeners, options) {
    var config = _ref2.config, windowListeners = _ref2.windowListeners;
    if (listeners === void 0) listeners = [];
    if (options === void 0) options = config.eventOptions;
    if (!config.window) return;
    $28b7821850e91fb9$var$removeListeners(config.window, windowListeners[stateKey], options);
    $28b7821850e91fb9$var$addListeners(config.window, windowListeners[stateKey] = listeners, options);
}
function $28b7821850e91fb9$var$updateDomListeners(_ref3, bindings) {
    var config = _ref3.config, domListeners = _ref3.domListeners;
    var domTarget = $28b7821850e91fb9$var$getDomTargetFromConfig(config);
    if (!domTarget) throw new Error("domTarget must be defined");
    var eventOptions = config.eventOptions;
    $28b7821850e91fb9$var$removeListeners(domTarget, $28b7821850e91fb9$var$takeAll(domListeners), eventOptions);
    for(var _i = 0, _Object$entries = Object.entries(bindings); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = _Object$entries[_i], key = _Object$entries$_i[0], fns = _Object$entries$_i[1];
        var name = key.slice(2).toLowerCase();
        domListeners.push([
            name,
            $28b7821850e91fb9$var$chainFns.apply(void 0, fns)
        ]);
    }
    $28b7821850e91fb9$var$addListeners(domTarget, domListeners, eventOptions);
}
function $28b7821850e91fb9$var$getPropsListener(_ref4, bindings) {
    var config = _ref4.config;
    var props = {};
    var captureString = config.eventOptions.capture ? "Capture" : "";
    for(var _i2 = 0, _Object$entries2 = Object.entries(bindings); _i2 < _Object$entries2.length; _i2++){
        var _Object$entries2$_i = _Object$entries2[_i2], event = _Object$entries2$_i[0], fns = _Object$entries2$_i[1];
        var fnsArray = Array.isArray(fns) ? fns : [
            fns
        ];
        var key = event + captureString;
        props[key] = $28b7821850e91fb9$var$chainFns.apply(void 0, fnsArray);
    }
    return props;
}
function $28b7821850e91fb9$var$takeAll(array) {
    if (array === void 0) array = [];
    return array.splice(0, array.length);
}
function $28b7821850e91fb9$var$getDomTargetFromConfig(_ref5) {
    var domTarget = _ref5.domTarget;
    return domTarget && "current" in domTarget ? domTarget.current : domTarget;
}
/**
 * bindings is an object which keys match ReactEventHandlerKeys.
 * Since a recognizer might want to bind a handler function to an event key already used by a previously
 * added recognizer, we need to make sure that each event key is an array of all the functions mapped for
 * that key.
 */ function $28b7821850e91fb9$var$addBindings(bindings, name, fn) {
    if (!bindings[name]) bindings[name] = [];
    bindings[name].push(fn);
}
function $28b7821850e91fb9$var$addListeners(el, listeners, options) {
    if (listeners === void 0) listeners = [];
    if (options === void 0) options = {};
    for(var _iterator2 = $28b7821850e91fb9$var$_createForOfIteratorHelperLoose(listeners), _step2; !(_step2 = _iterator2()).done;){
        var _step2$value = _step2.value, eventName = _step2$value[0], eventHandler = _step2$value[1];
        el.addEventListener(eventName, eventHandler, options);
    }
}
function $28b7821850e91fb9$var$removeListeners(el, listeners, options) {
    if (listeners === void 0) listeners = [];
    if (options === void 0) options = {};
    for(var _iterator3 = $28b7821850e91fb9$var$_createForOfIteratorHelperLoose(listeners), _step3; !(_step3 = _iterator3()).done;){
        var _step3$value = _step3.value, eventName = _step3$value[0], eventHandler = _step3$value[1];
        el.removeEventListener(eventName, eventHandler, options);
    }
}
/* eslint-disable react-hooks/exhaustive-deps */ /**
 * Utility hook called by all gesture hooks and that will be responsible for the internals.
 *
 * @param handlers
 * @param classes
 * @param config
 * @param nativeHandlers - native handlers such as onClick, onMouseDown, etc.
 */ function $28b7821850e91fb9$var$useRecognizers(handlers, config, nativeHandlers) {
    if (nativeHandlers === void 0) nativeHandlers = {};
    var classes = $28b7821850e91fb9$var$resolveClasses(handlers);
    var controller = (0, (/*@__PURE__*/$parcel$interopDefault($1bdO8))).useMemo(function() {
        return new $28b7821850e91fb9$var$Controller(classes);
    }, []);
    controller.config = config;
    controller.handlers = handlers;
    controller.nativeRefs = nativeHandlers;
    (0, (/*@__PURE__*/$parcel$interopDefault($1bdO8))).useEffect(controller.effect, []); // @ts-ignore
    if (controller.config.domTarget) return $28b7821850e91fb9$var$deprecationNoticeForDomTarget; // @ts-ignore
    return controller.bind;
}
function $28b7821850e91fb9$var$deprecationNoticeForDomTarget() {}
function $28b7821850e91fb9$var$resolveClasses(internalHandlers) {
    var classes = new Set();
    if (internalHandlers.drag) classes.add($28b7821850e91fb9$var$RecognizersMap.get("drag"));
    if (internalHandlers.wheel) classes.add($28b7821850e91fb9$var$RecognizersMap.get("wheel"));
    if (internalHandlers.scroll) classes.add($28b7821850e91fb9$var$RecognizersMap.get("scroll"));
    if (internalHandlers.move) classes.add($28b7821850e91fb9$var$RecognizersMap.get("move"));
    if (internalHandlers.pinch) classes.add($28b7821850e91fb9$var$RecognizersMap.get("pinch"));
    if (internalHandlers.hover) classes.add($28b7821850e91fb9$var$RecognizersMap.get("hover"));
    return classes;
}
/**
 * @private
 * Abstract class for coordinates-based gesture recongizers
 */ var $28b7821850e91fb9$var$CoordinatesRecognizer = /*#__PURE__*/ function(_Recognizer) {
    $28b7821850e91fb9$var$_inheritsLoose(CoordinatesRecognizer, _Recognizer);
    function CoordinatesRecognizer() {
        return _Recognizer.apply(this, arguments) || this;
    }
    var _proto = CoordinatesRecognizer.prototype;
    /**
   * Returns the real movement (without taking intentionality into account)
   */ _proto.getInternalMovement = function getInternalMovement(values, state) {
        return $28b7821850e91fb9$export$e0f232dd469378a8(values, state.initial);
    } /**
   * In coordinates-based gesture, this function will detect the first intentional axis,
   * lock the gesture axis if lockDirection is specified in the config, block the gesture
   * if the first intentional axis doesn't match the specified axis in config.
   */ ;
    _proto.checkIntentionality = function checkIntentionality(_intentional, _movement) {
        if (_intentional[0] === false && _intentional[1] === false) return {
            _intentional: _intentional,
            axis: this.state.axis
        };
        var _movement$map = _movement.map(Math.abs), absX = _movement$map[0], absY = _movement$map[1];
        var axis = this.state.axis || (absX > absY ? "x" : absX < absY ? "y" : undefined);
        if (!this.config.axis && !this.config.lockDirection) return {
            _intentional: _intentional,
            _blocked: false,
            axis: axis
        };
        if (!axis) return {
            _intentional: [
                false,
                false
            ],
            _blocked: false,
            axis: axis
        };
        if (!!this.config.axis && axis !== this.config.axis) return {
            _intentional: _intentional,
            _blocked: true,
            axis: axis
        };
        _intentional[axis === "x" ? 1 : 0] = false;
        return {
            _intentional: _intentional,
            _blocked: false,
            axis: axis
        };
    };
    _proto.getKinematics = function getKinematics(values, event) {
        var state = this.getMovement(values);
        if (!state._blocked) {
            var dt = event.timeStamp - this.state.timeStamp;
            Object.assign(state, $28b7821850e91fb9$var$calculateAllKinematics(state.movement, state.delta, dt));
        }
        return state;
    };
    _proto.mapStateValues = function mapStateValues(state) {
        return {
            xy: state.values,
            vxvy: state.velocities
        };
    };
    return CoordinatesRecognizer;
}($28b7821850e91fb9$var$Recognizer);
var $28b7821850e91fb9$var$TAP_DISTANCE_THRESHOLD = 3;
function $28b7821850e91fb9$var$persistEvent(event) {
    "persist" in event && typeof event.persist === "function" && event.persist();
}
var $28b7821850e91fb9$var$DragRecognizer = /*#__PURE__*/ function(_CoordinatesRecognize) {
    $28b7821850e91fb9$var$_inheritsLoose(DragRecognizer, _CoordinatesRecognize);
    function DragRecognizer() {
        var _this;
        _this = _CoordinatesRecognize.apply(this, arguments) || this;
        _this.ingKey = "dragging";
        _this.stateKey = "drag"; // TODO add back when setPointerCapture is widely wupported
        // https://caniuse.com/#search=setPointerCapture
        _this.setPointerCapture = function(event) {
            // don't perform pointere capture when user wants to use touch events or
            // when a pointerLockElement exists as this would throw an error
            if (_this.config.useTouch || document.pointerLockElement) return;
            var target = event.target, pointerId = event.pointerId;
            if (target && "setPointerCapture" in target) // this would work in the DOM but doesn't with react three fiber
            // target.addEventListener('pointermove', this.onDragChange, this.controller.config.eventOptions)
            // @ts-expect-error
            target.setPointerCapture(pointerId);
            _this.updateGestureState({
                _dragTarget: target,
                _dragPointerId: pointerId
            });
        };
        _this.releasePointerCapture = function() {
            if (_this.config.useTouch || document.pointerLockElement) return;
            var _this$state = _this.state, _dragTarget = _this$state._dragTarget, _dragPointerId = _this$state._dragPointerId;
            if (_dragPointerId && _dragTarget && "releasePointerCapture" in _dragTarget) {
                // this would work in the DOM but doesn't with react three fiber
                // target.removeEventListener('pointermove', this.onDragChange, this.controller.config.eventOptions)
                if (!("hasPointerCapture" in _dragTarget) || _dragTarget.hasPointerCapture(_dragPointerId)) try {
                    _dragTarget.releasePointerCapture(_dragPointerId);
                } catch (e) {}
            }
        };
        _this.preventScroll = function(event) {
            if (_this.state._dragPreventScroll && event.cancelable) event.preventDefault();
        };
        _this.getEventId = function(event) {
            if (_this.config.useTouch) return event.changedTouches[0].identifier;
            return event.pointerId;
        };
        _this.isValidEvent = function(event) {
            // if we were using pointer events only event.isPrimary === 1 would suffice
            return _this.state._pointerId === _this.getEventId(event);
        };
        _this.shouldPreventWindowScrollY = _this.config.experimental_preventWindowScrollY && _this.controller.supportsTouchEvents;
        _this.setUpWindowScrollDetection = function(event) {
            $28b7821850e91fb9$var$persistEvent(event); // we add window listeners that will prevent the scroll when the user has started dragging
            $28b7821850e91fb9$var$updateWindowListeners(_this.controller, _this.stateKey, [
                [
                    "touchmove",
                    _this.preventScroll
                ],
                [
                    "touchend",
                    _this.clean.bind($28b7821850e91fb9$var$_assertThisInitialized(_this))
                ],
                [
                    "touchcancel",
                    _this.clean.bind($28b7821850e91fb9$var$_assertThisInitialized(_this))
                ]
            ], {
                passive: false
            });
            _this.setTimeout(_this.startDrag.bind($28b7821850e91fb9$var$_assertThisInitialized(_this)), 250, event);
        };
        _this.setUpDelayedDragTrigger = function(event) {
            _this.state._dragDelayed = true;
            $28b7821850e91fb9$var$persistEvent(event);
            _this.setTimeout(_this.startDrag.bind($28b7821850e91fb9$var$_assertThisInitialized(_this)), _this.config.delay, event);
        };
        _this.setStartState = function(event) {
            var values = $28b7821850e91fb9$var$getPointerEventValues(event, _this.transform);
            _this.updateSharedState($28b7821850e91fb9$var$getGenericEventData(event));
            _this.updateGestureState($28b7821850e91fb9$var$_extends({}, $28b7821850e91fb9$var$getStartGestureState($28b7821850e91fb9$var$_assertThisInitialized(_this), values, event), $28b7821850e91fb9$var$getGenericPayload($28b7821850e91fb9$var$_assertThisInitialized(_this), event, true), {
                _pointerId: _this.getEventId(event)
            }));
            _this.updateGestureState(_this.getMovement(values));
        };
        _this.onDragStart = function(event) {
            $28b7821850e91fb9$var$addEventIds(_this.controller, event);
            if (!_this.enabled || _this.state._active) return;
            _this.setStartState(event);
            _this.setPointerCapture(event);
            if (_this.shouldPreventWindowScrollY) _this.setUpWindowScrollDetection(event);
            else if (_this.config.delay > 0) _this.setUpDelayedDragTrigger(event);
            else _this.startDrag(event, true); // we pass the values to the startDrag event
        };
        _this.onDragChange = function(event) {
            if (_this.state.canceled || // if onDragStart wasn't fired or
            !_this.state._active || // if the event pointerId doesn't match the one that initiated the drag
            !_this.isValidEvent(event) || // if the event has the same timestamp as the previous event
            // note that checking type equality is ONLY for tests ¯\_(ツ)_/¯
            _this.state._lastEventType === event.type && event.timeStamp === _this.state.timeStamp) return;
            var values;
            if (document.pointerLockElement) {
                var movementX = event.movementX, movementY = event.movementY;
                values = $28b7821850e91fb9$export$ca6b5e3985063434(_this.transform([
                    movementX,
                    movementY
                ]), _this.state.values);
            } else values = $28b7821850e91fb9$var$getPointerEventValues(event, _this.transform);
            var kinematics = _this.getKinematics(values, event); // if startDrag hasn't fired
            if (!_this.state._dragStarted) {
                // If the gesture isn't active then respond to the event only if
                // it's been delayed via the `delay` option, in which case start
                // the gesture immediately.
                if (_this.state._dragDelayed) {
                    _this.startDrag(event);
                    return;
                } // if the user wants to prevent vertical window scroll when user starts dragging
                if (_this.shouldPreventWindowScrollY) {
                    if (!_this.state._dragPreventScroll && kinematics.axis) {
                        // if the user is dragging horizontally then we should allow the drag
                        if (kinematics.axis === "x") _this.startDrag(event);
                        else {
                            _this.state._active = false;
                            return;
                        }
                    } else return;
                } else return;
            }
            var genericEventData = $28b7821850e91fb9$var$getGenericEventData(event);
            _this.updateSharedState(genericEventData);
            var genericPayload = $28b7821850e91fb9$var$getGenericPayload($28b7821850e91fb9$var$_assertThisInitialized(_this), event); // This verifies if the drag can be assimilated to a tap by checking
            // if the real distance of the drag (ie not accounting for the threshold) is
            // greater than the TAP_DISTANCE_THRESHOLD.
            var realDistance = $28b7821850e91fb9$var$calculateDistance(kinematics._movement);
            var _dragIsTap = _this.state._dragIsTap;
            if (_dragIsTap && realDistance >= $28b7821850e91fb9$var$TAP_DISTANCE_THRESHOLD) _dragIsTap = false;
            _this.updateGestureState($28b7821850e91fb9$var$_extends({}, genericPayload, kinematics, {
                _dragIsTap: _dragIsTap
            }));
            _this.fireGestureHandler();
        };
        _this.onDragEnd = function(event) {
            $28b7821850e91fb9$var$removeEventIds(_this.controller, event); // if the event pointerId doesn't match the one that initiated the drag
            // we don't want to end the drag
            if (!_this.isValidEvent(event)) return;
            _this.clean(); // if the gesture is no longer active (ie canceled)
            // don't do anything
            if (!_this.state._active) return;
            _this.state._active = false;
            var tap = _this.state._dragIsTap;
            var _this$state$velocitie = _this.state.velocities, vx = _this$state$velocitie[0], vy = _this$state$velocitie[1];
            var _this$state$movement = _this.state.movement, mx = _this$state$movement[0], my = _this$state$movement[1];
            var _this$state$_intentio = _this.state._intentional, ix = _this$state$_intentio[0], iy = _this$state$_intentio[1];
            var _this$config$swipeVel = _this.config.swipeVelocity, svx = _this$config$swipeVel[0], svy = _this$config$swipeVel[1];
            var _this$config$swipeDis = _this.config.swipeDistance, sx = _this$config$swipeDis[0], sy = _this$config$swipeDis[1];
            var sd = _this.config.swipeDuration;
            var endState = $28b7821850e91fb9$var$_extends({}, $28b7821850e91fb9$var$getGenericPayload($28b7821850e91fb9$var$_assertThisInitialized(_this), event), _this.getMovement(_this.state.values));
            var swipe = [
                0,
                0
            ];
            if (endState.elapsedTime < sd) {
                if (ix !== false && Math.abs(vx) > svx && Math.abs(mx) > sx) swipe[0] = $28b7821850e91fb9$var$sign(vx);
                if (iy !== false && Math.abs(vy) > svy && Math.abs(my) > sy) swipe[1] = $28b7821850e91fb9$var$sign(vy);
            }
            _this.updateSharedState({
                buttons: 0
            });
            _this.updateGestureState($28b7821850e91fb9$var$_extends({}, endState, {
                tap: tap,
                swipe: swipe
            }));
            _this.fireGestureHandler(_this.config.filterTaps && tap === true);
        };
        _this.clean = function() {
            _CoordinatesRecognize.prototype.clean.call($28b7821850e91fb9$var$_assertThisInitialized(_this));
            _this.state._dragStarted = false;
            _this.releasePointerCapture();
            $28b7821850e91fb9$var$clearWindowListeners(_this.controller, _this.stateKey);
        };
        _this.onCancel = function() {
            if (_this.state.canceled) return;
            _this.updateGestureState({
                canceled: true,
                _active: false
            });
            _this.updateSharedState({
                buttons: 0
            });
            setTimeout(function() {
                return _this.fireGestureHandler();
            }, 0);
        };
        _this.onClick = function(event) {
            if (!_this.state._dragIsTap) event.stopPropagation();
        };
        return _this;
    }
    var _proto = DragRecognizer.prototype;
    _proto.startDrag = function startDrag(event, onDragIsStart) {
        if (onDragIsStart === void 0) onDragIsStart = false;
        // startDrag can happen after a timeout, so we need to check if the gesture is still active
        // as the user might have lift up the pointer in between.
        if (!this.state._active || // if the drag has already started we should ignore subsequent attempts
        this.state._dragStarted) return;
        if (!onDragIsStart) this.setStartState(event);
        this.updateGestureState({
            _dragStarted: true,
            _dragPreventScroll: true,
            cancel: this.onCancel
        });
        this.clearTimeout();
        this.fireGestureHandler();
    };
    _proto.addBindings = function addBindings$1(bindings) {
        if (this.config.useTouch) {
            $28b7821850e91fb9$var$addBindings(bindings, "onTouchStart", this.onDragStart);
            $28b7821850e91fb9$var$addBindings(bindings, "onTouchMove", this.onDragChange); // this is needed for react-three-fiber
            $28b7821850e91fb9$var$addBindings(bindings, "onTouchEnd", this.onDragEnd);
            $28b7821850e91fb9$var$addBindings(bindings, "onTouchCancel", this.onDragEnd);
        } else {
            $28b7821850e91fb9$var$addBindings(bindings, "onPointerDown", this.onDragStart);
            $28b7821850e91fb9$var$addBindings(bindings, "onPointerMove", this.onDragChange); // this is needed for react-three-fiber
            $28b7821850e91fb9$var$addBindings(bindings, "onPointerUp", this.onDragEnd);
            $28b7821850e91fb9$var$addBindings(bindings, "onPointerCancel", this.onDragEnd);
        }
        if (this.config.filterTaps) {
            var handler = this.controller.config.eventOptions.capture ? "onClick" : "onClickCapture";
            $28b7821850e91fb9$var$addBindings(bindings, handler, this.onClick);
        }
    };
    return DragRecognizer;
}($28b7821850e91fb9$var$CoordinatesRecognizer);
/**
 * Inlined from https://github.com/alexreardon/memoize-one
 */ function $28b7821850e91fb9$var$memoizeOne(resultFn, isEqual) {
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        for(var _len = arguments.length, newArgs = new Array(_len), _key = 0; _key < _len; _key++)newArgs[_key] = arguments[_key];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
/**
 * Taken from https://github.com/FormidableLabs/react-fast-compare
 *
 * Dropped comments and ArrayBuffer handling
 */ function $28b7821850e91fb9$var$equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$28b7821850e91fb9$var$equal(a[i], b[i])) return false;
            }
            return true;
        }
        var it;
        if (typeof Map === "function" && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done){
                if (!b.has(i.value[0])) return false;
            }
            it = a.entries();
            while(!(i = it.next()).done){
                if (!$28b7821850e91fb9$var$equal(i.value[1], b.get(i.value[0]))) return false;
            }
            return true;
        }
        if (typeof Set === "function" && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done){
                if (!b.has(i.value[0])) return false;
            }
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        }
        if (typeof Element !== "undefined" && a instanceof Element) return false;
        for(i = length; i-- !== 0;){
            if (keys[i] === "_owner" && a.$$typeof) continue;
            if (!$28b7821850e91fb9$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        return true;
    } // true if both NaN, false otherwise — NaN !== NaN → true
    // eslint-disable-next-line no-self-compare
    return a !== a && b !== b;
}
function $28b7821850e91fb9$var$isEqual(a, b) {
    try {
        return $28b7821850e91fb9$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // eslint-disable-next-line no-console
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        throw error;
    }
}
/**
 * Drag hook.
 *
 * @param handler - the function fired every time the drag gesture updates
 * @param [config={}] - the config object including generic options and drag options
 */ function $28b7821850e91fb9$export$7941f8aafa4b6021(handler, config) {
    if (config === void 0) config = {};
    $28b7821850e91fb9$var$RecognizersMap.set("drag", $28b7821850e91fb9$var$DragRecognizer);
    var buildDragConfig = (0, $1bdO8.useRef)();
    if (!buildDragConfig.current) buildDragConfig.current = $28b7821850e91fb9$var$memoizeOne($28b7821850e91fb9$var$_buildDragConfig, $28b7821850e91fb9$var$isEqual);
    return $28b7821850e91fb9$var$useRecognizers({
        drag: handler
    }, buildDragConfig.current(config));
}
/**
 * @private
 * Abstract class for distance/angle-based gesture recongizers
 */ var $28b7821850e91fb9$var$DistanceAngleRecognizer = /*#__PURE__*/ function(_Recognizer) {
    $28b7821850e91fb9$var$_inheritsLoose(DistanceAngleRecognizer, _Recognizer);
    function DistanceAngleRecognizer() {
        return _Recognizer.apply(this, arguments) || this;
    }
    var _proto = DistanceAngleRecognizer.prototype;
    _proto.getInternalMovement = function getInternalMovement(values, state) {
        var prev_a = state.values[1]; // not be defined if ctrl+wheel is used for zoom only
        var d = values[0], _values$ = values[1], a = _values$ === void 0 ? prev_a : _values$;
        var delta_a = a - prev_a;
        var next_turns = state.turns;
        if (Math.abs(delta_a) > 270) next_turns += $28b7821850e91fb9$var$sign(delta_a);
        return $28b7821850e91fb9$export$e0f232dd469378a8([
            d,
            a - 360 * next_turns
        ], state.initial);
    };
    _proto.getKinematics = function getKinematics(values, event) {
        var state = this.getMovement(values);
        var turns = (values[1] - state._movement[1] - this.state.initial[1]) / 360;
        var dt = event.timeStamp - this.state.timeStamp;
        var _calculateAllKinemati = $28b7821850e91fb9$var$calculateAllKinematics(state.movement, state.delta, dt), kinematics = $28b7821850e91fb9$var$_objectWithoutPropertiesLoose(_calculateAllKinemati, [
            "distance",
            "velocity"
        ]);
        return $28b7821850e91fb9$var$_extends({
            turns: turns
        }, state, kinematics);
    };
    _proto.mapStateValues = function mapStateValues(state) {
        return {
            da: state.values,
            vdva: state.velocities
        };
    };
    return DistanceAngleRecognizer;
}($28b7821850e91fb9$var$Recognizer);
var $28b7821850e91fb9$var$ZOOM_CONSTANT = 7;
var $28b7821850e91fb9$var$WEBKIT_DISTANCE_SCALE_FACTOR = 260;
var $28b7821850e91fb9$var$PinchRecognizer = /*#__PURE__*/ function(_DistanceAngleRecogni) {
    $28b7821850e91fb9$var$_inheritsLoose(PinchRecognizer, _DistanceAngleRecogni);
    function PinchRecognizer() {
        var _this;
        _this = _DistanceAngleRecogni.apply(this, arguments) || this;
        _this.ingKey = "pinching";
        _this.stateKey = "pinch";
        _this.onPinchStart = function(event) {
            $28b7821850e91fb9$var$addEventIds(_this.controller, event);
            var touchIds = _this.controller.touchIds;
            if (!_this.enabled) return;
            if (_this.state._active) {
                // check that the pointerIds that initiated the gesture
                // are still enabled. This is useful for when the page
                // loses track of the pointers (minifying gesture on iPad).
                if (_this.state._pointerIds.every(function(id) {
                    return touchIds.has(id);
                })) return; // something was wrong with the pointers but we let it go.
            } // until we reach two fingers on the target don't react
            if (touchIds.size < 2) return;
            var _pointerIds = Array.from(touchIds).slice(0, 2);
            var _getTwoTouchesEventVa = $28b7821850e91fb9$var$getTwoTouchesEventValues(event, _pointerIds, _this.transform), values = _getTwoTouchesEventVa.values, origin = _getTwoTouchesEventVa.origin;
            _this.updateSharedState($28b7821850e91fb9$var$getGenericEventData(event));
            _this.updateGestureState($28b7821850e91fb9$var$_extends({}, $28b7821850e91fb9$var$getStartGestureState($28b7821850e91fb9$var$_assertThisInitialized(_this), values, event), $28b7821850e91fb9$var$getGenericPayload($28b7821850e91fb9$var$_assertThisInitialized(_this), event, true), {
                _pointerIds: _pointerIds,
                cancel: _this.onCancel,
                origin: origin
            }));
            _this.updateGestureState(_this.getMovement(values));
            _this.fireGestureHandler();
        };
        _this.onPinchChange = function(event) {
            var _this$state = _this.state, canceled = _this$state.canceled, _active = _this$state._active;
            if (canceled || !_active || // if the event has the same timestamp as the previous event
            event.timeStamp === _this.state.timeStamp) return;
            var genericEventData = $28b7821850e91fb9$var$getGenericEventData(event);
            _this.updateSharedState(genericEventData);
            try {
                var _getTwoTouchesEventVa2 = $28b7821850e91fb9$var$getTwoTouchesEventValues(event, _this.state._pointerIds, _this.transform), values = _getTwoTouchesEventVa2.values, origin = _getTwoTouchesEventVa2.origin;
                var kinematics = _this.getKinematics(values, event);
                _this.updateGestureState($28b7821850e91fb9$var$_extends({}, $28b7821850e91fb9$var$getGenericPayload($28b7821850e91fb9$var$_assertThisInitialized(_this), event), kinematics, {
                    origin: origin
                }));
                _this.fireGestureHandler();
            } catch (e) {
                _this.onPinchEnd(event);
            }
        };
        _this.onPinchEnd = function(event) {
            $28b7821850e91fb9$var$removeEventIds(_this.controller, event);
            var pointerIds = $28b7821850e91fb9$var$getTouchIds(event); // if none of the lifted pointerIds is in the state pointerIds don't do anything
            if (_this.state._pointerIds.every(function(id) {
                return !pointerIds.includes(id);
            })) return;
            _this.clean();
            if (!_this.state._active) return;
            _this.updateGestureState($28b7821850e91fb9$var$_extends({}, $28b7821850e91fb9$var$getGenericPayload($28b7821850e91fb9$var$_assertThisInitialized(_this), event), _this.getMovement(_this.state.values), {
                _active: false
            }));
            _this.fireGestureHandler();
        };
        _this.onCancel = function() {
            if (_this.state.canceled) return;
            _this.updateGestureState({
                _active: false,
                canceled: true
            });
            setTimeout(function() {
                return _this.fireGestureHandler();
            }, 0);
        };
        /**
     * PINCH WITH WEBKIT GESTURES
     */ _this.onGestureStart = function(event) {
            if (!_this.enabled) return;
            event.preventDefault();
            var values = $28b7821850e91fb9$var$getWebkitGestureEventValues(event, _this.transform);
            _this.updateSharedState($28b7821850e91fb9$var$getGenericEventData(event));
            _this.updateGestureState($28b7821850e91fb9$var$_extends({}, $28b7821850e91fb9$var$getStartGestureState($28b7821850e91fb9$var$_assertThisInitialized(_this), values, event), $28b7821850e91fb9$var$getGenericPayload($28b7821850e91fb9$var$_assertThisInitialized(_this), event, true), {
                origin: [
                    event.clientX,
                    event.clientY
                ],
                cancel: _this.onCancel
            }));
            _this.updateGestureState(_this.getMovement(values));
            _this.fireGestureHandler();
        };
        _this.onGestureChange = function(event) {
            var _this$state2 = _this.state, canceled = _this$state2.canceled, _active = _this$state2._active;
            if (canceled || !_active) return;
            event.preventDefault();
            var genericEventData = $28b7821850e91fb9$var$getGenericEventData(event);
            _this.updateSharedState(genericEventData); // this normalizes the values of the Safari's WebKitEvent by calculating
            // the delta and then multiplying it by a constant.
            var values = $28b7821850e91fb9$var$getWebkitGestureEventValues(event, _this.transform);
            values[0] = (values[0] - _this.state.event.scale) * $28b7821850e91fb9$var$WEBKIT_DISTANCE_SCALE_FACTOR + _this.state.values[0];
            var kinematics = _this.getKinematics(values, event);
            _this.updateGestureState($28b7821850e91fb9$var$_extends({}, $28b7821850e91fb9$var$getGenericPayload($28b7821850e91fb9$var$_assertThisInitialized(_this), event), kinematics, {
                origin: [
                    event.clientX,
                    event.clientY
                ]
            }));
            _this.fireGestureHandler();
        };
        _this.onGestureEnd = function(event) {
            _this.clean();
            if (!_this.state._active) return;
            _this.updateGestureState($28b7821850e91fb9$var$_extends({}, $28b7821850e91fb9$var$getGenericPayload($28b7821850e91fb9$var$_assertThisInitialized(_this), event), _this.getMovement(_this.state.values), {
                _active: false,
                origin: [
                    event.clientX,
                    event.clientY
                ]
            }));
            _this.fireGestureHandler();
        };
        /**
     * PINCH WITH WHEEL
     */ _this.wheelShouldRun = function(event) {
            return _this.enabled && event.ctrlKey;
        };
        _this.getWheelValuesFromEvent = function(event) {
            var _getWheelEventValues = $28b7821850e91fb9$var$getWheelEventValues(event, _this.transform), delta_d = _getWheelEventValues[1];
            var _this$state$values = _this.state.values, prev_d = _this$state$values[0], prev_a = _this$state$values[1]; // ZOOM_CONSTANT is based on Safari trackpad natural zooming
            var _delta_d = -delta_d * $28b7821850e91fb9$var$ZOOM_CONSTANT; // new distance is the previous state distance added to the delta
            var d = prev_d + _delta_d;
            var a = prev_a !== void 0 ? prev_a : 0;
            return {
                values: [
                    d,
                    a
                ],
                origin: [
                    event.clientX,
                    event.clientY
                ],
                delta: [
                    _delta_d,
                    a
                ]
            };
        };
        _this.onWheel = function(event) {
            if (!_this.wheelShouldRun(event)) return;
            _this.setTimeout(_this.onWheelEnd);
            if (!_this.state._active) _this.onWheelStart(event);
            else _this.onWheelChange(event);
        };
        _this.onWheelStart = function(event) {
            var _this$getWheelValuesF = _this.getWheelValuesFromEvent(event), values = _this$getWheelValuesF.values, delta = _this$getWheelValuesF.delta, origin = _this$getWheelValuesF.origin;
            if (event.cancelable) event.preventDefault();
            _this.updateSharedState($28b7821850e91fb9$var$getGenericEventData(event));
            _this.updateGestureState($28b7821850e91fb9$var$_extends({}, $28b7821850e91fb9$var$getStartGestureState($28b7821850e91fb9$var$_assertThisInitialized(_this), values, event, _this.state.values), $28b7821850e91fb9$var$getGenericPayload($28b7821850e91fb9$var$_assertThisInitialized(_this), event, true), {
                offset: values,
                delta: delta,
                origin: origin
            }));
            _this.updateGestureState(_this.getMovement(values));
            _this.fireGestureHandler();
        };
        _this.onWheelChange = function(event) {
            if (event.cancelable) event.preventDefault();
            _this.updateSharedState($28b7821850e91fb9$var$getGenericEventData(event));
            var _this$getWheelValuesF2 = _this.getWheelValuesFromEvent(event), values = _this$getWheelValuesF2.values, origin = _this$getWheelValuesF2.origin, delta = _this$getWheelValuesF2.delta;
            _this.updateGestureState($28b7821850e91fb9$var$_extends({}, $28b7821850e91fb9$var$getGenericPayload($28b7821850e91fb9$var$_assertThisInitialized(_this), event), _this.getKinematics(values, event), {
                origin: origin,
                delta: delta
            }));
            _this.fireGestureHandler();
        };
        _this.onWheelEnd = function() {
            _this.clean();
            if (!_this.state._active) return;
            _this.state._active = false;
            _this.updateGestureState(_this.getMovement(_this.state.values));
            _this.fireGestureHandler();
        };
        return _this;
    }
    var _proto = PinchRecognizer.prototype;
    _proto.addBindings = function addBindings$1(bindings) {
        // Only try to use gesture events when they are supported and domTarget is set
        // as React doesn't support gesture handlers.
        if (this.controller.config.domTarget && !this.controller.supportsTouchEvents && this.controller.supportsGestureEvents) {
            $28b7821850e91fb9$var$addBindings(bindings, "onGestureStart", this.onGestureStart);
            $28b7821850e91fb9$var$addBindings(bindings, "onGestureChange", this.onGestureChange);
            $28b7821850e91fb9$var$addBindings(bindings, "onGestureEnd", this.onGestureEnd);
        } else {
            $28b7821850e91fb9$var$addBindings(bindings, "onTouchStart", this.onPinchStart);
            $28b7821850e91fb9$var$addBindings(bindings, "onTouchMove", this.onPinchChange);
            $28b7821850e91fb9$var$addBindings(bindings, "onTouchEnd", this.onPinchEnd);
            $28b7821850e91fb9$var$addBindings(bindings, "onTouchCancel", this.onPinchEnd);
            $28b7821850e91fb9$var$addBindings(bindings, "onWheel", this.onWheel);
        }
    };
    return PinchRecognizer;
}($28b7821850e91fb9$var$DistanceAngleRecognizer);
/**
 * Pinch hook.
 *
 * @param handler - the function fired every time the pinch gesture updates
 * @param [config={}] - the config object including generic options and pinch options
 */ function $28b7821850e91fb9$export$ccc26886ea7dba8f(handler, config) {
    if (config === void 0) config = {};
    $28b7821850e91fb9$var$RecognizersMap.set("pinch", $28b7821850e91fb9$var$PinchRecognizer);
    var buildPinchConfig = (0, $1bdO8.useRef)();
    if (!buildPinchConfig.current) buildPinchConfig.current = $28b7821850e91fb9$var$memoizeOne($28b7821850e91fb9$var$_buildPinchConfig, $28b7821850e91fb9$var$isEqual);
    return $28b7821850e91fb9$var$useRecognizers({
        pinch: handler
    }, buildPinchConfig.current(config));
}
var $28b7821850e91fb9$var$WheelRecognizer = /*#__PURE__*/ function(_CoordinatesRecognize) {
    $28b7821850e91fb9$var$_inheritsLoose(WheelRecognizer, _CoordinatesRecognize);
    function WheelRecognizer() {
        var _this;
        _this = _CoordinatesRecognize.apply(this, arguments) || this;
        _this.ingKey = "wheeling";
        _this.stateKey = "wheel";
        _this.debounced = true;
        _this.handleEvent = function(event) {
            if (event.ctrlKey && "pinch" in _this.controller.handlers) return;
            if (!_this.enabled) return;
            _this.setTimeout(_this.onEnd);
            _this.updateSharedState($28b7821850e91fb9$var$getGenericEventData(event));
            var values = $28b7821850e91fb9$export$ca6b5e3985063434($28b7821850e91fb9$var$getWheelEventValues(event, _this.transform), _this.state.values);
            if (!_this.state._active) {
                _this.updateGestureState($28b7821850e91fb9$var$_extends({}, $28b7821850e91fb9$var$getStartGestureState($28b7821850e91fb9$var$_assertThisInitialized(_this), values, event, _this.state.values), $28b7821850e91fb9$var$getGenericPayload($28b7821850e91fb9$var$_assertThisInitialized(_this), event, true)));
                var movement = _this.getMovement(values);
                var geometry = $28b7821850e91fb9$var$calculateAllGeometry(movement.delta);
                _this.updateGestureState(movement);
                _this.updateGestureState(geometry);
            } else _this.updateGestureState($28b7821850e91fb9$var$_extends({}, $28b7821850e91fb9$var$getGenericPayload($28b7821850e91fb9$var$_assertThisInitialized(_this), event), _this.getKinematics(values, event)));
            _this.fireGestureHandler();
        };
        _this.onEnd = function() {
            _this.clean();
            if (!_this.state._active) return;
            var movement = _this.getMovement(_this.state.values);
            _this.updateGestureState(movement);
            _this.updateGestureState({
                _active: false,
                velocities: [
                    0,
                    0
                ],
                velocity: 0
            });
            _this.fireGestureHandler();
        };
        return _this;
    }
    var _proto = WheelRecognizer.prototype;
    _proto.addBindings = function addBindings$1(bindings) {
        $28b7821850e91fb9$var$addBindings(bindings, "onWheel", this.handleEvent);
    };
    return WheelRecognizer;
}($28b7821850e91fb9$var$CoordinatesRecognizer);
/**
 * Wheel hook.
 *
 * @param handler - the function fired every time the wheel gesture updates
 * @param the config object including generic options and wheel options
 */ function $28b7821850e91fb9$export$43260e1b277d5f62(handler, config) {
    if (config === void 0) config = {};
    $28b7821850e91fb9$var$RecognizersMap.set("wheel", $28b7821850e91fb9$var$WheelRecognizer);
    var buildWheelConfig = (0, $1bdO8.useRef)();
    if (!buildWheelConfig.current) buildWheelConfig.current = $28b7821850e91fb9$var$memoizeOne($28b7821850e91fb9$var$_buildWheelConfig, $28b7821850e91fb9$var$isEqual);
    return $28b7821850e91fb9$var$useRecognizers({
        wheel: handler
    }, buildWheelConfig.current(config));
}
var $28b7821850e91fb9$var$MoveRecognizer = /*#__PURE__*/ function(_CoordinatesRecognize) {
    $28b7821850e91fb9$var$_inheritsLoose(MoveRecognizer, _CoordinatesRecognize);
    function MoveRecognizer() {
        var _this;
        _this = _CoordinatesRecognize.apply(this, arguments) || this;
        _this.ingKey = "moving";
        _this.stateKey = "move";
        _this.debounced = true;
        _this.onMove = function(event) {
            if (!_this.enabled) return;
            _this.setTimeout(_this.onMoveEnd);
            if (!_this.state._active) _this.onMoveStart(event);
            else _this.onMoveChange(event);
        };
        _this.onMoveStart = function(event) {
            _this.updateSharedState($28b7821850e91fb9$var$getGenericEventData(event));
            var values = $28b7821850e91fb9$var$getPointerEventValues(event, _this.transform);
            _this.updateGestureState($28b7821850e91fb9$var$_extends({}, $28b7821850e91fb9$var$getStartGestureState($28b7821850e91fb9$var$_assertThisInitialized(_this), values, event), $28b7821850e91fb9$var$getGenericPayload($28b7821850e91fb9$var$_assertThisInitialized(_this), event, true)));
            _this.updateGestureState(_this.getMovement(values));
            _this.fireGestureHandler();
        };
        _this.onMoveChange = function(event) {
            _this.updateSharedState($28b7821850e91fb9$var$getGenericEventData(event));
            var values = $28b7821850e91fb9$var$getPointerEventValues(event, _this.transform);
            _this.updateGestureState($28b7821850e91fb9$var$_extends({}, $28b7821850e91fb9$var$getGenericPayload($28b7821850e91fb9$var$_assertThisInitialized(_this), event), _this.getKinematics(values, event)));
            _this.fireGestureHandler();
        };
        _this.onMoveEnd = function() {
            _this.clean();
            if (!_this.state._active) return;
            var values = _this.state.values;
            _this.updateGestureState(_this.getMovement(values));
            _this.updateGestureState({
                velocities: [
                    0,
                    0
                ],
                velocity: 0,
                _active: false
            });
            _this.fireGestureHandler();
        };
        _this.hoverTransform = function() {
            return _this.controller.config.hover.transform || _this.controller.config.transform;
        };
        _this.onPointerEnter = function(event) {
            _this.controller.state.shared.hovering = true;
            if (!_this.controller.config.enabled) return;
            if (_this.controller.config.hover.enabled) {
                var values = $28b7821850e91fb9$var$getPointerEventValues(event, _this.hoverTransform());
                var state = $28b7821850e91fb9$var$_extends({}, _this.controller.state.shared, _this.state, $28b7821850e91fb9$var$getGenericPayload($28b7821850e91fb9$var$_assertThisInitialized(_this), event, true), {
                    args: _this.args,
                    values: values,
                    active: true,
                    hovering: true
                });
                _this.controller.handlers.hover($28b7821850e91fb9$var$_extends({}, state, _this.mapStateValues(state)));
            }
            if ("move" in _this.controller.handlers) _this.onMoveStart(event);
        };
        _this.onPointerLeave = function(event) {
            _this.controller.state.shared.hovering = false;
            if ("move" in _this.controller.handlers) _this.onMoveEnd();
            if (!_this.controller.config.hover.enabled) return;
            var values = $28b7821850e91fb9$var$getPointerEventValues(event, _this.hoverTransform());
            var state = $28b7821850e91fb9$var$_extends({}, _this.controller.state.shared, _this.state, $28b7821850e91fb9$var$getGenericPayload($28b7821850e91fb9$var$_assertThisInitialized(_this), event), {
                args: _this.args,
                values: values,
                active: false
            });
            _this.controller.handlers.hover($28b7821850e91fb9$var$_extends({}, state, _this.mapStateValues(state)));
        };
        return _this;
    }
    var _proto = MoveRecognizer.prototype;
    _proto.addBindings = function addBindings$1(bindings) {
        if ("move" in this.controller.handlers) $28b7821850e91fb9$var$addBindings(bindings, "onPointerMove", this.onMove);
        if ("hover" in this.controller.handlers) {
            $28b7821850e91fb9$var$addBindings(bindings, "onPointerEnter", this.onPointerEnter);
            $28b7821850e91fb9$var$addBindings(bindings, "onPointerLeave", this.onPointerLeave);
        }
    };
    return MoveRecognizer;
}($28b7821850e91fb9$var$CoordinatesRecognizer);
/**
 * Move hook.
 *
 * @param handler - the function fired every time the move gesture updates
 * @param [config={}] - the config object including generic options and move options
 */ function $28b7821850e91fb9$export$36da96379f79f245(handler, config) {
    if (config === void 0) config = {};
    $28b7821850e91fb9$var$RecognizersMap.set("move", $28b7821850e91fb9$var$MoveRecognizer);
    var buildMoveConfig = (0, $1bdO8.useRef)();
    if (!buildMoveConfig.current) buildMoveConfig.current = $28b7821850e91fb9$var$memoizeOne($28b7821850e91fb9$var$_buildMoveConfig, $28b7821850e91fb9$var$isEqual);
    return $28b7821850e91fb9$var$useRecognizers({
        move: handler
    }, buildMoveConfig.current(config));
}
/**
 * Hover hook.
 *
 * @param handler - the function fired every time the hover gesture updates
 * @param [config={}] - the config object including generic options and hover options
 */ function $28b7821850e91fb9$export$ae780daf29e6d456(handler, config) {
    if (config === void 0) config = {};
    $28b7821850e91fb9$var$RecognizersMap.set("hover", $28b7821850e91fb9$var$MoveRecognizer);
    var buildHoverConfig = (0, $1bdO8.useRef)();
    if (!buildHoverConfig.current) buildHoverConfig.current = $28b7821850e91fb9$var$memoizeOne($28b7821850e91fb9$var$_buildHoverConfig, $28b7821850e91fb9$var$isEqual);
    return $28b7821850e91fb9$var$useRecognizers({
        hover: handler
    }, buildHoverConfig.current(config));
}
var $28b7821850e91fb9$var$ScrollRecognizer = /*#__PURE__*/ function(_CoordinatesRecognize) {
    $28b7821850e91fb9$var$_inheritsLoose(ScrollRecognizer, _CoordinatesRecognize);
    function ScrollRecognizer() {
        var _this;
        _this = _CoordinatesRecognize.apply(this, arguments) || this;
        _this.ingKey = "scrolling";
        _this.stateKey = "scroll";
        _this.debounced = true;
        _this.handleEvent = function(event) {
            if (!_this.enabled) return;
            _this.clearTimeout();
            _this.setTimeout(_this.onEnd);
            var values = $28b7821850e91fb9$var$getScrollEventValues(event, _this.transform);
            _this.updateSharedState($28b7821850e91fb9$var$getGenericEventData(event));
            if (!_this.state._active) {
                _this.updateGestureState($28b7821850e91fb9$var$_extends({}, $28b7821850e91fb9$var$getStartGestureState($28b7821850e91fb9$var$_assertThisInitialized(_this), values, event, _this.state.values), $28b7821850e91fb9$var$getGenericPayload($28b7821850e91fb9$var$_assertThisInitialized(_this), event, true)));
                var movementDetection = _this.getMovement(values);
                var geometry = $28b7821850e91fb9$var$calculateAllGeometry(movementDetection.delta);
                _this.updateGestureState(movementDetection);
                _this.updateGestureState(geometry);
            } else _this.updateGestureState($28b7821850e91fb9$var$_extends({}, $28b7821850e91fb9$var$getGenericPayload($28b7821850e91fb9$var$_assertThisInitialized(_this), event), _this.getKinematics(values, event)));
            _this.fireGestureHandler();
        };
        _this.onEnd = function() {
            _this.clean();
            if (!_this.state._active) return;
            _this.updateGestureState($28b7821850e91fb9$var$_extends({}, _this.getMovement(_this.state.values), {
                _active: false,
                velocities: [
                    0,
                    0
                ],
                velocity: 0
            }));
            _this.fireGestureHandler();
        };
        return _this;
    }
    var _proto = ScrollRecognizer.prototype;
    _proto.addBindings = function addBindings$1(bindings) {
        $28b7821850e91fb9$var$addBindings(bindings, "onScroll", this.handleEvent);
    };
    return ScrollRecognizer;
}($28b7821850e91fb9$var$CoordinatesRecognizer);
/**
 * Scroll hook.
 *
 * @param handler - the function fired every time the scroll gesture updates
 * @param [config={}] - the config object including generic options and scroll options
 */ function $28b7821850e91fb9$export$d928051c8cd740b(handler, config) {
    if (config === void 0) config = {};
    $28b7821850e91fb9$var$RecognizersMap.set("scroll", $28b7821850e91fb9$var$ScrollRecognizer);
    var buildScrollConfig = (0, $1bdO8.useRef)();
    if (!buildScrollConfig.current) buildScrollConfig.current = $28b7821850e91fb9$var$memoizeOne($28b7821850e91fb9$var$_buildScrollConfig, $28b7821850e91fb9$var$isEqual);
    return $28b7821850e91fb9$var$useRecognizers({
        scroll: handler
    }, buildScrollConfig.current(config));
}
var $28b7821850e91fb9$var$RE_NOT_NATIVE = /^on(Drag|Wheel|Scroll|Move|Pinch|Hover)/;
function $28b7821850e91fb9$var$sortHandlers(handlers) {
    var _native = {};
    var handle = {};
    var actions = new Set();
    for(var key in handlers)if ($28b7821850e91fb9$var$RE_NOT_NATIVE.test(key)) {
        actions.add(RegExp.lastMatch);
        handle[key] = handlers[key];
    } else _native[key] = handlers[key];
    return [
        handle,
        _native,
        actions
    ];
}
/**
 * @public
 *
 * The most complete gesture hook, allowing support for multiple gestures.
 *
 * @param {Handlers} handlers - an object with on[Gesture] keys containg gesture handlers
 * @param {UseGestureConfig} [config={}] - the full config object
 * @returns {(...args: any[]) => HookReturnType<Config>}
 */ function $28b7821850e91fb9$export$ece84446a783717(_handlers, config) {
    if (config === void 0) config = {};
    var _sortHandlers = $28b7821850e91fb9$var$sortHandlers(_handlers), handlers = _sortHandlers[0], nativeHandlers = _sortHandlers[1], actions = _sortHandlers[2];
    $28b7821850e91fb9$var$RecognizersMap.set("drag", $28b7821850e91fb9$var$DragRecognizer);
    $28b7821850e91fb9$var$RecognizersMap.set("hover", $28b7821850e91fb9$var$MoveRecognizer);
    $28b7821850e91fb9$var$RecognizersMap.set("move", $28b7821850e91fb9$var$MoveRecognizer);
    $28b7821850e91fb9$var$RecognizersMap.set("pinch", $28b7821850e91fb9$var$PinchRecognizer);
    $28b7821850e91fb9$var$RecognizersMap.set("scroll", $28b7821850e91fb9$var$ScrollRecognizer);
    $28b7821850e91fb9$var$RecognizersMap.set("wheel", $28b7821850e91fb9$var$WheelRecognizer);
    var mergedConfig = $28b7821850e91fb9$var$buildComplexConfig(config, actions);
    var internalHandlers = {};
    if (actions.has("onDrag")) internalHandlers.drag = $28b7821850e91fb9$var$includeStartEndHandlers(handlers, "onDrag");
    if (actions.has("onWheel")) internalHandlers.wheel = $28b7821850e91fb9$var$includeStartEndHandlers(handlers, "onWheel");
    if (actions.has("onScroll")) internalHandlers.scroll = $28b7821850e91fb9$var$includeStartEndHandlers(handlers, "onScroll");
    if (actions.has("onMove")) internalHandlers.move = $28b7821850e91fb9$var$includeStartEndHandlers(handlers, "onMove");
    if (actions.has("onPinch")) internalHandlers.pinch = $28b7821850e91fb9$var$includeStartEndHandlers(handlers, "onPinch");
    if (actions.has("onHover")) internalHandlers.hover = handlers.onHover;
    return $28b7821850e91fb9$var$useRecognizers(internalHandlers, mergedConfig, nativeHandlers);
}
function $28b7821850e91fb9$var$includeStartEndHandlers(handlers, handlerKey) {
    var startKey = handlerKey + "Start";
    var endKey = handlerKey + "End";
    var fn = function fn(state) {
        var memo = undefined;
        if (state.first && startKey in handlers) handlers[startKey](state);
        if (handlerKey in handlers) memo = handlers[handlerKey](state);
        if (state.last && endKey in handlers) handlers[endKey](state);
        return memo;
    };
    return fn;
}



var $gIzLq = parcelRequire("gIzLq");
const $1b3386dc819c306f$export$5e3e0b09ca4ddc0c = (0, $gIzLq.default)((0, $89216f20f1c77281$export$2e2bcd8739ae039))(({ theme: theme  })=>({
        flexDirection: "row",
        minWidth: theme.spacing(5),
        height: theme.spacing(8),
        borderRadius: 5,
        backgroundColor: theme.palette.grey.A700,
        color: theme.palette.text.primary,
        pointerEvents: "auto",
        userSelect: "none",
        transition: theme.transitions.create([
            "color",
            "background-color",
            "border-color"
        ]),
        overflow: "hidden",
        "&:hover": {
            color: "white",
            backgroundColor: theme.palette.grey.A400
        }
    }));


function $2694ddba44b2a417$export$611ca1473634fc41({ label: label = "Slider" , value: value = 0.5 , onChange: onChange , minValue: minValue = 0 , maxValue: maxValue = 1 , renderValue: renderValue = (value)=>value.toFixed(2)  }) {
    const ref = (0, $1bdO8.useRef)(null);
    const normalized = (value - minValue) / (maxValue - minValue);
    const percent = Math.round(normalized * 100).toFixed(2);
    const renderedValue = renderValue(value);
    const handleChange = (0, $1bdO8.useCallback)((value)=>{
        const denormalized = value * (maxValue - minValue) + minValue;
        onChange?.(denormalized);
    }, [
        onChange
    ]);
    (0, $28b7821850e91fb9$export$ece84446a783717)({
        onDrag: ({ delta: delta  })=>{
            const width = ref.current?.clientWidth || 100;
            handleChange(Math.max(0, Math.min(1, normalized + delta[0] / width)));
        }
    }, {
        domTarget: ref
    });
    return /*#__PURE__*/ (0, $cVgDf.jsxs)((0, $1b3386dc819c306f$export$5e3e0b09ca4ddc0c), {
        ref: ref,
        direction: "row",
        justifyContent: "space-between",
        padding: 3,
        alignItems: "center",
        sx: (theme)=>({
                position: "relative",
                cursor: "ew-resize",
                zIndex: 0,
                "&::after": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: `${percent}%`,
                    height: "100%",
                    backgroundColor: (0, $b8tOr.alpha)(theme.palette.grey[300], 0.25),
                    transition: theme.transitions.create([
                        "background-color"
                    ]),
                    zIndex: -1
                }
            }),
        children: [
            /*#__PURE__*/ (0, $cVgDf.jsx)((0, $15020dfde881caab$export$2e2bcd8739ae039), {
                sx: {
                    pointerEvents: "none"
                },
                variant: "body2",
                children: label
            }),
            /*#__PURE__*/ (0, $cVgDf.jsx)((0, $15020dfde881caab$export$2e2bcd8739ae039), {
                sx: {
                    pointerEvents: "none"
                },
                variant: "body2",
                children: renderedValue
            })
        ]
    });
}




var $cVgDf = parcelRequire("cVgDf");

var $1bdO8 = parcelRequire("1bdO8");

var $fZ2DJ = parcelRequire("fZ2DJ");

var $63nUy = parcelRequire("63nUy");

var $1bdO8 = parcelRequire("1bdO8");


var $gJjS7 = parcelRequire("gJjS7");

var $9H0b9 = parcelRequire("9H0b9");

var $b8tOr = parcelRequire("b8tOr");

var $gIzLq = parcelRequire("gIzLq");

var $dHuM2 = parcelRequire("dHuM2");

var $1bdO8 = parcelRequire("1bdO8");
/**
 * @ignore - internal component.
 */ const $ad72f43e4861a010$var$ListContext = /*#__PURE__*/ $1bdO8.createContext({});
var $ad72f43e4861a010$export$2e2bcd8739ae039 = $ad72f43e4861a010$var$ListContext;






var $itJr1 = parcelRequire("itJr1");

var $9nXgc = parcelRequire("9nXgc");
function $8a495c96936a866f$export$46f01d01378ec5a2(slot) {
    return (0, $9nXgc.default)("MuiDivider", slot);
}
const $8a495c96936a866f$var$dividerClasses = (0, $itJr1.default)("MuiDivider", [
    "root",
    "absolute",
    "fullWidth",
    "inset",
    "middle",
    "flexItem",
    "light",
    "vertical",
    "withChildren",
    "withChildrenVertical",
    "textAlignRight",
    "textAlignLeft",
    "wrapper",
    "wrapperVertical"
]);
var $8a495c96936a866f$export$2e2bcd8739ae039 = $8a495c96936a866f$var$dividerClasses;



var $itJr1 = parcelRequire("itJr1");

var $9nXgc = parcelRequire("9nXgc");
function $ed2f324b37c17b1e$export$81478e24460c57f2(slot) {
    return (0, $9nXgc.default)("MuiListItemIcon", slot);
}
const $ed2f324b37c17b1e$var$listItemIconClasses = (0, $itJr1.default)("MuiListItemIcon", [
    "root",
    "alignItemsFlexStart"
]);
var $ed2f324b37c17b1e$export$2e2bcd8739ae039 = $ed2f324b37c17b1e$var$listItemIconClasses;



var $itJr1 = parcelRequire("itJr1");

var $9nXgc = parcelRequire("9nXgc");
function $210707d9ec7c712c$export$1061006a0db3aeb5(slot) {
    return (0, $9nXgc.default)("MuiListItemText", slot);
}
const $210707d9ec7c712c$var$listItemTextClasses = (0, $itJr1.default)("MuiListItemText", [
    "root",
    "multiline",
    "dense",
    "inset",
    "primary",
    "secondary"
]);
var $210707d9ec7c712c$export$2e2bcd8739ae039 = $210707d9ec7c712c$var$listItemTextClasses;



var $itJr1 = parcelRequire("itJr1");

var $9nXgc = parcelRequire("9nXgc");
function $05de8e286ec6a7eb$export$515f8c67b5305377(slot) {
    return (0, $9nXgc.default)("MuiMenuItem", slot);
}
const $05de8e286ec6a7eb$var$menuItemClasses = (0, $itJr1.default)("MuiMenuItem", [
    "root",
    "focusVisible",
    "dense",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $05de8e286ec6a7eb$export$2e2bcd8739ae039 = $05de8e286ec6a7eb$var$menuItemClasses;



var $cVgDf = parcelRequire("cVgDf");
const $c617ae60c4aaf526$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const $c617ae60c4aaf526$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState  } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $c617ae60c4aaf526$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled , dense: dense , divider: divider , disableGutters: disableGutters , selected: selected , classes: classes  } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            disabled && "disabled",
            !disableGutters && "gutters",
            divider && "divider",
            selected && "selected"
        ]
    };
    const composedClasses = (0, $9H0b9.default)(slots, (0, $05de8e286ec6a7eb$export$515f8c67b5305377), classes);
    return (0, $63nUy.default)({}, classes, composedClasses);
};
const $c617ae60c4aaf526$var$MenuItemRoot = (0, $gIzLq.default)((0, $22f13692c22c9568$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $gIzLq.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiMenuItem",
    slot: "Root",
    overridesResolver: $c617ae60c4aaf526$export$4334bb34c76fef24
})(({ theme: theme , ownerState: ownerState  })=>(0, $63nUy.default)({}, theme.typography.body1, {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: "border-box",
        whiteSpace: "nowrap"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, {
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $05de8e286ec6a7eb$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $b8tOr.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $05de8e286ec6a7eb$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $b8tOr.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $05de8e286ec6a7eb$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $b8tOr.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $b8tOr.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $05de8e286ec6a7eb$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $05de8e286ec6a7eb$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $8a495c96936a866f$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $8a495c96936a866f$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $210707d9ec7c712c$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $210707d9ec7c712c$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $ed2f324b37c17b1e$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up("sm")]: {
            minHeight: "auto"
        }
    }, ownerState.dense && (0, $63nUy.default)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $ed2f324b37c17b1e$export$2e2bcd8739ae039).root} svg`]: {
            fontSize: "1.25rem"
        }
    })));
const $c617ae60c4aaf526$var$MenuItem = /*#__PURE__*/ $1bdO8.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $dHuM2.default)({
        props: inProps,
        name: "MuiMenuItem"
    });
    const { autoFocus: autoFocus = false , component: component = "li" , dense: dense = false , divider: divider = false , disableGutters: disableGutters = false , focusVisibleClassName: focusVisibleClassName , role: role = "menuitem" , tabIndex: tabIndexProp , className: className  } = props, other = (0, $fZ2DJ.default)(props, $c617ae60c4aaf526$var$_excluded);
    const context = $1bdO8.useContext((0, $ad72f43e4861a010$export$2e2bcd8739ae039));
    const childContext = $1bdO8.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $1bdO8.useRef(null);
    (0, $2365c19ceb621fef$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $63nUy.default)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $c617ae60c4aaf526$var$useUtilityClasses(props);
    const handleRef = (0, $428a291d5bcff83c$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $ad72f43e4861a010$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $cVgDf.jsx)($c617ae60c4aaf526$var$MenuItemRoot, (0, $63nUy.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $gJjS7.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $gJjS7.default)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
var $c617ae60c4aaf526$export$2e2bcd8739ae039 = $c617ae60c4aaf526$var$MenuItem;


var $63nUy = parcelRequire("63nUy");

var $fZ2DJ = parcelRequire("fZ2DJ");

var $1bdO8 = parcelRequire("1bdO8");


var $gJjS7 = parcelRequire("gJjS7");

var $1nBS8 = parcelRequire("1nBS8");

var $63nUy = parcelRequire("63nUy");

var $fZ2DJ = parcelRequire("fZ2DJ");

var $7xoNL = parcelRequire("7xoNL");

var $1bdO8 = parcelRequire("1bdO8");
var $f72d504c93ceb365$exports = {};
"use strict";

$f72d504c93ceb365$exports = (parcelRequire("c1aiQ"));




var $gJjS7 = parcelRequire("gJjS7");

var $9H0b9 = parcelRequire("9H0b9");


var $82mcY = parcelRequire("82mcY");

var $63nUy = parcelRequire("63nUy");

var $fZ2DJ = parcelRequire("fZ2DJ");

var $1bdO8 = parcelRequire("1bdO8");



var $gJjS7 = parcelRequire("gJjS7");

var $9H0b9 = parcelRequire("9H0b9");


var $63nUy = parcelRequire("63nUy");

var $fZ2DJ = parcelRequire("fZ2DJ");

var $1bdO8 = parcelRequire("1bdO8");




var $fZ2DJ = parcelRequire("fZ2DJ");

var $63nUy = parcelRequire("63nUy");

var $1bdO8 = parcelRequire("1bdO8");


var $gJjS7 = parcelRequire("gJjS7");

var $9H0b9 = parcelRequire("9H0b9");

var $gIzLq = parcelRequire("gIzLq");

var $dHuM2 = parcelRequire("dHuM2");


var $itJr1 = parcelRequire("itJr1");

var $9nXgc = parcelRequire("9nXgc");
function $3bb4fee1ba71c6b7$export$c6bd6795ed6e3203(slot) {
    return (0, $9nXgc.default)("MuiList", slot);
}
const $3bb4fee1ba71c6b7$var$listClasses = (0, $itJr1.default)("MuiList", [
    "root",
    "padding",
    "dense",
    "subheader"
]);
var $3bb4fee1ba71c6b7$export$2e2bcd8739ae039 = $3bb4fee1ba71c6b7$var$listClasses;



var $cVgDf = parcelRequire("cVgDf");
const $b9c669b886ce0c85$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $b9c669b886ce0c85$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , disablePadding: disablePadding , dense: dense , subheader: subheader  } = ownerState;
    const slots = {
        root: [
            "root",
            !disablePadding && "padding",
            dense && "dense",
            subheader && "subheader"
        ]
    };
    return (0, $9H0b9.default)(slots, (0, $3bb4fee1ba71c6b7$export$c6bd6795ed6e3203), classes);
};
const $b9c669b886ce0c85$var$ListRoot = (0, $gIzLq.default)("ul", {
    name: "MuiList",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState  })=>(0, $63nUy.default)({
        listStyle: "none",
        margin: 0,
        padding: 0,
        position: "relative"
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $b9c669b886ce0c85$var$List = /*#__PURE__*/ $1bdO8.forwardRef(function List(inProps, ref) {
    const props = (0, $dHuM2.default)({
        props: inProps,
        name: "MuiList"
    });
    const { children: children , className: className , component: component = "ul" , dense: dense = false , disablePadding: disablePadding = false , subheader: subheader  } = props, other = (0, $fZ2DJ.default)(props, $b9c669b886ce0c85$var$_excluded);
    const context = $1bdO8.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $63nUy.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $b9c669b886ce0c85$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $ad72f43e4861a010$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $cVgDf.jsxs)($b9c669b886ce0c85$var$ListRoot, (0, $63nUy.default)({
            as: component,
            className: (0, $gJjS7.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $b9c669b886ce0c85$export$2e2bcd8739ae039 = $b9c669b886ce0c85$var$List;



var $71151d6e9b93359b$export$2e2bcd8739ae039 = (0, $7c6f72e8b93bb1b5$export$2e2bcd8739ae039);





var $cVgDf = parcelRequire("cVgDf");
const $e009fa7e9ab1a1fc$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $e009fa7e9ab1a1fc$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $e009fa7e9ab1a1fc$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $e009fa7e9ab1a1fc$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join("")) === 0;
}
function $e009fa7e9ab1a1fc$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || !$e009fa7e9ab1a1fc$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $e009fa7e9ab1a1fc$var$MenuList = /*#__PURE__*/ $1bdO8.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions , autoFocus: autoFocus = false , autoFocusItem: autoFocusItem = false , children: children , className: className , disabledItemsFocusable: disabledItemsFocusable = false , disableListWrap: disableListWrap = false , onKeyDown: onKeyDown , variant: variant = "selectedMenu"  } = props, other = (0, $fZ2DJ.default)(props, $e009fa7e9ab1a1fc$var$_excluded);
    const listRef = $1bdO8.useRef(null);
    const textCriteriaRef = $1bdO8.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $2365c19ceb621fef$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $1bdO8.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, theme)=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $71151d6e9b93359b$export$2e2bcd8739ae039)((0, $e9b9938f25cebc56$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[theme.direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $e9b9938f25cebc56$export$2e2bcd8739ae039)(list).activeElement;
        if (key === "ArrowDown") {
            // Prevent scroll of the page
            event.preventDefault();
            $e009fa7e9ab1a1fc$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $e009fa7e9ab1a1fc$var$nextItem);
        } else if (key === "ArrowUp") {
            event.preventDefault();
            $e009fa7e9ab1a1fc$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $e009fa7e9ab1a1fc$var$previousItem);
        } else if (key === "Home") {
            event.preventDefault();
            $e009fa7e9ab1a1fc$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $e009fa7e9ab1a1fc$var$nextItem);
        } else if (key === "End") {
            event.preventDefault();
            $e009fa7e9ab1a1fc$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $e009fa7e9ab1a1fc$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $e009fa7e9ab1a1fc$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $e009fa7e9ab1a1fc$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $e009fa7e9ab1a1fc$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $428a291d5bcff83c$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $1bdO8.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $1bdO8.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $1bdO8.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === "selectedMenu") newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $1bdO8.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $b9c669b886ce0c85$export$2e2bcd8739ae039), (0, $63nUy.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $e009fa7e9ab1a1fc$export$2e2bcd8739ae039 = $e009fa7e9ab1a1fc$var$MenuList;




var $gIzLq = parcelRequire("gIzLq");


var $dHuM2 = parcelRequire("dHuM2");

var $itJr1 = parcelRequire("itJr1");

var $9nXgc = parcelRequire("9nXgc");
function $74aa52b0e5d561bd$export$2cf86a63a84fe23d(slot) {
    return (0, $9nXgc.default)("MuiMenu", slot);
}
const $74aa52b0e5d561bd$var$menuClasses = (0, $itJr1.default)("MuiMenu", [
    "root",
    "paper",
    "list"
]);
var $74aa52b0e5d561bd$export$2e2bcd8739ae039 = $74aa52b0e5d561bd$var$menuClasses;



var $cVgDf = parcelRequire("cVgDf");
const $cbfa1ab5b812b5d9$var$_excluded = [
    "onEntering"
], $cbfa1ab5b812b5d9$var$_excluded2 = [
    "autoFocus",
    "children",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant"
];
const $cbfa1ab5b812b5d9$var$RTL_ORIGIN = {
    vertical: "top",
    horizontal: "right"
};
const $cbfa1ab5b812b5d9$var$LTR_ORIGIN = {
    vertical: "top",
    horizontal: "left"
};
const $cbfa1ab5b812b5d9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes  } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ],
        list: [
            "list"
        ]
    };
    return (0, $9H0b9.default)(slots, (0, $74aa52b0e5d561bd$export$2cf86a63a84fe23d), classes);
};
const $cbfa1ab5b812b5d9$var$MenuRoot = (0, $gIzLq.default)((0, $58c8e082952f65ad$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $gIzLq.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiMenu",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $cbfa1ab5b812b5d9$export$4f7c51a5920c9f33 = (0, $gIzLq.default)((0, $58c8e082952f65ad$export$821346c38a2d9390), {
    name: "MuiMenu",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: "calc(100% - 96px)",
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: "touch"
});
const $cbfa1ab5b812b5d9$var$MenuMenuList = (0, $gIzLq.default)((0, $e009fa7e9ab1a1fc$export$2e2bcd8739ae039), {
    name: "MuiMenu",
    slot: "List",
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $cbfa1ab5b812b5d9$var$Menu = /*#__PURE__*/ $1bdO8.forwardRef(function Menu(inProps, ref) {
    const props = (0, $dHuM2.default)({
        props: inProps,
        name: "MuiMenu"
    });
    const { autoFocus: autoFocus = true , children: children , disableAutoFocusItem: disableAutoFocusItem = false , MenuListProps: MenuListProps = {} , onClose: onClose , open: open , PaperProps: PaperProps = {} , PopoverClasses: PopoverClasses , transitionDuration: transitionDuration = "auto" , TransitionProps: { onEntering: onEntering  } = {} , variant: variant = "selectedMenu"  } = props, TransitionProps = (0, $fZ2DJ.default)(props.TransitionProps, $cbfa1ab5b812b5d9$var$_excluded), other = (0, $fZ2DJ.default)(props, $cbfa1ab5b812b5d9$var$_excluded2);
    const theme = (0, $e8c20c93268b1fae$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === "rtl";
    const ownerState = (0, $63nUy.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $cbfa1ab5b812b5d9$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $1bdO8.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === "Tab") {
            event.preventDefault();
            if (onClose) onClose(event, "tabKeyDown");
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $1bdO8.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $1bdO8.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    return /*#__PURE__*/ (0, $cVgDf.jsx)($cbfa1ab5b812b5d9$var$MenuRoot, (0, $63nUy.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: isRtl ? "right" : "left"
        },
        transformOrigin: isRtl ? $cbfa1ab5b812b5d9$var$RTL_ORIGIN : $cbfa1ab5b812b5d9$var$LTR_ORIGIN,
        slots: {
            paper: $cbfa1ab5b812b5d9$export$4f7c51a5920c9f33
        },
        slotProps: {
            paper: (0, $63nUy.default)({}, PaperProps, {
                classes: (0, $63nUy.default)({}, PaperProps.classes, {
                    root: classes.paper
                })
            })
        },
        className: classes.root,
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $63nUy.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $cVgDf.jsx)($cbfa1ab5b812b5d9$var$MenuMenuList, (0, $63nUy.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $gJjS7.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $cbfa1ab5b812b5d9$export$2e2bcd8739ae039 = $cbfa1ab5b812b5d9$var$Menu;



var $fZ2DJ = parcelRequire("fZ2DJ");

var $63nUy = parcelRequire("63nUy");

var $1bdO8 = parcelRequire("1bdO8");


var $gJjS7 = parcelRequire("gJjS7");


var $9H0b9 = parcelRequire("9H0b9");

var $82mcY = parcelRequire("82mcY");

var $itJr1 = parcelRequire("itJr1");

var $9nXgc = parcelRequire("9nXgc");
function $c5d046044b272082$export$1ee13051fd9e2ab5(slot) {
    return (0, $9nXgc.default)("MuiNativeSelect", slot);
}
const $c5d046044b272082$var$nativeSelectClasses = (0, $itJr1.default)("MuiNativeSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $c5d046044b272082$export$2e2bcd8739ae039 = $c5d046044b272082$var$nativeSelectClasses;



var $gIzLq = parcelRequire("gIzLq");

var $cVgDf = parcelRequire("cVgDf");
const $23bd8b9566e2629f$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const $23bd8b9566e2629f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , variant: variant , disabled: disabled , multiple: multiple , open: open , error: error  } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $82mcY.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ]
    };
    return (0, $9H0b9.default)(slots, (0, $c5d046044b272082$export$1ee13051fd9e2ab5), classes);
};
const $23bd8b9566e2629f$export$c1eccd1617458c87 = ({ ownerState: ownerState , theme: theme  })=>(0, $63nUy.default)({
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: "none",
        borderRadius: 0,
        // Reset
        cursor: "pointer",
        "&:focus": (0, $63nUy.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        "&::-ms-expand": {
            display: "none"
        },
        [`&.${(0, $c5d046044b272082$export$2e2bcd8739ae039).disabled}`]: {
            cursor: "default"
        },
        "&[multiple]": {
            height: "auto"
        },
        "&:not([multiple]) option, &:not([multiple]) optgroup": {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        "&&&": {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === "filled" && {
        "&&&": {
            paddingRight: 32
        }
    }, ownerState.variant === "outlined" && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        "&:focus": {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        "&&&": {
            paddingRight: 32
        }
    });
const $23bd8b9566e2629f$var$NativeSelectSelect = (0, $gIzLq.default)("select", {
    name: "MuiNativeSelect",
    slot: "Select",
    shouldForwardProp: (0, $gIzLq.rootShouldForwardProp),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $c5d046044b272082$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})($23bd8b9566e2629f$export$c1eccd1617458c87);
const $23bd8b9566e2629f$export$e7a817afd12a40d0 = ({ ownerState: ownerState , theme: theme  })=>(0, $63nUy.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: "absolute",
        right: 0,
        top: "calc(50% - .5em)",
        // Center vertically, height is 1em
        pointerEvents: "none",
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $c5d046044b272082$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: "rotate(180deg)"
    }, ownerState.variant === "filled" && {
        right: 7
    }, ownerState.variant === "outlined" && {
        right: 7
    });
const $23bd8b9566e2629f$var$NativeSelectIcon = (0, $gIzLq.default)("svg", {
    name: "MuiNativeSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $82mcY.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($23bd8b9566e2629f$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $23bd8b9566e2629f$var$NativeSelectInput = /*#__PURE__*/ $1bdO8.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className , disabled: disabled , error: error , IconComponent: IconComponent , inputRef: inputRef , variant: variant = "standard"  } = props, other = (0, $fZ2DJ.default)(props, $23bd8b9566e2629f$var$_excluded);
    const ownerState = (0, $63nUy.default)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $23bd8b9566e2629f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $cVgDf.jsxs)($1bdO8.Fragment, {
        children: [
            /*#__PURE__*/ (0, $cVgDf.jsx)($23bd8b9566e2629f$var$NativeSelectSelect, (0, $63nUy.default)({
                ownerState: ownerState,
                className: (0, $gJjS7.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $cVgDf.jsx)($23bd8b9566e2629f$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $23bd8b9566e2629f$export$2e2bcd8739ae039 = $23bd8b9566e2629f$var$NativeSelectInput;




var $gIzLq = parcelRequire("gIzLq");



var $itJr1 = parcelRequire("itJr1");

var $9nXgc = parcelRequire("9nXgc");
function $6045c696060b7c6d$export$2c0c1ee5a3392e(slot) {
    return (0, $9nXgc.default)("MuiSelect", slot);
}
const $6045c696060b7c6d$var$selectClasses = (0, $itJr1.default)("MuiSelect", [
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "focused",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $6045c696060b7c6d$export$2e2bcd8739ae039 = $6045c696060b7c6d$var$selectClasses;



var $cVgDf = parcelRequire("cVgDf");
var $5c2b39c47a53a393$var$_span;
const $5c2b39c47a53a393$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $5c2b39c47a53a393$var$SelectSelect = (0, $gIzLq.default)("div", {
    name: "MuiSelect",
    slot: "Select",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $6045c696060b7c6d$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $6045c696060b7c6d$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $6045c696060b7c6d$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $6045c696060b7c6d$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $23bd8b9566e2629f$export$c1eccd1617458c87), {
    // Win specificity over the input base
    [`&.${(0, $6045c696060b7c6d$export$2e2bcd8739ae039).select}`]: {
        height: "auto",
        // Resets for multiple select with chips
        minHeight: "1.4375em",
        // Required for select\text-field height consistency
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden"
    }
});
const $5c2b39c47a53a393$var$SelectIcon = (0, $gIzLq.default)("svg", {
    name: "MuiSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $82mcY.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $23bd8b9566e2629f$export$e7a817afd12a40d0));
const $5c2b39c47a53a393$var$SelectNativeInput = (0, $gIzLq.default)("input", {
    shouldForwardProp: (prop)=>(0, $gIzLq.slotShouldForwardProp)(prop) && prop !== "classes",
    name: "MuiSelect",
    slot: "NativeInput",
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: "absolute",
    opacity: 0,
    pointerEvents: "none",
    width: "100%",
    boxSizing: "border-box"
});
function $5c2b39c47a53a393$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $5c2b39c47a53a393$var$isEmpty(display) {
    return display == null || typeof display === "string" && !display.trim();
}
const $5c2b39c47a53a393$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , variant: variant , disabled: disabled , multiple: multiple , open: open , error: error  } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $82mcY.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ],
        nativeInput: [
            "nativeInput"
        ]
    };
    return (0, $9H0b9.default)(slots, (0, $6045c696060b7c6d$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $5c2b39c47a53a393$var$SelectInput = /*#__PURE__*/ $1bdO8.forwardRef(function SelectInput(props, ref) {
    const { "aria-describedby": ariaDescribedby , "aria-label": ariaLabel , autoFocus: autoFocus , autoWidth: autoWidth , children: children , className: className , defaultOpen: defaultOpen , defaultValue: defaultValue , disabled: disabled , displayEmpty: displayEmpty , error: error = false , IconComponent: IconComponent , inputRef: inputRefProp , labelId: labelId , MenuProps: MenuProps = {} , multiple: multiple , name: name , onBlur: onBlur , onChange: onChange , onClose: onClose , onFocus: onFocus , onOpen: onOpen , open: openProp , readOnly: readOnly , renderValue: renderValue , SelectDisplayProps: SelectDisplayProps = {} , tabIndex: tabIndexProp , value: valueProp , variant: variant = "standard"  } = props, other = (0, $fZ2DJ.default)(props, $5c2b39c47a53a393$var$_excluded);
    const [value, setValueState] = (0, $e5534e08f650a1ea$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: "Select"
    });
    const [openState, setOpenState] = (0, $e5534e08f650a1ea$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: "Select"
    });
    const inputRef = $1bdO8.useRef(null);
    const displayRef = $1bdO8.useRef(null);
    const [displayNode, setDisplayNode] = $1bdO8.useState(null);
    const { current: isOpenControlled  } = $1bdO8.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $1bdO8.useState();
    const handleRef = (0, $428a291d5bcff83c$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $1bdO8.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $1bdO8.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $1bdO8.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $1bdO8.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $1bdO8.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $e9b9938f25cebc56$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener("click", handler);
            return ()=>{
                label.removeEventListener("click", handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $1bdO8.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute("tabindex")) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, "target", {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                " ",
                "ArrowUp",
                "ArrowDown",
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                "Enter"
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, "target", {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other["aria-invalid"];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $66b4eb86f2bc6b71$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $1bdO8.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $7xoNL.default)(2));
            selected = value.some((v)=>$5c2b39c47a53a393$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $5c2b39c47a53a393$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $1bdO8.cloneElement(child, {
            "aria-selected": selected ? "true" : "false",
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === " ") // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: "option",
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            "data-value": child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(", ");
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== "undefined") tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $63nUy.default)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $5c2b39c47a53a393$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $cVgDf.jsxs)($1bdO8.Fragment, {
        children: [
            /*#__PURE__*/ (0, $cVgDf.jsx)($5c2b39c47a53a393$var$SelectSelect, (0, $63nUy.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "button",
                "aria-disabled": disabled ? "true" : undefined,
                "aria-expanded": open ? "true" : "false",
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(" ") || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $gJjS7.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $5c2b39c47a53a393$var$isEmpty(display) ? $5c2b39c47a53a393$var$_span || ($5c2b39c47a53a393$var$_span = /*#__PURE__*/ (0, $cVgDf.jsx)("span", {
                    className: "notranslate",
                    children: "​"
                })) : display
            })),
            /*#__PURE__*/ (0, $cVgDf.jsx)($5c2b39c47a53a393$var$SelectNativeInput, (0, $63nUy.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(",") : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $cVgDf.jsx)($5c2b39c47a53a393$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $cVgDf.jsx)((0, $cbfa1ab5b812b5d9$export$2e2bcd8739ae039), (0, $63nUy.default)({
                id: `menu-${name || ""}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                }
            }, MenuProps, {
                MenuListProps: (0, $63nUy.default)({
                    "aria-labelledby": labelId,
                    role: "listbox",
                    disableListWrap: true
                }, MenuProps.MenuListProps),
                PaperProps: (0, $63nUy.default)({}, MenuProps.PaperProps, {
                    style: (0, $63nUy.default)({
                        minWidth: menuMinWidth
                    }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
                }),
                children: items
            }))
        ]
    });
});
var $5c2b39c47a53a393$export$2e2bcd8739ae039 = $5c2b39c47a53a393$var$SelectInput;




parcelRequire("1bdO8");

var $6wXS5 = parcelRequire("6wXS5");

var $cVgDf = parcelRequire("cVgDf");
var $fbe62a09751524a5$export$2e2bcd8739ae039 = (0, $6wXS5.default)(/*#__PURE__*/ (0, $cVgDf.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");





var $fZ2DJ = parcelRequire("fZ2DJ");

var $63nUy = parcelRequire("63nUy");

var $1bdO8 = parcelRequire("1bdO8");

var $1nBS8 = parcelRequire("1nBS8");


var $9H0b9 = parcelRequire("9H0b9");


var $gIzLq = parcelRequire("gIzLq");

var $dHuM2 = parcelRequire("dHuM2");

var $63nUy = parcelRequire("63nUy");

var $itJr1 = parcelRequire("itJr1");

var $9nXgc = parcelRequire("9nXgc");

function $2e8f0979bf376511$export$3331e419f1a48437(slot) {
    return (0, $9nXgc.default)("MuiFilledInput", slot);
}
const $2e8f0979bf376511$var$filledInputClasses = (0, $63nUy.default)({}, (0, $3297da41a38bef44$export$2e2bcd8739ae039), (0, $itJr1.default)("MuiFilledInput", [
    "root",
    "underline",
    "input"
]));
var $2e8f0979bf376511$export$2e2bcd8739ae039 = $2e8f0979bf376511$var$filledInputClasses;




var $cVgDf = parcelRequire("cVgDf");
const $3774b562192990f1$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $3774b562192990f1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , disableUnderline: disableUnderline  } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $9H0b9.default)(slots, (0, $2e8f0979bf376511$export$3331e419f1a48437), classes);
    return (0, $63nUy.default)({}, classes, composedClasses);
};
const $3774b562192990f1$var$FilledInputRoot = (0, $gIzLq.default)((0, $c18b36e4d6a45e73$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $gIzLq.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiFilledInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            ...(0, $c18b36e4d6a45e73$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>{
    var _palette;
    const light = theme.palette.mode === "light";
    const bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    const backgroundColor = light ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)";
    const hoverBackground = light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)";
    const disabledBackground = light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
    return (0, $63nUy.default)({
        position: "relative",
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        "&:hover": {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $2e8f0979bf376511$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $2e8f0979bf376511$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        "&:after": {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || "primary"]) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $2e8f0979bf376511$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $2e8f0979bf376511$export$2e2bcd8739ae039).error}`]: {
            "&:before, &:after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&:before": {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $2e8f0979bf376511$export$2e2bcd8739ae039).disabled}, .${(0, $2e8f0979bf376511$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $2e8f0979bf376511$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $63nUy.default)({
        padding: "25px 12px 8px"
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }));
});
const $3774b562192990f1$var$FilledInputInput = (0, $gIzLq.default)((0, $c18b36e4d6a45e73$export$a1ad29c901026019), {
    name: "MuiFilledInput",
    slot: "Input",
    overridesResolver: (0, $c18b36e4d6a45e73$export$cf507b112810e72d)
})(({ theme: theme , ownerState: ownerState  })=>(0, $63nUy.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }));
const $3774b562192990f1$var$FilledInput = /*#__PURE__*/ $1bdO8.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $dHuM2.default)({
        props: inProps,
        name: "MuiFilledInput"
    });
    const { components: components = {} , componentsProps: componentsPropsProp , fullWidth: fullWidth = false , inputComponent: // declare here to prevent spreading to DOM
    inputComponent = "input" , multiline: multiline = false , slotProps: slotProps , slots: slots = {} , type: type = "text"  } = props, other = (0, $fZ2DJ.default)(props, $3774b562192990f1$var$_excluded);
    const ownerState = (0, $63nUy.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $3774b562192990f1$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $1nBS8.default)(slotProps != null ? slotProps : componentsPropsProp, filledInputComponentsProps) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $3774b562192990f1$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $3774b562192990f1$var$FilledInputInput;
    return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $c18b36e4d6a45e73$export$2e2bcd8739ae039), (0, $63nUy.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$3774b562192990f1$var$FilledInput.muiName = "Input";
var $3774b562192990f1$export$2e2bcd8739ae039 = $3774b562192990f1$var$FilledInput;



var $fZ2DJ = parcelRequire("fZ2DJ");

var $63nUy = parcelRequire("63nUy");

var $1bdO8 = parcelRequire("1bdO8");



var $9H0b9 = parcelRequire("9H0b9");

var $fZ2DJ = parcelRequire("fZ2DJ");

var $63nUy = parcelRequire("63nUy");
parcelRequire("1bdO8");


var $gIzLq = parcelRequire("gIzLq");

var $cVgDf = parcelRequire("cVgDf");
var $191b7eda4dbd21b9$var$_span;
const $191b7eda4dbd21b9$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $191b7eda4dbd21b9$var$NotchedOutlineRoot = (0, $gIzLq.default)("fieldset")({
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%"
});
const $191b7eda4dbd21b9$var$NotchedOutlineLegend = (0, $gIzLq.default)("legend")(({ ownerState: ownerState , theme: theme  })=>(0, $63nUy.default)({
        float: "unset",
        // Fix conflict with bootstrap
        width: "auto",
        // Fix conflict with bootstrap
        overflow: "hidden"
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: "11px",
        // sync with `height` in `legend` styles
        transition: theme.transitions.create("width", {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $63nUy.default)({
        display: "block",
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: "0.75em",
        visibility: "hidden",
        maxWidth: 0.01,
        transition: theme.transitions.create("max-width", {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: "nowrap",
        "& > span": {
            paddingLeft: 5,
            paddingRight: 5,
            display: "inline-block",
            opacity: 0,
            visibility: "visible"
        }
    }, ownerState.notched && {
        maxWidth: "100%",
        transition: theme.transitions.create("max-width", {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $191b7eda4dbd21b9$export$2e2bcd8739ae039(props) {
    const { className: className , label: label , notched: notched  } = props, other = (0, $fZ2DJ.default)(props, $191b7eda4dbd21b9$var$_excluded);
    const withLabel = label != null && label !== "";
    const ownerState = (0, $63nUy.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $cVgDf.jsx)($191b7eda4dbd21b9$var$NotchedOutlineRoot, (0, $63nUy.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $cVgDf.jsx)($191b7eda4dbd21b9$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $cVgDf.jsx)("span", {
                children: label
            }) : $191b7eda4dbd21b9$var$_span || ($191b7eda4dbd21b9$var$_span = /*#__PURE__*/ (0, $cVgDf.jsx)("span", {
                className: "notranslate",
                children: "​"
            }))
        })
    }));
}





var $gIzLq = parcelRequire("gIzLq");

var $63nUy = parcelRequire("63nUy");

var $itJr1 = parcelRequire("itJr1");

var $9nXgc = parcelRequire("9nXgc");

function $7f85f4c0320ab3cc$export$89922944c7227687(slot) {
    return (0, $9nXgc.default)("MuiOutlinedInput", slot);
}
const $7f85f4c0320ab3cc$var$outlinedInputClasses = (0, $63nUy.default)({}, (0, $3297da41a38bef44$export$2e2bcd8739ae039), (0, $itJr1.default)("MuiOutlinedInput", [
    "root",
    "notchedOutline",
    "input"
]));
var $7f85f4c0320ab3cc$export$2e2bcd8739ae039 = $7f85f4c0320ab3cc$var$outlinedInputClasses;




var $dHuM2 = parcelRequire("dHuM2");

var $cVgDf = parcelRequire("cVgDf");
const $7d80e80487ec59ea$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $7d80e80487ec59ea$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes  } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        notchedOutline: [
            "notchedOutline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $9H0b9.default)(slots, (0, $7f85f4c0320ab3cc$export$89922944c7227687), classes);
    return (0, $63nUy.default)({}, classes, composedClasses);
};
const $7d80e80487ec59ea$var$OutlinedInputRoot = (0, $gIzLq.default)((0, $c18b36e4d6a45e73$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $gIzLq.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiOutlinedInput",
    slot: "Root",
    overridesResolver: (0, $c18b36e4d6a45e73$export$965edad20a84fa75)
})(({ theme: theme , ownerState: ownerState  })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return (0, $63nUy.default)({
        position: "relative",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $7f85f4c0320ab3cc$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
            [`&:hover .${(0, $7f85f4c0320ab3cc$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $7f85f4c0320ab3cc$export$2e2bcd8739ae039).focused} .${(0, $7f85f4c0320ab3cc$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $7f85f4c0320ab3cc$export$2e2bcd8739ae039).error} .${(0, $7f85f4c0320ab3cc$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $7f85f4c0320ab3cc$export$2e2bcd8739ae039).disabled} .${(0, $7f85f4c0320ab3cc$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $63nUy.default)({
        padding: "16.5px 14px"
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }));
});
const $7d80e80487ec59ea$var$NotchedOutlineRoot = (0, $gIzLq.default)((0, $191b7eda4dbd21b9$export$2e2bcd8739ae039), {
    name: "MuiOutlinedInput",
    slot: "NotchedOutline",
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme  })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $7d80e80487ec59ea$var$OutlinedInputInput = (0, $gIzLq.default)((0, $c18b36e4d6a45e73$export$a1ad29c901026019), {
    name: "MuiOutlinedInput",
    slot: "Input",
    overridesResolver: (0, $c18b36e4d6a45e73$export$cf507b112810e72d)
})(({ theme: theme , ownerState: ownerState  })=>(0, $63nUy.default)({
        padding: "16.5px 14px"
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $7d80e80487ec59ea$var$OutlinedInput = /*#__PURE__*/ $1bdO8.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $dHuM2.default)({
        props: inProps,
        name: "MuiOutlinedInput"
    });
    const { components: components = {} , fullWidth: fullWidth = false , inputComponent: inputComponent = "input" , label: label , multiline: multiline = false , notched: notched , slots: slots = {} , type: type = "text"  } = props, other = (0, $fZ2DJ.default)(props, $7d80e80487ec59ea$var$_excluded);
    const classes = $7d80e80487ec59ea$var$useUtilityClasses(props);
    const muiFormControl = (0, $7f8ac8bbee0785d9$export$2e2bcd8739ae039)();
    const fcs = (0, $65770948511e4963$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "required"
        ]
    });
    const ownerState = (0, $63nUy.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $7d80e80487ec59ea$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $7d80e80487ec59ea$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $c18b36e4d6a45e73$export$2e2bcd8739ae039), (0, $63nUy.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $cVgDf.jsx)($7d80e80487ec59ea$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== "" && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $cVgDf.jsxs)($1bdO8.Fragment, {
                    children: [
                        label,
                        " ",
                        "*"
                    ]
                })) : label,
                notched: typeof notched !== "undefined" ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $63nUy.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$7d80e80487ec59ea$var$OutlinedInput.muiName = "Input";
var $7d80e80487ec59ea$export$2e2bcd8739ae039 = $7d80e80487ec59ea$var$OutlinedInput;



var $dHuM2 = parcelRequire("dHuM2");


var $gIzLq = parcelRequire("gIzLq");

var $cVgDf = parcelRequire("cVgDf");
const $826eef3f2dd24ff3$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
];
const $826eef3f2dd24ff3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes  } = ownerState;
    return classes;
};
const $826eef3f2dd24ff3$var$styledRootConfig = {
    name: "MuiSelect",
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $gIzLq.rootShouldForwardProp)(prop) && prop !== "variant",
    slot: "Root"
};
const $826eef3f2dd24ff3$var$StyledInput = (0, $gIzLq.default)((0, $2fa28f938382aaac$export$2e2bcd8739ae039), $826eef3f2dd24ff3$var$styledRootConfig)("");
const $826eef3f2dd24ff3$var$StyledOutlinedInput = (0, $gIzLq.default)((0, $7d80e80487ec59ea$export$2e2bcd8739ae039), $826eef3f2dd24ff3$var$styledRootConfig)("");
const $826eef3f2dd24ff3$var$StyledFilledInput = (0, $gIzLq.default)((0, $3774b562192990f1$export$2e2bcd8739ae039), $826eef3f2dd24ff3$var$styledRootConfig)("");
const $826eef3f2dd24ff3$var$Select = /*#__PURE__*/ $1bdO8.forwardRef(function Select(inProps, ref) {
    const props = (0, $dHuM2.default)({
        name: "MuiSelect",
        props: inProps
    });
    const { autoWidth: autoWidth = false , children: children , classes: classesProp = {} , className: className , defaultOpen: defaultOpen = false , displayEmpty: displayEmpty = false , IconComponent: IconComponent = (0, $fbe62a09751524a5$export$2e2bcd8739ae039) , id: id , input: input , inputProps: inputProps , label: label , labelId: labelId , MenuProps: MenuProps , multiple: multiple = false , native: native = false , onClose: onClose , onOpen: onOpen , open: open , renderValue: renderValue , SelectDisplayProps: SelectDisplayProps , variant: variantProp = "outlined"  } = props, other = (0, $fZ2DJ.default)(props, $826eef3f2dd24ff3$var$_excluded);
    const inputComponent = native ? (0, $23bd8b9566e2629f$export$2e2bcd8739ae039) : (0, $5c2b39c47a53a393$export$2e2bcd8739ae039);
    const muiFormControl = (0, $7f8ac8bbee0785d9$export$2e2bcd8739ae039)();
    const fcs = (0, $65770948511e4963$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "error"
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $63nUy.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $826eef3f2dd24ff3$var$useUtilityClasses(ownerState);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $cVgDf.jsx)($826eef3f2dd24ff3$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $cVgDf.jsx)($826eef3f2dd24ff3$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $cVgDf.jsx)($826eef3f2dd24ff3$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $428a291d5bcff83c$export$2e2bcd8739ae039)(ref, InputComponent.ref);
    return /*#__PURE__*/ (0, $cVgDf.jsx)($1bdO8.Fragment, {
        children: /*#__PURE__*/ $1bdO8.cloneElement(InputComponent, (0, $63nUy.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $63nUy.default)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $63nUy.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $1nBS8.default)(classes, inputProps.classes) : classes
            }, input ? input.props.inputProps : {})
        }, multiple && native && variant === "outlined" ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $gJjS7.default)(InputComponent.props.className, className)
        }, !input && {
            variant: variant
        }, other))
    });
});
$826eef3f2dd24ff3$var$Select.muiName = "Select";
var $826eef3f2dd24ff3$export$2e2bcd8739ae039 = $826eef3f2dd24ff3$var$Select;



function $5c0ff068e85464ac$export$d55b50a564d0b931({ label: label = "Select" , value: value , options: options , onHover: onHover , onChange: onChange , renderValue: renderValue = (value)=>String(value)  }) {
    const ref = (0, $1bdO8.useRef)(null);
    const index = (0, $1bdO8.useMemo)(()=>options.indexOf(value), [
        options,
        value
    ]);
    const handleChange = (0, $1bdO8.useCallback)((index)=>{
        onChange?.(options[index]);
    }, [
        options,
        onChange
    ]);
    const renderedOptions = (0, $1bdO8.useMemo)(()=>options.map(renderValue), [
        renderValue,
        options
    ]);
    return /*#__PURE__*/ (0, $cVgDf.jsxs)((0, $1b3386dc819c306f$export$5e3e0b09ca4ddc0c), {
        ref: ref,
        direction: "row",
        justifyContent: "space-between",
        paddingLeft: 3,
        paddingRight: 0,
        gap: 1,
        alignItems: "center",
        sx: (theme)=>({
                position: "relative",
                cursor: "pointer"
            }),
        children: [
            /*#__PURE__*/ (0, $cVgDf.jsx)((0, $15020dfde881caab$export$2e2bcd8739ae039), {
                variant: "body2",
                children: label
            }),
            /*#__PURE__*/ (0, $cVgDf.jsx)((0, $826eef3f2dd24ff3$export$2e2bcd8739ae039), {
                label: label,
                value: index,
                onChange: (e)=>handleChange(e.target.value),
                MenuProps: {
                    elevation: 6,
                    sx: (theme)=>({
                            "& .MuiPaper-root": {
                                marginTop: theme.spacing(3),
                                borderRadius: "5px"
                            }
                        })
                },
                sx: (theme)=>({
                        textAlign: "right",
                        flexGrow: 1,
                        borderRadius: 0,
                        "& fieldset": {
                            display: "none"
                        },
                        "& .MuiSelect-select": {
                            padding: 0,
                            margin: 0,
                            border: 0,
                            fontSize: theme.typography.body2.fontSize,
                            textAlign: "right"
                        }
                    }),
                children: renderedOptions.map((option, index)=>/*#__PURE__*/ (0, $cVgDf.jsx)((0, $c617ae60c4aaf526$export$2e2bcd8739ae039), {
                        value: index,
                        disableRipple: true,
                        onPointerEnter: ()=>onHover?.(options[index]),
                        children: option
                    }, index))
            })
        ]
    });
}


function $e3746ee07c5f58c4$var$PaletteControl() {
    const settings = (0, $ff1962c46896fdbd$export$772cdd5f573abcc9)();
    return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $5c0ff068e85464ac$export$d55b50a564d0b931), {
        label: "Palette",
        options: (0, $4f0c4c686d4b1bad$export$2e2bcd8739ae039),
        renderValue: (value)=>value.name,
        value: settings.colorPalette,
        onChange: settings.setColorPalette
    });
}
function $e3746ee07c5f58c4$var$ColorAttributeControl() {
    const { colorAttribute: colorAttribute , setColorAttribute: setColorAttribute , dataset: dataset  } = (0, $a2bde23ea9c8df05$export$26531d8e255edf16)();
    const attributeNames = (0, $1bdO8.useMemo)(()=>{
        const datasetAttributes = dataset?.attributes.filter((a)=>a.type === "number" || a.type === "category").map((a)=>a.name);
        return [
            "None",
            ...datasetAttributes ?? []
        ];
    }, [
        dataset
    ]);
    if (!dataset) return null;
    return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $5c0ff068e85464ac$export$d55b50a564d0b931), {
        label: "Color by",
        options: attributeNames,
        value: colorAttribute ?? "None",
        onChange: setColorAttribute
    });
}
function $e3746ee07c5f58c4$var$ColorLegendControl() {
    const settings = (0, $ff1962c46896fdbd$export$772cdd5f573abcc9)();
    return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $5c0ff068e85464ac$export$d55b50a564d0b931), {
        label: "Legend",
        options: [
            true,
            false
        ],
        renderValue: (value)=>value ? "Show" : "Hide",
        value: settings.showColorLegend,
        onChange: settings.setShowColorLegend
    });
}
function $e3746ee07c5f58c4$var$PointSizeControl() {
    const settings = (0, $ff1962c46896fdbd$export$772cdd5f573abcc9)();
    return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $2694ddba44b2a417$export$611ca1473634fc41), {
        label: "Point size",
        minValue: 2,
        maxValue: 30,
        value: settings.pointSize,
        onChange: settings.setPointSize
    });
}
function $e3746ee07c5f58c4$export$fef7159a5e479b3c() {
    return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $2153fffbfe539b10$export$15fdf8ef180193c1), {
        icon: /*#__PURE__*/ (0, $cVgDf.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d5f52d1ef7aeb1d3$exports))), {}),
        children: /*#__PURE__*/ (0, $cVgDf.jsxs)((0, $89216f20f1c77281$export$2e2bcd8739ae039), {
            padding: 3,
            spacing: 1.5,
            children: [
                /*#__PURE__*/ (0, $cVgDf.jsx)((0, $15020dfde881caab$export$2e2bcd8739ae039), {
                    align: "center",
                    padding: 1,
                    children: "Settings"
                }),
                /*#__PURE__*/ (0, $cVgDf.jsx)($e3746ee07c5f58c4$var$PointSizeControl, {}),
                /*#__PURE__*/ (0, $cVgDf.jsx)($e3746ee07c5f58c4$var$PaletteControl, {}),
                /*#__PURE__*/ (0, $cVgDf.jsx)($e3746ee07c5f58c4$var$ColorAttributeControl, {}),
                /*#__PURE__*/ (0, $cVgDf.jsx)($e3746ee07c5f58c4$var$ColorLegendControl, {})
            ]
        })
    });
}



function $5aa745bb8eb38f23$export$79e7fa0d90158cbb({ name: name , title: title , hotkey: hotkey , children: children  }) {
    const { currentTool: currentTool , setTool: setTool , tools: tools  } = (0, $18138c912bf4d9fe$export$f735d6cbbb187197)();
    const selected = currentTool === name;
    (0, $3a2c5c12e4f579f2$export$b0ebbe7904d8d94a)(hotkey, ()=>setTool(name));
    if (!tools.includes(name)) return null;
    return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $b679af97cafc2a91$export$2e2bcd8739ae039), {
        title: title,
        arrow: true,
        children: /*#__PURE__*/ (0, $cVgDf.jsx)("div", {
            children: /*#__PURE__*/ (0, $cVgDf.jsx)((0, $d25467bba40385ca$export$b8914901871fbdb1), {
                selected: selected,
                onClick: ()=>setTool(name),
                children: children
            })
        })
    });
}
function $5aa745bb8eb38f23$export$4c260019440d418f() {
    return /*#__PURE__*/ (0, $cVgDf.jsxs)((0, $89216f20f1c77281$export$2e2bcd8739ae039), {
        width: "100%",
        direction: "row",
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ (0, $cVgDf.jsxs)((0, $89216f20f1c77281$export$2e2bcd8739ae039), {
                direction: "row",
                spacing: 1.5,
                minHeight: 60,
                children: [
                    /*#__PURE__*/ (0, $cVgDf.jsx)($5aa745bb8eb38f23$export$79e7fa0d90158cbb, {
                        name: "pointer",
                        title: "Pointer tool (p)",
                        hotkey: "p",
                        children: /*#__PURE__*/ (0, $cVgDf.jsx)((0, $kVGEJ.default), {
                            inheritViewBox: true,
                            component: (0, $3e964efadd575610$export$2e2bcd8739ae039)
                        })
                    }),
                    /*#__PURE__*/ (0, $cVgDf.jsx)($5aa745bb8eb38f23$export$79e7fa0d90158cbb, {
                        name: "lasso",
                        title: "Lasso tool (l)",
                        hotkey: "l",
                        children: /*#__PURE__*/ (0, $cVgDf.jsx)((0, $kVGEJ.default), {
                            inheritViewBox: true,
                            component: (0, $69643b1078eb0975$export$2e2bcd8739ae039)
                        })
                    }),
                    /*#__PURE__*/ (0, $cVgDf.jsx)((0, $852d884f595b377a$export$c5f53436d402a3d0), {})
                ]
            }),
            /*#__PURE__*/ (0, $cVgDf.jsx)((0, $89216f20f1c77281$export$2e2bcd8739ae039), {
                direction: "row",
                spacing: 1.5,
                minHeight: 60,
                children: /*#__PURE__*/ (0, $cVgDf.jsx)((0, $e3746ee07c5f58c4$export$fef7159a5e479b3c), {})
            })
        ]
    });
}



var $cVgDf = parcelRequire("cVgDf");

var $1bdO8 = parcelRequire("1bdO8");

var $cVgDf = parcelRequire("cVgDf");
parcelRequire("1bdO8");

var $fZ2DJ = parcelRequire("fZ2DJ");

var $63nUy = parcelRequire("63nUy");

var $1bdO8 = parcelRequire("1bdO8");


var $9H0b9 = parcelRequire("9H0b9");

var $1bdO8 = parcelRequire("1bdO8");



var $cVgDf = parcelRequire("cVgDf");
function $2b5f6fab558306a0$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $2b5f6fab558306a0$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://mui.com/base/react-click-away-listener/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/base/react-click-away-listener/components-api/#click-away-listener)
 */ function $2b5f6fab558306a0$var$ClickAwayListener(props) {
    const { children: children , disableReactTree: disableReactTree = false , mouseEvent: mouseEvent = "onClick" , onClickAway: onClickAway , touchEvent: touchEvent = "onTouchEnd"  } = props;
    const movedRef = $1bdO8.useRef(false);
    const nodeRef = $1bdO8.useRef(null);
    const activatedRef = $1bdO8.useRef(false);
    const syntheticEventRef = $1bdO8.useRef(false);
    $1bdO8.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, $dd3d0833de97326d$export$2e2bcd8739ae039)(// @ts-expect-error TODO upstream fix
    children.ref, nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $f10d5b4622f4a02e$export$2e2bcd8739ae039)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $274f1134d02f9864$export$2e2bcd8739ae039)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || "clientX" in event && $2b5f6fab558306a0$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target) || nodeRef.current.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $1bdO8.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = $2b5f6fab558306a0$var$mapEventPropToEvent(touchEvent);
            const doc = (0, $274f1134d02f9864$export$2e2bcd8739ae039)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener("touchmove", handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener("touchmove", handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $1bdO8.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = $2b5f6fab558306a0$var$mapEventPropToEvent(mouseEvent);
            const doc = (0, $274f1134d02f9864$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ (0, $cVgDf.jsx)($1bdO8.Fragment, {
        children: /*#__PURE__*/ $1bdO8.cloneElement(children, childrenProps)
    });
}
var $2b5f6fab558306a0$export$2e2bcd8739ae039 = $2b5f6fab558306a0$var$ClickAwayListener;



var $63nUy = parcelRequire("63nUy");

var $1bdO8 = parcelRequire("1bdO8");


function $8b83510b8fb5d041$export$2e2bcd8739ae039(parameters) {
    const { autoHideDuration: autoHideDuration = null , disableWindowBlurListener: disableWindowBlurListener = false , onClose: onClose , open: open , resumeHideDuration: resumeHideDuration  } = parameters;
    const timerAutoHide = $1bdO8.useRef();
    $1bdO8.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (!nativeEvent.defaultPrevented) // IE11, Edge (prior to using Blink?) use 'Esc'
            {
                if (nativeEvent.key === "Escape" || nativeEvent.key === "Esc") // not calling `preventDefault` since we don't know if people may ignore this event e.g. a permanently open snackbar
                onClose == null || onClose(nativeEvent, "escapeKeyDown");
            }
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        open,
        onClose
    ]);
    const handleClose = (0, $f10d5b4622f4a02e$export$2e2bcd8739ae039)((event, reason)=>{
        onClose == null || onClose(event, reason);
    });
    const setAutoHideTimer = (0, $f10d5b4622f4a02e$export$2e2bcd8739ae039)((autoHideDurationParam)=>{
        if (!onClose || autoHideDurationParam == null) return;
        clearTimeout(timerAutoHide.current);
        timerAutoHide.current = setTimeout(()=>{
            handleClose(null, "timeout");
        }, autoHideDurationParam);
    });
    $1bdO8.useEffect(()=>{
        if (open) setAutoHideTimer(autoHideDuration);
        return ()=>{
            clearTimeout(timerAutoHide.current);
        };
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer
    ]);
    const handleClickAway = (event)=>{
        onClose == null || onClose(event, "clickaway");
    };
    // Pause the timer when the user is interacting with the Snackbar
    // or when the user hide the window.
    const handlePause = ()=>{
        clearTimeout(timerAutoHide.current);
    };
    // Restart the timer when the user is no longer interacting with the Snackbar
    // or when the window is shown back.
    const handleResume = $1bdO8.useCallback(()=>{
        if (autoHideDuration != null) setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        resumeHideDuration,
        setAutoHideTimer
    ]);
    const createHandleBlur = (otherHandlers)=>(event)=>{
            const onBlurCallback = otherHandlers.onBlur;
            onBlurCallback == null || onBlurCallback(event);
            handleResume();
        };
    const createHandleFocus = (otherHandlers)=>(event)=>{
            const onFocusCallback = otherHandlers.onFocus;
            onFocusCallback == null || onFocusCallback(event);
            handlePause();
        };
    const createMouseEnter = (otherHandlers)=>(event)=>{
            const onMouseEnterCallback = otherHandlers.onMouseEnter;
            onMouseEnterCallback == null || onMouseEnterCallback(event);
            handlePause();
        };
    const createMouseLeave = (otherHandlers)=>(event)=>{
            const onMouseLeaveCallback = otherHandlers.onMouseLeave;
            onMouseLeaveCallback == null || onMouseLeaveCallback(event);
            handleResume();
        };
    $1bdO8.useEffect(()=>{
        // TODO: window global should be refactored here
        if (!disableWindowBlurListener && open) {
            window.addEventListener("focus", handleResume);
            window.addEventListener("blur", handlePause);
            return ()=>{
                window.removeEventListener("focus", handleResume);
                window.removeEventListener("blur", handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        handleResume,
        open
    ]);
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $f079698d98ef2187$export$2e2bcd8739ae039)(parameters);
        const externalEventHandlers = (0, $63nUy.default)({}, propsEventHandlers, otherHandlers);
        return (0, $63nUy.default)({
            // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
            // See https://github.com/mui/material-ui/issues/29080
            role: "presentation"
        }, externalEventHandlers, {
            onBlur: createHandleBlur(externalEventHandlers),
            onFocus: createHandleFocus(externalEventHandlers),
            onMouseEnter: createMouseEnter(externalEventHandlers),
            onMouseLeave: createMouseLeave(externalEventHandlers)
        });
    };
    return {
        getRootProps: getRootProps,
        onClickAway: handleClickAway
    };
}



var $gIzLq = parcelRequire("gIzLq");


var $dHuM2 = parcelRequire("dHuM2");

var $82mcY = parcelRequire("82mcY");


var $fZ2DJ = parcelRequire("fZ2DJ");

var $63nUy = parcelRequire("63nUy");

var $1bdO8 = parcelRequire("1bdO8");


var $gJjS7 = parcelRequire("gJjS7");

var $9H0b9 = parcelRequire("9H0b9");

var $b8tOr = parcelRequire("b8tOr");

var $gIzLq = parcelRequire("gIzLq");

var $dHuM2 = parcelRequire("dHuM2");


var $itJr1 = parcelRequire("itJr1");

var $9nXgc = parcelRequire("9nXgc");
function $6eb1fe4d2b770cc5$export$def81488db1a3216(slot) {
    return (0, $9nXgc.default)("MuiSnackbarContent", slot);
}
const $6eb1fe4d2b770cc5$var$snackbarContentClasses = (0, $itJr1.default)("MuiSnackbarContent", [
    "root",
    "message",
    "action"
]);
var $6eb1fe4d2b770cc5$export$2e2bcd8739ae039 = $6eb1fe4d2b770cc5$var$snackbarContentClasses;



var $cVgDf = parcelRequire("cVgDf");
const $b19a2e5dbb4fa005$var$_excluded = [
    "action",
    "className",
    "message",
    "role"
];
const $b19a2e5dbb4fa005$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes  } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        action: [
            "action"
        ],
        message: [
            "message"
        ]
    };
    return (0, $9H0b9.default)(slots, (0, $6eb1fe4d2b770cc5$export$def81488db1a3216), classes);
};
const $b19a2e5dbb4fa005$var$SnackbarContentRoot = (0, $gIzLq.default)((0, $39353411c1daa853$export$2e2bcd8739ae039), {
    name: "MuiSnackbarContent",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme  })=>{
    const emphasis = theme.palette.mode === "light" ? 0.8 : 0.98;
    const backgroundColor = (0, $b8tOr.emphasize)(theme.palette.background.default, emphasis);
    return (0, $63nUy.default)({}, theme.typography.body2, {
        color: theme.vars ? theme.vars.palette.SnackbarContent.color : theme.palette.getContrastText(backgroundColor),
        backgroundColor: theme.vars ? theme.vars.palette.SnackbarContent.bg : backgroundColor,
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        flexGrow: 1,
        [theme.breakpoints.up("sm")]: {
            flexGrow: "initial",
            minWidth: 288
        }
    });
});
const $b19a2e5dbb4fa005$var$SnackbarContentMessage = (0, $gIzLq.default)("div", {
    name: "MuiSnackbarContent",
    slot: "Message",
    overridesResolver: (props, styles)=>styles.message
})({
    padding: "8px 0"
});
const $b19a2e5dbb4fa005$var$SnackbarContentAction = (0, $gIzLq.default)("div", {
    name: "MuiSnackbarContent",
    slot: "Action",
    overridesResolver: (props, styles)=>styles.action
})({
    display: "flex",
    alignItems: "center",
    marginLeft: "auto",
    paddingLeft: 16,
    marginRight: -8
});
const $b19a2e5dbb4fa005$var$SnackbarContent = /*#__PURE__*/ $1bdO8.forwardRef(function SnackbarContent(inProps, ref) {
    const props = (0, $dHuM2.default)({
        props: inProps,
        name: "MuiSnackbarContent"
    });
    const { action: action , className: className , message: message , role: role = "alert"  } = props, other = (0, $fZ2DJ.default)(props, $b19a2e5dbb4fa005$var$_excluded);
    const ownerState = props;
    const classes = $b19a2e5dbb4fa005$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $cVgDf.jsxs)($b19a2e5dbb4fa005$var$SnackbarContentRoot, (0, $63nUy.default)({
        role: role,
        square: true,
        elevation: 6,
        className: (0, $gJjS7.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $cVgDf.jsx)($b19a2e5dbb4fa005$var$SnackbarContentMessage, {
                className: classes.message,
                ownerState: ownerState,
                children: message
            }),
            action ? /*#__PURE__*/ (0, $cVgDf.jsx)($b19a2e5dbb4fa005$var$SnackbarContentAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            }) : null
        ]
    }));
});
var $b19a2e5dbb4fa005$export$2e2bcd8739ae039 = $b19a2e5dbb4fa005$var$SnackbarContent;



var $itJr1 = parcelRequire("itJr1");

var $9nXgc = parcelRequire("9nXgc");
function $1f8923d27255a9c4$export$6cb096457f5926f4(slot) {
    return (0, $9nXgc.default)("MuiSnackbar", slot);
}
const $1f8923d27255a9c4$var$snackbarClasses = (0, $itJr1.default)("MuiSnackbar", [
    "root",
    "anchorOriginTopCenter",
    "anchorOriginBottomCenter",
    "anchorOriginTopRight",
    "anchorOriginBottomRight",
    "anchorOriginTopLeft",
    "anchorOriginBottomLeft"
]);
var $1f8923d27255a9c4$export$2e2bcd8739ae039 = $1f8923d27255a9c4$var$snackbarClasses;



var $cVgDf = parcelRequire("cVgDf");
const $81338d067d7ac5ca$var$_excluded = [
    "onEnter",
    "onExited"
], $81338d067d7ac5ca$var$_excluded2 = [
    "action",
    "anchorOrigin",
    "autoHideDuration",
    "children",
    "className",
    "ClickAwayListenerProps",
    "ContentProps",
    "disableWindowBlurListener",
    "message",
    "onBlur",
    "onClose",
    "onFocus",
    "onMouseEnter",
    "onMouseLeave",
    "open",
    "resumeHideDuration",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $81338d067d7ac5ca$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , anchorOrigin: anchorOrigin  } = ownerState;
    const slots = {
        root: [
            "root",
            `anchorOrigin${(0, $82mcY.default)(anchorOrigin.vertical)}${(0, $82mcY.default)(anchorOrigin.horizontal)}`
        ]
    };
    return (0, $9H0b9.default)(slots, (0, $1f8923d27255a9c4$export$6cb096457f5926f4), classes);
};
const $81338d067d7ac5ca$var$SnackbarRoot = (0, $gIzLq.default)("div", {
    name: "MuiSnackbar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            styles[`anchorOrigin${(0, $82mcY.default)(ownerState.anchorOrigin.vertical)}${(0, $82mcY.default)(ownerState.anchorOrigin.horizontal)}`]
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>{
    const center = {
        left: "50%",
        right: "auto",
        transform: "translateX(-50%)"
    };
    return (0, $63nUy.default)({
        zIndex: (theme.vars || theme).zIndex.snackbar,
        position: "fixed",
        display: "flex",
        left: 8,
        right: 8,
        justifyContent: "center",
        alignItems: "center"
    }, ownerState.anchorOrigin.vertical === "top" ? {
        top: 8
    } : {
        bottom: 8
    }, ownerState.anchorOrigin.horizontal === "left" && {
        justifyContent: "flex-start"
    }, ownerState.anchorOrigin.horizontal === "right" && {
        justifyContent: "flex-end"
    }, {
        [theme.breakpoints.up("sm")]: (0, $63nUy.default)({}, ownerState.anchorOrigin.vertical === "top" ? {
            top: 24
        } : {
            bottom: 24
        }, ownerState.anchorOrigin.horizontal === "center" && center, ownerState.anchorOrigin.horizontal === "left" && {
            left: 24,
            right: "auto"
        }, ownerState.anchorOrigin.horizontal === "right" && {
            right: 24,
            left: "auto"
        })
    });
});
const $81338d067d7ac5ca$var$Snackbar = /*#__PURE__*/ $1bdO8.forwardRef(function Snackbar(inProps, ref) {
    const props = (0, $dHuM2.default)({
        props: inProps,
        name: "MuiSnackbar"
    });
    const theme = (0, $e8c20c93268b1fae$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { action: action , anchorOrigin: { vertical: vertical , horizontal: horizontal  } = {
        vertical: "bottom",
        horizontal: "left"
    } , autoHideDuration: autoHideDuration = null , children: children , className: className , ClickAwayListenerProps: ClickAwayListenerProps , ContentProps: ContentProps , disableWindowBlurListener: disableWindowBlurListener = false , message: message , open: open , TransitionComponent: TransitionComponent = (0, $5f3be16a76f1a341$export$2e2bcd8739ae039) , transitionDuration: transitionDuration = defaultTransitionDuration , TransitionProps: { onEnter: onEnter , onExited: onExited  } = {}  } = props, TransitionProps = (0, $fZ2DJ.default)(props.TransitionProps, $81338d067d7ac5ca$var$_excluded), other = (0, $fZ2DJ.default)(props, $81338d067d7ac5ca$var$_excluded2);
    const ownerState = (0, $63nUy.default)({}, props, {
        anchorOrigin: {
            vertical: vertical,
            horizontal: horizontal
        },
        autoHideDuration: autoHideDuration,
        disableWindowBlurListener: disableWindowBlurListener,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDuration
    });
    const classes = $81338d067d7ac5ca$var$useUtilityClasses(ownerState);
    const { getRootProps: getRootProps , onClickAway: onClickAway  } = (0, $8b83510b8fb5d041$export$2e2bcd8739ae039)((0, $63nUy.default)({}, ownerState));
    const [exited, setExited] = $1bdO8.useState(true);
    const rootProps = (0, $a3690fae0734bc5f$export$2e2bcd8739ae039)({
        elementType: $81338d067d7ac5ca$var$SnackbarRoot,
        getSlotProps: getRootProps,
        externalForwardedProps: other,
        ownerState: ownerState,
        additionalProps: {
            ref: ref
        },
        className: [
            classes.root,
            className
        ]
    });
    const handleExited = (node)=>{
        setExited(true);
        if (onExited) onExited(node);
    };
    const handleEnter = (node, isAppearing)=>{
        setExited(false);
        if (onEnter) onEnter(node, isAppearing);
    };
    // So we only render active snackbars.
    if (!open && exited) return null;
    return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $2b5f6fab558306a0$export$2e2bcd8739ae039), (0, $63nUy.default)({
        onClickAway: onClickAway
    }, ClickAwayListenerProps, {
        children: /*#__PURE__*/ (0, $cVgDf.jsx)($81338d067d7ac5ca$var$SnackbarRoot, (0, $63nUy.default)({}, rootProps, {
            children: /*#__PURE__*/ (0, $cVgDf.jsx)(TransitionComponent, (0, $63nUy.default)({
                appear: true,
                in: open,
                timeout: transitionDuration,
                direction: vertical === "top" ? "down" : "up",
                onEnter: handleEnter,
                onExited: handleExited
            }, TransitionProps, {
                children: children || /*#__PURE__*/ (0, $cVgDf.jsx)((0, $b19a2e5dbb4fa005$export$2e2bcd8739ae039), (0, $63nUy.default)({
                    message: message,
                    action: action
                }, ContentProps))
            }))
        }))
    }));
});
var $81338d067d7ac5ca$export$2e2bcd8739ae039 = $81338d067d7ac5ca$var$Snackbar;


function $45b1474d52204ef2$export$d453a48ed52fb5a9({ progress: progress = 0 , title: title = "Loading..."  }) {
    return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $81338d067d7ac5ca$export$2e2bcd8739ae039), {
        open: true,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "right"
        },
        sx: {
            "& .MuiSnackbarContent-root": {
                background: "rgba(40,40,40,0.3)",
                backdropFilter: "blur(2px)",
                opacity: 0.9,
                pointerEvents: "auto"
            }
        },
        message: /*#__PURE__*/ (0, $cVgDf.jsxs)((0, $89216f20f1c77281$export$2e2bcd8739ae039), {
            width: 250,
            direction: "row",
            alignItems: "center",
            justifyContent: "space-between",
            spacing: 1,
            children: [
                /*#__PURE__*/ (0, $cVgDf.jsx)((0, $15020dfde881caab$export$2e2bcd8739ae039), {
                    variant: "body2",
                    color: "text.primary",
                    children: title
                }),
                progress > 0 && /*#__PURE__*/ (0, $cVgDf.jsxs)((0, $15020dfde881caab$export$2e2bcd8739ae039), {
                    variant: "body2",
                    color: "text.primary",
                    children: [
                        (progress * 100).toFixed(0),
                        "%"
                    ]
                })
            ]
        })
    });
}



function $abeff2a1dffdffd9$export$5c16a7d40d128857() {
    const dataset = (0, $a2bde23ea9c8df05$export$26531d8e255edf16)((s)=>s.dataset);
    const loading = (0, $a2bde23ea9c8df05$export$26531d8e255edf16)((s)=>s.loading);
    const progress = (0, $1bdO8.useMemo)(()=>{
        if (loading) return 0;
        return 1;
    }, [
        loading
    ]);
    if (!dataset) return null;
    if (progress >= 1) return null;
    return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $45b1474d52204ef2$export$d453a48ed52fb5a9), {
        title: "Loading dataset..."
    });
}



var $cVgDf = parcelRequire("cVgDf");

var $1bdO8 = parcelRequire("1bdO8");





// TODO: User non texture based color palette
const $0908c99279eb8882$var$getPaletteColors = async (imagePath)=>{
    const offscreenCanvas = new OffscreenCanvas(1, 1);
    const context = offscreenCanvas.getContext("2d");
    const image = new Image();
    image.src = imagePath;
    await image.decode();
    offscreenCanvas.width = image.width;
    offscreenCanvas.height = image.height;
    if (!context) return [];
    context.drawImage(image, 0, 0);
    const firstRowColors = [];
    const imageData = context.getImageData(0, 0, image.width, 1);
    for(let i = 0; i < imageData.width; i++){
        const startIndex = i * 4;
        const r = imageData.data[startIndex];
        const g = imageData.data[startIndex + 1];
        const b = imageData.data[startIndex + 2];
        const color = `rgb(${r}, ${g}, ${b})`;
        firstRowColors.push(color);
    }
    return firstRowColors;
};
function $0908c99279eb8882$var$ColorItem({ name: name , color: color  }) {
    return /*#__PURE__*/ (0, $cVgDf.jsxs)((0, $89216f20f1c77281$export$2e2bcd8739ae039), {
        direction: "row",
        spacing: 2,
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $cVgDf.jsx)((0, $15020dfde881caab$export$2e2bcd8739ae039), {
                variant: "body2",
                children: name
            }),
            /*#__PURE__*/ (0, $cVgDf.jsx)("div", {
                style: {
                    width: 16,
                    height: 16,
                    borderRadius: 4,
                    backgroundColor: color
                }
            })
        ]
    });
}
function $0908c99279eb8882$export$baa258a5880a61c9() {
    const { dataset: dataset , colorAttribute: colorAttribute  } = (0, $a2bde23ea9c8df05$export$26531d8e255edf16)();
    const { colorPalette: colorPalette , showColorLegend: showColorLegend , setColorPaletteLength: setColorPaletteLength  } = (0, $ff1962c46896fdbd$export$772cdd5f573abcc9)();
    const [paletteColors, setPaletteColors] = (0, $1bdO8.useState)(null);
    (0, $1bdO8.useEffect)(()=>{
        if (!colorPalette) setPaletteColors(null);
        $0908c99279eb8882$var$getPaletteColors(colorPalette.texture).then(setPaletteColors);
    }, [
        colorPalette
    ]);
    (0, $1bdO8.useEffect)(()=>{
        if (paletteColors) setColorPaletteLength(paletteColors.length);
    }, [
        paletteColors,
        setColorPaletteLength
    ]);
    const colors = (0, $1bdO8.useMemo)(()=>{
        if (!dataset || !colorAttribute || !paletteColors) return null;
        const attribute = dataset.getAttributeByName(colorAttribute);
        if (attribute instanceof (0, $2981a5535b73e677$export$a89907aa2cab9ea9)) return attribute.categories.map((category, index)=>{
            if (attribute.categories.length === 1) return {
                name: category,
                color: paletteColors[paletteColors.length - 1]
            };
            let colorIndex = Math.floor(index * paletteColors.length / (attribute.categories.length - 1));
            if (colorIndex >= paletteColors.length) colorIndex = paletteColors.length - 1;
            return {
                name: category,
                color: paletteColors[colorIndex]
            };
        });
        if (attribute instanceof (0, $06f8b1ca3fe54dd2$export$aac0c9b76a8647d7)) {
            const [min, max] = attribute.getRange();
            return paletteColors.map((color, index)=>{
                const value = min + (max - min) * (index / (paletteColors.length - 1));
                return {
                    name: value.toFixed(2),
                    color: color
                };
            });
        }
    }, [
        colorAttribute,
        paletteColors
    ]);
    if (!showColorLegend || !dataset || !colors) return null;
    return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $89216f20f1c77281$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $cVgDf.jsx)((0, $89216f20f1c77281$export$2e2bcd8739ae039), {
            padding: 2,
            spacing: 1,
            alignItems: "end",
            children: colors.map(({ name: name , color: color  }, index)=>/*#__PURE__*/ (0, $cVgDf.jsx)($0908c99279eb8882$var$ColorItem, {
                    name: name,
                    color: color
                }, index))
        })
    });
}



var $cVgDf = parcelRequire("cVgDf");
parcelRequire("1bdO8");


var $1bdO8 = parcelRequire("1bdO8");
var $b2d1b6f56309c746$exports = {};
"use strict";

$b2d1b6f56309c746$exports = (parcelRequire("inpRe"));


var $2c6ca03bf9e5b083$exports = {};
"use strict";
Object.defineProperty($2c6ca03bf9e5b083$exports, "__esModule", {
    value: true
});

var $1bdO8 = parcelRequire("1bdO8");
function $2c6ca03bf9e5b083$var$createStore(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === "function" ? partial(state) : partial;
        if (nextState !== state) {
            var _previousState = state;
            state = replace ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var subscribeWithSelector = function subscribeWithSelector(listener, selector, equalityFn) {
        if (selector === void 0) selector = getState;
        if (equalityFn === void 0) equalityFn = Object.is;
        console.warn("[DEPRECATED] Please use `subscribeWithSelector` middleware");
        var currentSlice = selector(state);
        function listenerToAdd() {
            var nextSlice = selector(state);
            if (!equalityFn(currentSlice, nextSlice)) {
                var _previousSlice = currentSlice;
                listener(currentSlice = nextSlice, _previousSlice);
            }
        }
        listeners.add(listenerToAdd);
        return function() {
            return listeners.delete(listenerToAdd);
        };
    };
    var subscribe = function subscribe(listener, selector, equalityFn) {
        if (selector || equalityFn) return subscribeWithSelector(listener, selector, equalityFn);
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        return listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        subscribe: subscribe,
        destroy: destroy
    };
    state = createState(setState, getState, api);
    return api;
}
var $2c6ca03bf9e5b083$var$isSSR = typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
var $2c6ca03bf9e5b083$var$useIsomorphicLayoutEffect = $2c6ca03bf9e5b083$var$isSSR ? $1bdO8.useEffect : $1bdO8.useLayoutEffect;
function $2c6ca03bf9e5b083$var$create(createState) {
    var api = typeof createState === "function" ? $2c6ca03bf9e5b083$var$createStore(createState) : createState;
    var useStore = function useStore(selector, equalityFn) {
        if (selector === void 0) selector = api.getState;
        if (equalityFn === void 0) equalityFn = Object.is;
        var _ref = $1bdO8.useReducer(function(c) {
            return c + 1;
        }, 0), forceUpdate = _ref[1];
        var state = api.getState();
        var stateRef = $1bdO8.useRef(state);
        var selectorRef = $1bdO8.useRef(selector);
        var equalityFnRef = $1bdO8.useRef(equalityFn);
        var erroredRef = $1bdO8.useRef(false);
        var currentSliceRef = $1bdO8.useRef();
        if (currentSliceRef.current === undefined) currentSliceRef.current = selector(state);
        var newStateSlice;
        var hasNewStateSlice = false;
        if (stateRef.current !== state || selectorRef.current !== selector || equalityFnRef.current !== equalityFn || erroredRef.current) {
            newStateSlice = selector(state);
            hasNewStateSlice = !equalityFn(currentSliceRef.current, newStateSlice);
        }
        $2c6ca03bf9e5b083$var$useIsomorphicLayoutEffect(function() {
            if (hasNewStateSlice) currentSliceRef.current = newStateSlice;
            stateRef.current = state;
            selectorRef.current = selector;
            equalityFnRef.current = equalityFn;
            erroredRef.current = false;
        });
        var stateBeforeSubscriptionRef = $1bdO8.useRef(state);
        $2c6ca03bf9e5b083$var$useIsomorphicLayoutEffect(function() {
            var listener = function listener() {
                try {
                    var nextState = api.getState();
                    var nextStateSlice = selectorRef.current(nextState);
                    if (!equalityFnRef.current(currentSliceRef.current, nextStateSlice)) {
                        stateRef.current = nextState;
                        currentSliceRef.current = nextStateSlice;
                        forceUpdate();
                    }
                } catch (error) {
                    erroredRef.current = true;
                    forceUpdate();
                }
            };
            var unsubscribe = api.subscribe(listener);
            if (api.getState() !== stateBeforeSubscriptionRef.current) listener();
            return unsubscribe;
        }, []);
        var sliceToReturn = hasNewStateSlice ? newStateSlice : currentSliceRef.current;
        $1bdO8.useDebugValue(sliceToReturn);
        return sliceToReturn;
    };
    Object.assign(useStore, api);
    useStore[Symbol.iterator] = function() {
        console.warn("[useStore, api] = create() is deprecated and will be removed in v4");
        var items = [
            useStore,
            api
        ];
        return {
            next: function next() {
                var done = items.length <= 0;
                return {
                    value: items.shift(),
                    done: done
                };
            }
        };
    };
    return useStore;
}
$2c6ca03bf9e5b083$exports["default"] = $2c6ca03bf9e5b083$var$create;


var $c75653253615531b$exports = {};
"use strict";

$c75653253615531b$exports = (parcelRequire("iz3tf"));



var $cpxvE = parcelRequire("cpxvE");
function $b060960d67d2c344$var$shallowEqualArrays(arrA, arrB, equal = (a, b)=>a === b) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++)if (!equal(arrA[i], arrB[i])) return false;
    return true;
}
const $b060960d67d2c344$var$globalCache = [];
function $b060960d67d2c344$var$query(fn, keys, preload = false, config = {}) {
    for (const entry of $b060960d67d2c344$var$globalCache)// Find a match
    if ($b060960d67d2c344$var$shallowEqualArrays(keys, entry.keys, entry.equal)) {
        // If we're pre-loading and the element is present, just return
        if (preload) return undefined; // If an error occurred, throw
        if (Object.prototype.hasOwnProperty.call(entry, "error")) throw entry.error; // If a response was successful, return
        if (Object.prototype.hasOwnProperty.call(entry, "response")) return entry.response; // If the promise is still unresolved, throw
        if (!preload) throw entry.promise;
    }
     // The request is new or has changed.
    const entry = {
        keys: keys,
        equal: config.equal,
        promise: fn(...keys) // When it resolves, store its value
        .then((response)=>entry.response = response) // Remove the entry if a lifespan was given
        .then(()=>{
            if (config.lifespan && config.lifespan > 0) setTimeout(()=>{
                const index = $b060960d67d2c344$var$globalCache.indexOf(entry);
                if (index !== -1) $b060960d67d2c344$var$globalCache.splice(index, 1);
            }, config.lifespan);
        }) // Store caught errors, they will be thrown in the render-phase to bubble into an error-bound
        .catch((error)=>entry.error = error)
    }; // Register the entry
    $b060960d67d2c344$var$globalCache.push(entry); // And throw the promise, this yields control back to React
    if (!preload) throw entry.promise;
    return undefined;
}
const $b060960d67d2c344$export$a1428c8f7ba796e8 = (fn, keys, config)=>$b060960d67d2c344$var$query(fn, keys, false, config);
const $b060960d67d2c344$export$513ccb98c53b8039 = (fn, keys, config)=>void $b060960d67d2c344$var$query(fn, keys, true, config);
const $b060960d67d2c344$export$4d3fb11e950abb9e = (keys)=>{
    var _globalCache$find;
    return (_globalCache$find = $b060960d67d2c344$var$globalCache.find((entry)=>$b060960d67d2c344$var$shallowEqualArrays(keys, entry.keys, entry.equal))) == null ? void 0 : _globalCache$find.response;
};
const $b060960d67d2c344$export$42ffd38884aecdac = (keys)=>{
    if (keys === undefined || keys.length === 0) $b060960d67d2c344$var$globalCache.splice(0, $b060960d67d2c344$var$globalCache.length);
    else {
        const entry = $b060960d67d2c344$var$globalCache.find((entry)=>$b060960d67d2c344$var$shallowEqualArrays(keys, entry.keys, entry.equal));
        if (entry) {
            const index = $b060960d67d2c344$var$globalCache.indexOf(entry);
            if (index !== -1) $b060960d67d2c344$var$globalCache.splice(index, 1);
        }
    }
};


var $e0e1f88defa94a87$export$625550452a3fa3ec = /*#__PURE__*/ Object.freeze({
    __proto__: null
});
const $e0e1f88defa94a87$var$catalogue = {};
const $e0e1f88defa94a87$export$f1e1789686576879 = (objects)=>void Object.assign($e0e1f88defa94a87$var$catalogue, objects);
function $e0e1f88defa94a87$var$createRenderer(_roots, _getEventPriority) {
    function createInstance(type, { args: args = [] , attach: attach , ...props }, root) {
        let name = `${type[0].toUpperCase()}${type.slice(1)}`;
        let instance;
        if (type === "primitive") {
            if (props.object === undefined) throw new Error("R3F: Primitives without 'object' are invalid!");
            const object = props.object;
            instance = $e0e1f88defa94a87$var$prepare(object, {
                type: type,
                root: root,
                attach: attach,
                primitive: true
            });
        } else {
            const target = $e0e1f88defa94a87$var$catalogue[name];
            if (!target) throw new Error(`R3F: ${name} is not part of the THREE namespace! Did you forget to extend? See: https://docs.pmnd.rs/react-three-fiber/api/objects#using-3rd-party-objects-declaratively`);
            // Throw if an object or literal was passed for args
            if (!Array.isArray(args)) throw new Error("R3F: The args prop must be an array!");
            // Instanciate new object, link it to the root
            // Append memoized props with args so it's not forgotten
            instance = $e0e1f88defa94a87$var$prepare(new target(...args), {
                type: type,
                root: root,
                attach: attach,
                // Save args in case we need to reconstruct later for HMR
                memoizedProps: {
                    args: args
                }
            });
        }
        // Auto-attach geometries and materials
        if (instance.__r3f.attach === undefined) {
            if (instance instanceof $e8ea6a63d48a4fea$export$b7be63a67df8959) instance.__r3f.attach = "geometry";
            else if (instance instanceof $e8ea6a63d48a4fea$export$a2d8b23205c25948) instance.__r3f.attach = "material";
        }
        // It should NOT call onUpdate on object instanciation, because it hasn't been added to the
        // view yet. If the callback relies on references for instance, they won't be ready yet, this is
        // why it passes "true" here
        // There is no reason to apply props to injects
        if (name !== "inject") $e0e1f88defa94a87$var$applyProps$1(instance, props);
        return instance;
    }
    function appendChild(parentInstance, child) {
        let added = false;
        if (child) {
            var _child$__r3f, _parentInstance$__r3f;
            // The attach attribute implies that the object attaches itself on the parent
            if ((_child$__r3f = child.__r3f) != null && _child$__r3f.attach) $e0e1f88defa94a87$var$attach(parentInstance, child, child.__r3f.attach);
            else if (child.isObject3D && parentInstance.isObject3D) {
                // add in the usual parent-child way
                parentInstance.add(child);
                added = true;
            }
            // This is for anything that used attach, and for non-Object3Ds that don't get attached to props;
            // that is, anything that's a child in React but not a child in the scenegraph.
            if (!added) (_parentInstance$__r3f = parentInstance.__r3f) == null || _parentInstance$__r3f.objects.push(child);
            if (!child.__r3f) $e0e1f88defa94a87$var$prepare(child, {});
            child.__r3f.parent = parentInstance;
            $e0e1f88defa94a87$var$updateInstance(child);
            $e0e1f88defa94a87$var$invalidateInstance(child);
        }
    }
    function insertBefore(parentInstance, child, beforeChild) {
        let added = false;
        if (child) {
            var _child$__r3f2, _parentInstance$__r3f2;
            if ((_child$__r3f2 = child.__r3f) != null && _child$__r3f2.attach) $e0e1f88defa94a87$var$attach(parentInstance, child, child.__r3f.attach);
            else if (child.isObject3D && parentInstance.isObject3D) {
                child.parent = parentInstance;
                child.dispatchEvent({
                    type: "added"
                });
                const restSiblings = parentInstance.children.filter((sibling)=>sibling !== child);
                const index = restSiblings.indexOf(beforeChild);
                parentInstance.children = [
                    ...restSiblings.slice(0, index),
                    child,
                    ...restSiblings.slice(index)
                ];
                added = true;
            }
            if (!added) (_parentInstance$__r3f2 = parentInstance.__r3f) == null || _parentInstance$__r3f2.objects.push(child);
            if (!child.__r3f) $e0e1f88defa94a87$var$prepare(child, {});
            child.__r3f.parent = parentInstance;
            $e0e1f88defa94a87$var$updateInstance(child);
            $e0e1f88defa94a87$var$invalidateInstance(child);
        }
    }
    function removeRecursive(array, parent, dispose = false) {
        if (array) [
            ...array
        ].forEach((child)=>removeChild(parent, child, dispose));
    }
    function removeChild(parentInstance, child, dispose) {
        if (child) {
            var _parentInstance$__r3f3, _child$__r3f3, _child$__r3f5;
            // Clear the parent reference
            if (child.__r3f) child.__r3f.parent = null;
            // Remove child from the parents objects
            if ((_parentInstance$__r3f3 = parentInstance.__r3f) != null && _parentInstance$__r3f3.objects) parentInstance.__r3f.objects = parentInstance.__r3f.objects.filter((x)=>x !== child);
            // Remove attachment
            if ((_child$__r3f3 = child.__r3f) != null && _child$__r3f3.attach) $e0e1f88defa94a87$var$detach(parentInstance, child, child.__r3f.attach);
            else if (child.isObject3D && parentInstance.isObject3D) {
                var _child$__r3f4;
                parentInstance.remove(child);
                // Remove interactivity
                if ((_child$__r3f4 = child.__r3f) != null && _child$__r3f4.root) $e0e1f88defa94a87$var$removeInteractivity(child.__r3f.root, child);
            }
            // Allow objects to bail out of recursive dispose altogether by passing dispose={null}
            // Never dispose of primitives because their state may be kept outside of React!
            // In order for an object to be able to dispose it has to have
            //   - a dispose method,
            //   - it cannot be a <primitive object={...} />
            //   - it cannot be a THREE.Scene, because three has broken it's own api
            //
            // Since disposal is recursive, we can check the optional dispose arg, which will be undefined
            // when the reconciler calls it, but then carry our own check recursively
            const isPrimitive = (_child$__r3f5 = child.__r3f) == null ? void 0 : _child$__r3f5.primitive;
            const shouldDispose = dispose === undefined ? child.dispose !== null && !isPrimitive : dispose;
            // Remove nested child objects. Primitives should not have objects and children that are
            // attached to them declaratively ...
            if (!isPrimitive) {
                var _child$__r3f6;
                removeRecursive((_child$__r3f6 = child.__r3f) == null ? void 0 : _child$__r3f6.objects, child, shouldDispose);
                removeRecursive(child.children, child, shouldDispose);
            }
            // Remove references
            if (child.__r3f) {
                delete child.__r3f.root;
                delete child.__r3f.objects;
                delete child.__r3f.handlers;
                delete child.__r3f.memoizedProps;
                if (!isPrimitive) delete child.__r3f;
            }
            // Dispose item whenever the reconciler feels like it
            if (shouldDispose && child.dispose && child.type !== "Scene") (0, $cpxvE.unstable_scheduleCallback)((0, $cpxvE.unstable_IdlePriority), ()=>{
                try {
                    child.dispose();
                } catch (e) {
                /* ... */ }
            });
            $e0e1f88defa94a87$var$invalidateInstance(parentInstance);
        }
    }
    function switchInstance(instance, type, newProps, fiber) {
        var _instance$__r3f;
        const parent = (_instance$__r3f = instance.__r3f) == null ? void 0 : _instance$__r3f.parent;
        if (!parent) return;
        const newInstance = createInstance(type, newProps, instance.__r3f.root);
        // https://github.com/pmndrs/react-three-fiber/issues/1348
        // When args change the instance has to be re-constructed, which then
        // forces r3f to re-parent the children and non-scene objects
        if (instance.children) {
            for (const child of instance.children)if (child.__r3f) appendChild(newInstance, child);
            instance.children = instance.children.filter((child)=>!child.__r3f);
        }
        instance.__r3f.objects.forEach((child)=>appendChild(newInstance, child));
        instance.__r3f.objects = [];
        if (!instance.__r3f.autoRemovedBeforeAppend) removeChild(parent, instance);
        if (newInstance.parent) newInstance.__r3f.autoRemovedBeforeAppend = true;
        appendChild(parent, newInstance);
        // Re-bind event handlers
        if (newInstance.raycast && newInstance.__r3f.eventCount) {
            const rootState = newInstance.__r3f.root.getState();
            rootState.internal.interaction.push(newInstance);
        }
        [
            fiber,
            fiber.alternate
        ].forEach((fiber)=>{
            if (fiber !== null) {
                fiber.stateNode = newInstance;
                if (fiber.ref) {
                    if (typeof fiber.ref === "function") fiber.ref(newInstance);
                    else fiber.ref.current = newInstance;
                }
            }
        });
    }
    // Don't handle text instances, warn on undefined behavior
    const handleTextInstance = ()=>console.warn("Text is not allowed in the R3F tree! This could be stray whitespace or characters.");
    const reconciler = (0, (/*@__PURE__*/$parcel$interopDefault($c75653253615531b$exports)))({
        createInstance: createInstance,
        removeChild: removeChild,
        appendChild: appendChild,
        appendInitialChild: appendChild,
        insertBefore: insertBefore,
        supportsMutation: true,
        isPrimaryRenderer: false,
        supportsPersistence: false,
        supportsHydration: false,
        noTimeout: -1,
        appendChildToContainer: (container, child)=>{
            if (!child) return;
            // Don't append to unmounted container
            const scene = container.getState().scene;
            if (!scene.__r3f) return;
            // Link current root to the default scene
            scene.__r3f.root = container;
            appendChild(scene, child);
        },
        removeChildFromContainer: (container, child)=>{
            if (!child) return;
            removeChild(container.getState().scene, child);
        },
        insertInContainerBefore: (container, child, beforeChild)=>{
            if (!child || !beforeChild) return;
            // Don't append to unmounted container
            const scene = container.getState().scene;
            if (!scene.__r3f) return;
            insertBefore(scene, child, beforeChild);
        },
        getRootHostContext: ()=>null,
        getChildHostContext: (parentHostContext)=>parentHostContext,
        finalizeInitialChildren (instance) {
            var _instance$__r3f2;
            const localState = (_instance$__r3f2 = instance == null ? void 0 : instance.__r3f) != null ? _instance$__r3f2 : {};
            // https://github.com/facebook/react/issues/20271
            // Returning true will trigger commitMount
            return Boolean(localState.handlers);
        },
        prepareUpdate (instance, _type, oldProps, newProps) {
            // Create diff-sets
            if (instance.__r3f.primitive && newProps.object && newProps.object !== instance) return [
                true
            ];
            else {
                // This is a data object, let's extract critical information about it
                const { args: argsNew = [] , children: cN , ...restNew } = newProps;
                const { args: argsOld = [] , children: cO , ...restOld } = oldProps;
                // Throw if an object or literal was passed for args
                if (!Array.isArray(argsNew)) throw new Error("R3F: the args prop must be an array!");
                // If it has new props or arguments, then it needs to be re-instantiated
                if (argsNew.some((value, index)=>value !== argsOld[index])) return [
                    true
                ];
                // Create a diff-set, flag if there are any changes
                const diff = $e0e1f88defa94a87$var$diffProps(instance, restNew, restOld, true);
                if (diff.changes.length) return [
                    false,
                    diff
                ];
                // Otherwise do not touch the instance
                return null;
            }
        },
        commitUpdate (instance, [reconstruct, diff], type, _oldProps, newProps, fiber) {
            // Reconstruct when args or <primitive object={...} have changes
            if (reconstruct) switchInstance(instance, type, newProps, fiber);
            else $e0e1f88defa94a87$var$applyProps$1(instance, diff);
        },
        commitMount (instance, _type, _props, _int) {
            var _instance$__r3f3;
            // https://github.com/facebook/react/issues/20271
            // This will make sure events are only added once to the central container
            const localState = (_instance$__r3f3 = instance.__r3f) != null ? _instance$__r3f3 : {};
            if (instance.raycast && localState.handlers && localState.eventCount) instance.__r3f.root.getState().internal.interaction.push(instance);
        },
        getPublicInstance: (instance)=>instance,
        prepareForCommit: ()=>null,
        preparePortalMount: (container)=>$e0e1f88defa94a87$var$prepare(container.getState().scene),
        resetAfterCommit: ()=>{},
        shouldSetTextContent: ()=>false,
        clearContainer: ()=>false,
        hideInstance (instance) {
            var _instance$__r3f4;
            // Detach while the instance is hidden
            const { attach: type , parent: parent  } = (_instance$__r3f4 = instance.__r3f) != null ? _instance$__r3f4 : {};
            if (type && parent) $e0e1f88defa94a87$var$detach(parent, instance, type);
            if (instance.isObject3D) instance.visible = false;
            $e0e1f88defa94a87$var$invalidateInstance(instance);
        },
        unhideInstance (instance, props) {
            var _instance$__r3f5;
            // Re-attach when the instance is unhidden
            const { attach: type , parent: parent  } = (_instance$__r3f5 = instance.__r3f) != null ? _instance$__r3f5 : {};
            if (type && parent) $e0e1f88defa94a87$var$attach(parent, instance, type);
            if (instance.isObject3D && props.visible == null || props.visible) instance.visible = true;
            $e0e1f88defa94a87$var$invalidateInstance(instance);
        },
        createTextInstance: handleTextInstance,
        hideTextInstance: handleTextInstance,
        unhideTextInstance: handleTextInstance,
        // https://github.com/pmndrs/react-three-fiber/pull/2360#discussion_r916356874
        // @ts-ignore
        getCurrentEventPriority: ()=>_getEventPriority ? _getEventPriority() : (0, $b2d1b6f56309c746$exports.DefaultEventPriority),
        beforeActiveInstanceBlur: ()=>{},
        afterActiveInstanceBlur: ()=>{},
        detachDeletedInstance: ()=>{},
        now: typeof performance !== "undefined" && $e0e1f88defa94a87$var$is.fun(performance.now) ? performance.now : $e0e1f88defa94a87$var$is.fun(Date.now) ? Date.now : ()=>0,
        // https://github.com/pmndrs/react-three-fiber/pull/2360#discussion_r920883503
        scheduleTimeout: $e0e1f88defa94a87$var$is.fun(setTimeout) ? setTimeout : undefined,
        cancelTimeout: $e0e1f88defa94a87$var$is.fun(clearTimeout) ? clearTimeout : undefined
    });
    return {
        reconciler: reconciler,
        applyProps: $e0e1f88defa94a87$var$applyProps$1
    };
}
var $e0e1f88defa94a87$var$_window$document, $e0e1f88defa94a87$var$_window$navigator;
/**
 * Returns `true` with correct TS type inference if an object has a configurable color space (since r152).
 */ const $e0e1f88defa94a87$var$hasColorSpace = (object)=>"colorSpace" in object || "outputColorSpace" in object;
/**
 * The current THREE.ColorManagement instance, if present.
 */ const $e0e1f88defa94a87$var$getColorManagement = ()=>{
    var _ColorManagement;
    return (_ColorManagement = $e0e1f88defa94a87$var$catalogue.ColorManagement) != null ? _ColorManagement : null;
};
const $e0e1f88defa94a87$var$isOrthographicCamera = (def)=>def && def.isOrthographicCamera;
const $e0e1f88defa94a87$export$23f2a1d2818174ef = (obj)=>obj && obj.hasOwnProperty("current");
/**
 * An SSR-friendly useLayoutEffect.
 *
 * React currently throws a warning when using useLayoutEffect on the server.
 * To get around it, we can conditionally useEffect on the server (no-op) and
 * useLayoutEffect elsewhere.
 *
 * @see https://github.com/facebook/react/issues/14927
 */ const $e0e1f88defa94a87$export$407448d2b89b1813 = typeof window !== "undefined" && (($e0e1f88defa94a87$var$_window$document = window.document) != null && $e0e1f88defa94a87$var$_window$document.createElement || (($e0e1f88defa94a87$var$_window$navigator = window.navigator) == null ? void 0 : $e0e1f88defa94a87$var$_window$navigator.product) === "ReactNative") ? $1bdO8.useLayoutEffect : $1bdO8.useEffect;
function $e0e1f88defa94a87$export$3b14a55fb2447963(fn) {
    const ref = $1bdO8.useRef(fn);
    $e0e1f88defa94a87$export$407448d2b89b1813(()=>void (ref.current = fn), [
        fn
    ]);
    return ref;
}
function $e0e1f88defa94a87$export$ef35774e6d314e91({ set: set  }) {
    $e0e1f88defa94a87$export$407448d2b89b1813(()=>{
        set(new Promise(()=>null));
        return ()=>set(false);
    }, [
        set
    ]);
    return null;
}
class $e0e1f88defa94a87$export$a9c23c6ac3fc3eca extends $1bdO8.Component {
    constructor(...args){
        super(...args);
        this.state = {
            error: false
        };
    }
    componentDidCatch(err) {
        this.props.set(err);
    }
    render() {
        return this.state.error ? null : this.props.children;
    }
}
$e0e1f88defa94a87$export$a9c23c6ac3fc3eca.getDerivedStateFromError = ()=>({
        error: true
    });
const $e0e1f88defa94a87$var$DEFAULT = "__default";
const $e0e1f88defa94a87$var$DEFAULTS = new Map();
const $e0e1f88defa94a87$var$isDiffSet = (def)=>def && !!def.memoized && !!def.changes;
function $e0e1f88defa94a87$var$calculateDpr(dpr) {
    var _window$devicePixelRa;
    // Err on the side of progress by assuming 2x dpr if we can't detect it
    // This will happen in workers where window is defined but dpr isn't.
    const target = typeof window !== "undefined" ? (_window$devicePixelRa = window.devicePixelRatio) != null ? _window$devicePixelRa : 2 : 1;
    return Array.isArray(dpr) ? Math.min(Math.max(dpr[0], target), dpr[1]) : dpr;
}
/**
 * Returns instance root state
 */ const $e0e1f88defa94a87$export$2408f22a0fab9ae5 = (obj)=>{
    var _r3f;
    return (_r3f = obj.__r3f) == null ? void 0 : _r3f.root.getState();
};
// A collection of compare functions
const $e0e1f88defa94a87$var$is = {
    obj: (a)=>a === Object(a) && !$e0e1f88defa94a87$var$is.arr(a) && typeof a !== "function",
    fun: (a)=>typeof a === "function",
    str: (a)=>typeof a === "string",
    num: (a)=>typeof a === "number",
    boo: (a)=>typeof a === "boolean",
    und: (a)=>a === void 0,
    arr: (a)=>Array.isArray(a),
    equ (a, b, { arrays: arrays = "shallow" , objects: objects = "reference" , strict: strict = true  } = {}) {
        // Wrong type or one of the two undefined, doesn't match
        if (typeof a !== typeof b || !!a !== !!b) return false;
        // Atomic, just compare a against b
        if ($e0e1f88defa94a87$var$is.str(a) || $e0e1f88defa94a87$var$is.num(a)) return a === b;
        const isObj = $e0e1f88defa94a87$var$is.obj(a);
        if (isObj && objects === "reference") return a === b;
        const isArr = $e0e1f88defa94a87$var$is.arr(a);
        if (isArr && arrays === "reference") return a === b;
        // Array or Object, shallow compare first to see if it's a match
        if ((isArr || isObj) && a === b) return true;
        // Last resort, go through keys
        let i;
        // Check if a has all the keys of b
        for(i in a)if (!(i in b)) return false;
        // Check if values between keys match
        if (isObj && arrays === "shallow" && objects === "shallow") {
            for(i in strict ? b : a)if (!$e0e1f88defa94a87$var$is.equ(a[i], b[i], {
                strict: strict,
                objects: "reference"
            })) return false;
        } else {
            for(i in strict ? b : a)if (a[i] !== b[i]) return false;
        }
        // If i is undefined
        if ($e0e1f88defa94a87$var$is.und(i)) {
            // If both arrays are empty we consider them equal
            if (isArr && a.length === 0 && b.length === 0) return true;
            // If both objects are empty we consider them equal
            if (isObj && Object.keys(a).length === 0 && Object.keys(b).length === 0) return true;
            // Otherwise match them by value
            if (a !== b) return false;
        }
        return true;
    }
};
// Collects nodes and materials from a THREE.Object3D
function $e0e1f88defa94a87$var$buildGraph(object) {
    const data = {
        nodes: {},
        materials: {}
    };
    if (object) object.traverse((obj)=>{
        if (obj.name) data.nodes[obj.name] = obj;
        if (obj.material && !data.materials[obj.material.name]) data.materials[obj.material.name] = obj.material;
    });
    return data;
}
// Disposes an object and all its properties
function $e0e1f88defa94a87$export$342063e11d6c3cad(obj) {
    if (obj.dispose && obj.type !== "Scene") obj.dispose();
    for(const p in obj){
        p.dispose == null || p.dispose();
        delete obj[p];
    }
}
// Each object in the scene carries a small LocalState descriptor
function $e0e1f88defa94a87$var$prepare(object, state) {
    const instance = object;
    if (state != null && state.primitive || !instance.__r3f) instance.__r3f = {
        type: "",
        root: null,
        previousAttach: null,
        memoizedProps: {},
        eventCount: 0,
        handlers: {},
        objects: [],
        parent: null,
        ...state
    };
    return object;
}
function $e0e1f88defa94a87$var$resolve(instance, key) {
    let target = instance;
    if (key.includes("-")) {
        const entries = key.split("-");
        const last = entries.pop();
        target = entries.reduce((acc, key)=>acc[key], instance);
        return {
            target: target,
            key: last
        };
    } else return {
        target: target,
        key: key
    };
}
// Checks if a dash-cased string ends with an integer
const $e0e1f88defa94a87$var$INDEX_REGEX = /-\d+$/;
function $e0e1f88defa94a87$var$attach(parent, child, type) {
    if ($e0e1f88defa94a87$var$is.str(type)) {
        // If attaching into an array (foo-0), create one
        if ($e0e1f88defa94a87$var$INDEX_REGEX.test(type)) {
            const root = type.replace($e0e1f88defa94a87$var$INDEX_REGEX, "");
            const { target: target , key: key  } = $e0e1f88defa94a87$var$resolve(parent, root);
            if (!Array.isArray(target[key])) target[key] = [];
        }
        const { target: target , key: key  } = $e0e1f88defa94a87$var$resolve(parent, type);
        child.__r3f.previousAttach = target[key];
        target[key] = child;
    } else child.__r3f.previousAttach = type(parent, child);
}
function $e0e1f88defa94a87$var$detach(parent, child, type) {
    var _child$__r3f, _child$__r3f2;
    if ($e0e1f88defa94a87$var$is.str(type)) {
        const { target: target , key: key  } = $e0e1f88defa94a87$var$resolve(parent, type);
        const previous = child.__r3f.previousAttach;
        // When the previous value was undefined, it means the value was never set to begin with
        if (previous === undefined) delete target[key];
        else target[key] = previous;
    } else (_child$__r3f = child.__r3f) == null || _child$__r3f.previousAttach == null || _child$__r3f.previousAttach(parent, child);
    (_child$__r3f2 = child.__r3f) == null || delete _child$__r3f2.previousAttach;
}
// This function prepares a set of changes to be applied to the instance
function $e0e1f88defa94a87$var$diffProps(instance, { children: cN , key: kN , ref: rN , ...props }, { children: cP , key: kP , ref: rP , ...previous } = {}, remove = false) {
    var _instance$__r3f;
    const localState = (_instance$__r3f = instance == null ? void 0 : instance.__r3f) != null ? _instance$__r3f : {};
    const entries = Object.entries(props);
    const changes = [];
    // Catch removed props, prepend them so they can be reset or removed
    if (remove) {
        const previousKeys = Object.keys(previous);
        for(let i = 0; i < previousKeys.length; i++)if (!props.hasOwnProperty(previousKeys[i])) entries.unshift([
            previousKeys[i],
            $e0e1f88defa94a87$var$DEFAULT + "remove"
        ]);
    }
    entries.forEach(([key, value])=>{
        var _instance$__r3f2;
        // Bail out on primitive object
        if ((_instance$__r3f2 = instance.__r3f) != null && _instance$__r3f2.primitive && key === "object") return;
        // When props match bail out
        if ($e0e1f88defa94a87$var$is.equ(value, previous[key])) return;
        // Collect handlers and bail out
        if (/^on(Pointer|Click|DoubleClick|ContextMenu|Wheel)/.test(key)) return changes.push([
            key,
            value,
            true,
            []
        ]);
        // Split dashed props
        let entries = [];
        if (key.includes("-")) entries = key.split("-");
        changes.push([
            key,
            value,
            false,
            entries
        ]);
        // Reset pierced props
        for(const prop in props){
            const value = props[prop];
            if (prop.startsWith(`${key}-`)) changes.push([
                prop,
                value,
                false,
                prop.split("-")
            ]);
        }
    });
    const memoized = {
        ...props
    };
    if (localState.memoizedProps && localState.memoizedProps.args) memoized.args = localState.memoizedProps.args;
    if (localState.memoizedProps && localState.memoizedProps.attach) memoized.attach = localState.memoizedProps.attach;
    return {
        memoized: memoized,
        changes: changes
    };
}
// This function applies a set of changes to the instance
function $e0e1f88defa94a87$var$applyProps$1(instance, data) {
    var _instance$__r3f3, _root$getState, _instance$__r3f4;
    // Filter equals, events and reserved props
    const localState = (_instance$__r3f3 = instance.__r3f) != null ? _instance$__r3f3 : {};
    const root = localState.root;
    const rootState = (_root$getState = root == null ? void 0 : root.getState == null ? void 0 : root.getState()) != null ? _root$getState : {};
    const { memoized: memoized , changes: changes  } = $e0e1f88defa94a87$var$isDiffSet(data) ? data : $e0e1f88defa94a87$var$diffProps(instance, data);
    const prevHandlers = localState.eventCount;
    // Prepare memoized props
    if (instance.__r3f) instance.__r3f.memoizedProps = memoized;
    for(let i = 0; i < changes.length; i++){
        let [key, value, isEvent, keys] = changes[i];
        // Alias (output)encoding => (output)colorSpace (since r152)
        // https://github.com/pmndrs/react-three-fiber/pull/2829
        if ($e0e1f88defa94a87$var$hasColorSpace(instance)) {
            const sRGBEncoding = 3001;
            const SRGBColorSpace = "srgb";
            const LinearSRGBColorSpace = "srgb-linear";
            if (key === "encoding") {
                key = "colorSpace";
                value = value === sRGBEncoding ? SRGBColorSpace : LinearSRGBColorSpace;
            } else if (key === "outputEncoding") {
                key = "outputColorSpace";
                value = value === sRGBEncoding ? SRGBColorSpace : LinearSRGBColorSpace;
            }
        }
        let currentInstance = instance;
        let targetProp = currentInstance[key];
        // Revolve dashed props
        if (keys.length) {
            targetProp = keys.reduce((acc, key)=>acc[key], instance);
            // If the target is atomic, it forces us to switch the root
            if (!(targetProp && targetProp.set)) {
                const [name, ...reverseEntries] = keys.reverse();
                currentInstance = reverseEntries.reverse().reduce((acc, key)=>acc[key], instance);
                key = name;
            }
        }
        // https://github.com/mrdoob/three.js/issues/21209
        // HMR/fast-refresh relies on the ability to cancel out props, but threejs
        // has no means to do this. Hence we curate a small collection of value-classes
        // with their respective constructor/set arguments
        // For removed props, try to set default values, if possible
        if (value === $e0e1f88defa94a87$var$DEFAULT + "remove") {
            if (currentInstance.constructor) {
                // create a blank slate of the instance and copy the particular parameter.
                let ctor = $e0e1f88defa94a87$var$DEFAULTS.get(currentInstance.constructor);
                if (!ctor) {
                    // @ts-ignore
                    ctor = new currentInstance.constructor();
                    $e0e1f88defa94a87$var$DEFAULTS.set(currentInstance.constructor, ctor);
                }
                value = ctor[key];
            } else // instance does not have constructor, just set it to 0
            value = 0;
        }
        // Deal with pointer events ...
        if (isEvent) {
            if (value) localState.handlers[key] = value;
            else delete localState.handlers[key];
            localState.eventCount = Object.keys(localState.handlers).length;
        } else if (targetProp && targetProp.set && (targetProp.copy || targetProp instanceof $e8ea6a63d48a4fea$export$89312ce47c0ca777)) {
            // If value is an array
            if (Array.isArray(value)) {
                if (targetProp.fromArray) targetProp.fromArray(value);
                else targetProp.set(...value);
            } else if (targetProp.copy && value && value.constructor && targetProp.constructor === value.constructor) targetProp.copy(value);
            else if (value !== undefined) {
                const isColor = targetProp instanceof $e8ea6a63d48a4fea$export$892596cec99bc70e;
                // Allow setting array scalars
                if (!isColor && targetProp.setScalar) targetProp.setScalar(value);
                else if (targetProp instanceof $e8ea6a63d48a4fea$export$89312ce47c0ca777 && value instanceof $e8ea6a63d48a4fea$export$89312ce47c0ca777) targetProp.mask = value.mask;
                else targetProp.set(value);
                // For versions of three which don't support THREE.ColorManagement,
                // Auto-convert sRGB colors
                // https://github.com/pmndrs/react-three-fiber/issues/344
                if (!$e0e1f88defa94a87$var$getColorManagement() && !rootState.linear && isColor) targetProp.convertSRGBToLinear();
            }
        // Else, just overwrite the value
        } else {
            currentInstance[key] = value;
            // Auto-convert sRGB textures, for now ...
            // https://github.com/pmndrs/react-three-fiber/issues/344
            if (currentInstance[key] instanceof $e8ea6a63d48a4fea$export$5431306cf43de24a && // sRGB textures must be RGBA8 since r137 https://github.com/mrdoob/three.js/pull/23129
            currentInstance[key].format === $e8ea6a63d48a4fea$export$3f8bb04b555a363c && currentInstance[key].type === $e8ea6a63d48a4fea$export$2e8ce08d3f6f5e10) {
                const texture = currentInstance[key];
                if ($e0e1f88defa94a87$var$hasColorSpace(texture) && $e0e1f88defa94a87$var$hasColorSpace(rootState.gl)) texture.colorSpace = rootState.gl.outputColorSpace;
                else texture.encoding = rootState.gl.outputEncoding;
            }
        }
        $e0e1f88defa94a87$var$invalidateInstance(instance);
    }
    if (localState.parent && rootState.internal && instance.raycast && prevHandlers !== localState.eventCount) {
        // Pre-emptively remove the instance from the interaction manager
        const index = rootState.internal.interaction.indexOf(instance);
        if (index > -1) rootState.internal.interaction.splice(index, 1);
        // Add the instance to the interaction manager only when it has handlers
        if (localState.eventCount) rootState.internal.interaction.push(instance);
    }
    // Call the update lifecycle when it is being updated, but only when it is part of the scene.
    // Skip updates to the `onUpdate` prop itself
    const isCircular = changes.length === 1 && changes[0][0] === "onUpdate";
    if (!isCircular && changes.length && (_instance$__r3f4 = instance.__r3f) != null && _instance$__r3f4.parent) $e0e1f88defa94a87$var$updateInstance(instance);
    return instance;
}
function $e0e1f88defa94a87$var$invalidateInstance(instance) {
    var _instance$__r3f5, _instance$__r3f5$root;
    const state = (_instance$__r3f5 = instance.__r3f) == null ? void 0 : (_instance$__r3f5$root = _instance$__r3f5.root) == null ? void 0 : _instance$__r3f5$root.getState == null ? void 0 : _instance$__r3f5$root.getState();
    if (state && state.internal.frames === 0) state.invalidate();
}
function $e0e1f88defa94a87$var$updateInstance(instance) {
    instance.onUpdate == null || instance.onUpdate(instance);
}
function $e0e1f88defa94a87$var$updateCamera(camera, size) {
    // https://github.com/pmndrs/react-three-fiber/issues/92
    // Do not mess with the camera if it belongs to the user
    if (!camera.manual) {
        if ($e0e1f88defa94a87$var$isOrthographicCamera(camera)) {
            camera.left = size.width / -2;
            camera.right = size.width / 2;
            camera.top = size.height / 2;
            camera.bottom = size.height / -2;
        } else camera.aspect = size.width / size.height;
        camera.updateProjectionMatrix();
        // https://github.com/pmndrs/react-three-fiber/issues/178
        // Update matrix world since the renderer is a frame late
        camera.updateMatrixWorld();
    }
}
function $e0e1f88defa94a87$var$makeId(event) {
    return (event.eventObject || event.object).uuid + "/" + event.index + event.instanceId;
}
// https://github.com/facebook/react/tree/main/packages/react-reconciler#getcurrenteventpriority
// Gives React a clue as to how import the current interaction is
function $e0e1f88defa94a87$var$getEventPriority() {
    var _globalScope$event;
    // Get a handle to the current global scope in window and worker contexts if able
    // https://github.com/pmndrs/react-three-fiber/pull/2493
    const globalScope = typeof self !== "undefined" && self || typeof window !== "undefined" && window;
    if (!globalScope) return 0, $b2d1b6f56309c746$exports.DefaultEventPriority;
    const name = (_globalScope$event = globalScope.event) == null ? void 0 : _globalScope$event.type;
    switch(name){
        case "click":
        case "contextmenu":
        case "dblclick":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
            return 0, $b2d1b6f56309c746$exports.DiscreteEventPriority;
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "pointerenter":
        case "pointerleave":
        case "wheel":
            return 0, $b2d1b6f56309c746$exports.ContinuousEventPriority;
        default:
            return 0, $b2d1b6f56309c746$exports.DefaultEventPriority;
    }
}
/**
 * Release pointer captures.
 * This is called by releasePointerCapture in the API, and when an object is removed.
 */ function $e0e1f88defa94a87$var$releaseInternalPointerCapture(capturedMap, obj, captures, pointerId) {
    const captureData = captures.get(obj);
    if (captureData) {
        captures.delete(obj);
        // If this was the last capturing object for this pointer
        if (captures.size === 0) {
            capturedMap.delete(pointerId);
            captureData.target.releasePointerCapture(pointerId);
        }
    }
}
function $e0e1f88defa94a87$var$removeInteractivity(store, object) {
    const { internal: internal  } = store.getState();
    // Removes every trace of an object from the data store
    internal.interaction = internal.interaction.filter((o)=>o !== object);
    internal.initialHits = internal.initialHits.filter((o)=>o !== object);
    internal.hovered.forEach((value, key)=>{
        if (value.eventObject === object || value.object === object) // Clear out intersects, they are outdated by now
        internal.hovered.delete(key);
    });
    internal.capturedMap.forEach((captures, pointerId)=>{
        $e0e1f88defa94a87$var$releaseInternalPointerCapture(internal.capturedMap, object, captures, pointerId);
    });
}
function $e0e1f88defa94a87$export$db3b6bfb95261072(store) {
    /** Calculates delta */ function calculateDistance(event) {
        const { internal: internal  } = store.getState();
        const dx = event.offsetX - internal.initialClick[0];
        const dy = event.offsetY - internal.initialClick[1];
        return Math.round(Math.sqrt(dx * dx + dy * dy));
    }
    /** Returns true if an instance has a valid pointer-event registered, this excludes scroll, clicks etc */ function filterPointerEvents(objects) {
        return objects.filter((obj)=>[
                "Move",
                "Over",
                "Enter",
                "Out",
                "Leave"
            ].some((name)=>{
                var _r3f;
                return (_r3f = obj.__r3f) == null ? void 0 : _r3f.handlers["onPointer" + name];
            }));
    }
    function intersect(event, filter) {
        const state = store.getState();
        const duplicates = new Set();
        const intersections = [];
        // Allow callers to eliminate event objects
        const eventsObjects = filter ? filter(state.internal.interaction) : state.internal.interaction;
        // Reset all raycaster cameras to undefined
        for(let i = 0; i < eventsObjects.length; i++){
            const state = $e0e1f88defa94a87$export$2408f22a0fab9ae5(eventsObjects[i]);
            if (state) state.raycaster.camera = undefined;
        }
        if (!state.previousRoot) // Make sure root-level pointer and ray are set up
        state.events.compute == null || state.events.compute(event, state);
        function handleRaycast(obj) {
            const state = $e0e1f88defa94a87$export$2408f22a0fab9ae5(obj);
            // Skip event handling when noEvents is set, or when the raycasters camera is null
            if (!state || !state.events.enabled || state.raycaster.camera === null) return [];
            // When the camera is undefined we have to call the event layers update function
            if (state.raycaster.camera === undefined) {
                var _state$previousRoot;
                state.events.compute == null || state.events.compute(event, state, (_state$previousRoot = state.previousRoot) == null ? void 0 : _state$previousRoot.getState());
                // If the camera is still undefined we have to skip this layer entirely
                if (state.raycaster.camera === undefined) state.raycaster.camera = null;
            }
            // Intersect object by object
            return state.raycaster.camera ? state.raycaster.intersectObject(obj, true) : [];
        }
        // Collect events
        let hits = eventsObjects// Intersect objects
        .flatMap(handleRaycast)// Sort by event priority and distance
        .sort((a, b)=>{
            const aState = $e0e1f88defa94a87$export$2408f22a0fab9ae5(a.object);
            const bState = $e0e1f88defa94a87$export$2408f22a0fab9ae5(b.object);
            if (!aState || !bState) return a.distance - b.distance;
            return bState.events.priority - aState.events.priority || a.distance - b.distance;
        })// Filter out duplicates
        .filter((item)=>{
            const id = $e0e1f88defa94a87$var$makeId(item);
            if (duplicates.has(id)) return false;
            duplicates.add(id);
            return true;
        });
        // https://github.com/mrdoob/three.js/issues/16031
        // Allow custom userland intersect sort order, this likely only makes sense on the root filter
        if (state.events.filter) hits = state.events.filter(hits, state);
        // Bubble up the events, find the event source (eventObject)
        for (const hit of hits){
            let eventObject = hit.object;
            // Bubble event up
            while(eventObject){
                var _r3f2;
                if ((_r3f2 = eventObject.__r3f) != null && _r3f2.eventCount) intersections.push({
                    ...hit,
                    eventObject: eventObject
                });
                eventObject = eventObject.parent;
            }
        }
        // If the interaction is captured, make all capturing targets part of the intersect.
        if ("pointerId" in event && state.internal.capturedMap.has(event.pointerId)) {
            for (let captureData of state.internal.capturedMap.get(event.pointerId).values())if (!duplicates.has($e0e1f88defa94a87$var$makeId(captureData.intersection))) intersections.push(captureData.intersection);
        }
        return intersections;
    }
    /**  Handles intersections by forwarding them to handlers */ function handleIntersects(intersections, event, delta, callback) {
        const rootState = store.getState();
        // If anything has been found, forward it to the event listeners
        if (intersections.length) {
            const localState = {
                stopped: false
            };
            for (const hit of intersections){
                const state = $e0e1f88defa94a87$export$2408f22a0fab9ae5(hit.object) || rootState;
                const { raycaster: raycaster , pointer: pointer , camera: camera , internal: internal  } = state;
                const unprojectedPoint = new $e8ea6a63d48a4fea$export$64b5c384219d3699(pointer.x, pointer.y, 0).unproject(camera);
                const hasPointerCapture = (id)=>{
                    var _internal$capturedMap, _internal$capturedMap2;
                    return (_internal$capturedMap = (_internal$capturedMap2 = internal.capturedMap.get(id)) == null ? void 0 : _internal$capturedMap2.has(hit.eventObject)) != null ? _internal$capturedMap : false;
                };
                const setPointerCapture = (id)=>{
                    const captureData = {
                        intersection: hit,
                        target: event.target
                    };
                    if (internal.capturedMap.has(id)) // if the pointerId was previously captured, we add the hit to the
                    // event capturedMap.
                    internal.capturedMap.get(id).set(hit.eventObject, captureData);
                    else // if the pointerId was not previously captured, we create a map
                    // containing the hitObject, and the hit. hitObject is used for
                    // faster access.
                    internal.capturedMap.set(id, new Map([
                        [
                            hit.eventObject,
                            captureData
                        ]
                    ]));
                    event.target.setPointerCapture(id);
                };
                const releasePointerCapture = (id)=>{
                    const captures = internal.capturedMap.get(id);
                    if (captures) $e0e1f88defa94a87$var$releaseInternalPointerCapture(internal.capturedMap, hit.eventObject, captures, id);
                };
                // Add native event props
                let extractEventProps = {};
                // This iterates over the event's properties including the inherited ones. Native PointerEvents have most of their props as getters which are inherited, but polyfilled PointerEvents have them all as their own properties (i.e. not inherited). We can't use Object.keys() or Object.entries() as they only return "own" properties; nor Object.getPrototypeOf(event) as that *doesn't* return "own" properties, only inherited ones.
                for(let prop in event){
                    let property = event[prop];
                    // Only copy over atomics, leave functions alone as these should be
                    // called as event.nativeEvent.fn()
                    if (typeof property !== "function") extractEventProps[prop] = property;
                }
                let raycastEvent = {
                    ...hit,
                    ...extractEventProps,
                    pointer: pointer,
                    intersections: intersections,
                    stopped: localState.stopped,
                    delta: delta,
                    unprojectedPoint: unprojectedPoint,
                    ray: raycaster.ray,
                    camera: camera,
                    // Hijack stopPropagation, which just sets a flag
                    stopPropagation () {
                        // https://github.com/pmndrs/react-three-fiber/issues/596
                        // Events are not allowed to stop propagation if the pointer has been captured
                        const capturesForPointer = "pointerId" in event && internal.capturedMap.get(event.pointerId);
                        // We only authorize stopPropagation...
                        if (// ...if this pointer hasn't been captured
                        !capturesForPointer || // ... or if the hit object is capturing the pointer
                        capturesForPointer.has(hit.eventObject)) {
                            raycastEvent.stopped = localState.stopped = true;
                            // Propagation is stopped, remove all other hover records
                            // An event handler is only allowed to flush other handlers if it is hovered itself
                            if (internal.hovered.size && Array.from(internal.hovered.values()).find((i)=>i.eventObject === hit.eventObject)) {
                                // Objects cannot flush out higher up objects that have already caught the event
                                const higher = intersections.slice(0, intersections.indexOf(hit));
                                cancelPointer([
                                    ...higher,
                                    hit
                                ]);
                            }
                        }
                    },
                    // there should be a distinction between target and currentTarget
                    target: {
                        hasPointerCapture: hasPointerCapture,
                        setPointerCapture: setPointerCapture,
                        releasePointerCapture: releasePointerCapture
                    },
                    currentTarget: {
                        hasPointerCapture: hasPointerCapture,
                        setPointerCapture: setPointerCapture,
                        releasePointerCapture: releasePointerCapture
                    },
                    nativeEvent: event
                };
                // Call subscribers
                callback(raycastEvent);
                // Event bubbling may be interrupted by stopPropagation
                if (localState.stopped === true) break;
            }
        }
        return intersections;
    }
    function cancelPointer(intersections) {
        const { internal: internal  } = store.getState();
        for (const hoveredObj of internal.hovered.values())// When no objects were hit or the the hovered object wasn't found underneath the cursor
        // we call onPointerOut and delete the object from the hovered-elements map
        if (!intersections.length || !intersections.find((hit)=>hit.object === hoveredObj.object && hit.index === hoveredObj.index && hit.instanceId === hoveredObj.instanceId)) {
            const eventObject = hoveredObj.eventObject;
            const instance = eventObject.__r3f;
            const handlers = instance == null ? void 0 : instance.handlers;
            internal.hovered.delete($e0e1f88defa94a87$var$makeId(hoveredObj));
            if (instance != null && instance.eventCount) {
                // Clear out intersects, they are outdated by now
                const data = {
                    ...hoveredObj,
                    intersections: intersections
                };
                handlers.onPointerOut == null || handlers.onPointerOut(data);
                handlers.onPointerLeave == null || handlers.onPointerLeave(data);
            }
        }
    }
    function pointerMissed(event, objects) {
        for(let i = 0; i < objects.length; i++){
            const instance = objects[i].__r3f;
            instance == null || instance.handlers.onPointerMissed == null || instance.handlers.onPointerMissed(event);
        }
    }
    function handlePointer(name) {
        // Deal with cancelation
        switch(name){
            case "onPointerLeave":
            case "onPointerCancel":
                return ()=>cancelPointer([]);
            case "onLostPointerCapture":
                return (event)=>{
                    const { internal: internal  } = store.getState();
                    if ("pointerId" in event && internal.capturedMap.has(event.pointerId)) // If the object event interface had onLostPointerCapture, we'd call it here on every
                    // object that's getting removed. We call it on the next frame because onLostPointerCapture
                    // fires before onPointerUp. Otherwise pointerUp would never be called if the event didn't
                    // happen in the object it originated from, leaving components in a in-between state.
                    requestAnimationFrame(()=>{
                        // Only release if pointer-up didn't do it already
                        if (internal.capturedMap.has(event.pointerId)) {
                            internal.capturedMap.delete(event.pointerId);
                            cancelPointer([]);
                        }
                    });
                };
        }
        // Any other pointer goes here ...
        return function handleEvent(event) {
            const { onPointerMissed: onPointerMissed , internal: internal  } = store.getState();
            // prepareRay(event)
            internal.lastEvent.current = event;
            // Get fresh intersects
            const isPointerMove = name === "onPointerMove";
            const isClickEvent = name === "onClick" || name === "onContextMenu" || name === "onDoubleClick";
            const filter = isPointerMove ? filterPointerEvents : undefined;
            const hits = intersect(event, filter);
            const delta = isClickEvent ? calculateDistance(event) : 0;
            // Save initial coordinates on pointer-down
            if (name === "onPointerDown") {
                internal.initialClick = [
                    event.offsetX,
                    event.offsetY
                ];
                internal.initialHits = hits.map((hit)=>hit.eventObject);
            }
            // If a click yields no results, pass it back to the user as a miss
            // Missed events have to come first in order to establish user-land side-effect clean up
            if (isClickEvent && !hits.length) {
                if (delta <= 2) {
                    pointerMissed(event, internal.interaction);
                    if (onPointerMissed) onPointerMissed(event);
                }
            }
            // Take care of unhover
            if (isPointerMove) cancelPointer(hits);
            function onIntersect(data) {
                const eventObject = data.eventObject;
                const instance = eventObject.__r3f;
                const handlers = instance == null ? void 0 : instance.handlers;
                // Check presence of handlers
                if (!(instance != null && instance.eventCount)) return;
                /*
        MAYBE TODO, DELETE IF NOT: 
          Check if the object is captured, captured events should not have intersects running in parallel
          But wouldn't it be better to just replace capturedMap with a single entry?
          Also, are we OK with straight up making picking up multiple objects impossible?
          
        const pointerId = (data as ThreeEvent<PointerEvent>).pointerId        
        if (pointerId !== undefined) {
          const capturedMeshSet = internal.capturedMap.get(pointerId)
          if (capturedMeshSet) {
            const captured = capturedMeshSet.get(eventObject)
            if (captured && captured.localState.stopped) return
          }
        }*/ if (isPointerMove) {
                    // Move event ...
                    if (handlers.onPointerOver || handlers.onPointerEnter || handlers.onPointerOut || handlers.onPointerLeave) {
                        // When enter or out is present take care of hover-state
                        const id = $e0e1f88defa94a87$var$makeId(data);
                        const hoveredItem = internal.hovered.get(id);
                        if (!hoveredItem) {
                            // If the object wasn't previously hovered, book it and call its handler
                            internal.hovered.set(id, data);
                            handlers.onPointerOver == null || handlers.onPointerOver(data);
                            handlers.onPointerEnter == null || handlers.onPointerEnter(data);
                        } else if (hoveredItem.stopped) // If the object was previously hovered and stopped, we shouldn't allow other items to proceed
                        data.stopPropagation();
                    }
                    // Call mouse move
                    handlers.onPointerMove == null || handlers.onPointerMove(data);
                } else {
                    // All other events ...
                    const handler = handlers[name];
                    if (handler) // Forward all events back to their respective handlers with the exception of click events,
                    // which must use the initial target
                    {
                        if (!isClickEvent || internal.initialHits.includes(eventObject)) {
                            // Missed events have to come first
                            pointerMissed(event, internal.interaction.filter((object)=>!internal.initialHits.includes(object)));
                            // Now call the handler
                            handler(data);
                        }
                    } else // Trigger onPointerMissed on all elements that have pointer over/out handlers, but not click and weren't hit
                    if (isClickEvent && internal.initialHits.includes(eventObject)) pointerMissed(event, internal.interaction.filter((object)=>!internal.initialHits.includes(object)));
                }
            }
            handleIntersects(hits, event, delta, onIntersect);
        };
    }
    return {
        handlePointer: handlePointer
    };
}
// Keys that shouldn't be copied between R3F stores
const $e0e1f88defa94a87$var$privateKeys = [
    "set",
    "get",
    "setSize",
    "setFrameloop",
    "setDpr",
    "events",
    "invalidate",
    "advance",
    "size",
    "viewport"
];
const $e0e1f88defa94a87$var$isRenderer = (def)=>!!(def != null && def.render);
const $e0e1f88defa94a87$export$2d1720544b23b823 = /*#__PURE__*/ $1bdO8.createContext(null);
const $e0e1f88defa94a87$var$createStore = (invalidate, advance)=>{
    const rootState = (0, (/*@__PURE__*/$parcel$interopDefault($2c6ca03bf9e5b083$exports)))((set, get)=>{
        const position = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        const defaultTarget = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        const tempTarget = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        function getCurrentViewport(camera = get().camera, target = defaultTarget, size = get().size) {
            const { width: width , height: height , top: top , left: left  } = size;
            const aspect = width / height;
            if (target instanceof $e8ea6a63d48a4fea$export$64b5c384219d3699) tempTarget.copy(target);
            else tempTarget.set(...target);
            const distance = camera.getWorldPosition(position).distanceTo(tempTarget);
            if ($e0e1f88defa94a87$var$isOrthographicCamera(camera)) return {
                width: width / camera.zoom,
                height: height / camera.zoom,
                top: top,
                left: left,
                factor: 1,
                distance: distance,
                aspect: aspect
            };
            else {
                const fov = camera.fov * Math.PI / 180; // convert vertical fov to radians
                const h = 2 * Math.tan(fov / 2) * distance; // visible height
                const w = h * (width / height);
                return {
                    width: w,
                    height: h,
                    top: top,
                    left: left,
                    factor: width / w,
                    distance: distance,
                    aspect: aspect
                };
            }
        }
        let performanceTimeout = undefined;
        const setPerformanceCurrent = (current)=>set((state)=>({
                    performance: {
                        ...state.performance,
                        current: current
                    }
                }));
        const pointer = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1();
        const rootState = {
            set: set,
            get: get,
            // Mock objects that have to be configured
            gl: null,
            camera: null,
            raycaster: null,
            events: {
                priority: 1,
                enabled: true,
                connected: false
            },
            xr: null,
            scene: null,
            invalidate: (frames = 1)=>invalidate(get(), frames),
            advance: (timestamp, runGlobalEffects)=>advance(timestamp, runGlobalEffects, get()),
            legacy: false,
            linear: false,
            flat: false,
            controls: null,
            clock: new $e8ea6a63d48a4fea$export$9735c82c4bae3302(),
            pointer: pointer,
            mouse: pointer,
            frameloop: "always",
            onPointerMissed: undefined,
            performance: {
                current: 1,
                min: 0.5,
                max: 1,
                debounce: 200,
                regress: ()=>{
                    const state = get();
                    // Clear timeout
                    if (performanceTimeout) clearTimeout(performanceTimeout);
                    // Set lower bound performance
                    if (state.performance.current !== state.performance.min) setPerformanceCurrent(state.performance.min);
                    // Go back to upper bound performance after a while unless something regresses meanwhile
                    performanceTimeout = setTimeout(()=>setPerformanceCurrent(get().performance.max), state.performance.debounce);
                }
            },
            size: {
                width: 0,
                height: 0,
                top: 0,
                left: 0,
                updateStyle: false
            },
            viewport: {
                initialDpr: 0,
                dpr: 0,
                width: 0,
                height: 0,
                top: 0,
                left: 0,
                aspect: 0,
                distance: 0,
                factor: 0,
                getCurrentViewport: getCurrentViewport
            },
            setEvents: (events)=>set((state)=>({
                        ...state,
                        events: {
                            ...state.events,
                            ...events
                        }
                    })),
            setSize: (width, height, updateStyle, top, left)=>{
                const camera = get().camera;
                const size = {
                    width: width,
                    height: height,
                    top: top || 0,
                    left: left || 0,
                    updateStyle: updateStyle
                };
                set((state)=>({
                        size: size,
                        viewport: {
                            ...state.viewport,
                            ...getCurrentViewport(camera, defaultTarget, size)
                        }
                    }));
            },
            setDpr: (dpr)=>set((state)=>{
                    const resolved = $e0e1f88defa94a87$var$calculateDpr(dpr);
                    return {
                        viewport: {
                            ...state.viewport,
                            dpr: resolved,
                            initialDpr: state.viewport.initialDpr || resolved
                        }
                    };
                }),
            setFrameloop: (frameloop = "always")=>{
                const clock = get().clock;
                // if frameloop === "never" clock.elapsedTime is updated using advance(timestamp)
                clock.stop();
                clock.elapsedTime = 0;
                if (frameloop !== "never") {
                    clock.start();
                    clock.elapsedTime = 0;
                }
                set(()=>({
                        frameloop: frameloop
                    }));
            },
            previousRoot: undefined,
            internal: {
                active: false,
                priority: 0,
                frames: 0,
                lastEvent: /*#__PURE__*/ $1bdO8.createRef(),
                interaction: [],
                hovered: new Map(),
                subscribers: [],
                initialClick: [
                    0,
                    0
                ],
                initialHits: [],
                capturedMap: new Map(),
                subscribe: (ref, priority, store)=>{
                    const internal = get().internal;
                    // If this subscription was given a priority, it takes rendering into its own hands
                    // For that reason we switch off automatic rendering and increase the manual flag
                    // As long as this flag is positive there can be no internal rendering at all
                    // because there could be multiple render subscriptions
                    internal.priority = internal.priority + (priority > 0 ? 1 : 0);
                    internal.subscribers.push({
                        ref: ref,
                        priority: priority,
                        store: store
                    });
                    // Register subscriber and sort layers from lowest to highest, meaning,
                    // highest priority renders last (on top of the other frames)
                    internal.subscribers = internal.subscribers.sort((a, b)=>a.priority - b.priority);
                    return ()=>{
                        const internal = get().internal;
                        if (internal != null && internal.subscribers) {
                            // Decrease manual flag if this subscription had a priority
                            internal.priority = internal.priority - (priority > 0 ? 1 : 0);
                            // Remove subscriber from list
                            internal.subscribers = internal.subscribers.filter((s)=>s.ref !== ref);
                        }
                    };
                }
            }
        };
        return rootState;
    });
    const state = rootState.getState();
    let oldSize = state.size;
    let oldDpr = state.viewport.dpr;
    let oldCamera = state.camera;
    rootState.subscribe(()=>{
        const { camera: camera , size: size , viewport: viewport , gl: gl , set: set  } = rootState.getState();
        // Resize camera and renderer on changes to size and pixelratio
        if (size !== oldSize || viewport.dpr !== oldDpr) {
            var _size$updateStyle;
            oldSize = size;
            oldDpr = viewport.dpr;
            // Update camera & renderer
            $e0e1f88defa94a87$var$updateCamera(camera, size);
            gl.setPixelRatio(viewport.dpr);
            const updateStyle = (_size$updateStyle = size.updateStyle) != null ? _size$updateStyle : typeof HTMLCanvasElement !== "undefined" && gl.domElement instanceof HTMLCanvasElement;
            gl.setSize(size.width, size.height, updateStyle);
        }
        // Update viewport once the camera changes
        if (camera !== oldCamera) {
            oldCamera = camera;
            // Update viewport
            set((state)=>({
                    viewport: {
                        ...state.viewport,
                        ...state.viewport.getCurrentViewport(camera)
                    }
                }));
        }
    });
    // Invalidate on any change
    rootState.subscribe((state)=>invalidate(state));
    // Return root state
    return rootState;
};
function $e0e1f88defa94a87$var$createSubs(callback, subs) {
    const sub = {
        callback: callback
    };
    subs.add(sub);
    return ()=>void subs.delete(sub);
}
let $e0e1f88defa94a87$var$i;
let $e0e1f88defa94a87$var$globalEffects = new Set();
let $e0e1f88defa94a87$var$globalAfterEffects = new Set();
let $e0e1f88defa94a87$var$globalTailEffects = new Set();
/**
 * Adds a global render callback which is called each frame.
 * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#addEffect
 */ const $e0e1f88defa94a87$export$7ccc53e8f1e7dfc5 = (callback)=>$e0e1f88defa94a87$var$createSubs(callback, $e0e1f88defa94a87$var$globalEffects);
/**
 * Adds a global after-render callback which is called each frame.
 * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#addAfterEffect
 */ const $e0e1f88defa94a87$export$ae1af26003f05816 = (callback)=>$e0e1f88defa94a87$var$createSubs(callback, $e0e1f88defa94a87$var$globalAfterEffects);
/**
 * Adds a global callback which is called when rendering stops.
 * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#addTail
 */ const $e0e1f88defa94a87$export$ffb5f4729a158638 = (callback)=>$e0e1f88defa94a87$var$createSubs(callback, $e0e1f88defa94a87$var$globalTailEffects);
function $e0e1f88defa94a87$var$run(effects, timestamp) {
    if (!effects.size) return;
    for (const { callback: callback  } of effects.values())callback(timestamp);
}
function $e0e1f88defa94a87$export$9e5f44173e64f162(type, timestamp) {
    switch(type){
        case "before":
            return $e0e1f88defa94a87$var$run($e0e1f88defa94a87$var$globalEffects, timestamp);
        case "after":
            return $e0e1f88defa94a87$var$run($e0e1f88defa94a87$var$globalAfterEffects, timestamp);
        case "tail":
            return $e0e1f88defa94a87$var$run($e0e1f88defa94a87$var$globalTailEffects, timestamp);
    }
}
let $e0e1f88defa94a87$var$subscribers;
let $e0e1f88defa94a87$var$subscription;
function $e0e1f88defa94a87$var$render$1(timestamp, state, frame) {
    // Run local effects
    let delta = state.clock.getDelta();
    // In frameloop='never' mode, clock times are updated using the provided timestamp
    if (state.frameloop === "never" && typeof timestamp === "number") {
        delta = timestamp - state.clock.elapsedTime;
        state.clock.oldTime = state.clock.elapsedTime;
        state.clock.elapsedTime = timestamp;
    }
    // Call subscribers (useFrame)
    $e0e1f88defa94a87$var$subscribers = state.internal.subscribers;
    for($e0e1f88defa94a87$var$i = 0; $e0e1f88defa94a87$var$i < $e0e1f88defa94a87$var$subscribers.length; $e0e1f88defa94a87$var$i++){
        $e0e1f88defa94a87$var$subscription = $e0e1f88defa94a87$var$subscribers[$e0e1f88defa94a87$var$i];
        $e0e1f88defa94a87$var$subscription.ref.current($e0e1f88defa94a87$var$subscription.store.getState(), delta, frame);
    }
    // Render content
    if (!state.internal.priority && state.gl.render) state.gl.render(state.scene, state.camera);
    // Decrease frame count
    state.internal.frames = Math.max(0, state.internal.frames - 1);
    return state.frameloop === "always" ? 1 : state.internal.frames;
}
function $e0e1f88defa94a87$var$createLoop(roots) {
    let running = false;
    let repeat;
    let frame;
    let state;
    function loop(timestamp) {
        frame = requestAnimationFrame(loop);
        running = true;
        repeat = 0;
        // Run effects
        $e0e1f88defa94a87$export$9e5f44173e64f162("before", timestamp);
        // Render all roots
        for (const root of roots.values()){
            var _state$gl$xr;
            state = root.store.getState();
            // If the frameloop is invalidated, do not run another frame
            if (state.internal.active && (state.frameloop === "always" || state.internal.frames > 0) && !((_state$gl$xr = state.gl.xr) != null && _state$gl$xr.isPresenting)) repeat += $e0e1f88defa94a87$var$render$1(timestamp, state);
        }
        // Run after-effects
        $e0e1f88defa94a87$export$9e5f44173e64f162("after", timestamp);
        // Stop the loop if nothing invalidates it
        if (repeat === 0) {
            // Tail call effects, they are called when rendering stops
            $e0e1f88defa94a87$export$9e5f44173e64f162("tail", timestamp);
            // Flag end of operation
            running = false;
            return cancelAnimationFrame(frame);
        }
    }
    function invalidate(state, frames = 1) {
        var _state$gl$xr2;
        if (!state) return roots.forEach((root)=>invalidate(root.store.getState()), frames);
        if ((_state$gl$xr2 = state.gl.xr) != null && _state$gl$xr2.isPresenting || !state.internal.active || state.frameloop === "never") return;
        // Increase frames, do not go higher than 60
        state.internal.frames = Math.min(60, state.internal.frames + frames);
        // If the render-loop isn't active, start it
        if (!running) {
            running = true;
            requestAnimationFrame(loop);
        }
    }
    function advance(timestamp, runGlobalEffects = true, state, frame) {
        if (runGlobalEffects) $e0e1f88defa94a87$export$9e5f44173e64f162("before", timestamp);
        if (!state) for (const root of roots.values())$e0e1f88defa94a87$var$render$1(timestamp, root.store.getState());
        else $e0e1f88defa94a87$var$render$1(timestamp, state, frame);
        if (runGlobalEffects) $e0e1f88defa94a87$export$9e5f44173e64f162("after", timestamp);
    }
    return {
        loop: loop,
        invalidate: /**
     * Invalidates the view, requesting a frame to be rendered. Will globally invalidate unless passed a root's state.
     * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#invalidate
     */ invalidate,
        advance: /**
     * Advances the frameloop and runs render effects, useful for when manually rendering via `frameloop="never"`.
     * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#advance
     */ advance
    };
}
/**
 * Exposes an object's {@link LocalState}.
 * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#useInstanceHandle
 *
 * **Note**: this is an escape hatch to react-internal fields. Expect this to change significantly between versions.
 */ function $e0e1f88defa94a87$export$d141bba7fdc215a3(ref) {
    const instance = $1bdO8.useRef(null);
    $e0e1f88defa94a87$export$407448d2b89b1813(()=>void (instance.current = ref.current.__r3f), [
        ref
    ]);
    return instance;
}
function $e0e1f88defa94a87$export$4a5767248b18ef41() {
    const store = $1bdO8.useContext($e0e1f88defa94a87$export$2d1720544b23b823);
    if (!store) throw new Error("R3F: Hooks can only be used within the Canvas component!");
    return store;
}
/**
 * Accesses R3F's internal state, containing renderer, canvas, scene, etc.
 * @see https://docs.pmnd.rs/react-three-fiber/api/hooks#usethree
 */ function $e0e1f88defa94a87$export$df995fae86a55f06(selector = (state)=>state, equalityFn) {
    return $e0e1f88defa94a87$export$4a5767248b18ef41()(selector, equalityFn);
}
/**
 * Executes a callback before render in a shared frame loop.
 * Can order effects with render priority or manually render with a positive priority.
 * @see https://docs.pmnd.rs/react-three-fiber/api/hooks#useframe
 */ function $e0e1f88defa94a87$export$ebd11618f299a286(callback, renderPriority = 0) {
    const store = $e0e1f88defa94a87$export$4a5767248b18ef41();
    const subscribe = store.getState().internal.subscribe;
    // Memoize ref
    const ref = $e0e1f88defa94a87$export$3b14a55fb2447963(callback);
    // Subscribe on mount, unsubscribe on unmount
    $e0e1f88defa94a87$export$407448d2b89b1813(()=>subscribe(ref, renderPriority, store), [
        renderPriority,
        subscribe,
        store
    ]);
    return null;
}
/**
 * Returns a node graph of an object with named nodes & materials.
 * @see https://docs.pmnd.rs/react-three-fiber/api/hooks#usegraph
 */ function $e0e1f88defa94a87$export$e7094788287c5e9b(object) {
    return $1bdO8.useMemo(()=>$e0e1f88defa94a87$var$buildGraph(object), [
        object
    ]);
}
function $e0e1f88defa94a87$var$loadingFn(extensions, onProgress) {
    return function(Proto, ...input) {
        // Construct new loader and run extensions
        const loader = new Proto();
        if (extensions) extensions(loader);
        // Go through the urls and load them
        return Promise.all(input.map((input)=>new Promise((res, reject)=>loader.load(input, (data)=>{
                    if (data.scene) Object.assign(data, $e0e1f88defa94a87$var$buildGraph(data.scene));
                    res(data);
                }, onProgress, (error)=>reject(new Error(`Could not load ${input}: ${error.message})`))))));
    };
}
/**
 * Synchronously loads and caches assets with a three loader.
 *
 * Note: this hook's caller must be wrapped with `React.Suspense`
 * @see https://docs.pmnd.rs/react-three-fiber/api/hooks#useloader
 */ function $e0e1f88defa94a87$export$96f57966bedc81b4(Proto, input, extensions, onProgress) {
    // Use suspense to load async assets
    const keys = Array.isArray(input) ? input : [
        input
    ];
    const results = (0, $b060960d67d2c344$export$a1428c8f7ba796e8)($e0e1f88defa94a87$var$loadingFn(extensions, onProgress), [
        Proto,
        ...keys
    ], {
        equal: $e0e1f88defa94a87$var$is.equ
    });
    // Return the object/s
    return Array.isArray(input) ? results : results[0];
}
/**
 * Preloads an asset into cache as a side-effect.
 */ $e0e1f88defa94a87$export$96f57966bedc81b4.preload = function(Proto, input, extensions) {
    const keys = Array.isArray(input) ? input : [
        input
    ];
    return (0, $b060960d67d2c344$export$513ccb98c53b8039)($e0e1f88defa94a87$var$loadingFn(extensions), [
        Proto,
        ...keys
    ]);
};
/**
 * Removes a loaded asset from cache.
 */ $e0e1f88defa94a87$export$96f57966bedc81b4.clear = function(Proto, input) {
    const keys = Array.isArray(input) ? input : [
        input
    ];
    return (0, $b060960d67d2c344$export$42ffd38884aecdac)([
        Proto,
        ...keys
    ]);
};
const $e0e1f88defa94a87$export$efccba1c4a2ef57b = new Map();
const { invalidate: $e0e1f88defa94a87$export$882b5998b3b9117c , advance: $e0e1f88defa94a87$export$953cecd6e717a553  } = $e0e1f88defa94a87$var$createLoop($e0e1f88defa94a87$export$efccba1c4a2ef57b);
const { reconciler: $e0e1f88defa94a87$export$dda1d9f60106f0e9 , applyProps: $e0e1f88defa94a87$export$35e795649ee09318  } = $e0e1f88defa94a87$var$createRenderer($e0e1f88defa94a87$export$efccba1c4a2ef57b, $e0e1f88defa94a87$var$getEventPriority);
const $e0e1f88defa94a87$var$shallowLoose = {
    objects: "shallow",
    strict: false
};
const $e0e1f88defa94a87$var$createRendererInstance = (gl, canvas)=>{
    const customRenderer = typeof gl === "function" ? gl(canvas) : gl;
    if ($e0e1f88defa94a87$var$isRenderer(customRenderer)) return customRenderer;
    else return new $e8ea6a63d48a4fea$export$f6cc00ef28d7cf97({
        powerPreference: "high-performance",
        canvas: canvas,
        antialias: true,
        alpha: true,
        ...gl
    });
};
function $e0e1f88defa94a87$var$computeInitialSize(canvas, defaultSize) {
    if (defaultSize) return defaultSize;
    if (typeof HTMLCanvasElement !== "undefined" && canvas instanceof HTMLCanvasElement && canvas.parentElement) {
        const { width: width , height: height , top: top , left: left  } = canvas.parentElement.getBoundingClientRect();
        return {
            width: width,
            height: height,
            top: top,
            left: left
        };
    } else if (typeof OffscreenCanvas !== "undefined" && canvas instanceof OffscreenCanvas) return {
        width: canvas.width,
        height: canvas.height,
        top: 0,
        left: 0
    };
    return {
        width: 0,
        height: 0,
        top: 0,
        left: 0
    };
}
function $e0e1f88defa94a87$export$8b22cf2602fb60ce(canvas) {
    // Check against mistaken use of createRoot
    const prevRoot = $e0e1f88defa94a87$export$efccba1c4a2ef57b.get(canvas);
    const prevFiber = prevRoot == null ? void 0 : prevRoot.fiber;
    const prevStore = prevRoot == null ? void 0 : prevRoot.store;
    if (prevRoot) console.warn("R3F.createRoot should only be called once!");
    // Report when an error was detected in a previous render
    // https://github.com/pmndrs/react-three-fiber/pull/2261
    const logRecoverableError = typeof reportError === "function" ? // In modern browsers, reportError will dispatch an error event,
    // emulating an uncaught JavaScript error.
    reportError : // In older browsers and test environments, fallback to console.error.
    console.error;
    // Create store
    const store = prevStore || $e0e1f88defa94a87$var$createStore($e0e1f88defa94a87$export$882b5998b3b9117c, $e0e1f88defa94a87$export$953cecd6e717a553);
    // Create renderer
    const fiber = prevFiber || $e0e1f88defa94a87$export$dda1d9f60106f0e9.createContainer(store, (0, $b2d1b6f56309c746$exports.ConcurrentRoot), null, false, null, "", logRecoverableError, null);
    // Map it
    if (!prevRoot) $e0e1f88defa94a87$export$efccba1c4a2ef57b.set(canvas, {
        fiber: fiber,
        store: store
    });
    // Locals
    let onCreated;
    let configured = false;
    let lastCamera;
    return {
        configure (props = {}) {
            let { gl: glConfig , size: propsSize , scene: sceneOptions , events: events , onCreated: onCreatedCallback , shadows: shadows = false , linear: linear = false , flat: flat = false , legacy: legacy = false , orthographic: orthographic = false , frameloop: frameloop = "always" , dpr: dpr = [
                1,
                2
            ] , performance: performance1 , raycaster: raycastOptions , camera: cameraOptions , onPointerMissed: onPointerMissed  } = props;
            let state = store.getState();
            // Set up renderer (one time only!)
            let gl = state.gl;
            if (!state.gl) state.set({
                gl: gl = $e0e1f88defa94a87$var$createRendererInstance(glConfig, canvas)
            });
            // Set up raycaster (one time only!)
            let raycaster = state.raycaster;
            if (!raycaster) state.set({
                raycaster: raycaster = new $e8ea6a63d48a4fea$export$8b7aaceff00bd2f()
            });
            // Set raycaster options
            const { params: params , ...options } = raycastOptions || {};
            if (!$e0e1f88defa94a87$var$is.equ(options, raycaster, $e0e1f88defa94a87$var$shallowLoose)) $e0e1f88defa94a87$export$35e795649ee09318(raycaster, {
                ...options
            });
            if (!$e0e1f88defa94a87$var$is.equ(params, raycaster.params, $e0e1f88defa94a87$var$shallowLoose)) $e0e1f88defa94a87$export$35e795649ee09318(raycaster, {
                params: {
                    ...raycaster.params,
                    ...params
                }
            });
            // Create default camera, don't overwrite any user-set state
            if (!state.camera || state.camera === lastCamera && !$e0e1f88defa94a87$var$is.equ(lastCamera, cameraOptions, $e0e1f88defa94a87$var$shallowLoose)) {
                lastCamera = cameraOptions;
                const isCamera = cameraOptions instanceof $e8ea6a63d48a4fea$export$79f141de891a5fed;
                const camera = isCamera ? cameraOptions : orthographic ? new $e8ea6a63d48a4fea$export$9ebf355ee4ed261b(0, 0, 0, 0, 0.1, 1000) : new $e8ea6a63d48a4fea$export$74e4ae24825f68d7(75, 0, 0.1, 1000);
                if (!isCamera) {
                    camera.position.z = 5;
                    if (cameraOptions) $e0e1f88defa94a87$export$35e795649ee09318(camera, cameraOptions);
                    // Always look at center by default
                    if (!state.camera && !(cameraOptions != null && cameraOptions.rotation)) camera.lookAt(0, 0, 0);
                }
                state.set({
                    camera: camera
                });
            }
            // Set up scene (one time only!)
            if (!state.scene) {
                let scene;
                if (sceneOptions instanceof $e8ea6a63d48a4fea$export$38af1803e3442a7f) scene = sceneOptions;
                else {
                    scene = new $e8ea6a63d48a4fea$export$38af1803e3442a7f();
                    if (sceneOptions) $e0e1f88defa94a87$export$35e795649ee09318(scene, sceneOptions);
                }
                state.set({
                    scene: $e0e1f88defa94a87$var$prepare(scene)
                });
            }
            // Set up XR (one time only!)
            if (!state.xr) {
                // Handle frame behavior in WebXR
                const handleXRFrame = (timestamp, frame)=>{
                    const state = store.getState();
                    if (state.frameloop === "never") return;
                    $e0e1f88defa94a87$export$953cecd6e717a553(timestamp, true, state, frame);
                };
                // Toggle render switching on session
                const handleSessionChange = ()=>{
                    const state = store.getState();
                    state.gl.xr.enabled = state.gl.xr.isPresenting;
                    state.gl.xr.setAnimationLoop(state.gl.xr.isPresenting ? handleXRFrame : null);
                    if (!state.gl.xr.isPresenting) $e0e1f88defa94a87$export$882b5998b3b9117c(state);
                };
                // WebXR session manager
                const xr = {
                    connect () {
                        const gl = store.getState().gl;
                        gl.xr.addEventListener("sessionstart", handleSessionChange);
                        gl.xr.addEventListener("sessionend", handleSessionChange);
                    },
                    disconnect () {
                        const gl = store.getState().gl;
                        gl.xr.removeEventListener("sessionstart", handleSessionChange);
                        gl.xr.removeEventListener("sessionend", handleSessionChange);
                    }
                };
                // Subscribe to WebXR session events
                if (gl.xr) xr.connect();
                state.set({
                    xr: xr
                });
            }
            // Set shadowmap
            if (gl.shadowMap) {
                const oldEnabled = gl.shadowMap.enabled;
                const oldType = gl.shadowMap.type;
                gl.shadowMap.enabled = !!shadows;
                if ($e0e1f88defa94a87$var$is.boo(shadows)) gl.shadowMap.type = $e8ea6a63d48a4fea$export$a47c4b43a1be34f0;
                else if ($e0e1f88defa94a87$var$is.str(shadows)) {
                    var _types$shadows;
                    const types = {
                        basic: $e8ea6a63d48a4fea$export$346307dbae2b7447,
                        percentage: $e8ea6a63d48a4fea$export$5813f879eee7cd88,
                        soft: $e8ea6a63d48a4fea$export$a47c4b43a1be34f0,
                        variance: $e8ea6a63d48a4fea$export$896ae1ade6c829c4
                    };
                    gl.shadowMap.type = (_types$shadows = types[shadows]) != null ? _types$shadows : $e8ea6a63d48a4fea$export$a47c4b43a1be34f0;
                } else if ($e0e1f88defa94a87$var$is.obj(shadows)) Object.assign(gl.shadowMap, shadows);
                if (oldEnabled !== gl.shadowMap.enabled || oldType !== gl.shadowMap.type) gl.shadowMap.needsUpdate = true;
            }
            // Safely set color management if available.
            // Avoid accessing THREE.ColorManagement to play nice with older versions
            const ColorManagement = $e0e1f88defa94a87$var$getColorManagement();
            if (ColorManagement) {
                if ("enabled" in ColorManagement) ColorManagement.enabled = !legacy;
                else if ("legacyMode" in ColorManagement) ColorManagement.legacyMode = legacy;
            }
            // Set color space and tonemapping preferences
            const LinearEncoding = 3000;
            const sRGBEncoding = 3001;
            $e0e1f88defa94a87$export$35e795649ee09318(gl, {
                outputEncoding: linear ? LinearEncoding : sRGBEncoding,
                toneMapping: flat ? $e8ea6a63d48a4fea$export$9fcb6b4294603b2 : $e8ea6a63d48a4fea$export$a0d98fe6d7e4af64
            });
            // Update color management state
            if (state.legacy !== legacy) state.set(()=>({
                    legacy: legacy
                }));
            if (state.linear !== linear) state.set(()=>({
                    linear: linear
                }));
            if (state.flat !== flat) state.set(()=>({
                    flat: flat
                }));
            // Set gl props
            if (glConfig && !$e0e1f88defa94a87$var$is.fun(glConfig) && !$e0e1f88defa94a87$var$isRenderer(glConfig) && !$e0e1f88defa94a87$var$is.equ(glConfig, gl, $e0e1f88defa94a87$var$shallowLoose)) $e0e1f88defa94a87$export$35e795649ee09318(gl, glConfig);
            // Store events internally
            if (events && !state.events.handlers) state.set({
                events: events(store)
            });
            // Check size, allow it to take on container bounds initially
            const size = $e0e1f88defa94a87$var$computeInitialSize(canvas, propsSize);
            if (!$e0e1f88defa94a87$var$is.equ(size, state.size, $e0e1f88defa94a87$var$shallowLoose)) state.setSize(size.width, size.height, size.updateStyle, size.top, size.left);
            // Check pixelratio
            if (dpr && state.viewport.dpr !== $e0e1f88defa94a87$var$calculateDpr(dpr)) state.setDpr(dpr);
            // Check frameloop
            if (state.frameloop !== frameloop) state.setFrameloop(frameloop);
            // Check pointer missed
            if (!state.onPointerMissed) state.set({
                onPointerMissed: onPointerMissed
            });
            // Check performance
            if (performance1 && !$e0e1f88defa94a87$var$is.equ(performance1, state.performance, $e0e1f88defa94a87$var$shallowLoose)) state.set((state)=>({
                    performance: {
                        ...state.performance,
                        ...performance1
                    }
                }));
            // Set locals
            onCreated = onCreatedCallback;
            configured = true;
            return this;
        },
        render (children) {
            // The root has to be configured before it can be rendered
            if (!configured) this.configure();
            $e0e1f88defa94a87$export$dda1d9f60106f0e9.updateContainer(/*#__PURE__*/ $1bdO8.createElement($e0e1f88defa94a87$var$Provider, {
                store: store,
                children: children,
                onCreated: onCreated,
                rootElement: canvas
            }), fiber, null, ()=>undefined);
            return store;
        },
        unmount () {
            $e0e1f88defa94a87$export$4368d992c4eafac0(canvas);
        }
    };
}
function $e0e1f88defa94a87$export$43caf9889c228507(children, canvas, config) {
    console.warn("R3F.render is no longer supported in React 18. Use createRoot instead!");
    const root = $e0e1f88defa94a87$export$8b22cf2602fb60ce(canvas);
    root.configure(config);
    return root.render(children);
}
function $e0e1f88defa94a87$var$Provider({ store: store , children: children , onCreated: onCreated , rootElement: rootElement  }) {
    $e0e1f88defa94a87$export$407448d2b89b1813(()=>{
        const state = store.getState();
        // Flag the canvas active, rendering will now begin
        state.set((state)=>({
                internal: {
                    ...state.internal,
                    active: true
                }
            }));
        // Notifiy that init is completed, the scene graph exists, but nothing has yet rendered
        if (onCreated) onCreated(state);
        // Connect events to the targets parent, this is done to ensure events are registered on
        // a shared target, and not on the canvas itself
        if (!store.getState().events.connected) state.events.connect == null || state.events.connect(rootElement);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ $1bdO8.createElement($e0e1f88defa94a87$export$2d1720544b23b823.Provider, {
        value: store
    }, children);
}
function $e0e1f88defa94a87$export$4368d992c4eafac0(canvas, callback) {
    const root = $e0e1f88defa94a87$export$efccba1c4a2ef57b.get(canvas);
    const fiber = root == null ? void 0 : root.fiber;
    if (fiber) {
        const state = root == null ? void 0 : root.store.getState();
        if (state) state.internal.active = false;
        $e0e1f88defa94a87$export$dda1d9f60106f0e9.updateContainer(null, fiber, null, ()=>{
            if (state) setTimeout(()=>{
                try {
                    var _state$gl, _state$gl$renderLists, _state$gl2, _state$gl3;
                    state.events.disconnect == null || state.events.disconnect();
                    (_state$gl = state.gl) == null || (_state$gl$renderLists = _state$gl.renderLists) == null || _state$gl$renderLists.dispose == null || _state$gl$renderLists.dispose();
                    (_state$gl2 = state.gl) == null || _state$gl2.forceContextLoss == null || _state$gl2.forceContextLoss();
                    if ((_state$gl3 = state.gl) != null && _state$gl3.xr) state.xr.disconnect();
                    $e0e1f88defa94a87$export$342063e11d6c3cad(state);
                    $e0e1f88defa94a87$export$efccba1c4a2ef57b.delete(canvas);
                    if (callback) callback(canvas);
                } catch (e) {
                /* ... */ }
            }, 500);
        });
    }
}
function $e0e1f88defa94a87$export$39b482c5e57630a8(children, container, state) {
    return /*#__PURE__*/ $1bdO8.createElement($e0e1f88defa94a87$var$Portal, {
        key: container.uuid,
        children: children,
        container: container,
        state: state
    });
}
function $e0e1f88defa94a87$var$Portal({ state: state = {} , children: children , container: container  }) {
    /** This has to be a component because it would not be able to call useThree/useStore otherwise since
   *  if this is our environment, then we are not in r3f's renderer but in react-dom, it would trigger
   *  the "R3F hooks can only be used within the Canvas component!" warning:
   *  <Canvas>
   *    {createPortal(...)} */ const { events: events , size: size , ...rest } = state;
    const previousRoot = $e0e1f88defa94a87$export$4a5767248b18ef41();
    const [raycaster] = $1bdO8.useState(()=>new $e8ea6a63d48a4fea$export$8b7aaceff00bd2f());
    const [pointer] = $1bdO8.useState(()=>new $e8ea6a63d48a4fea$export$c977b3e384af9ae1());
    const inject = $1bdO8.useCallback((rootState, injectState)=>{
        const intersect = {
            ...rootState
        }; // all prev state props
        // Only the fields of "rootState" that do not differ from injectState
        // Some props should be off-limits
        // Otherwise filter out the props that are different and let the inject layer take precedence
        Object.keys(rootState).forEach((key)=>{
            if (// Some props should be off-limits
            $e0e1f88defa94a87$var$privateKeys.includes(key) || // Otherwise filter out the props that are different and let the inject layer take precedence
            // Unless the inject layer props is undefined, then we keep the root layer
            rootState[key] !== injectState[key] && injectState[key]) delete intersect[key];
        });
        let viewport = undefined;
        if (injectState && size) {
            const camera = injectState.camera;
            // Calculate the override viewport, if present
            viewport = rootState.viewport.getCurrentViewport(camera, new $e8ea6a63d48a4fea$export$64b5c384219d3699(), size);
            // Update the portal camera, if it differs from the previous layer
            if (camera !== rootState.camera) $e0e1f88defa94a87$var$updateCamera(camera, size);
        }
        return {
            // The intersect consists of the previous root state
            ...intersect,
            // Portals have their own scene, which forms the root, a raycaster and a pointer
            scene: container,
            raycaster: raycaster,
            pointer: pointer,
            mouse: pointer,
            previousRoot: // Their previous root is the layer before it
            previousRoot,
            // Events, size and viewport can be overridden by the inject layer
            events: {
                ...rootState.events,
                ...injectState == null ? void 0 : injectState.events,
                ...events
            },
            size: {
                ...rootState.size,
                ...size
            },
            viewport: {
                ...rootState.viewport,
                ...viewport
            },
            ...rest
        };
    }, [
        state
    ]);
    const [usePortalStore] = $1bdO8.useState(()=>{
        // Create a mirrored store, based on the previous root with a few overrides ...
        const previousState = previousRoot.getState();
        const store = (0, (/*@__PURE__*/$parcel$interopDefault($2c6ca03bf9e5b083$exports)))((set, get)=>({
                ...previousState,
                scene: container,
                raycaster: raycaster,
                pointer: pointer,
                mouse: pointer,
                previousRoot: previousRoot,
                events: {
                    ...previousState.events,
                    ...events
                },
                size: {
                    ...previousState.size,
                    ...size
                },
                ...rest,
                set: // Set and get refer to this root-state
                set,
                get: get,
                // Layers are allowed to override events
                setEvents: (events)=>set((state)=>({
                            ...state,
                            events: {
                                ...state.events,
                                ...events
                            }
                        }))
            }));
        return store;
    });
    $1bdO8.useEffect(()=>{
        // Subscribe to previous root-state and copy changes over to the mirrored portal-state
        const unsub = previousRoot.subscribe((prev)=>usePortalStore.setState((state)=>inject(prev, state)));
        return ()=>{
            unsub();
            usePortalStore.destroy();
        };
    }, []);
    $1bdO8.useEffect(()=>{
        usePortalStore.setState((injectState)=>inject(previousRoot.getState(), injectState));
    }, [
        inject
    ]);
    return /*#__PURE__*/ $1bdO8.createElement($1bdO8.Fragment, null, $e0e1f88defa94a87$export$dda1d9f60106f0e9.createPortal(/*#__PURE__*/ $1bdO8.createElement($e0e1f88defa94a87$export$2d1720544b23b823.Provider, {
        value: usePortalStore
    }, children), usePortalStore, null));
}
$e0e1f88defa94a87$export$dda1d9f60106f0e9.injectIntoDevTools({
    bundleType: 0,
    rendererPackageName: "@react-three/fiber",
    version: $1bdO8.version
});
const $e0e1f88defa94a87$export$90a7f3efeed30595 = $1bdO8.unstable_act;



var $63nUy = parcelRequire("63nUy");

var $1bdO8 = parcelRequire("1bdO8");


var $1bdO8 = parcelRequire("1bdO8");
var $a653a8014e168202$exports = {};
/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */ function $a653a8014e168202$var$debounce(func, wait, immediate) {
    var timeout, args, context, timestamp, result;
    if (null == wait) wait = 100;
    function later() {
        var last = Date.now() - timestamp;
        if (last < wait && last >= 0) timeout = setTimeout(later, wait - last);
        else {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, args);
                context = args = null;
            }
        }
    }
    var debounced = function() {
        context = this;
        args = arguments;
        timestamp = Date.now();
        var callNow = immediate && !timeout;
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }
        return result;
    };
    debounced.clear = function() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
    };
    debounced.flush = function() {
        if (timeout) {
            result = func.apply(context, args);
            context = args = null;
            clearTimeout(timeout);
            timeout = null;
        }
    };
    return debounced;
}
// Adds compatibility for ES modules
$a653a8014e168202$var$debounce.debounce = $a653a8014e168202$var$debounce;
$a653a8014e168202$exports = $a653a8014e168202$var$debounce;


function $182daea206ea9c67$export$2e2bcd8739ae039(_temp) {
    let { debounce: debounce , scroll: scroll , polyfill: polyfill , offsetSize: offsetSize  } = _temp === void 0 ? {
        debounce: 0,
        scroll: false,
        offsetSize: false
    } : _temp;
    const ResizeObserver = polyfill || (typeof window === "undefined" ? class ResizeObserver {
    } : window.ResizeObserver);
    if (!ResizeObserver) throw new Error("This browser does not support ResizeObserver out of the box. See: https://github.com/react-spring/react-use-measure/#resize-observer-polyfills");
    const [bounds, set] = (0, $1bdO8.useState)({
        left: 0,
        top: 0,
        width: 0,
        height: 0,
        bottom: 0,
        right: 0,
        x: 0,
        y: 0
    }); // keep all state in a ref
    const state = (0, $1bdO8.useRef)({
        element: null,
        scrollContainers: null,
        resizeObserver: null,
        lastBounds: bounds
    }); // set actual debounce values early, so effects know if they should react accordingly
    const scrollDebounce = debounce ? typeof debounce === "number" ? debounce : debounce.scroll : null;
    const resizeDebounce = debounce ? typeof debounce === "number" ? debounce : debounce.resize : null; // make sure to update state only as long as the component is truly mounted
    const mounted = (0, $1bdO8.useRef)(false);
    (0, $1bdO8.useEffect)(()=>{
        mounted.current = true;
        return ()=>void (mounted.current = false);
    }); // memoize handlers, so event-listeners know when they should update
    const [forceRefresh, resizeChange, scrollChange] = (0, $1bdO8.useMemo)(()=>{
        const callback = ()=>{
            if (!state.current.element) return;
            const { left: left , top: top , width: width , height: height , bottom: bottom , right: right , x: x , y: y  } = state.current.element.getBoundingClientRect();
            const size = {
                left: left,
                top: top,
                width: width,
                height: height,
                bottom: bottom,
                right: right,
                x: x,
                y: y
            };
            if (state.current.element instanceof HTMLElement && offsetSize) {
                size.height = state.current.element.offsetHeight;
                size.width = state.current.element.offsetWidth;
            }
            Object.freeze(size);
            if (mounted.current && !$182daea206ea9c67$var$areBoundsEqual(state.current.lastBounds, size)) set(state.current.lastBounds = size);
        };
        return [
            callback,
            resizeDebounce ? (0, (/*@__PURE__*/$parcel$interopDefault($a653a8014e168202$exports)))(callback, resizeDebounce) : callback,
            scrollDebounce ? (0, (/*@__PURE__*/$parcel$interopDefault($a653a8014e168202$exports)))(callback, scrollDebounce) : callback
        ];
    }, [
        set,
        offsetSize,
        scrollDebounce,
        resizeDebounce
    ]); // cleanup current scroll-listeners / observers
    function removeListeners() {
        if (state.current.scrollContainers) {
            state.current.scrollContainers.forEach((element)=>element.removeEventListener("scroll", scrollChange, true));
            state.current.scrollContainers = null;
        }
        if (state.current.resizeObserver) {
            state.current.resizeObserver.disconnect();
            state.current.resizeObserver = null;
        }
    } // add scroll-listeners / observers
    function addListeners() {
        if (!state.current.element) return;
        state.current.resizeObserver = new ResizeObserver(scrollChange);
        state.current.resizeObserver.observe(state.current.element);
        if (scroll && state.current.scrollContainers) state.current.scrollContainers.forEach((scrollContainer)=>scrollContainer.addEventListener("scroll", scrollChange, {
                capture: true,
                passive: true
            }));
    } // the ref we expose to the user
    const ref = (node)=>{
        if (!node || node === state.current.element) return;
        removeListeners();
        state.current.element = node;
        state.current.scrollContainers = $182daea206ea9c67$var$findScrollContainers(node);
        addListeners();
    }; // add general event listeners
    $182daea206ea9c67$var$useOnWindowScroll(scrollChange, Boolean(scroll));
    $182daea206ea9c67$var$useOnWindowResize(resizeChange); // respond to changes that are relevant for the listeners
    (0, $1bdO8.useEffect)(()=>{
        removeListeners();
        addListeners();
    }, [
        scroll,
        scrollChange,
        resizeChange
    ]); // remove all listeners when the components unmounts
    (0, $1bdO8.useEffect)(()=>removeListeners, []);
    return [
        ref,
        bounds,
        forceRefresh
    ];
} // Adds native resize listener to window
function $182daea206ea9c67$var$useOnWindowResize(onWindowResize) {
    (0, $1bdO8.useEffect)(()=>{
        const cb = onWindowResize;
        window.addEventListener("resize", cb);
        return ()=>void window.removeEventListener("resize", cb);
    }, [
        onWindowResize
    ]);
}
function $182daea206ea9c67$var$useOnWindowScroll(onScroll, enabled) {
    (0, $1bdO8.useEffect)(()=>{
        if (enabled) {
            const cb = onScroll;
            window.addEventListener("scroll", cb, {
                capture: true,
                passive: true
            });
            return ()=>void window.removeEventListener("scroll", cb, true);
        }
    }, [
        onScroll,
        enabled
    ]);
} // Returns a list of scroll offsets
function $182daea206ea9c67$var$findScrollContainers(element) {
    const result = [];
    if (!element || element === document.body) return result;
    const { overflow: overflow , overflowX: overflowX , overflowY: overflowY  } = window.getComputedStyle(element);
    if ([
        overflow,
        overflowX,
        overflowY
    ].some((prop)=>prop === "auto" || prop === "scroll")) result.push(element);
    return [
        ...result,
        ...$182daea206ea9c67$var$findScrollContainers(element.parentElement)
    ];
} // Checks if element boundaries are equal
const $182daea206ea9c67$var$keys = [
    "x",
    "y",
    "top",
    "bottom",
    "left",
    "right",
    "width",
    "height"
];
const $182daea206ea9c67$var$areBoundsEqual = (a, b)=>$182daea206ea9c67$var$keys.every((key)=>a[key] === b[key]);



var $1bdO8 = parcelRequire("1bdO8");
var $3359b674b5255583$var$__defProp = Object.defineProperty;
var $3359b674b5255583$var$__defProps = Object.defineProperties;
var $3359b674b5255583$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $3359b674b5255583$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $3359b674b5255583$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $3359b674b5255583$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $3359b674b5255583$var$__defNormalProp = (obj, key, value)=>key in obj ? $3359b674b5255583$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $3359b674b5255583$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($3359b674b5255583$var$__hasOwnProp.call(b, prop)) $3359b674b5255583$var$__defNormalProp(a, prop, b[prop]);
    if ($3359b674b5255583$var$__getOwnPropSymbols) {
        for (var prop of $3359b674b5255583$var$__getOwnPropSymbols(b))if ($3359b674b5255583$var$__propIsEnum.call(b, prop)) $3359b674b5255583$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $3359b674b5255583$var$__spreadProps = (a, b)=>$3359b674b5255583$var$__defProps(a, $3359b674b5255583$var$__getOwnPropDescs(b));
function $3359b674b5255583$export$e2f435051054a3fd(fiber, ascending, selector) {
    if (!fiber) return;
    if (selector(fiber) === true) return fiber;
    let child = ascending ? fiber.return : fiber.child;
    while(child){
        const match = $3359b674b5255583$export$e2f435051054a3fd(child, ascending, selector);
        if (match) return match;
        child = ascending ? null : child.sibling;
    }
}
function $3359b674b5255583$var$wrapContext(context) {
    try {
        return Object.defineProperties(context, {
            _currentRenderer: {
                get () {
                    return null;
                },
                set () {}
            },
            _currentRenderer2: {
                get () {
                    return null;
                },
                set () {}
            }
        });
    } catch (_) {
        return context;
    }
}
const $3359b674b5255583$var$FiberContext = $3359b674b5255583$var$wrapContext($1bdO8.createContext(null));
class $3359b674b5255583$export$5a20fcbfd44d38b7 extends $1bdO8.Component {
    render() {
        return /* @__PURE__ */ $1bdO8.createElement($3359b674b5255583$var$FiberContext.Provider, {
            value: this._reactInternals
        }, this.props.children);
    }
}
const { ReactCurrentOwner: $3359b674b5255583$var$ReactCurrentOwner , ReactCurrentDispatcher: $3359b674b5255583$var$ReactCurrentDispatcher  } = $1bdO8.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
function $3359b674b5255583$export$69c8591d5df5c7d6() {
    const root = $1bdO8.useContext($3359b674b5255583$var$FiberContext);
    if (root === null) throw new Error("its-fine: useFiber must be called within a <FiberProvider />!");
    const id = $1bdO8.useId();
    const fiber = $1bdO8.useMemo(()=>{
        for (const maybeFiber of [
            $3359b674b5255583$var$ReactCurrentOwner == null ? void 0 : $3359b674b5255583$var$ReactCurrentOwner.current,
            root,
            root == null ? void 0 : root.alternate
        ]){
            if (!maybeFiber) continue;
            const fiber2 = $3359b674b5255583$export$e2f435051054a3fd(maybeFiber, false, (node)=>{
                let state = node.memoizedState;
                while(state){
                    if (state.memoizedState === id) return true;
                    state = state.next;
                }
            });
            if (fiber2) return fiber2;
        }
    }, [
        root,
        id
    ]);
    return fiber;
}
function $3359b674b5255583$export$b537cf6ebaf7ff54() {
    const fiber = $3359b674b5255583$export$69c8591d5df5c7d6();
    const root = $1bdO8.useMemo(()=>$3359b674b5255583$export$e2f435051054a3fd(fiber, true, (node)=>{
            var _a;
            return ((_a = node.stateNode) == null ? void 0 : _a.containerInfo) != null;
        }), [
        fiber
    ]);
    return root == null ? void 0 : root.stateNode.containerInfo;
}
function $3359b674b5255583$export$aec415ac1d7388b6(type) {
    const fiber = $3359b674b5255583$export$69c8591d5df5c7d6();
    const childRef = $1bdO8.useRef();
    $1bdO8.useLayoutEffect(()=>{
        var _a;
        childRef.current = (_a = $3359b674b5255583$export$e2f435051054a3fd(fiber, false, (node)=>typeof node.type === "string" && (type === void 0 || node.type === type))) == null ? void 0 : _a.stateNode;
    }, [
        fiber
    ]);
    return childRef;
}
function $3359b674b5255583$export$b57c9fdd1434988b(type) {
    const fiber = $3359b674b5255583$export$69c8591d5df5c7d6();
    const parentRef = $1bdO8.useRef();
    $1bdO8.useLayoutEffect(()=>{
        var _a;
        parentRef.current = (_a = $3359b674b5255583$export$e2f435051054a3fd(fiber, true, (node)=>typeof node.type === "string" && (type === void 0 || node.type === type))) == null ? void 0 : _a.stateNode;
    }, [
        fiber
    ]);
    return parentRef;
}
function $3359b674b5255583$export$8859381a76e56404() {
    var _a, _b;
    const fiber = $3359b674b5255583$export$69c8591d5df5c7d6();
    const [contextMap] = $1bdO8.useState(()=>/* @__PURE__ */ new Map());
    contextMap.clear();
    let node = fiber;
    while(node){
        const context = (_a = node.type) == null ? void 0 : _a._context;
        if (context && context !== $3359b674b5255583$var$FiberContext && !contextMap.has(context)) contextMap.set(context, (_b = $3359b674b5255583$var$ReactCurrentDispatcher == null ? void 0 : $3359b674b5255583$var$ReactCurrentDispatcher.current) == null ? void 0 : _b.readContext($3359b674b5255583$var$wrapContext(context)));
        node = node.return;
    }
    return contextMap;
}
function $3359b674b5255583$export$39579d26c695d393() {
    const contextMap = $3359b674b5255583$export$8859381a76e56404();
    return $1bdO8.useMemo(()=>Array.from(contextMap.keys()).reduce((Prev, context)=>(props)=>/* @__PURE__ */ $1bdO8.createElement(Prev, null, /* @__PURE__ */ $1bdO8.createElement(context.Provider, $3359b674b5255583$var$__spreadProps($3359b674b5255583$var$__spreadValues({}, props), {
                    value: contextMap.get(context)
                }))), (props)=>/* @__PURE__ */ $1bdO8.createElement($3359b674b5255583$export$5a20fcbfd44d38b7, $3359b674b5255583$var$__spreadValues({}, props))), [
        contextMap
    ]);
}





parcelRequire("cpxvE");

const $f62429bf2abe05cb$var$DOM_EVENTS = {
    onClick: [
        "click",
        false
    ],
    onContextMenu: [
        "contextmenu",
        false
    ],
    onDoubleClick: [
        "dblclick",
        false
    ],
    onWheel: [
        "wheel",
        true
    ],
    onPointerDown: [
        "pointerdown",
        true
    ],
    onPointerUp: [
        "pointerup",
        true
    ],
    onPointerLeave: [
        "pointerleave",
        true
    ],
    onPointerMove: [
        "pointermove",
        true
    ],
    onPointerCancel: [
        "pointercancel",
        true
    ],
    onLostPointerCapture: [
        "lostpointercapture",
        true
    ]
};
/** Default R3F event manager for web */ function $f62429bf2abe05cb$export$4bf9923669ad6c63(store) {
    const { handlePointer: handlePointer  } = (0, $e0e1f88defa94a87$export$db3b6bfb95261072)(store);
    return {
        priority: 1,
        enabled: true,
        compute (event, state, previous) {
            // https://github.com/pmndrs/react-three-fiber/pull/782
            // Events trigger outside of canvas when moved, use offsetX/Y by default and allow overrides
            state.pointer.set(event.offsetX / state.size.width * 2 - 1, -(event.offsetY / state.size.height) * 2 + 1);
            state.raycaster.setFromCamera(state.pointer, state.camera);
        },
        connected: undefined,
        handlers: Object.keys($f62429bf2abe05cb$var$DOM_EVENTS).reduce((acc, key)=>({
                ...acc,
                [key]: handlePointer(key)
            }), {}),
        update: ()=>{
            var _internal$lastEvent;
            const { events: events , internal: internal  } = store.getState();
            if ((_internal$lastEvent = internal.lastEvent) != null && _internal$lastEvent.current && events.handlers) events.handlers.onPointerMove(internal.lastEvent.current);
        },
        connect: (target)=>{
            var _events$handlers;
            const { set: set , events: events  } = store.getState();
            events.disconnect == null || events.disconnect();
            set((state)=>({
                    events: {
                        ...state.events,
                        connected: target
                    }
                }));
            Object.entries((_events$handlers = events.handlers) != null ? _events$handlers : []).forEach(([name, event])=>{
                const [eventName, passive] = $f62429bf2abe05cb$var$DOM_EVENTS[name];
                target.addEventListener(eventName, event, {
                    passive: passive
                });
            });
        },
        disconnect: ()=>{
            const { set: set , events: events  } = store.getState();
            if (events.connected) {
                var _events$handlers2;
                Object.entries((_events$handlers2 = events.handlers) != null ? _events$handlers2 : []).forEach(([name, event])=>{
                    if (events && events.connected instanceof HTMLElement) {
                        const [eventName] = $f62429bf2abe05cb$var$DOM_EVENTS[name];
                        events.connected.removeEventListener(eventName, event);
                    }
                });
                set((state)=>({
                        events: {
                            ...state.events,
                            connected: undefined
                        }
                    }));
            }
        }
    };
}
const $f62429bf2abe05cb$var$CanvasImpl = /*#__PURE__*/ $1bdO8.forwardRef(function Canvas({ children: children , fallback: fallback , resize: resize , style: style , gl: gl , events: events = $f62429bf2abe05cb$export$4bf9923669ad6c63 , eventSource: eventSource , eventPrefix: eventPrefix , shadows: shadows , linear: linear , flat: flat , legacy: legacy , orthographic: orthographic , frameloop: frameloop , dpr: dpr , performance: performance , raycaster: raycaster , camera: camera , onPointerMissed: onPointerMissed , onCreated: onCreated , ...props }, forwardedRef) {
    // Create a known catalogue of Threejs-native elements
    // This will include the entire THREE namespace by default, users can extend
    // their own elements by using the createRoot API instead
    $1bdO8.useMemo(()=>(0, $e0e1f88defa94a87$export$f1e1789686576879)($e8ea6a63d48a4fea$exports), []);
    const Bridge = (0, $3359b674b5255583$export$39579d26c695d393)();
    const [containerRef, containerRect] = (0, $182daea206ea9c67$export$2e2bcd8739ae039)({
        scroll: true,
        debounce: {
            scroll: 50,
            resize: 0
        },
        ...resize
    });
    const canvasRef = $1bdO8.useRef(null);
    const divRef = $1bdO8.useRef(null);
    $1bdO8.useImperativeHandle(forwardedRef, ()=>canvasRef.current);
    const handlePointerMissed = (0, $e0e1f88defa94a87$export$3b14a55fb2447963)(onPointerMissed);
    const [block, setBlock] = $1bdO8.useState(false);
    const [error, setError] = $1bdO8.useState(false);
    // Suspend this component if block is a promise (2nd run)
    if (block) throw block;
    // Throw exception outwards if anything within canvas throws
    if (error) throw error;
    const root = $1bdO8.useRef(null);
    (0, $e0e1f88defa94a87$export$407448d2b89b1813)(()=>{
        const canvas = canvasRef.current;
        if (containerRect.width > 0 && containerRect.height > 0 && canvas) {
            if (!root.current) root.current = (0, $e0e1f88defa94a87$export$8b22cf2602fb60ce)(canvas);
            root.current.configure({
                gl: gl,
                events: events,
                shadows: shadows,
                linear: linear,
                flat: flat,
                legacy: legacy,
                orthographic: orthographic,
                frameloop: frameloop,
                dpr: dpr,
                performance: performance,
                raycaster: raycaster,
                camera: camera,
                size: containerRect,
                // Pass mutable reference to onPointerMissed so it's free to update
                onPointerMissed: (...args)=>handlePointerMissed.current == null ? void 0 : handlePointerMissed.current(...args),
                onCreated: (state)=>{
                    // Connect to event source
                    state.events.connect == null || state.events.connect(eventSource ? (0, $e0e1f88defa94a87$export$23f2a1d2818174ef)(eventSource) ? eventSource.current : eventSource : divRef.current);
                    // Set up compute function
                    if (eventPrefix) state.setEvents({
                        compute: (event, state)=>{
                            const x = event[eventPrefix + "X"];
                            const y = event[eventPrefix + "Y"];
                            state.pointer.set(x / state.size.width * 2 - 1, -(y / state.size.height) * 2 + 1);
                            state.raycaster.setFromCamera(state.pointer, state.camera);
                        }
                    });
                    // Call onCreated callback
                    onCreated == null || onCreated(state);
                }
            });
            root.current.render(/*#__PURE__*/ $1bdO8.createElement(Bridge, null, /*#__PURE__*/ $1bdO8.createElement((0, $e0e1f88defa94a87$export$a9c23c6ac3fc3eca), {
                set: setError
            }, /*#__PURE__*/ $1bdO8.createElement($1bdO8.Suspense, {
                fallback: /*#__PURE__*/ $1bdO8.createElement((0, $e0e1f88defa94a87$export$ef35774e6d314e91), {
                    set: setBlock
                })
            }, children))));
        }
    });
    $1bdO8.useEffect(()=>{
        const canvas = canvasRef.current;
        if (canvas) return ()=>(0, $e0e1f88defa94a87$export$4368d992c4eafac0)(canvas);
    }, []);
    // When the event source is not this div, we need to set pointer-events to none
    // Or else the canvas will block events from reaching the event source
    const pointerEvents = eventSource ? "none" : "auto";
    return /*#__PURE__*/ $1bdO8.createElement("div", (0, $63nUy.default)({
        ref: divRef,
        style: {
            position: "relative",
            width: "100%",
            height: "100%",
            overflow: "hidden",
            pointerEvents: pointerEvents,
            ...style
        }
    }, props), /*#__PURE__*/ $1bdO8.createElement("div", {
        ref: containerRef,
        style: {
            width: "100%",
            height: "100%"
        }
    }, /*#__PURE__*/ $1bdO8.createElement("canvas", {
        ref: canvasRef,
        style: {
            display: "block"
        }
    }, fallback)));
});
/**
 * A DOM canvas which accepts threejs elements as children.
 * @see https://docs.pmnd.rs/react-three-fiber/api/canvas
 */ const $f62429bf2abe05cb$export$8d01c972ee8b14a9 = /*#__PURE__*/ $1bdO8.forwardRef(function CanvasWrapper(props, ref) {
    return /*#__PURE__*/ $1bdO8.createElement((0, $3359b674b5255583$export$5a20fcbfd44d38b7), null, /*#__PURE__*/ $1bdO8.createElement($f62429bf2abe05cb$var$CanvasImpl, (0, $63nUy.default)({}, props, {
        ref: ref
    })));
});



var $cVgDf = parcelRequire("cVgDf");

var $1bdO8 = parcelRequire("1bdO8");

var $cVgDf = parcelRequire("cVgDf");



var $1bdO8 = parcelRequire("1bdO8");
const $8431ce295a7a55af$export$e64f6626d4e96cfb = (url)=>url === Object(url) && !Array.isArray(url) && typeof url !== "function";
function $8431ce295a7a55af$export$5dd4f4a1dff269b2(input, onLoad) {
    const gl = (0, $e0e1f88defa94a87$export$df995fae86a55f06)((state)=>state.gl);
    const textures = (0, $e0e1f88defa94a87$export$96f57966bedc81b4)((0, $e8ea6a63d48a4fea$export$fd1bfc71f64c538c), $8431ce295a7a55af$export$e64f6626d4e96cfb(input) ? Object.values(input) : input);
    (0, $1bdO8.useLayoutEffect)(()=>{
        onLoad == null || onLoad(textures);
    }, [
        onLoad
    ]); // https://github.com/mrdoob/three.js/issues/22696
    // Upload the texture to the GPU immediately instead of waiting for the first render
    (0, $1bdO8.useEffect)(()=>{
        const array = Array.isArray(textures) ? textures : [
            textures
        ];
        array.forEach(gl.initTexture);
    }, [
        gl,
        textures
    ]);
    if ($8431ce295a7a55af$export$e64f6626d4e96cfb(input)) {
        const keys = Object.keys(input);
        const keyed = {};
        keys.forEach((key)=>Object.assign(keyed, {
                [key]: textures[keys.indexOf(key)]
            }));
        return keyed;
    } else return textures;
}
$8431ce295a7a55af$export$5dd4f4a1dff269b2.preload = (url)=>(0, $e0e1f88defa94a87$export$96f57966bedc81b4).preload((0, $e8ea6a63d48a4fea$export$fd1bfc71f64c538c), url);
$8431ce295a7a55af$export$5dd4f4a1dff269b2.clear = (input)=>(0, $e0e1f88defa94a87$export$96f57966bedc81b4).clear((0, $e8ea6a63d48a4fea$export$fd1bfc71f64c538c), input);



var $1bdO8 = parcelRequire("1bdO8");

var $e4ad74bf317323c8$exports = {};

$e4ad74bf317323c8$exports = new URL((parcelRequire("hMn6r")).resolve("dt7E1"), import.meta.url).toString();



class $760519a16effc22a$var$PointsMaterial extends $e8ea6a63d48a4fea$export$21c421a2e1df9d22 {
    constructor(){
        super({
            transparent: false,
            depthFunc: $e8ea6a63d48a4fea$export$eedccec66ab7ebe,
            vertexShader: /* glsl */ `#version 300 es
        uniform mat4 projectionMatrix;
        uniform mat4 modelViewMatrix;
        uniform vec2 resolution;
        uniform float pointSize;
        uniform sampler2D colors;
        in vec3 position;
        in float color;
        in uint id;
        out highp vec3 vColor;
        out float vPointSize;

        void main() {
          gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
          gl_PointSize = pointSize;
          vPointSize = pointSize;
          vColor = texture(colors, vec2(color, 0.5)).rgb;
        }
      `,
            fragmentShader: /* glsl */ `#version 300 es
        precision highp float;
        uniform vec2 resolution;
        uniform float edgeSize;
        uniform sampler2D dotTexture;
        in vec3 vColor;
        in float vPointSize;
        out vec4 fragColor;

        void main() {
          float alpha = texture(dotTexture, gl_PointCoord).r;
          fragColor = vec4(vColor * alpha, 1.0);
          float pixelSize = 1.0 / vPointSize;
          float r = length(gl_PointCoord - vec2(0.5));

          if (alpha < 0.1) discard;
          fragColor.a = alpha;

          float edgeAlpha = smoothstep(0.5 - edgeSize * pixelSize, 0.5, 1.0 - edgeSize * 2.0 * pixelSize - r);

          vec3 edgeColor = vec3(1.0);

          if (edgeSize > 0.5) {
            fragColor.rgb = mix(vColor, edgeColor, 1.0 - edgeAlpha);
          }
        }
      `,
            uniforms: {
                pointSize: new $e8ea6a63d48a4fea$export$2947cebfe91c02f8(10),
                colors: new $e8ea6a63d48a4fea$export$2947cebfe91c02f8(null),
                dotTexture: new $e8ea6a63d48a4fea$export$2947cebfe91c02f8(null),
                edgeSize: new $e8ea6a63d48a4fea$export$2947cebfe91c02f8(0)
            }
        });
    }
}
const $760519a16effc22a$var$PointsViewInstance = ({ geometry: geometry , pointSize: pointSize = 10 , edgeSize: edgeSize = 0 , colorsTexture: colorsTexture , dotTexture: dotTexture , selection: selection , depthFunc: depthFunc = $e8ea6a63d48a4fea$export$eedccec66ab7ebe , renderOrder: renderOrder = 0  })=>{
    const { invalidate: invalidate  } = (0, $e0e1f88defa94a87$export$df995fae86a55f06)();
    const instanceGeometry = (0, $1bdO8.useMemo)(()=>{
        const instanceGeometry = new $e8ea6a63d48a4fea$export$b7be63a67df8959();
        instanceGeometry.attributes = geometry.attributes;
        return instanceGeometry;
    }, [
        geometry
    ]);
    const material = (0, $1bdO8.useMemo)(()=>new $760519a16effc22a$var$PointsMaterial(), []);
    (0, $1bdO8.useEffect)(()=>{
        material.uniforms.pointSize.value = pointSize;
        material.uniforms.colors.value = colorsTexture || null;
        material.uniforms.dotTexture.value = dotTexture || null;
        material.uniforms.edgeSize.value = edgeSize;
        material.depthFunc = depthFunc;
        material.needsUpdate = true;
        invalidate();
    }, [
        material,
        pointSize,
        colorsTexture,
        dotTexture,
        depthFunc,
        edgeSize,
        invalidate
    ]);
    // Update groups
    (0, $1bdO8.useEffect)(()=>{
        instanceGeometry.attributes = geometry.attributes;
        instanceGeometry.setIndex(selection ?? null);
        invalidate();
    }, [
        geometry,
        selection
    ]);
    // Live reload material update
    (0, $1bdO8.useEffect)(()=>{
        material.version++;
    }, [
        "hot"
    ]);
    return /*#__PURE__*/ (0, $cVgDf.jsx)("points", {
        frustumCulled: false,
        geometry: instanceGeometry,
        material: material,
        renderOrder: renderOrder
    });
};
const $760519a16effc22a$export$acc61d9bc0df10b1 = ({ geometry: geometry , pointSize: pointSize = 10 , selected: selected , highlighted: highlighted , colorsTexture: colorsTexture  })=>{
    const dotTexture = (0, $8431ce295a7a55af$export$5dd4f4a1dff269b2)((0, (/*@__PURE__*/$parcel$interopDefault($e4ad74bf317323c8$exports))));
    return /*#__PURE__*/ (0, $cVgDf.jsxs)("group", {
        children: [
            /*#__PURE__*/ (0, $cVgDf.jsx)($760519a16effc22a$var$PointsViewInstance, {
                geometry: geometry,
                pointSize: pointSize,
                colorsTexture: colorsTexture,
                dotTexture: dotTexture
            }),
            /*#__PURE__*/ (0, $cVgDf.jsx)($760519a16effc22a$var$PointsViewInstance, {
                geometry: geometry,
                pointSize: pointSize + 4,
                edgeSize: 3,
                colorsTexture: colorsTexture,
                dotTexture: dotTexture,
                selection: selected,
                depthFunc: $e8ea6a63d48a4fea$export$7182eb52ea3b3f04,
                renderOrder: 1
            }),
            /*#__PURE__*/ (0, $cVgDf.jsx)($760519a16effc22a$var$PointsViewInstance, {
                geometry: geometry,
                pointSize: pointSize + 16,
                edgeSize: 4,
                colorsTexture: colorsTexture,
                dotTexture: dotTexture,
                selection: highlighted,
                depthFunc: $e8ea6a63d48a4fea$export$7182eb52ea3b3f04,
                renderOrder: 2
            })
        ]
    });
};






/*!
 * camera-controls
 * https://github.com/yomotsu/camera-controls
 * (c) 2017 @yomotsu
 * Released under the MIT License.
 */ // see https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons#value
const $625a33e30390866c$var$MOUSE_BUTTON = {
    LEFT: 1,
    RIGHT: 2,
    MIDDLE: 4
};
const $625a33e30390866c$var$ACTION = Object.freeze({
    NONE: 0,
    ROTATE: 1,
    TRUCK: 2,
    OFFSET: 4,
    DOLLY: 8,
    ZOOM: 16,
    TOUCH_ROTATE: 32,
    TOUCH_TRUCK: 64,
    TOUCH_OFFSET: 128,
    TOUCH_DOLLY: 256,
    TOUCH_ZOOM: 512,
    TOUCH_DOLLY_TRUCK: 1024,
    TOUCH_DOLLY_OFFSET: 2048,
    TOUCH_DOLLY_ROTATE: 4096,
    TOUCH_ZOOM_TRUCK: 8192,
    TOUCH_ZOOM_OFFSET: 16384,
    TOUCH_ZOOM_ROTATE: 32768
});
function $625a33e30390866c$var$isPerspectiveCamera(camera) {
    return camera.isPerspectiveCamera;
}
function $625a33e30390866c$var$isOrthographicCamera(camera) {
    return camera.isOrthographicCamera;
}
const $625a33e30390866c$var$PI_2 = Math.PI * 2;
const $625a33e30390866c$var$PI_HALF = Math.PI / 2;
const $625a33e30390866c$var$EPSILON = 1e-5;
const $625a33e30390866c$var$DEG2RAD = Math.PI / 180;
function $625a33e30390866c$var$clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
function $625a33e30390866c$var$approxZero(number, error = $625a33e30390866c$var$EPSILON) {
    return Math.abs(number) < error;
}
function $625a33e30390866c$var$approxEquals(a, b, error = $625a33e30390866c$var$EPSILON) {
    return $625a33e30390866c$var$approxZero(a - b, error);
}
function $625a33e30390866c$var$roundToStep(value, step) {
    return Math.round(value / step) * step;
}
function $625a33e30390866c$var$infinityToMaxNumber(value) {
    if (isFinite(value)) return value;
    if (value < 0) return -Number.MAX_VALUE;
    return Number.MAX_VALUE;
}
function $625a33e30390866c$var$maxNumberToInfinity(value) {
    if (Math.abs(value) < Number.MAX_VALUE) return value;
    return value * Infinity;
}
// https://docs.unity3d.com/ScriptReference/Mathf.SmoothDamp.html
// https://github.com/Unity-Technologies/UnityCsReference/blob/a2bdfe9b3c4cd4476f44bf52f848063bfaf7b6b9/Runtime/Export/Math/Mathf.cs#L308
function $625a33e30390866c$var$smoothDamp(current, target, currentVelocityRef, smoothTime, maxSpeed = Infinity, deltaTime) {
    // Based on Game Programming Gems 4 Chapter 1.10
    smoothTime = Math.max(0.0001, smoothTime);
    const omega = 2 / smoothTime;
    const x = omega * deltaTime;
    const exp = 1 / (1 + x + 0.48 * x * x + 0.235 * x * x * x);
    let change = current - target;
    const originalTo = target;
    // Clamp maximum speed
    const maxChange = maxSpeed * smoothTime;
    change = $625a33e30390866c$var$clamp(change, -maxChange, maxChange);
    target = current - change;
    const temp = (currentVelocityRef.value + omega * change) * deltaTime;
    currentVelocityRef.value = (currentVelocityRef.value - omega * temp) * exp;
    let output = target + (change + temp) * exp;
    // Prevent overshooting
    if (originalTo - current > 0.0 === output > originalTo) {
        output = originalTo;
        currentVelocityRef.value = (output - originalTo) / deltaTime;
    }
    return output;
}
// https://docs.unity3d.com/ScriptReference/Vector3.SmoothDamp.html
// https://github.com/Unity-Technologies/UnityCsReference/blob/a2bdfe9b3c4cd4476f44bf52f848063bfaf7b6b9/Runtime/Export/Math/Vector3.cs#L97
function $625a33e30390866c$var$smoothDampVec3(current, target, currentVelocityRef, smoothTime, maxSpeed = Infinity, deltaTime, out) {
    // Based on Game Programming Gems 4 Chapter 1.10
    smoothTime = Math.max(0.0001, smoothTime);
    const omega = 2 / smoothTime;
    const x = omega * deltaTime;
    const exp = 1 / (1 + x + 0.48 * x * x + 0.235 * x * x * x);
    let targetX = target.x;
    let targetY = target.y;
    let targetZ = target.z;
    let changeX = current.x - targetX;
    let changeY = current.y - targetY;
    let changeZ = current.z - targetZ;
    const originalToX = targetX;
    const originalToY = targetY;
    const originalToZ = targetZ;
    // Clamp maximum speed
    const maxChange = maxSpeed * smoothTime;
    const maxChangeSq = maxChange * maxChange;
    const magnitudeSq = changeX * changeX + changeY * changeY + changeZ * changeZ;
    if (magnitudeSq > maxChangeSq) {
        const magnitude = Math.sqrt(magnitudeSq);
        changeX = changeX / magnitude * maxChange;
        changeY = changeY / magnitude * maxChange;
        changeZ = changeZ / magnitude * maxChange;
    }
    targetX = current.x - changeX;
    targetY = current.y - changeY;
    targetZ = current.z - changeZ;
    const tempX = (currentVelocityRef.x + omega * changeX) * deltaTime;
    const tempY = (currentVelocityRef.y + omega * changeY) * deltaTime;
    const tempZ = (currentVelocityRef.z + omega * changeZ) * deltaTime;
    currentVelocityRef.x = (currentVelocityRef.x - omega * tempX) * exp;
    currentVelocityRef.y = (currentVelocityRef.y - omega * tempY) * exp;
    currentVelocityRef.z = (currentVelocityRef.z - omega * tempZ) * exp;
    out.x = targetX + (changeX + tempX) * exp;
    out.y = targetY + (changeY + tempY) * exp;
    out.z = targetZ + (changeZ + tempZ) * exp;
    // Prevent overshooting
    const origMinusCurrentX = originalToX - current.x;
    const origMinusCurrentY = originalToY - current.y;
    const origMinusCurrentZ = originalToZ - current.z;
    const outMinusOrigX = out.x - originalToX;
    const outMinusOrigY = out.y - originalToY;
    const outMinusOrigZ = out.z - originalToZ;
    if (origMinusCurrentX * outMinusOrigX + origMinusCurrentY * outMinusOrigY + origMinusCurrentZ * outMinusOrigZ > 0) {
        out.x = originalToX;
        out.y = originalToY;
        out.z = originalToZ;
        currentVelocityRef.x = (out.x - originalToX) / deltaTime;
        currentVelocityRef.y = (out.y - originalToY) / deltaTime;
        currentVelocityRef.z = (out.z - originalToZ) / deltaTime;
    }
    return out;
}
function $625a33e30390866c$var$extractClientCoordFromEvent(pointers, out) {
    out.set(0, 0);
    pointers.forEach((pointer)=>{
        out.x += pointer.clientX;
        out.y += pointer.clientY;
    });
    out.x /= pointers.length;
    out.y /= pointers.length;
}
function $625a33e30390866c$var$notSupportedInOrthographicCamera(camera, message) {
    if ($625a33e30390866c$var$isOrthographicCamera(camera)) {
        console.warn(`${message} is not supported in OrthographicCamera`);
        return true;
    }
    return false;
}
class $625a33e30390866c$var$EventDispatcher {
    constructor(){
        this._listeners = {};
    }
    /**
     * Adds the specified event listener.
     * @param type event name
     * @param listener handler function
     * @category Methods
     */ addEventListener(type, listener) {
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
    }
    /**
     * Presence of the specified event listener.
     * @param type event name
     * @param listener handler function
     * @category Methods
     */ hasEventListener(type, listener) {
        const listeners = this._listeners;
        return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
    }
    /**
     * Removes the specified event listener
     * @param type event name
     * @param listener handler function
     * @category Methods
     */ removeEventListener(type, listener) {
        const listeners = this._listeners;
        const listenerArray = listeners[type];
        if (listenerArray !== undefined) {
            const index = listenerArray.indexOf(listener);
            if (index !== -1) listenerArray.splice(index, 1);
        }
    }
    /**
     * Removes all event listeners
     * @param type event name
     * @category Methods
     */ removeAllEventListeners(type) {
        if (!type) {
            this._listeners = {};
            return;
        }
        if (Array.isArray(this._listeners[type])) this._listeners[type].length = 0;
    }
    /**
     * Fire an event type.
     * @param event DispatcherEvent
     * @category Methods
     */ dispatchEvent(event) {
        const listeners = this._listeners;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            const array = listenerArray.slice(0);
            for(let i = 0, l = array.length; i < l; i++)array[i].call(this, event);
        }
    }
}
const $625a33e30390866c$var$VERSION = "2.3.5"; // will be replaced with `version` in package.json during the build process.
const $625a33e30390866c$var$TOUCH_DOLLY_FACTOR = 1 / 8;
const $625a33e30390866c$var$isBrowser = typeof window !== "undefined";
const $625a33e30390866c$var$isMac = $625a33e30390866c$var$isBrowser && /Mac/.test(navigator.platform);
const $625a33e30390866c$var$isPointerEventsNotSupported = !($625a33e30390866c$var$isBrowser && "PointerEvent" in window); // macOS Safari 12 does not support PointerEvents API
let $625a33e30390866c$var$THREE;
let $625a33e30390866c$var$_ORIGIN;
let $625a33e30390866c$var$_AXIS_Y;
let $625a33e30390866c$var$_AXIS_Z;
let $625a33e30390866c$var$_v2;
let $625a33e30390866c$var$_v3A;
let $625a33e30390866c$var$_v3B;
let $625a33e30390866c$var$_v3C;
let $625a33e30390866c$var$_xColumn;
let $625a33e30390866c$var$_yColumn;
let $625a33e30390866c$var$_zColumn;
let $625a33e30390866c$var$_deltaTarget;
let $625a33e30390866c$var$_deltaOffset;
let $625a33e30390866c$var$_sphericalA;
let $625a33e30390866c$var$_sphericalB;
let $625a33e30390866c$var$_box3A;
let $625a33e30390866c$var$_box3B;
let $625a33e30390866c$var$_sphere;
let $625a33e30390866c$var$_quaternionA;
let $625a33e30390866c$var$_quaternionB;
let $625a33e30390866c$var$_rotationMatrix;
let $625a33e30390866c$var$_raycaster;
class $625a33e30390866c$export$2e2bcd8739ae039 extends $625a33e30390866c$var$EventDispatcher {
    /**
     * Injects THREE as the dependency. You can then proceed to use CameraControls.
     *
     * e.g
     * ```javascript
     * CameraControls.install( { THREE: THREE } );
     * ```
     *
     * Note: If you do not wish to use enter three.js to reduce file size(tree-shaking for example), make a subset to install.
     *
     * ```js
     * import {
     * 	Vector2,
     * 	Vector3,
     * 	Vector4,
     * 	Quaternion,
     * 	Matrix4,
     * 	Spherical,
     * 	Box3,
     * 	Sphere,
     * 	Raycaster,
     * 	MathUtils,
     * } from 'three';
     *
     * const subsetOfTHREE = {
     * 	Vector2   : Vector2,
     * 	Vector3   : Vector3,
     * 	Vector4   : Vector4,
     * 	Quaternion: Quaternion,
     * 	Matrix4   : Matrix4,
     * 	Spherical : Spherical,
     * 	Box3      : Box3,
     * 	Sphere    : Sphere,
     * 	Raycaster : Raycaster,
     * };

     * CameraControls.install( { THREE: subsetOfTHREE } );
     * ```
     * @category Statics
     */ static install(libs) {
        $625a33e30390866c$var$THREE = libs.THREE;
        $625a33e30390866c$var$_ORIGIN = Object.freeze(new $625a33e30390866c$var$THREE.Vector3(0, 0, 0));
        $625a33e30390866c$var$_AXIS_Y = Object.freeze(new $625a33e30390866c$var$THREE.Vector3(0, 1, 0));
        $625a33e30390866c$var$_AXIS_Z = Object.freeze(new $625a33e30390866c$var$THREE.Vector3(0, 0, 1));
        $625a33e30390866c$var$_v2 = new $625a33e30390866c$var$THREE.Vector2();
        $625a33e30390866c$var$_v3A = new $625a33e30390866c$var$THREE.Vector3();
        $625a33e30390866c$var$_v3B = new $625a33e30390866c$var$THREE.Vector3();
        $625a33e30390866c$var$_v3C = new $625a33e30390866c$var$THREE.Vector3();
        $625a33e30390866c$var$_xColumn = new $625a33e30390866c$var$THREE.Vector3();
        $625a33e30390866c$var$_yColumn = new $625a33e30390866c$var$THREE.Vector3();
        $625a33e30390866c$var$_zColumn = new $625a33e30390866c$var$THREE.Vector3();
        $625a33e30390866c$var$_deltaTarget = new $625a33e30390866c$var$THREE.Vector3();
        $625a33e30390866c$var$_deltaOffset = new $625a33e30390866c$var$THREE.Vector3();
        $625a33e30390866c$var$_sphericalA = new $625a33e30390866c$var$THREE.Spherical();
        $625a33e30390866c$var$_sphericalB = new $625a33e30390866c$var$THREE.Spherical();
        $625a33e30390866c$var$_box3A = new $625a33e30390866c$var$THREE.Box3();
        $625a33e30390866c$var$_box3B = new $625a33e30390866c$var$THREE.Box3();
        $625a33e30390866c$var$_sphere = new $625a33e30390866c$var$THREE.Sphere();
        $625a33e30390866c$var$_quaternionA = new $625a33e30390866c$var$THREE.Quaternion();
        $625a33e30390866c$var$_quaternionB = new $625a33e30390866c$var$THREE.Quaternion();
        $625a33e30390866c$var$_rotationMatrix = new $625a33e30390866c$var$THREE.Matrix4();
        $625a33e30390866c$var$_raycaster = new $625a33e30390866c$var$THREE.Raycaster();
    }
    /**
     * list all ACTIONs
     * @category Statics
     */ static get ACTION() {
        return $625a33e30390866c$var$ACTION;
    }
    /**
     * Creates a `CameraControls` instance.
     *
     * Note:
     * You **must install** three.js before using camera-controls. see [#install](#install)
     * Not doing so will lead to runtime errors (`undefined` references to THREE).
     *
     * e.g.
     * ```
     * CameraControls.install( { THREE } );
     * const cameraControls = new CameraControls( camera, domElement );
     * ```
     *
     * @param camera A `THREE.PerspectiveCamera` or `THREE.OrthographicCamera` to be controlled.
     * @param domElement A `HTMLElement` for the draggable area, usually `renderer.domElement`.
     * @category Constructor
     */ constructor(camera, domElement){
        super();
        /**
         * Minimum vertical angle in radians.
         * The angle has to be between `0` and `.maxPolarAngle` inclusive.
         * The default value is `0`.
         *
         * e.g.
         * ```
         * cameraControls.maxPolarAngle = 0;
         * ```
         * @category Properties
         */ this.minPolarAngle = 0; // radians
        /**
         * Maximum vertical angle in radians.
         * The angle has to be between `.maxPolarAngle` and `Math.PI` inclusive.
         * The default value is `Math.PI`.
         *
         * e.g.
         * ```
         * cameraControls.maxPolarAngle = Math.PI;
         * ```
         * @category Properties
         */ this.maxPolarAngle = Math.PI; // radians
        /**
         * Minimum horizontal angle in radians.
         * The angle has to be less than `.maxAzimuthAngle`.
         * The default value is `- Infinity`.
         *
         * e.g.
         * ```
         * cameraControls.minAzimuthAngle = - Infinity;
         * ```
         * @category Properties
         */ this.minAzimuthAngle = -Infinity; // radians
        /**
         * Maximum horizontal angle in radians.
         * The angle has to be greater than `.minAzimuthAngle`.
         * The default value is `Infinity`.
         *
         * e.g.
         * ```
         * cameraControls.maxAzimuthAngle = Infinity;
         * ```
         * @category Properties
         */ this.maxAzimuthAngle = Infinity; // radians
        // How far you can dolly in and out ( PerspectiveCamera only )
        /**
         * Minimum distance for dolly. The value must be higher than `0`.
         * PerspectiveCamera only.
         * @category Properties
         */ this.minDistance = 0;
        /**
         * Maximum distance for dolly. The value must be higher than `minDistance`.
         * PerspectiveCamera only.
         * @category Properties
         */ this.maxDistance = Infinity;
        /**
         * `true` to enable Infinity Dolly.
         * When the Dolly distance is less than the `minDistance`, radius of the sphere will be set `minDistance` automatically.
         * @category Properties
         */ this.infinityDolly = false;
        /**
         * Minimum camera zoom.
         * @category Properties
         */ this.minZoom = 0.01;
        /**
         * Maximum camera zoom.
         * @category Properties
         */ this.maxZoom = Infinity;
        /**
         * Approximate time in seconds to reach the target. A smaller value will reach the target faster.
         * @category Properties
         */ this.smoothTime = 0.25;
        /**
         * the smoothTime while dragging
         * @category Properties
         */ this.draggingSmoothTime = 0.125;
        /**
         * Max transition speed in unit-per-seconds
         * @category Properties
         */ this.maxSpeed = Infinity;
        /**
         * Speed of azimuth (horizontal) rotation.
         * @category Properties
         */ this.azimuthRotateSpeed = 1.0;
        /**
         * Speed of polar (vertical) rotation.
         * @category Properties
         */ this.polarRotateSpeed = 1.0;
        /**
         * Speed of mouse-wheel dollying.
         * @category Properties
         */ this.dollySpeed = 1.0;
        /**
         * `true` to invert direction when dollying or zooming via drag
         * @category Properties
         */ this.dollyDragInverted = false;
        /**
         * Speed of drag for truck and pedestal.
         * @category Properties
         */ this.truckSpeed = 2.0;
        /**
         * `true` to enable Dolly-in to the mouse cursor coords.
         * @category Properties
         */ this.dollyToCursor = false;
        /**
         * @category Properties
         */ this.dragToOffset = false;
        /**
         * The same as `.screenSpacePanning` in three.js's OrbitControls.
         * @category Properties
         */ this.verticalDragToForward = false;
        /**
         * Friction ratio of the boundary.
         * @category Properties
         */ this.boundaryFriction = 0.0;
        /**
         * Controls how soon the `rest` event fires as the camera slows.
         * @category Properties
         */ this.restThreshold = 0.01;
        /**
         * An array of Meshes to collide with camera.
         * Be aware colliderMeshes may decrease performance. The collision test uses 4 raycasters from the camera since the near plane has 4 corners.
         * @category Properties
         */ this.colliderMeshes = [];
        /**
         * Force cancel user dragging.
         * @category Methods
         */ // cancel will be overwritten in the constructor.
        this.cancel = ()=>{};
        this._enabled = true;
        this._state = $625a33e30390866c$var$ACTION.NONE;
        this._viewport = null;
        this._dollyControlAmount = 0;
        this._hasRested = true;
        this._boundaryEnclosesCamera = false;
        this._needsUpdate = true;
        this._updatedLastTime = false;
        this._elementRect = new DOMRect();
        this._isDragging = false;
        this._activePointers = [];
        this._lockedPointer = null;
        // Use draggingSmoothTime over smoothTime while true.
        // set automatically true on user-dragging start.
        // set automatically false on programmable methods call.
        this._isUserControllingRotate = false;
        this._isUserControllingDolly = false;
        this._isUserControllingTruck = false;
        this._isUserControllingOffset = false;
        this._isUserControllingZoom = false;
        // velocities for smoothDamp
        this._thetaVelocity = {
            value: 0
        };
        this._phiVelocity = {
            value: 0
        };
        this._radiusVelocity = {
            value: 0
        };
        this._targetVelocity = new $625a33e30390866c$var$THREE.Vector3();
        this._focalOffsetVelocity = new $625a33e30390866c$var$THREE.Vector3();
        this._zoomVelocity = {
            value: 0
        };
        this._truckInternal = (deltaX, deltaY, dragToOffset)=>{
            let truckX;
            let pedestalY;
            if ($625a33e30390866c$var$isPerspectiveCamera(this._camera)) {
                const offset = $625a33e30390866c$var$_v3A.copy(this._camera.position).sub(this._target);
                // half of the fov is center to top of screen
                const fov = this._camera.getEffectiveFOV() * $625a33e30390866c$var$DEG2RAD;
                const targetDistance = offset.length() * Math.tan(fov * 0.5);
                truckX = this.truckSpeed * deltaX * targetDistance / this._elementRect.height;
                pedestalY = this.truckSpeed * deltaY * targetDistance / this._elementRect.height;
            } else if ($625a33e30390866c$var$isOrthographicCamera(this._camera)) {
                const camera = this._camera;
                truckX = deltaX * (camera.right - camera.left) / camera.zoom / this._elementRect.width;
                pedestalY = deltaY * (camera.top - camera.bottom) / camera.zoom / this._elementRect.height;
            } else return;
            if (this.verticalDragToForward) {
                dragToOffset ? this.setFocalOffset(this._focalOffsetEnd.x + truckX, this._focalOffsetEnd.y, this._focalOffsetEnd.z, true) : this.truck(truckX, 0, true);
                this.forward(-pedestalY, true);
            } else dragToOffset ? this.setFocalOffset(this._focalOffsetEnd.x + truckX, this._focalOffsetEnd.y + pedestalY, this._focalOffsetEnd.z, true) : this.truck(truckX, pedestalY, true);
        };
        this._rotateInternal = (deltaX, deltaY)=>{
            const theta = $625a33e30390866c$var$PI_2 * this.azimuthRotateSpeed * deltaX / this._elementRect.height; // divide by *height* to refer the resolution
            const phi = $625a33e30390866c$var$PI_2 * this.polarRotateSpeed * deltaY / this._elementRect.height;
            this.rotate(theta, phi, true);
        };
        this._dollyInternal = (delta, x, y)=>{
            const dollyScale = Math.pow(0.95, -delta * this.dollySpeed);
            const distance = this._sphericalEnd.radius * dollyScale;
            const prevRadius = this._sphericalEnd.radius;
            const signedPrevRadius = prevRadius * (delta >= 0 ? -1 : 1);
            this.dollyTo(distance);
            if (this.infinityDolly && (distance < this.minDistance || this.maxDistance === this.minDistance)) {
                this._camera.getWorldDirection($625a33e30390866c$var$_v3A);
                this._targetEnd.add($625a33e30390866c$var$_v3A.normalize().multiplyScalar(signedPrevRadius));
                this._target.add($625a33e30390866c$var$_v3A.normalize().multiplyScalar(signedPrevRadius));
            }
            if (this.dollyToCursor) {
                this._dollyControlAmount += this._sphericalEnd.radius - prevRadius;
                if (this.infinityDolly && (distance < this.minDistance || this.maxDistance === this.minDistance)) this._dollyControlAmount -= signedPrevRadius;
                this._dollyControlCoord.set(x, y);
            }
        };
        this._zoomInternal = (delta, x, y)=>{
            const zoomScale = Math.pow(0.95, delta * this.dollySpeed);
            const prevZoom = this._zoomEnd;
            // for both PerspectiveCamera and OrthographicCamera
            this.zoomTo(this._zoom * zoomScale);
            if (this.dollyToCursor) {
                this._dollyControlAmount += this._zoomEnd - prevZoom;
                this._dollyControlCoord.set(x, y);
            }
        };
        // Check if the user has installed THREE
        if (typeof $625a33e30390866c$var$THREE === "undefined") console.error("camera-controls: `THREE` is undefined. You must first run `CameraControls.install( { THREE: THREE } )`. Check the docs for further information.");
        this._camera = camera;
        this._yAxisUpSpace = new $625a33e30390866c$var$THREE.Quaternion().setFromUnitVectors(this._camera.up, $625a33e30390866c$var$_AXIS_Y);
        this._yAxisUpSpaceInverse = this._yAxisUpSpace.clone().invert();
        this._state = $625a33e30390866c$var$ACTION.NONE;
        // the location
        this._target = new $625a33e30390866c$var$THREE.Vector3();
        this._targetEnd = this._target.clone();
        this._focalOffset = new $625a33e30390866c$var$THREE.Vector3();
        this._focalOffsetEnd = this._focalOffset.clone();
        // rotation
        this._spherical = new $625a33e30390866c$var$THREE.Spherical().setFromVector3($625a33e30390866c$var$_v3A.copy(this._camera.position).applyQuaternion(this._yAxisUpSpace));
        this._sphericalEnd = this._spherical.clone();
        this._zoom = this._camera.zoom;
        this._zoomEnd = this._zoom;
        // collisionTest uses nearPlane.s
        this._nearPlaneCorners = [
            new $625a33e30390866c$var$THREE.Vector3(),
            new $625a33e30390866c$var$THREE.Vector3(),
            new $625a33e30390866c$var$THREE.Vector3(),
            new $625a33e30390866c$var$THREE.Vector3()
        ];
        this._updateNearPlaneCorners();
        // Target cannot move outside of this box
        this._boundary = new $625a33e30390866c$var$THREE.Box3(new $625a33e30390866c$var$THREE.Vector3(-Infinity, -Infinity, -Infinity), new $625a33e30390866c$var$THREE.Vector3(Infinity, Infinity, Infinity));
        // reset
        this._cameraUp0 = this._camera.up.clone();
        this._target0 = this._target.clone();
        this._position0 = this._camera.position.clone();
        this._zoom0 = this._zoom;
        this._focalOffset0 = this._focalOffset.clone();
        this._dollyControlAmount = 0;
        this._dollyControlCoord = new $625a33e30390866c$var$THREE.Vector2();
        // configs
        this.mouseButtons = {
            left: $625a33e30390866c$var$ACTION.ROTATE,
            middle: $625a33e30390866c$var$ACTION.DOLLY,
            right: $625a33e30390866c$var$ACTION.TRUCK,
            wheel: $625a33e30390866c$var$isPerspectiveCamera(this._camera) ? $625a33e30390866c$var$ACTION.DOLLY : $625a33e30390866c$var$isOrthographicCamera(this._camera) ? $625a33e30390866c$var$ACTION.ZOOM : $625a33e30390866c$var$ACTION.NONE
        };
        this.touches = {
            one: $625a33e30390866c$var$ACTION.TOUCH_ROTATE,
            two: $625a33e30390866c$var$isPerspectiveCamera(this._camera) ? $625a33e30390866c$var$ACTION.TOUCH_DOLLY_TRUCK : $625a33e30390866c$var$isOrthographicCamera(this._camera) ? $625a33e30390866c$var$ACTION.TOUCH_ZOOM_TRUCK : $625a33e30390866c$var$ACTION.NONE,
            three: $625a33e30390866c$var$ACTION.TOUCH_TRUCK
        };
        const dragStartPosition = new $625a33e30390866c$var$THREE.Vector2();
        const lastDragPosition = new $625a33e30390866c$var$THREE.Vector2();
        const dollyStart = new $625a33e30390866c$var$THREE.Vector2();
        const onPointerDown = (event)=>{
            if (!this._enabled || !this._domElement) return;
            // Don't call `event.preventDefault()` on the pointerdown event
            // to keep receiving pointermove evens outside dragging iframe
            // https://taye.me/blog/tips/2015/11/16/mouse-drag-outside-iframe/
            const mouseButton = event.pointerType !== "mouse" ? null : (event.buttons & $625a33e30390866c$var$MOUSE_BUTTON.LEFT) === $625a33e30390866c$var$MOUSE_BUTTON.LEFT ? $625a33e30390866c$var$MOUSE_BUTTON.LEFT : (event.buttons & $625a33e30390866c$var$MOUSE_BUTTON.MIDDLE) === $625a33e30390866c$var$MOUSE_BUTTON.MIDDLE ? $625a33e30390866c$var$MOUSE_BUTTON.MIDDLE : (event.buttons & $625a33e30390866c$var$MOUSE_BUTTON.RIGHT) === $625a33e30390866c$var$MOUSE_BUTTON.RIGHT ? $625a33e30390866c$var$MOUSE_BUTTON.RIGHT : null;
            if (mouseButton !== null) {
                const zombiePointer = this._findPointerByMouseButton(mouseButton);
                zombiePointer && this._disposePointer(zombiePointer);
            }
            if ((event.buttons & $625a33e30390866c$var$MOUSE_BUTTON.LEFT) === $625a33e30390866c$var$MOUSE_BUTTON.LEFT && this._lockedPointer) return;
            const pointer = {
                pointerId: event.pointerId,
                clientX: event.clientX,
                clientY: event.clientY,
                deltaX: 0,
                deltaY: 0,
                mouseButton: mouseButton
            };
            this._activePointers.push(pointer);
            // eslint-disable-next-line no-undef
            this._domElement.ownerDocument.removeEventListener("pointermove", onPointerMove, {
                passive: false
            });
            this._domElement.ownerDocument.removeEventListener("pointerup", onPointerUp);
            this._domElement.ownerDocument.addEventListener("pointermove", onPointerMove, {
                passive: false
            });
            this._domElement.ownerDocument.addEventListener("pointerup", onPointerUp);
            this._isDragging = true;
            startDragging(event);
        };
        const onMouseDown = (event)=>{
            if (!this._enabled || !this._domElement || this._lockedPointer) return;
            const mouseButton = (event.buttons & $625a33e30390866c$var$MOUSE_BUTTON.LEFT) === $625a33e30390866c$var$MOUSE_BUTTON.LEFT ? $625a33e30390866c$var$MOUSE_BUTTON.LEFT : (event.buttons & $625a33e30390866c$var$MOUSE_BUTTON.MIDDLE) === $625a33e30390866c$var$MOUSE_BUTTON.MIDDLE ? $625a33e30390866c$var$MOUSE_BUTTON.MIDDLE : (event.buttons & $625a33e30390866c$var$MOUSE_BUTTON.RIGHT) === $625a33e30390866c$var$MOUSE_BUTTON.RIGHT ? $625a33e30390866c$var$MOUSE_BUTTON.RIGHT : null;
            if (mouseButton !== null) {
                const zombiePointer = this._findPointerByMouseButton(mouseButton);
                zombiePointer && this._disposePointer(zombiePointer);
            }
            const pointer = {
                pointerId: 1,
                clientX: event.clientX,
                clientY: event.clientY,
                deltaX: 0,
                deltaY: 0,
                mouseButton: (event.buttons & $625a33e30390866c$var$MOUSE_BUTTON.LEFT) === $625a33e30390866c$var$MOUSE_BUTTON.LEFT ? $625a33e30390866c$var$MOUSE_BUTTON.LEFT : (event.buttons & $625a33e30390866c$var$MOUSE_BUTTON.MIDDLE) === $625a33e30390866c$var$MOUSE_BUTTON.LEFT ? $625a33e30390866c$var$MOUSE_BUTTON.MIDDLE : (event.buttons & $625a33e30390866c$var$MOUSE_BUTTON.RIGHT) === $625a33e30390866c$var$MOUSE_BUTTON.LEFT ? $625a33e30390866c$var$MOUSE_BUTTON.RIGHT : null
            };
            this._activePointers.push(pointer);
            // see https://github.com/microsoft/TypeScript/issues/32912#issuecomment-522142969
            // eslint-disable-next-line no-undef
            this._domElement.ownerDocument.removeEventListener("mousemove", onMouseMove);
            this._domElement.ownerDocument.removeEventListener("mouseup", onMouseUp);
            this._domElement.ownerDocument.addEventListener("mousemove", onMouseMove);
            this._domElement.ownerDocument.addEventListener("mouseup", onMouseUp);
            this._isDragging = true;
            startDragging(event);
        };
        const onPointerMove = (event)=>{
            if (event.cancelable) event.preventDefault();
            const pointerId = event.pointerId;
            const pointer = this._lockedPointer || this._findPointerById(pointerId);
            if (!pointer) return;
            pointer.clientX = event.clientX;
            pointer.clientY = event.clientY;
            pointer.deltaX = event.movementX;
            pointer.deltaY = event.movementY;
            this._state = 0;
            if (event.pointerType === "touch") switch(this._activePointers.length){
                case 1:
                    this._state = this.touches.one;
                    break;
                case 2:
                    this._state = this.touches.two;
                    break;
                case 3:
                    this._state = this.touches.three;
                    break;
            }
            else {
                if (!this._isDragging && this._lockedPointer || this._isDragging && (event.buttons & $625a33e30390866c$var$MOUSE_BUTTON.LEFT) === $625a33e30390866c$var$MOUSE_BUTTON.LEFT) this._state = this._state | this.mouseButtons.left;
                if (this._isDragging && (event.buttons & $625a33e30390866c$var$MOUSE_BUTTON.MIDDLE) === $625a33e30390866c$var$MOUSE_BUTTON.MIDDLE) this._state = this._state | this.mouseButtons.middle;
                if (this._isDragging && (event.buttons & $625a33e30390866c$var$MOUSE_BUTTON.RIGHT) === $625a33e30390866c$var$MOUSE_BUTTON.RIGHT) this._state = this._state | this.mouseButtons.right;
            }
            dragging();
        };
        const onMouseMove = (event)=>{
            const pointer = this._lockedPointer || this._findPointerById(1);
            if (!pointer) return;
            pointer.clientX = event.clientX;
            pointer.clientY = event.clientY;
            pointer.deltaX = event.movementX;
            pointer.deltaY = event.movementY;
            this._state = 0;
            if (this._lockedPointer || (event.buttons & $625a33e30390866c$var$MOUSE_BUTTON.LEFT) === $625a33e30390866c$var$MOUSE_BUTTON.LEFT) this._state = this._state | this.mouseButtons.left;
            if ((event.buttons & $625a33e30390866c$var$MOUSE_BUTTON.MIDDLE) === $625a33e30390866c$var$MOUSE_BUTTON.MIDDLE) this._state = this._state | this.mouseButtons.middle;
            if ((event.buttons & $625a33e30390866c$var$MOUSE_BUTTON.RIGHT) === $625a33e30390866c$var$MOUSE_BUTTON.RIGHT) this._state = this._state | this.mouseButtons.right;
            dragging();
        };
        const onPointerUp = (event)=>{
            const pointer = this._findPointerById(event.pointerId);
            if (pointer && pointer === this._lockedPointer) return;
            pointer && this._disposePointer(pointer);
            if (event.pointerType === "touch") switch(this._activePointers.length){
                case 0:
                    this._state = $625a33e30390866c$var$ACTION.NONE;
                    break;
                case 1:
                    this._state = this.touches.one;
                    break;
                case 2:
                    this._state = this.touches.two;
                    break;
                case 3:
                    this._state = this.touches.three;
                    break;
            }
            else this._state = $625a33e30390866c$var$ACTION.NONE;
            endDragging();
        };
        const onMouseUp = ()=>{
            const pointer = this._findPointerById(1);
            if (pointer && pointer === this._lockedPointer) return;
            pointer && this._disposePointer(pointer);
            this._state = $625a33e30390866c$var$ACTION.NONE;
            endDragging();
        };
        let lastScrollTimeStamp = -1;
        const onMouseWheel = (event)=>{
            if (!this._enabled || this.mouseButtons.wheel === $625a33e30390866c$var$ACTION.NONE) return;
            event.preventDefault();
            if (this.dollyToCursor || this.mouseButtons.wheel === $625a33e30390866c$var$ACTION.ROTATE || this.mouseButtons.wheel === $625a33e30390866c$var$ACTION.TRUCK) {
                const now = performance.now();
                // only need to fire this at scroll start.
                if (lastScrollTimeStamp - now < 1000) this._getClientRect(this._elementRect);
                lastScrollTimeStamp = now;
            }
            // Ref: https://github.com/cedricpinson/osgjs/blob/00e5a7e9d9206c06fdde0436e1d62ab7cb5ce853/sources/osgViewer/input/source/InputSourceMouse.js#L89-L103
            const deltaYFactor = $625a33e30390866c$var$isMac ? -1 : -3;
            const delta = event.deltaMode === 1 ? event.deltaY / deltaYFactor : event.deltaY / (deltaYFactor * 10);
            const x = this.dollyToCursor ? (event.clientX - this._elementRect.x) / this._elementRect.width * 2 - 1 : 0;
            const y = this.dollyToCursor ? (event.clientY - this._elementRect.y) / this._elementRect.height * -2 + 1 : 0;
            switch(this.mouseButtons.wheel){
                case $625a33e30390866c$var$ACTION.ROTATE:
                    this._rotateInternal(event.deltaX, event.deltaY);
                    this._isUserControllingRotate = true;
                    break;
                case $625a33e30390866c$var$ACTION.TRUCK:
                    this._truckInternal(event.deltaX, event.deltaY, false);
                    this._isUserControllingTruck = true;
                    break;
                case $625a33e30390866c$var$ACTION.OFFSET:
                    this._truckInternal(event.deltaX, event.deltaY, true);
                    this._isUserControllingOffset = true;
                    break;
                case $625a33e30390866c$var$ACTION.DOLLY:
                    this._dollyInternal(-delta, x, y);
                    this._isUserControllingDolly = true;
                    break;
                case $625a33e30390866c$var$ACTION.ZOOM:
                    this._zoomInternal(-delta, x, y);
                    this._isUserControllingZoom = true;
                    break;
            }
            this.dispatchEvent({
                type: "control"
            });
        };
        const onContextMenu = (event)=>{
            if (!this._domElement || !this._enabled) return;
            // contextmenu event is fired right after pointerdown/mousedown.
            // remove attached handlers and active pointer, if interrupted by contextmenu.
            if (this.mouseButtons.right === $625a33e30390866c$export$2e2bcd8739ae039.ACTION.NONE) {
                const pointerId = event instanceof PointerEvent ? event.pointerId : event instanceof MouseEvent ? 0 : 0;
                const pointer = this._findPointerById(pointerId);
                pointer && this._disposePointer(pointer);
                // eslint-disable-next-line no-undef
                this._domElement.ownerDocument.removeEventListener("pointermove", onPointerMove, {
                    passive: false
                });
                this._domElement.ownerDocument.removeEventListener("pointerup", onPointerUp);
                this._domElement.ownerDocument.removeEventListener("mousemove", onMouseMove);
                this._domElement.ownerDocument.removeEventListener("mouseup", onMouseUp);
                return;
            }
            event.preventDefault();
        };
        const startDragging = (event)=>{
            if (!this._enabled) return;
            $625a33e30390866c$var$extractClientCoordFromEvent(this._activePointers, $625a33e30390866c$var$_v2);
            this._getClientRect(this._elementRect);
            dragStartPosition.copy($625a33e30390866c$var$_v2);
            lastDragPosition.copy($625a33e30390866c$var$_v2);
            const isMultiTouch = this._activePointers.length >= 2;
            if (isMultiTouch) {
                // 2 finger pinch
                const dx = $625a33e30390866c$var$_v2.x - this._activePointers[1].clientX;
                const dy = $625a33e30390866c$var$_v2.y - this._activePointers[1].clientY;
                const distance = Math.sqrt(dx * dx + dy * dy);
                dollyStart.set(0, distance);
                // center coords of 2 finger truck
                const x = (this._activePointers[0].clientX + this._activePointers[1].clientX) * 0.5;
                const y = (this._activePointers[0].clientY + this._activePointers[1].clientY) * 0.5;
                lastDragPosition.set(x, y);
            }
            this._state = 0;
            if (!event) {
                if (this._lockedPointer) this._state = this._state | this.mouseButtons.left;
            } else if ("pointerType" in event && event.pointerType === "touch") switch(this._activePointers.length){
                case 1:
                    this._state = this.touches.one;
                    break;
                case 2:
                    this._state = this.touches.two;
                    break;
                case 3:
                    this._state = this.touches.three;
                    break;
            }
            else {
                if (!this._lockedPointer && (event.buttons & $625a33e30390866c$var$MOUSE_BUTTON.LEFT) === $625a33e30390866c$var$MOUSE_BUTTON.LEFT) this._state = this._state | this.mouseButtons.left;
                if ((event.buttons & $625a33e30390866c$var$MOUSE_BUTTON.MIDDLE) === $625a33e30390866c$var$MOUSE_BUTTON.MIDDLE) this._state = this._state | this.mouseButtons.middle;
                if ((event.buttons & $625a33e30390866c$var$MOUSE_BUTTON.RIGHT) === $625a33e30390866c$var$MOUSE_BUTTON.RIGHT) this._state = this._state | this.mouseButtons.right;
            }
            // stop current movement on drag start
            if ((this._state & $625a33e30390866c$var$ACTION.ROTATE) === $625a33e30390866c$var$ACTION.ROTATE || (this._state & $625a33e30390866c$var$ACTION.TOUCH_ROTATE) === $625a33e30390866c$var$ACTION.TOUCH_ROTATE || (this._state & $625a33e30390866c$var$ACTION.TOUCH_DOLLY_ROTATE) === $625a33e30390866c$var$ACTION.TOUCH_DOLLY_ROTATE || (this._state & $625a33e30390866c$var$ACTION.TOUCH_ZOOM_ROTATE) === $625a33e30390866c$var$ACTION.TOUCH_ZOOM_ROTATE) {
                this._sphericalEnd.theta = this._spherical.theta;
                this._sphericalEnd.phi = this._spherical.phi;
                this._thetaVelocity.value = 0;
                this._phiVelocity.value = 0;
            }
            if ((this._state & $625a33e30390866c$var$ACTION.TRUCK) === $625a33e30390866c$var$ACTION.TRUCK || (this._state & $625a33e30390866c$var$ACTION.TOUCH_TRUCK) === $625a33e30390866c$var$ACTION.TOUCH_TRUCK || (this._state & $625a33e30390866c$var$ACTION.TOUCH_DOLLY_TRUCK) === $625a33e30390866c$var$ACTION.TOUCH_DOLLY_TRUCK || (this._state & $625a33e30390866c$var$ACTION.TOUCH_ZOOM_TRUCK) === $625a33e30390866c$var$ACTION.TOUCH_ZOOM_TRUCK) {
                this._targetEnd.copy(this._target);
                this._targetVelocity.set(0, 0, 0);
            }
            if ((this._state & $625a33e30390866c$var$ACTION.DOLLY) === $625a33e30390866c$var$ACTION.DOLLY || (this._state & $625a33e30390866c$var$ACTION.TOUCH_DOLLY) === $625a33e30390866c$var$ACTION.TOUCH_DOLLY || (this._state & $625a33e30390866c$var$ACTION.TOUCH_DOLLY_TRUCK) === $625a33e30390866c$var$ACTION.TOUCH_DOLLY_TRUCK || (this._state & $625a33e30390866c$var$ACTION.TOUCH_DOLLY_OFFSET) === $625a33e30390866c$var$ACTION.TOUCH_DOLLY_OFFSET || (this._state & $625a33e30390866c$var$ACTION.TOUCH_DOLLY_ROTATE) === $625a33e30390866c$var$ACTION.TOUCH_DOLLY_ROTATE) {
                this._sphericalEnd.radius = this._spherical.radius;
                this._radiusVelocity.value = 0;
            }
            if ((this._state & $625a33e30390866c$var$ACTION.ZOOM) === $625a33e30390866c$var$ACTION.ZOOM || (this._state & $625a33e30390866c$var$ACTION.TOUCH_ZOOM) === $625a33e30390866c$var$ACTION.TOUCH_ZOOM || (this._state & $625a33e30390866c$var$ACTION.TOUCH_ZOOM_TRUCK) === $625a33e30390866c$var$ACTION.TOUCH_ZOOM_TRUCK || (this._state & $625a33e30390866c$var$ACTION.TOUCH_ZOOM_OFFSET) === $625a33e30390866c$var$ACTION.TOUCH_ZOOM_OFFSET || (this._state & $625a33e30390866c$var$ACTION.TOUCH_ZOOM_ROTATE) === $625a33e30390866c$var$ACTION.TOUCH_ZOOM_ROTATE) {
                this._zoomEnd = this._zoom;
                this._zoomVelocity.value = 0;
            }
            if ((this._state & $625a33e30390866c$var$ACTION.OFFSET) === $625a33e30390866c$var$ACTION.OFFSET || (this._state & $625a33e30390866c$var$ACTION.TOUCH_OFFSET) === $625a33e30390866c$var$ACTION.TOUCH_OFFSET || (this._state & $625a33e30390866c$var$ACTION.TOUCH_DOLLY_OFFSET) === $625a33e30390866c$var$ACTION.TOUCH_DOLLY_OFFSET || (this._state & $625a33e30390866c$var$ACTION.TOUCH_ZOOM_OFFSET) === $625a33e30390866c$var$ACTION.TOUCH_ZOOM_OFFSET) {
                this._focalOffsetEnd.copy(this._focalOffset);
                this._focalOffsetVelocity.set(0, 0, 0);
            }
            this.dispatchEvent({
                type: "controlstart"
            });
        };
        const dragging = ()=>{
            if (!this._enabled) return;
            $625a33e30390866c$var$extractClientCoordFromEvent(this._activePointers, $625a33e30390866c$var$_v2);
            // When pointer lock is enabled clientX, clientY, screenX, and screenY remain 0.
            // If pointer lock is enabled, use the Delta directory, and assume active-pointer is not multiple.
            const isPointerLockActive = this._domElement && document.pointerLockElement === this._domElement;
            const lockedPointer = isPointerLockActive ? this._lockedPointer || this._activePointers[0] : null;
            const deltaX = lockedPointer ? -lockedPointer.deltaX : lastDragPosition.x - $625a33e30390866c$var$_v2.x;
            const deltaY = lockedPointer ? -lockedPointer.deltaY : lastDragPosition.y - $625a33e30390866c$var$_v2.y;
            lastDragPosition.copy($625a33e30390866c$var$_v2);
            if ((this._state & $625a33e30390866c$var$ACTION.ROTATE) === $625a33e30390866c$var$ACTION.ROTATE || (this._state & $625a33e30390866c$var$ACTION.TOUCH_ROTATE) === $625a33e30390866c$var$ACTION.TOUCH_ROTATE || (this._state & $625a33e30390866c$var$ACTION.TOUCH_DOLLY_ROTATE) === $625a33e30390866c$var$ACTION.TOUCH_DOLLY_ROTATE || (this._state & $625a33e30390866c$var$ACTION.TOUCH_ZOOM_ROTATE) === $625a33e30390866c$var$ACTION.TOUCH_ZOOM_ROTATE) {
                this._rotateInternal(deltaX, deltaY);
                this._isUserControllingRotate = true;
            }
            if ((this._state & $625a33e30390866c$var$ACTION.DOLLY) === $625a33e30390866c$var$ACTION.DOLLY || (this._state & $625a33e30390866c$var$ACTION.ZOOM) === $625a33e30390866c$var$ACTION.ZOOM) {
                const dollyX = this.dollyToCursor ? (dragStartPosition.x - this._elementRect.x) / this._elementRect.width * 2 - 1 : 0;
                const dollyY = this.dollyToCursor ? (dragStartPosition.y - this._elementRect.y) / this._elementRect.height * -2 + 1 : 0;
                const dollyDirection = this.dollyDragInverted ? -1 : 1;
                if ((this._state & $625a33e30390866c$var$ACTION.DOLLY) === $625a33e30390866c$var$ACTION.DOLLY) {
                    this._dollyInternal(dollyDirection * deltaY * $625a33e30390866c$var$TOUCH_DOLLY_FACTOR, dollyX, dollyY);
                    this._isUserControllingDolly = true;
                } else {
                    this._zoomInternal(dollyDirection * deltaY * $625a33e30390866c$var$TOUCH_DOLLY_FACTOR, dollyX, dollyY);
                    this._isUserControllingZoom = true;
                }
            }
            if ((this._state & $625a33e30390866c$var$ACTION.TOUCH_DOLLY) === $625a33e30390866c$var$ACTION.TOUCH_DOLLY || (this._state & $625a33e30390866c$var$ACTION.TOUCH_ZOOM) === $625a33e30390866c$var$ACTION.TOUCH_ZOOM || (this._state & $625a33e30390866c$var$ACTION.TOUCH_DOLLY_TRUCK) === $625a33e30390866c$var$ACTION.TOUCH_DOLLY_TRUCK || (this._state & $625a33e30390866c$var$ACTION.TOUCH_ZOOM_TRUCK) === $625a33e30390866c$var$ACTION.TOUCH_ZOOM_TRUCK || (this._state & $625a33e30390866c$var$ACTION.TOUCH_DOLLY_OFFSET) === $625a33e30390866c$var$ACTION.TOUCH_DOLLY_OFFSET || (this._state & $625a33e30390866c$var$ACTION.TOUCH_ZOOM_OFFSET) === $625a33e30390866c$var$ACTION.TOUCH_ZOOM_OFFSET || (this._state & $625a33e30390866c$var$ACTION.TOUCH_DOLLY_ROTATE) === $625a33e30390866c$var$ACTION.TOUCH_DOLLY_ROTATE || (this._state & $625a33e30390866c$var$ACTION.TOUCH_ZOOM_ROTATE) === $625a33e30390866c$var$ACTION.TOUCH_ZOOM_ROTATE) {
                const dx = $625a33e30390866c$var$_v2.x - this._activePointers[1].clientX;
                const dy = $625a33e30390866c$var$_v2.y - this._activePointers[1].clientY;
                const distance = Math.sqrt(dx * dx + dy * dy);
                const dollyDelta = dollyStart.y - distance;
                dollyStart.set(0, distance);
                const dollyX = this.dollyToCursor ? (lastDragPosition.x - this._elementRect.x) / this._elementRect.width * 2 - 1 : 0;
                const dollyY = this.dollyToCursor ? (lastDragPosition.y - this._elementRect.y) / this._elementRect.height * -2 + 1 : 0;
                if ((this._state & $625a33e30390866c$var$ACTION.TOUCH_DOLLY) === $625a33e30390866c$var$ACTION.TOUCH_DOLLY || (this._state & $625a33e30390866c$var$ACTION.TOUCH_DOLLY_ROTATE) === $625a33e30390866c$var$ACTION.TOUCH_DOLLY_ROTATE || (this._state & $625a33e30390866c$var$ACTION.TOUCH_DOLLY_TRUCK) === $625a33e30390866c$var$ACTION.TOUCH_DOLLY_TRUCK || (this._state & $625a33e30390866c$var$ACTION.TOUCH_DOLLY_OFFSET) === $625a33e30390866c$var$ACTION.TOUCH_DOLLY_OFFSET) {
                    this._dollyInternal(dollyDelta * $625a33e30390866c$var$TOUCH_DOLLY_FACTOR, dollyX, dollyY);
                    this._isUserControllingDolly = true;
                } else {
                    this._zoomInternal(dollyDelta * $625a33e30390866c$var$TOUCH_DOLLY_FACTOR, dollyX, dollyY);
                    this._isUserControllingZoom = true;
                }
            }
            if ((this._state & $625a33e30390866c$var$ACTION.TRUCK) === $625a33e30390866c$var$ACTION.TRUCK || (this._state & $625a33e30390866c$var$ACTION.TOUCH_TRUCK) === $625a33e30390866c$var$ACTION.TOUCH_TRUCK || (this._state & $625a33e30390866c$var$ACTION.TOUCH_DOLLY_TRUCK) === $625a33e30390866c$var$ACTION.TOUCH_DOLLY_TRUCK || (this._state & $625a33e30390866c$var$ACTION.TOUCH_ZOOM_TRUCK) === $625a33e30390866c$var$ACTION.TOUCH_ZOOM_TRUCK) {
                this._truckInternal(deltaX, deltaY, false);
                this._isUserControllingTruck = true;
            }
            if ((this._state & $625a33e30390866c$var$ACTION.OFFSET) === $625a33e30390866c$var$ACTION.OFFSET || (this._state & $625a33e30390866c$var$ACTION.TOUCH_OFFSET) === $625a33e30390866c$var$ACTION.TOUCH_OFFSET || (this._state & $625a33e30390866c$var$ACTION.TOUCH_DOLLY_OFFSET) === $625a33e30390866c$var$ACTION.TOUCH_DOLLY_OFFSET || (this._state & $625a33e30390866c$var$ACTION.TOUCH_ZOOM_OFFSET) === $625a33e30390866c$var$ACTION.TOUCH_ZOOM_OFFSET) {
                this._truckInternal(deltaX, deltaY, true);
                this._isUserControllingOffset = true;
            }
            this.dispatchEvent({
                type: "control"
            });
        };
        const endDragging = ()=>{
            $625a33e30390866c$var$extractClientCoordFromEvent(this._activePointers, $625a33e30390866c$var$_v2);
            lastDragPosition.copy($625a33e30390866c$var$_v2);
            if (this._activePointers.length === 0 || this._activePointers.length === 1 && this._activePointers[0] === this._lockedPointer) this._isDragging = false;
            if (this._activePointers.length === 0 && this._domElement) {
                // eslint-disable-next-line no-undef
                this._domElement.ownerDocument.removeEventListener("pointermove", onPointerMove, {
                    passive: false
                });
                this._domElement.ownerDocument.removeEventListener("mousemove", onMouseMove);
                this._domElement.ownerDocument.removeEventListener("pointerup", onPointerUp);
                this._domElement.ownerDocument.removeEventListener("mouseup", onMouseUp);
                this.dispatchEvent({
                    type: "controlend"
                });
            }
        };
        this.lockPointer = ()=>{
            if (!this._enabled || !this._domElement) return;
            this.cancel();
            // Element.requestPointerLock is allowed to happen without any pointer active - create a faux one for compatibility with controls
            this._lockedPointer = {
                pointerId: -1,
                clientX: 0,
                clientY: 0,
                deltaX: 0,
                deltaY: 0,
                mouseButton: null
            };
            this._activePointers.push(this._lockedPointer);
            // eslint-disable-next-line no-undef
            this._domElement.ownerDocument.removeEventListener("pointermove", onPointerMove, {
                passive: false
            });
            this._domElement.ownerDocument.removeEventListener("pointerup", onPointerUp);
            this._domElement.requestPointerLock();
            this._domElement.ownerDocument.addEventListener("pointerlockchange", onPointerLockChange);
            this._domElement.ownerDocument.addEventListener("pointerlockerror", onPointerLockError);
            this._domElement.ownerDocument.addEventListener("pointermove", onPointerMove, {
                passive: false
            });
            this._domElement.ownerDocument.addEventListener("pointerup", onPointerUp);
            startDragging();
        };
        this.unlockPointer = ()=>{
            if (this._lockedPointer !== null) {
                this._disposePointer(this._lockedPointer);
                this._lockedPointer = null;
            }
            document.exitPointerLock();
            this.cancel();
            if (!this._domElement) return;
            this._domElement.ownerDocument.removeEventListener("pointerlockchange", onPointerLockChange);
            this._domElement.ownerDocument.removeEventListener("pointerlockerror", onPointerLockError);
        };
        const onPointerLockChange = ()=>{
            const isPointerLockActive = this._domElement && this._domElement.ownerDocument.pointerLockElement === this._domElement;
            if (!isPointerLockActive) this.unlockPointer();
        };
        const onPointerLockError = ()=>{
            this.unlockPointer();
        };
        this._addAllEventListeners = (domElement)=>{
            this._domElement = domElement;
            this._domElement.style.touchAction = "none";
            this._domElement.style.userSelect = "none";
            this._domElement.style.webkitUserSelect = "none";
            this._domElement.addEventListener("pointerdown", onPointerDown);
            $625a33e30390866c$var$isPointerEventsNotSupported && this._domElement.addEventListener("mousedown", onMouseDown);
            this._domElement.addEventListener("pointercancel", onPointerUp);
            this._domElement.addEventListener("wheel", onMouseWheel, {
                passive: false
            });
            this._domElement.addEventListener("contextmenu", onContextMenu);
        };
        this._removeAllEventListeners = ()=>{
            if (!this._domElement) return;
            this._domElement.style.touchAction = "";
            this._domElement.style.userSelect = "";
            this._domElement.style.webkitUserSelect = "";
            this._domElement.removeEventListener("pointerdown", onPointerDown);
            this._domElement.removeEventListener("mousedown", onMouseDown);
            this._domElement.removeEventListener("pointercancel", onPointerUp);
            // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener#matching_event_listeners_for_removal
            // > it's probably wise to use the same values used for the call to `addEventListener()` when calling `removeEventListener()`
            // see https://github.com/microsoft/TypeScript/issues/32912#issuecomment-522142969
            // eslint-disable-next-line no-undef
            this._domElement.removeEventListener("wheel", onMouseWheel, {
                passive: false
            });
            this._domElement.removeEventListener("contextmenu", onContextMenu);
            // eslint-disable-next-line no-undef
            this._domElement.ownerDocument.removeEventListener("pointermove", onPointerMove, {
                passive: false
            });
            this._domElement.ownerDocument.removeEventListener("mousemove", onMouseMove);
            this._domElement.ownerDocument.removeEventListener("pointerup", onPointerUp);
            this._domElement.ownerDocument.removeEventListener("mouseup", onMouseUp);
            this._domElement.ownerDocument.removeEventListener("pointerlockchange", onPointerLockChange);
            this._domElement.ownerDocument.removeEventListener("pointerlockerror", onPointerLockError);
        };
        this.cancel = ()=>{
            if (this._state === $625a33e30390866c$var$ACTION.NONE) return;
            this._state = $625a33e30390866c$var$ACTION.NONE;
            this._activePointers.length = 0;
            endDragging();
        };
        if (domElement) this.connect(domElement);
        this.update(0);
    }
    /**
     * The camera to be controlled
     * @category Properties
     */ get camera() {
        return this._camera;
    }
    set camera(camera) {
        this._camera = camera;
        this.updateCameraUp();
        this._camera.updateProjectionMatrix();
        this._updateNearPlaneCorners();
        this._needsUpdate = true;
    }
    /**
     * Whether or not the controls are enabled.
     * `false` to disable user dragging/touch-move, but all methods works.
     * @category Properties
     */ get enabled() {
        return this._enabled;
    }
    set enabled(enabled) {
        this._enabled = enabled;
        if (!this._domElement) return;
        if (enabled) {
            this._domElement.style.touchAction = "none";
            this._domElement.style.userSelect = "none";
            this._domElement.style.webkitUserSelect = "none";
        } else {
            this.cancel();
            this._domElement.style.touchAction = "";
            this._domElement.style.userSelect = "";
            this._domElement.style.webkitUserSelect = "";
        }
    }
    /**
     * Returns `true` if the controls are active updating.
     * readonly value.
     * @category Properties
     */ get active() {
        return !this._hasRested;
    }
    /**
     * Getter for the current `ACTION`.
     * readonly value.
     * @category Properties
     */ get currentAction() {
        return this._state;
    }
    /**
     * get/set Current distance.
     * @category Properties
     */ get distance() {
        return this._spherical.radius;
    }
    set distance(distance) {
        if (this._spherical.radius === distance && this._sphericalEnd.radius === distance) return;
        this._spherical.radius = distance;
        this._sphericalEnd.radius = distance;
        this._needsUpdate = true;
    }
    // horizontal angle
    /**
     * get/set the azimuth angle (horizontal) in radians.
     * Every 360 degrees turn is added to `.azimuthAngle` value, which is accumulative.
     * @category Properties
     */ get azimuthAngle() {
        return this._spherical.theta;
    }
    set azimuthAngle(azimuthAngle) {
        if (this._spherical.theta === azimuthAngle && this._sphericalEnd.theta === azimuthAngle) return;
        this._spherical.theta = azimuthAngle;
        this._sphericalEnd.theta = azimuthAngle;
        this._needsUpdate = true;
    }
    // vertical angle
    /**
     * get/set the polar angle (vertical) in radians.
     * @category Properties
     */ get polarAngle() {
        return this._spherical.phi;
    }
    set polarAngle(polarAngle) {
        if (this._spherical.phi === polarAngle && this._sphericalEnd.phi === polarAngle) return;
        this._spherical.phi = polarAngle;
        this._sphericalEnd.phi = polarAngle;
        this._needsUpdate = true;
    }
    /**
     * Whether camera position should be enclosed in the boundary or not.
     * @category Properties
     */ get boundaryEnclosesCamera() {
        return this._boundaryEnclosesCamera;
    }
    set boundaryEnclosesCamera(boundaryEnclosesCamera) {
        this._boundaryEnclosesCamera = boundaryEnclosesCamera;
        this._needsUpdate = true;
    }
    /**
     * Adds the specified event listener.
     * Applicable event types (which is `K`) are:
     * | Event name          | Timing |
     * | ------------------- | ------ |
     * | `'controlstart'`    | When the user starts to control the camera via mouse / touches. ¹ |
     * | `'control'`         | When the user controls the camera (dragging). |
     * | `'controlend'`      | When the user ends to control the camera. ¹ |
     * | `'transitionstart'` | When any kind of transition starts, either user control or using a method with `enableTransition = true` |
     * | `'update'`          | When the camera position is updated. |
     * | `'wake'`            | When the camera starts moving. |
     * | `'rest'`            | When the camera movement is below `.restThreshold` ². |
     * | `'sleep'`           | When the camera end moving. |
     *
     * 1. `mouseButtons.wheel` (Mouse wheel control) does not emit `'controlstart'` and `'controlend'`. `mouseButtons.wheel` uses scroll-event internally, and scroll-event happens intermittently. That means "start" and "end" cannot be detected.
     * 2. Due to damping, `sleep` will usually fire a few seconds after the camera _appears_ to have stopped moving. If you want to do something (e.g. enable UI, perform another transition) at the point when the camera has stopped, you probably want the `rest` event. This can be fine tuned using the `.restThreshold` parameter. See the [Rest and Sleep Example](https://yomotsu.github.io/camera-controls/examples/rest-and-sleep.html).
     *
     * e.g.
     * ```
     * cameraControl.addEventListener( 'controlstart', myCallbackFunction );
     * ```
     * @param type event name
     * @param listener handler function
     * @category Methods
     */ addEventListener(type, listener) {
        super.addEventListener(type, listener);
    }
    /**
     * Removes the specified event listener
     * e.g.
     * ```
     * cameraControl.addEventListener( 'controlstart', myCallbackFunction );
     * ```
     * @param type event name
     * @param listener handler function
     * @category Methods
     */ removeEventListener(type, listener) {
        super.removeEventListener(type, listener);
    }
    /**
     * Rotate azimuthal angle(horizontal) and polar angle(vertical).
     * Every value is added to the current value.
     * @param azimuthAngle Azimuth rotate angle. In radian.
     * @param polarAngle Polar rotate angle. In radian.
     * @param enableTransition Whether to move smoothly or immediately
     * @category Methods
     */ rotate(azimuthAngle, polarAngle, enableTransition = false) {
        return this.rotateTo(this._sphericalEnd.theta + azimuthAngle, this._sphericalEnd.phi + polarAngle, enableTransition);
    }
    /**
     * Rotate azimuthal angle(horizontal) to the given angle and keep the same polar angle(vertical) target.
     *
     * e.g.
     * ```
     * cameraControls.rotateAzimuthTo( 30 * THREE.MathUtils.DEG2RAD, true );
     * ```
     * @param azimuthAngle Azimuth rotate angle. In radian.
     * @param enableTransition Whether to move smoothly or immediately
     * @category Methods
     */ rotateAzimuthTo(azimuthAngle, enableTransition = false) {
        return this.rotateTo(azimuthAngle, this._sphericalEnd.phi, enableTransition);
    }
    /**
     * Rotate polar angle(vertical) to the given angle and keep the same azimuthal angle(horizontal) target.
     *
     * e.g.
     * ```
     * cameraControls.rotatePolarTo( 30 * THREE.MathUtils.DEG2RAD, true );
     * ```
     * @param polarAngle Polar rotate angle. In radian.
     * @param enableTransition Whether to move smoothly or immediately
     * @category Methods
     */ rotatePolarTo(polarAngle, enableTransition = false) {
        return this.rotateTo(this._sphericalEnd.theta, polarAngle, enableTransition);
    }
    /**
     * Rotate azimuthal angle(horizontal) and polar angle(vertical) to the given angle.
     * Camera view will rotate over the orbit pivot absolutely:
     *
     * azimuthAngle
     * ```
     *       0º
     *         \
     * 90º -----+----- -90º
     *           \
     *           180º
     * ```
     * | direction | angle                  |
     * | --------- | ---------------------- |
     * | front     | 0º                     |
     * | left      | 90º (`Math.PI / 2`)    |
     * | right     | -90º (`- Math.PI / 2`) |
     * | back      | 180º (`Math.PI`)       |
     *
     * polarAngle
     * ```
     *     180º
     *      |
     *      90º
     *      |
     *      0º
     * ```
     * | direction            | angle                  |
     * | -------------------- | ---------------------- |
     * | top/sky              | 180º (`Math.PI`)       |
     * | horizontal from view | 90º (`Math.PI / 2`)    |
     * | bottom/floor         | 0º                     |
     *
     * @param azimuthAngle Azimuth rotate angle to. In radian.
     * @param polarAngle Polar rotate angle to. In radian.
     * @param enableTransition  Whether to move smoothly or immediately
     * @category Methods
     */ rotateTo(azimuthAngle, polarAngle, enableTransition = false) {
        this._isUserControllingRotate = false;
        const theta = $625a33e30390866c$var$clamp(azimuthAngle, this.minAzimuthAngle, this.maxAzimuthAngle);
        const phi = $625a33e30390866c$var$clamp(polarAngle, this.minPolarAngle, this.maxPolarAngle);
        this._sphericalEnd.theta = theta;
        this._sphericalEnd.phi = phi;
        this._sphericalEnd.makeSafe();
        this._needsUpdate = true;
        if (!enableTransition) {
            this._spherical.theta = this._sphericalEnd.theta;
            this._spherical.phi = this._sphericalEnd.phi;
        }
        const resolveImmediately = !enableTransition || $625a33e30390866c$var$approxEquals(this._spherical.theta, this._sphericalEnd.theta, this.restThreshold) && $625a33e30390866c$var$approxEquals(this._spherical.phi, this._sphericalEnd.phi, this.restThreshold);
        return this._createOnRestPromise(resolveImmediately);
    }
    /**
     * Dolly in/out camera position.
     * @param distance Distance of dollyIn. Negative number for dollyOut.
     * @param enableTransition Whether to move smoothly or immediately.
     * @category Methods
     */ dolly(distance, enableTransition = false) {
        return this.dollyTo(this._sphericalEnd.radius - distance, enableTransition);
    }
    /**
     * Dolly in/out camera position to given distance.
     * @param distance Distance of dolly.
     * @param enableTransition Whether to move smoothly or immediately.
     * @category Methods
     */ dollyTo(distance, enableTransition = false) {
        this._isUserControllingDolly = false;
        const lastRadius = this._sphericalEnd.radius;
        const newRadius = $625a33e30390866c$var$clamp(distance, this.minDistance, this.maxDistance);
        const hasCollider = this.colliderMeshes.length >= 1;
        if (hasCollider) {
            const maxDistanceByCollisionTest = this._collisionTest();
            const isCollided = $625a33e30390866c$var$approxEquals(maxDistanceByCollisionTest, this._spherical.radius);
            const isDollyIn = lastRadius > newRadius;
            if (!isDollyIn && isCollided) return Promise.resolve();
            this._sphericalEnd.radius = Math.min(newRadius, maxDistanceByCollisionTest);
        } else this._sphericalEnd.radius = newRadius;
        this._needsUpdate = true;
        if (!enableTransition) this._spherical.radius = this._sphericalEnd.radius;
        const resolveImmediately = !enableTransition || $625a33e30390866c$var$approxEquals(this._spherical.radius, this._sphericalEnd.radius, this.restThreshold);
        return this._createOnRestPromise(resolveImmediately);
    }
    /**
     * Zoom in/out camera. The value is added to camera zoom.
     * Limits set with `.minZoom` and `.maxZoom`
     * @param zoomStep zoom scale
     * @param enableTransition Whether to move smoothly or immediately
     * @category Methods
     */ zoom(zoomStep, enableTransition = false) {
        return this.zoomTo(this._zoomEnd + zoomStep, enableTransition);
    }
    /**
     * Zoom in/out camera to given scale. The value overwrites camera zoom.
     * Limits set with .minZoom and .maxZoom
     * @param zoom
     * @param enableTransition
     * @category Methods
     */ zoomTo(zoom, enableTransition = false) {
        this._isUserControllingZoom = false;
        this._zoomEnd = $625a33e30390866c$var$clamp(zoom, this.minZoom, this.maxZoom);
        this._needsUpdate = true;
        if (!enableTransition) this._zoom = this._zoomEnd;
        const resolveImmediately = !enableTransition || $625a33e30390866c$var$approxEquals(this._zoom, this._zoomEnd, this.restThreshold);
        return this._createOnRestPromise(resolveImmediately);
    }
    /**
     * @deprecated `pan()` has been renamed to `truck()`
     * @category Methods
     */ pan(x, y, enableTransition = false) {
        console.warn("`pan` has been renamed to `truck`");
        return this.truck(x, y, enableTransition);
    }
    /**
     * Truck and pedestal camera using current azimuthal angle
     * @param x Horizontal translate amount
     * @param y Vertical translate amount
     * @param enableTransition Whether to move smoothly or immediately
     * @category Methods
     */ truck(x, y, enableTransition = false) {
        this._camera.updateMatrix();
        $625a33e30390866c$var$_xColumn.setFromMatrixColumn(this._camera.matrix, 0);
        $625a33e30390866c$var$_yColumn.setFromMatrixColumn(this._camera.matrix, 1);
        $625a33e30390866c$var$_xColumn.multiplyScalar(x);
        $625a33e30390866c$var$_yColumn.multiplyScalar(-y);
        const offset = $625a33e30390866c$var$_v3A.copy($625a33e30390866c$var$_xColumn).add($625a33e30390866c$var$_yColumn);
        const to = $625a33e30390866c$var$_v3B.copy(this._targetEnd).add(offset);
        return this.moveTo(to.x, to.y, to.z, enableTransition);
    }
    /**
     * Move forward / backward.
     * @param distance Amount to move forward / backward. Negative value to move backward
     * @param enableTransition Whether to move smoothly or immediately
     * @category Methods
     */ forward(distance, enableTransition = false) {
        $625a33e30390866c$var$_v3A.setFromMatrixColumn(this._camera.matrix, 0);
        $625a33e30390866c$var$_v3A.crossVectors(this._camera.up, $625a33e30390866c$var$_v3A);
        $625a33e30390866c$var$_v3A.multiplyScalar(distance);
        const to = $625a33e30390866c$var$_v3B.copy(this._targetEnd).add($625a33e30390866c$var$_v3A);
        return this.moveTo(to.x, to.y, to.z, enableTransition);
    }
    /**
     * Move up / down.
     * @param height Amount to move up / down. Negative value to move down
     * @param enableTransition Whether to move smoothly or immediately
     * @category Methods
     */ elevate(height, enableTransition = false) {
        $625a33e30390866c$var$_v3A.copy(this._camera.up).multiplyScalar(height);
        return this.moveTo(this._targetEnd.x + $625a33e30390866c$var$_v3A.x, this._targetEnd.y + $625a33e30390866c$var$_v3A.y, this._targetEnd.z + $625a33e30390866c$var$_v3A.z, enableTransition);
    }
    /**
     * Move target position to given point.
     * @param x x coord to move center position
     * @param y y coord to move center position
     * @param z z coord to move center position
     * @param enableTransition Whether to move smoothly or immediately
     * @category Methods
     */ moveTo(x, y, z, enableTransition = false) {
        this._isUserControllingTruck = false;
        const offset = $625a33e30390866c$var$_v3A.set(x, y, z).sub(this._targetEnd);
        this._encloseToBoundary(this._targetEnd, offset, this.boundaryFriction);
        this._needsUpdate = true;
        if (!enableTransition) this._target.copy(this._targetEnd);
        const resolveImmediately = !enableTransition || $625a33e30390866c$var$approxEquals(this._target.x, this._targetEnd.x, this.restThreshold) && $625a33e30390866c$var$approxEquals(this._target.y, this._targetEnd.y, this.restThreshold) && $625a33e30390866c$var$approxEquals(this._target.z, this._targetEnd.z, this.restThreshold);
        return this._createOnRestPromise(resolveImmediately);
    }
    /**
     * Look in the given point direction.
     * @param x point x.
     * @param y point y.
     * @param z point z.
     * @param enableTransition Whether to move smoothly or immediately.
     * @returns Transition end promise
     * @category Methods
     */ lookInDirectionOf(x, y, z, enableTransition = false) {
        const point = $625a33e30390866c$var$_v3A.set(x, y, z);
        const direction = point.sub(this._targetEnd).normalize();
        const position = direction.multiplyScalar(-this._sphericalEnd.radius);
        return this.setPosition(position.x, position.y, position.z, enableTransition);
    }
    /**
     * Fit the viewport to the box or the bounding box of the object, using the nearest axis. paddings are in unit.
     * set `cover: true` to fill enter screen.
     * e.g.
     * ```
     * cameraControls.fitToBox( myMesh );
     * ```
     * @param box3OrObject Axis aligned bounding box to fit the view.
     * @param enableTransition Whether to move smoothly or immediately.
     * @param options | `<object>` { cover: boolean, paddingTop: number, paddingLeft: number, paddingBottom: number, paddingRight: number }
     * @returns Transition end promise
     * @category Methods
     */ fitToBox(box3OrObject, enableTransition, { cover: cover = false , paddingLeft: paddingLeft = 0 , paddingRight: paddingRight = 0 , paddingBottom: paddingBottom = 0 , paddingTop: paddingTop = 0  } = {}) {
        const promises = [];
        const aabb = box3OrObject.isBox3 ? $625a33e30390866c$var$_box3A.copy(box3OrObject) : $625a33e30390866c$var$_box3A.setFromObject(box3OrObject);
        if (aabb.isEmpty()) {
            console.warn("camera-controls: fitTo() cannot be used with an empty box. Aborting");
            Promise.resolve();
        }
        // round to closest axis ( forward | backward | right | left | top | bottom )
        const theta = $625a33e30390866c$var$roundToStep(this._sphericalEnd.theta, $625a33e30390866c$var$PI_HALF);
        const phi = $625a33e30390866c$var$roundToStep(this._sphericalEnd.phi, $625a33e30390866c$var$PI_HALF);
        promises.push(this.rotateTo(theta, phi, enableTransition));
        const normal = $625a33e30390866c$var$_v3A.setFromSpherical(this._sphericalEnd).normalize();
        const rotation = $625a33e30390866c$var$_quaternionA.setFromUnitVectors(normal, $625a33e30390866c$var$_AXIS_Z);
        const viewFromPolar = $625a33e30390866c$var$approxEquals(Math.abs(normal.y), 1);
        if (viewFromPolar) rotation.multiply($625a33e30390866c$var$_quaternionB.setFromAxisAngle($625a33e30390866c$var$_AXIS_Y, theta));
        rotation.multiply(this._yAxisUpSpaceInverse);
        // make oriented bounding box
        const bb = $625a33e30390866c$var$_box3B.makeEmpty();
        // left bottom back corner
        $625a33e30390866c$var$_v3B.copy(aabb.min).applyQuaternion(rotation);
        bb.expandByPoint($625a33e30390866c$var$_v3B);
        // right bottom back corner
        $625a33e30390866c$var$_v3B.copy(aabb.min).setX(aabb.max.x).applyQuaternion(rotation);
        bb.expandByPoint($625a33e30390866c$var$_v3B);
        // left top back corner
        $625a33e30390866c$var$_v3B.copy(aabb.min).setY(aabb.max.y).applyQuaternion(rotation);
        bb.expandByPoint($625a33e30390866c$var$_v3B);
        // right top back corner
        $625a33e30390866c$var$_v3B.copy(aabb.max).setZ(aabb.min.z).applyQuaternion(rotation);
        bb.expandByPoint($625a33e30390866c$var$_v3B);
        // left bottom front corner
        $625a33e30390866c$var$_v3B.copy(aabb.min).setZ(aabb.max.z).applyQuaternion(rotation);
        bb.expandByPoint($625a33e30390866c$var$_v3B);
        // right bottom front corner
        $625a33e30390866c$var$_v3B.copy(aabb.max).setY(aabb.min.y).applyQuaternion(rotation);
        bb.expandByPoint($625a33e30390866c$var$_v3B);
        // left top front corner
        $625a33e30390866c$var$_v3B.copy(aabb.max).setX(aabb.min.x).applyQuaternion(rotation);
        bb.expandByPoint($625a33e30390866c$var$_v3B);
        // right top front corner
        $625a33e30390866c$var$_v3B.copy(aabb.max).applyQuaternion(rotation);
        bb.expandByPoint($625a33e30390866c$var$_v3B);
        // add padding
        bb.min.x -= paddingLeft;
        bb.min.y -= paddingBottom;
        bb.max.x += paddingRight;
        bb.max.y += paddingTop;
        rotation.setFromUnitVectors($625a33e30390866c$var$_AXIS_Z, normal);
        if (viewFromPolar) rotation.premultiply($625a33e30390866c$var$_quaternionB.invert());
        rotation.premultiply(this._yAxisUpSpace);
        const bbSize = bb.getSize($625a33e30390866c$var$_v3A);
        const center = bb.getCenter($625a33e30390866c$var$_v3B).applyQuaternion(rotation);
        if ($625a33e30390866c$var$isPerspectiveCamera(this._camera)) {
            const distance = this.getDistanceToFitBox(bbSize.x, bbSize.y, bbSize.z, cover);
            promises.push(this.moveTo(center.x, center.y, center.z, enableTransition));
            promises.push(this.dollyTo(distance, enableTransition));
            promises.push(this.setFocalOffset(0, 0, 0, enableTransition));
        } else if ($625a33e30390866c$var$isOrthographicCamera(this._camera)) {
            const camera = this._camera;
            const width = camera.right - camera.left;
            const height = camera.top - camera.bottom;
            const zoom = cover ? Math.max(width / bbSize.x, height / bbSize.y) : Math.min(width / bbSize.x, height / bbSize.y);
            promises.push(this.moveTo(center.x, center.y, center.z, enableTransition));
            promises.push(this.zoomTo(zoom, enableTransition));
            promises.push(this.setFocalOffset(0, 0, 0, enableTransition));
        }
        return Promise.all(promises);
    }
    /**
     * Fit the viewport to the sphere or the bounding sphere of the object.
     * @param sphereOrMesh
     * @param enableTransition
     * @category Methods
     */ fitToSphere(sphereOrMesh, enableTransition) {
        const promises = [];
        const isSphere = sphereOrMesh instanceof $625a33e30390866c$var$THREE.Sphere;
        const boundingSphere = isSphere ? $625a33e30390866c$var$_sphere.copy(sphereOrMesh) : $625a33e30390866c$export$2e2bcd8739ae039.createBoundingSphere(sphereOrMesh, $625a33e30390866c$var$_sphere);
        promises.push(this.moveTo(boundingSphere.center.x, boundingSphere.center.y, boundingSphere.center.z, enableTransition));
        if ($625a33e30390866c$var$isPerspectiveCamera(this._camera)) {
            const distanceToFit = this.getDistanceToFitSphere(boundingSphere.radius);
            promises.push(this.dollyTo(distanceToFit, enableTransition));
        } else if ($625a33e30390866c$var$isOrthographicCamera(this._camera)) {
            const width = this._camera.right - this._camera.left;
            const height = this._camera.top - this._camera.bottom;
            const diameter = 2 * boundingSphere.radius;
            const zoom = Math.min(width / diameter, height / diameter);
            promises.push(this.zoomTo(zoom, enableTransition));
        }
        promises.push(this.setFocalOffset(0, 0, 0, enableTransition));
        return Promise.all(promises);
    }
    /**
     * Look at the `target` from the `position`.
     * @param positionX
     * @param positionY
     * @param positionZ
     * @param targetX
     * @param targetY
     * @param targetZ
     * @param enableTransition
     * @category Methods
     */ setLookAt(positionX, positionY, positionZ, targetX, targetY, targetZ, enableTransition = false) {
        this._isUserControllingRotate = false;
        this._isUserControllingDolly = false;
        this._isUserControllingTruck = false;
        const target = $625a33e30390866c$var$_v3B.set(targetX, targetY, targetZ);
        const position = $625a33e30390866c$var$_v3A.set(positionX, positionY, positionZ);
        this._targetEnd.copy(target);
        this._sphericalEnd.setFromVector3(position.sub(target).applyQuaternion(this._yAxisUpSpace));
        this.normalizeRotations();
        this._needsUpdate = true;
        if (!enableTransition) {
            this._target.copy(this._targetEnd);
            this._spherical.copy(this._sphericalEnd);
        }
        const resolveImmediately = !enableTransition || $625a33e30390866c$var$approxEquals(this._target.x, this._targetEnd.x, this.restThreshold) && $625a33e30390866c$var$approxEquals(this._target.y, this._targetEnd.y, this.restThreshold) && $625a33e30390866c$var$approxEquals(this._target.z, this._targetEnd.z, this.restThreshold) && $625a33e30390866c$var$approxEquals(this._spherical.theta, this._sphericalEnd.theta, this.restThreshold) && $625a33e30390866c$var$approxEquals(this._spherical.phi, this._sphericalEnd.phi, this.restThreshold) && $625a33e30390866c$var$approxEquals(this._spherical.radius, this._sphericalEnd.radius, this.restThreshold);
        return this._createOnRestPromise(resolveImmediately);
    }
    /**
     * Similar to setLookAt, but it interpolates between two states.
     * @param positionAX
     * @param positionAY
     * @param positionAZ
     * @param targetAX
     * @param targetAY
     * @param targetAZ
     * @param positionBX
     * @param positionBY
     * @param positionBZ
     * @param targetBX
     * @param targetBY
     * @param targetBZ
     * @param t
     * @param enableTransition
     * @category Methods
     */ lerpLookAt(positionAX, positionAY, positionAZ, targetAX, targetAY, targetAZ, positionBX, positionBY, positionBZ, targetBX, targetBY, targetBZ, t, enableTransition = false) {
        this._isUserControllingRotate = false;
        this._isUserControllingDolly = false;
        this._isUserControllingTruck = false;
        const targetA = $625a33e30390866c$var$_v3A.set(targetAX, targetAY, targetAZ);
        const positionA = $625a33e30390866c$var$_v3B.set(positionAX, positionAY, positionAZ);
        $625a33e30390866c$var$_sphericalA.setFromVector3(positionA.sub(targetA).applyQuaternion(this._yAxisUpSpace));
        const targetB = $625a33e30390866c$var$_v3C.set(targetBX, targetBY, targetBZ);
        const positionB = $625a33e30390866c$var$_v3B.set(positionBX, positionBY, positionBZ);
        $625a33e30390866c$var$_sphericalB.setFromVector3(positionB.sub(targetB).applyQuaternion(this._yAxisUpSpace));
        this._targetEnd.copy(targetA.lerp(targetB, t)); // tricky
        const deltaTheta = $625a33e30390866c$var$_sphericalB.theta - $625a33e30390866c$var$_sphericalA.theta;
        const deltaPhi = $625a33e30390866c$var$_sphericalB.phi - $625a33e30390866c$var$_sphericalA.phi;
        const deltaRadius = $625a33e30390866c$var$_sphericalB.radius - $625a33e30390866c$var$_sphericalA.radius;
        this._sphericalEnd.set($625a33e30390866c$var$_sphericalA.radius + deltaRadius * t, $625a33e30390866c$var$_sphericalA.phi + deltaPhi * t, $625a33e30390866c$var$_sphericalA.theta + deltaTheta * t);
        this.normalizeRotations();
        this._needsUpdate = true;
        if (!enableTransition) {
            this._target.copy(this._targetEnd);
            this._spherical.copy(this._sphericalEnd);
        }
        const resolveImmediately = !enableTransition || $625a33e30390866c$var$approxEquals(this._target.x, this._targetEnd.x, this.restThreshold) && $625a33e30390866c$var$approxEquals(this._target.y, this._targetEnd.y, this.restThreshold) && $625a33e30390866c$var$approxEquals(this._target.z, this._targetEnd.z, this.restThreshold) && $625a33e30390866c$var$approxEquals(this._spherical.theta, this._sphericalEnd.theta, this.restThreshold) && $625a33e30390866c$var$approxEquals(this._spherical.phi, this._sphericalEnd.phi, this.restThreshold) && $625a33e30390866c$var$approxEquals(this._spherical.radius, this._sphericalEnd.radius, this.restThreshold);
        return this._createOnRestPromise(resolveImmediately);
    }
    /**
     * Set angle and distance by given position.
     * An alias of `setLookAt()`, without target change. Thus keep gazing at the current target
     * @param positionX
     * @param positionY
     * @param positionZ
     * @param enableTransition
     * @category Methods
     */ setPosition(positionX, positionY, positionZ, enableTransition = false) {
        return this.setLookAt(positionX, positionY, positionZ, this._targetEnd.x, this._targetEnd.y, this._targetEnd.z, enableTransition);
    }
    /**
     * Set the target position where gaze at.
     * An alias of `setLookAt()`, without position change. Thus keep the same position.
     * @param targetX
     * @param targetY
     * @param targetZ
     * @param enableTransition
     * @category Methods
     */ setTarget(targetX, targetY, targetZ, enableTransition = false) {
        const pos = this.getPosition($625a33e30390866c$var$_v3A);
        const promise = this.setLookAt(pos.x, pos.y, pos.z, targetX, targetY, targetZ, enableTransition);
        // see https://github.com/yomotsu/camera-controls/issues/335
        this._sphericalEnd.phi = $625a33e30390866c$var$clamp(this.polarAngle, this.minPolarAngle, this.maxPolarAngle);
        return promise;
    }
    /**
     * Set focal offset using the screen parallel coordinates. z doesn't affect in Orthographic as with Dolly.
     * @param x
     * @param y
     * @param z
     * @param enableTransition
     * @category Methods
     */ setFocalOffset(x, y, z, enableTransition = false) {
        this._isUserControllingOffset = false;
        this._focalOffsetEnd.set(x, y, z);
        this._needsUpdate = true;
        if (!enableTransition) this._focalOffset.copy(this._focalOffsetEnd);
        const resolveImmediately = !enableTransition || $625a33e30390866c$var$approxEquals(this._focalOffset.x, this._focalOffsetEnd.x, this.restThreshold) && $625a33e30390866c$var$approxEquals(this._focalOffset.y, this._focalOffsetEnd.y, this.restThreshold) && $625a33e30390866c$var$approxEquals(this._focalOffset.z, this._focalOffsetEnd.z, this.restThreshold);
        return this._createOnRestPromise(resolveImmediately);
    }
    /**
     * Set orbit point without moving the camera.
     * SHOULD NOT RUN DURING ANIMATIONS. `setOrbitPoint()` will immediately fix the positions.
     * @param targetX
     * @param targetY
     * @param targetZ
     * @category Methods
     */ setOrbitPoint(targetX, targetY, targetZ) {
        this._camera.updateMatrixWorld();
        $625a33e30390866c$var$_xColumn.setFromMatrixColumn(this._camera.matrixWorldInverse, 0);
        $625a33e30390866c$var$_yColumn.setFromMatrixColumn(this._camera.matrixWorldInverse, 1);
        $625a33e30390866c$var$_zColumn.setFromMatrixColumn(this._camera.matrixWorldInverse, 2);
        const position = $625a33e30390866c$var$_v3A.set(targetX, targetY, targetZ);
        const distance = position.distanceTo(this._camera.position);
        const cameraToPoint = position.sub(this._camera.position);
        $625a33e30390866c$var$_xColumn.multiplyScalar(cameraToPoint.x);
        $625a33e30390866c$var$_yColumn.multiplyScalar(cameraToPoint.y);
        $625a33e30390866c$var$_zColumn.multiplyScalar(cameraToPoint.z);
        $625a33e30390866c$var$_v3A.copy($625a33e30390866c$var$_xColumn).add($625a33e30390866c$var$_yColumn).add($625a33e30390866c$var$_zColumn);
        $625a33e30390866c$var$_v3A.z = $625a33e30390866c$var$_v3A.z + distance;
        this.dollyTo(distance, false);
        this.setFocalOffset(-$625a33e30390866c$var$_v3A.x, $625a33e30390866c$var$_v3A.y, -$625a33e30390866c$var$_v3A.z, false);
        this.moveTo(targetX, targetY, targetZ, false);
    }
    /**
     * Set the boundary box that encloses the target of the camera. box3 is in THREE.Box3
     * @param box3
     * @category Methods
     */ setBoundary(box3) {
        if (!box3) {
            this._boundary.min.set(-Infinity, -Infinity, -Infinity);
            this._boundary.max.set(Infinity, Infinity, Infinity);
            this._needsUpdate = true;
            return;
        }
        this._boundary.copy(box3);
        this._boundary.clampPoint(this._targetEnd, this._targetEnd);
        this._needsUpdate = true;
    }
    /**
     * Set (or unset) the current viewport.
     * Set this when you want to use renderer viewport and .dollyToCursor feature at the same time.
     * @param viewportOrX
     * @param y
     * @param width
     * @param height
     * @category Methods
     */ setViewport(viewportOrX, y, width, height) {
        if (viewportOrX === null) {
            this._viewport = null;
            return;
        }
        this._viewport = this._viewport || new $625a33e30390866c$var$THREE.Vector4();
        if (typeof viewportOrX === "number") this._viewport.set(viewportOrX, y, width, height);
        else this._viewport.copy(viewportOrX);
    }
    /**
     * Calculate the distance to fit the box.
     * @param width box width
     * @param height box height
     * @param depth box depth
     * @returns distance
     * @category Methods
     */ getDistanceToFitBox(width, height, depth, cover = false) {
        if ($625a33e30390866c$var$notSupportedInOrthographicCamera(this._camera, "getDistanceToFitBox")) return this._spherical.radius;
        const boundingRectAspect = width / height;
        const fov = this._camera.getEffectiveFOV() * $625a33e30390866c$var$DEG2RAD;
        const aspect = this._camera.aspect;
        const heightToFit = (cover ? boundingRectAspect > aspect : boundingRectAspect < aspect) ? height : width / aspect;
        return heightToFit * 0.5 / Math.tan(fov * 0.5) + depth * 0.5;
    }
    /**
     * Calculate the distance to fit the sphere.
     * @param radius sphere radius
     * @returns distance
     * @category Methods
     */ getDistanceToFitSphere(radius) {
        if ($625a33e30390866c$var$notSupportedInOrthographicCamera(this._camera, "getDistanceToFitSphere")) return this._spherical.radius;
        // https://stackoverflow.com/a/44849975
        const vFOV = this._camera.getEffectiveFOV() * $625a33e30390866c$var$DEG2RAD;
        const hFOV = Math.atan(Math.tan(vFOV * 0.5) * this._camera.aspect) * 2;
        const fov = 1 < this._camera.aspect ? vFOV : hFOV;
        return radius / Math.sin(fov * 0.5);
    }
    /**
     * Returns its current gazing target, which is the center position of the orbit.
     * @param out current gazing target
     * @category Methods
     */ getTarget(out) {
        const _out = !!out && out.isVector3 ? out : new $625a33e30390866c$var$THREE.Vector3();
        return _out.copy(this._targetEnd);
    }
    /**
     * Returns its current position.
     * @param out current position
     * @category Methods
     */ getPosition(out) {
        const _out = !!out && out.isVector3 ? out : new $625a33e30390866c$var$THREE.Vector3();
        return _out.setFromSpherical(this._sphericalEnd).applyQuaternion(this._yAxisUpSpaceInverse).add(this._targetEnd);
    }
    /**
     * Returns its current focal offset, which is how much the camera appears to be translated in screen parallel coordinates.
     * @param out current focal offset
     * @category Methods
     */ getFocalOffset(out) {
        const _out = !!out && out.isVector3 ? out : new $625a33e30390866c$var$THREE.Vector3();
        return _out.copy(this._focalOffsetEnd);
    }
    /**
     * Normalize camera azimuth angle rotation between 0 and 360 degrees.
     * @category Methods
     */ normalizeRotations() {
        this._sphericalEnd.theta = this._sphericalEnd.theta % $625a33e30390866c$var$PI_2;
        if (this._sphericalEnd.theta < 0) this._sphericalEnd.theta += $625a33e30390866c$var$PI_2;
        this._spherical.theta += $625a33e30390866c$var$PI_2 * Math.round((this._sphericalEnd.theta - this._spherical.theta) / $625a33e30390866c$var$PI_2);
    }
    /**
     * Reset all rotation and position to defaults.
     * @param enableTransition
     * @category Methods
     */ reset(enableTransition = false) {
        if (!$625a33e30390866c$var$approxEquals(this._camera.up.x, this._cameraUp0.x) || !$625a33e30390866c$var$approxEquals(this._camera.up.y, this._cameraUp0.y) || !$625a33e30390866c$var$approxEquals(this._camera.up.z, this._cameraUp0.z)) {
            this._camera.up.copy(this._cameraUp0);
            const position = this.getPosition($625a33e30390866c$var$_v3A);
            this.updateCameraUp();
            this.setPosition(position.x, position.y, position.z);
        }
        const promises = [
            this.setLookAt(this._position0.x, this._position0.y, this._position0.z, this._target0.x, this._target0.y, this._target0.z, enableTransition),
            this.setFocalOffset(this._focalOffset0.x, this._focalOffset0.y, this._focalOffset0.z, enableTransition),
            this.zoomTo(this._zoom0, enableTransition)
        ];
        return Promise.all(promises);
    }
    /**
     * Set current camera position as the default position.
     * @category Methods
     */ saveState() {
        this._cameraUp0.copy(this._camera.up);
        this.getTarget(this._target0);
        this.getPosition(this._position0);
        this._zoom0 = this._zoom;
        this._focalOffset0.copy(this._focalOffset);
    }
    /**
     * Sync camera-up direction.
     * When camera-up vector is changed, `.updateCameraUp()` must be called.
     * @category Methods
     */ updateCameraUp() {
        this._yAxisUpSpace.setFromUnitVectors(this._camera.up, $625a33e30390866c$var$_AXIS_Y);
        this._yAxisUpSpaceInverse.copy(this._yAxisUpSpace).invert();
    }
    /**
     * Apply current camera-up direction to the camera.
     * The orbit system will be re-initialized with the current position.
     * @category Methods
     */ applyCameraUp() {
        const cameraDirection = $625a33e30390866c$var$_v3A.subVectors(this._target, this._camera.position).normalize();
        // So first find the vector off to the side, orthogonal to both this.object.up and
        // the "view" vector.
        const side = $625a33e30390866c$var$_v3B.crossVectors(cameraDirection, this._camera.up).normalize();
        // Then find the vector orthogonal to both this "side" vector and the "view" vector.
        // This vector will be the new "up" vector.
        this._camera.up.crossVectors(side, cameraDirection).normalize();
        this._camera.updateMatrixWorld();
        const position = this.getPosition($625a33e30390866c$var$_v3A);
        this.updateCameraUp();
        this.setPosition(position.x, position.y, position.z);
    }
    /**
     * Update camera position and directions.
     * This should be called in your tick loop every time, and returns true if re-rendering is needed.
     * @param delta
     * @returns updated
     * @category Methods
     */ update(delta) {
        const deltaTheta = this._sphericalEnd.theta - this._spherical.theta;
        const deltaPhi = this._sphericalEnd.phi - this._spherical.phi;
        const deltaRadius = this._sphericalEnd.radius - this._spherical.radius;
        const deltaTarget = $625a33e30390866c$var$_deltaTarget.subVectors(this._targetEnd, this._target);
        const deltaOffset = $625a33e30390866c$var$_deltaOffset.subVectors(this._focalOffsetEnd, this._focalOffset);
        const deltaZoom = this._zoomEnd - this._zoom;
        // update theta
        if ($625a33e30390866c$var$approxZero(deltaTheta)) {
            this._thetaVelocity.value = 0;
            this._spherical.theta = this._sphericalEnd.theta;
        } else {
            const smoothTime = this._isUserControllingRotate ? this.draggingSmoothTime : this.smoothTime;
            this._spherical.theta = $625a33e30390866c$var$smoothDamp(this._spherical.theta, this._sphericalEnd.theta, this._thetaVelocity, smoothTime, Infinity, delta);
            this._needsUpdate = true;
        }
        // update phi
        if ($625a33e30390866c$var$approxZero(deltaPhi)) {
            this._phiVelocity.value = 0;
            this._spherical.phi = this._sphericalEnd.phi;
        } else {
            const smoothTime = this._isUserControllingRotate ? this.draggingSmoothTime : this.smoothTime;
            this._spherical.phi = $625a33e30390866c$var$smoothDamp(this._spherical.phi, this._sphericalEnd.phi, this._phiVelocity, smoothTime, Infinity, delta);
            this._needsUpdate = true;
        }
        // update distance
        if ($625a33e30390866c$var$approxZero(deltaRadius)) {
            this._radiusVelocity.value = 0;
            this._spherical.radius = this._sphericalEnd.radius;
        } else {
            const smoothTime = this._isUserControllingDolly ? this.draggingSmoothTime : this.smoothTime;
            this._spherical.radius = $625a33e30390866c$var$smoothDamp(this._spherical.radius, this._sphericalEnd.radius, this._radiusVelocity, smoothTime, this.maxSpeed, delta);
            this._needsUpdate = true;
        }
        // update target position
        if ($625a33e30390866c$var$approxZero(deltaTarget.x) && $625a33e30390866c$var$approxZero(deltaTarget.y) && $625a33e30390866c$var$approxZero(deltaTarget.z)) {
            this._targetVelocity.set(0, 0, 0);
            this._target.copy(this._targetEnd);
        } else {
            const smoothTime = this._isUserControllingTruck ? this.draggingSmoothTime : this.smoothTime;
            $625a33e30390866c$var$smoothDampVec3(this._target, this._targetEnd, this._targetVelocity, smoothTime, this.maxSpeed, delta, this._target);
            this._needsUpdate = true;
        }
        // update focalOffset
        if ($625a33e30390866c$var$approxZero(deltaOffset.x) && $625a33e30390866c$var$approxZero(deltaOffset.y) && $625a33e30390866c$var$approxZero(deltaOffset.z)) {
            this._focalOffsetVelocity.set(0, 0, 0);
            this._focalOffset.copy(this._focalOffsetEnd);
        } else {
            const smoothTime = this._isUserControllingOffset ? this.draggingSmoothTime : this.smoothTime;
            $625a33e30390866c$var$smoothDampVec3(this._focalOffset, this._focalOffsetEnd, this._focalOffsetVelocity, smoothTime, this.maxSpeed, delta, this._focalOffset);
            this._needsUpdate = true;
        }
        if (this._dollyControlAmount !== 0) {
            if ($625a33e30390866c$var$isPerspectiveCamera(this._camera)) {
                const camera = this._camera;
                const cameraDirection = $625a33e30390866c$var$_v3A.setFromSpherical(this._spherical).applyQuaternion(this._yAxisUpSpaceInverse).normalize().negate();
                const planeX = $625a33e30390866c$var$_v3B.copy(cameraDirection).cross(camera.up).normalize();
                if (planeX.lengthSq() === 0) planeX.x = 1.0;
                const planeY = $625a33e30390866c$var$_v3C.crossVectors(planeX, cameraDirection);
                const worldToScreen = this._sphericalEnd.radius * Math.tan(camera.getEffectiveFOV() * $625a33e30390866c$var$DEG2RAD * 0.5);
                const prevRadius = this._sphericalEnd.radius - this._dollyControlAmount;
                const lerpRatio = (prevRadius - this._sphericalEnd.radius) / this._sphericalEnd.radius;
                const cursor = $625a33e30390866c$var$_v3A.copy(this._targetEnd).add(planeX.multiplyScalar(this._dollyControlCoord.x * worldToScreen * camera.aspect)).add(planeY.multiplyScalar(this._dollyControlCoord.y * worldToScreen));
                this._targetEnd.lerp(cursor, lerpRatio);
            } else if ($625a33e30390866c$var$isOrthographicCamera(this._camera)) {
                const camera = this._camera;
                const worldCursorPosition = $625a33e30390866c$var$_v3A.set(this._dollyControlCoord.x, this._dollyControlCoord.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); //.sub( _v3B.set( this._focalOffset.x, this._focalOffset.y, 0 ) );
                const quaternion = $625a33e30390866c$var$_v3B.set(0, 0, -1).applyQuaternion(camera.quaternion);
                const cursor = $625a33e30390866c$var$_v3C.copy(worldCursorPosition).add(quaternion.multiplyScalar(-worldCursorPosition.dot(camera.up)));
                const prevZoom = this._zoom - this._dollyControlAmount;
                const lerpRatio = -(prevZoom - this._zoomEnd) / this._zoom;
                // find the "distance" (aka plane constant in three.js) of Plane
                // from a given position (this._targetEnd) and normal vector (cameraDirection)
                // https://www.maplesoft.com/support/help/maple/view.aspx?path=MathApps%2FEquationOfAPlaneNormal#bkmrk0
                const cameraDirection = $625a33e30390866c$var$_v3A.setFromSpherical(this._spherical).applyQuaternion(this._yAxisUpSpaceInverse).normalize().negate();
                const prevPlaneConstant = this._targetEnd.dot(cameraDirection);
                this._targetEnd.lerp(cursor, lerpRatio);
                const newPlaneConstant = this._targetEnd.dot(cameraDirection);
                // Pull back the camera depth that has moved, to be the camera stationary as zoom
                const pullBack = cameraDirection.multiplyScalar(newPlaneConstant - prevPlaneConstant);
                this._targetEnd.sub(pullBack);
            }
            this._target.copy(this._targetEnd);
            // target position may be moved beyond boundary.
            this._boundary.clampPoint(this._targetEnd, this._targetEnd);
            this._dollyControlAmount = 0;
        }
        // update zoom
        if ($625a33e30390866c$var$approxZero(deltaZoom)) {
            this._zoomVelocity.value = 0;
            this._zoom = this._zoomEnd;
        } else {
            const smoothTime = this._isUserControllingZoom ? this.draggingSmoothTime : this.smoothTime;
            this._zoom = $625a33e30390866c$var$smoothDamp(this._zoom, this._zoomEnd, this._zoomVelocity, smoothTime, Infinity, delta);
        }
        if (this._camera.zoom !== this._zoom) {
            this._camera.zoom = this._zoom;
            this._camera.updateProjectionMatrix();
            this._updateNearPlaneCorners();
            this._needsUpdate = true;
        }
        // collision detection
        const maxDistance = this._collisionTest();
        this._spherical.radius = Math.min(this._spherical.radius, maxDistance);
        // decompose spherical to the camera position
        this._spherical.makeSafe();
        this._camera.position.setFromSpherical(this._spherical).applyQuaternion(this._yAxisUpSpaceInverse).add(this._target);
        this._camera.lookAt(this._target);
        // set offset after the orbit movement
        const affectOffset = !$625a33e30390866c$var$approxZero(this._focalOffset.x) || !$625a33e30390866c$var$approxZero(this._focalOffset.y) || !$625a33e30390866c$var$approxZero(this._focalOffset.z);
        if (affectOffset) {
            this._camera.updateMatrixWorld();
            $625a33e30390866c$var$_xColumn.setFromMatrixColumn(this._camera.matrix, 0);
            $625a33e30390866c$var$_yColumn.setFromMatrixColumn(this._camera.matrix, 1);
            $625a33e30390866c$var$_zColumn.setFromMatrixColumn(this._camera.matrix, 2);
            $625a33e30390866c$var$_xColumn.multiplyScalar(this._focalOffset.x);
            $625a33e30390866c$var$_yColumn.multiplyScalar(-this._focalOffset.y);
            $625a33e30390866c$var$_zColumn.multiplyScalar(this._focalOffset.z); // notice: z-offset will not affect in Orthographic.
            $625a33e30390866c$var$_v3A.copy($625a33e30390866c$var$_xColumn).add($625a33e30390866c$var$_yColumn).add($625a33e30390866c$var$_zColumn);
            this._camera.position.add($625a33e30390866c$var$_v3A);
        }
        if (this._boundaryEnclosesCamera) this._encloseToBoundary(this._camera.position.copy(this._target), $625a33e30390866c$var$_v3A.setFromSpherical(this._spherical).applyQuaternion(this._yAxisUpSpaceInverse), 1.0);
        const updated = this._needsUpdate;
        if (updated && !this._updatedLastTime) {
            this._hasRested = false;
            this.dispatchEvent({
                type: "wake"
            });
            this.dispatchEvent({
                type: "update"
            });
        } else if (updated) {
            this.dispatchEvent({
                type: "update"
            });
            if ($625a33e30390866c$var$approxZero(deltaTheta, this.restThreshold) && $625a33e30390866c$var$approxZero(deltaPhi, this.restThreshold) && $625a33e30390866c$var$approxZero(deltaRadius, this.restThreshold) && $625a33e30390866c$var$approxZero(deltaTarget.x, this.restThreshold) && $625a33e30390866c$var$approxZero(deltaTarget.y, this.restThreshold) && $625a33e30390866c$var$approxZero(deltaTarget.z, this.restThreshold) && $625a33e30390866c$var$approxZero(deltaOffset.x, this.restThreshold) && $625a33e30390866c$var$approxZero(deltaOffset.y, this.restThreshold) && $625a33e30390866c$var$approxZero(deltaOffset.z, this.restThreshold) && $625a33e30390866c$var$approxZero(deltaZoom, this.restThreshold) && !this._hasRested) {
                this._hasRested = true;
                this.dispatchEvent({
                    type: "rest"
                });
            }
        } else if (!updated && this._updatedLastTime) this.dispatchEvent({
            type: "sleep"
        });
        this._updatedLastTime = updated;
        this._needsUpdate = false;
        return updated;
    }
    /**
     * Get all state in JSON string
     * @category Methods
     */ toJSON() {
        return JSON.stringify({
            enabled: this._enabled,
            minDistance: this.minDistance,
            maxDistance: $625a33e30390866c$var$infinityToMaxNumber(this.maxDistance),
            minZoom: this.minZoom,
            maxZoom: $625a33e30390866c$var$infinityToMaxNumber(this.maxZoom),
            minPolarAngle: this.minPolarAngle,
            maxPolarAngle: $625a33e30390866c$var$infinityToMaxNumber(this.maxPolarAngle),
            minAzimuthAngle: $625a33e30390866c$var$infinityToMaxNumber(this.minAzimuthAngle),
            maxAzimuthAngle: $625a33e30390866c$var$infinityToMaxNumber(this.maxAzimuthAngle),
            smoothTime: this.smoothTime,
            draggingSmoothTime: this.draggingSmoothTime,
            dollySpeed: this.dollySpeed,
            truckSpeed: this.truckSpeed,
            dollyToCursor: this.dollyToCursor,
            verticalDragToForward: this.verticalDragToForward,
            target: this._targetEnd.toArray(),
            position: $625a33e30390866c$var$_v3A.setFromSpherical(this._sphericalEnd).add(this._targetEnd).toArray(),
            zoom: this._zoomEnd,
            focalOffset: this._focalOffsetEnd.toArray(),
            target0: this._target0.toArray(),
            position0: this._position0.toArray(),
            zoom0: this._zoom0,
            focalOffset0: this._focalOffset0.toArray()
        });
    }
    /**
     * Reproduce the control state with JSON. enableTransition is where anim or not in a boolean.
     * @param json
     * @param enableTransition
     * @category Methods
     */ fromJSON(json, enableTransition = false) {
        const obj = JSON.parse(json);
        this.enabled = obj.enabled;
        this.minDistance = obj.minDistance;
        this.maxDistance = $625a33e30390866c$var$maxNumberToInfinity(obj.maxDistance);
        this.minZoom = obj.minZoom;
        this.maxZoom = $625a33e30390866c$var$maxNumberToInfinity(obj.maxZoom);
        this.minPolarAngle = obj.minPolarAngle;
        this.maxPolarAngle = $625a33e30390866c$var$maxNumberToInfinity(obj.maxPolarAngle);
        this.minAzimuthAngle = $625a33e30390866c$var$maxNumberToInfinity(obj.minAzimuthAngle);
        this.maxAzimuthAngle = $625a33e30390866c$var$maxNumberToInfinity(obj.maxAzimuthAngle);
        this.smoothTime = obj.smoothTime;
        this.draggingSmoothTime = obj.draggingSmoothTime;
        this.dollySpeed = obj.dollySpeed;
        this.truckSpeed = obj.truckSpeed;
        this.dollyToCursor = obj.dollyToCursor;
        this.verticalDragToForward = obj.verticalDragToForward;
        this._target0.fromArray(obj.target0);
        this._position0.fromArray(obj.position0);
        this._zoom0 = obj.zoom0;
        this._focalOffset0.fromArray(obj.focalOffset0);
        this.moveTo(obj.target[0], obj.target[1], obj.target[2], enableTransition);
        $625a33e30390866c$var$_sphericalA.setFromVector3($625a33e30390866c$var$_v3A.fromArray(obj.position).sub(this._targetEnd).applyQuaternion(this._yAxisUpSpace));
        this.rotateTo($625a33e30390866c$var$_sphericalA.theta, $625a33e30390866c$var$_sphericalA.phi, enableTransition);
        this.dollyTo($625a33e30390866c$var$_sphericalA.radius, enableTransition);
        this.zoomTo(obj.zoom, enableTransition);
        this.setFocalOffset(obj.focalOffset[0], obj.focalOffset[1], obj.focalOffset[2], enableTransition);
        this._needsUpdate = true;
    }
    /**
     * Attach all internal event handlers to enable drag control.
     * @category Methods
     */ connect(domElement) {
        if (this._domElement) {
            console.warn("camera-controls is already connected.");
            return;
        }
        domElement.setAttribute("data-camera-controls-version", $625a33e30390866c$var$VERSION);
        this._addAllEventListeners(domElement);
    }
    /**
     * Detach all internal event handlers to disable drag control.
     */ disconnect() {
        this.cancel();
        this._removeAllEventListeners();
        if (this._domElement) {
            this._domElement.removeAttribute("data-camera-controls-version");
            this._domElement = undefined;
        }
    }
    /**
     * Dispose the cameraControls instance itself, remove all eventListeners.
     * @category Methods
     */ dispose() {
        // remove all user event listeners
        this.removeAllEventListeners();
        // remove all internal event listeners
        this.disconnect();
    }
    _findPointerById(pointerId) {
        return this._activePointers.find((activePointer)=>activePointer.pointerId === pointerId);
    }
    _findPointerByMouseButton(mouseButton) {
        return this._activePointers.find((activePointer)=>activePointer.mouseButton === mouseButton);
    }
    _disposePointer(pointer) {
        this._activePointers.splice(this._activePointers.indexOf(pointer), 1);
    }
    _encloseToBoundary(position, offset, friction) {
        const offsetLength2 = offset.lengthSq();
        if (offsetLength2 === 0.0) return position;
        // See: https://twitter.com/FMS_Cat/status/1106508958640988161
        const newTarget = $625a33e30390866c$var$_v3B.copy(offset).add(position); // target
        const clampedTarget = this._boundary.clampPoint(newTarget, $625a33e30390866c$var$_v3C); // clamped target
        const deltaClampedTarget = clampedTarget.sub(newTarget); // newTarget -> clampedTarget
        const deltaClampedTargetLength2 = deltaClampedTarget.lengthSq(); // squared length of deltaClampedTarget
        if (deltaClampedTargetLength2 === 0.0) return position.add(offset);
        else if (deltaClampedTargetLength2 === offsetLength2) return position;
        else if (friction === 0.0) return position.add(offset).add(deltaClampedTarget);
        else {
            const offsetFactor = 1.0 + friction * deltaClampedTargetLength2 / offset.dot(deltaClampedTarget);
            return position.add($625a33e30390866c$var$_v3B.copy(offset).multiplyScalar(offsetFactor)).add(deltaClampedTarget.multiplyScalar(1.0 - friction));
        }
    }
    _updateNearPlaneCorners() {
        if ($625a33e30390866c$var$isPerspectiveCamera(this._camera)) {
            const camera = this._camera;
            const near = camera.near;
            const fov = camera.getEffectiveFOV() * $625a33e30390866c$var$DEG2RAD;
            const heightHalf = Math.tan(fov * 0.5) * near; // near plain half height
            const widthHalf = heightHalf * camera.aspect; // near plain half width
            this._nearPlaneCorners[0].set(-widthHalf, -heightHalf, 0);
            this._nearPlaneCorners[1].set(widthHalf, -heightHalf, 0);
            this._nearPlaneCorners[2].set(widthHalf, heightHalf, 0);
            this._nearPlaneCorners[3].set(-widthHalf, heightHalf, 0);
        } else if ($625a33e30390866c$var$isOrthographicCamera(this._camera)) {
            const camera = this._camera;
            const zoomInv = 1 / camera.zoom;
            const left = camera.left * zoomInv;
            const right = camera.right * zoomInv;
            const top = camera.top * zoomInv;
            const bottom = camera.bottom * zoomInv;
            this._nearPlaneCorners[0].set(left, top, 0);
            this._nearPlaneCorners[1].set(right, top, 0);
            this._nearPlaneCorners[2].set(right, bottom, 0);
            this._nearPlaneCorners[3].set(left, bottom, 0);
        }
    }
    // lateUpdate
    _collisionTest() {
        let distance = Infinity;
        const hasCollider = this.colliderMeshes.length >= 1;
        if (!hasCollider) return distance;
        if ($625a33e30390866c$var$notSupportedInOrthographicCamera(this._camera, "_collisionTest")) return distance;
        // divide by distance to normalize, lighter than `Vector3.prototype.normalize()`
        const direction = $625a33e30390866c$var$_v3A.setFromSpherical(this._spherical).divideScalar(this._spherical.radius);
        $625a33e30390866c$var$_rotationMatrix.lookAt($625a33e30390866c$var$_ORIGIN, direction, this._camera.up);
        for(let i = 0; i < 4; i++){
            const nearPlaneCorner = $625a33e30390866c$var$_v3B.copy(this._nearPlaneCorners[i]);
            nearPlaneCorner.applyMatrix4($625a33e30390866c$var$_rotationMatrix);
            const origin = $625a33e30390866c$var$_v3C.addVectors(this._target, nearPlaneCorner);
            $625a33e30390866c$var$_raycaster.set(origin, direction);
            $625a33e30390866c$var$_raycaster.far = this._spherical.radius + 1;
            const intersects = $625a33e30390866c$var$_raycaster.intersectObjects(this.colliderMeshes);
            if (intersects.length !== 0 && intersects[0].distance < distance) distance = intersects[0].distance;
        }
        return distance;
    }
    /**
     * Get its client rect and package into given `DOMRect` .
     */ _getClientRect(target) {
        if (!this._domElement) return;
        const rect = this._domElement.getBoundingClientRect();
        target.x = rect.left;
        target.y = rect.top;
        if (this._viewport) {
            target.x += this._viewport.x;
            target.y += rect.height - this._viewport.w - this._viewport.y;
            target.width = this._viewport.z;
            target.height = this._viewport.w;
        } else {
            target.width = rect.width;
            target.height = rect.height;
        }
        return target;
    }
    _createOnRestPromise(resolveImmediately) {
        if (resolveImmediately) return Promise.resolve();
        this._hasRested = false;
        this.dispatchEvent({
            type: "transitionstart"
        });
        return new Promise((resolve)=>{
            const onResolve = ()=>{
                this.removeEventListener("rest", onResolve);
                resolve();
            };
            this.addEventListener("rest", onResolve);
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _addAllEventListeners(_domElement) {}
    _removeAllEventListeners() {}
    /**
     * backward compatible
     * @deprecated use smoothTime (in seconds) instead
     * @category Properties
     */ get dampingFactor() {
        console.warn(".dampingFactor has been deprecated. use smoothTime (in seconds) instead.");
        return 0;
    }
    /**
     * backward compatible
     * @deprecated use smoothTime (in seconds) instead
     * @category Properties
     */ set dampingFactor(_) {
        console.warn(".dampingFactor has been deprecated. use smoothTime (in seconds) instead.");
    }
    /**
     * backward compatible
     * @deprecated use draggingSmoothTime (in seconds) instead
     * @category Properties
     */ get draggingDampingFactor() {
        console.warn(".draggingDampingFactor has been deprecated. use draggingSmoothTime (in seconds) instead.");
        return 0;
    }
    /**
     * backward compatible
     * @deprecated use draggingSmoothTime (in seconds) instead
     * @category Properties
     */ set draggingDampingFactor(_) {
        console.warn(".draggingDampingFactor has been deprecated. use draggingSmoothTime (in seconds) instead.");
    }
    static createBoundingSphere(object3d, out = new $625a33e30390866c$var$THREE.Sphere()) {
        const boundingSphere = out;
        const center = boundingSphere.center;
        $625a33e30390866c$var$_box3A.makeEmpty();
        // find the center
        object3d.traverseVisible((object)=>{
            if (!object.isMesh) return;
            $625a33e30390866c$var$_box3A.expandByObject(object);
        });
        $625a33e30390866c$var$_box3A.getCenter(center);
        // find the radius
        let maxRadiusSq = 0;
        object3d.traverseVisible((object)=>{
            if (!object.isMesh) return;
            const mesh = object;
            const geometry = mesh.geometry.clone();
            geometry.applyMatrix4(mesh.matrixWorld);
            const bufferGeometry = geometry;
            const position = bufferGeometry.attributes.position;
            for(let i = 0, l = position.count; i < l; i++){
                $625a33e30390866c$var$_v3A.fromBufferAttribute(position, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($625a33e30390866c$var$_v3A));
            }
        });
        boundingSphere.radius = Math.sqrt(maxRadiusSq);
        return boundingSphere;
    }
}




var $1bdO8 = parcelRequire("1bdO8");

const $288a4125d710e976$export$266a56a2f4822531 = ()=>{
    const [active, setActive] = (0, $1bdO8.useState)(false);
    const controls = (0, $e0e1f88defa94a87$export$df995fae86a55f06)((s)=>{
        if (s.controls instanceof (0, $625a33e30390866c$export$2e2bcd8739ae039)) return s.controls;
    });
    const handleStart = (0, $1bdO8.useCallback)(()=>{
        if (controls && controls.currentAction > 0) // console.log('setActive true');
        setActive(true);
    }, [
        controls
    ]);
    const handleEnd = (0, $1bdO8.useCallback)(()=>{
        // console.log('setActive false');
        setActive(false);
    }, [
        controls
    ]);
    (0, $d7b300a34dff373a$export$2e2bcd8739ae039)("controlstart", handleStart, controls);
    (0, $d7b300a34dff373a$export$2e2bcd8739ae039)("controlend", handleEnd, controls);
    return {
        controls: controls,
        active: active
    };
};




const $b9e146cc377af7a8$export$b9eeabc94409d792 = (box)=>{
    return new $e8ea6a63d48a4fea$export$6f7d5a9418ab2aa3(new $e8ea6a63d48a4fea$export$64b5c384219d3699(-Math.max(Math.abs(box.min.x), Math.abs(box.max.x)), -Math.max(Math.abs(box.min.y), Math.abs(box.max.y)), -Math.max(Math.abs(box.min.z), Math.abs(box.max.z))), new $e8ea6a63d48a4fea$export$64b5c384219d3699(Math.max(Math.abs(box.min.x), Math.abs(box.max.x)), Math.max(Math.abs(box.min.y), Math.abs(box.max.y)), Math.max(Math.abs(box.min.z), Math.abs(box.max.z))));
};



var $cVgDf = parcelRequire("cVgDf");

var $1bdO8 = parcelRequire("1bdO8");


var $cVgDf = parcelRequire("cVgDf");

var $1bdO8 = parcelRequire("1bdO8");

var $cVgDf = parcelRequire("cVgDf");
parcelRequire("1bdO8");



var $1bdO8 = parcelRequire("1bdO8");

function $108729c0b1999f4a$var$RenderHud({ defaultScene: defaultScene , defaultCamera: defaultCamera , renderPriority: renderPriority = 1  }) {
    const { gl: gl , scene: scene , camera: camera  } = (0, $e0e1f88defa94a87$export$df995fae86a55f06)();
    let oldCLear;
    (0, $e0e1f88defa94a87$export$ebd11618f299a286)(()=>{
        oldCLear = gl.autoClear;
        if (renderPriority === 1) {
            // Clear scene and render the default scene
            gl.autoClear = true;
            gl.render(defaultScene, defaultCamera);
        } // Disable cleaning and render the portal with its own camera
        gl.autoClear = false;
        gl.clearDepth();
        gl.render(scene, camera); // Restore default
        gl.autoClear = oldCLear;
    }, renderPriority);
    return /*#__PURE__*/ $1bdO8.createElement($1bdO8.Fragment, null);
}
function $108729c0b1999f4a$export$3df3c878e47daeb9({ children: children , renderPriority: renderPriority = 1  }) {
    const { scene: defaultScene , camera: defaultCamera  } = (0, $e0e1f88defa94a87$export$df995fae86a55f06)();
    const [hudScene] = $1bdO8.useState(()=>new $e8ea6a63d48a4fea$export$38af1803e3442a7f());
    return /*#__PURE__*/ $1bdO8.createElement($1bdO8.Fragment, null, (0, $e0e1f88defa94a87$export$39b482c5e57630a8)(/*#__PURE__*/ $1bdO8.createElement($1bdO8.Fragment, null, children, /*#__PURE__*/ $1bdO8.createElement($108729c0b1999f4a$var$RenderHud, {
        defaultScene: defaultScene,
        defaultCamera: defaultCamera,
        renderPriority: renderPriority
    })), hudScene, {
        events: {
            priority: renderPriority + 1
        }
    }));
}


var $63nUy = parcelRequire("63nUy");

var $1bdO8 = parcelRequire("1bdO8");

function $5880939bb54aa655$var$mergeRefs(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
var $5880939bb54aa655$export$2e2bcd8739ae039 = $5880939bb54aa655$var$mergeRefs;



var $1bdO8 = parcelRequire("1bdO8");


// 👇 uncomment when TS version supports function overloads
// export function useFBO(settings?: FBOSettings)
function $0937f858f4a26bd9$export$46efc781def3def7(/** Width in pixels, or settings (will render fullscreen by default) */ width, /** Height in pixels */ height, /**Settings */ settings) {
    const size = (0, $e0e1f88defa94a87$export$df995fae86a55f06)((state)=>state.size);
    const viewport = (0, $e0e1f88defa94a87$export$df995fae86a55f06)((state)=>state.viewport);
    const _width = typeof width === "number" ? width : size.width * viewport.dpr;
    const _height = typeof height === "number" ? height : size.height * viewport.dpr;
    const _settings = (typeof width === "number" ? settings : width) || {};
    const { samples: samples = 0 , depth: depth , ...targetSettings } = _settings;
    const target = $1bdO8.useMemo(()=>{
        const target = new $e8ea6a63d48a4fea$export$3c052beb2e51e23f(_width, _height, {
            minFilter: $e8ea6a63d48a4fea$export$8a72f490b25c56c8,
            magFilter: $e8ea6a63d48a4fea$export$8a72f490b25c56c8,
            type: $e8ea6a63d48a4fea$export$2697304443f382bc,
            ...targetSettings
        });
        if (depth) target.depthTexture = new $e8ea6a63d48a4fea$export$fc830aa069cc8c2f(_width, _height, $e8ea6a63d48a4fea$export$f6d331659b644596);
        target.samples = samples;
        return target;
    }, []);
    $1bdO8.useLayoutEffect(()=>{
        target.setSize(_width, _height);
        if (samples) target.samples = samples;
    }, [
        samples,
        target,
        _width,
        _height
    ]);
    $1bdO8.useEffect(()=>{
        return ()=>target.dispose();
    }, []);
    return target;
}


const $5994448d2cebddd0$var$isFunction = (node)=>typeof node === "function";
const $5994448d2cebddd0$export$9ebf355ee4ed261b = /*#__PURE__*/ $1bdO8.forwardRef(({ envMap: envMap , resolution: resolution = 256 , frames: frames = Infinity , children: children , makeDefault: makeDefault , ...props }, ref)=>{
    const set = (0, $e0e1f88defa94a87$export$df995fae86a55f06)(({ set: set  })=>set);
    const camera = (0, $e0e1f88defa94a87$export$df995fae86a55f06)(({ camera: camera  })=>camera);
    const size = (0, $e0e1f88defa94a87$export$df995fae86a55f06)(({ size: size  })=>size);
    const cameraRef = $1bdO8.useRef(null);
    const groupRef = $1bdO8.useRef(null);
    const fbo = (0, $0937f858f4a26bd9$export$46efc781def3def7)(resolution);
    $1bdO8.useLayoutEffect(()=>{
        if (!props.manual) cameraRef.current.updateProjectionMatrix();
    }, [
        size,
        props
    ]);
    $1bdO8.useLayoutEffect(()=>{
        cameraRef.current.updateProjectionMatrix();
    });
    $1bdO8.useLayoutEffect(()=>{
        if (makeDefault) {
            const oldCam = camera;
            set(()=>({
                    camera: cameraRef.current
                }));
            return ()=>set(()=>({
                        camera: oldCam
                    }));
        } // The camera should not be part of the dependency list because this components camera is a stable reference
    // that must exchange the default, and clean up after itself on unmount.
    }, [
        cameraRef,
        makeDefault,
        set
    ]);
    let count = 0;
    let oldEnvMap = null;
    const functional = $5994448d2cebddd0$var$isFunction(children);
    (0, $e0e1f88defa94a87$export$ebd11618f299a286)((state)=>{
        if (functional && (frames === Infinity || count < frames)) {
            groupRef.current.visible = false;
            state.gl.setRenderTarget(fbo);
            oldEnvMap = state.scene.background;
            if (envMap) state.scene.background = envMap;
            state.gl.render(state.scene, cameraRef.current);
            state.scene.background = oldEnvMap;
            state.gl.setRenderTarget(null);
            groupRef.current.visible = true;
            count++;
        }
    });
    return /*#__PURE__*/ $1bdO8.createElement($1bdO8.Fragment, null, /*#__PURE__*/ $1bdO8.createElement("orthographicCamera", (0, $63nUy.default)({
        left: size.width / -2,
        right: size.width / 2,
        top: size.height / 2,
        bottom: size.height / -2,
        ref: (0, $5880939bb54aa655$export$2e2bcd8739ae039)([
            cameraRef,
            ref
        ])
    }, props), !functional && children), /*#__PURE__*/ $1bdO8.createElement("group", {
        ref: groupRef
    }, functional && children(fbo.texture)));
});


function $a7bcb744ac034ff3$export$4f9a05f5d7140d31({ children: children , renderPriority: renderPriority = 1  }) {
    const size = (0, $e0e1f88defa94a87$export$df995fae86a55f06)((state)=>state.size);
    return /*#__PURE__*/ (0, $cVgDf.jsxs)((0, $108729c0b1999f4a$export$3df3c878e47daeb9), {
        renderPriority: renderPriority,
        children: [
            /*#__PURE__*/ (0, $cVgDf.jsx)((0, $5994448d2cebddd0$export$9ebf355ee4ed261b), {
                makeDefault: true,
                left: 0,
                bottom: 0,
                right: size.width,
                top: size.height,
                far: 1000,
                near: -1000
            }),
            children
        ]
    });
}



var $cVgDf = parcelRequire("cVgDf");


var $1bdO8 = parcelRequire("1bdO8");

var $63nUy = parcelRequire("63nUy");

var $1bdO8 = parcelRequire("1bdO8");




const $bafdd7b713b4d153$var$_box = new (0, $e8ea6a63d48a4fea$export$6f7d5a9418ab2aa3)();
const $bafdd7b713b4d153$var$_vector = new (0, $e8ea6a63d48a4fea$export$64b5c384219d3699)();
class $bafdd7b713b4d153$export$5b1256aa5274bf8 extends (0, $e8ea6a63d48a4fea$export$231f009cbe414146) {
    constructor(){
        super();
        this.isLineSegmentsGeometry = true;
        this.type = "LineSegmentsGeometry";
        const positions = [
            -1,
            2,
            0,
            1,
            2,
            0,
            -1,
            1,
            0,
            1,
            1,
            0,
            -1,
            0,
            0,
            1,
            0,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0
        ];
        const uvs = [
            -1,
            2,
            1,
            2,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -2,
            1,
            -2
        ];
        const index = [
            0,
            2,
            1,
            2,
            3,
            1,
            2,
            4,
            3,
            4,
            5,
            3,
            4,
            6,
            5,
            6,
            7,
            5
        ];
        this.setIndex(index);
        this.setAttribute("position", new (0, $e8ea6a63d48a4fea$export$cbe7a62641830ebd)(positions, 3));
        this.setAttribute("uv", new (0, $e8ea6a63d48a4fea$export$cbe7a62641830ebd)(uvs, 2));
    }
    applyMatrix4(matrix) {
        const start = this.attributes.instanceStart;
        const end = this.attributes.instanceEnd;
        if (start !== undefined) {
            start.applyMatrix4(matrix);
            end.applyMatrix4(matrix);
            start.needsUpdate = true;
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        return this;
    }
    setPositions(array) {
        let lineSegments;
        if (array instanceof Float32Array) lineSegments = array;
        else if (Array.isArray(array)) lineSegments = new Float32Array(array);
        const instanceBuffer = new (0, $e8ea6a63d48a4fea$export$25ec0e1af1389358)(lineSegments, 6, 1); // xyz, xyz
        this.setAttribute("instanceStart", new (0, $e8ea6a63d48a4fea$export$920b6d07334599c7)(instanceBuffer, 3, 0)); // xyz
        this.setAttribute("instanceEnd", new (0, $e8ea6a63d48a4fea$export$920b6d07334599c7)(instanceBuffer, 3, 3)); // xyz
        //
        this.computeBoundingBox();
        this.computeBoundingSphere();
        return this;
    }
    setColors(array) {
        let colors;
        if (array instanceof Float32Array) colors = array;
        else if (Array.isArray(array)) colors = new Float32Array(array);
        const instanceColorBuffer = new (0, $e8ea6a63d48a4fea$export$25ec0e1af1389358)(colors, 6, 1); // rgb, rgb
        this.setAttribute("instanceColorStart", new (0, $e8ea6a63d48a4fea$export$920b6d07334599c7)(instanceColorBuffer, 3, 0)); // rgb
        this.setAttribute("instanceColorEnd", new (0, $e8ea6a63d48a4fea$export$920b6d07334599c7)(instanceColorBuffer, 3, 3)); // rgb
        return this;
    }
    fromWireframeGeometry(geometry) {
        this.setPositions(geometry.attributes.position.array);
        return this;
    }
    fromEdgesGeometry(geometry) {
        this.setPositions(geometry.attributes.position.array);
        return this;
    }
    fromMesh(mesh) {
        this.fromWireframeGeometry(new (0, $e8ea6a63d48a4fea$export$4b739da06d24892b)(mesh.geometry)); // set colors, maybe
        return this;
    }
    fromLineSegments(lineSegments) {
        const geometry = lineSegments.geometry;
        this.setPositions(geometry.attributes.position.array); // assumes non-indexed
        // set colors, maybe
        return this;
    }
    computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new (0, $e8ea6a63d48a4fea$export$6f7d5a9418ab2aa3)();
        const start = this.attributes.instanceStart;
        const end = this.attributes.instanceEnd;
        if (start !== undefined && end !== undefined) {
            this.boundingBox.setFromBufferAttribute(start);
            $bafdd7b713b4d153$var$_box.setFromBufferAttribute(end);
            this.boundingBox.union($bafdd7b713b4d153$var$_box);
        }
    }
    computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new (0, $e8ea6a63d48a4fea$export$805e8b72413ccaba)();
        if (this.boundingBox === null) this.computeBoundingBox();
        const start = this.attributes.instanceStart;
        const end = this.attributes.instanceEnd;
        if (start !== undefined && end !== undefined) {
            const center = this.boundingSphere.center;
            this.boundingBox.getCenter(center);
            let maxRadiusSq = 0;
            for(let i = 0, il = start.count; i < il; i++){
                $bafdd7b713b4d153$var$_vector.fromBufferAttribute(start, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($bafdd7b713b4d153$var$_vector));
                $bafdd7b713b4d153$var$_vector.fromBufferAttribute(end, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($bafdd7b713b4d153$var$_vector));
            }
            this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
            if (isNaN(this.boundingSphere.radius)) console.error("THREE.LineSegmentsGeometry.computeBoundingSphere(): Computed radius is NaN. The instanced position data is likely to have NaN values.", this);
        }
    }
    toJSON() {}
    applyMatrix(matrix) {
        console.warn("THREE.LineSegmentsGeometry: applyMatrix() has been renamed to applyMatrix4().");
        return this.applyMatrix4(matrix);
    }
}



/**
 * parameters = {
 *  color: <hex>,
 *  linewidth: <float>,
 *  dashed: <boolean>,
 *  dashScale: <float>,
 *  dashSize: <float>,
 *  dashOffset: <float>,
 *  gapSize: <float>,
 *  resolution: <Vector2>, // to be set by renderer
 * }
 */ (0, $e8ea6a63d48a4fea$export$6643083551874bf5).line = {
    worldUnits: {
        value: 1
    },
    linewidth: {
        value: 1
    },
    resolution: {
        value: new (0, $e8ea6a63d48a4fea$export$c977b3e384af9ae1)(1, 1)
    },
    dashOffset: {
        value: 0
    },
    dashScale: {
        value: 1
    },
    dashSize: {
        value: 1
    },
    gapSize: {
        value: 1
    } // todo FIX - maybe change to totalSize
};
(0, $e8ea6a63d48a4fea$export$bee4a7d47f8f5014)["line"] = {
    uniforms: (0, $e8ea6a63d48a4fea$export$d8ecdf8615bfea69).merge([
        (0, $e8ea6a63d48a4fea$export$6643083551874bf5).common,
        (0, $e8ea6a63d48a4fea$export$6643083551874bf5).fog,
        (0, $e8ea6a63d48a4fea$export$6643083551874bf5).line
    ]),
    vertexShader: /* glsl */ `
		#include <common>
		#include <color_pars_vertex>
		#include <fog_pars_vertex>
		#include <logdepthbuf_pars_vertex>
		#include <clipping_planes_pars_vertex>

		uniform float linewidth;
		uniform vec2 resolution;

		attribute vec3 instanceStart;
		attribute vec3 instanceEnd;

		attribute vec3 instanceColorStart;
		attribute vec3 instanceColorEnd;

		#ifdef WORLD_UNITS

			varying vec4 worldPos;
			varying vec3 worldStart;
			varying vec3 worldEnd;

			#ifdef USE_DASH

				varying vec2 vUv;

			#endif

		#else

			varying vec2 vUv;

		#endif

		#ifdef USE_DASH

			uniform float dashScale;
			attribute float instanceDistanceStart;
			attribute float instanceDistanceEnd;
			varying float vLineDistance;

		#endif

		void trimSegment( const in vec4 start, inout vec4 end ) {

			// trim end segment so it terminates between the camera plane and the near plane

			// conservative estimate of the near plane
			float a = projectionMatrix[ 2 ][ 2 ]; // 3nd entry in 3th column
			float b = projectionMatrix[ 3 ][ 2 ]; // 3nd entry in 4th column
			float nearEstimate = - 0.5 * b / a;

			float alpha = ( nearEstimate - start.z ) / ( end.z - start.z );

			end.xyz = mix( start.xyz, end.xyz, alpha );

		}

		void main() {

			#ifdef USE_COLOR

				vColor.xyz = ( position.y < 0.5 ) ? instanceColorStart : instanceColorEnd;

			#endif

			#ifdef USE_DASH

				vLineDistance = ( position.y < 0.5 ) ? dashScale * instanceDistanceStart : dashScale * instanceDistanceEnd;
				vUv = uv;

			#endif

			float aspect = resolution.x / resolution.y;

			// camera space
			vec4 start = modelViewMatrix * vec4( instanceStart, 1.0 );
			vec4 end = modelViewMatrix * vec4( instanceEnd, 1.0 );

			#ifdef WORLD_UNITS

				worldStart = start.xyz;
				worldEnd = end.xyz;

			#else

				vUv = uv;

			#endif

			// special case for perspective projection, and segments that terminate either in, or behind, the camera plane
			// clearly the gpu firmware has a way of addressing this issue when projecting into ndc space
			// but we need to perform ndc-space calculations in the shader, so we must address this issue directly
			// perhaps there is a more elegant solution -- WestLangley

			bool perspective = ( projectionMatrix[ 2 ][ 3 ] == - 1.0 ); // 4th entry in the 3rd column

			if ( perspective ) {

				if ( start.z < 0.0 && end.z >= 0.0 ) {

					trimSegment( start, end );

				} else if ( end.z < 0.0 && start.z >= 0.0 ) {

					trimSegment( end, start );

				}

			}

			// clip space
			vec4 clipStart = projectionMatrix * start;
			vec4 clipEnd = projectionMatrix * end;

			// ndc space
			vec3 ndcStart = clipStart.xyz / clipStart.w;
			vec3 ndcEnd = clipEnd.xyz / clipEnd.w;

			// direction
			vec2 dir = ndcEnd.xy - ndcStart.xy;

			// account for clip-space aspect ratio
			dir.x *= aspect;
			dir = normalize( dir );

			#ifdef WORLD_UNITS

				// get the offset direction as perpendicular to the view vector
				vec3 worldDir = normalize( end.xyz - start.xyz );
				vec3 offset;
				if ( position.y < 0.5 ) {

					offset = normalize( cross( start.xyz, worldDir ) );

				} else {

					offset = normalize( cross( end.xyz, worldDir ) );

				}

				// sign flip
				if ( position.x < 0.0 ) offset *= - 1.0;

				float forwardOffset = dot( worldDir, vec3( 0.0, 0.0, 1.0 ) );

				// don't extend the line if we're rendering dashes because we
				// won't be rendering the endcaps
				#ifndef USE_DASH

					// extend the line bounds to encompass  endcaps
					start.xyz += - worldDir * linewidth * 0.5;
					end.xyz += worldDir * linewidth * 0.5;

					// shift the position of the quad so it hugs the forward edge of the line
					offset.xy -= dir * forwardOffset;
					offset.z += 0.5;

				#endif

				// endcaps
				if ( position.y > 1.0 || position.y < 0.0 ) {

					offset.xy += dir * 2.0 * forwardOffset;

				}

				// adjust for linewidth
				offset *= linewidth * 0.5;

				// set the world position
				worldPos = ( position.y < 0.5 ) ? start : end;
				worldPos.xyz += offset;

				// project the worldpos
				vec4 clip = projectionMatrix * worldPos;

				// shift the depth of the projected points so the line
				// segments overlap neatly
				vec3 clipPose = ( position.y < 0.5 ) ? ndcStart : ndcEnd;
				clip.z = clipPose.z * clip.w;

			#else

				vec2 offset = vec2( dir.y, - dir.x );
				// undo aspect ratio adjustment
				dir.x /= aspect;
				offset.x /= aspect;

				// sign flip
				if ( position.x < 0.0 ) offset *= - 1.0;

				// endcaps
				if ( position.y < 0.0 ) {

					offset += - dir;

				} else if ( position.y > 1.0 ) {

					offset += dir;

				}

				// adjust for linewidth
				offset *= linewidth;

				// adjust for clip-space to screen-space conversion // maybe resolution should be based on viewport ...
				offset /= resolution.y;

				// select end
				vec4 clip = ( position.y < 0.5 ) ? clipStart : clipEnd;

				// back to clip space
				offset *= clip.w;

				clip.xy += offset;

			#endif

			gl_Position = clip;

			vec4 mvPosition = ( position.y < 0.5 ) ? start : end; // this is an approximation

			#include <logdepthbuf_vertex>
			#include <clipping_planes_vertex>
			#include <fog_vertex>

		}
		`,
    fragmentShader: /* glsl */ `
		uniform vec3 diffuse;
		uniform float opacity;
		uniform float linewidth;

		#ifdef USE_DASH

			uniform float dashOffset;
			uniform float dashSize;
			uniform float gapSize;

		#endif

		varying float vLineDistance;

		#ifdef WORLD_UNITS

			varying vec4 worldPos;
			varying vec3 worldStart;
			varying vec3 worldEnd;

			#ifdef USE_DASH

				varying vec2 vUv;

			#endif

		#else

			varying vec2 vUv;

		#endif

		#include <common>
		#include <color_pars_fragment>
		#include <fog_pars_fragment>
		#include <logdepthbuf_pars_fragment>
		#include <clipping_planes_pars_fragment>

		vec2 closestLineToLine(vec3 p1, vec3 p2, vec3 p3, vec3 p4) {

			float mua;
			float mub;

			vec3 p13 = p1 - p3;
			vec3 p43 = p4 - p3;

			vec3 p21 = p2 - p1;

			float d1343 = dot( p13, p43 );
			float d4321 = dot( p43, p21 );
			float d1321 = dot( p13, p21 );
			float d4343 = dot( p43, p43 );
			float d2121 = dot( p21, p21 );

			float denom = d2121 * d4343 - d4321 * d4321;

			float numer = d1343 * d4321 - d1321 * d4343;

			mua = numer / denom;
			mua = clamp( mua, 0.0, 1.0 );
			mub = ( d1343 + d4321 * ( mua ) ) / d4343;
			mub = clamp( mub, 0.0, 1.0 );

			return vec2( mua, mub );

		}

		void main() {

			#include <clipping_planes_fragment>

			#ifdef USE_DASH

				if ( vUv.y < - 1.0 || vUv.y > 1.0 ) discard; // discard endcaps

				if ( mod( vLineDistance + dashOffset, dashSize + gapSize ) > dashSize ) discard; // todo - FIX

			#endif

			float alpha = opacity;

			#ifdef WORLD_UNITS

				// Find the closest points on the view ray and the line segment
				vec3 rayEnd = normalize( worldPos.xyz ) * 1e5;
				vec3 lineDir = worldEnd - worldStart;
				vec2 params = closestLineToLine( worldStart, worldEnd, vec3( 0.0, 0.0, 0.0 ), rayEnd );

				vec3 p1 = worldStart + lineDir * params.x;
				vec3 p2 = rayEnd * params.y;
				vec3 delta = p1 - p2;
				float len = length( delta );
				float norm = len / linewidth;

				#ifndef USE_DASH

					#ifdef USE_ALPHA_TO_COVERAGE

						float dnorm = fwidth( norm );
						alpha = 1.0 - smoothstep( 0.5 - dnorm, 0.5 + dnorm, norm );

					#else

						if ( norm > 0.5 ) {

							discard;

						}

					#endif

				#endif

			#else

				#ifdef USE_ALPHA_TO_COVERAGE

					// artifacts appear on some hardware if a derivative is taken within a conditional
					float a = vUv.x;
					float b = ( vUv.y > 0.0 ) ? vUv.y - 1.0 : vUv.y + 1.0;
					float len2 = a * a + b * b;
					float dlen = fwidth( len2 );

					if ( abs( vUv.y ) > 1.0 ) {

						alpha = 1.0 - smoothstep( 1.0 - dlen, 1.0 + dlen, len2 );

					}

				#else

					if ( abs( vUv.y ) > 1.0 ) {

						float a = vUv.x;
						float b = ( vUv.y > 0.0 ) ? vUv.y - 1.0 : vUv.y + 1.0;
						float len2 = a * a + b * b;

						if ( len2 > 1.0 ) discard;

					}

				#endif

			#endif

			vec4 diffuseColor = vec4( diffuse, alpha );

			#include <logdepthbuf_fragment>
			#include <color_fragment>

			gl_FragColor = vec4( diffuseColor.rgb, alpha );

			#include <tonemapping_fragment>
			#include <encodings_fragment>
			#include <fog_fragment>
			#include <premultiplied_alpha_fragment>

		}
		`
};
class $9ead5c2fdc8d2606$export$d19cd1378966f3d3 extends (0, $e8ea6a63d48a4fea$export$83c7d75d550a8b0d) {
    constructor(parameters){
        super({
            type: "LineMaterial",
            uniforms: (0, $e8ea6a63d48a4fea$export$d8ecdf8615bfea69).clone((0, $e8ea6a63d48a4fea$export$bee4a7d47f8f5014)["line"].uniforms),
            vertexShader: (0, $e8ea6a63d48a4fea$export$bee4a7d47f8f5014)["line"].vertexShader,
            fragmentShader: (0, $e8ea6a63d48a4fea$export$bee4a7d47f8f5014)["line"].fragmentShader,
            clipping: true // required for clipping support
        });
        this.isLineMaterial = true;
        Object.defineProperties(this, {
            color: {
                enumerable: true,
                get: function() {
                    return this.uniforms.diffuse.value;
                },
                set: function(value) {
                    this.uniforms.diffuse.value = value;
                }
            },
            worldUnits: {
                enumerable: true,
                get: function() {
                    return "WORLD_UNITS" in this.defines;
                },
                set: function(value) {
                    if (value === true) this.defines.WORLD_UNITS = "";
                    else delete this.defines.WORLD_UNITS;
                }
            },
            linewidth: {
                enumerable: true,
                get: function() {
                    return this.uniforms.linewidth.value;
                },
                set: function(value) {
                    this.uniforms.linewidth.value = value;
                }
            },
            dashed: {
                enumerable: true,
                get: function() {
                    return Boolean("USE_DASH" in this.defines);
                },
                set (value) {
                    if (Boolean(value) !== Boolean("USE_DASH" in this.defines)) this.needsUpdate = true;
                    if (value === true) this.defines.USE_DASH = "";
                    else delete this.defines.USE_DASH;
                }
            },
            dashScale: {
                enumerable: true,
                get: function() {
                    return this.uniforms.dashScale.value;
                },
                set: function(value) {
                    this.uniforms.dashScale.value = value;
                }
            },
            dashSize: {
                enumerable: true,
                get: function() {
                    return this.uniforms.dashSize.value;
                },
                set: function(value) {
                    this.uniforms.dashSize.value = value;
                }
            },
            dashOffset: {
                enumerable: true,
                get: function() {
                    return this.uniforms.dashOffset.value;
                },
                set: function(value) {
                    this.uniforms.dashOffset.value = value;
                }
            },
            gapSize: {
                enumerable: true,
                get: function() {
                    return this.uniforms.gapSize.value;
                },
                set: function(value) {
                    this.uniforms.gapSize.value = value;
                }
            },
            opacity: {
                enumerable: true,
                get: function() {
                    return this.uniforms.opacity.value;
                },
                set: function(value) {
                    this.uniforms.opacity.value = value;
                }
            },
            resolution: {
                enumerable: true,
                get: function() {
                    return this.uniforms.resolution.value;
                },
                set: function(value) {
                    this.uniforms.resolution.value.copy(value);
                }
            },
            alphaToCoverage: {
                enumerable: true,
                get: function() {
                    return Boolean("USE_ALPHA_TO_COVERAGE" in this.defines);
                },
                set: function(value) {
                    if (Boolean(value) !== Boolean("USE_ALPHA_TO_COVERAGE" in this.defines)) this.needsUpdate = true;
                    if (value === true) {
                        this.defines.USE_ALPHA_TO_COVERAGE = "";
                        this.extensions.derivatives = true;
                    } else {
                        delete this.defines.USE_ALPHA_TO_COVERAGE;
                        this.extensions.derivatives = false;
                    }
                }
            }
        });
        this.setValues(parameters);
    }
}


const $27a15484768bd0f4$var$_start = new (0, $e8ea6a63d48a4fea$export$64b5c384219d3699)();
const $27a15484768bd0f4$var$_end = new (0, $e8ea6a63d48a4fea$export$64b5c384219d3699)();
const $27a15484768bd0f4$var$_start4 = new (0, $e8ea6a63d48a4fea$export$fa7daccca11cdbe3)();
const $27a15484768bd0f4$var$_end4 = new (0, $e8ea6a63d48a4fea$export$fa7daccca11cdbe3)();
const $27a15484768bd0f4$var$_ssOrigin = new (0, $e8ea6a63d48a4fea$export$fa7daccca11cdbe3)();
const $27a15484768bd0f4$var$_ssOrigin3 = new (0, $e8ea6a63d48a4fea$export$64b5c384219d3699)();
const $27a15484768bd0f4$var$_mvMatrix = new (0, $e8ea6a63d48a4fea$export$2ae72fc923e5eb5)();
const $27a15484768bd0f4$var$_line = new (0, $e8ea6a63d48a4fea$export$e0ba6359f1954fd3)();
const $27a15484768bd0f4$var$_closestPoint = new (0, $e8ea6a63d48a4fea$export$64b5c384219d3699)();
const $27a15484768bd0f4$var$_box = new (0, $e8ea6a63d48a4fea$export$6f7d5a9418ab2aa3)();
const $27a15484768bd0f4$var$_sphere = new (0, $e8ea6a63d48a4fea$export$805e8b72413ccaba)();
const $27a15484768bd0f4$var$_clipToWorldVector = new (0, $e8ea6a63d48a4fea$export$fa7daccca11cdbe3)();
let $27a15484768bd0f4$var$_ray, $27a15484768bd0f4$var$_instanceStart, $27a15484768bd0f4$var$_instanceEnd, $27a15484768bd0f4$var$_lineWidth; // Returns the margin required to expand by in world space given the distance from the camera,
// line width, resolution, and camera projection
function $27a15484768bd0f4$var$getWorldSpaceHalfWidth(camera, distance, resolution) {
    // transform into clip space, adjust the x and y values by the pixel width offset, then
    // transform back into world space to get world offset. Note clip space is [-1, 1] so full
    // width does not need to be halved.
    $27a15484768bd0f4$var$_clipToWorldVector.set(0, 0, -distance, 1.0).applyMatrix4(camera.projectionMatrix);
    $27a15484768bd0f4$var$_clipToWorldVector.multiplyScalar(1.0 / $27a15484768bd0f4$var$_clipToWorldVector.w);
    $27a15484768bd0f4$var$_clipToWorldVector.x = $27a15484768bd0f4$var$_lineWidth / resolution.width;
    $27a15484768bd0f4$var$_clipToWorldVector.y = $27a15484768bd0f4$var$_lineWidth / resolution.height;
    $27a15484768bd0f4$var$_clipToWorldVector.applyMatrix4(camera.projectionMatrixInverse);
    $27a15484768bd0f4$var$_clipToWorldVector.multiplyScalar(1.0 / $27a15484768bd0f4$var$_clipToWorldVector.w);
    return Math.abs(Math.max($27a15484768bd0f4$var$_clipToWorldVector.x, $27a15484768bd0f4$var$_clipToWorldVector.y));
}
function $27a15484768bd0f4$var$raycastWorldUnits(lineSegments, intersects) {
    for(let i = 0, l = $27a15484768bd0f4$var$_instanceStart.count; i < l; i++){
        $27a15484768bd0f4$var$_line.start.fromBufferAttribute($27a15484768bd0f4$var$_instanceStart, i);
        $27a15484768bd0f4$var$_line.end.fromBufferAttribute($27a15484768bd0f4$var$_instanceEnd, i);
        const pointOnLine = new (0, $e8ea6a63d48a4fea$export$64b5c384219d3699)();
        const point = new (0, $e8ea6a63d48a4fea$export$64b5c384219d3699)();
        $27a15484768bd0f4$var$_ray.distanceSqToSegment($27a15484768bd0f4$var$_line.start, $27a15484768bd0f4$var$_line.end, point, pointOnLine);
        const isInside = point.distanceTo(pointOnLine) < $27a15484768bd0f4$var$_lineWidth * 0.5;
        if (isInside) intersects.push({
            point: point,
            pointOnLine: pointOnLine,
            distance: $27a15484768bd0f4$var$_ray.origin.distanceTo(point),
            object: lineSegments,
            face: null,
            faceIndex: i,
            uv: null,
            uv2: null
        });
    }
}
function $27a15484768bd0f4$var$raycastScreenSpace(lineSegments, camera, intersects) {
    const projectionMatrix = camera.projectionMatrix;
    const material = lineSegments.material;
    const resolution = material.resolution;
    const matrixWorld = lineSegments.matrixWorld;
    const geometry = lineSegments.geometry;
    const instanceStart = geometry.attributes.instanceStart;
    const instanceEnd = geometry.attributes.instanceEnd;
    const near = -camera.near; //
    // pick a point 1 unit out along the ray to avoid the ray origin
    // sitting at the camera origin which will cause "w" to be 0 when
    // applying the projection matrix.
    $27a15484768bd0f4$var$_ray.at(1, $27a15484768bd0f4$var$_ssOrigin); // ndc space [ - 1.0, 1.0 ]
    $27a15484768bd0f4$var$_ssOrigin.w = 1;
    $27a15484768bd0f4$var$_ssOrigin.applyMatrix4(camera.matrixWorldInverse);
    $27a15484768bd0f4$var$_ssOrigin.applyMatrix4(projectionMatrix);
    $27a15484768bd0f4$var$_ssOrigin.multiplyScalar(1 / $27a15484768bd0f4$var$_ssOrigin.w); // screen space
    $27a15484768bd0f4$var$_ssOrigin.x *= resolution.x / 2;
    $27a15484768bd0f4$var$_ssOrigin.y *= resolution.y / 2;
    $27a15484768bd0f4$var$_ssOrigin.z = 0;
    $27a15484768bd0f4$var$_ssOrigin3.copy($27a15484768bd0f4$var$_ssOrigin);
    $27a15484768bd0f4$var$_mvMatrix.multiplyMatrices(camera.matrixWorldInverse, matrixWorld);
    for(let i = 0, l = instanceStart.count; i < l; i++){
        $27a15484768bd0f4$var$_start4.fromBufferAttribute(instanceStart, i);
        $27a15484768bd0f4$var$_end4.fromBufferAttribute(instanceEnd, i);
        $27a15484768bd0f4$var$_start4.w = 1;
        $27a15484768bd0f4$var$_end4.w = 1; // camera space
        $27a15484768bd0f4$var$_start4.applyMatrix4($27a15484768bd0f4$var$_mvMatrix);
        $27a15484768bd0f4$var$_end4.applyMatrix4($27a15484768bd0f4$var$_mvMatrix); // skip the segment if it's entirely behind the camera
        const isBehindCameraNear = $27a15484768bd0f4$var$_start4.z > near && $27a15484768bd0f4$var$_end4.z > near;
        if (isBehindCameraNear) continue;
         // trim the segment if it extends behind camera near
        if ($27a15484768bd0f4$var$_start4.z > near) {
            const deltaDist = $27a15484768bd0f4$var$_start4.z - $27a15484768bd0f4$var$_end4.z;
            const t = ($27a15484768bd0f4$var$_start4.z - near) / deltaDist;
            $27a15484768bd0f4$var$_start4.lerp($27a15484768bd0f4$var$_end4, t);
        } else if ($27a15484768bd0f4$var$_end4.z > near) {
            const deltaDist = $27a15484768bd0f4$var$_end4.z - $27a15484768bd0f4$var$_start4.z;
            const t = ($27a15484768bd0f4$var$_end4.z - near) / deltaDist;
            $27a15484768bd0f4$var$_end4.lerp($27a15484768bd0f4$var$_start4, t);
        } // clip space
        $27a15484768bd0f4$var$_start4.applyMatrix4(projectionMatrix);
        $27a15484768bd0f4$var$_end4.applyMatrix4(projectionMatrix); // ndc space [ - 1.0, 1.0 ]
        $27a15484768bd0f4$var$_start4.multiplyScalar(1 / $27a15484768bd0f4$var$_start4.w);
        $27a15484768bd0f4$var$_end4.multiplyScalar(1 / $27a15484768bd0f4$var$_end4.w); // screen space
        $27a15484768bd0f4$var$_start4.x *= resolution.x / 2;
        $27a15484768bd0f4$var$_start4.y *= resolution.y / 2;
        $27a15484768bd0f4$var$_end4.x *= resolution.x / 2;
        $27a15484768bd0f4$var$_end4.y *= resolution.y / 2; // create 2d segment
        $27a15484768bd0f4$var$_line.start.copy($27a15484768bd0f4$var$_start4);
        $27a15484768bd0f4$var$_line.start.z = 0;
        $27a15484768bd0f4$var$_line.end.copy($27a15484768bd0f4$var$_end4);
        $27a15484768bd0f4$var$_line.end.z = 0; // get closest point on ray to segment
        const param = $27a15484768bd0f4$var$_line.closestPointToPointParameter($27a15484768bd0f4$var$_ssOrigin3, true);
        $27a15484768bd0f4$var$_line.at(param, $27a15484768bd0f4$var$_closestPoint); // check if the intersection point is within clip space
        const zPos = (0, $e8ea6a63d48a4fea$export$6a7ef315a0d1ef07).lerp($27a15484768bd0f4$var$_start4.z, $27a15484768bd0f4$var$_end4.z, param);
        const isInClipSpace = zPos >= -1 && zPos <= 1;
        const isInside = $27a15484768bd0f4$var$_ssOrigin3.distanceTo($27a15484768bd0f4$var$_closestPoint) < $27a15484768bd0f4$var$_lineWidth * 0.5;
        if (isInClipSpace && isInside) {
            $27a15484768bd0f4$var$_line.start.fromBufferAttribute(instanceStart, i);
            $27a15484768bd0f4$var$_line.end.fromBufferAttribute(instanceEnd, i);
            $27a15484768bd0f4$var$_line.start.applyMatrix4(matrixWorld);
            $27a15484768bd0f4$var$_line.end.applyMatrix4(matrixWorld);
            const pointOnLine = new (0, $e8ea6a63d48a4fea$export$64b5c384219d3699)();
            const point = new (0, $e8ea6a63d48a4fea$export$64b5c384219d3699)();
            $27a15484768bd0f4$var$_ray.distanceSqToSegment($27a15484768bd0f4$var$_line.start, $27a15484768bd0f4$var$_line.end, point, pointOnLine);
            intersects.push({
                point: point,
                pointOnLine: pointOnLine,
                distance: $27a15484768bd0f4$var$_ray.origin.distanceTo(point),
                object: lineSegments,
                face: null,
                faceIndex: i,
                uv: null,
                uv2: null
            });
        }
    }
}
class $27a15484768bd0f4$export$6eda8f258bdba8c5 extends (0, $e8ea6a63d48a4fea$export$e176487c05830cc5) {
    constructor(geometry = new (0, $bafdd7b713b4d153$export$5b1256aa5274bf8)(), material = new (0, $9ead5c2fdc8d2606$export$d19cd1378966f3d3)({
        color: Math.random() * 0xffffff
    })){
        super(geometry, material);
        this.isLineSegments2 = true;
        this.type = "LineSegments2";
    }
    computeLineDistances() {
        const geometry = this.geometry;
        const instanceStart = geometry.attributes.instanceStart;
        const instanceEnd = geometry.attributes.instanceEnd;
        const lineDistances = new Float32Array(2 * instanceStart.count);
        for(let i = 0, j = 0, l = instanceStart.count; i < l; i++, j += 2){
            $27a15484768bd0f4$var$_start.fromBufferAttribute(instanceStart, i);
            $27a15484768bd0f4$var$_end.fromBufferAttribute(instanceEnd, i);
            lineDistances[j] = j === 0 ? 0 : lineDistances[j - 1];
            lineDistances[j + 1] = lineDistances[j] + $27a15484768bd0f4$var$_start.distanceTo($27a15484768bd0f4$var$_end);
        }
        const instanceDistanceBuffer = new (0, $e8ea6a63d48a4fea$export$25ec0e1af1389358)(lineDistances, 2, 1); // d0, d1
        geometry.setAttribute("instanceDistanceStart", new (0, $e8ea6a63d48a4fea$export$920b6d07334599c7)(instanceDistanceBuffer, 1, 0)); // d0
        geometry.setAttribute("instanceDistanceEnd", new (0, $e8ea6a63d48a4fea$export$920b6d07334599c7)(instanceDistanceBuffer, 1, 1)); // d1
        return this;
    }
    raycast(raycaster, intersects) {
        const worldUnits = this.material.worldUnits;
        const camera = raycaster.camera;
        if (camera === null && !worldUnits) console.error('LineSegments2: "Raycaster.camera" needs to be set in order to raycast against LineSegments2 while worldUnits is set to false.');
        const threshold = raycaster.params.Line2 !== undefined ? raycaster.params.Line2.threshold || 0 : 0;
        $27a15484768bd0f4$var$_ray = raycaster.ray;
        const matrixWorld = this.matrixWorld;
        const geometry = this.geometry;
        const material = this.material;
        $27a15484768bd0f4$var$_lineWidth = material.linewidth + threshold;
        $27a15484768bd0f4$var$_instanceStart = geometry.attributes.instanceStart;
        $27a15484768bd0f4$var$_instanceEnd = geometry.attributes.instanceEnd; // check if we intersect the sphere bounds
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $27a15484768bd0f4$var$_sphere.copy(geometry.boundingSphere).applyMatrix4(matrixWorld); // increase the sphere bounds by the worst case line screen space width
        let sphereMargin;
        if (worldUnits) sphereMargin = $27a15484768bd0f4$var$_lineWidth * 0.5;
        else {
            const distanceToSphere = Math.max(camera.near, $27a15484768bd0f4$var$_sphere.distanceToPoint($27a15484768bd0f4$var$_ray.origin));
            sphereMargin = $27a15484768bd0f4$var$getWorldSpaceHalfWidth(camera, distanceToSphere, material.resolution);
        }
        $27a15484768bd0f4$var$_sphere.radius += sphereMargin;
        if ($27a15484768bd0f4$var$_ray.intersectsSphere($27a15484768bd0f4$var$_sphere) === false) return;
         // check if we intersect the box bounds
        if (geometry.boundingBox === null) geometry.computeBoundingBox();
        $27a15484768bd0f4$var$_box.copy(geometry.boundingBox).applyMatrix4(matrixWorld); // increase the box bounds by the worst case line width
        let boxMargin;
        if (worldUnits) boxMargin = $27a15484768bd0f4$var$_lineWidth * 0.5;
        else {
            const distanceToBox = Math.max(camera.near, $27a15484768bd0f4$var$_box.distanceToPoint($27a15484768bd0f4$var$_ray.origin));
            boxMargin = $27a15484768bd0f4$var$getWorldSpaceHalfWidth(camera, distanceToBox, material.resolution);
        }
        $27a15484768bd0f4$var$_box.expandByScalar(boxMargin);
        if ($27a15484768bd0f4$var$_ray.intersectsBox($27a15484768bd0f4$var$_box) === false) return;
        if (worldUnits) $27a15484768bd0f4$var$raycastWorldUnits(this, intersects);
        else $27a15484768bd0f4$var$raycastScreenSpace(this, camera, intersects);
    }
}



class $f9b3f88c641470f7$export$dcc17b59d0a74bb5 extends (0, $bafdd7b713b4d153$export$5b1256aa5274bf8) {
    constructor(){
        super();
        this.isLineGeometry = true;
        this.type = "LineGeometry";
    }
    setPositions(array) {
        // converts [ x1, y1, z1,  x2, y2, z2, ... ] to pairs format
        const length = array.length - 3;
        const points = new Float32Array(2 * length);
        for(let i = 0; i < length; i += 3){
            points[2 * i] = array[i];
            points[2 * i + 1] = array[i + 1];
            points[2 * i + 2] = array[i + 2];
            points[2 * i + 3] = array[i + 3];
            points[2 * i + 4] = array[i + 4];
            points[2 * i + 5] = array[i + 5];
        }
        super.setPositions(points);
        return this;
    }
    setColors(array) {
        // converts [ r1, g1, b1,  r2, g2, b2, ... ] to pairs format
        const length = array.length - 3;
        const colors = new Float32Array(2 * length);
        for(let i = 0; i < length; i += 3){
            colors[2 * i] = array[i];
            colors[2 * i + 1] = array[i + 1];
            colors[2 * i + 2] = array[i + 2];
            colors[2 * i + 3] = array[i + 3];
            colors[2 * i + 4] = array[i + 4];
            colors[2 * i + 5] = array[i + 5];
        }
        super.setColors(colors);
        return this;
    }
    fromLine(line) {
        const geometry = line.geometry;
        this.setPositions(geometry.attributes.position.array); // assumes non-indexed
        // set colors, maybe
        return this;
    }
}



class $28ca9fae4e7d2f69$export$4e6fcde58d84e955 extends (0, $27a15484768bd0f4$export$6eda8f258bdba8c5) {
    constructor(geometry = new (0, $f9b3f88c641470f7$export$dcc17b59d0a74bb5)(), material = new (0, $9ead5c2fdc8d2606$export$d19cd1378966f3d3)({
        color: Math.random() * 0xffffff
    })){
        super(geometry, material);
        this.isLine2 = true;
        this.type = "Line2";
    }
}


const $bd47a7efd84ed9a1$export$17d680238e50603e = /*#__PURE__*/ $1bdO8.forwardRef(function Line({ points: points , color: color = "black" , vertexColors: vertexColors , linewidth: linewidth , lineWidth: lineWidth , segments: segments , dashed: dashed , ...rest }, ref) {
    const size = (0, $e0e1f88defa94a87$export$df995fae86a55f06)((state)=>state.size);
    const line2 = $1bdO8.useMemo(()=>segments ? new (0, $27a15484768bd0f4$export$6eda8f258bdba8c5)() : new (0, $28ca9fae4e7d2f69$export$4e6fcde58d84e955)(), [
        segments
    ]);
    const [lineMaterial] = $1bdO8.useState(()=>new (0, $9ead5c2fdc8d2606$export$d19cd1378966f3d3)());
    const lineGeom = $1bdO8.useMemo(()=>{
        const geom = segments ? new (0, $bafdd7b713b4d153$export$5b1256aa5274bf8)() : new (0, $f9b3f88c641470f7$export$dcc17b59d0a74bb5)();
        const pValues = points.map((p)=>{
            const isArray = Array.isArray(p);
            return p instanceof (0, $e8ea6a63d48a4fea$export$64b5c384219d3699) ? [
                p.x,
                p.y,
                p.z
            ] : p instanceof (0, $e8ea6a63d48a4fea$export$c977b3e384af9ae1) ? [
                p.x,
                p.y,
                0
            ] : isArray && p.length === 3 ? [
                p[0],
                p[1],
                p[2]
            ] : isArray && p.length === 2 ? [
                p[0],
                p[1],
                0
            ] : p;
        });
        geom.setPositions(pValues.flat());
        if (vertexColors) {
            const cValues = vertexColors.map((c)=>c instanceof (0, $e8ea6a63d48a4fea$export$892596cec99bc70e) ? c.toArray() : c);
            geom.setColors(cValues.flat());
        }
        return geom;
    }, [
        points,
        segments,
        vertexColors
    ]);
    $1bdO8.useLayoutEffect(()=>{
        line2.computeLineDistances();
    }, [
        points,
        line2
    ]);
    $1bdO8.useLayoutEffect(()=>{
        if (dashed) lineMaterial.defines.USE_DASH = "";
        else // Setting lineMaterial.defines.USE_DASH to undefined is apparently not sufficient.
        delete lineMaterial.defines.USE_DASH;
        lineMaterial.needsUpdate = true;
    }, [
        dashed,
        lineMaterial
    ]);
    $1bdO8.useEffect(()=>{
        return ()=>lineGeom.dispose();
    }, [
        lineGeom
    ]);
    return /*#__PURE__*/ $1bdO8.createElement("primitive", (0, $63nUy.default)({
        object: line2,
        ref: ref
    }, rest), /*#__PURE__*/ $1bdO8.createElement("primitive", {
        object: lineGeom,
        attach: "geometry"
    }), /*#__PURE__*/ $1bdO8.createElement("primitive", (0, $63nUy.default)({
        object: lineMaterial,
        attach: "material",
        color: color,
        vertexColors: Boolean(vertexColors),
        resolution: [
            size.width,
            size.height
        ],
        linewidth: linewidth !== null && linewidth !== void 0 ? linewidth : lineWidth,
        dashed: dashed
    }, rest)));
});




function $3894e11db13163c2$export$202b91c142600e81(handlers, config) {
    const { gl: gl  } = (0, $e0e1f88defa94a87$export$df995fae86a55f06)();
    return (0, $28b7821850e91fb9$export$ece84446a783717)(handlers, {
        domTarget: gl.domElement,
        transform: ([x, y])=>[
                x,
                gl.domElement.clientHeight - y
            ],
        ...config
    });
}


function $0613d9f35b5a031c$export$360e6f46aa8bdfbf({ width: width = 2 , color: color = "white" , opacity: opacity = 1 , enabled: enabled = true , minDistance: minDistance = 5 , vertices: vertices , onChange: onChange , onSubmit: onSubmit  }) {
    const handleChange = (0, $1bdO8.useCallback)((vertices)=>{
        onChange?.(vertices);
    }, [
        onChange
    ]);
    (0, $3894e11db13163c2$export$202b91c142600e81)({
        onDragStart: ({ event: event , buttons: buttons , xy: xy  })=>{
            if (buttons === 1) {
                const vertex = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(...xy);
                handleChange([
                    vertex
                ]);
            // event.stopPropagation();
            }
        },
        onDrag: ({ buttons: buttons , xy: xy  })=>{
            if (buttons === 1) {
                const vertex = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(...xy);
                const lastVertex = vertices[vertices.length - 1];
                if (lastVertex && lastVertex.distanceTo(vertex) < minDistance) return;
                handleChange([
                    ...vertices,
                    vertex
                ]);
            }
        },
        onDragEnd: ()=>{
            onSubmit?.(vertices);
            handleChange([]);
        }
    }, {
        enabled: enabled,
        eventOptions: {
            capture: true
        }
    });
    if (!enabled || vertices.length < 1) return null;
    return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $bd47a7efd84ed9a1$export$17d680238e50603e), {
        points: vertices,
        color: color,
        lineWidth: width,
        depthWrite: true,
        depthFunc: $e8ea6a63d48a4fea$export$eedccec66ab7ebe,
        opacity: opacity,
        transparent: opacity < 1
    });
}



var $8b1d73cd8313f831$exports = {};
var $c285a8a1dbf295b7$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $c285a8a1dbf295b7$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$c285a8a1dbf295b7$exports = $c285a8a1dbf295b7$var$arrayMap;


var $26ab2135629fbfea$exports = {};
var $a7291ef6b6e21237$exports = {};
var $b610785e036c74f1$exports = {};
var $177ce593b718bea3$exports = {};
var $064788226bdaeef3$exports = {};
var $ac08d20b99fb13e5$exports = {};
var $eb2cf96388608614$exports = {};
var $16b0ec41ff4f86ba$exports = {};
var $a495d4819acc9acb$exports = {};
var $acceaa586f93ddec$exports = {};
var $d754966aaa5d1eb8$exports = {};
var $824ca4779e9a6b1a$exports = {};
var $b2f0e8788f145d4e$exports = {};
var $b1ff6b7cca06ad7a$exports = {};
/** Detect free variable `global` from Node.js. */ var $b1ff6b7cca06ad7a$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
$b1ff6b7cca06ad7a$exports = $b1ff6b7cca06ad7a$var$freeGlobal;


/** Detect free variable `self`. */ var $b2f0e8788f145d4e$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $b2f0e8788f145d4e$var$root = $b1ff6b7cca06ad7a$exports || $b2f0e8788f145d4e$var$freeSelf || Function("return this")();
$b2f0e8788f145d4e$exports = $b2f0e8788f145d4e$var$root;


/** Built-in value references. */ var $824ca4779e9a6b1a$var$Symbol = $b2f0e8788f145d4e$exports.Symbol;
$824ca4779e9a6b1a$exports = $824ca4779e9a6b1a$var$Symbol;


var $395c749b5c0ce961$exports = {};

/** Used for built-in method references. */ var $395c749b5c0ce961$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $395c749b5c0ce961$var$hasOwnProperty = $395c749b5c0ce961$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $395c749b5c0ce961$var$nativeObjectToString = $395c749b5c0ce961$var$objectProto.toString;
/** Built-in value references. */ var $395c749b5c0ce961$var$symToStringTag = $824ca4779e9a6b1a$exports ? $824ca4779e9a6b1a$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $395c749b5c0ce961$var$getRawTag(value) {
    var isOwn = $395c749b5c0ce961$var$hasOwnProperty.call(value, $395c749b5c0ce961$var$symToStringTag), tag = value[$395c749b5c0ce961$var$symToStringTag];
    try {
        value[$395c749b5c0ce961$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $395c749b5c0ce961$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$395c749b5c0ce961$var$symToStringTag] = tag;
        else delete value[$395c749b5c0ce961$var$symToStringTag];
    }
    return result;
}
$395c749b5c0ce961$exports = $395c749b5c0ce961$var$getRawTag;


var $ae1a45b0d987cf40$exports = {};
/** Used for built-in method references. */ var $ae1a45b0d987cf40$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $ae1a45b0d987cf40$var$nativeObjectToString = $ae1a45b0d987cf40$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $ae1a45b0d987cf40$var$objectToString(value) {
    return $ae1a45b0d987cf40$var$nativeObjectToString.call(value);
}
$ae1a45b0d987cf40$exports = $ae1a45b0d987cf40$var$objectToString;


/** `Object#toString` result references. */ var $d754966aaa5d1eb8$var$nullTag = "[object Null]", $d754966aaa5d1eb8$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $d754966aaa5d1eb8$var$symToStringTag = $824ca4779e9a6b1a$exports ? $824ca4779e9a6b1a$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $d754966aaa5d1eb8$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $d754966aaa5d1eb8$var$undefinedTag : $d754966aaa5d1eb8$var$nullTag;
    return $d754966aaa5d1eb8$var$symToStringTag && $d754966aaa5d1eb8$var$symToStringTag in Object(value) ? $395c749b5c0ce961$exports(value) : $ae1a45b0d987cf40$exports(value);
}
$d754966aaa5d1eb8$exports = $d754966aaa5d1eb8$var$baseGetTag;


var $eebb5ae1dc93ea95$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $eebb5ae1dc93ea95$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
$eebb5ae1dc93ea95$exports = $eebb5ae1dc93ea95$var$isObject;


/** `Object#toString` result references. */ var $acceaa586f93ddec$var$asyncTag = "[object AsyncFunction]", $acceaa586f93ddec$var$funcTag = "[object Function]", $acceaa586f93ddec$var$genTag = "[object GeneratorFunction]", $acceaa586f93ddec$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $acceaa586f93ddec$var$isFunction(value) {
    if (!$eebb5ae1dc93ea95$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $d754966aaa5d1eb8$exports(value);
    return tag == $acceaa586f93ddec$var$funcTag || tag == $acceaa586f93ddec$var$genTag || tag == $acceaa586f93ddec$var$asyncTag || tag == $acceaa586f93ddec$var$proxyTag;
}
$acceaa586f93ddec$exports = $acceaa586f93ddec$var$isFunction;


var $aacbec684f4f13ec$exports = {};
var $b4dfc336947297be$exports = {};

/** Used to detect overreaching core-js shims. */ var $b4dfc336947297be$var$coreJsData = $b2f0e8788f145d4e$exports["__core-js_shared__"];
$b4dfc336947297be$exports = $b4dfc336947297be$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $aacbec684f4f13ec$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($b4dfc336947297be$exports && $b4dfc336947297be$exports.keys && $b4dfc336947297be$exports.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $aacbec684f4f13ec$var$isMasked(func) {
    return !!$aacbec684f4f13ec$var$maskSrcKey && $aacbec684f4f13ec$var$maskSrcKey in func;
}
$aacbec684f4f13ec$exports = $aacbec684f4f13ec$var$isMasked;



var $f7d181a2578bc8ce$exports = {};
/** Used for built-in method references. */ var $f7d181a2578bc8ce$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $f7d181a2578bc8ce$var$funcToString = $f7d181a2578bc8ce$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $f7d181a2578bc8ce$var$toSource(func) {
    if (func != null) {
        try {
            return $f7d181a2578bc8ce$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
$f7d181a2578bc8ce$exports = $f7d181a2578bc8ce$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $a495d4819acc9acb$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $a495d4819acc9acb$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $a495d4819acc9acb$var$funcProto = Function.prototype, $a495d4819acc9acb$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $a495d4819acc9acb$var$funcToString = $a495d4819acc9acb$var$funcProto.toString;
/** Used to check objects for own properties. */ var $a495d4819acc9acb$var$hasOwnProperty = $a495d4819acc9acb$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $a495d4819acc9acb$var$reIsNative = RegExp("^" + $a495d4819acc9acb$var$funcToString.call($a495d4819acc9acb$var$hasOwnProperty).replace($a495d4819acc9acb$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $a495d4819acc9acb$var$baseIsNative(value) {
    if (!$eebb5ae1dc93ea95$exports(value) || $aacbec684f4f13ec$exports(value)) return false;
    var pattern = $acceaa586f93ddec$exports(value) ? $a495d4819acc9acb$var$reIsNative : $a495d4819acc9acb$var$reIsHostCtor;
    return pattern.test($f7d181a2578bc8ce$exports(value));
}
$a495d4819acc9acb$exports = $a495d4819acc9acb$var$baseIsNative;


var $d5dbbeea061782ab$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d5dbbeea061782ab$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$d5dbbeea061782ab$exports = $d5dbbeea061782ab$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $16b0ec41ff4f86ba$var$getNative(object, key) {
    var value = $d5dbbeea061782ab$exports(object, key);
    return $a495d4819acc9acb$exports(value) ? value : undefined;
}
$16b0ec41ff4f86ba$exports = $16b0ec41ff4f86ba$var$getNative;


/* Built-in method references that are verified to be native. */ var $eb2cf96388608614$var$nativeCreate = $16b0ec41ff4f86ba$exports(Object, "create");
$eb2cf96388608614$exports = $eb2cf96388608614$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $ac08d20b99fb13e5$var$hashClear() {
    this.__data__ = $eb2cf96388608614$exports ? $eb2cf96388608614$exports(null) : {};
    this.size = 0;
}
$ac08d20b99fb13e5$exports = $ac08d20b99fb13e5$var$hashClear;


var $56ae421ee94bdd32$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $56ae421ee94bdd32$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$56ae421ee94bdd32$exports = $56ae421ee94bdd32$var$hashDelete;


var $97cddc78337d3486$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $97cddc78337d3486$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $97cddc78337d3486$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $97cddc78337d3486$var$hasOwnProperty = $97cddc78337d3486$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $97cddc78337d3486$var$hashGet(key) {
    var data = this.__data__;
    if ($eb2cf96388608614$exports) {
        var result = data[key];
        return result === $97cddc78337d3486$var$HASH_UNDEFINED ? undefined : result;
    }
    return $97cddc78337d3486$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$97cddc78337d3486$exports = $97cddc78337d3486$var$hashGet;


var $89c2f6991c31a126$exports = {};

/** Used for built-in method references. */ var $89c2f6991c31a126$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $89c2f6991c31a126$var$hasOwnProperty = $89c2f6991c31a126$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $89c2f6991c31a126$var$hashHas(key) {
    var data = this.__data__;
    return $eb2cf96388608614$exports ? data[key] !== undefined : $89c2f6991c31a126$var$hasOwnProperty.call(data, key);
}
$89c2f6991c31a126$exports = $89c2f6991c31a126$var$hashHas;


var $f97b4886ca845c8a$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $f97b4886ca845c8a$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $f97b4886ca845c8a$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $eb2cf96388608614$exports && value === undefined ? $f97b4886ca845c8a$var$HASH_UNDEFINED : value;
    return this;
}
$f97b4886ca845c8a$exports = $f97b4886ca845c8a$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $064788226bdaeef3$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$064788226bdaeef3$var$Hash.prototype.clear = $ac08d20b99fb13e5$exports;
$064788226bdaeef3$var$Hash.prototype["delete"] = $56ae421ee94bdd32$exports;
$064788226bdaeef3$var$Hash.prototype.get = $97cddc78337d3486$exports;
$064788226bdaeef3$var$Hash.prototype.has = $89c2f6991c31a126$exports;
$064788226bdaeef3$var$Hash.prototype.set = $f97b4886ca845c8a$exports;
$064788226bdaeef3$exports = $064788226bdaeef3$var$Hash;


var $ea3287b16b8f678e$exports = {};
var $8341ad06a2aafedd$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $8341ad06a2aafedd$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$8341ad06a2aafedd$exports = $8341ad06a2aafedd$var$listCacheClear;


var $b6273325d1a21571$exports = {};
var $bacbfe188c337580$exports = {};
var $4bf7f1a91403aec3$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $4bf7f1a91403aec3$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$4bf7f1a91403aec3$exports = $4bf7f1a91403aec3$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $bacbfe188c337580$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($4bf7f1a91403aec3$exports(array[length][0], key)) return length;
    }
    return -1;
}
$bacbfe188c337580$exports = $bacbfe188c337580$var$assocIndexOf;


/** Used for built-in method references. */ var $b6273325d1a21571$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $b6273325d1a21571$var$splice = $b6273325d1a21571$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b6273325d1a21571$var$listCacheDelete(key) {
    var data = this.__data__, index = $bacbfe188c337580$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $b6273325d1a21571$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$b6273325d1a21571$exports = $b6273325d1a21571$var$listCacheDelete;


var $2e9073b1b71de542$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $2e9073b1b71de542$var$listCacheGet(key) {
    var data = this.__data__, index = $bacbfe188c337580$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$2e9073b1b71de542$exports = $2e9073b1b71de542$var$listCacheGet;


var $75f7b798b3affc7a$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $75f7b798b3affc7a$var$listCacheHas(key) {
    return $bacbfe188c337580$exports(this.__data__, key) > -1;
}
$75f7b798b3affc7a$exports = $75f7b798b3affc7a$var$listCacheHas;


var $c4a80b6d3ba86133$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $c4a80b6d3ba86133$var$listCacheSet(key, value) {
    var data = this.__data__, index = $bacbfe188c337580$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$c4a80b6d3ba86133$exports = $c4a80b6d3ba86133$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $ea3287b16b8f678e$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$ea3287b16b8f678e$var$ListCache.prototype.clear = $8341ad06a2aafedd$exports;
$ea3287b16b8f678e$var$ListCache.prototype["delete"] = $b6273325d1a21571$exports;
$ea3287b16b8f678e$var$ListCache.prototype.get = $2e9073b1b71de542$exports;
$ea3287b16b8f678e$var$ListCache.prototype.has = $75f7b798b3affc7a$exports;
$ea3287b16b8f678e$var$ListCache.prototype.set = $c4a80b6d3ba86133$exports;
$ea3287b16b8f678e$exports = $ea3287b16b8f678e$var$ListCache;


var $e376c1a2685ea8ec$exports = {};


/* Built-in method references that are verified to be native. */ var $e376c1a2685ea8ec$var$Map = $16b0ec41ff4f86ba$exports($b2f0e8788f145d4e$exports, "Map");
$e376c1a2685ea8ec$exports = $e376c1a2685ea8ec$var$Map;


/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $177ce593b718bea3$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $064788226bdaeef3$exports,
        "map": new ($e376c1a2685ea8ec$exports || $ea3287b16b8f678e$exports),
        "string": new $064788226bdaeef3$exports
    };
}
$177ce593b718bea3$exports = $177ce593b718bea3$var$mapCacheClear;


var $07b0b9ce94b17174$exports = {};
var $a5f9cecd73476833$exports = {};
var $399b71021151f2dd$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $399b71021151f2dd$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
$399b71021151f2dd$exports = $399b71021151f2dd$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $a5f9cecd73476833$var$getMapData(map, key) {
    var data = map.__data__;
    return $399b71021151f2dd$exports(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
$a5f9cecd73476833$exports = $a5f9cecd73476833$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $07b0b9ce94b17174$var$mapCacheDelete(key) {
    var result = $a5f9cecd73476833$exports(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
$07b0b9ce94b17174$exports = $07b0b9ce94b17174$var$mapCacheDelete;


var $66d7b67464fa9a0b$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $66d7b67464fa9a0b$var$mapCacheGet(key) {
    return $a5f9cecd73476833$exports(this, key).get(key);
}
$66d7b67464fa9a0b$exports = $66d7b67464fa9a0b$var$mapCacheGet;


var $9c4c799f812a0d1b$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $9c4c799f812a0d1b$var$mapCacheHas(key) {
    return $a5f9cecd73476833$exports(this, key).has(key);
}
$9c4c799f812a0d1b$exports = $9c4c799f812a0d1b$var$mapCacheHas;


var $a28e4e8140f19525$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $a28e4e8140f19525$var$mapCacheSet(key, value) {
    var data = $a5f9cecd73476833$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$a28e4e8140f19525$exports = $a28e4e8140f19525$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $b610785e036c74f1$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$b610785e036c74f1$var$MapCache.prototype.clear = $177ce593b718bea3$exports;
$b610785e036c74f1$var$MapCache.prototype["delete"] = $07b0b9ce94b17174$exports;
$b610785e036c74f1$var$MapCache.prototype.get = $66d7b67464fa9a0b$exports;
$b610785e036c74f1$var$MapCache.prototype.has = $9c4c799f812a0d1b$exports;
$b610785e036c74f1$var$MapCache.prototype.set = $a28e4e8140f19525$exports;
$b610785e036c74f1$exports = $b610785e036c74f1$var$MapCache;


var $6643e88c4c53105e$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $6643e88c4c53105e$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $6643e88c4c53105e$var$setCacheAdd(value) {
    this.__data__.set(value, $6643e88c4c53105e$var$HASH_UNDEFINED);
    return this;
}
$6643e88c4c53105e$exports = $6643e88c4c53105e$var$setCacheAdd;


var $2f476db3504ead9c$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $2f476db3504ead9c$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$2f476db3504ead9c$exports = $2f476db3504ead9c$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $a7291ef6b6e21237$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $b610785e036c74f1$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$a7291ef6b6e21237$var$SetCache.prototype.add = $a7291ef6b6e21237$var$SetCache.prototype.push = $6643e88c4c53105e$exports;
$a7291ef6b6e21237$var$SetCache.prototype.has = $2f476db3504ead9c$exports;
$a7291ef6b6e21237$exports = $a7291ef6b6e21237$var$SetCache;


var $cd7d113c5aa8ccc3$exports = {};
var $0b6a121262c38919$exports = {};
var $a4d9ae03a3d38ca8$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a4d9ae03a3d38ca8$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$a4d9ae03a3d38ca8$exports = $a4d9ae03a3d38ca8$var$baseFindIndex;


var $b156b1ae22afd9bf$exports = {};
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $b156b1ae22afd9bf$var$baseIsNaN(value) {
    return value !== value;
}
$b156b1ae22afd9bf$exports = $b156b1ae22afd9bf$var$baseIsNaN;


var $c2a5020ef8f9f919$exports = {};
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $c2a5020ef8f9f919$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
$c2a5020ef8f9f919$exports = $c2a5020ef8f9f919$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $0b6a121262c38919$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $c2a5020ef8f9f919$exports(array, value, fromIndex) : $a4d9ae03a3d38ca8$exports(array, $b156b1ae22afd9bf$exports, fromIndex);
}
$0b6a121262c38919$exports = $0b6a121262c38919$var$baseIndexOf;


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $cd7d113c5aa8ccc3$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $0b6a121262c38919$exports(array, value, 0) > -1;
}
$cd7d113c5aa8ccc3$exports = $cd7d113c5aa8ccc3$var$arrayIncludes;


var $1149f2f4c1b09980$exports = {};
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $1149f2f4c1b09980$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
$1149f2f4c1b09980$exports = $1149f2f4c1b09980$var$arrayIncludesWith;



var $c7a147afef0f0c76$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $c7a147afef0f0c76$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$c7a147afef0f0c76$exports = $c7a147afef0f0c76$var$baseUnary;


var $a8303255df927a29$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $a8303255df927a29$var$cacheHas(cache, key) {
    return cache.has(key);
}
$a8303255df927a29$exports = $a8303255df927a29$var$cacheHas;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $26ab2135629fbfea$var$nativeMin = Math.min;
/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */ function $26ab2135629fbfea$var$baseIntersection(arrays, iteratee, comparator) {
    var includes = comparator ? $1149f2f4c1b09980$exports : $cd7d113c5aa8ccc3$exports, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
    while(othIndex--){
        var array = arrays[othIndex];
        if (othIndex && iteratee) array = $c285a8a1dbf295b7$exports(array, $c7a147afef0f0c76$exports(iteratee));
        maxLength = $26ab2135629fbfea$var$nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new $a7291ef6b6e21237$exports(othIndex && array) : undefined;
    }
    array = arrays[0];
    var index = -1, seen = caches[0];
    outer: while(++index < length && result.length < maxLength){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (!(seen ? $a8303255df927a29$exports(seen, computed) : includes(result, computed, comparator))) {
            othIndex = othLength;
            while(--othIndex){
                var cache = caches[othIndex];
                if (!(cache ? $a8303255df927a29$exports(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
            }
            if (seen) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
$26ab2135629fbfea$exports = $26ab2135629fbfea$var$baseIntersection;


var $83e858d5b374b98d$exports = {};
var $83986af1ba3a3479$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $83986af1ba3a3479$var$identity(value) {
    return value;
}
$83986af1ba3a3479$exports = $83986af1ba3a3479$var$identity;


var $feb7a2af8f738a16$exports = {};
var $8b2f45f5bc320eea$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $8b2f45f5bc320eea$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$8b2f45f5bc320eea$exports = $8b2f45f5bc320eea$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $feb7a2af8f738a16$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $feb7a2af8f738a16$var$overRest(func, start, transform) {
    start = $feb7a2af8f738a16$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $feb7a2af8f738a16$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $8b2f45f5bc320eea$exports(func, this, otherArgs);
    };
}
$feb7a2af8f738a16$exports = $feb7a2af8f738a16$var$overRest;


var $b13acec5390545b9$exports = {};
var $60d9148ac4a318d4$exports = {};
var $ac745c9e05253167$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $ac745c9e05253167$var$constant(value) {
    return function() {
        return value;
    };
}
$ac745c9e05253167$exports = $ac745c9e05253167$var$constant;


var $26f05a0720bc973c$exports = {};

var $26f05a0720bc973c$var$defineProperty = function() {
    try {
        var func = $16b0ec41ff4f86ba$exports(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
$26f05a0720bc973c$exports = $26f05a0720bc973c$var$defineProperty;



/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $60d9148ac4a318d4$var$baseSetToString = !$26f05a0720bc973c$exports ? $83986af1ba3a3479$exports : function(func, string) {
    return $26f05a0720bc973c$exports(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": $ac745c9e05253167$exports(string),
        "writable": true
    });
};
$60d9148ac4a318d4$exports = $60d9148ac4a318d4$var$baseSetToString;


var $c64bb6db6ab714c5$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $c64bb6db6ab714c5$var$HOT_COUNT = 800, $c64bb6db6ab714c5$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $c64bb6db6ab714c5$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $c64bb6db6ab714c5$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $c64bb6db6ab714c5$var$nativeNow(), remaining = $c64bb6db6ab714c5$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $c64bb6db6ab714c5$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$c64bb6db6ab714c5$exports = $c64bb6db6ab714c5$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $b13acec5390545b9$var$setToString = $c64bb6db6ab714c5$exports($60d9148ac4a318d4$exports);
$b13acec5390545b9$exports = $b13acec5390545b9$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $83e858d5b374b98d$var$baseRest(func, start) {
    return $b13acec5390545b9$exports($feb7a2af8f738a16$exports(func, start, $83986af1ba3a3479$exports), func + "");
}
$83e858d5b374b98d$exports = $83e858d5b374b98d$var$baseRest;


var $dd29c2a4a1daa4fa$exports = {};
var $2953067aa91a12c9$exports = {};
var $2405d9ff81217976$exports = {};

var $0f76a8fc82b4e633$exports = {};
/** Used as references for various `Number` constants. */ var $0f76a8fc82b4e633$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $0f76a8fc82b4e633$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $0f76a8fc82b4e633$var$MAX_SAFE_INTEGER;
}
$0f76a8fc82b4e633$exports = $0f76a8fc82b4e633$var$isLength;


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $2405d9ff81217976$var$isArrayLike(value) {
    return value != null && $0f76a8fc82b4e633$exports(value.length) && !$acceaa586f93ddec$exports(value);
}
$2405d9ff81217976$exports = $2405d9ff81217976$var$isArrayLike;


var $967017d58a10aa85$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $967017d58a10aa85$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
$967017d58a10aa85$exports = $967017d58a10aa85$var$isObjectLike;


/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $2953067aa91a12c9$var$isArrayLikeObject(value) {
    return $967017d58a10aa85$exports(value) && $2405d9ff81217976$exports(value);
}
$2953067aa91a12c9$exports = $2953067aa91a12c9$var$isArrayLikeObject;


/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */ function $dd29c2a4a1daa4fa$var$castArrayLikeObject(value) {
    return $2953067aa91a12c9$exports(value) ? value : [];
}
$dd29c2a4a1daa4fa$exports = $dd29c2a4a1daa4fa$var$castArrayLikeObject;


/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */ var $8b1d73cd8313f831$var$intersection = $83e858d5b374b98d$exports(function(arrays) {
    var mapped = $c285a8a1dbf295b7$exports(arrays, $dd29c2a4a1daa4fa$exports);
    return mapped.length && mapped[0] === arrays[0] ? $26ab2135629fbfea$exports(mapped) : [];
});
$8b1d73cd8313f831$exports = $8b1d73cd8313f831$var$intersection;


class $313ef6ac6f94ae4f$export$62297b13309008b2 {
    run(previous) {
        return previous || [];
    }
    merge(result, previous) {
        return previous ? (0, (/*@__PURE__*/$parcel$interopDefault($8b1d73cd8313f831$exports)))(previous) : result;
    }
}


class $5830a1d857b039e2$export$a66c132b509693aa extends (0, $313ef6ac6f94ae4f$export$62297b13309008b2) {
    constructor(params){
        super();
        this.boxTree = params.boxTree;
        this.points = params.points;
    }
    run(previous) {
        throw new Error("Method not implemented.");
    }
}



class $2700b81799baed1e$export$7d31b617c820d435 {
    constructor(vertices){
        this.vertices = vertices;
    }
    /**
   * Returns the distance from the polygon to a point
   */ distanceToPoint(point) {
        const line = new $e8ea6a63d48a4fea$export$e0ba6359f1954fd3();
        const p1 = new $e8ea6a63d48a4fea$export$64b5c384219d3699().set(point.x, point.y, 0);
        const p2 = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        let minDistance = Infinity;
        for(let i = 0; i < this.vertices.length; i++){
            const j = (i + 1) % this.vertices.length;
            line.start.set(this.vertices[i].x, this.vertices[i].y, 0);
            line.end.set(this.vertices[j].x, this.vertices[j].y, 0);
            line.closestPointToPoint(p1, true, p2);
            const distance = p1.distanceTo(p2);
            minDistance = Math.min(minDistance, distance);
        }
        return minDistance;
    }
    /**
   * Checks if a point is inside the polygon
   */ containsPoint(point) {
        if (this.vertices.length < 3) return false;
        return this.vertices.reduce((inside, p0, index, vs)=>{
            const p1 = vs[(index + 1) % vs.length];
            const intersect = p0.y > point.y != p1.y > point.y && point.x < (p1.x - p0.x) * (point.y - p0.y) / (p1.y - p0.y) + p0.x;
            return intersect ? !inside : inside;
        }, false);
    }
    // Check if any point is inside the polygon
    intersectsBox(box) {
        if (this.vertices.some((p)=>box.containsPoint(p))) return true;
        const p = new $e8ea6a63d48a4fea$export$c977b3e384af9ae1();
        for(let i = 0; i < 2; i++){
            for(let j = 0; j < 2; j++)for(let k = 0; k < 2; k++){
                const x = (i === 0 ? box.min : box.max).x;
                const y = (j === 0 ? box.min : box.max).y;
                if (this.containsPoint(p.set(x, y))) return true;
            }
        }
        return false;
    }
}


class $a30ce0a6163ed286$export$e78d18b423b17178 extends (0, $5830a1d857b039e2$export$a66c132b509693aa) {
    constructor(params){
        super(params);
        this.vertices = params.vertices;
        this.projection = params.projection;
    }
    run(previous) {
        const polygon = new (0, $2700b81799baed1e$export$7d31b617c820d435)(this.vertices);
        const point = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        const box3 = new $e8ea6a63d48a4fea$export$6f7d5a9418ab2aa3();
        const box2 = new $e8ea6a63d48a4fea$export$60f553fa130f08b0();
        // let linearCount = 0;
        // let nodeCount = 0;
        const indices = [];
        this.boxTree.traverse((node)=>{
            box3.copy(node.boundingBox).applyMatrix4(this.projection);
            box2.setFromPoints([
                new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(box3.min.x, box3.min.y),
                new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(box3.max.x, box3.max.y)
            ]);
            if (!polygon.intersectsBox(box2)) return false;
            if (node.children.length > 0) return true;
            // nodeCount++;
            for(let i = 0; i < node.count; i++){
                const index = node.index[i];
                point.fromArray(this.points, index * 3);
                point.applyMatrix4(this.projection);
                // linearCount++;
                if (polygon.containsPoint(point)) indices.push(index);
            }
            return false;
        });
        return this.merge(indices, previous);
    }
}




var $1bdO8 = parcelRequire("1bdO8");




var $1bdO8 = parcelRequire("1bdO8");
function $907f0175efe74308$export$9a16fd00e65d0bbe() {
    const transform = (0, $1bdO8.useMemo)(()=>new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5(), []);
    const { size: size  } = (0, $e0e1f88defa94a87$export$df995fae86a55f06)();
    (0, $1bdO8.useEffect)(()=>{
        transform.compose(new $e8ea6a63d48a4fea$export$64b5c384219d3699(size.width / 2, size.height / 2, 0), new $e8ea6a63d48a4fea$export$23d6a54f0bbc85a3(), new $e8ea6a63d48a4fea$export$64b5c384219d3699(size.width / 2, size.height / 2, 1));
    }, [
        size.width,
        size.height
    ]);
    return transform;
}


function $945de26b40cbebad$export$1fe137006056cf29() {
    const transform = (0, $1bdO8.useMemo)(()=>new $e8ea6a63d48a4fea$export$2ae72fc923e5eb5(), []);
    const clipToCanvas = (0, $907f0175efe74308$export$9a16fd00e65d0bbe)();
    (0, $e0e1f88defa94a87$export$ebd11618f299a286)(({ camera: camera , scene: scene  })=>{
        transform.copy(scene.matrixWorld).premultiply(camera.matrixWorldInverse).premultiply(camera.projectionMatrix).premultiply(clipToCanvas);
    });
    return transform;
}



var $fd59b11c97075b5c$exports = {};

$fd59b11c97075b5c$exports = new URL((parcelRequire("hMn6r")).resolve("3srKo"), import.meta.url).toString();


var $d8479cde078647d7$exports = {};

$d8479cde078647d7$exports = new URL((parcelRequire("hMn6r")).resolve("fJgch"), import.meta.url).toString();


var $38fca6044d226cd8$exports = {};

$38fca6044d226cd8$exports = new URL((parcelRequire("hMn6r")).resolve("9p2Bw"), import.meta.url).toString();



var $1bdO8 = parcelRequire("1bdO8");


let $2e42e2153e98e1cc$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $2e42e2153e98e1cc$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
    let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    let step = -~(1.6 * mask * defaultSize / alphabet.length);
    return (size = defaultSize)=>{
        let id = "";
        while(true){
            let bytes = getRandom(step);
            let j = step;
            while(j--){
                id += alphabet[bytes[j] & mask] || "";
                if (id.length === size) return id;
            }
        }
    };
};
let $2e42e2153e98e1cc$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$2e42e2153e98e1cc$export$a5cee9e955a615e5(alphabet, size, $2e42e2153e98e1cc$export$4385e60b38654f68);
let $2e42e2153e98e1cc$export$ac4959f4f1338dfc = (size = 21)=>crypto.getRandomValues(new Uint8Array(size)).reduce((id, byte)=>{
        byte &= 63;
        if (byte < 36) id += byte.toString(36);
        else if (byte < 62) id += (byte - 26).toString(36).toUpperCase();
        else if (byte > 62) id += "-";
        else id += "_";
        return id;
    }, "");



const $ccade5f8dab5baee$export$580c8cae1d310b11 = (0, $ca0ed0868e4d0815$exports.create)((set, get)=>({
        claims: [],
        currentCursor: "auto",
        claim: (id, value, priority)=>{
            const claim = {
                id: id,
                value: value,
                priority: priority
            };
            set((state)=>({
                    claims: [
                        ...state.claims,
                        claim
                    ]
                }));
            get().update();
            return claim;
        },
        release: (id)=>{
            set((state)=>({
                    claims: state.claims.filter((claim)=>claim.id !== id)
                }));
            get().update();
        },
        update: ()=>{
            const sorted = get().claims.sort((a, b)=>b.priority - a.priority);
            const cursor = sorted[0]?.value || "auto";
            if (get().currentCursor !== cursor) set({
                currentCursor: cursor
            });
        }
    }));
function $ccade5f8dab5baee$export$b6a79797ad180576({ value: value , priority: priority = 0  }) {
    const { gl: gl  } = (0, $e0e1f88defa94a87$export$df995fae86a55f06)();
    const { claim: claim , release: release , currentCursor: currentCursor  } = $ccade5f8dab5baee$export$580c8cae1d310b11();
    (0, $1bdO8.useEffect)(()=>{
        if (value) {
            const id = (0, $2e42e2153e98e1cc$export$ac4959f4f1338dfc)();
            claim(id, value, priority);
            return ()=>{
                release(id);
            };
        }
    }, [
        value,
        claim,
        release
    ]);
    (0, $1bdO8.useEffect)(()=>{
        if (currentCursor !== gl.domElement.style.cursor) gl.domElement.style.cursor = currentCursor;
    }, [
        currentCursor
    ]);
    return null;
}


function $2eb94f6273dbecb7$export$faf366744455ed6b() {
    const [shiftPressed] = (0, $b0ad4098c2db7014$export$2e2bcd8739ae039)("Shift");
    const [altPressed] = (0, $b0ad4098c2db7014$export$2e2bcd8739ae039)("Alt");
    if (altPressed) return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $ccade5f8dab5baee$export$b6a79797ad180576), {
        value: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($38fca6044d226cd8$exports)))}), auto`
    });
    if (shiftPressed) return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $ccade5f8dab5baee$export$b6a79797ad180576), {
        value: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($d8479cde078647d7$exports)))}), auto`
    });
    return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $ccade5f8dab5baee$export$b6a79797ad180576), {
        value: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($fd59b11c97075b5c$exports)))}), auto`
    });
}
function $2eb94f6273dbecb7$export$c869beb7f37545b8({ geometry: geometry , onSelect: onSelect , enabled: enabled = true  }) {
    const [vertices, setVertices] = (0, $1bdO8.useState)([]);
    const sceneToCanvas = (0, $945de26b40cbebad$export$1fe137006056cf29)();
    const handleSubmit = (0, $1bdO8.useCallback)(()=>{
        if (vertices.length < 3) return;
        const query = new (0, $a30ce0a6163ed286$export$e78d18b423b17178)({
            boxTree: geometry.boxTree,
            points: geometry.positions,
            vertices: vertices,
            projection: sceneToCanvas
        });
        const result = query.run();
        onSelect?.(result);
    }, [
        vertices,
        onSelect
    ]);
    if (!enabled) return null;
    return /*#__PURE__*/ (0, $cVgDf.jsxs)((0, $a7bcb744ac034ff3$export$4f9a05f5d7140d31), {
        children: [
            /*#__PURE__*/ (0, $cVgDf.jsx)((0, $0613d9f35b5a031c$export$360e6f46aa8bdfbf), {
                vertices: vertices,
                onChange: setVertices,
                onSubmit: handleSubmit,
                width: 1,
                opacity: 1.0
            }),
            /*#__PURE__*/ (0, $cVgDf.jsx)($2eb94f6273dbecb7$export$faf366744455ed6b, {})
        ]
    });
}



var $cVgDf = parcelRequire("cVgDf");



var $1bdO8 = parcelRequire("1bdO8");






class $c74785c0f0369ab6$export$a1cd39573a6fd2a2 extends (0, $5830a1d857b039e2$export$a66c132b509693aa) {
    constructor(params){
        super(params);
        this.target = params.target;
        this.projection = params.projection;
        this.maxDistance = params.maxDistance || 10;
    }
    run(previous) {
        const box = new $e8ea6a63d48a4fea$export$6f7d5a9418ab2aa3();
        const point = new $e8ea6a63d48a4fea$export$64b5c384219d3699();
        let minDistance = Infinity;
        point.fromArray(this.points, 0);
        point.applyMatrix4(this.projection);
        const result = [];
        this.boxTree.traverse((node)=>{
            box.copy(node.boundingBox).applyMatrix4(this.projection);
            const boxDistance = box.distanceToPoint(this.target);
            if (boxDistance > this.maxDistance && box.max.z < 1) return false;
            if (node.children.length === 0) for(let i = 0; i < node.count; i++){
                point.fromArray(this.points, node.index[i] * 3);
                point.applyMatrix4(this.projection);
                const distance = point.distanceTo(this.target);
                if (distance < minDistance) {
                    minDistance = distance;
                    if (minDistance < this.maxDistance) result[0] = node.index[i];
                }
            }
        });
        return this.merge(result, previous);
    }
}



var $1bdO8 = parcelRequire("1bdO8");

var $1bdO8 = parcelRequire("1bdO8");
var $d3fe22b51fbd7af2$var$useEffectOnce = function(effect) {
    (0, $1bdO8.useEffect)(effect, []);
};
var $d3fe22b51fbd7af2$export$2e2bcd8739ae039 = $d3fe22b51fbd7af2$var$useEffectOnce;


var $5c47144b18a5cd5d$var$useUnmount = function(fn) {
    var fnRef = (0, $1bdO8.useRef)(fn);
    // update the ref each render so if it change the newest callback will be invoked
    fnRef.current = fn;
    (0, $d3fe22b51fbd7af2$export$2e2bcd8739ae039)(function() {
        return function() {
            return fnRef.current();
        };
    });
};
var $5c47144b18a5cd5d$export$2e2bcd8739ae039 = $5c47144b18a5cd5d$var$useUnmount;


function $f958b3f8f22d91f3$export$6bdf4601c3163ec1({ geometry: geometry , radius: radius = 10 , onSelect: onSelect , onHover: onHover  }) {
    const sceneToCanvas = (0, $945de26b40cbebad$export$1fe137006056cf29)();
    const clipToCanvas = (0, $907f0175efe74308$export$9a16fd00e65d0bbe)();
    const target = (0, $1bdO8.useMemo)(()=>new $e8ea6a63d48a4fea$export$64b5c384219d3699(), []);
    const lastPointer = (0, $1bdO8.useMemo)(()=>new $e8ea6a63d48a4fea$export$c977b3e384af9ae1(), []);
    const [hovered, setHovered] = (0, $1bdO8.useState)(-1);
    const [dragging, setDragging] = (0, $1bdO8.useState)(false);
    const { pointer: pointer , invalidate: invalidate  } = (0, $e0e1f88defa94a87$export$df995fae86a55f06)();
    const checkHover = (0, $1bdO8.useCallback)(()=>{
        if (!lastPointer.equals(pointer)) {
            lastPointer.copy(pointer);
            const query = new (0, $c74785c0f0369ab6$export$a1cd39573a6fd2a2)({
                boxTree: geometry.boxTree,
                points: geometry.positions,
                target: target.set(pointer.x, pointer.y, 0).applyMatrix4(clipToCanvas),
                projection: sceneToCanvas,
                maxDistance: radius
            });
            const result = query.run();
            return result[0] ?? -1;
        }
        return -1;
    }, [
        dragging,
        hovered,
        lastPointer,
        pointer,
        radius,
        sceneToCanvas
    ]);
    (0, $3894e11db13163c2$export$202b91c142600e81)({
        onDragStart: ({ buttons: buttons  })=>{
            if (hovered > -1 && buttons === 1) onSelect?.([
                hovered
            ]);
        },
        onDrag: ({ distance: distance  })=>{
            if (distance > 2 && !dragging) setDragging(true);
        },
        onDragEnd: ()=>{
            setDragging(false);
            setHovered(-1);
            onHover?.(-1);
        },
        onMouseMove: ()=>{
            if (dragging) return;
            const index = checkHover();
            if (index !== hovered) {
                setHovered(index);
                onHover?.(index);
                invalidate(2);
            }
        }
    });
    (0, $5c47144b18a5cd5d$export$2e2bcd8739ae039)(()=>{
        setDragging(false);
        setHovered(-1);
        onHover?.(-1);
    });
    return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $ccade5f8dab5baee$export$b6a79797ad180576), {
        value: hovered > -1 && !dragging ? "pointer" : undefined,
        priority: 5
    });
}








const $0267fa015d627e35$var$BRUSH_KEY = "b";
const $0267fa015d627e35$var$LASSO_KEY = "l";
function $0267fa015d627e35$export$5baa88f96eed30a0({ geometry: geometry , enabled: enabled = true  }) {
    const { currentTool: currentTool , setTool: setTool  } = (0, $18138c912bf4d9fe$export$f735d6cbbb187197)();
    const { active: isCameraActive  } = (0, $288a4125d710e976$export$266a56a2f4822531)();
    (0, $18138c912bf4d9fe$export$fab2e03fdf80f55d)("pointer");
    (0, $18138c912bf4d9fe$export$fab2e03fdf80f55d)("lasso");
    (0, $3a2c5c12e4f579f2$export$b0ebbe7904d8d94a)($0267fa015d627e35$var$LASSO_KEY, ()=>currentTool === "lasso" ? setTool("pointer") : setTool("lasso"));
    // useShortcut(BRUSH_KEY, () =>
    //   currentTool === "brush" ? setTool("pointer") : setTool("brush")
    // );
    const [shiftPressed] = (0, $b0ad4098c2db7014$export$2e2bcd8739ae039)("Shift");
    const [altPressed] = (0, $b0ad4098c2db7014$export$2e2bcd8739ae039)("Alt");
    const { invalidate: invalidate  } = (0, $e0e1f88defa94a87$export$df995fae86a55f06)();
    const { controls: controls  } = (0, $288a4125d710e976$export$266a56a2f4822531)();
    const [dragging, setDragging] = (0, $1bdO8.useState)(false);
    (0, $3894e11db13163c2$export$202b91c142600e81)({
        onDragStart: ()=>{
            // console.log("start drag", controls?.active);
            setDragging(true);
        },
        onDragEnd: ()=>setDragging(false)
    });
    const selection = (0, $91a6458dd589bbd0$export$4b4c417a6113a34c)();
    // Escape key to switch back to pointer-lasso
    (0, $06a60cf932bc70f9$export$2e2bcd8739ae039)("Escape", ()=>{
        selection.setSelectedIds([]);
        invalidate(2);
    });
    // Selections
    const handleSelect = (0, $1bdO8.useCallback)((ids)=>{
        if (altPressed) selection.removeSelectedIds(ids);
        else if (shiftPressed) selection.addSelectedIds(ids);
        else selection.setSelectedIds(ids);
    }, [
        shiftPressed,
        altPressed
    ]);
    const handleHover = (0, $1bdO8.useCallback)((id)=>{
        selection.setHighlightIds(id === -1 ? [] : [
            id
        ]);
    }, []);
    // console.log('isCameraActive', isCameraActive);
    if (!enabled || isCameraActive) return null;
    if (currentTool === "pointer") return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $cVgDf.Fragment), {
        children: /*#__PURE__*/ (0, $cVgDf.jsx)((0, $f958b3f8f22d91f3$export$6bdf4601c3163ec1), {
            geometry: geometry,
            onHover: handleHover,
            onSelect: handleSelect
        })
    });
    if (currentTool === "lasso") return /*#__PURE__*/ (0, $cVgDf.jsx)((0, $2eb94f6273dbecb7$export$c869beb7f37545b8), {
        geometry: geometry,
        onSelect: handleSelect
    });
    return null;
}



function $5f5371944d263c60$var$DatasetView() {
    const { invalidate: invalidate  } = (0, $e0e1f88defa94a87$export$df995fae86a55f06)();
    const geometry = (0, $a2bde23ea9c8df05$export$26531d8e255edf16)((s)=>s.geometry);
    const colorAttribute = (0, $a2bde23ea9c8df05$export$26531d8e255edf16)((s)=>s.colorAttribute);
    const selection = (0, $91a6458dd589bbd0$export$4b4c417a6113a34c)();
    const { colorPalette: colorPalette , pointSize: pointSize  } = (0, $ff1962c46896fdbd$export$772cdd5f573abcc9)();
    const colorsTexture = (0, $8431ce295a7a55af$export$5dd4f4a1dff269b2)(colorPalette.texture);
    const { controls: controls  } = (0, $288a4125d710e976$export$266a56a2f4822531)();
    const { defaultCamera: defaultCamera  } = (0, $a2bde23ea9c8df05$export$26531d8e255edf16)();
    const handleFitToBox = (0, $1bdO8.useCallback)(()=>{
        const box = geometry?.boxTree?.root.boundingBox ?? geometry?.boundingBox;
        const { defaultX: defaultX , defaultY: defaultY , defaultBox: defaultBox , defaultPaddingX: defaultPaddingX , defaultPaddingY: defaultPaddingY  } = defaultCamera ?? {};
        if (defaultX && defaultY && controls) controls.setTarget(defaultX, defaultY, 0, true);
        if (defaultBox && controls) controls.fitToBox(defaultBox, true, {
            paddingTop: defaultPaddingY,
            paddingLeft: defaultPaddingX,
            paddingBottom: defaultPaddingY,
            paddingRight: defaultPaddingX
        });
        else if (box && controls) {
            controls.rotatePolarTo(0, true);
            controls.fitToBox((0, $b9e146cc377af7a8$export$b9eeabc94409d792)(box), true);
        }
    }, [
        geometry,
        defaultCamera,
        controls
    ]);
    (0, $1bdO8.useEffect)(handleFitToBox, [
        geometry,
        defaultCamera,
        controls
    ]);
    (0, $06a60cf932bc70f9$export$2e2bcd8739ae039)("f", handleFitToBox, undefined, [
        handleFitToBox
    ]);
    // Invalidate when selection changes
    (0, $1bdO8.useEffect)(invalidate, [
        geometry,
        selection.selectedIds,
        selection.highlightIds,
        colorPalette,
        colorAttribute
    ]);
    if (!geometry) return null;
    return /*#__PURE__*/ (0, $cVgDf.jsxs)("group", {
        children: [
            /*#__PURE__*/ (0, $cVgDf.jsx)((0, $760519a16effc22a$export$acc61d9bc0df10b1), {
                geometry: geometry,
                pointSize: pointSize,
                colorsTexture: colorsTexture,
                selected: selection.selectedIds,
                highlighted: selection.highlightIds
            }),
            /*#__PURE__*/ (0, $cVgDf.jsx)((0, $0267fa015d627e35$export$5baa88f96eed30a0), {
                geometry: geometry
            })
        ]
    });
}
var $5f5371944d263c60$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bdO8))).memo($5f5371944d263c60$var$DatasetView);






var $cVgDf = parcelRequire("cVgDf");

var $1bdO8 = parcelRequire("1bdO8");


var $63nUy = parcelRequire("63nUy");


var $1bdO8 = parcelRequire("1bdO8");


const $045b3a416b33fcf7$export$9f7b01b6c21c3faf = /*#__PURE__*/ (0, $1bdO8.forwardRef)((props, ref)=>{
    (0, $1bdO8.useMemo)(()=>{
        (0, $625a33e30390866c$export$2e2bcd8739ae039).install({
            THREE: $e8ea6a63d48a4fea$exports
        });
        (0, $e0e1f88defa94a87$export$f1e1789686576879)({
            CameraControlsImpl: $625a33e30390866c$export$2e2bcd8739ae039
        });
    }, []);
    const { camera: camera , domElement: domElement , makeDefault: makeDefault , onStart: onStart , onEnd: onEnd , onChange: onChange , regress: regress , ...restProps } = props;
    const defaultCamera = (0, $e0e1f88defa94a87$export$df995fae86a55f06)((state)=>state.camera);
    const gl = (0, $e0e1f88defa94a87$export$df995fae86a55f06)((state)=>state.gl);
    const invalidate = (0, $e0e1f88defa94a87$export$df995fae86a55f06)((state)=>state.invalidate);
    const events = (0, $e0e1f88defa94a87$export$df995fae86a55f06)((state)=>state.events);
    const setEvents = (0, $e0e1f88defa94a87$export$df995fae86a55f06)((state)=>state.setEvents);
    const set = (0, $e0e1f88defa94a87$export$df995fae86a55f06)((state)=>state.set);
    const get = (0, $e0e1f88defa94a87$export$df995fae86a55f06)((state)=>state.get);
    const performance = (0, $e0e1f88defa94a87$export$df995fae86a55f06)((state)=>state.performance);
    const explCamera = camera || defaultCamera;
    const explDomElement = domElement || events.connected || gl.domElement;
    const controls = (0, $1bdO8.useMemo)(()=>new (0, $625a33e30390866c$export$2e2bcd8739ae039)(explCamera), [
        explCamera
    ]);
    (0, $e0e1f88defa94a87$export$ebd11618f299a286)((state, delta)=>{
        if (controls.enabled) controls.update(delta);
    }, -1);
    (0, $1bdO8.useEffect)(()=>{
        controls.connect(explDomElement);
        return ()=>void controls.disconnect();
    }, [
        explDomElement,
        controls
    ]);
    $1bdO8.useEffect(()=>{
        const callback = (e)=>{
            invalidate();
            if (regress) performance.regress();
            if (onChange) onChange(e);
        };
        const onStartCb = (e)=>{
            if (onStart) onStart(e);
        };
        const onEndCb = (e)=>{
            if (onEnd) onEnd(e);
        };
        controls.addEventListener("update", callback);
        controls.addEventListener("controlstart", onStartCb);
        controls.addEventListener("controlend", onEndCb);
        controls.addEventListener("control", callback);
        controls.addEventListener("transitionstart", callback);
        controls.addEventListener("wake", callback);
        return ()=>{
            controls.removeEventListener("update", callback);
            controls.removeEventListener("controlstart", onStartCb);
            controls.removeEventListener("controlend", onEndCb);
            controls.removeEventListener("control", callback);
            controls.removeEventListener("transitionstart", callback);
            controls.removeEventListener("wake", callback);
        };
    }, [
        controls,
        onStart,
        onEnd,
        invalidate,
        setEvents,
        regress,
        onChange
    ]);
    (0, $1bdO8.useEffect)(()=>{
        if (makeDefault) {
            const old = get().controls;
            set({
                controls: controls
            });
            return ()=>set({
                    controls: old
                });
        }
    }, [
        makeDefault,
        controls
    ]);
    return /*#__PURE__*/ $1bdO8.createElement("primitive", (0, $63nUy.default)({
        ref: ref,
        object: controls
    }, restProps));
});






const $0323589491a5a1d9$var$TOP_KEY = "t";
const $0323589491a5a1d9$var$MOVE_KEY = " ";
const $0323589491a5a1d9$var$ROTATE_KEY = "Alt";
var $0323589491a5a1d9$var$Action;
(function(Action) {
    Action[Action["None"] = (0, $625a33e30390866c$export$2e2bcd8739ae039).ACTION.NONE] = "None";
    Action[Action["Move"] = (0, $625a33e30390866c$export$2e2bcd8739ae039).ACTION.TRUCK] = "Move";
    Action[Action["Rotate"] = (0, $625a33e30390866c$export$2e2bcd8739ae039).ACTION.ROTATE] = "Rotate";
    Action[Action["Zoom"] = (0, $625a33e30390866c$export$2e2bcd8739ae039).ACTION.ZOOM] = "Zoom";
})($0323589491a5a1d9$var$Action || ($0323589491a5a1d9$var$Action = {}));
function $0323589491a5a1d9$var$getAction(code) {
    if (code === $0323589491a5a1d9$var$Action.Move) return $0323589491a5a1d9$var$Action.Move;
    if (code === $0323589491a5a1d9$var$Action.Rotate) return $0323589491a5a1d9$var$Action.Rotate;
    return $0323589491a5a1d9$var$Action.None;
}
function $0323589491a5a1d9$var$MainCameraControls() {
    const controls = (0, $e0e1f88defa94a87$export$df995fae86a55f06)((s)=>s.controls instanceof (0, $625a33e30390866c$export$2e2bcd8739ae039) ? s.controls : null);
    const aspect = (0, $e0e1f88defa94a87$export$df995fae86a55f06)((state)=>state.size.width / state.size.height);
    const [isMovingMode, setMovingMode] = (0, $1bdO8.useState)(false);
    const [isRotateMode, setRotatingMode] = (0, $1bdO8.useState)(false);
    const [currentAction, setCurrentAction] = (0, $1bdO8.useState)($0323589491a5a1d9$var$Action.None);
    const { currentTool: currentTool  } = (0, $18138c912bf4d9fe$export$f735d6cbbb187197)();
    const lastPolar = (0, $1bdO8.useRef)(Math.PI / 4);
    const handleTopKey = (0, $1bdO8.useCallback)(()=>{
        if (!controls) return;
        const isTop = controls.polarAngle < 0.001;
        console.log("isTop", isTop, controls.polarAngle);
        if (isTop) {
            controls.rotatePolarTo(lastPolar.current, true);
            return;
        }
        lastPolar.current = controls.polarAngle;
        controls.rotatePolarTo(0, true);
    }, [
        controls
    ]);
    // Key handlers
    (0, $3a2c5c12e4f579f2$export$b0ebbe7904d8d94a)($0323589491a5a1d9$var$TOP_KEY, handleTopKey);
    (0, $3a2c5c12e4f579f2$export$b0ebbe7904d8d94a)($0323589491a5a1d9$var$MOVE_KEY, ()=>setMovingMode(true), ()=>setMovingMode(false));
    (0, $1bdO8.useEffect)(()=>{
        if (currentTool === "pointer") setMovingMode(true);
        else setMovingMode(false);
    }, [
        currentTool
    ]);
    (0, $3a2c5c12e4f579f2$export$b0ebbe7904d8d94a)($0323589491a5a1d9$var$ROTATE_KEY, ()=>setRotatingMode(true), ()=>setRotatingMode(false));
    const handleActionChange = (0, $1bdO8.useCallback)(()=>{
        const action = $0323589491a5a1d9$var$getAction(controls?.currentAction);
        if (action !== currentAction) setCurrentAction(action);
    }, [
        controls,
        currentAction
    ]);
    // Cursor state
    const cursor = (0, $1bdO8.useMemo)(()=>{
        if (controls?.enabled === false) return undefined;
        if (currentAction == $0323589491a5a1d9$var$Action.Move) return "move";
        if (currentAction === $0323589491a5a1d9$var$Action.Rotate) return "grabbing";
        if (isMovingMode) return "move";
    }, [
        controls,
        currentAction,
        isMovingMode
    ]);
    const leftAction = (0, $1bdO8.useMemo)(()=>{
        if (isMovingMode) return (0, $625a33e30390866c$export$2e2bcd8739ae039).ACTION.TRUCK;
        return (0, $625a33e30390866c$export$2e2bcd8739ae039).ACTION.NONE;
    }, [
        isMovingMode
    ]);
    const rightAction = (0, $1bdO8.useMemo)(()=>{
        if (isRotateMode) return (0, $625a33e30390866c$export$2e2bcd8739ae039).ACTION.ROTATE;
        return (0, $625a33e30390866c$export$2e2bcd8739ae039).ACTION.TRUCK;
    }, [
        isRotateMode
    ]);
    return /*#__PURE__*/ (0, $cVgDf.jsxs)((0, $cVgDf.Fragment), {
        children: [
            /*#__PURE__*/ (0, $cVgDf.jsx)((0, $045b3a416b33fcf7$export$9f7b01b6c21c3faf), {
                onStart: handleActionChange,
                onEnd: handleActionChange,
                onChange: handleActionChange,
                makeDefault: true,
                dollyToCursor: true,
                dollyDragInverted: true,
                dollySpeed: 0.2,
                dragToOffset: true,
                minZoom: 0.001,
                maxZoom: 100,
                smoothTime: 0.05,
                draggingSmoothTime: 0.01,
                mouseButtons: {
                    left: leftAction,
                    wheel: (0, $625a33e30390866c$export$2e2bcd8739ae039).ACTION.ZOOM,
                    middle: (0, $625a33e30390866c$export$2e2bcd8739ae039).ACTION.NONE,
                    right: rightAction
                }
            }),
            /*#__PURE__*/ (0, $cVgDf.jsx)((0, $5994448d2cebddd0$export$9ebf355ee4ed261b), {
                manual: true,
                makeDefault: true,
                up: [
                    0,
                    0,
                    1
                ],
                top: 1,
                bottom: -1,
                left: -1 * aspect,
                right: 1 * aspect,
                near: -1000,
                far: 1000,
                zoom: 0.1,
                position: [
                    0,
                    0,
                    1
                ]
            }),
            /*#__PURE__*/ (0, $cVgDf.jsx)((0, $ccade5f8dab5baee$export$b6a79797ad180576), {
                value: cursor,
                priority: 1
            })
        ]
    });
}
var $0323589491a5a1d9$export$2e2bcd8739ae039 = $0323589491a5a1d9$var$MainCameraControls;




function $0eced317855ccf5d$export$e6aa79d593524a48() {
    return /*#__PURE__*/ (0, $cVgDf.jsxs)((0, $d9f98aed922d8554$export$2e2bcd8739ae039), {
        theme: (0, $3810992676f217af$export$2e2bcd8739ae039),
        children: [
            /*#__PURE__*/ (0, $cVgDf.jsx)((0, $4e7ac4d9add92137$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $cVgDf.jsxs)((0, $f62429bf2abe05cb$export$8d01c972ee8b14a9), {
                frameloop: "demand",
                children: [
                    /*#__PURE__*/ (0, $cVgDf.jsx)((0, $0323589491a5a1d9$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $cVgDf.jsx)("axesHelper", {}),
                    /*#__PURE__*/ (0, $cVgDf.jsx)((0, $5f5371944d263c60$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
}
async function $0eced317855ccf5d$export$f002011cfa1fc363(dataset) {
    return (0, $a2bde23ea9c8df05$export$26531d8e255edf16).getState().loadDataset(dataset);
}
async function $0eced317855ccf5d$export$b9baf70786241f1e(url) {
    const dataset = await (0, $88569b9317805644$export$615c82c7c5f5e492)(url);
    return $0eced317855ccf5d$export$f002011cfa1fc363(dataset);
}


const $1e09bf3184da02ac$export$86fbec116b87613f = ()=>{
    const getDatasetUrlFromURL = ()=>{
        const queryString = window.location.search.substring(1); // Remove the leading '?'
        // Can't use regular search params since signed s3 links have '&' or '=' or other special characters
        const [name, value] = queryString.split("datasetUrl=", 2);
        return value;
    };
    const datasetUrl = getDatasetUrlFromURL();
    (0, $1bdO8.useEffect)(()=>{
        if (datasetUrl) (0, $0eced317855ccf5d$export$b9baf70786241f1e)(datasetUrl);
    }, [
        datasetUrl
    ]);
    return /*#__PURE__*/ (0, $cVgDf.jsxs)((0, $d9f98aed922d8554$export$2e2bcd8739ae039), {
        theme: (0, $3810992676f217af$export$2e2bcd8739ae039),
        children: [
            /*#__PURE__*/ (0, $cVgDf.jsx)((0, $4e7ac4d9add92137$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $cVgDf.jsx)((0, $cd7897de12d8547b$export$b38d13258b7431d5), {}),
            /*#__PURE__*/ (0, $cVgDf.jsx)((0, $81ec01875ae6fe97$export$2e2bcd8739ae039), {
                sx: {
                    background: "#111"
                },
                children: /*#__PURE__*/ (0, $cVgDf.jsx)((0, $0eced317855ccf5d$export$e6aa79d593524a48), {})
            }),
            /*#__PURE__*/ (0, $cVgDf.jsx)((0, $81ec01875ae6fe97$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $cVgDf.jsxs)((0, $89216f20f1c77281$export$2e2bcd8739ae039), {
                    height: "100%",
                    overflow: "hidden",
                    justifyContent: "space-between",
                    alignItems: "baseline",
                    spacing: 2,
                    padding: 4,
                    children: [
                        /*#__PURE__*/ (0, $cVgDf.jsx)((0, $5aa745bb8eb38f23$export$4c260019440d418f), {}),
                        /*#__PURE__*/ (0, $cVgDf.jsxs)((0, $89216f20f1c77281$export$2e2bcd8739ae039), {
                            width: "100%",
                            direction: "row",
                            spacing: 2,
                            alignItems: "end",
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0, $cVgDf.jsx)((0, $e385011a49baa960$export$85da36fd8391a81), {}),
                                /*#__PURE__*/ (0, $cVgDf.jsx)((0, $0908c99279eb8882$export$baa258a5880a61c9), {})
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $cVgDf.jsx)((0, $ff5ea5bd6380e79a$export$3af09e5af73c5f4f), {}),
            /*#__PURE__*/ (0, $cVgDf.jsx)((0, $c40724a2dbf728fa$export$bad241469279ac89), {
                onLoad: (0, $0eced317855ccf5d$export$f002011cfa1fc363)
            }),
            /*#__PURE__*/ (0, $cVgDf.jsx)((0, $abeff2a1dffdffd9$export$5c16a7d40d128857), {})
        ]
    });
};
window.addEventListener("wheel", (e)=>{
    e.preventDefault();
}, {
    passive: false
});


const $25b5198d14652ae9$var$container = document.getElementById("app");
if (!$25b5198d14652ae9$var$container) throw new Error("Failed to find the root element");
const $25b5198d14652ae9$var$root = (0, $9c5fb7f33068258d$export$882461b6382ed46c)($25b5198d14652ae9$var$container);
$25b5198d14652ae9$var$root.render(/*#__PURE__*/ (0, $cVgDf.jsx)((0, $1e09bf3184da02ac$export$86fbec116b87613f), {}));


//# sourceMappingURL=index.43d5cad7.js.map
